// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */

/**
 * Remove the margin in all browsers.
 */

body {
  margin: 0;
}

/**
 * Render the \`main\` element consistently in IE.
 */

main {
  display: block;
}

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */

/**
 * Remove the gray background on active links in IE 10.
 */

a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */

small {
  font-size: 80%;
}

/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove the border on images inside links in IE 10.
 */

img {
  border-style: none;
}

/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input { /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select { /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type=button]:-moz-focusring,
[type=reset]:-moz-focusring,
[type=submit]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */

textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

[type=checkbox],
[type=radio] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type=search] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */

/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */

summary {
  display: list-item;
}

/* Misc
   ========================================================================== */

/**
 * Add the correct display in IE 10+.
 */

template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */

[hidden] {
  display: none;
}

/**
 * Manually forked from SUIT CSS Base: https://github.com/suitcss/base
 * A thin layer on top of normalize.css that provides a starting point more
 * suitable for web applications.
 */

/**
 * Removes the default spacing and border for appropriate elements.
 */

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

button {
  background-color: transparent;
  background-image: none;
}

/**
 * Work around a Firefox/IE bug where the transparent \`button\` background
 * results in a loss of the default \`button\` focus styles.
 */

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

fieldset {
  margin: 0;
  padding: 0;
}

ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

/**
 * Tailwind custom reset styles
 */

/**
 * 1. Use the user's configured \`sans\` font-family (with Tailwind's default
 *    sans-serif font stack as a fallback) as a sane default.
 * 2. Use Tailwind's default "normal" line-height so the user isn't forced
 *    to override it to ensure consistency even when using the default theme.
 */

html {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 1 */
  line-height: 1.5; /* 2 */
}

/**
 * 1. Prevent padding and border from affecting element width.
 *
 *    We used to set this in the html element and inherit from
 *    the parent element for everything else. This caused issues
 *    in shadow-dom-enhanced elements like <details> where the content
 *    is wrapped by a div with box-sizing set to \`content-box\`.
 *
 *    https://github.com/mozdevs/cssremedy/issues/4
 *
 *
 * 2. Allow adding a border to an element by just adding a border-width.
 *
 *    By default, the way the browser specifies that an element should have no
 *    border is by setting it's border-style to \`none\` in the user-agent
 *    stylesheet.
 *
 *    In order to easily add borders to elements by just setting the \`border-width\`
 *    property, we change the default border-style for all elements to \`solid\`, and
 *    use border-width to hide them instead. This way our \`border\` utilities only
 *    need to set the \`border-width\` property instead of the entire \`border\`
 *    shorthand, making our border utilities much more straightforward to compose.
 *
 *    https://github.com/tailwindcss/tailwindcss/pull/116
 */

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e2e8f0; /* 2 */
}

/*
 * Ensure horizontal rules are visible by default
 */

hr {
  border-top-width: 1px;
}

/**
 * Undo the \`border-style: none\` reset that Normalize applies to images so that
 * our \`border-{width}\` utilities have the expected effect.
 *
 * The Normalize reset is unnecessary for us since we default the border-width
 * to 0 on all elements.
 *
 * https://github.com/tailwindcss/tailwindcss/issues/362
 */

img {
  border-style: solid;
}

textarea {
  resize: vertical;
}

input::placeholder,
textarea::placeholder {
  color: #a0aec0;
}

button,
[role=button] {
  cursor: pointer;
}

table {
  border-collapse: collapse;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/**
 * Reset links to optimize for opt-in styling instead of
 * opt-out.
 */

a {
  color: inherit;
  text-decoration: inherit;
}

/**
 * Reset form element properties that are easy to forget to
 * style explicitly so you don't inadvertently introduce
 * styles that deviate from your design system. These styles
 * supplement a partial reset that is already applied by
 * normalize.css.
 */

button,
input,
optgroup,
select,
textarea {
  padding: 0;
  line-height: inherit;
  color: inherit;
}

/**
 * Use the configured 'mono' font family for elements that
 * are expected to be rendered with a monospace font, falling
 * back to the system monospace stack if there is no configured
 * 'mono' font family.
 */

pre,
code,
kbd,
samp {
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

/**
 * Make replaced elements \`display: block\` by default as that's
 * the behavior you want almost all of the time. Inspired by
 * CSS Remedy, with \`svg\` added as well.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  vertical-align: middle;
}

/**
 * Constrain images and videos to the parent width and preserve
 * their instrinsic aspect ratio.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */

img,
video {
  max-width: 100%;
  height: auto;
}

.container {
  width: 100%;
}

@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

.space-y-0 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0px * (1 - var(--space-y-reverse)));
  margin-bottom: calc(0px * var(--space-y-reverse));
}

.space-x-0 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0px * var(--space-x-reverse));
  margin-left: calc(0px * (1 - var(--space-x-reverse)));
}

.space-y-1 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--space-y-reverse));
}

.space-x-1 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--space-x-reverse));
  margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
}

.space-y-2 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--space-y-reverse));
}

.space-x-2 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--space-x-reverse));
  margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
}

.space-y-3 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--space-y-reverse));
}

.space-x-3 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--space-x-reverse));
  margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
}

.space-y-4 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(1rem * var(--space-y-reverse));
}

.space-x-4 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1rem * var(--space-x-reverse));
  margin-left: calc(1rem * (1 - var(--space-x-reverse)));
}

.space-y-5 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--space-y-reverse));
}

.space-x-5 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--space-x-reverse));
  margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
}

.space-y-6 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--space-y-reverse));
}

.space-x-6 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--space-x-reverse));
  margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
}

.space-y-8 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(2rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(2rem * var(--space-y-reverse));
}

.space-x-8 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(2rem * var(--space-x-reverse));
  margin-left: calc(2rem * (1 - var(--space-x-reverse)));
}

.space-y-10 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--space-y-reverse));
}

.space-x-10 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(2.5rem * var(--space-x-reverse));
  margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
}

.space-y-12 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(3rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(3rem * var(--space-y-reverse));
}

.space-x-12 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(3rem * var(--space-x-reverse));
  margin-left: calc(3rem * (1 - var(--space-x-reverse)));
}

.space-y-16 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(4rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(4rem * var(--space-y-reverse));
}

.space-x-16 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(4rem * var(--space-x-reverse));
  margin-left: calc(4rem * (1 - var(--space-x-reverse)));
}

.space-y-20 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(5rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(5rem * var(--space-y-reverse));
}

.space-x-20 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(5rem * var(--space-x-reverse));
  margin-left: calc(5rem * (1 - var(--space-x-reverse)));
}

.space-y-24 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(6rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(6rem * var(--space-y-reverse));
}

.space-x-24 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(6rem * var(--space-x-reverse));
  margin-left: calc(6rem * (1 - var(--space-x-reverse)));
}

.space-y-32 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(8rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(8rem * var(--space-y-reverse));
}

.space-x-32 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(8rem * var(--space-x-reverse));
  margin-left: calc(8rem * (1 - var(--space-x-reverse)));
}

.space-y-40 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(10rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(10rem * var(--space-y-reverse));
}

.space-x-40 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(10rem * var(--space-x-reverse));
  margin-left: calc(10rem * (1 - var(--space-x-reverse)));
}

.space-y-48 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(12rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(12rem * var(--space-y-reverse));
}

.space-x-48 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(12rem * var(--space-x-reverse));
  margin-left: calc(12rem * (1 - var(--space-x-reverse)));
}

.space-y-56 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(14rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(14rem * var(--space-y-reverse));
}

.space-x-56 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(14rem * var(--space-x-reverse));
  margin-left: calc(14rem * (1 - var(--space-x-reverse)));
}

.space-y-64 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(16rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(16rem * var(--space-y-reverse));
}

.space-x-64 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(16rem * var(--space-x-reverse));
  margin-left: calc(16rem * (1 - var(--space-x-reverse)));
}

.space-y-px > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(1px * (1 - var(--space-y-reverse)));
  margin-bottom: calc(1px * var(--space-y-reverse));
}

.space-x-px > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(1px * var(--space-x-reverse));
  margin-left: calc(1px * (1 - var(--space-x-reverse)));
}

.-space-y-1 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.25rem * var(--space-y-reverse));
}

.-space-x-1 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.25rem * var(--space-x-reverse));
  margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
}

.-space-y-2 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.5rem * var(--space-y-reverse));
}

.-space-x-2 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--space-x-reverse));
  margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
}

.-space-y-3 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.75rem * var(--space-y-reverse));
}

.-space-x-3 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-0.75rem * var(--space-x-reverse));
  margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
}

.-space-y-4 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-1rem * var(--space-y-reverse));
}

.-space-x-4 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1rem * var(--space-x-reverse));
  margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
}

.-space-y-5 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-1.25rem * var(--space-y-reverse));
}

.-space-x-5 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1.25rem * var(--space-x-reverse));
  margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
}

.-space-y-6 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-1.5rem * var(--space-y-reverse));
}

.-space-x-6 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1.5rem * var(--space-x-reverse));
  margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
}

.-space-y-8 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-2rem * var(--space-y-reverse));
}

.-space-x-8 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-2rem * var(--space-x-reverse));
  margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
}

.-space-y-10 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-2.5rem * var(--space-y-reverse));
}

.-space-x-10 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-2.5rem * var(--space-x-reverse));
  margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
}

.-space-y-12 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-3rem * var(--space-y-reverse));
}

.-space-x-12 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-3rem * var(--space-x-reverse));
  margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
}

.-space-y-16 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-4rem * var(--space-y-reverse));
}

.-space-x-16 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-4rem * var(--space-x-reverse));
  margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
}

.-space-y-20 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-5rem * var(--space-y-reverse));
}

.-space-x-20 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-5rem * var(--space-x-reverse));
  margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
}

.-space-y-24 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-6rem * var(--space-y-reverse));
}

.-space-x-24 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-6rem * var(--space-x-reverse));
  margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
}

.-space-y-32 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-8rem * var(--space-y-reverse));
}

.-space-x-32 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-8rem * var(--space-x-reverse));
  margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
}

.-space-y-40 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-10rem * var(--space-y-reverse));
}

.-space-x-40 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-10rem * var(--space-x-reverse));
  margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
}

.-space-y-48 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-12rem * var(--space-y-reverse));
}

.-space-x-48 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-12rem * var(--space-x-reverse));
  margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
}

.-space-y-56 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-14rem * var(--space-y-reverse));
}

.-space-x-56 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-14rem * var(--space-x-reverse));
  margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
}

.-space-y-64 > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-16rem * var(--space-y-reverse));
}

.-space-x-64 > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-16rem * var(--space-x-reverse));
  margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
}

.-space-y-px > :not(template) ~ :not(template) {
  --space-y-reverse: 0;
  margin-top: calc(-1px * (1 - var(--space-y-reverse)));
  margin-bottom: calc(-1px * var(--space-y-reverse));
}

.-space-x-px > :not(template) ~ :not(template) {
  --space-x-reverse: 0;
  margin-right: calc(-1px * var(--space-x-reverse));
  margin-left: calc(-1px * (1 - var(--space-x-reverse)));
}

.space-y-reverse > :not(template) ~ :not(template) {
  --space-y-reverse: 1;
}

.space-x-reverse > :not(template) ~ :not(template) {
  --space-x-reverse: 1;
}

.divide-y-0 > :not(template) ~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
  border-bottom-width: calc(0px * var(--divide-y-reverse));
}

.divide-x-0 > :not(template) ~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(0px * var(--divide-x-reverse));
  border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
}

.divide-y-2 > :not(template) ~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
  border-bottom-width: calc(2px * var(--divide-y-reverse));
}

.divide-x-2 > :not(template) ~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(2px * var(--divide-x-reverse));
  border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
}

.divide-y-4 > :not(template) ~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
  border-bottom-width: calc(4px * var(--divide-y-reverse));
}

.divide-x-4 > :not(template) ~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(4px * var(--divide-x-reverse));
  border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
}

.divide-y-8 > :not(template) ~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
  border-bottom-width: calc(8px * var(--divide-y-reverse));
}

.divide-x-8 > :not(template) ~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(8px * var(--divide-x-reverse));
  border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
}

.divide-y > :not(template) ~ :not(template) {
  --divide-y-reverse: 0;
  border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
  border-bottom-width: calc(1px * var(--divide-y-reverse));
}

.divide-x > :not(template) ~ :not(template) {
  --divide-x-reverse: 0;
  border-right-width: calc(1px * var(--divide-x-reverse));
  border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
}

.divide-y-reverse > :not(template) ~ :not(template) {
  --divide-y-reverse: 1;
}

.divide-x-reverse > :not(template) ~ :not(template) {
  --divide-x-reverse: 1;
}

.divide-transparent > :not(template) ~ :not(template) {
  border-color: transparent;
}

.divide-current > :not(template) ~ :not(template) {
  border-color: currentColor;
}

.divide-black > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #000;
  border-color: rgba(0, 0, 0, var(--divide-opacity));
}

.divide-white > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fff;
  border-color: rgba(255, 255, 255, var(--divide-opacity));
}

.divide-gray-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #f7fafc;
  border-color: rgba(247, 250, 252, var(--divide-opacity));
}

.divide-gray-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #edf2f7;
  border-color: rgba(237, 242, 247, var(--divide-opacity));
}

.divide-gray-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--divide-opacity));
}

.divide-gray-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #cbd5e0;
  border-color: rgba(203, 213, 224, var(--divide-opacity));
}

.divide-gray-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #a0aec0;
  border-color: rgba(160, 174, 192, var(--divide-opacity));
}

.divide-gray-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #718096;
  border-color: rgba(113, 128, 150, var(--divide-opacity));
}

.divide-gray-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #4a5568;
  border-color: rgba(74, 85, 104, var(--divide-opacity));
}

.divide-gray-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #2d3748;
  border-color: rgba(45, 55, 72, var(--divide-opacity));
}

.divide-gray-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #1a202c;
  border-color: rgba(26, 32, 44, var(--divide-opacity));
}

.divide-red-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fff5f5;
  border-color: rgba(255, 245, 245, var(--divide-opacity));
}

.divide-red-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fed7d7;
  border-color: rgba(254, 215, 215, var(--divide-opacity));
}

.divide-red-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #feb2b2;
  border-color: rgba(254, 178, 178, var(--divide-opacity));
}

.divide-red-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fc8181;
  border-color: rgba(252, 129, 129, var(--divide-opacity));
}

.divide-red-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #f56565;
  border-color: rgba(245, 101, 101, var(--divide-opacity));
}

.divide-red-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #e53e3e;
  border-color: rgba(229, 62, 62, var(--divide-opacity));
}

.divide-red-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #c53030;
  border-color: rgba(197, 48, 48, var(--divide-opacity));
}

.divide-red-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #9b2c2c;
  border-color: rgba(155, 44, 44, var(--divide-opacity));
}

.divide-red-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #742a2a;
  border-color: rgba(116, 42, 42, var(--divide-opacity));
}

.divide-orange-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fffaf0;
  border-color: rgba(255, 250, 240, var(--divide-opacity));
}

.divide-orange-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #feebc8;
  border-color: rgba(254, 235, 200, var(--divide-opacity));
}

.divide-orange-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fbd38d;
  border-color: rgba(251, 211, 141, var(--divide-opacity));
}

.divide-orange-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #f6ad55;
  border-color: rgba(246, 173, 85, var(--divide-opacity));
}

.divide-orange-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #ed8936;
  border-color: rgba(237, 137, 54, var(--divide-opacity));
}

.divide-orange-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #dd6b20;
  border-color: rgba(221, 107, 32, var(--divide-opacity));
}

.divide-orange-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #c05621;
  border-color: rgba(192, 86, 33, var(--divide-opacity));
}

.divide-orange-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #9c4221;
  border-color: rgba(156, 66, 33, var(--divide-opacity));
}

.divide-orange-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #7b341e;
  border-color: rgba(123, 52, 30, var(--divide-opacity));
}

.divide-yellow-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fffff0;
  border-color: rgba(255, 255, 240, var(--divide-opacity));
}

.divide-yellow-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fefcbf;
  border-color: rgba(254, 252, 191, var(--divide-opacity));
}

.divide-yellow-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #faf089;
  border-color: rgba(250, 240, 137, var(--divide-opacity));
}

.divide-yellow-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #f6e05e;
  border-color: rgba(246, 224, 94, var(--divide-opacity));
}

.divide-yellow-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #ecc94b;
  border-color: rgba(236, 201, 75, var(--divide-opacity));
}

.divide-yellow-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #d69e2e;
  border-color: rgba(214, 158, 46, var(--divide-opacity));
}

.divide-yellow-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #b7791f;
  border-color: rgba(183, 121, 31, var(--divide-opacity));
}

.divide-yellow-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #975a16;
  border-color: rgba(151, 90, 22, var(--divide-opacity));
}

.divide-yellow-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #744210;
  border-color: rgba(116, 66, 16, var(--divide-opacity));
}

.divide-green-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #f0fff4;
  border-color: rgba(240, 255, 244, var(--divide-opacity));
}

.divide-green-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #c6f6d5;
  border-color: rgba(198, 246, 213, var(--divide-opacity));
}

.divide-green-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #9ae6b4;
  border-color: rgba(154, 230, 180, var(--divide-opacity));
}

.divide-green-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #68d391;
  border-color: rgba(104, 211, 145, var(--divide-opacity));
}

.divide-green-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #48bb78;
  border-color: rgba(72, 187, 120, var(--divide-opacity));
}

.divide-green-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #38a169;
  border-color: rgba(56, 161, 105, var(--divide-opacity));
}

.divide-green-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #2f855a;
  border-color: rgba(47, 133, 90, var(--divide-opacity));
}

.divide-green-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #276749;
  border-color: rgba(39, 103, 73, var(--divide-opacity));
}

.divide-green-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #22543d;
  border-color: rgba(34, 84, 61, var(--divide-opacity));
}

.divide-teal-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #e6fffa;
  border-color: rgba(230, 255, 250, var(--divide-opacity));
}

.divide-teal-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #b2f5ea;
  border-color: rgba(178, 245, 234, var(--divide-opacity));
}

.divide-teal-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #81e6d9;
  border-color: rgba(129, 230, 217, var(--divide-opacity));
}

.divide-teal-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #4fd1c5;
  border-color: rgba(79, 209, 197, var(--divide-opacity));
}

.divide-teal-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #38b2ac;
  border-color: rgba(56, 178, 172, var(--divide-opacity));
}

.divide-teal-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #319795;
  border-color: rgba(49, 151, 149, var(--divide-opacity));
}

.divide-teal-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #2c7a7b;
  border-color: rgba(44, 122, 123, var(--divide-opacity));
}

.divide-teal-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #285e61;
  border-color: rgba(40, 94, 97, var(--divide-opacity));
}

.divide-teal-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #234e52;
  border-color: rgba(35, 78, 82, var(--divide-opacity));
}

.divide-blue-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #ebf8ff;
  border-color: rgba(235, 248, 255, var(--divide-opacity));
}

.divide-blue-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #bee3f8;
  border-color: rgba(190, 227, 248, var(--divide-opacity));
}

.divide-blue-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #90cdf4;
  border-color: rgba(144, 205, 244, var(--divide-opacity));
}

.divide-blue-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #63b3ed;
  border-color: rgba(99, 179, 237, var(--divide-opacity));
}

.divide-blue-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #4299e1;
  border-color: rgba(66, 153, 225, var(--divide-opacity));
}

.divide-blue-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #3182ce;
  border-color: rgba(49, 130, 206, var(--divide-opacity));
}

.divide-blue-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #2b6cb0;
  border-color: rgba(43, 108, 176, var(--divide-opacity));
}

.divide-blue-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #2c5282;
  border-color: rgba(44, 82, 130, var(--divide-opacity));
}

.divide-blue-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #2a4365;
  border-color: rgba(42, 67, 101, var(--divide-opacity));
}

.divide-indigo-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #ebf4ff;
  border-color: rgba(235, 244, 255, var(--divide-opacity));
}

.divide-indigo-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #c3dafe;
  border-color: rgba(195, 218, 254, var(--divide-opacity));
}

.divide-indigo-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #a3bffa;
  border-color: rgba(163, 191, 250, var(--divide-opacity));
}

.divide-indigo-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #7f9cf5;
  border-color: rgba(127, 156, 245, var(--divide-opacity));
}

.divide-indigo-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #667eea;
  border-color: rgba(102, 126, 234, var(--divide-opacity));
}

.divide-indigo-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #5a67d8;
  border-color: rgba(90, 103, 216, var(--divide-opacity));
}

.divide-indigo-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #4c51bf;
  border-color: rgba(76, 81, 191, var(--divide-opacity));
}

.divide-indigo-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #434190;
  border-color: rgba(67, 65, 144, var(--divide-opacity));
}

.divide-indigo-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #3c366b;
  border-color: rgba(60, 54, 107, var(--divide-opacity));
}

.divide-purple-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #faf5ff;
  border-color: rgba(250, 245, 255, var(--divide-opacity));
}

.divide-purple-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #e9d8fd;
  border-color: rgba(233, 216, 253, var(--divide-opacity));
}

.divide-purple-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #d6bcfa;
  border-color: rgba(214, 188, 250, var(--divide-opacity));
}

.divide-purple-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #b794f4;
  border-color: rgba(183, 148, 244, var(--divide-opacity));
}

.divide-purple-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #9f7aea;
  border-color: rgba(159, 122, 234, var(--divide-opacity));
}

.divide-purple-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #805ad5;
  border-color: rgba(128, 90, 213, var(--divide-opacity));
}

.divide-purple-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #6b46c1;
  border-color: rgba(107, 70, 193, var(--divide-opacity));
}

.divide-purple-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #553c9a;
  border-color: rgba(85, 60, 154, var(--divide-opacity));
}

.divide-purple-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #44337a;
  border-color: rgba(68, 51, 122, var(--divide-opacity));
}

.divide-pink-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fff5f7;
  border-color: rgba(255, 245, 247, var(--divide-opacity));
}

.divide-pink-200 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fed7e2;
  border-color: rgba(254, 215, 226, var(--divide-opacity));
}

.divide-pink-300 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #fbb6ce;
  border-color: rgba(251, 182, 206, var(--divide-opacity));
}

.divide-pink-400 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #f687b3;
  border-color: rgba(246, 135, 179, var(--divide-opacity));
}

.divide-pink-500 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #ed64a6;
  border-color: rgba(237, 100, 166, var(--divide-opacity));
}

.divide-pink-600 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #d53f8c;
  border-color: rgba(213, 63, 140, var(--divide-opacity));
}

.divide-pink-700 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #b83280;
  border-color: rgba(184, 50, 128, var(--divide-opacity));
}

.divide-pink-800 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #97266d;
  border-color: rgba(151, 38, 109, var(--divide-opacity));
}

.divide-pink-900 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
  border-color: #702459;
  border-color: rgba(112, 36, 89, var(--divide-opacity));
}

.divide-solid > :not(template) ~ :not(template) {
  border-style: solid;
}

.divide-dashed > :not(template) ~ :not(template) {
  border-style: dashed;
}

.divide-dotted > :not(template) ~ :not(template) {
  border-style: dotted;
}

.divide-double > :not(template) ~ :not(template) {
  border-style: double;
}

.divide-none > :not(template) ~ :not(template) {
  border-style: none;
}

.divide-opacity-0 > :not(template) ~ :not(template) {
  --divide-opacity: 0;
}

.divide-opacity-25 > :not(template) ~ :not(template) {
  --divide-opacity: 0.25;
}

.divide-opacity-50 > :not(template) ~ :not(template) {
  --divide-opacity: 0.5;
}

.divide-opacity-75 > :not(template) ~ :not(template) {
  --divide-opacity: 0.75;
}

.divide-opacity-100 > :not(template) ~ :not(template) {
  --divide-opacity: 1;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.not-sr-only {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.focus\\:sr-only:focus {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.focus\\:not-sr-only:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.appearance-none {
  appearance: none;
}

.bg-fixed {
  background-attachment: fixed;
}

.bg-local {
  background-attachment: local;
}

.bg-scroll {
  background-attachment: scroll;
}

.bg-clip-border {
  background-clip: border-box;
}

.bg-clip-padding {
  background-clip: padding-box;
}

.bg-clip-content {
  background-clip: content-box;
}

.bg-clip-text {
  -webkit-background-clip: text;
  background-clip: text;
}

.bg-transparent {
  background-color: transparent;
}

.bg-current {
  background-color: currentColor;
}

.bg-black {
  --bg-opacity: 1;
  background-color: #000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}

.bg-white {
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}

.bg-gray-100 {
  --bg-opacity: 1;
  background-color: #f7fafc;
  background-color: rgba(247, 250, 252, var(--bg-opacity));
}

.bg-gray-200 {
  --bg-opacity: 1;
  background-color: #edf2f7;
  background-color: rgba(237, 242, 247, var(--bg-opacity));
}

.bg-gray-300 {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}

.bg-gray-400 {
  --bg-opacity: 1;
  background-color: #cbd5e0;
  background-color: rgba(203, 213, 224, var(--bg-opacity));
}

.bg-gray-500 {
  --bg-opacity: 1;
  background-color: #a0aec0;
  background-color: rgba(160, 174, 192, var(--bg-opacity));
}

.bg-gray-600 {
  --bg-opacity: 1;
  background-color: #718096;
  background-color: rgba(113, 128, 150, var(--bg-opacity));
}

.bg-gray-700 {
  --bg-opacity: 1;
  background-color: #4a5568;
  background-color: rgba(74, 85, 104, var(--bg-opacity));
}

.bg-gray-800 {
  --bg-opacity: 1;
  background-color: #2d3748;
  background-color: rgba(45, 55, 72, var(--bg-opacity));
}

.bg-gray-900 {
  --bg-opacity: 1;
  background-color: #1a202c;
  background-color: rgba(26, 32, 44, var(--bg-opacity));
}

.bg-red-100 {
  --bg-opacity: 1;
  background-color: #fff5f5;
  background-color: rgba(255, 245, 245, var(--bg-opacity));
}

.bg-red-200 {
  --bg-opacity: 1;
  background-color: #fed7d7;
  background-color: rgba(254, 215, 215, var(--bg-opacity));
}

.bg-red-300 {
  --bg-opacity: 1;
  background-color: #feb2b2;
  background-color: rgba(254, 178, 178, var(--bg-opacity));
}

.bg-red-400 {
  --bg-opacity: 1;
  background-color: #fc8181;
  background-color: rgba(252, 129, 129, var(--bg-opacity));
}

.bg-red-500 {
  --bg-opacity: 1;
  background-color: #f56565;
  background-color: rgba(245, 101, 101, var(--bg-opacity));
}

.bg-red-600 {
  --bg-opacity: 1;
  background-color: #e53e3e;
  background-color: rgba(229, 62, 62, var(--bg-opacity));
}

.bg-red-700 {
  --bg-opacity: 1;
  background-color: #c53030;
  background-color: rgba(197, 48, 48, var(--bg-opacity));
}

.bg-red-800 {
  --bg-opacity: 1;
  background-color: #9b2c2c;
  background-color: rgba(155, 44, 44, var(--bg-opacity));
}

.bg-red-900 {
  --bg-opacity: 1;
  background-color: #742a2a;
  background-color: rgba(116, 42, 42, var(--bg-opacity));
}

.bg-orange-100 {
  --bg-opacity: 1;
  background-color: #fffaf0;
  background-color: rgba(255, 250, 240, var(--bg-opacity));
}

.bg-orange-200 {
  --bg-opacity: 1;
  background-color: #feebc8;
  background-color: rgba(254, 235, 200, var(--bg-opacity));
}

.bg-orange-300 {
  --bg-opacity: 1;
  background-color: #fbd38d;
  background-color: rgba(251, 211, 141, var(--bg-opacity));
}

.bg-orange-400 {
  --bg-opacity: 1;
  background-color: #f6ad55;
  background-color: rgba(246, 173, 85, var(--bg-opacity));
}

.bg-orange-500 {
  --bg-opacity: 1;
  background-color: #ed8936;
  background-color: rgba(237, 137, 54, var(--bg-opacity));
}

.bg-orange-600 {
  --bg-opacity: 1;
  background-color: #dd6b20;
  background-color: rgba(221, 107, 32, var(--bg-opacity));
}

.bg-orange-700 {
  --bg-opacity: 1;
  background-color: #c05621;
  background-color: rgba(192, 86, 33, var(--bg-opacity));
}

.bg-orange-800 {
  --bg-opacity: 1;
  background-color: #9c4221;
  background-color: rgba(156, 66, 33, var(--bg-opacity));
}

.bg-orange-900 {
  --bg-opacity: 1;
  background-color: #7b341e;
  background-color: rgba(123, 52, 30, var(--bg-opacity));
}

.bg-yellow-100 {
  --bg-opacity: 1;
  background-color: #fffff0;
  background-color: rgba(255, 255, 240, var(--bg-opacity));
}

.bg-yellow-200 {
  --bg-opacity: 1;
  background-color: #fefcbf;
  background-color: rgba(254, 252, 191, var(--bg-opacity));
}

.bg-yellow-300 {
  --bg-opacity: 1;
  background-color: #faf089;
  background-color: rgba(250, 240, 137, var(--bg-opacity));
}

.bg-yellow-400 {
  --bg-opacity: 1;
  background-color: #f6e05e;
  background-color: rgba(246, 224, 94, var(--bg-opacity));
}

.bg-yellow-500 {
  --bg-opacity: 1;
  background-color: #ecc94b;
  background-color: rgba(236, 201, 75, var(--bg-opacity));
}

.bg-yellow-600 {
  --bg-opacity: 1;
  background-color: #d69e2e;
  background-color: rgba(214, 158, 46, var(--bg-opacity));
}

.bg-yellow-700 {
  --bg-opacity: 1;
  background-color: #b7791f;
  background-color: rgba(183, 121, 31, var(--bg-opacity));
}

.bg-yellow-800 {
  --bg-opacity: 1;
  background-color: #975a16;
  background-color: rgba(151, 90, 22, var(--bg-opacity));
}

.bg-yellow-900 {
  --bg-opacity: 1;
  background-color: #744210;
  background-color: rgba(116, 66, 16, var(--bg-opacity));
}

.bg-green-100 {
  --bg-opacity: 1;
  background-color: #f0fff4;
  background-color: rgba(240, 255, 244, var(--bg-opacity));
}

.bg-green-200 {
  --bg-opacity: 1;
  background-color: #c6f6d5;
  background-color: rgba(198, 246, 213, var(--bg-opacity));
}

.bg-green-300 {
  --bg-opacity: 1;
  background-color: #9ae6b4;
  background-color: rgba(154, 230, 180, var(--bg-opacity));
}

.bg-green-400 {
  --bg-opacity: 1;
  background-color: #68d391;
  background-color: rgba(104, 211, 145, var(--bg-opacity));
}

.bg-green-500 {
  --bg-opacity: 1;
  background-color: #48bb78;
  background-color: rgba(72, 187, 120, var(--bg-opacity));
}

.bg-green-600 {
  --bg-opacity: 1;
  background-color: #38a169;
  background-color: rgba(56, 161, 105, var(--bg-opacity));
}

.bg-green-700 {
  --bg-opacity: 1;
  background-color: #2f855a;
  background-color: rgba(47, 133, 90, var(--bg-opacity));
}

.bg-green-800 {
  --bg-opacity: 1;
  background-color: #276749;
  background-color: rgba(39, 103, 73, var(--bg-opacity));
}

.bg-green-900 {
  --bg-opacity: 1;
  background-color: #22543d;
  background-color: rgba(34, 84, 61, var(--bg-opacity));
}

.bg-teal-100 {
  --bg-opacity: 1;
  background-color: #e6fffa;
  background-color: rgba(230, 255, 250, var(--bg-opacity));
}

.bg-teal-200 {
  --bg-opacity: 1;
  background-color: #b2f5ea;
  background-color: rgba(178, 245, 234, var(--bg-opacity));
}

.bg-teal-300 {
  --bg-opacity: 1;
  background-color: #81e6d9;
  background-color: rgba(129, 230, 217, var(--bg-opacity));
}

.bg-teal-400 {
  --bg-opacity: 1;
  background-color: #4fd1c5;
  background-color: rgba(79, 209, 197, var(--bg-opacity));
}

.bg-teal-500 {
  --bg-opacity: 1;
  background-color: #38b2ac;
  background-color: rgba(56, 178, 172, var(--bg-opacity));
}

.bg-teal-600 {
  --bg-opacity: 1;
  background-color: #319795;
  background-color: rgba(49, 151, 149, var(--bg-opacity));
}

.bg-teal-700 {
  --bg-opacity: 1;
  background-color: #2c7a7b;
  background-color: rgba(44, 122, 123, var(--bg-opacity));
}

.bg-teal-800 {
  --bg-opacity: 1;
  background-color: #285e61;
  background-color: rgba(40, 94, 97, var(--bg-opacity));
}

.bg-teal-900 {
  --bg-opacity: 1;
  background-color: #234e52;
  background-color: rgba(35, 78, 82, var(--bg-opacity));
}

.bg-blue-100 {
  --bg-opacity: 1;
  background-color: #ebf8ff;
  background-color: rgba(235, 248, 255, var(--bg-opacity));
}

.bg-blue-200 {
  --bg-opacity: 1;
  background-color: #bee3f8;
  background-color: rgba(190, 227, 248, var(--bg-opacity));
}

.bg-blue-300 {
  --bg-opacity: 1;
  background-color: #90cdf4;
  background-color: rgba(144, 205, 244, var(--bg-opacity));
}

.bg-blue-400 {
  --bg-opacity: 1;
  background-color: #63b3ed;
  background-color: rgba(99, 179, 237, var(--bg-opacity));
}

.bg-blue-500 {
  --bg-opacity: 1;
  background-color: #4299e1;
  background-color: rgba(66, 153, 225, var(--bg-opacity));
}

.bg-blue-600 {
  --bg-opacity: 1;
  background-color: #3182ce;
  background-color: rgba(49, 130, 206, var(--bg-opacity));
}

.bg-blue-700 {
  --bg-opacity: 1;
  background-color: #2b6cb0;
  background-color: rgba(43, 108, 176, var(--bg-opacity));
}

.bg-blue-800 {
  --bg-opacity: 1;
  background-color: #2c5282;
  background-color: rgba(44, 82, 130, var(--bg-opacity));
}

.bg-blue-900 {
  --bg-opacity: 1;
  background-color: #2a4365;
  background-color: rgba(42, 67, 101, var(--bg-opacity));
}

.bg-indigo-100 {
  --bg-opacity: 1;
  background-color: #ebf4ff;
  background-color: rgba(235, 244, 255, var(--bg-opacity));
}

.bg-indigo-200 {
  --bg-opacity: 1;
  background-color: #c3dafe;
  background-color: rgba(195, 218, 254, var(--bg-opacity));
}

.bg-indigo-300 {
  --bg-opacity: 1;
  background-color: #a3bffa;
  background-color: rgba(163, 191, 250, var(--bg-opacity));
}

.bg-indigo-400 {
  --bg-opacity: 1;
  background-color: #7f9cf5;
  background-color: rgba(127, 156, 245, var(--bg-opacity));
}

.bg-indigo-500 {
  --bg-opacity: 1;
  background-color: #667eea;
  background-color: rgba(102, 126, 234, var(--bg-opacity));
}

.bg-indigo-600 {
  --bg-opacity: 1;
  background-color: #5a67d8;
  background-color: rgba(90, 103, 216, var(--bg-opacity));
}

.bg-indigo-700 {
  --bg-opacity: 1;
  background-color: #4c51bf;
  background-color: rgba(76, 81, 191, var(--bg-opacity));
}

.bg-indigo-800 {
  --bg-opacity: 1;
  background-color: #434190;
  background-color: rgba(67, 65, 144, var(--bg-opacity));
}

.bg-indigo-900 {
  --bg-opacity: 1;
  background-color: #3c366b;
  background-color: rgba(60, 54, 107, var(--bg-opacity));
}

.bg-purple-100 {
  --bg-opacity: 1;
  background-color: #faf5ff;
  background-color: rgba(250, 245, 255, var(--bg-opacity));
}

.bg-purple-200 {
  --bg-opacity: 1;
  background-color: #e9d8fd;
  background-color: rgba(233, 216, 253, var(--bg-opacity));
}

.bg-purple-300 {
  --bg-opacity: 1;
  background-color: #d6bcfa;
  background-color: rgba(214, 188, 250, var(--bg-opacity));
}

.bg-purple-400 {
  --bg-opacity: 1;
  background-color: #b794f4;
  background-color: rgba(183, 148, 244, var(--bg-opacity));
}

.bg-purple-500 {
  --bg-opacity: 1;
  background-color: #9f7aea;
  background-color: rgba(159, 122, 234, var(--bg-opacity));
}

.bg-purple-600 {
  --bg-opacity: 1;
  background-color: #805ad5;
  background-color: rgba(128, 90, 213, var(--bg-opacity));
}

.bg-purple-700 {
  --bg-opacity: 1;
  background-color: #6b46c1;
  background-color: rgba(107, 70, 193, var(--bg-opacity));
}

.bg-purple-800 {
  --bg-opacity: 1;
  background-color: #553c9a;
  background-color: rgba(85, 60, 154, var(--bg-opacity));
}

.bg-purple-900 {
  --bg-opacity: 1;
  background-color: #44337a;
  background-color: rgba(68, 51, 122, var(--bg-opacity));
}

.bg-pink-100 {
  --bg-opacity: 1;
  background-color: #fff5f7;
  background-color: rgba(255, 245, 247, var(--bg-opacity));
}

.bg-pink-200 {
  --bg-opacity: 1;
  background-color: #fed7e2;
  background-color: rgba(254, 215, 226, var(--bg-opacity));
}

.bg-pink-300 {
  --bg-opacity: 1;
  background-color: #fbb6ce;
  background-color: rgba(251, 182, 206, var(--bg-opacity));
}

.bg-pink-400 {
  --bg-opacity: 1;
  background-color: #f687b3;
  background-color: rgba(246, 135, 179, var(--bg-opacity));
}

.bg-pink-500 {
  --bg-opacity: 1;
  background-color: #ed64a6;
  background-color: rgba(237, 100, 166, var(--bg-opacity));
}

.bg-pink-600 {
  --bg-opacity: 1;
  background-color: #d53f8c;
  background-color: rgba(213, 63, 140, var(--bg-opacity));
}

.bg-pink-700 {
  --bg-opacity: 1;
  background-color: #b83280;
  background-color: rgba(184, 50, 128, var(--bg-opacity));
}

.bg-pink-800 {
  --bg-opacity: 1;
  background-color: #97266d;
  background-color: rgba(151, 38, 109, var(--bg-opacity));
}

.bg-pink-900 {
  --bg-opacity: 1;
  background-color: #702459;
  background-color: rgba(112, 36, 89, var(--bg-opacity));
}

.hover\\:bg-transparent:hover {
  background-color: transparent;
}

.hover\\:bg-current:hover {
  background-color: currentColor;
}

.hover\\:bg-black:hover {
  --bg-opacity: 1;
  background-color: #000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}

.hover\\:bg-white:hover {
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}

.hover\\:bg-gray-100:hover {
  --bg-opacity: 1;
  background-color: #f7fafc;
  background-color: rgba(247, 250, 252, var(--bg-opacity));
}

.hover\\:bg-gray-200:hover {
  --bg-opacity: 1;
  background-color: #edf2f7;
  background-color: rgba(237, 242, 247, var(--bg-opacity));
}

.hover\\:bg-gray-300:hover {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}

.hover\\:bg-gray-400:hover {
  --bg-opacity: 1;
  background-color: #cbd5e0;
  background-color: rgba(203, 213, 224, var(--bg-opacity));
}

.hover\\:bg-gray-500:hover {
  --bg-opacity: 1;
  background-color: #a0aec0;
  background-color: rgba(160, 174, 192, var(--bg-opacity));
}

.hover\\:bg-gray-600:hover {
  --bg-opacity: 1;
  background-color: #718096;
  background-color: rgba(113, 128, 150, var(--bg-opacity));
}

.hover\\:bg-gray-700:hover {
  --bg-opacity: 1;
  background-color: #4a5568;
  background-color: rgba(74, 85, 104, var(--bg-opacity));
}

.hover\\:bg-gray-800:hover {
  --bg-opacity: 1;
  background-color: #2d3748;
  background-color: rgba(45, 55, 72, var(--bg-opacity));
}

.hover\\:bg-gray-900:hover {
  --bg-opacity: 1;
  background-color: #1a202c;
  background-color: rgba(26, 32, 44, var(--bg-opacity));
}

.hover\\:bg-red-100:hover {
  --bg-opacity: 1;
  background-color: #fff5f5;
  background-color: rgba(255, 245, 245, var(--bg-opacity));
}

.hover\\:bg-red-200:hover {
  --bg-opacity: 1;
  background-color: #fed7d7;
  background-color: rgba(254, 215, 215, var(--bg-opacity));
}

.hover\\:bg-red-300:hover {
  --bg-opacity: 1;
  background-color: #feb2b2;
  background-color: rgba(254, 178, 178, var(--bg-opacity));
}

.hover\\:bg-red-400:hover {
  --bg-opacity: 1;
  background-color: #fc8181;
  background-color: rgba(252, 129, 129, var(--bg-opacity));
}

.hover\\:bg-red-500:hover {
  --bg-opacity: 1;
  background-color: #f56565;
  background-color: rgba(245, 101, 101, var(--bg-opacity));
}

.hover\\:bg-red-600:hover {
  --bg-opacity: 1;
  background-color: #e53e3e;
  background-color: rgba(229, 62, 62, var(--bg-opacity));
}

.hover\\:bg-red-700:hover {
  --bg-opacity: 1;
  background-color: #c53030;
  background-color: rgba(197, 48, 48, var(--bg-opacity));
}

.hover\\:bg-red-800:hover {
  --bg-opacity: 1;
  background-color: #9b2c2c;
  background-color: rgba(155, 44, 44, var(--bg-opacity));
}

.hover\\:bg-red-900:hover {
  --bg-opacity: 1;
  background-color: #742a2a;
  background-color: rgba(116, 42, 42, var(--bg-opacity));
}

.hover\\:bg-orange-100:hover {
  --bg-opacity: 1;
  background-color: #fffaf0;
  background-color: rgba(255, 250, 240, var(--bg-opacity));
}

.hover\\:bg-orange-200:hover {
  --bg-opacity: 1;
  background-color: #feebc8;
  background-color: rgba(254, 235, 200, var(--bg-opacity));
}

.hover\\:bg-orange-300:hover {
  --bg-opacity: 1;
  background-color: #fbd38d;
  background-color: rgba(251, 211, 141, var(--bg-opacity));
}

.hover\\:bg-orange-400:hover {
  --bg-opacity: 1;
  background-color: #f6ad55;
  background-color: rgba(246, 173, 85, var(--bg-opacity));
}

.hover\\:bg-orange-500:hover {
  --bg-opacity: 1;
  background-color: #ed8936;
  background-color: rgba(237, 137, 54, var(--bg-opacity));
}

.hover\\:bg-orange-600:hover {
  --bg-opacity: 1;
  background-color: #dd6b20;
  background-color: rgba(221, 107, 32, var(--bg-opacity));
}

.hover\\:bg-orange-700:hover {
  --bg-opacity: 1;
  background-color: #c05621;
  background-color: rgba(192, 86, 33, var(--bg-opacity));
}

.hover\\:bg-orange-800:hover {
  --bg-opacity: 1;
  background-color: #9c4221;
  background-color: rgba(156, 66, 33, var(--bg-opacity));
}

.hover\\:bg-orange-900:hover {
  --bg-opacity: 1;
  background-color: #7b341e;
  background-color: rgba(123, 52, 30, var(--bg-opacity));
}

.hover\\:bg-yellow-100:hover {
  --bg-opacity: 1;
  background-color: #fffff0;
  background-color: rgba(255, 255, 240, var(--bg-opacity));
}

.hover\\:bg-yellow-200:hover {
  --bg-opacity: 1;
  background-color: #fefcbf;
  background-color: rgba(254, 252, 191, var(--bg-opacity));
}

.hover\\:bg-yellow-300:hover {
  --bg-opacity: 1;
  background-color: #faf089;
  background-color: rgba(250, 240, 137, var(--bg-opacity));
}

.hover\\:bg-yellow-400:hover {
  --bg-opacity: 1;
  background-color: #f6e05e;
  background-color: rgba(246, 224, 94, var(--bg-opacity));
}

.hover\\:bg-yellow-500:hover {
  --bg-opacity: 1;
  background-color: #ecc94b;
  background-color: rgba(236, 201, 75, var(--bg-opacity));
}

.hover\\:bg-yellow-600:hover {
  --bg-opacity: 1;
  background-color: #d69e2e;
  background-color: rgba(214, 158, 46, var(--bg-opacity));
}

.hover\\:bg-yellow-700:hover {
  --bg-opacity: 1;
  background-color: #b7791f;
  background-color: rgba(183, 121, 31, var(--bg-opacity));
}

.hover\\:bg-yellow-800:hover {
  --bg-opacity: 1;
  background-color: #975a16;
  background-color: rgba(151, 90, 22, var(--bg-opacity));
}

.hover\\:bg-yellow-900:hover {
  --bg-opacity: 1;
  background-color: #744210;
  background-color: rgba(116, 66, 16, var(--bg-opacity));
}

.hover\\:bg-green-100:hover {
  --bg-opacity: 1;
  background-color: #f0fff4;
  background-color: rgba(240, 255, 244, var(--bg-opacity));
}

.hover\\:bg-green-200:hover {
  --bg-opacity: 1;
  background-color: #c6f6d5;
  background-color: rgba(198, 246, 213, var(--bg-opacity));
}

.hover\\:bg-green-300:hover {
  --bg-opacity: 1;
  background-color: #9ae6b4;
  background-color: rgba(154, 230, 180, var(--bg-opacity));
}

.hover\\:bg-green-400:hover {
  --bg-opacity: 1;
  background-color: #68d391;
  background-color: rgba(104, 211, 145, var(--bg-opacity));
}

.hover\\:bg-green-500:hover {
  --bg-opacity: 1;
  background-color: #48bb78;
  background-color: rgba(72, 187, 120, var(--bg-opacity));
}

.hover\\:bg-green-600:hover {
  --bg-opacity: 1;
  background-color: #38a169;
  background-color: rgba(56, 161, 105, var(--bg-opacity));
}

.hover\\:bg-green-700:hover {
  --bg-opacity: 1;
  background-color: #2f855a;
  background-color: rgba(47, 133, 90, var(--bg-opacity));
}

.hover\\:bg-green-800:hover {
  --bg-opacity: 1;
  background-color: #276749;
  background-color: rgba(39, 103, 73, var(--bg-opacity));
}

.hover\\:bg-green-900:hover {
  --bg-opacity: 1;
  background-color: #22543d;
  background-color: rgba(34, 84, 61, var(--bg-opacity));
}

.hover\\:bg-teal-100:hover {
  --bg-opacity: 1;
  background-color: #e6fffa;
  background-color: rgba(230, 255, 250, var(--bg-opacity));
}

.hover\\:bg-teal-200:hover {
  --bg-opacity: 1;
  background-color: #b2f5ea;
  background-color: rgba(178, 245, 234, var(--bg-opacity));
}

.hover\\:bg-teal-300:hover {
  --bg-opacity: 1;
  background-color: #81e6d9;
  background-color: rgba(129, 230, 217, var(--bg-opacity));
}

.hover\\:bg-teal-400:hover {
  --bg-opacity: 1;
  background-color: #4fd1c5;
  background-color: rgba(79, 209, 197, var(--bg-opacity));
}

.hover\\:bg-teal-500:hover {
  --bg-opacity: 1;
  background-color: #38b2ac;
  background-color: rgba(56, 178, 172, var(--bg-opacity));
}

.hover\\:bg-teal-600:hover {
  --bg-opacity: 1;
  background-color: #319795;
  background-color: rgba(49, 151, 149, var(--bg-opacity));
}

.hover\\:bg-teal-700:hover {
  --bg-opacity: 1;
  background-color: #2c7a7b;
  background-color: rgba(44, 122, 123, var(--bg-opacity));
}

.hover\\:bg-teal-800:hover {
  --bg-opacity: 1;
  background-color: #285e61;
  background-color: rgba(40, 94, 97, var(--bg-opacity));
}

.hover\\:bg-teal-900:hover {
  --bg-opacity: 1;
  background-color: #234e52;
  background-color: rgba(35, 78, 82, var(--bg-opacity));
}

.hover\\:bg-blue-100:hover {
  --bg-opacity: 1;
  background-color: #ebf8ff;
  background-color: rgba(235, 248, 255, var(--bg-opacity));
}

.hover\\:bg-blue-200:hover {
  --bg-opacity: 1;
  background-color: #bee3f8;
  background-color: rgba(190, 227, 248, var(--bg-opacity));
}

.hover\\:bg-blue-300:hover {
  --bg-opacity: 1;
  background-color: #90cdf4;
  background-color: rgba(144, 205, 244, var(--bg-opacity));
}

.hover\\:bg-blue-400:hover {
  --bg-opacity: 1;
  background-color: #63b3ed;
  background-color: rgba(99, 179, 237, var(--bg-opacity));
}

.hover\\:bg-blue-500:hover {
  --bg-opacity: 1;
  background-color: #4299e1;
  background-color: rgba(66, 153, 225, var(--bg-opacity));
}

.hover\\:bg-blue-600:hover {
  --bg-opacity: 1;
  background-color: #3182ce;
  background-color: rgba(49, 130, 206, var(--bg-opacity));
}

.hover\\:bg-blue-700:hover {
  --bg-opacity: 1;
  background-color: #2b6cb0;
  background-color: rgba(43, 108, 176, var(--bg-opacity));
}

.hover\\:bg-blue-800:hover {
  --bg-opacity: 1;
  background-color: #2c5282;
  background-color: rgba(44, 82, 130, var(--bg-opacity));
}

.hover\\:bg-blue-900:hover {
  --bg-opacity: 1;
  background-color: #2a4365;
  background-color: rgba(42, 67, 101, var(--bg-opacity));
}

.hover\\:bg-indigo-100:hover {
  --bg-opacity: 1;
  background-color: #ebf4ff;
  background-color: rgba(235, 244, 255, var(--bg-opacity));
}

.hover\\:bg-indigo-200:hover {
  --bg-opacity: 1;
  background-color: #c3dafe;
  background-color: rgba(195, 218, 254, var(--bg-opacity));
}

.hover\\:bg-indigo-300:hover {
  --bg-opacity: 1;
  background-color: #a3bffa;
  background-color: rgba(163, 191, 250, var(--bg-opacity));
}

.hover\\:bg-indigo-400:hover {
  --bg-opacity: 1;
  background-color: #7f9cf5;
  background-color: rgba(127, 156, 245, var(--bg-opacity));
}

.hover\\:bg-indigo-500:hover {
  --bg-opacity: 1;
  background-color: #667eea;
  background-color: rgba(102, 126, 234, var(--bg-opacity));
}

.hover\\:bg-indigo-600:hover {
  --bg-opacity: 1;
  background-color: #5a67d8;
  background-color: rgba(90, 103, 216, var(--bg-opacity));
}

.hover\\:bg-indigo-700:hover {
  --bg-opacity: 1;
  background-color: #4c51bf;
  background-color: rgba(76, 81, 191, var(--bg-opacity));
}

.hover\\:bg-indigo-800:hover {
  --bg-opacity: 1;
  background-color: #434190;
  background-color: rgba(67, 65, 144, var(--bg-opacity));
}

.hover\\:bg-indigo-900:hover {
  --bg-opacity: 1;
  background-color: #3c366b;
  background-color: rgba(60, 54, 107, var(--bg-opacity));
}

.hover\\:bg-purple-100:hover {
  --bg-opacity: 1;
  background-color: #faf5ff;
  background-color: rgba(250, 245, 255, var(--bg-opacity));
}

.hover\\:bg-purple-200:hover {
  --bg-opacity: 1;
  background-color: #e9d8fd;
  background-color: rgba(233, 216, 253, var(--bg-opacity));
}

.hover\\:bg-purple-300:hover {
  --bg-opacity: 1;
  background-color: #d6bcfa;
  background-color: rgba(214, 188, 250, var(--bg-opacity));
}

.hover\\:bg-purple-400:hover {
  --bg-opacity: 1;
  background-color: #b794f4;
  background-color: rgba(183, 148, 244, var(--bg-opacity));
}

.hover\\:bg-purple-500:hover {
  --bg-opacity: 1;
  background-color: #9f7aea;
  background-color: rgba(159, 122, 234, var(--bg-opacity));
}

.hover\\:bg-purple-600:hover {
  --bg-opacity: 1;
  background-color: #805ad5;
  background-color: rgba(128, 90, 213, var(--bg-opacity));
}

.hover\\:bg-purple-700:hover {
  --bg-opacity: 1;
  background-color: #6b46c1;
  background-color: rgba(107, 70, 193, var(--bg-opacity));
}

.hover\\:bg-purple-800:hover {
  --bg-opacity: 1;
  background-color: #553c9a;
  background-color: rgba(85, 60, 154, var(--bg-opacity));
}

.hover\\:bg-purple-900:hover {
  --bg-opacity: 1;
  background-color: #44337a;
  background-color: rgba(68, 51, 122, var(--bg-opacity));
}

.hover\\:bg-pink-100:hover {
  --bg-opacity: 1;
  background-color: #fff5f7;
  background-color: rgba(255, 245, 247, var(--bg-opacity));
}

.hover\\:bg-pink-200:hover {
  --bg-opacity: 1;
  background-color: #fed7e2;
  background-color: rgba(254, 215, 226, var(--bg-opacity));
}

.hover\\:bg-pink-300:hover {
  --bg-opacity: 1;
  background-color: #fbb6ce;
  background-color: rgba(251, 182, 206, var(--bg-opacity));
}

.hover\\:bg-pink-400:hover {
  --bg-opacity: 1;
  background-color: #f687b3;
  background-color: rgba(246, 135, 179, var(--bg-opacity));
}

.hover\\:bg-pink-500:hover {
  --bg-opacity: 1;
  background-color: #ed64a6;
  background-color: rgba(237, 100, 166, var(--bg-opacity));
}

.hover\\:bg-pink-600:hover {
  --bg-opacity: 1;
  background-color: #d53f8c;
  background-color: rgba(213, 63, 140, var(--bg-opacity));
}

.hover\\:bg-pink-700:hover {
  --bg-opacity: 1;
  background-color: #b83280;
  background-color: rgba(184, 50, 128, var(--bg-opacity));
}

.hover\\:bg-pink-800:hover {
  --bg-opacity: 1;
  background-color: #97266d;
  background-color: rgba(151, 38, 109, var(--bg-opacity));
}

.hover\\:bg-pink-900:hover {
  --bg-opacity: 1;
  background-color: #702459;
  background-color: rgba(112, 36, 89, var(--bg-opacity));
}

.focus\\:bg-transparent:focus {
  background-color: transparent;
}

.focus\\:bg-current:focus {
  background-color: currentColor;
}

.focus\\:bg-black:focus {
  --bg-opacity: 1;
  background-color: #000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}

.focus\\:bg-white:focus {
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}

.focus\\:bg-gray-100:focus {
  --bg-opacity: 1;
  background-color: #f7fafc;
  background-color: rgba(247, 250, 252, var(--bg-opacity));
}

.focus\\:bg-gray-200:focus {
  --bg-opacity: 1;
  background-color: #edf2f7;
  background-color: rgba(237, 242, 247, var(--bg-opacity));
}

.focus\\:bg-gray-300:focus {
  --bg-opacity: 1;
  background-color: #e2e8f0;
  background-color: rgba(226, 232, 240, var(--bg-opacity));
}

.focus\\:bg-gray-400:focus {
  --bg-opacity: 1;
  background-color: #cbd5e0;
  background-color: rgba(203, 213, 224, var(--bg-opacity));
}

.focus\\:bg-gray-500:focus {
  --bg-opacity: 1;
  background-color: #a0aec0;
  background-color: rgba(160, 174, 192, var(--bg-opacity));
}

.focus\\:bg-gray-600:focus {
  --bg-opacity: 1;
  background-color: #718096;
  background-color: rgba(113, 128, 150, var(--bg-opacity));
}

.focus\\:bg-gray-700:focus {
  --bg-opacity: 1;
  background-color: #4a5568;
  background-color: rgba(74, 85, 104, var(--bg-opacity));
}

.focus\\:bg-gray-800:focus {
  --bg-opacity: 1;
  background-color: #2d3748;
  background-color: rgba(45, 55, 72, var(--bg-opacity));
}

.focus\\:bg-gray-900:focus {
  --bg-opacity: 1;
  background-color: #1a202c;
  background-color: rgba(26, 32, 44, var(--bg-opacity));
}

.focus\\:bg-red-100:focus {
  --bg-opacity: 1;
  background-color: #fff5f5;
  background-color: rgba(255, 245, 245, var(--bg-opacity));
}

.focus\\:bg-red-200:focus {
  --bg-opacity: 1;
  background-color: #fed7d7;
  background-color: rgba(254, 215, 215, var(--bg-opacity));
}

.focus\\:bg-red-300:focus {
  --bg-opacity: 1;
  background-color: #feb2b2;
  background-color: rgba(254, 178, 178, var(--bg-opacity));
}

.focus\\:bg-red-400:focus {
  --bg-opacity: 1;
  background-color: #fc8181;
  background-color: rgba(252, 129, 129, var(--bg-opacity));
}

.focus\\:bg-red-500:focus {
  --bg-opacity: 1;
  background-color: #f56565;
  background-color: rgba(245, 101, 101, var(--bg-opacity));
}

.focus\\:bg-red-600:focus {
  --bg-opacity: 1;
  background-color: #e53e3e;
  background-color: rgba(229, 62, 62, var(--bg-opacity));
}

.focus\\:bg-red-700:focus {
  --bg-opacity: 1;
  background-color: #c53030;
  background-color: rgba(197, 48, 48, var(--bg-opacity));
}

.focus\\:bg-red-800:focus {
  --bg-opacity: 1;
  background-color: #9b2c2c;
  background-color: rgba(155, 44, 44, var(--bg-opacity));
}

.focus\\:bg-red-900:focus {
  --bg-opacity: 1;
  background-color: #742a2a;
  background-color: rgba(116, 42, 42, var(--bg-opacity));
}

.focus\\:bg-orange-100:focus {
  --bg-opacity: 1;
  background-color: #fffaf0;
  background-color: rgba(255, 250, 240, var(--bg-opacity));
}

.focus\\:bg-orange-200:focus {
  --bg-opacity: 1;
  background-color: #feebc8;
  background-color: rgba(254, 235, 200, var(--bg-opacity));
}

.focus\\:bg-orange-300:focus {
  --bg-opacity: 1;
  background-color: #fbd38d;
  background-color: rgba(251, 211, 141, var(--bg-opacity));
}

.focus\\:bg-orange-400:focus {
  --bg-opacity: 1;
  background-color: #f6ad55;
  background-color: rgba(246, 173, 85, var(--bg-opacity));
}

.focus\\:bg-orange-500:focus {
  --bg-opacity: 1;
  background-color: #ed8936;
  background-color: rgba(237, 137, 54, var(--bg-opacity));
}

.focus\\:bg-orange-600:focus {
  --bg-opacity: 1;
  background-color: #dd6b20;
  background-color: rgba(221, 107, 32, var(--bg-opacity));
}

.focus\\:bg-orange-700:focus {
  --bg-opacity: 1;
  background-color: #c05621;
  background-color: rgba(192, 86, 33, var(--bg-opacity));
}

.focus\\:bg-orange-800:focus {
  --bg-opacity: 1;
  background-color: #9c4221;
  background-color: rgba(156, 66, 33, var(--bg-opacity));
}

.focus\\:bg-orange-900:focus {
  --bg-opacity: 1;
  background-color: #7b341e;
  background-color: rgba(123, 52, 30, var(--bg-opacity));
}

.focus\\:bg-yellow-100:focus {
  --bg-opacity: 1;
  background-color: #fffff0;
  background-color: rgba(255, 255, 240, var(--bg-opacity));
}

.focus\\:bg-yellow-200:focus {
  --bg-opacity: 1;
  background-color: #fefcbf;
  background-color: rgba(254, 252, 191, var(--bg-opacity));
}

.focus\\:bg-yellow-300:focus {
  --bg-opacity: 1;
  background-color: #faf089;
  background-color: rgba(250, 240, 137, var(--bg-opacity));
}

.focus\\:bg-yellow-400:focus {
  --bg-opacity: 1;
  background-color: #f6e05e;
  background-color: rgba(246, 224, 94, var(--bg-opacity));
}

.focus\\:bg-yellow-500:focus {
  --bg-opacity: 1;
  background-color: #ecc94b;
  background-color: rgba(236, 201, 75, var(--bg-opacity));
}

.focus\\:bg-yellow-600:focus {
  --bg-opacity: 1;
  background-color: #d69e2e;
  background-color: rgba(214, 158, 46, var(--bg-opacity));
}

.focus\\:bg-yellow-700:focus {
  --bg-opacity: 1;
  background-color: #b7791f;
  background-color: rgba(183, 121, 31, var(--bg-opacity));
}

.focus\\:bg-yellow-800:focus {
  --bg-opacity: 1;
  background-color: #975a16;
  background-color: rgba(151, 90, 22, var(--bg-opacity));
}

.focus\\:bg-yellow-900:focus {
  --bg-opacity: 1;
  background-color: #744210;
  background-color: rgba(116, 66, 16, var(--bg-opacity));
}

.focus\\:bg-green-100:focus {
  --bg-opacity: 1;
  background-color: #f0fff4;
  background-color: rgba(240, 255, 244, var(--bg-opacity));
}

.focus\\:bg-green-200:focus {
  --bg-opacity: 1;
  background-color: #c6f6d5;
  background-color: rgba(198, 246, 213, var(--bg-opacity));
}

.focus\\:bg-green-300:focus {
  --bg-opacity: 1;
  background-color: #9ae6b4;
  background-color: rgba(154, 230, 180, var(--bg-opacity));
}

.focus\\:bg-green-400:focus {
  --bg-opacity: 1;
  background-color: #68d391;
  background-color: rgba(104, 211, 145, var(--bg-opacity));
}

.focus\\:bg-green-500:focus {
  --bg-opacity: 1;
  background-color: #48bb78;
  background-color: rgba(72, 187, 120, var(--bg-opacity));
}

.focus\\:bg-green-600:focus {
  --bg-opacity: 1;
  background-color: #38a169;
  background-color: rgba(56, 161, 105, var(--bg-opacity));
}

.focus\\:bg-green-700:focus {
  --bg-opacity: 1;
  background-color: #2f855a;
  background-color: rgba(47, 133, 90, var(--bg-opacity));
}

.focus\\:bg-green-800:focus {
  --bg-opacity: 1;
  background-color: #276749;
  background-color: rgba(39, 103, 73, var(--bg-opacity));
}

.focus\\:bg-green-900:focus {
  --bg-opacity: 1;
  background-color: #22543d;
  background-color: rgba(34, 84, 61, var(--bg-opacity));
}

.focus\\:bg-teal-100:focus {
  --bg-opacity: 1;
  background-color: #e6fffa;
  background-color: rgba(230, 255, 250, var(--bg-opacity));
}

.focus\\:bg-teal-200:focus {
  --bg-opacity: 1;
  background-color: #b2f5ea;
  background-color: rgba(178, 245, 234, var(--bg-opacity));
}

.focus\\:bg-teal-300:focus {
  --bg-opacity: 1;
  background-color: #81e6d9;
  background-color: rgba(129, 230, 217, var(--bg-opacity));
}

.focus\\:bg-teal-400:focus {
  --bg-opacity: 1;
  background-color: #4fd1c5;
  background-color: rgba(79, 209, 197, var(--bg-opacity));
}

.focus\\:bg-teal-500:focus {
  --bg-opacity: 1;
  background-color: #38b2ac;
  background-color: rgba(56, 178, 172, var(--bg-opacity));
}

.focus\\:bg-teal-600:focus {
  --bg-opacity: 1;
  background-color: #319795;
  background-color: rgba(49, 151, 149, var(--bg-opacity));
}

.focus\\:bg-teal-700:focus {
  --bg-opacity: 1;
  background-color: #2c7a7b;
  background-color: rgba(44, 122, 123, var(--bg-opacity));
}

.focus\\:bg-teal-800:focus {
  --bg-opacity: 1;
  background-color: #285e61;
  background-color: rgba(40, 94, 97, var(--bg-opacity));
}

.focus\\:bg-teal-900:focus {
  --bg-opacity: 1;
  background-color: #234e52;
  background-color: rgba(35, 78, 82, var(--bg-opacity));
}

.focus\\:bg-blue-100:focus {
  --bg-opacity: 1;
  background-color: #ebf8ff;
  background-color: rgba(235, 248, 255, var(--bg-opacity));
}

.focus\\:bg-blue-200:focus {
  --bg-opacity: 1;
  background-color: #bee3f8;
  background-color: rgba(190, 227, 248, var(--bg-opacity));
}

.focus\\:bg-blue-300:focus {
  --bg-opacity: 1;
  background-color: #90cdf4;
  background-color: rgba(144, 205, 244, var(--bg-opacity));
}

.focus\\:bg-blue-400:focus {
  --bg-opacity: 1;
  background-color: #63b3ed;
  background-color: rgba(99, 179, 237, var(--bg-opacity));
}

.focus\\:bg-blue-500:focus {
  --bg-opacity: 1;
  background-color: #4299e1;
  background-color: rgba(66, 153, 225, var(--bg-opacity));
}

.focus\\:bg-blue-600:focus {
  --bg-opacity: 1;
  background-color: #3182ce;
  background-color: rgba(49, 130, 206, var(--bg-opacity));
}

.focus\\:bg-blue-700:focus {
  --bg-opacity: 1;
  background-color: #2b6cb0;
  background-color: rgba(43, 108, 176, var(--bg-opacity));
}

.focus\\:bg-blue-800:focus {
  --bg-opacity: 1;
  background-color: #2c5282;
  background-color: rgba(44, 82, 130, var(--bg-opacity));
}

.focus\\:bg-blue-900:focus {
  --bg-opacity: 1;
  background-color: #2a4365;
  background-color: rgba(42, 67, 101, var(--bg-opacity));
}

.focus\\:bg-indigo-100:focus {
  --bg-opacity: 1;
  background-color: #ebf4ff;
  background-color: rgba(235, 244, 255, var(--bg-opacity));
}

.focus\\:bg-indigo-200:focus {
  --bg-opacity: 1;
  background-color: #c3dafe;
  background-color: rgba(195, 218, 254, var(--bg-opacity));
}

.focus\\:bg-indigo-300:focus {
  --bg-opacity: 1;
  background-color: #a3bffa;
  background-color: rgba(163, 191, 250, var(--bg-opacity));
}

.focus\\:bg-indigo-400:focus {
  --bg-opacity: 1;
  background-color: #7f9cf5;
  background-color: rgba(127, 156, 245, var(--bg-opacity));
}

.focus\\:bg-indigo-500:focus {
  --bg-opacity: 1;
  background-color: #667eea;
  background-color: rgba(102, 126, 234, var(--bg-opacity));
}

.focus\\:bg-indigo-600:focus {
  --bg-opacity: 1;
  background-color: #5a67d8;
  background-color: rgba(90, 103, 216, var(--bg-opacity));
}

.focus\\:bg-indigo-700:focus {
  --bg-opacity: 1;
  background-color: #4c51bf;
  background-color: rgba(76, 81, 191, var(--bg-opacity));
}

.focus\\:bg-indigo-800:focus {
  --bg-opacity: 1;
  background-color: #434190;
  background-color: rgba(67, 65, 144, var(--bg-opacity));
}

.focus\\:bg-indigo-900:focus {
  --bg-opacity: 1;
  background-color: #3c366b;
  background-color: rgba(60, 54, 107, var(--bg-opacity));
}

.focus\\:bg-purple-100:focus {
  --bg-opacity: 1;
  background-color: #faf5ff;
  background-color: rgba(250, 245, 255, var(--bg-opacity));
}

.focus\\:bg-purple-200:focus {
  --bg-opacity: 1;
  background-color: #e9d8fd;
  background-color: rgba(233, 216, 253, var(--bg-opacity));
}

.focus\\:bg-purple-300:focus {
  --bg-opacity: 1;
  background-color: #d6bcfa;
  background-color: rgba(214, 188, 250, var(--bg-opacity));
}

.focus\\:bg-purple-400:focus {
  --bg-opacity: 1;
  background-color: #b794f4;
  background-color: rgba(183, 148, 244, var(--bg-opacity));
}

.focus\\:bg-purple-500:focus {
  --bg-opacity: 1;
  background-color: #9f7aea;
  background-color: rgba(159, 122, 234, var(--bg-opacity));
}

.focus\\:bg-purple-600:focus {
  --bg-opacity: 1;
  background-color: #805ad5;
  background-color: rgba(128, 90, 213, var(--bg-opacity));
}

.focus\\:bg-purple-700:focus {
  --bg-opacity: 1;
  background-color: #6b46c1;
  background-color: rgba(107, 70, 193, var(--bg-opacity));
}

.focus\\:bg-purple-800:focus {
  --bg-opacity: 1;
  background-color: #553c9a;
  background-color: rgba(85, 60, 154, var(--bg-opacity));
}

.focus\\:bg-purple-900:focus {
  --bg-opacity: 1;
  background-color: #44337a;
  background-color: rgba(68, 51, 122, var(--bg-opacity));
}

.focus\\:bg-pink-100:focus {
  --bg-opacity: 1;
  background-color: #fff5f7;
  background-color: rgba(255, 245, 247, var(--bg-opacity));
}

.focus\\:bg-pink-200:focus {
  --bg-opacity: 1;
  background-color: #fed7e2;
  background-color: rgba(254, 215, 226, var(--bg-opacity));
}

.focus\\:bg-pink-300:focus {
  --bg-opacity: 1;
  background-color: #fbb6ce;
  background-color: rgba(251, 182, 206, var(--bg-opacity));
}

.focus\\:bg-pink-400:focus {
  --bg-opacity: 1;
  background-color: #f687b3;
  background-color: rgba(246, 135, 179, var(--bg-opacity));
}

.focus\\:bg-pink-500:focus {
  --bg-opacity: 1;
  background-color: #ed64a6;
  background-color: rgba(237, 100, 166, var(--bg-opacity));
}

.focus\\:bg-pink-600:focus {
  --bg-opacity: 1;
  background-color: #d53f8c;
  background-color: rgba(213, 63, 140, var(--bg-opacity));
}

.focus\\:bg-pink-700:focus {
  --bg-opacity: 1;
  background-color: #b83280;
  background-color: rgba(184, 50, 128, var(--bg-opacity));
}

.focus\\:bg-pink-800:focus {
  --bg-opacity: 1;
  background-color: #97266d;
  background-color: rgba(151, 38, 109, var(--bg-opacity));
}

.focus\\:bg-pink-900:focus {
  --bg-opacity: 1;
  background-color: #702459;
  background-color: rgba(112, 36, 89, var(--bg-opacity));
}

.bg-none {
  background-image: none;
}

.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--gradient-color-stops));
}

.bg-gradient-to-tr {
  background-image: linear-gradient(to top right, var(--gradient-color-stops));
}

.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--gradient-color-stops));
}

.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
}

.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--gradient-color-stops));
}

.bg-gradient-to-bl {
  background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
}

.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--gradient-color-stops));
}

.bg-gradient-to-tl {
  background-image: linear-gradient(to top left, var(--gradient-color-stops));
}

.from-transparent {
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.from-current {
  --gradient-from-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.from-black {
  --gradient-from-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.from-white {
  --gradient-from-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.from-gray-100 {
  --gradient-from-color: #f7fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
}

.from-gray-200 {
  --gradient-from-color: #edf2f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
}

.from-gray-300 {
  --gradient-from-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}

.from-gray-400 {
  --gradient-from-color: #cbd5e0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
}

.from-gray-500 {
  --gradient-from-color: #a0aec0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
}

.from-gray-600 {
  --gradient-from-color: #718096;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
}

.from-gray-700 {
  --gradient-from-color: #4a5568;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
}

.from-gray-800 {
  --gradient-from-color: #2d3748;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
}

.from-gray-900 {
  --gradient-from-color: #1a202c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
}

.from-red-100 {
  --gradient-from-color: #fff5f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
}

.from-red-200 {
  --gradient-from-color: #fed7d7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
}

.from-red-300 {
  --gradient-from-color: #feb2b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
}

.from-red-400 {
  --gradient-from-color: #fc8181;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
}

.from-red-500 {
  --gradient-from-color: #f56565;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
}

.from-red-600 {
  --gradient-from-color: #e53e3e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
}

.from-red-700 {
  --gradient-from-color: #c53030;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
}

.from-red-800 {
  --gradient-from-color: #9b2c2c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
}

.from-red-900 {
  --gradient-from-color: #742a2a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
}

.from-orange-100 {
  --gradient-from-color: #fffaf0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
}

.from-orange-200 {
  --gradient-from-color: #feebc8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
}

.from-orange-300 {
  --gradient-from-color: #fbd38d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
}

.from-orange-400 {
  --gradient-from-color: #f6ad55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
}

.from-orange-500 {
  --gradient-from-color: #ed8936;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
}

.from-orange-600 {
  --gradient-from-color: #dd6b20;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
}

.from-orange-700 {
  --gradient-from-color: #c05621;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
}

.from-orange-800 {
  --gradient-from-color: #9c4221;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
}

.from-orange-900 {
  --gradient-from-color: #7b341e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
}

.from-yellow-100 {
  --gradient-from-color: #fffff0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
}

.from-yellow-200 {
  --gradient-from-color: #fefcbf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
}

.from-yellow-300 {
  --gradient-from-color: #faf089;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
}

.from-yellow-400 {
  --gradient-from-color: #f6e05e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
}

.from-yellow-500 {
  --gradient-from-color: #ecc94b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
}

.from-yellow-600 {
  --gradient-from-color: #d69e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
}

.from-yellow-700 {
  --gradient-from-color: #b7791f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
}

.from-yellow-800 {
  --gradient-from-color: #975a16;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
}

.from-yellow-900 {
  --gradient-from-color: #744210;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
}

.from-green-100 {
  --gradient-from-color: #f0fff4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
}

.from-green-200 {
  --gradient-from-color: #c6f6d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
}

.from-green-300 {
  --gradient-from-color: #9ae6b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
}

.from-green-400 {
  --gradient-from-color: #68d391;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
}

.from-green-500 {
  --gradient-from-color: #48bb78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
}

.from-green-600 {
  --gradient-from-color: #38a169;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
}

.from-green-700 {
  --gradient-from-color: #2f855a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
}

.from-green-800 {
  --gradient-from-color: #276749;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
}

.from-green-900 {
  --gradient-from-color: #22543d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
}

.from-teal-100 {
  --gradient-from-color: #e6fffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
}

.from-teal-200 {
  --gradient-from-color: #b2f5ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
}

.from-teal-300 {
  --gradient-from-color: #81e6d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
}

.from-teal-400 {
  --gradient-from-color: #4fd1c5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
}

.from-teal-500 {
  --gradient-from-color: #38b2ac;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
}

.from-teal-600 {
  --gradient-from-color: #319795;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
}

.from-teal-700 {
  --gradient-from-color: #2c7a7b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
}

.from-teal-800 {
  --gradient-from-color: #285e61;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
}

.from-teal-900 {
  --gradient-from-color: #234e52;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
}

.from-blue-100 {
  --gradient-from-color: #ebf8ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
}

.from-blue-200 {
  --gradient-from-color: #bee3f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
}

.from-blue-300 {
  --gradient-from-color: #90cdf4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
}

.from-blue-400 {
  --gradient-from-color: #63b3ed;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
}

.from-blue-500 {
  --gradient-from-color: #4299e1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
}

.from-blue-600 {
  --gradient-from-color: #3182ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
}

.from-blue-700 {
  --gradient-from-color: #2b6cb0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
}

.from-blue-800 {
  --gradient-from-color: #2c5282;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
}

.from-blue-900 {
  --gradient-from-color: #2a4365;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
}

.from-indigo-100 {
  --gradient-from-color: #ebf4ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
}

.from-indigo-200 {
  --gradient-from-color: #c3dafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
}

.from-indigo-300 {
  --gradient-from-color: #a3bffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
}

.from-indigo-400 {
  --gradient-from-color: #7f9cf5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
}

.from-indigo-500 {
  --gradient-from-color: #667eea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
}

.from-indigo-600 {
  --gradient-from-color: #5a67d8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
}

.from-indigo-700 {
  --gradient-from-color: #4c51bf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
}

.from-indigo-800 {
  --gradient-from-color: #434190;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
}

.from-indigo-900 {
  --gradient-from-color: #3c366b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
}

.from-purple-100 {
  --gradient-from-color: #faf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
}

.from-purple-200 {
  --gradient-from-color: #e9d8fd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
}

.from-purple-300 {
  --gradient-from-color: #d6bcfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
}

.from-purple-400 {
  --gradient-from-color: #b794f4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
}

.from-purple-500 {
  --gradient-from-color: #9f7aea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
}

.from-purple-600 {
  --gradient-from-color: #805ad5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
}

.from-purple-700 {
  --gradient-from-color: #6b46c1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
}

.from-purple-800 {
  --gradient-from-color: #553c9a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
}

.from-purple-900 {
  --gradient-from-color: #44337a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
}

.from-pink-100 {
  --gradient-from-color: #fff5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
}

.from-pink-200 {
  --gradient-from-color: #fed7e2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
}

.from-pink-300 {
  --gradient-from-color: #fbb6ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
}

.from-pink-400 {
  --gradient-from-color: #f687b3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
}

.from-pink-500 {
  --gradient-from-color: #ed64a6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
}

.from-pink-600 {
  --gradient-from-color: #d53f8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
}

.from-pink-700 {
  --gradient-from-color: #b83280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
}

.from-pink-800 {
  --gradient-from-color: #97266d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
}

.from-pink-900 {
  --gradient-from-color: #702459;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
}

.via-transparent {
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.via-current {
  --gradient-via-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.via-black {
  --gradient-via-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.via-white {
  --gradient-via-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.via-gray-100 {
  --gradient-via-color: #f7fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
}

.via-gray-200 {
  --gradient-via-color: #edf2f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
}

.via-gray-300 {
  --gradient-via-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}

.via-gray-400 {
  --gradient-via-color: #cbd5e0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
}

.via-gray-500 {
  --gradient-via-color: #a0aec0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
}

.via-gray-600 {
  --gradient-via-color: #718096;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
}

.via-gray-700 {
  --gradient-via-color: #4a5568;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
}

.via-gray-800 {
  --gradient-via-color: #2d3748;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
}

.via-gray-900 {
  --gradient-via-color: #1a202c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
}

.via-red-100 {
  --gradient-via-color: #fff5f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
}

.via-red-200 {
  --gradient-via-color: #fed7d7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
}

.via-red-300 {
  --gradient-via-color: #feb2b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
}

.via-red-400 {
  --gradient-via-color: #fc8181;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
}

.via-red-500 {
  --gradient-via-color: #f56565;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
}

.via-red-600 {
  --gradient-via-color: #e53e3e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
}

.via-red-700 {
  --gradient-via-color: #c53030;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
}

.via-red-800 {
  --gradient-via-color: #9b2c2c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
}

.via-red-900 {
  --gradient-via-color: #742a2a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
}

.via-orange-100 {
  --gradient-via-color: #fffaf0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
}

.via-orange-200 {
  --gradient-via-color: #feebc8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
}

.via-orange-300 {
  --gradient-via-color: #fbd38d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
}

.via-orange-400 {
  --gradient-via-color: #f6ad55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
}

.via-orange-500 {
  --gradient-via-color: #ed8936;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
}

.via-orange-600 {
  --gradient-via-color: #dd6b20;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
}

.via-orange-700 {
  --gradient-via-color: #c05621;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
}

.via-orange-800 {
  --gradient-via-color: #9c4221;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
}

.via-orange-900 {
  --gradient-via-color: #7b341e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
}

.via-yellow-100 {
  --gradient-via-color: #fffff0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
}

.via-yellow-200 {
  --gradient-via-color: #fefcbf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
}

.via-yellow-300 {
  --gradient-via-color: #faf089;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
}

.via-yellow-400 {
  --gradient-via-color: #f6e05e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
}

.via-yellow-500 {
  --gradient-via-color: #ecc94b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
}

.via-yellow-600 {
  --gradient-via-color: #d69e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
}

.via-yellow-700 {
  --gradient-via-color: #b7791f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
}

.via-yellow-800 {
  --gradient-via-color: #975a16;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
}

.via-yellow-900 {
  --gradient-via-color: #744210;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
}

.via-green-100 {
  --gradient-via-color: #f0fff4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
}

.via-green-200 {
  --gradient-via-color: #c6f6d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
}

.via-green-300 {
  --gradient-via-color: #9ae6b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
}

.via-green-400 {
  --gradient-via-color: #68d391;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
}

.via-green-500 {
  --gradient-via-color: #48bb78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
}

.via-green-600 {
  --gradient-via-color: #38a169;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
}

.via-green-700 {
  --gradient-via-color: #2f855a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
}

.via-green-800 {
  --gradient-via-color: #276749;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
}

.via-green-900 {
  --gradient-via-color: #22543d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
}

.via-teal-100 {
  --gradient-via-color: #e6fffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
}

.via-teal-200 {
  --gradient-via-color: #b2f5ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
}

.via-teal-300 {
  --gradient-via-color: #81e6d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
}

.via-teal-400 {
  --gradient-via-color: #4fd1c5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
}

.via-teal-500 {
  --gradient-via-color: #38b2ac;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
}

.via-teal-600 {
  --gradient-via-color: #319795;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
}

.via-teal-700 {
  --gradient-via-color: #2c7a7b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
}

.via-teal-800 {
  --gradient-via-color: #285e61;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
}

.via-teal-900 {
  --gradient-via-color: #234e52;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
}

.via-blue-100 {
  --gradient-via-color: #ebf8ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
}

.via-blue-200 {
  --gradient-via-color: #bee3f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
}

.via-blue-300 {
  --gradient-via-color: #90cdf4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
}

.via-blue-400 {
  --gradient-via-color: #63b3ed;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
}

.via-blue-500 {
  --gradient-via-color: #4299e1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
}

.via-blue-600 {
  --gradient-via-color: #3182ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
}

.via-blue-700 {
  --gradient-via-color: #2b6cb0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
}

.via-blue-800 {
  --gradient-via-color: #2c5282;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
}

.via-blue-900 {
  --gradient-via-color: #2a4365;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
}

.via-indigo-100 {
  --gradient-via-color: #ebf4ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
}

.via-indigo-200 {
  --gradient-via-color: #c3dafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
}

.via-indigo-300 {
  --gradient-via-color: #a3bffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
}

.via-indigo-400 {
  --gradient-via-color: #7f9cf5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
}

.via-indigo-500 {
  --gradient-via-color: #667eea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
}

.via-indigo-600 {
  --gradient-via-color: #5a67d8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
}

.via-indigo-700 {
  --gradient-via-color: #4c51bf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
}

.via-indigo-800 {
  --gradient-via-color: #434190;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
}

.via-indigo-900 {
  --gradient-via-color: #3c366b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
}

.via-purple-100 {
  --gradient-via-color: #faf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
}

.via-purple-200 {
  --gradient-via-color: #e9d8fd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
}

.via-purple-300 {
  --gradient-via-color: #d6bcfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
}

.via-purple-400 {
  --gradient-via-color: #b794f4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
}

.via-purple-500 {
  --gradient-via-color: #9f7aea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
}

.via-purple-600 {
  --gradient-via-color: #805ad5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
}

.via-purple-700 {
  --gradient-via-color: #6b46c1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
}

.via-purple-800 {
  --gradient-via-color: #553c9a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
}

.via-purple-900 {
  --gradient-via-color: #44337a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
}

.via-pink-100 {
  --gradient-via-color: #fff5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
}

.via-pink-200 {
  --gradient-via-color: #fed7e2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
}

.via-pink-300 {
  --gradient-via-color: #fbb6ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
}

.via-pink-400 {
  --gradient-via-color: #f687b3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
}

.via-pink-500 {
  --gradient-via-color: #ed64a6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
}

.via-pink-600 {
  --gradient-via-color: #d53f8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
}

.via-pink-700 {
  --gradient-via-color: #b83280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
}

.via-pink-800 {
  --gradient-via-color: #97266d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
}

.via-pink-900 {
  --gradient-via-color: #702459;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
}

.to-transparent {
  --gradient-to-color: transparent;
}

.to-current {
  --gradient-to-color: currentColor;
}

.to-black {
  --gradient-to-color: #000;
}

.to-white {
  --gradient-to-color: #fff;
}

.to-gray-100 {
  --gradient-to-color: #f7fafc;
}

.to-gray-200 {
  --gradient-to-color: #edf2f7;
}

.to-gray-300 {
  --gradient-to-color: #e2e8f0;
}

.to-gray-400 {
  --gradient-to-color: #cbd5e0;
}

.to-gray-500 {
  --gradient-to-color: #a0aec0;
}

.to-gray-600 {
  --gradient-to-color: #718096;
}

.to-gray-700 {
  --gradient-to-color: #4a5568;
}

.to-gray-800 {
  --gradient-to-color: #2d3748;
}

.to-gray-900 {
  --gradient-to-color: #1a202c;
}

.to-red-100 {
  --gradient-to-color: #fff5f5;
}

.to-red-200 {
  --gradient-to-color: #fed7d7;
}

.to-red-300 {
  --gradient-to-color: #feb2b2;
}

.to-red-400 {
  --gradient-to-color: #fc8181;
}

.to-red-500 {
  --gradient-to-color: #f56565;
}

.to-red-600 {
  --gradient-to-color: #e53e3e;
}

.to-red-700 {
  --gradient-to-color: #c53030;
}

.to-red-800 {
  --gradient-to-color: #9b2c2c;
}

.to-red-900 {
  --gradient-to-color: #742a2a;
}

.to-orange-100 {
  --gradient-to-color: #fffaf0;
}

.to-orange-200 {
  --gradient-to-color: #feebc8;
}

.to-orange-300 {
  --gradient-to-color: #fbd38d;
}

.to-orange-400 {
  --gradient-to-color: #f6ad55;
}

.to-orange-500 {
  --gradient-to-color: #ed8936;
}

.to-orange-600 {
  --gradient-to-color: #dd6b20;
}

.to-orange-700 {
  --gradient-to-color: #c05621;
}

.to-orange-800 {
  --gradient-to-color: #9c4221;
}

.to-orange-900 {
  --gradient-to-color: #7b341e;
}

.to-yellow-100 {
  --gradient-to-color: #fffff0;
}

.to-yellow-200 {
  --gradient-to-color: #fefcbf;
}

.to-yellow-300 {
  --gradient-to-color: #faf089;
}

.to-yellow-400 {
  --gradient-to-color: #f6e05e;
}

.to-yellow-500 {
  --gradient-to-color: #ecc94b;
}

.to-yellow-600 {
  --gradient-to-color: #d69e2e;
}

.to-yellow-700 {
  --gradient-to-color: #b7791f;
}

.to-yellow-800 {
  --gradient-to-color: #975a16;
}

.to-yellow-900 {
  --gradient-to-color: #744210;
}

.to-green-100 {
  --gradient-to-color: #f0fff4;
}

.to-green-200 {
  --gradient-to-color: #c6f6d5;
}

.to-green-300 {
  --gradient-to-color: #9ae6b4;
}

.to-green-400 {
  --gradient-to-color: #68d391;
}

.to-green-500 {
  --gradient-to-color: #48bb78;
}

.to-green-600 {
  --gradient-to-color: #38a169;
}

.to-green-700 {
  --gradient-to-color: #2f855a;
}

.to-green-800 {
  --gradient-to-color: #276749;
}

.to-green-900 {
  --gradient-to-color: #22543d;
}

.to-teal-100 {
  --gradient-to-color: #e6fffa;
}

.to-teal-200 {
  --gradient-to-color: #b2f5ea;
}

.to-teal-300 {
  --gradient-to-color: #81e6d9;
}

.to-teal-400 {
  --gradient-to-color: #4fd1c5;
}

.to-teal-500 {
  --gradient-to-color: #38b2ac;
}

.to-teal-600 {
  --gradient-to-color: #319795;
}

.to-teal-700 {
  --gradient-to-color: #2c7a7b;
}

.to-teal-800 {
  --gradient-to-color: #285e61;
}

.to-teal-900 {
  --gradient-to-color: #234e52;
}

.to-blue-100 {
  --gradient-to-color: #ebf8ff;
}

.to-blue-200 {
  --gradient-to-color: #bee3f8;
}

.to-blue-300 {
  --gradient-to-color: #90cdf4;
}

.to-blue-400 {
  --gradient-to-color: #63b3ed;
}

.to-blue-500 {
  --gradient-to-color: #4299e1;
}

.to-blue-600 {
  --gradient-to-color: #3182ce;
}

.to-blue-700 {
  --gradient-to-color: #2b6cb0;
}

.to-blue-800 {
  --gradient-to-color: #2c5282;
}

.to-blue-900 {
  --gradient-to-color: #2a4365;
}

.to-indigo-100 {
  --gradient-to-color: #ebf4ff;
}

.to-indigo-200 {
  --gradient-to-color: #c3dafe;
}

.to-indigo-300 {
  --gradient-to-color: #a3bffa;
}

.to-indigo-400 {
  --gradient-to-color: #7f9cf5;
}

.to-indigo-500 {
  --gradient-to-color: #667eea;
}

.to-indigo-600 {
  --gradient-to-color: #5a67d8;
}

.to-indigo-700 {
  --gradient-to-color: #4c51bf;
}

.to-indigo-800 {
  --gradient-to-color: #434190;
}

.to-indigo-900 {
  --gradient-to-color: #3c366b;
}

.to-purple-100 {
  --gradient-to-color: #faf5ff;
}

.to-purple-200 {
  --gradient-to-color: #e9d8fd;
}

.to-purple-300 {
  --gradient-to-color: #d6bcfa;
}

.to-purple-400 {
  --gradient-to-color: #b794f4;
}

.to-purple-500 {
  --gradient-to-color: #9f7aea;
}

.to-purple-600 {
  --gradient-to-color: #805ad5;
}

.to-purple-700 {
  --gradient-to-color: #6b46c1;
}

.to-purple-800 {
  --gradient-to-color: #553c9a;
}

.to-purple-900 {
  --gradient-to-color: #44337a;
}

.to-pink-100 {
  --gradient-to-color: #fff5f7;
}

.to-pink-200 {
  --gradient-to-color: #fed7e2;
}

.to-pink-300 {
  --gradient-to-color: #fbb6ce;
}

.to-pink-400 {
  --gradient-to-color: #f687b3;
}

.to-pink-500 {
  --gradient-to-color: #ed64a6;
}

.to-pink-600 {
  --gradient-to-color: #d53f8c;
}

.to-pink-700 {
  --gradient-to-color: #b83280;
}

.to-pink-800 {
  --gradient-to-color: #97266d;
}

.to-pink-900 {
  --gradient-to-color: #702459;
}

.hover\\:from-transparent:hover {
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.hover\\:from-current:hover {
  --gradient-from-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:from-black:hover {
  --gradient-from-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.hover\\:from-white:hover {
  --gradient-from-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:from-gray-100:hover {
  --gradient-from-color: #f7fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
}

.hover\\:from-gray-200:hover {
  --gradient-from-color: #edf2f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
}

.hover\\:from-gray-300:hover {
  --gradient-from-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}

.hover\\:from-gray-400:hover {
  --gradient-from-color: #cbd5e0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
}

.hover\\:from-gray-500:hover {
  --gradient-from-color: #a0aec0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
}

.hover\\:from-gray-600:hover {
  --gradient-from-color: #718096;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
}

.hover\\:from-gray-700:hover {
  --gradient-from-color: #4a5568;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
}

.hover\\:from-gray-800:hover {
  --gradient-from-color: #2d3748;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
}

.hover\\:from-gray-900:hover {
  --gradient-from-color: #1a202c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
}

.hover\\:from-red-100:hover {
  --gradient-from-color: #fff5f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
}

.hover\\:from-red-200:hover {
  --gradient-from-color: #fed7d7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
}

.hover\\:from-red-300:hover {
  --gradient-from-color: #feb2b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
}

.hover\\:from-red-400:hover {
  --gradient-from-color: #fc8181;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
}

.hover\\:from-red-500:hover {
  --gradient-from-color: #f56565;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
}

.hover\\:from-red-600:hover {
  --gradient-from-color: #e53e3e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
}

.hover\\:from-red-700:hover {
  --gradient-from-color: #c53030;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
}

.hover\\:from-red-800:hover {
  --gradient-from-color: #9b2c2c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
}

.hover\\:from-red-900:hover {
  --gradient-from-color: #742a2a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
}

.hover\\:from-orange-100:hover {
  --gradient-from-color: #fffaf0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
}

.hover\\:from-orange-200:hover {
  --gradient-from-color: #feebc8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
}

.hover\\:from-orange-300:hover {
  --gradient-from-color: #fbd38d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
}

.hover\\:from-orange-400:hover {
  --gradient-from-color: #f6ad55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
}

.hover\\:from-orange-500:hover {
  --gradient-from-color: #ed8936;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
}

.hover\\:from-orange-600:hover {
  --gradient-from-color: #dd6b20;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
}

.hover\\:from-orange-700:hover {
  --gradient-from-color: #c05621;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
}

.hover\\:from-orange-800:hover {
  --gradient-from-color: #9c4221;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
}

.hover\\:from-orange-900:hover {
  --gradient-from-color: #7b341e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
}

.hover\\:from-yellow-100:hover {
  --gradient-from-color: #fffff0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
}

.hover\\:from-yellow-200:hover {
  --gradient-from-color: #fefcbf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
}

.hover\\:from-yellow-300:hover {
  --gradient-from-color: #faf089;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
}

.hover\\:from-yellow-400:hover {
  --gradient-from-color: #f6e05e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
}

.hover\\:from-yellow-500:hover {
  --gradient-from-color: #ecc94b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
}

.hover\\:from-yellow-600:hover {
  --gradient-from-color: #d69e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
}

.hover\\:from-yellow-700:hover {
  --gradient-from-color: #b7791f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
}

.hover\\:from-yellow-800:hover {
  --gradient-from-color: #975a16;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
}

.hover\\:from-yellow-900:hover {
  --gradient-from-color: #744210;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
}

.hover\\:from-green-100:hover {
  --gradient-from-color: #f0fff4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
}

.hover\\:from-green-200:hover {
  --gradient-from-color: #c6f6d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
}

.hover\\:from-green-300:hover {
  --gradient-from-color: #9ae6b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
}

.hover\\:from-green-400:hover {
  --gradient-from-color: #68d391;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
}

.hover\\:from-green-500:hover {
  --gradient-from-color: #48bb78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
}

.hover\\:from-green-600:hover {
  --gradient-from-color: #38a169;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
}

.hover\\:from-green-700:hover {
  --gradient-from-color: #2f855a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
}

.hover\\:from-green-800:hover {
  --gradient-from-color: #276749;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
}

.hover\\:from-green-900:hover {
  --gradient-from-color: #22543d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
}

.hover\\:from-teal-100:hover {
  --gradient-from-color: #e6fffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
}

.hover\\:from-teal-200:hover {
  --gradient-from-color: #b2f5ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
}

.hover\\:from-teal-300:hover {
  --gradient-from-color: #81e6d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
}

.hover\\:from-teal-400:hover {
  --gradient-from-color: #4fd1c5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
}

.hover\\:from-teal-500:hover {
  --gradient-from-color: #38b2ac;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
}

.hover\\:from-teal-600:hover {
  --gradient-from-color: #319795;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
}

.hover\\:from-teal-700:hover {
  --gradient-from-color: #2c7a7b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
}

.hover\\:from-teal-800:hover {
  --gradient-from-color: #285e61;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
}

.hover\\:from-teal-900:hover {
  --gradient-from-color: #234e52;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
}

.hover\\:from-blue-100:hover {
  --gradient-from-color: #ebf8ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
}

.hover\\:from-blue-200:hover {
  --gradient-from-color: #bee3f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
}

.hover\\:from-blue-300:hover {
  --gradient-from-color: #90cdf4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
}

.hover\\:from-blue-400:hover {
  --gradient-from-color: #63b3ed;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
}

.hover\\:from-blue-500:hover {
  --gradient-from-color: #4299e1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
}

.hover\\:from-blue-600:hover {
  --gradient-from-color: #3182ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
}

.hover\\:from-blue-700:hover {
  --gradient-from-color: #2b6cb0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
}

.hover\\:from-blue-800:hover {
  --gradient-from-color: #2c5282;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
}

.hover\\:from-blue-900:hover {
  --gradient-from-color: #2a4365;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
}

.hover\\:from-indigo-100:hover {
  --gradient-from-color: #ebf4ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
}

.hover\\:from-indigo-200:hover {
  --gradient-from-color: #c3dafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
}

.hover\\:from-indigo-300:hover {
  --gradient-from-color: #a3bffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
}

.hover\\:from-indigo-400:hover {
  --gradient-from-color: #7f9cf5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
}

.hover\\:from-indigo-500:hover {
  --gradient-from-color: #667eea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
}

.hover\\:from-indigo-600:hover {
  --gradient-from-color: #5a67d8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
}

.hover\\:from-indigo-700:hover {
  --gradient-from-color: #4c51bf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
}

.hover\\:from-indigo-800:hover {
  --gradient-from-color: #434190;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
}

.hover\\:from-indigo-900:hover {
  --gradient-from-color: #3c366b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
}

.hover\\:from-purple-100:hover {
  --gradient-from-color: #faf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
}

.hover\\:from-purple-200:hover {
  --gradient-from-color: #e9d8fd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
}

.hover\\:from-purple-300:hover {
  --gradient-from-color: #d6bcfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
}

.hover\\:from-purple-400:hover {
  --gradient-from-color: #b794f4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
}

.hover\\:from-purple-500:hover {
  --gradient-from-color: #9f7aea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
}

.hover\\:from-purple-600:hover {
  --gradient-from-color: #805ad5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
}

.hover\\:from-purple-700:hover {
  --gradient-from-color: #6b46c1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
}

.hover\\:from-purple-800:hover {
  --gradient-from-color: #553c9a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
}

.hover\\:from-purple-900:hover {
  --gradient-from-color: #44337a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
}

.hover\\:from-pink-100:hover {
  --gradient-from-color: #fff5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
}

.hover\\:from-pink-200:hover {
  --gradient-from-color: #fed7e2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
}

.hover\\:from-pink-300:hover {
  --gradient-from-color: #fbb6ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
}

.hover\\:from-pink-400:hover {
  --gradient-from-color: #f687b3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
}

.hover\\:from-pink-500:hover {
  --gradient-from-color: #ed64a6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
}

.hover\\:from-pink-600:hover {
  --gradient-from-color: #d53f8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
}

.hover\\:from-pink-700:hover {
  --gradient-from-color: #b83280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
}

.hover\\:from-pink-800:hover {
  --gradient-from-color: #97266d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
}

.hover\\:from-pink-900:hover {
  --gradient-from-color: #702459;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
}

.hover\\:via-transparent:hover {
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.hover\\:via-current:hover {
  --gradient-via-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:via-black:hover {
  --gradient-via-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.hover\\:via-white:hover {
  --gradient-via-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:via-gray-100:hover {
  --gradient-via-color: #f7fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
}

.hover\\:via-gray-200:hover {
  --gradient-via-color: #edf2f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
}

.hover\\:via-gray-300:hover {
  --gradient-via-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}

.hover\\:via-gray-400:hover {
  --gradient-via-color: #cbd5e0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
}

.hover\\:via-gray-500:hover {
  --gradient-via-color: #a0aec0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
}

.hover\\:via-gray-600:hover {
  --gradient-via-color: #718096;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
}

.hover\\:via-gray-700:hover {
  --gradient-via-color: #4a5568;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
}

.hover\\:via-gray-800:hover {
  --gradient-via-color: #2d3748;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
}

.hover\\:via-gray-900:hover {
  --gradient-via-color: #1a202c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
}

.hover\\:via-red-100:hover {
  --gradient-via-color: #fff5f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
}

.hover\\:via-red-200:hover {
  --gradient-via-color: #fed7d7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
}

.hover\\:via-red-300:hover {
  --gradient-via-color: #feb2b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
}

.hover\\:via-red-400:hover {
  --gradient-via-color: #fc8181;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
}

.hover\\:via-red-500:hover {
  --gradient-via-color: #f56565;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
}

.hover\\:via-red-600:hover {
  --gradient-via-color: #e53e3e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
}

.hover\\:via-red-700:hover {
  --gradient-via-color: #c53030;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
}

.hover\\:via-red-800:hover {
  --gradient-via-color: #9b2c2c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
}

.hover\\:via-red-900:hover {
  --gradient-via-color: #742a2a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
}

.hover\\:via-orange-100:hover {
  --gradient-via-color: #fffaf0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
}

.hover\\:via-orange-200:hover {
  --gradient-via-color: #feebc8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
}

.hover\\:via-orange-300:hover {
  --gradient-via-color: #fbd38d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
}

.hover\\:via-orange-400:hover {
  --gradient-via-color: #f6ad55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
}

.hover\\:via-orange-500:hover {
  --gradient-via-color: #ed8936;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
}

.hover\\:via-orange-600:hover {
  --gradient-via-color: #dd6b20;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
}

.hover\\:via-orange-700:hover {
  --gradient-via-color: #c05621;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
}

.hover\\:via-orange-800:hover {
  --gradient-via-color: #9c4221;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
}

.hover\\:via-orange-900:hover {
  --gradient-via-color: #7b341e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
}

.hover\\:via-yellow-100:hover {
  --gradient-via-color: #fffff0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
}

.hover\\:via-yellow-200:hover {
  --gradient-via-color: #fefcbf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
}

.hover\\:via-yellow-300:hover {
  --gradient-via-color: #faf089;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
}

.hover\\:via-yellow-400:hover {
  --gradient-via-color: #f6e05e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
}

.hover\\:via-yellow-500:hover {
  --gradient-via-color: #ecc94b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
}

.hover\\:via-yellow-600:hover {
  --gradient-via-color: #d69e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
}

.hover\\:via-yellow-700:hover {
  --gradient-via-color: #b7791f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
}

.hover\\:via-yellow-800:hover {
  --gradient-via-color: #975a16;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
}

.hover\\:via-yellow-900:hover {
  --gradient-via-color: #744210;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
}

.hover\\:via-green-100:hover {
  --gradient-via-color: #f0fff4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
}

.hover\\:via-green-200:hover {
  --gradient-via-color: #c6f6d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
}

.hover\\:via-green-300:hover {
  --gradient-via-color: #9ae6b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
}

.hover\\:via-green-400:hover {
  --gradient-via-color: #68d391;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
}

.hover\\:via-green-500:hover {
  --gradient-via-color: #48bb78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
}

.hover\\:via-green-600:hover {
  --gradient-via-color: #38a169;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
}

.hover\\:via-green-700:hover {
  --gradient-via-color: #2f855a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
}

.hover\\:via-green-800:hover {
  --gradient-via-color: #276749;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
}

.hover\\:via-green-900:hover {
  --gradient-via-color: #22543d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
}

.hover\\:via-teal-100:hover {
  --gradient-via-color: #e6fffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
}

.hover\\:via-teal-200:hover {
  --gradient-via-color: #b2f5ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
}

.hover\\:via-teal-300:hover {
  --gradient-via-color: #81e6d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
}

.hover\\:via-teal-400:hover {
  --gradient-via-color: #4fd1c5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
}

.hover\\:via-teal-500:hover {
  --gradient-via-color: #38b2ac;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
}

.hover\\:via-teal-600:hover {
  --gradient-via-color: #319795;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
}

.hover\\:via-teal-700:hover {
  --gradient-via-color: #2c7a7b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
}

.hover\\:via-teal-800:hover {
  --gradient-via-color: #285e61;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
}

.hover\\:via-teal-900:hover {
  --gradient-via-color: #234e52;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
}

.hover\\:via-blue-100:hover {
  --gradient-via-color: #ebf8ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
}

.hover\\:via-blue-200:hover {
  --gradient-via-color: #bee3f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
}

.hover\\:via-blue-300:hover {
  --gradient-via-color: #90cdf4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
}

.hover\\:via-blue-400:hover {
  --gradient-via-color: #63b3ed;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
}

.hover\\:via-blue-500:hover {
  --gradient-via-color: #4299e1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
}

.hover\\:via-blue-600:hover {
  --gradient-via-color: #3182ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
}

.hover\\:via-blue-700:hover {
  --gradient-via-color: #2b6cb0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
}

.hover\\:via-blue-800:hover {
  --gradient-via-color: #2c5282;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
}

.hover\\:via-blue-900:hover {
  --gradient-via-color: #2a4365;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
}

.hover\\:via-indigo-100:hover {
  --gradient-via-color: #ebf4ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
}

.hover\\:via-indigo-200:hover {
  --gradient-via-color: #c3dafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
}

.hover\\:via-indigo-300:hover {
  --gradient-via-color: #a3bffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
}

.hover\\:via-indigo-400:hover {
  --gradient-via-color: #7f9cf5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
}

.hover\\:via-indigo-500:hover {
  --gradient-via-color: #667eea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
}

.hover\\:via-indigo-600:hover {
  --gradient-via-color: #5a67d8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
}

.hover\\:via-indigo-700:hover {
  --gradient-via-color: #4c51bf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
}

.hover\\:via-indigo-800:hover {
  --gradient-via-color: #434190;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
}

.hover\\:via-indigo-900:hover {
  --gradient-via-color: #3c366b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
}

.hover\\:via-purple-100:hover {
  --gradient-via-color: #faf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
}

.hover\\:via-purple-200:hover {
  --gradient-via-color: #e9d8fd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
}

.hover\\:via-purple-300:hover {
  --gradient-via-color: #d6bcfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
}

.hover\\:via-purple-400:hover {
  --gradient-via-color: #b794f4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
}

.hover\\:via-purple-500:hover {
  --gradient-via-color: #9f7aea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
}

.hover\\:via-purple-600:hover {
  --gradient-via-color: #805ad5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
}

.hover\\:via-purple-700:hover {
  --gradient-via-color: #6b46c1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
}

.hover\\:via-purple-800:hover {
  --gradient-via-color: #553c9a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
}

.hover\\:via-purple-900:hover {
  --gradient-via-color: #44337a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
}

.hover\\:via-pink-100:hover {
  --gradient-via-color: #fff5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
}

.hover\\:via-pink-200:hover {
  --gradient-via-color: #fed7e2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
}

.hover\\:via-pink-300:hover {
  --gradient-via-color: #fbb6ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
}

.hover\\:via-pink-400:hover {
  --gradient-via-color: #f687b3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
}

.hover\\:via-pink-500:hover {
  --gradient-via-color: #ed64a6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
}

.hover\\:via-pink-600:hover {
  --gradient-via-color: #d53f8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
}

.hover\\:via-pink-700:hover {
  --gradient-via-color: #b83280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
}

.hover\\:via-pink-800:hover {
  --gradient-via-color: #97266d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
}

.hover\\:via-pink-900:hover {
  --gradient-via-color: #702459;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
}

.hover\\:to-transparent:hover {
  --gradient-to-color: transparent;
}

.hover\\:to-current:hover {
  --gradient-to-color: currentColor;
}

.hover\\:to-black:hover {
  --gradient-to-color: #000;
}

.hover\\:to-white:hover {
  --gradient-to-color: #fff;
}

.hover\\:to-gray-100:hover {
  --gradient-to-color: #f7fafc;
}

.hover\\:to-gray-200:hover {
  --gradient-to-color: #edf2f7;
}

.hover\\:to-gray-300:hover {
  --gradient-to-color: #e2e8f0;
}

.hover\\:to-gray-400:hover {
  --gradient-to-color: #cbd5e0;
}

.hover\\:to-gray-500:hover {
  --gradient-to-color: #a0aec0;
}

.hover\\:to-gray-600:hover {
  --gradient-to-color: #718096;
}

.hover\\:to-gray-700:hover {
  --gradient-to-color: #4a5568;
}

.hover\\:to-gray-800:hover {
  --gradient-to-color: #2d3748;
}

.hover\\:to-gray-900:hover {
  --gradient-to-color: #1a202c;
}

.hover\\:to-red-100:hover {
  --gradient-to-color: #fff5f5;
}

.hover\\:to-red-200:hover {
  --gradient-to-color: #fed7d7;
}

.hover\\:to-red-300:hover {
  --gradient-to-color: #feb2b2;
}

.hover\\:to-red-400:hover {
  --gradient-to-color: #fc8181;
}

.hover\\:to-red-500:hover {
  --gradient-to-color: #f56565;
}

.hover\\:to-red-600:hover {
  --gradient-to-color: #e53e3e;
}

.hover\\:to-red-700:hover {
  --gradient-to-color: #c53030;
}

.hover\\:to-red-800:hover {
  --gradient-to-color: #9b2c2c;
}

.hover\\:to-red-900:hover {
  --gradient-to-color: #742a2a;
}

.hover\\:to-orange-100:hover {
  --gradient-to-color: #fffaf0;
}

.hover\\:to-orange-200:hover {
  --gradient-to-color: #feebc8;
}

.hover\\:to-orange-300:hover {
  --gradient-to-color: #fbd38d;
}

.hover\\:to-orange-400:hover {
  --gradient-to-color: #f6ad55;
}

.hover\\:to-orange-500:hover {
  --gradient-to-color: #ed8936;
}

.hover\\:to-orange-600:hover {
  --gradient-to-color: #dd6b20;
}

.hover\\:to-orange-700:hover {
  --gradient-to-color: #c05621;
}

.hover\\:to-orange-800:hover {
  --gradient-to-color: #9c4221;
}

.hover\\:to-orange-900:hover {
  --gradient-to-color: #7b341e;
}

.hover\\:to-yellow-100:hover {
  --gradient-to-color: #fffff0;
}

.hover\\:to-yellow-200:hover {
  --gradient-to-color: #fefcbf;
}

.hover\\:to-yellow-300:hover {
  --gradient-to-color: #faf089;
}

.hover\\:to-yellow-400:hover {
  --gradient-to-color: #f6e05e;
}

.hover\\:to-yellow-500:hover {
  --gradient-to-color: #ecc94b;
}

.hover\\:to-yellow-600:hover {
  --gradient-to-color: #d69e2e;
}

.hover\\:to-yellow-700:hover {
  --gradient-to-color: #b7791f;
}

.hover\\:to-yellow-800:hover {
  --gradient-to-color: #975a16;
}

.hover\\:to-yellow-900:hover {
  --gradient-to-color: #744210;
}

.hover\\:to-green-100:hover {
  --gradient-to-color: #f0fff4;
}

.hover\\:to-green-200:hover {
  --gradient-to-color: #c6f6d5;
}

.hover\\:to-green-300:hover {
  --gradient-to-color: #9ae6b4;
}

.hover\\:to-green-400:hover {
  --gradient-to-color: #68d391;
}

.hover\\:to-green-500:hover {
  --gradient-to-color: #48bb78;
}

.hover\\:to-green-600:hover {
  --gradient-to-color: #38a169;
}

.hover\\:to-green-700:hover {
  --gradient-to-color: #2f855a;
}

.hover\\:to-green-800:hover {
  --gradient-to-color: #276749;
}

.hover\\:to-green-900:hover {
  --gradient-to-color: #22543d;
}

.hover\\:to-teal-100:hover {
  --gradient-to-color: #e6fffa;
}

.hover\\:to-teal-200:hover {
  --gradient-to-color: #b2f5ea;
}

.hover\\:to-teal-300:hover {
  --gradient-to-color: #81e6d9;
}

.hover\\:to-teal-400:hover {
  --gradient-to-color: #4fd1c5;
}

.hover\\:to-teal-500:hover {
  --gradient-to-color: #38b2ac;
}

.hover\\:to-teal-600:hover {
  --gradient-to-color: #319795;
}

.hover\\:to-teal-700:hover {
  --gradient-to-color: #2c7a7b;
}

.hover\\:to-teal-800:hover {
  --gradient-to-color: #285e61;
}

.hover\\:to-teal-900:hover {
  --gradient-to-color: #234e52;
}

.hover\\:to-blue-100:hover {
  --gradient-to-color: #ebf8ff;
}

.hover\\:to-blue-200:hover {
  --gradient-to-color: #bee3f8;
}

.hover\\:to-blue-300:hover {
  --gradient-to-color: #90cdf4;
}

.hover\\:to-blue-400:hover {
  --gradient-to-color: #63b3ed;
}

.hover\\:to-blue-500:hover {
  --gradient-to-color: #4299e1;
}

.hover\\:to-blue-600:hover {
  --gradient-to-color: #3182ce;
}

.hover\\:to-blue-700:hover {
  --gradient-to-color: #2b6cb0;
}

.hover\\:to-blue-800:hover {
  --gradient-to-color: #2c5282;
}

.hover\\:to-blue-900:hover {
  --gradient-to-color: #2a4365;
}

.hover\\:to-indigo-100:hover {
  --gradient-to-color: #ebf4ff;
}

.hover\\:to-indigo-200:hover {
  --gradient-to-color: #c3dafe;
}

.hover\\:to-indigo-300:hover {
  --gradient-to-color: #a3bffa;
}

.hover\\:to-indigo-400:hover {
  --gradient-to-color: #7f9cf5;
}

.hover\\:to-indigo-500:hover {
  --gradient-to-color: #667eea;
}

.hover\\:to-indigo-600:hover {
  --gradient-to-color: #5a67d8;
}

.hover\\:to-indigo-700:hover {
  --gradient-to-color: #4c51bf;
}

.hover\\:to-indigo-800:hover {
  --gradient-to-color: #434190;
}

.hover\\:to-indigo-900:hover {
  --gradient-to-color: #3c366b;
}

.hover\\:to-purple-100:hover {
  --gradient-to-color: #faf5ff;
}

.hover\\:to-purple-200:hover {
  --gradient-to-color: #e9d8fd;
}

.hover\\:to-purple-300:hover {
  --gradient-to-color: #d6bcfa;
}

.hover\\:to-purple-400:hover {
  --gradient-to-color: #b794f4;
}

.hover\\:to-purple-500:hover {
  --gradient-to-color: #9f7aea;
}

.hover\\:to-purple-600:hover {
  --gradient-to-color: #805ad5;
}

.hover\\:to-purple-700:hover {
  --gradient-to-color: #6b46c1;
}

.hover\\:to-purple-800:hover {
  --gradient-to-color: #553c9a;
}

.hover\\:to-purple-900:hover {
  --gradient-to-color: #44337a;
}

.hover\\:to-pink-100:hover {
  --gradient-to-color: #fff5f7;
}

.hover\\:to-pink-200:hover {
  --gradient-to-color: #fed7e2;
}

.hover\\:to-pink-300:hover {
  --gradient-to-color: #fbb6ce;
}

.hover\\:to-pink-400:hover {
  --gradient-to-color: #f687b3;
}

.hover\\:to-pink-500:hover {
  --gradient-to-color: #ed64a6;
}

.hover\\:to-pink-600:hover {
  --gradient-to-color: #d53f8c;
}

.hover\\:to-pink-700:hover {
  --gradient-to-color: #b83280;
}

.hover\\:to-pink-800:hover {
  --gradient-to-color: #97266d;
}

.hover\\:to-pink-900:hover {
  --gradient-to-color: #702459;
}

.focus\\:from-transparent:focus {
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.focus\\:from-current:focus {
  --gradient-from-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:from-black:focus {
  --gradient-from-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.focus\\:from-white:focus {
  --gradient-from-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:from-gray-100:focus {
  --gradient-from-color: #f7fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
}

.focus\\:from-gray-200:focus {
  --gradient-from-color: #edf2f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
}

.focus\\:from-gray-300:focus {
  --gradient-from-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}

.focus\\:from-gray-400:focus {
  --gradient-from-color: #cbd5e0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
}

.focus\\:from-gray-500:focus {
  --gradient-from-color: #a0aec0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
}

.focus\\:from-gray-600:focus {
  --gradient-from-color: #718096;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
}

.focus\\:from-gray-700:focus {
  --gradient-from-color: #4a5568;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
}

.focus\\:from-gray-800:focus {
  --gradient-from-color: #2d3748;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
}

.focus\\:from-gray-900:focus {
  --gradient-from-color: #1a202c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
}

.focus\\:from-red-100:focus {
  --gradient-from-color: #fff5f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
}

.focus\\:from-red-200:focus {
  --gradient-from-color: #fed7d7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
}

.focus\\:from-red-300:focus {
  --gradient-from-color: #feb2b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
}

.focus\\:from-red-400:focus {
  --gradient-from-color: #fc8181;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
}

.focus\\:from-red-500:focus {
  --gradient-from-color: #f56565;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
}

.focus\\:from-red-600:focus {
  --gradient-from-color: #e53e3e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
}

.focus\\:from-red-700:focus {
  --gradient-from-color: #c53030;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
}

.focus\\:from-red-800:focus {
  --gradient-from-color: #9b2c2c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
}

.focus\\:from-red-900:focus {
  --gradient-from-color: #742a2a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
}

.focus\\:from-orange-100:focus {
  --gradient-from-color: #fffaf0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
}

.focus\\:from-orange-200:focus {
  --gradient-from-color: #feebc8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
}

.focus\\:from-orange-300:focus {
  --gradient-from-color: #fbd38d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
}

.focus\\:from-orange-400:focus {
  --gradient-from-color: #f6ad55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
}

.focus\\:from-orange-500:focus {
  --gradient-from-color: #ed8936;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
}

.focus\\:from-orange-600:focus {
  --gradient-from-color: #dd6b20;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
}

.focus\\:from-orange-700:focus {
  --gradient-from-color: #c05621;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
}

.focus\\:from-orange-800:focus {
  --gradient-from-color: #9c4221;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
}

.focus\\:from-orange-900:focus {
  --gradient-from-color: #7b341e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
}

.focus\\:from-yellow-100:focus {
  --gradient-from-color: #fffff0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
}

.focus\\:from-yellow-200:focus {
  --gradient-from-color: #fefcbf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
}

.focus\\:from-yellow-300:focus {
  --gradient-from-color: #faf089;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
}

.focus\\:from-yellow-400:focus {
  --gradient-from-color: #f6e05e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
}

.focus\\:from-yellow-500:focus {
  --gradient-from-color: #ecc94b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
}

.focus\\:from-yellow-600:focus {
  --gradient-from-color: #d69e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
}

.focus\\:from-yellow-700:focus {
  --gradient-from-color: #b7791f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
}

.focus\\:from-yellow-800:focus {
  --gradient-from-color: #975a16;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
}

.focus\\:from-yellow-900:focus {
  --gradient-from-color: #744210;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
}

.focus\\:from-green-100:focus {
  --gradient-from-color: #f0fff4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
}

.focus\\:from-green-200:focus {
  --gradient-from-color: #c6f6d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
}

.focus\\:from-green-300:focus {
  --gradient-from-color: #9ae6b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
}

.focus\\:from-green-400:focus {
  --gradient-from-color: #68d391;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
}

.focus\\:from-green-500:focus {
  --gradient-from-color: #48bb78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
}

.focus\\:from-green-600:focus {
  --gradient-from-color: #38a169;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
}

.focus\\:from-green-700:focus {
  --gradient-from-color: #2f855a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
}

.focus\\:from-green-800:focus {
  --gradient-from-color: #276749;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
}

.focus\\:from-green-900:focus {
  --gradient-from-color: #22543d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
}

.focus\\:from-teal-100:focus {
  --gradient-from-color: #e6fffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
}

.focus\\:from-teal-200:focus {
  --gradient-from-color: #b2f5ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
}

.focus\\:from-teal-300:focus {
  --gradient-from-color: #81e6d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
}

.focus\\:from-teal-400:focus {
  --gradient-from-color: #4fd1c5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
}

.focus\\:from-teal-500:focus {
  --gradient-from-color: #38b2ac;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
}

.focus\\:from-teal-600:focus {
  --gradient-from-color: #319795;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
}

.focus\\:from-teal-700:focus {
  --gradient-from-color: #2c7a7b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
}

.focus\\:from-teal-800:focus {
  --gradient-from-color: #285e61;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
}

.focus\\:from-teal-900:focus {
  --gradient-from-color: #234e52;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
}

.focus\\:from-blue-100:focus {
  --gradient-from-color: #ebf8ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
}

.focus\\:from-blue-200:focus {
  --gradient-from-color: #bee3f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
}

.focus\\:from-blue-300:focus {
  --gradient-from-color: #90cdf4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
}

.focus\\:from-blue-400:focus {
  --gradient-from-color: #63b3ed;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
}

.focus\\:from-blue-500:focus {
  --gradient-from-color: #4299e1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
}

.focus\\:from-blue-600:focus {
  --gradient-from-color: #3182ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
}

.focus\\:from-blue-700:focus {
  --gradient-from-color: #2b6cb0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
}

.focus\\:from-blue-800:focus {
  --gradient-from-color: #2c5282;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
}

.focus\\:from-blue-900:focus {
  --gradient-from-color: #2a4365;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
}

.focus\\:from-indigo-100:focus {
  --gradient-from-color: #ebf4ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
}

.focus\\:from-indigo-200:focus {
  --gradient-from-color: #c3dafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
}

.focus\\:from-indigo-300:focus {
  --gradient-from-color: #a3bffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
}

.focus\\:from-indigo-400:focus {
  --gradient-from-color: #7f9cf5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
}

.focus\\:from-indigo-500:focus {
  --gradient-from-color: #667eea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
}

.focus\\:from-indigo-600:focus {
  --gradient-from-color: #5a67d8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
}

.focus\\:from-indigo-700:focus {
  --gradient-from-color: #4c51bf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
}

.focus\\:from-indigo-800:focus {
  --gradient-from-color: #434190;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
}

.focus\\:from-indigo-900:focus {
  --gradient-from-color: #3c366b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
}

.focus\\:from-purple-100:focus {
  --gradient-from-color: #faf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
}

.focus\\:from-purple-200:focus {
  --gradient-from-color: #e9d8fd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
}

.focus\\:from-purple-300:focus {
  --gradient-from-color: #d6bcfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
}

.focus\\:from-purple-400:focus {
  --gradient-from-color: #b794f4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
}

.focus\\:from-purple-500:focus {
  --gradient-from-color: #9f7aea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
}

.focus\\:from-purple-600:focus {
  --gradient-from-color: #805ad5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
}

.focus\\:from-purple-700:focus {
  --gradient-from-color: #6b46c1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
}

.focus\\:from-purple-800:focus {
  --gradient-from-color: #553c9a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
}

.focus\\:from-purple-900:focus {
  --gradient-from-color: #44337a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
}

.focus\\:from-pink-100:focus {
  --gradient-from-color: #fff5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
}

.focus\\:from-pink-200:focus {
  --gradient-from-color: #fed7e2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
}

.focus\\:from-pink-300:focus {
  --gradient-from-color: #fbb6ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
}

.focus\\:from-pink-400:focus {
  --gradient-from-color: #f687b3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
}

.focus\\:from-pink-500:focus {
  --gradient-from-color: #ed64a6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
}

.focus\\:from-pink-600:focus {
  --gradient-from-color: #d53f8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
}

.focus\\:from-pink-700:focus {
  --gradient-from-color: #b83280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
}

.focus\\:from-pink-800:focus {
  --gradient-from-color: #97266d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
}

.focus\\:from-pink-900:focus {
  --gradient-from-color: #702459;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
}

.focus\\:via-transparent:focus {
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.focus\\:via-current:focus {
  --gradient-via-color: currentColor;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:via-black:focus {
  --gradient-via-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.focus\\:via-white:focus {
  --gradient-via-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:via-gray-100:focus {
  --gradient-via-color: #f7fafc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
}

.focus\\:via-gray-200:focus {
  --gradient-via-color: #edf2f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
}

.focus\\:via-gray-300:focus {
  --gradient-via-color: #e2e8f0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
}

.focus\\:via-gray-400:focus {
  --gradient-via-color: #cbd5e0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
}

.focus\\:via-gray-500:focus {
  --gradient-via-color: #a0aec0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
}

.focus\\:via-gray-600:focus {
  --gradient-via-color: #718096;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
}

.focus\\:via-gray-700:focus {
  --gradient-via-color: #4a5568;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
}

.focus\\:via-gray-800:focus {
  --gradient-via-color: #2d3748;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
}

.focus\\:via-gray-900:focus {
  --gradient-via-color: #1a202c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
}

.focus\\:via-red-100:focus {
  --gradient-via-color: #fff5f5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
}

.focus\\:via-red-200:focus {
  --gradient-via-color: #fed7d7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
}

.focus\\:via-red-300:focus {
  --gradient-via-color: #feb2b2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
}

.focus\\:via-red-400:focus {
  --gradient-via-color: #fc8181;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
}

.focus\\:via-red-500:focus {
  --gradient-via-color: #f56565;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
}

.focus\\:via-red-600:focus {
  --gradient-via-color: #e53e3e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
}

.focus\\:via-red-700:focus {
  --gradient-via-color: #c53030;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
}

.focus\\:via-red-800:focus {
  --gradient-via-color: #9b2c2c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
}

.focus\\:via-red-900:focus {
  --gradient-via-color: #742a2a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
}

.focus\\:via-orange-100:focus {
  --gradient-via-color: #fffaf0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
}

.focus\\:via-orange-200:focus {
  --gradient-via-color: #feebc8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
}

.focus\\:via-orange-300:focus {
  --gradient-via-color: #fbd38d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
}

.focus\\:via-orange-400:focus {
  --gradient-via-color: #f6ad55;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
}

.focus\\:via-orange-500:focus {
  --gradient-via-color: #ed8936;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
}

.focus\\:via-orange-600:focus {
  --gradient-via-color: #dd6b20;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
}

.focus\\:via-orange-700:focus {
  --gradient-via-color: #c05621;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
}

.focus\\:via-orange-800:focus {
  --gradient-via-color: #9c4221;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
}

.focus\\:via-orange-900:focus {
  --gradient-via-color: #7b341e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
}

.focus\\:via-yellow-100:focus {
  --gradient-via-color: #fffff0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
}

.focus\\:via-yellow-200:focus {
  --gradient-via-color: #fefcbf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
}

.focus\\:via-yellow-300:focus {
  --gradient-via-color: #faf089;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
}

.focus\\:via-yellow-400:focus {
  --gradient-via-color: #f6e05e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
}

.focus\\:via-yellow-500:focus {
  --gradient-via-color: #ecc94b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
}

.focus\\:via-yellow-600:focus {
  --gradient-via-color: #d69e2e;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
}

.focus\\:via-yellow-700:focus {
  --gradient-via-color: #b7791f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
}

.focus\\:via-yellow-800:focus {
  --gradient-via-color: #975a16;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
}

.focus\\:via-yellow-900:focus {
  --gradient-via-color: #744210;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
}

.focus\\:via-green-100:focus {
  --gradient-via-color: #f0fff4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
}

.focus\\:via-green-200:focus {
  --gradient-via-color: #c6f6d5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
}

.focus\\:via-green-300:focus {
  --gradient-via-color: #9ae6b4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
}

.focus\\:via-green-400:focus {
  --gradient-via-color: #68d391;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
}

.focus\\:via-green-500:focus {
  --gradient-via-color: #48bb78;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
}

.focus\\:via-green-600:focus {
  --gradient-via-color: #38a169;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
}

.focus\\:via-green-700:focus {
  --gradient-via-color: #2f855a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
}

.focus\\:via-green-800:focus {
  --gradient-via-color: #276749;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
}

.focus\\:via-green-900:focus {
  --gradient-via-color: #22543d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
}

.focus\\:via-teal-100:focus {
  --gradient-via-color: #e6fffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
}

.focus\\:via-teal-200:focus {
  --gradient-via-color: #b2f5ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
}

.focus\\:via-teal-300:focus {
  --gradient-via-color: #81e6d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
}

.focus\\:via-teal-400:focus {
  --gradient-via-color: #4fd1c5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
}

.focus\\:via-teal-500:focus {
  --gradient-via-color: #38b2ac;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
}

.focus\\:via-teal-600:focus {
  --gradient-via-color: #319795;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
}

.focus\\:via-teal-700:focus {
  --gradient-via-color: #2c7a7b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
}

.focus\\:via-teal-800:focus {
  --gradient-via-color: #285e61;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
}

.focus\\:via-teal-900:focus {
  --gradient-via-color: #234e52;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
}

.focus\\:via-blue-100:focus {
  --gradient-via-color: #ebf8ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
}

.focus\\:via-blue-200:focus {
  --gradient-via-color: #bee3f8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
}

.focus\\:via-blue-300:focus {
  --gradient-via-color: #90cdf4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
}

.focus\\:via-blue-400:focus {
  --gradient-via-color: #63b3ed;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
}

.focus\\:via-blue-500:focus {
  --gradient-via-color: #4299e1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
}

.focus\\:via-blue-600:focus {
  --gradient-via-color: #3182ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
}

.focus\\:via-blue-700:focus {
  --gradient-via-color: #2b6cb0;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
}

.focus\\:via-blue-800:focus {
  --gradient-via-color: #2c5282;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
}

.focus\\:via-blue-900:focus {
  --gradient-via-color: #2a4365;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
}

.focus\\:via-indigo-100:focus {
  --gradient-via-color: #ebf4ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
}

.focus\\:via-indigo-200:focus {
  --gradient-via-color: #c3dafe;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
}

.focus\\:via-indigo-300:focus {
  --gradient-via-color: #a3bffa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
}

.focus\\:via-indigo-400:focus {
  --gradient-via-color: #7f9cf5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
}

.focus\\:via-indigo-500:focus {
  --gradient-via-color: #667eea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
}

.focus\\:via-indigo-600:focus {
  --gradient-via-color: #5a67d8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
}

.focus\\:via-indigo-700:focus {
  --gradient-via-color: #4c51bf;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
}

.focus\\:via-indigo-800:focus {
  --gradient-via-color: #434190;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
}

.focus\\:via-indigo-900:focus {
  --gradient-via-color: #3c366b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
}

.focus\\:via-purple-100:focus {
  --gradient-via-color: #faf5ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
}

.focus\\:via-purple-200:focus {
  --gradient-via-color: #e9d8fd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
}

.focus\\:via-purple-300:focus {
  --gradient-via-color: #d6bcfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
}

.focus\\:via-purple-400:focus {
  --gradient-via-color: #b794f4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
}

.focus\\:via-purple-500:focus {
  --gradient-via-color: #9f7aea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
}

.focus\\:via-purple-600:focus {
  --gradient-via-color: #805ad5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
}

.focus\\:via-purple-700:focus {
  --gradient-via-color: #6b46c1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
}

.focus\\:via-purple-800:focus {
  --gradient-via-color: #553c9a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
}

.focus\\:via-purple-900:focus {
  --gradient-via-color: #44337a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
}

.focus\\:via-pink-100:focus {
  --gradient-via-color: #fff5f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
}

.focus\\:via-pink-200:focus {
  --gradient-via-color: #fed7e2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
}

.focus\\:via-pink-300:focus {
  --gradient-via-color: #fbb6ce;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
}

.focus\\:via-pink-400:focus {
  --gradient-via-color: #f687b3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
}

.focus\\:via-pink-500:focus {
  --gradient-via-color: #ed64a6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
}

.focus\\:via-pink-600:focus {
  --gradient-via-color: #d53f8c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
}

.focus\\:via-pink-700:focus {
  --gradient-via-color: #b83280;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
}

.focus\\:via-pink-800:focus {
  --gradient-via-color: #97266d;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
}

.focus\\:via-pink-900:focus {
  --gradient-via-color: #702459;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
}

.focus\\:to-transparent:focus {
  --gradient-to-color: transparent;
}

.focus\\:to-current:focus {
  --gradient-to-color: currentColor;
}

.focus\\:to-black:focus {
  --gradient-to-color: #000;
}

.focus\\:to-white:focus {
  --gradient-to-color: #fff;
}

.focus\\:to-gray-100:focus {
  --gradient-to-color: #f7fafc;
}

.focus\\:to-gray-200:focus {
  --gradient-to-color: #edf2f7;
}

.focus\\:to-gray-300:focus {
  --gradient-to-color: #e2e8f0;
}

.focus\\:to-gray-400:focus {
  --gradient-to-color: #cbd5e0;
}

.focus\\:to-gray-500:focus {
  --gradient-to-color: #a0aec0;
}

.focus\\:to-gray-600:focus {
  --gradient-to-color: #718096;
}

.focus\\:to-gray-700:focus {
  --gradient-to-color: #4a5568;
}

.focus\\:to-gray-800:focus {
  --gradient-to-color: #2d3748;
}

.focus\\:to-gray-900:focus {
  --gradient-to-color: #1a202c;
}

.focus\\:to-red-100:focus {
  --gradient-to-color: #fff5f5;
}

.focus\\:to-red-200:focus {
  --gradient-to-color: #fed7d7;
}

.focus\\:to-red-300:focus {
  --gradient-to-color: #feb2b2;
}

.focus\\:to-red-400:focus {
  --gradient-to-color: #fc8181;
}

.focus\\:to-red-500:focus {
  --gradient-to-color: #f56565;
}

.focus\\:to-red-600:focus {
  --gradient-to-color: #e53e3e;
}

.focus\\:to-red-700:focus {
  --gradient-to-color: #c53030;
}

.focus\\:to-red-800:focus {
  --gradient-to-color: #9b2c2c;
}

.focus\\:to-red-900:focus {
  --gradient-to-color: #742a2a;
}

.focus\\:to-orange-100:focus {
  --gradient-to-color: #fffaf0;
}

.focus\\:to-orange-200:focus {
  --gradient-to-color: #feebc8;
}

.focus\\:to-orange-300:focus {
  --gradient-to-color: #fbd38d;
}

.focus\\:to-orange-400:focus {
  --gradient-to-color: #f6ad55;
}

.focus\\:to-orange-500:focus {
  --gradient-to-color: #ed8936;
}

.focus\\:to-orange-600:focus {
  --gradient-to-color: #dd6b20;
}

.focus\\:to-orange-700:focus {
  --gradient-to-color: #c05621;
}

.focus\\:to-orange-800:focus {
  --gradient-to-color: #9c4221;
}

.focus\\:to-orange-900:focus {
  --gradient-to-color: #7b341e;
}

.focus\\:to-yellow-100:focus {
  --gradient-to-color: #fffff0;
}

.focus\\:to-yellow-200:focus {
  --gradient-to-color: #fefcbf;
}

.focus\\:to-yellow-300:focus {
  --gradient-to-color: #faf089;
}

.focus\\:to-yellow-400:focus {
  --gradient-to-color: #f6e05e;
}

.focus\\:to-yellow-500:focus {
  --gradient-to-color: #ecc94b;
}

.focus\\:to-yellow-600:focus {
  --gradient-to-color: #d69e2e;
}

.focus\\:to-yellow-700:focus {
  --gradient-to-color: #b7791f;
}

.focus\\:to-yellow-800:focus {
  --gradient-to-color: #975a16;
}

.focus\\:to-yellow-900:focus {
  --gradient-to-color: #744210;
}

.focus\\:to-green-100:focus {
  --gradient-to-color: #f0fff4;
}

.focus\\:to-green-200:focus {
  --gradient-to-color: #c6f6d5;
}

.focus\\:to-green-300:focus {
  --gradient-to-color: #9ae6b4;
}

.focus\\:to-green-400:focus {
  --gradient-to-color: #68d391;
}

.focus\\:to-green-500:focus {
  --gradient-to-color: #48bb78;
}

.focus\\:to-green-600:focus {
  --gradient-to-color: #38a169;
}

.focus\\:to-green-700:focus {
  --gradient-to-color: #2f855a;
}

.focus\\:to-green-800:focus {
  --gradient-to-color: #276749;
}

.focus\\:to-green-900:focus {
  --gradient-to-color: #22543d;
}

.focus\\:to-teal-100:focus {
  --gradient-to-color: #e6fffa;
}

.focus\\:to-teal-200:focus {
  --gradient-to-color: #b2f5ea;
}

.focus\\:to-teal-300:focus {
  --gradient-to-color: #81e6d9;
}

.focus\\:to-teal-400:focus {
  --gradient-to-color: #4fd1c5;
}

.focus\\:to-teal-500:focus {
  --gradient-to-color: #38b2ac;
}

.focus\\:to-teal-600:focus {
  --gradient-to-color: #319795;
}

.focus\\:to-teal-700:focus {
  --gradient-to-color: #2c7a7b;
}

.focus\\:to-teal-800:focus {
  --gradient-to-color: #285e61;
}

.focus\\:to-teal-900:focus {
  --gradient-to-color: #234e52;
}

.focus\\:to-blue-100:focus {
  --gradient-to-color: #ebf8ff;
}

.focus\\:to-blue-200:focus {
  --gradient-to-color: #bee3f8;
}

.focus\\:to-blue-300:focus {
  --gradient-to-color: #90cdf4;
}

.focus\\:to-blue-400:focus {
  --gradient-to-color: #63b3ed;
}

.focus\\:to-blue-500:focus {
  --gradient-to-color: #4299e1;
}

.focus\\:to-blue-600:focus {
  --gradient-to-color: #3182ce;
}

.focus\\:to-blue-700:focus {
  --gradient-to-color: #2b6cb0;
}

.focus\\:to-blue-800:focus {
  --gradient-to-color: #2c5282;
}

.focus\\:to-blue-900:focus {
  --gradient-to-color: #2a4365;
}

.focus\\:to-indigo-100:focus {
  --gradient-to-color: #ebf4ff;
}

.focus\\:to-indigo-200:focus {
  --gradient-to-color: #c3dafe;
}

.focus\\:to-indigo-300:focus {
  --gradient-to-color: #a3bffa;
}

.focus\\:to-indigo-400:focus {
  --gradient-to-color: #7f9cf5;
}

.focus\\:to-indigo-500:focus {
  --gradient-to-color: #667eea;
}

.focus\\:to-indigo-600:focus {
  --gradient-to-color: #5a67d8;
}

.focus\\:to-indigo-700:focus {
  --gradient-to-color: #4c51bf;
}

.focus\\:to-indigo-800:focus {
  --gradient-to-color: #434190;
}

.focus\\:to-indigo-900:focus {
  --gradient-to-color: #3c366b;
}

.focus\\:to-purple-100:focus {
  --gradient-to-color: #faf5ff;
}

.focus\\:to-purple-200:focus {
  --gradient-to-color: #e9d8fd;
}

.focus\\:to-purple-300:focus {
  --gradient-to-color: #d6bcfa;
}

.focus\\:to-purple-400:focus {
  --gradient-to-color: #b794f4;
}

.focus\\:to-purple-500:focus {
  --gradient-to-color: #9f7aea;
}

.focus\\:to-purple-600:focus {
  --gradient-to-color: #805ad5;
}

.focus\\:to-purple-700:focus {
  --gradient-to-color: #6b46c1;
}

.focus\\:to-purple-800:focus {
  --gradient-to-color: #553c9a;
}

.focus\\:to-purple-900:focus {
  --gradient-to-color: #44337a;
}

.focus\\:to-pink-100:focus {
  --gradient-to-color: #fff5f7;
}

.focus\\:to-pink-200:focus {
  --gradient-to-color: #fed7e2;
}

.focus\\:to-pink-300:focus {
  --gradient-to-color: #fbb6ce;
}

.focus\\:to-pink-400:focus {
  --gradient-to-color: #f687b3;
}

.focus\\:to-pink-500:focus {
  --gradient-to-color: #ed64a6;
}

.focus\\:to-pink-600:focus {
  --gradient-to-color: #d53f8c;
}

.focus\\:to-pink-700:focus {
  --gradient-to-color: #b83280;
}

.focus\\:to-pink-800:focus {
  --gradient-to-color: #97266d;
}

.focus\\:to-pink-900:focus {
  --gradient-to-color: #702459;
}

.bg-opacity-0 {
  --bg-opacity: 0;
}

.bg-opacity-25 {
  --bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bg-opacity: 1;
}

.hover\\:bg-opacity-0:hover {
  --bg-opacity: 0;
}

.hover\\:bg-opacity-25:hover {
  --bg-opacity: 0.25;
}

.hover\\:bg-opacity-50:hover {
  --bg-opacity: 0.5;
}

.hover\\:bg-opacity-75:hover {
  --bg-opacity: 0.75;
}

.hover\\:bg-opacity-100:hover {
  --bg-opacity: 1;
}

.focus\\:bg-opacity-0:focus {
  --bg-opacity: 0;
}

.focus\\:bg-opacity-25:focus {
  --bg-opacity: 0.25;
}

.focus\\:bg-opacity-50:focus {
  --bg-opacity: 0.5;
}

.focus\\:bg-opacity-75:focus {
  --bg-opacity: 0.75;
}

.focus\\:bg-opacity-100:focus {
  --bg-opacity: 1;
}

.bg-bottom {
  background-position: bottom;
}

.bg-center {
  background-position: center;
}

.bg-left {
  background-position: left;
}

.bg-left-bottom {
  background-position: left bottom;
}

.bg-left-top {
  background-position: left top;
}

.bg-right {
  background-position: right;
}

.bg-right-bottom {
  background-position: right bottom;
}

.bg-right-top {
  background-position: right top;
}

.bg-top {
  background-position: top;
}

.bg-repeat {
  background-repeat: repeat;
}

.bg-no-repeat {
  background-repeat: no-repeat;
}

.bg-repeat-x {
  background-repeat: repeat-x;
}

.bg-repeat-y {
  background-repeat: repeat-y;
}

.bg-repeat-round {
  background-repeat: round;
}

.bg-repeat-space {
  background-repeat: space;
}

.bg-auto {
  background-size: auto;
}

.bg-cover {
  background-size: cover;
}

.bg-contain {
  background-size: contain;
}

.border-collapse {
  border-collapse: collapse;
}

.border-separate {
  border-collapse: separate;
}

.border-transparent {
  border-color: transparent;
}

.border-current {
  border-color: currentColor;
}

.border-black {
  --border-opacity: 1;
  border-color: #000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}

.border-white {
  --border-opacity: 1;
  border-color: #fff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}

.border-gray-100 {
  --border-opacity: 1;
  border-color: #f7fafc;
  border-color: rgba(247, 250, 252, var(--border-opacity));
}

.border-gray-200 {
  --border-opacity: 1;
  border-color: #edf2f7;
  border-color: rgba(237, 242, 247, var(--border-opacity));
}

.border-gray-300 {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}

.border-gray-400 {
  --border-opacity: 1;
  border-color: #cbd5e0;
  border-color: rgba(203, 213, 224, var(--border-opacity));
}

.border-gray-500 {
  --border-opacity: 1;
  border-color: #a0aec0;
  border-color: rgba(160, 174, 192, var(--border-opacity));
}

.border-gray-600 {
  --border-opacity: 1;
  border-color: #718096;
  border-color: rgba(113, 128, 150, var(--border-opacity));
}

.border-gray-700 {
  --border-opacity: 1;
  border-color: #4a5568;
  border-color: rgba(74, 85, 104, var(--border-opacity));
}

.border-gray-800 {
  --border-opacity: 1;
  border-color: #2d3748;
  border-color: rgba(45, 55, 72, var(--border-opacity));
}

.border-gray-900 {
  --border-opacity: 1;
  border-color: #1a202c;
  border-color: rgba(26, 32, 44, var(--border-opacity));
}

.border-red-100 {
  --border-opacity: 1;
  border-color: #fff5f5;
  border-color: rgba(255, 245, 245, var(--border-opacity));
}

.border-red-200 {
  --border-opacity: 1;
  border-color: #fed7d7;
  border-color: rgba(254, 215, 215, var(--border-opacity));
}

.border-red-300 {
  --border-opacity: 1;
  border-color: #feb2b2;
  border-color: rgba(254, 178, 178, var(--border-opacity));
}

.border-red-400 {
  --border-opacity: 1;
  border-color: #fc8181;
  border-color: rgba(252, 129, 129, var(--border-opacity));
}

.border-red-500 {
  --border-opacity: 1;
  border-color: #f56565;
  border-color: rgba(245, 101, 101, var(--border-opacity));
}

.border-red-600 {
  --border-opacity: 1;
  border-color: #e53e3e;
  border-color: rgba(229, 62, 62, var(--border-opacity));
}

.border-red-700 {
  --border-opacity: 1;
  border-color: #c53030;
  border-color: rgba(197, 48, 48, var(--border-opacity));
}

.border-red-800 {
  --border-opacity: 1;
  border-color: #9b2c2c;
  border-color: rgba(155, 44, 44, var(--border-opacity));
}

.border-red-900 {
  --border-opacity: 1;
  border-color: #742a2a;
  border-color: rgba(116, 42, 42, var(--border-opacity));
}

.border-orange-100 {
  --border-opacity: 1;
  border-color: #fffaf0;
  border-color: rgba(255, 250, 240, var(--border-opacity));
}

.border-orange-200 {
  --border-opacity: 1;
  border-color: #feebc8;
  border-color: rgba(254, 235, 200, var(--border-opacity));
}

.border-orange-300 {
  --border-opacity: 1;
  border-color: #fbd38d;
  border-color: rgba(251, 211, 141, var(--border-opacity));
}

.border-orange-400 {
  --border-opacity: 1;
  border-color: #f6ad55;
  border-color: rgba(246, 173, 85, var(--border-opacity));
}

.border-orange-500 {
  --border-opacity: 1;
  border-color: #ed8936;
  border-color: rgba(237, 137, 54, var(--border-opacity));
}

.border-orange-600 {
  --border-opacity: 1;
  border-color: #dd6b20;
  border-color: rgba(221, 107, 32, var(--border-opacity));
}

.border-orange-700 {
  --border-opacity: 1;
  border-color: #c05621;
  border-color: rgba(192, 86, 33, var(--border-opacity));
}

.border-orange-800 {
  --border-opacity: 1;
  border-color: #9c4221;
  border-color: rgba(156, 66, 33, var(--border-opacity));
}

.border-orange-900 {
  --border-opacity: 1;
  border-color: #7b341e;
  border-color: rgba(123, 52, 30, var(--border-opacity));
}

.border-yellow-100 {
  --border-opacity: 1;
  border-color: #fffff0;
  border-color: rgba(255, 255, 240, var(--border-opacity));
}

.border-yellow-200 {
  --border-opacity: 1;
  border-color: #fefcbf;
  border-color: rgba(254, 252, 191, var(--border-opacity));
}

.border-yellow-300 {
  --border-opacity: 1;
  border-color: #faf089;
  border-color: rgba(250, 240, 137, var(--border-opacity));
}

.border-yellow-400 {
  --border-opacity: 1;
  border-color: #f6e05e;
  border-color: rgba(246, 224, 94, var(--border-opacity));
}

.border-yellow-500 {
  --border-opacity: 1;
  border-color: #ecc94b;
  border-color: rgba(236, 201, 75, var(--border-opacity));
}

.border-yellow-600 {
  --border-opacity: 1;
  border-color: #d69e2e;
  border-color: rgba(214, 158, 46, var(--border-opacity));
}

.border-yellow-700 {
  --border-opacity: 1;
  border-color: #b7791f;
  border-color: rgba(183, 121, 31, var(--border-opacity));
}

.border-yellow-800 {
  --border-opacity: 1;
  border-color: #975a16;
  border-color: rgba(151, 90, 22, var(--border-opacity));
}

.border-yellow-900 {
  --border-opacity: 1;
  border-color: #744210;
  border-color: rgba(116, 66, 16, var(--border-opacity));
}

.border-green-100 {
  --border-opacity: 1;
  border-color: #f0fff4;
  border-color: rgba(240, 255, 244, var(--border-opacity));
}

.border-green-200 {
  --border-opacity: 1;
  border-color: #c6f6d5;
  border-color: rgba(198, 246, 213, var(--border-opacity));
}

.border-green-300 {
  --border-opacity: 1;
  border-color: #9ae6b4;
  border-color: rgba(154, 230, 180, var(--border-opacity));
}

.border-green-400 {
  --border-opacity: 1;
  border-color: #68d391;
  border-color: rgba(104, 211, 145, var(--border-opacity));
}

.border-green-500 {
  --border-opacity: 1;
  border-color: #48bb78;
  border-color: rgba(72, 187, 120, var(--border-opacity));
}

.border-green-600 {
  --border-opacity: 1;
  border-color: #38a169;
  border-color: rgba(56, 161, 105, var(--border-opacity));
}

.border-green-700 {
  --border-opacity: 1;
  border-color: #2f855a;
  border-color: rgba(47, 133, 90, var(--border-opacity));
}

.border-green-800 {
  --border-opacity: 1;
  border-color: #276749;
  border-color: rgba(39, 103, 73, var(--border-opacity));
}

.border-green-900 {
  --border-opacity: 1;
  border-color: #22543d;
  border-color: rgba(34, 84, 61, var(--border-opacity));
}

.border-teal-100 {
  --border-opacity: 1;
  border-color: #e6fffa;
  border-color: rgba(230, 255, 250, var(--border-opacity));
}

.border-teal-200 {
  --border-opacity: 1;
  border-color: #b2f5ea;
  border-color: rgba(178, 245, 234, var(--border-opacity));
}

.border-teal-300 {
  --border-opacity: 1;
  border-color: #81e6d9;
  border-color: rgba(129, 230, 217, var(--border-opacity));
}

.border-teal-400 {
  --border-opacity: 1;
  border-color: #4fd1c5;
  border-color: rgba(79, 209, 197, var(--border-opacity));
}

.border-teal-500 {
  --border-opacity: 1;
  border-color: #38b2ac;
  border-color: rgba(56, 178, 172, var(--border-opacity));
}

.border-teal-600 {
  --border-opacity: 1;
  border-color: #319795;
  border-color: rgba(49, 151, 149, var(--border-opacity));
}

.border-teal-700 {
  --border-opacity: 1;
  border-color: #2c7a7b;
  border-color: rgba(44, 122, 123, var(--border-opacity));
}

.border-teal-800 {
  --border-opacity: 1;
  border-color: #285e61;
  border-color: rgba(40, 94, 97, var(--border-opacity));
}

.border-teal-900 {
  --border-opacity: 1;
  border-color: #234e52;
  border-color: rgba(35, 78, 82, var(--border-opacity));
}

.border-blue-100 {
  --border-opacity: 1;
  border-color: #ebf8ff;
  border-color: rgba(235, 248, 255, var(--border-opacity));
}

.border-blue-200 {
  --border-opacity: 1;
  border-color: #bee3f8;
  border-color: rgba(190, 227, 248, var(--border-opacity));
}

.border-blue-300 {
  --border-opacity: 1;
  border-color: #90cdf4;
  border-color: rgba(144, 205, 244, var(--border-opacity));
}

.border-blue-400 {
  --border-opacity: 1;
  border-color: #63b3ed;
  border-color: rgba(99, 179, 237, var(--border-opacity));
}

.border-blue-500 {
  --border-opacity: 1;
  border-color: #4299e1;
  border-color: rgba(66, 153, 225, var(--border-opacity));
}

.border-blue-600 {
  --border-opacity: 1;
  border-color: #3182ce;
  border-color: rgba(49, 130, 206, var(--border-opacity));
}

.border-blue-700 {
  --border-opacity: 1;
  border-color: #2b6cb0;
  border-color: rgba(43, 108, 176, var(--border-opacity));
}

.border-blue-800 {
  --border-opacity: 1;
  border-color: #2c5282;
  border-color: rgba(44, 82, 130, var(--border-opacity));
}

.border-blue-900 {
  --border-opacity: 1;
  border-color: #2a4365;
  border-color: rgba(42, 67, 101, var(--border-opacity));
}

.border-indigo-100 {
  --border-opacity: 1;
  border-color: #ebf4ff;
  border-color: rgba(235, 244, 255, var(--border-opacity));
}

.border-indigo-200 {
  --border-opacity: 1;
  border-color: #c3dafe;
  border-color: rgba(195, 218, 254, var(--border-opacity));
}

.border-indigo-300 {
  --border-opacity: 1;
  border-color: #a3bffa;
  border-color: rgba(163, 191, 250, var(--border-opacity));
}

.border-indigo-400 {
  --border-opacity: 1;
  border-color: #7f9cf5;
  border-color: rgba(127, 156, 245, var(--border-opacity));
}

.border-indigo-500 {
  --border-opacity: 1;
  border-color: #667eea;
  border-color: rgba(102, 126, 234, var(--border-opacity));
}

.border-indigo-600 {
  --border-opacity: 1;
  border-color: #5a67d8;
  border-color: rgba(90, 103, 216, var(--border-opacity));
}

.border-indigo-700 {
  --border-opacity: 1;
  border-color: #4c51bf;
  border-color: rgba(76, 81, 191, var(--border-opacity));
}

.border-indigo-800 {
  --border-opacity: 1;
  border-color: #434190;
  border-color: rgba(67, 65, 144, var(--border-opacity));
}

.border-indigo-900 {
  --border-opacity: 1;
  border-color: #3c366b;
  border-color: rgba(60, 54, 107, var(--border-opacity));
}

.border-purple-100 {
  --border-opacity: 1;
  border-color: #faf5ff;
  border-color: rgba(250, 245, 255, var(--border-opacity));
}

.border-purple-200 {
  --border-opacity: 1;
  border-color: #e9d8fd;
  border-color: rgba(233, 216, 253, var(--border-opacity));
}

.border-purple-300 {
  --border-opacity: 1;
  border-color: #d6bcfa;
  border-color: rgba(214, 188, 250, var(--border-opacity));
}

.border-purple-400 {
  --border-opacity: 1;
  border-color: #b794f4;
  border-color: rgba(183, 148, 244, var(--border-opacity));
}

.border-purple-500 {
  --border-opacity: 1;
  border-color: #9f7aea;
  border-color: rgba(159, 122, 234, var(--border-opacity));
}

.border-purple-600 {
  --border-opacity: 1;
  border-color: #805ad5;
  border-color: rgba(128, 90, 213, var(--border-opacity));
}

.border-purple-700 {
  --border-opacity: 1;
  border-color: #6b46c1;
  border-color: rgba(107, 70, 193, var(--border-opacity));
}

.border-purple-800 {
  --border-opacity: 1;
  border-color: #553c9a;
  border-color: rgba(85, 60, 154, var(--border-opacity));
}

.border-purple-900 {
  --border-opacity: 1;
  border-color: #44337a;
  border-color: rgba(68, 51, 122, var(--border-opacity));
}

.border-pink-100 {
  --border-opacity: 1;
  border-color: #fff5f7;
  border-color: rgba(255, 245, 247, var(--border-opacity));
}

.border-pink-200 {
  --border-opacity: 1;
  border-color: #fed7e2;
  border-color: rgba(254, 215, 226, var(--border-opacity));
}

.border-pink-300 {
  --border-opacity: 1;
  border-color: #fbb6ce;
  border-color: rgba(251, 182, 206, var(--border-opacity));
}

.border-pink-400 {
  --border-opacity: 1;
  border-color: #f687b3;
  border-color: rgba(246, 135, 179, var(--border-opacity));
}

.border-pink-500 {
  --border-opacity: 1;
  border-color: #ed64a6;
  border-color: rgba(237, 100, 166, var(--border-opacity));
}

.border-pink-600 {
  --border-opacity: 1;
  border-color: #d53f8c;
  border-color: rgba(213, 63, 140, var(--border-opacity));
}

.border-pink-700 {
  --border-opacity: 1;
  border-color: #b83280;
  border-color: rgba(184, 50, 128, var(--border-opacity));
}

.border-pink-800 {
  --border-opacity: 1;
  border-color: #97266d;
  border-color: rgba(151, 38, 109, var(--border-opacity));
}

.border-pink-900 {
  --border-opacity: 1;
  border-color: #702459;
  border-color: rgba(112, 36, 89, var(--border-opacity));
}

.hover\\:border-transparent:hover {
  border-color: transparent;
}

.hover\\:border-current:hover {
  border-color: currentColor;
}

.hover\\:border-black:hover {
  --border-opacity: 1;
  border-color: #000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}

.hover\\:border-white:hover {
  --border-opacity: 1;
  border-color: #fff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}

.hover\\:border-gray-100:hover {
  --border-opacity: 1;
  border-color: #f7fafc;
  border-color: rgba(247, 250, 252, var(--border-opacity));
}

.hover\\:border-gray-200:hover {
  --border-opacity: 1;
  border-color: #edf2f7;
  border-color: rgba(237, 242, 247, var(--border-opacity));
}

.hover\\:border-gray-300:hover {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}

.hover\\:border-gray-400:hover {
  --border-opacity: 1;
  border-color: #cbd5e0;
  border-color: rgba(203, 213, 224, var(--border-opacity));
}

.hover\\:border-gray-500:hover {
  --border-opacity: 1;
  border-color: #a0aec0;
  border-color: rgba(160, 174, 192, var(--border-opacity));
}

.hover\\:border-gray-600:hover {
  --border-opacity: 1;
  border-color: #718096;
  border-color: rgba(113, 128, 150, var(--border-opacity));
}

.hover\\:border-gray-700:hover {
  --border-opacity: 1;
  border-color: #4a5568;
  border-color: rgba(74, 85, 104, var(--border-opacity));
}

.hover\\:border-gray-800:hover {
  --border-opacity: 1;
  border-color: #2d3748;
  border-color: rgba(45, 55, 72, var(--border-opacity));
}

.hover\\:border-gray-900:hover {
  --border-opacity: 1;
  border-color: #1a202c;
  border-color: rgba(26, 32, 44, var(--border-opacity));
}

.hover\\:border-red-100:hover {
  --border-opacity: 1;
  border-color: #fff5f5;
  border-color: rgba(255, 245, 245, var(--border-opacity));
}

.hover\\:border-red-200:hover {
  --border-opacity: 1;
  border-color: #fed7d7;
  border-color: rgba(254, 215, 215, var(--border-opacity));
}

.hover\\:border-red-300:hover {
  --border-opacity: 1;
  border-color: #feb2b2;
  border-color: rgba(254, 178, 178, var(--border-opacity));
}

.hover\\:border-red-400:hover {
  --border-opacity: 1;
  border-color: #fc8181;
  border-color: rgba(252, 129, 129, var(--border-opacity));
}

.hover\\:border-red-500:hover {
  --border-opacity: 1;
  border-color: #f56565;
  border-color: rgba(245, 101, 101, var(--border-opacity));
}

.hover\\:border-red-600:hover {
  --border-opacity: 1;
  border-color: #e53e3e;
  border-color: rgba(229, 62, 62, var(--border-opacity));
}

.hover\\:border-red-700:hover {
  --border-opacity: 1;
  border-color: #c53030;
  border-color: rgba(197, 48, 48, var(--border-opacity));
}

.hover\\:border-red-800:hover {
  --border-opacity: 1;
  border-color: #9b2c2c;
  border-color: rgba(155, 44, 44, var(--border-opacity));
}

.hover\\:border-red-900:hover {
  --border-opacity: 1;
  border-color: #742a2a;
  border-color: rgba(116, 42, 42, var(--border-opacity));
}

.hover\\:border-orange-100:hover {
  --border-opacity: 1;
  border-color: #fffaf0;
  border-color: rgba(255, 250, 240, var(--border-opacity));
}

.hover\\:border-orange-200:hover {
  --border-opacity: 1;
  border-color: #feebc8;
  border-color: rgba(254, 235, 200, var(--border-opacity));
}

.hover\\:border-orange-300:hover {
  --border-opacity: 1;
  border-color: #fbd38d;
  border-color: rgba(251, 211, 141, var(--border-opacity));
}

.hover\\:border-orange-400:hover {
  --border-opacity: 1;
  border-color: #f6ad55;
  border-color: rgba(246, 173, 85, var(--border-opacity));
}

.hover\\:border-orange-500:hover {
  --border-opacity: 1;
  border-color: #ed8936;
  border-color: rgba(237, 137, 54, var(--border-opacity));
}

.hover\\:border-orange-600:hover {
  --border-opacity: 1;
  border-color: #dd6b20;
  border-color: rgba(221, 107, 32, var(--border-opacity));
}

.hover\\:border-orange-700:hover {
  --border-opacity: 1;
  border-color: #c05621;
  border-color: rgba(192, 86, 33, var(--border-opacity));
}

.hover\\:border-orange-800:hover {
  --border-opacity: 1;
  border-color: #9c4221;
  border-color: rgba(156, 66, 33, var(--border-opacity));
}

.hover\\:border-orange-900:hover {
  --border-opacity: 1;
  border-color: #7b341e;
  border-color: rgba(123, 52, 30, var(--border-opacity));
}

.hover\\:border-yellow-100:hover {
  --border-opacity: 1;
  border-color: #fffff0;
  border-color: rgba(255, 255, 240, var(--border-opacity));
}

.hover\\:border-yellow-200:hover {
  --border-opacity: 1;
  border-color: #fefcbf;
  border-color: rgba(254, 252, 191, var(--border-opacity));
}

.hover\\:border-yellow-300:hover {
  --border-opacity: 1;
  border-color: #faf089;
  border-color: rgba(250, 240, 137, var(--border-opacity));
}

.hover\\:border-yellow-400:hover {
  --border-opacity: 1;
  border-color: #f6e05e;
  border-color: rgba(246, 224, 94, var(--border-opacity));
}

.hover\\:border-yellow-500:hover {
  --border-opacity: 1;
  border-color: #ecc94b;
  border-color: rgba(236, 201, 75, var(--border-opacity));
}

.hover\\:border-yellow-600:hover {
  --border-opacity: 1;
  border-color: #d69e2e;
  border-color: rgba(214, 158, 46, var(--border-opacity));
}

.hover\\:border-yellow-700:hover {
  --border-opacity: 1;
  border-color: #b7791f;
  border-color: rgba(183, 121, 31, var(--border-opacity));
}

.hover\\:border-yellow-800:hover {
  --border-opacity: 1;
  border-color: #975a16;
  border-color: rgba(151, 90, 22, var(--border-opacity));
}

.hover\\:border-yellow-900:hover {
  --border-opacity: 1;
  border-color: #744210;
  border-color: rgba(116, 66, 16, var(--border-opacity));
}

.hover\\:border-green-100:hover {
  --border-opacity: 1;
  border-color: #f0fff4;
  border-color: rgba(240, 255, 244, var(--border-opacity));
}

.hover\\:border-green-200:hover {
  --border-opacity: 1;
  border-color: #c6f6d5;
  border-color: rgba(198, 246, 213, var(--border-opacity));
}

.hover\\:border-green-300:hover {
  --border-opacity: 1;
  border-color: #9ae6b4;
  border-color: rgba(154, 230, 180, var(--border-opacity));
}

.hover\\:border-green-400:hover {
  --border-opacity: 1;
  border-color: #68d391;
  border-color: rgba(104, 211, 145, var(--border-opacity));
}

.hover\\:border-green-500:hover {
  --border-opacity: 1;
  border-color: #48bb78;
  border-color: rgba(72, 187, 120, var(--border-opacity));
}

.hover\\:border-green-600:hover {
  --border-opacity: 1;
  border-color: #38a169;
  border-color: rgba(56, 161, 105, var(--border-opacity));
}

.hover\\:border-green-700:hover {
  --border-opacity: 1;
  border-color: #2f855a;
  border-color: rgba(47, 133, 90, var(--border-opacity));
}

.hover\\:border-green-800:hover {
  --border-opacity: 1;
  border-color: #276749;
  border-color: rgba(39, 103, 73, var(--border-opacity));
}

.hover\\:border-green-900:hover {
  --border-opacity: 1;
  border-color: #22543d;
  border-color: rgba(34, 84, 61, var(--border-opacity));
}

.hover\\:border-teal-100:hover {
  --border-opacity: 1;
  border-color: #e6fffa;
  border-color: rgba(230, 255, 250, var(--border-opacity));
}

.hover\\:border-teal-200:hover {
  --border-opacity: 1;
  border-color: #b2f5ea;
  border-color: rgba(178, 245, 234, var(--border-opacity));
}

.hover\\:border-teal-300:hover {
  --border-opacity: 1;
  border-color: #81e6d9;
  border-color: rgba(129, 230, 217, var(--border-opacity));
}

.hover\\:border-teal-400:hover {
  --border-opacity: 1;
  border-color: #4fd1c5;
  border-color: rgba(79, 209, 197, var(--border-opacity));
}

.hover\\:border-teal-500:hover {
  --border-opacity: 1;
  border-color: #38b2ac;
  border-color: rgba(56, 178, 172, var(--border-opacity));
}

.hover\\:border-teal-600:hover {
  --border-opacity: 1;
  border-color: #319795;
  border-color: rgba(49, 151, 149, var(--border-opacity));
}

.hover\\:border-teal-700:hover {
  --border-opacity: 1;
  border-color: #2c7a7b;
  border-color: rgba(44, 122, 123, var(--border-opacity));
}

.hover\\:border-teal-800:hover {
  --border-opacity: 1;
  border-color: #285e61;
  border-color: rgba(40, 94, 97, var(--border-opacity));
}

.hover\\:border-teal-900:hover {
  --border-opacity: 1;
  border-color: #234e52;
  border-color: rgba(35, 78, 82, var(--border-opacity));
}

.hover\\:border-blue-100:hover {
  --border-opacity: 1;
  border-color: #ebf8ff;
  border-color: rgba(235, 248, 255, var(--border-opacity));
}

.hover\\:border-blue-200:hover {
  --border-opacity: 1;
  border-color: #bee3f8;
  border-color: rgba(190, 227, 248, var(--border-opacity));
}

.hover\\:border-blue-300:hover {
  --border-opacity: 1;
  border-color: #90cdf4;
  border-color: rgba(144, 205, 244, var(--border-opacity));
}

.hover\\:border-blue-400:hover {
  --border-opacity: 1;
  border-color: #63b3ed;
  border-color: rgba(99, 179, 237, var(--border-opacity));
}

.hover\\:border-blue-500:hover {
  --border-opacity: 1;
  border-color: #4299e1;
  border-color: rgba(66, 153, 225, var(--border-opacity));
}

.hover\\:border-blue-600:hover {
  --border-opacity: 1;
  border-color: #3182ce;
  border-color: rgba(49, 130, 206, var(--border-opacity));
}

.hover\\:border-blue-700:hover {
  --border-opacity: 1;
  border-color: #2b6cb0;
  border-color: rgba(43, 108, 176, var(--border-opacity));
}

.hover\\:border-blue-800:hover {
  --border-opacity: 1;
  border-color: #2c5282;
  border-color: rgba(44, 82, 130, var(--border-opacity));
}

.hover\\:border-blue-900:hover {
  --border-opacity: 1;
  border-color: #2a4365;
  border-color: rgba(42, 67, 101, var(--border-opacity));
}

.hover\\:border-indigo-100:hover {
  --border-opacity: 1;
  border-color: #ebf4ff;
  border-color: rgba(235, 244, 255, var(--border-opacity));
}

.hover\\:border-indigo-200:hover {
  --border-opacity: 1;
  border-color: #c3dafe;
  border-color: rgba(195, 218, 254, var(--border-opacity));
}

.hover\\:border-indigo-300:hover {
  --border-opacity: 1;
  border-color: #a3bffa;
  border-color: rgba(163, 191, 250, var(--border-opacity));
}

.hover\\:border-indigo-400:hover {
  --border-opacity: 1;
  border-color: #7f9cf5;
  border-color: rgba(127, 156, 245, var(--border-opacity));
}

.hover\\:border-indigo-500:hover {
  --border-opacity: 1;
  border-color: #667eea;
  border-color: rgba(102, 126, 234, var(--border-opacity));
}

.hover\\:border-indigo-600:hover {
  --border-opacity: 1;
  border-color: #5a67d8;
  border-color: rgba(90, 103, 216, var(--border-opacity));
}

.hover\\:border-indigo-700:hover {
  --border-opacity: 1;
  border-color: #4c51bf;
  border-color: rgba(76, 81, 191, var(--border-opacity));
}

.hover\\:border-indigo-800:hover {
  --border-opacity: 1;
  border-color: #434190;
  border-color: rgba(67, 65, 144, var(--border-opacity));
}

.hover\\:border-indigo-900:hover {
  --border-opacity: 1;
  border-color: #3c366b;
  border-color: rgba(60, 54, 107, var(--border-opacity));
}

.hover\\:border-purple-100:hover {
  --border-opacity: 1;
  border-color: #faf5ff;
  border-color: rgba(250, 245, 255, var(--border-opacity));
}

.hover\\:border-purple-200:hover {
  --border-opacity: 1;
  border-color: #e9d8fd;
  border-color: rgba(233, 216, 253, var(--border-opacity));
}

.hover\\:border-purple-300:hover {
  --border-opacity: 1;
  border-color: #d6bcfa;
  border-color: rgba(214, 188, 250, var(--border-opacity));
}

.hover\\:border-purple-400:hover {
  --border-opacity: 1;
  border-color: #b794f4;
  border-color: rgba(183, 148, 244, var(--border-opacity));
}

.hover\\:border-purple-500:hover {
  --border-opacity: 1;
  border-color: #9f7aea;
  border-color: rgba(159, 122, 234, var(--border-opacity));
}

.hover\\:border-purple-600:hover {
  --border-opacity: 1;
  border-color: #805ad5;
  border-color: rgba(128, 90, 213, var(--border-opacity));
}

.hover\\:border-purple-700:hover {
  --border-opacity: 1;
  border-color: #6b46c1;
  border-color: rgba(107, 70, 193, var(--border-opacity));
}

.hover\\:border-purple-800:hover {
  --border-opacity: 1;
  border-color: #553c9a;
  border-color: rgba(85, 60, 154, var(--border-opacity));
}

.hover\\:border-purple-900:hover {
  --border-opacity: 1;
  border-color: #44337a;
  border-color: rgba(68, 51, 122, var(--border-opacity));
}

.hover\\:border-pink-100:hover {
  --border-opacity: 1;
  border-color: #fff5f7;
  border-color: rgba(255, 245, 247, var(--border-opacity));
}

.hover\\:border-pink-200:hover {
  --border-opacity: 1;
  border-color: #fed7e2;
  border-color: rgba(254, 215, 226, var(--border-opacity));
}

.hover\\:border-pink-300:hover {
  --border-opacity: 1;
  border-color: #fbb6ce;
  border-color: rgba(251, 182, 206, var(--border-opacity));
}

.hover\\:border-pink-400:hover {
  --border-opacity: 1;
  border-color: #f687b3;
  border-color: rgba(246, 135, 179, var(--border-opacity));
}

.hover\\:border-pink-500:hover {
  --border-opacity: 1;
  border-color: #ed64a6;
  border-color: rgba(237, 100, 166, var(--border-opacity));
}

.hover\\:border-pink-600:hover {
  --border-opacity: 1;
  border-color: #d53f8c;
  border-color: rgba(213, 63, 140, var(--border-opacity));
}

.hover\\:border-pink-700:hover {
  --border-opacity: 1;
  border-color: #b83280;
  border-color: rgba(184, 50, 128, var(--border-opacity));
}

.hover\\:border-pink-800:hover {
  --border-opacity: 1;
  border-color: #97266d;
  border-color: rgba(151, 38, 109, var(--border-opacity));
}

.hover\\:border-pink-900:hover {
  --border-opacity: 1;
  border-color: #702459;
  border-color: rgba(112, 36, 89, var(--border-opacity));
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:border-current:focus {
  border-color: currentColor;
}

.focus\\:border-black:focus {
  --border-opacity: 1;
  border-color: #000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}

.focus\\:border-white:focus {
  --border-opacity: 1;
  border-color: #fff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}

.focus\\:border-gray-100:focus {
  --border-opacity: 1;
  border-color: #f7fafc;
  border-color: rgba(247, 250, 252, var(--border-opacity));
}

.focus\\:border-gray-200:focus {
  --border-opacity: 1;
  border-color: #edf2f7;
  border-color: rgba(237, 242, 247, var(--border-opacity));
}

.focus\\:border-gray-300:focus {
  --border-opacity: 1;
  border-color: #e2e8f0;
  border-color: rgba(226, 232, 240, var(--border-opacity));
}

.focus\\:border-gray-400:focus {
  --border-opacity: 1;
  border-color: #cbd5e0;
  border-color: rgba(203, 213, 224, var(--border-opacity));
}

.focus\\:border-gray-500:focus {
  --border-opacity: 1;
  border-color: #a0aec0;
  border-color: rgba(160, 174, 192, var(--border-opacity));
}

.focus\\:border-gray-600:focus {
  --border-opacity: 1;
  border-color: #718096;
  border-color: rgba(113, 128, 150, var(--border-opacity));
}

.focus\\:border-gray-700:focus {
  --border-opacity: 1;
  border-color: #4a5568;
  border-color: rgba(74, 85, 104, var(--border-opacity));
}

.focus\\:border-gray-800:focus {
  --border-opacity: 1;
  border-color: #2d3748;
  border-color: rgba(45, 55, 72, var(--border-opacity));
}

.focus\\:border-gray-900:focus {
  --border-opacity: 1;
  border-color: #1a202c;
  border-color: rgba(26, 32, 44, var(--border-opacity));
}

.focus\\:border-red-100:focus {
  --border-opacity: 1;
  border-color: #fff5f5;
  border-color: rgba(255, 245, 245, var(--border-opacity));
}

.focus\\:border-red-200:focus {
  --border-opacity: 1;
  border-color: #fed7d7;
  border-color: rgba(254, 215, 215, var(--border-opacity));
}

.focus\\:border-red-300:focus {
  --border-opacity: 1;
  border-color: #feb2b2;
  border-color: rgba(254, 178, 178, var(--border-opacity));
}

.focus\\:border-red-400:focus {
  --border-opacity: 1;
  border-color: #fc8181;
  border-color: rgba(252, 129, 129, var(--border-opacity));
}

.focus\\:border-red-500:focus {
  --border-opacity: 1;
  border-color: #f56565;
  border-color: rgba(245, 101, 101, var(--border-opacity));
}

.focus\\:border-red-600:focus {
  --border-opacity: 1;
  border-color: #e53e3e;
  border-color: rgba(229, 62, 62, var(--border-opacity));
}

.focus\\:border-red-700:focus {
  --border-opacity: 1;
  border-color: #c53030;
  border-color: rgba(197, 48, 48, var(--border-opacity));
}

.focus\\:border-red-800:focus {
  --border-opacity: 1;
  border-color: #9b2c2c;
  border-color: rgba(155, 44, 44, var(--border-opacity));
}

.focus\\:border-red-900:focus {
  --border-opacity: 1;
  border-color: #742a2a;
  border-color: rgba(116, 42, 42, var(--border-opacity));
}

.focus\\:border-orange-100:focus {
  --border-opacity: 1;
  border-color: #fffaf0;
  border-color: rgba(255, 250, 240, var(--border-opacity));
}

.focus\\:border-orange-200:focus {
  --border-opacity: 1;
  border-color: #feebc8;
  border-color: rgba(254, 235, 200, var(--border-opacity));
}

.focus\\:border-orange-300:focus {
  --border-opacity: 1;
  border-color: #fbd38d;
  border-color: rgba(251, 211, 141, var(--border-opacity));
}

.focus\\:border-orange-400:focus {
  --border-opacity: 1;
  border-color: #f6ad55;
  border-color: rgba(246, 173, 85, var(--border-opacity));
}

.focus\\:border-orange-500:focus {
  --border-opacity: 1;
  border-color: #ed8936;
  border-color: rgba(237, 137, 54, var(--border-opacity));
}

.focus\\:border-orange-600:focus {
  --border-opacity: 1;
  border-color: #dd6b20;
  border-color: rgba(221, 107, 32, var(--border-opacity));
}

.focus\\:border-orange-700:focus {
  --border-opacity: 1;
  border-color: #c05621;
  border-color: rgba(192, 86, 33, var(--border-opacity));
}

.focus\\:border-orange-800:focus {
  --border-opacity: 1;
  border-color: #9c4221;
  border-color: rgba(156, 66, 33, var(--border-opacity));
}

.focus\\:border-orange-900:focus {
  --border-opacity: 1;
  border-color: #7b341e;
  border-color: rgba(123, 52, 30, var(--border-opacity));
}

.focus\\:border-yellow-100:focus {
  --border-opacity: 1;
  border-color: #fffff0;
  border-color: rgba(255, 255, 240, var(--border-opacity));
}

.focus\\:border-yellow-200:focus {
  --border-opacity: 1;
  border-color: #fefcbf;
  border-color: rgba(254, 252, 191, var(--border-opacity));
}

.focus\\:border-yellow-300:focus {
  --border-opacity: 1;
  border-color: #faf089;
  border-color: rgba(250, 240, 137, var(--border-opacity));
}

.focus\\:border-yellow-400:focus {
  --border-opacity: 1;
  border-color: #f6e05e;
  border-color: rgba(246, 224, 94, var(--border-opacity));
}

.focus\\:border-yellow-500:focus {
  --border-opacity: 1;
  border-color: #ecc94b;
  border-color: rgba(236, 201, 75, var(--border-opacity));
}

.focus\\:border-yellow-600:focus {
  --border-opacity: 1;
  border-color: #d69e2e;
  border-color: rgba(214, 158, 46, var(--border-opacity));
}

.focus\\:border-yellow-700:focus {
  --border-opacity: 1;
  border-color: #b7791f;
  border-color: rgba(183, 121, 31, var(--border-opacity));
}

.focus\\:border-yellow-800:focus {
  --border-opacity: 1;
  border-color: #975a16;
  border-color: rgba(151, 90, 22, var(--border-opacity));
}

.focus\\:border-yellow-900:focus {
  --border-opacity: 1;
  border-color: #744210;
  border-color: rgba(116, 66, 16, var(--border-opacity));
}

.focus\\:border-green-100:focus {
  --border-opacity: 1;
  border-color: #f0fff4;
  border-color: rgba(240, 255, 244, var(--border-opacity));
}

.focus\\:border-green-200:focus {
  --border-opacity: 1;
  border-color: #c6f6d5;
  border-color: rgba(198, 246, 213, var(--border-opacity));
}

.focus\\:border-green-300:focus {
  --border-opacity: 1;
  border-color: #9ae6b4;
  border-color: rgba(154, 230, 180, var(--border-opacity));
}

.focus\\:border-green-400:focus {
  --border-opacity: 1;
  border-color: #68d391;
  border-color: rgba(104, 211, 145, var(--border-opacity));
}

.focus\\:border-green-500:focus {
  --border-opacity: 1;
  border-color: #48bb78;
  border-color: rgba(72, 187, 120, var(--border-opacity));
}

.focus\\:border-green-600:focus {
  --border-opacity: 1;
  border-color: #38a169;
  border-color: rgba(56, 161, 105, var(--border-opacity));
}

.focus\\:border-green-700:focus {
  --border-opacity: 1;
  border-color: #2f855a;
  border-color: rgba(47, 133, 90, var(--border-opacity));
}

.focus\\:border-green-800:focus {
  --border-opacity: 1;
  border-color: #276749;
  border-color: rgba(39, 103, 73, var(--border-opacity));
}

.focus\\:border-green-900:focus {
  --border-opacity: 1;
  border-color: #22543d;
  border-color: rgba(34, 84, 61, var(--border-opacity));
}

.focus\\:border-teal-100:focus {
  --border-opacity: 1;
  border-color: #e6fffa;
  border-color: rgba(230, 255, 250, var(--border-opacity));
}

.focus\\:border-teal-200:focus {
  --border-opacity: 1;
  border-color: #b2f5ea;
  border-color: rgba(178, 245, 234, var(--border-opacity));
}

.focus\\:border-teal-300:focus {
  --border-opacity: 1;
  border-color: #81e6d9;
  border-color: rgba(129, 230, 217, var(--border-opacity));
}

.focus\\:border-teal-400:focus {
  --border-opacity: 1;
  border-color: #4fd1c5;
  border-color: rgba(79, 209, 197, var(--border-opacity));
}

.focus\\:border-teal-500:focus {
  --border-opacity: 1;
  border-color: #38b2ac;
  border-color: rgba(56, 178, 172, var(--border-opacity));
}

.focus\\:border-teal-600:focus {
  --border-opacity: 1;
  border-color: #319795;
  border-color: rgba(49, 151, 149, var(--border-opacity));
}

.focus\\:border-teal-700:focus {
  --border-opacity: 1;
  border-color: #2c7a7b;
  border-color: rgba(44, 122, 123, var(--border-opacity));
}

.focus\\:border-teal-800:focus {
  --border-opacity: 1;
  border-color: #285e61;
  border-color: rgba(40, 94, 97, var(--border-opacity));
}

.focus\\:border-teal-900:focus {
  --border-opacity: 1;
  border-color: #234e52;
  border-color: rgba(35, 78, 82, var(--border-opacity));
}

.focus\\:border-blue-100:focus {
  --border-opacity: 1;
  border-color: #ebf8ff;
  border-color: rgba(235, 248, 255, var(--border-opacity));
}

.focus\\:border-blue-200:focus {
  --border-opacity: 1;
  border-color: #bee3f8;
  border-color: rgba(190, 227, 248, var(--border-opacity));
}

.focus\\:border-blue-300:focus {
  --border-opacity: 1;
  border-color: #90cdf4;
  border-color: rgba(144, 205, 244, var(--border-opacity));
}

.focus\\:border-blue-400:focus {
  --border-opacity: 1;
  border-color: #63b3ed;
  border-color: rgba(99, 179, 237, var(--border-opacity));
}

.focus\\:border-blue-500:focus {
  --border-opacity: 1;
  border-color: #4299e1;
  border-color: rgba(66, 153, 225, var(--border-opacity));
}

.focus\\:border-blue-600:focus {
  --border-opacity: 1;
  border-color: #3182ce;
  border-color: rgba(49, 130, 206, var(--border-opacity));
}

.focus\\:border-blue-700:focus {
  --border-opacity: 1;
  border-color: #2b6cb0;
  border-color: rgba(43, 108, 176, var(--border-opacity));
}

.focus\\:border-blue-800:focus {
  --border-opacity: 1;
  border-color: #2c5282;
  border-color: rgba(44, 82, 130, var(--border-opacity));
}

.focus\\:border-blue-900:focus {
  --border-opacity: 1;
  border-color: #2a4365;
  border-color: rgba(42, 67, 101, var(--border-opacity));
}

.focus\\:border-indigo-100:focus {
  --border-opacity: 1;
  border-color: #ebf4ff;
  border-color: rgba(235, 244, 255, var(--border-opacity));
}

.focus\\:border-indigo-200:focus {
  --border-opacity: 1;
  border-color: #c3dafe;
  border-color: rgba(195, 218, 254, var(--border-opacity));
}

.focus\\:border-indigo-300:focus {
  --border-opacity: 1;
  border-color: #a3bffa;
  border-color: rgba(163, 191, 250, var(--border-opacity));
}

.focus\\:border-indigo-400:focus {
  --border-opacity: 1;
  border-color: #7f9cf5;
  border-color: rgba(127, 156, 245, var(--border-opacity));
}

.focus\\:border-indigo-500:focus {
  --border-opacity: 1;
  border-color: #667eea;
  border-color: rgba(102, 126, 234, var(--border-opacity));
}

.focus\\:border-indigo-600:focus {
  --border-opacity: 1;
  border-color: #5a67d8;
  border-color: rgba(90, 103, 216, var(--border-opacity));
}

.focus\\:border-indigo-700:focus {
  --border-opacity: 1;
  border-color: #4c51bf;
  border-color: rgba(76, 81, 191, var(--border-opacity));
}

.focus\\:border-indigo-800:focus {
  --border-opacity: 1;
  border-color: #434190;
  border-color: rgba(67, 65, 144, var(--border-opacity));
}

.focus\\:border-indigo-900:focus {
  --border-opacity: 1;
  border-color: #3c366b;
  border-color: rgba(60, 54, 107, var(--border-opacity));
}

.focus\\:border-purple-100:focus {
  --border-opacity: 1;
  border-color: #faf5ff;
  border-color: rgba(250, 245, 255, var(--border-opacity));
}

.focus\\:border-purple-200:focus {
  --border-opacity: 1;
  border-color: #e9d8fd;
  border-color: rgba(233, 216, 253, var(--border-opacity));
}

.focus\\:border-purple-300:focus {
  --border-opacity: 1;
  border-color: #d6bcfa;
  border-color: rgba(214, 188, 250, var(--border-opacity));
}

.focus\\:border-purple-400:focus {
  --border-opacity: 1;
  border-color: #b794f4;
  border-color: rgba(183, 148, 244, var(--border-opacity));
}

.focus\\:border-purple-500:focus {
  --border-opacity: 1;
  border-color: #9f7aea;
  border-color: rgba(159, 122, 234, var(--border-opacity));
}

.focus\\:border-purple-600:focus {
  --border-opacity: 1;
  border-color: #805ad5;
  border-color: rgba(128, 90, 213, var(--border-opacity));
}

.focus\\:border-purple-700:focus {
  --border-opacity: 1;
  border-color: #6b46c1;
  border-color: rgba(107, 70, 193, var(--border-opacity));
}

.focus\\:border-purple-800:focus {
  --border-opacity: 1;
  border-color: #553c9a;
  border-color: rgba(85, 60, 154, var(--border-opacity));
}

.focus\\:border-purple-900:focus {
  --border-opacity: 1;
  border-color: #44337a;
  border-color: rgba(68, 51, 122, var(--border-opacity));
}

.focus\\:border-pink-100:focus {
  --border-opacity: 1;
  border-color: #fff5f7;
  border-color: rgba(255, 245, 247, var(--border-opacity));
}

.focus\\:border-pink-200:focus {
  --border-opacity: 1;
  border-color: #fed7e2;
  border-color: rgba(254, 215, 226, var(--border-opacity));
}

.focus\\:border-pink-300:focus {
  --border-opacity: 1;
  border-color: #fbb6ce;
  border-color: rgba(251, 182, 206, var(--border-opacity));
}

.focus\\:border-pink-400:focus {
  --border-opacity: 1;
  border-color: #f687b3;
  border-color: rgba(246, 135, 179, var(--border-opacity));
}

.focus\\:border-pink-500:focus {
  --border-opacity: 1;
  border-color: #ed64a6;
  border-color: rgba(237, 100, 166, var(--border-opacity));
}

.focus\\:border-pink-600:focus {
  --border-opacity: 1;
  border-color: #d53f8c;
  border-color: rgba(213, 63, 140, var(--border-opacity));
}

.focus\\:border-pink-700:focus {
  --border-opacity: 1;
  border-color: #b83280;
  border-color: rgba(184, 50, 128, var(--border-opacity));
}

.focus\\:border-pink-800:focus {
  --border-opacity: 1;
  border-color: #97266d;
  border-color: rgba(151, 38, 109, var(--border-opacity));
}

.focus\\:border-pink-900:focus {
  --border-opacity: 1;
  border-color: #702459;
  border-color: rgba(112, 36, 89, var(--border-opacity));
}

.border-opacity-0 {
  --border-opacity: 0;
}

.border-opacity-25 {
  --border-opacity: 0.25;
}

.border-opacity-50 {
  --border-opacity: 0.5;
}

.border-opacity-75 {
  --border-opacity: 0.75;
}

.border-opacity-100 {
  --border-opacity: 1;
}

.hover\\:border-opacity-0:hover {
  --border-opacity: 0;
}

.hover\\:border-opacity-25:hover {
  --border-opacity: 0.25;
}

.hover\\:border-opacity-50:hover {
  --border-opacity: 0.5;
}

.hover\\:border-opacity-75:hover {
  --border-opacity: 0.75;
}

.hover\\:border-opacity-100:hover {
  --border-opacity: 1;
}

.focus\\:border-opacity-0:focus {
  --border-opacity: 0;
}

.focus\\:border-opacity-25:focus {
  --border-opacity: 0.25;
}

.focus\\:border-opacity-50:focus {
  --border-opacity: 0.5;
}

.focus\\:border-opacity-75:focus {
  --border-opacity: 0.75;
}

.focus\\:border-opacity-100:focus {
  --border-opacity: 1;
}

.rounded-none {
  border-radius: 0;
}

.rounded-sm {
  border-radius: 0.125rem;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-xl {
  border-radius: 0.75rem;
}

.rounded-2xl {
  border-radius: 1rem;
}

.rounded-3xl {
  border-radius: 1.5rem;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-t-none {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rounded-r-none {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rounded-b-none {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.rounded-l-none {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rounded-t-sm {
  border-top-left-radius: 0.125rem;
  border-top-right-radius: 0.125rem;
}

.rounded-r-sm {
  border-top-right-radius: 0.125rem;
  border-bottom-right-radius: 0.125rem;
}

.rounded-b-sm {
  border-bottom-right-radius: 0.125rem;
  border-bottom-left-radius: 0.125rem;
}

.rounded-l-sm {
  border-top-left-radius: 0.125rem;
  border-bottom-left-radius: 0.125rem;
}

.rounded-t {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.rounded-r {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.rounded-b {
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.rounded-b-md {
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}

.rounded-r-lg {
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
}

.rounded-b-lg {
  border-bottom-right-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.rounded-l-lg {
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
}

.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.rounded-r-xl {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}

.rounded-b-xl {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.rounded-l-xl {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.rounded-t-2xl {
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}

.rounded-r-2xl {
  border-top-right-radius: 1rem;
  border-bottom-right-radius: 1rem;
}

.rounded-b-2xl {
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.rounded-l-2xl {
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.rounded-t-3xl {
  border-top-left-radius: 1.5rem;
  border-top-right-radius: 1.5rem;
}

.rounded-r-3xl {
  border-top-right-radius: 1.5rem;
  border-bottom-right-radius: 1.5rem;
}

.rounded-b-3xl {
  border-bottom-right-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}

.rounded-l-3xl {
  border-top-left-radius: 1.5rem;
  border-bottom-left-radius: 1.5rem;
}

.rounded-t-full {
  border-top-left-radius: 9999px;
  border-top-right-radius: 9999px;
}

.rounded-r-full {
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}

.rounded-b-full {
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
}

.rounded-l-full {
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}

.rounded-tl-none {
  border-top-left-radius: 0;
}

.rounded-tr-none {
  border-top-right-radius: 0;
}

.rounded-br-none {
  border-bottom-right-radius: 0;
}

.rounded-bl-none {
  border-bottom-left-radius: 0;
}

.rounded-tl-sm {
  border-top-left-radius: 0.125rem;
}

.rounded-tr-sm {
  border-top-right-radius: 0.125rem;
}

.rounded-br-sm {
  border-bottom-right-radius: 0.125rem;
}

.rounded-bl-sm {
  border-bottom-left-radius: 0.125rem;
}

.rounded-tl {
  border-top-left-radius: 0.25rem;
}

.rounded-tr {
  border-top-right-radius: 0.25rem;
}

.rounded-br {
  border-bottom-right-radius: 0.25rem;
}

.rounded-bl {
  border-bottom-left-radius: 0.25rem;
}

.rounded-tl-md {
  border-top-left-radius: 0.375rem;
}

.rounded-tr-md {
  border-top-right-radius: 0.375rem;
}

.rounded-br-md {
  border-bottom-right-radius: 0.375rem;
}

.rounded-bl-md {
  border-bottom-left-radius: 0.375rem;
}

.rounded-tl-lg {
  border-top-left-radius: 0.5rem;
}

.rounded-tr-lg {
  border-top-right-radius: 0.5rem;
}

.rounded-br-lg {
  border-bottom-right-radius: 0.5rem;
}

.rounded-bl-lg {
  border-bottom-left-radius: 0.5rem;
}

.rounded-tl-xl {
  border-top-left-radius: 0.75rem;
}

.rounded-tr-xl {
  border-top-right-radius: 0.75rem;
}

.rounded-br-xl {
  border-bottom-right-radius: 0.75rem;
}

.rounded-bl-xl {
  border-bottom-left-radius: 0.75rem;
}

.rounded-tl-2xl {
  border-top-left-radius: 1rem;
}

.rounded-tr-2xl {
  border-top-right-radius: 1rem;
}

.rounded-br-2xl {
  border-bottom-right-radius: 1rem;
}

.rounded-bl-2xl {
  border-bottom-left-radius: 1rem;
}

.rounded-tl-3xl {
  border-top-left-radius: 1.5rem;
}

.rounded-tr-3xl {
  border-top-right-radius: 1.5rem;
}

.rounded-br-3xl {
  border-bottom-right-radius: 1.5rem;
}

.rounded-bl-3xl {
  border-bottom-left-radius: 1.5rem;
}

.rounded-tl-full {
  border-top-left-radius: 9999px;
}

.rounded-tr-full {
  border-top-right-radius: 9999px;
}

.rounded-br-full {
  border-bottom-right-radius: 9999px;
}

.rounded-bl-full {
  border-bottom-left-radius: 9999px;
}

.border-solid {
  border-style: solid;
}

.border-dashed {
  border-style: dashed;
}

.border-dotted {
  border-style: dotted;
}

.border-double {
  border-style: double;
}

.border-none {
  border-style: none;
}

.border-0 {
  border-width: 0;
}

.border-2 {
  border-width: 2px;
}

.border-4 {
  border-width: 4px;
}

.border-8 {
  border-width: 8px;
}

.border {
  border-width: 1px;
}

.border-t-0 {
  border-top-width: 0;
}

.border-r-0 {
  border-right-width: 0;
}

.border-b-0 {
  border-bottom-width: 0;
}

.border-l-0 {
  border-left-width: 0;
}

.border-t-2 {
  border-top-width: 2px;
}

.border-r-2 {
  border-right-width: 2px;
}

.border-b-2 {
  border-bottom-width: 2px;
}

.border-l-2 {
  border-left-width: 2px;
}

.border-t-4 {
  border-top-width: 4px;
}

.border-r-4 {
  border-right-width: 4px;
}

.border-b-4 {
  border-bottom-width: 4px;
}

.border-l-4 {
  border-left-width: 4px;
}

.border-t-8 {
  border-top-width: 8px;
}

.border-r-8 {
  border-right-width: 8px;
}

.border-b-8 {
  border-bottom-width: 8px;
}

.border-l-8 {
  border-left-width: 8px;
}

.border-t {
  border-top-width: 1px;
}

.border-r {
  border-right-width: 1px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-l {
  border-left-width: 1px;
}

.box-border {
  box-sizing: border-box;
}

.box-content {
  box-sizing: content-box;
}

.cursor-auto {
  cursor: auto;
}

.cursor-default {
  cursor: default;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-wait {
  cursor: wait;
}

.cursor-text {
  cursor: text;
}

.cursor-move {
  cursor: move;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.inline {
  display: inline;
}

.flex {
  display: flex;
}

.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.table-caption {
  display: table-caption;
}

.table-cell {
  display: table-cell;
}

.table-column {
  display: table-column;
}

.table-column-group {
  display: table-column-group;
}

.table-footer-group {
  display: table-footer-group;
}

.table-header-group {
  display: table-header-group;
}

.table-row-group {
  display: table-row-group;
}

.table-row {
  display: table-row;
}

.flow-root {
  display: flow-root;
}

.grid {
  display: grid;
}

.inline-grid {
  display: inline-grid;
}

.contents {
  display: contents;
}

.hidden {
  display: none;
}

.flex-row {
  flex-direction: row;
}

.flex-row-reverse {
  flex-direction: row-reverse;
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse;
}

.flex-no-wrap {
  flex-wrap: nowrap;
}

.place-items-auto {
  place-items: auto;
}

.place-items-start {
  place-items: start;
}

.place-items-end {
  place-items: end;
}

.place-items-center {
  place-items: center;
}

.place-items-stretch {
  place-items: stretch;
}

.place-content-center {
  place-content: center;
}

.place-content-start {
  place-content: start;
}

.place-content-end {
  place-content: end;
}

.place-content-between {
  place-content: space-between;
}

.place-content-around {
  place-content: space-around;
}

.place-content-evenly {
  place-content: space-evenly;
}

.place-content-stretch {
  place-content: stretch;
}

.place-self-auto {
  place-self: auto;
}

.place-self-start {
  place-self: start;
}

.place-self-end {
  place-self: end;
}

.place-self-center {
  place-self: center;
}

.place-self-stretch {
  place-self: stretch;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.items-baseline {
  align-items: baseline;
}

.items-stretch {
  align-items: stretch;
}

.content-center {
  align-content: center;
}

.content-start {
  align-content: flex-start;
}

.content-end {
  align-content: flex-end;
}

.content-between {
  align-content: space-between;
}

.content-around {
  align-content: space-around;
}

.content-evenly {
  align-content: space-evenly;
}

.self-auto {
  align-self: auto;
}

.self-start {
  align-self: flex-start;
}

.self-end {
  align-self: flex-end;
}

.self-center {
  align-self: center;
}

.self-stretch {
  align-self: stretch;
}

.justify-items-auto {
  justify-items: auto;
}

.justify-items-start {
  justify-items: start;
}

.justify-items-end {
  justify-items: end;
}

.justify-items-center {
  justify-items: center;
}

.justify-items-stretch {
  justify-items: stretch;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.justify-around {
  justify-content: space-around;
}

.justify-evenly {
  justify-content: space-evenly;
}

.justify-self-auto {
  justify-self: auto;
}

.justify-self-start {
  justify-self: start;
}

.justify-self-end {
  justify-self: end;
}

.justify-self-center {
  justify-self: center;
}

.justify-self-stretch {
  justify-self: stretch;
}

.flex-1 {
  flex: 1 1;
}

.flex-auto {
  flex: 1 1 auto;
}

.flex-initial {
  flex: 0 1 auto;
}

.flex-none {
  flex: none;
}

.flex-grow-0 {
  flex-grow: 0;
}

.flex-grow {
  flex-grow: 1;
}

.flex-shrink-0 {
  flex-shrink: 0;
}

.flex-shrink {
  flex-shrink: 1;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.order-first {
  order: -9999;
}

.order-last {
  order: 9999;
}

.order-none {
  order: 0;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.float-none {
  float: none;
}

.clearfix:after {
  content: "";
  display: table;
  clear: both;
}

.clear-left {
  clear: left;
}

.clear-right {
  clear: right;
}

.clear-both {
  clear: both;
}

.clear-none {
  clear: none;
}

.font-sans {
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.font-serif {
  font-family: Georgia, Cambria, "Times New Roman", Times, serif;
}

.font-mono {
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.font-hairline {
  font-weight: 100;
}

.font-thin {
  font-weight: 200;
}

.font-light {
  font-weight: 300;
}

.font-normal {
  font-weight: 400;
}

.font-medium {
  font-weight: 500;
}

.font-semibold {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.font-extrabold {
  font-weight: 800;
}

.font-black {
  font-weight: 900;
}

.hover\\:font-hairline:hover {
  font-weight: 100;
}

.hover\\:font-thin:hover {
  font-weight: 200;
}

.hover\\:font-light:hover {
  font-weight: 300;
}

.hover\\:font-normal:hover {
  font-weight: 400;
}

.hover\\:font-medium:hover {
  font-weight: 500;
}

.hover\\:font-semibold:hover {
  font-weight: 600;
}

.hover\\:font-bold:hover {
  font-weight: 700;
}

.hover\\:font-extrabold:hover {
  font-weight: 800;
}

.hover\\:font-black:hover {
  font-weight: 900;
}

.focus\\:font-hairline:focus {
  font-weight: 100;
}

.focus\\:font-thin:focus {
  font-weight: 200;
}

.focus\\:font-light:focus {
  font-weight: 300;
}

.focus\\:font-normal:focus {
  font-weight: 400;
}

.focus\\:font-medium:focus {
  font-weight: 500;
}

.focus\\:font-semibold:focus {
  font-weight: 600;
}

.focus\\:font-bold:focus {
  font-weight: 700;
}

.focus\\:font-extrabold:focus {
  font-weight: 800;
}

.focus\\:font-black:focus {
  font-weight: 900;
}

.h-0 {
  height: 0;
}

.h-1 {
  height: 0.25rem;
}

.h-2 {
  height: 0.5rem;
}

.h-3 {
  height: 0.75rem;
}

.h-4 {
  height: 1rem;
}

.h-5 {
  height: 1.25rem;
}

.h-6 {
  height: 1.5rem;
}

.h-8 {
  height: 2rem;
}

.h-10 {
  height: 2.5rem;
}

.h-12 {
  height: 3rem;
}

.h-16 {
  height: 4rem;
}

.h-20 {
  height: 5rem;
}

.h-24 {
  height: 6rem;
}

.h-32 {
  height: 8rem;
}

.h-40 {
  height: 10rem;
}

.h-48 {
  height: 12rem;
}

.h-56 {
  height: 14rem;
}

.h-64 {
  height: 16rem;
}

.h-auto {
  height: auto;
}

.h-px {
  height: 1px;
}

.h-full {
  height: 100%;
}

.h-screen {
  height: 100vh;
}

.text-15 {
  font-size: 0.9375rem;
}

.text-xs {
  font-size: 0.75rem;
}

.text-sm {
  font-size: 0.875rem;
}

.text-base {
  font-size: 1rem;
}

.text-lg {
  font-size: 1.125rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-1\\.5xl {
  font-size: 1.375rem;
}

.text-2xl {
  font-size: 1.5rem;
}

.text-3xl {
  font-size: 1.875rem;
}

.text-4xl {
  font-size: 2.25rem;
}

.text-5xl {
  font-size: 3rem;
}

.text-6xl {
  font-size: 4rem;
}

.leading-3 {
  line-height: 0.75rem;
}

.leading-4 {
  line-height: 1rem;
}

.leading-5 {
  line-height: 1.25rem;
}

.leading-6 {
  line-height: 1.5rem;
}

.leading-7 {
  line-height: 1.75rem;
}

.leading-8 {
  line-height: 2rem;
}

.leading-9 {
  line-height: 2.25rem;
}

.leading-10 {
  line-height: 2.5rem;
}

.leading-none {
  line-height: 1;
}

.leading-tight {
  line-height: 1.25;
}

.leading-snug {
  line-height: 1.375;
}

.leading-normal {
  line-height: 1.5;
}

.leading-relaxed {
  line-height: 1.625;
}

.leading-loose {
  line-height: 2;
}

.list-inside {
  list-style-position: inside;
}

.list-outside {
  list-style-position: outside;
}

.list-none {
  list-style-type: none;
}

.list-disc {
  list-style-type: disc;
}

.list-decimal {
  list-style-type: decimal;
}

.m-0 {
  margin: 0;
}

.m-1 {
  margin: 0.25rem;
}

.m-2 {
  margin: 0.5rem;
}

.m-3 {
  margin: 0.75rem;
}

.m-4 {
  margin: 1rem;
}

.m-5 {
  margin: 1.25rem;
}

.m-6 {
  margin: 1.5rem;
}

.m-8 {
  margin: 2rem;
}

.m-10 {
  margin: 2.5rem;
}

.m-12 {
  margin: 3rem;
}

.m-16 {
  margin: 4rem;
}

.m-20 {
  margin: 5rem;
}

.m-24 {
  margin: 6rem;
}

.m-32 {
  margin: 8rem;
}

.m-40 {
  margin: 10rem;
}

.m-48 {
  margin: 12rem;
}

.m-56 {
  margin: 14rem;
}

.m-64 {
  margin: 16rem;
}

.m-auto {
  margin: auto;
}

.m-px {
  margin: 1px;
}

.-m-1 {
  margin: -0.25rem;
}

.-m-2 {
  margin: -0.5rem;
}

.-m-3 {
  margin: -0.75rem;
}

.-m-4 {
  margin: -1rem;
}

.-m-5 {
  margin: -1.25rem;
}

.-m-6 {
  margin: -1.5rem;
}

.-m-8 {
  margin: -2rem;
}

.-m-10 {
  margin: -2.5rem;
}

.-m-12 {
  margin: -3rem;
}

.-m-16 {
  margin: -4rem;
}

.-m-20 {
  margin: -5rem;
}

.-m-24 {
  margin: -6rem;
}

.-m-32 {
  margin: -8rem;
}

.-m-40 {
  margin: -10rem;
}

.-m-48 {
  margin: -12rem;
}

.-m-56 {
  margin: -14rem;
}

.-m-64 {
  margin: -16rem;
}

.-m-px {
  margin: -1px;
}

.my-0 {
  margin-top: 0;
  margin-bottom: 0;
}

.mx-0 {
  margin-left: 0;
  margin-right: 0;
}

.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

.mx-5 {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.my-8 {
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.mx-8 {
  margin-left: 2rem;
  margin-right: 2rem;
}

.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.mx-10 {
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}

.my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.mx-12 {
  margin-left: 3rem;
  margin-right: 3rem;
}

.my-16 {
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.mx-16 {
  margin-left: 4rem;
  margin-right: 4rem;
}

.my-20 {
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.mx-20 {
  margin-left: 5rem;
  margin-right: 5rem;
}

.my-24 {
  margin-top: 6rem;
  margin-bottom: 6rem;
}

.mx-24 {
  margin-left: 6rem;
  margin-right: 6rem;
}

.my-32 {
  margin-top: 8rem;
  margin-bottom: 8rem;
}

.mx-32 {
  margin-left: 8rem;
  margin-right: 8rem;
}

.my-40 {
  margin-top: 10rem;
  margin-bottom: 10rem;
}

.mx-40 {
  margin-left: 10rem;
  margin-right: 10rem;
}

.my-48 {
  margin-top: 12rem;
  margin-bottom: 12rem;
}

.mx-48 {
  margin-left: 12rem;
  margin-right: 12rem;
}

.my-56 {
  margin-top: 14rem;
  margin-bottom: 14rem;
}

.mx-56 {
  margin-left: 14rem;
  margin-right: 14rem;
}

.my-64 {
  margin-top: 16rem;
  margin-bottom: 16rem;
}

.mx-64 {
  margin-left: 16rem;
  margin-right: 16rem;
}

.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.my-px {
  margin-top: 1px;
  margin-bottom: 1px;
}

.mx-px {
  margin-left: 1px;
  margin-right: 1px;
}

.-my-1 {
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}

.-mx-1 {
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.-my-2 {
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}

.-mx-2 {
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}

.-my-3 {
  margin-top: -0.75rem;
  margin-bottom: -0.75rem;
}

.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.-my-4 {
  margin-top: -1rem;
  margin-bottom: -1rem;
}

.-mx-4 {
  margin-left: -1rem;
  margin-right: -1rem;
}

.-my-5 {
  margin-top: -1.25rem;
  margin-bottom: -1.25rem;
}

.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}

.-my-6 {
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}

.-mx-6 {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

.-my-8 {
  margin-top: -2rem;
  margin-bottom: -2rem;
}

.-mx-8 {
  margin-left: -2rem;
  margin-right: -2rem;
}

.-my-10 {
  margin-top: -2.5rem;
  margin-bottom: -2.5rem;
}

.-mx-10 {
  margin-left: -2.5rem;
  margin-right: -2.5rem;
}

.-my-12 {
  margin-top: -3rem;
  margin-bottom: -3rem;
}

.-mx-12 {
  margin-left: -3rem;
  margin-right: -3rem;
}

.-my-16 {
  margin-top: -4rem;
  margin-bottom: -4rem;
}

.-mx-16 {
  margin-left: -4rem;
  margin-right: -4rem;
}

.-my-20 {
  margin-top: -5rem;
  margin-bottom: -5rem;
}

.-mx-20 {
  margin-left: -5rem;
  margin-right: -5rem;
}

.-my-24 {
  margin-top: -6rem;
  margin-bottom: -6rem;
}

.-mx-24 {
  margin-left: -6rem;
  margin-right: -6rem;
}

.-my-32 {
  margin-top: -8rem;
  margin-bottom: -8rem;
}

.-mx-32 {
  margin-left: -8rem;
  margin-right: -8rem;
}

.-my-40 {
  margin-top: -10rem;
  margin-bottom: -10rem;
}

.-mx-40 {
  margin-left: -10rem;
  margin-right: -10rem;
}

.-my-48 {
  margin-top: -12rem;
  margin-bottom: -12rem;
}

.-mx-48 {
  margin-left: -12rem;
  margin-right: -12rem;
}

.-my-56 {
  margin-top: -14rem;
  margin-bottom: -14rem;
}

.-mx-56 {
  margin-left: -14rem;
  margin-right: -14rem;
}

.-my-64 {
  margin-top: -16rem;
  margin-bottom: -16rem;
}

.-mx-64 {
  margin-left: -16rem;
  margin-right: -16rem;
}

.-my-px {
  margin-top: -1px;
  margin-bottom: -1px;
}

.-mx-px {
  margin-left: -1px;
  margin-right: -1px;
}

.mt-0 {
  margin-top: 0;
}

.mr-0 {
  margin-right: 0;
}

.mb-0 {
  margin-bottom: 0;
}

.ml-0 {
  margin-left: 0;
}

.mt-1 {
  margin-top: 0.25rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.ml-1 {
  margin-left: 0.25rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.mr-3 {
  margin-right: 0.75rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.ml-3 {
  margin-left: 0.75rem;
}

.mt-4 {
  margin-top: 1rem;
}

.mr-4 {
  margin-right: 1rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.ml-4 {
  margin-left: 1rem;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mr-5 {
  margin-right: 1.25rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.ml-5 {
  margin-left: 1.25rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.mr-6 {
  margin-right: 1.5rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.ml-6 {
  margin-left: 1.5rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mr-8 {
  margin-right: 2rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.ml-8 {
  margin-left: 2rem;
}

.mt-10 {
  margin-top: 2.5rem;
}

.mr-10 {
  margin-right: 2.5rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.ml-10 {
  margin-left: 2.5rem;
}

.mt-12 {
  margin-top: 3rem;
}

.mr-12 {
  margin-right: 3rem;
}

.mb-12 {
  margin-bottom: 3rem;
}

.ml-12 {
  margin-left: 3rem;
}

.mt-16 {
  margin-top: 4rem;
}

.mr-16 {
  margin-right: 4rem;
}

.mb-16 {
  margin-bottom: 4rem;
}

.ml-16 {
  margin-left: 4rem;
}

.mt-20 {
  margin-top: 5rem;
}

.mr-20 {
  margin-right: 5rem;
}

.mb-20 {
  margin-bottom: 5rem;
}

.ml-20 {
  margin-left: 5rem;
}

.mt-24 {
  margin-top: 6rem;
}

.mr-24 {
  margin-right: 6rem;
}

.mb-24 {
  margin-bottom: 6rem;
}

.ml-24 {
  margin-left: 6rem;
}

.mt-32 {
  margin-top: 8rem;
}

.mr-32 {
  margin-right: 8rem;
}

.mb-32 {
  margin-bottom: 8rem;
}

.ml-32 {
  margin-left: 8rem;
}

.mt-40 {
  margin-top: 10rem;
}

.mr-40 {
  margin-right: 10rem;
}

.mb-40 {
  margin-bottom: 10rem;
}

.ml-40 {
  margin-left: 10rem;
}

.mt-48 {
  margin-top: 12rem;
}

.mr-48 {
  margin-right: 12rem;
}

.mb-48 {
  margin-bottom: 12rem;
}

.ml-48 {
  margin-left: 12rem;
}

.mt-56 {
  margin-top: 14rem;
}

.mr-56 {
  margin-right: 14rem;
}

.mb-56 {
  margin-bottom: 14rem;
}

.ml-56 {
  margin-left: 14rem;
}

.mt-64 {
  margin-top: 16rem;
}

.mr-64 {
  margin-right: 16rem;
}

.mb-64 {
  margin-bottom: 16rem;
}

.ml-64 {
  margin-left: 16rem;
}

.mt-auto {
  margin-top: auto;
}

.mr-auto {
  margin-right: auto;
}

.mb-auto {
  margin-bottom: auto;
}

.ml-auto {
  margin-left: auto;
}

.mt-px {
  margin-top: 1px;
}

.mr-px {
  margin-right: 1px;
}

.mb-px {
  margin-bottom: 1px;
}

.ml-px {
  margin-left: 1px;
}

.-mt-1 {
  margin-top: -0.25rem;
}

.-mr-1 {
  margin-right: -0.25rem;
}

.-mb-1 {
  margin-bottom: -0.25rem;
}

.-ml-1 {
  margin-left: -0.25rem;
}

.-mt-2 {
  margin-top: -0.5rem;
}

.-mr-2 {
  margin-right: -0.5rem;
}

.-mb-2 {
  margin-bottom: -0.5rem;
}

.-ml-2 {
  margin-left: -0.5rem;
}

.-mt-3 {
  margin-top: -0.75rem;
}

.-mr-3 {
  margin-right: -0.75rem;
}

.-mb-3 {
  margin-bottom: -0.75rem;
}

.-ml-3 {
  margin-left: -0.75rem;
}

.-mt-4 {
  margin-top: -1rem;
}

.-mr-4 {
  margin-right: -1rem;
}

.-mb-4 {
  margin-bottom: -1rem;
}

.-ml-4 {
  margin-left: -1rem;
}

.-mt-5 {
  margin-top: -1.25rem;
}

.-mr-5 {
  margin-right: -1.25rem;
}

.-mb-5 {
  margin-bottom: -1.25rem;
}

.-ml-5 {
  margin-left: -1.25rem;
}

.-mt-6 {
  margin-top: -1.5rem;
}

.-mr-6 {
  margin-right: -1.5rem;
}

.-mb-6 {
  margin-bottom: -1.5rem;
}

.-ml-6 {
  margin-left: -1.5rem;
}

.-mt-8 {
  margin-top: -2rem;
}

.-mr-8 {
  margin-right: -2rem;
}

.-mb-8 {
  margin-bottom: -2rem;
}

.-ml-8 {
  margin-left: -2rem;
}

.-mt-10 {
  margin-top: -2.5rem;
}

.-mr-10 {
  margin-right: -2.5rem;
}

.-mb-10 {
  margin-bottom: -2.5rem;
}

.-ml-10 {
  margin-left: -2.5rem;
}

.-mt-12 {
  margin-top: -3rem;
}

.-mr-12 {
  margin-right: -3rem;
}

.-mb-12 {
  margin-bottom: -3rem;
}

.-ml-12 {
  margin-left: -3rem;
}

.-mt-16 {
  margin-top: -4rem;
}

.-mr-16 {
  margin-right: -4rem;
}

.-mb-16 {
  margin-bottom: -4rem;
}

.-ml-16 {
  margin-left: -4rem;
}

.-mt-20 {
  margin-top: -5rem;
}

.-mr-20 {
  margin-right: -5rem;
}

.-mb-20 {
  margin-bottom: -5rem;
}

.-ml-20 {
  margin-left: -5rem;
}

.-mt-24 {
  margin-top: -6rem;
}

.-mr-24 {
  margin-right: -6rem;
}

.-mb-24 {
  margin-bottom: -6rem;
}

.-ml-24 {
  margin-left: -6rem;
}

.-mt-32 {
  margin-top: -8rem;
}

.-mr-32 {
  margin-right: -8rem;
}

.-mb-32 {
  margin-bottom: -8rem;
}

.-ml-32 {
  margin-left: -8rem;
}

.-mt-40 {
  margin-top: -10rem;
}

.-mr-40 {
  margin-right: -10rem;
}

.-mb-40 {
  margin-bottom: -10rem;
}

.-ml-40 {
  margin-left: -10rem;
}

.-mt-48 {
  margin-top: -12rem;
}

.-mr-48 {
  margin-right: -12rem;
}

.-mb-48 {
  margin-bottom: -12rem;
}

.-ml-48 {
  margin-left: -12rem;
}

.-mt-56 {
  margin-top: -14rem;
}

.-mr-56 {
  margin-right: -14rem;
}

.-mb-56 {
  margin-bottom: -14rem;
}

.-ml-56 {
  margin-left: -14rem;
}

.-mt-64 {
  margin-top: -16rem;
}

.-mr-64 {
  margin-right: -16rem;
}

.-mb-64 {
  margin-bottom: -16rem;
}

.-ml-64 {
  margin-left: -16rem;
}

.-mt-px {
  margin-top: -1px;
}

.-mr-px {
  margin-right: -1px;
}

.-mb-px {
  margin-bottom: -1px;
}

.-ml-px {
  margin-left: -1px;
}

.max-h-full {
  max-height: 100%;
}

.max-h-screen {
  max-height: 100vh;
}

.max-w-none {
  max-width: none;
}

.max-w-xs {
  max-width: 20rem;
}

.max-w-sm {
  max-width: 24rem;
}

.max-w-md {
  max-width: 28rem;
}

.max-w-lg {
  max-width: 32rem;
}

.max-w-xl {
  max-width: 36rem;
}

.max-w-2xl {
  max-width: 42rem;
}

.max-w-3xl {
  max-width: 48rem;
}

.max-w-4xl {
  max-width: 56rem;
}

.max-w-5xl {
  max-width: 64rem;
}

.max-w-6xl {
  max-width: 72rem;
}

.max-w-full {
  max-width: 100%;
}

.max-w-screen-sm {
  max-width: 640px;
}

.max-w-screen-md {
  max-width: 768px;
}

.max-w-screen-lg {
  max-width: 1024px;
}

.max-w-screen-xl {
  max-width: 1280px;
}

.min-h-0 {
  min-height: 0;
}

.min-h-full {
  min-height: 100%;
}

.min-h-screen {
  min-height: 100vh;
}

.min-w-0 {
  min-width: 0;
}

.min-w-full {
  min-width: 100%;
}

.object-contain {
  object-fit: contain;
}

.object-cover {
  object-fit: cover;
}

.object-fill {
  object-fit: fill;
}

.object-none {
  object-fit: none;
}

.object-scale-down {
  object-fit: scale-down;
}

.object-bottom {
  object-position: bottom;
}

.object-center {
  object-position: center;
}

.object-left {
  object-position: left;
}

.object-left-bottom {
  object-position: left bottom;
}

.object-left-top {
  object-position: left top;
}

.object-right {
  object-position: right;
}

.object-right-bottom {
  object-position: right bottom;
}

.object-right-top {
  object-position: right top;
}

.object-top {
  object-position: top;
}

.opacity-0 {
  opacity: 0;
}

.opacity-25 {
  opacity: 0.25;
}

.opacity-50 {
  opacity: 0.5;
}

.opacity-75 {
  opacity: 0.75;
}

.opacity-100 {
  opacity: 1;
}

.hover\\:opacity-0:hover {
  opacity: 0;
}

.hover\\:opacity-25:hover {
  opacity: 0.25;
}

.hover\\:opacity-50:hover {
  opacity: 0.5;
}

.hover\\:opacity-75:hover {
  opacity: 0.75;
}

.hover\\:opacity-100:hover {
  opacity: 1;
}

.focus\\:opacity-0:focus {
  opacity: 0;
}

.focus\\:opacity-25:focus {
  opacity: 0.25;
}

.focus\\:opacity-50:focus {
  opacity: 0.5;
}

.focus\\:opacity-75:focus {
  opacity: 0.75;
}

.focus\\:opacity-100:focus {
  opacity: 1;
}

.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline-white {
  outline: 2px dotted white;
  outline-offset: 2px;
}

.outline-black {
  outline: 2px dotted black;
  outline-offset: 2px;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-white:focus {
  outline: 2px dotted white;
  outline-offset: 2px;
}

.focus\\:outline-black:focus {
  outline: 2px dotted black;
  outline-offset: 2px;
}

.overflow-auto {
  overflow: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-visible {
  overflow: visible;
}

.overflow-scroll {
  overflow: scroll;
}

.overflow-x-auto {
  overflow-x: auto;
}

.overflow-y-auto {
  overflow-y: auto;
}

.overflow-x-hidden {
  overflow-x: hidden;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

.overflow-x-visible {
  overflow-x: visible;
}

.overflow-y-visible {
  overflow-y: visible;
}

.overflow-x-scroll {
  overflow-x: scroll;
}

.overflow-y-scroll {
  overflow-y: scroll;
}

.scrolling-touch {
  -webkit-overflow-scrolling: touch;
}

.scrolling-auto {
  -webkit-overflow-scrolling: auto;
}

.overscroll-auto {
  overscroll-behavior: auto;
}

.overscroll-contain {
  overscroll-behavior: contain;
}

.overscroll-none {
  overscroll-behavior: none;
}

.overscroll-y-auto {
  overscroll-behavior-y: auto;
}

.overscroll-y-contain {
  overscroll-behavior-y: contain;
}

.overscroll-y-none {
  overscroll-behavior-y: none;
}

.overscroll-x-auto {
  overscroll-behavior-x: auto;
}

.overscroll-x-contain {
  overscroll-behavior-x: contain;
}

.overscroll-x-none {
  overscroll-behavior-x: none;
}

.p-0 {
  padding: 0;
}

.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-3 {
  padding: 0.75rem;
}

.p-4 {
  padding: 1rem;
}

.p-5 {
  padding: 1.25rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-8 {
  padding: 2rem;
}

.p-10 {
  padding: 2.5rem;
}

.p-12 {
  padding: 3rem;
}

.p-16 {
  padding: 4rem;
}

.p-20 {
  padding: 5rem;
}

.p-24 {
  padding: 6rem;
}

.p-32 {
  padding: 8rem;
}

.p-40 {
  padding: 10rem;
}

.p-48 {
  padding: 12rem;
}

.p-56 {
  padding: 14rem;
}

.p-64 {
  padding: 16rem;
}

.p-px {
  padding: 1px;
}

.py-0 {
  padding-top: 0;
  padding-bottom: 0;
}

.px-0 {
  padding-left: 0;
  padding-right: 0;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}

.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.px-16 {
  padding-left: 4rem;
  padding-right: 4rem;
}

.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.px-20 {
  padding-left: 5rem;
  padding-right: 5rem;
}

.py-24 {
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.px-24 {
  padding-left: 6rem;
  padding-right: 6rem;
}

.py-32 {
  padding-top: 8rem;
  padding-bottom: 8rem;
}

.px-32 {
  padding-left: 8rem;
  padding-right: 8rem;
}

.py-40 {
  padding-top: 10rem;
  padding-bottom: 10rem;
}

.px-40 {
  padding-left: 10rem;
  padding-right: 10rem;
}

.py-48 {
  padding-top: 12rem;
  padding-bottom: 12rem;
}

.px-48 {
  padding-left: 12rem;
  padding-right: 12rem;
}

.py-56 {
  padding-top: 14rem;
  padding-bottom: 14rem;
}

.px-56 {
  padding-left: 14rem;
  padding-right: 14rem;
}

.py-64 {
  padding-top: 16rem;
  padding-bottom: 16rem;
}

.px-64 {
  padding-left: 16rem;
  padding-right: 16rem;
}

.py-px {
  padding-top: 1px;
  padding-bottom: 1px;
}

.px-px {
  padding-left: 1px;
  padding-right: 1px;
}

.pt-0 {
  padding-top: 0;
}

.pr-0 {
  padding-right: 0;
}

.pb-0 {
  padding-bottom: 0;
}

.pl-0 {
  padding-left: 0;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pr-1 {
  padding-right: 0.25rem;
}

.pb-1 {
  padding-bottom: 0.25rem;
}

.pl-1 {
  padding-left: 0.25rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pr-2 {
  padding-right: 0.5rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pl-2 {
  padding-left: 0.5rem;
}

.pt-3 {
  padding-top: 0.75rem;
}

.pr-3 {
  padding-right: 0.75rem;
}

.pb-3 {
  padding-bottom: 0.75rem;
}

.pl-3 {
  padding-left: 0.75rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pr-4 {
  padding-right: 1rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pl-4 {
  padding-left: 1rem;
}

.pt-5 {
  padding-top: 1.25rem;
}

.pr-5 {
  padding-right: 1.25rem;
}

.pb-5 {
  padding-bottom: 1.25rem;
}

.pl-5 {
  padding-left: 1.25rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.pr-6 {
  padding-right: 1.5rem;
}

.pb-6 {
  padding-bottom: 1.5rem;
}

.pl-6 {
  padding-left: 1.5rem;
}

.pt-8 {
  padding-top: 2rem;
}

.pr-8 {
  padding-right: 2rem;
}

.pb-8 {
  padding-bottom: 2rem;
}

.pl-8 {
  padding-left: 2rem;
}

.pt-10 {
  padding-top: 2.5rem;
}

.pr-10 {
  padding-right: 2.5rem;
}

.pb-10 {
  padding-bottom: 2.5rem;
}

.pl-10 {
  padding-left: 2.5rem;
}

.pt-12 {
  padding-top: 3rem;
}

.pr-12 {
  padding-right: 3rem;
}

.pb-12 {
  padding-bottom: 3rem;
}

.pl-12 {
  padding-left: 3rem;
}

.pt-16 {
  padding-top: 4rem;
}

.pr-16 {
  padding-right: 4rem;
}

.pb-16 {
  padding-bottom: 4rem;
}

.pl-16 {
  padding-left: 4rem;
}

.pt-20 {
  padding-top: 5rem;
}

.pr-20 {
  padding-right: 5rem;
}

.pb-20 {
  padding-bottom: 5rem;
}

.pl-20 {
  padding-left: 5rem;
}

.pt-24 {
  padding-top: 6rem;
}

.pr-24 {
  padding-right: 6rem;
}

.pb-24 {
  padding-bottom: 6rem;
}

.pl-24 {
  padding-left: 6rem;
}

.pt-32 {
  padding-top: 8rem;
}

.pr-32 {
  padding-right: 8rem;
}

.pb-32 {
  padding-bottom: 8rem;
}

.pl-32 {
  padding-left: 8rem;
}

.pt-40 {
  padding-top: 10rem;
}

.pr-40 {
  padding-right: 10rem;
}

.pb-40 {
  padding-bottom: 10rem;
}

.pl-40 {
  padding-left: 10rem;
}

.pt-48 {
  padding-top: 12rem;
}

.pr-48 {
  padding-right: 12rem;
}

.pb-48 {
  padding-bottom: 12rem;
}

.pl-48 {
  padding-left: 12rem;
}

.pt-56 {
  padding-top: 14rem;
}

.pr-56 {
  padding-right: 14rem;
}

.pb-56 {
  padding-bottom: 14rem;
}

.pl-56 {
  padding-left: 14rem;
}

.pt-64 {
  padding-top: 16rem;
}

.pr-64 {
  padding-right: 16rem;
}

.pb-64 {
  padding-bottom: 16rem;
}

.pl-64 {
  padding-left: 16rem;
}

.pt-px {
  padding-top: 1px;
}

.pr-px {
  padding-right: 1px;
}

.pb-px {
  padding-bottom: 1px;
}

.pl-px {
  padding-left: 1px;
}

.placeholder-transparent::placeholder {
  color: transparent;
}

.placeholder-current::placeholder {
  color: currentColor;
}

.placeholder-black::placeholder {
  --placeholder-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, var(--placeholder-opacity));
}

.placeholder-white::placeholder {
  --placeholder-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, var(--placeholder-opacity));
}

.placeholder-gray-100::placeholder {
  --placeholder-opacity: 1;
  color: #f7fafc;
  color: rgba(247, 250, 252, var(--placeholder-opacity));
}

.placeholder-gray-200::placeholder {
  --placeholder-opacity: 1;
  color: #edf2f7;
  color: rgba(237, 242, 247, var(--placeholder-opacity));
}

.placeholder-gray-300::placeholder {
  --placeholder-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--placeholder-opacity));
}

.placeholder-gray-400::placeholder {
  --placeholder-opacity: 1;
  color: #cbd5e0;
  color: rgba(203, 213, 224, var(--placeholder-opacity));
}

.placeholder-gray-500::placeholder {
  --placeholder-opacity: 1;
  color: #a0aec0;
  color: rgba(160, 174, 192, var(--placeholder-opacity));
}

.placeholder-gray-600::placeholder {
  --placeholder-opacity: 1;
  color: #718096;
  color: rgba(113, 128, 150, var(--placeholder-opacity));
}

.placeholder-gray-700::placeholder {
  --placeholder-opacity: 1;
  color: #4a5568;
  color: rgba(74, 85, 104, var(--placeholder-opacity));
}

.placeholder-gray-800::placeholder {
  --placeholder-opacity: 1;
  color: #2d3748;
  color: rgba(45, 55, 72, var(--placeholder-opacity));
}

.placeholder-gray-900::placeholder {
  --placeholder-opacity: 1;
  color: #1a202c;
  color: rgba(26, 32, 44, var(--placeholder-opacity));
}

.placeholder-red-100::placeholder {
  --placeholder-opacity: 1;
  color: #fff5f5;
  color: rgba(255, 245, 245, var(--placeholder-opacity));
}

.placeholder-red-200::placeholder {
  --placeholder-opacity: 1;
  color: #fed7d7;
  color: rgba(254, 215, 215, var(--placeholder-opacity));
}

.placeholder-red-300::placeholder {
  --placeholder-opacity: 1;
  color: #feb2b2;
  color: rgba(254, 178, 178, var(--placeholder-opacity));
}

.placeholder-red-400::placeholder {
  --placeholder-opacity: 1;
  color: #fc8181;
  color: rgba(252, 129, 129, var(--placeholder-opacity));
}

.placeholder-red-500::placeholder {
  --placeholder-opacity: 1;
  color: #f56565;
  color: rgba(245, 101, 101, var(--placeholder-opacity));
}

.placeholder-red-600::placeholder {
  --placeholder-opacity: 1;
  color: #e53e3e;
  color: rgba(229, 62, 62, var(--placeholder-opacity));
}

.placeholder-red-700::placeholder {
  --placeholder-opacity: 1;
  color: #c53030;
  color: rgba(197, 48, 48, var(--placeholder-opacity));
}

.placeholder-red-800::placeholder {
  --placeholder-opacity: 1;
  color: #9b2c2c;
  color: rgba(155, 44, 44, var(--placeholder-opacity));
}

.placeholder-red-900::placeholder {
  --placeholder-opacity: 1;
  color: #742a2a;
  color: rgba(116, 42, 42, var(--placeholder-opacity));
}

.placeholder-orange-100::placeholder {
  --placeholder-opacity: 1;
  color: #fffaf0;
  color: rgba(255, 250, 240, var(--placeholder-opacity));
}

.placeholder-orange-200::placeholder {
  --placeholder-opacity: 1;
  color: #feebc8;
  color: rgba(254, 235, 200, var(--placeholder-opacity));
}

.placeholder-orange-300::placeholder {
  --placeholder-opacity: 1;
  color: #fbd38d;
  color: rgba(251, 211, 141, var(--placeholder-opacity));
}

.placeholder-orange-400::placeholder {
  --placeholder-opacity: 1;
  color: #f6ad55;
  color: rgba(246, 173, 85, var(--placeholder-opacity));
}

.placeholder-orange-500::placeholder {
  --placeholder-opacity: 1;
  color: #ed8936;
  color: rgba(237, 137, 54, var(--placeholder-opacity));
}

.placeholder-orange-600::placeholder {
  --placeholder-opacity: 1;
  color: #dd6b20;
  color: rgba(221, 107, 32, var(--placeholder-opacity));
}

.placeholder-orange-700::placeholder {
  --placeholder-opacity: 1;
  color: #c05621;
  color: rgba(192, 86, 33, var(--placeholder-opacity));
}

.placeholder-orange-800::placeholder {
  --placeholder-opacity: 1;
  color: #9c4221;
  color: rgba(156, 66, 33, var(--placeholder-opacity));
}

.placeholder-orange-900::placeholder {
  --placeholder-opacity: 1;
  color: #7b341e;
  color: rgba(123, 52, 30, var(--placeholder-opacity));
}

.placeholder-yellow-100::placeholder {
  --placeholder-opacity: 1;
  color: #fffff0;
  color: rgba(255, 255, 240, var(--placeholder-opacity));
}

.placeholder-yellow-200::placeholder {
  --placeholder-opacity: 1;
  color: #fefcbf;
  color: rgba(254, 252, 191, var(--placeholder-opacity));
}

.placeholder-yellow-300::placeholder {
  --placeholder-opacity: 1;
  color: #faf089;
  color: rgba(250, 240, 137, var(--placeholder-opacity));
}

.placeholder-yellow-400::placeholder {
  --placeholder-opacity: 1;
  color: #f6e05e;
  color: rgba(246, 224, 94, var(--placeholder-opacity));
}

.placeholder-yellow-500::placeholder {
  --placeholder-opacity: 1;
  color: #ecc94b;
  color: rgba(236, 201, 75, var(--placeholder-opacity));
}

.placeholder-yellow-600::placeholder {
  --placeholder-opacity: 1;
  color: #d69e2e;
  color: rgba(214, 158, 46, var(--placeholder-opacity));
}

.placeholder-yellow-700::placeholder {
  --placeholder-opacity: 1;
  color: #b7791f;
  color: rgba(183, 121, 31, var(--placeholder-opacity));
}

.placeholder-yellow-800::placeholder {
  --placeholder-opacity: 1;
  color: #975a16;
  color: rgba(151, 90, 22, var(--placeholder-opacity));
}

.placeholder-yellow-900::placeholder {
  --placeholder-opacity: 1;
  color: #744210;
  color: rgba(116, 66, 16, var(--placeholder-opacity));
}

.placeholder-green-100::placeholder {
  --placeholder-opacity: 1;
  color: #f0fff4;
  color: rgba(240, 255, 244, var(--placeholder-opacity));
}

.placeholder-green-200::placeholder {
  --placeholder-opacity: 1;
  color: #c6f6d5;
  color: rgba(198, 246, 213, var(--placeholder-opacity));
}

.placeholder-green-300::placeholder {
  --placeholder-opacity: 1;
  color: #9ae6b4;
  color: rgba(154, 230, 180, var(--placeholder-opacity));
}

.placeholder-green-400::placeholder {
  --placeholder-opacity: 1;
  color: #68d391;
  color: rgba(104, 211, 145, var(--placeholder-opacity));
}

.placeholder-green-500::placeholder {
  --placeholder-opacity: 1;
  color: #48bb78;
  color: rgba(72, 187, 120, var(--placeholder-opacity));
}

.placeholder-green-600::placeholder {
  --placeholder-opacity: 1;
  color: #38a169;
  color: rgba(56, 161, 105, var(--placeholder-opacity));
}

.placeholder-green-700::placeholder {
  --placeholder-opacity: 1;
  color: #2f855a;
  color: rgba(47, 133, 90, var(--placeholder-opacity));
}

.placeholder-green-800::placeholder {
  --placeholder-opacity: 1;
  color: #276749;
  color: rgba(39, 103, 73, var(--placeholder-opacity));
}

.placeholder-green-900::placeholder {
  --placeholder-opacity: 1;
  color: #22543d;
  color: rgba(34, 84, 61, var(--placeholder-opacity));
}

.placeholder-teal-100::placeholder {
  --placeholder-opacity: 1;
  color: #e6fffa;
  color: rgba(230, 255, 250, var(--placeholder-opacity));
}

.placeholder-teal-200::placeholder {
  --placeholder-opacity: 1;
  color: #b2f5ea;
  color: rgba(178, 245, 234, var(--placeholder-opacity));
}

.placeholder-teal-300::placeholder {
  --placeholder-opacity: 1;
  color: #81e6d9;
  color: rgba(129, 230, 217, var(--placeholder-opacity));
}

.placeholder-teal-400::placeholder {
  --placeholder-opacity: 1;
  color: #4fd1c5;
  color: rgba(79, 209, 197, var(--placeholder-opacity));
}

.placeholder-teal-500::placeholder {
  --placeholder-opacity: 1;
  color: #38b2ac;
  color: rgba(56, 178, 172, var(--placeholder-opacity));
}

.placeholder-teal-600::placeholder {
  --placeholder-opacity: 1;
  color: #319795;
  color: rgba(49, 151, 149, var(--placeholder-opacity));
}

.placeholder-teal-700::placeholder {
  --placeholder-opacity: 1;
  color: #2c7a7b;
  color: rgba(44, 122, 123, var(--placeholder-opacity));
}

.placeholder-teal-800::placeholder {
  --placeholder-opacity: 1;
  color: #285e61;
  color: rgba(40, 94, 97, var(--placeholder-opacity));
}

.placeholder-teal-900::placeholder {
  --placeholder-opacity: 1;
  color: #234e52;
  color: rgba(35, 78, 82, var(--placeholder-opacity));
}

.placeholder-blue-100::placeholder {
  --placeholder-opacity: 1;
  color: #ebf8ff;
  color: rgba(235, 248, 255, var(--placeholder-opacity));
}

.placeholder-blue-200::placeholder {
  --placeholder-opacity: 1;
  color: #bee3f8;
  color: rgba(190, 227, 248, var(--placeholder-opacity));
}

.placeholder-blue-300::placeholder {
  --placeholder-opacity: 1;
  color: #90cdf4;
  color: rgba(144, 205, 244, var(--placeholder-opacity));
}

.placeholder-blue-400::placeholder {
  --placeholder-opacity: 1;
  color: #63b3ed;
  color: rgba(99, 179, 237, var(--placeholder-opacity));
}

.placeholder-blue-500::placeholder {
  --placeholder-opacity: 1;
  color: #4299e1;
  color: rgba(66, 153, 225, var(--placeholder-opacity));
}

.placeholder-blue-600::placeholder {
  --placeholder-opacity: 1;
  color: #3182ce;
  color: rgba(49, 130, 206, var(--placeholder-opacity));
}

.placeholder-blue-700::placeholder {
  --placeholder-opacity: 1;
  color: #2b6cb0;
  color: rgba(43, 108, 176, var(--placeholder-opacity));
}

.placeholder-blue-800::placeholder {
  --placeholder-opacity: 1;
  color: #2c5282;
  color: rgba(44, 82, 130, var(--placeholder-opacity));
}

.placeholder-blue-900::placeholder {
  --placeholder-opacity: 1;
  color: #2a4365;
  color: rgba(42, 67, 101, var(--placeholder-opacity));
}

.placeholder-indigo-100::placeholder {
  --placeholder-opacity: 1;
  color: #ebf4ff;
  color: rgba(235, 244, 255, var(--placeholder-opacity));
}

.placeholder-indigo-200::placeholder {
  --placeholder-opacity: 1;
  color: #c3dafe;
  color: rgba(195, 218, 254, var(--placeholder-opacity));
}

.placeholder-indigo-300::placeholder {
  --placeholder-opacity: 1;
  color: #a3bffa;
  color: rgba(163, 191, 250, var(--placeholder-opacity));
}

.placeholder-indigo-400::placeholder {
  --placeholder-opacity: 1;
  color: #7f9cf5;
  color: rgba(127, 156, 245, var(--placeholder-opacity));
}

.placeholder-indigo-500::placeholder {
  --placeholder-opacity: 1;
  color: #667eea;
  color: rgba(102, 126, 234, var(--placeholder-opacity));
}

.placeholder-indigo-600::placeholder {
  --placeholder-opacity: 1;
  color: #5a67d8;
  color: rgba(90, 103, 216, var(--placeholder-opacity));
}

.placeholder-indigo-700::placeholder {
  --placeholder-opacity: 1;
  color: #4c51bf;
  color: rgba(76, 81, 191, var(--placeholder-opacity));
}

.placeholder-indigo-800::placeholder {
  --placeholder-opacity: 1;
  color: #434190;
  color: rgba(67, 65, 144, var(--placeholder-opacity));
}

.placeholder-indigo-900::placeholder {
  --placeholder-opacity: 1;
  color: #3c366b;
  color: rgba(60, 54, 107, var(--placeholder-opacity));
}

.placeholder-purple-100::placeholder {
  --placeholder-opacity: 1;
  color: #faf5ff;
  color: rgba(250, 245, 255, var(--placeholder-opacity));
}

.placeholder-purple-200::placeholder {
  --placeholder-opacity: 1;
  color: #e9d8fd;
  color: rgba(233, 216, 253, var(--placeholder-opacity));
}

.placeholder-purple-300::placeholder {
  --placeholder-opacity: 1;
  color: #d6bcfa;
  color: rgba(214, 188, 250, var(--placeholder-opacity));
}

.placeholder-purple-400::placeholder {
  --placeholder-opacity: 1;
  color: #b794f4;
  color: rgba(183, 148, 244, var(--placeholder-opacity));
}

.placeholder-purple-500::placeholder {
  --placeholder-opacity: 1;
  color: #9f7aea;
  color: rgba(159, 122, 234, var(--placeholder-opacity));
}

.placeholder-purple-600::placeholder {
  --placeholder-opacity: 1;
  color: #805ad5;
  color: rgba(128, 90, 213, var(--placeholder-opacity));
}

.placeholder-purple-700::placeholder {
  --placeholder-opacity: 1;
  color: #6b46c1;
  color: rgba(107, 70, 193, var(--placeholder-opacity));
}

.placeholder-purple-800::placeholder {
  --placeholder-opacity: 1;
  color: #553c9a;
  color: rgba(85, 60, 154, var(--placeholder-opacity));
}

.placeholder-purple-900::placeholder {
  --placeholder-opacity: 1;
  color: #44337a;
  color: rgba(68, 51, 122, var(--placeholder-opacity));
}

.placeholder-pink-100::placeholder {
  --placeholder-opacity: 1;
  color: #fff5f7;
  color: rgba(255, 245, 247, var(--placeholder-opacity));
}

.placeholder-pink-200::placeholder {
  --placeholder-opacity: 1;
  color: #fed7e2;
  color: rgba(254, 215, 226, var(--placeholder-opacity));
}

.placeholder-pink-300::placeholder {
  --placeholder-opacity: 1;
  color: #fbb6ce;
  color: rgba(251, 182, 206, var(--placeholder-opacity));
}

.placeholder-pink-400::placeholder {
  --placeholder-opacity: 1;
  color: #f687b3;
  color: rgba(246, 135, 179, var(--placeholder-opacity));
}

.placeholder-pink-500::placeholder {
  --placeholder-opacity: 1;
  color: #ed64a6;
  color: rgba(237, 100, 166, var(--placeholder-opacity));
}

.placeholder-pink-600::placeholder {
  --placeholder-opacity: 1;
  color: #d53f8c;
  color: rgba(213, 63, 140, var(--placeholder-opacity));
}

.placeholder-pink-700::placeholder {
  --placeholder-opacity: 1;
  color: #b83280;
  color: rgba(184, 50, 128, var(--placeholder-opacity));
}

.placeholder-pink-800::placeholder {
  --placeholder-opacity: 1;
  color: #97266d;
  color: rgba(151, 38, 109, var(--placeholder-opacity));
}

.placeholder-pink-900::placeholder {
  --placeholder-opacity: 1;
  color: #702459;
  color: rgba(112, 36, 89, var(--placeholder-opacity));
}

.focus\\:placeholder-transparent:focus::placeholder {
  color: transparent;
}

.focus\\:placeholder-current:focus::placeholder {
  color: currentColor;
}

.focus\\:placeholder-black:focus::placeholder {
  --placeholder-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, var(--placeholder-opacity));
}

.focus\\:placeholder-white:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f7fafc;
  color: rgba(247, 250, 252, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #edf2f7;
  color: rgba(237, 242, 247, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e2e8f0;
  color: rgba(226, 232, 240, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #cbd5e0;
  color: rgba(203, 213, 224, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #a0aec0;
  color: rgba(160, 174, 192, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #718096;
  color: rgba(113, 128, 150, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #4a5568;
  color: rgba(74, 85, 104, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #2d3748;
  color: rgba(45, 55, 72, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #1a202c;
  color: rgba(26, 32, 44, var(--placeholder-opacity));
}

.focus\\:placeholder-red-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fff5f5;
  color: rgba(255, 245, 245, var(--placeholder-opacity));
}

.focus\\:placeholder-red-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fed7d7;
  color: rgba(254, 215, 215, var(--placeholder-opacity));
}

.focus\\:placeholder-red-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #feb2b2;
  color: rgba(254, 178, 178, var(--placeholder-opacity));
}

.focus\\:placeholder-red-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fc8181;
  color: rgba(252, 129, 129, var(--placeholder-opacity));
}

.focus\\:placeholder-red-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f56565;
  color: rgba(245, 101, 101, var(--placeholder-opacity));
}

.focus\\:placeholder-red-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e53e3e;
  color: rgba(229, 62, 62, var(--placeholder-opacity));
}

.focus\\:placeholder-red-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #c53030;
  color: rgba(197, 48, 48, var(--placeholder-opacity));
}

.focus\\:placeholder-red-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #9b2c2c;
  color: rgba(155, 44, 44, var(--placeholder-opacity));
}

.focus\\:placeholder-red-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #742a2a;
  color: rgba(116, 42, 42, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fffaf0;
  color: rgba(255, 250, 240, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #feebc8;
  color: rgba(254, 235, 200, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fbd38d;
  color: rgba(251, 211, 141, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f6ad55;
  color: rgba(246, 173, 85, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ed8936;
  color: rgba(237, 137, 54, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #dd6b20;
  color: rgba(221, 107, 32, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #c05621;
  color: rgba(192, 86, 33, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #9c4221;
  color: rgba(156, 66, 33, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #7b341e;
  color: rgba(123, 52, 30, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fffff0;
  color: rgba(255, 255, 240, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fefcbf;
  color: rgba(254, 252, 191, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #faf089;
  color: rgba(250, 240, 137, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f6e05e;
  color: rgba(246, 224, 94, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ecc94b;
  color: rgba(236, 201, 75, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #d69e2e;
  color: rgba(214, 158, 46, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #b7791f;
  color: rgba(183, 121, 31, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #975a16;
  color: rgba(151, 90, 22, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #744210;
  color: rgba(116, 66, 16, var(--placeholder-opacity));
}

.focus\\:placeholder-green-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f0fff4;
  color: rgba(240, 255, 244, var(--placeholder-opacity));
}

.focus\\:placeholder-green-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #c6f6d5;
  color: rgba(198, 246, 213, var(--placeholder-opacity));
}

.focus\\:placeholder-green-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #9ae6b4;
  color: rgba(154, 230, 180, var(--placeholder-opacity));
}

.focus\\:placeholder-green-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #68d391;
  color: rgba(104, 211, 145, var(--placeholder-opacity));
}

.focus\\:placeholder-green-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #48bb78;
  color: rgba(72, 187, 120, var(--placeholder-opacity));
}

.focus\\:placeholder-green-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #38a169;
  color: rgba(56, 161, 105, var(--placeholder-opacity));
}

.focus\\:placeholder-green-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #2f855a;
  color: rgba(47, 133, 90, var(--placeholder-opacity));
}

.focus\\:placeholder-green-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #276749;
  color: rgba(39, 103, 73, var(--placeholder-opacity));
}

.focus\\:placeholder-green-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #22543d;
  color: rgba(34, 84, 61, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e6fffa;
  color: rgba(230, 255, 250, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #b2f5ea;
  color: rgba(178, 245, 234, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #81e6d9;
  color: rgba(129, 230, 217, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #4fd1c5;
  color: rgba(79, 209, 197, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #38b2ac;
  color: rgba(56, 178, 172, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #319795;
  color: rgba(49, 151, 149, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #2c7a7b;
  color: rgba(44, 122, 123, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #285e61;
  color: rgba(40, 94, 97, var(--placeholder-opacity));
}

.focus\\:placeholder-teal-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #234e52;
  color: rgba(35, 78, 82, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ebf8ff;
  color: rgba(235, 248, 255, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #bee3f8;
  color: rgba(190, 227, 248, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #90cdf4;
  color: rgba(144, 205, 244, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #63b3ed;
  color: rgba(99, 179, 237, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #4299e1;
  color: rgba(66, 153, 225, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #3182ce;
  color: rgba(49, 130, 206, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #2b6cb0;
  color: rgba(43, 108, 176, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #2c5282;
  color: rgba(44, 82, 130, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #2a4365;
  color: rgba(42, 67, 101, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ebf4ff;
  color: rgba(235, 244, 255, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #c3dafe;
  color: rgba(195, 218, 254, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #a3bffa;
  color: rgba(163, 191, 250, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #7f9cf5;
  color: rgba(127, 156, 245, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #667eea;
  color: rgba(102, 126, 234, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #5a67d8;
  color: rgba(90, 103, 216, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #4c51bf;
  color: rgba(76, 81, 191, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #434190;
  color: rgba(67, 65, 144, var(--placeholder-opacity));
}

.focus\\:placeholder-indigo-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #3c366b;
  color: rgba(60, 54, 107, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #faf5ff;
  color: rgba(250, 245, 255, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #e9d8fd;
  color: rgba(233, 216, 253, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #d6bcfa;
  color: rgba(214, 188, 250, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #b794f4;
  color: rgba(183, 148, 244, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #9f7aea;
  color: rgba(159, 122, 234, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #805ad5;
  color: rgba(128, 90, 213, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #6b46c1;
  color: rgba(107, 70, 193, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #553c9a;
  color: rgba(85, 60, 154, var(--placeholder-opacity));
}

.focus\\:placeholder-purple-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #44337a;
  color: rgba(68, 51, 122, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-100:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fff5f7;
  color: rgba(255, 245, 247, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-200:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fed7e2;
  color: rgba(254, 215, 226, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-300:focus::placeholder {
  --placeholder-opacity: 1;
  color: #fbb6ce;
  color: rgba(251, 182, 206, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-400:focus::placeholder {
  --placeholder-opacity: 1;
  color: #f687b3;
  color: rgba(246, 135, 179, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-500:focus::placeholder {
  --placeholder-opacity: 1;
  color: #ed64a6;
  color: rgba(237, 100, 166, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-600:focus::placeholder {
  --placeholder-opacity: 1;
  color: #d53f8c;
  color: rgba(213, 63, 140, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-700:focus::placeholder {
  --placeholder-opacity: 1;
  color: #b83280;
  color: rgba(184, 50, 128, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-800:focus::placeholder {
  --placeholder-opacity: 1;
  color: #97266d;
  color: rgba(151, 38, 109, var(--placeholder-opacity));
}

.focus\\:placeholder-pink-900:focus::placeholder {
  --placeholder-opacity: 1;
  color: #702459;
  color: rgba(112, 36, 89, var(--placeholder-opacity));
}

.placeholder-opacity-0::placeholder {
  --placeholder-opacity: 0;
}

.placeholder-opacity-25::placeholder {
  --placeholder-opacity: 0.25;
}

.placeholder-opacity-50::placeholder {
  --placeholder-opacity: 0.5;
}

.placeholder-opacity-75::placeholder {
  --placeholder-opacity: 0.75;
}

.placeholder-opacity-100::placeholder {
  --placeholder-opacity: 1;
}

.focus\\:placeholder-opacity-0:focus::placeholder {
  --placeholder-opacity: 0;
}

.focus\\:placeholder-opacity-25:focus::placeholder {
  --placeholder-opacity: 0.25;
}

.focus\\:placeholder-opacity-50:focus::placeholder {
  --placeholder-opacity: 0.5;
}

.focus\\:placeholder-opacity-75:focus::placeholder {
  --placeholder-opacity: 0.75;
}

.focus\\:placeholder-opacity-100:focus::placeholder {
  --placeholder-opacity: 1;
}

.pointer-events-none {
  pointer-events: none;
}

.pointer-events-auto {
  pointer-events: auto;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.sticky {
  position: sticky;
}

.inset-0 {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.inset-auto {
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
}

.inset-y-0 {
  top: 0;
  bottom: 0;
}

.inset-x-0 {
  right: 0;
  left: 0;
}

.inset-y-auto {
  top: auto;
  bottom: auto;
}

.inset-x-auto {
  right: auto;
  left: auto;
}

.top-0 {
  top: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

.left-0 {
  left: 0;
}

.top-auto {
  top: auto;
}

.right-auto {
  right: auto;
}

.bottom-auto {
  bottom: auto;
}

.left-auto {
  left: auto;
}

.resize-none {
  resize: none;
}

.resize-y {
  resize: vertical;
}

.resize-x {
  resize: horizontal;
}

.resize {
  resize: both;
}

.shadow-xs {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}

.shadow-sm {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.shadow {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.shadow-xl {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.shadow-inner {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.shadow-outline {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.shadow-none {
  box-shadow: none;
}

.hover\\:shadow-xs:hover {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}

.hover\\:shadow-sm:hover {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.hover\\:shadow:hover {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.hover\\:shadow-md:hover {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.hover\\:shadow-lg:hover {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.hover\\:shadow-xl:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.hover\\:shadow-2xl:hover {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.hover\\:shadow-inner:hover {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.hover\\:shadow-outline:hover {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.hover\\:shadow-none:hover {
  box-shadow: none;
}

.focus\\:shadow-xs:focus {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
}

.focus\\:shadow-sm:focus {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.focus\\:shadow:focus {
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.focus\\:shadow-md:focus {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.focus\\:shadow-lg:focus {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.focus\\:shadow-xl:focus {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.focus\\:shadow-2xl:focus {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.focus\\:shadow-inner:focus {
  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
}

.focus\\:shadow-outline:focus {
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
}

.focus\\:shadow-none:focus {
  box-shadow: none;
}

.fill-current {
  fill: currentColor;
}

.stroke-current {
  stroke: currentColor;
}

.stroke-0 {
  stroke-width: 0;
}

.stroke-1 {
  stroke-width: 1;
}

.stroke-2 {
  stroke-width: 2;
}

.table-auto {
  table-layout: auto;
}

.table-fixed {
  table-layout: fixed;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-justify {
  text-align: justify;
}

.text-blue {
  --text-opacity: 1;
  color: #2C7FFF;
  color: rgba(44, 127, 255, var(--text-opacity));
}

.text-primaryText {
  --text-opacity: 1;
  color: #0E264B;
  color: rgba(14, 38, 75, var(--text-opacity));
}

.text-red {
  --text-opacity: 1;
  color: #FF2759;
  color: rgba(255, 39, 89, var(--text-opacity));
}

.hover\\:text-blue:hover {
  --text-opacity: 1;
  color: #2C7FFF;
  color: rgba(44, 127, 255, var(--text-opacity));
}

.hover\\:text-primaryText:hover {
  --text-opacity: 1;
  color: #0E264B;
  color: rgba(14, 38, 75, var(--text-opacity));
}

.hover\\:text-red:hover {
  --text-opacity: 1;
  color: #FF2759;
  color: rgba(255, 39, 89, var(--text-opacity));
}

.focus\\:text-blue:focus {
  --text-opacity: 1;
  color: #2C7FFF;
  color: rgba(44, 127, 255, var(--text-opacity));
}

.focus\\:text-primaryText:focus {
  --text-opacity: 1;
  color: #0E264B;
  color: rgba(14, 38, 75, var(--text-opacity));
}

.focus\\:text-red:focus {
  --text-opacity: 1;
  color: #FF2759;
  color: rgba(255, 39, 89, var(--text-opacity));
}

.text-opacity-0 {
  --text-opacity: 0;
}

.text-opacity-25 {
  --text-opacity: 0.25;
}

.text-opacity-50 {
  --text-opacity: 0.5;
}

.text-opacity-75 {
  --text-opacity: 0.75;
}

.text-opacity-100 {
  --text-opacity: 1;
}

.hover\\:text-opacity-0:hover {
  --text-opacity: 0;
}

.hover\\:text-opacity-25:hover {
  --text-opacity: 0.25;
}

.hover\\:text-opacity-50:hover {
  --text-opacity: 0.5;
}

.hover\\:text-opacity-75:hover {
  --text-opacity: 0.75;
}

.hover\\:text-opacity-100:hover {
  --text-opacity: 1;
}

.focus\\:text-opacity-0:focus {
  --text-opacity: 0;
}

.focus\\:text-opacity-25:focus {
  --text-opacity: 0.25;
}

.focus\\:text-opacity-50:focus {
  --text-opacity: 0.5;
}

.focus\\:text-opacity-75:focus {
  --text-opacity: 0.75;
}

.focus\\:text-opacity-100:focus {
  --text-opacity: 1;
}

.italic {
  font-style: italic;
}

.not-italic {
  font-style: normal;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.capitalize {
  text-transform: capitalize;
}

.normal-case {
  text-transform: none;
}

.underline {
  text-decoration: underline;
}

.line-through {
  text-decoration: line-through;
}

.no-underline {
  text-decoration: none;
}

.hover\\:underline:hover {
  text-decoration: underline;
}

.hover\\:line-through:hover {
  text-decoration: line-through;
}

.hover\\:no-underline:hover {
  text-decoration: none;
}

.focus\\:underline:focus {
  text-decoration: underline;
}

.focus\\:line-through:focus {
  text-decoration: line-through;
}

.focus\\:no-underline:focus {
  text-decoration: none;
}

.antialiased {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subpixel-antialiased {
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}

.ordinal, .slashed-zero, .lining-nums, .oldstyle-nums, .proportional-nums, .tabular-nums, .diagonal-fractions, .stacked-fractions {
  --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
  --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
  --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
  --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
  --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
  font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
}

.normal-nums {
  font-variant-numeric: normal;
}

.ordinal {
  --font-variant-numeric-ordinal: ordinal;
}

.slashed-zero {
  --font-variant-numeric-slashed-zero: slashed-zero;
}

.lining-nums {
  --font-variant-numeric-figure: lining-nums;
}

.oldstyle-nums {
  --font-variant-numeric-figure: oldstyle-nums;
}

.proportional-nums {
  --font-variant-numeric-spacing: proportional-nums;
}

.tabular-nums {
  --font-variant-numeric-spacing: tabular-nums;
}

.diagonal-fractions {
  --font-variant-numeric-fraction: diagonal-fractions;
}

.stacked-fractions {
  --font-variant-numeric-fraction: stacked-fractions;
}

.tracking-tighter {
  letter-spacing: -0.05em;
}

.tracking-tight {
  letter-spacing: -0.025em;
}

.tracking-normal {
  letter-spacing: 0;
}

.tracking-wide {
  letter-spacing: 0.025em;
}

.tracking-wider {
  letter-spacing: 0.05em;
}

.tracking-widest {
  letter-spacing: 0.1em;
}

.select-none {
  -webkit-user-select: none;
  user-select: none;
}

.select-text {
  -webkit-user-select: text;
  user-select: text;
}

.select-all {
  -webkit-user-select: all;
  user-select: all;
}

.select-auto {
  -webkit-user-select: auto;
  user-select: auto;
}

.align-baseline {
  vertical-align: baseline;
}

.align-top {
  vertical-align: top;
}

.align-middle {
  vertical-align: middle;
}

.align-bottom {
  vertical-align: bottom;
}

.align-text-top {
  vertical-align: text-top;
}

.align-text-bottom {
  vertical-align: text-bottom;
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.whitespace-normal {
  white-space: normal;
}

.whitespace-no-wrap {
  white-space: nowrap;
}

.whitespace-pre {
  white-space: pre;
}

.whitespace-pre-line {
  white-space: pre-line;
}

.whitespace-pre-wrap {
  white-space: pre-wrap;
}

.break-normal {
  word-wrap: normal;
  overflow-wrap: normal;
  word-break: normal;
}

.break-words {
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.break-all {
  word-break: break-all;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.w-0 {
  width: 0;
}

.w-1 {
  width: 0.25rem;
}

.w-2 {
  width: 0.5rem;
}

.w-3 {
  width: 0.75rem;
}

.w-4 {
  width: 1rem;
}

.w-5 {
  width: 1.25rem;
}

.w-6 {
  width: 1.5rem;
}

.w-8 {
  width: 2rem;
}

.w-10 {
  width: 2.5rem;
}

.w-12 {
  width: 3rem;
}

.w-16 {
  width: 4rem;
}

.w-20 {
  width: 5rem;
}

.w-24 {
  width: 6rem;
}

.w-32 {
  width: 8rem;
}

.w-40 {
  width: 10rem;
}

.w-48 {
  width: 12rem;
}

.w-56 {
  width: 14rem;
}

.w-64 {
  width: 16rem;
}

.w-auto {
  width: auto;
}

.w-px {
  width: 1px;
}

.w-1\\/2 {
  width: 50%;
}

.w-1\\/3 {
  width: 33.333333%;
}

.w-2\\/3 {
  width: 66.666667%;
}

.w-1\\/4 {
  width: 25%;
}

.w-2\\/4 {
  width: 50%;
}

.w-3\\/4 {
  width: 75%;
}

.w-1\\/5 {
  width: 20%;
}

.w-2\\/5 {
  width: 40%;
}

.w-3\\/5 {
  width: 60%;
}

.w-4\\/5 {
  width: 80%;
}

.w-1\\/6 {
  width: 16.666667%;
}

.w-2\\/6 {
  width: 33.333333%;
}

.w-3\\/6 {
  width: 50%;
}

.w-4\\/6 {
  width: 66.666667%;
}

.w-5\\/6 {
  width: 83.333333%;
}

.w-1\\/12 {
  width: 8.333333%;
}

.w-2\\/12 {
  width: 16.666667%;
}

.w-3\\/12 {
  width: 25%;
}

.w-4\\/12 {
  width: 33.333333%;
}

.w-5\\/12 {
  width: 41.666667%;
}

.w-6\\/12 {
  width: 50%;
}

.w-7\\/12 {
  width: 58.333333%;
}

.w-8\\/12 {
  width: 66.666667%;
}

.w-9\\/12 {
  width: 75%;
}

.w-10\\/12 {
  width: 83.333333%;
}

.w-11\\/12 {
  width: 91.666667%;
}

.w-full {
  width: 100%;
}

.w-screen {
  width: 100vw;
}

.z-0 {
  z-index: 0;
}

.z-10 {
  z-index: 10;
}

.z-20 {
  z-index: 20;
}

.z-30 {
  z-index: 30;
}

.z-40 {
  z-index: 40;
}

.z-50 {
  z-index: 50;
}

.z-auto {
  z-index: auto;
}

.gap-0 {
  grid-gap: 0;
  gap: 0;
}

.gap-1 {
  grid-gap: 0.25rem;
  gap: 0.25rem;
}

.gap-2 {
  grid-gap: 0.5rem;
  gap: 0.5rem;
}

.gap-3 {
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.gap-4 {
  grid-gap: 1rem;
  gap: 1rem;
}

.gap-5 {
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.gap-6 {
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.gap-8 {
  grid-gap: 2rem;
  gap: 2rem;
}

.gap-10 {
  grid-gap: 2.5rem;
  gap: 2.5rem;
}

.gap-12 {
  grid-gap: 3rem;
  gap: 3rem;
}

.gap-16 {
  grid-gap: 4rem;
  gap: 4rem;
}

.gap-20 {
  grid-gap: 5rem;
  gap: 5rem;
}

.gap-24 {
  grid-gap: 6rem;
  gap: 6rem;
}

.gap-32 {
  grid-gap: 8rem;
  gap: 8rem;
}

.gap-40 {
  grid-gap: 10rem;
  gap: 10rem;
}

.gap-48 {
  grid-gap: 12rem;
  gap: 12rem;
}

.gap-56 {
  grid-gap: 14rem;
  gap: 14rem;
}

.gap-64 {
  grid-gap: 16rem;
  gap: 16rem;
}

.gap-px {
  grid-gap: 1px;
  gap: 1px;
}

.col-gap-0 {
  grid-column-gap: 0;
  column-gap: 0;
}

.col-gap-1 {
  grid-column-gap: 0.25rem;
  column-gap: 0.25rem;
}

.col-gap-2 {
  grid-column-gap: 0.5rem;
  column-gap: 0.5rem;
}

.col-gap-3 {
  grid-column-gap: 0.75rem;
  column-gap: 0.75rem;
}

.col-gap-4 {
  grid-column-gap: 1rem;
  column-gap: 1rem;
}

.col-gap-5 {
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
}

.col-gap-6 {
  grid-column-gap: 1.5rem;
  column-gap: 1.5rem;
}

.col-gap-8 {
  grid-column-gap: 2rem;
  column-gap: 2rem;
}

.col-gap-10 {
  grid-column-gap: 2.5rem;
  column-gap: 2.5rem;
}

.col-gap-12 {
  grid-column-gap: 3rem;
  column-gap: 3rem;
}

.col-gap-16 {
  grid-column-gap: 4rem;
  column-gap: 4rem;
}

.col-gap-20 {
  grid-column-gap: 5rem;
  column-gap: 5rem;
}

.col-gap-24 {
  grid-column-gap: 6rem;
  column-gap: 6rem;
}

.col-gap-32 {
  grid-column-gap: 8rem;
  column-gap: 8rem;
}

.col-gap-40 {
  grid-column-gap: 10rem;
  column-gap: 10rem;
}

.col-gap-48 {
  grid-column-gap: 12rem;
  column-gap: 12rem;
}

.col-gap-56 {
  grid-column-gap: 14rem;
  column-gap: 14rem;
}

.col-gap-64 {
  grid-column-gap: 16rem;
  column-gap: 16rem;
}

.col-gap-px {
  grid-column-gap: 1px;
  column-gap: 1px;
}

.gap-x-0 {
  grid-column-gap: 0;
  column-gap: 0;
}

.gap-x-1 {
  grid-column-gap: 0.25rem;
  column-gap: 0.25rem;
}

.gap-x-2 {
  grid-column-gap: 0.5rem;
  column-gap: 0.5rem;
}

.gap-x-3 {
  grid-column-gap: 0.75rem;
  column-gap: 0.75rem;
}

.gap-x-4 {
  grid-column-gap: 1rem;
  column-gap: 1rem;
}

.gap-x-5 {
  grid-column-gap: 1.25rem;
  column-gap: 1.25rem;
}

.gap-x-6 {
  grid-column-gap: 1.5rem;
  column-gap: 1.5rem;
}

.gap-x-8 {
  grid-column-gap: 2rem;
  column-gap: 2rem;
}

.gap-x-10 {
  grid-column-gap: 2.5rem;
  column-gap: 2.5rem;
}

.gap-x-12 {
  grid-column-gap: 3rem;
  column-gap: 3rem;
}

.gap-x-16 {
  grid-column-gap: 4rem;
  column-gap: 4rem;
}

.gap-x-20 {
  grid-column-gap: 5rem;
  column-gap: 5rem;
}

.gap-x-24 {
  grid-column-gap: 6rem;
  column-gap: 6rem;
}

.gap-x-32 {
  grid-column-gap: 8rem;
  column-gap: 8rem;
}

.gap-x-40 {
  grid-column-gap: 10rem;
  column-gap: 10rem;
}

.gap-x-48 {
  grid-column-gap: 12rem;
  column-gap: 12rem;
}

.gap-x-56 {
  grid-column-gap: 14rem;
  column-gap: 14rem;
}

.gap-x-64 {
  grid-column-gap: 16rem;
  column-gap: 16rem;
}

.gap-x-px {
  grid-column-gap: 1px;
  column-gap: 1px;
}

.row-gap-0 {
  grid-row-gap: 0;
  row-gap: 0;
}

.row-gap-1 {
  grid-row-gap: 0.25rem;
  row-gap: 0.25rem;
}

.row-gap-2 {
  grid-row-gap: 0.5rem;
  row-gap: 0.5rem;
}

.row-gap-3 {
  grid-row-gap: 0.75rem;
  row-gap: 0.75rem;
}

.row-gap-4 {
  grid-row-gap: 1rem;
  row-gap: 1rem;
}

.row-gap-5 {
  grid-row-gap: 1.25rem;
  row-gap: 1.25rem;
}

.row-gap-6 {
  grid-row-gap: 1.5rem;
  row-gap: 1.5rem;
}

.row-gap-8 {
  grid-row-gap: 2rem;
  row-gap: 2rem;
}

.row-gap-10 {
  grid-row-gap: 2.5rem;
  row-gap: 2.5rem;
}

.row-gap-12 {
  grid-row-gap: 3rem;
  row-gap: 3rem;
}

.row-gap-16 {
  grid-row-gap: 4rem;
  row-gap: 4rem;
}

.row-gap-20 {
  grid-row-gap: 5rem;
  row-gap: 5rem;
}

.row-gap-24 {
  grid-row-gap: 6rem;
  row-gap: 6rem;
}

.row-gap-32 {
  grid-row-gap: 8rem;
  row-gap: 8rem;
}

.row-gap-40 {
  grid-row-gap: 10rem;
  row-gap: 10rem;
}

.row-gap-48 {
  grid-row-gap: 12rem;
  row-gap: 12rem;
}

.row-gap-56 {
  grid-row-gap: 14rem;
  row-gap: 14rem;
}

.row-gap-64 {
  grid-row-gap: 16rem;
  row-gap: 16rem;
}

.row-gap-px {
  grid-row-gap: 1px;
  row-gap: 1px;
}

.gap-y-0 {
  grid-row-gap: 0;
  row-gap: 0;
}

.gap-y-1 {
  grid-row-gap: 0.25rem;
  row-gap: 0.25rem;
}

.gap-y-2 {
  grid-row-gap: 0.5rem;
  row-gap: 0.5rem;
}

.gap-y-3 {
  grid-row-gap: 0.75rem;
  row-gap: 0.75rem;
}

.gap-y-4 {
  grid-row-gap: 1rem;
  row-gap: 1rem;
}

.gap-y-5 {
  grid-row-gap: 1.25rem;
  row-gap: 1.25rem;
}

.gap-y-6 {
  grid-row-gap: 1.5rem;
  row-gap: 1.5rem;
}

.gap-y-8 {
  grid-row-gap: 2rem;
  row-gap: 2rem;
}

.gap-y-10 {
  grid-row-gap: 2.5rem;
  row-gap: 2.5rem;
}

.gap-y-12 {
  grid-row-gap: 3rem;
  row-gap: 3rem;
}

.gap-y-16 {
  grid-row-gap: 4rem;
  row-gap: 4rem;
}

.gap-y-20 {
  grid-row-gap: 5rem;
  row-gap: 5rem;
}

.gap-y-24 {
  grid-row-gap: 6rem;
  row-gap: 6rem;
}

.gap-y-32 {
  grid-row-gap: 8rem;
  row-gap: 8rem;
}

.gap-y-40 {
  grid-row-gap: 10rem;
  row-gap: 10rem;
}

.gap-y-48 {
  grid-row-gap: 12rem;
  row-gap: 12rem;
}

.gap-y-56 {
  grid-row-gap: 14rem;
  row-gap: 14rem;
}

.gap-y-64 {
  grid-row-gap: 16rem;
  row-gap: 16rem;
}

.gap-y-px {
  grid-row-gap: 1px;
  row-gap: 1px;
}

.grid-flow-row {
  grid-auto-flow: row;
}

.grid-flow-col {
  grid-auto-flow: column;
}

.grid-flow-row-dense {
  grid-auto-flow: row dense;
}

.grid-flow-col-dense {
  grid-auto-flow: column dense;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-6 {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

.grid-cols-9 {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

.grid-cols-10 {
  grid-template-columns: repeat(10, minmax(0, 1fr));
}

.grid-cols-11 {
  grid-template-columns: repeat(11, minmax(0, 1fr));
}

.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.grid-cols-none {
  grid-template-columns: none;
}

.auto-cols-auto {
  grid-auto-columns: auto;
}

.auto-cols-min {
  grid-auto-columns: min-content;
}

.auto-cols-max {
  grid-auto-columns: max-content;
}

.auto-cols-fr {
  grid-auto-columns: minmax(0, 1fr);
}

.col-auto {
  grid-column: auto;
}

.col-span-1 {
  grid-column: span 1/span 1;
}

.col-span-2 {
  grid-column: span 2/span 2;
}

.col-span-3 {
  grid-column: span 3/span 3;
}

.col-span-4 {
  grid-column: span 4/span 4;
}

.col-span-5 {
  grid-column: span 5/span 5;
}

.col-span-6 {
  grid-column: span 6/span 6;
}

.col-span-7 {
  grid-column: span 7/span 7;
}

.col-span-8 {
  grid-column: span 8/span 8;
}

.col-span-9 {
  grid-column: span 9/span 9;
}

.col-span-10 {
  grid-column: span 10/span 10;
}

.col-span-11 {
  grid-column: span 11/span 11;
}

.col-span-12 {
  grid-column: span 12/span 12;
}

.col-span-full {
  grid-column: 1/-1;
}

.col-start-1 {
  grid-column-start: 1;
}

.col-start-2 {
  grid-column-start: 2;
}

.col-start-3 {
  grid-column-start: 3;
}

.col-start-4 {
  grid-column-start: 4;
}

.col-start-5 {
  grid-column-start: 5;
}

.col-start-6 {
  grid-column-start: 6;
}

.col-start-7 {
  grid-column-start: 7;
}

.col-start-8 {
  grid-column-start: 8;
}

.col-start-9 {
  grid-column-start: 9;
}

.col-start-10 {
  grid-column-start: 10;
}

.col-start-11 {
  grid-column-start: 11;
}

.col-start-12 {
  grid-column-start: 12;
}

.col-start-13 {
  grid-column-start: 13;
}

.col-start-auto {
  grid-column-start: auto;
}

.col-end-1 {
  grid-column-end: 1;
}

.col-end-2 {
  grid-column-end: 2;
}

.col-end-3 {
  grid-column-end: 3;
}

.col-end-4 {
  grid-column-end: 4;
}

.col-end-5 {
  grid-column-end: 5;
}

.col-end-6 {
  grid-column-end: 6;
}

.col-end-7 {
  grid-column-end: 7;
}

.col-end-8 {
  grid-column-end: 8;
}

.col-end-9 {
  grid-column-end: 9;
}

.col-end-10 {
  grid-column-end: 10;
}

.col-end-11 {
  grid-column-end: 11;
}

.col-end-12 {
  grid-column-end: 12;
}

.col-end-13 {
  grid-column-end: 13;
}

.col-end-auto {
  grid-column-end: auto;
}

.grid-rows-1 {
  grid-template-rows: repeat(1, minmax(0, 1fr));
}

.grid-rows-2 {
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

.grid-rows-3 {
  grid-template-rows: repeat(3, minmax(0, 1fr));
}

.grid-rows-4 {
  grid-template-rows: repeat(4, minmax(0, 1fr));
}

.grid-rows-5 {
  grid-template-rows: repeat(5, minmax(0, 1fr));
}

.grid-rows-6 {
  grid-template-rows: repeat(6, minmax(0, 1fr));
}

.grid-rows-none {
  grid-template-rows: none;
}

.auto-rows-auto {
  grid-auto-rows: auto;
}

.auto-rows-min {
  grid-auto-rows: min-content;
}

.auto-rows-max {
  grid-auto-rows: max-content;
}

.auto-rows-fr {
  grid-auto-rows: minmax(0, 1fr);
}

.row-auto {
  grid-row: auto;
}

.row-span-1 {
  grid-row: span 1/span 1;
}

.row-span-2 {
  grid-row: span 2/span 2;
}

.row-span-3 {
  grid-row: span 3/span 3;
}

.row-span-4 {
  grid-row: span 4/span 4;
}

.row-span-5 {
  grid-row: span 5/span 5;
}

.row-span-6 {
  grid-row: span 6/span 6;
}

.row-span-full {
  grid-row: 1/-1;
}

.row-start-1 {
  grid-row-start: 1;
}

.row-start-2 {
  grid-row-start: 2;
}

.row-start-3 {
  grid-row-start: 3;
}

.row-start-4 {
  grid-row-start: 4;
}

.row-start-5 {
  grid-row-start: 5;
}

.row-start-6 {
  grid-row-start: 6;
}

.row-start-7 {
  grid-row-start: 7;
}

.row-start-auto {
  grid-row-start: auto;
}

.row-end-1 {
  grid-row-end: 1;
}

.row-end-2 {
  grid-row-end: 2;
}

.row-end-3 {
  grid-row-end: 3;
}

.row-end-4 {
  grid-row-end: 4;
}

.row-end-5 {
  grid-row-end: 5;
}

.row-end-6 {
  grid-row-end: 6;
}

.row-end-7 {
  grid-row-end: 7;
}

.row-end-auto {
  grid-row-end: auto;
}

.transform {
  --transform-translate-x: 0;
  --transform-translate-y: 0;
  --transform-rotate: 0;
  --transform-skew-x: 0;
  --transform-skew-y: 0;
  --transform-scale-x: 1;
  --transform-scale-y: 1;
  transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
}

.transform-none {
  transform: none;
}

.origin-center {
  transform-origin: center;
}

.origin-top {
  transform-origin: top;
}

.origin-top-right {
  transform-origin: top right;
}

.origin-right {
  transform-origin: right;
}

.origin-bottom-right {
  transform-origin: bottom right;
}

.origin-bottom {
  transform-origin: bottom;
}

.origin-bottom-left {
  transform-origin: bottom left;
}

.origin-left {
  transform-origin: left;
}

.origin-top-left {
  transform-origin: top left;
}

.scale-0 {
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}

.scale-50 {
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}

.scale-75 {
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}

.scale-90 {
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}

.scale-95 {
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}

.scale-100 {
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}

.scale-105 {
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}

.scale-110 {
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}

.scale-125 {
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}

.scale-150 {
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}

.scale-x-0 {
  --transform-scale-x: 0;
}

.scale-x-50 {
  --transform-scale-x: .5;
}

.scale-x-75 {
  --transform-scale-x: .75;
}

.scale-x-90 {
  --transform-scale-x: .9;
}

.scale-x-95 {
  --transform-scale-x: .95;
}

.scale-x-100 {
  --transform-scale-x: 1;
}

.scale-x-105 {
  --transform-scale-x: 1.05;
}

.scale-x-110 {
  --transform-scale-x: 1.1;
}

.scale-x-125 {
  --transform-scale-x: 1.25;
}

.scale-x-150 {
  --transform-scale-x: 1.5;
}

.scale-y-0 {
  --transform-scale-y: 0;
}

.scale-y-50 {
  --transform-scale-y: .5;
}

.scale-y-75 {
  --transform-scale-y: .75;
}

.scale-y-90 {
  --transform-scale-y: .9;
}

.scale-y-95 {
  --transform-scale-y: .95;
}

.scale-y-100 {
  --transform-scale-y: 1;
}

.scale-y-105 {
  --transform-scale-y: 1.05;
}

.scale-y-110 {
  --transform-scale-y: 1.1;
}

.scale-y-125 {
  --transform-scale-y: 1.25;
}

.scale-y-150 {
  --transform-scale-y: 1.5;
}

.hover\\:scale-0:hover {
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}

.hover\\:scale-50:hover {
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}

.hover\\:scale-75:hover {
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}

.hover\\:scale-90:hover {
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}

.hover\\:scale-95:hover {
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}

.hover\\:scale-100:hover {
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}

.hover\\:scale-105:hover {
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}

.hover\\:scale-110:hover {
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}

.hover\\:scale-125:hover {
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}

.hover\\:scale-150:hover {
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}

.hover\\:scale-x-0:hover {
  --transform-scale-x: 0;
}

.hover\\:scale-x-50:hover {
  --transform-scale-x: .5;
}

.hover\\:scale-x-75:hover {
  --transform-scale-x: .75;
}

.hover\\:scale-x-90:hover {
  --transform-scale-x: .9;
}

.hover\\:scale-x-95:hover {
  --transform-scale-x: .95;
}

.hover\\:scale-x-100:hover {
  --transform-scale-x: 1;
}

.hover\\:scale-x-105:hover {
  --transform-scale-x: 1.05;
}

.hover\\:scale-x-110:hover {
  --transform-scale-x: 1.1;
}

.hover\\:scale-x-125:hover {
  --transform-scale-x: 1.25;
}

.hover\\:scale-x-150:hover {
  --transform-scale-x: 1.5;
}

.hover\\:scale-y-0:hover {
  --transform-scale-y: 0;
}

.hover\\:scale-y-50:hover {
  --transform-scale-y: .5;
}

.hover\\:scale-y-75:hover {
  --transform-scale-y: .75;
}

.hover\\:scale-y-90:hover {
  --transform-scale-y: .9;
}

.hover\\:scale-y-95:hover {
  --transform-scale-y: .95;
}

.hover\\:scale-y-100:hover {
  --transform-scale-y: 1;
}

.hover\\:scale-y-105:hover {
  --transform-scale-y: 1.05;
}

.hover\\:scale-y-110:hover {
  --transform-scale-y: 1.1;
}

.hover\\:scale-y-125:hover {
  --transform-scale-y: 1.25;
}

.hover\\:scale-y-150:hover {
  --transform-scale-y: 1.5;
}

.focus\\:scale-0:focus {
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}

.focus\\:scale-50:focus {
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}

.focus\\:scale-75:focus {
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}

.focus\\:scale-90:focus {
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}

.focus\\:scale-95:focus {
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}

.focus\\:scale-100:focus {
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}

.focus\\:scale-105:focus {
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}

.focus\\:scale-110:focus {
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}

.focus\\:scale-125:focus {
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}

.focus\\:scale-150:focus {
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}

.focus\\:scale-x-0:focus {
  --transform-scale-x: 0;
}

.focus\\:scale-x-50:focus {
  --transform-scale-x: .5;
}

.focus\\:scale-x-75:focus {
  --transform-scale-x: .75;
}

.focus\\:scale-x-90:focus {
  --transform-scale-x: .9;
}

.focus\\:scale-x-95:focus {
  --transform-scale-x: .95;
}

.focus\\:scale-x-100:focus {
  --transform-scale-x: 1;
}

.focus\\:scale-x-105:focus {
  --transform-scale-x: 1.05;
}

.focus\\:scale-x-110:focus {
  --transform-scale-x: 1.1;
}

.focus\\:scale-x-125:focus {
  --transform-scale-x: 1.25;
}

.focus\\:scale-x-150:focus {
  --transform-scale-x: 1.5;
}

.focus\\:scale-y-0:focus {
  --transform-scale-y: 0;
}

.focus\\:scale-y-50:focus {
  --transform-scale-y: .5;
}

.focus\\:scale-y-75:focus {
  --transform-scale-y: .75;
}

.focus\\:scale-y-90:focus {
  --transform-scale-y: .9;
}

.focus\\:scale-y-95:focus {
  --transform-scale-y: .95;
}

.focus\\:scale-y-100:focus {
  --transform-scale-y: 1;
}

.focus\\:scale-y-105:focus {
  --transform-scale-y: 1.05;
}

.focus\\:scale-y-110:focus {
  --transform-scale-y: 1.1;
}

.focus\\:scale-y-125:focus {
  --transform-scale-y: 1.25;
}

.focus\\:scale-y-150:focus {
  --transform-scale-y: 1.5;
}

.rotate-0 {
  --transform-rotate: 0;
}

.rotate-1 {
  --transform-rotate: 1deg;
}

.rotate-2 {
  --transform-rotate: 2deg;
}

.rotate-3 {
  --transform-rotate: 3deg;
}

.rotate-6 {
  --transform-rotate: 6deg;
}

.rotate-12 {
  --transform-rotate: 12deg;
}

.rotate-45 {
  --transform-rotate: 45deg;
}

.rotate-90 {
  --transform-rotate: 90deg;
}

.rotate-180 {
  --transform-rotate: 180deg;
}

.-rotate-180 {
  --transform-rotate: -180deg;
}

.-rotate-90 {
  --transform-rotate: -90deg;
}

.-rotate-45 {
  --transform-rotate: -45deg;
}

.-rotate-12 {
  --transform-rotate: -12deg;
}

.-rotate-6 {
  --transform-rotate: -6deg;
}

.-rotate-3 {
  --transform-rotate: -3deg;
}

.-rotate-2 {
  --transform-rotate: -2deg;
}

.-rotate-1 {
  --transform-rotate: -1deg;
}

.hover\\:rotate-0:hover {
  --transform-rotate: 0;
}

.hover\\:rotate-1:hover {
  --transform-rotate: 1deg;
}

.hover\\:rotate-2:hover {
  --transform-rotate: 2deg;
}

.hover\\:rotate-3:hover {
  --transform-rotate: 3deg;
}

.hover\\:rotate-6:hover {
  --transform-rotate: 6deg;
}

.hover\\:rotate-12:hover {
  --transform-rotate: 12deg;
}

.hover\\:rotate-45:hover {
  --transform-rotate: 45deg;
}

.hover\\:rotate-90:hover {
  --transform-rotate: 90deg;
}

.hover\\:rotate-180:hover {
  --transform-rotate: 180deg;
}

.hover\\:-rotate-180:hover {
  --transform-rotate: -180deg;
}

.hover\\:-rotate-90:hover {
  --transform-rotate: -90deg;
}

.hover\\:-rotate-45:hover {
  --transform-rotate: -45deg;
}

.hover\\:-rotate-12:hover {
  --transform-rotate: -12deg;
}

.hover\\:-rotate-6:hover {
  --transform-rotate: -6deg;
}

.hover\\:-rotate-3:hover {
  --transform-rotate: -3deg;
}

.hover\\:-rotate-2:hover {
  --transform-rotate: -2deg;
}

.hover\\:-rotate-1:hover {
  --transform-rotate: -1deg;
}

.focus\\:rotate-0:focus {
  --transform-rotate: 0;
}

.focus\\:rotate-1:focus {
  --transform-rotate: 1deg;
}

.focus\\:rotate-2:focus {
  --transform-rotate: 2deg;
}

.focus\\:rotate-3:focus {
  --transform-rotate: 3deg;
}

.focus\\:rotate-6:focus {
  --transform-rotate: 6deg;
}

.focus\\:rotate-12:focus {
  --transform-rotate: 12deg;
}

.focus\\:rotate-45:focus {
  --transform-rotate: 45deg;
}

.focus\\:rotate-90:focus {
  --transform-rotate: 90deg;
}

.focus\\:rotate-180:focus {
  --transform-rotate: 180deg;
}

.focus\\:-rotate-180:focus {
  --transform-rotate: -180deg;
}

.focus\\:-rotate-90:focus {
  --transform-rotate: -90deg;
}

.focus\\:-rotate-45:focus {
  --transform-rotate: -45deg;
}

.focus\\:-rotate-12:focus {
  --transform-rotate: -12deg;
}

.focus\\:-rotate-6:focus {
  --transform-rotate: -6deg;
}

.focus\\:-rotate-3:focus {
  --transform-rotate: -3deg;
}

.focus\\:-rotate-2:focus {
  --transform-rotate: -2deg;
}

.focus\\:-rotate-1:focus {
  --transform-rotate: -1deg;
}

.translate-x-0 {
  --transform-translate-x: 0;
}

.translate-x-1 {
  --transform-translate-x: 0.25rem;
}

.translate-x-2 {
  --transform-translate-x: 0.5rem;
}

.translate-x-3 {
  --transform-translate-x: 0.75rem;
}

.translate-x-4 {
  --transform-translate-x: 1rem;
}

.translate-x-5 {
  --transform-translate-x: 1.25rem;
}

.translate-x-6 {
  --transform-translate-x: 1.5rem;
}

.translate-x-8 {
  --transform-translate-x: 2rem;
}

.translate-x-10 {
  --transform-translate-x: 2.5rem;
}

.translate-x-12 {
  --transform-translate-x: 3rem;
}

.translate-x-16 {
  --transform-translate-x: 4rem;
}

.translate-x-20 {
  --transform-translate-x: 5rem;
}

.translate-x-24 {
  --transform-translate-x: 6rem;
}

.translate-x-32 {
  --transform-translate-x: 8rem;
}

.translate-x-40 {
  --transform-translate-x: 10rem;
}

.translate-x-48 {
  --transform-translate-x: 12rem;
}

.translate-x-56 {
  --transform-translate-x: 14rem;
}

.translate-x-64 {
  --transform-translate-x: 16rem;
}

.translate-x-px {
  --transform-translate-x: 1px;
}

.-translate-x-1 {
  --transform-translate-x: -0.25rem;
}

.-translate-x-2 {
  --transform-translate-x: -0.5rem;
}

.-translate-x-3 {
  --transform-translate-x: -0.75rem;
}

.-translate-x-4 {
  --transform-translate-x: -1rem;
}

.-translate-x-5 {
  --transform-translate-x: -1.25rem;
}

.-translate-x-6 {
  --transform-translate-x: -1.5rem;
}

.-translate-x-8 {
  --transform-translate-x: -2rem;
}

.-translate-x-10 {
  --transform-translate-x: -2.5rem;
}

.-translate-x-12 {
  --transform-translate-x: -3rem;
}

.-translate-x-16 {
  --transform-translate-x: -4rem;
}

.-translate-x-20 {
  --transform-translate-x: -5rem;
}

.-translate-x-24 {
  --transform-translate-x: -6rem;
}

.-translate-x-32 {
  --transform-translate-x: -8rem;
}

.-translate-x-40 {
  --transform-translate-x: -10rem;
}

.-translate-x-48 {
  --transform-translate-x: -12rem;
}

.-translate-x-56 {
  --transform-translate-x: -14rem;
}

.-translate-x-64 {
  --transform-translate-x: -16rem;
}

.-translate-x-px {
  --transform-translate-x: -1px;
}

.-translate-x-full {
  --transform-translate-x: -100%;
}

.-translate-x-1\\/2 {
  --transform-translate-x: -50%;
}

.translate-x-1\\/2 {
  --transform-translate-x: 50%;
}

.translate-x-full {
  --transform-translate-x: 100%;
}

.translate-y-0 {
  --transform-translate-y: 0;
}

.translate-y-1 {
  --transform-translate-y: 0.25rem;
}

.translate-y-2 {
  --transform-translate-y: 0.5rem;
}

.translate-y-3 {
  --transform-translate-y: 0.75rem;
}

.translate-y-4 {
  --transform-translate-y: 1rem;
}

.translate-y-5 {
  --transform-translate-y: 1.25rem;
}

.translate-y-6 {
  --transform-translate-y: 1.5rem;
}

.translate-y-8 {
  --transform-translate-y: 2rem;
}

.translate-y-10 {
  --transform-translate-y: 2.5rem;
}

.translate-y-12 {
  --transform-translate-y: 3rem;
}

.translate-y-16 {
  --transform-translate-y: 4rem;
}

.translate-y-20 {
  --transform-translate-y: 5rem;
}

.translate-y-24 {
  --transform-translate-y: 6rem;
}

.translate-y-32 {
  --transform-translate-y: 8rem;
}

.translate-y-40 {
  --transform-translate-y: 10rem;
}

.translate-y-48 {
  --transform-translate-y: 12rem;
}

.translate-y-56 {
  --transform-translate-y: 14rem;
}

.translate-y-64 {
  --transform-translate-y: 16rem;
}

.translate-y-px {
  --transform-translate-y: 1px;
}

.-translate-y-1 {
  --transform-translate-y: -0.25rem;
}

.-translate-y-2 {
  --transform-translate-y: -0.5rem;
}

.-translate-y-3 {
  --transform-translate-y: -0.75rem;
}

.-translate-y-4 {
  --transform-translate-y: -1rem;
}

.-translate-y-5 {
  --transform-translate-y: -1.25rem;
}

.-translate-y-6 {
  --transform-translate-y: -1.5rem;
}

.-translate-y-8 {
  --transform-translate-y: -2rem;
}

.-translate-y-10 {
  --transform-translate-y: -2.5rem;
}

.-translate-y-12 {
  --transform-translate-y: -3rem;
}

.-translate-y-16 {
  --transform-translate-y: -4rem;
}

.-translate-y-20 {
  --transform-translate-y: -5rem;
}

.-translate-y-24 {
  --transform-translate-y: -6rem;
}

.-translate-y-32 {
  --transform-translate-y: -8rem;
}

.-translate-y-40 {
  --transform-translate-y: -10rem;
}

.-translate-y-48 {
  --transform-translate-y: -12rem;
}

.-translate-y-56 {
  --transform-translate-y: -14rem;
}

.-translate-y-64 {
  --transform-translate-y: -16rem;
}

.-translate-y-px {
  --transform-translate-y: -1px;
}

.-translate-y-full {
  --transform-translate-y: -100%;
}

.-translate-y-1\\/2 {
  --transform-translate-y: -50%;
}

.translate-y-1\\/2 {
  --transform-translate-y: 50%;
}

.translate-y-full {
  --transform-translate-y: 100%;
}

.hover\\:translate-x-0:hover {
  --transform-translate-x: 0;
}

.hover\\:translate-x-1:hover {
  --transform-translate-x: 0.25rem;
}

.hover\\:translate-x-2:hover {
  --transform-translate-x: 0.5rem;
}

.hover\\:translate-x-3:hover {
  --transform-translate-x: 0.75rem;
}

.hover\\:translate-x-4:hover {
  --transform-translate-x: 1rem;
}

.hover\\:translate-x-5:hover {
  --transform-translate-x: 1.25rem;
}

.hover\\:translate-x-6:hover {
  --transform-translate-x: 1.5rem;
}

.hover\\:translate-x-8:hover {
  --transform-translate-x: 2rem;
}

.hover\\:translate-x-10:hover {
  --transform-translate-x: 2.5rem;
}

.hover\\:translate-x-12:hover {
  --transform-translate-x: 3rem;
}

.hover\\:translate-x-16:hover {
  --transform-translate-x: 4rem;
}

.hover\\:translate-x-20:hover {
  --transform-translate-x: 5rem;
}

.hover\\:translate-x-24:hover {
  --transform-translate-x: 6rem;
}

.hover\\:translate-x-32:hover {
  --transform-translate-x: 8rem;
}

.hover\\:translate-x-40:hover {
  --transform-translate-x: 10rem;
}

.hover\\:translate-x-48:hover {
  --transform-translate-x: 12rem;
}

.hover\\:translate-x-56:hover {
  --transform-translate-x: 14rem;
}

.hover\\:translate-x-64:hover {
  --transform-translate-x: 16rem;
}

.hover\\:translate-x-px:hover {
  --transform-translate-x: 1px;
}

.hover\\:-translate-x-1:hover {
  --transform-translate-x: -0.25rem;
}

.hover\\:-translate-x-2:hover {
  --transform-translate-x: -0.5rem;
}

.hover\\:-translate-x-3:hover {
  --transform-translate-x: -0.75rem;
}

.hover\\:-translate-x-4:hover {
  --transform-translate-x: -1rem;
}

.hover\\:-translate-x-5:hover {
  --transform-translate-x: -1.25rem;
}

.hover\\:-translate-x-6:hover {
  --transform-translate-x: -1.5rem;
}

.hover\\:-translate-x-8:hover {
  --transform-translate-x: -2rem;
}

.hover\\:-translate-x-10:hover {
  --transform-translate-x: -2.5rem;
}

.hover\\:-translate-x-12:hover {
  --transform-translate-x: -3rem;
}

.hover\\:-translate-x-16:hover {
  --transform-translate-x: -4rem;
}

.hover\\:-translate-x-20:hover {
  --transform-translate-x: -5rem;
}

.hover\\:-translate-x-24:hover {
  --transform-translate-x: -6rem;
}

.hover\\:-translate-x-32:hover {
  --transform-translate-x: -8rem;
}

.hover\\:-translate-x-40:hover {
  --transform-translate-x: -10rem;
}

.hover\\:-translate-x-48:hover {
  --transform-translate-x: -12rem;
}

.hover\\:-translate-x-56:hover {
  --transform-translate-x: -14rem;
}

.hover\\:-translate-x-64:hover {
  --transform-translate-x: -16rem;
}

.hover\\:-translate-x-px:hover {
  --transform-translate-x: -1px;
}

.hover\\:-translate-x-full:hover {
  --transform-translate-x: -100%;
}

.hover\\:-translate-x-1\\/2:hover {
  --transform-translate-x: -50%;
}

.hover\\:translate-x-1\\/2:hover {
  --transform-translate-x: 50%;
}

.hover\\:translate-x-full:hover {
  --transform-translate-x: 100%;
}

.hover\\:translate-y-0:hover {
  --transform-translate-y: 0;
}

.hover\\:translate-y-1:hover {
  --transform-translate-y: 0.25rem;
}

.hover\\:translate-y-2:hover {
  --transform-translate-y: 0.5rem;
}

.hover\\:translate-y-3:hover {
  --transform-translate-y: 0.75rem;
}

.hover\\:translate-y-4:hover {
  --transform-translate-y: 1rem;
}

.hover\\:translate-y-5:hover {
  --transform-translate-y: 1.25rem;
}

.hover\\:translate-y-6:hover {
  --transform-translate-y: 1.5rem;
}

.hover\\:translate-y-8:hover {
  --transform-translate-y: 2rem;
}

.hover\\:translate-y-10:hover {
  --transform-translate-y: 2.5rem;
}

.hover\\:translate-y-12:hover {
  --transform-translate-y: 3rem;
}

.hover\\:translate-y-16:hover {
  --transform-translate-y: 4rem;
}

.hover\\:translate-y-20:hover {
  --transform-translate-y: 5rem;
}

.hover\\:translate-y-24:hover {
  --transform-translate-y: 6rem;
}

.hover\\:translate-y-32:hover {
  --transform-translate-y: 8rem;
}

.hover\\:translate-y-40:hover {
  --transform-translate-y: 10rem;
}

.hover\\:translate-y-48:hover {
  --transform-translate-y: 12rem;
}

.hover\\:translate-y-56:hover {
  --transform-translate-y: 14rem;
}

.hover\\:translate-y-64:hover {
  --transform-translate-y: 16rem;
}

.hover\\:translate-y-px:hover {
  --transform-translate-y: 1px;
}

.hover\\:-translate-y-1:hover {
  --transform-translate-y: -0.25rem;
}

.hover\\:-translate-y-2:hover {
  --transform-translate-y: -0.5rem;
}

.hover\\:-translate-y-3:hover {
  --transform-translate-y: -0.75rem;
}

.hover\\:-translate-y-4:hover {
  --transform-translate-y: -1rem;
}

.hover\\:-translate-y-5:hover {
  --transform-translate-y: -1.25rem;
}

.hover\\:-translate-y-6:hover {
  --transform-translate-y: -1.5rem;
}

.hover\\:-translate-y-8:hover {
  --transform-translate-y: -2rem;
}

.hover\\:-translate-y-10:hover {
  --transform-translate-y: -2.5rem;
}

.hover\\:-translate-y-12:hover {
  --transform-translate-y: -3rem;
}

.hover\\:-translate-y-16:hover {
  --transform-translate-y: -4rem;
}

.hover\\:-translate-y-20:hover {
  --transform-translate-y: -5rem;
}

.hover\\:-translate-y-24:hover {
  --transform-translate-y: -6rem;
}

.hover\\:-translate-y-32:hover {
  --transform-translate-y: -8rem;
}

.hover\\:-translate-y-40:hover {
  --transform-translate-y: -10rem;
}

.hover\\:-translate-y-48:hover {
  --transform-translate-y: -12rem;
}

.hover\\:-translate-y-56:hover {
  --transform-translate-y: -14rem;
}

.hover\\:-translate-y-64:hover {
  --transform-translate-y: -16rem;
}

.hover\\:-translate-y-px:hover {
  --transform-translate-y: -1px;
}

.hover\\:-translate-y-full:hover {
  --transform-translate-y: -100%;
}

.hover\\:-translate-y-1\\/2:hover {
  --transform-translate-y: -50%;
}

.hover\\:translate-y-1\\/2:hover {
  --transform-translate-y: 50%;
}

.hover\\:translate-y-full:hover {
  --transform-translate-y: 100%;
}

.focus\\:translate-x-0:focus {
  --transform-translate-x: 0;
}

.focus\\:translate-x-1:focus {
  --transform-translate-x: 0.25rem;
}

.focus\\:translate-x-2:focus {
  --transform-translate-x: 0.5rem;
}

.focus\\:translate-x-3:focus {
  --transform-translate-x: 0.75rem;
}

.focus\\:translate-x-4:focus {
  --transform-translate-x: 1rem;
}

.focus\\:translate-x-5:focus {
  --transform-translate-x: 1.25rem;
}

.focus\\:translate-x-6:focus {
  --transform-translate-x: 1.5rem;
}

.focus\\:translate-x-8:focus {
  --transform-translate-x: 2rem;
}

.focus\\:translate-x-10:focus {
  --transform-translate-x: 2.5rem;
}

.focus\\:translate-x-12:focus {
  --transform-translate-x: 3rem;
}

.focus\\:translate-x-16:focus {
  --transform-translate-x: 4rem;
}

.focus\\:translate-x-20:focus {
  --transform-translate-x: 5rem;
}

.focus\\:translate-x-24:focus {
  --transform-translate-x: 6rem;
}

.focus\\:translate-x-32:focus {
  --transform-translate-x: 8rem;
}

.focus\\:translate-x-40:focus {
  --transform-translate-x: 10rem;
}

.focus\\:translate-x-48:focus {
  --transform-translate-x: 12rem;
}

.focus\\:translate-x-56:focus {
  --transform-translate-x: 14rem;
}

.focus\\:translate-x-64:focus {
  --transform-translate-x: 16rem;
}

.focus\\:translate-x-px:focus {
  --transform-translate-x: 1px;
}

.focus\\:-translate-x-1:focus {
  --transform-translate-x: -0.25rem;
}

.focus\\:-translate-x-2:focus {
  --transform-translate-x: -0.5rem;
}

.focus\\:-translate-x-3:focus {
  --transform-translate-x: -0.75rem;
}

.focus\\:-translate-x-4:focus {
  --transform-translate-x: -1rem;
}

.focus\\:-translate-x-5:focus {
  --transform-translate-x: -1.25rem;
}

.focus\\:-translate-x-6:focus {
  --transform-translate-x: -1.5rem;
}

.focus\\:-translate-x-8:focus {
  --transform-translate-x: -2rem;
}

.focus\\:-translate-x-10:focus {
  --transform-translate-x: -2.5rem;
}

.focus\\:-translate-x-12:focus {
  --transform-translate-x: -3rem;
}

.focus\\:-translate-x-16:focus {
  --transform-translate-x: -4rem;
}

.focus\\:-translate-x-20:focus {
  --transform-translate-x: -5rem;
}

.focus\\:-translate-x-24:focus {
  --transform-translate-x: -6rem;
}

.focus\\:-translate-x-32:focus {
  --transform-translate-x: -8rem;
}

.focus\\:-translate-x-40:focus {
  --transform-translate-x: -10rem;
}

.focus\\:-translate-x-48:focus {
  --transform-translate-x: -12rem;
}

.focus\\:-translate-x-56:focus {
  --transform-translate-x: -14rem;
}

.focus\\:-translate-x-64:focus {
  --transform-translate-x: -16rem;
}

.focus\\:-translate-x-px:focus {
  --transform-translate-x: -1px;
}

.focus\\:-translate-x-full:focus {
  --transform-translate-x: -100%;
}

.focus\\:-translate-x-1\\/2:focus {
  --transform-translate-x: -50%;
}

.focus\\:translate-x-1\\/2:focus {
  --transform-translate-x: 50%;
}

.focus\\:translate-x-full:focus {
  --transform-translate-x: 100%;
}

.focus\\:translate-y-0:focus {
  --transform-translate-y: 0;
}

.focus\\:translate-y-1:focus {
  --transform-translate-y: 0.25rem;
}

.focus\\:translate-y-2:focus {
  --transform-translate-y: 0.5rem;
}

.focus\\:translate-y-3:focus {
  --transform-translate-y: 0.75rem;
}

.focus\\:translate-y-4:focus {
  --transform-translate-y: 1rem;
}

.focus\\:translate-y-5:focus {
  --transform-translate-y: 1.25rem;
}

.focus\\:translate-y-6:focus {
  --transform-translate-y: 1.5rem;
}

.focus\\:translate-y-8:focus {
  --transform-translate-y: 2rem;
}

.focus\\:translate-y-10:focus {
  --transform-translate-y: 2.5rem;
}

.focus\\:translate-y-12:focus {
  --transform-translate-y: 3rem;
}

.focus\\:translate-y-16:focus {
  --transform-translate-y: 4rem;
}

.focus\\:translate-y-20:focus {
  --transform-translate-y: 5rem;
}

.focus\\:translate-y-24:focus {
  --transform-translate-y: 6rem;
}

.focus\\:translate-y-32:focus {
  --transform-translate-y: 8rem;
}

.focus\\:translate-y-40:focus {
  --transform-translate-y: 10rem;
}

.focus\\:translate-y-48:focus {
  --transform-translate-y: 12rem;
}

.focus\\:translate-y-56:focus {
  --transform-translate-y: 14rem;
}

.focus\\:translate-y-64:focus {
  --transform-translate-y: 16rem;
}

.focus\\:translate-y-px:focus {
  --transform-translate-y: 1px;
}

.focus\\:-translate-y-1:focus {
  --transform-translate-y: -0.25rem;
}

.focus\\:-translate-y-2:focus {
  --transform-translate-y: -0.5rem;
}

.focus\\:-translate-y-3:focus {
  --transform-translate-y: -0.75rem;
}

.focus\\:-translate-y-4:focus {
  --transform-translate-y: -1rem;
}

.focus\\:-translate-y-5:focus {
  --transform-translate-y: -1.25rem;
}

.focus\\:-translate-y-6:focus {
  --transform-translate-y: -1.5rem;
}

.focus\\:-translate-y-8:focus {
  --transform-translate-y: -2rem;
}

.focus\\:-translate-y-10:focus {
  --transform-translate-y: -2.5rem;
}

.focus\\:-translate-y-12:focus {
  --transform-translate-y: -3rem;
}

.focus\\:-translate-y-16:focus {
  --transform-translate-y: -4rem;
}

.focus\\:-translate-y-20:focus {
  --transform-translate-y: -5rem;
}

.focus\\:-translate-y-24:focus {
  --transform-translate-y: -6rem;
}

.focus\\:-translate-y-32:focus {
  --transform-translate-y: -8rem;
}

.focus\\:-translate-y-40:focus {
  --transform-translate-y: -10rem;
}

.focus\\:-translate-y-48:focus {
  --transform-translate-y: -12rem;
}

.focus\\:-translate-y-56:focus {
  --transform-translate-y: -14rem;
}

.focus\\:-translate-y-64:focus {
  --transform-translate-y: -16rem;
}

.focus\\:-translate-y-px:focus {
  --transform-translate-y: -1px;
}

.focus\\:-translate-y-full:focus {
  --transform-translate-y: -100%;
}

.focus\\:-translate-y-1\\/2:focus {
  --transform-translate-y: -50%;
}

.focus\\:translate-y-1\\/2:focus {
  --transform-translate-y: 50%;
}

.focus\\:translate-y-full:focus {
  --transform-translate-y: 100%;
}

.skew-x-0 {
  --transform-skew-x: 0;
}

.skew-x-1 {
  --transform-skew-x: 1deg;
}

.skew-x-2 {
  --transform-skew-x: 2deg;
}

.skew-x-3 {
  --transform-skew-x: 3deg;
}

.skew-x-6 {
  --transform-skew-x: 6deg;
}

.skew-x-12 {
  --transform-skew-x: 12deg;
}

.-skew-x-12 {
  --transform-skew-x: -12deg;
}

.-skew-x-6 {
  --transform-skew-x: -6deg;
}

.-skew-x-3 {
  --transform-skew-x: -3deg;
}

.-skew-x-2 {
  --transform-skew-x: -2deg;
}

.-skew-x-1 {
  --transform-skew-x: -1deg;
}

.skew-y-0 {
  --transform-skew-y: 0;
}

.skew-y-1 {
  --transform-skew-y: 1deg;
}

.skew-y-2 {
  --transform-skew-y: 2deg;
}

.skew-y-3 {
  --transform-skew-y: 3deg;
}

.skew-y-6 {
  --transform-skew-y: 6deg;
}

.skew-y-12 {
  --transform-skew-y: 12deg;
}

.-skew-y-12 {
  --transform-skew-y: -12deg;
}

.-skew-y-6 {
  --transform-skew-y: -6deg;
}

.-skew-y-3 {
  --transform-skew-y: -3deg;
}

.-skew-y-2 {
  --transform-skew-y: -2deg;
}

.-skew-y-1 {
  --transform-skew-y: -1deg;
}

.hover\\:skew-x-0:hover {
  --transform-skew-x: 0;
}

.hover\\:skew-x-1:hover {
  --transform-skew-x: 1deg;
}

.hover\\:skew-x-2:hover {
  --transform-skew-x: 2deg;
}

.hover\\:skew-x-3:hover {
  --transform-skew-x: 3deg;
}

.hover\\:skew-x-6:hover {
  --transform-skew-x: 6deg;
}

.hover\\:skew-x-12:hover {
  --transform-skew-x: 12deg;
}

.hover\\:-skew-x-12:hover {
  --transform-skew-x: -12deg;
}

.hover\\:-skew-x-6:hover {
  --transform-skew-x: -6deg;
}

.hover\\:-skew-x-3:hover {
  --transform-skew-x: -3deg;
}

.hover\\:-skew-x-2:hover {
  --transform-skew-x: -2deg;
}

.hover\\:-skew-x-1:hover {
  --transform-skew-x: -1deg;
}

.hover\\:skew-y-0:hover {
  --transform-skew-y: 0;
}

.hover\\:skew-y-1:hover {
  --transform-skew-y: 1deg;
}

.hover\\:skew-y-2:hover {
  --transform-skew-y: 2deg;
}

.hover\\:skew-y-3:hover {
  --transform-skew-y: 3deg;
}

.hover\\:skew-y-6:hover {
  --transform-skew-y: 6deg;
}

.hover\\:skew-y-12:hover {
  --transform-skew-y: 12deg;
}

.hover\\:-skew-y-12:hover {
  --transform-skew-y: -12deg;
}

.hover\\:-skew-y-6:hover {
  --transform-skew-y: -6deg;
}

.hover\\:-skew-y-3:hover {
  --transform-skew-y: -3deg;
}

.hover\\:-skew-y-2:hover {
  --transform-skew-y: -2deg;
}

.hover\\:-skew-y-1:hover {
  --transform-skew-y: -1deg;
}

.focus\\:skew-x-0:focus {
  --transform-skew-x: 0;
}

.focus\\:skew-x-1:focus {
  --transform-skew-x: 1deg;
}

.focus\\:skew-x-2:focus {
  --transform-skew-x: 2deg;
}

.focus\\:skew-x-3:focus {
  --transform-skew-x: 3deg;
}

.focus\\:skew-x-6:focus {
  --transform-skew-x: 6deg;
}

.focus\\:skew-x-12:focus {
  --transform-skew-x: 12deg;
}

.focus\\:-skew-x-12:focus {
  --transform-skew-x: -12deg;
}

.focus\\:-skew-x-6:focus {
  --transform-skew-x: -6deg;
}

.focus\\:-skew-x-3:focus {
  --transform-skew-x: -3deg;
}

.focus\\:-skew-x-2:focus {
  --transform-skew-x: -2deg;
}

.focus\\:-skew-x-1:focus {
  --transform-skew-x: -1deg;
}

.focus\\:skew-y-0:focus {
  --transform-skew-y: 0;
}

.focus\\:skew-y-1:focus {
  --transform-skew-y: 1deg;
}

.focus\\:skew-y-2:focus {
  --transform-skew-y: 2deg;
}

.focus\\:skew-y-3:focus {
  --transform-skew-y: 3deg;
}

.focus\\:skew-y-6:focus {
  --transform-skew-y: 6deg;
}

.focus\\:skew-y-12:focus {
  --transform-skew-y: 12deg;
}

.focus\\:-skew-y-12:focus {
  --transform-skew-y: -12deg;
}

.focus\\:-skew-y-6:focus {
  --transform-skew-y: -6deg;
}

.focus\\:-skew-y-3:focus {
  --transform-skew-y: -3deg;
}

.focus\\:-skew-y-2:focus {
  --transform-skew-y: -2deg;
}

.focus\\:-skew-y-1:focus {
  --transform-skew-y: -1deg;
}

.transition-none {
  transition-property: none;
}

.transition-all {
  transition-property: all;
}

.transition {
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
}

.transition-colors {
  transition-property: background-color, border-color, color, fill, stroke;
}

.transition-opacity {
  transition-property: opacity;
}

.transition-shadow {
  transition-property: box-shadow;
}

.transition-transform {
  transition-property: transform;
}

.ease-linear {
  transition-timing-function: linear;
}

.ease-in {
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.duration-75 {
  transition-duration: 75ms;
}

.duration-100 {
  transition-duration: 100ms;
}

.duration-150 {
  transition-duration: 150ms;
}

.duration-200 {
  transition-duration: 200ms;
}

.duration-300 {
  transition-duration: 300ms;
}

.duration-500 {
  transition-duration: 500ms;
}

.duration-700 {
  transition-duration: 700ms;
}

.duration-1000 {
  transition-duration: 1000ms;
}

.delay-75 {
  transition-delay: 75ms;
}

.delay-100 {
  transition-delay: 100ms;
}

.delay-150 {
  transition-delay: 150ms;
}

.delay-200 {
  transition-delay: 200ms;
}

.delay-300 {
  transition-delay: 300ms;
}

.delay-500 {
  transition-delay: 500ms;
}

.delay-700 {
  transition-delay: 700ms;
}

.delay-1000 {
  transition-delay: 1000ms;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes ping {
  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes pulse {
  50% {
    opacity: 0.5;
  }
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }

  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

.animate-none {
  animation: none;
}

.animate-spin {
  animation: spin 1s linear infinite;
}

.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-bounce {
  animation: bounce 1s infinite;
}

@media (min-width: 640px) {
  .sm\\:container {
    width: 100%;
  }
}

@media (min-width: 640px) and (min-width: 640px) {
  .sm\\:container {
    max-width: 640px;
  }
}

@media (min-width: 640px) and (min-width: 768px) {
  .sm\\:container {
    max-width: 768px;
  }
}

@media (min-width: 640px) and (min-width: 1024px) {
  .sm\\:container {
    max-width: 1024px;
  }
}

@media (min-width: 640px) and (min-width: 1280px) {
  .sm\\:container {
    max-width: 1280px;
  }
}

@media (min-width: 640px) {
  .sm\\:space-y-0 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .sm\\:space-x-0 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-1 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .sm\\:space-x-1 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-2 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-2 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-3 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .sm\\:space-x-3 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-4 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .sm\\:space-x-4 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-5 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .sm\\:space-x-5 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-6 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-6 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-8 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .sm\\:space-x-8 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-10 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-10 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-12 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .sm\\:space-x-12 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-16 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .sm\\:space-x-16 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-20 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-20 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-24 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .sm\\:space-x-24 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-32 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .sm\\:space-x-32 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-40 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .sm\\:space-x-40 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-48 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .sm\\:space-x-48 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-56 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .sm\\:space-x-56 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-64 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .sm\\:space-x-64 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-px > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .sm\\:space-x-px > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-1 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-1 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-2 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-2 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-3 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-3 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-4 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-4 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-5 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-5 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-6 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-6 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-8 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-8 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-10 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-10 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-12 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-12 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-16 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-16 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-20 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-20 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-24 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-24 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-32 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-32 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-40 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-40 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-48 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-48 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-56 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-56 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-64 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-64 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-px > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .sm\\:-space-x-px > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-reverse > :not(template) ~ :not(template) {
    --space-y-reverse: 1;
  }

  .sm\\:space-x-reverse > :not(template) ~ :not(template) {
    --space-x-reverse: 1;
  }

  .sm\\:divide-y-0 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-0 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-2 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-2 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-4 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-4 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-8 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-8 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .sm\\:divide-x > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-reverse > :not(template) ~ :not(template) {
    --divide-y-reverse: 1;
  }

  .sm\\:divide-x-reverse > :not(template) ~ :not(template) {
    --divide-x-reverse: 1;
  }

  .sm\\:divide-transparent > :not(template) ~ :not(template) {
    border-color: transparent;
  }

  .sm\\:divide-current > :not(template) ~ :not(template) {
    border-color: currentColor;
  }

  .sm\\:divide-black > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .sm\\:divide-white > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .sm\\:divide-gray-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--divide-opacity));
  }

  .sm\\:divide-gray-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--divide-opacity));
  }

  .sm\\:divide-gray-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--divide-opacity));
  }

  .sm\\:divide-gray-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--divide-opacity));
  }

  .sm\\:divide-gray-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--divide-opacity));
  }

  .sm\\:divide-gray-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--divide-opacity));
  }

  .sm\\:divide-gray-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--divide-opacity));
  }

  .sm\\:divide-gray-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--divide-opacity));
  }

  .sm\\:divide-gray-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--divide-opacity));
  }

  .sm\\:divide-red-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--divide-opacity));
  }

  .sm\\:divide-red-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--divide-opacity));
  }

  .sm\\:divide-red-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--divide-opacity));
  }

  .sm\\:divide-red-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--divide-opacity));
  }

  .sm\\:divide-red-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--divide-opacity));
  }

  .sm\\:divide-red-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--divide-opacity));
  }

  .sm\\:divide-red-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--divide-opacity));
  }

  .sm\\:divide-red-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--divide-opacity));
  }

  .sm\\:divide-red-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--divide-opacity));
  }

  .sm\\:divide-orange-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--divide-opacity));
  }

  .sm\\:divide-orange-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--divide-opacity));
  }

  .sm\\:divide-orange-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--divide-opacity));
  }

  .sm\\:divide-orange-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--divide-opacity));
  }

  .sm\\:divide-orange-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--divide-opacity));
  }

  .sm\\:divide-orange-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--divide-opacity));
  }

  .sm\\:divide-orange-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--divide-opacity));
  }

  .sm\\:divide-orange-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--divide-opacity));
  }

  .sm\\:divide-orange-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--divide-opacity));
  }

  .sm\\:divide-yellow-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--divide-opacity));
  }

  .sm\\:divide-yellow-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--divide-opacity));
  }

  .sm\\:divide-yellow-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--divide-opacity));
  }

  .sm\\:divide-yellow-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--divide-opacity));
  }

  .sm\\:divide-yellow-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--divide-opacity));
  }

  .sm\\:divide-yellow-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--divide-opacity));
  }

  .sm\\:divide-yellow-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--divide-opacity));
  }

  .sm\\:divide-yellow-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--divide-opacity));
  }

  .sm\\:divide-yellow-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--divide-opacity));
  }

  .sm\\:divide-green-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--divide-opacity));
  }

  .sm\\:divide-green-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--divide-opacity));
  }

  .sm\\:divide-green-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--divide-opacity));
  }

  .sm\\:divide-green-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--divide-opacity));
  }

  .sm\\:divide-green-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--divide-opacity));
  }

  .sm\\:divide-green-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--divide-opacity));
  }

  .sm\\:divide-green-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--divide-opacity));
  }

  .sm\\:divide-green-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--divide-opacity));
  }

  .sm\\:divide-green-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--divide-opacity));
  }

  .sm\\:divide-teal-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--divide-opacity));
  }

  .sm\\:divide-teal-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--divide-opacity));
  }

  .sm\\:divide-teal-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--divide-opacity));
  }

  .sm\\:divide-teal-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--divide-opacity));
  }

  .sm\\:divide-teal-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--divide-opacity));
  }

  .sm\\:divide-teal-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--divide-opacity));
  }

  .sm\\:divide-teal-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--divide-opacity));
  }

  .sm\\:divide-teal-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--divide-opacity));
  }

  .sm\\:divide-teal-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--divide-opacity));
  }

  .sm\\:divide-blue-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--divide-opacity));
  }

  .sm\\:divide-blue-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--divide-opacity));
  }

  .sm\\:divide-blue-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--divide-opacity));
  }

  .sm\\:divide-blue-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--divide-opacity));
  }

  .sm\\:divide-blue-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--divide-opacity));
  }

  .sm\\:divide-blue-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--divide-opacity));
  }

  .sm\\:divide-blue-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--divide-opacity));
  }

  .sm\\:divide-blue-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--divide-opacity));
  }

  .sm\\:divide-blue-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--divide-opacity));
  }

  .sm\\:divide-indigo-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--divide-opacity));
  }

  .sm\\:divide-indigo-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--divide-opacity));
  }

  .sm\\:divide-indigo-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--divide-opacity));
  }

  .sm\\:divide-indigo-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--divide-opacity));
  }

  .sm\\:divide-indigo-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--divide-opacity));
  }

  .sm\\:divide-indigo-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--divide-opacity));
  }

  .sm\\:divide-indigo-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--divide-opacity));
  }

  .sm\\:divide-indigo-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--divide-opacity));
  }

  .sm\\:divide-indigo-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--divide-opacity));
  }

  .sm\\:divide-purple-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--divide-opacity));
  }

  .sm\\:divide-purple-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--divide-opacity));
  }

  .sm\\:divide-purple-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--divide-opacity));
  }

  .sm\\:divide-purple-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--divide-opacity));
  }

  .sm\\:divide-purple-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--divide-opacity));
  }

  .sm\\:divide-purple-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--divide-opacity));
  }

  .sm\\:divide-purple-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--divide-opacity));
  }

  .sm\\:divide-purple-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--divide-opacity));
  }

  .sm\\:divide-purple-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--divide-opacity));
  }

  .sm\\:divide-pink-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--divide-opacity));
  }

  .sm\\:divide-pink-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--divide-opacity));
  }

  .sm\\:divide-pink-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--divide-opacity));
  }

  .sm\\:divide-pink-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--divide-opacity));
  }

  .sm\\:divide-pink-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--divide-opacity));
  }

  .sm\\:divide-pink-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--divide-opacity));
  }

  .sm\\:divide-pink-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--divide-opacity));
  }

  .sm\\:divide-pink-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--divide-opacity));
  }

  .sm\\:divide-pink-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--divide-opacity));
  }

  .sm\\:divide-solid > :not(template) ~ :not(template) {
    border-style: solid;
  }

  .sm\\:divide-dashed > :not(template) ~ :not(template) {
    border-style: dashed;
  }

  .sm\\:divide-dotted > :not(template) ~ :not(template) {
    border-style: dotted;
  }

  .sm\\:divide-double > :not(template) ~ :not(template) {
    border-style: double;
  }

  .sm\\:divide-none > :not(template) ~ :not(template) {
    border-style: none;
  }

  .sm\\:divide-opacity-0 > :not(template) ~ :not(template) {
    --divide-opacity: 0;
  }

  .sm\\:divide-opacity-25 > :not(template) ~ :not(template) {
    --divide-opacity: 0.25;
  }

  .sm\\:divide-opacity-50 > :not(template) ~ :not(template) {
    --divide-opacity: 0.5;
  }

  .sm\\:divide-opacity-75 > :not(template) ~ :not(template) {
    --divide-opacity: 0.75;
  }

  .sm\\:divide-opacity-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
  }

  .sm\\:sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .sm\\:not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .sm\\:focus\\:sr-only:focus {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .sm\\:focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .sm\\:appearance-none {
    appearance: none;
  }

  .sm\\:bg-fixed {
    background-attachment: fixed;
  }

  .sm\\:bg-local {
    background-attachment: local;
  }

  .sm\\:bg-scroll {
    background-attachment: scroll;
  }

  .sm\\:bg-clip-border {
    background-clip: border-box;
  }

  .sm\\:bg-clip-padding {
    background-clip: padding-box;
  }

  .sm\\:bg-clip-content {
    background-clip: content-box;
  }

  .sm\\:bg-clip-text {
    -webkit-background-clip: text;
    background-clip: text;
  }

  .sm\\:bg-transparent {
    background-color: transparent;
  }

  .sm\\:bg-current {
    background-color: currentColor;
  }

  .sm\\:bg-black {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .sm\\:bg-white {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .sm\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .sm\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .sm\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .sm\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .sm\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .sm\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .sm\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .sm\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .sm\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .sm\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .sm\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .sm\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .sm\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .sm\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .sm\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .sm\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .sm\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .sm\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .sm\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .sm\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .sm\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .sm\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .sm\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .sm\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .sm\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .sm\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .sm\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .sm\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .sm\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .sm\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .sm\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .sm\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .sm\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .sm\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .sm\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .sm\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .sm\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .sm\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .sm\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .sm\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .sm\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .sm\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .sm\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .sm\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .sm\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .sm\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .sm\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .sm\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .sm\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .sm\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .sm\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .sm\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .sm\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .sm\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .sm\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .sm\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .sm\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .sm\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .sm\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .sm\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .sm\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .sm\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .sm\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .sm\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .sm\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .sm\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .sm\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .sm\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .sm\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .sm\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .sm\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .sm\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .sm\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .sm\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .sm\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .sm\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .sm\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .sm\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .sm\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .sm\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .sm\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .sm\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .sm\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .sm\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .sm\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .sm\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .sm\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .sm\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .sm\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .sm\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }

  .sm\\:hover\\:bg-current:hover {
    background-color: currentColor;
  }

  .sm\\:hover\\:bg-black:hover {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-white:hover {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-200:hover {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-300:hover {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-400:hover {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-500:hover {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-600:hover {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-700:hover {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-800:hover {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-900:hover {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-100:hover {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-200:hover {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-300:hover {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-400:hover {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-500:hover {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-600:hover {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-700:hover {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-800:hover {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-900:hover {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-100:hover {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-200:hover {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-300:hover {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-400:hover {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-500:hover {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-600:hover {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-700:hover {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-800:hover {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-900:hover {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-100:hover {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-200:hover {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-300:hover {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-400:hover {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-500:hover {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-600:hover {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-700:hover {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-800:hover {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-900:hover {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-100:hover {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-200:hover {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-300:hover {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-400:hover {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-500:hover {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-600:hover {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-700:hover {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-800:hover {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-900:hover {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-100:hover {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-200:hover {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-300:hover {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-400:hover {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-500:hover {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-600:hover {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-700:hover {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-800:hover {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-teal-900:hover {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-100:hover {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-200:hover {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-300:hover {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-400:hover {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-500:hover {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-600:hover {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-700:hover {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-800:hover {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-900:hover {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-100:hover {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-200:hover {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-300:hover {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-400:hover {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-500:hover {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-600:hover {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-700:hover {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-800:hover {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-indigo-900:hover {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-100:hover {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-200:hover {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-300:hover {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-400:hover {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-500:hover {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-600:hover {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-700:hover {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-800:hover {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-purple-900:hover {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-100:hover {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-200:hover {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-300:hover {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-400:hover {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-500:hover {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-600:hover {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-700:hover {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-800:hover {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-pink-900:hover {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-transparent:focus {
    background-color: transparent;
  }

  .sm\\:focus\\:bg-current:focus {
    background-color: currentColor;
  }

  .sm\\:focus\\:bg-black:focus {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-white:focus {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-200:focus {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-300:focus {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-400:focus {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-500:focus {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-600:focus {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-700:focus {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-800:focus {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-900:focus {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-100:focus {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-200:focus {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-300:focus {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-400:focus {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-500:focus {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-600:focus {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-700:focus {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-800:focus {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-900:focus {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-100:focus {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-200:focus {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-300:focus {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-400:focus {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-500:focus {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-600:focus {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-700:focus {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-800:focus {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-900:focus {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-100:focus {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-200:focus {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-300:focus {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-400:focus {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-500:focus {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-600:focus {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-700:focus {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-800:focus {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-900:focus {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-100:focus {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-200:focus {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-300:focus {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-400:focus {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-500:focus {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-600:focus {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-700:focus {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-800:focus {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-900:focus {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-100:focus {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-200:focus {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-300:focus {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-400:focus {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-500:focus {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-600:focus {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-700:focus {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-800:focus {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-teal-900:focus {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-100:focus {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-200:focus {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-300:focus {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-400:focus {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-500:focus {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-600:focus {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-700:focus {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-800:focus {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-900:focus {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-100:focus {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-200:focus {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-300:focus {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-400:focus {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-500:focus {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-600:focus {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-700:focus {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-800:focus {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-indigo-900:focus {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-100:focus {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-200:focus {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-300:focus {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-400:focus {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-500:focus {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-600:focus {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-700:focus {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-800:focus {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-purple-900:focus {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-100:focus {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-200:focus {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-300:focus {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-400:focus {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-500:focus {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-600:focus {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-700:focus {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-800:focus {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-pink-900:focus {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .sm\\:bg-none {
    background-image: none;
  }

  .sm\\:bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-tl {
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .sm\\:from-transparent {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:from-current {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:from-black {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:from-white {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:from-gray-100 {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .sm\\:from-gray-200 {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .sm\\:from-gray-300 {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .sm\\:from-gray-400 {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .sm\\:from-gray-500 {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .sm\\:from-gray-600 {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .sm\\:from-gray-700 {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .sm\\:from-gray-800 {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .sm\\:from-gray-900 {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .sm\\:from-red-100 {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .sm\\:from-red-200 {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .sm\\:from-red-300 {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .sm\\:from-red-400 {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .sm\\:from-red-500 {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .sm\\:from-red-600 {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .sm\\:from-red-700 {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .sm\\:from-red-800 {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .sm\\:from-red-900 {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .sm\\:from-orange-100 {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .sm\\:from-orange-200 {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .sm\\:from-orange-300 {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .sm\\:from-orange-400 {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .sm\\:from-orange-500 {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .sm\\:from-orange-600 {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .sm\\:from-orange-700 {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .sm\\:from-orange-800 {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .sm\\:from-orange-900 {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .sm\\:from-yellow-100 {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .sm\\:from-yellow-200 {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .sm\\:from-yellow-300 {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .sm\\:from-yellow-400 {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .sm\\:from-yellow-500 {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .sm\\:from-yellow-600 {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .sm\\:from-yellow-700 {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .sm\\:from-yellow-800 {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .sm\\:from-yellow-900 {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .sm\\:from-green-100 {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .sm\\:from-green-200 {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .sm\\:from-green-300 {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .sm\\:from-green-400 {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .sm\\:from-green-500 {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .sm\\:from-green-600 {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .sm\\:from-green-700 {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .sm\\:from-green-800 {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .sm\\:from-green-900 {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .sm\\:from-teal-100 {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .sm\\:from-teal-200 {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .sm\\:from-teal-300 {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .sm\\:from-teal-400 {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .sm\\:from-teal-500 {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .sm\\:from-teal-600 {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .sm\\:from-teal-700 {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .sm\\:from-teal-800 {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .sm\\:from-teal-900 {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .sm\\:from-blue-100 {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .sm\\:from-blue-200 {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .sm\\:from-blue-300 {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .sm\\:from-blue-400 {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .sm\\:from-blue-500 {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .sm\\:from-blue-600 {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .sm\\:from-blue-700 {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .sm\\:from-blue-800 {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .sm\\:from-blue-900 {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .sm\\:from-indigo-100 {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .sm\\:from-indigo-200 {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .sm\\:from-indigo-300 {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .sm\\:from-indigo-400 {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .sm\\:from-indigo-500 {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .sm\\:from-indigo-600 {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .sm\\:from-indigo-700 {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .sm\\:from-indigo-800 {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .sm\\:from-indigo-900 {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .sm\\:from-purple-100 {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .sm\\:from-purple-200 {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .sm\\:from-purple-300 {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .sm\\:from-purple-400 {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .sm\\:from-purple-500 {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .sm\\:from-purple-600 {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .sm\\:from-purple-700 {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .sm\\:from-purple-800 {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .sm\\:from-purple-900 {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .sm\\:from-pink-100 {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .sm\\:from-pink-200 {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .sm\\:from-pink-300 {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .sm\\:from-pink-400 {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .sm\\:from-pink-500 {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .sm\\:from-pink-600 {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .sm\\:from-pink-700 {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .sm\\:from-pink-800 {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .sm\\:from-pink-900 {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .sm\\:via-transparent {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:via-current {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:via-black {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:via-white {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:via-gray-100 {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .sm\\:via-gray-200 {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .sm\\:via-gray-300 {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .sm\\:via-gray-400 {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .sm\\:via-gray-500 {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .sm\\:via-gray-600 {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .sm\\:via-gray-700 {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .sm\\:via-gray-800 {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .sm\\:via-gray-900 {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .sm\\:via-red-100 {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .sm\\:via-red-200 {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .sm\\:via-red-300 {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .sm\\:via-red-400 {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .sm\\:via-red-500 {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .sm\\:via-red-600 {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .sm\\:via-red-700 {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .sm\\:via-red-800 {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .sm\\:via-red-900 {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .sm\\:via-orange-100 {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .sm\\:via-orange-200 {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .sm\\:via-orange-300 {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .sm\\:via-orange-400 {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .sm\\:via-orange-500 {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .sm\\:via-orange-600 {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .sm\\:via-orange-700 {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .sm\\:via-orange-800 {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .sm\\:via-orange-900 {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .sm\\:via-yellow-100 {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .sm\\:via-yellow-200 {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .sm\\:via-yellow-300 {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .sm\\:via-yellow-400 {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .sm\\:via-yellow-500 {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .sm\\:via-yellow-600 {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .sm\\:via-yellow-700 {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .sm\\:via-yellow-800 {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .sm\\:via-yellow-900 {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .sm\\:via-green-100 {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .sm\\:via-green-200 {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .sm\\:via-green-300 {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .sm\\:via-green-400 {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .sm\\:via-green-500 {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .sm\\:via-green-600 {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .sm\\:via-green-700 {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .sm\\:via-green-800 {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .sm\\:via-green-900 {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .sm\\:via-teal-100 {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .sm\\:via-teal-200 {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .sm\\:via-teal-300 {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .sm\\:via-teal-400 {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .sm\\:via-teal-500 {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .sm\\:via-teal-600 {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .sm\\:via-teal-700 {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .sm\\:via-teal-800 {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .sm\\:via-teal-900 {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .sm\\:via-blue-100 {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .sm\\:via-blue-200 {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .sm\\:via-blue-300 {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .sm\\:via-blue-400 {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .sm\\:via-blue-500 {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .sm\\:via-blue-600 {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .sm\\:via-blue-700 {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .sm\\:via-blue-800 {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .sm\\:via-blue-900 {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .sm\\:via-indigo-100 {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .sm\\:via-indigo-200 {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .sm\\:via-indigo-300 {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .sm\\:via-indigo-400 {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .sm\\:via-indigo-500 {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .sm\\:via-indigo-600 {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .sm\\:via-indigo-700 {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .sm\\:via-indigo-800 {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .sm\\:via-indigo-900 {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .sm\\:via-purple-100 {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .sm\\:via-purple-200 {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .sm\\:via-purple-300 {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .sm\\:via-purple-400 {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .sm\\:via-purple-500 {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .sm\\:via-purple-600 {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .sm\\:via-purple-700 {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .sm\\:via-purple-800 {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .sm\\:via-purple-900 {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .sm\\:via-pink-100 {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .sm\\:via-pink-200 {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .sm\\:via-pink-300 {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .sm\\:via-pink-400 {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .sm\\:via-pink-500 {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .sm\\:via-pink-600 {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .sm\\:via-pink-700 {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .sm\\:via-pink-800 {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .sm\\:via-pink-900 {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .sm\\:to-transparent {
    --gradient-to-color: transparent;
  }

  .sm\\:to-current {
    --gradient-to-color: currentColor;
  }

  .sm\\:to-black {
    --gradient-to-color: #000;
  }

  .sm\\:to-white {
    --gradient-to-color: #fff;
  }

  .sm\\:to-gray-100 {
    --gradient-to-color: #f7fafc;
  }

  .sm\\:to-gray-200 {
    --gradient-to-color: #edf2f7;
  }

  .sm\\:to-gray-300 {
    --gradient-to-color: #e2e8f0;
  }

  .sm\\:to-gray-400 {
    --gradient-to-color: #cbd5e0;
  }

  .sm\\:to-gray-500 {
    --gradient-to-color: #a0aec0;
  }

  .sm\\:to-gray-600 {
    --gradient-to-color: #718096;
  }

  .sm\\:to-gray-700 {
    --gradient-to-color: #4a5568;
  }

  .sm\\:to-gray-800 {
    --gradient-to-color: #2d3748;
  }

  .sm\\:to-gray-900 {
    --gradient-to-color: #1a202c;
  }

  .sm\\:to-red-100 {
    --gradient-to-color: #fff5f5;
  }

  .sm\\:to-red-200 {
    --gradient-to-color: #fed7d7;
  }

  .sm\\:to-red-300 {
    --gradient-to-color: #feb2b2;
  }

  .sm\\:to-red-400 {
    --gradient-to-color: #fc8181;
  }

  .sm\\:to-red-500 {
    --gradient-to-color: #f56565;
  }

  .sm\\:to-red-600 {
    --gradient-to-color: #e53e3e;
  }

  .sm\\:to-red-700 {
    --gradient-to-color: #c53030;
  }

  .sm\\:to-red-800 {
    --gradient-to-color: #9b2c2c;
  }

  .sm\\:to-red-900 {
    --gradient-to-color: #742a2a;
  }

  .sm\\:to-orange-100 {
    --gradient-to-color: #fffaf0;
  }

  .sm\\:to-orange-200 {
    --gradient-to-color: #feebc8;
  }

  .sm\\:to-orange-300 {
    --gradient-to-color: #fbd38d;
  }

  .sm\\:to-orange-400 {
    --gradient-to-color: #f6ad55;
  }

  .sm\\:to-orange-500 {
    --gradient-to-color: #ed8936;
  }

  .sm\\:to-orange-600 {
    --gradient-to-color: #dd6b20;
  }

  .sm\\:to-orange-700 {
    --gradient-to-color: #c05621;
  }

  .sm\\:to-orange-800 {
    --gradient-to-color: #9c4221;
  }

  .sm\\:to-orange-900 {
    --gradient-to-color: #7b341e;
  }

  .sm\\:to-yellow-100 {
    --gradient-to-color: #fffff0;
  }

  .sm\\:to-yellow-200 {
    --gradient-to-color: #fefcbf;
  }

  .sm\\:to-yellow-300 {
    --gradient-to-color: #faf089;
  }

  .sm\\:to-yellow-400 {
    --gradient-to-color: #f6e05e;
  }

  .sm\\:to-yellow-500 {
    --gradient-to-color: #ecc94b;
  }

  .sm\\:to-yellow-600 {
    --gradient-to-color: #d69e2e;
  }

  .sm\\:to-yellow-700 {
    --gradient-to-color: #b7791f;
  }

  .sm\\:to-yellow-800 {
    --gradient-to-color: #975a16;
  }

  .sm\\:to-yellow-900 {
    --gradient-to-color: #744210;
  }

  .sm\\:to-green-100 {
    --gradient-to-color: #f0fff4;
  }

  .sm\\:to-green-200 {
    --gradient-to-color: #c6f6d5;
  }

  .sm\\:to-green-300 {
    --gradient-to-color: #9ae6b4;
  }

  .sm\\:to-green-400 {
    --gradient-to-color: #68d391;
  }

  .sm\\:to-green-500 {
    --gradient-to-color: #48bb78;
  }

  .sm\\:to-green-600 {
    --gradient-to-color: #38a169;
  }

  .sm\\:to-green-700 {
    --gradient-to-color: #2f855a;
  }

  .sm\\:to-green-800 {
    --gradient-to-color: #276749;
  }

  .sm\\:to-green-900 {
    --gradient-to-color: #22543d;
  }

  .sm\\:to-teal-100 {
    --gradient-to-color: #e6fffa;
  }

  .sm\\:to-teal-200 {
    --gradient-to-color: #b2f5ea;
  }

  .sm\\:to-teal-300 {
    --gradient-to-color: #81e6d9;
  }

  .sm\\:to-teal-400 {
    --gradient-to-color: #4fd1c5;
  }

  .sm\\:to-teal-500 {
    --gradient-to-color: #38b2ac;
  }

  .sm\\:to-teal-600 {
    --gradient-to-color: #319795;
  }

  .sm\\:to-teal-700 {
    --gradient-to-color: #2c7a7b;
  }

  .sm\\:to-teal-800 {
    --gradient-to-color: #285e61;
  }

  .sm\\:to-teal-900 {
    --gradient-to-color: #234e52;
  }

  .sm\\:to-blue-100 {
    --gradient-to-color: #ebf8ff;
  }

  .sm\\:to-blue-200 {
    --gradient-to-color: #bee3f8;
  }

  .sm\\:to-blue-300 {
    --gradient-to-color: #90cdf4;
  }

  .sm\\:to-blue-400 {
    --gradient-to-color: #63b3ed;
  }

  .sm\\:to-blue-500 {
    --gradient-to-color: #4299e1;
  }

  .sm\\:to-blue-600 {
    --gradient-to-color: #3182ce;
  }

  .sm\\:to-blue-700 {
    --gradient-to-color: #2b6cb0;
  }

  .sm\\:to-blue-800 {
    --gradient-to-color: #2c5282;
  }

  .sm\\:to-blue-900 {
    --gradient-to-color: #2a4365;
  }

  .sm\\:to-indigo-100 {
    --gradient-to-color: #ebf4ff;
  }

  .sm\\:to-indigo-200 {
    --gradient-to-color: #c3dafe;
  }

  .sm\\:to-indigo-300 {
    --gradient-to-color: #a3bffa;
  }

  .sm\\:to-indigo-400 {
    --gradient-to-color: #7f9cf5;
  }

  .sm\\:to-indigo-500 {
    --gradient-to-color: #667eea;
  }

  .sm\\:to-indigo-600 {
    --gradient-to-color: #5a67d8;
  }

  .sm\\:to-indigo-700 {
    --gradient-to-color: #4c51bf;
  }

  .sm\\:to-indigo-800 {
    --gradient-to-color: #434190;
  }

  .sm\\:to-indigo-900 {
    --gradient-to-color: #3c366b;
  }

  .sm\\:to-purple-100 {
    --gradient-to-color: #faf5ff;
  }

  .sm\\:to-purple-200 {
    --gradient-to-color: #e9d8fd;
  }

  .sm\\:to-purple-300 {
    --gradient-to-color: #d6bcfa;
  }

  .sm\\:to-purple-400 {
    --gradient-to-color: #b794f4;
  }

  .sm\\:to-purple-500 {
    --gradient-to-color: #9f7aea;
  }

  .sm\\:to-purple-600 {
    --gradient-to-color: #805ad5;
  }

  .sm\\:to-purple-700 {
    --gradient-to-color: #6b46c1;
  }

  .sm\\:to-purple-800 {
    --gradient-to-color: #553c9a;
  }

  .sm\\:to-purple-900 {
    --gradient-to-color: #44337a;
  }

  .sm\\:to-pink-100 {
    --gradient-to-color: #fff5f7;
  }

  .sm\\:to-pink-200 {
    --gradient-to-color: #fed7e2;
  }

  .sm\\:to-pink-300 {
    --gradient-to-color: #fbb6ce;
  }

  .sm\\:to-pink-400 {
    --gradient-to-color: #f687b3;
  }

  .sm\\:to-pink-500 {
    --gradient-to-color: #ed64a6;
  }

  .sm\\:to-pink-600 {
    --gradient-to-color: #d53f8c;
  }

  .sm\\:to-pink-700 {
    --gradient-to-color: #b83280;
  }

  .sm\\:to-pink-800 {
    --gradient-to-color: #97266d;
  }

  .sm\\:to-pink-900 {
    --gradient-to-color: #702459;
  }

  .sm\\:hover\\:from-transparent:hover {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:hover\\:from-current:hover {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:from-black:hover {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:hover\\:from-white:hover {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:from-gray-100:hover {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .sm\\:hover\\:from-gray-200:hover {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .sm\\:hover\\:from-gray-300:hover {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .sm\\:hover\\:from-gray-400:hover {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .sm\\:hover\\:from-gray-500:hover {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .sm\\:hover\\:from-gray-600:hover {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .sm\\:hover\\:from-gray-700:hover {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .sm\\:hover\\:from-gray-800:hover {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .sm\\:hover\\:from-gray-900:hover {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .sm\\:hover\\:from-red-100:hover {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .sm\\:hover\\:from-red-200:hover {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .sm\\:hover\\:from-red-300:hover {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .sm\\:hover\\:from-red-400:hover {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .sm\\:hover\\:from-red-500:hover {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .sm\\:hover\\:from-red-600:hover {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .sm\\:hover\\:from-red-700:hover {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .sm\\:hover\\:from-red-800:hover {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .sm\\:hover\\:from-red-900:hover {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .sm\\:hover\\:from-orange-100:hover {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .sm\\:hover\\:from-orange-200:hover {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .sm\\:hover\\:from-orange-300:hover {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .sm\\:hover\\:from-orange-400:hover {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .sm\\:hover\\:from-orange-500:hover {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .sm\\:hover\\:from-orange-600:hover {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .sm\\:hover\\:from-orange-700:hover {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .sm\\:hover\\:from-orange-800:hover {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .sm\\:hover\\:from-orange-900:hover {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .sm\\:hover\\:from-yellow-100:hover {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .sm\\:hover\\:from-yellow-200:hover {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .sm\\:hover\\:from-yellow-300:hover {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .sm\\:hover\\:from-yellow-400:hover {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .sm\\:hover\\:from-yellow-500:hover {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .sm\\:hover\\:from-yellow-600:hover {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .sm\\:hover\\:from-yellow-700:hover {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .sm\\:hover\\:from-yellow-800:hover {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .sm\\:hover\\:from-yellow-900:hover {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .sm\\:hover\\:from-green-100:hover {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .sm\\:hover\\:from-green-200:hover {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .sm\\:hover\\:from-green-300:hover {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .sm\\:hover\\:from-green-400:hover {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .sm\\:hover\\:from-green-500:hover {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .sm\\:hover\\:from-green-600:hover {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .sm\\:hover\\:from-green-700:hover {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .sm\\:hover\\:from-green-800:hover {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .sm\\:hover\\:from-green-900:hover {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .sm\\:hover\\:from-teal-100:hover {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .sm\\:hover\\:from-teal-200:hover {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .sm\\:hover\\:from-teal-300:hover {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .sm\\:hover\\:from-teal-400:hover {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .sm\\:hover\\:from-teal-500:hover {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .sm\\:hover\\:from-teal-600:hover {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .sm\\:hover\\:from-teal-700:hover {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .sm\\:hover\\:from-teal-800:hover {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .sm\\:hover\\:from-teal-900:hover {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .sm\\:hover\\:from-blue-100:hover {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .sm\\:hover\\:from-blue-200:hover {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .sm\\:hover\\:from-blue-300:hover {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .sm\\:hover\\:from-blue-400:hover {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .sm\\:hover\\:from-blue-500:hover {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .sm\\:hover\\:from-blue-600:hover {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .sm\\:hover\\:from-blue-700:hover {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .sm\\:hover\\:from-blue-800:hover {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .sm\\:hover\\:from-blue-900:hover {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .sm\\:hover\\:from-indigo-100:hover {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .sm\\:hover\\:from-indigo-200:hover {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .sm\\:hover\\:from-indigo-300:hover {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .sm\\:hover\\:from-indigo-400:hover {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .sm\\:hover\\:from-indigo-500:hover {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .sm\\:hover\\:from-indigo-600:hover {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .sm\\:hover\\:from-indigo-700:hover {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .sm\\:hover\\:from-indigo-800:hover {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .sm\\:hover\\:from-indigo-900:hover {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .sm\\:hover\\:from-purple-100:hover {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .sm\\:hover\\:from-purple-200:hover {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .sm\\:hover\\:from-purple-300:hover {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .sm\\:hover\\:from-purple-400:hover {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .sm\\:hover\\:from-purple-500:hover {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .sm\\:hover\\:from-purple-600:hover {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .sm\\:hover\\:from-purple-700:hover {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .sm\\:hover\\:from-purple-800:hover {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .sm\\:hover\\:from-purple-900:hover {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .sm\\:hover\\:from-pink-100:hover {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .sm\\:hover\\:from-pink-200:hover {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .sm\\:hover\\:from-pink-300:hover {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .sm\\:hover\\:from-pink-400:hover {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .sm\\:hover\\:from-pink-500:hover {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .sm\\:hover\\:from-pink-600:hover {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .sm\\:hover\\:from-pink-700:hover {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .sm\\:hover\\:from-pink-800:hover {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .sm\\:hover\\:from-pink-900:hover {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .sm\\:hover\\:via-transparent:hover {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:hover\\:via-current:hover {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:via-black:hover {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:hover\\:via-white:hover {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:via-gray-100:hover {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .sm\\:hover\\:via-gray-200:hover {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .sm\\:hover\\:via-gray-300:hover {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .sm\\:hover\\:via-gray-400:hover {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .sm\\:hover\\:via-gray-500:hover {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .sm\\:hover\\:via-gray-600:hover {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .sm\\:hover\\:via-gray-700:hover {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .sm\\:hover\\:via-gray-800:hover {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .sm\\:hover\\:via-gray-900:hover {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .sm\\:hover\\:via-red-100:hover {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .sm\\:hover\\:via-red-200:hover {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .sm\\:hover\\:via-red-300:hover {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .sm\\:hover\\:via-red-400:hover {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .sm\\:hover\\:via-red-500:hover {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .sm\\:hover\\:via-red-600:hover {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .sm\\:hover\\:via-red-700:hover {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .sm\\:hover\\:via-red-800:hover {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .sm\\:hover\\:via-red-900:hover {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .sm\\:hover\\:via-orange-100:hover {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .sm\\:hover\\:via-orange-200:hover {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .sm\\:hover\\:via-orange-300:hover {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .sm\\:hover\\:via-orange-400:hover {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .sm\\:hover\\:via-orange-500:hover {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .sm\\:hover\\:via-orange-600:hover {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .sm\\:hover\\:via-orange-700:hover {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .sm\\:hover\\:via-orange-800:hover {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .sm\\:hover\\:via-orange-900:hover {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .sm\\:hover\\:via-yellow-100:hover {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .sm\\:hover\\:via-yellow-200:hover {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .sm\\:hover\\:via-yellow-300:hover {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .sm\\:hover\\:via-yellow-400:hover {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .sm\\:hover\\:via-yellow-500:hover {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .sm\\:hover\\:via-yellow-600:hover {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .sm\\:hover\\:via-yellow-700:hover {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .sm\\:hover\\:via-yellow-800:hover {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .sm\\:hover\\:via-yellow-900:hover {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .sm\\:hover\\:via-green-100:hover {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .sm\\:hover\\:via-green-200:hover {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .sm\\:hover\\:via-green-300:hover {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .sm\\:hover\\:via-green-400:hover {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .sm\\:hover\\:via-green-500:hover {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .sm\\:hover\\:via-green-600:hover {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .sm\\:hover\\:via-green-700:hover {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .sm\\:hover\\:via-green-800:hover {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .sm\\:hover\\:via-green-900:hover {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .sm\\:hover\\:via-teal-100:hover {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .sm\\:hover\\:via-teal-200:hover {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .sm\\:hover\\:via-teal-300:hover {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .sm\\:hover\\:via-teal-400:hover {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .sm\\:hover\\:via-teal-500:hover {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .sm\\:hover\\:via-teal-600:hover {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .sm\\:hover\\:via-teal-700:hover {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .sm\\:hover\\:via-teal-800:hover {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .sm\\:hover\\:via-teal-900:hover {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .sm\\:hover\\:via-blue-100:hover {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .sm\\:hover\\:via-blue-200:hover {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .sm\\:hover\\:via-blue-300:hover {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .sm\\:hover\\:via-blue-400:hover {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .sm\\:hover\\:via-blue-500:hover {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .sm\\:hover\\:via-blue-600:hover {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .sm\\:hover\\:via-blue-700:hover {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .sm\\:hover\\:via-blue-800:hover {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .sm\\:hover\\:via-blue-900:hover {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .sm\\:hover\\:via-indigo-100:hover {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .sm\\:hover\\:via-indigo-200:hover {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .sm\\:hover\\:via-indigo-300:hover {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .sm\\:hover\\:via-indigo-400:hover {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .sm\\:hover\\:via-indigo-500:hover {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .sm\\:hover\\:via-indigo-600:hover {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .sm\\:hover\\:via-indigo-700:hover {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .sm\\:hover\\:via-indigo-800:hover {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .sm\\:hover\\:via-indigo-900:hover {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .sm\\:hover\\:via-purple-100:hover {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .sm\\:hover\\:via-purple-200:hover {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .sm\\:hover\\:via-purple-300:hover {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .sm\\:hover\\:via-purple-400:hover {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .sm\\:hover\\:via-purple-500:hover {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .sm\\:hover\\:via-purple-600:hover {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .sm\\:hover\\:via-purple-700:hover {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .sm\\:hover\\:via-purple-800:hover {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .sm\\:hover\\:via-purple-900:hover {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .sm\\:hover\\:via-pink-100:hover {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .sm\\:hover\\:via-pink-200:hover {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .sm\\:hover\\:via-pink-300:hover {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .sm\\:hover\\:via-pink-400:hover {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .sm\\:hover\\:via-pink-500:hover {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .sm\\:hover\\:via-pink-600:hover {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .sm\\:hover\\:via-pink-700:hover {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .sm\\:hover\\:via-pink-800:hover {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .sm\\:hover\\:via-pink-900:hover {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .sm\\:hover\\:to-transparent:hover {
    --gradient-to-color: transparent;
  }

  .sm\\:hover\\:to-current:hover {
    --gradient-to-color: currentColor;
  }

  .sm\\:hover\\:to-black:hover {
    --gradient-to-color: #000;
  }

  .sm\\:hover\\:to-white:hover {
    --gradient-to-color: #fff;
  }

  .sm\\:hover\\:to-gray-100:hover {
    --gradient-to-color: #f7fafc;
  }

  .sm\\:hover\\:to-gray-200:hover {
    --gradient-to-color: #edf2f7;
  }

  .sm\\:hover\\:to-gray-300:hover {
    --gradient-to-color: #e2e8f0;
  }

  .sm\\:hover\\:to-gray-400:hover {
    --gradient-to-color: #cbd5e0;
  }

  .sm\\:hover\\:to-gray-500:hover {
    --gradient-to-color: #a0aec0;
  }

  .sm\\:hover\\:to-gray-600:hover {
    --gradient-to-color: #718096;
  }

  .sm\\:hover\\:to-gray-700:hover {
    --gradient-to-color: #4a5568;
  }

  .sm\\:hover\\:to-gray-800:hover {
    --gradient-to-color: #2d3748;
  }

  .sm\\:hover\\:to-gray-900:hover {
    --gradient-to-color: #1a202c;
  }

  .sm\\:hover\\:to-red-100:hover {
    --gradient-to-color: #fff5f5;
  }

  .sm\\:hover\\:to-red-200:hover {
    --gradient-to-color: #fed7d7;
  }

  .sm\\:hover\\:to-red-300:hover {
    --gradient-to-color: #feb2b2;
  }

  .sm\\:hover\\:to-red-400:hover {
    --gradient-to-color: #fc8181;
  }

  .sm\\:hover\\:to-red-500:hover {
    --gradient-to-color: #f56565;
  }

  .sm\\:hover\\:to-red-600:hover {
    --gradient-to-color: #e53e3e;
  }

  .sm\\:hover\\:to-red-700:hover {
    --gradient-to-color: #c53030;
  }

  .sm\\:hover\\:to-red-800:hover {
    --gradient-to-color: #9b2c2c;
  }

  .sm\\:hover\\:to-red-900:hover {
    --gradient-to-color: #742a2a;
  }

  .sm\\:hover\\:to-orange-100:hover {
    --gradient-to-color: #fffaf0;
  }

  .sm\\:hover\\:to-orange-200:hover {
    --gradient-to-color: #feebc8;
  }

  .sm\\:hover\\:to-orange-300:hover {
    --gradient-to-color: #fbd38d;
  }

  .sm\\:hover\\:to-orange-400:hover {
    --gradient-to-color: #f6ad55;
  }

  .sm\\:hover\\:to-orange-500:hover {
    --gradient-to-color: #ed8936;
  }

  .sm\\:hover\\:to-orange-600:hover {
    --gradient-to-color: #dd6b20;
  }

  .sm\\:hover\\:to-orange-700:hover {
    --gradient-to-color: #c05621;
  }

  .sm\\:hover\\:to-orange-800:hover {
    --gradient-to-color: #9c4221;
  }

  .sm\\:hover\\:to-orange-900:hover {
    --gradient-to-color: #7b341e;
  }

  .sm\\:hover\\:to-yellow-100:hover {
    --gradient-to-color: #fffff0;
  }

  .sm\\:hover\\:to-yellow-200:hover {
    --gradient-to-color: #fefcbf;
  }

  .sm\\:hover\\:to-yellow-300:hover {
    --gradient-to-color: #faf089;
  }

  .sm\\:hover\\:to-yellow-400:hover {
    --gradient-to-color: #f6e05e;
  }

  .sm\\:hover\\:to-yellow-500:hover {
    --gradient-to-color: #ecc94b;
  }

  .sm\\:hover\\:to-yellow-600:hover {
    --gradient-to-color: #d69e2e;
  }

  .sm\\:hover\\:to-yellow-700:hover {
    --gradient-to-color: #b7791f;
  }

  .sm\\:hover\\:to-yellow-800:hover {
    --gradient-to-color: #975a16;
  }

  .sm\\:hover\\:to-yellow-900:hover {
    --gradient-to-color: #744210;
  }

  .sm\\:hover\\:to-green-100:hover {
    --gradient-to-color: #f0fff4;
  }

  .sm\\:hover\\:to-green-200:hover {
    --gradient-to-color: #c6f6d5;
  }

  .sm\\:hover\\:to-green-300:hover {
    --gradient-to-color: #9ae6b4;
  }

  .sm\\:hover\\:to-green-400:hover {
    --gradient-to-color: #68d391;
  }

  .sm\\:hover\\:to-green-500:hover {
    --gradient-to-color: #48bb78;
  }

  .sm\\:hover\\:to-green-600:hover {
    --gradient-to-color: #38a169;
  }

  .sm\\:hover\\:to-green-700:hover {
    --gradient-to-color: #2f855a;
  }

  .sm\\:hover\\:to-green-800:hover {
    --gradient-to-color: #276749;
  }

  .sm\\:hover\\:to-green-900:hover {
    --gradient-to-color: #22543d;
  }

  .sm\\:hover\\:to-teal-100:hover {
    --gradient-to-color: #e6fffa;
  }

  .sm\\:hover\\:to-teal-200:hover {
    --gradient-to-color: #b2f5ea;
  }

  .sm\\:hover\\:to-teal-300:hover {
    --gradient-to-color: #81e6d9;
  }

  .sm\\:hover\\:to-teal-400:hover {
    --gradient-to-color: #4fd1c5;
  }

  .sm\\:hover\\:to-teal-500:hover {
    --gradient-to-color: #38b2ac;
  }

  .sm\\:hover\\:to-teal-600:hover {
    --gradient-to-color: #319795;
  }

  .sm\\:hover\\:to-teal-700:hover {
    --gradient-to-color: #2c7a7b;
  }

  .sm\\:hover\\:to-teal-800:hover {
    --gradient-to-color: #285e61;
  }

  .sm\\:hover\\:to-teal-900:hover {
    --gradient-to-color: #234e52;
  }

  .sm\\:hover\\:to-blue-100:hover {
    --gradient-to-color: #ebf8ff;
  }

  .sm\\:hover\\:to-blue-200:hover {
    --gradient-to-color: #bee3f8;
  }

  .sm\\:hover\\:to-blue-300:hover {
    --gradient-to-color: #90cdf4;
  }

  .sm\\:hover\\:to-blue-400:hover {
    --gradient-to-color: #63b3ed;
  }

  .sm\\:hover\\:to-blue-500:hover {
    --gradient-to-color: #4299e1;
  }

  .sm\\:hover\\:to-blue-600:hover {
    --gradient-to-color: #3182ce;
  }

  .sm\\:hover\\:to-blue-700:hover {
    --gradient-to-color: #2b6cb0;
  }

  .sm\\:hover\\:to-blue-800:hover {
    --gradient-to-color: #2c5282;
  }

  .sm\\:hover\\:to-blue-900:hover {
    --gradient-to-color: #2a4365;
  }

  .sm\\:hover\\:to-indigo-100:hover {
    --gradient-to-color: #ebf4ff;
  }

  .sm\\:hover\\:to-indigo-200:hover {
    --gradient-to-color: #c3dafe;
  }

  .sm\\:hover\\:to-indigo-300:hover {
    --gradient-to-color: #a3bffa;
  }

  .sm\\:hover\\:to-indigo-400:hover {
    --gradient-to-color: #7f9cf5;
  }

  .sm\\:hover\\:to-indigo-500:hover {
    --gradient-to-color: #667eea;
  }

  .sm\\:hover\\:to-indigo-600:hover {
    --gradient-to-color: #5a67d8;
  }

  .sm\\:hover\\:to-indigo-700:hover {
    --gradient-to-color: #4c51bf;
  }

  .sm\\:hover\\:to-indigo-800:hover {
    --gradient-to-color: #434190;
  }

  .sm\\:hover\\:to-indigo-900:hover {
    --gradient-to-color: #3c366b;
  }

  .sm\\:hover\\:to-purple-100:hover {
    --gradient-to-color: #faf5ff;
  }

  .sm\\:hover\\:to-purple-200:hover {
    --gradient-to-color: #e9d8fd;
  }

  .sm\\:hover\\:to-purple-300:hover {
    --gradient-to-color: #d6bcfa;
  }

  .sm\\:hover\\:to-purple-400:hover {
    --gradient-to-color: #b794f4;
  }

  .sm\\:hover\\:to-purple-500:hover {
    --gradient-to-color: #9f7aea;
  }

  .sm\\:hover\\:to-purple-600:hover {
    --gradient-to-color: #805ad5;
  }

  .sm\\:hover\\:to-purple-700:hover {
    --gradient-to-color: #6b46c1;
  }

  .sm\\:hover\\:to-purple-800:hover {
    --gradient-to-color: #553c9a;
  }

  .sm\\:hover\\:to-purple-900:hover {
    --gradient-to-color: #44337a;
  }

  .sm\\:hover\\:to-pink-100:hover {
    --gradient-to-color: #fff5f7;
  }

  .sm\\:hover\\:to-pink-200:hover {
    --gradient-to-color: #fed7e2;
  }

  .sm\\:hover\\:to-pink-300:hover {
    --gradient-to-color: #fbb6ce;
  }

  .sm\\:hover\\:to-pink-400:hover {
    --gradient-to-color: #f687b3;
  }

  .sm\\:hover\\:to-pink-500:hover {
    --gradient-to-color: #ed64a6;
  }

  .sm\\:hover\\:to-pink-600:hover {
    --gradient-to-color: #d53f8c;
  }

  .sm\\:hover\\:to-pink-700:hover {
    --gradient-to-color: #b83280;
  }

  .sm\\:hover\\:to-pink-800:hover {
    --gradient-to-color: #97266d;
  }

  .sm\\:hover\\:to-pink-900:hover {
    --gradient-to-color: #702459;
  }

  .sm\\:focus\\:from-transparent:focus {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:focus\\:from-current:focus {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:from-black:focus {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:focus\\:from-white:focus {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:from-gray-100:focus {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .sm\\:focus\\:from-gray-200:focus {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .sm\\:focus\\:from-gray-300:focus {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .sm\\:focus\\:from-gray-400:focus {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .sm\\:focus\\:from-gray-500:focus {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .sm\\:focus\\:from-gray-600:focus {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .sm\\:focus\\:from-gray-700:focus {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .sm\\:focus\\:from-gray-800:focus {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .sm\\:focus\\:from-gray-900:focus {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .sm\\:focus\\:from-red-100:focus {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .sm\\:focus\\:from-red-200:focus {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .sm\\:focus\\:from-red-300:focus {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .sm\\:focus\\:from-red-400:focus {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .sm\\:focus\\:from-red-500:focus {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .sm\\:focus\\:from-red-600:focus {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .sm\\:focus\\:from-red-700:focus {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .sm\\:focus\\:from-red-800:focus {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .sm\\:focus\\:from-red-900:focus {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .sm\\:focus\\:from-orange-100:focus {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .sm\\:focus\\:from-orange-200:focus {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .sm\\:focus\\:from-orange-300:focus {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .sm\\:focus\\:from-orange-400:focus {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .sm\\:focus\\:from-orange-500:focus {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .sm\\:focus\\:from-orange-600:focus {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .sm\\:focus\\:from-orange-700:focus {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .sm\\:focus\\:from-orange-800:focus {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .sm\\:focus\\:from-orange-900:focus {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .sm\\:focus\\:from-yellow-100:focus {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .sm\\:focus\\:from-yellow-200:focus {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .sm\\:focus\\:from-yellow-300:focus {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .sm\\:focus\\:from-yellow-400:focus {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .sm\\:focus\\:from-yellow-500:focus {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .sm\\:focus\\:from-yellow-600:focus {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .sm\\:focus\\:from-yellow-700:focus {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .sm\\:focus\\:from-yellow-800:focus {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .sm\\:focus\\:from-yellow-900:focus {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .sm\\:focus\\:from-green-100:focus {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .sm\\:focus\\:from-green-200:focus {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .sm\\:focus\\:from-green-300:focus {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .sm\\:focus\\:from-green-400:focus {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .sm\\:focus\\:from-green-500:focus {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .sm\\:focus\\:from-green-600:focus {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .sm\\:focus\\:from-green-700:focus {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .sm\\:focus\\:from-green-800:focus {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .sm\\:focus\\:from-green-900:focus {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .sm\\:focus\\:from-teal-100:focus {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .sm\\:focus\\:from-teal-200:focus {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .sm\\:focus\\:from-teal-300:focus {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .sm\\:focus\\:from-teal-400:focus {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .sm\\:focus\\:from-teal-500:focus {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .sm\\:focus\\:from-teal-600:focus {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .sm\\:focus\\:from-teal-700:focus {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .sm\\:focus\\:from-teal-800:focus {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .sm\\:focus\\:from-teal-900:focus {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .sm\\:focus\\:from-blue-100:focus {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .sm\\:focus\\:from-blue-200:focus {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .sm\\:focus\\:from-blue-300:focus {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .sm\\:focus\\:from-blue-400:focus {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .sm\\:focus\\:from-blue-500:focus {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .sm\\:focus\\:from-blue-600:focus {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .sm\\:focus\\:from-blue-700:focus {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .sm\\:focus\\:from-blue-800:focus {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .sm\\:focus\\:from-blue-900:focus {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .sm\\:focus\\:from-indigo-100:focus {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .sm\\:focus\\:from-indigo-200:focus {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .sm\\:focus\\:from-indigo-300:focus {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .sm\\:focus\\:from-indigo-400:focus {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .sm\\:focus\\:from-indigo-500:focus {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .sm\\:focus\\:from-indigo-600:focus {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .sm\\:focus\\:from-indigo-700:focus {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .sm\\:focus\\:from-indigo-800:focus {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .sm\\:focus\\:from-indigo-900:focus {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .sm\\:focus\\:from-purple-100:focus {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .sm\\:focus\\:from-purple-200:focus {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .sm\\:focus\\:from-purple-300:focus {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .sm\\:focus\\:from-purple-400:focus {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .sm\\:focus\\:from-purple-500:focus {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .sm\\:focus\\:from-purple-600:focus {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .sm\\:focus\\:from-purple-700:focus {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .sm\\:focus\\:from-purple-800:focus {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .sm\\:focus\\:from-purple-900:focus {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .sm\\:focus\\:from-pink-100:focus {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .sm\\:focus\\:from-pink-200:focus {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .sm\\:focus\\:from-pink-300:focus {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .sm\\:focus\\:from-pink-400:focus {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .sm\\:focus\\:from-pink-500:focus {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .sm\\:focus\\:from-pink-600:focus {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .sm\\:focus\\:from-pink-700:focus {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .sm\\:focus\\:from-pink-800:focus {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .sm\\:focus\\:from-pink-900:focus {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .sm\\:focus\\:via-transparent:focus {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:focus\\:via-current:focus {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:via-black:focus {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:focus\\:via-white:focus {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:via-gray-100:focus {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .sm\\:focus\\:via-gray-200:focus {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .sm\\:focus\\:via-gray-300:focus {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .sm\\:focus\\:via-gray-400:focus {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .sm\\:focus\\:via-gray-500:focus {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .sm\\:focus\\:via-gray-600:focus {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .sm\\:focus\\:via-gray-700:focus {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .sm\\:focus\\:via-gray-800:focus {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .sm\\:focus\\:via-gray-900:focus {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .sm\\:focus\\:via-red-100:focus {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .sm\\:focus\\:via-red-200:focus {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .sm\\:focus\\:via-red-300:focus {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .sm\\:focus\\:via-red-400:focus {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .sm\\:focus\\:via-red-500:focus {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .sm\\:focus\\:via-red-600:focus {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .sm\\:focus\\:via-red-700:focus {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .sm\\:focus\\:via-red-800:focus {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .sm\\:focus\\:via-red-900:focus {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .sm\\:focus\\:via-orange-100:focus {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .sm\\:focus\\:via-orange-200:focus {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .sm\\:focus\\:via-orange-300:focus {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .sm\\:focus\\:via-orange-400:focus {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .sm\\:focus\\:via-orange-500:focus {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .sm\\:focus\\:via-orange-600:focus {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .sm\\:focus\\:via-orange-700:focus {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .sm\\:focus\\:via-orange-800:focus {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .sm\\:focus\\:via-orange-900:focus {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .sm\\:focus\\:via-yellow-100:focus {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .sm\\:focus\\:via-yellow-200:focus {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .sm\\:focus\\:via-yellow-300:focus {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .sm\\:focus\\:via-yellow-400:focus {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .sm\\:focus\\:via-yellow-500:focus {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .sm\\:focus\\:via-yellow-600:focus {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .sm\\:focus\\:via-yellow-700:focus {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .sm\\:focus\\:via-yellow-800:focus {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .sm\\:focus\\:via-yellow-900:focus {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .sm\\:focus\\:via-green-100:focus {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .sm\\:focus\\:via-green-200:focus {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .sm\\:focus\\:via-green-300:focus {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .sm\\:focus\\:via-green-400:focus {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .sm\\:focus\\:via-green-500:focus {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .sm\\:focus\\:via-green-600:focus {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .sm\\:focus\\:via-green-700:focus {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .sm\\:focus\\:via-green-800:focus {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .sm\\:focus\\:via-green-900:focus {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .sm\\:focus\\:via-teal-100:focus {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .sm\\:focus\\:via-teal-200:focus {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .sm\\:focus\\:via-teal-300:focus {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .sm\\:focus\\:via-teal-400:focus {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .sm\\:focus\\:via-teal-500:focus {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .sm\\:focus\\:via-teal-600:focus {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .sm\\:focus\\:via-teal-700:focus {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .sm\\:focus\\:via-teal-800:focus {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .sm\\:focus\\:via-teal-900:focus {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .sm\\:focus\\:via-blue-100:focus {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .sm\\:focus\\:via-blue-200:focus {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .sm\\:focus\\:via-blue-300:focus {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .sm\\:focus\\:via-blue-400:focus {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .sm\\:focus\\:via-blue-500:focus {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .sm\\:focus\\:via-blue-600:focus {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .sm\\:focus\\:via-blue-700:focus {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .sm\\:focus\\:via-blue-800:focus {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .sm\\:focus\\:via-blue-900:focus {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .sm\\:focus\\:via-indigo-100:focus {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .sm\\:focus\\:via-indigo-200:focus {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .sm\\:focus\\:via-indigo-300:focus {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .sm\\:focus\\:via-indigo-400:focus {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .sm\\:focus\\:via-indigo-500:focus {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .sm\\:focus\\:via-indigo-600:focus {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .sm\\:focus\\:via-indigo-700:focus {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .sm\\:focus\\:via-indigo-800:focus {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .sm\\:focus\\:via-indigo-900:focus {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .sm\\:focus\\:via-purple-100:focus {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .sm\\:focus\\:via-purple-200:focus {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .sm\\:focus\\:via-purple-300:focus {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .sm\\:focus\\:via-purple-400:focus {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .sm\\:focus\\:via-purple-500:focus {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .sm\\:focus\\:via-purple-600:focus {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .sm\\:focus\\:via-purple-700:focus {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .sm\\:focus\\:via-purple-800:focus {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .sm\\:focus\\:via-purple-900:focus {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .sm\\:focus\\:via-pink-100:focus {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .sm\\:focus\\:via-pink-200:focus {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .sm\\:focus\\:via-pink-300:focus {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .sm\\:focus\\:via-pink-400:focus {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .sm\\:focus\\:via-pink-500:focus {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .sm\\:focus\\:via-pink-600:focus {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .sm\\:focus\\:via-pink-700:focus {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .sm\\:focus\\:via-pink-800:focus {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .sm\\:focus\\:via-pink-900:focus {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .sm\\:focus\\:to-transparent:focus {
    --gradient-to-color: transparent;
  }

  .sm\\:focus\\:to-current:focus {
    --gradient-to-color: currentColor;
  }

  .sm\\:focus\\:to-black:focus {
    --gradient-to-color: #000;
  }

  .sm\\:focus\\:to-white:focus {
    --gradient-to-color: #fff;
  }

  .sm\\:focus\\:to-gray-100:focus {
    --gradient-to-color: #f7fafc;
  }

  .sm\\:focus\\:to-gray-200:focus {
    --gradient-to-color: #edf2f7;
  }

  .sm\\:focus\\:to-gray-300:focus {
    --gradient-to-color: #e2e8f0;
  }

  .sm\\:focus\\:to-gray-400:focus {
    --gradient-to-color: #cbd5e0;
  }

  .sm\\:focus\\:to-gray-500:focus {
    --gradient-to-color: #a0aec0;
  }

  .sm\\:focus\\:to-gray-600:focus {
    --gradient-to-color: #718096;
  }

  .sm\\:focus\\:to-gray-700:focus {
    --gradient-to-color: #4a5568;
  }

  .sm\\:focus\\:to-gray-800:focus {
    --gradient-to-color: #2d3748;
  }

  .sm\\:focus\\:to-gray-900:focus {
    --gradient-to-color: #1a202c;
  }

  .sm\\:focus\\:to-red-100:focus {
    --gradient-to-color: #fff5f5;
  }

  .sm\\:focus\\:to-red-200:focus {
    --gradient-to-color: #fed7d7;
  }

  .sm\\:focus\\:to-red-300:focus {
    --gradient-to-color: #feb2b2;
  }

  .sm\\:focus\\:to-red-400:focus {
    --gradient-to-color: #fc8181;
  }

  .sm\\:focus\\:to-red-500:focus {
    --gradient-to-color: #f56565;
  }

  .sm\\:focus\\:to-red-600:focus {
    --gradient-to-color: #e53e3e;
  }

  .sm\\:focus\\:to-red-700:focus {
    --gradient-to-color: #c53030;
  }

  .sm\\:focus\\:to-red-800:focus {
    --gradient-to-color: #9b2c2c;
  }

  .sm\\:focus\\:to-red-900:focus {
    --gradient-to-color: #742a2a;
  }

  .sm\\:focus\\:to-orange-100:focus {
    --gradient-to-color: #fffaf0;
  }

  .sm\\:focus\\:to-orange-200:focus {
    --gradient-to-color: #feebc8;
  }

  .sm\\:focus\\:to-orange-300:focus {
    --gradient-to-color: #fbd38d;
  }

  .sm\\:focus\\:to-orange-400:focus {
    --gradient-to-color: #f6ad55;
  }

  .sm\\:focus\\:to-orange-500:focus {
    --gradient-to-color: #ed8936;
  }

  .sm\\:focus\\:to-orange-600:focus {
    --gradient-to-color: #dd6b20;
  }

  .sm\\:focus\\:to-orange-700:focus {
    --gradient-to-color: #c05621;
  }

  .sm\\:focus\\:to-orange-800:focus {
    --gradient-to-color: #9c4221;
  }

  .sm\\:focus\\:to-orange-900:focus {
    --gradient-to-color: #7b341e;
  }

  .sm\\:focus\\:to-yellow-100:focus {
    --gradient-to-color: #fffff0;
  }

  .sm\\:focus\\:to-yellow-200:focus {
    --gradient-to-color: #fefcbf;
  }

  .sm\\:focus\\:to-yellow-300:focus {
    --gradient-to-color: #faf089;
  }

  .sm\\:focus\\:to-yellow-400:focus {
    --gradient-to-color: #f6e05e;
  }

  .sm\\:focus\\:to-yellow-500:focus {
    --gradient-to-color: #ecc94b;
  }

  .sm\\:focus\\:to-yellow-600:focus {
    --gradient-to-color: #d69e2e;
  }

  .sm\\:focus\\:to-yellow-700:focus {
    --gradient-to-color: #b7791f;
  }

  .sm\\:focus\\:to-yellow-800:focus {
    --gradient-to-color: #975a16;
  }

  .sm\\:focus\\:to-yellow-900:focus {
    --gradient-to-color: #744210;
  }

  .sm\\:focus\\:to-green-100:focus {
    --gradient-to-color: #f0fff4;
  }

  .sm\\:focus\\:to-green-200:focus {
    --gradient-to-color: #c6f6d5;
  }

  .sm\\:focus\\:to-green-300:focus {
    --gradient-to-color: #9ae6b4;
  }

  .sm\\:focus\\:to-green-400:focus {
    --gradient-to-color: #68d391;
  }

  .sm\\:focus\\:to-green-500:focus {
    --gradient-to-color: #48bb78;
  }

  .sm\\:focus\\:to-green-600:focus {
    --gradient-to-color: #38a169;
  }

  .sm\\:focus\\:to-green-700:focus {
    --gradient-to-color: #2f855a;
  }

  .sm\\:focus\\:to-green-800:focus {
    --gradient-to-color: #276749;
  }

  .sm\\:focus\\:to-green-900:focus {
    --gradient-to-color: #22543d;
  }

  .sm\\:focus\\:to-teal-100:focus {
    --gradient-to-color: #e6fffa;
  }

  .sm\\:focus\\:to-teal-200:focus {
    --gradient-to-color: #b2f5ea;
  }

  .sm\\:focus\\:to-teal-300:focus {
    --gradient-to-color: #81e6d9;
  }

  .sm\\:focus\\:to-teal-400:focus {
    --gradient-to-color: #4fd1c5;
  }

  .sm\\:focus\\:to-teal-500:focus {
    --gradient-to-color: #38b2ac;
  }

  .sm\\:focus\\:to-teal-600:focus {
    --gradient-to-color: #319795;
  }

  .sm\\:focus\\:to-teal-700:focus {
    --gradient-to-color: #2c7a7b;
  }

  .sm\\:focus\\:to-teal-800:focus {
    --gradient-to-color: #285e61;
  }

  .sm\\:focus\\:to-teal-900:focus {
    --gradient-to-color: #234e52;
  }

  .sm\\:focus\\:to-blue-100:focus {
    --gradient-to-color: #ebf8ff;
  }

  .sm\\:focus\\:to-blue-200:focus {
    --gradient-to-color: #bee3f8;
  }

  .sm\\:focus\\:to-blue-300:focus {
    --gradient-to-color: #90cdf4;
  }

  .sm\\:focus\\:to-blue-400:focus {
    --gradient-to-color: #63b3ed;
  }

  .sm\\:focus\\:to-blue-500:focus {
    --gradient-to-color: #4299e1;
  }

  .sm\\:focus\\:to-blue-600:focus {
    --gradient-to-color: #3182ce;
  }

  .sm\\:focus\\:to-blue-700:focus {
    --gradient-to-color: #2b6cb0;
  }

  .sm\\:focus\\:to-blue-800:focus {
    --gradient-to-color: #2c5282;
  }

  .sm\\:focus\\:to-blue-900:focus {
    --gradient-to-color: #2a4365;
  }

  .sm\\:focus\\:to-indigo-100:focus {
    --gradient-to-color: #ebf4ff;
  }

  .sm\\:focus\\:to-indigo-200:focus {
    --gradient-to-color: #c3dafe;
  }

  .sm\\:focus\\:to-indigo-300:focus {
    --gradient-to-color: #a3bffa;
  }

  .sm\\:focus\\:to-indigo-400:focus {
    --gradient-to-color: #7f9cf5;
  }

  .sm\\:focus\\:to-indigo-500:focus {
    --gradient-to-color: #667eea;
  }

  .sm\\:focus\\:to-indigo-600:focus {
    --gradient-to-color: #5a67d8;
  }

  .sm\\:focus\\:to-indigo-700:focus {
    --gradient-to-color: #4c51bf;
  }

  .sm\\:focus\\:to-indigo-800:focus {
    --gradient-to-color: #434190;
  }

  .sm\\:focus\\:to-indigo-900:focus {
    --gradient-to-color: #3c366b;
  }

  .sm\\:focus\\:to-purple-100:focus {
    --gradient-to-color: #faf5ff;
  }

  .sm\\:focus\\:to-purple-200:focus {
    --gradient-to-color: #e9d8fd;
  }

  .sm\\:focus\\:to-purple-300:focus {
    --gradient-to-color: #d6bcfa;
  }

  .sm\\:focus\\:to-purple-400:focus {
    --gradient-to-color: #b794f4;
  }

  .sm\\:focus\\:to-purple-500:focus {
    --gradient-to-color: #9f7aea;
  }

  .sm\\:focus\\:to-purple-600:focus {
    --gradient-to-color: #805ad5;
  }

  .sm\\:focus\\:to-purple-700:focus {
    --gradient-to-color: #6b46c1;
  }

  .sm\\:focus\\:to-purple-800:focus {
    --gradient-to-color: #553c9a;
  }

  .sm\\:focus\\:to-purple-900:focus {
    --gradient-to-color: #44337a;
  }

  .sm\\:focus\\:to-pink-100:focus {
    --gradient-to-color: #fff5f7;
  }

  .sm\\:focus\\:to-pink-200:focus {
    --gradient-to-color: #fed7e2;
  }

  .sm\\:focus\\:to-pink-300:focus {
    --gradient-to-color: #fbb6ce;
  }

  .sm\\:focus\\:to-pink-400:focus {
    --gradient-to-color: #f687b3;
  }

  .sm\\:focus\\:to-pink-500:focus {
    --gradient-to-color: #ed64a6;
  }

  .sm\\:focus\\:to-pink-600:focus {
    --gradient-to-color: #d53f8c;
  }

  .sm\\:focus\\:to-pink-700:focus {
    --gradient-to-color: #b83280;
  }

  .sm\\:focus\\:to-pink-800:focus {
    --gradient-to-color: #97266d;
  }

  .sm\\:focus\\:to-pink-900:focus {
    --gradient-to-color: #702459;
  }

  .sm\\:bg-opacity-0 {
    --bg-opacity: 0;
  }

  .sm\\:bg-opacity-25 {
    --bg-opacity: 0.25;
  }

  .sm\\:bg-opacity-50 {
    --bg-opacity: 0.5;
  }

  .sm\\:bg-opacity-75 {
    --bg-opacity: 0.75;
  }

  .sm\\:bg-opacity-100 {
    --bg-opacity: 1;
  }

  .sm\\:hover\\:bg-opacity-0:hover {
    --bg-opacity: 0;
  }

  .sm\\:hover\\:bg-opacity-25:hover {
    --bg-opacity: 0.25;
  }

  .sm\\:hover\\:bg-opacity-50:hover {
    --bg-opacity: 0.5;
  }

  .sm\\:hover\\:bg-opacity-75:hover {
    --bg-opacity: 0.75;
  }

  .sm\\:hover\\:bg-opacity-100:hover {
    --bg-opacity: 1;
  }

  .sm\\:focus\\:bg-opacity-0:focus {
    --bg-opacity: 0;
  }

  .sm\\:focus\\:bg-opacity-25:focus {
    --bg-opacity: 0.25;
  }

  .sm\\:focus\\:bg-opacity-50:focus {
    --bg-opacity: 0.5;
  }

  .sm\\:focus\\:bg-opacity-75:focus {
    --bg-opacity: 0.75;
  }

  .sm\\:focus\\:bg-opacity-100:focus {
    --bg-opacity: 1;
  }

  .sm\\:bg-bottom {
    background-position: bottom;
  }

  .sm\\:bg-center {
    background-position: center;
  }

  .sm\\:bg-left {
    background-position: left;
  }

  .sm\\:bg-left-bottom {
    background-position: left bottom;
  }

  .sm\\:bg-left-top {
    background-position: left top;
  }

  .sm\\:bg-right {
    background-position: right;
  }

  .sm\\:bg-right-bottom {
    background-position: right bottom;
  }

  .sm\\:bg-right-top {
    background-position: right top;
  }

  .sm\\:bg-top {
    background-position: top;
  }

  .sm\\:bg-repeat {
    background-repeat: repeat;
  }

  .sm\\:bg-no-repeat {
    background-repeat: no-repeat;
  }

  .sm\\:bg-repeat-x {
    background-repeat: repeat-x;
  }

  .sm\\:bg-repeat-y {
    background-repeat: repeat-y;
  }

  .sm\\:bg-repeat-round {
    background-repeat: round;
  }

  .sm\\:bg-repeat-space {
    background-repeat: space;
  }

  .sm\\:bg-auto {
    background-size: auto;
  }

  .sm\\:bg-cover {
    background-size: cover;
  }

  .sm\\:bg-contain {
    background-size: contain;
  }

  .sm\\:border-collapse {
    border-collapse: collapse;
  }

  .sm\\:border-separate {
    border-collapse: separate;
  }

  .sm\\:border-transparent {
    border-color: transparent;
  }

  .sm\\:border-current {
    border-color: currentColor;
  }

  .sm\\:border-black {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .sm\\:border-white {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .sm\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .sm\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .sm\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .sm\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .sm\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .sm\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .sm\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .sm\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .sm\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .sm\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .sm\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .sm\\:border-red-300 {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .sm\\:border-red-400 {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .sm\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .sm\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .sm\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .sm\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .sm\\:border-red-900 {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .sm\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .sm\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .sm\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .sm\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .sm\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .sm\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .sm\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .sm\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .sm\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .sm\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .sm\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .sm\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .sm\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .sm\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .sm\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .sm\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .sm\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .sm\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .sm\\:border-green-100 {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .sm\\:border-green-200 {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .sm\\:border-green-300 {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .sm\\:border-green-400 {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .sm\\:border-green-500 {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .sm\\:border-green-600 {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .sm\\:border-green-700 {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .sm\\:border-green-800 {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .sm\\:border-green-900 {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .sm\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .sm\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .sm\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .sm\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .sm\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .sm\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .sm\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .sm\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .sm\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .sm\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .sm\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .sm\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .sm\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .sm\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .sm\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .sm\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .sm\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .sm\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .sm\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .sm\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .sm\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .sm\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .sm\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .sm\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .sm\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .sm\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .sm\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .sm\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .sm\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .sm\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .sm\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .sm\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .sm\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .sm\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .sm\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .sm\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .sm\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .sm\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .sm\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .sm\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .sm\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .sm\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .sm\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .sm\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .sm\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .sm\\:hover\\:border-transparent:hover {
    border-color: transparent;
  }

  .sm\\:hover\\:border-current:hover {
    border-color: currentColor;
  }

  .sm\\:hover\\:border-black:hover {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .sm\\:hover\\:border-white:hover {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-100:hover {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-200:hover {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-300:hover {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-400:hover {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-500:hover {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-600:hover {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-700:hover {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-800:hover {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-900:hover {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-100:hover {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-200:hover {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-300:hover {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-400:hover {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-500:hover {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-600:hover {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-700:hover {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-800:hover {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-900:hover {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-100:hover {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-200:hover {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-300:hover {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-400:hover {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-500:hover {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-600:hover {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-700:hover {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-800:hover {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-900:hover {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-100:hover {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-200:hover {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-300:hover {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-400:hover {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-500:hover {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-600:hover {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-700:hover {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-800:hover {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-900:hover {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-100:hover {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-200:hover {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-300:hover {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-400:hover {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-500:hover {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-600:hover {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-700:hover {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-800:hover {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-900:hover {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-100:hover {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-200:hover {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-300:hover {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-400:hover {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-500:hover {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-600:hover {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-700:hover {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-800:hover {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .sm\\:hover\\:border-teal-900:hover {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-100:hover {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-200:hover {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-300:hover {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-400:hover {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-500:hover {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-600:hover {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-700:hover {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-800:hover {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-900:hover {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-100:hover {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-200:hover {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-300:hover {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-400:hover {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-500:hover {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-600:hover {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-700:hover {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-800:hover {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .sm\\:hover\\:border-indigo-900:hover {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-100:hover {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-200:hover {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-300:hover {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-400:hover {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-500:hover {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-600:hover {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-700:hover {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-800:hover {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .sm\\:hover\\:border-purple-900:hover {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-100:hover {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-200:hover {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-300:hover {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-400:hover {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-500:hover {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-600:hover {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-700:hover {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-800:hover {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .sm\\:hover\\:border-pink-900:hover {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .sm\\:focus\\:border-transparent:focus {
    border-color: transparent;
  }

  .sm\\:focus\\:border-current:focus {
    border-color: currentColor;
  }

  .sm\\:focus\\:border-black:focus {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .sm\\:focus\\:border-white:focus {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-100:focus {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-200:focus {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-300:focus {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-400:focus {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-500:focus {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-600:focus {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-700:focus {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-800:focus {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-900:focus {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-100:focus {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-200:focus {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-300:focus {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-400:focus {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-500:focus {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-600:focus {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-700:focus {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-800:focus {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-900:focus {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-100:focus {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-200:focus {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-300:focus {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-400:focus {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-500:focus {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-600:focus {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-700:focus {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-800:focus {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-900:focus {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-100:focus {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-200:focus {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-300:focus {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-400:focus {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-500:focus {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-600:focus {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-700:focus {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-800:focus {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-900:focus {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-100:focus {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-200:focus {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-300:focus {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-400:focus {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-500:focus {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-600:focus {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-700:focus {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-800:focus {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-900:focus {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-100:focus {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-200:focus {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-300:focus {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-400:focus {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-500:focus {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-600:focus {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-700:focus {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-800:focus {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .sm\\:focus\\:border-teal-900:focus {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-100:focus {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-200:focus {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-300:focus {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-400:focus {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-500:focus {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-600:focus {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-700:focus {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-800:focus {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-900:focus {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-100:focus {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-200:focus {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-300:focus {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-400:focus {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-500:focus {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-600:focus {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-700:focus {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-800:focus {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .sm\\:focus\\:border-indigo-900:focus {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-100:focus {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-200:focus {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-300:focus {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-400:focus {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-500:focus {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-600:focus {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-700:focus {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-800:focus {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .sm\\:focus\\:border-purple-900:focus {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-100:focus {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-200:focus {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-300:focus {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-400:focus {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-500:focus {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-600:focus {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-700:focus {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-800:focus {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .sm\\:focus\\:border-pink-900:focus {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .sm\\:border-opacity-0 {
    --border-opacity: 0;
  }

  .sm\\:border-opacity-25 {
    --border-opacity: 0.25;
  }

  .sm\\:border-opacity-50 {
    --border-opacity: 0.5;
  }

  .sm\\:border-opacity-75 {
    --border-opacity: 0.75;
  }

  .sm\\:border-opacity-100 {
    --border-opacity: 1;
  }

  .sm\\:hover\\:border-opacity-0:hover {
    --border-opacity: 0;
  }

  .sm\\:hover\\:border-opacity-25:hover {
    --border-opacity: 0.25;
  }

  .sm\\:hover\\:border-opacity-50:hover {
    --border-opacity: 0.5;
  }

  .sm\\:hover\\:border-opacity-75:hover {
    --border-opacity: 0.75;
  }

  .sm\\:hover\\:border-opacity-100:hover {
    --border-opacity: 1;
  }

  .sm\\:focus\\:border-opacity-0:focus {
    --border-opacity: 0;
  }

  .sm\\:focus\\:border-opacity-25:focus {
    --border-opacity: 0.25;
  }

  .sm\\:focus\\:border-opacity-50:focus {
    --border-opacity: 0.5;
  }

  .sm\\:focus\\:border-opacity-75:focus {
    --border-opacity: 0.75;
  }

  .sm\\:focus\\:border-opacity-100:focus {
    --border-opacity: 1;
  }

  .sm\\:rounded-none {
    border-radius: 0;
  }

  .sm\\:rounded-sm {
    border-radius: 0.125rem;
  }

  .sm\\:rounded {
    border-radius: 0.25rem;
  }

  .sm\\:rounded-md {
    border-radius: 0.375rem;
  }

  .sm\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .sm\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .sm\\:rounded-2xl {
    border-radius: 1rem;
  }

  .sm\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .sm\\:rounded-full {
    border-radius: 9999px;
  }

  .sm\\:rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .sm\\:rounded-r-none {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .sm\\:rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .sm\\:rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .sm\\:rounded-t-sm {
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
  }

  .sm\\:rounded-r-sm {
    border-top-right-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
  }

  .sm\\:rounded-b-sm {
    border-bottom-right-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }

  .sm\\:rounded-l-sm {
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }

  .sm\\:rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .sm\\:rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }

  .sm\\:rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .sm\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .sm\\:rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }

  .sm\\:rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }

  .sm\\:rounded-b-md {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }

  .sm\\:rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }

  .sm\\:rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  .sm\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .sm\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .sm\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .sm\\:rounded-t-xl {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }

  .sm\\:rounded-r-xl {
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }

  .sm\\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .sm\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .sm\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  .sm\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }

  .sm\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .sm\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .sm\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .sm\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .sm\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .sm\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .sm\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .sm\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .sm\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .sm\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .sm\\:rounded-tl-none {
    border-top-left-radius: 0;
  }

  .sm\\:rounded-tr-none {
    border-top-right-radius: 0;
  }

  .sm\\:rounded-br-none {
    border-bottom-right-radius: 0;
  }

  .sm\\:rounded-bl-none {
    border-bottom-left-radius: 0;
  }

  .sm\\:rounded-tl-sm {
    border-top-left-radius: 0.125rem;
  }

  .sm\\:rounded-tr-sm {
    border-top-right-radius: 0.125rem;
  }

  .sm\\:rounded-br-sm {
    border-bottom-right-radius: 0.125rem;
  }

  .sm\\:rounded-bl-sm {
    border-bottom-left-radius: 0.125rem;
  }

  .sm\\:rounded-tl {
    border-top-left-radius: 0.25rem;
  }

  .sm\\:rounded-tr {
    border-top-right-radius: 0.25rem;
  }

  .sm\\:rounded-br {
    border-bottom-right-radius: 0.25rem;
  }

  .sm\\:rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }

  .sm\\:rounded-tl-md {
    border-top-left-radius: 0.375rem;
  }

  .sm\\:rounded-tr-md {
    border-top-right-radius: 0.375rem;
  }

  .sm\\:rounded-br-md {
    border-bottom-right-radius: 0.375rem;
  }

  .sm\\:rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
  }

  .sm\\:rounded-tl-lg {
    border-top-left-radius: 0.5rem;
  }

  .sm\\:rounded-tr-lg {
    border-top-right-radius: 0.5rem;
  }

  .sm\\:rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
  }

  .sm\\:rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
  }

  .sm\\:rounded-tl-xl {
    border-top-left-radius: 0.75rem;
  }

  .sm\\:rounded-tr-xl {
    border-top-right-radius: 0.75rem;
  }

  .sm\\:rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
  }

  .sm\\:rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
  }

  .sm\\:rounded-tl-2xl {
    border-top-left-radius: 1rem;
  }

  .sm\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }

  .sm\\:rounded-br-2xl {
    border-bottom-right-radius: 1rem;
  }

  .sm\\:rounded-bl-2xl {
    border-bottom-left-radius: 1rem;
  }

  .sm\\:rounded-tl-3xl {
    border-top-left-radius: 1.5rem;
  }

  .sm\\:rounded-tr-3xl {
    border-top-right-radius: 1.5rem;
  }

  .sm\\:rounded-br-3xl {
    border-bottom-right-radius: 1.5rem;
  }

  .sm\\:rounded-bl-3xl {
    border-bottom-left-radius: 1.5rem;
  }

  .sm\\:rounded-tl-full {
    border-top-left-radius: 9999px;
  }

  .sm\\:rounded-tr-full {
    border-top-right-radius: 9999px;
  }

  .sm\\:rounded-br-full {
    border-bottom-right-radius: 9999px;
  }

  .sm\\:rounded-bl-full {
    border-bottom-left-radius: 9999px;
  }

  .sm\\:border-solid {
    border-style: solid;
  }

  .sm\\:border-dashed {
    border-style: dashed;
  }

  .sm\\:border-dotted {
    border-style: dotted;
  }

  .sm\\:border-double {
    border-style: double;
  }

  .sm\\:border-none {
    border-style: none;
  }

  .sm\\:border-0 {
    border-width: 0;
  }

  .sm\\:border-2 {
    border-width: 2px;
  }

  .sm\\:border-4 {
    border-width: 4px;
  }

  .sm\\:border-8 {
    border-width: 8px;
  }

  .sm\\:border {
    border-width: 1px;
  }

  .sm\\:border-t-0 {
    border-top-width: 0;
  }

  .sm\\:border-r-0 {
    border-right-width: 0;
  }

  .sm\\:border-b-0 {
    border-bottom-width: 0;
  }

  .sm\\:border-l-0 {
    border-left-width: 0;
  }

  .sm\\:border-t-2 {
    border-top-width: 2px;
  }

  .sm\\:border-r-2 {
    border-right-width: 2px;
  }

  .sm\\:border-b-2 {
    border-bottom-width: 2px;
  }

  .sm\\:border-l-2 {
    border-left-width: 2px;
  }

  .sm\\:border-t-4 {
    border-top-width: 4px;
  }

  .sm\\:border-r-4 {
    border-right-width: 4px;
  }

  .sm\\:border-b-4 {
    border-bottom-width: 4px;
  }

  .sm\\:border-l-4 {
    border-left-width: 4px;
  }

  .sm\\:border-t-8 {
    border-top-width: 8px;
  }

  .sm\\:border-r-8 {
    border-right-width: 8px;
  }

  .sm\\:border-b-8 {
    border-bottom-width: 8px;
  }

  .sm\\:border-l-8 {
    border-left-width: 8px;
  }

  .sm\\:border-t {
    border-top-width: 1px;
  }

  .sm\\:border-r {
    border-right-width: 1px;
  }

  .sm\\:border-b {
    border-bottom-width: 1px;
  }

  .sm\\:border-l {
    border-left-width: 1px;
  }

  .sm\\:box-border {
    box-sizing: border-box;
  }

  .sm\\:box-content {
    box-sizing: content-box;
  }

  .sm\\:cursor-auto {
    cursor: auto;
  }

  .sm\\:cursor-default {
    cursor: default;
  }

  .sm\\:cursor-pointer {
    cursor: pointer;
  }

  .sm\\:cursor-wait {
    cursor: wait;
  }

  .sm\\:cursor-text {
    cursor: text;
  }

  .sm\\:cursor-move {
    cursor: move;
  }

  .sm\\:cursor-not-allowed {
    cursor: not-allowed;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:inline-block {
    display: inline-block;
  }

  .sm\\:inline {
    display: inline;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:inline-flex {
    display: inline-flex;
  }

  .sm\\:table {
    display: table;
  }

  .sm\\:table-caption {
    display: table-caption;
  }

  .sm\\:table-cell {
    display: table-cell;
  }

  .sm\\:table-column {
    display: table-column;
  }

  .sm\\:table-column-group {
    display: table-column-group;
  }

  .sm\\:table-footer-group {
    display: table-footer-group;
  }

  .sm\\:table-header-group {
    display: table-header-group;
  }

  .sm\\:table-row-group {
    display: table-row-group;
  }

  .sm\\:table-row {
    display: table-row;
  }

  .sm\\:flow-root {
    display: flow-root;
  }

  .sm\\:grid {
    display: grid;
  }

  .sm\\:inline-grid {
    display: inline-grid;
  }

  .sm\\:contents {
    display: contents;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .sm\\:flex-col {
    flex-direction: column;
  }

  .sm\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .sm\\:flex-wrap {
    flex-wrap: wrap;
  }

  .sm\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .sm\\:flex-no-wrap {
    flex-wrap: nowrap;
  }

  .sm\\:place-items-auto {
    place-items: auto;
  }

  .sm\\:place-items-start {
    place-items: start;
  }

  .sm\\:place-items-end {
    place-items: end;
  }

  .sm\\:place-items-center {
    place-items: center;
  }

  .sm\\:place-items-stretch {
    place-items: stretch;
  }

  .sm\\:place-content-center {
    place-content: center;
  }

  .sm\\:place-content-start {
    place-content: start;
  }

  .sm\\:place-content-end {
    place-content: end;
  }

  .sm\\:place-content-between {
    place-content: space-between;
  }

  .sm\\:place-content-around {
    place-content: space-around;
  }

  .sm\\:place-content-evenly {
    place-content: space-evenly;
  }

  .sm\\:place-content-stretch {
    place-content: stretch;
  }

  .sm\\:place-self-auto {
    place-self: auto;
  }

  .sm\\:place-self-start {
    place-self: start;
  }

  .sm\\:place-self-end {
    place-self: end;
  }

  .sm\\:place-self-center {
    place-self: center;
  }

  .sm\\:place-self-stretch {
    place-self: stretch;
  }

  .sm\\:items-start {
    align-items: flex-start;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:items-baseline {
    align-items: baseline;
  }

  .sm\\:items-stretch {
    align-items: stretch;
  }

  .sm\\:content-center {
    align-content: center;
  }

  .sm\\:content-start {
    align-content: flex-start;
  }

  .sm\\:content-end {
    align-content: flex-end;
  }

  .sm\\:content-between {
    align-content: space-between;
  }

  .sm\\:content-around {
    align-content: space-around;
  }

  .sm\\:content-evenly {
    align-content: space-evenly;
  }

  .sm\\:self-auto {
    align-self: auto;
  }

  .sm\\:self-start {
    align-self: flex-start;
  }

  .sm\\:self-end {
    align-self: flex-end;
  }

  .sm\\:self-center {
    align-self: center;
  }

  .sm\\:self-stretch {
    align-self: stretch;
  }

  .sm\\:justify-items-auto {
    justify-items: auto;
  }

  .sm\\:justify-items-start {
    justify-items: start;
  }

  .sm\\:justify-items-end {
    justify-items: end;
  }

  .sm\\:justify-items-center {
    justify-items: center;
  }

  .sm\\:justify-items-stretch {
    justify-items: stretch;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:justify-center {
    justify-content: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:justify-around {
    justify-content: space-around;
  }

  .sm\\:justify-evenly {
    justify-content: space-evenly;
  }

  .sm\\:justify-self-auto {
    justify-self: auto;
  }

  .sm\\:justify-self-start {
    justify-self: start;
  }

  .sm\\:justify-self-end {
    justify-self: end;
  }

  .sm\\:justify-self-center {
    justify-self: center;
  }

  .sm\\:justify-self-stretch {
    justify-self: stretch;
  }

  .sm\\:flex-1 {
    flex: 1 1;
  }

  .sm\\:flex-auto {
    flex: 1 1 auto;
  }

  .sm\\:flex-initial {
    flex: 0 1 auto;
  }

  .sm\\:flex-none {
    flex: none;
  }

  .sm\\:flex-grow-0 {
    flex-grow: 0;
  }

  .sm\\:flex-grow {
    flex-grow: 1;
  }

  .sm\\:flex-shrink-0 {
    flex-shrink: 0;
  }

  .sm\\:flex-shrink {
    flex-shrink: 1;
  }

  .sm\\:order-1 {
    order: 1;
  }

  .sm\\:order-2 {
    order: 2;
  }

  .sm\\:order-3 {
    order: 3;
  }

  .sm\\:order-4 {
    order: 4;
  }

  .sm\\:order-5 {
    order: 5;
  }

  .sm\\:order-6 {
    order: 6;
  }

  .sm\\:order-7 {
    order: 7;
  }

  .sm\\:order-8 {
    order: 8;
  }

  .sm\\:order-9 {
    order: 9;
  }

  .sm\\:order-10 {
    order: 10;
  }

  .sm\\:order-11 {
    order: 11;
  }

  .sm\\:order-12 {
    order: 12;
  }

  .sm\\:order-first {
    order: -9999;
  }

  .sm\\:order-last {
    order: 9999;
  }

  .sm\\:order-none {
    order: 0;
  }

  .sm\\:float-right {
    float: right;
  }

  .sm\\:float-left {
    float: left;
  }

  .sm\\:float-none {
    float: none;
  }

  .sm\\:clearfix:after {
    content: "";
    display: table;
    clear: both;
  }

  .sm\\:clear-left {
    clear: left;
  }

  .sm\\:clear-right {
    clear: right;
  }

  .sm\\:clear-both {
    clear: both;
  }

  .sm\\:clear-none {
    clear: none;
  }

  .sm\\:font-sans {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .sm\\:font-serif {
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .sm\\:font-mono {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .sm\\:font-hairline {
    font-weight: 100;
  }

  .sm\\:font-thin {
    font-weight: 200;
  }

  .sm\\:font-light {
    font-weight: 300;
  }

  .sm\\:font-normal {
    font-weight: 400;
  }

  .sm\\:font-medium {
    font-weight: 500;
  }

  .sm\\:font-semibold {
    font-weight: 600;
  }

  .sm\\:font-bold {
    font-weight: 700;
  }

  .sm\\:font-extrabold {
    font-weight: 800;
  }

  .sm\\:font-black {
    font-weight: 900;
  }

  .sm\\:hover\\:font-hairline:hover {
    font-weight: 100;
  }

  .sm\\:hover\\:font-thin:hover {
    font-weight: 200;
  }

  .sm\\:hover\\:font-light:hover {
    font-weight: 300;
  }

  .sm\\:hover\\:font-normal:hover {
    font-weight: 400;
  }

  .sm\\:hover\\:font-medium:hover {
    font-weight: 500;
  }

  .sm\\:hover\\:font-semibold:hover {
    font-weight: 600;
  }

  .sm\\:hover\\:font-bold:hover {
    font-weight: 700;
  }

  .sm\\:hover\\:font-extrabold:hover {
    font-weight: 800;
  }

  .sm\\:hover\\:font-black:hover {
    font-weight: 900;
  }

  .sm\\:focus\\:font-hairline:focus {
    font-weight: 100;
  }

  .sm\\:focus\\:font-thin:focus {
    font-weight: 200;
  }

  .sm\\:focus\\:font-light:focus {
    font-weight: 300;
  }

  .sm\\:focus\\:font-normal:focus {
    font-weight: 400;
  }

  .sm\\:focus\\:font-medium:focus {
    font-weight: 500;
  }

  .sm\\:focus\\:font-semibold:focus {
    font-weight: 600;
  }

  .sm\\:focus\\:font-bold:focus {
    font-weight: 700;
  }

  .sm\\:focus\\:font-extrabold:focus {
    font-weight: 800;
  }

  .sm\\:focus\\:font-black:focus {
    font-weight: 900;
  }

  .sm\\:h-0 {
    height: 0;
  }

  .sm\\:h-1 {
    height: 0.25rem;
  }

  .sm\\:h-2 {
    height: 0.5rem;
  }

  .sm\\:h-3 {
    height: 0.75rem;
  }

  .sm\\:h-4 {
    height: 1rem;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-6 {
    height: 1.5rem;
  }

  .sm\\:h-8 {
    height: 2rem;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-16 {
    height: 4rem;
  }

  .sm\\:h-20 {
    height: 5rem;
  }

  .sm\\:h-24 {
    height: 6rem;
  }

  .sm\\:h-32 {
    height: 8rem;
  }

  .sm\\:h-40 {
    height: 10rem;
  }

  .sm\\:h-48 {
    height: 12rem;
  }

  .sm\\:h-56 {
    height: 14rem;
  }

  .sm\\:h-64 {
    height: 16rem;
  }

  .sm\\:h-auto {
    height: auto;
  }

  .sm\\:h-px {
    height: 1px;
  }

  .sm\\:h-full {
    height: 100%;
  }

  .sm\\:h-screen {
    height: 100vh;
  }

  .sm\\:text-15 {
    font-size: 0.9375rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
  }

  .sm\\:text-base {
    font-size: 1rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
  }

  .sm\\:text-xl {
    font-size: 1.25rem;
  }

  .sm\\:text-1\\.5xl {
    font-size: 1.375rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
  }

  .sm\\:text-5xl {
    font-size: 3rem;
  }

  .sm\\:text-6xl {
    font-size: 4rem;
  }

  .sm\\:leading-3 {
    line-height: 0.75rem;
  }

  .sm\\:leading-4 {
    line-height: 1rem;
  }

  .sm\\:leading-5 {
    line-height: 1.25rem;
  }

  .sm\\:leading-6 {
    line-height: 1.5rem;
  }

  .sm\\:leading-7 {
    line-height: 1.75rem;
  }

  .sm\\:leading-8 {
    line-height: 2rem;
  }

  .sm\\:leading-9 {
    line-height: 2.25rem;
  }

  .sm\\:leading-10 {
    line-height: 2.5rem;
  }

  .sm\\:leading-none {
    line-height: 1;
  }

  .sm\\:leading-tight {
    line-height: 1.25;
  }

  .sm\\:leading-snug {
    line-height: 1.375;
  }

  .sm\\:leading-normal {
    line-height: 1.5;
  }

  .sm\\:leading-relaxed {
    line-height: 1.625;
  }

  .sm\\:leading-loose {
    line-height: 2;
  }

  .sm\\:list-inside {
    list-style-position: inside;
  }

  .sm\\:list-outside {
    list-style-position: outside;
  }

  .sm\\:list-none {
    list-style-type: none;
  }

  .sm\\:list-disc {
    list-style-type: disc;
  }

  .sm\\:list-decimal {
    list-style-type: decimal;
  }

  .sm\\:m-0 {
    margin: 0;
  }

  .sm\\:m-1 {
    margin: 0.25rem;
  }

  .sm\\:m-2 {
    margin: 0.5rem;
  }

  .sm\\:m-3 {
    margin: 0.75rem;
  }

  .sm\\:m-4 {
    margin: 1rem;
  }

  .sm\\:m-5 {
    margin: 1.25rem;
  }

  .sm\\:m-6 {
    margin: 1.5rem;
  }

  .sm\\:m-8 {
    margin: 2rem;
  }

  .sm\\:m-10 {
    margin: 2.5rem;
  }

  .sm\\:m-12 {
    margin: 3rem;
  }

  .sm\\:m-16 {
    margin: 4rem;
  }

  .sm\\:m-20 {
    margin: 5rem;
  }

  .sm\\:m-24 {
    margin: 6rem;
  }

  .sm\\:m-32 {
    margin: 8rem;
  }

  .sm\\:m-40 {
    margin: 10rem;
  }

  .sm\\:m-48 {
    margin: 12rem;
  }

  .sm\\:m-56 {
    margin: 14rem;
  }

  .sm\\:m-64 {
    margin: 16rem;
  }

  .sm\\:m-auto {
    margin: auto;
  }

  .sm\\:m-px {
    margin: 1px;
  }

  .sm\\:-m-1 {
    margin: -0.25rem;
  }

  .sm\\:-m-2 {
    margin: -0.5rem;
  }

  .sm\\:-m-3 {
    margin: -0.75rem;
  }

  .sm\\:-m-4 {
    margin: -1rem;
  }

  .sm\\:-m-5 {
    margin: -1.25rem;
  }

  .sm\\:-m-6 {
    margin: -1.5rem;
  }

  .sm\\:-m-8 {
    margin: -2rem;
  }

  .sm\\:-m-10 {
    margin: -2.5rem;
  }

  .sm\\:-m-12 {
    margin: -3rem;
  }

  .sm\\:-m-16 {
    margin: -4rem;
  }

  .sm\\:-m-20 {
    margin: -5rem;
  }

  .sm\\:-m-24 {
    margin: -6rem;
  }

  .sm\\:-m-32 {
    margin: -8rem;
  }

  .sm\\:-m-40 {
    margin: -10rem;
  }

  .sm\\:-m-48 {
    margin: -12rem;
  }

  .sm\\:-m-56 {
    margin: -14rem;
  }

  .sm\\:-m-64 {
    margin: -16rem;
  }

  .sm\\:-m-px {
    margin: -1px;
  }

  .sm\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:mx-0 {
    margin-left: 0;
    margin-right: 0;
  }

  .sm\\:my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .sm\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .sm\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .sm\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .sm\\:my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .sm\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .sm\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .sm\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sm\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .sm\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .sm\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .sm\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .sm\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .sm\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .sm\\:mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .sm\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .sm\\:mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .sm\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .sm\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .sm\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .sm\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .sm\\:my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .sm\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .sm\\:my-32 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .sm\\:mx-32 {
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .sm\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .sm\\:mx-40 {
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .sm\\:my-48 {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .sm\\:mx-48 {
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .sm\\:my-56 {
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .sm\\:mx-56 {
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .sm\\:my-64 {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .sm\\:mx-64 {
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .sm\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }

  .sm\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:my-px {
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .sm\\:mx-px {
    margin-left: 1px;
    margin-right: 1px;
  }

  .sm\\:-my-1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .sm\\:-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .sm\\:-my-2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .sm\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .sm\\:-my-3 {
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .sm\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .sm\\:-my-4 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .sm\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .sm\\:-my-5 {
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .sm\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .sm\\:-my-6 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .sm\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:-my-8 {
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .sm\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .sm\\:-my-10 {
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .sm\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .sm\\:-my-12 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .sm\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .sm\\:-my-16 {
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .sm\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .sm\\:-my-20 {
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .sm\\:-mx-20 {
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .sm\\:-my-24 {
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .sm\\:-mx-24 {
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .sm\\:-my-32 {
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .sm\\:-mx-32 {
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .sm\\:-my-40 {
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .sm\\:-mx-40 {
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .sm\\:-my-48 {
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .sm\\:-mx-48 {
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .sm\\:-my-56 {
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .sm\\:-mx-56 {
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .sm\\:-my-64 {
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .sm\\:-mx-64 {
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .sm\\:-my-px {
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .sm\\:-mx-px {
    margin-left: -1px;
    margin-right: -1px;
  }

  .sm\\:mt-0 {
    margin-top: 0;
  }

  .sm\\:mr-0 {
    margin-right: 0;
  }

  .sm\\:mb-0 {
    margin-bottom: 0;
  }

  .sm\\:ml-0 {
    margin-left: 0;
  }

  .sm\\:mt-1 {
    margin-top: 0.25rem;
  }

  .sm\\:mr-1 {
    margin-right: 0.25rem;
  }

  .sm\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .sm\\:ml-1 {
    margin-left: 0.25rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mr-2 {
    margin-right: 0.5rem;
  }

  .sm\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .sm\\:ml-2 {
    margin-left: 0.5rem;
  }

  .sm\\:mt-3 {
    margin-top: 0.75rem;
  }

  .sm\\:mr-3 {
    margin-right: 0.75rem;
  }

  .sm\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .sm\\:ml-3 {
    margin-left: 0.75rem;
  }

  .sm\\:mt-4 {
    margin-top: 1rem;
  }

  .sm\\:mr-4 {
    margin-right: 1rem;
  }

  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }

  .sm\\:ml-4 {
    margin-left: 1rem;
  }

  .sm\\:mt-5 {
    margin-top: 1.25rem;
  }

  .sm\\:mr-5 {
    margin-right: 1.25rem;
  }

  .sm\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .sm\\:ml-5 {
    margin-left: 1.25rem;
  }

  .sm\\:mt-6 {
    margin-top: 1.5rem;
  }

  .sm\\:mr-6 {
    margin-right: 1.5rem;
  }

  .sm\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .sm\\:ml-6 {
    margin-left: 1.5rem;
  }

  .sm\\:mt-8 {
    margin-top: 2rem;
  }

  .sm\\:mr-8 {
    margin-right: 2rem;
  }

  .sm\\:mb-8 {
    margin-bottom: 2rem;
  }

  .sm\\:ml-8 {
    margin-left: 2rem;
  }

  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }

  .sm\\:mr-10 {
    margin-right: 2.5rem;
  }

  .sm\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .sm\\:ml-10 {
    margin-left: 2.5rem;
  }

  .sm\\:mt-12 {
    margin-top: 3rem;
  }

  .sm\\:mr-12 {
    margin-right: 3rem;
  }

  .sm\\:mb-12 {
    margin-bottom: 3rem;
  }

  .sm\\:ml-12 {
    margin-left: 3rem;
  }

  .sm\\:mt-16 {
    margin-top: 4rem;
  }

  .sm\\:mr-16 {
    margin-right: 4rem;
  }

  .sm\\:mb-16 {
    margin-bottom: 4rem;
  }

  .sm\\:ml-16 {
    margin-left: 4rem;
  }

  .sm\\:mt-20 {
    margin-top: 5rem;
  }

  .sm\\:mr-20 {
    margin-right: 5rem;
  }

  .sm\\:mb-20 {
    margin-bottom: 5rem;
  }

  .sm\\:ml-20 {
    margin-left: 5rem;
  }

  .sm\\:mt-24 {
    margin-top: 6rem;
  }

  .sm\\:mr-24 {
    margin-right: 6rem;
  }

  .sm\\:mb-24 {
    margin-bottom: 6rem;
  }

  .sm\\:ml-24 {
    margin-left: 6rem;
  }

  .sm\\:mt-32 {
    margin-top: 8rem;
  }

  .sm\\:mr-32 {
    margin-right: 8rem;
  }

  .sm\\:mb-32 {
    margin-bottom: 8rem;
  }

  .sm\\:ml-32 {
    margin-left: 8rem;
  }

  .sm\\:mt-40 {
    margin-top: 10rem;
  }

  .sm\\:mr-40 {
    margin-right: 10rem;
  }

  .sm\\:mb-40 {
    margin-bottom: 10rem;
  }

  .sm\\:ml-40 {
    margin-left: 10rem;
  }

  .sm\\:mt-48 {
    margin-top: 12rem;
  }

  .sm\\:mr-48 {
    margin-right: 12rem;
  }

  .sm\\:mb-48 {
    margin-bottom: 12rem;
  }

  .sm\\:ml-48 {
    margin-left: 12rem;
  }

  .sm\\:mt-56 {
    margin-top: 14rem;
  }

  .sm\\:mr-56 {
    margin-right: 14rem;
  }

  .sm\\:mb-56 {
    margin-bottom: 14rem;
  }

  .sm\\:ml-56 {
    margin-left: 14rem;
  }

  .sm\\:mt-64 {
    margin-top: 16rem;
  }

  .sm\\:mr-64 {
    margin-right: 16rem;
  }

  .sm\\:mb-64 {
    margin-bottom: 16rem;
  }

  .sm\\:ml-64 {
    margin-left: 16rem;
  }

  .sm\\:mt-auto {
    margin-top: auto;
  }

  .sm\\:mr-auto {
    margin-right: auto;
  }

  .sm\\:mb-auto {
    margin-bottom: auto;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:mt-px {
    margin-top: 1px;
  }

  .sm\\:mr-px {
    margin-right: 1px;
  }

  .sm\\:mb-px {
    margin-bottom: 1px;
  }

  .sm\\:ml-px {
    margin-left: 1px;
  }

  .sm\\:-mt-1 {
    margin-top: -0.25rem;
  }

  .sm\\:-mr-1 {
    margin-right: -0.25rem;
  }

  .sm\\:-mb-1 {
    margin-bottom: -0.25rem;
  }

  .sm\\:-ml-1 {
    margin-left: -0.25rem;
  }

  .sm\\:-mt-2 {
    margin-top: -0.5rem;
  }

  .sm\\:-mr-2 {
    margin-right: -0.5rem;
  }

  .sm\\:-mb-2 {
    margin-bottom: -0.5rem;
  }

  .sm\\:-ml-2 {
    margin-left: -0.5rem;
  }

  .sm\\:-mt-3 {
    margin-top: -0.75rem;
  }

  .sm\\:-mr-3 {
    margin-right: -0.75rem;
  }

  .sm\\:-mb-3 {
    margin-bottom: -0.75rem;
  }

  .sm\\:-ml-3 {
    margin-left: -0.75rem;
  }

  .sm\\:-mt-4 {
    margin-top: -1rem;
  }

  .sm\\:-mr-4 {
    margin-right: -1rem;
  }

  .sm\\:-mb-4 {
    margin-bottom: -1rem;
  }

  .sm\\:-ml-4 {
    margin-left: -1rem;
  }

  .sm\\:-mt-5 {
    margin-top: -1.25rem;
  }

  .sm\\:-mr-5 {
    margin-right: -1.25rem;
  }

  .sm\\:-mb-5 {
    margin-bottom: -1.25rem;
  }

  .sm\\:-ml-5 {
    margin-left: -1.25rem;
  }

  .sm\\:-mt-6 {
    margin-top: -1.5rem;
  }

  .sm\\:-mr-6 {
    margin-right: -1.5rem;
  }

  .sm\\:-mb-6 {
    margin-bottom: -1.5rem;
  }

  .sm\\:-ml-6 {
    margin-left: -1.5rem;
  }

  .sm\\:-mt-8 {
    margin-top: -2rem;
  }

  .sm\\:-mr-8 {
    margin-right: -2rem;
  }

  .sm\\:-mb-8 {
    margin-bottom: -2rem;
  }

  .sm\\:-ml-8 {
    margin-left: -2rem;
  }

  .sm\\:-mt-10 {
    margin-top: -2.5rem;
  }

  .sm\\:-mr-10 {
    margin-right: -2.5rem;
  }

  .sm\\:-mb-10 {
    margin-bottom: -2.5rem;
  }

  .sm\\:-ml-10 {
    margin-left: -2.5rem;
  }

  .sm\\:-mt-12 {
    margin-top: -3rem;
  }

  .sm\\:-mr-12 {
    margin-right: -3rem;
  }

  .sm\\:-mb-12 {
    margin-bottom: -3rem;
  }

  .sm\\:-ml-12 {
    margin-left: -3rem;
  }

  .sm\\:-mt-16 {
    margin-top: -4rem;
  }

  .sm\\:-mr-16 {
    margin-right: -4rem;
  }

  .sm\\:-mb-16 {
    margin-bottom: -4rem;
  }

  .sm\\:-ml-16 {
    margin-left: -4rem;
  }

  .sm\\:-mt-20 {
    margin-top: -5rem;
  }

  .sm\\:-mr-20 {
    margin-right: -5rem;
  }

  .sm\\:-mb-20 {
    margin-bottom: -5rem;
  }

  .sm\\:-ml-20 {
    margin-left: -5rem;
  }

  .sm\\:-mt-24 {
    margin-top: -6rem;
  }

  .sm\\:-mr-24 {
    margin-right: -6rem;
  }

  .sm\\:-mb-24 {
    margin-bottom: -6rem;
  }

  .sm\\:-ml-24 {
    margin-left: -6rem;
  }

  .sm\\:-mt-32 {
    margin-top: -8rem;
  }

  .sm\\:-mr-32 {
    margin-right: -8rem;
  }

  .sm\\:-mb-32 {
    margin-bottom: -8rem;
  }

  .sm\\:-ml-32 {
    margin-left: -8rem;
  }

  .sm\\:-mt-40 {
    margin-top: -10rem;
  }

  .sm\\:-mr-40 {
    margin-right: -10rem;
  }

  .sm\\:-mb-40 {
    margin-bottom: -10rem;
  }

  .sm\\:-ml-40 {
    margin-left: -10rem;
  }

  .sm\\:-mt-48 {
    margin-top: -12rem;
  }

  .sm\\:-mr-48 {
    margin-right: -12rem;
  }

  .sm\\:-mb-48 {
    margin-bottom: -12rem;
  }

  .sm\\:-ml-48 {
    margin-left: -12rem;
  }

  .sm\\:-mt-56 {
    margin-top: -14rem;
  }

  .sm\\:-mr-56 {
    margin-right: -14rem;
  }

  .sm\\:-mb-56 {
    margin-bottom: -14rem;
  }

  .sm\\:-ml-56 {
    margin-left: -14rem;
  }

  .sm\\:-mt-64 {
    margin-top: -16rem;
  }

  .sm\\:-mr-64 {
    margin-right: -16rem;
  }

  .sm\\:-mb-64 {
    margin-bottom: -16rem;
  }

  .sm\\:-ml-64 {
    margin-left: -16rem;
  }

  .sm\\:-mt-px {
    margin-top: -1px;
  }

  .sm\\:-mr-px {
    margin-right: -1px;
  }

  .sm\\:-mb-px {
    margin-bottom: -1px;
  }

  .sm\\:-ml-px {
    margin-left: -1px;
  }

  .sm\\:max-h-full {
    max-height: 100%;
  }

  .sm\\:max-h-screen {
    max-height: 100vh;
  }

  .sm\\:max-w-none {
    max-width: none;
  }

  .sm\\:max-w-xs {
    max-width: 20rem;
  }

  .sm\\:max-w-sm {
    max-width: 24rem;
  }

  .sm\\:max-w-md {
    max-width: 28rem;
  }

  .sm\\:max-w-lg {
    max-width: 32rem;
  }

  .sm\\:max-w-xl {
    max-width: 36rem;
  }

  .sm\\:max-w-2xl {
    max-width: 42rem;
  }

  .sm\\:max-w-3xl {
    max-width: 48rem;
  }

  .sm\\:max-w-4xl {
    max-width: 56rem;
  }

  .sm\\:max-w-5xl {
    max-width: 64rem;
  }

  .sm\\:max-w-6xl {
    max-width: 72rem;
  }

  .sm\\:max-w-full {
    max-width: 100%;
  }

  .sm\\:max-w-screen-sm {
    max-width: 640px;
  }

  .sm\\:max-w-screen-md {
    max-width: 768px;
  }

  .sm\\:max-w-screen-lg {
    max-width: 1024px;
  }

  .sm\\:max-w-screen-xl {
    max-width: 1280px;
  }

  .sm\\:min-h-0 {
    min-height: 0;
  }

  .sm\\:min-h-full {
    min-height: 100%;
  }

  .sm\\:min-h-screen {
    min-height: 100vh;
  }

  .sm\\:min-w-0 {
    min-width: 0;
  }

  .sm\\:min-w-full {
    min-width: 100%;
  }

  .sm\\:object-contain {
    object-fit: contain;
  }

  .sm\\:object-cover {
    object-fit: cover;
  }

  .sm\\:object-fill {
    object-fit: fill;
  }

  .sm\\:object-none {
    object-fit: none;
  }

  .sm\\:object-scale-down {
    object-fit: scale-down;
  }

  .sm\\:object-bottom {
    object-position: bottom;
  }

  .sm\\:object-center {
    object-position: center;
  }

  .sm\\:object-left {
    object-position: left;
  }

  .sm\\:object-left-bottom {
    object-position: left bottom;
  }

  .sm\\:object-left-top {
    object-position: left top;
  }

  .sm\\:object-right {
    object-position: right;
  }

  .sm\\:object-right-bottom {
    object-position: right bottom;
  }

  .sm\\:object-right-top {
    object-position: right top;
  }

  .sm\\:object-top {
    object-position: top;
  }

  .sm\\:opacity-0 {
    opacity: 0;
  }

  .sm\\:opacity-25 {
    opacity: 0.25;
  }

  .sm\\:opacity-50 {
    opacity: 0.5;
  }

  .sm\\:opacity-75 {
    opacity: 0.75;
  }

  .sm\\:opacity-100 {
    opacity: 1;
  }

  .sm\\:hover\\:opacity-0:hover {
    opacity: 0;
  }

  .sm\\:hover\\:opacity-25:hover {
    opacity: 0.25;
  }

  .sm\\:hover\\:opacity-50:hover {
    opacity: 0.5;
  }

  .sm\\:hover\\:opacity-75:hover {
    opacity: 0.75;
  }

  .sm\\:hover\\:opacity-100:hover {
    opacity: 1;
  }

  .sm\\:focus\\:opacity-0:focus {
    opacity: 0;
  }

  .sm\\:focus\\:opacity-25:focus {
    opacity: 0.25;
  }

  .sm\\:focus\\:opacity-50:focus {
    opacity: 0.5;
  }

  .sm\\:focus\\:opacity-75:focus {
    opacity: 0.75;
  }

  .sm\\:focus\\:opacity-100:focus {
    opacity: 1;
  }

  .sm\\:outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .sm\\:outline-white {
    outline: 2px dotted white;
    outline-offset: 2px;
  }

  .sm\\:outline-black {
    outline: 2px dotted black;
    outline-offset: 2px;
  }

  .sm\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .sm\\:focus\\:outline-white:focus {
    outline: 2px dotted white;
    outline-offset: 2px;
  }

  .sm\\:focus\\:outline-black:focus {
    outline: 2px dotted black;
    outline-offset: 2px;
  }

  .sm\\:overflow-auto {
    overflow: auto;
  }

  .sm\\:overflow-hidden {
    overflow: hidden;
  }

  .sm\\:overflow-visible {
    overflow: visible;
  }

  .sm\\:overflow-scroll {
    overflow: scroll;
  }

  .sm\\:overflow-x-auto {
    overflow-x: auto;
  }

  .sm\\:overflow-y-auto {
    overflow-y: auto;
  }

  .sm\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .sm\\:overflow-y-hidden {
    overflow-y: hidden;
  }

  .sm\\:overflow-x-visible {
    overflow-x: visible;
  }

  .sm\\:overflow-y-visible {
    overflow-y: visible;
  }

  .sm\\:overflow-x-scroll {
    overflow-x: scroll;
  }

  .sm\\:overflow-y-scroll {
    overflow-y: scroll;
  }

  .sm\\:scrolling-touch {
    -webkit-overflow-scrolling: touch;
  }

  .sm\\:scrolling-auto {
    -webkit-overflow-scrolling: auto;
  }

  .sm\\:overscroll-auto {
    overscroll-behavior: auto;
  }

  .sm\\:overscroll-contain {
    overscroll-behavior: contain;
  }

  .sm\\:overscroll-none {
    overscroll-behavior: none;
  }

  .sm\\:overscroll-y-auto {
    overscroll-behavior-y: auto;
  }

  .sm\\:overscroll-y-contain {
    overscroll-behavior-y: contain;
  }

  .sm\\:overscroll-y-none {
    overscroll-behavior-y: none;
  }

  .sm\\:overscroll-x-auto {
    overscroll-behavior-x: auto;
  }

  .sm\\:overscroll-x-contain {
    overscroll-behavior-x: contain;
  }

  .sm\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }

  .sm\\:p-0 {
    padding: 0;
  }

  .sm\\:p-1 {
    padding: 0.25rem;
  }

  .sm\\:p-2 {
    padding: 0.5rem;
  }

  .sm\\:p-3 {
    padding: 0.75rem;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:p-5 {
    padding: 1.25rem;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:p-10 {
    padding: 2.5rem;
  }

  .sm\\:p-12 {
    padding: 3rem;
  }

  .sm\\:p-16 {
    padding: 4rem;
  }

  .sm\\:p-20 {
    padding: 5rem;
  }

  .sm\\:p-24 {
    padding: 6rem;
  }

  .sm\\:p-32 {
    padding: 8rem;
  }

  .sm\\:p-40 {
    padding: 10rem;
  }

  .sm\\:p-48 {
    padding: 12rem;
  }

  .sm\\:p-56 {
    padding: 14rem;
  }

  .sm\\:p-64 {
    padding: 16rem;
  }

  .sm\\:p-px {
    padding: 1px;
  }

  .sm\\:py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .sm\\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }

  .sm\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .sm\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .sm\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .sm\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .sm\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .sm\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .sm\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .sm\\:py-48 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .sm\\:px-48 {
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .sm\\:py-56 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .sm\\:px-56 {
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .sm\\:py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .sm\\:px-64 {
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .sm\\:py-px {
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .sm\\:px-px {
    padding-left: 1px;
    padding-right: 1px;
  }

  .sm\\:pt-0 {
    padding-top: 0;
  }

  .sm\\:pr-0 {
    padding-right: 0;
  }

  .sm\\:pb-0 {
    padding-bottom: 0;
  }

  .sm\\:pl-0 {
    padding-left: 0;
  }

  .sm\\:pt-1 {
    padding-top: 0.25rem;
  }

  .sm\\:pr-1 {
    padding-right: 0.25rem;
  }

  .sm\\:pb-1 {
    padding-bottom: 0.25rem;
  }

  .sm\\:pl-1 {
    padding-left: 0.25rem;
  }

  .sm\\:pt-2 {
    padding-top: 0.5rem;
  }

  .sm\\:pr-2 {
    padding-right: 0.5rem;
  }

  .sm\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .sm\\:pl-2 {
    padding-left: 0.5rem;
  }

  .sm\\:pt-3 {
    padding-top: 0.75rem;
  }

  .sm\\:pr-3 {
    padding-right: 0.75rem;
  }

  .sm\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .sm\\:pl-3 {
    padding-left: 0.75rem;
  }

  .sm\\:pt-4 {
    padding-top: 1rem;
  }

  .sm\\:pr-4 {
    padding-right: 1rem;
  }

  .sm\\:pb-4 {
    padding-bottom: 1rem;
  }

  .sm\\:pl-4 {
    padding-left: 1rem;
  }

  .sm\\:pt-5 {
    padding-top: 1.25rem;
  }

  .sm\\:pr-5 {
    padding-right: 1.25rem;
  }

  .sm\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .sm\\:pl-5 {
    padding-left: 1.25rem;
  }

  .sm\\:pt-6 {
    padding-top: 1.5rem;
  }

  .sm\\:pr-6 {
    padding-right: 1.5rem;
  }

  .sm\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .sm\\:pl-6 {
    padding-left: 1.5rem;
  }

  .sm\\:pt-8 {
    padding-top: 2rem;
  }

  .sm\\:pr-8 {
    padding-right: 2rem;
  }

  .sm\\:pb-8 {
    padding-bottom: 2rem;
  }

  .sm\\:pl-8 {
    padding-left: 2rem;
  }

  .sm\\:pt-10 {
    padding-top: 2.5rem;
  }

  .sm\\:pr-10 {
    padding-right: 2.5rem;
  }

  .sm\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .sm\\:pl-10 {
    padding-left: 2.5rem;
  }

  .sm\\:pt-12 {
    padding-top: 3rem;
  }

  .sm\\:pr-12 {
    padding-right: 3rem;
  }

  .sm\\:pb-12 {
    padding-bottom: 3rem;
  }

  .sm\\:pl-12 {
    padding-left: 3rem;
  }

  .sm\\:pt-16 {
    padding-top: 4rem;
  }

  .sm\\:pr-16 {
    padding-right: 4rem;
  }

  .sm\\:pb-16 {
    padding-bottom: 4rem;
  }

  .sm\\:pl-16 {
    padding-left: 4rem;
  }

  .sm\\:pt-20 {
    padding-top: 5rem;
  }

  .sm\\:pr-20 {
    padding-right: 5rem;
  }

  .sm\\:pb-20 {
    padding-bottom: 5rem;
  }

  .sm\\:pl-20 {
    padding-left: 5rem;
  }

  .sm\\:pt-24 {
    padding-top: 6rem;
  }

  .sm\\:pr-24 {
    padding-right: 6rem;
  }

  .sm\\:pb-24 {
    padding-bottom: 6rem;
  }

  .sm\\:pl-24 {
    padding-left: 6rem;
  }

  .sm\\:pt-32 {
    padding-top: 8rem;
  }

  .sm\\:pr-32 {
    padding-right: 8rem;
  }

  .sm\\:pb-32 {
    padding-bottom: 8rem;
  }

  .sm\\:pl-32 {
    padding-left: 8rem;
  }

  .sm\\:pt-40 {
    padding-top: 10rem;
  }

  .sm\\:pr-40 {
    padding-right: 10rem;
  }

  .sm\\:pb-40 {
    padding-bottom: 10rem;
  }

  .sm\\:pl-40 {
    padding-left: 10rem;
  }

  .sm\\:pt-48 {
    padding-top: 12rem;
  }

  .sm\\:pr-48 {
    padding-right: 12rem;
  }

  .sm\\:pb-48 {
    padding-bottom: 12rem;
  }

  .sm\\:pl-48 {
    padding-left: 12rem;
  }

  .sm\\:pt-56 {
    padding-top: 14rem;
  }

  .sm\\:pr-56 {
    padding-right: 14rem;
  }

  .sm\\:pb-56 {
    padding-bottom: 14rem;
  }

  .sm\\:pl-56 {
    padding-left: 14rem;
  }

  .sm\\:pt-64 {
    padding-top: 16rem;
  }

  .sm\\:pr-64 {
    padding-right: 16rem;
  }

  .sm\\:pb-64 {
    padding-bottom: 16rem;
  }

  .sm\\:pl-64 {
    padding-left: 16rem;
  }

  .sm\\:pt-px {
    padding-top: 1px;
  }

  .sm\\:pr-px {
    padding-right: 1px;
  }

  .sm\\:pb-px {
    padding-bottom: 1px;
  }

  .sm\\:pl-px {
    padding-left: 1px;
  }

  .sm\\:placeholder-transparent::placeholder {
    color: transparent;
  }

  .sm\\:placeholder-current::placeholder {
    color: currentColor;
  }

  .sm\\:placeholder-black::placeholder {
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .sm\\:placeholder-white::placeholder {
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f7fafc;
    color: rgba(247, 250, 252, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #edf2f7;
    color: rgba(237, 242, 247, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #a0aec0;
    color: rgba(160, 174, 192, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #718096;
    color: rgba(113, 128, 150, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #4a5568;
    color: rgba(74, 85, 104, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #2d3748;
    color: rgba(45, 55, 72, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #1a202c;
    color: rgba(26, 32, 44, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-100::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f5;
    color: rgba(255, 245, 245, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-200::placeholder {
    --placeholder-opacity: 1;
    color: #fed7d7;
    color: rgba(254, 215, 215, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-300::placeholder {
    --placeholder-opacity: 1;
    color: #feb2b2;
    color: rgba(254, 178, 178, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-400::placeholder {
    --placeholder-opacity: 1;
    color: #fc8181;
    color: rgba(252, 129, 129, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-500::placeholder {
    --placeholder-opacity: 1;
    color: #f56565;
    color: rgba(245, 101, 101, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-600::placeholder {
    --placeholder-opacity: 1;
    color: #e53e3e;
    color: rgba(229, 62, 62, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-700::placeholder {
    --placeholder-opacity: 1;
    color: #c53030;
    color: rgba(197, 48, 48, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-800::placeholder {
    --placeholder-opacity: 1;
    color: #9b2c2c;
    color: rgba(155, 44, 44, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-900::placeholder {
    --placeholder-opacity: 1;
    color: #742a2a;
    color: rgba(116, 42, 42, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-100::placeholder {
    --placeholder-opacity: 1;
    color: #fffaf0;
    color: rgba(255, 250, 240, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-200::placeholder {
    --placeholder-opacity: 1;
    color: #feebc8;
    color: rgba(254, 235, 200, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-300::placeholder {
    --placeholder-opacity: 1;
    color: #fbd38d;
    color: rgba(251, 211, 141, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-400::placeholder {
    --placeholder-opacity: 1;
    color: #f6ad55;
    color: rgba(246, 173, 85, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-500::placeholder {
    --placeholder-opacity: 1;
    color: #ed8936;
    color: rgba(237, 137, 54, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-600::placeholder {
    --placeholder-opacity: 1;
    color: #dd6b20;
    color: rgba(221, 107, 32, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-700::placeholder {
    --placeholder-opacity: 1;
    color: #c05621;
    color: rgba(192, 86, 33, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-800::placeholder {
    --placeholder-opacity: 1;
    color: #9c4221;
    color: rgba(156, 66, 33, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-900::placeholder {
    --placeholder-opacity: 1;
    color: #7b341e;
    color: rgba(123, 52, 30, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-100::placeholder {
    --placeholder-opacity: 1;
    color: #fffff0;
    color: rgba(255, 255, 240, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-200::placeholder {
    --placeholder-opacity: 1;
    color: #fefcbf;
    color: rgba(254, 252, 191, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-300::placeholder {
    --placeholder-opacity: 1;
    color: #faf089;
    color: rgba(250, 240, 137, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-400::placeholder {
    --placeholder-opacity: 1;
    color: #f6e05e;
    color: rgba(246, 224, 94, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-500::placeholder {
    --placeholder-opacity: 1;
    color: #ecc94b;
    color: rgba(236, 201, 75, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-600::placeholder {
    --placeholder-opacity: 1;
    color: #d69e2e;
    color: rgba(214, 158, 46, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-700::placeholder {
    --placeholder-opacity: 1;
    color: #b7791f;
    color: rgba(183, 121, 31, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-800::placeholder {
    --placeholder-opacity: 1;
    color: #975a16;
    color: rgba(151, 90, 22, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-900::placeholder {
    --placeholder-opacity: 1;
    color: #744210;
    color: rgba(116, 66, 16, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-100::placeholder {
    --placeholder-opacity: 1;
    color: #f0fff4;
    color: rgba(240, 255, 244, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-200::placeholder {
    --placeholder-opacity: 1;
    color: #c6f6d5;
    color: rgba(198, 246, 213, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-300::placeholder {
    --placeholder-opacity: 1;
    color: #9ae6b4;
    color: rgba(154, 230, 180, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-400::placeholder {
    --placeholder-opacity: 1;
    color: #68d391;
    color: rgba(104, 211, 145, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-500::placeholder {
    --placeholder-opacity: 1;
    color: #48bb78;
    color: rgba(72, 187, 120, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-600::placeholder {
    --placeholder-opacity: 1;
    color: #38a169;
    color: rgba(56, 161, 105, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-700::placeholder {
    --placeholder-opacity: 1;
    color: #2f855a;
    color: rgba(47, 133, 90, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-800::placeholder {
    --placeholder-opacity: 1;
    color: #276749;
    color: rgba(39, 103, 73, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-900::placeholder {
    --placeholder-opacity: 1;
    color: #22543d;
    color: rgba(34, 84, 61, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-100::placeholder {
    --placeholder-opacity: 1;
    color: #e6fffa;
    color: rgba(230, 255, 250, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-200::placeholder {
    --placeholder-opacity: 1;
    color: #b2f5ea;
    color: rgba(178, 245, 234, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-300::placeholder {
    --placeholder-opacity: 1;
    color: #81e6d9;
    color: rgba(129, 230, 217, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-400::placeholder {
    --placeholder-opacity: 1;
    color: #4fd1c5;
    color: rgba(79, 209, 197, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-500::placeholder {
    --placeholder-opacity: 1;
    color: #38b2ac;
    color: rgba(56, 178, 172, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-600::placeholder {
    --placeholder-opacity: 1;
    color: #319795;
    color: rgba(49, 151, 149, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-700::placeholder {
    --placeholder-opacity: 1;
    color: #2c7a7b;
    color: rgba(44, 122, 123, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-800::placeholder {
    --placeholder-opacity: 1;
    color: #285e61;
    color: rgba(40, 94, 97, var(--placeholder-opacity));
  }

  .sm\\:placeholder-teal-900::placeholder {
    --placeholder-opacity: 1;
    color: #234e52;
    color: rgba(35, 78, 82, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-100::placeholder {
    --placeholder-opacity: 1;
    color: #ebf8ff;
    color: rgba(235, 248, 255, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-200::placeholder {
    --placeholder-opacity: 1;
    color: #bee3f8;
    color: rgba(190, 227, 248, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-300::placeholder {
    --placeholder-opacity: 1;
    color: #90cdf4;
    color: rgba(144, 205, 244, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-400::placeholder {
    --placeholder-opacity: 1;
    color: #63b3ed;
    color: rgba(99, 179, 237, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-500::placeholder {
    --placeholder-opacity: 1;
    color: #4299e1;
    color: rgba(66, 153, 225, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-600::placeholder {
    --placeholder-opacity: 1;
    color: #3182ce;
    color: rgba(49, 130, 206, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-700::placeholder {
    --placeholder-opacity: 1;
    color: #2b6cb0;
    color: rgba(43, 108, 176, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-800::placeholder {
    --placeholder-opacity: 1;
    color: #2c5282;
    color: rgba(44, 82, 130, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-900::placeholder {
    --placeholder-opacity: 1;
    color: #2a4365;
    color: rgba(42, 67, 101, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-100::placeholder {
    --placeholder-opacity: 1;
    color: #ebf4ff;
    color: rgba(235, 244, 255, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-200::placeholder {
    --placeholder-opacity: 1;
    color: #c3dafe;
    color: rgba(195, 218, 254, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-300::placeholder {
    --placeholder-opacity: 1;
    color: #a3bffa;
    color: rgba(163, 191, 250, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-400::placeholder {
    --placeholder-opacity: 1;
    color: #7f9cf5;
    color: rgba(127, 156, 245, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-500::placeholder {
    --placeholder-opacity: 1;
    color: #667eea;
    color: rgba(102, 126, 234, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-600::placeholder {
    --placeholder-opacity: 1;
    color: #5a67d8;
    color: rgba(90, 103, 216, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-700::placeholder {
    --placeholder-opacity: 1;
    color: #4c51bf;
    color: rgba(76, 81, 191, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-800::placeholder {
    --placeholder-opacity: 1;
    color: #434190;
    color: rgba(67, 65, 144, var(--placeholder-opacity));
  }

  .sm\\:placeholder-indigo-900::placeholder {
    --placeholder-opacity: 1;
    color: #3c366b;
    color: rgba(60, 54, 107, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-100::placeholder {
    --placeholder-opacity: 1;
    color: #faf5ff;
    color: rgba(250, 245, 255, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-200::placeholder {
    --placeholder-opacity: 1;
    color: #e9d8fd;
    color: rgba(233, 216, 253, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-300::placeholder {
    --placeholder-opacity: 1;
    color: #d6bcfa;
    color: rgba(214, 188, 250, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-400::placeholder {
    --placeholder-opacity: 1;
    color: #b794f4;
    color: rgba(183, 148, 244, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-500::placeholder {
    --placeholder-opacity: 1;
    color: #9f7aea;
    color: rgba(159, 122, 234, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-600::placeholder {
    --placeholder-opacity: 1;
    color: #805ad5;
    color: rgba(128, 90, 213, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-700::placeholder {
    --placeholder-opacity: 1;
    color: #6b46c1;
    color: rgba(107, 70, 193, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-800::placeholder {
    --placeholder-opacity: 1;
    color: #553c9a;
    color: rgba(85, 60, 154, var(--placeholder-opacity));
  }

  .sm\\:placeholder-purple-900::placeholder {
    --placeholder-opacity: 1;
    color: #44337a;
    color: rgba(68, 51, 122, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-100::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f7;
    color: rgba(255, 245, 247, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-200::placeholder {
    --placeholder-opacity: 1;
    color: #fed7e2;
    color: rgba(254, 215, 226, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-300::placeholder {
    --placeholder-opacity: 1;
    color: #fbb6ce;
    color: rgba(251, 182, 206, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-400::placeholder {
    --placeholder-opacity: 1;
    color: #f687b3;
    color: rgba(246, 135, 179, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-500::placeholder {
    --placeholder-opacity: 1;
    color: #ed64a6;
    color: rgba(237, 100, 166, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-600::placeholder {
    --placeholder-opacity: 1;
    color: #d53f8c;
    color: rgba(213, 63, 140, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-700::placeholder {
    --placeholder-opacity: 1;
    color: #b83280;
    color: rgba(184, 50, 128, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-800::placeholder {
    --placeholder-opacity: 1;
    color: #97266d;
    color: rgba(151, 38, 109, var(--placeholder-opacity));
  }

  .sm\\:placeholder-pink-900::placeholder {
    --placeholder-opacity: 1;
    color: #702459;
    color: rgba(112, 36, 89, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-transparent:focus::placeholder {
    color: transparent;
  }

  .sm\\:focus\\:placeholder-current:focus::placeholder {
    color: currentColor;
  }

  .sm\\:focus\\:placeholder-black:focus::placeholder {
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-white:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f7fafc;
    color: rgba(247, 250, 252, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edf2f7;
    color: rgba(237, 242, 247, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a0aec0;
    color: rgba(160, 174, 192, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #718096;
    color: rgba(113, 128, 150, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4a5568;
    color: rgba(74, 85, 104, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2d3748;
    color: rgba(45, 55, 72, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a202c;
    color: rgba(26, 32, 44, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f5;
    color: rgba(255, 245, 245, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fed7d7;
    color: rgba(254, 215, 215, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feb2b2;
    color: rgba(254, 178, 178, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fc8181;
    color: rgba(252, 129, 129, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f56565;
    color: rgba(245, 101, 101, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e53e3e;
    color: rgba(229, 62, 62, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c53030;
    color: rgba(197, 48, 48, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9b2c2c;
    color: rgba(155, 44, 44, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #742a2a;
    color: rgba(116, 42, 42, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fffaf0;
    color: rgba(255, 250, 240, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feebc8;
    color: rgba(254, 235, 200, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbd38d;
    color: rgba(251, 211, 141, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6ad55;
    color: rgba(246, 173, 85, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ed8936;
    color: rgba(237, 137, 54, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #dd6b20;
    color: rgba(221, 107, 32, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c05621;
    color: rgba(192, 86, 33, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9c4221;
    color: rgba(156, 66, 33, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7b341e;
    color: rgba(123, 52, 30, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fffff0;
    color: rgba(255, 255, 240, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fefcbf;
    color: rgba(254, 252, 191, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faf089;
    color: rgba(250, 240, 137, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6e05e;
    color: rgba(246, 224, 94, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ecc94b;
    color: rgba(236, 201, 75, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d69e2e;
    color: rgba(214, 158, 46, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b7791f;
    color: rgba(183, 121, 31, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #975a16;
    color: rgba(151, 90, 22, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #744210;
    color: rgba(116, 66, 16, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f0fff4;
    color: rgba(240, 255, 244, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c6f6d5;
    color: rgba(198, 246, 213, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9ae6b4;
    color: rgba(154, 230, 180, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #68d391;
    color: rgba(104, 211, 145, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #48bb78;
    color: rgba(72, 187, 120, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #38a169;
    color: rgba(56, 161, 105, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2f855a;
    color: rgba(47, 133, 90, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #276749;
    color: rgba(39, 103, 73, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #22543d;
    color: rgba(34, 84, 61, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e6fffa;
    color: rgba(230, 255, 250, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b2f5ea;
    color: rgba(178, 245, 234, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #81e6d9;
    color: rgba(129, 230, 217, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4fd1c5;
    color: rgba(79, 209, 197, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #38b2ac;
    color: rgba(56, 178, 172, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #319795;
    color: rgba(49, 151, 149, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2c7a7b;
    color: rgba(44, 122, 123, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #285e61;
    color: rgba(40, 94, 97, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-teal-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #234e52;
    color: rgba(35, 78, 82, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf8ff;
    color: rgba(235, 248, 255, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bee3f8;
    color: rgba(190, 227, 248, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #90cdf4;
    color: rgba(144, 205, 244, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #63b3ed;
    color: rgba(99, 179, 237, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4299e1;
    color: rgba(66, 153, 225, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3182ce;
    color: rgba(49, 130, 206, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2b6cb0;
    color: rgba(43, 108, 176, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2c5282;
    color: rgba(44, 82, 130, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2a4365;
    color: rgba(42, 67, 101, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf4ff;
    color: rgba(235, 244, 255, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c3dafe;
    color: rgba(195, 218, 254, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a3bffa;
    color: rgba(163, 191, 250, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7f9cf5;
    color: rgba(127, 156, 245, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #667eea;
    color: rgba(102, 126, 234, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5a67d8;
    color: rgba(90, 103, 216, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4c51bf;
    color: rgba(76, 81, 191, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #434190;
    color: rgba(67, 65, 144, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-indigo-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3c366b;
    color: rgba(60, 54, 107, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faf5ff;
    color: rgba(250, 245, 255, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e9d8fd;
    color: rgba(233, 216, 253, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d6bcfa;
    color: rgba(214, 188, 250, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b794f4;
    color: rgba(183, 148, 244, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9f7aea;
    color: rgba(159, 122, 234, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #805ad5;
    color: rgba(128, 90, 213, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6b46c1;
    color: rgba(107, 70, 193, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #553c9a;
    color: rgba(85, 60, 154, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-purple-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #44337a;
    color: rgba(68, 51, 122, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f7;
    color: rgba(255, 245, 247, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fed7e2;
    color: rgba(254, 215, 226, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbb6ce;
    color: rgba(251, 182, 206, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f687b3;
    color: rgba(246, 135, 179, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ed64a6;
    color: rgba(237, 100, 166, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d53f8c;
    color: rgba(213, 63, 140, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b83280;
    color: rgba(184, 50, 128, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #97266d;
    color: rgba(151, 38, 109, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-pink-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #702459;
    color: rgba(112, 36, 89, var(--placeholder-opacity));
  }

  .sm\\:placeholder-opacity-0::placeholder {
    --placeholder-opacity: 0;
  }

  .sm\\:placeholder-opacity-25::placeholder {
    --placeholder-opacity: 0.25;
  }

  .sm\\:placeholder-opacity-50::placeholder {
    --placeholder-opacity: 0.5;
  }

  .sm\\:placeholder-opacity-75::placeholder {
    --placeholder-opacity: 0.75;
  }

  .sm\\:placeholder-opacity-100::placeholder {
    --placeholder-opacity: 1;
  }

  .sm\\:focus\\:placeholder-opacity-0:focus::placeholder {
    --placeholder-opacity: 0;
  }

  .sm\\:focus\\:placeholder-opacity-25:focus::placeholder {
    --placeholder-opacity: 0.25;
  }

  .sm\\:focus\\:placeholder-opacity-50:focus::placeholder {
    --placeholder-opacity: 0.5;
  }

  .sm\\:focus\\:placeholder-opacity-75:focus::placeholder {
    --placeholder-opacity: 0.75;
  }

  .sm\\:focus\\:placeholder-opacity-100:focus::placeholder {
    --placeholder-opacity: 1;
  }

  .sm\\:pointer-events-none {
    pointer-events: none;
  }

  .sm\\:pointer-events-auto {
    pointer-events: auto;
  }

  .sm\\:static {
    position: static;
  }

  .sm\\:fixed {
    position: fixed;
  }

  .sm\\:absolute {
    position: absolute;
  }

  .sm\\:relative {
    position: relative;
  }

  .sm\\:sticky {
    position: sticky;
  }

  .sm\\:inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .sm\\:inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .sm\\:inset-y-0 {
    top: 0;
    bottom: 0;
  }

  .sm\\:inset-x-0 {
    right: 0;
    left: 0;
  }

  .sm\\:inset-y-auto {
    top: auto;
    bottom: auto;
  }

  .sm\\:inset-x-auto {
    right: auto;
    left: auto;
  }

  .sm\\:top-0 {
    top: 0;
  }

  .sm\\:right-0 {
    right: 0;
  }

  .sm\\:bottom-0 {
    bottom: 0;
  }

  .sm\\:left-0 {
    left: 0;
  }

  .sm\\:top-auto {
    top: auto;
  }

  .sm\\:right-auto {
    right: auto;
  }

  .sm\\:bottom-auto {
    bottom: auto;
  }

  .sm\\:left-auto {
    left: auto;
  }

  .sm\\:resize-none {
    resize: none;
  }

  .sm\\:resize-y {
    resize: vertical;
  }

  .sm\\:resize-x {
    resize: horizontal;
  }

  .sm\\:resize {
    resize: both;
  }

  .sm\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .sm\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .sm\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .sm\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .sm\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .sm\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .sm\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .sm\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .sm\\:shadow-none {
    box-shadow: none;
  }

  .sm\\:hover\\:shadow-xs:hover {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .sm\\:hover\\:shadow-sm:hover {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .sm\\:hover\\:shadow:hover {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .sm\\:hover\\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:hover\\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .sm\\:hover\\:shadow-xl:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .sm\\:hover\\:shadow-2xl:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .sm\\:hover\\:shadow-inner:hover {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .sm\\:hover\\:shadow-outline:hover {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .sm\\:hover\\:shadow-none:hover {
    box-shadow: none;
  }

  .sm\\:focus\\:shadow-xs:focus {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .sm\\:focus\\:shadow-sm:focus {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .sm\\:focus\\:shadow:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .sm\\:focus\\:shadow-md:focus {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:focus\\:shadow-lg:focus {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .sm\\:focus\\:shadow-xl:focus {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .sm\\:focus\\:shadow-2xl:focus {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .sm\\:focus\\:shadow-inner:focus {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .sm\\:focus\\:shadow-outline:focus {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .sm\\:focus\\:shadow-none:focus {
    box-shadow: none;
  }

  .sm\\:fill-current {
    fill: currentColor;
  }

  .sm\\:stroke-current {
    stroke: currentColor;
  }

  .sm\\:stroke-0 {
    stroke-width: 0;
  }

  .sm\\:stroke-1 {
    stroke-width: 1;
  }

  .sm\\:stroke-2 {
    stroke-width: 2;
  }

  .sm\\:table-auto {
    table-layout: auto;
  }

  .sm\\:table-fixed {
    table-layout: fixed;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-center {
    text-align: center;
  }

  .sm\\:text-right {
    text-align: right;
  }

  .sm\\:text-justify {
    text-align: justify;
  }

  .sm\\:text-blue {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .sm\\:text-primaryText {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .sm\\:text-red {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue:hover {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .sm\\:hover\\:text-primaryText:hover {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .sm\\:hover\\:text-red:hover {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue:focus {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .sm\\:focus\\:text-primaryText:focus {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .sm\\:focus\\:text-red:focus {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .sm\\:text-opacity-0 {
    --text-opacity: 0;
  }

  .sm\\:text-opacity-25 {
    --text-opacity: 0.25;
  }

  .sm\\:text-opacity-50 {
    --text-opacity: 0.5;
  }

  .sm\\:text-opacity-75 {
    --text-opacity: 0.75;
  }

  .sm\\:text-opacity-100 {
    --text-opacity: 1;
  }

  .sm\\:hover\\:text-opacity-0:hover {
    --text-opacity: 0;
  }

  .sm\\:hover\\:text-opacity-25:hover {
    --text-opacity: 0.25;
  }

  .sm\\:hover\\:text-opacity-50:hover {
    --text-opacity: 0.5;
  }

  .sm\\:hover\\:text-opacity-75:hover {
    --text-opacity: 0.75;
  }

  .sm\\:hover\\:text-opacity-100:hover {
    --text-opacity: 1;
  }

  .sm\\:focus\\:text-opacity-0:focus {
    --text-opacity: 0;
  }

  .sm\\:focus\\:text-opacity-25:focus {
    --text-opacity: 0.25;
  }

  .sm\\:focus\\:text-opacity-50:focus {
    --text-opacity: 0.5;
  }

  .sm\\:focus\\:text-opacity-75:focus {
    --text-opacity: 0.75;
  }

  .sm\\:focus\\:text-opacity-100:focus {
    --text-opacity: 1;
  }

  .sm\\:italic {
    font-style: italic;
  }

  .sm\\:not-italic {
    font-style: normal;
  }

  .sm\\:uppercase {
    text-transform: uppercase;
  }

  .sm\\:lowercase {
    text-transform: lowercase;
  }

  .sm\\:capitalize {
    text-transform: capitalize;
  }

  .sm\\:normal-case {
    text-transform: none;
  }

  .sm\\:underline {
    text-decoration: underline;
  }

  .sm\\:line-through {
    text-decoration: line-through;
  }

  .sm\\:no-underline {
    text-decoration: none;
  }

  .sm\\:hover\\:underline:hover {
    text-decoration: underline;
  }

  .sm\\:hover\\:line-through:hover {
    text-decoration: line-through;
  }

  .sm\\:hover\\:no-underline:hover {
    text-decoration: none;
  }

  .sm\\:focus\\:underline:focus {
    text-decoration: underline;
  }

  .sm\\:focus\\:line-through:focus {
    text-decoration: line-through;
  }

  .sm\\:focus\\:no-underline:focus {
    text-decoration: none;
  }

  .sm\\:antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .sm\\:subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .sm\\:ordinal, .sm\\:slashed-zero, .sm\\:lining-nums, .sm\\:oldstyle-nums, .sm\\:proportional-nums, .sm\\:tabular-nums, .sm\\:diagonal-fractions, .sm\\:stacked-fractions {
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .sm\\:normal-nums {
    font-variant-numeric: normal;
  }

  .sm\\:ordinal {
    --font-variant-numeric-ordinal: ordinal;
  }

  .sm\\:slashed-zero {
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .sm\\:lining-nums {
    --font-variant-numeric-figure: lining-nums;
  }

  .sm\\:oldstyle-nums {
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .sm\\:proportional-nums {
    --font-variant-numeric-spacing: proportional-nums;
  }

  .sm\\:tabular-nums {
    --font-variant-numeric-spacing: tabular-nums;
  }

  .sm\\:diagonal-fractions {
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .sm\\:stacked-fractions {
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .sm\\:tracking-tighter {
    letter-spacing: -0.05em;
  }

  .sm\\:tracking-tight {
    letter-spacing: -0.025em;
  }

  .sm\\:tracking-normal {
    letter-spacing: 0;
  }

  .sm\\:tracking-wide {
    letter-spacing: 0.025em;
  }

  .sm\\:tracking-wider {
    letter-spacing: 0.05em;
  }

  .sm\\:tracking-widest {
    letter-spacing: 0.1em;
  }

  .sm\\:select-none {
    -webkit-user-select: none;
    user-select: none;
  }

  .sm\\:select-text {
    -webkit-user-select: text;
    user-select: text;
  }

  .sm\\:select-all {
    -webkit-user-select: all;
    user-select: all;
  }

  .sm\\:select-auto {
    -webkit-user-select: auto;
    user-select: auto;
  }

  .sm\\:align-baseline {
    vertical-align: baseline;
  }

  .sm\\:align-top {
    vertical-align: top;
  }

  .sm\\:align-middle {
    vertical-align: middle;
  }

  .sm\\:align-bottom {
    vertical-align: bottom;
  }

  .sm\\:align-text-top {
    vertical-align: text-top;
  }

  .sm\\:align-text-bottom {
    vertical-align: text-bottom;
  }

  .sm\\:visible {
    visibility: visible;
  }

  .sm\\:invisible {
    visibility: hidden;
  }

  .sm\\:whitespace-normal {
    white-space: normal;
  }

  .sm\\:whitespace-no-wrap {
    white-space: nowrap;
  }

  .sm\\:whitespace-pre {
    white-space: pre;
  }

  .sm\\:whitespace-pre-line {
    white-space: pre-line;
  }

  .sm\\:whitespace-pre-wrap {
    white-space: pre-wrap;
  }

  .sm\\:break-normal {
    word-wrap: normal;
    overflow-wrap: normal;
    word-break: normal;
  }

  .sm\\:break-words {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .sm\\:break-all {
    word-break: break-all;
  }

  .sm\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sm\\:w-0 {
    width: 0;
  }

  .sm\\:w-1 {
    width: 0.25rem;
  }

  .sm\\:w-2 {
    width: 0.5rem;
  }

  .sm\\:w-3 {
    width: 0.75rem;
  }

  .sm\\:w-4 {
    width: 1rem;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-6 {
    width: 1.5rem;
  }

  .sm\\:w-8 {
    width: 2rem;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-16 {
    width: 4rem;
  }

  .sm\\:w-20 {
    width: 5rem;
  }

  .sm\\:w-24 {
    width: 6rem;
  }

  .sm\\:w-32 {
    width: 8rem;
  }

  .sm\\:w-40 {
    width: 10rem;
  }

  .sm\\:w-48 {
    width: 12rem;
  }

  .sm\\:w-56 {
    width: 14rem;
  }

  .sm\\:w-64 {
    width: 16rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-px {
    width: 1px;
  }

  .sm\\:w-1\\/2 {
    width: 50%;
  }

  .sm\\:w-1\\/3 {
    width: 33.333333%;
  }

  .sm\\:w-2\\/3 {
    width: 66.666667%;
  }

  .sm\\:w-1\\/4 {
    width: 25%;
  }

  .sm\\:w-2\\/4 {
    width: 50%;
  }

  .sm\\:w-3\\/4 {
    width: 75%;
  }

  .sm\\:w-1\\/5 {
    width: 20%;
  }

  .sm\\:w-2\\/5 {
    width: 40%;
  }

  .sm\\:w-3\\/5 {
    width: 60%;
  }

  .sm\\:w-4\\/5 {
    width: 80%;
  }

  .sm\\:w-1\\/6 {
    width: 16.666667%;
  }

  .sm\\:w-2\\/6 {
    width: 33.333333%;
  }

  .sm\\:w-3\\/6 {
    width: 50%;
  }

  .sm\\:w-4\\/6 {
    width: 66.666667%;
  }

  .sm\\:w-5\\/6 {
    width: 83.333333%;
  }

  .sm\\:w-1\\/12 {
    width: 8.333333%;
  }

  .sm\\:w-2\\/12 {
    width: 16.666667%;
  }

  .sm\\:w-3\\/12 {
    width: 25%;
  }

  .sm\\:w-4\\/12 {
    width: 33.333333%;
  }

  .sm\\:w-5\\/12 {
    width: 41.666667%;
  }

  .sm\\:w-6\\/12 {
    width: 50%;
  }

  .sm\\:w-7\\/12 {
    width: 58.333333%;
  }

  .sm\\:w-8\\/12 {
    width: 66.666667%;
  }

  .sm\\:w-9\\/12 {
    width: 75%;
  }

  .sm\\:w-10\\/12 {
    width: 83.333333%;
  }

  .sm\\:w-11\\/12 {
    width: 91.666667%;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:w-screen {
    width: 100vw;
  }

  .sm\\:z-0 {
    z-index: 0;
  }

  .sm\\:z-10 {
    z-index: 10;
  }

  .sm\\:z-20 {
    z-index: 20;
  }

  .sm\\:z-30 {
    z-index: 30;
  }

  .sm\\:z-40 {
    z-index: 40;
  }

  .sm\\:z-50 {
    z-index: 50;
  }

  .sm\\:z-auto {
    z-index: auto;
  }

  .sm\\:gap-0 {
    grid-gap: 0;
    gap: 0;
  }

  .sm\\:gap-1 {
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .sm\\:gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .sm\\:gap-3 {
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .sm\\:gap-4 {
    grid-gap: 1rem;
    gap: 1rem;
  }

  .sm\\:gap-5 {
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .sm\\:gap-6 {
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .sm\\:gap-8 {
    grid-gap: 2rem;
    gap: 2rem;
  }

  .sm\\:gap-10 {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .sm\\:gap-12 {
    grid-gap: 3rem;
    gap: 3rem;
  }

  .sm\\:gap-16 {
    grid-gap: 4rem;
    gap: 4rem;
  }

  .sm\\:gap-20 {
    grid-gap: 5rem;
    gap: 5rem;
  }

  .sm\\:gap-24 {
    grid-gap: 6rem;
    gap: 6rem;
  }

  .sm\\:gap-32 {
    grid-gap: 8rem;
    gap: 8rem;
  }

  .sm\\:gap-40 {
    grid-gap: 10rem;
    gap: 10rem;
  }

  .sm\\:gap-48 {
    grid-gap: 12rem;
    gap: 12rem;
  }

  .sm\\:gap-56 {
    grid-gap: 14rem;
    gap: 14rem;
  }

  .sm\\:gap-64 {
    grid-gap: 16rem;
    gap: 16rem;
  }

  .sm\\:gap-px {
    grid-gap: 1px;
    gap: 1px;
  }

  .sm\\:col-gap-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }

  .sm\\:col-gap-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }

  .sm\\:col-gap-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }

  .sm\\:col-gap-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }

  .sm\\:col-gap-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }

  .sm\\:col-gap-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .sm\\:col-gap-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .sm\\:col-gap-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }

  .sm\\:col-gap-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .sm\\:col-gap-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }

  .sm\\:col-gap-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }

  .sm\\:col-gap-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }

  .sm\\:col-gap-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }

  .sm\\:col-gap-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }

  .sm\\:col-gap-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }

  .sm\\:col-gap-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }

  .sm\\:col-gap-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }

  .sm\\:col-gap-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }

  .sm\\:col-gap-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }

  .sm\\:gap-x-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }

  .sm\\:gap-x-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }

  .sm\\:gap-x-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }

  .sm\\:gap-x-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }

  .sm\\:gap-x-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }

  .sm\\:gap-x-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .sm\\:gap-x-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .sm\\:gap-x-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }

  .sm\\:gap-x-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .sm\\:gap-x-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }

  .sm\\:gap-x-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }

  .sm\\:gap-x-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }

  .sm\\:gap-x-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }

  .sm\\:gap-x-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }

  .sm\\:gap-x-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }

  .sm\\:gap-x-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }

  .sm\\:gap-x-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }

  .sm\\:gap-x-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }

  .sm\\:gap-x-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }

  .sm\\:row-gap-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }

  .sm\\:row-gap-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .sm\\:row-gap-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .sm\\:row-gap-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .sm\\:row-gap-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .sm\\:row-gap-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .sm\\:row-gap-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .sm\\:row-gap-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .sm\\:row-gap-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .sm\\:row-gap-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .sm\\:row-gap-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .sm\\:row-gap-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .sm\\:row-gap-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .sm\\:row-gap-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .sm\\:row-gap-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .sm\\:row-gap-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .sm\\:row-gap-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .sm\\:row-gap-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .sm\\:row-gap-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .sm\\:gap-y-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }

  .sm\\:gap-y-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .sm\\:gap-y-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .sm\\:gap-y-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .sm\\:gap-y-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .sm\\:gap-y-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .sm\\:gap-y-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .sm\\:gap-y-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .sm\\:gap-y-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .sm\\:gap-y-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .sm\\:gap-y-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .sm\\:gap-y-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .sm\\:gap-y-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .sm\\:gap-y-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .sm\\:gap-y-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .sm\\:gap-y-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .sm\\:gap-y-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .sm\\:gap-y-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .sm\\:gap-y-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .sm\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .sm\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .sm\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .sm\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .sm\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .sm\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .sm\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .sm\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .sm\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .sm\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-none {
    grid-template-columns: none;
  }

  .sm\\:auto-cols-auto {
    grid-auto-columns: auto;
  }

  .sm\\:auto-cols-min {
    grid-auto-columns: min-content;
  }

  .sm\\:auto-cols-max {
    grid-auto-columns: max-content;
  }

  .sm\\:auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }

  .sm\\:col-auto {
    grid-column: auto;
  }

  .sm\\:col-span-1 {
    grid-column: span 1/span 1;
  }

  .sm\\:col-span-2 {
    grid-column: span 2/span 2;
  }

  .sm\\:col-span-3 {
    grid-column: span 3/span 3;
  }

  .sm\\:col-span-4 {
    grid-column: span 4/span 4;
  }

  .sm\\:col-span-5 {
    grid-column: span 5/span 5;
  }

  .sm\\:col-span-6 {
    grid-column: span 6/span 6;
  }

  .sm\\:col-span-7 {
    grid-column: span 7/span 7;
  }

  .sm\\:col-span-8 {
    grid-column: span 8/span 8;
  }

  .sm\\:col-span-9 {
    grid-column: span 9/span 9;
  }

  .sm\\:col-span-10 {
    grid-column: span 10/span 10;
  }

  .sm\\:col-span-11 {
    grid-column: span 11/span 11;
  }

  .sm\\:col-span-12 {
    grid-column: span 12/span 12;
  }

  .sm\\:col-span-full {
    grid-column: 1/-1;
  }

  .sm\\:col-start-1 {
    grid-column-start: 1;
  }

  .sm\\:col-start-2 {
    grid-column-start: 2;
  }

  .sm\\:col-start-3 {
    grid-column-start: 3;
  }

  .sm\\:col-start-4 {
    grid-column-start: 4;
  }

  .sm\\:col-start-5 {
    grid-column-start: 5;
  }

  .sm\\:col-start-6 {
    grid-column-start: 6;
  }

  .sm\\:col-start-7 {
    grid-column-start: 7;
  }

  .sm\\:col-start-8 {
    grid-column-start: 8;
  }

  .sm\\:col-start-9 {
    grid-column-start: 9;
  }

  .sm\\:col-start-10 {
    grid-column-start: 10;
  }

  .sm\\:col-start-11 {
    grid-column-start: 11;
  }

  .sm\\:col-start-12 {
    grid-column-start: 12;
  }

  .sm\\:col-start-13 {
    grid-column-start: 13;
  }

  .sm\\:col-start-auto {
    grid-column-start: auto;
  }

  .sm\\:col-end-1 {
    grid-column-end: 1;
  }

  .sm\\:col-end-2 {
    grid-column-end: 2;
  }

  .sm\\:col-end-3 {
    grid-column-end: 3;
  }

  .sm\\:col-end-4 {
    grid-column-end: 4;
  }

  .sm\\:col-end-5 {
    grid-column-end: 5;
  }

  .sm\\:col-end-6 {
    grid-column-end: 6;
  }

  .sm\\:col-end-7 {
    grid-column-end: 7;
  }

  .sm\\:col-end-8 {
    grid-column-end: 8;
  }

  .sm\\:col-end-9 {
    grid-column-end: 9;
  }

  .sm\\:col-end-10 {
    grid-column-end: 10;
  }

  .sm\\:col-end-11 {
    grid-column-end: 11;
  }

  .sm\\:col-end-12 {
    grid-column-end: 12;
  }

  .sm\\:col-end-13 {
    grid-column-end: 13;
  }

  .sm\\:col-end-auto {
    grid-column-end: auto;
  }

  .sm\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-rows-none {
    grid-template-rows: none;
  }

  .sm\\:auto-rows-auto {
    grid-auto-rows: auto;
  }

  .sm\\:auto-rows-min {
    grid-auto-rows: min-content;
  }

  .sm\\:auto-rows-max {
    grid-auto-rows: max-content;
  }

  .sm\\:auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
  }

  .sm\\:row-auto {
    grid-row: auto;
  }

  .sm\\:row-span-1 {
    grid-row: span 1/span 1;
  }

  .sm\\:row-span-2 {
    grid-row: span 2/span 2;
  }

  .sm\\:row-span-3 {
    grid-row: span 3/span 3;
  }

  .sm\\:row-span-4 {
    grid-row: span 4/span 4;
  }

  .sm\\:row-span-5 {
    grid-row: span 5/span 5;
  }

  .sm\\:row-span-6 {
    grid-row: span 6/span 6;
  }

  .sm\\:row-span-full {
    grid-row: 1/-1;
  }

  .sm\\:row-start-1 {
    grid-row-start: 1;
  }

  .sm\\:row-start-2 {
    grid-row-start: 2;
  }

  .sm\\:row-start-3 {
    grid-row-start: 3;
  }

  .sm\\:row-start-4 {
    grid-row-start: 4;
  }

  .sm\\:row-start-5 {
    grid-row-start: 5;
  }

  .sm\\:row-start-6 {
    grid-row-start: 6;
  }

  .sm\\:row-start-7 {
    grid-row-start: 7;
  }

  .sm\\:row-start-auto {
    grid-row-start: auto;
  }

  .sm\\:row-end-1 {
    grid-row-end: 1;
  }

  .sm\\:row-end-2 {
    grid-row-end: 2;
  }

  .sm\\:row-end-3 {
    grid-row-end: 3;
  }

  .sm\\:row-end-4 {
    grid-row-end: 4;
  }

  .sm\\:row-end-5 {
    grid-row-end: 5;
  }

  .sm\\:row-end-6 {
    grid-row-end: 6;
  }

  .sm\\:row-end-7 {
    grid-row-end: 7;
  }

  .sm\\:row-end-auto {
    grid-row-end: auto;
  }

  .sm\\:transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .sm\\:transform-none {
    transform: none;
  }

  .sm\\:origin-center {
    transform-origin: center;
  }

  .sm\\:origin-top {
    transform-origin: top;
  }

  .sm\\:origin-top-right {
    transform-origin: top right;
  }

  .sm\\:origin-right {
    transform-origin: right;
  }

  .sm\\:origin-bottom-right {
    transform-origin: bottom right;
  }

  .sm\\:origin-bottom {
    transform-origin: bottom;
  }

  .sm\\:origin-bottom-left {
    transform-origin: bottom left;
  }

  .sm\\:origin-left {
    transform-origin: left;
  }

  .sm\\:origin-top-left {
    transform-origin: top left;
  }

  .sm\\:scale-0 {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .sm\\:scale-50 {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .sm\\:scale-75 {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .sm\\:scale-90 {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .sm\\:scale-95 {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .sm\\:scale-100 {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .sm\\:scale-105 {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .sm\\:scale-110 {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .sm\\:scale-125 {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .sm\\:scale-150 {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .sm\\:scale-x-0 {
    --transform-scale-x: 0;
  }

  .sm\\:scale-x-50 {
    --transform-scale-x: .5;
  }

  .sm\\:scale-x-75 {
    --transform-scale-x: .75;
  }

  .sm\\:scale-x-90 {
    --transform-scale-x: .9;
  }

  .sm\\:scale-x-95 {
    --transform-scale-x: .95;
  }

  .sm\\:scale-x-100 {
    --transform-scale-x: 1;
  }

  .sm\\:scale-x-105 {
    --transform-scale-x: 1.05;
  }

  .sm\\:scale-x-110 {
    --transform-scale-x: 1.1;
  }

  .sm\\:scale-x-125 {
    --transform-scale-x: 1.25;
  }

  .sm\\:scale-x-150 {
    --transform-scale-x: 1.5;
  }

  .sm\\:scale-y-0 {
    --transform-scale-y: 0;
  }

  .sm\\:scale-y-50 {
    --transform-scale-y: .5;
  }

  .sm\\:scale-y-75 {
    --transform-scale-y: .75;
  }

  .sm\\:scale-y-90 {
    --transform-scale-y: .9;
  }

  .sm\\:scale-y-95 {
    --transform-scale-y: .95;
  }

  .sm\\:scale-y-100 {
    --transform-scale-y: 1;
  }

  .sm\\:scale-y-105 {
    --transform-scale-y: 1.05;
  }

  .sm\\:scale-y-110 {
    --transform-scale-y: 1.1;
  }

  .sm\\:scale-y-125 {
    --transform-scale-y: 1.25;
  }

  .sm\\:scale-y-150 {
    --transform-scale-y: 1.5;
  }

  .sm\\:hover\\:scale-0:hover {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .sm\\:hover\\:scale-50:hover {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .sm\\:hover\\:scale-75:hover {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .sm\\:hover\\:scale-90:hover {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .sm\\:hover\\:scale-95:hover {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .sm\\:hover\\:scale-100:hover {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .sm\\:hover\\:scale-105:hover {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .sm\\:hover\\:scale-110:hover {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .sm\\:hover\\:scale-125:hover {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .sm\\:hover\\:scale-150:hover {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .sm\\:hover\\:scale-x-0:hover {
    --transform-scale-x: 0;
  }

  .sm\\:hover\\:scale-x-50:hover {
    --transform-scale-x: .5;
  }

  .sm\\:hover\\:scale-x-75:hover {
    --transform-scale-x: .75;
  }

  .sm\\:hover\\:scale-x-90:hover {
    --transform-scale-x: .9;
  }

  .sm\\:hover\\:scale-x-95:hover {
    --transform-scale-x: .95;
  }

  .sm\\:hover\\:scale-x-100:hover {
    --transform-scale-x: 1;
  }

  .sm\\:hover\\:scale-x-105:hover {
    --transform-scale-x: 1.05;
  }

  .sm\\:hover\\:scale-x-110:hover {
    --transform-scale-x: 1.1;
  }

  .sm\\:hover\\:scale-x-125:hover {
    --transform-scale-x: 1.25;
  }

  .sm\\:hover\\:scale-x-150:hover {
    --transform-scale-x: 1.5;
  }

  .sm\\:hover\\:scale-y-0:hover {
    --transform-scale-y: 0;
  }

  .sm\\:hover\\:scale-y-50:hover {
    --transform-scale-y: .5;
  }

  .sm\\:hover\\:scale-y-75:hover {
    --transform-scale-y: .75;
  }

  .sm\\:hover\\:scale-y-90:hover {
    --transform-scale-y: .9;
  }

  .sm\\:hover\\:scale-y-95:hover {
    --transform-scale-y: .95;
  }

  .sm\\:hover\\:scale-y-100:hover {
    --transform-scale-y: 1;
  }

  .sm\\:hover\\:scale-y-105:hover {
    --transform-scale-y: 1.05;
  }

  .sm\\:hover\\:scale-y-110:hover {
    --transform-scale-y: 1.1;
  }

  .sm\\:hover\\:scale-y-125:hover {
    --transform-scale-y: 1.25;
  }

  .sm\\:hover\\:scale-y-150:hover {
    --transform-scale-y: 1.5;
  }

  .sm\\:focus\\:scale-0:focus {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .sm\\:focus\\:scale-50:focus {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .sm\\:focus\\:scale-75:focus {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .sm\\:focus\\:scale-90:focus {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .sm\\:focus\\:scale-95:focus {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .sm\\:focus\\:scale-100:focus {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .sm\\:focus\\:scale-105:focus {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .sm\\:focus\\:scale-110:focus {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .sm\\:focus\\:scale-125:focus {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .sm\\:focus\\:scale-150:focus {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .sm\\:focus\\:scale-x-0:focus {
    --transform-scale-x: 0;
  }

  .sm\\:focus\\:scale-x-50:focus {
    --transform-scale-x: .5;
  }

  .sm\\:focus\\:scale-x-75:focus {
    --transform-scale-x: .75;
  }

  .sm\\:focus\\:scale-x-90:focus {
    --transform-scale-x: .9;
  }

  .sm\\:focus\\:scale-x-95:focus {
    --transform-scale-x: .95;
  }

  .sm\\:focus\\:scale-x-100:focus {
    --transform-scale-x: 1;
  }

  .sm\\:focus\\:scale-x-105:focus {
    --transform-scale-x: 1.05;
  }

  .sm\\:focus\\:scale-x-110:focus {
    --transform-scale-x: 1.1;
  }

  .sm\\:focus\\:scale-x-125:focus {
    --transform-scale-x: 1.25;
  }

  .sm\\:focus\\:scale-x-150:focus {
    --transform-scale-x: 1.5;
  }

  .sm\\:focus\\:scale-y-0:focus {
    --transform-scale-y: 0;
  }

  .sm\\:focus\\:scale-y-50:focus {
    --transform-scale-y: .5;
  }

  .sm\\:focus\\:scale-y-75:focus {
    --transform-scale-y: .75;
  }

  .sm\\:focus\\:scale-y-90:focus {
    --transform-scale-y: .9;
  }

  .sm\\:focus\\:scale-y-95:focus {
    --transform-scale-y: .95;
  }

  .sm\\:focus\\:scale-y-100:focus {
    --transform-scale-y: 1;
  }

  .sm\\:focus\\:scale-y-105:focus {
    --transform-scale-y: 1.05;
  }

  .sm\\:focus\\:scale-y-110:focus {
    --transform-scale-y: 1.1;
  }

  .sm\\:focus\\:scale-y-125:focus {
    --transform-scale-y: 1.25;
  }

  .sm\\:focus\\:scale-y-150:focus {
    --transform-scale-y: 1.5;
  }

  .sm\\:rotate-0 {
    --transform-rotate: 0;
  }

  .sm\\:rotate-1 {
    --transform-rotate: 1deg;
  }

  .sm\\:rotate-2 {
    --transform-rotate: 2deg;
  }

  .sm\\:rotate-3 {
    --transform-rotate: 3deg;
  }

  .sm\\:rotate-6 {
    --transform-rotate: 6deg;
  }

  .sm\\:rotate-12 {
    --transform-rotate: 12deg;
  }

  .sm\\:rotate-45 {
    --transform-rotate: 45deg;
  }

  .sm\\:rotate-90 {
    --transform-rotate: 90deg;
  }

  .sm\\:rotate-180 {
    --transform-rotate: 180deg;
  }

  .sm\\:-rotate-180 {
    --transform-rotate: -180deg;
  }

  .sm\\:-rotate-90 {
    --transform-rotate: -90deg;
  }

  .sm\\:-rotate-45 {
    --transform-rotate: -45deg;
  }

  .sm\\:-rotate-12 {
    --transform-rotate: -12deg;
  }

  .sm\\:-rotate-6 {
    --transform-rotate: -6deg;
  }

  .sm\\:-rotate-3 {
    --transform-rotate: -3deg;
  }

  .sm\\:-rotate-2 {
    --transform-rotate: -2deg;
  }

  .sm\\:-rotate-1 {
    --transform-rotate: -1deg;
  }

  .sm\\:hover\\:rotate-0:hover {
    --transform-rotate: 0;
  }

  .sm\\:hover\\:rotate-1:hover {
    --transform-rotate: 1deg;
  }

  .sm\\:hover\\:rotate-2:hover {
    --transform-rotate: 2deg;
  }

  .sm\\:hover\\:rotate-3:hover {
    --transform-rotate: 3deg;
  }

  .sm\\:hover\\:rotate-6:hover {
    --transform-rotate: 6deg;
  }

  .sm\\:hover\\:rotate-12:hover {
    --transform-rotate: 12deg;
  }

  .sm\\:hover\\:rotate-45:hover {
    --transform-rotate: 45deg;
  }

  .sm\\:hover\\:rotate-90:hover {
    --transform-rotate: 90deg;
  }

  .sm\\:hover\\:rotate-180:hover {
    --transform-rotate: 180deg;
  }

  .sm\\:hover\\:-rotate-180:hover {
    --transform-rotate: -180deg;
  }

  .sm\\:hover\\:-rotate-90:hover {
    --transform-rotate: -90deg;
  }

  .sm\\:hover\\:-rotate-45:hover {
    --transform-rotate: -45deg;
  }

  .sm\\:hover\\:-rotate-12:hover {
    --transform-rotate: -12deg;
  }

  .sm\\:hover\\:-rotate-6:hover {
    --transform-rotate: -6deg;
  }

  .sm\\:hover\\:-rotate-3:hover {
    --transform-rotate: -3deg;
  }

  .sm\\:hover\\:-rotate-2:hover {
    --transform-rotate: -2deg;
  }

  .sm\\:hover\\:-rotate-1:hover {
    --transform-rotate: -1deg;
  }

  .sm\\:focus\\:rotate-0:focus {
    --transform-rotate: 0;
  }

  .sm\\:focus\\:rotate-1:focus {
    --transform-rotate: 1deg;
  }

  .sm\\:focus\\:rotate-2:focus {
    --transform-rotate: 2deg;
  }

  .sm\\:focus\\:rotate-3:focus {
    --transform-rotate: 3deg;
  }

  .sm\\:focus\\:rotate-6:focus {
    --transform-rotate: 6deg;
  }

  .sm\\:focus\\:rotate-12:focus {
    --transform-rotate: 12deg;
  }

  .sm\\:focus\\:rotate-45:focus {
    --transform-rotate: 45deg;
  }

  .sm\\:focus\\:rotate-90:focus {
    --transform-rotate: 90deg;
  }

  .sm\\:focus\\:rotate-180:focus {
    --transform-rotate: 180deg;
  }

  .sm\\:focus\\:-rotate-180:focus {
    --transform-rotate: -180deg;
  }

  .sm\\:focus\\:-rotate-90:focus {
    --transform-rotate: -90deg;
  }

  .sm\\:focus\\:-rotate-45:focus {
    --transform-rotate: -45deg;
  }

  .sm\\:focus\\:-rotate-12:focus {
    --transform-rotate: -12deg;
  }

  .sm\\:focus\\:-rotate-6:focus {
    --transform-rotate: -6deg;
  }

  .sm\\:focus\\:-rotate-3:focus {
    --transform-rotate: -3deg;
  }

  .sm\\:focus\\:-rotate-2:focus {
    --transform-rotate: -2deg;
  }

  .sm\\:focus\\:-rotate-1:focus {
    --transform-rotate: -1deg;
  }

  .sm\\:translate-x-0 {
    --transform-translate-x: 0;
  }

  .sm\\:translate-x-1 {
    --transform-translate-x: 0.25rem;
  }

  .sm\\:translate-x-2 {
    --transform-translate-x: 0.5rem;
  }

  .sm\\:translate-x-3 {
    --transform-translate-x: 0.75rem;
  }

  .sm\\:translate-x-4 {
    --transform-translate-x: 1rem;
  }

  .sm\\:translate-x-5 {
    --transform-translate-x: 1.25rem;
  }

  .sm\\:translate-x-6 {
    --transform-translate-x: 1.5rem;
  }

  .sm\\:translate-x-8 {
    --transform-translate-x: 2rem;
  }

  .sm\\:translate-x-10 {
    --transform-translate-x: 2.5rem;
  }

  .sm\\:translate-x-12 {
    --transform-translate-x: 3rem;
  }

  .sm\\:translate-x-16 {
    --transform-translate-x: 4rem;
  }

  .sm\\:translate-x-20 {
    --transform-translate-x: 5rem;
  }

  .sm\\:translate-x-24 {
    --transform-translate-x: 6rem;
  }

  .sm\\:translate-x-32 {
    --transform-translate-x: 8rem;
  }

  .sm\\:translate-x-40 {
    --transform-translate-x: 10rem;
  }

  .sm\\:translate-x-48 {
    --transform-translate-x: 12rem;
  }

  .sm\\:translate-x-56 {
    --transform-translate-x: 14rem;
  }

  .sm\\:translate-x-64 {
    --transform-translate-x: 16rem;
  }

  .sm\\:translate-x-px {
    --transform-translate-x: 1px;
  }

  .sm\\:-translate-x-1 {
    --transform-translate-x: -0.25rem;
  }

  .sm\\:-translate-x-2 {
    --transform-translate-x: -0.5rem;
  }

  .sm\\:-translate-x-3 {
    --transform-translate-x: -0.75rem;
  }

  .sm\\:-translate-x-4 {
    --transform-translate-x: -1rem;
  }

  .sm\\:-translate-x-5 {
    --transform-translate-x: -1.25rem;
  }

  .sm\\:-translate-x-6 {
    --transform-translate-x: -1.5rem;
  }

  .sm\\:-translate-x-8 {
    --transform-translate-x: -2rem;
  }

  .sm\\:-translate-x-10 {
    --transform-translate-x: -2.5rem;
  }

  .sm\\:-translate-x-12 {
    --transform-translate-x: -3rem;
  }

  .sm\\:-translate-x-16 {
    --transform-translate-x: -4rem;
  }

  .sm\\:-translate-x-20 {
    --transform-translate-x: -5rem;
  }

  .sm\\:-translate-x-24 {
    --transform-translate-x: -6rem;
  }

  .sm\\:-translate-x-32 {
    --transform-translate-x: -8rem;
  }

  .sm\\:-translate-x-40 {
    --transform-translate-x: -10rem;
  }

  .sm\\:-translate-x-48 {
    --transform-translate-x: -12rem;
  }

  .sm\\:-translate-x-56 {
    --transform-translate-x: -14rem;
  }

  .sm\\:-translate-x-64 {
    --transform-translate-x: -16rem;
  }

  .sm\\:-translate-x-px {
    --transform-translate-x: -1px;
  }

  .sm\\:-translate-x-full {
    --transform-translate-x: -100%;
  }

  .sm\\:-translate-x-1\\/2 {
    --transform-translate-x: -50%;
  }

  .sm\\:translate-x-1\\/2 {
    --transform-translate-x: 50%;
  }

  .sm\\:translate-x-full {
    --transform-translate-x: 100%;
  }

  .sm\\:translate-y-0 {
    --transform-translate-y: 0;
  }

  .sm\\:translate-y-1 {
    --transform-translate-y: 0.25rem;
  }

  .sm\\:translate-y-2 {
    --transform-translate-y: 0.5rem;
  }

  .sm\\:translate-y-3 {
    --transform-translate-y: 0.75rem;
  }

  .sm\\:translate-y-4 {
    --transform-translate-y: 1rem;
  }

  .sm\\:translate-y-5 {
    --transform-translate-y: 1.25rem;
  }

  .sm\\:translate-y-6 {
    --transform-translate-y: 1.5rem;
  }

  .sm\\:translate-y-8 {
    --transform-translate-y: 2rem;
  }

  .sm\\:translate-y-10 {
    --transform-translate-y: 2.5rem;
  }

  .sm\\:translate-y-12 {
    --transform-translate-y: 3rem;
  }

  .sm\\:translate-y-16 {
    --transform-translate-y: 4rem;
  }

  .sm\\:translate-y-20 {
    --transform-translate-y: 5rem;
  }

  .sm\\:translate-y-24 {
    --transform-translate-y: 6rem;
  }

  .sm\\:translate-y-32 {
    --transform-translate-y: 8rem;
  }

  .sm\\:translate-y-40 {
    --transform-translate-y: 10rem;
  }

  .sm\\:translate-y-48 {
    --transform-translate-y: 12rem;
  }

  .sm\\:translate-y-56 {
    --transform-translate-y: 14rem;
  }

  .sm\\:translate-y-64 {
    --transform-translate-y: 16rem;
  }

  .sm\\:translate-y-px {
    --transform-translate-y: 1px;
  }

  .sm\\:-translate-y-1 {
    --transform-translate-y: -0.25rem;
  }

  .sm\\:-translate-y-2 {
    --transform-translate-y: -0.5rem;
  }

  .sm\\:-translate-y-3 {
    --transform-translate-y: -0.75rem;
  }

  .sm\\:-translate-y-4 {
    --transform-translate-y: -1rem;
  }

  .sm\\:-translate-y-5 {
    --transform-translate-y: -1.25rem;
  }

  .sm\\:-translate-y-6 {
    --transform-translate-y: -1.5rem;
  }

  .sm\\:-translate-y-8 {
    --transform-translate-y: -2rem;
  }

  .sm\\:-translate-y-10 {
    --transform-translate-y: -2.5rem;
  }

  .sm\\:-translate-y-12 {
    --transform-translate-y: -3rem;
  }

  .sm\\:-translate-y-16 {
    --transform-translate-y: -4rem;
  }

  .sm\\:-translate-y-20 {
    --transform-translate-y: -5rem;
  }

  .sm\\:-translate-y-24 {
    --transform-translate-y: -6rem;
  }

  .sm\\:-translate-y-32 {
    --transform-translate-y: -8rem;
  }

  .sm\\:-translate-y-40 {
    --transform-translate-y: -10rem;
  }

  .sm\\:-translate-y-48 {
    --transform-translate-y: -12rem;
  }

  .sm\\:-translate-y-56 {
    --transform-translate-y: -14rem;
  }

  .sm\\:-translate-y-64 {
    --transform-translate-y: -16rem;
  }

  .sm\\:-translate-y-px {
    --transform-translate-y: -1px;
  }

  .sm\\:-translate-y-full {
    --transform-translate-y: -100%;
  }

  .sm\\:-translate-y-1\\/2 {
    --transform-translate-y: -50%;
  }

  .sm\\:translate-y-1\\/2 {
    --transform-translate-y: 50%;
  }

  .sm\\:translate-y-full {
    --transform-translate-y: 100%;
  }

  .sm\\:hover\\:translate-x-0:hover {
    --transform-translate-x: 0;
  }

  .sm\\:hover\\:translate-x-1:hover {
    --transform-translate-x: 0.25rem;
  }

  .sm\\:hover\\:translate-x-2:hover {
    --transform-translate-x: 0.5rem;
  }

  .sm\\:hover\\:translate-x-3:hover {
    --transform-translate-x: 0.75rem;
  }

  .sm\\:hover\\:translate-x-4:hover {
    --transform-translate-x: 1rem;
  }

  .sm\\:hover\\:translate-x-5:hover {
    --transform-translate-x: 1.25rem;
  }

  .sm\\:hover\\:translate-x-6:hover {
    --transform-translate-x: 1.5rem;
  }

  .sm\\:hover\\:translate-x-8:hover {
    --transform-translate-x: 2rem;
  }

  .sm\\:hover\\:translate-x-10:hover {
    --transform-translate-x: 2.5rem;
  }

  .sm\\:hover\\:translate-x-12:hover {
    --transform-translate-x: 3rem;
  }

  .sm\\:hover\\:translate-x-16:hover {
    --transform-translate-x: 4rem;
  }

  .sm\\:hover\\:translate-x-20:hover {
    --transform-translate-x: 5rem;
  }

  .sm\\:hover\\:translate-x-24:hover {
    --transform-translate-x: 6rem;
  }

  .sm\\:hover\\:translate-x-32:hover {
    --transform-translate-x: 8rem;
  }

  .sm\\:hover\\:translate-x-40:hover {
    --transform-translate-x: 10rem;
  }

  .sm\\:hover\\:translate-x-48:hover {
    --transform-translate-x: 12rem;
  }

  .sm\\:hover\\:translate-x-56:hover {
    --transform-translate-x: 14rem;
  }

  .sm\\:hover\\:translate-x-64:hover {
    --transform-translate-x: 16rem;
  }

  .sm\\:hover\\:translate-x-px:hover {
    --transform-translate-x: 1px;
  }

  .sm\\:hover\\:-translate-x-1:hover {
    --transform-translate-x: -0.25rem;
  }

  .sm\\:hover\\:-translate-x-2:hover {
    --transform-translate-x: -0.5rem;
  }

  .sm\\:hover\\:-translate-x-3:hover {
    --transform-translate-x: -0.75rem;
  }

  .sm\\:hover\\:-translate-x-4:hover {
    --transform-translate-x: -1rem;
  }

  .sm\\:hover\\:-translate-x-5:hover {
    --transform-translate-x: -1.25rem;
  }

  .sm\\:hover\\:-translate-x-6:hover {
    --transform-translate-x: -1.5rem;
  }

  .sm\\:hover\\:-translate-x-8:hover {
    --transform-translate-x: -2rem;
  }

  .sm\\:hover\\:-translate-x-10:hover {
    --transform-translate-x: -2.5rem;
  }

  .sm\\:hover\\:-translate-x-12:hover {
    --transform-translate-x: -3rem;
  }

  .sm\\:hover\\:-translate-x-16:hover {
    --transform-translate-x: -4rem;
  }

  .sm\\:hover\\:-translate-x-20:hover {
    --transform-translate-x: -5rem;
  }

  .sm\\:hover\\:-translate-x-24:hover {
    --transform-translate-x: -6rem;
  }

  .sm\\:hover\\:-translate-x-32:hover {
    --transform-translate-x: -8rem;
  }

  .sm\\:hover\\:-translate-x-40:hover {
    --transform-translate-x: -10rem;
  }

  .sm\\:hover\\:-translate-x-48:hover {
    --transform-translate-x: -12rem;
  }

  .sm\\:hover\\:-translate-x-56:hover {
    --transform-translate-x: -14rem;
  }

  .sm\\:hover\\:-translate-x-64:hover {
    --transform-translate-x: -16rem;
  }

  .sm\\:hover\\:-translate-x-px:hover {
    --transform-translate-x: -1px;
  }

  .sm\\:hover\\:-translate-x-full:hover {
    --transform-translate-x: -100%;
  }

  .sm\\:hover\\:-translate-x-1\\/2:hover {
    --transform-translate-x: -50%;
  }

  .sm\\:hover\\:translate-x-1\\/2:hover {
    --transform-translate-x: 50%;
  }

  .sm\\:hover\\:translate-x-full:hover {
    --transform-translate-x: 100%;
  }

  .sm\\:hover\\:translate-y-0:hover {
    --transform-translate-y: 0;
  }

  .sm\\:hover\\:translate-y-1:hover {
    --transform-translate-y: 0.25rem;
  }

  .sm\\:hover\\:translate-y-2:hover {
    --transform-translate-y: 0.5rem;
  }

  .sm\\:hover\\:translate-y-3:hover {
    --transform-translate-y: 0.75rem;
  }

  .sm\\:hover\\:translate-y-4:hover {
    --transform-translate-y: 1rem;
  }

  .sm\\:hover\\:translate-y-5:hover {
    --transform-translate-y: 1.25rem;
  }

  .sm\\:hover\\:translate-y-6:hover {
    --transform-translate-y: 1.5rem;
  }

  .sm\\:hover\\:translate-y-8:hover {
    --transform-translate-y: 2rem;
  }

  .sm\\:hover\\:translate-y-10:hover {
    --transform-translate-y: 2.5rem;
  }

  .sm\\:hover\\:translate-y-12:hover {
    --transform-translate-y: 3rem;
  }

  .sm\\:hover\\:translate-y-16:hover {
    --transform-translate-y: 4rem;
  }

  .sm\\:hover\\:translate-y-20:hover {
    --transform-translate-y: 5rem;
  }

  .sm\\:hover\\:translate-y-24:hover {
    --transform-translate-y: 6rem;
  }

  .sm\\:hover\\:translate-y-32:hover {
    --transform-translate-y: 8rem;
  }

  .sm\\:hover\\:translate-y-40:hover {
    --transform-translate-y: 10rem;
  }

  .sm\\:hover\\:translate-y-48:hover {
    --transform-translate-y: 12rem;
  }

  .sm\\:hover\\:translate-y-56:hover {
    --transform-translate-y: 14rem;
  }

  .sm\\:hover\\:translate-y-64:hover {
    --transform-translate-y: 16rem;
  }

  .sm\\:hover\\:translate-y-px:hover {
    --transform-translate-y: 1px;
  }

  .sm\\:hover\\:-translate-y-1:hover {
    --transform-translate-y: -0.25rem;
  }

  .sm\\:hover\\:-translate-y-2:hover {
    --transform-translate-y: -0.5rem;
  }

  .sm\\:hover\\:-translate-y-3:hover {
    --transform-translate-y: -0.75rem;
  }

  .sm\\:hover\\:-translate-y-4:hover {
    --transform-translate-y: -1rem;
  }

  .sm\\:hover\\:-translate-y-5:hover {
    --transform-translate-y: -1.25rem;
  }

  .sm\\:hover\\:-translate-y-6:hover {
    --transform-translate-y: -1.5rem;
  }

  .sm\\:hover\\:-translate-y-8:hover {
    --transform-translate-y: -2rem;
  }

  .sm\\:hover\\:-translate-y-10:hover {
    --transform-translate-y: -2.5rem;
  }

  .sm\\:hover\\:-translate-y-12:hover {
    --transform-translate-y: -3rem;
  }

  .sm\\:hover\\:-translate-y-16:hover {
    --transform-translate-y: -4rem;
  }

  .sm\\:hover\\:-translate-y-20:hover {
    --transform-translate-y: -5rem;
  }

  .sm\\:hover\\:-translate-y-24:hover {
    --transform-translate-y: -6rem;
  }

  .sm\\:hover\\:-translate-y-32:hover {
    --transform-translate-y: -8rem;
  }

  .sm\\:hover\\:-translate-y-40:hover {
    --transform-translate-y: -10rem;
  }

  .sm\\:hover\\:-translate-y-48:hover {
    --transform-translate-y: -12rem;
  }

  .sm\\:hover\\:-translate-y-56:hover {
    --transform-translate-y: -14rem;
  }

  .sm\\:hover\\:-translate-y-64:hover {
    --transform-translate-y: -16rem;
  }

  .sm\\:hover\\:-translate-y-px:hover {
    --transform-translate-y: -1px;
  }

  .sm\\:hover\\:-translate-y-full:hover {
    --transform-translate-y: -100%;
  }

  .sm\\:hover\\:-translate-y-1\\/2:hover {
    --transform-translate-y: -50%;
  }

  .sm\\:hover\\:translate-y-1\\/2:hover {
    --transform-translate-y: 50%;
  }

  .sm\\:hover\\:translate-y-full:hover {
    --transform-translate-y: 100%;
  }

  .sm\\:focus\\:translate-x-0:focus {
    --transform-translate-x: 0;
  }

  .sm\\:focus\\:translate-x-1:focus {
    --transform-translate-x: 0.25rem;
  }

  .sm\\:focus\\:translate-x-2:focus {
    --transform-translate-x: 0.5rem;
  }

  .sm\\:focus\\:translate-x-3:focus {
    --transform-translate-x: 0.75rem;
  }

  .sm\\:focus\\:translate-x-4:focus {
    --transform-translate-x: 1rem;
  }

  .sm\\:focus\\:translate-x-5:focus {
    --transform-translate-x: 1.25rem;
  }

  .sm\\:focus\\:translate-x-6:focus {
    --transform-translate-x: 1.5rem;
  }

  .sm\\:focus\\:translate-x-8:focus {
    --transform-translate-x: 2rem;
  }

  .sm\\:focus\\:translate-x-10:focus {
    --transform-translate-x: 2.5rem;
  }

  .sm\\:focus\\:translate-x-12:focus {
    --transform-translate-x: 3rem;
  }

  .sm\\:focus\\:translate-x-16:focus {
    --transform-translate-x: 4rem;
  }

  .sm\\:focus\\:translate-x-20:focus {
    --transform-translate-x: 5rem;
  }

  .sm\\:focus\\:translate-x-24:focus {
    --transform-translate-x: 6rem;
  }

  .sm\\:focus\\:translate-x-32:focus {
    --transform-translate-x: 8rem;
  }

  .sm\\:focus\\:translate-x-40:focus {
    --transform-translate-x: 10rem;
  }

  .sm\\:focus\\:translate-x-48:focus {
    --transform-translate-x: 12rem;
  }

  .sm\\:focus\\:translate-x-56:focus {
    --transform-translate-x: 14rem;
  }

  .sm\\:focus\\:translate-x-64:focus {
    --transform-translate-x: 16rem;
  }

  .sm\\:focus\\:translate-x-px:focus {
    --transform-translate-x: 1px;
  }

  .sm\\:focus\\:-translate-x-1:focus {
    --transform-translate-x: -0.25rem;
  }

  .sm\\:focus\\:-translate-x-2:focus {
    --transform-translate-x: -0.5rem;
  }

  .sm\\:focus\\:-translate-x-3:focus {
    --transform-translate-x: -0.75rem;
  }

  .sm\\:focus\\:-translate-x-4:focus {
    --transform-translate-x: -1rem;
  }

  .sm\\:focus\\:-translate-x-5:focus {
    --transform-translate-x: -1.25rem;
  }

  .sm\\:focus\\:-translate-x-6:focus {
    --transform-translate-x: -1.5rem;
  }

  .sm\\:focus\\:-translate-x-8:focus {
    --transform-translate-x: -2rem;
  }

  .sm\\:focus\\:-translate-x-10:focus {
    --transform-translate-x: -2.5rem;
  }

  .sm\\:focus\\:-translate-x-12:focus {
    --transform-translate-x: -3rem;
  }

  .sm\\:focus\\:-translate-x-16:focus {
    --transform-translate-x: -4rem;
  }

  .sm\\:focus\\:-translate-x-20:focus {
    --transform-translate-x: -5rem;
  }

  .sm\\:focus\\:-translate-x-24:focus {
    --transform-translate-x: -6rem;
  }

  .sm\\:focus\\:-translate-x-32:focus {
    --transform-translate-x: -8rem;
  }

  .sm\\:focus\\:-translate-x-40:focus {
    --transform-translate-x: -10rem;
  }

  .sm\\:focus\\:-translate-x-48:focus {
    --transform-translate-x: -12rem;
  }

  .sm\\:focus\\:-translate-x-56:focus {
    --transform-translate-x: -14rem;
  }

  .sm\\:focus\\:-translate-x-64:focus {
    --transform-translate-x: -16rem;
  }

  .sm\\:focus\\:-translate-x-px:focus {
    --transform-translate-x: -1px;
  }

  .sm\\:focus\\:-translate-x-full:focus {
    --transform-translate-x: -100%;
  }

  .sm\\:focus\\:-translate-x-1\\/2:focus {
    --transform-translate-x: -50%;
  }

  .sm\\:focus\\:translate-x-1\\/2:focus {
    --transform-translate-x: 50%;
  }

  .sm\\:focus\\:translate-x-full:focus {
    --transform-translate-x: 100%;
  }

  .sm\\:focus\\:translate-y-0:focus {
    --transform-translate-y: 0;
  }

  .sm\\:focus\\:translate-y-1:focus {
    --transform-translate-y: 0.25rem;
  }

  .sm\\:focus\\:translate-y-2:focus {
    --transform-translate-y: 0.5rem;
  }

  .sm\\:focus\\:translate-y-3:focus {
    --transform-translate-y: 0.75rem;
  }

  .sm\\:focus\\:translate-y-4:focus {
    --transform-translate-y: 1rem;
  }

  .sm\\:focus\\:translate-y-5:focus {
    --transform-translate-y: 1.25rem;
  }

  .sm\\:focus\\:translate-y-6:focus {
    --transform-translate-y: 1.5rem;
  }

  .sm\\:focus\\:translate-y-8:focus {
    --transform-translate-y: 2rem;
  }

  .sm\\:focus\\:translate-y-10:focus {
    --transform-translate-y: 2.5rem;
  }

  .sm\\:focus\\:translate-y-12:focus {
    --transform-translate-y: 3rem;
  }

  .sm\\:focus\\:translate-y-16:focus {
    --transform-translate-y: 4rem;
  }

  .sm\\:focus\\:translate-y-20:focus {
    --transform-translate-y: 5rem;
  }

  .sm\\:focus\\:translate-y-24:focus {
    --transform-translate-y: 6rem;
  }

  .sm\\:focus\\:translate-y-32:focus {
    --transform-translate-y: 8rem;
  }

  .sm\\:focus\\:translate-y-40:focus {
    --transform-translate-y: 10rem;
  }

  .sm\\:focus\\:translate-y-48:focus {
    --transform-translate-y: 12rem;
  }

  .sm\\:focus\\:translate-y-56:focus {
    --transform-translate-y: 14rem;
  }

  .sm\\:focus\\:translate-y-64:focus {
    --transform-translate-y: 16rem;
  }

  .sm\\:focus\\:translate-y-px:focus {
    --transform-translate-y: 1px;
  }

  .sm\\:focus\\:-translate-y-1:focus {
    --transform-translate-y: -0.25rem;
  }

  .sm\\:focus\\:-translate-y-2:focus {
    --transform-translate-y: -0.5rem;
  }

  .sm\\:focus\\:-translate-y-3:focus {
    --transform-translate-y: -0.75rem;
  }

  .sm\\:focus\\:-translate-y-4:focus {
    --transform-translate-y: -1rem;
  }

  .sm\\:focus\\:-translate-y-5:focus {
    --transform-translate-y: -1.25rem;
  }

  .sm\\:focus\\:-translate-y-6:focus {
    --transform-translate-y: -1.5rem;
  }

  .sm\\:focus\\:-translate-y-8:focus {
    --transform-translate-y: -2rem;
  }

  .sm\\:focus\\:-translate-y-10:focus {
    --transform-translate-y: -2.5rem;
  }

  .sm\\:focus\\:-translate-y-12:focus {
    --transform-translate-y: -3rem;
  }

  .sm\\:focus\\:-translate-y-16:focus {
    --transform-translate-y: -4rem;
  }

  .sm\\:focus\\:-translate-y-20:focus {
    --transform-translate-y: -5rem;
  }

  .sm\\:focus\\:-translate-y-24:focus {
    --transform-translate-y: -6rem;
  }

  .sm\\:focus\\:-translate-y-32:focus {
    --transform-translate-y: -8rem;
  }

  .sm\\:focus\\:-translate-y-40:focus {
    --transform-translate-y: -10rem;
  }

  .sm\\:focus\\:-translate-y-48:focus {
    --transform-translate-y: -12rem;
  }

  .sm\\:focus\\:-translate-y-56:focus {
    --transform-translate-y: -14rem;
  }

  .sm\\:focus\\:-translate-y-64:focus {
    --transform-translate-y: -16rem;
  }

  .sm\\:focus\\:-translate-y-px:focus {
    --transform-translate-y: -1px;
  }

  .sm\\:focus\\:-translate-y-full:focus {
    --transform-translate-y: -100%;
  }

  .sm\\:focus\\:-translate-y-1\\/2:focus {
    --transform-translate-y: -50%;
  }

  .sm\\:focus\\:translate-y-1\\/2:focus {
    --transform-translate-y: 50%;
  }

  .sm\\:focus\\:translate-y-full:focus {
    --transform-translate-y: 100%;
  }

  .sm\\:skew-x-0 {
    --transform-skew-x: 0;
  }

  .sm\\:skew-x-1 {
    --transform-skew-x: 1deg;
  }

  .sm\\:skew-x-2 {
    --transform-skew-x: 2deg;
  }

  .sm\\:skew-x-3 {
    --transform-skew-x: 3deg;
  }

  .sm\\:skew-x-6 {
    --transform-skew-x: 6deg;
  }

  .sm\\:skew-x-12 {
    --transform-skew-x: 12deg;
  }

  .sm\\:-skew-x-12 {
    --transform-skew-x: -12deg;
  }

  .sm\\:-skew-x-6 {
    --transform-skew-x: -6deg;
  }

  .sm\\:-skew-x-3 {
    --transform-skew-x: -3deg;
  }

  .sm\\:-skew-x-2 {
    --transform-skew-x: -2deg;
  }

  .sm\\:-skew-x-1 {
    --transform-skew-x: -1deg;
  }

  .sm\\:skew-y-0 {
    --transform-skew-y: 0;
  }

  .sm\\:skew-y-1 {
    --transform-skew-y: 1deg;
  }

  .sm\\:skew-y-2 {
    --transform-skew-y: 2deg;
  }

  .sm\\:skew-y-3 {
    --transform-skew-y: 3deg;
  }

  .sm\\:skew-y-6 {
    --transform-skew-y: 6deg;
  }

  .sm\\:skew-y-12 {
    --transform-skew-y: 12deg;
  }

  .sm\\:-skew-y-12 {
    --transform-skew-y: -12deg;
  }

  .sm\\:-skew-y-6 {
    --transform-skew-y: -6deg;
  }

  .sm\\:-skew-y-3 {
    --transform-skew-y: -3deg;
  }

  .sm\\:-skew-y-2 {
    --transform-skew-y: -2deg;
  }

  .sm\\:-skew-y-1 {
    --transform-skew-y: -1deg;
  }

  .sm\\:hover\\:skew-x-0:hover {
    --transform-skew-x: 0;
  }

  .sm\\:hover\\:skew-x-1:hover {
    --transform-skew-x: 1deg;
  }

  .sm\\:hover\\:skew-x-2:hover {
    --transform-skew-x: 2deg;
  }

  .sm\\:hover\\:skew-x-3:hover {
    --transform-skew-x: 3deg;
  }

  .sm\\:hover\\:skew-x-6:hover {
    --transform-skew-x: 6deg;
  }

  .sm\\:hover\\:skew-x-12:hover {
    --transform-skew-x: 12deg;
  }

  .sm\\:hover\\:-skew-x-12:hover {
    --transform-skew-x: -12deg;
  }

  .sm\\:hover\\:-skew-x-6:hover {
    --transform-skew-x: -6deg;
  }

  .sm\\:hover\\:-skew-x-3:hover {
    --transform-skew-x: -3deg;
  }

  .sm\\:hover\\:-skew-x-2:hover {
    --transform-skew-x: -2deg;
  }

  .sm\\:hover\\:-skew-x-1:hover {
    --transform-skew-x: -1deg;
  }

  .sm\\:hover\\:skew-y-0:hover {
    --transform-skew-y: 0;
  }

  .sm\\:hover\\:skew-y-1:hover {
    --transform-skew-y: 1deg;
  }

  .sm\\:hover\\:skew-y-2:hover {
    --transform-skew-y: 2deg;
  }

  .sm\\:hover\\:skew-y-3:hover {
    --transform-skew-y: 3deg;
  }

  .sm\\:hover\\:skew-y-6:hover {
    --transform-skew-y: 6deg;
  }

  .sm\\:hover\\:skew-y-12:hover {
    --transform-skew-y: 12deg;
  }

  .sm\\:hover\\:-skew-y-12:hover {
    --transform-skew-y: -12deg;
  }

  .sm\\:hover\\:-skew-y-6:hover {
    --transform-skew-y: -6deg;
  }

  .sm\\:hover\\:-skew-y-3:hover {
    --transform-skew-y: -3deg;
  }

  .sm\\:hover\\:-skew-y-2:hover {
    --transform-skew-y: -2deg;
  }

  .sm\\:hover\\:-skew-y-1:hover {
    --transform-skew-y: -1deg;
  }

  .sm\\:focus\\:skew-x-0:focus {
    --transform-skew-x: 0;
  }

  .sm\\:focus\\:skew-x-1:focus {
    --transform-skew-x: 1deg;
  }

  .sm\\:focus\\:skew-x-2:focus {
    --transform-skew-x: 2deg;
  }

  .sm\\:focus\\:skew-x-3:focus {
    --transform-skew-x: 3deg;
  }

  .sm\\:focus\\:skew-x-6:focus {
    --transform-skew-x: 6deg;
  }

  .sm\\:focus\\:skew-x-12:focus {
    --transform-skew-x: 12deg;
  }

  .sm\\:focus\\:-skew-x-12:focus {
    --transform-skew-x: -12deg;
  }

  .sm\\:focus\\:-skew-x-6:focus {
    --transform-skew-x: -6deg;
  }

  .sm\\:focus\\:-skew-x-3:focus {
    --transform-skew-x: -3deg;
  }

  .sm\\:focus\\:-skew-x-2:focus {
    --transform-skew-x: -2deg;
  }

  .sm\\:focus\\:-skew-x-1:focus {
    --transform-skew-x: -1deg;
  }

  .sm\\:focus\\:skew-y-0:focus {
    --transform-skew-y: 0;
  }

  .sm\\:focus\\:skew-y-1:focus {
    --transform-skew-y: 1deg;
  }

  .sm\\:focus\\:skew-y-2:focus {
    --transform-skew-y: 2deg;
  }

  .sm\\:focus\\:skew-y-3:focus {
    --transform-skew-y: 3deg;
  }

  .sm\\:focus\\:skew-y-6:focus {
    --transform-skew-y: 6deg;
  }

  .sm\\:focus\\:skew-y-12:focus {
    --transform-skew-y: 12deg;
  }

  .sm\\:focus\\:-skew-y-12:focus {
    --transform-skew-y: -12deg;
  }

  .sm\\:focus\\:-skew-y-6:focus {
    --transform-skew-y: -6deg;
  }

  .sm\\:focus\\:-skew-y-3:focus {
    --transform-skew-y: -3deg;
  }

  .sm\\:focus\\:-skew-y-2:focus {
    --transform-skew-y: -2deg;
  }

  .sm\\:focus\\:-skew-y-1:focus {
    --transform-skew-y: -1deg;
  }

  .sm\\:transition-none {
    transition-property: none;
  }

  .sm\\:transition-all {
    transition-property: all;
  }

  .sm\\:transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .sm\\:transition-colors {
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .sm\\:transition-opacity {
    transition-property: opacity;
  }

  .sm\\:transition-shadow {
    transition-property: box-shadow;
  }

  .sm\\:transition-transform {
    transition-property: transform;
  }

  .sm\\:ease-linear {
    transition-timing-function: linear;
  }

  .sm\\:ease-in {
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .sm\\:ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .sm\\:ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .sm\\:duration-75 {
    transition-duration: 75ms;
  }

  .sm\\:duration-100 {
    transition-duration: 100ms;
  }

  .sm\\:duration-150 {
    transition-duration: 150ms;
  }

  .sm\\:duration-200 {
    transition-duration: 200ms;
  }

  .sm\\:duration-300 {
    transition-duration: 300ms;
  }

  .sm\\:duration-500 {
    transition-duration: 500ms;
  }

  .sm\\:duration-700 {
    transition-duration: 700ms;
  }

  .sm\\:duration-1000 {
    transition-duration: 1000ms;
  }

  .sm\\:delay-75 {
    transition-delay: 75ms;
  }

  .sm\\:delay-100 {
    transition-delay: 100ms;
  }

  .sm\\:delay-150 {
    transition-delay: 150ms;
  }

  .sm\\:delay-200 {
    transition-delay: 200ms;
  }

  .sm\\:delay-300 {
    transition-delay: 300ms;
  }

  .sm\\:delay-500 {
    transition-delay: 500ms;
  }

  .sm\\:delay-700 {
    transition-delay: 700ms;
  }

  .sm\\:delay-1000 {
    transition-delay: 1000ms;
  }

  .sm\\:animate-none {
    animation: none;
  }

  .sm\\:animate-spin {
    animation: spin 1s linear infinite;
  }

  .sm\\:animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .sm\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .sm\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}

@media (min-width: 768px) {
  .md\\:container {
    width: 100%;
  }
}

@media (min-width: 768px) and (min-width: 640px) {
  .md\\:container {
    max-width: 640px;
  }
}

@media (min-width: 768px) and (min-width: 768px) {
  .md\\:container {
    max-width: 768px;
  }
}

@media (min-width: 768px) and (min-width: 1024px) {
  .md\\:container {
    max-width: 1024px;
  }
}

@media (min-width: 768px) and (min-width: 1280px) {
  .md\\:container {
    max-width: 1280px;
  }
}

@media (min-width: 768px) {
  .md\\:space-y-0 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .md\\:space-x-0 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-1 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .md\\:space-x-1 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-2 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-2 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-3 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .md\\:space-x-3 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-4 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .md\\:space-x-4 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-5 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .md\\:space-x-5 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-6 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-6 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-8 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .md\\:space-x-8 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-10 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-10 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-12 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .md\\:space-x-12 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-16 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .md\\:space-x-16 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-20 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .md\\:space-x-20 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-24 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .md\\:space-x-24 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-32 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .md\\:space-x-32 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-40 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .md\\:space-x-40 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-48 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .md\\:space-x-48 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-56 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .md\\:space-x-56 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-64 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .md\\:space-x-64 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-px > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .md\\:space-x-px > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-1 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .md\\:-space-x-1 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-2 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-2 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-3 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .md\\:-space-x-3 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-4 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .md\\:-space-x-4 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-5 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .md\\:-space-x-5 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-6 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-6 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-8 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .md\\:-space-x-8 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-10 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-10 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-12 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .md\\:-space-x-12 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-16 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .md\\:-space-x-16 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-20 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-20 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-24 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .md\\:-space-x-24 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-32 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .md\\:-space-x-32 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-40 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .md\\:-space-x-40 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-48 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .md\\:-space-x-48 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-56 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .md\\:-space-x-56 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-64 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .md\\:-space-x-64 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-px > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .md\\:-space-x-px > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
  }

  .md\\:space-y-reverse > :not(template) ~ :not(template) {
    --space-y-reverse: 1;
  }

  .md\\:space-x-reverse > :not(template) ~ :not(template) {
    --space-x-reverse: 1;
  }

  .md\\:divide-y-0 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .md\\:divide-x-0 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-2 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .md\\:divide-x-2 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-4 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .md\\:divide-x-4 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-8 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .md\\:divide-x-8 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .md\\:divide-x > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-reverse > :not(template) ~ :not(template) {
    --divide-y-reverse: 1;
  }

  .md\\:divide-x-reverse > :not(template) ~ :not(template) {
    --divide-x-reverse: 1;
  }

  .md\\:divide-transparent > :not(template) ~ :not(template) {
    border-color: transparent;
  }

  .md\\:divide-current > :not(template) ~ :not(template) {
    border-color: currentColor;
  }

  .md\\:divide-black > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .md\\:divide-white > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .md\\:divide-gray-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--divide-opacity));
  }

  .md\\:divide-gray-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--divide-opacity));
  }

  .md\\:divide-gray-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--divide-opacity));
  }

  .md\\:divide-gray-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--divide-opacity));
  }

  .md\\:divide-gray-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--divide-opacity));
  }

  .md\\:divide-gray-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--divide-opacity));
  }

  .md\\:divide-gray-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--divide-opacity));
  }

  .md\\:divide-gray-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--divide-opacity));
  }

  .md\\:divide-gray-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--divide-opacity));
  }

  .md\\:divide-red-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--divide-opacity));
  }

  .md\\:divide-red-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--divide-opacity));
  }

  .md\\:divide-red-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--divide-opacity));
  }

  .md\\:divide-red-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--divide-opacity));
  }

  .md\\:divide-red-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--divide-opacity));
  }

  .md\\:divide-red-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--divide-opacity));
  }

  .md\\:divide-red-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--divide-opacity));
  }

  .md\\:divide-red-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--divide-opacity));
  }

  .md\\:divide-red-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--divide-opacity));
  }

  .md\\:divide-orange-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--divide-opacity));
  }

  .md\\:divide-orange-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--divide-opacity));
  }

  .md\\:divide-orange-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--divide-opacity));
  }

  .md\\:divide-orange-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--divide-opacity));
  }

  .md\\:divide-orange-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--divide-opacity));
  }

  .md\\:divide-orange-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--divide-opacity));
  }

  .md\\:divide-orange-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--divide-opacity));
  }

  .md\\:divide-orange-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--divide-opacity));
  }

  .md\\:divide-orange-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--divide-opacity));
  }

  .md\\:divide-yellow-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--divide-opacity));
  }

  .md\\:divide-yellow-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--divide-opacity));
  }

  .md\\:divide-yellow-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--divide-opacity));
  }

  .md\\:divide-yellow-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--divide-opacity));
  }

  .md\\:divide-yellow-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--divide-opacity));
  }

  .md\\:divide-yellow-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--divide-opacity));
  }

  .md\\:divide-yellow-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--divide-opacity));
  }

  .md\\:divide-yellow-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--divide-opacity));
  }

  .md\\:divide-yellow-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--divide-opacity));
  }

  .md\\:divide-green-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--divide-opacity));
  }

  .md\\:divide-green-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--divide-opacity));
  }

  .md\\:divide-green-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--divide-opacity));
  }

  .md\\:divide-green-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--divide-opacity));
  }

  .md\\:divide-green-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--divide-opacity));
  }

  .md\\:divide-green-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--divide-opacity));
  }

  .md\\:divide-green-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--divide-opacity));
  }

  .md\\:divide-green-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--divide-opacity));
  }

  .md\\:divide-green-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--divide-opacity));
  }

  .md\\:divide-teal-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--divide-opacity));
  }

  .md\\:divide-teal-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--divide-opacity));
  }

  .md\\:divide-teal-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--divide-opacity));
  }

  .md\\:divide-teal-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--divide-opacity));
  }

  .md\\:divide-teal-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--divide-opacity));
  }

  .md\\:divide-teal-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--divide-opacity));
  }

  .md\\:divide-teal-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--divide-opacity));
  }

  .md\\:divide-teal-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--divide-opacity));
  }

  .md\\:divide-teal-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--divide-opacity));
  }

  .md\\:divide-blue-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--divide-opacity));
  }

  .md\\:divide-blue-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--divide-opacity));
  }

  .md\\:divide-blue-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--divide-opacity));
  }

  .md\\:divide-blue-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--divide-opacity));
  }

  .md\\:divide-blue-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--divide-opacity));
  }

  .md\\:divide-blue-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--divide-opacity));
  }

  .md\\:divide-blue-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--divide-opacity));
  }

  .md\\:divide-blue-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--divide-opacity));
  }

  .md\\:divide-blue-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--divide-opacity));
  }

  .md\\:divide-indigo-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--divide-opacity));
  }

  .md\\:divide-indigo-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--divide-opacity));
  }

  .md\\:divide-indigo-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--divide-opacity));
  }

  .md\\:divide-indigo-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--divide-opacity));
  }

  .md\\:divide-indigo-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--divide-opacity));
  }

  .md\\:divide-indigo-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--divide-opacity));
  }

  .md\\:divide-indigo-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--divide-opacity));
  }

  .md\\:divide-indigo-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--divide-opacity));
  }

  .md\\:divide-indigo-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--divide-opacity));
  }

  .md\\:divide-purple-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--divide-opacity));
  }

  .md\\:divide-purple-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--divide-opacity));
  }

  .md\\:divide-purple-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--divide-opacity));
  }

  .md\\:divide-purple-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--divide-opacity));
  }

  .md\\:divide-purple-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--divide-opacity));
  }

  .md\\:divide-purple-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--divide-opacity));
  }

  .md\\:divide-purple-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--divide-opacity));
  }

  .md\\:divide-purple-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--divide-opacity));
  }

  .md\\:divide-purple-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--divide-opacity));
  }

  .md\\:divide-pink-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--divide-opacity));
  }

  .md\\:divide-pink-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--divide-opacity));
  }

  .md\\:divide-pink-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--divide-opacity));
  }

  .md\\:divide-pink-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--divide-opacity));
  }

  .md\\:divide-pink-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--divide-opacity));
  }

  .md\\:divide-pink-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--divide-opacity));
  }

  .md\\:divide-pink-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--divide-opacity));
  }

  .md\\:divide-pink-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--divide-opacity));
  }

  .md\\:divide-pink-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--divide-opacity));
  }

  .md\\:divide-solid > :not(template) ~ :not(template) {
    border-style: solid;
  }

  .md\\:divide-dashed > :not(template) ~ :not(template) {
    border-style: dashed;
  }

  .md\\:divide-dotted > :not(template) ~ :not(template) {
    border-style: dotted;
  }

  .md\\:divide-double > :not(template) ~ :not(template) {
    border-style: double;
  }

  .md\\:divide-none > :not(template) ~ :not(template) {
    border-style: none;
  }

  .md\\:divide-opacity-0 > :not(template) ~ :not(template) {
    --divide-opacity: 0;
  }

  .md\\:divide-opacity-25 > :not(template) ~ :not(template) {
    --divide-opacity: 0.25;
  }

  .md\\:divide-opacity-50 > :not(template) ~ :not(template) {
    --divide-opacity: 0.5;
  }

  .md\\:divide-opacity-75 > :not(template) ~ :not(template) {
    --divide-opacity: 0.75;
  }

  .md\\:divide-opacity-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
  }

  .md\\:sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .md\\:not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .md\\:focus\\:sr-only:focus {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .md\\:focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .md\\:appearance-none {
    appearance: none;
  }

  .md\\:bg-fixed {
    background-attachment: fixed;
  }

  .md\\:bg-local {
    background-attachment: local;
  }

  .md\\:bg-scroll {
    background-attachment: scroll;
  }

  .md\\:bg-clip-border {
    background-clip: border-box;
  }

  .md\\:bg-clip-padding {
    background-clip: padding-box;
  }

  .md\\:bg-clip-content {
    background-clip: content-box;
  }

  .md\\:bg-clip-text {
    -webkit-background-clip: text;
    background-clip: text;
  }

  .md\\:bg-transparent {
    background-color: transparent;
  }

  .md\\:bg-current {
    background-color: currentColor;
  }

  .md\\:bg-black {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .md\\:bg-white {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .md\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .md\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .md\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .md\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .md\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .md\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .md\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .md\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .md\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .md\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .md\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .md\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .md\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .md\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .md\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .md\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .md\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .md\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .md\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .md\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .md\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .md\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .md\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .md\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .md\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .md\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .md\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .md\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .md\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .md\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .md\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .md\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .md\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .md\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .md\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .md\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .md\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .md\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .md\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .md\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .md\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .md\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .md\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .md\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .md\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .md\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .md\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .md\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .md\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .md\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .md\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .md\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .md\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .md\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .md\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .md\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .md\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .md\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .md\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .md\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .md\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .md\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .md\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .md\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .md\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .md\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .md\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .md\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .md\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .md\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .md\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .md\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .md\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .md\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .md\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .md\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .md\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .md\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .md\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .md\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .md\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .md\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .md\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .md\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .md\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .md\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .md\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .md\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .md\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .md\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .md\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }

  .md\\:hover\\:bg-current:hover {
    background-color: currentColor;
  }

  .md\\:hover\\:bg-black:hover {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .md\\:hover\\:bg-white:hover {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-200:hover {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-300:hover {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-400:hover {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-500:hover {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-600:hover {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-700:hover {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-800:hover {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-900:hover {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-100:hover {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-200:hover {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-300:hover {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-400:hover {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-500:hover {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-600:hover {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-700:hover {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-800:hover {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-900:hover {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-100:hover {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-200:hover {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-300:hover {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-400:hover {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-500:hover {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-600:hover {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-700:hover {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-800:hover {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-900:hover {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-100:hover {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-200:hover {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-300:hover {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-400:hover {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-500:hover {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-600:hover {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-700:hover {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-800:hover {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-900:hover {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-100:hover {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-200:hover {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-300:hover {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-400:hover {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-500:hover {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-600:hover {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-700:hover {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-800:hover {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-900:hover {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-100:hover {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-200:hover {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-300:hover {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-400:hover {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-500:hover {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-600:hover {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-700:hover {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-800:hover {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .md\\:hover\\:bg-teal-900:hover {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-100:hover {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-200:hover {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-300:hover {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-400:hover {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-500:hover {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-600:hover {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-700:hover {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-800:hover {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-900:hover {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-100:hover {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-200:hover {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-300:hover {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-400:hover {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-500:hover {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-600:hover {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-700:hover {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-800:hover {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .md\\:hover\\:bg-indigo-900:hover {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-100:hover {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-200:hover {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-300:hover {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-400:hover {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-500:hover {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-600:hover {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-700:hover {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-800:hover {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .md\\:hover\\:bg-purple-900:hover {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-100:hover {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-200:hover {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-300:hover {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-400:hover {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-500:hover {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-600:hover {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-700:hover {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-800:hover {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .md\\:hover\\:bg-pink-900:hover {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .md\\:focus\\:bg-transparent:focus {
    background-color: transparent;
  }

  .md\\:focus\\:bg-current:focus {
    background-color: currentColor;
  }

  .md\\:focus\\:bg-black:focus {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .md\\:focus\\:bg-white:focus {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-200:focus {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-300:focus {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-400:focus {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-500:focus {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-600:focus {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-700:focus {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-800:focus {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-900:focus {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-100:focus {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-200:focus {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-300:focus {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-400:focus {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-500:focus {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-600:focus {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-700:focus {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-800:focus {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-900:focus {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-100:focus {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-200:focus {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-300:focus {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-400:focus {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-500:focus {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-600:focus {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-700:focus {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-800:focus {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-900:focus {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-100:focus {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-200:focus {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-300:focus {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-400:focus {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-500:focus {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-600:focus {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-700:focus {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-800:focus {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-900:focus {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-100:focus {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-200:focus {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-300:focus {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-400:focus {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-500:focus {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-600:focus {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-700:focus {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-800:focus {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-900:focus {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-100:focus {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-200:focus {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-300:focus {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-400:focus {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-500:focus {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-600:focus {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-700:focus {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-800:focus {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .md\\:focus\\:bg-teal-900:focus {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-100:focus {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-200:focus {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-300:focus {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-400:focus {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-500:focus {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-600:focus {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-700:focus {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-800:focus {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-900:focus {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-100:focus {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-200:focus {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-300:focus {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-400:focus {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-500:focus {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-600:focus {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-700:focus {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-800:focus {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .md\\:focus\\:bg-indigo-900:focus {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-100:focus {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-200:focus {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-300:focus {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-400:focus {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-500:focus {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-600:focus {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-700:focus {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-800:focus {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .md\\:focus\\:bg-purple-900:focus {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-100:focus {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-200:focus {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-300:focus {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-400:focus {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-500:focus {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-600:focus {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-700:focus {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-800:focus {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .md\\:focus\\:bg-pink-900:focus {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .md\\:bg-none {
    background-image: none;
  }

  .md\\:bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-tl {
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .md\\:from-transparent {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:from-current {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:from-black {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:from-white {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:from-gray-100 {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .md\\:from-gray-200 {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .md\\:from-gray-300 {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .md\\:from-gray-400 {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .md\\:from-gray-500 {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .md\\:from-gray-600 {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .md\\:from-gray-700 {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .md\\:from-gray-800 {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .md\\:from-gray-900 {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .md\\:from-red-100 {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .md\\:from-red-200 {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .md\\:from-red-300 {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .md\\:from-red-400 {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .md\\:from-red-500 {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .md\\:from-red-600 {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .md\\:from-red-700 {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .md\\:from-red-800 {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .md\\:from-red-900 {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .md\\:from-orange-100 {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .md\\:from-orange-200 {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .md\\:from-orange-300 {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .md\\:from-orange-400 {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .md\\:from-orange-500 {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .md\\:from-orange-600 {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .md\\:from-orange-700 {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .md\\:from-orange-800 {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .md\\:from-orange-900 {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .md\\:from-yellow-100 {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .md\\:from-yellow-200 {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .md\\:from-yellow-300 {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .md\\:from-yellow-400 {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .md\\:from-yellow-500 {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .md\\:from-yellow-600 {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .md\\:from-yellow-700 {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .md\\:from-yellow-800 {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .md\\:from-yellow-900 {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .md\\:from-green-100 {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .md\\:from-green-200 {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .md\\:from-green-300 {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .md\\:from-green-400 {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .md\\:from-green-500 {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .md\\:from-green-600 {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .md\\:from-green-700 {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .md\\:from-green-800 {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .md\\:from-green-900 {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .md\\:from-teal-100 {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .md\\:from-teal-200 {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .md\\:from-teal-300 {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .md\\:from-teal-400 {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .md\\:from-teal-500 {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .md\\:from-teal-600 {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .md\\:from-teal-700 {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .md\\:from-teal-800 {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .md\\:from-teal-900 {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .md\\:from-blue-100 {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .md\\:from-blue-200 {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .md\\:from-blue-300 {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .md\\:from-blue-400 {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .md\\:from-blue-500 {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .md\\:from-blue-600 {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .md\\:from-blue-700 {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .md\\:from-blue-800 {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .md\\:from-blue-900 {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .md\\:from-indigo-100 {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .md\\:from-indigo-200 {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .md\\:from-indigo-300 {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .md\\:from-indigo-400 {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .md\\:from-indigo-500 {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .md\\:from-indigo-600 {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .md\\:from-indigo-700 {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .md\\:from-indigo-800 {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .md\\:from-indigo-900 {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .md\\:from-purple-100 {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .md\\:from-purple-200 {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .md\\:from-purple-300 {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .md\\:from-purple-400 {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .md\\:from-purple-500 {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .md\\:from-purple-600 {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .md\\:from-purple-700 {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .md\\:from-purple-800 {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .md\\:from-purple-900 {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .md\\:from-pink-100 {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .md\\:from-pink-200 {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .md\\:from-pink-300 {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .md\\:from-pink-400 {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .md\\:from-pink-500 {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .md\\:from-pink-600 {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .md\\:from-pink-700 {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .md\\:from-pink-800 {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .md\\:from-pink-900 {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .md\\:via-transparent {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:via-current {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:via-black {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:via-white {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:via-gray-100 {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .md\\:via-gray-200 {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .md\\:via-gray-300 {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .md\\:via-gray-400 {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .md\\:via-gray-500 {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .md\\:via-gray-600 {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .md\\:via-gray-700 {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .md\\:via-gray-800 {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .md\\:via-gray-900 {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .md\\:via-red-100 {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .md\\:via-red-200 {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .md\\:via-red-300 {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .md\\:via-red-400 {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .md\\:via-red-500 {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .md\\:via-red-600 {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .md\\:via-red-700 {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .md\\:via-red-800 {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .md\\:via-red-900 {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .md\\:via-orange-100 {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .md\\:via-orange-200 {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .md\\:via-orange-300 {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .md\\:via-orange-400 {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .md\\:via-orange-500 {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .md\\:via-orange-600 {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .md\\:via-orange-700 {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .md\\:via-orange-800 {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .md\\:via-orange-900 {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .md\\:via-yellow-100 {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .md\\:via-yellow-200 {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .md\\:via-yellow-300 {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .md\\:via-yellow-400 {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .md\\:via-yellow-500 {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .md\\:via-yellow-600 {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .md\\:via-yellow-700 {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .md\\:via-yellow-800 {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .md\\:via-yellow-900 {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .md\\:via-green-100 {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .md\\:via-green-200 {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .md\\:via-green-300 {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .md\\:via-green-400 {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .md\\:via-green-500 {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .md\\:via-green-600 {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .md\\:via-green-700 {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .md\\:via-green-800 {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .md\\:via-green-900 {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .md\\:via-teal-100 {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .md\\:via-teal-200 {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .md\\:via-teal-300 {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .md\\:via-teal-400 {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .md\\:via-teal-500 {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .md\\:via-teal-600 {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .md\\:via-teal-700 {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .md\\:via-teal-800 {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .md\\:via-teal-900 {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .md\\:via-blue-100 {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .md\\:via-blue-200 {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .md\\:via-blue-300 {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .md\\:via-blue-400 {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .md\\:via-blue-500 {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .md\\:via-blue-600 {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .md\\:via-blue-700 {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .md\\:via-blue-800 {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .md\\:via-blue-900 {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .md\\:via-indigo-100 {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .md\\:via-indigo-200 {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .md\\:via-indigo-300 {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .md\\:via-indigo-400 {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .md\\:via-indigo-500 {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .md\\:via-indigo-600 {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .md\\:via-indigo-700 {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .md\\:via-indigo-800 {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .md\\:via-indigo-900 {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .md\\:via-purple-100 {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .md\\:via-purple-200 {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .md\\:via-purple-300 {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .md\\:via-purple-400 {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .md\\:via-purple-500 {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .md\\:via-purple-600 {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .md\\:via-purple-700 {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .md\\:via-purple-800 {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .md\\:via-purple-900 {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .md\\:via-pink-100 {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .md\\:via-pink-200 {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .md\\:via-pink-300 {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .md\\:via-pink-400 {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .md\\:via-pink-500 {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .md\\:via-pink-600 {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .md\\:via-pink-700 {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .md\\:via-pink-800 {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .md\\:via-pink-900 {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .md\\:to-transparent {
    --gradient-to-color: transparent;
  }

  .md\\:to-current {
    --gradient-to-color: currentColor;
  }

  .md\\:to-black {
    --gradient-to-color: #000;
  }

  .md\\:to-white {
    --gradient-to-color: #fff;
  }

  .md\\:to-gray-100 {
    --gradient-to-color: #f7fafc;
  }

  .md\\:to-gray-200 {
    --gradient-to-color: #edf2f7;
  }

  .md\\:to-gray-300 {
    --gradient-to-color: #e2e8f0;
  }

  .md\\:to-gray-400 {
    --gradient-to-color: #cbd5e0;
  }

  .md\\:to-gray-500 {
    --gradient-to-color: #a0aec0;
  }

  .md\\:to-gray-600 {
    --gradient-to-color: #718096;
  }

  .md\\:to-gray-700 {
    --gradient-to-color: #4a5568;
  }

  .md\\:to-gray-800 {
    --gradient-to-color: #2d3748;
  }

  .md\\:to-gray-900 {
    --gradient-to-color: #1a202c;
  }

  .md\\:to-red-100 {
    --gradient-to-color: #fff5f5;
  }

  .md\\:to-red-200 {
    --gradient-to-color: #fed7d7;
  }

  .md\\:to-red-300 {
    --gradient-to-color: #feb2b2;
  }

  .md\\:to-red-400 {
    --gradient-to-color: #fc8181;
  }

  .md\\:to-red-500 {
    --gradient-to-color: #f56565;
  }

  .md\\:to-red-600 {
    --gradient-to-color: #e53e3e;
  }

  .md\\:to-red-700 {
    --gradient-to-color: #c53030;
  }

  .md\\:to-red-800 {
    --gradient-to-color: #9b2c2c;
  }

  .md\\:to-red-900 {
    --gradient-to-color: #742a2a;
  }

  .md\\:to-orange-100 {
    --gradient-to-color: #fffaf0;
  }

  .md\\:to-orange-200 {
    --gradient-to-color: #feebc8;
  }

  .md\\:to-orange-300 {
    --gradient-to-color: #fbd38d;
  }

  .md\\:to-orange-400 {
    --gradient-to-color: #f6ad55;
  }

  .md\\:to-orange-500 {
    --gradient-to-color: #ed8936;
  }

  .md\\:to-orange-600 {
    --gradient-to-color: #dd6b20;
  }

  .md\\:to-orange-700 {
    --gradient-to-color: #c05621;
  }

  .md\\:to-orange-800 {
    --gradient-to-color: #9c4221;
  }

  .md\\:to-orange-900 {
    --gradient-to-color: #7b341e;
  }

  .md\\:to-yellow-100 {
    --gradient-to-color: #fffff0;
  }

  .md\\:to-yellow-200 {
    --gradient-to-color: #fefcbf;
  }

  .md\\:to-yellow-300 {
    --gradient-to-color: #faf089;
  }

  .md\\:to-yellow-400 {
    --gradient-to-color: #f6e05e;
  }

  .md\\:to-yellow-500 {
    --gradient-to-color: #ecc94b;
  }

  .md\\:to-yellow-600 {
    --gradient-to-color: #d69e2e;
  }

  .md\\:to-yellow-700 {
    --gradient-to-color: #b7791f;
  }

  .md\\:to-yellow-800 {
    --gradient-to-color: #975a16;
  }

  .md\\:to-yellow-900 {
    --gradient-to-color: #744210;
  }

  .md\\:to-green-100 {
    --gradient-to-color: #f0fff4;
  }

  .md\\:to-green-200 {
    --gradient-to-color: #c6f6d5;
  }

  .md\\:to-green-300 {
    --gradient-to-color: #9ae6b4;
  }

  .md\\:to-green-400 {
    --gradient-to-color: #68d391;
  }

  .md\\:to-green-500 {
    --gradient-to-color: #48bb78;
  }

  .md\\:to-green-600 {
    --gradient-to-color: #38a169;
  }

  .md\\:to-green-700 {
    --gradient-to-color: #2f855a;
  }

  .md\\:to-green-800 {
    --gradient-to-color: #276749;
  }

  .md\\:to-green-900 {
    --gradient-to-color: #22543d;
  }

  .md\\:to-teal-100 {
    --gradient-to-color: #e6fffa;
  }

  .md\\:to-teal-200 {
    --gradient-to-color: #b2f5ea;
  }

  .md\\:to-teal-300 {
    --gradient-to-color: #81e6d9;
  }

  .md\\:to-teal-400 {
    --gradient-to-color: #4fd1c5;
  }

  .md\\:to-teal-500 {
    --gradient-to-color: #38b2ac;
  }

  .md\\:to-teal-600 {
    --gradient-to-color: #319795;
  }

  .md\\:to-teal-700 {
    --gradient-to-color: #2c7a7b;
  }

  .md\\:to-teal-800 {
    --gradient-to-color: #285e61;
  }

  .md\\:to-teal-900 {
    --gradient-to-color: #234e52;
  }

  .md\\:to-blue-100 {
    --gradient-to-color: #ebf8ff;
  }

  .md\\:to-blue-200 {
    --gradient-to-color: #bee3f8;
  }

  .md\\:to-blue-300 {
    --gradient-to-color: #90cdf4;
  }

  .md\\:to-blue-400 {
    --gradient-to-color: #63b3ed;
  }

  .md\\:to-blue-500 {
    --gradient-to-color: #4299e1;
  }

  .md\\:to-blue-600 {
    --gradient-to-color: #3182ce;
  }

  .md\\:to-blue-700 {
    --gradient-to-color: #2b6cb0;
  }

  .md\\:to-blue-800 {
    --gradient-to-color: #2c5282;
  }

  .md\\:to-blue-900 {
    --gradient-to-color: #2a4365;
  }

  .md\\:to-indigo-100 {
    --gradient-to-color: #ebf4ff;
  }

  .md\\:to-indigo-200 {
    --gradient-to-color: #c3dafe;
  }

  .md\\:to-indigo-300 {
    --gradient-to-color: #a3bffa;
  }

  .md\\:to-indigo-400 {
    --gradient-to-color: #7f9cf5;
  }

  .md\\:to-indigo-500 {
    --gradient-to-color: #667eea;
  }

  .md\\:to-indigo-600 {
    --gradient-to-color: #5a67d8;
  }

  .md\\:to-indigo-700 {
    --gradient-to-color: #4c51bf;
  }

  .md\\:to-indigo-800 {
    --gradient-to-color: #434190;
  }

  .md\\:to-indigo-900 {
    --gradient-to-color: #3c366b;
  }

  .md\\:to-purple-100 {
    --gradient-to-color: #faf5ff;
  }

  .md\\:to-purple-200 {
    --gradient-to-color: #e9d8fd;
  }

  .md\\:to-purple-300 {
    --gradient-to-color: #d6bcfa;
  }

  .md\\:to-purple-400 {
    --gradient-to-color: #b794f4;
  }

  .md\\:to-purple-500 {
    --gradient-to-color: #9f7aea;
  }

  .md\\:to-purple-600 {
    --gradient-to-color: #805ad5;
  }

  .md\\:to-purple-700 {
    --gradient-to-color: #6b46c1;
  }

  .md\\:to-purple-800 {
    --gradient-to-color: #553c9a;
  }

  .md\\:to-purple-900 {
    --gradient-to-color: #44337a;
  }

  .md\\:to-pink-100 {
    --gradient-to-color: #fff5f7;
  }

  .md\\:to-pink-200 {
    --gradient-to-color: #fed7e2;
  }

  .md\\:to-pink-300 {
    --gradient-to-color: #fbb6ce;
  }

  .md\\:to-pink-400 {
    --gradient-to-color: #f687b3;
  }

  .md\\:to-pink-500 {
    --gradient-to-color: #ed64a6;
  }

  .md\\:to-pink-600 {
    --gradient-to-color: #d53f8c;
  }

  .md\\:to-pink-700 {
    --gradient-to-color: #b83280;
  }

  .md\\:to-pink-800 {
    --gradient-to-color: #97266d;
  }

  .md\\:to-pink-900 {
    --gradient-to-color: #702459;
  }

  .md\\:hover\\:from-transparent:hover {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:hover\\:from-current:hover {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:from-black:hover {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:hover\\:from-white:hover {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:from-gray-100:hover {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .md\\:hover\\:from-gray-200:hover {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .md\\:hover\\:from-gray-300:hover {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .md\\:hover\\:from-gray-400:hover {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .md\\:hover\\:from-gray-500:hover {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .md\\:hover\\:from-gray-600:hover {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .md\\:hover\\:from-gray-700:hover {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .md\\:hover\\:from-gray-800:hover {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .md\\:hover\\:from-gray-900:hover {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .md\\:hover\\:from-red-100:hover {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .md\\:hover\\:from-red-200:hover {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .md\\:hover\\:from-red-300:hover {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .md\\:hover\\:from-red-400:hover {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .md\\:hover\\:from-red-500:hover {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .md\\:hover\\:from-red-600:hover {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .md\\:hover\\:from-red-700:hover {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .md\\:hover\\:from-red-800:hover {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .md\\:hover\\:from-red-900:hover {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .md\\:hover\\:from-orange-100:hover {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .md\\:hover\\:from-orange-200:hover {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .md\\:hover\\:from-orange-300:hover {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .md\\:hover\\:from-orange-400:hover {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .md\\:hover\\:from-orange-500:hover {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .md\\:hover\\:from-orange-600:hover {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .md\\:hover\\:from-orange-700:hover {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .md\\:hover\\:from-orange-800:hover {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .md\\:hover\\:from-orange-900:hover {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .md\\:hover\\:from-yellow-100:hover {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .md\\:hover\\:from-yellow-200:hover {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .md\\:hover\\:from-yellow-300:hover {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .md\\:hover\\:from-yellow-400:hover {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .md\\:hover\\:from-yellow-500:hover {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .md\\:hover\\:from-yellow-600:hover {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .md\\:hover\\:from-yellow-700:hover {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .md\\:hover\\:from-yellow-800:hover {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .md\\:hover\\:from-yellow-900:hover {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .md\\:hover\\:from-green-100:hover {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .md\\:hover\\:from-green-200:hover {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .md\\:hover\\:from-green-300:hover {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .md\\:hover\\:from-green-400:hover {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .md\\:hover\\:from-green-500:hover {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .md\\:hover\\:from-green-600:hover {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .md\\:hover\\:from-green-700:hover {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .md\\:hover\\:from-green-800:hover {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .md\\:hover\\:from-green-900:hover {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .md\\:hover\\:from-teal-100:hover {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .md\\:hover\\:from-teal-200:hover {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .md\\:hover\\:from-teal-300:hover {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .md\\:hover\\:from-teal-400:hover {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .md\\:hover\\:from-teal-500:hover {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .md\\:hover\\:from-teal-600:hover {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .md\\:hover\\:from-teal-700:hover {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .md\\:hover\\:from-teal-800:hover {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .md\\:hover\\:from-teal-900:hover {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .md\\:hover\\:from-blue-100:hover {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .md\\:hover\\:from-blue-200:hover {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .md\\:hover\\:from-blue-300:hover {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .md\\:hover\\:from-blue-400:hover {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .md\\:hover\\:from-blue-500:hover {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .md\\:hover\\:from-blue-600:hover {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .md\\:hover\\:from-blue-700:hover {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .md\\:hover\\:from-blue-800:hover {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .md\\:hover\\:from-blue-900:hover {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .md\\:hover\\:from-indigo-100:hover {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .md\\:hover\\:from-indigo-200:hover {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .md\\:hover\\:from-indigo-300:hover {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .md\\:hover\\:from-indigo-400:hover {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .md\\:hover\\:from-indigo-500:hover {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .md\\:hover\\:from-indigo-600:hover {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .md\\:hover\\:from-indigo-700:hover {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .md\\:hover\\:from-indigo-800:hover {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .md\\:hover\\:from-indigo-900:hover {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .md\\:hover\\:from-purple-100:hover {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .md\\:hover\\:from-purple-200:hover {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .md\\:hover\\:from-purple-300:hover {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .md\\:hover\\:from-purple-400:hover {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .md\\:hover\\:from-purple-500:hover {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .md\\:hover\\:from-purple-600:hover {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .md\\:hover\\:from-purple-700:hover {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .md\\:hover\\:from-purple-800:hover {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .md\\:hover\\:from-purple-900:hover {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .md\\:hover\\:from-pink-100:hover {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .md\\:hover\\:from-pink-200:hover {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .md\\:hover\\:from-pink-300:hover {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .md\\:hover\\:from-pink-400:hover {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .md\\:hover\\:from-pink-500:hover {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .md\\:hover\\:from-pink-600:hover {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .md\\:hover\\:from-pink-700:hover {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .md\\:hover\\:from-pink-800:hover {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .md\\:hover\\:from-pink-900:hover {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .md\\:hover\\:via-transparent:hover {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:hover\\:via-current:hover {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:via-black:hover {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:hover\\:via-white:hover {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:via-gray-100:hover {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .md\\:hover\\:via-gray-200:hover {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .md\\:hover\\:via-gray-300:hover {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .md\\:hover\\:via-gray-400:hover {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .md\\:hover\\:via-gray-500:hover {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .md\\:hover\\:via-gray-600:hover {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .md\\:hover\\:via-gray-700:hover {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .md\\:hover\\:via-gray-800:hover {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .md\\:hover\\:via-gray-900:hover {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .md\\:hover\\:via-red-100:hover {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .md\\:hover\\:via-red-200:hover {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .md\\:hover\\:via-red-300:hover {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .md\\:hover\\:via-red-400:hover {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .md\\:hover\\:via-red-500:hover {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .md\\:hover\\:via-red-600:hover {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .md\\:hover\\:via-red-700:hover {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .md\\:hover\\:via-red-800:hover {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .md\\:hover\\:via-red-900:hover {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .md\\:hover\\:via-orange-100:hover {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .md\\:hover\\:via-orange-200:hover {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .md\\:hover\\:via-orange-300:hover {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .md\\:hover\\:via-orange-400:hover {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .md\\:hover\\:via-orange-500:hover {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .md\\:hover\\:via-orange-600:hover {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .md\\:hover\\:via-orange-700:hover {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .md\\:hover\\:via-orange-800:hover {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .md\\:hover\\:via-orange-900:hover {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .md\\:hover\\:via-yellow-100:hover {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .md\\:hover\\:via-yellow-200:hover {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .md\\:hover\\:via-yellow-300:hover {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .md\\:hover\\:via-yellow-400:hover {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .md\\:hover\\:via-yellow-500:hover {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .md\\:hover\\:via-yellow-600:hover {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .md\\:hover\\:via-yellow-700:hover {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .md\\:hover\\:via-yellow-800:hover {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .md\\:hover\\:via-yellow-900:hover {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .md\\:hover\\:via-green-100:hover {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .md\\:hover\\:via-green-200:hover {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .md\\:hover\\:via-green-300:hover {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .md\\:hover\\:via-green-400:hover {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .md\\:hover\\:via-green-500:hover {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .md\\:hover\\:via-green-600:hover {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .md\\:hover\\:via-green-700:hover {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .md\\:hover\\:via-green-800:hover {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .md\\:hover\\:via-green-900:hover {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .md\\:hover\\:via-teal-100:hover {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .md\\:hover\\:via-teal-200:hover {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .md\\:hover\\:via-teal-300:hover {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .md\\:hover\\:via-teal-400:hover {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .md\\:hover\\:via-teal-500:hover {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .md\\:hover\\:via-teal-600:hover {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .md\\:hover\\:via-teal-700:hover {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .md\\:hover\\:via-teal-800:hover {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .md\\:hover\\:via-teal-900:hover {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .md\\:hover\\:via-blue-100:hover {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .md\\:hover\\:via-blue-200:hover {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .md\\:hover\\:via-blue-300:hover {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .md\\:hover\\:via-blue-400:hover {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .md\\:hover\\:via-blue-500:hover {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .md\\:hover\\:via-blue-600:hover {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .md\\:hover\\:via-blue-700:hover {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .md\\:hover\\:via-blue-800:hover {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .md\\:hover\\:via-blue-900:hover {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .md\\:hover\\:via-indigo-100:hover {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .md\\:hover\\:via-indigo-200:hover {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .md\\:hover\\:via-indigo-300:hover {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .md\\:hover\\:via-indigo-400:hover {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .md\\:hover\\:via-indigo-500:hover {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .md\\:hover\\:via-indigo-600:hover {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .md\\:hover\\:via-indigo-700:hover {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .md\\:hover\\:via-indigo-800:hover {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .md\\:hover\\:via-indigo-900:hover {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .md\\:hover\\:via-purple-100:hover {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .md\\:hover\\:via-purple-200:hover {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .md\\:hover\\:via-purple-300:hover {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .md\\:hover\\:via-purple-400:hover {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .md\\:hover\\:via-purple-500:hover {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .md\\:hover\\:via-purple-600:hover {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .md\\:hover\\:via-purple-700:hover {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .md\\:hover\\:via-purple-800:hover {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .md\\:hover\\:via-purple-900:hover {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .md\\:hover\\:via-pink-100:hover {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .md\\:hover\\:via-pink-200:hover {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .md\\:hover\\:via-pink-300:hover {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .md\\:hover\\:via-pink-400:hover {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .md\\:hover\\:via-pink-500:hover {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .md\\:hover\\:via-pink-600:hover {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .md\\:hover\\:via-pink-700:hover {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .md\\:hover\\:via-pink-800:hover {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .md\\:hover\\:via-pink-900:hover {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .md\\:hover\\:to-transparent:hover {
    --gradient-to-color: transparent;
  }

  .md\\:hover\\:to-current:hover {
    --gradient-to-color: currentColor;
  }

  .md\\:hover\\:to-black:hover {
    --gradient-to-color: #000;
  }

  .md\\:hover\\:to-white:hover {
    --gradient-to-color: #fff;
  }

  .md\\:hover\\:to-gray-100:hover {
    --gradient-to-color: #f7fafc;
  }

  .md\\:hover\\:to-gray-200:hover {
    --gradient-to-color: #edf2f7;
  }

  .md\\:hover\\:to-gray-300:hover {
    --gradient-to-color: #e2e8f0;
  }

  .md\\:hover\\:to-gray-400:hover {
    --gradient-to-color: #cbd5e0;
  }

  .md\\:hover\\:to-gray-500:hover {
    --gradient-to-color: #a0aec0;
  }

  .md\\:hover\\:to-gray-600:hover {
    --gradient-to-color: #718096;
  }

  .md\\:hover\\:to-gray-700:hover {
    --gradient-to-color: #4a5568;
  }

  .md\\:hover\\:to-gray-800:hover {
    --gradient-to-color: #2d3748;
  }

  .md\\:hover\\:to-gray-900:hover {
    --gradient-to-color: #1a202c;
  }

  .md\\:hover\\:to-red-100:hover {
    --gradient-to-color: #fff5f5;
  }

  .md\\:hover\\:to-red-200:hover {
    --gradient-to-color: #fed7d7;
  }

  .md\\:hover\\:to-red-300:hover {
    --gradient-to-color: #feb2b2;
  }

  .md\\:hover\\:to-red-400:hover {
    --gradient-to-color: #fc8181;
  }

  .md\\:hover\\:to-red-500:hover {
    --gradient-to-color: #f56565;
  }

  .md\\:hover\\:to-red-600:hover {
    --gradient-to-color: #e53e3e;
  }

  .md\\:hover\\:to-red-700:hover {
    --gradient-to-color: #c53030;
  }

  .md\\:hover\\:to-red-800:hover {
    --gradient-to-color: #9b2c2c;
  }

  .md\\:hover\\:to-red-900:hover {
    --gradient-to-color: #742a2a;
  }

  .md\\:hover\\:to-orange-100:hover {
    --gradient-to-color: #fffaf0;
  }

  .md\\:hover\\:to-orange-200:hover {
    --gradient-to-color: #feebc8;
  }

  .md\\:hover\\:to-orange-300:hover {
    --gradient-to-color: #fbd38d;
  }

  .md\\:hover\\:to-orange-400:hover {
    --gradient-to-color: #f6ad55;
  }

  .md\\:hover\\:to-orange-500:hover {
    --gradient-to-color: #ed8936;
  }

  .md\\:hover\\:to-orange-600:hover {
    --gradient-to-color: #dd6b20;
  }

  .md\\:hover\\:to-orange-700:hover {
    --gradient-to-color: #c05621;
  }

  .md\\:hover\\:to-orange-800:hover {
    --gradient-to-color: #9c4221;
  }

  .md\\:hover\\:to-orange-900:hover {
    --gradient-to-color: #7b341e;
  }

  .md\\:hover\\:to-yellow-100:hover {
    --gradient-to-color: #fffff0;
  }

  .md\\:hover\\:to-yellow-200:hover {
    --gradient-to-color: #fefcbf;
  }

  .md\\:hover\\:to-yellow-300:hover {
    --gradient-to-color: #faf089;
  }

  .md\\:hover\\:to-yellow-400:hover {
    --gradient-to-color: #f6e05e;
  }

  .md\\:hover\\:to-yellow-500:hover {
    --gradient-to-color: #ecc94b;
  }

  .md\\:hover\\:to-yellow-600:hover {
    --gradient-to-color: #d69e2e;
  }

  .md\\:hover\\:to-yellow-700:hover {
    --gradient-to-color: #b7791f;
  }

  .md\\:hover\\:to-yellow-800:hover {
    --gradient-to-color: #975a16;
  }

  .md\\:hover\\:to-yellow-900:hover {
    --gradient-to-color: #744210;
  }

  .md\\:hover\\:to-green-100:hover {
    --gradient-to-color: #f0fff4;
  }

  .md\\:hover\\:to-green-200:hover {
    --gradient-to-color: #c6f6d5;
  }

  .md\\:hover\\:to-green-300:hover {
    --gradient-to-color: #9ae6b4;
  }

  .md\\:hover\\:to-green-400:hover {
    --gradient-to-color: #68d391;
  }

  .md\\:hover\\:to-green-500:hover {
    --gradient-to-color: #48bb78;
  }

  .md\\:hover\\:to-green-600:hover {
    --gradient-to-color: #38a169;
  }

  .md\\:hover\\:to-green-700:hover {
    --gradient-to-color: #2f855a;
  }

  .md\\:hover\\:to-green-800:hover {
    --gradient-to-color: #276749;
  }

  .md\\:hover\\:to-green-900:hover {
    --gradient-to-color: #22543d;
  }

  .md\\:hover\\:to-teal-100:hover {
    --gradient-to-color: #e6fffa;
  }

  .md\\:hover\\:to-teal-200:hover {
    --gradient-to-color: #b2f5ea;
  }

  .md\\:hover\\:to-teal-300:hover {
    --gradient-to-color: #81e6d9;
  }

  .md\\:hover\\:to-teal-400:hover {
    --gradient-to-color: #4fd1c5;
  }

  .md\\:hover\\:to-teal-500:hover {
    --gradient-to-color: #38b2ac;
  }

  .md\\:hover\\:to-teal-600:hover {
    --gradient-to-color: #319795;
  }

  .md\\:hover\\:to-teal-700:hover {
    --gradient-to-color: #2c7a7b;
  }

  .md\\:hover\\:to-teal-800:hover {
    --gradient-to-color: #285e61;
  }

  .md\\:hover\\:to-teal-900:hover {
    --gradient-to-color: #234e52;
  }

  .md\\:hover\\:to-blue-100:hover {
    --gradient-to-color: #ebf8ff;
  }

  .md\\:hover\\:to-blue-200:hover {
    --gradient-to-color: #bee3f8;
  }

  .md\\:hover\\:to-blue-300:hover {
    --gradient-to-color: #90cdf4;
  }

  .md\\:hover\\:to-blue-400:hover {
    --gradient-to-color: #63b3ed;
  }

  .md\\:hover\\:to-blue-500:hover {
    --gradient-to-color: #4299e1;
  }

  .md\\:hover\\:to-blue-600:hover {
    --gradient-to-color: #3182ce;
  }

  .md\\:hover\\:to-blue-700:hover {
    --gradient-to-color: #2b6cb0;
  }

  .md\\:hover\\:to-blue-800:hover {
    --gradient-to-color: #2c5282;
  }

  .md\\:hover\\:to-blue-900:hover {
    --gradient-to-color: #2a4365;
  }

  .md\\:hover\\:to-indigo-100:hover {
    --gradient-to-color: #ebf4ff;
  }

  .md\\:hover\\:to-indigo-200:hover {
    --gradient-to-color: #c3dafe;
  }

  .md\\:hover\\:to-indigo-300:hover {
    --gradient-to-color: #a3bffa;
  }

  .md\\:hover\\:to-indigo-400:hover {
    --gradient-to-color: #7f9cf5;
  }

  .md\\:hover\\:to-indigo-500:hover {
    --gradient-to-color: #667eea;
  }

  .md\\:hover\\:to-indigo-600:hover {
    --gradient-to-color: #5a67d8;
  }

  .md\\:hover\\:to-indigo-700:hover {
    --gradient-to-color: #4c51bf;
  }

  .md\\:hover\\:to-indigo-800:hover {
    --gradient-to-color: #434190;
  }

  .md\\:hover\\:to-indigo-900:hover {
    --gradient-to-color: #3c366b;
  }

  .md\\:hover\\:to-purple-100:hover {
    --gradient-to-color: #faf5ff;
  }

  .md\\:hover\\:to-purple-200:hover {
    --gradient-to-color: #e9d8fd;
  }

  .md\\:hover\\:to-purple-300:hover {
    --gradient-to-color: #d6bcfa;
  }

  .md\\:hover\\:to-purple-400:hover {
    --gradient-to-color: #b794f4;
  }

  .md\\:hover\\:to-purple-500:hover {
    --gradient-to-color: #9f7aea;
  }

  .md\\:hover\\:to-purple-600:hover {
    --gradient-to-color: #805ad5;
  }

  .md\\:hover\\:to-purple-700:hover {
    --gradient-to-color: #6b46c1;
  }

  .md\\:hover\\:to-purple-800:hover {
    --gradient-to-color: #553c9a;
  }

  .md\\:hover\\:to-purple-900:hover {
    --gradient-to-color: #44337a;
  }

  .md\\:hover\\:to-pink-100:hover {
    --gradient-to-color: #fff5f7;
  }

  .md\\:hover\\:to-pink-200:hover {
    --gradient-to-color: #fed7e2;
  }

  .md\\:hover\\:to-pink-300:hover {
    --gradient-to-color: #fbb6ce;
  }

  .md\\:hover\\:to-pink-400:hover {
    --gradient-to-color: #f687b3;
  }

  .md\\:hover\\:to-pink-500:hover {
    --gradient-to-color: #ed64a6;
  }

  .md\\:hover\\:to-pink-600:hover {
    --gradient-to-color: #d53f8c;
  }

  .md\\:hover\\:to-pink-700:hover {
    --gradient-to-color: #b83280;
  }

  .md\\:hover\\:to-pink-800:hover {
    --gradient-to-color: #97266d;
  }

  .md\\:hover\\:to-pink-900:hover {
    --gradient-to-color: #702459;
  }

  .md\\:focus\\:from-transparent:focus {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:focus\\:from-current:focus {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:from-black:focus {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:focus\\:from-white:focus {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:from-gray-100:focus {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .md\\:focus\\:from-gray-200:focus {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .md\\:focus\\:from-gray-300:focus {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .md\\:focus\\:from-gray-400:focus {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .md\\:focus\\:from-gray-500:focus {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .md\\:focus\\:from-gray-600:focus {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .md\\:focus\\:from-gray-700:focus {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .md\\:focus\\:from-gray-800:focus {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .md\\:focus\\:from-gray-900:focus {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .md\\:focus\\:from-red-100:focus {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .md\\:focus\\:from-red-200:focus {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .md\\:focus\\:from-red-300:focus {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .md\\:focus\\:from-red-400:focus {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .md\\:focus\\:from-red-500:focus {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .md\\:focus\\:from-red-600:focus {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .md\\:focus\\:from-red-700:focus {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .md\\:focus\\:from-red-800:focus {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .md\\:focus\\:from-red-900:focus {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .md\\:focus\\:from-orange-100:focus {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .md\\:focus\\:from-orange-200:focus {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .md\\:focus\\:from-orange-300:focus {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .md\\:focus\\:from-orange-400:focus {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .md\\:focus\\:from-orange-500:focus {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .md\\:focus\\:from-orange-600:focus {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .md\\:focus\\:from-orange-700:focus {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .md\\:focus\\:from-orange-800:focus {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .md\\:focus\\:from-orange-900:focus {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .md\\:focus\\:from-yellow-100:focus {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .md\\:focus\\:from-yellow-200:focus {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .md\\:focus\\:from-yellow-300:focus {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .md\\:focus\\:from-yellow-400:focus {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .md\\:focus\\:from-yellow-500:focus {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .md\\:focus\\:from-yellow-600:focus {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .md\\:focus\\:from-yellow-700:focus {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .md\\:focus\\:from-yellow-800:focus {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .md\\:focus\\:from-yellow-900:focus {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .md\\:focus\\:from-green-100:focus {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .md\\:focus\\:from-green-200:focus {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .md\\:focus\\:from-green-300:focus {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .md\\:focus\\:from-green-400:focus {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .md\\:focus\\:from-green-500:focus {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .md\\:focus\\:from-green-600:focus {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .md\\:focus\\:from-green-700:focus {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .md\\:focus\\:from-green-800:focus {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .md\\:focus\\:from-green-900:focus {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .md\\:focus\\:from-teal-100:focus {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .md\\:focus\\:from-teal-200:focus {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .md\\:focus\\:from-teal-300:focus {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .md\\:focus\\:from-teal-400:focus {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .md\\:focus\\:from-teal-500:focus {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .md\\:focus\\:from-teal-600:focus {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .md\\:focus\\:from-teal-700:focus {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .md\\:focus\\:from-teal-800:focus {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .md\\:focus\\:from-teal-900:focus {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .md\\:focus\\:from-blue-100:focus {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .md\\:focus\\:from-blue-200:focus {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .md\\:focus\\:from-blue-300:focus {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .md\\:focus\\:from-blue-400:focus {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .md\\:focus\\:from-blue-500:focus {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .md\\:focus\\:from-blue-600:focus {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .md\\:focus\\:from-blue-700:focus {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .md\\:focus\\:from-blue-800:focus {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .md\\:focus\\:from-blue-900:focus {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .md\\:focus\\:from-indigo-100:focus {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .md\\:focus\\:from-indigo-200:focus {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .md\\:focus\\:from-indigo-300:focus {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .md\\:focus\\:from-indigo-400:focus {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .md\\:focus\\:from-indigo-500:focus {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .md\\:focus\\:from-indigo-600:focus {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .md\\:focus\\:from-indigo-700:focus {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .md\\:focus\\:from-indigo-800:focus {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .md\\:focus\\:from-indigo-900:focus {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .md\\:focus\\:from-purple-100:focus {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .md\\:focus\\:from-purple-200:focus {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .md\\:focus\\:from-purple-300:focus {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .md\\:focus\\:from-purple-400:focus {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .md\\:focus\\:from-purple-500:focus {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .md\\:focus\\:from-purple-600:focus {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .md\\:focus\\:from-purple-700:focus {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .md\\:focus\\:from-purple-800:focus {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .md\\:focus\\:from-purple-900:focus {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .md\\:focus\\:from-pink-100:focus {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .md\\:focus\\:from-pink-200:focus {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .md\\:focus\\:from-pink-300:focus {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .md\\:focus\\:from-pink-400:focus {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .md\\:focus\\:from-pink-500:focus {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .md\\:focus\\:from-pink-600:focus {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .md\\:focus\\:from-pink-700:focus {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .md\\:focus\\:from-pink-800:focus {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .md\\:focus\\:from-pink-900:focus {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .md\\:focus\\:via-transparent:focus {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:focus\\:via-current:focus {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:via-black:focus {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:focus\\:via-white:focus {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:via-gray-100:focus {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .md\\:focus\\:via-gray-200:focus {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .md\\:focus\\:via-gray-300:focus {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .md\\:focus\\:via-gray-400:focus {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .md\\:focus\\:via-gray-500:focus {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .md\\:focus\\:via-gray-600:focus {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .md\\:focus\\:via-gray-700:focus {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .md\\:focus\\:via-gray-800:focus {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .md\\:focus\\:via-gray-900:focus {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .md\\:focus\\:via-red-100:focus {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .md\\:focus\\:via-red-200:focus {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .md\\:focus\\:via-red-300:focus {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .md\\:focus\\:via-red-400:focus {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .md\\:focus\\:via-red-500:focus {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .md\\:focus\\:via-red-600:focus {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .md\\:focus\\:via-red-700:focus {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .md\\:focus\\:via-red-800:focus {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .md\\:focus\\:via-red-900:focus {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .md\\:focus\\:via-orange-100:focus {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .md\\:focus\\:via-orange-200:focus {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .md\\:focus\\:via-orange-300:focus {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .md\\:focus\\:via-orange-400:focus {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .md\\:focus\\:via-orange-500:focus {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .md\\:focus\\:via-orange-600:focus {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .md\\:focus\\:via-orange-700:focus {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .md\\:focus\\:via-orange-800:focus {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .md\\:focus\\:via-orange-900:focus {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .md\\:focus\\:via-yellow-100:focus {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .md\\:focus\\:via-yellow-200:focus {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .md\\:focus\\:via-yellow-300:focus {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .md\\:focus\\:via-yellow-400:focus {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .md\\:focus\\:via-yellow-500:focus {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .md\\:focus\\:via-yellow-600:focus {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .md\\:focus\\:via-yellow-700:focus {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .md\\:focus\\:via-yellow-800:focus {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .md\\:focus\\:via-yellow-900:focus {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .md\\:focus\\:via-green-100:focus {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .md\\:focus\\:via-green-200:focus {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .md\\:focus\\:via-green-300:focus {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .md\\:focus\\:via-green-400:focus {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .md\\:focus\\:via-green-500:focus {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .md\\:focus\\:via-green-600:focus {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .md\\:focus\\:via-green-700:focus {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .md\\:focus\\:via-green-800:focus {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .md\\:focus\\:via-green-900:focus {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .md\\:focus\\:via-teal-100:focus {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .md\\:focus\\:via-teal-200:focus {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .md\\:focus\\:via-teal-300:focus {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .md\\:focus\\:via-teal-400:focus {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .md\\:focus\\:via-teal-500:focus {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .md\\:focus\\:via-teal-600:focus {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .md\\:focus\\:via-teal-700:focus {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .md\\:focus\\:via-teal-800:focus {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .md\\:focus\\:via-teal-900:focus {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .md\\:focus\\:via-blue-100:focus {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .md\\:focus\\:via-blue-200:focus {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .md\\:focus\\:via-blue-300:focus {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .md\\:focus\\:via-blue-400:focus {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .md\\:focus\\:via-blue-500:focus {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .md\\:focus\\:via-blue-600:focus {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .md\\:focus\\:via-blue-700:focus {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .md\\:focus\\:via-blue-800:focus {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .md\\:focus\\:via-blue-900:focus {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .md\\:focus\\:via-indigo-100:focus {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .md\\:focus\\:via-indigo-200:focus {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .md\\:focus\\:via-indigo-300:focus {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .md\\:focus\\:via-indigo-400:focus {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .md\\:focus\\:via-indigo-500:focus {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .md\\:focus\\:via-indigo-600:focus {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .md\\:focus\\:via-indigo-700:focus {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .md\\:focus\\:via-indigo-800:focus {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .md\\:focus\\:via-indigo-900:focus {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .md\\:focus\\:via-purple-100:focus {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .md\\:focus\\:via-purple-200:focus {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .md\\:focus\\:via-purple-300:focus {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .md\\:focus\\:via-purple-400:focus {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .md\\:focus\\:via-purple-500:focus {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .md\\:focus\\:via-purple-600:focus {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .md\\:focus\\:via-purple-700:focus {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .md\\:focus\\:via-purple-800:focus {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .md\\:focus\\:via-purple-900:focus {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .md\\:focus\\:via-pink-100:focus {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .md\\:focus\\:via-pink-200:focus {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .md\\:focus\\:via-pink-300:focus {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .md\\:focus\\:via-pink-400:focus {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .md\\:focus\\:via-pink-500:focus {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .md\\:focus\\:via-pink-600:focus {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .md\\:focus\\:via-pink-700:focus {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .md\\:focus\\:via-pink-800:focus {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .md\\:focus\\:via-pink-900:focus {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .md\\:focus\\:to-transparent:focus {
    --gradient-to-color: transparent;
  }

  .md\\:focus\\:to-current:focus {
    --gradient-to-color: currentColor;
  }

  .md\\:focus\\:to-black:focus {
    --gradient-to-color: #000;
  }

  .md\\:focus\\:to-white:focus {
    --gradient-to-color: #fff;
  }

  .md\\:focus\\:to-gray-100:focus {
    --gradient-to-color: #f7fafc;
  }

  .md\\:focus\\:to-gray-200:focus {
    --gradient-to-color: #edf2f7;
  }

  .md\\:focus\\:to-gray-300:focus {
    --gradient-to-color: #e2e8f0;
  }

  .md\\:focus\\:to-gray-400:focus {
    --gradient-to-color: #cbd5e0;
  }

  .md\\:focus\\:to-gray-500:focus {
    --gradient-to-color: #a0aec0;
  }

  .md\\:focus\\:to-gray-600:focus {
    --gradient-to-color: #718096;
  }

  .md\\:focus\\:to-gray-700:focus {
    --gradient-to-color: #4a5568;
  }

  .md\\:focus\\:to-gray-800:focus {
    --gradient-to-color: #2d3748;
  }

  .md\\:focus\\:to-gray-900:focus {
    --gradient-to-color: #1a202c;
  }

  .md\\:focus\\:to-red-100:focus {
    --gradient-to-color: #fff5f5;
  }

  .md\\:focus\\:to-red-200:focus {
    --gradient-to-color: #fed7d7;
  }

  .md\\:focus\\:to-red-300:focus {
    --gradient-to-color: #feb2b2;
  }

  .md\\:focus\\:to-red-400:focus {
    --gradient-to-color: #fc8181;
  }

  .md\\:focus\\:to-red-500:focus {
    --gradient-to-color: #f56565;
  }

  .md\\:focus\\:to-red-600:focus {
    --gradient-to-color: #e53e3e;
  }

  .md\\:focus\\:to-red-700:focus {
    --gradient-to-color: #c53030;
  }

  .md\\:focus\\:to-red-800:focus {
    --gradient-to-color: #9b2c2c;
  }

  .md\\:focus\\:to-red-900:focus {
    --gradient-to-color: #742a2a;
  }

  .md\\:focus\\:to-orange-100:focus {
    --gradient-to-color: #fffaf0;
  }

  .md\\:focus\\:to-orange-200:focus {
    --gradient-to-color: #feebc8;
  }

  .md\\:focus\\:to-orange-300:focus {
    --gradient-to-color: #fbd38d;
  }

  .md\\:focus\\:to-orange-400:focus {
    --gradient-to-color: #f6ad55;
  }

  .md\\:focus\\:to-orange-500:focus {
    --gradient-to-color: #ed8936;
  }

  .md\\:focus\\:to-orange-600:focus {
    --gradient-to-color: #dd6b20;
  }

  .md\\:focus\\:to-orange-700:focus {
    --gradient-to-color: #c05621;
  }

  .md\\:focus\\:to-orange-800:focus {
    --gradient-to-color: #9c4221;
  }

  .md\\:focus\\:to-orange-900:focus {
    --gradient-to-color: #7b341e;
  }

  .md\\:focus\\:to-yellow-100:focus {
    --gradient-to-color: #fffff0;
  }

  .md\\:focus\\:to-yellow-200:focus {
    --gradient-to-color: #fefcbf;
  }

  .md\\:focus\\:to-yellow-300:focus {
    --gradient-to-color: #faf089;
  }

  .md\\:focus\\:to-yellow-400:focus {
    --gradient-to-color: #f6e05e;
  }

  .md\\:focus\\:to-yellow-500:focus {
    --gradient-to-color: #ecc94b;
  }

  .md\\:focus\\:to-yellow-600:focus {
    --gradient-to-color: #d69e2e;
  }

  .md\\:focus\\:to-yellow-700:focus {
    --gradient-to-color: #b7791f;
  }

  .md\\:focus\\:to-yellow-800:focus {
    --gradient-to-color: #975a16;
  }

  .md\\:focus\\:to-yellow-900:focus {
    --gradient-to-color: #744210;
  }

  .md\\:focus\\:to-green-100:focus {
    --gradient-to-color: #f0fff4;
  }

  .md\\:focus\\:to-green-200:focus {
    --gradient-to-color: #c6f6d5;
  }

  .md\\:focus\\:to-green-300:focus {
    --gradient-to-color: #9ae6b4;
  }

  .md\\:focus\\:to-green-400:focus {
    --gradient-to-color: #68d391;
  }

  .md\\:focus\\:to-green-500:focus {
    --gradient-to-color: #48bb78;
  }

  .md\\:focus\\:to-green-600:focus {
    --gradient-to-color: #38a169;
  }

  .md\\:focus\\:to-green-700:focus {
    --gradient-to-color: #2f855a;
  }

  .md\\:focus\\:to-green-800:focus {
    --gradient-to-color: #276749;
  }

  .md\\:focus\\:to-green-900:focus {
    --gradient-to-color: #22543d;
  }

  .md\\:focus\\:to-teal-100:focus {
    --gradient-to-color: #e6fffa;
  }

  .md\\:focus\\:to-teal-200:focus {
    --gradient-to-color: #b2f5ea;
  }

  .md\\:focus\\:to-teal-300:focus {
    --gradient-to-color: #81e6d9;
  }

  .md\\:focus\\:to-teal-400:focus {
    --gradient-to-color: #4fd1c5;
  }

  .md\\:focus\\:to-teal-500:focus {
    --gradient-to-color: #38b2ac;
  }

  .md\\:focus\\:to-teal-600:focus {
    --gradient-to-color: #319795;
  }

  .md\\:focus\\:to-teal-700:focus {
    --gradient-to-color: #2c7a7b;
  }

  .md\\:focus\\:to-teal-800:focus {
    --gradient-to-color: #285e61;
  }

  .md\\:focus\\:to-teal-900:focus {
    --gradient-to-color: #234e52;
  }

  .md\\:focus\\:to-blue-100:focus {
    --gradient-to-color: #ebf8ff;
  }

  .md\\:focus\\:to-blue-200:focus {
    --gradient-to-color: #bee3f8;
  }

  .md\\:focus\\:to-blue-300:focus {
    --gradient-to-color: #90cdf4;
  }

  .md\\:focus\\:to-blue-400:focus {
    --gradient-to-color: #63b3ed;
  }

  .md\\:focus\\:to-blue-500:focus {
    --gradient-to-color: #4299e1;
  }

  .md\\:focus\\:to-blue-600:focus {
    --gradient-to-color: #3182ce;
  }

  .md\\:focus\\:to-blue-700:focus {
    --gradient-to-color: #2b6cb0;
  }

  .md\\:focus\\:to-blue-800:focus {
    --gradient-to-color: #2c5282;
  }

  .md\\:focus\\:to-blue-900:focus {
    --gradient-to-color: #2a4365;
  }

  .md\\:focus\\:to-indigo-100:focus {
    --gradient-to-color: #ebf4ff;
  }

  .md\\:focus\\:to-indigo-200:focus {
    --gradient-to-color: #c3dafe;
  }

  .md\\:focus\\:to-indigo-300:focus {
    --gradient-to-color: #a3bffa;
  }

  .md\\:focus\\:to-indigo-400:focus {
    --gradient-to-color: #7f9cf5;
  }

  .md\\:focus\\:to-indigo-500:focus {
    --gradient-to-color: #667eea;
  }

  .md\\:focus\\:to-indigo-600:focus {
    --gradient-to-color: #5a67d8;
  }

  .md\\:focus\\:to-indigo-700:focus {
    --gradient-to-color: #4c51bf;
  }

  .md\\:focus\\:to-indigo-800:focus {
    --gradient-to-color: #434190;
  }

  .md\\:focus\\:to-indigo-900:focus {
    --gradient-to-color: #3c366b;
  }

  .md\\:focus\\:to-purple-100:focus {
    --gradient-to-color: #faf5ff;
  }

  .md\\:focus\\:to-purple-200:focus {
    --gradient-to-color: #e9d8fd;
  }

  .md\\:focus\\:to-purple-300:focus {
    --gradient-to-color: #d6bcfa;
  }

  .md\\:focus\\:to-purple-400:focus {
    --gradient-to-color: #b794f4;
  }

  .md\\:focus\\:to-purple-500:focus {
    --gradient-to-color: #9f7aea;
  }

  .md\\:focus\\:to-purple-600:focus {
    --gradient-to-color: #805ad5;
  }

  .md\\:focus\\:to-purple-700:focus {
    --gradient-to-color: #6b46c1;
  }

  .md\\:focus\\:to-purple-800:focus {
    --gradient-to-color: #553c9a;
  }

  .md\\:focus\\:to-purple-900:focus {
    --gradient-to-color: #44337a;
  }

  .md\\:focus\\:to-pink-100:focus {
    --gradient-to-color: #fff5f7;
  }

  .md\\:focus\\:to-pink-200:focus {
    --gradient-to-color: #fed7e2;
  }

  .md\\:focus\\:to-pink-300:focus {
    --gradient-to-color: #fbb6ce;
  }

  .md\\:focus\\:to-pink-400:focus {
    --gradient-to-color: #f687b3;
  }

  .md\\:focus\\:to-pink-500:focus {
    --gradient-to-color: #ed64a6;
  }

  .md\\:focus\\:to-pink-600:focus {
    --gradient-to-color: #d53f8c;
  }

  .md\\:focus\\:to-pink-700:focus {
    --gradient-to-color: #b83280;
  }

  .md\\:focus\\:to-pink-800:focus {
    --gradient-to-color: #97266d;
  }

  .md\\:focus\\:to-pink-900:focus {
    --gradient-to-color: #702459;
  }

  .md\\:bg-opacity-0 {
    --bg-opacity: 0;
  }

  .md\\:bg-opacity-25 {
    --bg-opacity: 0.25;
  }

  .md\\:bg-opacity-50 {
    --bg-opacity: 0.5;
  }

  .md\\:bg-opacity-75 {
    --bg-opacity: 0.75;
  }

  .md\\:bg-opacity-100 {
    --bg-opacity: 1;
  }

  .md\\:hover\\:bg-opacity-0:hover {
    --bg-opacity: 0;
  }

  .md\\:hover\\:bg-opacity-25:hover {
    --bg-opacity: 0.25;
  }

  .md\\:hover\\:bg-opacity-50:hover {
    --bg-opacity: 0.5;
  }

  .md\\:hover\\:bg-opacity-75:hover {
    --bg-opacity: 0.75;
  }

  .md\\:hover\\:bg-opacity-100:hover {
    --bg-opacity: 1;
  }

  .md\\:focus\\:bg-opacity-0:focus {
    --bg-opacity: 0;
  }

  .md\\:focus\\:bg-opacity-25:focus {
    --bg-opacity: 0.25;
  }

  .md\\:focus\\:bg-opacity-50:focus {
    --bg-opacity: 0.5;
  }

  .md\\:focus\\:bg-opacity-75:focus {
    --bg-opacity: 0.75;
  }

  .md\\:focus\\:bg-opacity-100:focus {
    --bg-opacity: 1;
  }

  .md\\:bg-bottom {
    background-position: bottom;
  }

  .md\\:bg-center {
    background-position: center;
  }

  .md\\:bg-left {
    background-position: left;
  }

  .md\\:bg-left-bottom {
    background-position: left bottom;
  }

  .md\\:bg-left-top {
    background-position: left top;
  }

  .md\\:bg-right {
    background-position: right;
  }

  .md\\:bg-right-bottom {
    background-position: right bottom;
  }

  .md\\:bg-right-top {
    background-position: right top;
  }

  .md\\:bg-top {
    background-position: top;
  }

  .md\\:bg-repeat {
    background-repeat: repeat;
  }

  .md\\:bg-no-repeat {
    background-repeat: no-repeat;
  }

  .md\\:bg-repeat-x {
    background-repeat: repeat-x;
  }

  .md\\:bg-repeat-y {
    background-repeat: repeat-y;
  }

  .md\\:bg-repeat-round {
    background-repeat: round;
  }

  .md\\:bg-repeat-space {
    background-repeat: space;
  }

  .md\\:bg-auto {
    background-size: auto;
  }

  .md\\:bg-cover {
    background-size: cover;
  }

  .md\\:bg-contain {
    background-size: contain;
  }

  .md\\:border-collapse {
    border-collapse: collapse;
  }

  .md\\:border-separate {
    border-collapse: separate;
  }

  .md\\:border-transparent {
    border-color: transparent;
  }

  .md\\:border-current {
    border-color: currentColor;
  }

  .md\\:border-black {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .md\\:border-white {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .md\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .md\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .md\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .md\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .md\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .md\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .md\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .md\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .md\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .md\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .md\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .md\\:border-red-300 {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .md\\:border-red-400 {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .md\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .md\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .md\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .md\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .md\\:border-red-900 {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .md\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .md\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .md\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .md\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .md\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .md\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .md\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .md\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .md\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .md\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .md\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .md\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .md\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .md\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .md\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .md\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .md\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .md\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .md\\:border-green-100 {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .md\\:border-green-200 {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .md\\:border-green-300 {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .md\\:border-green-400 {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .md\\:border-green-500 {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .md\\:border-green-600 {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .md\\:border-green-700 {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .md\\:border-green-800 {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .md\\:border-green-900 {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .md\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .md\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .md\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .md\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .md\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .md\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .md\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .md\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .md\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .md\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .md\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .md\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .md\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .md\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .md\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .md\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .md\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .md\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .md\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .md\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .md\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .md\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .md\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .md\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .md\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .md\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .md\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .md\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .md\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .md\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .md\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .md\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .md\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .md\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .md\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .md\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .md\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .md\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .md\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .md\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .md\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .md\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .md\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .md\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .md\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .md\\:hover\\:border-transparent:hover {
    border-color: transparent;
  }

  .md\\:hover\\:border-current:hover {
    border-color: currentColor;
  }

  .md\\:hover\\:border-black:hover {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .md\\:hover\\:border-white:hover {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-100:hover {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-200:hover {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-300:hover {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-400:hover {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-500:hover {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-600:hover {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-700:hover {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-800:hover {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-900:hover {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .md\\:hover\\:border-red-100:hover {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .md\\:hover\\:border-red-200:hover {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .md\\:hover\\:border-red-300:hover {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .md\\:hover\\:border-red-400:hover {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .md\\:hover\\:border-red-500:hover {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .md\\:hover\\:border-red-600:hover {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .md\\:hover\\:border-red-700:hover {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .md\\:hover\\:border-red-800:hover {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .md\\:hover\\:border-red-900:hover {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-100:hover {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-200:hover {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-300:hover {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-400:hover {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-500:hover {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-600:hover {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-700:hover {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-800:hover {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-900:hover {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-100:hover {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-200:hover {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-300:hover {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-400:hover {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-500:hover {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-600:hover {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-700:hover {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-800:hover {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-900:hover {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .md\\:hover\\:border-green-100:hover {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .md\\:hover\\:border-green-200:hover {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .md\\:hover\\:border-green-300:hover {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .md\\:hover\\:border-green-400:hover {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .md\\:hover\\:border-green-500:hover {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .md\\:hover\\:border-green-600:hover {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .md\\:hover\\:border-green-700:hover {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .md\\:hover\\:border-green-800:hover {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .md\\:hover\\:border-green-900:hover {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-100:hover {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-200:hover {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-300:hover {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-400:hover {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-500:hover {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-600:hover {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-700:hover {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-800:hover {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .md\\:hover\\:border-teal-900:hover {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-100:hover {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-200:hover {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-300:hover {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-400:hover {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-500:hover {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-600:hover {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-700:hover {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-800:hover {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-900:hover {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-100:hover {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-200:hover {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-300:hover {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-400:hover {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-500:hover {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-600:hover {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-700:hover {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-800:hover {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .md\\:hover\\:border-indigo-900:hover {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-100:hover {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-200:hover {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-300:hover {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-400:hover {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-500:hover {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-600:hover {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-700:hover {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-800:hover {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .md\\:hover\\:border-purple-900:hover {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-100:hover {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-200:hover {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-300:hover {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-400:hover {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-500:hover {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-600:hover {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-700:hover {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-800:hover {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .md\\:hover\\:border-pink-900:hover {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .md\\:focus\\:border-transparent:focus {
    border-color: transparent;
  }

  .md\\:focus\\:border-current:focus {
    border-color: currentColor;
  }

  .md\\:focus\\:border-black:focus {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .md\\:focus\\:border-white:focus {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-100:focus {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-200:focus {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-300:focus {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-400:focus {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-500:focus {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-600:focus {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-700:focus {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-800:focus {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-900:focus {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .md\\:focus\\:border-red-100:focus {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .md\\:focus\\:border-red-200:focus {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .md\\:focus\\:border-red-300:focus {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .md\\:focus\\:border-red-400:focus {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .md\\:focus\\:border-red-500:focus {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .md\\:focus\\:border-red-600:focus {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .md\\:focus\\:border-red-700:focus {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .md\\:focus\\:border-red-800:focus {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .md\\:focus\\:border-red-900:focus {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-100:focus {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-200:focus {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-300:focus {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-400:focus {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-500:focus {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-600:focus {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-700:focus {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-800:focus {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-900:focus {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-100:focus {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-200:focus {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-300:focus {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-400:focus {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-500:focus {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-600:focus {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-700:focus {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-800:focus {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-900:focus {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .md\\:focus\\:border-green-100:focus {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .md\\:focus\\:border-green-200:focus {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .md\\:focus\\:border-green-300:focus {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .md\\:focus\\:border-green-400:focus {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .md\\:focus\\:border-green-500:focus {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .md\\:focus\\:border-green-600:focus {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .md\\:focus\\:border-green-700:focus {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .md\\:focus\\:border-green-800:focus {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .md\\:focus\\:border-green-900:focus {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-100:focus {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-200:focus {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-300:focus {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-400:focus {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-500:focus {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-600:focus {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-700:focus {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-800:focus {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .md\\:focus\\:border-teal-900:focus {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-100:focus {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-200:focus {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-300:focus {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-400:focus {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-500:focus {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-600:focus {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-700:focus {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-800:focus {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-900:focus {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-100:focus {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-200:focus {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-300:focus {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-400:focus {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-500:focus {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-600:focus {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-700:focus {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-800:focus {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .md\\:focus\\:border-indigo-900:focus {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-100:focus {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-200:focus {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-300:focus {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-400:focus {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-500:focus {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-600:focus {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-700:focus {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-800:focus {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .md\\:focus\\:border-purple-900:focus {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-100:focus {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-200:focus {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-300:focus {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-400:focus {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-500:focus {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-600:focus {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-700:focus {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-800:focus {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .md\\:focus\\:border-pink-900:focus {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .md\\:border-opacity-0 {
    --border-opacity: 0;
  }

  .md\\:border-opacity-25 {
    --border-opacity: 0.25;
  }

  .md\\:border-opacity-50 {
    --border-opacity: 0.5;
  }

  .md\\:border-opacity-75 {
    --border-opacity: 0.75;
  }

  .md\\:border-opacity-100 {
    --border-opacity: 1;
  }

  .md\\:hover\\:border-opacity-0:hover {
    --border-opacity: 0;
  }

  .md\\:hover\\:border-opacity-25:hover {
    --border-opacity: 0.25;
  }

  .md\\:hover\\:border-opacity-50:hover {
    --border-opacity: 0.5;
  }

  .md\\:hover\\:border-opacity-75:hover {
    --border-opacity: 0.75;
  }

  .md\\:hover\\:border-opacity-100:hover {
    --border-opacity: 1;
  }

  .md\\:focus\\:border-opacity-0:focus {
    --border-opacity: 0;
  }

  .md\\:focus\\:border-opacity-25:focus {
    --border-opacity: 0.25;
  }

  .md\\:focus\\:border-opacity-50:focus {
    --border-opacity: 0.5;
  }

  .md\\:focus\\:border-opacity-75:focus {
    --border-opacity: 0.75;
  }

  .md\\:focus\\:border-opacity-100:focus {
    --border-opacity: 1;
  }

  .md\\:rounded-none {
    border-radius: 0;
  }

  .md\\:rounded-sm {
    border-radius: 0.125rem;
  }

  .md\\:rounded {
    border-radius: 0.25rem;
  }

  .md\\:rounded-md {
    border-radius: 0.375rem;
  }

  .md\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .md\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .md\\:rounded-2xl {
    border-radius: 1rem;
  }

  .md\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .md\\:rounded-full {
    border-radius: 9999px;
  }

  .md\\:rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .md\\:rounded-r-none {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .md\\:rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .md\\:rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .md\\:rounded-t-sm {
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
  }

  .md\\:rounded-r-sm {
    border-top-right-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
  }

  .md\\:rounded-b-sm {
    border-bottom-right-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }

  .md\\:rounded-l-sm {
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }

  .md\\:rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .md\\:rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }

  .md\\:rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .md\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .md\\:rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }

  .md\\:rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }

  .md\\:rounded-b-md {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }

  .md\\:rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }

  .md\\:rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  .md\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .md\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .md\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .md\\:rounded-t-xl {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }

  .md\\:rounded-r-xl {
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }

  .md\\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .md\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .md\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  .md\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }

  .md\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .md\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .md\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .md\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .md\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .md\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .md\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .md\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .md\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .md\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .md\\:rounded-tl-none {
    border-top-left-radius: 0;
  }

  .md\\:rounded-tr-none {
    border-top-right-radius: 0;
  }

  .md\\:rounded-br-none {
    border-bottom-right-radius: 0;
  }

  .md\\:rounded-bl-none {
    border-bottom-left-radius: 0;
  }

  .md\\:rounded-tl-sm {
    border-top-left-radius: 0.125rem;
  }

  .md\\:rounded-tr-sm {
    border-top-right-radius: 0.125rem;
  }

  .md\\:rounded-br-sm {
    border-bottom-right-radius: 0.125rem;
  }

  .md\\:rounded-bl-sm {
    border-bottom-left-radius: 0.125rem;
  }

  .md\\:rounded-tl {
    border-top-left-radius: 0.25rem;
  }

  .md\\:rounded-tr {
    border-top-right-radius: 0.25rem;
  }

  .md\\:rounded-br {
    border-bottom-right-radius: 0.25rem;
  }

  .md\\:rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }

  .md\\:rounded-tl-md {
    border-top-left-radius: 0.375rem;
  }

  .md\\:rounded-tr-md {
    border-top-right-radius: 0.375rem;
  }

  .md\\:rounded-br-md {
    border-bottom-right-radius: 0.375rem;
  }

  .md\\:rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
  }

  .md\\:rounded-tl-lg {
    border-top-left-radius: 0.5rem;
  }

  .md\\:rounded-tr-lg {
    border-top-right-radius: 0.5rem;
  }

  .md\\:rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
  }

  .md\\:rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
  }

  .md\\:rounded-tl-xl {
    border-top-left-radius: 0.75rem;
  }

  .md\\:rounded-tr-xl {
    border-top-right-radius: 0.75rem;
  }

  .md\\:rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
  }

  .md\\:rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
  }

  .md\\:rounded-tl-2xl {
    border-top-left-radius: 1rem;
  }

  .md\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }

  .md\\:rounded-br-2xl {
    border-bottom-right-radius: 1rem;
  }

  .md\\:rounded-bl-2xl {
    border-bottom-left-radius: 1rem;
  }

  .md\\:rounded-tl-3xl {
    border-top-left-radius: 1.5rem;
  }

  .md\\:rounded-tr-3xl {
    border-top-right-radius: 1.5rem;
  }

  .md\\:rounded-br-3xl {
    border-bottom-right-radius: 1.5rem;
  }

  .md\\:rounded-bl-3xl {
    border-bottom-left-radius: 1.5rem;
  }

  .md\\:rounded-tl-full {
    border-top-left-radius: 9999px;
  }

  .md\\:rounded-tr-full {
    border-top-right-radius: 9999px;
  }

  .md\\:rounded-br-full {
    border-bottom-right-radius: 9999px;
  }

  .md\\:rounded-bl-full {
    border-bottom-left-radius: 9999px;
  }

  .md\\:border-solid {
    border-style: solid;
  }

  .md\\:border-dashed {
    border-style: dashed;
  }

  .md\\:border-dotted {
    border-style: dotted;
  }

  .md\\:border-double {
    border-style: double;
  }

  .md\\:border-none {
    border-style: none;
  }

  .md\\:border-0 {
    border-width: 0;
  }

  .md\\:border-2 {
    border-width: 2px;
  }

  .md\\:border-4 {
    border-width: 4px;
  }

  .md\\:border-8 {
    border-width: 8px;
  }

  .md\\:border {
    border-width: 1px;
  }

  .md\\:border-t-0 {
    border-top-width: 0;
  }

  .md\\:border-r-0 {
    border-right-width: 0;
  }

  .md\\:border-b-0 {
    border-bottom-width: 0;
  }

  .md\\:border-l-0 {
    border-left-width: 0;
  }

  .md\\:border-t-2 {
    border-top-width: 2px;
  }

  .md\\:border-r-2 {
    border-right-width: 2px;
  }

  .md\\:border-b-2 {
    border-bottom-width: 2px;
  }

  .md\\:border-l-2 {
    border-left-width: 2px;
  }

  .md\\:border-t-4 {
    border-top-width: 4px;
  }

  .md\\:border-r-4 {
    border-right-width: 4px;
  }

  .md\\:border-b-4 {
    border-bottom-width: 4px;
  }

  .md\\:border-l-4 {
    border-left-width: 4px;
  }

  .md\\:border-t-8 {
    border-top-width: 8px;
  }

  .md\\:border-r-8 {
    border-right-width: 8px;
  }

  .md\\:border-b-8 {
    border-bottom-width: 8px;
  }

  .md\\:border-l-8 {
    border-left-width: 8px;
  }

  .md\\:border-t {
    border-top-width: 1px;
  }

  .md\\:border-r {
    border-right-width: 1px;
  }

  .md\\:border-b {
    border-bottom-width: 1px;
  }

  .md\\:border-l {
    border-left-width: 1px;
  }

  .md\\:box-border {
    box-sizing: border-box;
  }

  .md\\:box-content {
    box-sizing: content-box;
  }

  .md\\:cursor-auto {
    cursor: auto;
  }

  .md\\:cursor-default {
    cursor: default;
  }

  .md\\:cursor-pointer {
    cursor: pointer;
  }

  .md\\:cursor-wait {
    cursor: wait;
  }

  .md\\:cursor-text {
    cursor: text;
  }

  .md\\:cursor-move {
    cursor: move;
  }

  .md\\:cursor-not-allowed {
    cursor: not-allowed;
  }

  .md\\:block {
    display: block;
  }

  .md\\:inline-block {
    display: inline-block;
  }

  .md\\:inline {
    display: inline;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:inline-flex {
    display: inline-flex;
  }

  .md\\:table {
    display: table;
  }

  .md\\:table-caption {
    display: table-caption;
  }

  .md\\:table-cell {
    display: table-cell;
  }

  .md\\:table-column {
    display: table-column;
  }

  .md\\:table-column-group {
    display: table-column-group;
  }

  .md\\:table-footer-group {
    display: table-footer-group;
  }

  .md\\:table-header-group {
    display: table-header-group;
  }

  .md\\:table-row-group {
    display: table-row-group;
  }

  .md\\:table-row {
    display: table-row;
  }

  .md\\:flow-root {
    display: flow-root;
  }

  .md\\:grid {
    display: grid;
  }

  .md\\:inline-grid {
    display: inline-grid;
  }

  .md\\:contents {
    display: contents;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .md\\:flex-wrap {
    flex-wrap: wrap;
  }

  .md\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .md\\:flex-no-wrap {
    flex-wrap: nowrap;
  }

  .md\\:place-items-auto {
    place-items: auto;
  }

  .md\\:place-items-start {
    place-items: start;
  }

  .md\\:place-items-end {
    place-items: end;
  }

  .md\\:place-items-center {
    place-items: center;
  }

  .md\\:place-items-stretch {
    place-items: stretch;
  }

  .md\\:place-content-center {
    place-content: center;
  }

  .md\\:place-content-start {
    place-content: start;
  }

  .md\\:place-content-end {
    place-content: end;
  }

  .md\\:place-content-between {
    place-content: space-between;
  }

  .md\\:place-content-around {
    place-content: space-around;
  }

  .md\\:place-content-evenly {
    place-content: space-evenly;
  }

  .md\\:place-content-stretch {
    place-content: stretch;
  }

  .md\\:place-self-auto {
    place-self: auto;
  }

  .md\\:place-self-start {
    place-self: start;
  }

  .md\\:place-self-end {
    place-self: end;
  }

  .md\\:place-self-center {
    place-self: center;
  }

  .md\\:place-self-stretch {
    place-self: stretch;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:items-end {
    align-items: flex-end;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:items-baseline {
    align-items: baseline;
  }

  .md\\:items-stretch {
    align-items: stretch;
  }

  .md\\:content-center {
    align-content: center;
  }

  .md\\:content-start {
    align-content: flex-start;
  }

  .md\\:content-end {
    align-content: flex-end;
  }

  .md\\:content-between {
    align-content: space-between;
  }

  .md\\:content-around {
    align-content: space-around;
  }

  .md\\:content-evenly {
    align-content: space-evenly;
  }

  .md\\:self-auto {
    align-self: auto;
  }

  .md\\:self-start {
    align-self: flex-start;
  }

  .md\\:self-end {
    align-self: flex-end;
  }

  .md\\:self-center {
    align-self: center;
  }

  .md\\:self-stretch {
    align-self: stretch;
  }

  .md\\:justify-items-auto {
    justify-items: auto;
  }

  .md\\:justify-items-start {
    justify-items: start;
  }

  .md\\:justify-items-end {
    justify-items: end;
  }

  .md\\:justify-items-center {
    justify-items: center;
  }

  .md\\:justify-items-stretch {
    justify-items: stretch;
  }

  .md\\:justify-start {
    justify-content: flex-start;
  }

  .md\\:justify-end {
    justify-content: flex-end;
  }

  .md\\:justify-center {
    justify-content: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }

  .md\\:justify-around {
    justify-content: space-around;
  }

  .md\\:justify-evenly {
    justify-content: space-evenly;
  }

  .md\\:justify-self-auto {
    justify-self: auto;
  }

  .md\\:justify-self-start {
    justify-self: start;
  }

  .md\\:justify-self-end {
    justify-self: end;
  }

  .md\\:justify-self-center {
    justify-self: center;
  }

  .md\\:justify-self-stretch {
    justify-self: stretch;
  }

  .md\\:flex-1 {
    flex: 1 1;
  }

  .md\\:flex-auto {
    flex: 1 1 auto;
  }

  .md\\:flex-initial {
    flex: 0 1 auto;
  }

  .md\\:flex-none {
    flex: none;
  }

  .md\\:flex-grow-0 {
    flex-grow: 0;
  }

  .md\\:flex-grow {
    flex-grow: 1;
  }

  .md\\:flex-shrink-0 {
    flex-shrink: 0;
  }

  .md\\:flex-shrink {
    flex-shrink: 1;
  }

  .md\\:order-1 {
    order: 1;
  }

  .md\\:order-2 {
    order: 2;
  }

  .md\\:order-3 {
    order: 3;
  }

  .md\\:order-4 {
    order: 4;
  }

  .md\\:order-5 {
    order: 5;
  }

  .md\\:order-6 {
    order: 6;
  }

  .md\\:order-7 {
    order: 7;
  }

  .md\\:order-8 {
    order: 8;
  }

  .md\\:order-9 {
    order: 9;
  }

  .md\\:order-10 {
    order: 10;
  }

  .md\\:order-11 {
    order: 11;
  }

  .md\\:order-12 {
    order: 12;
  }

  .md\\:order-first {
    order: -9999;
  }

  .md\\:order-last {
    order: 9999;
  }

  .md\\:order-none {
    order: 0;
  }

  .md\\:float-right {
    float: right;
  }

  .md\\:float-left {
    float: left;
  }

  .md\\:float-none {
    float: none;
  }

  .md\\:clearfix:after {
    content: "";
    display: table;
    clear: both;
  }

  .md\\:clear-left {
    clear: left;
  }

  .md\\:clear-right {
    clear: right;
  }

  .md\\:clear-both {
    clear: both;
  }

  .md\\:clear-none {
    clear: none;
  }

  .md\\:font-sans {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .md\\:font-serif {
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .md\\:font-mono {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .md\\:font-hairline {
    font-weight: 100;
  }

  .md\\:font-thin {
    font-weight: 200;
  }

  .md\\:font-light {
    font-weight: 300;
  }

  .md\\:font-normal {
    font-weight: 400;
  }

  .md\\:font-medium {
    font-weight: 500;
  }

  .md\\:font-semibold {
    font-weight: 600;
  }

  .md\\:font-bold {
    font-weight: 700;
  }

  .md\\:font-extrabold {
    font-weight: 800;
  }

  .md\\:font-black {
    font-weight: 900;
  }

  .md\\:hover\\:font-hairline:hover {
    font-weight: 100;
  }

  .md\\:hover\\:font-thin:hover {
    font-weight: 200;
  }

  .md\\:hover\\:font-light:hover {
    font-weight: 300;
  }

  .md\\:hover\\:font-normal:hover {
    font-weight: 400;
  }

  .md\\:hover\\:font-medium:hover {
    font-weight: 500;
  }

  .md\\:hover\\:font-semibold:hover {
    font-weight: 600;
  }

  .md\\:hover\\:font-bold:hover {
    font-weight: 700;
  }

  .md\\:hover\\:font-extrabold:hover {
    font-weight: 800;
  }

  .md\\:hover\\:font-black:hover {
    font-weight: 900;
  }

  .md\\:focus\\:font-hairline:focus {
    font-weight: 100;
  }

  .md\\:focus\\:font-thin:focus {
    font-weight: 200;
  }

  .md\\:focus\\:font-light:focus {
    font-weight: 300;
  }

  .md\\:focus\\:font-normal:focus {
    font-weight: 400;
  }

  .md\\:focus\\:font-medium:focus {
    font-weight: 500;
  }

  .md\\:focus\\:font-semibold:focus {
    font-weight: 600;
  }

  .md\\:focus\\:font-bold:focus {
    font-weight: 700;
  }

  .md\\:focus\\:font-extrabold:focus {
    font-weight: 800;
  }

  .md\\:focus\\:font-black:focus {
    font-weight: 900;
  }

  .md\\:h-0 {
    height: 0;
  }

  .md\\:h-1 {
    height: 0.25rem;
  }

  .md\\:h-2 {
    height: 0.5rem;
  }

  .md\\:h-3 {
    height: 0.75rem;
  }

  .md\\:h-4 {
    height: 1rem;
  }

  .md\\:h-5 {
    height: 1.25rem;
  }

  .md\\:h-6 {
    height: 1.5rem;
  }

  .md\\:h-8 {
    height: 2rem;
  }

  .md\\:h-10 {
    height: 2.5rem;
  }

  .md\\:h-12 {
    height: 3rem;
  }

  .md\\:h-16 {
    height: 4rem;
  }

  .md\\:h-20 {
    height: 5rem;
  }

  .md\\:h-24 {
    height: 6rem;
  }

  .md\\:h-32 {
    height: 8rem;
  }

  .md\\:h-40 {
    height: 10rem;
  }

  .md\\:h-48 {
    height: 12rem;
  }

  .md\\:h-56 {
    height: 14rem;
  }

  .md\\:h-64 {
    height: 16rem;
  }

  .md\\:h-auto {
    height: auto;
  }

  .md\\:h-px {
    height: 1px;
  }

  .md\\:h-full {
    height: 100%;
  }

  .md\\:h-screen {
    height: 100vh;
  }

  .md\\:text-15 {
    font-size: 0.9375rem;
  }

  .md\\:text-xs {
    font-size: 0.75rem;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
  }

  .md\\:text-base {
    font-size: 1rem;
  }

  .md\\:text-lg {
    font-size: 1.125rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
  }

  .md\\:text-1\\.5xl {
    font-size: 1.375rem;
  }

  .md\\:text-2xl {
    font-size: 1.5rem;
  }

  .md\\:text-3xl {
    font-size: 1.875rem;
  }

  .md\\:text-4xl {
    font-size: 2.25rem;
  }

  .md\\:text-5xl {
    font-size: 3rem;
  }

  .md\\:text-6xl {
    font-size: 4rem;
  }

  .md\\:leading-3 {
    line-height: 0.75rem;
  }

  .md\\:leading-4 {
    line-height: 1rem;
  }

  .md\\:leading-5 {
    line-height: 1.25rem;
  }

  .md\\:leading-6 {
    line-height: 1.5rem;
  }

  .md\\:leading-7 {
    line-height: 1.75rem;
  }

  .md\\:leading-8 {
    line-height: 2rem;
  }

  .md\\:leading-9 {
    line-height: 2.25rem;
  }

  .md\\:leading-10 {
    line-height: 2.5rem;
  }

  .md\\:leading-none {
    line-height: 1;
  }

  .md\\:leading-tight {
    line-height: 1.25;
  }

  .md\\:leading-snug {
    line-height: 1.375;
  }

  .md\\:leading-normal {
    line-height: 1.5;
  }

  .md\\:leading-relaxed {
    line-height: 1.625;
  }

  .md\\:leading-loose {
    line-height: 2;
  }

  .md\\:list-inside {
    list-style-position: inside;
  }

  .md\\:list-outside {
    list-style-position: outside;
  }

  .md\\:list-none {
    list-style-type: none;
  }

  .md\\:list-disc {
    list-style-type: disc;
  }

  .md\\:list-decimal {
    list-style-type: decimal;
  }

  .md\\:m-0 {
    margin: 0;
  }

  .md\\:m-1 {
    margin: 0.25rem;
  }

  .md\\:m-2 {
    margin: 0.5rem;
  }

  .md\\:m-3 {
    margin: 0.75rem;
  }

  .md\\:m-4 {
    margin: 1rem;
  }

  .md\\:m-5 {
    margin: 1.25rem;
  }

  .md\\:m-6 {
    margin: 1.5rem;
  }

  .md\\:m-8 {
    margin: 2rem;
  }

  .md\\:m-10 {
    margin: 2.5rem;
  }

  .md\\:m-12 {
    margin: 3rem;
  }

  .md\\:m-16 {
    margin: 4rem;
  }

  .md\\:m-20 {
    margin: 5rem;
  }

  .md\\:m-24 {
    margin: 6rem;
  }

  .md\\:m-32 {
    margin: 8rem;
  }

  .md\\:m-40 {
    margin: 10rem;
  }

  .md\\:m-48 {
    margin: 12rem;
  }

  .md\\:m-56 {
    margin: 14rem;
  }

  .md\\:m-64 {
    margin: 16rem;
  }

  .md\\:m-auto {
    margin: auto;
  }

  .md\\:m-px {
    margin: 1px;
  }

  .md\\:-m-1 {
    margin: -0.25rem;
  }

  .md\\:-m-2 {
    margin: -0.5rem;
  }

  .md\\:-m-3 {
    margin: -0.75rem;
  }

  .md\\:-m-4 {
    margin: -1rem;
  }

  .md\\:-m-5 {
    margin: -1.25rem;
  }

  .md\\:-m-6 {
    margin: -1.5rem;
  }

  .md\\:-m-8 {
    margin: -2rem;
  }

  .md\\:-m-10 {
    margin: -2.5rem;
  }

  .md\\:-m-12 {
    margin: -3rem;
  }

  .md\\:-m-16 {
    margin: -4rem;
  }

  .md\\:-m-20 {
    margin: -5rem;
  }

  .md\\:-m-24 {
    margin: -6rem;
  }

  .md\\:-m-32 {
    margin: -8rem;
  }

  .md\\:-m-40 {
    margin: -10rem;
  }

  .md\\:-m-48 {
    margin: -12rem;
  }

  .md\\:-m-56 {
    margin: -14rem;
  }

  .md\\:-m-64 {
    margin: -16rem;
  }

  .md\\:-m-px {
    margin: -1px;
  }

  .md\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:mx-0 {
    margin-left: 0;
    margin-right: 0;
  }

  .md\\:my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .md\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .md\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .md\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .md\\:my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .md\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .md\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .md\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .md\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .md\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .md\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .md\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .md\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .md\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .md\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .md\\:mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .md\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .md\\:mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .md\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .md\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .md\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .md\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .md\\:my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .md\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .md\\:my-32 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .md\\:mx-32 {
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .md\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .md\\:mx-40 {
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .md\\:my-48 {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .md\\:mx-48 {
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .md\\:my-56 {
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .md\\:mx-56 {
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .md\\:my-64 {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .md\\:mx-64 {
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .md\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }

  .md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .md\\:my-px {
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .md\\:mx-px {
    margin-left: 1px;
    margin-right: 1px;
  }

  .md\\:-my-1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .md\\:-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .md\\:-my-2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .md\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .md\\:-my-3 {
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .md\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .md\\:-my-4 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .md\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .md\\:-my-5 {
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .md\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .md\\:-my-6 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .md\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .md\\:-my-8 {
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .md\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .md\\:-my-10 {
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .md\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .md\\:-my-12 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .md\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .md\\:-my-16 {
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .md\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .md\\:-my-20 {
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .md\\:-mx-20 {
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .md\\:-my-24 {
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .md\\:-mx-24 {
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .md\\:-my-32 {
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .md\\:-mx-32 {
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .md\\:-my-40 {
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .md\\:-mx-40 {
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .md\\:-my-48 {
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .md\\:-mx-48 {
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .md\\:-my-56 {
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .md\\:-mx-56 {
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .md\\:-my-64 {
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .md\\:-mx-64 {
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .md\\:-my-px {
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .md\\:-mx-px {
    margin-left: -1px;
    margin-right: -1px;
  }

  .md\\:mt-0 {
    margin-top: 0;
  }

  .md\\:mr-0 {
    margin-right: 0;
  }

  .md\\:mb-0 {
    margin-bottom: 0;
  }

  .md\\:ml-0 {
    margin-left: 0;
  }

  .md\\:mt-1 {
    margin-top: 0.25rem;
  }

  .md\\:mr-1 {
    margin-right: 0.25rem;
  }

  .md\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .md\\:ml-1 {
    margin-left: 0.25rem;
  }

  .md\\:mt-2 {
    margin-top: 0.5rem;
  }

  .md\\:mr-2 {
    margin-right: 0.5rem;
  }

  .md\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .md\\:ml-2 {
    margin-left: 0.5rem;
  }

  .md\\:mt-3 {
    margin-top: 0.75rem;
  }

  .md\\:mr-3 {
    margin-right: 0.75rem;
  }

  .md\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .md\\:ml-3 {
    margin-left: 0.75rem;
  }

  .md\\:mt-4 {
    margin-top: 1rem;
  }

  .md\\:mr-4 {
    margin-right: 1rem;
  }

  .md\\:mb-4 {
    margin-bottom: 1rem;
  }

  .md\\:ml-4 {
    margin-left: 1rem;
  }

  .md\\:mt-5 {
    margin-top: 1.25rem;
  }

  .md\\:mr-5 {
    margin-right: 1.25rem;
  }

  .md\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .md\\:ml-5 {
    margin-left: 1.25rem;
  }

  .md\\:mt-6 {
    margin-top: 1.5rem;
  }

  .md\\:mr-6 {
    margin-right: 1.5rem;
  }

  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .md\\:ml-6 {
    margin-left: 1.5rem;
  }

  .md\\:mt-8 {
    margin-top: 2rem;
  }

  .md\\:mr-8 {
    margin-right: 2rem;
  }

  .md\\:mb-8 {
    margin-bottom: 2rem;
  }

  .md\\:ml-8 {
    margin-left: 2rem;
  }

  .md\\:mt-10 {
    margin-top: 2.5rem;
  }

  .md\\:mr-10 {
    margin-right: 2.5rem;
  }

  .md\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .md\\:ml-10 {
    margin-left: 2.5rem;
  }

  .md\\:mt-12 {
    margin-top: 3rem;
  }

  .md\\:mr-12 {
    margin-right: 3rem;
  }

  .md\\:mb-12 {
    margin-bottom: 3rem;
  }

  .md\\:ml-12 {
    margin-left: 3rem;
  }

  .md\\:mt-16 {
    margin-top: 4rem;
  }

  .md\\:mr-16 {
    margin-right: 4rem;
  }

  .md\\:mb-16 {
    margin-bottom: 4rem;
  }

  .md\\:ml-16 {
    margin-left: 4rem;
  }

  .md\\:mt-20 {
    margin-top: 5rem;
  }

  .md\\:mr-20 {
    margin-right: 5rem;
  }

  .md\\:mb-20 {
    margin-bottom: 5rem;
  }

  .md\\:ml-20 {
    margin-left: 5rem;
  }

  .md\\:mt-24 {
    margin-top: 6rem;
  }

  .md\\:mr-24 {
    margin-right: 6rem;
  }

  .md\\:mb-24 {
    margin-bottom: 6rem;
  }

  .md\\:ml-24 {
    margin-left: 6rem;
  }

  .md\\:mt-32 {
    margin-top: 8rem;
  }

  .md\\:mr-32 {
    margin-right: 8rem;
  }

  .md\\:mb-32 {
    margin-bottom: 8rem;
  }

  .md\\:ml-32 {
    margin-left: 8rem;
  }

  .md\\:mt-40 {
    margin-top: 10rem;
  }

  .md\\:mr-40 {
    margin-right: 10rem;
  }

  .md\\:mb-40 {
    margin-bottom: 10rem;
  }

  .md\\:ml-40 {
    margin-left: 10rem;
  }

  .md\\:mt-48 {
    margin-top: 12rem;
  }

  .md\\:mr-48 {
    margin-right: 12rem;
  }

  .md\\:mb-48 {
    margin-bottom: 12rem;
  }

  .md\\:ml-48 {
    margin-left: 12rem;
  }

  .md\\:mt-56 {
    margin-top: 14rem;
  }

  .md\\:mr-56 {
    margin-right: 14rem;
  }

  .md\\:mb-56 {
    margin-bottom: 14rem;
  }

  .md\\:ml-56 {
    margin-left: 14rem;
  }

  .md\\:mt-64 {
    margin-top: 16rem;
  }

  .md\\:mr-64 {
    margin-right: 16rem;
  }

  .md\\:mb-64 {
    margin-bottom: 16rem;
  }

  .md\\:ml-64 {
    margin-left: 16rem;
  }

  .md\\:mt-auto {
    margin-top: auto;
  }

  .md\\:mr-auto {
    margin-right: auto;
  }

  .md\\:mb-auto {
    margin-bottom: auto;
  }

  .md\\:ml-auto {
    margin-left: auto;
  }

  .md\\:mt-px {
    margin-top: 1px;
  }

  .md\\:mr-px {
    margin-right: 1px;
  }

  .md\\:mb-px {
    margin-bottom: 1px;
  }

  .md\\:ml-px {
    margin-left: 1px;
  }

  .md\\:-mt-1 {
    margin-top: -0.25rem;
  }

  .md\\:-mr-1 {
    margin-right: -0.25rem;
  }

  .md\\:-mb-1 {
    margin-bottom: -0.25rem;
  }

  .md\\:-ml-1 {
    margin-left: -0.25rem;
  }

  .md\\:-mt-2 {
    margin-top: -0.5rem;
  }

  .md\\:-mr-2 {
    margin-right: -0.5rem;
  }

  .md\\:-mb-2 {
    margin-bottom: -0.5rem;
  }

  .md\\:-ml-2 {
    margin-left: -0.5rem;
  }

  .md\\:-mt-3 {
    margin-top: -0.75rem;
  }

  .md\\:-mr-3 {
    margin-right: -0.75rem;
  }

  .md\\:-mb-3 {
    margin-bottom: -0.75rem;
  }

  .md\\:-ml-3 {
    margin-left: -0.75rem;
  }

  .md\\:-mt-4 {
    margin-top: -1rem;
  }

  .md\\:-mr-4 {
    margin-right: -1rem;
  }

  .md\\:-mb-4 {
    margin-bottom: -1rem;
  }

  .md\\:-ml-4 {
    margin-left: -1rem;
  }

  .md\\:-mt-5 {
    margin-top: -1.25rem;
  }

  .md\\:-mr-5 {
    margin-right: -1.25rem;
  }

  .md\\:-mb-5 {
    margin-bottom: -1.25rem;
  }

  .md\\:-ml-5 {
    margin-left: -1.25rem;
  }

  .md\\:-mt-6 {
    margin-top: -1.5rem;
  }

  .md\\:-mr-6 {
    margin-right: -1.5rem;
  }

  .md\\:-mb-6 {
    margin-bottom: -1.5rem;
  }

  .md\\:-ml-6 {
    margin-left: -1.5rem;
  }

  .md\\:-mt-8 {
    margin-top: -2rem;
  }

  .md\\:-mr-8 {
    margin-right: -2rem;
  }

  .md\\:-mb-8 {
    margin-bottom: -2rem;
  }

  .md\\:-ml-8 {
    margin-left: -2rem;
  }

  .md\\:-mt-10 {
    margin-top: -2.5rem;
  }

  .md\\:-mr-10 {
    margin-right: -2.5rem;
  }

  .md\\:-mb-10 {
    margin-bottom: -2.5rem;
  }

  .md\\:-ml-10 {
    margin-left: -2.5rem;
  }

  .md\\:-mt-12 {
    margin-top: -3rem;
  }

  .md\\:-mr-12 {
    margin-right: -3rem;
  }

  .md\\:-mb-12 {
    margin-bottom: -3rem;
  }

  .md\\:-ml-12 {
    margin-left: -3rem;
  }

  .md\\:-mt-16 {
    margin-top: -4rem;
  }

  .md\\:-mr-16 {
    margin-right: -4rem;
  }

  .md\\:-mb-16 {
    margin-bottom: -4rem;
  }

  .md\\:-ml-16 {
    margin-left: -4rem;
  }

  .md\\:-mt-20 {
    margin-top: -5rem;
  }

  .md\\:-mr-20 {
    margin-right: -5rem;
  }

  .md\\:-mb-20 {
    margin-bottom: -5rem;
  }

  .md\\:-ml-20 {
    margin-left: -5rem;
  }

  .md\\:-mt-24 {
    margin-top: -6rem;
  }

  .md\\:-mr-24 {
    margin-right: -6rem;
  }

  .md\\:-mb-24 {
    margin-bottom: -6rem;
  }

  .md\\:-ml-24 {
    margin-left: -6rem;
  }

  .md\\:-mt-32 {
    margin-top: -8rem;
  }

  .md\\:-mr-32 {
    margin-right: -8rem;
  }

  .md\\:-mb-32 {
    margin-bottom: -8rem;
  }

  .md\\:-ml-32 {
    margin-left: -8rem;
  }

  .md\\:-mt-40 {
    margin-top: -10rem;
  }

  .md\\:-mr-40 {
    margin-right: -10rem;
  }

  .md\\:-mb-40 {
    margin-bottom: -10rem;
  }

  .md\\:-ml-40 {
    margin-left: -10rem;
  }

  .md\\:-mt-48 {
    margin-top: -12rem;
  }

  .md\\:-mr-48 {
    margin-right: -12rem;
  }

  .md\\:-mb-48 {
    margin-bottom: -12rem;
  }

  .md\\:-ml-48 {
    margin-left: -12rem;
  }

  .md\\:-mt-56 {
    margin-top: -14rem;
  }

  .md\\:-mr-56 {
    margin-right: -14rem;
  }

  .md\\:-mb-56 {
    margin-bottom: -14rem;
  }

  .md\\:-ml-56 {
    margin-left: -14rem;
  }

  .md\\:-mt-64 {
    margin-top: -16rem;
  }

  .md\\:-mr-64 {
    margin-right: -16rem;
  }

  .md\\:-mb-64 {
    margin-bottom: -16rem;
  }

  .md\\:-ml-64 {
    margin-left: -16rem;
  }

  .md\\:-mt-px {
    margin-top: -1px;
  }

  .md\\:-mr-px {
    margin-right: -1px;
  }

  .md\\:-mb-px {
    margin-bottom: -1px;
  }

  .md\\:-ml-px {
    margin-left: -1px;
  }

  .md\\:max-h-full {
    max-height: 100%;
  }

  .md\\:max-h-screen {
    max-height: 100vh;
  }

  .md\\:max-w-none {
    max-width: none;
  }

  .md\\:max-w-xs {
    max-width: 20rem;
  }

  .md\\:max-w-sm {
    max-width: 24rem;
  }

  .md\\:max-w-md {
    max-width: 28rem;
  }

  .md\\:max-w-lg {
    max-width: 32rem;
  }

  .md\\:max-w-xl {
    max-width: 36rem;
  }

  .md\\:max-w-2xl {
    max-width: 42rem;
  }

  .md\\:max-w-3xl {
    max-width: 48rem;
  }

  .md\\:max-w-4xl {
    max-width: 56rem;
  }

  .md\\:max-w-5xl {
    max-width: 64rem;
  }

  .md\\:max-w-6xl {
    max-width: 72rem;
  }

  .md\\:max-w-full {
    max-width: 100%;
  }

  .md\\:max-w-screen-sm {
    max-width: 640px;
  }

  .md\\:max-w-screen-md {
    max-width: 768px;
  }

  .md\\:max-w-screen-lg {
    max-width: 1024px;
  }

  .md\\:max-w-screen-xl {
    max-width: 1280px;
  }

  .md\\:min-h-0 {
    min-height: 0;
  }

  .md\\:min-h-full {
    min-height: 100%;
  }

  .md\\:min-h-screen {
    min-height: 100vh;
  }

  .md\\:min-w-0 {
    min-width: 0;
  }

  .md\\:min-w-full {
    min-width: 100%;
  }

  .md\\:object-contain {
    object-fit: contain;
  }

  .md\\:object-cover {
    object-fit: cover;
  }

  .md\\:object-fill {
    object-fit: fill;
  }

  .md\\:object-none {
    object-fit: none;
  }

  .md\\:object-scale-down {
    object-fit: scale-down;
  }

  .md\\:object-bottom {
    object-position: bottom;
  }

  .md\\:object-center {
    object-position: center;
  }

  .md\\:object-left {
    object-position: left;
  }

  .md\\:object-left-bottom {
    object-position: left bottom;
  }

  .md\\:object-left-top {
    object-position: left top;
  }

  .md\\:object-right {
    object-position: right;
  }

  .md\\:object-right-bottom {
    object-position: right bottom;
  }

  .md\\:object-right-top {
    object-position: right top;
  }

  .md\\:object-top {
    object-position: top;
  }

  .md\\:opacity-0 {
    opacity: 0;
  }

  .md\\:opacity-25 {
    opacity: 0.25;
  }

  .md\\:opacity-50 {
    opacity: 0.5;
  }

  .md\\:opacity-75 {
    opacity: 0.75;
  }

  .md\\:opacity-100 {
    opacity: 1;
  }

  .md\\:hover\\:opacity-0:hover {
    opacity: 0;
  }

  .md\\:hover\\:opacity-25:hover {
    opacity: 0.25;
  }

  .md\\:hover\\:opacity-50:hover {
    opacity: 0.5;
  }

  .md\\:hover\\:opacity-75:hover {
    opacity: 0.75;
  }

  .md\\:hover\\:opacity-100:hover {
    opacity: 1;
  }

  .md\\:focus\\:opacity-0:focus {
    opacity: 0;
  }

  .md\\:focus\\:opacity-25:focus {
    opacity: 0.25;
  }

  .md\\:focus\\:opacity-50:focus {
    opacity: 0.5;
  }

  .md\\:focus\\:opacity-75:focus {
    opacity: 0.75;
  }

  .md\\:focus\\:opacity-100:focus {
    opacity: 1;
  }

  .md\\:outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .md\\:outline-white {
    outline: 2px dotted white;
    outline-offset: 2px;
  }

  .md\\:outline-black {
    outline: 2px dotted black;
    outline-offset: 2px;
  }

  .md\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .md\\:focus\\:outline-white:focus {
    outline: 2px dotted white;
    outline-offset: 2px;
  }

  .md\\:focus\\:outline-black:focus {
    outline: 2px dotted black;
    outline-offset: 2px;
  }

  .md\\:overflow-auto {
    overflow: auto;
  }

  .md\\:overflow-hidden {
    overflow: hidden;
  }

  .md\\:overflow-visible {
    overflow: visible;
  }

  .md\\:overflow-scroll {
    overflow: scroll;
  }

  .md\\:overflow-x-auto {
    overflow-x: auto;
  }

  .md\\:overflow-y-auto {
    overflow-y: auto;
  }

  .md\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .md\\:overflow-y-hidden {
    overflow-y: hidden;
  }

  .md\\:overflow-x-visible {
    overflow-x: visible;
  }

  .md\\:overflow-y-visible {
    overflow-y: visible;
  }

  .md\\:overflow-x-scroll {
    overflow-x: scroll;
  }

  .md\\:overflow-y-scroll {
    overflow-y: scroll;
  }

  .md\\:scrolling-touch {
    -webkit-overflow-scrolling: touch;
  }

  .md\\:scrolling-auto {
    -webkit-overflow-scrolling: auto;
  }

  .md\\:overscroll-auto {
    overscroll-behavior: auto;
  }

  .md\\:overscroll-contain {
    overscroll-behavior: contain;
  }

  .md\\:overscroll-none {
    overscroll-behavior: none;
  }

  .md\\:overscroll-y-auto {
    overscroll-behavior-y: auto;
  }

  .md\\:overscroll-y-contain {
    overscroll-behavior-y: contain;
  }

  .md\\:overscroll-y-none {
    overscroll-behavior-y: none;
  }

  .md\\:overscroll-x-auto {
    overscroll-behavior-x: auto;
  }

  .md\\:overscroll-x-contain {
    overscroll-behavior-x: contain;
  }

  .md\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }

  .md\\:p-0 {
    padding: 0;
  }

  .md\\:p-1 {
    padding: 0.25rem;
  }

  .md\\:p-2 {
    padding: 0.5rem;
  }

  .md\\:p-3 {
    padding: 0.75rem;
  }

  .md\\:p-4 {
    padding: 1rem;
  }

  .md\\:p-5 {
    padding: 1.25rem;
  }

  .md\\:p-6 {
    padding: 1.5rem;
  }

  .md\\:p-8 {
    padding: 2rem;
  }

  .md\\:p-10 {
    padding: 2.5rem;
  }

  .md\\:p-12 {
    padding: 3rem;
  }

  .md\\:p-16 {
    padding: 4rem;
  }

  .md\\:p-20 {
    padding: 5rem;
  }

  .md\\:p-24 {
    padding: 6rem;
  }

  .md\\:p-32 {
    padding: 8rem;
  }

  .md\\:p-40 {
    padding: 10rem;
  }

  .md\\:p-48 {
    padding: 12rem;
  }

  .md\\:p-56 {
    padding: 14rem;
  }

  .md\\:p-64 {
    padding: 16rem;
  }

  .md\\:p-px {
    padding: 1px;
  }

  .md\\:py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .md\\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }

  .md\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .md\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .md\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .md\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .md\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .md\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .md\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .md\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .md\\:py-48 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .md\\:px-48 {
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .md\\:py-56 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .md\\:px-56 {
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .md\\:py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .md\\:px-64 {
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .md\\:py-px {
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .md\\:px-px {
    padding-left: 1px;
    padding-right: 1px;
  }

  .md\\:pt-0 {
    padding-top: 0;
  }

  .md\\:pr-0 {
    padding-right: 0;
  }

  .md\\:pb-0 {
    padding-bottom: 0;
  }

  .md\\:pl-0 {
    padding-left: 0;
  }

  .md\\:pt-1 {
    padding-top: 0.25rem;
  }

  .md\\:pr-1 {
    padding-right: 0.25rem;
  }

  .md\\:pb-1 {
    padding-bottom: 0.25rem;
  }

  .md\\:pl-1 {
    padding-left: 0.25rem;
  }

  .md\\:pt-2 {
    padding-top: 0.5rem;
  }

  .md\\:pr-2 {
    padding-right: 0.5rem;
  }

  .md\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .md\\:pl-2 {
    padding-left: 0.5rem;
  }

  .md\\:pt-3 {
    padding-top: 0.75rem;
  }

  .md\\:pr-3 {
    padding-right: 0.75rem;
  }

  .md\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .md\\:pl-3 {
    padding-left: 0.75rem;
  }

  .md\\:pt-4 {
    padding-top: 1rem;
  }

  .md\\:pr-4 {
    padding-right: 1rem;
  }

  .md\\:pb-4 {
    padding-bottom: 1rem;
  }

  .md\\:pl-4 {
    padding-left: 1rem;
  }

  .md\\:pt-5 {
    padding-top: 1.25rem;
  }

  .md\\:pr-5 {
    padding-right: 1.25rem;
  }

  .md\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .md\\:pl-5 {
    padding-left: 1.25rem;
  }

  .md\\:pt-6 {
    padding-top: 1.5rem;
  }

  .md\\:pr-6 {
    padding-right: 1.5rem;
  }

  .md\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .md\\:pl-6 {
    padding-left: 1.5rem;
  }

  .md\\:pt-8 {
    padding-top: 2rem;
  }

  .md\\:pr-8 {
    padding-right: 2rem;
  }

  .md\\:pb-8 {
    padding-bottom: 2rem;
  }

  .md\\:pl-8 {
    padding-left: 2rem;
  }

  .md\\:pt-10 {
    padding-top: 2.5rem;
  }

  .md\\:pr-10 {
    padding-right: 2.5rem;
  }

  .md\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .md\\:pl-10 {
    padding-left: 2.5rem;
  }

  .md\\:pt-12 {
    padding-top: 3rem;
  }

  .md\\:pr-12 {
    padding-right: 3rem;
  }

  .md\\:pb-12 {
    padding-bottom: 3rem;
  }

  .md\\:pl-12 {
    padding-left: 3rem;
  }

  .md\\:pt-16 {
    padding-top: 4rem;
  }

  .md\\:pr-16 {
    padding-right: 4rem;
  }

  .md\\:pb-16 {
    padding-bottom: 4rem;
  }

  .md\\:pl-16 {
    padding-left: 4rem;
  }

  .md\\:pt-20 {
    padding-top: 5rem;
  }

  .md\\:pr-20 {
    padding-right: 5rem;
  }

  .md\\:pb-20 {
    padding-bottom: 5rem;
  }

  .md\\:pl-20 {
    padding-left: 5rem;
  }

  .md\\:pt-24 {
    padding-top: 6rem;
  }

  .md\\:pr-24 {
    padding-right: 6rem;
  }

  .md\\:pb-24 {
    padding-bottom: 6rem;
  }

  .md\\:pl-24 {
    padding-left: 6rem;
  }

  .md\\:pt-32 {
    padding-top: 8rem;
  }

  .md\\:pr-32 {
    padding-right: 8rem;
  }

  .md\\:pb-32 {
    padding-bottom: 8rem;
  }

  .md\\:pl-32 {
    padding-left: 8rem;
  }

  .md\\:pt-40 {
    padding-top: 10rem;
  }

  .md\\:pr-40 {
    padding-right: 10rem;
  }

  .md\\:pb-40 {
    padding-bottom: 10rem;
  }

  .md\\:pl-40 {
    padding-left: 10rem;
  }

  .md\\:pt-48 {
    padding-top: 12rem;
  }

  .md\\:pr-48 {
    padding-right: 12rem;
  }

  .md\\:pb-48 {
    padding-bottom: 12rem;
  }

  .md\\:pl-48 {
    padding-left: 12rem;
  }

  .md\\:pt-56 {
    padding-top: 14rem;
  }

  .md\\:pr-56 {
    padding-right: 14rem;
  }

  .md\\:pb-56 {
    padding-bottom: 14rem;
  }

  .md\\:pl-56 {
    padding-left: 14rem;
  }

  .md\\:pt-64 {
    padding-top: 16rem;
  }

  .md\\:pr-64 {
    padding-right: 16rem;
  }

  .md\\:pb-64 {
    padding-bottom: 16rem;
  }

  .md\\:pl-64 {
    padding-left: 16rem;
  }

  .md\\:pt-px {
    padding-top: 1px;
  }

  .md\\:pr-px {
    padding-right: 1px;
  }

  .md\\:pb-px {
    padding-bottom: 1px;
  }

  .md\\:pl-px {
    padding-left: 1px;
  }

  .md\\:placeholder-transparent::placeholder {
    color: transparent;
  }

  .md\\:placeholder-current::placeholder {
    color: currentColor;
  }

  .md\\:placeholder-black::placeholder {
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .md\\:placeholder-white::placeholder {
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f7fafc;
    color: rgba(247, 250, 252, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #edf2f7;
    color: rgba(237, 242, 247, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #a0aec0;
    color: rgba(160, 174, 192, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #718096;
    color: rgba(113, 128, 150, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #4a5568;
    color: rgba(74, 85, 104, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #2d3748;
    color: rgba(45, 55, 72, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #1a202c;
    color: rgba(26, 32, 44, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-100::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f5;
    color: rgba(255, 245, 245, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-200::placeholder {
    --placeholder-opacity: 1;
    color: #fed7d7;
    color: rgba(254, 215, 215, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-300::placeholder {
    --placeholder-opacity: 1;
    color: #feb2b2;
    color: rgba(254, 178, 178, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-400::placeholder {
    --placeholder-opacity: 1;
    color: #fc8181;
    color: rgba(252, 129, 129, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-500::placeholder {
    --placeholder-opacity: 1;
    color: #f56565;
    color: rgba(245, 101, 101, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-600::placeholder {
    --placeholder-opacity: 1;
    color: #e53e3e;
    color: rgba(229, 62, 62, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-700::placeholder {
    --placeholder-opacity: 1;
    color: #c53030;
    color: rgba(197, 48, 48, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-800::placeholder {
    --placeholder-opacity: 1;
    color: #9b2c2c;
    color: rgba(155, 44, 44, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-900::placeholder {
    --placeholder-opacity: 1;
    color: #742a2a;
    color: rgba(116, 42, 42, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-100::placeholder {
    --placeholder-opacity: 1;
    color: #fffaf0;
    color: rgba(255, 250, 240, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-200::placeholder {
    --placeholder-opacity: 1;
    color: #feebc8;
    color: rgba(254, 235, 200, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-300::placeholder {
    --placeholder-opacity: 1;
    color: #fbd38d;
    color: rgba(251, 211, 141, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-400::placeholder {
    --placeholder-opacity: 1;
    color: #f6ad55;
    color: rgba(246, 173, 85, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-500::placeholder {
    --placeholder-opacity: 1;
    color: #ed8936;
    color: rgba(237, 137, 54, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-600::placeholder {
    --placeholder-opacity: 1;
    color: #dd6b20;
    color: rgba(221, 107, 32, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-700::placeholder {
    --placeholder-opacity: 1;
    color: #c05621;
    color: rgba(192, 86, 33, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-800::placeholder {
    --placeholder-opacity: 1;
    color: #9c4221;
    color: rgba(156, 66, 33, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-900::placeholder {
    --placeholder-opacity: 1;
    color: #7b341e;
    color: rgba(123, 52, 30, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-100::placeholder {
    --placeholder-opacity: 1;
    color: #fffff0;
    color: rgba(255, 255, 240, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-200::placeholder {
    --placeholder-opacity: 1;
    color: #fefcbf;
    color: rgba(254, 252, 191, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-300::placeholder {
    --placeholder-opacity: 1;
    color: #faf089;
    color: rgba(250, 240, 137, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-400::placeholder {
    --placeholder-opacity: 1;
    color: #f6e05e;
    color: rgba(246, 224, 94, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-500::placeholder {
    --placeholder-opacity: 1;
    color: #ecc94b;
    color: rgba(236, 201, 75, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-600::placeholder {
    --placeholder-opacity: 1;
    color: #d69e2e;
    color: rgba(214, 158, 46, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-700::placeholder {
    --placeholder-opacity: 1;
    color: #b7791f;
    color: rgba(183, 121, 31, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-800::placeholder {
    --placeholder-opacity: 1;
    color: #975a16;
    color: rgba(151, 90, 22, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-900::placeholder {
    --placeholder-opacity: 1;
    color: #744210;
    color: rgba(116, 66, 16, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-100::placeholder {
    --placeholder-opacity: 1;
    color: #f0fff4;
    color: rgba(240, 255, 244, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-200::placeholder {
    --placeholder-opacity: 1;
    color: #c6f6d5;
    color: rgba(198, 246, 213, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-300::placeholder {
    --placeholder-opacity: 1;
    color: #9ae6b4;
    color: rgba(154, 230, 180, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-400::placeholder {
    --placeholder-opacity: 1;
    color: #68d391;
    color: rgba(104, 211, 145, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-500::placeholder {
    --placeholder-opacity: 1;
    color: #48bb78;
    color: rgba(72, 187, 120, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-600::placeholder {
    --placeholder-opacity: 1;
    color: #38a169;
    color: rgba(56, 161, 105, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-700::placeholder {
    --placeholder-opacity: 1;
    color: #2f855a;
    color: rgba(47, 133, 90, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-800::placeholder {
    --placeholder-opacity: 1;
    color: #276749;
    color: rgba(39, 103, 73, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-900::placeholder {
    --placeholder-opacity: 1;
    color: #22543d;
    color: rgba(34, 84, 61, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-100::placeholder {
    --placeholder-opacity: 1;
    color: #e6fffa;
    color: rgba(230, 255, 250, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-200::placeholder {
    --placeholder-opacity: 1;
    color: #b2f5ea;
    color: rgba(178, 245, 234, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-300::placeholder {
    --placeholder-opacity: 1;
    color: #81e6d9;
    color: rgba(129, 230, 217, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-400::placeholder {
    --placeholder-opacity: 1;
    color: #4fd1c5;
    color: rgba(79, 209, 197, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-500::placeholder {
    --placeholder-opacity: 1;
    color: #38b2ac;
    color: rgba(56, 178, 172, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-600::placeholder {
    --placeholder-opacity: 1;
    color: #319795;
    color: rgba(49, 151, 149, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-700::placeholder {
    --placeholder-opacity: 1;
    color: #2c7a7b;
    color: rgba(44, 122, 123, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-800::placeholder {
    --placeholder-opacity: 1;
    color: #285e61;
    color: rgba(40, 94, 97, var(--placeholder-opacity));
  }

  .md\\:placeholder-teal-900::placeholder {
    --placeholder-opacity: 1;
    color: #234e52;
    color: rgba(35, 78, 82, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-100::placeholder {
    --placeholder-opacity: 1;
    color: #ebf8ff;
    color: rgba(235, 248, 255, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-200::placeholder {
    --placeholder-opacity: 1;
    color: #bee3f8;
    color: rgba(190, 227, 248, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-300::placeholder {
    --placeholder-opacity: 1;
    color: #90cdf4;
    color: rgba(144, 205, 244, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-400::placeholder {
    --placeholder-opacity: 1;
    color: #63b3ed;
    color: rgba(99, 179, 237, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-500::placeholder {
    --placeholder-opacity: 1;
    color: #4299e1;
    color: rgba(66, 153, 225, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-600::placeholder {
    --placeholder-opacity: 1;
    color: #3182ce;
    color: rgba(49, 130, 206, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-700::placeholder {
    --placeholder-opacity: 1;
    color: #2b6cb0;
    color: rgba(43, 108, 176, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-800::placeholder {
    --placeholder-opacity: 1;
    color: #2c5282;
    color: rgba(44, 82, 130, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-900::placeholder {
    --placeholder-opacity: 1;
    color: #2a4365;
    color: rgba(42, 67, 101, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-100::placeholder {
    --placeholder-opacity: 1;
    color: #ebf4ff;
    color: rgba(235, 244, 255, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-200::placeholder {
    --placeholder-opacity: 1;
    color: #c3dafe;
    color: rgba(195, 218, 254, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-300::placeholder {
    --placeholder-opacity: 1;
    color: #a3bffa;
    color: rgba(163, 191, 250, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-400::placeholder {
    --placeholder-opacity: 1;
    color: #7f9cf5;
    color: rgba(127, 156, 245, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-500::placeholder {
    --placeholder-opacity: 1;
    color: #667eea;
    color: rgba(102, 126, 234, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-600::placeholder {
    --placeholder-opacity: 1;
    color: #5a67d8;
    color: rgba(90, 103, 216, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-700::placeholder {
    --placeholder-opacity: 1;
    color: #4c51bf;
    color: rgba(76, 81, 191, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-800::placeholder {
    --placeholder-opacity: 1;
    color: #434190;
    color: rgba(67, 65, 144, var(--placeholder-opacity));
  }

  .md\\:placeholder-indigo-900::placeholder {
    --placeholder-opacity: 1;
    color: #3c366b;
    color: rgba(60, 54, 107, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-100::placeholder {
    --placeholder-opacity: 1;
    color: #faf5ff;
    color: rgba(250, 245, 255, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-200::placeholder {
    --placeholder-opacity: 1;
    color: #e9d8fd;
    color: rgba(233, 216, 253, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-300::placeholder {
    --placeholder-opacity: 1;
    color: #d6bcfa;
    color: rgba(214, 188, 250, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-400::placeholder {
    --placeholder-opacity: 1;
    color: #b794f4;
    color: rgba(183, 148, 244, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-500::placeholder {
    --placeholder-opacity: 1;
    color: #9f7aea;
    color: rgba(159, 122, 234, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-600::placeholder {
    --placeholder-opacity: 1;
    color: #805ad5;
    color: rgba(128, 90, 213, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-700::placeholder {
    --placeholder-opacity: 1;
    color: #6b46c1;
    color: rgba(107, 70, 193, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-800::placeholder {
    --placeholder-opacity: 1;
    color: #553c9a;
    color: rgba(85, 60, 154, var(--placeholder-opacity));
  }

  .md\\:placeholder-purple-900::placeholder {
    --placeholder-opacity: 1;
    color: #44337a;
    color: rgba(68, 51, 122, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-100::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f7;
    color: rgba(255, 245, 247, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-200::placeholder {
    --placeholder-opacity: 1;
    color: #fed7e2;
    color: rgba(254, 215, 226, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-300::placeholder {
    --placeholder-opacity: 1;
    color: #fbb6ce;
    color: rgba(251, 182, 206, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-400::placeholder {
    --placeholder-opacity: 1;
    color: #f687b3;
    color: rgba(246, 135, 179, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-500::placeholder {
    --placeholder-opacity: 1;
    color: #ed64a6;
    color: rgba(237, 100, 166, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-600::placeholder {
    --placeholder-opacity: 1;
    color: #d53f8c;
    color: rgba(213, 63, 140, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-700::placeholder {
    --placeholder-opacity: 1;
    color: #b83280;
    color: rgba(184, 50, 128, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-800::placeholder {
    --placeholder-opacity: 1;
    color: #97266d;
    color: rgba(151, 38, 109, var(--placeholder-opacity));
  }

  .md\\:placeholder-pink-900::placeholder {
    --placeholder-opacity: 1;
    color: #702459;
    color: rgba(112, 36, 89, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-transparent:focus::placeholder {
    color: transparent;
  }

  .md\\:focus\\:placeholder-current:focus::placeholder {
    color: currentColor;
  }

  .md\\:focus\\:placeholder-black:focus::placeholder {
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-white:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f7fafc;
    color: rgba(247, 250, 252, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edf2f7;
    color: rgba(237, 242, 247, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a0aec0;
    color: rgba(160, 174, 192, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #718096;
    color: rgba(113, 128, 150, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4a5568;
    color: rgba(74, 85, 104, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2d3748;
    color: rgba(45, 55, 72, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a202c;
    color: rgba(26, 32, 44, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f5;
    color: rgba(255, 245, 245, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fed7d7;
    color: rgba(254, 215, 215, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feb2b2;
    color: rgba(254, 178, 178, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fc8181;
    color: rgba(252, 129, 129, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f56565;
    color: rgba(245, 101, 101, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e53e3e;
    color: rgba(229, 62, 62, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c53030;
    color: rgba(197, 48, 48, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9b2c2c;
    color: rgba(155, 44, 44, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #742a2a;
    color: rgba(116, 42, 42, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fffaf0;
    color: rgba(255, 250, 240, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feebc8;
    color: rgba(254, 235, 200, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbd38d;
    color: rgba(251, 211, 141, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6ad55;
    color: rgba(246, 173, 85, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ed8936;
    color: rgba(237, 137, 54, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #dd6b20;
    color: rgba(221, 107, 32, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c05621;
    color: rgba(192, 86, 33, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9c4221;
    color: rgba(156, 66, 33, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7b341e;
    color: rgba(123, 52, 30, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fffff0;
    color: rgba(255, 255, 240, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fefcbf;
    color: rgba(254, 252, 191, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faf089;
    color: rgba(250, 240, 137, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6e05e;
    color: rgba(246, 224, 94, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ecc94b;
    color: rgba(236, 201, 75, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d69e2e;
    color: rgba(214, 158, 46, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b7791f;
    color: rgba(183, 121, 31, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #975a16;
    color: rgba(151, 90, 22, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #744210;
    color: rgba(116, 66, 16, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f0fff4;
    color: rgba(240, 255, 244, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c6f6d5;
    color: rgba(198, 246, 213, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9ae6b4;
    color: rgba(154, 230, 180, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #68d391;
    color: rgba(104, 211, 145, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #48bb78;
    color: rgba(72, 187, 120, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #38a169;
    color: rgba(56, 161, 105, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2f855a;
    color: rgba(47, 133, 90, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #276749;
    color: rgba(39, 103, 73, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #22543d;
    color: rgba(34, 84, 61, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e6fffa;
    color: rgba(230, 255, 250, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b2f5ea;
    color: rgba(178, 245, 234, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #81e6d9;
    color: rgba(129, 230, 217, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4fd1c5;
    color: rgba(79, 209, 197, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #38b2ac;
    color: rgba(56, 178, 172, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #319795;
    color: rgba(49, 151, 149, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2c7a7b;
    color: rgba(44, 122, 123, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #285e61;
    color: rgba(40, 94, 97, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-teal-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #234e52;
    color: rgba(35, 78, 82, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf8ff;
    color: rgba(235, 248, 255, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bee3f8;
    color: rgba(190, 227, 248, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #90cdf4;
    color: rgba(144, 205, 244, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #63b3ed;
    color: rgba(99, 179, 237, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4299e1;
    color: rgba(66, 153, 225, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3182ce;
    color: rgba(49, 130, 206, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2b6cb0;
    color: rgba(43, 108, 176, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2c5282;
    color: rgba(44, 82, 130, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2a4365;
    color: rgba(42, 67, 101, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf4ff;
    color: rgba(235, 244, 255, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c3dafe;
    color: rgba(195, 218, 254, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a3bffa;
    color: rgba(163, 191, 250, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7f9cf5;
    color: rgba(127, 156, 245, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #667eea;
    color: rgba(102, 126, 234, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5a67d8;
    color: rgba(90, 103, 216, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4c51bf;
    color: rgba(76, 81, 191, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #434190;
    color: rgba(67, 65, 144, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-indigo-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3c366b;
    color: rgba(60, 54, 107, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faf5ff;
    color: rgba(250, 245, 255, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e9d8fd;
    color: rgba(233, 216, 253, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d6bcfa;
    color: rgba(214, 188, 250, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b794f4;
    color: rgba(183, 148, 244, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9f7aea;
    color: rgba(159, 122, 234, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #805ad5;
    color: rgba(128, 90, 213, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6b46c1;
    color: rgba(107, 70, 193, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #553c9a;
    color: rgba(85, 60, 154, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-purple-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #44337a;
    color: rgba(68, 51, 122, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f7;
    color: rgba(255, 245, 247, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fed7e2;
    color: rgba(254, 215, 226, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbb6ce;
    color: rgba(251, 182, 206, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f687b3;
    color: rgba(246, 135, 179, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ed64a6;
    color: rgba(237, 100, 166, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d53f8c;
    color: rgba(213, 63, 140, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b83280;
    color: rgba(184, 50, 128, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #97266d;
    color: rgba(151, 38, 109, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-pink-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #702459;
    color: rgba(112, 36, 89, var(--placeholder-opacity));
  }

  .md\\:placeholder-opacity-0::placeholder {
    --placeholder-opacity: 0;
  }

  .md\\:placeholder-opacity-25::placeholder {
    --placeholder-opacity: 0.25;
  }

  .md\\:placeholder-opacity-50::placeholder {
    --placeholder-opacity: 0.5;
  }

  .md\\:placeholder-opacity-75::placeholder {
    --placeholder-opacity: 0.75;
  }

  .md\\:placeholder-opacity-100::placeholder {
    --placeholder-opacity: 1;
  }

  .md\\:focus\\:placeholder-opacity-0:focus::placeholder {
    --placeholder-opacity: 0;
  }

  .md\\:focus\\:placeholder-opacity-25:focus::placeholder {
    --placeholder-opacity: 0.25;
  }

  .md\\:focus\\:placeholder-opacity-50:focus::placeholder {
    --placeholder-opacity: 0.5;
  }

  .md\\:focus\\:placeholder-opacity-75:focus::placeholder {
    --placeholder-opacity: 0.75;
  }

  .md\\:focus\\:placeholder-opacity-100:focus::placeholder {
    --placeholder-opacity: 1;
  }

  .md\\:pointer-events-none {
    pointer-events: none;
  }

  .md\\:pointer-events-auto {
    pointer-events: auto;
  }

  .md\\:static {
    position: static;
  }

  .md\\:fixed {
    position: fixed;
  }

  .md\\:absolute {
    position: absolute;
  }

  .md\\:relative {
    position: relative;
  }

  .md\\:sticky {
    position: sticky;
  }

  .md\\:inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .md\\:inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .md\\:inset-y-0 {
    top: 0;
    bottom: 0;
  }

  .md\\:inset-x-0 {
    right: 0;
    left: 0;
  }

  .md\\:inset-y-auto {
    top: auto;
    bottom: auto;
  }

  .md\\:inset-x-auto {
    right: auto;
    left: auto;
  }

  .md\\:top-0 {
    top: 0;
  }

  .md\\:right-0 {
    right: 0;
  }

  .md\\:bottom-0 {
    bottom: 0;
  }

  .md\\:left-0 {
    left: 0;
  }

  .md\\:top-auto {
    top: auto;
  }

  .md\\:right-auto {
    right: auto;
  }

  .md\\:bottom-auto {
    bottom: auto;
  }

  .md\\:left-auto {
    left: auto;
  }

  .md\\:resize-none {
    resize: none;
  }

  .md\\:resize-y {
    resize: vertical;
  }

  .md\\:resize-x {
    resize: horizontal;
  }

  .md\\:resize {
    resize: both;
  }

  .md\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .md\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .md\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .md\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .md\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .md\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .md\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .md\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .md\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .md\\:shadow-none {
    box-shadow: none;
  }

  .md\\:hover\\:shadow-xs:hover {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .md\\:hover\\:shadow-sm:hover {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .md\\:hover\\:shadow:hover {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .md\\:hover\\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .md\\:hover\\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .md\\:hover\\:shadow-xl:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .md\\:hover\\:shadow-2xl:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .md\\:hover\\:shadow-inner:hover {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .md\\:hover\\:shadow-outline:hover {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .md\\:hover\\:shadow-none:hover {
    box-shadow: none;
  }

  .md\\:focus\\:shadow-xs:focus {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .md\\:focus\\:shadow-sm:focus {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .md\\:focus\\:shadow:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .md\\:focus\\:shadow-md:focus {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .md\\:focus\\:shadow-lg:focus {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .md\\:focus\\:shadow-xl:focus {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .md\\:focus\\:shadow-2xl:focus {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .md\\:focus\\:shadow-inner:focus {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .md\\:focus\\:shadow-outline:focus {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .md\\:focus\\:shadow-none:focus {
    box-shadow: none;
  }

  .md\\:fill-current {
    fill: currentColor;
  }

  .md\\:stroke-current {
    stroke: currentColor;
  }

  .md\\:stroke-0 {
    stroke-width: 0;
  }

  .md\\:stroke-1 {
    stroke-width: 1;
  }

  .md\\:stroke-2 {
    stroke-width: 2;
  }

  .md\\:table-auto {
    table-layout: auto;
  }

  .md\\:table-fixed {
    table-layout: fixed;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-center {
    text-align: center;
  }

  .md\\:text-right {
    text-align: right;
  }

  .md\\:text-justify {
    text-align: justify;
  }

  .md\\:text-blue {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .md\\:text-primaryText {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .md\\:text-red {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .md\\:hover\\:text-blue:hover {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .md\\:hover\\:text-primaryText:hover {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .md\\:hover\\:text-red:hover {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .md\\:focus\\:text-blue:focus {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .md\\:focus\\:text-primaryText:focus {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .md\\:focus\\:text-red:focus {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .md\\:text-opacity-0 {
    --text-opacity: 0;
  }

  .md\\:text-opacity-25 {
    --text-opacity: 0.25;
  }

  .md\\:text-opacity-50 {
    --text-opacity: 0.5;
  }

  .md\\:text-opacity-75 {
    --text-opacity: 0.75;
  }

  .md\\:text-opacity-100 {
    --text-opacity: 1;
  }

  .md\\:hover\\:text-opacity-0:hover {
    --text-opacity: 0;
  }

  .md\\:hover\\:text-opacity-25:hover {
    --text-opacity: 0.25;
  }

  .md\\:hover\\:text-opacity-50:hover {
    --text-opacity: 0.5;
  }

  .md\\:hover\\:text-opacity-75:hover {
    --text-opacity: 0.75;
  }

  .md\\:hover\\:text-opacity-100:hover {
    --text-opacity: 1;
  }

  .md\\:focus\\:text-opacity-0:focus {
    --text-opacity: 0;
  }

  .md\\:focus\\:text-opacity-25:focus {
    --text-opacity: 0.25;
  }

  .md\\:focus\\:text-opacity-50:focus {
    --text-opacity: 0.5;
  }

  .md\\:focus\\:text-opacity-75:focus {
    --text-opacity: 0.75;
  }

  .md\\:focus\\:text-opacity-100:focus {
    --text-opacity: 1;
  }

  .md\\:italic {
    font-style: italic;
  }

  .md\\:not-italic {
    font-style: normal;
  }

  .md\\:uppercase {
    text-transform: uppercase;
  }

  .md\\:lowercase {
    text-transform: lowercase;
  }

  .md\\:capitalize {
    text-transform: capitalize;
  }

  .md\\:normal-case {
    text-transform: none;
  }

  .md\\:underline {
    text-decoration: underline;
  }

  .md\\:line-through {
    text-decoration: line-through;
  }

  .md\\:no-underline {
    text-decoration: none;
  }

  .md\\:hover\\:underline:hover {
    text-decoration: underline;
  }

  .md\\:hover\\:line-through:hover {
    text-decoration: line-through;
  }

  .md\\:hover\\:no-underline:hover {
    text-decoration: none;
  }

  .md\\:focus\\:underline:focus {
    text-decoration: underline;
  }

  .md\\:focus\\:line-through:focus {
    text-decoration: line-through;
  }

  .md\\:focus\\:no-underline:focus {
    text-decoration: none;
  }

  .md\\:antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .md\\:subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .md\\:ordinal, .md\\:slashed-zero, .md\\:lining-nums, .md\\:oldstyle-nums, .md\\:proportional-nums, .md\\:tabular-nums, .md\\:diagonal-fractions, .md\\:stacked-fractions {
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .md\\:normal-nums {
    font-variant-numeric: normal;
  }

  .md\\:ordinal {
    --font-variant-numeric-ordinal: ordinal;
  }

  .md\\:slashed-zero {
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .md\\:lining-nums {
    --font-variant-numeric-figure: lining-nums;
  }

  .md\\:oldstyle-nums {
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .md\\:proportional-nums {
    --font-variant-numeric-spacing: proportional-nums;
  }

  .md\\:tabular-nums {
    --font-variant-numeric-spacing: tabular-nums;
  }

  .md\\:diagonal-fractions {
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .md\\:stacked-fractions {
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .md\\:tracking-tighter {
    letter-spacing: -0.05em;
  }

  .md\\:tracking-tight {
    letter-spacing: -0.025em;
  }

  .md\\:tracking-normal {
    letter-spacing: 0;
  }

  .md\\:tracking-wide {
    letter-spacing: 0.025em;
  }

  .md\\:tracking-wider {
    letter-spacing: 0.05em;
  }

  .md\\:tracking-widest {
    letter-spacing: 0.1em;
  }

  .md\\:select-none {
    -webkit-user-select: none;
    user-select: none;
  }

  .md\\:select-text {
    -webkit-user-select: text;
    user-select: text;
  }

  .md\\:select-all {
    -webkit-user-select: all;
    user-select: all;
  }

  .md\\:select-auto {
    -webkit-user-select: auto;
    user-select: auto;
  }

  .md\\:align-baseline {
    vertical-align: baseline;
  }

  .md\\:align-top {
    vertical-align: top;
  }

  .md\\:align-middle {
    vertical-align: middle;
  }

  .md\\:align-bottom {
    vertical-align: bottom;
  }

  .md\\:align-text-top {
    vertical-align: text-top;
  }

  .md\\:align-text-bottom {
    vertical-align: text-bottom;
  }

  .md\\:visible {
    visibility: visible;
  }

  .md\\:invisible {
    visibility: hidden;
  }

  .md\\:whitespace-normal {
    white-space: normal;
  }

  .md\\:whitespace-no-wrap {
    white-space: nowrap;
  }

  .md\\:whitespace-pre {
    white-space: pre;
  }

  .md\\:whitespace-pre-line {
    white-space: pre-line;
  }

  .md\\:whitespace-pre-wrap {
    white-space: pre-wrap;
  }

  .md\\:break-normal {
    word-wrap: normal;
    overflow-wrap: normal;
    word-break: normal;
  }

  .md\\:break-words {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .md\\:break-all {
    word-break: break-all;
  }

  .md\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .md\\:w-0 {
    width: 0;
  }

  .md\\:w-1 {
    width: 0.25rem;
  }

  .md\\:w-2 {
    width: 0.5rem;
  }

  .md\\:w-3 {
    width: 0.75rem;
  }

  .md\\:w-4 {
    width: 1rem;
  }

  .md\\:w-5 {
    width: 1.25rem;
  }

  .md\\:w-6 {
    width: 1.5rem;
  }

  .md\\:w-8 {
    width: 2rem;
  }

  .md\\:w-10 {
    width: 2.5rem;
  }

  .md\\:w-12 {
    width: 3rem;
  }

  .md\\:w-16 {
    width: 4rem;
  }

  .md\\:w-20 {
    width: 5rem;
  }

  .md\\:w-24 {
    width: 6rem;
  }

  .md\\:w-32 {
    width: 8rem;
  }

  .md\\:w-40 {
    width: 10rem;
  }

  .md\\:w-48 {
    width: 12rem;
  }

  .md\\:w-56 {
    width: 14rem;
  }

  .md\\:w-64 {
    width: 16rem;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:w-px {
    width: 1px;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:w-1\\/3 {
    width: 33.333333%;
  }

  .md\\:w-2\\/3 {
    width: 66.666667%;
  }

  .md\\:w-1\\/4 {
    width: 25%;
  }

  .md\\:w-2\\/4 {
    width: 50%;
  }

  .md\\:w-3\\/4 {
    width: 75%;
  }

  .md\\:w-1\\/5 {
    width: 20%;
  }

  .md\\:w-2\\/5 {
    width: 40%;
  }

  .md\\:w-3\\/5 {
    width: 60%;
  }

  .md\\:w-4\\/5 {
    width: 80%;
  }

  .md\\:w-1\\/6 {
    width: 16.666667%;
  }

  .md\\:w-2\\/6 {
    width: 33.333333%;
  }

  .md\\:w-3\\/6 {
    width: 50%;
  }

  .md\\:w-4\\/6 {
    width: 66.666667%;
  }

  .md\\:w-5\\/6 {
    width: 83.333333%;
  }

  .md\\:w-1\\/12 {
    width: 8.333333%;
  }

  .md\\:w-2\\/12 {
    width: 16.666667%;
  }

  .md\\:w-3\\/12 {
    width: 25%;
  }

  .md\\:w-4\\/12 {
    width: 33.333333%;
  }

  .md\\:w-5\\/12 {
    width: 41.666667%;
  }

  .md\\:w-6\\/12 {
    width: 50%;
  }

  .md\\:w-7\\/12 {
    width: 58.333333%;
  }

  .md\\:w-8\\/12 {
    width: 66.666667%;
  }

  .md\\:w-9\\/12 {
    width: 75%;
  }

  .md\\:w-10\\/12 {
    width: 83.333333%;
  }

  .md\\:w-11\\/12 {
    width: 91.666667%;
  }

  .md\\:w-full {
    width: 100%;
  }

  .md\\:w-screen {
    width: 100vw;
  }

  .md\\:z-0 {
    z-index: 0;
  }

  .md\\:z-10 {
    z-index: 10;
  }

  .md\\:z-20 {
    z-index: 20;
  }

  .md\\:z-30 {
    z-index: 30;
  }

  .md\\:z-40 {
    z-index: 40;
  }

  .md\\:z-50 {
    z-index: 50;
  }

  .md\\:z-auto {
    z-index: auto;
  }

  .md\\:gap-0 {
    grid-gap: 0;
    gap: 0;
  }

  .md\\:gap-1 {
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .md\\:gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .md\\:gap-3 {
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .md\\:gap-4 {
    grid-gap: 1rem;
    gap: 1rem;
  }

  .md\\:gap-5 {
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .md\\:gap-6 {
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .md\\:gap-8 {
    grid-gap: 2rem;
    gap: 2rem;
  }

  .md\\:gap-10 {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .md\\:gap-12 {
    grid-gap: 3rem;
    gap: 3rem;
  }

  .md\\:gap-16 {
    grid-gap: 4rem;
    gap: 4rem;
  }

  .md\\:gap-20 {
    grid-gap: 5rem;
    gap: 5rem;
  }

  .md\\:gap-24 {
    grid-gap: 6rem;
    gap: 6rem;
  }

  .md\\:gap-32 {
    grid-gap: 8rem;
    gap: 8rem;
  }

  .md\\:gap-40 {
    grid-gap: 10rem;
    gap: 10rem;
  }

  .md\\:gap-48 {
    grid-gap: 12rem;
    gap: 12rem;
  }

  .md\\:gap-56 {
    grid-gap: 14rem;
    gap: 14rem;
  }

  .md\\:gap-64 {
    grid-gap: 16rem;
    gap: 16rem;
  }

  .md\\:gap-px {
    grid-gap: 1px;
    gap: 1px;
  }

  .md\\:col-gap-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }

  .md\\:col-gap-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }

  .md\\:col-gap-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }

  .md\\:col-gap-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }

  .md\\:col-gap-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }

  .md\\:col-gap-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .md\\:col-gap-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .md\\:col-gap-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }

  .md\\:col-gap-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .md\\:col-gap-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }

  .md\\:col-gap-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }

  .md\\:col-gap-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }

  .md\\:col-gap-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }

  .md\\:col-gap-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }

  .md\\:col-gap-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }

  .md\\:col-gap-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }

  .md\\:col-gap-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }

  .md\\:col-gap-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }

  .md\\:col-gap-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }

  .md\\:gap-x-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }

  .md\\:gap-x-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }

  .md\\:gap-x-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }

  .md\\:gap-x-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }

  .md\\:gap-x-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }

  .md\\:gap-x-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .md\\:gap-x-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .md\\:gap-x-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }

  .md\\:gap-x-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .md\\:gap-x-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }

  .md\\:gap-x-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }

  .md\\:gap-x-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }

  .md\\:gap-x-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }

  .md\\:gap-x-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }

  .md\\:gap-x-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }

  .md\\:gap-x-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }

  .md\\:gap-x-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }

  .md\\:gap-x-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }

  .md\\:gap-x-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }

  .md\\:row-gap-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }

  .md\\:row-gap-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .md\\:row-gap-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .md\\:row-gap-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .md\\:row-gap-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .md\\:row-gap-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .md\\:row-gap-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .md\\:row-gap-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .md\\:row-gap-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .md\\:row-gap-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .md\\:row-gap-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .md\\:row-gap-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .md\\:row-gap-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .md\\:row-gap-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .md\\:row-gap-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .md\\:row-gap-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .md\\:row-gap-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .md\\:row-gap-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .md\\:row-gap-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .md\\:gap-y-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }

  .md\\:gap-y-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .md\\:gap-y-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .md\\:gap-y-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .md\\:gap-y-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .md\\:gap-y-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .md\\:gap-y-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .md\\:gap-y-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .md\\:gap-y-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .md\\:gap-y-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .md\\:gap-y-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .md\\:gap-y-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .md\\:gap-y-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .md\\:gap-y-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .md\\:gap-y-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .md\\:gap-y-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .md\\:gap-y-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .md\\:gap-y-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .md\\:gap-y-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .md\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .md\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .md\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .md\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .md\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .md\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .md\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .md\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .md\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .md\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-none {
    grid-template-columns: none;
  }

  .md\\:auto-cols-auto {
    grid-auto-columns: auto;
  }

  .md\\:auto-cols-min {
    grid-auto-columns: min-content;
  }

  .md\\:auto-cols-max {
    grid-auto-columns: max-content;
  }

  .md\\:auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }

  .md\\:col-auto {
    grid-column: auto;
  }

  .md\\:col-span-1 {
    grid-column: span 1/span 1;
  }

  .md\\:col-span-2 {
    grid-column: span 2/span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3/span 3;
  }

  .md\\:col-span-4 {
    grid-column: span 4/span 4;
  }

  .md\\:col-span-5 {
    grid-column: span 5/span 5;
  }

  .md\\:col-span-6 {
    grid-column: span 6/span 6;
  }

  .md\\:col-span-7 {
    grid-column: span 7/span 7;
  }

  .md\\:col-span-8 {
    grid-column: span 8/span 8;
  }

  .md\\:col-span-9 {
    grid-column: span 9/span 9;
  }

  .md\\:col-span-10 {
    grid-column: span 10/span 10;
  }

  .md\\:col-span-11 {
    grid-column: span 11/span 11;
  }

  .md\\:col-span-12 {
    grid-column: span 12/span 12;
  }

  .md\\:col-span-full {
    grid-column: 1/-1;
  }

  .md\\:col-start-1 {
    grid-column-start: 1;
  }

  .md\\:col-start-2 {
    grid-column-start: 2;
  }

  .md\\:col-start-3 {
    grid-column-start: 3;
  }

  .md\\:col-start-4 {
    grid-column-start: 4;
  }

  .md\\:col-start-5 {
    grid-column-start: 5;
  }

  .md\\:col-start-6 {
    grid-column-start: 6;
  }

  .md\\:col-start-7 {
    grid-column-start: 7;
  }

  .md\\:col-start-8 {
    grid-column-start: 8;
  }

  .md\\:col-start-9 {
    grid-column-start: 9;
  }

  .md\\:col-start-10 {
    grid-column-start: 10;
  }

  .md\\:col-start-11 {
    grid-column-start: 11;
  }

  .md\\:col-start-12 {
    grid-column-start: 12;
  }

  .md\\:col-start-13 {
    grid-column-start: 13;
  }

  .md\\:col-start-auto {
    grid-column-start: auto;
  }

  .md\\:col-end-1 {
    grid-column-end: 1;
  }

  .md\\:col-end-2 {
    grid-column-end: 2;
  }

  .md\\:col-end-3 {
    grid-column-end: 3;
  }

  .md\\:col-end-4 {
    grid-column-end: 4;
  }

  .md\\:col-end-5 {
    grid-column-end: 5;
  }

  .md\\:col-end-6 {
    grid-column-end: 6;
  }

  .md\\:col-end-7 {
    grid-column-end: 7;
  }

  .md\\:col-end-8 {
    grid-column-end: 8;
  }

  .md\\:col-end-9 {
    grid-column-end: 9;
  }

  .md\\:col-end-10 {
    grid-column-end: 10;
  }

  .md\\:col-end-11 {
    grid-column-end: 11;
  }

  .md\\:col-end-12 {
    grid-column-end: 12;
  }

  .md\\:col-end-13 {
    grid-column-end: 13;
  }

  .md\\:col-end-auto {
    grid-column-end: auto;
  }

  .md\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-rows-none {
    grid-template-rows: none;
  }

  .md\\:auto-rows-auto {
    grid-auto-rows: auto;
  }

  .md\\:auto-rows-min {
    grid-auto-rows: min-content;
  }

  .md\\:auto-rows-max {
    grid-auto-rows: max-content;
  }

  .md\\:auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
  }

  .md\\:row-auto {
    grid-row: auto;
  }

  .md\\:row-span-1 {
    grid-row: span 1/span 1;
  }

  .md\\:row-span-2 {
    grid-row: span 2/span 2;
  }

  .md\\:row-span-3 {
    grid-row: span 3/span 3;
  }

  .md\\:row-span-4 {
    grid-row: span 4/span 4;
  }

  .md\\:row-span-5 {
    grid-row: span 5/span 5;
  }

  .md\\:row-span-6 {
    grid-row: span 6/span 6;
  }

  .md\\:row-span-full {
    grid-row: 1/-1;
  }

  .md\\:row-start-1 {
    grid-row-start: 1;
  }

  .md\\:row-start-2 {
    grid-row-start: 2;
  }

  .md\\:row-start-3 {
    grid-row-start: 3;
  }

  .md\\:row-start-4 {
    grid-row-start: 4;
  }

  .md\\:row-start-5 {
    grid-row-start: 5;
  }

  .md\\:row-start-6 {
    grid-row-start: 6;
  }

  .md\\:row-start-7 {
    grid-row-start: 7;
  }

  .md\\:row-start-auto {
    grid-row-start: auto;
  }

  .md\\:row-end-1 {
    grid-row-end: 1;
  }

  .md\\:row-end-2 {
    grid-row-end: 2;
  }

  .md\\:row-end-3 {
    grid-row-end: 3;
  }

  .md\\:row-end-4 {
    grid-row-end: 4;
  }

  .md\\:row-end-5 {
    grid-row-end: 5;
  }

  .md\\:row-end-6 {
    grid-row-end: 6;
  }

  .md\\:row-end-7 {
    grid-row-end: 7;
  }

  .md\\:row-end-auto {
    grid-row-end: auto;
  }

  .md\\:transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .md\\:transform-none {
    transform: none;
  }

  .md\\:origin-center {
    transform-origin: center;
  }

  .md\\:origin-top {
    transform-origin: top;
  }

  .md\\:origin-top-right {
    transform-origin: top right;
  }

  .md\\:origin-right {
    transform-origin: right;
  }

  .md\\:origin-bottom-right {
    transform-origin: bottom right;
  }

  .md\\:origin-bottom {
    transform-origin: bottom;
  }

  .md\\:origin-bottom-left {
    transform-origin: bottom left;
  }

  .md\\:origin-left {
    transform-origin: left;
  }

  .md\\:origin-top-left {
    transform-origin: top left;
  }

  .md\\:scale-0 {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .md\\:scale-50 {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .md\\:scale-75 {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .md\\:scale-90 {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .md\\:scale-95 {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .md\\:scale-100 {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .md\\:scale-105 {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .md\\:scale-110 {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .md\\:scale-125 {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .md\\:scale-150 {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .md\\:scale-x-0 {
    --transform-scale-x: 0;
  }

  .md\\:scale-x-50 {
    --transform-scale-x: .5;
  }

  .md\\:scale-x-75 {
    --transform-scale-x: .75;
  }

  .md\\:scale-x-90 {
    --transform-scale-x: .9;
  }

  .md\\:scale-x-95 {
    --transform-scale-x: .95;
  }

  .md\\:scale-x-100 {
    --transform-scale-x: 1;
  }

  .md\\:scale-x-105 {
    --transform-scale-x: 1.05;
  }

  .md\\:scale-x-110 {
    --transform-scale-x: 1.1;
  }

  .md\\:scale-x-125 {
    --transform-scale-x: 1.25;
  }

  .md\\:scale-x-150 {
    --transform-scale-x: 1.5;
  }

  .md\\:scale-y-0 {
    --transform-scale-y: 0;
  }

  .md\\:scale-y-50 {
    --transform-scale-y: .5;
  }

  .md\\:scale-y-75 {
    --transform-scale-y: .75;
  }

  .md\\:scale-y-90 {
    --transform-scale-y: .9;
  }

  .md\\:scale-y-95 {
    --transform-scale-y: .95;
  }

  .md\\:scale-y-100 {
    --transform-scale-y: 1;
  }

  .md\\:scale-y-105 {
    --transform-scale-y: 1.05;
  }

  .md\\:scale-y-110 {
    --transform-scale-y: 1.1;
  }

  .md\\:scale-y-125 {
    --transform-scale-y: 1.25;
  }

  .md\\:scale-y-150 {
    --transform-scale-y: 1.5;
  }

  .md\\:hover\\:scale-0:hover {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .md\\:hover\\:scale-50:hover {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .md\\:hover\\:scale-75:hover {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .md\\:hover\\:scale-90:hover {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .md\\:hover\\:scale-95:hover {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .md\\:hover\\:scale-100:hover {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .md\\:hover\\:scale-105:hover {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .md\\:hover\\:scale-110:hover {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .md\\:hover\\:scale-125:hover {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .md\\:hover\\:scale-150:hover {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .md\\:hover\\:scale-x-0:hover {
    --transform-scale-x: 0;
  }

  .md\\:hover\\:scale-x-50:hover {
    --transform-scale-x: .5;
  }

  .md\\:hover\\:scale-x-75:hover {
    --transform-scale-x: .75;
  }

  .md\\:hover\\:scale-x-90:hover {
    --transform-scale-x: .9;
  }

  .md\\:hover\\:scale-x-95:hover {
    --transform-scale-x: .95;
  }

  .md\\:hover\\:scale-x-100:hover {
    --transform-scale-x: 1;
  }

  .md\\:hover\\:scale-x-105:hover {
    --transform-scale-x: 1.05;
  }

  .md\\:hover\\:scale-x-110:hover {
    --transform-scale-x: 1.1;
  }

  .md\\:hover\\:scale-x-125:hover {
    --transform-scale-x: 1.25;
  }

  .md\\:hover\\:scale-x-150:hover {
    --transform-scale-x: 1.5;
  }

  .md\\:hover\\:scale-y-0:hover {
    --transform-scale-y: 0;
  }

  .md\\:hover\\:scale-y-50:hover {
    --transform-scale-y: .5;
  }

  .md\\:hover\\:scale-y-75:hover {
    --transform-scale-y: .75;
  }

  .md\\:hover\\:scale-y-90:hover {
    --transform-scale-y: .9;
  }

  .md\\:hover\\:scale-y-95:hover {
    --transform-scale-y: .95;
  }

  .md\\:hover\\:scale-y-100:hover {
    --transform-scale-y: 1;
  }

  .md\\:hover\\:scale-y-105:hover {
    --transform-scale-y: 1.05;
  }

  .md\\:hover\\:scale-y-110:hover {
    --transform-scale-y: 1.1;
  }

  .md\\:hover\\:scale-y-125:hover {
    --transform-scale-y: 1.25;
  }

  .md\\:hover\\:scale-y-150:hover {
    --transform-scale-y: 1.5;
  }

  .md\\:focus\\:scale-0:focus {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .md\\:focus\\:scale-50:focus {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .md\\:focus\\:scale-75:focus {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .md\\:focus\\:scale-90:focus {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .md\\:focus\\:scale-95:focus {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .md\\:focus\\:scale-100:focus {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .md\\:focus\\:scale-105:focus {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .md\\:focus\\:scale-110:focus {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .md\\:focus\\:scale-125:focus {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .md\\:focus\\:scale-150:focus {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .md\\:focus\\:scale-x-0:focus {
    --transform-scale-x: 0;
  }

  .md\\:focus\\:scale-x-50:focus {
    --transform-scale-x: .5;
  }

  .md\\:focus\\:scale-x-75:focus {
    --transform-scale-x: .75;
  }

  .md\\:focus\\:scale-x-90:focus {
    --transform-scale-x: .9;
  }

  .md\\:focus\\:scale-x-95:focus {
    --transform-scale-x: .95;
  }

  .md\\:focus\\:scale-x-100:focus {
    --transform-scale-x: 1;
  }

  .md\\:focus\\:scale-x-105:focus {
    --transform-scale-x: 1.05;
  }

  .md\\:focus\\:scale-x-110:focus {
    --transform-scale-x: 1.1;
  }

  .md\\:focus\\:scale-x-125:focus {
    --transform-scale-x: 1.25;
  }

  .md\\:focus\\:scale-x-150:focus {
    --transform-scale-x: 1.5;
  }

  .md\\:focus\\:scale-y-0:focus {
    --transform-scale-y: 0;
  }

  .md\\:focus\\:scale-y-50:focus {
    --transform-scale-y: .5;
  }

  .md\\:focus\\:scale-y-75:focus {
    --transform-scale-y: .75;
  }

  .md\\:focus\\:scale-y-90:focus {
    --transform-scale-y: .9;
  }

  .md\\:focus\\:scale-y-95:focus {
    --transform-scale-y: .95;
  }

  .md\\:focus\\:scale-y-100:focus {
    --transform-scale-y: 1;
  }

  .md\\:focus\\:scale-y-105:focus {
    --transform-scale-y: 1.05;
  }

  .md\\:focus\\:scale-y-110:focus {
    --transform-scale-y: 1.1;
  }

  .md\\:focus\\:scale-y-125:focus {
    --transform-scale-y: 1.25;
  }

  .md\\:focus\\:scale-y-150:focus {
    --transform-scale-y: 1.5;
  }

  .md\\:rotate-0 {
    --transform-rotate: 0;
  }

  .md\\:rotate-1 {
    --transform-rotate: 1deg;
  }

  .md\\:rotate-2 {
    --transform-rotate: 2deg;
  }

  .md\\:rotate-3 {
    --transform-rotate: 3deg;
  }

  .md\\:rotate-6 {
    --transform-rotate: 6deg;
  }

  .md\\:rotate-12 {
    --transform-rotate: 12deg;
  }

  .md\\:rotate-45 {
    --transform-rotate: 45deg;
  }

  .md\\:rotate-90 {
    --transform-rotate: 90deg;
  }

  .md\\:rotate-180 {
    --transform-rotate: 180deg;
  }

  .md\\:-rotate-180 {
    --transform-rotate: -180deg;
  }

  .md\\:-rotate-90 {
    --transform-rotate: -90deg;
  }

  .md\\:-rotate-45 {
    --transform-rotate: -45deg;
  }

  .md\\:-rotate-12 {
    --transform-rotate: -12deg;
  }

  .md\\:-rotate-6 {
    --transform-rotate: -6deg;
  }

  .md\\:-rotate-3 {
    --transform-rotate: -3deg;
  }

  .md\\:-rotate-2 {
    --transform-rotate: -2deg;
  }

  .md\\:-rotate-1 {
    --transform-rotate: -1deg;
  }

  .md\\:hover\\:rotate-0:hover {
    --transform-rotate: 0;
  }

  .md\\:hover\\:rotate-1:hover {
    --transform-rotate: 1deg;
  }

  .md\\:hover\\:rotate-2:hover {
    --transform-rotate: 2deg;
  }

  .md\\:hover\\:rotate-3:hover {
    --transform-rotate: 3deg;
  }

  .md\\:hover\\:rotate-6:hover {
    --transform-rotate: 6deg;
  }

  .md\\:hover\\:rotate-12:hover {
    --transform-rotate: 12deg;
  }

  .md\\:hover\\:rotate-45:hover {
    --transform-rotate: 45deg;
  }

  .md\\:hover\\:rotate-90:hover {
    --transform-rotate: 90deg;
  }

  .md\\:hover\\:rotate-180:hover {
    --transform-rotate: 180deg;
  }

  .md\\:hover\\:-rotate-180:hover {
    --transform-rotate: -180deg;
  }

  .md\\:hover\\:-rotate-90:hover {
    --transform-rotate: -90deg;
  }

  .md\\:hover\\:-rotate-45:hover {
    --transform-rotate: -45deg;
  }

  .md\\:hover\\:-rotate-12:hover {
    --transform-rotate: -12deg;
  }

  .md\\:hover\\:-rotate-6:hover {
    --transform-rotate: -6deg;
  }

  .md\\:hover\\:-rotate-3:hover {
    --transform-rotate: -3deg;
  }

  .md\\:hover\\:-rotate-2:hover {
    --transform-rotate: -2deg;
  }

  .md\\:hover\\:-rotate-1:hover {
    --transform-rotate: -1deg;
  }

  .md\\:focus\\:rotate-0:focus {
    --transform-rotate: 0;
  }

  .md\\:focus\\:rotate-1:focus {
    --transform-rotate: 1deg;
  }

  .md\\:focus\\:rotate-2:focus {
    --transform-rotate: 2deg;
  }

  .md\\:focus\\:rotate-3:focus {
    --transform-rotate: 3deg;
  }

  .md\\:focus\\:rotate-6:focus {
    --transform-rotate: 6deg;
  }

  .md\\:focus\\:rotate-12:focus {
    --transform-rotate: 12deg;
  }

  .md\\:focus\\:rotate-45:focus {
    --transform-rotate: 45deg;
  }

  .md\\:focus\\:rotate-90:focus {
    --transform-rotate: 90deg;
  }

  .md\\:focus\\:rotate-180:focus {
    --transform-rotate: 180deg;
  }

  .md\\:focus\\:-rotate-180:focus {
    --transform-rotate: -180deg;
  }

  .md\\:focus\\:-rotate-90:focus {
    --transform-rotate: -90deg;
  }

  .md\\:focus\\:-rotate-45:focus {
    --transform-rotate: -45deg;
  }

  .md\\:focus\\:-rotate-12:focus {
    --transform-rotate: -12deg;
  }

  .md\\:focus\\:-rotate-6:focus {
    --transform-rotate: -6deg;
  }

  .md\\:focus\\:-rotate-3:focus {
    --transform-rotate: -3deg;
  }

  .md\\:focus\\:-rotate-2:focus {
    --transform-rotate: -2deg;
  }

  .md\\:focus\\:-rotate-1:focus {
    --transform-rotate: -1deg;
  }

  .md\\:translate-x-0 {
    --transform-translate-x: 0;
  }

  .md\\:translate-x-1 {
    --transform-translate-x: 0.25rem;
  }

  .md\\:translate-x-2 {
    --transform-translate-x: 0.5rem;
  }

  .md\\:translate-x-3 {
    --transform-translate-x: 0.75rem;
  }

  .md\\:translate-x-4 {
    --transform-translate-x: 1rem;
  }

  .md\\:translate-x-5 {
    --transform-translate-x: 1.25rem;
  }

  .md\\:translate-x-6 {
    --transform-translate-x: 1.5rem;
  }

  .md\\:translate-x-8 {
    --transform-translate-x: 2rem;
  }

  .md\\:translate-x-10 {
    --transform-translate-x: 2.5rem;
  }

  .md\\:translate-x-12 {
    --transform-translate-x: 3rem;
  }

  .md\\:translate-x-16 {
    --transform-translate-x: 4rem;
  }

  .md\\:translate-x-20 {
    --transform-translate-x: 5rem;
  }

  .md\\:translate-x-24 {
    --transform-translate-x: 6rem;
  }

  .md\\:translate-x-32 {
    --transform-translate-x: 8rem;
  }

  .md\\:translate-x-40 {
    --transform-translate-x: 10rem;
  }

  .md\\:translate-x-48 {
    --transform-translate-x: 12rem;
  }

  .md\\:translate-x-56 {
    --transform-translate-x: 14rem;
  }

  .md\\:translate-x-64 {
    --transform-translate-x: 16rem;
  }

  .md\\:translate-x-px {
    --transform-translate-x: 1px;
  }

  .md\\:-translate-x-1 {
    --transform-translate-x: -0.25rem;
  }

  .md\\:-translate-x-2 {
    --transform-translate-x: -0.5rem;
  }

  .md\\:-translate-x-3 {
    --transform-translate-x: -0.75rem;
  }

  .md\\:-translate-x-4 {
    --transform-translate-x: -1rem;
  }

  .md\\:-translate-x-5 {
    --transform-translate-x: -1.25rem;
  }

  .md\\:-translate-x-6 {
    --transform-translate-x: -1.5rem;
  }

  .md\\:-translate-x-8 {
    --transform-translate-x: -2rem;
  }

  .md\\:-translate-x-10 {
    --transform-translate-x: -2.5rem;
  }

  .md\\:-translate-x-12 {
    --transform-translate-x: -3rem;
  }

  .md\\:-translate-x-16 {
    --transform-translate-x: -4rem;
  }

  .md\\:-translate-x-20 {
    --transform-translate-x: -5rem;
  }

  .md\\:-translate-x-24 {
    --transform-translate-x: -6rem;
  }

  .md\\:-translate-x-32 {
    --transform-translate-x: -8rem;
  }

  .md\\:-translate-x-40 {
    --transform-translate-x: -10rem;
  }

  .md\\:-translate-x-48 {
    --transform-translate-x: -12rem;
  }

  .md\\:-translate-x-56 {
    --transform-translate-x: -14rem;
  }

  .md\\:-translate-x-64 {
    --transform-translate-x: -16rem;
  }

  .md\\:-translate-x-px {
    --transform-translate-x: -1px;
  }

  .md\\:-translate-x-full {
    --transform-translate-x: -100%;
  }

  .md\\:-translate-x-1\\/2 {
    --transform-translate-x: -50%;
  }

  .md\\:translate-x-1\\/2 {
    --transform-translate-x: 50%;
  }

  .md\\:translate-x-full {
    --transform-translate-x: 100%;
  }

  .md\\:translate-y-0 {
    --transform-translate-y: 0;
  }

  .md\\:translate-y-1 {
    --transform-translate-y: 0.25rem;
  }

  .md\\:translate-y-2 {
    --transform-translate-y: 0.5rem;
  }

  .md\\:translate-y-3 {
    --transform-translate-y: 0.75rem;
  }

  .md\\:translate-y-4 {
    --transform-translate-y: 1rem;
  }

  .md\\:translate-y-5 {
    --transform-translate-y: 1.25rem;
  }

  .md\\:translate-y-6 {
    --transform-translate-y: 1.5rem;
  }

  .md\\:translate-y-8 {
    --transform-translate-y: 2rem;
  }

  .md\\:translate-y-10 {
    --transform-translate-y: 2.5rem;
  }

  .md\\:translate-y-12 {
    --transform-translate-y: 3rem;
  }

  .md\\:translate-y-16 {
    --transform-translate-y: 4rem;
  }

  .md\\:translate-y-20 {
    --transform-translate-y: 5rem;
  }

  .md\\:translate-y-24 {
    --transform-translate-y: 6rem;
  }

  .md\\:translate-y-32 {
    --transform-translate-y: 8rem;
  }

  .md\\:translate-y-40 {
    --transform-translate-y: 10rem;
  }

  .md\\:translate-y-48 {
    --transform-translate-y: 12rem;
  }

  .md\\:translate-y-56 {
    --transform-translate-y: 14rem;
  }

  .md\\:translate-y-64 {
    --transform-translate-y: 16rem;
  }

  .md\\:translate-y-px {
    --transform-translate-y: 1px;
  }

  .md\\:-translate-y-1 {
    --transform-translate-y: -0.25rem;
  }

  .md\\:-translate-y-2 {
    --transform-translate-y: -0.5rem;
  }

  .md\\:-translate-y-3 {
    --transform-translate-y: -0.75rem;
  }

  .md\\:-translate-y-4 {
    --transform-translate-y: -1rem;
  }

  .md\\:-translate-y-5 {
    --transform-translate-y: -1.25rem;
  }

  .md\\:-translate-y-6 {
    --transform-translate-y: -1.5rem;
  }

  .md\\:-translate-y-8 {
    --transform-translate-y: -2rem;
  }

  .md\\:-translate-y-10 {
    --transform-translate-y: -2.5rem;
  }

  .md\\:-translate-y-12 {
    --transform-translate-y: -3rem;
  }

  .md\\:-translate-y-16 {
    --transform-translate-y: -4rem;
  }

  .md\\:-translate-y-20 {
    --transform-translate-y: -5rem;
  }

  .md\\:-translate-y-24 {
    --transform-translate-y: -6rem;
  }

  .md\\:-translate-y-32 {
    --transform-translate-y: -8rem;
  }

  .md\\:-translate-y-40 {
    --transform-translate-y: -10rem;
  }

  .md\\:-translate-y-48 {
    --transform-translate-y: -12rem;
  }

  .md\\:-translate-y-56 {
    --transform-translate-y: -14rem;
  }

  .md\\:-translate-y-64 {
    --transform-translate-y: -16rem;
  }

  .md\\:-translate-y-px {
    --transform-translate-y: -1px;
  }

  .md\\:-translate-y-full {
    --transform-translate-y: -100%;
  }

  .md\\:-translate-y-1\\/2 {
    --transform-translate-y: -50%;
  }

  .md\\:translate-y-1\\/2 {
    --transform-translate-y: 50%;
  }

  .md\\:translate-y-full {
    --transform-translate-y: 100%;
  }

  .md\\:hover\\:translate-x-0:hover {
    --transform-translate-x: 0;
  }

  .md\\:hover\\:translate-x-1:hover {
    --transform-translate-x: 0.25rem;
  }

  .md\\:hover\\:translate-x-2:hover {
    --transform-translate-x: 0.5rem;
  }

  .md\\:hover\\:translate-x-3:hover {
    --transform-translate-x: 0.75rem;
  }

  .md\\:hover\\:translate-x-4:hover {
    --transform-translate-x: 1rem;
  }

  .md\\:hover\\:translate-x-5:hover {
    --transform-translate-x: 1.25rem;
  }

  .md\\:hover\\:translate-x-6:hover {
    --transform-translate-x: 1.5rem;
  }

  .md\\:hover\\:translate-x-8:hover {
    --transform-translate-x: 2rem;
  }

  .md\\:hover\\:translate-x-10:hover {
    --transform-translate-x: 2.5rem;
  }

  .md\\:hover\\:translate-x-12:hover {
    --transform-translate-x: 3rem;
  }

  .md\\:hover\\:translate-x-16:hover {
    --transform-translate-x: 4rem;
  }

  .md\\:hover\\:translate-x-20:hover {
    --transform-translate-x: 5rem;
  }

  .md\\:hover\\:translate-x-24:hover {
    --transform-translate-x: 6rem;
  }

  .md\\:hover\\:translate-x-32:hover {
    --transform-translate-x: 8rem;
  }

  .md\\:hover\\:translate-x-40:hover {
    --transform-translate-x: 10rem;
  }

  .md\\:hover\\:translate-x-48:hover {
    --transform-translate-x: 12rem;
  }

  .md\\:hover\\:translate-x-56:hover {
    --transform-translate-x: 14rem;
  }

  .md\\:hover\\:translate-x-64:hover {
    --transform-translate-x: 16rem;
  }

  .md\\:hover\\:translate-x-px:hover {
    --transform-translate-x: 1px;
  }

  .md\\:hover\\:-translate-x-1:hover {
    --transform-translate-x: -0.25rem;
  }

  .md\\:hover\\:-translate-x-2:hover {
    --transform-translate-x: -0.5rem;
  }

  .md\\:hover\\:-translate-x-3:hover {
    --transform-translate-x: -0.75rem;
  }

  .md\\:hover\\:-translate-x-4:hover {
    --transform-translate-x: -1rem;
  }

  .md\\:hover\\:-translate-x-5:hover {
    --transform-translate-x: -1.25rem;
  }

  .md\\:hover\\:-translate-x-6:hover {
    --transform-translate-x: -1.5rem;
  }

  .md\\:hover\\:-translate-x-8:hover {
    --transform-translate-x: -2rem;
  }

  .md\\:hover\\:-translate-x-10:hover {
    --transform-translate-x: -2.5rem;
  }

  .md\\:hover\\:-translate-x-12:hover {
    --transform-translate-x: -3rem;
  }

  .md\\:hover\\:-translate-x-16:hover {
    --transform-translate-x: -4rem;
  }

  .md\\:hover\\:-translate-x-20:hover {
    --transform-translate-x: -5rem;
  }

  .md\\:hover\\:-translate-x-24:hover {
    --transform-translate-x: -6rem;
  }

  .md\\:hover\\:-translate-x-32:hover {
    --transform-translate-x: -8rem;
  }

  .md\\:hover\\:-translate-x-40:hover {
    --transform-translate-x: -10rem;
  }

  .md\\:hover\\:-translate-x-48:hover {
    --transform-translate-x: -12rem;
  }

  .md\\:hover\\:-translate-x-56:hover {
    --transform-translate-x: -14rem;
  }

  .md\\:hover\\:-translate-x-64:hover {
    --transform-translate-x: -16rem;
  }

  .md\\:hover\\:-translate-x-px:hover {
    --transform-translate-x: -1px;
  }

  .md\\:hover\\:-translate-x-full:hover {
    --transform-translate-x: -100%;
  }

  .md\\:hover\\:-translate-x-1\\/2:hover {
    --transform-translate-x: -50%;
  }

  .md\\:hover\\:translate-x-1\\/2:hover {
    --transform-translate-x: 50%;
  }

  .md\\:hover\\:translate-x-full:hover {
    --transform-translate-x: 100%;
  }

  .md\\:hover\\:translate-y-0:hover {
    --transform-translate-y: 0;
  }

  .md\\:hover\\:translate-y-1:hover {
    --transform-translate-y: 0.25rem;
  }

  .md\\:hover\\:translate-y-2:hover {
    --transform-translate-y: 0.5rem;
  }

  .md\\:hover\\:translate-y-3:hover {
    --transform-translate-y: 0.75rem;
  }

  .md\\:hover\\:translate-y-4:hover {
    --transform-translate-y: 1rem;
  }

  .md\\:hover\\:translate-y-5:hover {
    --transform-translate-y: 1.25rem;
  }

  .md\\:hover\\:translate-y-6:hover {
    --transform-translate-y: 1.5rem;
  }

  .md\\:hover\\:translate-y-8:hover {
    --transform-translate-y: 2rem;
  }

  .md\\:hover\\:translate-y-10:hover {
    --transform-translate-y: 2.5rem;
  }

  .md\\:hover\\:translate-y-12:hover {
    --transform-translate-y: 3rem;
  }

  .md\\:hover\\:translate-y-16:hover {
    --transform-translate-y: 4rem;
  }

  .md\\:hover\\:translate-y-20:hover {
    --transform-translate-y: 5rem;
  }

  .md\\:hover\\:translate-y-24:hover {
    --transform-translate-y: 6rem;
  }

  .md\\:hover\\:translate-y-32:hover {
    --transform-translate-y: 8rem;
  }

  .md\\:hover\\:translate-y-40:hover {
    --transform-translate-y: 10rem;
  }

  .md\\:hover\\:translate-y-48:hover {
    --transform-translate-y: 12rem;
  }

  .md\\:hover\\:translate-y-56:hover {
    --transform-translate-y: 14rem;
  }

  .md\\:hover\\:translate-y-64:hover {
    --transform-translate-y: 16rem;
  }

  .md\\:hover\\:translate-y-px:hover {
    --transform-translate-y: 1px;
  }

  .md\\:hover\\:-translate-y-1:hover {
    --transform-translate-y: -0.25rem;
  }

  .md\\:hover\\:-translate-y-2:hover {
    --transform-translate-y: -0.5rem;
  }

  .md\\:hover\\:-translate-y-3:hover {
    --transform-translate-y: -0.75rem;
  }

  .md\\:hover\\:-translate-y-4:hover {
    --transform-translate-y: -1rem;
  }

  .md\\:hover\\:-translate-y-5:hover {
    --transform-translate-y: -1.25rem;
  }

  .md\\:hover\\:-translate-y-6:hover {
    --transform-translate-y: -1.5rem;
  }

  .md\\:hover\\:-translate-y-8:hover {
    --transform-translate-y: -2rem;
  }

  .md\\:hover\\:-translate-y-10:hover {
    --transform-translate-y: -2.5rem;
  }

  .md\\:hover\\:-translate-y-12:hover {
    --transform-translate-y: -3rem;
  }

  .md\\:hover\\:-translate-y-16:hover {
    --transform-translate-y: -4rem;
  }

  .md\\:hover\\:-translate-y-20:hover {
    --transform-translate-y: -5rem;
  }

  .md\\:hover\\:-translate-y-24:hover {
    --transform-translate-y: -6rem;
  }

  .md\\:hover\\:-translate-y-32:hover {
    --transform-translate-y: -8rem;
  }

  .md\\:hover\\:-translate-y-40:hover {
    --transform-translate-y: -10rem;
  }

  .md\\:hover\\:-translate-y-48:hover {
    --transform-translate-y: -12rem;
  }

  .md\\:hover\\:-translate-y-56:hover {
    --transform-translate-y: -14rem;
  }

  .md\\:hover\\:-translate-y-64:hover {
    --transform-translate-y: -16rem;
  }

  .md\\:hover\\:-translate-y-px:hover {
    --transform-translate-y: -1px;
  }

  .md\\:hover\\:-translate-y-full:hover {
    --transform-translate-y: -100%;
  }

  .md\\:hover\\:-translate-y-1\\/2:hover {
    --transform-translate-y: -50%;
  }

  .md\\:hover\\:translate-y-1\\/2:hover {
    --transform-translate-y: 50%;
  }

  .md\\:hover\\:translate-y-full:hover {
    --transform-translate-y: 100%;
  }

  .md\\:focus\\:translate-x-0:focus {
    --transform-translate-x: 0;
  }

  .md\\:focus\\:translate-x-1:focus {
    --transform-translate-x: 0.25rem;
  }

  .md\\:focus\\:translate-x-2:focus {
    --transform-translate-x: 0.5rem;
  }

  .md\\:focus\\:translate-x-3:focus {
    --transform-translate-x: 0.75rem;
  }

  .md\\:focus\\:translate-x-4:focus {
    --transform-translate-x: 1rem;
  }

  .md\\:focus\\:translate-x-5:focus {
    --transform-translate-x: 1.25rem;
  }

  .md\\:focus\\:translate-x-6:focus {
    --transform-translate-x: 1.5rem;
  }

  .md\\:focus\\:translate-x-8:focus {
    --transform-translate-x: 2rem;
  }

  .md\\:focus\\:translate-x-10:focus {
    --transform-translate-x: 2.5rem;
  }

  .md\\:focus\\:translate-x-12:focus {
    --transform-translate-x: 3rem;
  }

  .md\\:focus\\:translate-x-16:focus {
    --transform-translate-x: 4rem;
  }

  .md\\:focus\\:translate-x-20:focus {
    --transform-translate-x: 5rem;
  }

  .md\\:focus\\:translate-x-24:focus {
    --transform-translate-x: 6rem;
  }

  .md\\:focus\\:translate-x-32:focus {
    --transform-translate-x: 8rem;
  }

  .md\\:focus\\:translate-x-40:focus {
    --transform-translate-x: 10rem;
  }

  .md\\:focus\\:translate-x-48:focus {
    --transform-translate-x: 12rem;
  }

  .md\\:focus\\:translate-x-56:focus {
    --transform-translate-x: 14rem;
  }

  .md\\:focus\\:translate-x-64:focus {
    --transform-translate-x: 16rem;
  }

  .md\\:focus\\:translate-x-px:focus {
    --transform-translate-x: 1px;
  }

  .md\\:focus\\:-translate-x-1:focus {
    --transform-translate-x: -0.25rem;
  }

  .md\\:focus\\:-translate-x-2:focus {
    --transform-translate-x: -0.5rem;
  }

  .md\\:focus\\:-translate-x-3:focus {
    --transform-translate-x: -0.75rem;
  }

  .md\\:focus\\:-translate-x-4:focus {
    --transform-translate-x: -1rem;
  }

  .md\\:focus\\:-translate-x-5:focus {
    --transform-translate-x: -1.25rem;
  }

  .md\\:focus\\:-translate-x-6:focus {
    --transform-translate-x: -1.5rem;
  }

  .md\\:focus\\:-translate-x-8:focus {
    --transform-translate-x: -2rem;
  }

  .md\\:focus\\:-translate-x-10:focus {
    --transform-translate-x: -2.5rem;
  }

  .md\\:focus\\:-translate-x-12:focus {
    --transform-translate-x: -3rem;
  }

  .md\\:focus\\:-translate-x-16:focus {
    --transform-translate-x: -4rem;
  }

  .md\\:focus\\:-translate-x-20:focus {
    --transform-translate-x: -5rem;
  }

  .md\\:focus\\:-translate-x-24:focus {
    --transform-translate-x: -6rem;
  }

  .md\\:focus\\:-translate-x-32:focus {
    --transform-translate-x: -8rem;
  }

  .md\\:focus\\:-translate-x-40:focus {
    --transform-translate-x: -10rem;
  }

  .md\\:focus\\:-translate-x-48:focus {
    --transform-translate-x: -12rem;
  }

  .md\\:focus\\:-translate-x-56:focus {
    --transform-translate-x: -14rem;
  }

  .md\\:focus\\:-translate-x-64:focus {
    --transform-translate-x: -16rem;
  }

  .md\\:focus\\:-translate-x-px:focus {
    --transform-translate-x: -1px;
  }

  .md\\:focus\\:-translate-x-full:focus {
    --transform-translate-x: -100%;
  }

  .md\\:focus\\:-translate-x-1\\/2:focus {
    --transform-translate-x: -50%;
  }

  .md\\:focus\\:translate-x-1\\/2:focus {
    --transform-translate-x: 50%;
  }

  .md\\:focus\\:translate-x-full:focus {
    --transform-translate-x: 100%;
  }

  .md\\:focus\\:translate-y-0:focus {
    --transform-translate-y: 0;
  }

  .md\\:focus\\:translate-y-1:focus {
    --transform-translate-y: 0.25rem;
  }

  .md\\:focus\\:translate-y-2:focus {
    --transform-translate-y: 0.5rem;
  }

  .md\\:focus\\:translate-y-3:focus {
    --transform-translate-y: 0.75rem;
  }

  .md\\:focus\\:translate-y-4:focus {
    --transform-translate-y: 1rem;
  }

  .md\\:focus\\:translate-y-5:focus {
    --transform-translate-y: 1.25rem;
  }

  .md\\:focus\\:translate-y-6:focus {
    --transform-translate-y: 1.5rem;
  }

  .md\\:focus\\:translate-y-8:focus {
    --transform-translate-y: 2rem;
  }

  .md\\:focus\\:translate-y-10:focus {
    --transform-translate-y: 2.5rem;
  }

  .md\\:focus\\:translate-y-12:focus {
    --transform-translate-y: 3rem;
  }

  .md\\:focus\\:translate-y-16:focus {
    --transform-translate-y: 4rem;
  }

  .md\\:focus\\:translate-y-20:focus {
    --transform-translate-y: 5rem;
  }

  .md\\:focus\\:translate-y-24:focus {
    --transform-translate-y: 6rem;
  }

  .md\\:focus\\:translate-y-32:focus {
    --transform-translate-y: 8rem;
  }

  .md\\:focus\\:translate-y-40:focus {
    --transform-translate-y: 10rem;
  }

  .md\\:focus\\:translate-y-48:focus {
    --transform-translate-y: 12rem;
  }

  .md\\:focus\\:translate-y-56:focus {
    --transform-translate-y: 14rem;
  }

  .md\\:focus\\:translate-y-64:focus {
    --transform-translate-y: 16rem;
  }

  .md\\:focus\\:translate-y-px:focus {
    --transform-translate-y: 1px;
  }

  .md\\:focus\\:-translate-y-1:focus {
    --transform-translate-y: -0.25rem;
  }

  .md\\:focus\\:-translate-y-2:focus {
    --transform-translate-y: -0.5rem;
  }

  .md\\:focus\\:-translate-y-3:focus {
    --transform-translate-y: -0.75rem;
  }

  .md\\:focus\\:-translate-y-4:focus {
    --transform-translate-y: -1rem;
  }

  .md\\:focus\\:-translate-y-5:focus {
    --transform-translate-y: -1.25rem;
  }

  .md\\:focus\\:-translate-y-6:focus {
    --transform-translate-y: -1.5rem;
  }

  .md\\:focus\\:-translate-y-8:focus {
    --transform-translate-y: -2rem;
  }

  .md\\:focus\\:-translate-y-10:focus {
    --transform-translate-y: -2.5rem;
  }

  .md\\:focus\\:-translate-y-12:focus {
    --transform-translate-y: -3rem;
  }

  .md\\:focus\\:-translate-y-16:focus {
    --transform-translate-y: -4rem;
  }

  .md\\:focus\\:-translate-y-20:focus {
    --transform-translate-y: -5rem;
  }

  .md\\:focus\\:-translate-y-24:focus {
    --transform-translate-y: -6rem;
  }

  .md\\:focus\\:-translate-y-32:focus {
    --transform-translate-y: -8rem;
  }

  .md\\:focus\\:-translate-y-40:focus {
    --transform-translate-y: -10rem;
  }

  .md\\:focus\\:-translate-y-48:focus {
    --transform-translate-y: -12rem;
  }

  .md\\:focus\\:-translate-y-56:focus {
    --transform-translate-y: -14rem;
  }

  .md\\:focus\\:-translate-y-64:focus {
    --transform-translate-y: -16rem;
  }

  .md\\:focus\\:-translate-y-px:focus {
    --transform-translate-y: -1px;
  }

  .md\\:focus\\:-translate-y-full:focus {
    --transform-translate-y: -100%;
  }

  .md\\:focus\\:-translate-y-1\\/2:focus {
    --transform-translate-y: -50%;
  }

  .md\\:focus\\:translate-y-1\\/2:focus {
    --transform-translate-y: 50%;
  }

  .md\\:focus\\:translate-y-full:focus {
    --transform-translate-y: 100%;
  }

  .md\\:skew-x-0 {
    --transform-skew-x: 0;
  }

  .md\\:skew-x-1 {
    --transform-skew-x: 1deg;
  }

  .md\\:skew-x-2 {
    --transform-skew-x: 2deg;
  }

  .md\\:skew-x-3 {
    --transform-skew-x: 3deg;
  }

  .md\\:skew-x-6 {
    --transform-skew-x: 6deg;
  }

  .md\\:skew-x-12 {
    --transform-skew-x: 12deg;
  }

  .md\\:-skew-x-12 {
    --transform-skew-x: -12deg;
  }

  .md\\:-skew-x-6 {
    --transform-skew-x: -6deg;
  }

  .md\\:-skew-x-3 {
    --transform-skew-x: -3deg;
  }

  .md\\:-skew-x-2 {
    --transform-skew-x: -2deg;
  }

  .md\\:-skew-x-1 {
    --transform-skew-x: -1deg;
  }

  .md\\:skew-y-0 {
    --transform-skew-y: 0;
  }

  .md\\:skew-y-1 {
    --transform-skew-y: 1deg;
  }

  .md\\:skew-y-2 {
    --transform-skew-y: 2deg;
  }

  .md\\:skew-y-3 {
    --transform-skew-y: 3deg;
  }

  .md\\:skew-y-6 {
    --transform-skew-y: 6deg;
  }

  .md\\:skew-y-12 {
    --transform-skew-y: 12deg;
  }

  .md\\:-skew-y-12 {
    --transform-skew-y: -12deg;
  }

  .md\\:-skew-y-6 {
    --transform-skew-y: -6deg;
  }

  .md\\:-skew-y-3 {
    --transform-skew-y: -3deg;
  }

  .md\\:-skew-y-2 {
    --transform-skew-y: -2deg;
  }

  .md\\:-skew-y-1 {
    --transform-skew-y: -1deg;
  }

  .md\\:hover\\:skew-x-0:hover {
    --transform-skew-x: 0;
  }

  .md\\:hover\\:skew-x-1:hover {
    --transform-skew-x: 1deg;
  }

  .md\\:hover\\:skew-x-2:hover {
    --transform-skew-x: 2deg;
  }

  .md\\:hover\\:skew-x-3:hover {
    --transform-skew-x: 3deg;
  }

  .md\\:hover\\:skew-x-6:hover {
    --transform-skew-x: 6deg;
  }

  .md\\:hover\\:skew-x-12:hover {
    --transform-skew-x: 12deg;
  }

  .md\\:hover\\:-skew-x-12:hover {
    --transform-skew-x: -12deg;
  }

  .md\\:hover\\:-skew-x-6:hover {
    --transform-skew-x: -6deg;
  }

  .md\\:hover\\:-skew-x-3:hover {
    --transform-skew-x: -3deg;
  }

  .md\\:hover\\:-skew-x-2:hover {
    --transform-skew-x: -2deg;
  }

  .md\\:hover\\:-skew-x-1:hover {
    --transform-skew-x: -1deg;
  }

  .md\\:hover\\:skew-y-0:hover {
    --transform-skew-y: 0;
  }

  .md\\:hover\\:skew-y-1:hover {
    --transform-skew-y: 1deg;
  }

  .md\\:hover\\:skew-y-2:hover {
    --transform-skew-y: 2deg;
  }

  .md\\:hover\\:skew-y-3:hover {
    --transform-skew-y: 3deg;
  }

  .md\\:hover\\:skew-y-6:hover {
    --transform-skew-y: 6deg;
  }

  .md\\:hover\\:skew-y-12:hover {
    --transform-skew-y: 12deg;
  }

  .md\\:hover\\:-skew-y-12:hover {
    --transform-skew-y: -12deg;
  }

  .md\\:hover\\:-skew-y-6:hover {
    --transform-skew-y: -6deg;
  }

  .md\\:hover\\:-skew-y-3:hover {
    --transform-skew-y: -3deg;
  }

  .md\\:hover\\:-skew-y-2:hover {
    --transform-skew-y: -2deg;
  }

  .md\\:hover\\:-skew-y-1:hover {
    --transform-skew-y: -1deg;
  }

  .md\\:focus\\:skew-x-0:focus {
    --transform-skew-x: 0;
  }

  .md\\:focus\\:skew-x-1:focus {
    --transform-skew-x: 1deg;
  }

  .md\\:focus\\:skew-x-2:focus {
    --transform-skew-x: 2deg;
  }

  .md\\:focus\\:skew-x-3:focus {
    --transform-skew-x: 3deg;
  }

  .md\\:focus\\:skew-x-6:focus {
    --transform-skew-x: 6deg;
  }

  .md\\:focus\\:skew-x-12:focus {
    --transform-skew-x: 12deg;
  }

  .md\\:focus\\:-skew-x-12:focus {
    --transform-skew-x: -12deg;
  }

  .md\\:focus\\:-skew-x-6:focus {
    --transform-skew-x: -6deg;
  }

  .md\\:focus\\:-skew-x-3:focus {
    --transform-skew-x: -3deg;
  }

  .md\\:focus\\:-skew-x-2:focus {
    --transform-skew-x: -2deg;
  }

  .md\\:focus\\:-skew-x-1:focus {
    --transform-skew-x: -1deg;
  }

  .md\\:focus\\:skew-y-0:focus {
    --transform-skew-y: 0;
  }

  .md\\:focus\\:skew-y-1:focus {
    --transform-skew-y: 1deg;
  }

  .md\\:focus\\:skew-y-2:focus {
    --transform-skew-y: 2deg;
  }

  .md\\:focus\\:skew-y-3:focus {
    --transform-skew-y: 3deg;
  }

  .md\\:focus\\:skew-y-6:focus {
    --transform-skew-y: 6deg;
  }

  .md\\:focus\\:skew-y-12:focus {
    --transform-skew-y: 12deg;
  }

  .md\\:focus\\:-skew-y-12:focus {
    --transform-skew-y: -12deg;
  }

  .md\\:focus\\:-skew-y-6:focus {
    --transform-skew-y: -6deg;
  }

  .md\\:focus\\:-skew-y-3:focus {
    --transform-skew-y: -3deg;
  }

  .md\\:focus\\:-skew-y-2:focus {
    --transform-skew-y: -2deg;
  }

  .md\\:focus\\:-skew-y-1:focus {
    --transform-skew-y: -1deg;
  }

  .md\\:transition-none {
    transition-property: none;
  }

  .md\\:transition-all {
    transition-property: all;
  }

  .md\\:transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .md\\:transition-colors {
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .md\\:transition-opacity {
    transition-property: opacity;
  }

  .md\\:transition-shadow {
    transition-property: box-shadow;
  }

  .md\\:transition-transform {
    transition-property: transform;
  }

  .md\\:ease-linear {
    transition-timing-function: linear;
  }

  .md\\:ease-in {
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .md\\:ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .md\\:ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .md\\:duration-75 {
    transition-duration: 75ms;
  }

  .md\\:duration-100 {
    transition-duration: 100ms;
  }

  .md\\:duration-150 {
    transition-duration: 150ms;
  }

  .md\\:duration-200 {
    transition-duration: 200ms;
  }

  .md\\:duration-300 {
    transition-duration: 300ms;
  }

  .md\\:duration-500 {
    transition-duration: 500ms;
  }

  .md\\:duration-700 {
    transition-duration: 700ms;
  }

  .md\\:duration-1000 {
    transition-duration: 1000ms;
  }

  .md\\:delay-75 {
    transition-delay: 75ms;
  }

  .md\\:delay-100 {
    transition-delay: 100ms;
  }

  .md\\:delay-150 {
    transition-delay: 150ms;
  }

  .md\\:delay-200 {
    transition-delay: 200ms;
  }

  .md\\:delay-300 {
    transition-delay: 300ms;
  }

  .md\\:delay-500 {
    transition-delay: 500ms;
  }

  .md\\:delay-700 {
    transition-delay: 700ms;
  }

  .md\\:delay-1000 {
    transition-delay: 1000ms;
  }

  .md\\:animate-none {
    animation: none;
  }

  .md\\:animate-spin {
    animation: spin 1s linear infinite;
  }

  .md\\:animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .md\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .md\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}

@media (min-width: 1024px) {
  .lg\\:container {
    width: 100%;
  }
}

@media (min-width: 1024px) and (min-width: 640px) {
  .lg\\:container {
    max-width: 640px;
  }
}

@media (min-width: 1024px) and (min-width: 768px) {
  .lg\\:container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) and (min-width: 1024px) {
  .lg\\:container {
    max-width: 1024px;
  }
}

@media (min-width: 1024px) and (min-width: 1280px) {
  .lg\\:container {
    max-width: 1280px;
  }
}

@media (min-width: 1024px) {
  .lg\\:space-y-0 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .lg\\:space-x-0 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-1 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .lg\\:space-x-1 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-2 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-2 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-3 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .lg\\:space-x-3 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-4 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .lg\\:space-x-4 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-5 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .lg\\:space-x-5 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-6 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-6 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-8 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .lg\\:space-x-8 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-10 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-10 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-12 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .lg\\:space-x-12 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-16 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .lg\\:space-x-16 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-20 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-20 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-24 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .lg\\:space-x-24 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-32 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .lg\\:space-x-32 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-40 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .lg\\:space-x-40 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-48 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .lg\\:space-x-48 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-56 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .lg\\:space-x-56 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-64 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .lg\\:space-x-64 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-px > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .lg\\:space-x-px > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-1 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-1 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-2 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-2 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-3 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-3 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-4 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-4 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-5 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-5 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-6 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-6 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-8 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-8 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-10 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-10 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-12 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-12 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-16 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-16 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-20 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-20 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-24 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-24 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-32 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-32 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-40 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-40 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-48 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-48 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-56 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-56 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-64 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-64 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-px > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .lg\\:-space-x-px > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-reverse > :not(template) ~ :not(template) {
    --space-y-reverse: 1;
  }

  .lg\\:space-x-reverse > :not(template) ~ :not(template) {
    --space-x-reverse: 1;
  }

  .lg\\:divide-y-0 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-0 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-2 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-2 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-4 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-4 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-8 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-8 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .lg\\:divide-x > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-reverse > :not(template) ~ :not(template) {
    --divide-y-reverse: 1;
  }

  .lg\\:divide-x-reverse > :not(template) ~ :not(template) {
    --divide-x-reverse: 1;
  }

  .lg\\:divide-transparent > :not(template) ~ :not(template) {
    border-color: transparent;
  }

  .lg\\:divide-current > :not(template) ~ :not(template) {
    border-color: currentColor;
  }

  .lg\\:divide-black > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .lg\\:divide-white > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .lg\\:divide-gray-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--divide-opacity));
  }

  .lg\\:divide-gray-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--divide-opacity));
  }

  .lg\\:divide-gray-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--divide-opacity));
  }

  .lg\\:divide-gray-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--divide-opacity));
  }

  .lg\\:divide-gray-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--divide-opacity));
  }

  .lg\\:divide-gray-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--divide-opacity));
  }

  .lg\\:divide-gray-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--divide-opacity));
  }

  .lg\\:divide-gray-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--divide-opacity));
  }

  .lg\\:divide-gray-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--divide-opacity));
  }

  .lg\\:divide-red-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--divide-opacity));
  }

  .lg\\:divide-red-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--divide-opacity));
  }

  .lg\\:divide-red-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--divide-opacity));
  }

  .lg\\:divide-red-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--divide-opacity));
  }

  .lg\\:divide-red-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--divide-opacity));
  }

  .lg\\:divide-red-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--divide-opacity));
  }

  .lg\\:divide-red-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--divide-opacity));
  }

  .lg\\:divide-red-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--divide-opacity));
  }

  .lg\\:divide-red-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--divide-opacity));
  }

  .lg\\:divide-orange-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--divide-opacity));
  }

  .lg\\:divide-orange-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--divide-opacity));
  }

  .lg\\:divide-orange-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--divide-opacity));
  }

  .lg\\:divide-orange-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--divide-opacity));
  }

  .lg\\:divide-orange-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--divide-opacity));
  }

  .lg\\:divide-orange-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--divide-opacity));
  }

  .lg\\:divide-orange-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--divide-opacity));
  }

  .lg\\:divide-orange-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--divide-opacity));
  }

  .lg\\:divide-orange-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--divide-opacity));
  }

  .lg\\:divide-yellow-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--divide-opacity));
  }

  .lg\\:divide-yellow-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--divide-opacity));
  }

  .lg\\:divide-yellow-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--divide-opacity));
  }

  .lg\\:divide-yellow-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--divide-opacity));
  }

  .lg\\:divide-yellow-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--divide-opacity));
  }

  .lg\\:divide-yellow-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--divide-opacity));
  }

  .lg\\:divide-yellow-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--divide-opacity));
  }

  .lg\\:divide-yellow-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--divide-opacity));
  }

  .lg\\:divide-yellow-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--divide-opacity));
  }

  .lg\\:divide-green-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--divide-opacity));
  }

  .lg\\:divide-green-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--divide-opacity));
  }

  .lg\\:divide-green-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--divide-opacity));
  }

  .lg\\:divide-green-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--divide-opacity));
  }

  .lg\\:divide-green-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--divide-opacity));
  }

  .lg\\:divide-green-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--divide-opacity));
  }

  .lg\\:divide-green-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--divide-opacity));
  }

  .lg\\:divide-green-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--divide-opacity));
  }

  .lg\\:divide-green-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--divide-opacity));
  }

  .lg\\:divide-teal-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--divide-opacity));
  }

  .lg\\:divide-teal-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--divide-opacity));
  }

  .lg\\:divide-teal-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--divide-opacity));
  }

  .lg\\:divide-teal-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--divide-opacity));
  }

  .lg\\:divide-teal-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--divide-opacity));
  }

  .lg\\:divide-teal-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--divide-opacity));
  }

  .lg\\:divide-teal-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--divide-opacity));
  }

  .lg\\:divide-teal-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--divide-opacity));
  }

  .lg\\:divide-teal-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--divide-opacity));
  }

  .lg\\:divide-blue-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--divide-opacity));
  }

  .lg\\:divide-blue-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--divide-opacity));
  }

  .lg\\:divide-blue-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--divide-opacity));
  }

  .lg\\:divide-blue-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--divide-opacity));
  }

  .lg\\:divide-blue-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--divide-opacity));
  }

  .lg\\:divide-blue-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--divide-opacity));
  }

  .lg\\:divide-blue-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--divide-opacity));
  }

  .lg\\:divide-blue-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--divide-opacity));
  }

  .lg\\:divide-blue-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--divide-opacity));
  }

  .lg\\:divide-indigo-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--divide-opacity));
  }

  .lg\\:divide-indigo-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--divide-opacity));
  }

  .lg\\:divide-indigo-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--divide-opacity));
  }

  .lg\\:divide-indigo-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--divide-opacity));
  }

  .lg\\:divide-indigo-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--divide-opacity));
  }

  .lg\\:divide-indigo-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--divide-opacity));
  }

  .lg\\:divide-indigo-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--divide-opacity));
  }

  .lg\\:divide-indigo-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--divide-opacity));
  }

  .lg\\:divide-indigo-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--divide-opacity));
  }

  .lg\\:divide-purple-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--divide-opacity));
  }

  .lg\\:divide-purple-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--divide-opacity));
  }

  .lg\\:divide-purple-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--divide-opacity));
  }

  .lg\\:divide-purple-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--divide-opacity));
  }

  .lg\\:divide-purple-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--divide-opacity));
  }

  .lg\\:divide-purple-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--divide-opacity));
  }

  .lg\\:divide-purple-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--divide-opacity));
  }

  .lg\\:divide-purple-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--divide-opacity));
  }

  .lg\\:divide-purple-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--divide-opacity));
  }

  .lg\\:divide-pink-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--divide-opacity));
  }

  .lg\\:divide-pink-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--divide-opacity));
  }

  .lg\\:divide-pink-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--divide-opacity));
  }

  .lg\\:divide-pink-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--divide-opacity));
  }

  .lg\\:divide-pink-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--divide-opacity));
  }

  .lg\\:divide-pink-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--divide-opacity));
  }

  .lg\\:divide-pink-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--divide-opacity));
  }

  .lg\\:divide-pink-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--divide-opacity));
  }

  .lg\\:divide-pink-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--divide-opacity));
  }

  .lg\\:divide-solid > :not(template) ~ :not(template) {
    border-style: solid;
  }

  .lg\\:divide-dashed > :not(template) ~ :not(template) {
    border-style: dashed;
  }

  .lg\\:divide-dotted > :not(template) ~ :not(template) {
    border-style: dotted;
  }

  .lg\\:divide-double > :not(template) ~ :not(template) {
    border-style: double;
  }

  .lg\\:divide-none > :not(template) ~ :not(template) {
    border-style: none;
  }

  .lg\\:divide-opacity-0 > :not(template) ~ :not(template) {
    --divide-opacity: 0;
  }

  .lg\\:divide-opacity-25 > :not(template) ~ :not(template) {
    --divide-opacity: 0.25;
  }

  .lg\\:divide-opacity-50 > :not(template) ~ :not(template) {
    --divide-opacity: 0.5;
  }

  .lg\\:divide-opacity-75 > :not(template) ~ :not(template) {
    --divide-opacity: 0.75;
  }

  .lg\\:divide-opacity-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
  }

  .lg\\:sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .lg\\:not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .lg\\:focus\\:sr-only:focus {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .lg\\:focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .lg\\:appearance-none {
    appearance: none;
  }

  .lg\\:bg-fixed {
    background-attachment: fixed;
  }

  .lg\\:bg-local {
    background-attachment: local;
  }

  .lg\\:bg-scroll {
    background-attachment: scroll;
  }

  .lg\\:bg-clip-border {
    background-clip: border-box;
  }

  .lg\\:bg-clip-padding {
    background-clip: padding-box;
  }

  .lg\\:bg-clip-content {
    background-clip: content-box;
  }

  .lg\\:bg-clip-text {
    -webkit-background-clip: text;
    background-clip: text;
  }

  .lg\\:bg-transparent {
    background-color: transparent;
  }

  .lg\\:bg-current {
    background-color: currentColor;
  }

  .lg\\:bg-black {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .lg\\:bg-white {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .lg\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .lg\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .lg\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .lg\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .lg\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .lg\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .lg\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .lg\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .lg\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .lg\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .lg\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .lg\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .lg\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .lg\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .lg\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .lg\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .lg\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .lg\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .lg\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .lg\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .lg\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .lg\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .lg\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .lg\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .lg\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .lg\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .lg\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .lg\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .lg\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .lg\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .lg\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .lg\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .lg\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .lg\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .lg\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .lg\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .lg\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .lg\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .lg\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .lg\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .lg\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .lg\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .lg\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .lg\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .lg\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .lg\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .lg\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .lg\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .lg\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .lg\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .lg\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .lg\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .lg\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .lg\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .lg\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .lg\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .lg\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .lg\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .lg\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .lg\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .lg\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .lg\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .lg\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .lg\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .lg\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .lg\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .lg\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .lg\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .lg\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .lg\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .lg\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .lg\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .lg\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .lg\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .lg\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .lg\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .lg\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .lg\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .lg\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .lg\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .lg\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .lg\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .lg\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .lg\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .lg\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .lg\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .lg\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .lg\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .lg\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .lg\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }

  .lg\\:hover\\:bg-current:hover {
    background-color: currentColor;
  }

  .lg\\:hover\\:bg-black:hover {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-white:hover {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-200:hover {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-300:hover {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-400:hover {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-500:hover {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-600:hover {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-700:hover {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-800:hover {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-900:hover {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-100:hover {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-200:hover {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-300:hover {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-400:hover {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-500:hover {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-600:hover {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-700:hover {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-800:hover {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-900:hover {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-100:hover {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-200:hover {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-300:hover {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-400:hover {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-500:hover {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-600:hover {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-700:hover {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-800:hover {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-900:hover {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-100:hover {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-200:hover {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-300:hover {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-400:hover {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-500:hover {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-600:hover {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-700:hover {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-800:hover {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-900:hover {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-100:hover {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-200:hover {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-300:hover {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-400:hover {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-500:hover {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-600:hover {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-700:hover {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-800:hover {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-900:hover {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-100:hover {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-200:hover {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-300:hover {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-400:hover {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-500:hover {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-600:hover {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-700:hover {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-800:hover {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-teal-900:hover {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-100:hover {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-200:hover {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-300:hover {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-400:hover {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-500:hover {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-600:hover {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-700:hover {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-800:hover {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-900:hover {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-100:hover {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-200:hover {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-300:hover {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-400:hover {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-500:hover {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-600:hover {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-700:hover {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-800:hover {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-indigo-900:hover {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-100:hover {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-200:hover {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-300:hover {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-400:hover {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-500:hover {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-600:hover {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-700:hover {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-800:hover {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-purple-900:hover {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-100:hover {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-200:hover {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-300:hover {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-400:hover {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-500:hover {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-600:hover {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-700:hover {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-800:hover {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-pink-900:hover {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-transparent:focus {
    background-color: transparent;
  }

  .lg\\:focus\\:bg-current:focus {
    background-color: currentColor;
  }

  .lg\\:focus\\:bg-black:focus {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-white:focus {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-200:focus {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-300:focus {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-400:focus {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-500:focus {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-600:focus {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-700:focus {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-800:focus {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-900:focus {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-100:focus {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-200:focus {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-300:focus {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-400:focus {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-500:focus {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-600:focus {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-700:focus {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-800:focus {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-900:focus {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-100:focus {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-200:focus {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-300:focus {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-400:focus {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-500:focus {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-600:focus {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-700:focus {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-800:focus {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-900:focus {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-100:focus {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-200:focus {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-300:focus {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-400:focus {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-500:focus {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-600:focus {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-700:focus {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-800:focus {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-900:focus {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-100:focus {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-200:focus {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-300:focus {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-400:focus {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-500:focus {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-600:focus {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-700:focus {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-800:focus {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-900:focus {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-100:focus {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-200:focus {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-300:focus {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-400:focus {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-500:focus {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-600:focus {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-700:focus {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-800:focus {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-teal-900:focus {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-100:focus {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-200:focus {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-300:focus {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-400:focus {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-500:focus {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-600:focus {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-700:focus {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-800:focus {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-900:focus {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-100:focus {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-200:focus {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-300:focus {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-400:focus {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-500:focus {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-600:focus {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-700:focus {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-800:focus {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-indigo-900:focus {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-100:focus {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-200:focus {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-300:focus {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-400:focus {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-500:focus {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-600:focus {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-700:focus {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-800:focus {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-purple-900:focus {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-100:focus {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-200:focus {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-300:focus {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-400:focus {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-500:focus {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-600:focus {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-700:focus {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-800:focus {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-pink-900:focus {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .lg\\:bg-none {
    background-image: none;
  }

  .lg\\:bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-tl {
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .lg\\:from-transparent {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:from-current {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:from-black {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:from-white {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:from-gray-100 {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .lg\\:from-gray-200 {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .lg\\:from-gray-300 {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .lg\\:from-gray-400 {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .lg\\:from-gray-500 {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .lg\\:from-gray-600 {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .lg\\:from-gray-700 {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .lg\\:from-gray-800 {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .lg\\:from-gray-900 {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .lg\\:from-red-100 {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .lg\\:from-red-200 {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .lg\\:from-red-300 {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .lg\\:from-red-400 {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .lg\\:from-red-500 {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .lg\\:from-red-600 {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .lg\\:from-red-700 {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .lg\\:from-red-800 {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .lg\\:from-red-900 {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .lg\\:from-orange-100 {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .lg\\:from-orange-200 {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .lg\\:from-orange-300 {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .lg\\:from-orange-400 {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .lg\\:from-orange-500 {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .lg\\:from-orange-600 {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .lg\\:from-orange-700 {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .lg\\:from-orange-800 {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .lg\\:from-orange-900 {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .lg\\:from-yellow-100 {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .lg\\:from-yellow-200 {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .lg\\:from-yellow-300 {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .lg\\:from-yellow-400 {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .lg\\:from-yellow-500 {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .lg\\:from-yellow-600 {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .lg\\:from-yellow-700 {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .lg\\:from-yellow-800 {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .lg\\:from-yellow-900 {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .lg\\:from-green-100 {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .lg\\:from-green-200 {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .lg\\:from-green-300 {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .lg\\:from-green-400 {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .lg\\:from-green-500 {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .lg\\:from-green-600 {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .lg\\:from-green-700 {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .lg\\:from-green-800 {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .lg\\:from-green-900 {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .lg\\:from-teal-100 {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .lg\\:from-teal-200 {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .lg\\:from-teal-300 {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .lg\\:from-teal-400 {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .lg\\:from-teal-500 {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .lg\\:from-teal-600 {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .lg\\:from-teal-700 {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .lg\\:from-teal-800 {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .lg\\:from-teal-900 {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .lg\\:from-blue-100 {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .lg\\:from-blue-200 {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .lg\\:from-blue-300 {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .lg\\:from-blue-400 {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .lg\\:from-blue-500 {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .lg\\:from-blue-600 {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .lg\\:from-blue-700 {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .lg\\:from-blue-800 {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .lg\\:from-blue-900 {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .lg\\:from-indigo-100 {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .lg\\:from-indigo-200 {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .lg\\:from-indigo-300 {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .lg\\:from-indigo-400 {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .lg\\:from-indigo-500 {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .lg\\:from-indigo-600 {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .lg\\:from-indigo-700 {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .lg\\:from-indigo-800 {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .lg\\:from-indigo-900 {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .lg\\:from-purple-100 {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .lg\\:from-purple-200 {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .lg\\:from-purple-300 {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .lg\\:from-purple-400 {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .lg\\:from-purple-500 {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .lg\\:from-purple-600 {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .lg\\:from-purple-700 {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .lg\\:from-purple-800 {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .lg\\:from-purple-900 {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .lg\\:from-pink-100 {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .lg\\:from-pink-200 {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .lg\\:from-pink-300 {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .lg\\:from-pink-400 {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .lg\\:from-pink-500 {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .lg\\:from-pink-600 {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .lg\\:from-pink-700 {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .lg\\:from-pink-800 {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .lg\\:from-pink-900 {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .lg\\:via-transparent {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:via-current {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:via-black {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:via-white {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:via-gray-100 {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .lg\\:via-gray-200 {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .lg\\:via-gray-300 {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .lg\\:via-gray-400 {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .lg\\:via-gray-500 {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .lg\\:via-gray-600 {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .lg\\:via-gray-700 {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .lg\\:via-gray-800 {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .lg\\:via-gray-900 {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .lg\\:via-red-100 {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .lg\\:via-red-200 {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .lg\\:via-red-300 {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .lg\\:via-red-400 {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .lg\\:via-red-500 {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .lg\\:via-red-600 {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .lg\\:via-red-700 {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .lg\\:via-red-800 {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .lg\\:via-red-900 {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .lg\\:via-orange-100 {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .lg\\:via-orange-200 {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .lg\\:via-orange-300 {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .lg\\:via-orange-400 {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .lg\\:via-orange-500 {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .lg\\:via-orange-600 {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .lg\\:via-orange-700 {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .lg\\:via-orange-800 {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .lg\\:via-orange-900 {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .lg\\:via-yellow-100 {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .lg\\:via-yellow-200 {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .lg\\:via-yellow-300 {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .lg\\:via-yellow-400 {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .lg\\:via-yellow-500 {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .lg\\:via-yellow-600 {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .lg\\:via-yellow-700 {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .lg\\:via-yellow-800 {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .lg\\:via-yellow-900 {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .lg\\:via-green-100 {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .lg\\:via-green-200 {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .lg\\:via-green-300 {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .lg\\:via-green-400 {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .lg\\:via-green-500 {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .lg\\:via-green-600 {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .lg\\:via-green-700 {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .lg\\:via-green-800 {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .lg\\:via-green-900 {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .lg\\:via-teal-100 {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .lg\\:via-teal-200 {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .lg\\:via-teal-300 {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .lg\\:via-teal-400 {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .lg\\:via-teal-500 {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .lg\\:via-teal-600 {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .lg\\:via-teal-700 {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .lg\\:via-teal-800 {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .lg\\:via-teal-900 {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .lg\\:via-blue-100 {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .lg\\:via-blue-200 {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .lg\\:via-blue-300 {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .lg\\:via-blue-400 {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .lg\\:via-blue-500 {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .lg\\:via-blue-600 {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .lg\\:via-blue-700 {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .lg\\:via-blue-800 {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .lg\\:via-blue-900 {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .lg\\:via-indigo-100 {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .lg\\:via-indigo-200 {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .lg\\:via-indigo-300 {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .lg\\:via-indigo-400 {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .lg\\:via-indigo-500 {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .lg\\:via-indigo-600 {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .lg\\:via-indigo-700 {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .lg\\:via-indigo-800 {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .lg\\:via-indigo-900 {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .lg\\:via-purple-100 {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .lg\\:via-purple-200 {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .lg\\:via-purple-300 {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .lg\\:via-purple-400 {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .lg\\:via-purple-500 {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .lg\\:via-purple-600 {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .lg\\:via-purple-700 {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .lg\\:via-purple-800 {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .lg\\:via-purple-900 {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .lg\\:via-pink-100 {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .lg\\:via-pink-200 {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .lg\\:via-pink-300 {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .lg\\:via-pink-400 {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .lg\\:via-pink-500 {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .lg\\:via-pink-600 {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .lg\\:via-pink-700 {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .lg\\:via-pink-800 {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .lg\\:via-pink-900 {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .lg\\:to-transparent {
    --gradient-to-color: transparent;
  }

  .lg\\:to-current {
    --gradient-to-color: currentColor;
  }

  .lg\\:to-black {
    --gradient-to-color: #000;
  }

  .lg\\:to-white {
    --gradient-to-color: #fff;
  }

  .lg\\:to-gray-100 {
    --gradient-to-color: #f7fafc;
  }

  .lg\\:to-gray-200 {
    --gradient-to-color: #edf2f7;
  }

  .lg\\:to-gray-300 {
    --gradient-to-color: #e2e8f0;
  }

  .lg\\:to-gray-400 {
    --gradient-to-color: #cbd5e0;
  }

  .lg\\:to-gray-500 {
    --gradient-to-color: #a0aec0;
  }

  .lg\\:to-gray-600 {
    --gradient-to-color: #718096;
  }

  .lg\\:to-gray-700 {
    --gradient-to-color: #4a5568;
  }

  .lg\\:to-gray-800 {
    --gradient-to-color: #2d3748;
  }

  .lg\\:to-gray-900 {
    --gradient-to-color: #1a202c;
  }

  .lg\\:to-red-100 {
    --gradient-to-color: #fff5f5;
  }

  .lg\\:to-red-200 {
    --gradient-to-color: #fed7d7;
  }

  .lg\\:to-red-300 {
    --gradient-to-color: #feb2b2;
  }

  .lg\\:to-red-400 {
    --gradient-to-color: #fc8181;
  }

  .lg\\:to-red-500 {
    --gradient-to-color: #f56565;
  }

  .lg\\:to-red-600 {
    --gradient-to-color: #e53e3e;
  }

  .lg\\:to-red-700 {
    --gradient-to-color: #c53030;
  }

  .lg\\:to-red-800 {
    --gradient-to-color: #9b2c2c;
  }

  .lg\\:to-red-900 {
    --gradient-to-color: #742a2a;
  }

  .lg\\:to-orange-100 {
    --gradient-to-color: #fffaf0;
  }

  .lg\\:to-orange-200 {
    --gradient-to-color: #feebc8;
  }

  .lg\\:to-orange-300 {
    --gradient-to-color: #fbd38d;
  }

  .lg\\:to-orange-400 {
    --gradient-to-color: #f6ad55;
  }

  .lg\\:to-orange-500 {
    --gradient-to-color: #ed8936;
  }

  .lg\\:to-orange-600 {
    --gradient-to-color: #dd6b20;
  }

  .lg\\:to-orange-700 {
    --gradient-to-color: #c05621;
  }

  .lg\\:to-orange-800 {
    --gradient-to-color: #9c4221;
  }

  .lg\\:to-orange-900 {
    --gradient-to-color: #7b341e;
  }

  .lg\\:to-yellow-100 {
    --gradient-to-color: #fffff0;
  }

  .lg\\:to-yellow-200 {
    --gradient-to-color: #fefcbf;
  }

  .lg\\:to-yellow-300 {
    --gradient-to-color: #faf089;
  }

  .lg\\:to-yellow-400 {
    --gradient-to-color: #f6e05e;
  }

  .lg\\:to-yellow-500 {
    --gradient-to-color: #ecc94b;
  }

  .lg\\:to-yellow-600 {
    --gradient-to-color: #d69e2e;
  }

  .lg\\:to-yellow-700 {
    --gradient-to-color: #b7791f;
  }

  .lg\\:to-yellow-800 {
    --gradient-to-color: #975a16;
  }

  .lg\\:to-yellow-900 {
    --gradient-to-color: #744210;
  }

  .lg\\:to-green-100 {
    --gradient-to-color: #f0fff4;
  }

  .lg\\:to-green-200 {
    --gradient-to-color: #c6f6d5;
  }

  .lg\\:to-green-300 {
    --gradient-to-color: #9ae6b4;
  }

  .lg\\:to-green-400 {
    --gradient-to-color: #68d391;
  }

  .lg\\:to-green-500 {
    --gradient-to-color: #48bb78;
  }

  .lg\\:to-green-600 {
    --gradient-to-color: #38a169;
  }

  .lg\\:to-green-700 {
    --gradient-to-color: #2f855a;
  }

  .lg\\:to-green-800 {
    --gradient-to-color: #276749;
  }

  .lg\\:to-green-900 {
    --gradient-to-color: #22543d;
  }

  .lg\\:to-teal-100 {
    --gradient-to-color: #e6fffa;
  }

  .lg\\:to-teal-200 {
    --gradient-to-color: #b2f5ea;
  }

  .lg\\:to-teal-300 {
    --gradient-to-color: #81e6d9;
  }

  .lg\\:to-teal-400 {
    --gradient-to-color: #4fd1c5;
  }

  .lg\\:to-teal-500 {
    --gradient-to-color: #38b2ac;
  }

  .lg\\:to-teal-600 {
    --gradient-to-color: #319795;
  }

  .lg\\:to-teal-700 {
    --gradient-to-color: #2c7a7b;
  }

  .lg\\:to-teal-800 {
    --gradient-to-color: #285e61;
  }

  .lg\\:to-teal-900 {
    --gradient-to-color: #234e52;
  }

  .lg\\:to-blue-100 {
    --gradient-to-color: #ebf8ff;
  }

  .lg\\:to-blue-200 {
    --gradient-to-color: #bee3f8;
  }

  .lg\\:to-blue-300 {
    --gradient-to-color: #90cdf4;
  }

  .lg\\:to-blue-400 {
    --gradient-to-color: #63b3ed;
  }

  .lg\\:to-blue-500 {
    --gradient-to-color: #4299e1;
  }

  .lg\\:to-blue-600 {
    --gradient-to-color: #3182ce;
  }

  .lg\\:to-blue-700 {
    --gradient-to-color: #2b6cb0;
  }

  .lg\\:to-blue-800 {
    --gradient-to-color: #2c5282;
  }

  .lg\\:to-blue-900 {
    --gradient-to-color: #2a4365;
  }

  .lg\\:to-indigo-100 {
    --gradient-to-color: #ebf4ff;
  }

  .lg\\:to-indigo-200 {
    --gradient-to-color: #c3dafe;
  }

  .lg\\:to-indigo-300 {
    --gradient-to-color: #a3bffa;
  }

  .lg\\:to-indigo-400 {
    --gradient-to-color: #7f9cf5;
  }

  .lg\\:to-indigo-500 {
    --gradient-to-color: #667eea;
  }

  .lg\\:to-indigo-600 {
    --gradient-to-color: #5a67d8;
  }

  .lg\\:to-indigo-700 {
    --gradient-to-color: #4c51bf;
  }

  .lg\\:to-indigo-800 {
    --gradient-to-color: #434190;
  }

  .lg\\:to-indigo-900 {
    --gradient-to-color: #3c366b;
  }

  .lg\\:to-purple-100 {
    --gradient-to-color: #faf5ff;
  }

  .lg\\:to-purple-200 {
    --gradient-to-color: #e9d8fd;
  }

  .lg\\:to-purple-300 {
    --gradient-to-color: #d6bcfa;
  }

  .lg\\:to-purple-400 {
    --gradient-to-color: #b794f4;
  }

  .lg\\:to-purple-500 {
    --gradient-to-color: #9f7aea;
  }

  .lg\\:to-purple-600 {
    --gradient-to-color: #805ad5;
  }

  .lg\\:to-purple-700 {
    --gradient-to-color: #6b46c1;
  }

  .lg\\:to-purple-800 {
    --gradient-to-color: #553c9a;
  }

  .lg\\:to-purple-900 {
    --gradient-to-color: #44337a;
  }

  .lg\\:to-pink-100 {
    --gradient-to-color: #fff5f7;
  }

  .lg\\:to-pink-200 {
    --gradient-to-color: #fed7e2;
  }

  .lg\\:to-pink-300 {
    --gradient-to-color: #fbb6ce;
  }

  .lg\\:to-pink-400 {
    --gradient-to-color: #f687b3;
  }

  .lg\\:to-pink-500 {
    --gradient-to-color: #ed64a6;
  }

  .lg\\:to-pink-600 {
    --gradient-to-color: #d53f8c;
  }

  .lg\\:to-pink-700 {
    --gradient-to-color: #b83280;
  }

  .lg\\:to-pink-800 {
    --gradient-to-color: #97266d;
  }

  .lg\\:to-pink-900 {
    --gradient-to-color: #702459;
  }

  .lg\\:hover\\:from-transparent:hover {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:hover\\:from-current:hover {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:from-black:hover {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:hover\\:from-white:hover {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:from-gray-100:hover {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .lg\\:hover\\:from-gray-200:hover {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .lg\\:hover\\:from-gray-300:hover {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .lg\\:hover\\:from-gray-400:hover {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .lg\\:hover\\:from-gray-500:hover {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .lg\\:hover\\:from-gray-600:hover {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .lg\\:hover\\:from-gray-700:hover {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .lg\\:hover\\:from-gray-800:hover {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .lg\\:hover\\:from-gray-900:hover {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .lg\\:hover\\:from-red-100:hover {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .lg\\:hover\\:from-red-200:hover {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .lg\\:hover\\:from-red-300:hover {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .lg\\:hover\\:from-red-400:hover {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .lg\\:hover\\:from-red-500:hover {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .lg\\:hover\\:from-red-600:hover {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .lg\\:hover\\:from-red-700:hover {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .lg\\:hover\\:from-red-800:hover {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .lg\\:hover\\:from-red-900:hover {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .lg\\:hover\\:from-orange-100:hover {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .lg\\:hover\\:from-orange-200:hover {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .lg\\:hover\\:from-orange-300:hover {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .lg\\:hover\\:from-orange-400:hover {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .lg\\:hover\\:from-orange-500:hover {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .lg\\:hover\\:from-orange-600:hover {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .lg\\:hover\\:from-orange-700:hover {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .lg\\:hover\\:from-orange-800:hover {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .lg\\:hover\\:from-orange-900:hover {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .lg\\:hover\\:from-yellow-100:hover {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .lg\\:hover\\:from-yellow-200:hover {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .lg\\:hover\\:from-yellow-300:hover {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .lg\\:hover\\:from-yellow-400:hover {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .lg\\:hover\\:from-yellow-500:hover {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .lg\\:hover\\:from-yellow-600:hover {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .lg\\:hover\\:from-yellow-700:hover {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .lg\\:hover\\:from-yellow-800:hover {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .lg\\:hover\\:from-yellow-900:hover {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .lg\\:hover\\:from-green-100:hover {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .lg\\:hover\\:from-green-200:hover {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .lg\\:hover\\:from-green-300:hover {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .lg\\:hover\\:from-green-400:hover {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .lg\\:hover\\:from-green-500:hover {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .lg\\:hover\\:from-green-600:hover {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .lg\\:hover\\:from-green-700:hover {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .lg\\:hover\\:from-green-800:hover {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .lg\\:hover\\:from-green-900:hover {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .lg\\:hover\\:from-teal-100:hover {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .lg\\:hover\\:from-teal-200:hover {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .lg\\:hover\\:from-teal-300:hover {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .lg\\:hover\\:from-teal-400:hover {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .lg\\:hover\\:from-teal-500:hover {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .lg\\:hover\\:from-teal-600:hover {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .lg\\:hover\\:from-teal-700:hover {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .lg\\:hover\\:from-teal-800:hover {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .lg\\:hover\\:from-teal-900:hover {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .lg\\:hover\\:from-blue-100:hover {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .lg\\:hover\\:from-blue-200:hover {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .lg\\:hover\\:from-blue-300:hover {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .lg\\:hover\\:from-blue-400:hover {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .lg\\:hover\\:from-blue-500:hover {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .lg\\:hover\\:from-blue-600:hover {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .lg\\:hover\\:from-blue-700:hover {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .lg\\:hover\\:from-blue-800:hover {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .lg\\:hover\\:from-blue-900:hover {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .lg\\:hover\\:from-indigo-100:hover {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .lg\\:hover\\:from-indigo-200:hover {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .lg\\:hover\\:from-indigo-300:hover {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .lg\\:hover\\:from-indigo-400:hover {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .lg\\:hover\\:from-indigo-500:hover {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .lg\\:hover\\:from-indigo-600:hover {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .lg\\:hover\\:from-indigo-700:hover {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .lg\\:hover\\:from-indigo-800:hover {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .lg\\:hover\\:from-indigo-900:hover {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .lg\\:hover\\:from-purple-100:hover {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .lg\\:hover\\:from-purple-200:hover {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .lg\\:hover\\:from-purple-300:hover {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .lg\\:hover\\:from-purple-400:hover {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .lg\\:hover\\:from-purple-500:hover {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .lg\\:hover\\:from-purple-600:hover {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .lg\\:hover\\:from-purple-700:hover {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .lg\\:hover\\:from-purple-800:hover {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .lg\\:hover\\:from-purple-900:hover {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .lg\\:hover\\:from-pink-100:hover {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .lg\\:hover\\:from-pink-200:hover {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .lg\\:hover\\:from-pink-300:hover {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .lg\\:hover\\:from-pink-400:hover {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .lg\\:hover\\:from-pink-500:hover {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .lg\\:hover\\:from-pink-600:hover {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .lg\\:hover\\:from-pink-700:hover {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .lg\\:hover\\:from-pink-800:hover {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .lg\\:hover\\:from-pink-900:hover {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .lg\\:hover\\:via-transparent:hover {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:hover\\:via-current:hover {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:via-black:hover {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:hover\\:via-white:hover {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:via-gray-100:hover {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .lg\\:hover\\:via-gray-200:hover {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .lg\\:hover\\:via-gray-300:hover {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .lg\\:hover\\:via-gray-400:hover {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .lg\\:hover\\:via-gray-500:hover {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .lg\\:hover\\:via-gray-600:hover {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .lg\\:hover\\:via-gray-700:hover {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .lg\\:hover\\:via-gray-800:hover {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .lg\\:hover\\:via-gray-900:hover {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .lg\\:hover\\:via-red-100:hover {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .lg\\:hover\\:via-red-200:hover {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .lg\\:hover\\:via-red-300:hover {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .lg\\:hover\\:via-red-400:hover {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .lg\\:hover\\:via-red-500:hover {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .lg\\:hover\\:via-red-600:hover {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .lg\\:hover\\:via-red-700:hover {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .lg\\:hover\\:via-red-800:hover {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .lg\\:hover\\:via-red-900:hover {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .lg\\:hover\\:via-orange-100:hover {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .lg\\:hover\\:via-orange-200:hover {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .lg\\:hover\\:via-orange-300:hover {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .lg\\:hover\\:via-orange-400:hover {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .lg\\:hover\\:via-orange-500:hover {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .lg\\:hover\\:via-orange-600:hover {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .lg\\:hover\\:via-orange-700:hover {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .lg\\:hover\\:via-orange-800:hover {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .lg\\:hover\\:via-orange-900:hover {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .lg\\:hover\\:via-yellow-100:hover {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .lg\\:hover\\:via-yellow-200:hover {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .lg\\:hover\\:via-yellow-300:hover {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .lg\\:hover\\:via-yellow-400:hover {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .lg\\:hover\\:via-yellow-500:hover {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .lg\\:hover\\:via-yellow-600:hover {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .lg\\:hover\\:via-yellow-700:hover {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .lg\\:hover\\:via-yellow-800:hover {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .lg\\:hover\\:via-yellow-900:hover {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .lg\\:hover\\:via-green-100:hover {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .lg\\:hover\\:via-green-200:hover {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .lg\\:hover\\:via-green-300:hover {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .lg\\:hover\\:via-green-400:hover {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .lg\\:hover\\:via-green-500:hover {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .lg\\:hover\\:via-green-600:hover {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .lg\\:hover\\:via-green-700:hover {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .lg\\:hover\\:via-green-800:hover {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .lg\\:hover\\:via-green-900:hover {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .lg\\:hover\\:via-teal-100:hover {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .lg\\:hover\\:via-teal-200:hover {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .lg\\:hover\\:via-teal-300:hover {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .lg\\:hover\\:via-teal-400:hover {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .lg\\:hover\\:via-teal-500:hover {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .lg\\:hover\\:via-teal-600:hover {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .lg\\:hover\\:via-teal-700:hover {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .lg\\:hover\\:via-teal-800:hover {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .lg\\:hover\\:via-teal-900:hover {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .lg\\:hover\\:via-blue-100:hover {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .lg\\:hover\\:via-blue-200:hover {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .lg\\:hover\\:via-blue-300:hover {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .lg\\:hover\\:via-blue-400:hover {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .lg\\:hover\\:via-blue-500:hover {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .lg\\:hover\\:via-blue-600:hover {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .lg\\:hover\\:via-blue-700:hover {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .lg\\:hover\\:via-blue-800:hover {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .lg\\:hover\\:via-blue-900:hover {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .lg\\:hover\\:via-indigo-100:hover {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .lg\\:hover\\:via-indigo-200:hover {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .lg\\:hover\\:via-indigo-300:hover {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .lg\\:hover\\:via-indigo-400:hover {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .lg\\:hover\\:via-indigo-500:hover {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .lg\\:hover\\:via-indigo-600:hover {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .lg\\:hover\\:via-indigo-700:hover {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .lg\\:hover\\:via-indigo-800:hover {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .lg\\:hover\\:via-indigo-900:hover {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .lg\\:hover\\:via-purple-100:hover {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .lg\\:hover\\:via-purple-200:hover {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .lg\\:hover\\:via-purple-300:hover {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .lg\\:hover\\:via-purple-400:hover {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .lg\\:hover\\:via-purple-500:hover {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .lg\\:hover\\:via-purple-600:hover {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .lg\\:hover\\:via-purple-700:hover {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .lg\\:hover\\:via-purple-800:hover {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .lg\\:hover\\:via-purple-900:hover {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .lg\\:hover\\:via-pink-100:hover {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .lg\\:hover\\:via-pink-200:hover {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .lg\\:hover\\:via-pink-300:hover {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .lg\\:hover\\:via-pink-400:hover {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .lg\\:hover\\:via-pink-500:hover {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .lg\\:hover\\:via-pink-600:hover {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .lg\\:hover\\:via-pink-700:hover {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .lg\\:hover\\:via-pink-800:hover {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .lg\\:hover\\:via-pink-900:hover {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .lg\\:hover\\:to-transparent:hover {
    --gradient-to-color: transparent;
  }

  .lg\\:hover\\:to-current:hover {
    --gradient-to-color: currentColor;
  }

  .lg\\:hover\\:to-black:hover {
    --gradient-to-color: #000;
  }

  .lg\\:hover\\:to-white:hover {
    --gradient-to-color: #fff;
  }

  .lg\\:hover\\:to-gray-100:hover {
    --gradient-to-color: #f7fafc;
  }

  .lg\\:hover\\:to-gray-200:hover {
    --gradient-to-color: #edf2f7;
  }

  .lg\\:hover\\:to-gray-300:hover {
    --gradient-to-color: #e2e8f0;
  }

  .lg\\:hover\\:to-gray-400:hover {
    --gradient-to-color: #cbd5e0;
  }

  .lg\\:hover\\:to-gray-500:hover {
    --gradient-to-color: #a0aec0;
  }

  .lg\\:hover\\:to-gray-600:hover {
    --gradient-to-color: #718096;
  }

  .lg\\:hover\\:to-gray-700:hover {
    --gradient-to-color: #4a5568;
  }

  .lg\\:hover\\:to-gray-800:hover {
    --gradient-to-color: #2d3748;
  }

  .lg\\:hover\\:to-gray-900:hover {
    --gradient-to-color: #1a202c;
  }

  .lg\\:hover\\:to-red-100:hover {
    --gradient-to-color: #fff5f5;
  }

  .lg\\:hover\\:to-red-200:hover {
    --gradient-to-color: #fed7d7;
  }

  .lg\\:hover\\:to-red-300:hover {
    --gradient-to-color: #feb2b2;
  }

  .lg\\:hover\\:to-red-400:hover {
    --gradient-to-color: #fc8181;
  }

  .lg\\:hover\\:to-red-500:hover {
    --gradient-to-color: #f56565;
  }

  .lg\\:hover\\:to-red-600:hover {
    --gradient-to-color: #e53e3e;
  }

  .lg\\:hover\\:to-red-700:hover {
    --gradient-to-color: #c53030;
  }

  .lg\\:hover\\:to-red-800:hover {
    --gradient-to-color: #9b2c2c;
  }

  .lg\\:hover\\:to-red-900:hover {
    --gradient-to-color: #742a2a;
  }

  .lg\\:hover\\:to-orange-100:hover {
    --gradient-to-color: #fffaf0;
  }

  .lg\\:hover\\:to-orange-200:hover {
    --gradient-to-color: #feebc8;
  }

  .lg\\:hover\\:to-orange-300:hover {
    --gradient-to-color: #fbd38d;
  }

  .lg\\:hover\\:to-orange-400:hover {
    --gradient-to-color: #f6ad55;
  }

  .lg\\:hover\\:to-orange-500:hover {
    --gradient-to-color: #ed8936;
  }

  .lg\\:hover\\:to-orange-600:hover {
    --gradient-to-color: #dd6b20;
  }

  .lg\\:hover\\:to-orange-700:hover {
    --gradient-to-color: #c05621;
  }

  .lg\\:hover\\:to-orange-800:hover {
    --gradient-to-color: #9c4221;
  }

  .lg\\:hover\\:to-orange-900:hover {
    --gradient-to-color: #7b341e;
  }

  .lg\\:hover\\:to-yellow-100:hover {
    --gradient-to-color: #fffff0;
  }

  .lg\\:hover\\:to-yellow-200:hover {
    --gradient-to-color: #fefcbf;
  }

  .lg\\:hover\\:to-yellow-300:hover {
    --gradient-to-color: #faf089;
  }

  .lg\\:hover\\:to-yellow-400:hover {
    --gradient-to-color: #f6e05e;
  }

  .lg\\:hover\\:to-yellow-500:hover {
    --gradient-to-color: #ecc94b;
  }

  .lg\\:hover\\:to-yellow-600:hover {
    --gradient-to-color: #d69e2e;
  }

  .lg\\:hover\\:to-yellow-700:hover {
    --gradient-to-color: #b7791f;
  }

  .lg\\:hover\\:to-yellow-800:hover {
    --gradient-to-color: #975a16;
  }

  .lg\\:hover\\:to-yellow-900:hover {
    --gradient-to-color: #744210;
  }

  .lg\\:hover\\:to-green-100:hover {
    --gradient-to-color: #f0fff4;
  }

  .lg\\:hover\\:to-green-200:hover {
    --gradient-to-color: #c6f6d5;
  }

  .lg\\:hover\\:to-green-300:hover {
    --gradient-to-color: #9ae6b4;
  }

  .lg\\:hover\\:to-green-400:hover {
    --gradient-to-color: #68d391;
  }

  .lg\\:hover\\:to-green-500:hover {
    --gradient-to-color: #48bb78;
  }

  .lg\\:hover\\:to-green-600:hover {
    --gradient-to-color: #38a169;
  }

  .lg\\:hover\\:to-green-700:hover {
    --gradient-to-color: #2f855a;
  }

  .lg\\:hover\\:to-green-800:hover {
    --gradient-to-color: #276749;
  }

  .lg\\:hover\\:to-green-900:hover {
    --gradient-to-color: #22543d;
  }

  .lg\\:hover\\:to-teal-100:hover {
    --gradient-to-color: #e6fffa;
  }

  .lg\\:hover\\:to-teal-200:hover {
    --gradient-to-color: #b2f5ea;
  }

  .lg\\:hover\\:to-teal-300:hover {
    --gradient-to-color: #81e6d9;
  }

  .lg\\:hover\\:to-teal-400:hover {
    --gradient-to-color: #4fd1c5;
  }

  .lg\\:hover\\:to-teal-500:hover {
    --gradient-to-color: #38b2ac;
  }

  .lg\\:hover\\:to-teal-600:hover {
    --gradient-to-color: #319795;
  }

  .lg\\:hover\\:to-teal-700:hover {
    --gradient-to-color: #2c7a7b;
  }

  .lg\\:hover\\:to-teal-800:hover {
    --gradient-to-color: #285e61;
  }

  .lg\\:hover\\:to-teal-900:hover {
    --gradient-to-color: #234e52;
  }

  .lg\\:hover\\:to-blue-100:hover {
    --gradient-to-color: #ebf8ff;
  }

  .lg\\:hover\\:to-blue-200:hover {
    --gradient-to-color: #bee3f8;
  }

  .lg\\:hover\\:to-blue-300:hover {
    --gradient-to-color: #90cdf4;
  }

  .lg\\:hover\\:to-blue-400:hover {
    --gradient-to-color: #63b3ed;
  }

  .lg\\:hover\\:to-blue-500:hover {
    --gradient-to-color: #4299e1;
  }

  .lg\\:hover\\:to-blue-600:hover {
    --gradient-to-color: #3182ce;
  }

  .lg\\:hover\\:to-blue-700:hover {
    --gradient-to-color: #2b6cb0;
  }

  .lg\\:hover\\:to-blue-800:hover {
    --gradient-to-color: #2c5282;
  }

  .lg\\:hover\\:to-blue-900:hover {
    --gradient-to-color: #2a4365;
  }

  .lg\\:hover\\:to-indigo-100:hover {
    --gradient-to-color: #ebf4ff;
  }

  .lg\\:hover\\:to-indigo-200:hover {
    --gradient-to-color: #c3dafe;
  }

  .lg\\:hover\\:to-indigo-300:hover {
    --gradient-to-color: #a3bffa;
  }

  .lg\\:hover\\:to-indigo-400:hover {
    --gradient-to-color: #7f9cf5;
  }

  .lg\\:hover\\:to-indigo-500:hover {
    --gradient-to-color: #667eea;
  }

  .lg\\:hover\\:to-indigo-600:hover {
    --gradient-to-color: #5a67d8;
  }

  .lg\\:hover\\:to-indigo-700:hover {
    --gradient-to-color: #4c51bf;
  }

  .lg\\:hover\\:to-indigo-800:hover {
    --gradient-to-color: #434190;
  }

  .lg\\:hover\\:to-indigo-900:hover {
    --gradient-to-color: #3c366b;
  }

  .lg\\:hover\\:to-purple-100:hover {
    --gradient-to-color: #faf5ff;
  }

  .lg\\:hover\\:to-purple-200:hover {
    --gradient-to-color: #e9d8fd;
  }

  .lg\\:hover\\:to-purple-300:hover {
    --gradient-to-color: #d6bcfa;
  }

  .lg\\:hover\\:to-purple-400:hover {
    --gradient-to-color: #b794f4;
  }

  .lg\\:hover\\:to-purple-500:hover {
    --gradient-to-color: #9f7aea;
  }

  .lg\\:hover\\:to-purple-600:hover {
    --gradient-to-color: #805ad5;
  }

  .lg\\:hover\\:to-purple-700:hover {
    --gradient-to-color: #6b46c1;
  }

  .lg\\:hover\\:to-purple-800:hover {
    --gradient-to-color: #553c9a;
  }

  .lg\\:hover\\:to-purple-900:hover {
    --gradient-to-color: #44337a;
  }

  .lg\\:hover\\:to-pink-100:hover {
    --gradient-to-color: #fff5f7;
  }

  .lg\\:hover\\:to-pink-200:hover {
    --gradient-to-color: #fed7e2;
  }

  .lg\\:hover\\:to-pink-300:hover {
    --gradient-to-color: #fbb6ce;
  }

  .lg\\:hover\\:to-pink-400:hover {
    --gradient-to-color: #f687b3;
  }

  .lg\\:hover\\:to-pink-500:hover {
    --gradient-to-color: #ed64a6;
  }

  .lg\\:hover\\:to-pink-600:hover {
    --gradient-to-color: #d53f8c;
  }

  .lg\\:hover\\:to-pink-700:hover {
    --gradient-to-color: #b83280;
  }

  .lg\\:hover\\:to-pink-800:hover {
    --gradient-to-color: #97266d;
  }

  .lg\\:hover\\:to-pink-900:hover {
    --gradient-to-color: #702459;
  }

  .lg\\:focus\\:from-transparent:focus {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:focus\\:from-current:focus {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:from-black:focus {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:focus\\:from-white:focus {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:from-gray-100:focus {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .lg\\:focus\\:from-gray-200:focus {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .lg\\:focus\\:from-gray-300:focus {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .lg\\:focus\\:from-gray-400:focus {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .lg\\:focus\\:from-gray-500:focus {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .lg\\:focus\\:from-gray-600:focus {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .lg\\:focus\\:from-gray-700:focus {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .lg\\:focus\\:from-gray-800:focus {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .lg\\:focus\\:from-gray-900:focus {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .lg\\:focus\\:from-red-100:focus {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .lg\\:focus\\:from-red-200:focus {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .lg\\:focus\\:from-red-300:focus {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .lg\\:focus\\:from-red-400:focus {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .lg\\:focus\\:from-red-500:focus {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .lg\\:focus\\:from-red-600:focus {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .lg\\:focus\\:from-red-700:focus {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .lg\\:focus\\:from-red-800:focus {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .lg\\:focus\\:from-red-900:focus {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .lg\\:focus\\:from-orange-100:focus {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .lg\\:focus\\:from-orange-200:focus {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .lg\\:focus\\:from-orange-300:focus {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .lg\\:focus\\:from-orange-400:focus {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .lg\\:focus\\:from-orange-500:focus {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .lg\\:focus\\:from-orange-600:focus {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .lg\\:focus\\:from-orange-700:focus {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .lg\\:focus\\:from-orange-800:focus {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .lg\\:focus\\:from-orange-900:focus {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .lg\\:focus\\:from-yellow-100:focus {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .lg\\:focus\\:from-yellow-200:focus {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .lg\\:focus\\:from-yellow-300:focus {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .lg\\:focus\\:from-yellow-400:focus {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .lg\\:focus\\:from-yellow-500:focus {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .lg\\:focus\\:from-yellow-600:focus {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .lg\\:focus\\:from-yellow-700:focus {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .lg\\:focus\\:from-yellow-800:focus {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .lg\\:focus\\:from-yellow-900:focus {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .lg\\:focus\\:from-green-100:focus {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .lg\\:focus\\:from-green-200:focus {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .lg\\:focus\\:from-green-300:focus {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .lg\\:focus\\:from-green-400:focus {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .lg\\:focus\\:from-green-500:focus {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .lg\\:focus\\:from-green-600:focus {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .lg\\:focus\\:from-green-700:focus {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .lg\\:focus\\:from-green-800:focus {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .lg\\:focus\\:from-green-900:focus {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .lg\\:focus\\:from-teal-100:focus {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .lg\\:focus\\:from-teal-200:focus {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .lg\\:focus\\:from-teal-300:focus {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .lg\\:focus\\:from-teal-400:focus {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .lg\\:focus\\:from-teal-500:focus {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .lg\\:focus\\:from-teal-600:focus {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .lg\\:focus\\:from-teal-700:focus {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .lg\\:focus\\:from-teal-800:focus {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .lg\\:focus\\:from-teal-900:focus {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .lg\\:focus\\:from-blue-100:focus {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .lg\\:focus\\:from-blue-200:focus {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .lg\\:focus\\:from-blue-300:focus {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .lg\\:focus\\:from-blue-400:focus {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .lg\\:focus\\:from-blue-500:focus {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .lg\\:focus\\:from-blue-600:focus {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .lg\\:focus\\:from-blue-700:focus {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .lg\\:focus\\:from-blue-800:focus {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .lg\\:focus\\:from-blue-900:focus {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .lg\\:focus\\:from-indigo-100:focus {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .lg\\:focus\\:from-indigo-200:focus {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .lg\\:focus\\:from-indigo-300:focus {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .lg\\:focus\\:from-indigo-400:focus {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .lg\\:focus\\:from-indigo-500:focus {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .lg\\:focus\\:from-indigo-600:focus {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .lg\\:focus\\:from-indigo-700:focus {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .lg\\:focus\\:from-indigo-800:focus {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .lg\\:focus\\:from-indigo-900:focus {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .lg\\:focus\\:from-purple-100:focus {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .lg\\:focus\\:from-purple-200:focus {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .lg\\:focus\\:from-purple-300:focus {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .lg\\:focus\\:from-purple-400:focus {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .lg\\:focus\\:from-purple-500:focus {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .lg\\:focus\\:from-purple-600:focus {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .lg\\:focus\\:from-purple-700:focus {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .lg\\:focus\\:from-purple-800:focus {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .lg\\:focus\\:from-purple-900:focus {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .lg\\:focus\\:from-pink-100:focus {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .lg\\:focus\\:from-pink-200:focus {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .lg\\:focus\\:from-pink-300:focus {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .lg\\:focus\\:from-pink-400:focus {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .lg\\:focus\\:from-pink-500:focus {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .lg\\:focus\\:from-pink-600:focus {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .lg\\:focus\\:from-pink-700:focus {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .lg\\:focus\\:from-pink-800:focus {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .lg\\:focus\\:from-pink-900:focus {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .lg\\:focus\\:via-transparent:focus {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:focus\\:via-current:focus {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:via-black:focus {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:focus\\:via-white:focus {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:via-gray-100:focus {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .lg\\:focus\\:via-gray-200:focus {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .lg\\:focus\\:via-gray-300:focus {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .lg\\:focus\\:via-gray-400:focus {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .lg\\:focus\\:via-gray-500:focus {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .lg\\:focus\\:via-gray-600:focus {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .lg\\:focus\\:via-gray-700:focus {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .lg\\:focus\\:via-gray-800:focus {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .lg\\:focus\\:via-gray-900:focus {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .lg\\:focus\\:via-red-100:focus {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .lg\\:focus\\:via-red-200:focus {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .lg\\:focus\\:via-red-300:focus {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .lg\\:focus\\:via-red-400:focus {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .lg\\:focus\\:via-red-500:focus {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .lg\\:focus\\:via-red-600:focus {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .lg\\:focus\\:via-red-700:focus {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .lg\\:focus\\:via-red-800:focus {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .lg\\:focus\\:via-red-900:focus {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .lg\\:focus\\:via-orange-100:focus {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .lg\\:focus\\:via-orange-200:focus {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .lg\\:focus\\:via-orange-300:focus {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .lg\\:focus\\:via-orange-400:focus {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .lg\\:focus\\:via-orange-500:focus {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .lg\\:focus\\:via-orange-600:focus {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .lg\\:focus\\:via-orange-700:focus {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .lg\\:focus\\:via-orange-800:focus {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .lg\\:focus\\:via-orange-900:focus {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .lg\\:focus\\:via-yellow-100:focus {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .lg\\:focus\\:via-yellow-200:focus {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .lg\\:focus\\:via-yellow-300:focus {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .lg\\:focus\\:via-yellow-400:focus {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .lg\\:focus\\:via-yellow-500:focus {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .lg\\:focus\\:via-yellow-600:focus {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .lg\\:focus\\:via-yellow-700:focus {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .lg\\:focus\\:via-yellow-800:focus {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .lg\\:focus\\:via-yellow-900:focus {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .lg\\:focus\\:via-green-100:focus {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .lg\\:focus\\:via-green-200:focus {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .lg\\:focus\\:via-green-300:focus {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .lg\\:focus\\:via-green-400:focus {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .lg\\:focus\\:via-green-500:focus {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .lg\\:focus\\:via-green-600:focus {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .lg\\:focus\\:via-green-700:focus {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .lg\\:focus\\:via-green-800:focus {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .lg\\:focus\\:via-green-900:focus {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .lg\\:focus\\:via-teal-100:focus {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .lg\\:focus\\:via-teal-200:focus {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .lg\\:focus\\:via-teal-300:focus {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .lg\\:focus\\:via-teal-400:focus {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .lg\\:focus\\:via-teal-500:focus {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .lg\\:focus\\:via-teal-600:focus {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .lg\\:focus\\:via-teal-700:focus {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .lg\\:focus\\:via-teal-800:focus {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .lg\\:focus\\:via-teal-900:focus {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .lg\\:focus\\:via-blue-100:focus {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .lg\\:focus\\:via-blue-200:focus {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .lg\\:focus\\:via-blue-300:focus {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .lg\\:focus\\:via-blue-400:focus {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .lg\\:focus\\:via-blue-500:focus {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .lg\\:focus\\:via-blue-600:focus {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .lg\\:focus\\:via-blue-700:focus {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .lg\\:focus\\:via-blue-800:focus {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .lg\\:focus\\:via-blue-900:focus {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .lg\\:focus\\:via-indigo-100:focus {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .lg\\:focus\\:via-indigo-200:focus {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .lg\\:focus\\:via-indigo-300:focus {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .lg\\:focus\\:via-indigo-400:focus {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .lg\\:focus\\:via-indigo-500:focus {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .lg\\:focus\\:via-indigo-600:focus {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .lg\\:focus\\:via-indigo-700:focus {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .lg\\:focus\\:via-indigo-800:focus {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .lg\\:focus\\:via-indigo-900:focus {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .lg\\:focus\\:via-purple-100:focus {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .lg\\:focus\\:via-purple-200:focus {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .lg\\:focus\\:via-purple-300:focus {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .lg\\:focus\\:via-purple-400:focus {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .lg\\:focus\\:via-purple-500:focus {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .lg\\:focus\\:via-purple-600:focus {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .lg\\:focus\\:via-purple-700:focus {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .lg\\:focus\\:via-purple-800:focus {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .lg\\:focus\\:via-purple-900:focus {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .lg\\:focus\\:via-pink-100:focus {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .lg\\:focus\\:via-pink-200:focus {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .lg\\:focus\\:via-pink-300:focus {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .lg\\:focus\\:via-pink-400:focus {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .lg\\:focus\\:via-pink-500:focus {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .lg\\:focus\\:via-pink-600:focus {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .lg\\:focus\\:via-pink-700:focus {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .lg\\:focus\\:via-pink-800:focus {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .lg\\:focus\\:via-pink-900:focus {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .lg\\:focus\\:to-transparent:focus {
    --gradient-to-color: transparent;
  }

  .lg\\:focus\\:to-current:focus {
    --gradient-to-color: currentColor;
  }

  .lg\\:focus\\:to-black:focus {
    --gradient-to-color: #000;
  }

  .lg\\:focus\\:to-white:focus {
    --gradient-to-color: #fff;
  }

  .lg\\:focus\\:to-gray-100:focus {
    --gradient-to-color: #f7fafc;
  }

  .lg\\:focus\\:to-gray-200:focus {
    --gradient-to-color: #edf2f7;
  }

  .lg\\:focus\\:to-gray-300:focus {
    --gradient-to-color: #e2e8f0;
  }

  .lg\\:focus\\:to-gray-400:focus {
    --gradient-to-color: #cbd5e0;
  }

  .lg\\:focus\\:to-gray-500:focus {
    --gradient-to-color: #a0aec0;
  }

  .lg\\:focus\\:to-gray-600:focus {
    --gradient-to-color: #718096;
  }

  .lg\\:focus\\:to-gray-700:focus {
    --gradient-to-color: #4a5568;
  }

  .lg\\:focus\\:to-gray-800:focus {
    --gradient-to-color: #2d3748;
  }

  .lg\\:focus\\:to-gray-900:focus {
    --gradient-to-color: #1a202c;
  }

  .lg\\:focus\\:to-red-100:focus {
    --gradient-to-color: #fff5f5;
  }

  .lg\\:focus\\:to-red-200:focus {
    --gradient-to-color: #fed7d7;
  }

  .lg\\:focus\\:to-red-300:focus {
    --gradient-to-color: #feb2b2;
  }

  .lg\\:focus\\:to-red-400:focus {
    --gradient-to-color: #fc8181;
  }

  .lg\\:focus\\:to-red-500:focus {
    --gradient-to-color: #f56565;
  }

  .lg\\:focus\\:to-red-600:focus {
    --gradient-to-color: #e53e3e;
  }

  .lg\\:focus\\:to-red-700:focus {
    --gradient-to-color: #c53030;
  }

  .lg\\:focus\\:to-red-800:focus {
    --gradient-to-color: #9b2c2c;
  }

  .lg\\:focus\\:to-red-900:focus {
    --gradient-to-color: #742a2a;
  }

  .lg\\:focus\\:to-orange-100:focus {
    --gradient-to-color: #fffaf0;
  }

  .lg\\:focus\\:to-orange-200:focus {
    --gradient-to-color: #feebc8;
  }

  .lg\\:focus\\:to-orange-300:focus {
    --gradient-to-color: #fbd38d;
  }

  .lg\\:focus\\:to-orange-400:focus {
    --gradient-to-color: #f6ad55;
  }

  .lg\\:focus\\:to-orange-500:focus {
    --gradient-to-color: #ed8936;
  }

  .lg\\:focus\\:to-orange-600:focus {
    --gradient-to-color: #dd6b20;
  }

  .lg\\:focus\\:to-orange-700:focus {
    --gradient-to-color: #c05621;
  }

  .lg\\:focus\\:to-orange-800:focus {
    --gradient-to-color: #9c4221;
  }

  .lg\\:focus\\:to-orange-900:focus {
    --gradient-to-color: #7b341e;
  }

  .lg\\:focus\\:to-yellow-100:focus {
    --gradient-to-color: #fffff0;
  }

  .lg\\:focus\\:to-yellow-200:focus {
    --gradient-to-color: #fefcbf;
  }

  .lg\\:focus\\:to-yellow-300:focus {
    --gradient-to-color: #faf089;
  }

  .lg\\:focus\\:to-yellow-400:focus {
    --gradient-to-color: #f6e05e;
  }

  .lg\\:focus\\:to-yellow-500:focus {
    --gradient-to-color: #ecc94b;
  }

  .lg\\:focus\\:to-yellow-600:focus {
    --gradient-to-color: #d69e2e;
  }

  .lg\\:focus\\:to-yellow-700:focus {
    --gradient-to-color: #b7791f;
  }

  .lg\\:focus\\:to-yellow-800:focus {
    --gradient-to-color: #975a16;
  }

  .lg\\:focus\\:to-yellow-900:focus {
    --gradient-to-color: #744210;
  }

  .lg\\:focus\\:to-green-100:focus {
    --gradient-to-color: #f0fff4;
  }

  .lg\\:focus\\:to-green-200:focus {
    --gradient-to-color: #c6f6d5;
  }

  .lg\\:focus\\:to-green-300:focus {
    --gradient-to-color: #9ae6b4;
  }

  .lg\\:focus\\:to-green-400:focus {
    --gradient-to-color: #68d391;
  }

  .lg\\:focus\\:to-green-500:focus {
    --gradient-to-color: #48bb78;
  }

  .lg\\:focus\\:to-green-600:focus {
    --gradient-to-color: #38a169;
  }

  .lg\\:focus\\:to-green-700:focus {
    --gradient-to-color: #2f855a;
  }

  .lg\\:focus\\:to-green-800:focus {
    --gradient-to-color: #276749;
  }

  .lg\\:focus\\:to-green-900:focus {
    --gradient-to-color: #22543d;
  }

  .lg\\:focus\\:to-teal-100:focus {
    --gradient-to-color: #e6fffa;
  }

  .lg\\:focus\\:to-teal-200:focus {
    --gradient-to-color: #b2f5ea;
  }

  .lg\\:focus\\:to-teal-300:focus {
    --gradient-to-color: #81e6d9;
  }

  .lg\\:focus\\:to-teal-400:focus {
    --gradient-to-color: #4fd1c5;
  }

  .lg\\:focus\\:to-teal-500:focus {
    --gradient-to-color: #38b2ac;
  }

  .lg\\:focus\\:to-teal-600:focus {
    --gradient-to-color: #319795;
  }

  .lg\\:focus\\:to-teal-700:focus {
    --gradient-to-color: #2c7a7b;
  }

  .lg\\:focus\\:to-teal-800:focus {
    --gradient-to-color: #285e61;
  }

  .lg\\:focus\\:to-teal-900:focus {
    --gradient-to-color: #234e52;
  }

  .lg\\:focus\\:to-blue-100:focus {
    --gradient-to-color: #ebf8ff;
  }

  .lg\\:focus\\:to-blue-200:focus {
    --gradient-to-color: #bee3f8;
  }

  .lg\\:focus\\:to-blue-300:focus {
    --gradient-to-color: #90cdf4;
  }

  .lg\\:focus\\:to-blue-400:focus {
    --gradient-to-color: #63b3ed;
  }

  .lg\\:focus\\:to-blue-500:focus {
    --gradient-to-color: #4299e1;
  }

  .lg\\:focus\\:to-blue-600:focus {
    --gradient-to-color: #3182ce;
  }

  .lg\\:focus\\:to-blue-700:focus {
    --gradient-to-color: #2b6cb0;
  }

  .lg\\:focus\\:to-blue-800:focus {
    --gradient-to-color: #2c5282;
  }

  .lg\\:focus\\:to-blue-900:focus {
    --gradient-to-color: #2a4365;
  }

  .lg\\:focus\\:to-indigo-100:focus {
    --gradient-to-color: #ebf4ff;
  }

  .lg\\:focus\\:to-indigo-200:focus {
    --gradient-to-color: #c3dafe;
  }

  .lg\\:focus\\:to-indigo-300:focus {
    --gradient-to-color: #a3bffa;
  }

  .lg\\:focus\\:to-indigo-400:focus {
    --gradient-to-color: #7f9cf5;
  }

  .lg\\:focus\\:to-indigo-500:focus {
    --gradient-to-color: #667eea;
  }

  .lg\\:focus\\:to-indigo-600:focus {
    --gradient-to-color: #5a67d8;
  }

  .lg\\:focus\\:to-indigo-700:focus {
    --gradient-to-color: #4c51bf;
  }

  .lg\\:focus\\:to-indigo-800:focus {
    --gradient-to-color: #434190;
  }

  .lg\\:focus\\:to-indigo-900:focus {
    --gradient-to-color: #3c366b;
  }

  .lg\\:focus\\:to-purple-100:focus {
    --gradient-to-color: #faf5ff;
  }

  .lg\\:focus\\:to-purple-200:focus {
    --gradient-to-color: #e9d8fd;
  }

  .lg\\:focus\\:to-purple-300:focus {
    --gradient-to-color: #d6bcfa;
  }

  .lg\\:focus\\:to-purple-400:focus {
    --gradient-to-color: #b794f4;
  }

  .lg\\:focus\\:to-purple-500:focus {
    --gradient-to-color: #9f7aea;
  }

  .lg\\:focus\\:to-purple-600:focus {
    --gradient-to-color: #805ad5;
  }

  .lg\\:focus\\:to-purple-700:focus {
    --gradient-to-color: #6b46c1;
  }

  .lg\\:focus\\:to-purple-800:focus {
    --gradient-to-color: #553c9a;
  }

  .lg\\:focus\\:to-purple-900:focus {
    --gradient-to-color: #44337a;
  }

  .lg\\:focus\\:to-pink-100:focus {
    --gradient-to-color: #fff5f7;
  }

  .lg\\:focus\\:to-pink-200:focus {
    --gradient-to-color: #fed7e2;
  }

  .lg\\:focus\\:to-pink-300:focus {
    --gradient-to-color: #fbb6ce;
  }

  .lg\\:focus\\:to-pink-400:focus {
    --gradient-to-color: #f687b3;
  }

  .lg\\:focus\\:to-pink-500:focus {
    --gradient-to-color: #ed64a6;
  }

  .lg\\:focus\\:to-pink-600:focus {
    --gradient-to-color: #d53f8c;
  }

  .lg\\:focus\\:to-pink-700:focus {
    --gradient-to-color: #b83280;
  }

  .lg\\:focus\\:to-pink-800:focus {
    --gradient-to-color: #97266d;
  }

  .lg\\:focus\\:to-pink-900:focus {
    --gradient-to-color: #702459;
  }

  .lg\\:bg-opacity-0 {
    --bg-opacity: 0;
  }

  .lg\\:bg-opacity-25 {
    --bg-opacity: 0.25;
  }

  .lg\\:bg-opacity-50 {
    --bg-opacity: 0.5;
  }

  .lg\\:bg-opacity-75 {
    --bg-opacity: 0.75;
  }

  .lg\\:bg-opacity-100 {
    --bg-opacity: 1;
  }

  .lg\\:hover\\:bg-opacity-0:hover {
    --bg-opacity: 0;
  }

  .lg\\:hover\\:bg-opacity-25:hover {
    --bg-opacity: 0.25;
  }

  .lg\\:hover\\:bg-opacity-50:hover {
    --bg-opacity: 0.5;
  }

  .lg\\:hover\\:bg-opacity-75:hover {
    --bg-opacity: 0.75;
  }

  .lg\\:hover\\:bg-opacity-100:hover {
    --bg-opacity: 1;
  }

  .lg\\:focus\\:bg-opacity-0:focus {
    --bg-opacity: 0;
  }

  .lg\\:focus\\:bg-opacity-25:focus {
    --bg-opacity: 0.25;
  }

  .lg\\:focus\\:bg-opacity-50:focus {
    --bg-opacity: 0.5;
  }

  .lg\\:focus\\:bg-opacity-75:focus {
    --bg-opacity: 0.75;
  }

  .lg\\:focus\\:bg-opacity-100:focus {
    --bg-opacity: 1;
  }

  .lg\\:bg-bottom {
    background-position: bottom;
  }

  .lg\\:bg-center {
    background-position: center;
  }

  .lg\\:bg-left {
    background-position: left;
  }

  .lg\\:bg-left-bottom {
    background-position: left bottom;
  }

  .lg\\:bg-left-top {
    background-position: left top;
  }

  .lg\\:bg-right {
    background-position: right;
  }

  .lg\\:bg-right-bottom {
    background-position: right bottom;
  }

  .lg\\:bg-right-top {
    background-position: right top;
  }

  .lg\\:bg-top {
    background-position: top;
  }

  .lg\\:bg-repeat {
    background-repeat: repeat;
  }

  .lg\\:bg-no-repeat {
    background-repeat: no-repeat;
  }

  .lg\\:bg-repeat-x {
    background-repeat: repeat-x;
  }

  .lg\\:bg-repeat-y {
    background-repeat: repeat-y;
  }

  .lg\\:bg-repeat-round {
    background-repeat: round;
  }

  .lg\\:bg-repeat-space {
    background-repeat: space;
  }

  .lg\\:bg-auto {
    background-size: auto;
  }

  .lg\\:bg-cover {
    background-size: cover;
  }

  .lg\\:bg-contain {
    background-size: contain;
  }

  .lg\\:border-collapse {
    border-collapse: collapse;
  }

  .lg\\:border-separate {
    border-collapse: separate;
  }

  .lg\\:border-transparent {
    border-color: transparent;
  }

  .lg\\:border-current {
    border-color: currentColor;
  }

  .lg\\:border-black {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .lg\\:border-white {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .lg\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .lg\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .lg\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .lg\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .lg\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .lg\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .lg\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .lg\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .lg\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .lg\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .lg\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .lg\\:border-red-300 {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .lg\\:border-red-400 {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .lg\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .lg\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .lg\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .lg\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .lg\\:border-red-900 {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .lg\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .lg\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .lg\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .lg\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .lg\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .lg\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .lg\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .lg\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .lg\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .lg\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .lg\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .lg\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .lg\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .lg\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .lg\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .lg\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .lg\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .lg\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .lg\\:border-green-100 {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .lg\\:border-green-200 {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .lg\\:border-green-300 {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .lg\\:border-green-400 {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .lg\\:border-green-500 {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .lg\\:border-green-600 {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .lg\\:border-green-700 {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .lg\\:border-green-800 {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .lg\\:border-green-900 {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .lg\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .lg\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .lg\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .lg\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .lg\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .lg\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .lg\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .lg\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .lg\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .lg\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .lg\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .lg\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .lg\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .lg\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .lg\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .lg\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .lg\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .lg\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .lg\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .lg\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .lg\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .lg\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .lg\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .lg\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .lg\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .lg\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .lg\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .lg\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .lg\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .lg\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .lg\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .lg\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .lg\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .lg\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .lg\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .lg\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .lg\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .lg\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .lg\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .lg\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .lg\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .lg\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .lg\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .lg\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .lg\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .lg\\:hover\\:border-transparent:hover {
    border-color: transparent;
  }

  .lg\\:hover\\:border-current:hover {
    border-color: currentColor;
  }

  .lg\\:hover\\:border-black:hover {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .lg\\:hover\\:border-white:hover {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-100:hover {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-200:hover {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-300:hover {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-400:hover {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-500:hover {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-600:hover {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-700:hover {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-800:hover {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-900:hover {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-100:hover {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-200:hover {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-300:hover {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-400:hover {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-500:hover {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-600:hover {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-700:hover {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-800:hover {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-900:hover {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-100:hover {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-200:hover {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-300:hover {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-400:hover {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-500:hover {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-600:hover {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-700:hover {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-800:hover {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-900:hover {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-100:hover {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-200:hover {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-300:hover {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-400:hover {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-500:hover {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-600:hover {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-700:hover {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-800:hover {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-900:hover {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-100:hover {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-200:hover {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-300:hover {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-400:hover {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-500:hover {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-600:hover {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-700:hover {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-800:hover {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-900:hover {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-100:hover {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-200:hover {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-300:hover {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-400:hover {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-500:hover {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-600:hover {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-700:hover {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-800:hover {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .lg\\:hover\\:border-teal-900:hover {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-100:hover {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-200:hover {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-300:hover {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-400:hover {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-500:hover {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-600:hover {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-700:hover {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-800:hover {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-900:hover {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-100:hover {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-200:hover {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-300:hover {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-400:hover {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-500:hover {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-600:hover {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-700:hover {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-800:hover {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .lg\\:hover\\:border-indigo-900:hover {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-100:hover {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-200:hover {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-300:hover {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-400:hover {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-500:hover {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-600:hover {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-700:hover {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-800:hover {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .lg\\:hover\\:border-purple-900:hover {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-100:hover {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-200:hover {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-300:hover {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-400:hover {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-500:hover {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-600:hover {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-700:hover {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-800:hover {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .lg\\:hover\\:border-pink-900:hover {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .lg\\:focus\\:border-transparent:focus {
    border-color: transparent;
  }

  .lg\\:focus\\:border-current:focus {
    border-color: currentColor;
  }

  .lg\\:focus\\:border-black:focus {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .lg\\:focus\\:border-white:focus {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-100:focus {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-200:focus {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-300:focus {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-400:focus {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-500:focus {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-600:focus {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-700:focus {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-800:focus {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-900:focus {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-100:focus {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-200:focus {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-300:focus {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-400:focus {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-500:focus {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-600:focus {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-700:focus {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-800:focus {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-900:focus {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-100:focus {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-200:focus {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-300:focus {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-400:focus {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-500:focus {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-600:focus {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-700:focus {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-800:focus {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-900:focus {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-100:focus {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-200:focus {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-300:focus {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-400:focus {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-500:focus {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-600:focus {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-700:focus {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-800:focus {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-900:focus {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-100:focus {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-200:focus {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-300:focus {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-400:focus {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-500:focus {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-600:focus {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-700:focus {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-800:focus {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-900:focus {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-100:focus {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-200:focus {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-300:focus {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-400:focus {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-500:focus {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-600:focus {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-700:focus {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-800:focus {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .lg\\:focus\\:border-teal-900:focus {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-100:focus {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-200:focus {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-300:focus {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-400:focus {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-500:focus {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-600:focus {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-700:focus {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-800:focus {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-900:focus {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-100:focus {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-200:focus {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-300:focus {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-400:focus {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-500:focus {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-600:focus {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-700:focus {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-800:focus {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .lg\\:focus\\:border-indigo-900:focus {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-100:focus {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-200:focus {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-300:focus {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-400:focus {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-500:focus {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-600:focus {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-700:focus {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-800:focus {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .lg\\:focus\\:border-purple-900:focus {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-100:focus {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-200:focus {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-300:focus {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-400:focus {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-500:focus {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-600:focus {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-700:focus {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-800:focus {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .lg\\:focus\\:border-pink-900:focus {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .lg\\:border-opacity-0 {
    --border-opacity: 0;
  }

  .lg\\:border-opacity-25 {
    --border-opacity: 0.25;
  }

  .lg\\:border-opacity-50 {
    --border-opacity: 0.5;
  }

  .lg\\:border-opacity-75 {
    --border-opacity: 0.75;
  }

  .lg\\:border-opacity-100 {
    --border-opacity: 1;
  }

  .lg\\:hover\\:border-opacity-0:hover {
    --border-opacity: 0;
  }

  .lg\\:hover\\:border-opacity-25:hover {
    --border-opacity: 0.25;
  }

  .lg\\:hover\\:border-opacity-50:hover {
    --border-opacity: 0.5;
  }

  .lg\\:hover\\:border-opacity-75:hover {
    --border-opacity: 0.75;
  }

  .lg\\:hover\\:border-opacity-100:hover {
    --border-opacity: 1;
  }

  .lg\\:focus\\:border-opacity-0:focus {
    --border-opacity: 0;
  }

  .lg\\:focus\\:border-opacity-25:focus {
    --border-opacity: 0.25;
  }

  .lg\\:focus\\:border-opacity-50:focus {
    --border-opacity: 0.5;
  }

  .lg\\:focus\\:border-opacity-75:focus {
    --border-opacity: 0.75;
  }

  .lg\\:focus\\:border-opacity-100:focus {
    --border-opacity: 1;
  }

  .lg\\:rounded-none {
    border-radius: 0;
  }

  .lg\\:rounded-sm {
    border-radius: 0.125rem;
  }

  .lg\\:rounded {
    border-radius: 0.25rem;
  }

  .lg\\:rounded-md {
    border-radius: 0.375rem;
  }

  .lg\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .lg\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .lg\\:rounded-2xl {
    border-radius: 1rem;
  }

  .lg\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .lg\\:rounded-full {
    border-radius: 9999px;
  }

  .lg\\:rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .lg\\:rounded-r-none {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .lg\\:rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .lg\\:rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .lg\\:rounded-t-sm {
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
  }

  .lg\\:rounded-r-sm {
    border-top-right-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
  }

  .lg\\:rounded-b-sm {
    border-bottom-right-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }

  .lg\\:rounded-l-sm {
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }

  .lg\\:rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .lg\\:rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }

  .lg\\:rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .lg\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .lg\\:rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }

  .lg\\:rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }

  .lg\\:rounded-b-md {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }

  .lg\\:rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }

  .lg\\:rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  .lg\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .lg\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .lg\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .lg\\:rounded-t-xl {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }

  .lg\\:rounded-r-xl {
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }

  .lg\\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .lg\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .lg\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  .lg\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }

  .lg\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .lg\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .lg\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .lg\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .lg\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .lg\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .lg\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .lg\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .lg\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .lg\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .lg\\:rounded-tl-none {
    border-top-left-radius: 0;
  }

  .lg\\:rounded-tr-none {
    border-top-right-radius: 0;
  }

  .lg\\:rounded-br-none {
    border-bottom-right-radius: 0;
  }

  .lg\\:rounded-bl-none {
    border-bottom-left-radius: 0;
  }

  .lg\\:rounded-tl-sm {
    border-top-left-radius: 0.125rem;
  }

  .lg\\:rounded-tr-sm {
    border-top-right-radius: 0.125rem;
  }

  .lg\\:rounded-br-sm {
    border-bottom-right-radius: 0.125rem;
  }

  .lg\\:rounded-bl-sm {
    border-bottom-left-radius: 0.125rem;
  }

  .lg\\:rounded-tl {
    border-top-left-radius: 0.25rem;
  }

  .lg\\:rounded-tr {
    border-top-right-radius: 0.25rem;
  }

  .lg\\:rounded-br {
    border-bottom-right-radius: 0.25rem;
  }

  .lg\\:rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }

  .lg\\:rounded-tl-md {
    border-top-left-radius: 0.375rem;
  }

  .lg\\:rounded-tr-md {
    border-top-right-radius: 0.375rem;
  }

  .lg\\:rounded-br-md {
    border-bottom-right-radius: 0.375rem;
  }

  .lg\\:rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
  }

  .lg\\:rounded-tl-lg {
    border-top-left-radius: 0.5rem;
  }

  .lg\\:rounded-tr-lg {
    border-top-right-radius: 0.5rem;
  }

  .lg\\:rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
  }

  .lg\\:rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
  }

  .lg\\:rounded-tl-xl {
    border-top-left-radius: 0.75rem;
  }

  .lg\\:rounded-tr-xl {
    border-top-right-radius: 0.75rem;
  }

  .lg\\:rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
  }

  .lg\\:rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
  }

  .lg\\:rounded-tl-2xl {
    border-top-left-radius: 1rem;
  }

  .lg\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }

  .lg\\:rounded-br-2xl {
    border-bottom-right-radius: 1rem;
  }

  .lg\\:rounded-bl-2xl {
    border-bottom-left-radius: 1rem;
  }

  .lg\\:rounded-tl-3xl {
    border-top-left-radius: 1.5rem;
  }

  .lg\\:rounded-tr-3xl {
    border-top-right-radius: 1.5rem;
  }

  .lg\\:rounded-br-3xl {
    border-bottom-right-radius: 1.5rem;
  }

  .lg\\:rounded-bl-3xl {
    border-bottom-left-radius: 1.5rem;
  }

  .lg\\:rounded-tl-full {
    border-top-left-radius: 9999px;
  }

  .lg\\:rounded-tr-full {
    border-top-right-radius: 9999px;
  }

  .lg\\:rounded-br-full {
    border-bottom-right-radius: 9999px;
  }

  .lg\\:rounded-bl-full {
    border-bottom-left-radius: 9999px;
  }

  .lg\\:border-solid {
    border-style: solid;
  }

  .lg\\:border-dashed {
    border-style: dashed;
  }

  .lg\\:border-dotted {
    border-style: dotted;
  }

  .lg\\:border-double {
    border-style: double;
  }

  .lg\\:border-none {
    border-style: none;
  }

  .lg\\:border-0 {
    border-width: 0;
  }

  .lg\\:border-2 {
    border-width: 2px;
  }

  .lg\\:border-4 {
    border-width: 4px;
  }

  .lg\\:border-8 {
    border-width: 8px;
  }

  .lg\\:border {
    border-width: 1px;
  }

  .lg\\:border-t-0 {
    border-top-width: 0;
  }

  .lg\\:border-r-0 {
    border-right-width: 0;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0;
  }

  .lg\\:border-l-0 {
    border-left-width: 0;
  }

  .lg\\:border-t-2 {
    border-top-width: 2px;
  }

  .lg\\:border-r-2 {
    border-right-width: 2px;
  }

  .lg\\:border-b-2 {
    border-bottom-width: 2px;
  }

  .lg\\:border-l-2 {
    border-left-width: 2px;
  }

  .lg\\:border-t-4 {
    border-top-width: 4px;
  }

  .lg\\:border-r-4 {
    border-right-width: 4px;
  }

  .lg\\:border-b-4 {
    border-bottom-width: 4px;
  }

  .lg\\:border-l-4 {
    border-left-width: 4px;
  }

  .lg\\:border-t-8 {
    border-top-width: 8px;
  }

  .lg\\:border-r-8 {
    border-right-width: 8px;
  }

  .lg\\:border-b-8 {
    border-bottom-width: 8px;
  }

  .lg\\:border-l-8 {
    border-left-width: 8px;
  }

  .lg\\:border-t {
    border-top-width: 1px;
  }

  .lg\\:border-r {
    border-right-width: 1px;
  }

  .lg\\:border-b {
    border-bottom-width: 1px;
  }

  .lg\\:border-l {
    border-left-width: 1px;
  }

  .lg\\:box-border {
    box-sizing: border-box;
  }

  .lg\\:box-content {
    box-sizing: content-box;
  }

  .lg\\:cursor-auto {
    cursor: auto;
  }

  .lg\\:cursor-default {
    cursor: default;
  }

  .lg\\:cursor-pointer {
    cursor: pointer;
  }

  .lg\\:cursor-wait {
    cursor: wait;
  }

  .lg\\:cursor-text {
    cursor: text;
  }

  .lg\\:cursor-move {
    cursor: move;
  }

  .lg\\:cursor-not-allowed {
    cursor: not-allowed;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:inline-block {
    display: inline-block;
  }

  .lg\\:inline {
    display: inline;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:inline-flex {
    display: inline-flex;
  }

  .lg\\:table {
    display: table;
  }

  .lg\\:table-caption {
    display: table-caption;
  }

  .lg\\:table-cell {
    display: table-cell;
  }

  .lg\\:table-column {
    display: table-column;
  }

  .lg\\:table-column-group {
    display: table-column-group;
  }

  .lg\\:table-footer-group {
    display: table-footer-group;
  }

  .lg\\:table-header-group {
    display: table-header-group;
  }

  .lg\\:table-row-group {
    display: table-row-group;
  }

  .lg\\:table-row {
    display: table-row;
  }

  .lg\\:flow-root {
    display: flow-root;
  }

  .lg\\:grid {
    display: grid;
  }

  .lg\\:inline-grid {
    display: inline-grid;
  }

  .lg\\:contents {
    display: contents;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .lg\\:flex-col {
    flex-direction: column;
  }

  .lg\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .lg\\:flex-wrap {
    flex-wrap: wrap;
  }

  .lg\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .lg\\:flex-no-wrap {
    flex-wrap: nowrap;
  }

  .lg\\:place-items-auto {
    place-items: auto;
  }

  .lg\\:place-items-start {
    place-items: start;
  }

  .lg\\:place-items-end {
    place-items: end;
  }

  .lg\\:place-items-center {
    place-items: center;
  }

  .lg\\:place-items-stretch {
    place-items: stretch;
  }

  .lg\\:place-content-center {
    place-content: center;
  }

  .lg\\:place-content-start {
    place-content: start;
  }

  .lg\\:place-content-end {
    place-content: end;
  }

  .lg\\:place-content-between {
    place-content: space-between;
  }

  .lg\\:place-content-around {
    place-content: space-around;
  }

  .lg\\:place-content-evenly {
    place-content: space-evenly;
  }

  .lg\\:place-content-stretch {
    place-content: stretch;
  }

  .lg\\:place-self-auto {
    place-self: auto;
  }

  .lg\\:place-self-start {
    place-self: start;
  }

  .lg\\:place-self-end {
    place-self: end;
  }

  .lg\\:place-self-center {
    place-self: center;
  }

  .lg\\:place-self-stretch {
    place-self: stretch;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-end {
    align-items: flex-end;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:items-baseline {
    align-items: baseline;
  }

  .lg\\:items-stretch {
    align-items: stretch;
  }

  .lg\\:content-center {
    align-content: center;
  }

  .lg\\:content-start {
    align-content: flex-start;
  }

  .lg\\:content-end {
    align-content: flex-end;
  }

  .lg\\:content-between {
    align-content: space-between;
  }

  .lg\\:content-around {
    align-content: space-around;
  }

  .lg\\:content-evenly {
    align-content: space-evenly;
  }

  .lg\\:self-auto {
    align-self: auto;
  }

  .lg\\:self-start {
    align-self: flex-start;
  }

  .lg\\:self-end {
    align-self: flex-end;
  }

  .lg\\:self-center {
    align-self: center;
  }

  .lg\\:self-stretch {
    align-self: stretch;
  }

  .lg\\:justify-items-auto {
    justify-items: auto;
  }

  .lg\\:justify-items-start {
    justify-items: start;
  }

  .lg\\:justify-items-end {
    justify-items: end;
  }

  .lg\\:justify-items-center {
    justify-items: center;
  }

  .lg\\:justify-items-stretch {
    justify-items: stretch;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:justify-between {
    justify-content: space-between;
  }

  .lg\\:justify-around {
    justify-content: space-around;
  }

  .lg\\:justify-evenly {
    justify-content: space-evenly;
  }

  .lg\\:justify-self-auto {
    justify-self: auto;
  }

  .lg\\:justify-self-start {
    justify-self: start;
  }

  .lg\\:justify-self-end {
    justify-self: end;
  }

  .lg\\:justify-self-center {
    justify-self: center;
  }

  .lg\\:justify-self-stretch {
    justify-self: stretch;
  }

  .lg\\:flex-1 {
    flex: 1 1;
  }

  .lg\\:flex-auto {
    flex: 1 1 auto;
  }

  .lg\\:flex-initial {
    flex: 0 1 auto;
  }

  .lg\\:flex-none {
    flex: none;
  }

  .lg\\:flex-grow-0 {
    flex-grow: 0;
  }

  .lg\\:flex-grow {
    flex-grow: 1;
  }

  .lg\\:flex-shrink-0 {
    flex-shrink: 0;
  }

  .lg\\:flex-shrink {
    flex-shrink: 1;
  }

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:order-3 {
    order: 3;
  }

  .lg\\:order-4 {
    order: 4;
  }

  .lg\\:order-5 {
    order: 5;
  }

  .lg\\:order-6 {
    order: 6;
  }

  .lg\\:order-7 {
    order: 7;
  }

  .lg\\:order-8 {
    order: 8;
  }

  .lg\\:order-9 {
    order: 9;
  }

  .lg\\:order-10 {
    order: 10;
  }

  .lg\\:order-11 {
    order: 11;
  }

  .lg\\:order-12 {
    order: 12;
  }

  .lg\\:order-first {
    order: -9999;
  }

  .lg\\:order-last {
    order: 9999;
  }

  .lg\\:order-none {
    order: 0;
  }

  .lg\\:float-right {
    float: right;
  }

  .lg\\:float-left {
    float: left;
  }

  .lg\\:float-none {
    float: none;
  }

  .lg\\:clearfix:after {
    content: "";
    display: table;
    clear: both;
  }

  .lg\\:clear-left {
    clear: left;
  }

  .lg\\:clear-right {
    clear: right;
  }

  .lg\\:clear-both {
    clear: both;
  }

  .lg\\:clear-none {
    clear: none;
  }

  .lg\\:font-sans {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .lg\\:font-serif {
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .lg\\:font-mono {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .lg\\:font-hairline {
    font-weight: 100;
  }

  .lg\\:font-thin {
    font-weight: 200;
  }

  .lg\\:font-light {
    font-weight: 300;
  }

  .lg\\:font-normal {
    font-weight: 400;
  }

  .lg\\:font-medium {
    font-weight: 500;
  }

  .lg\\:font-semibold {
    font-weight: 600;
  }

  .lg\\:font-bold {
    font-weight: 700;
  }

  .lg\\:font-extrabold {
    font-weight: 800;
  }

  .lg\\:font-black {
    font-weight: 900;
  }

  .lg\\:hover\\:font-hairline:hover {
    font-weight: 100;
  }

  .lg\\:hover\\:font-thin:hover {
    font-weight: 200;
  }

  .lg\\:hover\\:font-light:hover {
    font-weight: 300;
  }

  .lg\\:hover\\:font-normal:hover {
    font-weight: 400;
  }

  .lg\\:hover\\:font-medium:hover {
    font-weight: 500;
  }

  .lg\\:hover\\:font-semibold:hover {
    font-weight: 600;
  }

  .lg\\:hover\\:font-bold:hover {
    font-weight: 700;
  }

  .lg\\:hover\\:font-extrabold:hover {
    font-weight: 800;
  }

  .lg\\:hover\\:font-black:hover {
    font-weight: 900;
  }

  .lg\\:focus\\:font-hairline:focus {
    font-weight: 100;
  }

  .lg\\:focus\\:font-thin:focus {
    font-weight: 200;
  }

  .lg\\:focus\\:font-light:focus {
    font-weight: 300;
  }

  .lg\\:focus\\:font-normal:focus {
    font-weight: 400;
  }

  .lg\\:focus\\:font-medium:focus {
    font-weight: 500;
  }

  .lg\\:focus\\:font-semibold:focus {
    font-weight: 600;
  }

  .lg\\:focus\\:font-bold:focus {
    font-weight: 700;
  }

  .lg\\:focus\\:font-extrabold:focus {
    font-weight: 800;
  }

  .lg\\:focus\\:font-black:focus {
    font-weight: 900;
  }

  .lg\\:h-0 {
    height: 0;
  }

  .lg\\:h-1 {
    height: 0.25rem;
  }

  .lg\\:h-2 {
    height: 0.5rem;
  }

  .lg\\:h-3 {
    height: 0.75rem;
  }

  .lg\\:h-4 {
    height: 1rem;
  }

  .lg\\:h-5 {
    height: 1.25rem;
  }

  .lg\\:h-6 {
    height: 1.5rem;
  }

  .lg\\:h-8 {
    height: 2rem;
  }

  .lg\\:h-10 {
    height: 2.5rem;
  }

  .lg\\:h-12 {
    height: 3rem;
  }

  .lg\\:h-16 {
    height: 4rem;
  }

  .lg\\:h-20 {
    height: 5rem;
  }

  .lg\\:h-24 {
    height: 6rem;
  }

  .lg\\:h-32 {
    height: 8rem;
  }

  .lg\\:h-40 {
    height: 10rem;
  }

  .lg\\:h-48 {
    height: 12rem;
  }

  .lg\\:h-56 {
    height: 14rem;
  }

  .lg\\:h-64 {
    height: 16rem;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:h-px {
    height: 1px;
  }

  .lg\\:h-full {
    height: 100%;
  }

  .lg\\:h-screen {
    height: 100vh;
  }

  .lg\\:text-15 {
    font-size: 0.9375rem;
  }

  .lg\\:text-xs {
    font-size: 0.75rem;
  }

  .lg\\:text-sm {
    font-size: 0.875rem;
  }

  .lg\\:text-base {
    font-size: 1rem;
  }

  .lg\\:text-lg {
    font-size: 1.125rem;
  }

  .lg\\:text-xl {
    font-size: 1.25rem;
  }

  .lg\\:text-1\\.5xl {
    font-size: 1.375rem;
  }

  .lg\\:text-2xl {
    font-size: 1.5rem;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
  }

  .lg\\:text-6xl {
    font-size: 4rem;
  }

  .lg\\:leading-3 {
    line-height: 0.75rem;
  }

  .lg\\:leading-4 {
    line-height: 1rem;
  }

  .lg\\:leading-5 {
    line-height: 1.25rem;
  }

  .lg\\:leading-6 {
    line-height: 1.5rem;
  }

  .lg\\:leading-7 {
    line-height: 1.75rem;
  }

  .lg\\:leading-8 {
    line-height: 2rem;
  }

  .lg\\:leading-9 {
    line-height: 2.25rem;
  }

  .lg\\:leading-10 {
    line-height: 2.5rem;
  }

  .lg\\:leading-none {
    line-height: 1;
  }

  .lg\\:leading-tight {
    line-height: 1.25;
  }

  .lg\\:leading-snug {
    line-height: 1.375;
  }

  .lg\\:leading-normal {
    line-height: 1.5;
  }

  .lg\\:leading-relaxed {
    line-height: 1.625;
  }

  .lg\\:leading-loose {
    line-height: 2;
  }

  .lg\\:list-inside {
    list-style-position: inside;
  }

  .lg\\:list-outside {
    list-style-position: outside;
  }

  .lg\\:list-none {
    list-style-type: none;
  }

  .lg\\:list-disc {
    list-style-type: disc;
  }

  .lg\\:list-decimal {
    list-style-type: decimal;
  }

  .lg\\:m-0 {
    margin: 0;
  }

  .lg\\:m-1 {
    margin: 0.25rem;
  }

  .lg\\:m-2 {
    margin: 0.5rem;
  }

  .lg\\:m-3 {
    margin: 0.75rem;
  }

  .lg\\:m-4 {
    margin: 1rem;
  }

  .lg\\:m-5 {
    margin: 1.25rem;
  }

  .lg\\:m-6 {
    margin: 1.5rem;
  }

  .lg\\:m-8 {
    margin: 2rem;
  }

  .lg\\:m-10 {
    margin: 2.5rem;
  }

  .lg\\:m-12 {
    margin: 3rem;
  }

  .lg\\:m-16 {
    margin: 4rem;
  }

  .lg\\:m-20 {
    margin: 5rem;
  }

  .lg\\:m-24 {
    margin: 6rem;
  }

  .lg\\:m-32 {
    margin: 8rem;
  }

  .lg\\:m-40 {
    margin: 10rem;
  }

  .lg\\:m-48 {
    margin: 12rem;
  }

  .lg\\:m-56 {
    margin: 14rem;
  }

  .lg\\:m-64 {
    margin: 16rem;
  }

  .lg\\:m-auto {
    margin: auto;
  }

  .lg\\:m-px {
    margin: 1px;
  }

  .lg\\:-m-1 {
    margin: -0.25rem;
  }

  .lg\\:-m-2 {
    margin: -0.5rem;
  }

  .lg\\:-m-3 {
    margin: -0.75rem;
  }

  .lg\\:-m-4 {
    margin: -1rem;
  }

  .lg\\:-m-5 {
    margin: -1.25rem;
  }

  .lg\\:-m-6 {
    margin: -1.5rem;
  }

  .lg\\:-m-8 {
    margin: -2rem;
  }

  .lg\\:-m-10 {
    margin: -2.5rem;
  }

  .lg\\:-m-12 {
    margin: -3rem;
  }

  .lg\\:-m-16 {
    margin: -4rem;
  }

  .lg\\:-m-20 {
    margin: -5rem;
  }

  .lg\\:-m-24 {
    margin: -6rem;
  }

  .lg\\:-m-32 {
    margin: -8rem;
  }

  .lg\\:-m-40 {
    margin: -10rem;
  }

  .lg\\:-m-48 {
    margin: -12rem;
  }

  .lg\\:-m-56 {
    margin: -14rem;
  }

  .lg\\:-m-64 {
    margin: -16rem;
  }

  .lg\\:-m-px {
    margin: -1px;
  }

  .lg\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\\:mx-0 {
    margin-left: 0;
    margin-right: 0;
  }

  .lg\\:my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .lg\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .lg\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .lg\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .lg\\:my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .lg\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .lg\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .lg\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .lg\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .lg\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .lg\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .lg\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .lg\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .lg\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .lg\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .lg\\:mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .lg\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .lg\\:mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .lg\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .lg\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .lg\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .lg\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .lg\\:my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .lg\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .lg\\:my-32 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .lg\\:mx-32 {
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .lg\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .lg\\:mx-40 {
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .lg\\:my-48 {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .lg\\:mx-48 {
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .lg\\:my-56 {
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .lg\\:mx-56 {
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .lg\\:my-64 {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .lg\\:mx-64 {
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .lg\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }

  .lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:my-px {
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .lg\\:mx-px {
    margin-left: 1px;
    margin-right: 1px;
  }

  .lg\\:-my-1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .lg\\:-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .lg\\:-my-2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .lg\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .lg\\:-my-3 {
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .lg\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .lg\\:-my-4 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .lg\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .lg\\:-my-5 {
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .lg\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .lg\\:-my-6 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .lg\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .lg\\:-my-8 {
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .lg\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .lg\\:-my-10 {
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .lg\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .lg\\:-my-12 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .lg\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .lg\\:-my-16 {
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .lg\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .lg\\:-my-20 {
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .lg\\:-mx-20 {
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .lg\\:-my-24 {
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .lg\\:-mx-24 {
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .lg\\:-my-32 {
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .lg\\:-mx-32 {
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .lg\\:-my-40 {
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .lg\\:-mx-40 {
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .lg\\:-my-48 {
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .lg\\:-mx-48 {
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .lg\\:-my-56 {
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .lg\\:-mx-56 {
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .lg\\:-my-64 {
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .lg\\:-mx-64 {
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .lg\\:-my-px {
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .lg\\:-mx-px {
    margin-left: -1px;
    margin-right: -1px;
  }

  .lg\\:mt-0 {
    margin-top: 0;
  }

  .lg\\:mr-0 {
    margin-right: 0;
  }

  .lg\\:mb-0 {
    margin-bottom: 0;
  }

  .lg\\:ml-0 {
    margin-left: 0;
  }

  .lg\\:mt-1 {
    margin-top: 0.25rem;
  }

  .lg\\:mr-1 {
    margin-right: 0.25rem;
  }

  .lg\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .lg\\:ml-1 {
    margin-left: 0.25rem;
  }

  .lg\\:mt-2 {
    margin-top: 0.5rem;
  }

  .lg\\:mr-2 {
    margin-right: 0.5rem;
  }

  .lg\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .lg\\:ml-2 {
    margin-left: 0.5rem;
  }

  .lg\\:mt-3 {
    margin-top: 0.75rem;
  }

  .lg\\:mr-3 {
    margin-right: 0.75rem;
  }

  .lg\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .lg\\:ml-3 {
    margin-left: 0.75rem;
  }

  .lg\\:mt-4 {
    margin-top: 1rem;
  }

  .lg\\:mr-4 {
    margin-right: 1rem;
  }

  .lg\\:mb-4 {
    margin-bottom: 1rem;
  }

  .lg\\:ml-4 {
    margin-left: 1rem;
  }

  .lg\\:mt-5 {
    margin-top: 1.25rem;
  }

  .lg\\:mr-5 {
    margin-right: 1.25rem;
  }

  .lg\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .lg\\:ml-5 {
    margin-left: 1.25rem;
  }

  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:mr-6 {
    margin-right: 1.5rem;
  }

  .lg\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .lg\\:ml-6 {
    margin-left: 1.5rem;
  }

  .lg\\:mt-8 {
    margin-top: 2rem;
  }

  .lg\\:mr-8 {
    margin-right: 2rem;
  }

  .lg\\:mb-8 {
    margin-bottom: 2rem;
  }

  .lg\\:ml-8 {
    margin-left: 2rem;
  }

  .lg\\:mt-10 {
    margin-top: 2.5rem;
  }

  .lg\\:mr-10 {
    margin-right: 2.5rem;
  }

  .lg\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .lg\\:ml-10 {
    margin-left: 2.5rem;
  }

  .lg\\:mt-12 {
    margin-top: 3rem;
  }

  .lg\\:mr-12 {
    margin-right: 3rem;
  }

  .lg\\:mb-12 {
    margin-bottom: 3rem;
  }

  .lg\\:ml-12 {
    margin-left: 3rem;
  }

  .lg\\:mt-16 {
    margin-top: 4rem;
  }

  .lg\\:mr-16 {
    margin-right: 4rem;
  }

  .lg\\:mb-16 {
    margin-bottom: 4rem;
  }

  .lg\\:ml-16 {
    margin-left: 4rem;
  }

  .lg\\:mt-20 {
    margin-top: 5rem;
  }

  .lg\\:mr-20 {
    margin-right: 5rem;
  }

  .lg\\:mb-20 {
    margin-bottom: 5rem;
  }

  .lg\\:ml-20 {
    margin-left: 5rem;
  }

  .lg\\:mt-24 {
    margin-top: 6rem;
  }

  .lg\\:mr-24 {
    margin-right: 6rem;
  }

  .lg\\:mb-24 {
    margin-bottom: 6rem;
  }

  .lg\\:ml-24 {
    margin-left: 6rem;
  }

  .lg\\:mt-32 {
    margin-top: 8rem;
  }

  .lg\\:mr-32 {
    margin-right: 8rem;
  }

  .lg\\:mb-32 {
    margin-bottom: 8rem;
  }

  .lg\\:ml-32 {
    margin-left: 8rem;
  }

  .lg\\:mt-40 {
    margin-top: 10rem;
  }

  .lg\\:mr-40 {
    margin-right: 10rem;
  }

  .lg\\:mb-40 {
    margin-bottom: 10rem;
  }

  .lg\\:ml-40 {
    margin-left: 10rem;
  }

  .lg\\:mt-48 {
    margin-top: 12rem;
  }

  .lg\\:mr-48 {
    margin-right: 12rem;
  }

  .lg\\:mb-48 {
    margin-bottom: 12rem;
  }

  .lg\\:ml-48 {
    margin-left: 12rem;
  }

  .lg\\:mt-56 {
    margin-top: 14rem;
  }

  .lg\\:mr-56 {
    margin-right: 14rem;
  }

  .lg\\:mb-56 {
    margin-bottom: 14rem;
  }

  .lg\\:ml-56 {
    margin-left: 14rem;
  }

  .lg\\:mt-64 {
    margin-top: 16rem;
  }

  .lg\\:mr-64 {
    margin-right: 16rem;
  }

  .lg\\:mb-64 {
    margin-bottom: 16rem;
  }

  .lg\\:ml-64 {
    margin-left: 16rem;
  }

  .lg\\:mt-auto {
    margin-top: auto;
  }

  .lg\\:mr-auto {
    margin-right: auto;
  }

  .lg\\:mb-auto {
    margin-bottom: auto;
  }

  .lg\\:ml-auto {
    margin-left: auto;
  }

  .lg\\:mt-px {
    margin-top: 1px;
  }

  .lg\\:mr-px {
    margin-right: 1px;
  }

  .lg\\:mb-px {
    margin-bottom: 1px;
  }

  .lg\\:ml-px {
    margin-left: 1px;
  }

  .lg\\:-mt-1 {
    margin-top: -0.25rem;
  }

  .lg\\:-mr-1 {
    margin-right: -0.25rem;
  }

  .lg\\:-mb-1 {
    margin-bottom: -0.25rem;
  }

  .lg\\:-ml-1 {
    margin-left: -0.25rem;
  }

  .lg\\:-mt-2 {
    margin-top: -0.5rem;
  }

  .lg\\:-mr-2 {
    margin-right: -0.5rem;
  }

  .lg\\:-mb-2 {
    margin-bottom: -0.5rem;
  }

  .lg\\:-ml-2 {
    margin-left: -0.5rem;
  }

  .lg\\:-mt-3 {
    margin-top: -0.75rem;
  }

  .lg\\:-mr-3 {
    margin-right: -0.75rem;
  }

  .lg\\:-mb-3 {
    margin-bottom: -0.75rem;
  }

  .lg\\:-ml-3 {
    margin-left: -0.75rem;
  }

  .lg\\:-mt-4 {
    margin-top: -1rem;
  }

  .lg\\:-mr-4 {
    margin-right: -1rem;
  }

  .lg\\:-mb-4 {
    margin-bottom: -1rem;
  }

  .lg\\:-ml-4 {
    margin-left: -1rem;
  }

  .lg\\:-mt-5 {
    margin-top: -1.25rem;
  }

  .lg\\:-mr-5 {
    margin-right: -1.25rem;
  }

  .lg\\:-mb-5 {
    margin-bottom: -1.25rem;
  }

  .lg\\:-ml-5 {
    margin-left: -1.25rem;
  }

  .lg\\:-mt-6 {
    margin-top: -1.5rem;
  }

  .lg\\:-mr-6 {
    margin-right: -1.5rem;
  }

  .lg\\:-mb-6 {
    margin-bottom: -1.5rem;
  }

  .lg\\:-ml-6 {
    margin-left: -1.5rem;
  }

  .lg\\:-mt-8 {
    margin-top: -2rem;
  }

  .lg\\:-mr-8 {
    margin-right: -2rem;
  }

  .lg\\:-mb-8 {
    margin-bottom: -2rem;
  }

  .lg\\:-ml-8 {
    margin-left: -2rem;
  }

  .lg\\:-mt-10 {
    margin-top: -2.5rem;
  }

  .lg\\:-mr-10 {
    margin-right: -2.5rem;
  }

  .lg\\:-mb-10 {
    margin-bottom: -2.5rem;
  }

  .lg\\:-ml-10 {
    margin-left: -2.5rem;
  }

  .lg\\:-mt-12 {
    margin-top: -3rem;
  }

  .lg\\:-mr-12 {
    margin-right: -3rem;
  }

  .lg\\:-mb-12 {
    margin-bottom: -3rem;
  }

  .lg\\:-ml-12 {
    margin-left: -3rem;
  }

  .lg\\:-mt-16 {
    margin-top: -4rem;
  }

  .lg\\:-mr-16 {
    margin-right: -4rem;
  }

  .lg\\:-mb-16 {
    margin-bottom: -4rem;
  }

  .lg\\:-ml-16 {
    margin-left: -4rem;
  }

  .lg\\:-mt-20 {
    margin-top: -5rem;
  }

  .lg\\:-mr-20 {
    margin-right: -5rem;
  }

  .lg\\:-mb-20 {
    margin-bottom: -5rem;
  }

  .lg\\:-ml-20 {
    margin-left: -5rem;
  }

  .lg\\:-mt-24 {
    margin-top: -6rem;
  }

  .lg\\:-mr-24 {
    margin-right: -6rem;
  }

  .lg\\:-mb-24 {
    margin-bottom: -6rem;
  }

  .lg\\:-ml-24 {
    margin-left: -6rem;
  }

  .lg\\:-mt-32 {
    margin-top: -8rem;
  }

  .lg\\:-mr-32 {
    margin-right: -8rem;
  }

  .lg\\:-mb-32 {
    margin-bottom: -8rem;
  }

  .lg\\:-ml-32 {
    margin-left: -8rem;
  }

  .lg\\:-mt-40 {
    margin-top: -10rem;
  }

  .lg\\:-mr-40 {
    margin-right: -10rem;
  }

  .lg\\:-mb-40 {
    margin-bottom: -10rem;
  }

  .lg\\:-ml-40 {
    margin-left: -10rem;
  }

  .lg\\:-mt-48 {
    margin-top: -12rem;
  }

  .lg\\:-mr-48 {
    margin-right: -12rem;
  }

  .lg\\:-mb-48 {
    margin-bottom: -12rem;
  }

  .lg\\:-ml-48 {
    margin-left: -12rem;
  }

  .lg\\:-mt-56 {
    margin-top: -14rem;
  }

  .lg\\:-mr-56 {
    margin-right: -14rem;
  }

  .lg\\:-mb-56 {
    margin-bottom: -14rem;
  }

  .lg\\:-ml-56 {
    margin-left: -14rem;
  }

  .lg\\:-mt-64 {
    margin-top: -16rem;
  }

  .lg\\:-mr-64 {
    margin-right: -16rem;
  }

  .lg\\:-mb-64 {
    margin-bottom: -16rem;
  }

  .lg\\:-ml-64 {
    margin-left: -16rem;
  }

  .lg\\:-mt-px {
    margin-top: -1px;
  }

  .lg\\:-mr-px {
    margin-right: -1px;
  }

  .lg\\:-mb-px {
    margin-bottom: -1px;
  }

  .lg\\:-ml-px {
    margin-left: -1px;
  }

  .lg\\:max-h-full {
    max-height: 100%;
  }

  .lg\\:max-h-screen {
    max-height: 100vh;
  }

  .lg\\:max-w-none {
    max-width: none;
  }

  .lg\\:max-w-xs {
    max-width: 20rem;
  }

  .lg\\:max-w-sm {
    max-width: 24rem;
  }

  .lg\\:max-w-md {
    max-width: 28rem;
  }

  .lg\\:max-w-lg {
    max-width: 32rem;
  }

  .lg\\:max-w-xl {
    max-width: 36rem;
  }

  .lg\\:max-w-2xl {
    max-width: 42rem;
  }

  .lg\\:max-w-3xl {
    max-width: 48rem;
  }

  .lg\\:max-w-4xl {
    max-width: 56rem;
  }

  .lg\\:max-w-5xl {
    max-width: 64rem;
  }

  .lg\\:max-w-6xl {
    max-width: 72rem;
  }

  .lg\\:max-w-full {
    max-width: 100%;
  }

  .lg\\:max-w-screen-sm {
    max-width: 640px;
  }

  .lg\\:max-w-screen-md {
    max-width: 768px;
  }

  .lg\\:max-w-screen-lg {
    max-width: 1024px;
  }

  .lg\\:max-w-screen-xl {
    max-width: 1280px;
  }

  .lg\\:min-h-0 {
    min-height: 0;
  }

  .lg\\:min-h-full {
    min-height: 100%;
  }

  .lg\\:min-h-screen {
    min-height: 100vh;
  }

  .lg\\:min-w-0 {
    min-width: 0;
  }

  .lg\\:min-w-full {
    min-width: 100%;
  }

  .lg\\:object-contain {
    object-fit: contain;
  }

  .lg\\:object-cover {
    object-fit: cover;
  }

  .lg\\:object-fill {
    object-fit: fill;
  }

  .lg\\:object-none {
    object-fit: none;
  }

  .lg\\:object-scale-down {
    object-fit: scale-down;
  }

  .lg\\:object-bottom {
    object-position: bottom;
  }

  .lg\\:object-center {
    object-position: center;
  }

  .lg\\:object-left {
    object-position: left;
  }

  .lg\\:object-left-bottom {
    object-position: left bottom;
  }

  .lg\\:object-left-top {
    object-position: left top;
  }

  .lg\\:object-right {
    object-position: right;
  }

  .lg\\:object-right-bottom {
    object-position: right bottom;
  }

  .lg\\:object-right-top {
    object-position: right top;
  }

  .lg\\:object-top {
    object-position: top;
  }

  .lg\\:opacity-0 {
    opacity: 0;
  }

  .lg\\:opacity-25 {
    opacity: 0.25;
  }

  .lg\\:opacity-50 {
    opacity: 0.5;
  }

  .lg\\:opacity-75 {
    opacity: 0.75;
  }

  .lg\\:opacity-100 {
    opacity: 1;
  }

  .lg\\:hover\\:opacity-0:hover {
    opacity: 0;
  }

  .lg\\:hover\\:opacity-25:hover {
    opacity: 0.25;
  }

  .lg\\:hover\\:opacity-50:hover {
    opacity: 0.5;
  }

  .lg\\:hover\\:opacity-75:hover {
    opacity: 0.75;
  }

  .lg\\:hover\\:opacity-100:hover {
    opacity: 1;
  }

  .lg\\:focus\\:opacity-0:focus {
    opacity: 0;
  }

  .lg\\:focus\\:opacity-25:focus {
    opacity: 0.25;
  }

  .lg\\:focus\\:opacity-50:focus {
    opacity: 0.5;
  }

  .lg\\:focus\\:opacity-75:focus {
    opacity: 0.75;
  }

  .lg\\:focus\\:opacity-100:focus {
    opacity: 1;
  }

  .lg\\:outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .lg\\:outline-white {
    outline: 2px dotted white;
    outline-offset: 2px;
  }

  .lg\\:outline-black {
    outline: 2px dotted black;
    outline-offset: 2px;
  }

  .lg\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .lg\\:focus\\:outline-white:focus {
    outline: 2px dotted white;
    outline-offset: 2px;
  }

  .lg\\:focus\\:outline-black:focus {
    outline: 2px dotted black;
    outline-offset: 2px;
  }

  .lg\\:overflow-auto {
    overflow: auto;
  }

  .lg\\:overflow-hidden {
    overflow: hidden;
  }

  .lg\\:overflow-visible {
    overflow: visible;
  }

  .lg\\:overflow-scroll {
    overflow: scroll;
  }

  .lg\\:overflow-x-auto {
    overflow-x: auto;
  }

  .lg\\:overflow-y-auto {
    overflow-y: auto;
  }

  .lg\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .lg\\:overflow-y-hidden {
    overflow-y: hidden;
  }

  .lg\\:overflow-x-visible {
    overflow-x: visible;
  }

  .lg\\:overflow-y-visible {
    overflow-y: visible;
  }

  .lg\\:overflow-x-scroll {
    overflow-x: scroll;
  }

  .lg\\:overflow-y-scroll {
    overflow-y: scroll;
  }

  .lg\\:scrolling-touch {
    -webkit-overflow-scrolling: touch;
  }

  .lg\\:scrolling-auto {
    -webkit-overflow-scrolling: auto;
  }

  .lg\\:overscroll-auto {
    overscroll-behavior: auto;
  }

  .lg\\:overscroll-contain {
    overscroll-behavior: contain;
  }

  .lg\\:overscroll-none {
    overscroll-behavior: none;
  }

  .lg\\:overscroll-y-auto {
    overscroll-behavior-y: auto;
  }

  .lg\\:overscroll-y-contain {
    overscroll-behavior-y: contain;
  }

  .lg\\:overscroll-y-none {
    overscroll-behavior-y: none;
  }

  .lg\\:overscroll-x-auto {
    overscroll-behavior-x: auto;
  }

  .lg\\:overscroll-x-contain {
    overscroll-behavior-x: contain;
  }

  .lg\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }

  .lg\\:p-0 {
    padding: 0;
  }

  .lg\\:p-1 {
    padding: 0.25rem;
  }

  .lg\\:p-2 {
    padding: 0.5rem;
  }

  .lg\\:p-3 {
    padding: 0.75rem;
  }

  .lg\\:p-4 {
    padding: 1rem;
  }

  .lg\\:p-5 {
    padding: 1.25rem;
  }

  .lg\\:p-6 {
    padding: 1.5rem;
  }

  .lg\\:p-8 {
    padding: 2rem;
  }

  .lg\\:p-10 {
    padding: 2.5rem;
  }

  .lg\\:p-12 {
    padding: 3rem;
  }

  .lg\\:p-16 {
    padding: 4rem;
  }

  .lg\\:p-20 {
    padding: 5rem;
  }

  .lg\\:p-24 {
    padding: 6rem;
  }

  .lg\\:p-32 {
    padding: 8rem;
  }

  .lg\\:p-40 {
    padding: 10rem;
  }

  .lg\\:p-48 {
    padding: 12rem;
  }

  .lg\\:p-56 {
    padding: 14rem;
  }

  .lg\\:p-64 {
    padding: 16rem;
  }

  .lg\\:p-px {
    padding: 1px;
  }

  .lg\\:py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lg\\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }

  .lg\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .lg\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .lg\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .lg\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .lg\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .lg\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .lg\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .lg\\:py-48 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .lg\\:px-48 {
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .lg\\:py-56 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .lg\\:px-56 {
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .lg\\:py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .lg\\:px-64 {
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .lg\\:py-px {
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .lg\\:px-px {
    padding-left: 1px;
    padding-right: 1px;
  }

  .lg\\:pt-0 {
    padding-top: 0;
  }

  .lg\\:pr-0 {
    padding-right: 0;
  }

  .lg\\:pb-0 {
    padding-bottom: 0;
  }

  .lg\\:pl-0 {
    padding-left: 0;
  }

  .lg\\:pt-1 {
    padding-top: 0.25rem;
  }

  .lg\\:pr-1 {
    padding-right: 0.25rem;
  }

  .lg\\:pb-1 {
    padding-bottom: 0.25rem;
  }

  .lg\\:pl-1 {
    padding-left: 0.25rem;
  }

  .lg\\:pt-2 {
    padding-top: 0.5rem;
  }

  .lg\\:pr-2 {
    padding-right: 0.5rem;
  }

  .lg\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .lg\\:pl-2 {
    padding-left: 0.5rem;
  }

  .lg\\:pt-3 {
    padding-top: 0.75rem;
  }

  .lg\\:pr-3 {
    padding-right: 0.75rem;
  }

  .lg\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .lg\\:pl-3 {
    padding-left: 0.75rem;
  }

  .lg\\:pt-4 {
    padding-top: 1rem;
  }

  .lg\\:pr-4 {
    padding-right: 1rem;
  }

  .lg\\:pb-4 {
    padding-bottom: 1rem;
  }

  .lg\\:pl-4 {
    padding-left: 1rem;
  }

  .lg\\:pt-5 {
    padding-top: 1.25rem;
  }

  .lg\\:pr-5 {
    padding-right: 1.25rem;
  }

  .lg\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .lg\\:pl-5 {
    padding-left: 1.25rem;
  }

  .lg\\:pt-6 {
    padding-top: 1.5rem;
  }

  .lg\\:pr-6 {
    padding-right: 1.5rem;
  }

  .lg\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .lg\\:pl-6 {
    padding-left: 1.5rem;
  }

  .lg\\:pt-8 {
    padding-top: 2rem;
  }

  .lg\\:pr-8 {
    padding-right: 2rem;
  }

  .lg\\:pb-8 {
    padding-bottom: 2rem;
  }

  .lg\\:pl-8 {
    padding-left: 2rem;
  }

  .lg\\:pt-10 {
    padding-top: 2.5rem;
  }

  .lg\\:pr-10 {
    padding-right: 2.5rem;
  }

  .lg\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .lg\\:pl-10 {
    padding-left: 2.5rem;
  }

  .lg\\:pt-12 {
    padding-top: 3rem;
  }

  .lg\\:pr-12 {
    padding-right: 3rem;
  }

  .lg\\:pb-12 {
    padding-bottom: 3rem;
  }

  .lg\\:pl-12 {
    padding-left: 3rem;
  }

  .lg\\:pt-16 {
    padding-top: 4rem;
  }

  .lg\\:pr-16 {
    padding-right: 4rem;
  }

  .lg\\:pb-16 {
    padding-bottom: 4rem;
  }

  .lg\\:pl-16 {
    padding-left: 4rem;
  }

  .lg\\:pt-20 {
    padding-top: 5rem;
  }

  .lg\\:pr-20 {
    padding-right: 5rem;
  }

  .lg\\:pb-20 {
    padding-bottom: 5rem;
  }

  .lg\\:pl-20 {
    padding-left: 5rem;
  }

  .lg\\:pt-24 {
    padding-top: 6rem;
  }

  .lg\\:pr-24 {
    padding-right: 6rem;
  }

  .lg\\:pb-24 {
    padding-bottom: 6rem;
  }

  .lg\\:pl-24 {
    padding-left: 6rem;
  }

  .lg\\:pt-32 {
    padding-top: 8rem;
  }

  .lg\\:pr-32 {
    padding-right: 8rem;
  }

  .lg\\:pb-32 {
    padding-bottom: 8rem;
  }

  .lg\\:pl-32 {
    padding-left: 8rem;
  }

  .lg\\:pt-40 {
    padding-top: 10rem;
  }

  .lg\\:pr-40 {
    padding-right: 10rem;
  }

  .lg\\:pb-40 {
    padding-bottom: 10rem;
  }

  .lg\\:pl-40 {
    padding-left: 10rem;
  }

  .lg\\:pt-48 {
    padding-top: 12rem;
  }

  .lg\\:pr-48 {
    padding-right: 12rem;
  }

  .lg\\:pb-48 {
    padding-bottom: 12rem;
  }

  .lg\\:pl-48 {
    padding-left: 12rem;
  }

  .lg\\:pt-56 {
    padding-top: 14rem;
  }

  .lg\\:pr-56 {
    padding-right: 14rem;
  }

  .lg\\:pb-56 {
    padding-bottom: 14rem;
  }

  .lg\\:pl-56 {
    padding-left: 14rem;
  }

  .lg\\:pt-64 {
    padding-top: 16rem;
  }

  .lg\\:pr-64 {
    padding-right: 16rem;
  }

  .lg\\:pb-64 {
    padding-bottom: 16rem;
  }

  .lg\\:pl-64 {
    padding-left: 16rem;
  }

  .lg\\:pt-px {
    padding-top: 1px;
  }

  .lg\\:pr-px {
    padding-right: 1px;
  }

  .lg\\:pb-px {
    padding-bottom: 1px;
  }

  .lg\\:pl-px {
    padding-left: 1px;
  }

  .lg\\:placeholder-transparent::placeholder {
    color: transparent;
  }

  .lg\\:placeholder-current::placeholder {
    color: currentColor;
  }

  .lg\\:placeholder-black::placeholder {
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .lg\\:placeholder-white::placeholder {
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f7fafc;
    color: rgba(247, 250, 252, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #edf2f7;
    color: rgba(237, 242, 247, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #a0aec0;
    color: rgba(160, 174, 192, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #718096;
    color: rgba(113, 128, 150, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #4a5568;
    color: rgba(74, 85, 104, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #2d3748;
    color: rgba(45, 55, 72, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #1a202c;
    color: rgba(26, 32, 44, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-100::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f5;
    color: rgba(255, 245, 245, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-200::placeholder {
    --placeholder-opacity: 1;
    color: #fed7d7;
    color: rgba(254, 215, 215, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-300::placeholder {
    --placeholder-opacity: 1;
    color: #feb2b2;
    color: rgba(254, 178, 178, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-400::placeholder {
    --placeholder-opacity: 1;
    color: #fc8181;
    color: rgba(252, 129, 129, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-500::placeholder {
    --placeholder-opacity: 1;
    color: #f56565;
    color: rgba(245, 101, 101, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-600::placeholder {
    --placeholder-opacity: 1;
    color: #e53e3e;
    color: rgba(229, 62, 62, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-700::placeholder {
    --placeholder-opacity: 1;
    color: #c53030;
    color: rgba(197, 48, 48, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-800::placeholder {
    --placeholder-opacity: 1;
    color: #9b2c2c;
    color: rgba(155, 44, 44, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-900::placeholder {
    --placeholder-opacity: 1;
    color: #742a2a;
    color: rgba(116, 42, 42, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-100::placeholder {
    --placeholder-opacity: 1;
    color: #fffaf0;
    color: rgba(255, 250, 240, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-200::placeholder {
    --placeholder-opacity: 1;
    color: #feebc8;
    color: rgba(254, 235, 200, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-300::placeholder {
    --placeholder-opacity: 1;
    color: #fbd38d;
    color: rgba(251, 211, 141, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-400::placeholder {
    --placeholder-opacity: 1;
    color: #f6ad55;
    color: rgba(246, 173, 85, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-500::placeholder {
    --placeholder-opacity: 1;
    color: #ed8936;
    color: rgba(237, 137, 54, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-600::placeholder {
    --placeholder-opacity: 1;
    color: #dd6b20;
    color: rgba(221, 107, 32, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-700::placeholder {
    --placeholder-opacity: 1;
    color: #c05621;
    color: rgba(192, 86, 33, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-800::placeholder {
    --placeholder-opacity: 1;
    color: #9c4221;
    color: rgba(156, 66, 33, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-900::placeholder {
    --placeholder-opacity: 1;
    color: #7b341e;
    color: rgba(123, 52, 30, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-100::placeholder {
    --placeholder-opacity: 1;
    color: #fffff0;
    color: rgba(255, 255, 240, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-200::placeholder {
    --placeholder-opacity: 1;
    color: #fefcbf;
    color: rgba(254, 252, 191, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-300::placeholder {
    --placeholder-opacity: 1;
    color: #faf089;
    color: rgba(250, 240, 137, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-400::placeholder {
    --placeholder-opacity: 1;
    color: #f6e05e;
    color: rgba(246, 224, 94, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-500::placeholder {
    --placeholder-opacity: 1;
    color: #ecc94b;
    color: rgba(236, 201, 75, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-600::placeholder {
    --placeholder-opacity: 1;
    color: #d69e2e;
    color: rgba(214, 158, 46, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-700::placeholder {
    --placeholder-opacity: 1;
    color: #b7791f;
    color: rgba(183, 121, 31, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-800::placeholder {
    --placeholder-opacity: 1;
    color: #975a16;
    color: rgba(151, 90, 22, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-900::placeholder {
    --placeholder-opacity: 1;
    color: #744210;
    color: rgba(116, 66, 16, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-100::placeholder {
    --placeholder-opacity: 1;
    color: #f0fff4;
    color: rgba(240, 255, 244, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-200::placeholder {
    --placeholder-opacity: 1;
    color: #c6f6d5;
    color: rgba(198, 246, 213, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-300::placeholder {
    --placeholder-opacity: 1;
    color: #9ae6b4;
    color: rgba(154, 230, 180, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-400::placeholder {
    --placeholder-opacity: 1;
    color: #68d391;
    color: rgba(104, 211, 145, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-500::placeholder {
    --placeholder-opacity: 1;
    color: #48bb78;
    color: rgba(72, 187, 120, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-600::placeholder {
    --placeholder-opacity: 1;
    color: #38a169;
    color: rgba(56, 161, 105, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-700::placeholder {
    --placeholder-opacity: 1;
    color: #2f855a;
    color: rgba(47, 133, 90, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-800::placeholder {
    --placeholder-opacity: 1;
    color: #276749;
    color: rgba(39, 103, 73, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-900::placeholder {
    --placeholder-opacity: 1;
    color: #22543d;
    color: rgba(34, 84, 61, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-100::placeholder {
    --placeholder-opacity: 1;
    color: #e6fffa;
    color: rgba(230, 255, 250, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-200::placeholder {
    --placeholder-opacity: 1;
    color: #b2f5ea;
    color: rgba(178, 245, 234, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-300::placeholder {
    --placeholder-opacity: 1;
    color: #81e6d9;
    color: rgba(129, 230, 217, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-400::placeholder {
    --placeholder-opacity: 1;
    color: #4fd1c5;
    color: rgba(79, 209, 197, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-500::placeholder {
    --placeholder-opacity: 1;
    color: #38b2ac;
    color: rgba(56, 178, 172, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-600::placeholder {
    --placeholder-opacity: 1;
    color: #319795;
    color: rgba(49, 151, 149, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-700::placeholder {
    --placeholder-opacity: 1;
    color: #2c7a7b;
    color: rgba(44, 122, 123, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-800::placeholder {
    --placeholder-opacity: 1;
    color: #285e61;
    color: rgba(40, 94, 97, var(--placeholder-opacity));
  }

  .lg\\:placeholder-teal-900::placeholder {
    --placeholder-opacity: 1;
    color: #234e52;
    color: rgba(35, 78, 82, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-100::placeholder {
    --placeholder-opacity: 1;
    color: #ebf8ff;
    color: rgba(235, 248, 255, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-200::placeholder {
    --placeholder-opacity: 1;
    color: #bee3f8;
    color: rgba(190, 227, 248, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-300::placeholder {
    --placeholder-opacity: 1;
    color: #90cdf4;
    color: rgba(144, 205, 244, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-400::placeholder {
    --placeholder-opacity: 1;
    color: #63b3ed;
    color: rgba(99, 179, 237, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-500::placeholder {
    --placeholder-opacity: 1;
    color: #4299e1;
    color: rgba(66, 153, 225, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-600::placeholder {
    --placeholder-opacity: 1;
    color: #3182ce;
    color: rgba(49, 130, 206, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-700::placeholder {
    --placeholder-opacity: 1;
    color: #2b6cb0;
    color: rgba(43, 108, 176, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-800::placeholder {
    --placeholder-opacity: 1;
    color: #2c5282;
    color: rgba(44, 82, 130, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-900::placeholder {
    --placeholder-opacity: 1;
    color: #2a4365;
    color: rgba(42, 67, 101, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-100::placeholder {
    --placeholder-opacity: 1;
    color: #ebf4ff;
    color: rgba(235, 244, 255, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-200::placeholder {
    --placeholder-opacity: 1;
    color: #c3dafe;
    color: rgba(195, 218, 254, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-300::placeholder {
    --placeholder-opacity: 1;
    color: #a3bffa;
    color: rgba(163, 191, 250, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-400::placeholder {
    --placeholder-opacity: 1;
    color: #7f9cf5;
    color: rgba(127, 156, 245, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-500::placeholder {
    --placeholder-opacity: 1;
    color: #667eea;
    color: rgba(102, 126, 234, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-600::placeholder {
    --placeholder-opacity: 1;
    color: #5a67d8;
    color: rgba(90, 103, 216, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-700::placeholder {
    --placeholder-opacity: 1;
    color: #4c51bf;
    color: rgba(76, 81, 191, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-800::placeholder {
    --placeholder-opacity: 1;
    color: #434190;
    color: rgba(67, 65, 144, var(--placeholder-opacity));
  }

  .lg\\:placeholder-indigo-900::placeholder {
    --placeholder-opacity: 1;
    color: #3c366b;
    color: rgba(60, 54, 107, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-100::placeholder {
    --placeholder-opacity: 1;
    color: #faf5ff;
    color: rgba(250, 245, 255, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-200::placeholder {
    --placeholder-opacity: 1;
    color: #e9d8fd;
    color: rgba(233, 216, 253, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-300::placeholder {
    --placeholder-opacity: 1;
    color: #d6bcfa;
    color: rgba(214, 188, 250, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-400::placeholder {
    --placeholder-opacity: 1;
    color: #b794f4;
    color: rgba(183, 148, 244, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-500::placeholder {
    --placeholder-opacity: 1;
    color: #9f7aea;
    color: rgba(159, 122, 234, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-600::placeholder {
    --placeholder-opacity: 1;
    color: #805ad5;
    color: rgba(128, 90, 213, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-700::placeholder {
    --placeholder-opacity: 1;
    color: #6b46c1;
    color: rgba(107, 70, 193, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-800::placeholder {
    --placeholder-opacity: 1;
    color: #553c9a;
    color: rgba(85, 60, 154, var(--placeholder-opacity));
  }

  .lg\\:placeholder-purple-900::placeholder {
    --placeholder-opacity: 1;
    color: #44337a;
    color: rgba(68, 51, 122, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-100::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f7;
    color: rgba(255, 245, 247, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-200::placeholder {
    --placeholder-opacity: 1;
    color: #fed7e2;
    color: rgba(254, 215, 226, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-300::placeholder {
    --placeholder-opacity: 1;
    color: #fbb6ce;
    color: rgba(251, 182, 206, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-400::placeholder {
    --placeholder-opacity: 1;
    color: #f687b3;
    color: rgba(246, 135, 179, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-500::placeholder {
    --placeholder-opacity: 1;
    color: #ed64a6;
    color: rgba(237, 100, 166, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-600::placeholder {
    --placeholder-opacity: 1;
    color: #d53f8c;
    color: rgba(213, 63, 140, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-700::placeholder {
    --placeholder-opacity: 1;
    color: #b83280;
    color: rgba(184, 50, 128, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-800::placeholder {
    --placeholder-opacity: 1;
    color: #97266d;
    color: rgba(151, 38, 109, var(--placeholder-opacity));
  }

  .lg\\:placeholder-pink-900::placeholder {
    --placeholder-opacity: 1;
    color: #702459;
    color: rgba(112, 36, 89, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-transparent:focus::placeholder {
    color: transparent;
  }

  .lg\\:focus\\:placeholder-current:focus::placeholder {
    color: currentColor;
  }

  .lg\\:focus\\:placeholder-black:focus::placeholder {
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-white:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f7fafc;
    color: rgba(247, 250, 252, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edf2f7;
    color: rgba(237, 242, 247, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a0aec0;
    color: rgba(160, 174, 192, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #718096;
    color: rgba(113, 128, 150, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4a5568;
    color: rgba(74, 85, 104, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2d3748;
    color: rgba(45, 55, 72, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a202c;
    color: rgba(26, 32, 44, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f5;
    color: rgba(255, 245, 245, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fed7d7;
    color: rgba(254, 215, 215, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feb2b2;
    color: rgba(254, 178, 178, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fc8181;
    color: rgba(252, 129, 129, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f56565;
    color: rgba(245, 101, 101, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e53e3e;
    color: rgba(229, 62, 62, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c53030;
    color: rgba(197, 48, 48, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9b2c2c;
    color: rgba(155, 44, 44, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #742a2a;
    color: rgba(116, 42, 42, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fffaf0;
    color: rgba(255, 250, 240, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feebc8;
    color: rgba(254, 235, 200, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbd38d;
    color: rgba(251, 211, 141, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6ad55;
    color: rgba(246, 173, 85, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ed8936;
    color: rgba(237, 137, 54, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #dd6b20;
    color: rgba(221, 107, 32, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c05621;
    color: rgba(192, 86, 33, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9c4221;
    color: rgba(156, 66, 33, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7b341e;
    color: rgba(123, 52, 30, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fffff0;
    color: rgba(255, 255, 240, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fefcbf;
    color: rgba(254, 252, 191, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faf089;
    color: rgba(250, 240, 137, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6e05e;
    color: rgba(246, 224, 94, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ecc94b;
    color: rgba(236, 201, 75, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d69e2e;
    color: rgba(214, 158, 46, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b7791f;
    color: rgba(183, 121, 31, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #975a16;
    color: rgba(151, 90, 22, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #744210;
    color: rgba(116, 66, 16, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f0fff4;
    color: rgba(240, 255, 244, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c6f6d5;
    color: rgba(198, 246, 213, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9ae6b4;
    color: rgba(154, 230, 180, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #68d391;
    color: rgba(104, 211, 145, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #48bb78;
    color: rgba(72, 187, 120, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #38a169;
    color: rgba(56, 161, 105, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2f855a;
    color: rgba(47, 133, 90, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #276749;
    color: rgba(39, 103, 73, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #22543d;
    color: rgba(34, 84, 61, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e6fffa;
    color: rgba(230, 255, 250, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b2f5ea;
    color: rgba(178, 245, 234, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #81e6d9;
    color: rgba(129, 230, 217, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4fd1c5;
    color: rgba(79, 209, 197, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #38b2ac;
    color: rgba(56, 178, 172, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #319795;
    color: rgba(49, 151, 149, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2c7a7b;
    color: rgba(44, 122, 123, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #285e61;
    color: rgba(40, 94, 97, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-teal-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #234e52;
    color: rgba(35, 78, 82, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf8ff;
    color: rgba(235, 248, 255, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bee3f8;
    color: rgba(190, 227, 248, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #90cdf4;
    color: rgba(144, 205, 244, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #63b3ed;
    color: rgba(99, 179, 237, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4299e1;
    color: rgba(66, 153, 225, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3182ce;
    color: rgba(49, 130, 206, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2b6cb0;
    color: rgba(43, 108, 176, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2c5282;
    color: rgba(44, 82, 130, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2a4365;
    color: rgba(42, 67, 101, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf4ff;
    color: rgba(235, 244, 255, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c3dafe;
    color: rgba(195, 218, 254, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a3bffa;
    color: rgba(163, 191, 250, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7f9cf5;
    color: rgba(127, 156, 245, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #667eea;
    color: rgba(102, 126, 234, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5a67d8;
    color: rgba(90, 103, 216, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4c51bf;
    color: rgba(76, 81, 191, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #434190;
    color: rgba(67, 65, 144, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-indigo-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3c366b;
    color: rgba(60, 54, 107, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faf5ff;
    color: rgba(250, 245, 255, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e9d8fd;
    color: rgba(233, 216, 253, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d6bcfa;
    color: rgba(214, 188, 250, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b794f4;
    color: rgba(183, 148, 244, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9f7aea;
    color: rgba(159, 122, 234, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #805ad5;
    color: rgba(128, 90, 213, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6b46c1;
    color: rgba(107, 70, 193, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #553c9a;
    color: rgba(85, 60, 154, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-purple-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #44337a;
    color: rgba(68, 51, 122, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f7;
    color: rgba(255, 245, 247, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fed7e2;
    color: rgba(254, 215, 226, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbb6ce;
    color: rgba(251, 182, 206, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f687b3;
    color: rgba(246, 135, 179, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ed64a6;
    color: rgba(237, 100, 166, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d53f8c;
    color: rgba(213, 63, 140, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b83280;
    color: rgba(184, 50, 128, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #97266d;
    color: rgba(151, 38, 109, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-pink-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #702459;
    color: rgba(112, 36, 89, var(--placeholder-opacity));
  }

  .lg\\:placeholder-opacity-0::placeholder {
    --placeholder-opacity: 0;
  }

  .lg\\:placeholder-opacity-25::placeholder {
    --placeholder-opacity: 0.25;
  }

  .lg\\:placeholder-opacity-50::placeholder {
    --placeholder-opacity: 0.5;
  }

  .lg\\:placeholder-opacity-75::placeholder {
    --placeholder-opacity: 0.75;
  }

  .lg\\:placeholder-opacity-100::placeholder {
    --placeholder-opacity: 1;
  }

  .lg\\:focus\\:placeholder-opacity-0:focus::placeholder {
    --placeholder-opacity: 0;
  }

  .lg\\:focus\\:placeholder-opacity-25:focus::placeholder {
    --placeholder-opacity: 0.25;
  }

  .lg\\:focus\\:placeholder-opacity-50:focus::placeholder {
    --placeholder-opacity: 0.5;
  }

  .lg\\:focus\\:placeholder-opacity-75:focus::placeholder {
    --placeholder-opacity: 0.75;
  }

  .lg\\:focus\\:placeholder-opacity-100:focus::placeholder {
    --placeholder-opacity: 1;
  }

  .lg\\:pointer-events-none {
    pointer-events: none;
  }

  .lg\\:pointer-events-auto {
    pointer-events: auto;
  }

  .lg\\:static {
    position: static;
  }

  .lg\\:fixed {
    position: fixed;
  }

  .lg\\:absolute {
    position: absolute;
  }

  .lg\\:relative {
    position: relative;
  }

  .lg\\:sticky {
    position: sticky;
  }

  .lg\\:inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .lg\\:inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .lg\\:inset-y-0 {
    top: 0;
    bottom: 0;
  }

  .lg\\:inset-x-0 {
    right: 0;
    left: 0;
  }

  .lg\\:inset-y-auto {
    top: auto;
    bottom: auto;
  }

  .lg\\:inset-x-auto {
    right: auto;
    left: auto;
  }

  .lg\\:top-0 {
    top: 0;
  }

  .lg\\:right-0 {
    right: 0;
  }

  .lg\\:bottom-0 {
    bottom: 0;
  }

  .lg\\:left-0 {
    left: 0;
  }

  .lg\\:top-auto {
    top: auto;
  }

  .lg\\:right-auto {
    right: auto;
  }

  .lg\\:bottom-auto {
    bottom: auto;
  }

  .lg\\:left-auto {
    left: auto;
  }

  .lg\\:resize-none {
    resize: none;
  }

  .lg\\:resize-y {
    resize: vertical;
  }

  .lg\\:resize-x {
    resize: horizontal;
  }

  .lg\\:resize {
    resize: both;
  }

  .lg\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .lg\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .lg\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .lg\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .lg\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .lg\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .lg\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .lg\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .lg\\:shadow-none {
    box-shadow: none;
  }

  .lg\\:hover\\:shadow-xs:hover {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .lg\\:hover\\:shadow-sm:hover {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .lg\\:hover\\:shadow:hover {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .lg\\:hover\\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:hover\\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .lg\\:hover\\:shadow-xl:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .lg\\:hover\\:shadow-2xl:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .lg\\:hover\\:shadow-inner:hover {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .lg\\:hover\\:shadow-outline:hover {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .lg\\:hover\\:shadow-none:hover {
    box-shadow: none;
  }

  .lg\\:focus\\:shadow-xs:focus {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .lg\\:focus\\:shadow-sm:focus {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .lg\\:focus\\:shadow:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .lg\\:focus\\:shadow-md:focus {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:focus\\:shadow-lg:focus {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .lg\\:focus\\:shadow-xl:focus {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .lg\\:focus\\:shadow-2xl:focus {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .lg\\:focus\\:shadow-inner:focus {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .lg\\:focus\\:shadow-outline:focus {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .lg\\:focus\\:shadow-none:focus {
    box-shadow: none;
  }

  .lg\\:fill-current {
    fill: currentColor;
  }

  .lg\\:stroke-current {
    stroke: currentColor;
  }

  .lg\\:stroke-0 {
    stroke-width: 0;
  }

  .lg\\:stroke-1 {
    stroke-width: 1;
  }

  .lg\\:stroke-2 {
    stroke-width: 2;
  }

  .lg\\:table-auto {
    table-layout: auto;
  }

  .lg\\:table-fixed {
    table-layout: fixed;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-center {
    text-align: center;
  }

  .lg\\:text-right {
    text-align: right;
  }

  .lg\\:text-justify {
    text-align: justify;
  }

  .lg\\:text-blue {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .lg\\:text-primaryText {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .lg\\:text-red {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue:hover {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .lg\\:hover\\:text-primaryText:hover {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .lg\\:hover\\:text-red:hover {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue:focus {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .lg\\:focus\\:text-primaryText:focus {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .lg\\:focus\\:text-red:focus {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .lg\\:text-opacity-0 {
    --text-opacity: 0;
  }

  .lg\\:text-opacity-25 {
    --text-opacity: 0.25;
  }

  .lg\\:text-opacity-50 {
    --text-opacity: 0.5;
  }

  .lg\\:text-opacity-75 {
    --text-opacity: 0.75;
  }

  .lg\\:text-opacity-100 {
    --text-opacity: 1;
  }

  .lg\\:hover\\:text-opacity-0:hover {
    --text-opacity: 0;
  }

  .lg\\:hover\\:text-opacity-25:hover {
    --text-opacity: 0.25;
  }

  .lg\\:hover\\:text-opacity-50:hover {
    --text-opacity: 0.5;
  }

  .lg\\:hover\\:text-opacity-75:hover {
    --text-opacity: 0.75;
  }

  .lg\\:hover\\:text-opacity-100:hover {
    --text-opacity: 1;
  }

  .lg\\:focus\\:text-opacity-0:focus {
    --text-opacity: 0;
  }

  .lg\\:focus\\:text-opacity-25:focus {
    --text-opacity: 0.25;
  }

  .lg\\:focus\\:text-opacity-50:focus {
    --text-opacity: 0.5;
  }

  .lg\\:focus\\:text-opacity-75:focus {
    --text-opacity: 0.75;
  }

  .lg\\:focus\\:text-opacity-100:focus {
    --text-opacity: 1;
  }

  .lg\\:italic {
    font-style: italic;
  }

  .lg\\:not-italic {
    font-style: normal;
  }

  .lg\\:uppercase {
    text-transform: uppercase;
  }

  .lg\\:lowercase {
    text-transform: lowercase;
  }

  .lg\\:capitalize {
    text-transform: capitalize;
  }

  .lg\\:normal-case {
    text-transform: none;
  }

  .lg\\:underline {
    text-decoration: underline;
  }

  .lg\\:line-through {
    text-decoration: line-through;
  }

  .lg\\:no-underline {
    text-decoration: none;
  }

  .lg\\:hover\\:underline:hover {
    text-decoration: underline;
  }

  .lg\\:hover\\:line-through:hover {
    text-decoration: line-through;
  }

  .lg\\:hover\\:no-underline:hover {
    text-decoration: none;
  }

  .lg\\:focus\\:underline:focus {
    text-decoration: underline;
  }

  .lg\\:focus\\:line-through:focus {
    text-decoration: line-through;
  }

  .lg\\:focus\\:no-underline:focus {
    text-decoration: none;
  }

  .lg\\:antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .lg\\:subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .lg\\:ordinal, .lg\\:slashed-zero, .lg\\:lining-nums, .lg\\:oldstyle-nums, .lg\\:proportional-nums, .lg\\:tabular-nums, .lg\\:diagonal-fractions, .lg\\:stacked-fractions {
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .lg\\:normal-nums {
    font-variant-numeric: normal;
  }

  .lg\\:ordinal {
    --font-variant-numeric-ordinal: ordinal;
  }

  .lg\\:slashed-zero {
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .lg\\:lining-nums {
    --font-variant-numeric-figure: lining-nums;
  }

  .lg\\:oldstyle-nums {
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .lg\\:proportional-nums {
    --font-variant-numeric-spacing: proportional-nums;
  }

  .lg\\:tabular-nums {
    --font-variant-numeric-spacing: tabular-nums;
  }

  .lg\\:diagonal-fractions {
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .lg\\:stacked-fractions {
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .lg\\:tracking-tighter {
    letter-spacing: -0.05em;
  }

  .lg\\:tracking-tight {
    letter-spacing: -0.025em;
  }

  .lg\\:tracking-normal {
    letter-spacing: 0;
  }

  .lg\\:tracking-wide {
    letter-spacing: 0.025em;
  }

  .lg\\:tracking-wider {
    letter-spacing: 0.05em;
  }

  .lg\\:tracking-widest {
    letter-spacing: 0.1em;
  }

  .lg\\:select-none {
    -webkit-user-select: none;
    user-select: none;
  }

  .lg\\:select-text {
    -webkit-user-select: text;
    user-select: text;
  }

  .lg\\:select-all {
    -webkit-user-select: all;
    user-select: all;
  }

  .lg\\:select-auto {
    -webkit-user-select: auto;
    user-select: auto;
  }

  .lg\\:align-baseline {
    vertical-align: baseline;
  }

  .lg\\:align-top {
    vertical-align: top;
  }

  .lg\\:align-middle {
    vertical-align: middle;
  }

  .lg\\:align-bottom {
    vertical-align: bottom;
  }

  .lg\\:align-text-top {
    vertical-align: text-top;
  }

  .lg\\:align-text-bottom {
    vertical-align: text-bottom;
  }

  .lg\\:visible {
    visibility: visible;
  }

  .lg\\:invisible {
    visibility: hidden;
  }

  .lg\\:whitespace-normal {
    white-space: normal;
  }

  .lg\\:whitespace-no-wrap {
    white-space: nowrap;
  }

  .lg\\:whitespace-pre {
    white-space: pre;
  }

  .lg\\:whitespace-pre-line {
    white-space: pre-line;
  }

  .lg\\:whitespace-pre-wrap {
    white-space: pre-wrap;
  }

  .lg\\:break-normal {
    word-wrap: normal;
    overflow-wrap: normal;
    word-break: normal;
  }

  .lg\\:break-words {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .lg\\:break-all {
    word-break: break-all;
  }

  .lg\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .lg\\:w-0 {
    width: 0;
  }

  .lg\\:w-1 {
    width: 0.25rem;
  }

  .lg\\:w-2 {
    width: 0.5rem;
  }

  .lg\\:w-3 {
    width: 0.75rem;
  }

  .lg\\:w-4 {
    width: 1rem;
  }

  .lg\\:w-5 {
    width: 1.25rem;
  }

  .lg\\:w-6 {
    width: 1.5rem;
  }

  .lg\\:w-8 {
    width: 2rem;
  }

  .lg\\:w-10 {
    width: 2.5rem;
  }

  .lg\\:w-12 {
    width: 3rem;
  }

  .lg\\:w-16 {
    width: 4rem;
  }

  .lg\\:w-20 {
    width: 5rem;
  }

  .lg\\:w-24 {
    width: 6rem;
  }

  .lg\\:w-32 {
    width: 8rem;
  }

  .lg\\:w-40 {
    width: 10rem;
  }

  .lg\\:w-48 {
    width: 12rem;
  }

  .lg\\:w-56 {
    width: 14rem;
  }

  .lg\\:w-64 {
    width: 16rem;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-px {
    width: 1px;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:w-1\\/3 {
    width: 33.333333%;
  }

  .lg\\:w-2\\/3 {
    width: 66.666667%;
  }

  .lg\\:w-1\\/4 {
    width: 25%;
  }

  .lg\\:w-2\\/4 {
    width: 50%;
  }

  .lg\\:w-3\\/4 {
    width: 75%;
  }

  .lg\\:w-1\\/5 {
    width: 20%;
  }

  .lg\\:w-2\\/5 {
    width: 40%;
  }

  .lg\\:w-3\\/5 {
    width: 60%;
  }

  .lg\\:w-4\\/5 {
    width: 80%;
  }

  .lg\\:w-1\\/6 {
    width: 16.666667%;
  }

  .lg\\:w-2\\/6 {
    width: 33.333333%;
  }

  .lg\\:w-3\\/6 {
    width: 50%;
  }

  .lg\\:w-4\\/6 {
    width: 66.666667%;
  }

  .lg\\:w-5\\/6 {
    width: 83.333333%;
  }

  .lg\\:w-1\\/12 {
    width: 8.333333%;
  }

  .lg\\:w-2\\/12 {
    width: 16.666667%;
  }

  .lg\\:w-3\\/12 {
    width: 25%;
  }

  .lg\\:w-4\\/12 {
    width: 33.333333%;
  }

  .lg\\:w-5\\/12 {
    width: 41.666667%;
  }

  .lg\\:w-6\\/12 {
    width: 50%;
  }

  .lg\\:w-7\\/12 {
    width: 58.333333%;
  }

  .lg\\:w-8\\/12 {
    width: 66.666667%;
  }

  .lg\\:w-9\\/12 {
    width: 75%;
  }

  .lg\\:w-10\\/12 {
    width: 83.333333%;
  }

  .lg\\:w-11\\/12 {
    width: 91.666667%;
  }

  .lg\\:w-full {
    width: 100%;
  }

  .lg\\:w-screen {
    width: 100vw;
  }

  .lg\\:z-0 {
    z-index: 0;
  }

  .lg\\:z-10 {
    z-index: 10;
  }

  .lg\\:z-20 {
    z-index: 20;
  }

  .lg\\:z-30 {
    z-index: 30;
  }

  .lg\\:z-40 {
    z-index: 40;
  }

  .lg\\:z-50 {
    z-index: 50;
  }

  .lg\\:z-auto {
    z-index: auto;
  }

  .lg\\:gap-0 {
    grid-gap: 0;
    gap: 0;
  }

  .lg\\:gap-1 {
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .lg\\:gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .lg\\:gap-3 {
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .lg\\:gap-4 {
    grid-gap: 1rem;
    gap: 1rem;
  }

  .lg\\:gap-5 {
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .lg\\:gap-6 {
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .lg\\:gap-8 {
    grid-gap: 2rem;
    gap: 2rem;
  }

  .lg\\:gap-10 {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .lg\\:gap-12 {
    grid-gap: 3rem;
    gap: 3rem;
  }

  .lg\\:gap-16 {
    grid-gap: 4rem;
    gap: 4rem;
  }

  .lg\\:gap-20 {
    grid-gap: 5rem;
    gap: 5rem;
  }

  .lg\\:gap-24 {
    grid-gap: 6rem;
    gap: 6rem;
  }

  .lg\\:gap-32 {
    grid-gap: 8rem;
    gap: 8rem;
  }

  .lg\\:gap-40 {
    grid-gap: 10rem;
    gap: 10rem;
  }

  .lg\\:gap-48 {
    grid-gap: 12rem;
    gap: 12rem;
  }

  .lg\\:gap-56 {
    grid-gap: 14rem;
    gap: 14rem;
  }

  .lg\\:gap-64 {
    grid-gap: 16rem;
    gap: 16rem;
  }

  .lg\\:gap-px {
    grid-gap: 1px;
    gap: 1px;
  }

  .lg\\:col-gap-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }

  .lg\\:col-gap-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }

  .lg\\:col-gap-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }

  .lg\\:col-gap-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }

  .lg\\:col-gap-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }

  .lg\\:col-gap-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .lg\\:col-gap-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .lg\\:col-gap-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }

  .lg\\:col-gap-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .lg\\:col-gap-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }

  .lg\\:col-gap-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }

  .lg\\:col-gap-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }

  .lg\\:col-gap-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }

  .lg\\:col-gap-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }

  .lg\\:col-gap-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }

  .lg\\:col-gap-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }

  .lg\\:col-gap-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }

  .lg\\:col-gap-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }

  .lg\\:col-gap-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }

  .lg\\:gap-x-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }

  .lg\\:gap-x-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }

  .lg\\:gap-x-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }

  .lg\\:gap-x-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }

  .lg\\:gap-x-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }

  .lg\\:gap-x-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .lg\\:gap-x-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .lg\\:gap-x-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }

  .lg\\:gap-x-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .lg\\:gap-x-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }

  .lg\\:gap-x-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }

  .lg\\:gap-x-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }

  .lg\\:gap-x-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }

  .lg\\:gap-x-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }

  .lg\\:gap-x-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }

  .lg\\:gap-x-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }

  .lg\\:gap-x-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }

  .lg\\:gap-x-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }

  .lg\\:gap-x-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }

  .lg\\:row-gap-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }

  .lg\\:row-gap-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .lg\\:row-gap-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .lg\\:row-gap-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .lg\\:row-gap-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .lg\\:row-gap-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .lg\\:row-gap-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .lg\\:row-gap-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .lg\\:row-gap-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .lg\\:row-gap-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .lg\\:row-gap-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .lg\\:row-gap-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .lg\\:row-gap-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .lg\\:row-gap-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .lg\\:row-gap-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .lg\\:row-gap-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .lg\\:row-gap-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .lg\\:row-gap-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .lg\\:row-gap-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .lg\\:gap-y-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }

  .lg\\:gap-y-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .lg\\:gap-y-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .lg\\:gap-y-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .lg\\:gap-y-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .lg\\:gap-y-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .lg\\:gap-y-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .lg\\:gap-y-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .lg\\:gap-y-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .lg\\:gap-y-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .lg\\:gap-y-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .lg\\:gap-y-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .lg\\:gap-y-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .lg\\:gap-y-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .lg\\:gap-y-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .lg\\:gap-y-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .lg\\:gap-y-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .lg\\:gap-y-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .lg\\:gap-y-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .lg\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .lg\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .lg\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .lg\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .lg\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .lg\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .lg\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-none {
    grid-template-columns: none;
  }

  .lg\\:auto-cols-auto {
    grid-auto-columns: auto;
  }

  .lg\\:auto-cols-min {
    grid-auto-columns: min-content;
  }

  .lg\\:auto-cols-max {
    grid-auto-columns: max-content;
  }

  .lg\\:auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }

  .lg\\:col-auto {
    grid-column: auto;
  }

  .lg\\:col-span-1 {
    grid-column: span 1/span 1;
  }

  .lg\\:col-span-2 {
    grid-column: span 2/span 2;
  }

  .lg\\:col-span-3 {
    grid-column: span 3/span 3;
  }

  .lg\\:col-span-4 {
    grid-column: span 4/span 4;
  }

  .lg\\:col-span-5 {
    grid-column: span 5/span 5;
  }

  .lg\\:col-span-6 {
    grid-column: span 6/span 6;
  }

  .lg\\:col-span-7 {
    grid-column: span 7/span 7;
  }

  .lg\\:col-span-8 {
    grid-column: span 8/span 8;
  }

  .lg\\:col-span-9 {
    grid-column: span 9/span 9;
  }

  .lg\\:col-span-10 {
    grid-column: span 10/span 10;
  }

  .lg\\:col-span-11 {
    grid-column: span 11/span 11;
  }

  .lg\\:col-span-12 {
    grid-column: span 12/span 12;
  }

  .lg\\:col-span-full {
    grid-column: 1/-1;
  }

  .lg\\:col-start-1 {
    grid-column-start: 1;
  }

  .lg\\:col-start-2 {
    grid-column-start: 2;
  }

  .lg\\:col-start-3 {
    grid-column-start: 3;
  }

  .lg\\:col-start-4 {
    grid-column-start: 4;
  }

  .lg\\:col-start-5 {
    grid-column-start: 5;
  }

  .lg\\:col-start-6 {
    grid-column-start: 6;
  }

  .lg\\:col-start-7 {
    grid-column-start: 7;
  }

  .lg\\:col-start-8 {
    grid-column-start: 8;
  }

  .lg\\:col-start-9 {
    grid-column-start: 9;
  }

  .lg\\:col-start-10 {
    grid-column-start: 10;
  }

  .lg\\:col-start-11 {
    grid-column-start: 11;
  }

  .lg\\:col-start-12 {
    grid-column-start: 12;
  }

  .lg\\:col-start-13 {
    grid-column-start: 13;
  }

  .lg\\:col-start-auto {
    grid-column-start: auto;
  }

  .lg\\:col-end-1 {
    grid-column-end: 1;
  }

  .lg\\:col-end-2 {
    grid-column-end: 2;
  }

  .lg\\:col-end-3 {
    grid-column-end: 3;
  }

  .lg\\:col-end-4 {
    grid-column-end: 4;
  }

  .lg\\:col-end-5 {
    grid-column-end: 5;
  }

  .lg\\:col-end-6 {
    grid-column-end: 6;
  }

  .lg\\:col-end-7 {
    grid-column-end: 7;
  }

  .lg\\:col-end-8 {
    grid-column-end: 8;
  }

  .lg\\:col-end-9 {
    grid-column-end: 9;
  }

  .lg\\:col-end-10 {
    grid-column-end: 10;
  }

  .lg\\:col-end-11 {
    grid-column-end: 11;
  }

  .lg\\:col-end-12 {
    grid-column-end: 12;
  }

  .lg\\:col-end-13 {
    grid-column-end: 13;
  }

  .lg\\:col-end-auto {
    grid-column-end: auto;
  }

  .lg\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-rows-none {
    grid-template-rows: none;
  }

  .lg\\:auto-rows-auto {
    grid-auto-rows: auto;
  }

  .lg\\:auto-rows-min {
    grid-auto-rows: min-content;
  }

  .lg\\:auto-rows-max {
    grid-auto-rows: max-content;
  }

  .lg\\:auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
  }

  .lg\\:row-auto {
    grid-row: auto;
  }

  .lg\\:row-span-1 {
    grid-row: span 1/span 1;
  }

  .lg\\:row-span-2 {
    grid-row: span 2/span 2;
  }

  .lg\\:row-span-3 {
    grid-row: span 3/span 3;
  }

  .lg\\:row-span-4 {
    grid-row: span 4/span 4;
  }

  .lg\\:row-span-5 {
    grid-row: span 5/span 5;
  }

  .lg\\:row-span-6 {
    grid-row: span 6/span 6;
  }

  .lg\\:row-span-full {
    grid-row: 1/-1;
  }

  .lg\\:row-start-1 {
    grid-row-start: 1;
  }

  .lg\\:row-start-2 {
    grid-row-start: 2;
  }

  .lg\\:row-start-3 {
    grid-row-start: 3;
  }

  .lg\\:row-start-4 {
    grid-row-start: 4;
  }

  .lg\\:row-start-5 {
    grid-row-start: 5;
  }

  .lg\\:row-start-6 {
    grid-row-start: 6;
  }

  .lg\\:row-start-7 {
    grid-row-start: 7;
  }

  .lg\\:row-start-auto {
    grid-row-start: auto;
  }

  .lg\\:row-end-1 {
    grid-row-end: 1;
  }

  .lg\\:row-end-2 {
    grid-row-end: 2;
  }

  .lg\\:row-end-3 {
    grid-row-end: 3;
  }

  .lg\\:row-end-4 {
    grid-row-end: 4;
  }

  .lg\\:row-end-5 {
    grid-row-end: 5;
  }

  .lg\\:row-end-6 {
    grid-row-end: 6;
  }

  .lg\\:row-end-7 {
    grid-row-end: 7;
  }

  .lg\\:row-end-auto {
    grid-row-end: auto;
  }

  .lg\\:transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .lg\\:transform-none {
    transform: none;
  }

  .lg\\:origin-center {
    transform-origin: center;
  }

  .lg\\:origin-top {
    transform-origin: top;
  }

  .lg\\:origin-top-right {
    transform-origin: top right;
  }

  .lg\\:origin-right {
    transform-origin: right;
  }

  .lg\\:origin-bottom-right {
    transform-origin: bottom right;
  }

  .lg\\:origin-bottom {
    transform-origin: bottom;
  }

  .lg\\:origin-bottom-left {
    transform-origin: bottom left;
  }

  .lg\\:origin-left {
    transform-origin: left;
  }

  .lg\\:origin-top-left {
    transform-origin: top left;
  }

  .lg\\:scale-0 {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .lg\\:scale-50 {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .lg\\:scale-75 {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .lg\\:scale-90 {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .lg\\:scale-95 {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .lg\\:scale-100 {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .lg\\:scale-105 {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .lg\\:scale-110 {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .lg\\:scale-125 {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .lg\\:scale-150 {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .lg\\:scale-x-0 {
    --transform-scale-x: 0;
  }

  .lg\\:scale-x-50 {
    --transform-scale-x: .5;
  }

  .lg\\:scale-x-75 {
    --transform-scale-x: .75;
  }

  .lg\\:scale-x-90 {
    --transform-scale-x: .9;
  }

  .lg\\:scale-x-95 {
    --transform-scale-x: .95;
  }

  .lg\\:scale-x-100 {
    --transform-scale-x: 1;
  }

  .lg\\:scale-x-105 {
    --transform-scale-x: 1.05;
  }

  .lg\\:scale-x-110 {
    --transform-scale-x: 1.1;
  }

  .lg\\:scale-x-125 {
    --transform-scale-x: 1.25;
  }

  .lg\\:scale-x-150 {
    --transform-scale-x: 1.5;
  }

  .lg\\:scale-y-0 {
    --transform-scale-y: 0;
  }

  .lg\\:scale-y-50 {
    --transform-scale-y: .5;
  }

  .lg\\:scale-y-75 {
    --transform-scale-y: .75;
  }

  .lg\\:scale-y-90 {
    --transform-scale-y: .9;
  }

  .lg\\:scale-y-95 {
    --transform-scale-y: .95;
  }

  .lg\\:scale-y-100 {
    --transform-scale-y: 1;
  }

  .lg\\:scale-y-105 {
    --transform-scale-y: 1.05;
  }

  .lg\\:scale-y-110 {
    --transform-scale-y: 1.1;
  }

  .lg\\:scale-y-125 {
    --transform-scale-y: 1.25;
  }

  .lg\\:scale-y-150 {
    --transform-scale-y: 1.5;
  }

  .lg\\:hover\\:scale-0:hover {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .lg\\:hover\\:scale-50:hover {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .lg\\:hover\\:scale-75:hover {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .lg\\:hover\\:scale-90:hover {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .lg\\:hover\\:scale-95:hover {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .lg\\:hover\\:scale-100:hover {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .lg\\:hover\\:scale-105:hover {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .lg\\:hover\\:scale-110:hover {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .lg\\:hover\\:scale-125:hover {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .lg\\:hover\\:scale-150:hover {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .lg\\:hover\\:scale-x-0:hover {
    --transform-scale-x: 0;
  }

  .lg\\:hover\\:scale-x-50:hover {
    --transform-scale-x: .5;
  }

  .lg\\:hover\\:scale-x-75:hover {
    --transform-scale-x: .75;
  }

  .lg\\:hover\\:scale-x-90:hover {
    --transform-scale-x: .9;
  }

  .lg\\:hover\\:scale-x-95:hover {
    --transform-scale-x: .95;
  }

  .lg\\:hover\\:scale-x-100:hover {
    --transform-scale-x: 1;
  }

  .lg\\:hover\\:scale-x-105:hover {
    --transform-scale-x: 1.05;
  }

  .lg\\:hover\\:scale-x-110:hover {
    --transform-scale-x: 1.1;
  }

  .lg\\:hover\\:scale-x-125:hover {
    --transform-scale-x: 1.25;
  }

  .lg\\:hover\\:scale-x-150:hover {
    --transform-scale-x: 1.5;
  }

  .lg\\:hover\\:scale-y-0:hover {
    --transform-scale-y: 0;
  }

  .lg\\:hover\\:scale-y-50:hover {
    --transform-scale-y: .5;
  }

  .lg\\:hover\\:scale-y-75:hover {
    --transform-scale-y: .75;
  }

  .lg\\:hover\\:scale-y-90:hover {
    --transform-scale-y: .9;
  }

  .lg\\:hover\\:scale-y-95:hover {
    --transform-scale-y: .95;
  }

  .lg\\:hover\\:scale-y-100:hover {
    --transform-scale-y: 1;
  }

  .lg\\:hover\\:scale-y-105:hover {
    --transform-scale-y: 1.05;
  }

  .lg\\:hover\\:scale-y-110:hover {
    --transform-scale-y: 1.1;
  }

  .lg\\:hover\\:scale-y-125:hover {
    --transform-scale-y: 1.25;
  }

  .lg\\:hover\\:scale-y-150:hover {
    --transform-scale-y: 1.5;
  }

  .lg\\:focus\\:scale-0:focus {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .lg\\:focus\\:scale-50:focus {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .lg\\:focus\\:scale-75:focus {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .lg\\:focus\\:scale-90:focus {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .lg\\:focus\\:scale-95:focus {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .lg\\:focus\\:scale-100:focus {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .lg\\:focus\\:scale-105:focus {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .lg\\:focus\\:scale-110:focus {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .lg\\:focus\\:scale-125:focus {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .lg\\:focus\\:scale-150:focus {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .lg\\:focus\\:scale-x-0:focus {
    --transform-scale-x: 0;
  }

  .lg\\:focus\\:scale-x-50:focus {
    --transform-scale-x: .5;
  }

  .lg\\:focus\\:scale-x-75:focus {
    --transform-scale-x: .75;
  }

  .lg\\:focus\\:scale-x-90:focus {
    --transform-scale-x: .9;
  }

  .lg\\:focus\\:scale-x-95:focus {
    --transform-scale-x: .95;
  }

  .lg\\:focus\\:scale-x-100:focus {
    --transform-scale-x: 1;
  }

  .lg\\:focus\\:scale-x-105:focus {
    --transform-scale-x: 1.05;
  }

  .lg\\:focus\\:scale-x-110:focus {
    --transform-scale-x: 1.1;
  }

  .lg\\:focus\\:scale-x-125:focus {
    --transform-scale-x: 1.25;
  }

  .lg\\:focus\\:scale-x-150:focus {
    --transform-scale-x: 1.5;
  }

  .lg\\:focus\\:scale-y-0:focus {
    --transform-scale-y: 0;
  }

  .lg\\:focus\\:scale-y-50:focus {
    --transform-scale-y: .5;
  }

  .lg\\:focus\\:scale-y-75:focus {
    --transform-scale-y: .75;
  }

  .lg\\:focus\\:scale-y-90:focus {
    --transform-scale-y: .9;
  }

  .lg\\:focus\\:scale-y-95:focus {
    --transform-scale-y: .95;
  }

  .lg\\:focus\\:scale-y-100:focus {
    --transform-scale-y: 1;
  }

  .lg\\:focus\\:scale-y-105:focus {
    --transform-scale-y: 1.05;
  }

  .lg\\:focus\\:scale-y-110:focus {
    --transform-scale-y: 1.1;
  }

  .lg\\:focus\\:scale-y-125:focus {
    --transform-scale-y: 1.25;
  }

  .lg\\:focus\\:scale-y-150:focus {
    --transform-scale-y: 1.5;
  }

  .lg\\:rotate-0 {
    --transform-rotate: 0;
  }

  .lg\\:rotate-1 {
    --transform-rotate: 1deg;
  }

  .lg\\:rotate-2 {
    --transform-rotate: 2deg;
  }

  .lg\\:rotate-3 {
    --transform-rotate: 3deg;
  }

  .lg\\:rotate-6 {
    --transform-rotate: 6deg;
  }

  .lg\\:rotate-12 {
    --transform-rotate: 12deg;
  }

  .lg\\:rotate-45 {
    --transform-rotate: 45deg;
  }

  .lg\\:rotate-90 {
    --transform-rotate: 90deg;
  }

  .lg\\:rotate-180 {
    --transform-rotate: 180deg;
  }

  .lg\\:-rotate-180 {
    --transform-rotate: -180deg;
  }

  .lg\\:-rotate-90 {
    --transform-rotate: -90deg;
  }

  .lg\\:-rotate-45 {
    --transform-rotate: -45deg;
  }

  .lg\\:-rotate-12 {
    --transform-rotate: -12deg;
  }

  .lg\\:-rotate-6 {
    --transform-rotate: -6deg;
  }

  .lg\\:-rotate-3 {
    --transform-rotate: -3deg;
  }

  .lg\\:-rotate-2 {
    --transform-rotate: -2deg;
  }

  .lg\\:-rotate-1 {
    --transform-rotate: -1deg;
  }

  .lg\\:hover\\:rotate-0:hover {
    --transform-rotate: 0;
  }

  .lg\\:hover\\:rotate-1:hover {
    --transform-rotate: 1deg;
  }

  .lg\\:hover\\:rotate-2:hover {
    --transform-rotate: 2deg;
  }

  .lg\\:hover\\:rotate-3:hover {
    --transform-rotate: 3deg;
  }

  .lg\\:hover\\:rotate-6:hover {
    --transform-rotate: 6deg;
  }

  .lg\\:hover\\:rotate-12:hover {
    --transform-rotate: 12deg;
  }

  .lg\\:hover\\:rotate-45:hover {
    --transform-rotate: 45deg;
  }

  .lg\\:hover\\:rotate-90:hover {
    --transform-rotate: 90deg;
  }

  .lg\\:hover\\:rotate-180:hover {
    --transform-rotate: 180deg;
  }

  .lg\\:hover\\:-rotate-180:hover {
    --transform-rotate: -180deg;
  }

  .lg\\:hover\\:-rotate-90:hover {
    --transform-rotate: -90deg;
  }

  .lg\\:hover\\:-rotate-45:hover {
    --transform-rotate: -45deg;
  }

  .lg\\:hover\\:-rotate-12:hover {
    --transform-rotate: -12deg;
  }

  .lg\\:hover\\:-rotate-6:hover {
    --transform-rotate: -6deg;
  }

  .lg\\:hover\\:-rotate-3:hover {
    --transform-rotate: -3deg;
  }

  .lg\\:hover\\:-rotate-2:hover {
    --transform-rotate: -2deg;
  }

  .lg\\:hover\\:-rotate-1:hover {
    --transform-rotate: -1deg;
  }

  .lg\\:focus\\:rotate-0:focus {
    --transform-rotate: 0;
  }

  .lg\\:focus\\:rotate-1:focus {
    --transform-rotate: 1deg;
  }

  .lg\\:focus\\:rotate-2:focus {
    --transform-rotate: 2deg;
  }

  .lg\\:focus\\:rotate-3:focus {
    --transform-rotate: 3deg;
  }

  .lg\\:focus\\:rotate-6:focus {
    --transform-rotate: 6deg;
  }

  .lg\\:focus\\:rotate-12:focus {
    --transform-rotate: 12deg;
  }

  .lg\\:focus\\:rotate-45:focus {
    --transform-rotate: 45deg;
  }

  .lg\\:focus\\:rotate-90:focus {
    --transform-rotate: 90deg;
  }

  .lg\\:focus\\:rotate-180:focus {
    --transform-rotate: 180deg;
  }

  .lg\\:focus\\:-rotate-180:focus {
    --transform-rotate: -180deg;
  }

  .lg\\:focus\\:-rotate-90:focus {
    --transform-rotate: -90deg;
  }

  .lg\\:focus\\:-rotate-45:focus {
    --transform-rotate: -45deg;
  }

  .lg\\:focus\\:-rotate-12:focus {
    --transform-rotate: -12deg;
  }

  .lg\\:focus\\:-rotate-6:focus {
    --transform-rotate: -6deg;
  }

  .lg\\:focus\\:-rotate-3:focus {
    --transform-rotate: -3deg;
  }

  .lg\\:focus\\:-rotate-2:focus {
    --transform-rotate: -2deg;
  }

  .lg\\:focus\\:-rotate-1:focus {
    --transform-rotate: -1deg;
  }

  .lg\\:translate-x-0 {
    --transform-translate-x: 0;
  }

  .lg\\:translate-x-1 {
    --transform-translate-x: 0.25rem;
  }

  .lg\\:translate-x-2 {
    --transform-translate-x: 0.5rem;
  }

  .lg\\:translate-x-3 {
    --transform-translate-x: 0.75rem;
  }

  .lg\\:translate-x-4 {
    --transform-translate-x: 1rem;
  }

  .lg\\:translate-x-5 {
    --transform-translate-x: 1.25rem;
  }

  .lg\\:translate-x-6 {
    --transform-translate-x: 1.5rem;
  }

  .lg\\:translate-x-8 {
    --transform-translate-x: 2rem;
  }

  .lg\\:translate-x-10 {
    --transform-translate-x: 2.5rem;
  }

  .lg\\:translate-x-12 {
    --transform-translate-x: 3rem;
  }

  .lg\\:translate-x-16 {
    --transform-translate-x: 4rem;
  }

  .lg\\:translate-x-20 {
    --transform-translate-x: 5rem;
  }

  .lg\\:translate-x-24 {
    --transform-translate-x: 6rem;
  }

  .lg\\:translate-x-32 {
    --transform-translate-x: 8rem;
  }

  .lg\\:translate-x-40 {
    --transform-translate-x: 10rem;
  }

  .lg\\:translate-x-48 {
    --transform-translate-x: 12rem;
  }

  .lg\\:translate-x-56 {
    --transform-translate-x: 14rem;
  }

  .lg\\:translate-x-64 {
    --transform-translate-x: 16rem;
  }

  .lg\\:translate-x-px {
    --transform-translate-x: 1px;
  }

  .lg\\:-translate-x-1 {
    --transform-translate-x: -0.25rem;
  }

  .lg\\:-translate-x-2 {
    --transform-translate-x: -0.5rem;
  }

  .lg\\:-translate-x-3 {
    --transform-translate-x: -0.75rem;
  }

  .lg\\:-translate-x-4 {
    --transform-translate-x: -1rem;
  }

  .lg\\:-translate-x-5 {
    --transform-translate-x: -1.25rem;
  }

  .lg\\:-translate-x-6 {
    --transform-translate-x: -1.5rem;
  }

  .lg\\:-translate-x-8 {
    --transform-translate-x: -2rem;
  }

  .lg\\:-translate-x-10 {
    --transform-translate-x: -2.5rem;
  }

  .lg\\:-translate-x-12 {
    --transform-translate-x: -3rem;
  }

  .lg\\:-translate-x-16 {
    --transform-translate-x: -4rem;
  }

  .lg\\:-translate-x-20 {
    --transform-translate-x: -5rem;
  }

  .lg\\:-translate-x-24 {
    --transform-translate-x: -6rem;
  }

  .lg\\:-translate-x-32 {
    --transform-translate-x: -8rem;
  }

  .lg\\:-translate-x-40 {
    --transform-translate-x: -10rem;
  }

  .lg\\:-translate-x-48 {
    --transform-translate-x: -12rem;
  }

  .lg\\:-translate-x-56 {
    --transform-translate-x: -14rem;
  }

  .lg\\:-translate-x-64 {
    --transform-translate-x: -16rem;
  }

  .lg\\:-translate-x-px {
    --transform-translate-x: -1px;
  }

  .lg\\:-translate-x-full {
    --transform-translate-x: -100%;
  }

  .lg\\:-translate-x-1\\/2 {
    --transform-translate-x: -50%;
  }

  .lg\\:translate-x-1\\/2 {
    --transform-translate-x: 50%;
  }

  .lg\\:translate-x-full {
    --transform-translate-x: 100%;
  }

  .lg\\:translate-y-0 {
    --transform-translate-y: 0;
  }

  .lg\\:translate-y-1 {
    --transform-translate-y: 0.25rem;
  }

  .lg\\:translate-y-2 {
    --transform-translate-y: 0.5rem;
  }

  .lg\\:translate-y-3 {
    --transform-translate-y: 0.75rem;
  }

  .lg\\:translate-y-4 {
    --transform-translate-y: 1rem;
  }

  .lg\\:translate-y-5 {
    --transform-translate-y: 1.25rem;
  }

  .lg\\:translate-y-6 {
    --transform-translate-y: 1.5rem;
  }

  .lg\\:translate-y-8 {
    --transform-translate-y: 2rem;
  }

  .lg\\:translate-y-10 {
    --transform-translate-y: 2.5rem;
  }

  .lg\\:translate-y-12 {
    --transform-translate-y: 3rem;
  }

  .lg\\:translate-y-16 {
    --transform-translate-y: 4rem;
  }

  .lg\\:translate-y-20 {
    --transform-translate-y: 5rem;
  }

  .lg\\:translate-y-24 {
    --transform-translate-y: 6rem;
  }

  .lg\\:translate-y-32 {
    --transform-translate-y: 8rem;
  }

  .lg\\:translate-y-40 {
    --transform-translate-y: 10rem;
  }

  .lg\\:translate-y-48 {
    --transform-translate-y: 12rem;
  }

  .lg\\:translate-y-56 {
    --transform-translate-y: 14rem;
  }

  .lg\\:translate-y-64 {
    --transform-translate-y: 16rem;
  }

  .lg\\:translate-y-px {
    --transform-translate-y: 1px;
  }

  .lg\\:-translate-y-1 {
    --transform-translate-y: -0.25rem;
  }

  .lg\\:-translate-y-2 {
    --transform-translate-y: -0.5rem;
  }

  .lg\\:-translate-y-3 {
    --transform-translate-y: -0.75rem;
  }

  .lg\\:-translate-y-4 {
    --transform-translate-y: -1rem;
  }

  .lg\\:-translate-y-5 {
    --transform-translate-y: -1.25rem;
  }

  .lg\\:-translate-y-6 {
    --transform-translate-y: -1.5rem;
  }

  .lg\\:-translate-y-8 {
    --transform-translate-y: -2rem;
  }

  .lg\\:-translate-y-10 {
    --transform-translate-y: -2.5rem;
  }

  .lg\\:-translate-y-12 {
    --transform-translate-y: -3rem;
  }

  .lg\\:-translate-y-16 {
    --transform-translate-y: -4rem;
  }

  .lg\\:-translate-y-20 {
    --transform-translate-y: -5rem;
  }

  .lg\\:-translate-y-24 {
    --transform-translate-y: -6rem;
  }

  .lg\\:-translate-y-32 {
    --transform-translate-y: -8rem;
  }

  .lg\\:-translate-y-40 {
    --transform-translate-y: -10rem;
  }

  .lg\\:-translate-y-48 {
    --transform-translate-y: -12rem;
  }

  .lg\\:-translate-y-56 {
    --transform-translate-y: -14rem;
  }

  .lg\\:-translate-y-64 {
    --transform-translate-y: -16rem;
  }

  .lg\\:-translate-y-px {
    --transform-translate-y: -1px;
  }

  .lg\\:-translate-y-full {
    --transform-translate-y: -100%;
  }

  .lg\\:-translate-y-1\\/2 {
    --transform-translate-y: -50%;
  }

  .lg\\:translate-y-1\\/2 {
    --transform-translate-y: 50%;
  }

  .lg\\:translate-y-full {
    --transform-translate-y: 100%;
  }

  .lg\\:hover\\:translate-x-0:hover {
    --transform-translate-x: 0;
  }

  .lg\\:hover\\:translate-x-1:hover {
    --transform-translate-x: 0.25rem;
  }

  .lg\\:hover\\:translate-x-2:hover {
    --transform-translate-x: 0.5rem;
  }

  .lg\\:hover\\:translate-x-3:hover {
    --transform-translate-x: 0.75rem;
  }

  .lg\\:hover\\:translate-x-4:hover {
    --transform-translate-x: 1rem;
  }

  .lg\\:hover\\:translate-x-5:hover {
    --transform-translate-x: 1.25rem;
  }

  .lg\\:hover\\:translate-x-6:hover {
    --transform-translate-x: 1.5rem;
  }

  .lg\\:hover\\:translate-x-8:hover {
    --transform-translate-x: 2rem;
  }

  .lg\\:hover\\:translate-x-10:hover {
    --transform-translate-x: 2.5rem;
  }

  .lg\\:hover\\:translate-x-12:hover {
    --transform-translate-x: 3rem;
  }

  .lg\\:hover\\:translate-x-16:hover {
    --transform-translate-x: 4rem;
  }

  .lg\\:hover\\:translate-x-20:hover {
    --transform-translate-x: 5rem;
  }

  .lg\\:hover\\:translate-x-24:hover {
    --transform-translate-x: 6rem;
  }

  .lg\\:hover\\:translate-x-32:hover {
    --transform-translate-x: 8rem;
  }

  .lg\\:hover\\:translate-x-40:hover {
    --transform-translate-x: 10rem;
  }

  .lg\\:hover\\:translate-x-48:hover {
    --transform-translate-x: 12rem;
  }

  .lg\\:hover\\:translate-x-56:hover {
    --transform-translate-x: 14rem;
  }

  .lg\\:hover\\:translate-x-64:hover {
    --transform-translate-x: 16rem;
  }

  .lg\\:hover\\:translate-x-px:hover {
    --transform-translate-x: 1px;
  }

  .lg\\:hover\\:-translate-x-1:hover {
    --transform-translate-x: -0.25rem;
  }

  .lg\\:hover\\:-translate-x-2:hover {
    --transform-translate-x: -0.5rem;
  }

  .lg\\:hover\\:-translate-x-3:hover {
    --transform-translate-x: -0.75rem;
  }

  .lg\\:hover\\:-translate-x-4:hover {
    --transform-translate-x: -1rem;
  }

  .lg\\:hover\\:-translate-x-5:hover {
    --transform-translate-x: -1.25rem;
  }

  .lg\\:hover\\:-translate-x-6:hover {
    --transform-translate-x: -1.5rem;
  }

  .lg\\:hover\\:-translate-x-8:hover {
    --transform-translate-x: -2rem;
  }

  .lg\\:hover\\:-translate-x-10:hover {
    --transform-translate-x: -2.5rem;
  }

  .lg\\:hover\\:-translate-x-12:hover {
    --transform-translate-x: -3rem;
  }

  .lg\\:hover\\:-translate-x-16:hover {
    --transform-translate-x: -4rem;
  }

  .lg\\:hover\\:-translate-x-20:hover {
    --transform-translate-x: -5rem;
  }

  .lg\\:hover\\:-translate-x-24:hover {
    --transform-translate-x: -6rem;
  }

  .lg\\:hover\\:-translate-x-32:hover {
    --transform-translate-x: -8rem;
  }

  .lg\\:hover\\:-translate-x-40:hover {
    --transform-translate-x: -10rem;
  }

  .lg\\:hover\\:-translate-x-48:hover {
    --transform-translate-x: -12rem;
  }

  .lg\\:hover\\:-translate-x-56:hover {
    --transform-translate-x: -14rem;
  }

  .lg\\:hover\\:-translate-x-64:hover {
    --transform-translate-x: -16rem;
  }

  .lg\\:hover\\:-translate-x-px:hover {
    --transform-translate-x: -1px;
  }

  .lg\\:hover\\:-translate-x-full:hover {
    --transform-translate-x: -100%;
  }

  .lg\\:hover\\:-translate-x-1\\/2:hover {
    --transform-translate-x: -50%;
  }

  .lg\\:hover\\:translate-x-1\\/2:hover {
    --transform-translate-x: 50%;
  }

  .lg\\:hover\\:translate-x-full:hover {
    --transform-translate-x: 100%;
  }

  .lg\\:hover\\:translate-y-0:hover {
    --transform-translate-y: 0;
  }

  .lg\\:hover\\:translate-y-1:hover {
    --transform-translate-y: 0.25rem;
  }

  .lg\\:hover\\:translate-y-2:hover {
    --transform-translate-y: 0.5rem;
  }

  .lg\\:hover\\:translate-y-3:hover {
    --transform-translate-y: 0.75rem;
  }

  .lg\\:hover\\:translate-y-4:hover {
    --transform-translate-y: 1rem;
  }

  .lg\\:hover\\:translate-y-5:hover {
    --transform-translate-y: 1.25rem;
  }

  .lg\\:hover\\:translate-y-6:hover {
    --transform-translate-y: 1.5rem;
  }

  .lg\\:hover\\:translate-y-8:hover {
    --transform-translate-y: 2rem;
  }

  .lg\\:hover\\:translate-y-10:hover {
    --transform-translate-y: 2.5rem;
  }

  .lg\\:hover\\:translate-y-12:hover {
    --transform-translate-y: 3rem;
  }

  .lg\\:hover\\:translate-y-16:hover {
    --transform-translate-y: 4rem;
  }

  .lg\\:hover\\:translate-y-20:hover {
    --transform-translate-y: 5rem;
  }

  .lg\\:hover\\:translate-y-24:hover {
    --transform-translate-y: 6rem;
  }

  .lg\\:hover\\:translate-y-32:hover {
    --transform-translate-y: 8rem;
  }

  .lg\\:hover\\:translate-y-40:hover {
    --transform-translate-y: 10rem;
  }

  .lg\\:hover\\:translate-y-48:hover {
    --transform-translate-y: 12rem;
  }

  .lg\\:hover\\:translate-y-56:hover {
    --transform-translate-y: 14rem;
  }

  .lg\\:hover\\:translate-y-64:hover {
    --transform-translate-y: 16rem;
  }

  .lg\\:hover\\:translate-y-px:hover {
    --transform-translate-y: 1px;
  }

  .lg\\:hover\\:-translate-y-1:hover {
    --transform-translate-y: -0.25rem;
  }

  .lg\\:hover\\:-translate-y-2:hover {
    --transform-translate-y: -0.5rem;
  }

  .lg\\:hover\\:-translate-y-3:hover {
    --transform-translate-y: -0.75rem;
  }

  .lg\\:hover\\:-translate-y-4:hover {
    --transform-translate-y: -1rem;
  }

  .lg\\:hover\\:-translate-y-5:hover {
    --transform-translate-y: -1.25rem;
  }

  .lg\\:hover\\:-translate-y-6:hover {
    --transform-translate-y: -1.5rem;
  }

  .lg\\:hover\\:-translate-y-8:hover {
    --transform-translate-y: -2rem;
  }

  .lg\\:hover\\:-translate-y-10:hover {
    --transform-translate-y: -2.5rem;
  }

  .lg\\:hover\\:-translate-y-12:hover {
    --transform-translate-y: -3rem;
  }

  .lg\\:hover\\:-translate-y-16:hover {
    --transform-translate-y: -4rem;
  }

  .lg\\:hover\\:-translate-y-20:hover {
    --transform-translate-y: -5rem;
  }

  .lg\\:hover\\:-translate-y-24:hover {
    --transform-translate-y: -6rem;
  }

  .lg\\:hover\\:-translate-y-32:hover {
    --transform-translate-y: -8rem;
  }

  .lg\\:hover\\:-translate-y-40:hover {
    --transform-translate-y: -10rem;
  }

  .lg\\:hover\\:-translate-y-48:hover {
    --transform-translate-y: -12rem;
  }

  .lg\\:hover\\:-translate-y-56:hover {
    --transform-translate-y: -14rem;
  }

  .lg\\:hover\\:-translate-y-64:hover {
    --transform-translate-y: -16rem;
  }

  .lg\\:hover\\:-translate-y-px:hover {
    --transform-translate-y: -1px;
  }

  .lg\\:hover\\:-translate-y-full:hover {
    --transform-translate-y: -100%;
  }

  .lg\\:hover\\:-translate-y-1\\/2:hover {
    --transform-translate-y: -50%;
  }

  .lg\\:hover\\:translate-y-1\\/2:hover {
    --transform-translate-y: 50%;
  }

  .lg\\:hover\\:translate-y-full:hover {
    --transform-translate-y: 100%;
  }

  .lg\\:focus\\:translate-x-0:focus {
    --transform-translate-x: 0;
  }

  .lg\\:focus\\:translate-x-1:focus {
    --transform-translate-x: 0.25rem;
  }

  .lg\\:focus\\:translate-x-2:focus {
    --transform-translate-x: 0.5rem;
  }

  .lg\\:focus\\:translate-x-3:focus {
    --transform-translate-x: 0.75rem;
  }

  .lg\\:focus\\:translate-x-4:focus {
    --transform-translate-x: 1rem;
  }

  .lg\\:focus\\:translate-x-5:focus {
    --transform-translate-x: 1.25rem;
  }

  .lg\\:focus\\:translate-x-6:focus {
    --transform-translate-x: 1.5rem;
  }

  .lg\\:focus\\:translate-x-8:focus {
    --transform-translate-x: 2rem;
  }

  .lg\\:focus\\:translate-x-10:focus {
    --transform-translate-x: 2.5rem;
  }

  .lg\\:focus\\:translate-x-12:focus {
    --transform-translate-x: 3rem;
  }

  .lg\\:focus\\:translate-x-16:focus {
    --transform-translate-x: 4rem;
  }

  .lg\\:focus\\:translate-x-20:focus {
    --transform-translate-x: 5rem;
  }

  .lg\\:focus\\:translate-x-24:focus {
    --transform-translate-x: 6rem;
  }

  .lg\\:focus\\:translate-x-32:focus {
    --transform-translate-x: 8rem;
  }

  .lg\\:focus\\:translate-x-40:focus {
    --transform-translate-x: 10rem;
  }

  .lg\\:focus\\:translate-x-48:focus {
    --transform-translate-x: 12rem;
  }

  .lg\\:focus\\:translate-x-56:focus {
    --transform-translate-x: 14rem;
  }

  .lg\\:focus\\:translate-x-64:focus {
    --transform-translate-x: 16rem;
  }

  .lg\\:focus\\:translate-x-px:focus {
    --transform-translate-x: 1px;
  }

  .lg\\:focus\\:-translate-x-1:focus {
    --transform-translate-x: -0.25rem;
  }

  .lg\\:focus\\:-translate-x-2:focus {
    --transform-translate-x: -0.5rem;
  }

  .lg\\:focus\\:-translate-x-3:focus {
    --transform-translate-x: -0.75rem;
  }

  .lg\\:focus\\:-translate-x-4:focus {
    --transform-translate-x: -1rem;
  }

  .lg\\:focus\\:-translate-x-5:focus {
    --transform-translate-x: -1.25rem;
  }

  .lg\\:focus\\:-translate-x-6:focus {
    --transform-translate-x: -1.5rem;
  }

  .lg\\:focus\\:-translate-x-8:focus {
    --transform-translate-x: -2rem;
  }

  .lg\\:focus\\:-translate-x-10:focus {
    --transform-translate-x: -2.5rem;
  }

  .lg\\:focus\\:-translate-x-12:focus {
    --transform-translate-x: -3rem;
  }

  .lg\\:focus\\:-translate-x-16:focus {
    --transform-translate-x: -4rem;
  }

  .lg\\:focus\\:-translate-x-20:focus {
    --transform-translate-x: -5rem;
  }

  .lg\\:focus\\:-translate-x-24:focus {
    --transform-translate-x: -6rem;
  }

  .lg\\:focus\\:-translate-x-32:focus {
    --transform-translate-x: -8rem;
  }

  .lg\\:focus\\:-translate-x-40:focus {
    --transform-translate-x: -10rem;
  }

  .lg\\:focus\\:-translate-x-48:focus {
    --transform-translate-x: -12rem;
  }

  .lg\\:focus\\:-translate-x-56:focus {
    --transform-translate-x: -14rem;
  }

  .lg\\:focus\\:-translate-x-64:focus {
    --transform-translate-x: -16rem;
  }

  .lg\\:focus\\:-translate-x-px:focus {
    --transform-translate-x: -1px;
  }

  .lg\\:focus\\:-translate-x-full:focus {
    --transform-translate-x: -100%;
  }

  .lg\\:focus\\:-translate-x-1\\/2:focus {
    --transform-translate-x: -50%;
  }

  .lg\\:focus\\:translate-x-1\\/2:focus {
    --transform-translate-x: 50%;
  }

  .lg\\:focus\\:translate-x-full:focus {
    --transform-translate-x: 100%;
  }

  .lg\\:focus\\:translate-y-0:focus {
    --transform-translate-y: 0;
  }

  .lg\\:focus\\:translate-y-1:focus {
    --transform-translate-y: 0.25rem;
  }

  .lg\\:focus\\:translate-y-2:focus {
    --transform-translate-y: 0.5rem;
  }

  .lg\\:focus\\:translate-y-3:focus {
    --transform-translate-y: 0.75rem;
  }

  .lg\\:focus\\:translate-y-4:focus {
    --transform-translate-y: 1rem;
  }

  .lg\\:focus\\:translate-y-5:focus {
    --transform-translate-y: 1.25rem;
  }

  .lg\\:focus\\:translate-y-6:focus {
    --transform-translate-y: 1.5rem;
  }

  .lg\\:focus\\:translate-y-8:focus {
    --transform-translate-y: 2rem;
  }

  .lg\\:focus\\:translate-y-10:focus {
    --transform-translate-y: 2.5rem;
  }

  .lg\\:focus\\:translate-y-12:focus {
    --transform-translate-y: 3rem;
  }

  .lg\\:focus\\:translate-y-16:focus {
    --transform-translate-y: 4rem;
  }

  .lg\\:focus\\:translate-y-20:focus {
    --transform-translate-y: 5rem;
  }

  .lg\\:focus\\:translate-y-24:focus {
    --transform-translate-y: 6rem;
  }

  .lg\\:focus\\:translate-y-32:focus {
    --transform-translate-y: 8rem;
  }

  .lg\\:focus\\:translate-y-40:focus {
    --transform-translate-y: 10rem;
  }

  .lg\\:focus\\:translate-y-48:focus {
    --transform-translate-y: 12rem;
  }

  .lg\\:focus\\:translate-y-56:focus {
    --transform-translate-y: 14rem;
  }

  .lg\\:focus\\:translate-y-64:focus {
    --transform-translate-y: 16rem;
  }

  .lg\\:focus\\:translate-y-px:focus {
    --transform-translate-y: 1px;
  }

  .lg\\:focus\\:-translate-y-1:focus {
    --transform-translate-y: -0.25rem;
  }

  .lg\\:focus\\:-translate-y-2:focus {
    --transform-translate-y: -0.5rem;
  }

  .lg\\:focus\\:-translate-y-3:focus {
    --transform-translate-y: -0.75rem;
  }

  .lg\\:focus\\:-translate-y-4:focus {
    --transform-translate-y: -1rem;
  }

  .lg\\:focus\\:-translate-y-5:focus {
    --transform-translate-y: -1.25rem;
  }

  .lg\\:focus\\:-translate-y-6:focus {
    --transform-translate-y: -1.5rem;
  }

  .lg\\:focus\\:-translate-y-8:focus {
    --transform-translate-y: -2rem;
  }

  .lg\\:focus\\:-translate-y-10:focus {
    --transform-translate-y: -2.5rem;
  }

  .lg\\:focus\\:-translate-y-12:focus {
    --transform-translate-y: -3rem;
  }

  .lg\\:focus\\:-translate-y-16:focus {
    --transform-translate-y: -4rem;
  }

  .lg\\:focus\\:-translate-y-20:focus {
    --transform-translate-y: -5rem;
  }

  .lg\\:focus\\:-translate-y-24:focus {
    --transform-translate-y: -6rem;
  }

  .lg\\:focus\\:-translate-y-32:focus {
    --transform-translate-y: -8rem;
  }

  .lg\\:focus\\:-translate-y-40:focus {
    --transform-translate-y: -10rem;
  }

  .lg\\:focus\\:-translate-y-48:focus {
    --transform-translate-y: -12rem;
  }

  .lg\\:focus\\:-translate-y-56:focus {
    --transform-translate-y: -14rem;
  }

  .lg\\:focus\\:-translate-y-64:focus {
    --transform-translate-y: -16rem;
  }

  .lg\\:focus\\:-translate-y-px:focus {
    --transform-translate-y: -1px;
  }

  .lg\\:focus\\:-translate-y-full:focus {
    --transform-translate-y: -100%;
  }

  .lg\\:focus\\:-translate-y-1\\/2:focus {
    --transform-translate-y: -50%;
  }

  .lg\\:focus\\:translate-y-1\\/2:focus {
    --transform-translate-y: 50%;
  }

  .lg\\:focus\\:translate-y-full:focus {
    --transform-translate-y: 100%;
  }

  .lg\\:skew-x-0 {
    --transform-skew-x: 0;
  }

  .lg\\:skew-x-1 {
    --transform-skew-x: 1deg;
  }

  .lg\\:skew-x-2 {
    --transform-skew-x: 2deg;
  }

  .lg\\:skew-x-3 {
    --transform-skew-x: 3deg;
  }

  .lg\\:skew-x-6 {
    --transform-skew-x: 6deg;
  }

  .lg\\:skew-x-12 {
    --transform-skew-x: 12deg;
  }

  .lg\\:-skew-x-12 {
    --transform-skew-x: -12deg;
  }

  .lg\\:-skew-x-6 {
    --transform-skew-x: -6deg;
  }

  .lg\\:-skew-x-3 {
    --transform-skew-x: -3deg;
  }

  .lg\\:-skew-x-2 {
    --transform-skew-x: -2deg;
  }

  .lg\\:-skew-x-1 {
    --transform-skew-x: -1deg;
  }

  .lg\\:skew-y-0 {
    --transform-skew-y: 0;
  }

  .lg\\:skew-y-1 {
    --transform-skew-y: 1deg;
  }

  .lg\\:skew-y-2 {
    --transform-skew-y: 2deg;
  }

  .lg\\:skew-y-3 {
    --transform-skew-y: 3deg;
  }

  .lg\\:skew-y-6 {
    --transform-skew-y: 6deg;
  }

  .lg\\:skew-y-12 {
    --transform-skew-y: 12deg;
  }

  .lg\\:-skew-y-12 {
    --transform-skew-y: -12deg;
  }

  .lg\\:-skew-y-6 {
    --transform-skew-y: -6deg;
  }

  .lg\\:-skew-y-3 {
    --transform-skew-y: -3deg;
  }

  .lg\\:-skew-y-2 {
    --transform-skew-y: -2deg;
  }

  .lg\\:-skew-y-1 {
    --transform-skew-y: -1deg;
  }

  .lg\\:hover\\:skew-x-0:hover {
    --transform-skew-x: 0;
  }

  .lg\\:hover\\:skew-x-1:hover {
    --transform-skew-x: 1deg;
  }

  .lg\\:hover\\:skew-x-2:hover {
    --transform-skew-x: 2deg;
  }

  .lg\\:hover\\:skew-x-3:hover {
    --transform-skew-x: 3deg;
  }

  .lg\\:hover\\:skew-x-6:hover {
    --transform-skew-x: 6deg;
  }

  .lg\\:hover\\:skew-x-12:hover {
    --transform-skew-x: 12deg;
  }

  .lg\\:hover\\:-skew-x-12:hover {
    --transform-skew-x: -12deg;
  }

  .lg\\:hover\\:-skew-x-6:hover {
    --transform-skew-x: -6deg;
  }

  .lg\\:hover\\:-skew-x-3:hover {
    --transform-skew-x: -3deg;
  }

  .lg\\:hover\\:-skew-x-2:hover {
    --transform-skew-x: -2deg;
  }

  .lg\\:hover\\:-skew-x-1:hover {
    --transform-skew-x: -1deg;
  }

  .lg\\:hover\\:skew-y-0:hover {
    --transform-skew-y: 0;
  }

  .lg\\:hover\\:skew-y-1:hover {
    --transform-skew-y: 1deg;
  }

  .lg\\:hover\\:skew-y-2:hover {
    --transform-skew-y: 2deg;
  }

  .lg\\:hover\\:skew-y-3:hover {
    --transform-skew-y: 3deg;
  }

  .lg\\:hover\\:skew-y-6:hover {
    --transform-skew-y: 6deg;
  }

  .lg\\:hover\\:skew-y-12:hover {
    --transform-skew-y: 12deg;
  }

  .lg\\:hover\\:-skew-y-12:hover {
    --transform-skew-y: -12deg;
  }

  .lg\\:hover\\:-skew-y-6:hover {
    --transform-skew-y: -6deg;
  }

  .lg\\:hover\\:-skew-y-3:hover {
    --transform-skew-y: -3deg;
  }

  .lg\\:hover\\:-skew-y-2:hover {
    --transform-skew-y: -2deg;
  }

  .lg\\:hover\\:-skew-y-1:hover {
    --transform-skew-y: -1deg;
  }

  .lg\\:focus\\:skew-x-0:focus {
    --transform-skew-x: 0;
  }

  .lg\\:focus\\:skew-x-1:focus {
    --transform-skew-x: 1deg;
  }

  .lg\\:focus\\:skew-x-2:focus {
    --transform-skew-x: 2deg;
  }

  .lg\\:focus\\:skew-x-3:focus {
    --transform-skew-x: 3deg;
  }

  .lg\\:focus\\:skew-x-6:focus {
    --transform-skew-x: 6deg;
  }

  .lg\\:focus\\:skew-x-12:focus {
    --transform-skew-x: 12deg;
  }

  .lg\\:focus\\:-skew-x-12:focus {
    --transform-skew-x: -12deg;
  }

  .lg\\:focus\\:-skew-x-6:focus {
    --transform-skew-x: -6deg;
  }

  .lg\\:focus\\:-skew-x-3:focus {
    --transform-skew-x: -3deg;
  }

  .lg\\:focus\\:-skew-x-2:focus {
    --transform-skew-x: -2deg;
  }

  .lg\\:focus\\:-skew-x-1:focus {
    --transform-skew-x: -1deg;
  }

  .lg\\:focus\\:skew-y-0:focus {
    --transform-skew-y: 0;
  }

  .lg\\:focus\\:skew-y-1:focus {
    --transform-skew-y: 1deg;
  }

  .lg\\:focus\\:skew-y-2:focus {
    --transform-skew-y: 2deg;
  }

  .lg\\:focus\\:skew-y-3:focus {
    --transform-skew-y: 3deg;
  }

  .lg\\:focus\\:skew-y-6:focus {
    --transform-skew-y: 6deg;
  }

  .lg\\:focus\\:skew-y-12:focus {
    --transform-skew-y: 12deg;
  }

  .lg\\:focus\\:-skew-y-12:focus {
    --transform-skew-y: -12deg;
  }

  .lg\\:focus\\:-skew-y-6:focus {
    --transform-skew-y: -6deg;
  }

  .lg\\:focus\\:-skew-y-3:focus {
    --transform-skew-y: -3deg;
  }

  .lg\\:focus\\:-skew-y-2:focus {
    --transform-skew-y: -2deg;
  }

  .lg\\:focus\\:-skew-y-1:focus {
    --transform-skew-y: -1deg;
  }

  .lg\\:transition-none {
    transition-property: none;
  }

  .lg\\:transition-all {
    transition-property: all;
  }

  .lg\\:transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .lg\\:transition-colors {
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .lg\\:transition-opacity {
    transition-property: opacity;
  }

  .lg\\:transition-shadow {
    transition-property: box-shadow;
  }

  .lg\\:transition-transform {
    transition-property: transform;
  }

  .lg\\:ease-linear {
    transition-timing-function: linear;
  }

  .lg\\:ease-in {
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .lg\\:ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .lg\\:ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .lg\\:duration-75 {
    transition-duration: 75ms;
  }

  .lg\\:duration-100 {
    transition-duration: 100ms;
  }

  .lg\\:duration-150 {
    transition-duration: 150ms;
  }

  .lg\\:duration-200 {
    transition-duration: 200ms;
  }

  .lg\\:duration-300 {
    transition-duration: 300ms;
  }

  .lg\\:duration-500 {
    transition-duration: 500ms;
  }

  .lg\\:duration-700 {
    transition-duration: 700ms;
  }

  .lg\\:duration-1000 {
    transition-duration: 1000ms;
  }

  .lg\\:delay-75 {
    transition-delay: 75ms;
  }

  .lg\\:delay-100 {
    transition-delay: 100ms;
  }

  .lg\\:delay-150 {
    transition-delay: 150ms;
  }

  .lg\\:delay-200 {
    transition-delay: 200ms;
  }

  .lg\\:delay-300 {
    transition-delay: 300ms;
  }

  .lg\\:delay-500 {
    transition-delay: 500ms;
  }

  .lg\\:delay-700 {
    transition-delay: 700ms;
  }

  .lg\\:delay-1000 {
    transition-delay: 1000ms;
  }

  .lg\\:animate-none {
    animation: none;
  }

  .lg\\:animate-spin {
    animation: spin 1s linear infinite;
  }

  .lg\\:animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .lg\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .lg\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}

@media (min-width: 1280px) {
  .xl\\:container {
    width: 100%;
  }
}

@media (min-width: 1280px) and (min-width: 640px) {
  .xl\\:container {
    max-width: 640px;
  }
}

@media (min-width: 1280px) and (min-width: 768px) {
  .xl\\:container {
    max-width: 768px;
  }
}

@media (min-width: 1280px) and (min-width: 1024px) {
  .xl\\:container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) and (min-width: 1280px) {
  .xl\\:container {
    max-width: 1280px;
  }
}

@media (min-width: 1280px) {
  .xl\\:space-y-0 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .xl\\:space-x-0 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-1 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .xl\\:space-x-1 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-2 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-2 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-3 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .xl\\:space-x-3 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-4 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .xl\\:space-x-4 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-5 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .xl\\:space-x-5 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-6 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-6 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-8 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .xl\\:space-x-8 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-10 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-10 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-12 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .xl\\:space-x-12 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-16 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .xl\\:space-x-16 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-20 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-20 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-24 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .xl\\:space-x-24 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-32 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .xl\\:space-x-32 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-40 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .xl\\:space-x-40 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-48 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .xl\\:space-x-48 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-56 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .xl\\:space-x-56 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-64 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .xl\\:space-x-64 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-px > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .xl\\:space-x-px > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-1 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-1 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-2 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-2 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-3 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-3 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-4 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-4 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-5 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-5 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-6 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-6 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-8 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-8 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-10 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-10 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-12 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-12 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-16 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-16 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-20 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-20 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-24 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-24 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-32 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-32 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-40 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-40 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-48 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-48 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-56 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-56 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-64 > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-64 > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-px > :not(template) ~ :not(template) {
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .xl\\:-space-x-px > :not(template) ~ :not(template) {
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-reverse > :not(template) ~ :not(template) {
    --space-y-reverse: 1;
  }

  .xl\\:space-x-reverse > :not(template) ~ :not(template) {
    --space-x-reverse: 1;
  }

  .xl\\:divide-y-0 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-0 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-2 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-2 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-4 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-4 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-8 > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-8 > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y > :not(template) ~ :not(template) {
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .xl\\:divide-x > :not(template) ~ :not(template) {
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-reverse > :not(template) ~ :not(template) {
    --divide-y-reverse: 1;
  }

  .xl\\:divide-x-reverse > :not(template) ~ :not(template) {
    --divide-x-reverse: 1;
  }

  .xl\\:divide-transparent > :not(template) ~ :not(template) {
    border-color: transparent;
  }

  .xl\\:divide-current > :not(template) ~ :not(template) {
    border-color: currentColor;
  }

  .xl\\:divide-black > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .xl\\:divide-white > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .xl\\:divide-gray-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--divide-opacity));
  }

  .xl\\:divide-gray-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--divide-opacity));
  }

  .xl\\:divide-gray-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--divide-opacity));
  }

  .xl\\:divide-gray-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--divide-opacity));
  }

  .xl\\:divide-gray-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--divide-opacity));
  }

  .xl\\:divide-gray-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--divide-opacity));
  }

  .xl\\:divide-gray-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--divide-opacity));
  }

  .xl\\:divide-gray-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--divide-opacity));
  }

  .xl\\:divide-gray-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--divide-opacity));
  }

  .xl\\:divide-red-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--divide-opacity));
  }

  .xl\\:divide-red-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--divide-opacity));
  }

  .xl\\:divide-red-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--divide-opacity));
  }

  .xl\\:divide-red-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--divide-opacity));
  }

  .xl\\:divide-red-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--divide-opacity));
  }

  .xl\\:divide-red-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--divide-opacity));
  }

  .xl\\:divide-red-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--divide-opacity));
  }

  .xl\\:divide-red-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--divide-opacity));
  }

  .xl\\:divide-red-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--divide-opacity));
  }

  .xl\\:divide-orange-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--divide-opacity));
  }

  .xl\\:divide-orange-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--divide-opacity));
  }

  .xl\\:divide-orange-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--divide-opacity));
  }

  .xl\\:divide-orange-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--divide-opacity));
  }

  .xl\\:divide-orange-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--divide-opacity));
  }

  .xl\\:divide-orange-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--divide-opacity));
  }

  .xl\\:divide-orange-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--divide-opacity));
  }

  .xl\\:divide-orange-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--divide-opacity));
  }

  .xl\\:divide-orange-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--divide-opacity));
  }

  .xl\\:divide-yellow-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--divide-opacity));
  }

  .xl\\:divide-yellow-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--divide-opacity));
  }

  .xl\\:divide-yellow-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--divide-opacity));
  }

  .xl\\:divide-yellow-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--divide-opacity));
  }

  .xl\\:divide-yellow-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--divide-opacity));
  }

  .xl\\:divide-yellow-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--divide-opacity));
  }

  .xl\\:divide-yellow-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--divide-opacity));
  }

  .xl\\:divide-yellow-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--divide-opacity));
  }

  .xl\\:divide-yellow-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--divide-opacity));
  }

  .xl\\:divide-green-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--divide-opacity));
  }

  .xl\\:divide-green-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--divide-opacity));
  }

  .xl\\:divide-green-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--divide-opacity));
  }

  .xl\\:divide-green-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--divide-opacity));
  }

  .xl\\:divide-green-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--divide-opacity));
  }

  .xl\\:divide-green-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--divide-opacity));
  }

  .xl\\:divide-green-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--divide-opacity));
  }

  .xl\\:divide-green-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--divide-opacity));
  }

  .xl\\:divide-green-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--divide-opacity));
  }

  .xl\\:divide-teal-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--divide-opacity));
  }

  .xl\\:divide-teal-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--divide-opacity));
  }

  .xl\\:divide-teal-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--divide-opacity));
  }

  .xl\\:divide-teal-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--divide-opacity));
  }

  .xl\\:divide-teal-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--divide-opacity));
  }

  .xl\\:divide-teal-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--divide-opacity));
  }

  .xl\\:divide-teal-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--divide-opacity));
  }

  .xl\\:divide-teal-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--divide-opacity));
  }

  .xl\\:divide-teal-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--divide-opacity));
  }

  .xl\\:divide-blue-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--divide-opacity));
  }

  .xl\\:divide-blue-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--divide-opacity));
  }

  .xl\\:divide-blue-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--divide-opacity));
  }

  .xl\\:divide-blue-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--divide-opacity));
  }

  .xl\\:divide-blue-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--divide-opacity));
  }

  .xl\\:divide-blue-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--divide-opacity));
  }

  .xl\\:divide-blue-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--divide-opacity));
  }

  .xl\\:divide-blue-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--divide-opacity));
  }

  .xl\\:divide-blue-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--divide-opacity));
  }

  .xl\\:divide-indigo-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--divide-opacity));
  }

  .xl\\:divide-indigo-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--divide-opacity));
  }

  .xl\\:divide-indigo-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--divide-opacity));
  }

  .xl\\:divide-indigo-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--divide-opacity));
  }

  .xl\\:divide-indigo-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--divide-opacity));
  }

  .xl\\:divide-indigo-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--divide-opacity));
  }

  .xl\\:divide-indigo-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--divide-opacity));
  }

  .xl\\:divide-indigo-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--divide-opacity));
  }

  .xl\\:divide-indigo-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--divide-opacity));
  }

  .xl\\:divide-purple-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--divide-opacity));
  }

  .xl\\:divide-purple-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--divide-opacity));
  }

  .xl\\:divide-purple-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--divide-opacity));
  }

  .xl\\:divide-purple-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--divide-opacity));
  }

  .xl\\:divide-purple-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--divide-opacity));
  }

  .xl\\:divide-purple-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--divide-opacity));
  }

  .xl\\:divide-purple-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--divide-opacity));
  }

  .xl\\:divide-purple-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--divide-opacity));
  }

  .xl\\:divide-purple-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--divide-opacity));
  }

  .xl\\:divide-pink-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--divide-opacity));
  }

  .xl\\:divide-pink-200 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--divide-opacity));
  }

  .xl\\:divide-pink-300 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--divide-opacity));
  }

  .xl\\:divide-pink-400 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--divide-opacity));
  }

  .xl\\:divide-pink-500 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--divide-opacity));
  }

  .xl\\:divide-pink-600 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--divide-opacity));
  }

  .xl\\:divide-pink-700 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--divide-opacity));
  }

  .xl\\:divide-pink-800 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--divide-opacity));
  }

  .xl\\:divide-pink-900 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--divide-opacity));
  }

  .xl\\:divide-solid > :not(template) ~ :not(template) {
    border-style: solid;
  }

  .xl\\:divide-dashed > :not(template) ~ :not(template) {
    border-style: dashed;
  }

  .xl\\:divide-dotted > :not(template) ~ :not(template) {
    border-style: dotted;
  }

  .xl\\:divide-double > :not(template) ~ :not(template) {
    border-style: double;
  }

  .xl\\:divide-none > :not(template) ~ :not(template) {
    border-style: none;
  }

  .xl\\:divide-opacity-0 > :not(template) ~ :not(template) {
    --divide-opacity: 0;
  }

  .xl\\:divide-opacity-25 > :not(template) ~ :not(template) {
    --divide-opacity: 0.25;
  }

  .xl\\:divide-opacity-50 > :not(template) ~ :not(template) {
    --divide-opacity: 0.5;
  }

  .xl\\:divide-opacity-75 > :not(template) ~ :not(template) {
    --divide-opacity: 0.75;
  }

  .xl\\:divide-opacity-100 > :not(template) ~ :not(template) {
    --divide-opacity: 1;
  }

  .xl\\:sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .xl\\:not-sr-only {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .xl\\:focus\\:sr-only:focus {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .xl\\:focus\\:not-sr-only:focus {
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .xl\\:appearance-none {
    appearance: none;
  }

  .xl\\:bg-fixed {
    background-attachment: fixed;
  }

  .xl\\:bg-local {
    background-attachment: local;
  }

  .xl\\:bg-scroll {
    background-attachment: scroll;
  }

  .xl\\:bg-clip-border {
    background-clip: border-box;
  }

  .xl\\:bg-clip-padding {
    background-clip: padding-box;
  }

  .xl\\:bg-clip-content {
    background-clip: content-box;
  }

  .xl\\:bg-clip-text {
    -webkit-background-clip: text;
    background-clip: text;
  }

  .xl\\:bg-transparent {
    background-color: transparent;
  }

  .xl\\:bg-current {
    background-color: currentColor;
  }

  .xl\\:bg-black {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .xl\\:bg-white {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .xl\\:bg-gray-100 {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .xl\\:bg-gray-200 {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .xl\\:bg-gray-300 {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .xl\\:bg-gray-400 {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .xl\\:bg-gray-500 {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .xl\\:bg-gray-600 {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .xl\\:bg-gray-700 {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .xl\\:bg-gray-800 {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .xl\\:bg-gray-900 {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .xl\\:bg-red-100 {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .xl\\:bg-red-200 {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .xl\\:bg-red-300 {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .xl\\:bg-red-400 {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .xl\\:bg-red-500 {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .xl\\:bg-red-600 {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .xl\\:bg-red-700 {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .xl\\:bg-red-800 {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .xl\\:bg-red-900 {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .xl\\:bg-orange-100 {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .xl\\:bg-orange-200 {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .xl\\:bg-orange-300 {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .xl\\:bg-orange-400 {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .xl\\:bg-orange-500 {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .xl\\:bg-orange-600 {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .xl\\:bg-orange-700 {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .xl\\:bg-orange-800 {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .xl\\:bg-orange-900 {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .xl\\:bg-yellow-100 {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .xl\\:bg-yellow-200 {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .xl\\:bg-yellow-300 {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .xl\\:bg-yellow-400 {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .xl\\:bg-yellow-500 {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .xl\\:bg-yellow-600 {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .xl\\:bg-yellow-700 {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .xl\\:bg-yellow-800 {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .xl\\:bg-yellow-900 {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .xl\\:bg-green-100 {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .xl\\:bg-green-200 {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .xl\\:bg-green-300 {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .xl\\:bg-green-400 {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .xl\\:bg-green-500 {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .xl\\:bg-green-600 {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .xl\\:bg-green-700 {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .xl\\:bg-green-800 {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .xl\\:bg-green-900 {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .xl\\:bg-teal-100 {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .xl\\:bg-teal-200 {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .xl\\:bg-teal-300 {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .xl\\:bg-teal-400 {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .xl\\:bg-teal-500 {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .xl\\:bg-teal-600 {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .xl\\:bg-teal-700 {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .xl\\:bg-teal-800 {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .xl\\:bg-teal-900 {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .xl\\:bg-blue-100 {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .xl\\:bg-blue-200 {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .xl\\:bg-blue-300 {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .xl\\:bg-blue-400 {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .xl\\:bg-blue-500 {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .xl\\:bg-blue-600 {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .xl\\:bg-blue-700 {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .xl\\:bg-blue-800 {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .xl\\:bg-blue-900 {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .xl\\:bg-indigo-100 {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .xl\\:bg-indigo-200 {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .xl\\:bg-indigo-300 {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .xl\\:bg-indigo-400 {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .xl\\:bg-indigo-500 {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .xl\\:bg-indigo-600 {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .xl\\:bg-indigo-700 {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .xl\\:bg-indigo-800 {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .xl\\:bg-indigo-900 {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .xl\\:bg-purple-100 {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .xl\\:bg-purple-200 {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .xl\\:bg-purple-300 {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .xl\\:bg-purple-400 {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .xl\\:bg-purple-500 {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .xl\\:bg-purple-600 {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .xl\\:bg-purple-700 {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .xl\\:bg-purple-800 {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .xl\\:bg-purple-900 {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .xl\\:bg-pink-100 {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .xl\\:bg-pink-200 {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .xl\\:bg-pink-300 {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .xl\\:bg-pink-400 {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .xl\\:bg-pink-500 {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .xl\\:bg-pink-600 {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .xl\\:bg-pink-700 {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .xl\\:bg-pink-800 {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .xl\\:bg-pink-900 {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-transparent:hover {
    background-color: transparent;
  }

  .xl\\:hover\\:bg-current:hover {
    background-color: currentColor;
  }

  .xl\\:hover\\:bg-black:hover {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-white:hover {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-100:hover {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-200:hover {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-300:hover {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-400:hover {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-500:hover {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-600:hover {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-700:hover {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-800:hover {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-900:hover {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-100:hover {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-200:hover {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-300:hover {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-400:hover {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-500:hover {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-600:hover {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-700:hover {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-800:hover {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-900:hover {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-100:hover {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-200:hover {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-300:hover {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-400:hover {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-500:hover {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-600:hover {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-700:hover {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-800:hover {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-900:hover {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-100:hover {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-200:hover {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-300:hover {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-400:hover {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-500:hover {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-600:hover {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-700:hover {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-800:hover {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-900:hover {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-100:hover {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-200:hover {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-300:hover {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-400:hover {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-500:hover {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-600:hover {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-700:hover {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-800:hover {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-900:hover {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-100:hover {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-200:hover {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-300:hover {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-400:hover {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-500:hover {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-600:hover {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-700:hover {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-800:hover {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-teal-900:hover {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-100:hover {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-200:hover {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-300:hover {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-400:hover {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-500:hover {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-600:hover {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-700:hover {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-800:hover {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-900:hover {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-100:hover {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-200:hover {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-300:hover {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-400:hover {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-500:hover {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-600:hover {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-700:hover {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-800:hover {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-indigo-900:hover {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-100:hover {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-200:hover {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-300:hover {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-400:hover {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-500:hover {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-600:hover {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-700:hover {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-800:hover {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-purple-900:hover {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-100:hover {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-200:hover {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-300:hover {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-400:hover {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-500:hover {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-600:hover {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-700:hover {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-800:hover {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-pink-900:hover {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-transparent:focus {
    background-color: transparent;
  }

  .xl\\:focus\\:bg-current:focus {
    background-color: currentColor;
  }

  .xl\\:focus\\:bg-black:focus {
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-white:focus {
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-100:focus {
    --bg-opacity: 1;
    background-color: #f7fafc;
    background-color: rgba(247, 250, 252, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-200:focus {
    --bg-opacity: 1;
    background-color: #edf2f7;
    background-color: rgba(237, 242, 247, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-300:focus {
    --bg-opacity: 1;
    background-color: #e2e8f0;
    background-color: rgba(226, 232, 240, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-400:focus {
    --bg-opacity: 1;
    background-color: #cbd5e0;
    background-color: rgba(203, 213, 224, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-500:focus {
    --bg-opacity: 1;
    background-color: #a0aec0;
    background-color: rgba(160, 174, 192, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-600:focus {
    --bg-opacity: 1;
    background-color: #718096;
    background-color: rgba(113, 128, 150, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-700:focus {
    --bg-opacity: 1;
    background-color: #4a5568;
    background-color: rgba(74, 85, 104, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-800:focus {
    --bg-opacity: 1;
    background-color: #2d3748;
    background-color: rgba(45, 55, 72, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-900:focus {
    --bg-opacity: 1;
    background-color: #1a202c;
    background-color: rgba(26, 32, 44, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-100:focus {
    --bg-opacity: 1;
    background-color: #fff5f5;
    background-color: rgba(255, 245, 245, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-200:focus {
    --bg-opacity: 1;
    background-color: #fed7d7;
    background-color: rgba(254, 215, 215, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-300:focus {
    --bg-opacity: 1;
    background-color: #feb2b2;
    background-color: rgba(254, 178, 178, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-400:focus {
    --bg-opacity: 1;
    background-color: #fc8181;
    background-color: rgba(252, 129, 129, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-500:focus {
    --bg-opacity: 1;
    background-color: #f56565;
    background-color: rgba(245, 101, 101, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-600:focus {
    --bg-opacity: 1;
    background-color: #e53e3e;
    background-color: rgba(229, 62, 62, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-700:focus {
    --bg-opacity: 1;
    background-color: #c53030;
    background-color: rgba(197, 48, 48, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-800:focus {
    --bg-opacity: 1;
    background-color: #9b2c2c;
    background-color: rgba(155, 44, 44, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-900:focus {
    --bg-opacity: 1;
    background-color: #742a2a;
    background-color: rgba(116, 42, 42, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-100:focus {
    --bg-opacity: 1;
    background-color: #fffaf0;
    background-color: rgba(255, 250, 240, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-200:focus {
    --bg-opacity: 1;
    background-color: #feebc8;
    background-color: rgba(254, 235, 200, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-300:focus {
    --bg-opacity: 1;
    background-color: #fbd38d;
    background-color: rgba(251, 211, 141, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-400:focus {
    --bg-opacity: 1;
    background-color: #f6ad55;
    background-color: rgba(246, 173, 85, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-500:focus {
    --bg-opacity: 1;
    background-color: #ed8936;
    background-color: rgba(237, 137, 54, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-600:focus {
    --bg-opacity: 1;
    background-color: #dd6b20;
    background-color: rgba(221, 107, 32, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-700:focus {
    --bg-opacity: 1;
    background-color: #c05621;
    background-color: rgba(192, 86, 33, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-800:focus {
    --bg-opacity: 1;
    background-color: #9c4221;
    background-color: rgba(156, 66, 33, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-900:focus {
    --bg-opacity: 1;
    background-color: #7b341e;
    background-color: rgba(123, 52, 30, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-100:focus {
    --bg-opacity: 1;
    background-color: #fffff0;
    background-color: rgba(255, 255, 240, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-200:focus {
    --bg-opacity: 1;
    background-color: #fefcbf;
    background-color: rgba(254, 252, 191, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-300:focus {
    --bg-opacity: 1;
    background-color: #faf089;
    background-color: rgba(250, 240, 137, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-400:focus {
    --bg-opacity: 1;
    background-color: #f6e05e;
    background-color: rgba(246, 224, 94, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-500:focus {
    --bg-opacity: 1;
    background-color: #ecc94b;
    background-color: rgba(236, 201, 75, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-600:focus {
    --bg-opacity: 1;
    background-color: #d69e2e;
    background-color: rgba(214, 158, 46, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-700:focus {
    --bg-opacity: 1;
    background-color: #b7791f;
    background-color: rgba(183, 121, 31, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-800:focus {
    --bg-opacity: 1;
    background-color: #975a16;
    background-color: rgba(151, 90, 22, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-900:focus {
    --bg-opacity: 1;
    background-color: #744210;
    background-color: rgba(116, 66, 16, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-100:focus {
    --bg-opacity: 1;
    background-color: #f0fff4;
    background-color: rgba(240, 255, 244, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-200:focus {
    --bg-opacity: 1;
    background-color: #c6f6d5;
    background-color: rgba(198, 246, 213, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-300:focus {
    --bg-opacity: 1;
    background-color: #9ae6b4;
    background-color: rgba(154, 230, 180, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-400:focus {
    --bg-opacity: 1;
    background-color: #68d391;
    background-color: rgba(104, 211, 145, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-500:focus {
    --bg-opacity: 1;
    background-color: #48bb78;
    background-color: rgba(72, 187, 120, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-600:focus {
    --bg-opacity: 1;
    background-color: #38a169;
    background-color: rgba(56, 161, 105, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-700:focus {
    --bg-opacity: 1;
    background-color: #2f855a;
    background-color: rgba(47, 133, 90, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-800:focus {
    --bg-opacity: 1;
    background-color: #276749;
    background-color: rgba(39, 103, 73, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-900:focus {
    --bg-opacity: 1;
    background-color: #22543d;
    background-color: rgba(34, 84, 61, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-100:focus {
    --bg-opacity: 1;
    background-color: #e6fffa;
    background-color: rgba(230, 255, 250, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-200:focus {
    --bg-opacity: 1;
    background-color: #b2f5ea;
    background-color: rgba(178, 245, 234, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-300:focus {
    --bg-opacity: 1;
    background-color: #81e6d9;
    background-color: rgba(129, 230, 217, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-400:focus {
    --bg-opacity: 1;
    background-color: #4fd1c5;
    background-color: rgba(79, 209, 197, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-500:focus {
    --bg-opacity: 1;
    background-color: #38b2ac;
    background-color: rgba(56, 178, 172, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-600:focus {
    --bg-opacity: 1;
    background-color: #319795;
    background-color: rgba(49, 151, 149, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-700:focus {
    --bg-opacity: 1;
    background-color: #2c7a7b;
    background-color: rgba(44, 122, 123, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-800:focus {
    --bg-opacity: 1;
    background-color: #285e61;
    background-color: rgba(40, 94, 97, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-teal-900:focus {
    --bg-opacity: 1;
    background-color: #234e52;
    background-color: rgba(35, 78, 82, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-100:focus {
    --bg-opacity: 1;
    background-color: #ebf8ff;
    background-color: rgba(235, 248, 255, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-200:focus {
    --bg-opacity: 1;
    background-color: #bee3f8;
    background-color: rgba(190, 227, 248, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-300:focus {
    --bg-opacity: 1;
    background-color: #90cdf4;
    background-color: rgba(144, 205, 244, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-400:focus {
    --bg-opacity: 1;
    background-color: #63b3ed;
    background-color: rgba(99, 179, 237, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-500:focus {
    --bg-opacity: 1;
    background-color: #4299e1;
    background-color: rgba(66, 153, 225, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-600:focus {
    --bg-opacity: 1;
    background-color: #3182ce;
    background-color: rgba(49, 130, 206, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-700:focus {
    --bg-opacity: 1;
    background-color: #2b6cb0;
    background-color: rgba(43, 108, 176, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-800:focus {
    --bg-opacity: 1;
    background-color: #2c5282;
    background-color: rgba(44, 82, 130, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-900:focus {
    --bg-opacity: 1;
    background-color: #2a4365;
    background-color: rgba(42, 67, 101, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-100:focus {
    --bg-opacity: 1;
    background-color: #ebf4ff;
    background-color: rgba(235, 244, 255, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-200:focus {
    --bg-opacity: 1;
    background-color: #c3dafe;
    background-color: rgba(195, 218, 254, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-300:focus {
    --bg-opacity: 1;
    background-color: #a3bffa;
    background-color: rgba(163, 191, 250, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-400:focus {
    --bg-opacity: 1;
    background-color: #7f9cf5;
    background-color: rgba(127, 156, 245, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-500:focus {
    --bg-opacity: 1;
    background-color: #667eea;
    background-color: rgba(102, 126, 234, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-600:focus {
    --bg-opacity: 1;
    background-color: #5a67d8;
    background-color: rgba(90, 103, 216, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-700:focus {
    --bg-opacity: 1;
    background-color: #4c51bf;
    background-color: rgba(76, 81, 191, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-800:focus {
    --bg-opacity: 1;
    background-color: #434190;
    background-color: rgba(67, 65, 144, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-indigo-900:focus {
    --bg-opacity: 1;
    background-color: #3c366b;
    background-color: rgba(60, 54, 107, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-100:focus {
    --bg-opacity: 1;
    background-color: #faf5ff;
    background-color: rgba(250, 245, 255, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-200:focus {
    --bg-opacity: 1;
    background-color: #e9d8fd;
    background-color: rgba(233, 216, 253, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-300:focus {
    --bg-opacity: 1;
    background-color: #d6bcfa;
    background-color: rgba(214, 188, 250, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-400:focus {
    --bg-opacity: 1;
    background-color: #b794f4;
    background-color: rgba(183, 148, 244, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-500:focus {
    --bg-opacity: 1;
    background-color: #9f7aea;
    background-color: rgba(159, 122, 234, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-600:focus {
    --bg-opacity: 1;
    background-color: #805ad5;
    background-color: rgba(128, 90, 213, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-700:focus {
    --bg-opacity: 1;
    background-color: #6b46c1;
    background-color: rgba(107, 70, 193, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-800:focus {
    --bg-opacity: 1;
    background-color: #553c9a;
    background-color: rgba(85, 60, 154, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-purple-900:focus {
    --bg-opacity: 1;
    background-color: #44337a;
    background-color: rgba(68, 51, 122, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-100:focus {
    --bg-opacity: 1;
    background-color: #fff5f7;
    background-color: rgba(255, 245, 247, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-200:focus {
    --bg-opacity: 1;
    background-color: #fed7e2;
    background-color: rgba(254, 215, 226, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-300:focus {
    --bg-opacity: 1;
    background-color: #fbb6ce;
    background-color: rgba(251, 182, 206, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-400:focus {
    --bg-opacity: 1;
    background-color: #f687b3;
    background-color: rgba(246, 135, 179, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-500:focus {
    --bg-opacity: 1;
    background-color: #ed64a6;
    background-color: rgba(237, 100, 166, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-600:focus {
    --bg-opacity: 1;
    background-color: #d53f8c;
    background-color: rgba(213, 63, 140, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-700:focus {
    --bg-opacity: 1;
    background-color: #b83280;
    background-color: rgba(184, 50, 128, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-800:focus {
    --bg-opacity: 1;
    background-color: #97266d;
    background-color: rgba(151, 38, 109, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-pink-900:focus {
    --bg-opacity: 1;
    background-color: #702459;
    background-color: rgba(112, 36, 89, var(--bg-opacity));
  }

  .xl\\:bg-none {
    background-image: none;
  }

  .xl\\:bg-gradient-to-t {
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-tr {
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-r {
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-br {
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-bl {
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-l {
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-tl {
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .xl\\:from-transparent {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:from-current {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:from-black {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:from-white {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:from-gray-100 {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .xl\\:from-gray-200 {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .xl\\:from-gray-300 {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .xl\\:from-gray-400 {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .xl\\:from-gray-500 {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .xl\\:from-gray-600 {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .xl\\:from-gray-700 {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .xl\\:from-gray-800 {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .xl\\:from-gray-900 {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .xl\\:from-red-100 {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .xl\\:from-red-200 {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .xl\\:from-red-300 {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .xl\\:from-red-400 {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .xl\\:from-red-500 {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .xl\\:from-red-600 {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .xl\\:from-red-700 {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .xl\\:from-red-800 {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .xl\\:from-red-900 {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .xl\\:from-orange-100 {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .xl\\:from-orange-200 {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .xl\\:from-orange-300 {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .xl\\:from-orange-400 {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .xl\\:from-orange-500 {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .xl\\:from-orange-600 {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .xl\\:from-orange-700 {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .xl\\:from-orange-800 {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .xl\\:from-orange-900 {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .xl\\:from-yellow-100 {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .xl\\:from-yellow-200 {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .xl\\:from-yellow-300 {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .xl\\:from-yellow-400 {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .xl\\:from-yellow-500 {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .xl\\:from-yellow-600 {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .xl\\:from-yellow-700 {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .xl\\:from-yellow-800 {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .xl\\:from-yellow-900 {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .xl\\:from-green-100 {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .xl\\:from-green-200 {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .xl\\:from-green-300 {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .xl\\:from-green-400 {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .xl\\:from-green-500 {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .xl\\:from-green-600 {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .xl\\:from-green-700 {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .xl\\:from-green-800 {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .xl\\:from-green-900 {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .xl\\:from-teal-100 {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .xl\\:from-teal-200 {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .xl\\:from-teal-300 {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .xl\\:from-teal-400 {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .xl\\:from-teal-500 {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .xl\\:from-teal-600 {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .xl\\:from-teal-700 {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .xl\\:from-teal-800 {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .xl\\:from-teal-900 {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .xl\\:from-blue-100 {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .xl\\:from-blue-200 {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .xl\\:from-blue-300 {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .xl\\:from-blue-400 {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .xl\\:from-blue-500 {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .xl\\:from-blue-600 {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .xl\\:from-blue-700 {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .xl\\:from-blue-800 {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .xl\\:from-blue-900 {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .xl\\:from-indigo-100 {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .xl\\:from-indigo-200 {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .xl\\:from-indigo-300 {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .xl\\:from-indigo-400 {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .xl\\:from-indigo-500 {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .xl\\:from-indigo-600 {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .xl\\:from-indigo-700 {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .xl\\:from-indigo-800 {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .xl\\:from-indigo-900 {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .xl\\:from-purple-100 {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .xl\\:from-purple-200 {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .xl\\:from-purple-300 {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .xl\\:from-purple-400 {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .xl\\:from-purple-500 {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .xl\\:from-purple-600 {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .xl\\:from-purple-700 {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .xl\\:from-purple-800 {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .xl\\:from-purple-900 {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .xl\\:from-pink-100 {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .xl\\:from-pink-200 {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .xl\\:from-pink-300 {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .xl\\:from-pink-400 {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .xl\\:from-pink-500 {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .xl\\:from-pink-600 {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .xl\\:from-pink-700 {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .xl\\:from-pink-800 {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .xl\\:from-pink-900 {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .xl\\:via-transparent {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:via-current {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:via-black {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:via-white {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:via-gray-100 {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .xl\\:via-gray-200 {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .xl\\:via-gray-300 {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .xl\\:via-gray-400 {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .xl\\:via-gray-500 {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .xl\\:via-gray-600 {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .xl\\:via-gray-700 {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .xl\\:via-gray-800 {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .xl\\:via-gray-900 {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .xl\\:via-red-100 {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .xl\\:via-red-200 {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .xl\\:via-red-300 {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .xl\\:via-red-400 {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .xl\\:via-red-500 {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .xl\\:via-red-600 {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .xl\\:via-red-700 {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .xl\\:via-red-800 {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .xl\\:via-red-900 {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .xl\\:via-orange-100 {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .xl\\:via-orange-200 {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .xl\\:via-orange-300 {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .xl\\:via-orange-400 {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .xl\\:via-orange-500 {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .xl\\:via-orange-600 {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .xl\\:via-orange-700 {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .xl\\:via-orange-800 {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .xl\\:via-orange-900 {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .xl\\:via-yellow-100 {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .xl\\:via-yellow-200 {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .xl\\:via-yellow-300 {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .xl\\:via-yellow-400 {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .xl\\:via-yellow-500 {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .xl\\:via-yellow-600 {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .xl\\:via-yellow-700 {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .xl\\:via-yellow-800 {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .xl\\:via-yellow-900 {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .xl\\:via-green-100 {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .xl\\:via-green-200 {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .xl\\:via-green-300 {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .xl\\:via-green-400 {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .xl\\:via-green-500 {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .xl\\:via-green-600 {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .xl\\:via-green-700 {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .xl\\:via-green-800 {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .xl\\:via-green-900 {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .xl\\:via-teal-100 {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .xl\\:via-teal-200 {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .xl\\:via-teal-300 {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .xl\\:via-teal-400 {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .xl\\:via-teal-500 {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .xl\\:via-teal-600 {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .xl\\:via-teal-700 {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .xl\\:via-teal-800 {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .xl\\:via-teal-900 {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .xl\\:via-blue-100 {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .xl\\:via-blue-200 {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .xl\\:via-blue-300 {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .xl\\:via-blue-400 {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .xl\\:via-blue-500 {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .xl\\:via-blue-600 {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .xl\\:via-blue-700 {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .xl\\:via-blue-800 {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .xl\\:via-blue-900 {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .xl\\:via-indigo-100 {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .xl\\:via-indigo-200 {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .xl\\:via-indigo-300 {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .xl\\:via-indigo-400 {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .xl\\:via-indigo-500 {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .xl\\:via-indigo-600 {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .xl\\:via-indigo-700 {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .xl\\:via-indigo-800 {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .xl\\:via-indigo-900 {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .xl\\:via-purple-100 {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .xl\\:via-purple-200 {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .xl\\:via-purple-300 {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .xl\\:via-purple-400 {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .xl\\:via-purple-500 {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .xl\\:via-purple-600 {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .xl\\:via-purple-700 {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .xl\\:via-purple-800 {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .xl\\:via-purple-900 {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .xl\\:via-pink-100 {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .xl\\:via-pink-200 {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .xl\\:via-pink-300 {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .xl\\:via-pink-400 {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .xl\\:via-pink-500 {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .xl\\:via-pink-600 {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .xl\\:via-pink-700 {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .xl\\:via-pink-800 {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .xl\\:via-pink-900 {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .xl\\:to-transparent {
    --gradient-to-color: transparent;
  }

  .xl\\:to-current {
    --gradient-to-color: currentColor;
  }

  .xl\\:to-black {
    --gradient-to-color: #000;
  }

  .xl\\:to-white {
    --gradient-to-color: #fff;
  }

  .xl\\:to-gray-100 {
    --gradient-to-color: #f7fafc;
  }

  .xl\\:to-gray-200 {
    --gradient-to-color: #edf2f7;
  }

  .xl\\:to-gray-300 {
    --gradient-to-color: #e2e8f0;
  }

  .xl\\:to-gray-400 {
    --gradient-to-color: #cbd5e0;
  }

  .xl\\:to-gray-500 {
    --gradient-to-color: #a0aec0;
  }

  .xl\\:to-gray-600 {
    --gradient-to-color: #718096;
  }

  .xl\\:to-gray-700 {
    --gradient-to-color: #4a5568;
  }

  .xl\\:to-gray-800 {
    --gradient-to-color: #2d3748;
  }

  .xl\\:to-gray-900 {
    --gradient-to-color: #1a202c;
  }

  .xl\\:to-red-100 {
    --gradient-to-color: #fff5f5;
  }

  .xl\\:to-red-200 {
    --gradient-to-color: #fed7d7;
  }

  .xl\\:to-red-300 {
    --gradient-to-color: #feb2b2;
  }

  .xl\\:to-red-400 {
    --gradient-to-color: #fc8181;
  }

  .xl\\:to-red-500 {
    --gradient-to-color: #f56565;
  }

  .xl\\:to-red-600 {
    --gradient-to-color: #e53e3e;
  }

  .xl\\:to-red-700 {
    --gradient-to-color: #c53030;
  }

  .xl\\:to-red-800 {
    --gradient-to-color: #9b2c2c;
  }

  .xl\\:to-red-900 {
    --gradient-to-color: #742a2a;
  }

  .xl\\:to-orange-100 {
    --gradient-to-color: #fffaf0;
  }

  .xl\\:to-orange-200 {
    --gradient-to-color: #feebc8;
  }

  .xl\\:to-orange-300 {
    --gradient-to-color: #fbd38d;
  }

  .xl\\:to-orange-400 {
    --gradient-to-color: #f6ad55;
  }

  .xl\\:to-orange-500 {
    --gradient-to-color: #ed8936;
  }

  .xl\\:to-orange-600 {
    --gradient-to-color: #dd6b20;
  }

  .xl\\:to-orange-700 {
    --gradient-to-color: #c05621;
  }

  .xl\\:to-orange-800 {
    --gradient-to-color: #9c4221;
  }

  .xl\\:to-orange-900 {
    --gradient-to-color: #7b341e;
  }

  .xl\\:to-yellow-100 {
    --gradient-to-color: #fffff0;
  }

  .xl\\:to-yellow-200 {
    --gradient-to-color: #fefcbf;
  }

  .xl\\:to-yellow-300 {
    --gradient-to-color: #faf089;
  }

  .xl\\:to-yellow-400 {
    --gradient-to-color: #f6e05e;
  }

  .xl\\:to-yellow-500 {
    --gradient-to-color: #ecc94b;
  }

  .xl\\:to-yellow-600 {
    --gradient-to-color: #d69e2e;
  }

  .xl\\:to-yellow-700 {
    --gradient-to-color: #b7791f;
  }

  .xl\\:to-yellow-800 {
    --gradient-to-color: #975a16;
  }

  .xl\\:to-yellow-900 {
    --gradient-to-color: #744210;
  }

  .xl\\:to-green-100 {
    --gradient-to-color: #f0fff4;
  }

  .xl\\:to-green-200 {
    --gradient-to-color: #c6f6d5;
  }

  .xl\\:to-green-300 {
    --gradient-to-color: #9ae6b4;
  }

  .xl\\:to-green-400 {
    --gradient-to-color: #68d391;
  }

  .xl\\:to-green-500 {
    --gradient-to-color: #48bb78;
  }

  .xl\\:to-green-600 {
    --gradient-to-color: #38a169;
  }

  .xl\\:to-green-700 {
    --gradient-to-color: #2f855a;
  }

  .xl\\:to-green-800 {
    --gradient-to-color: #276749;
  }

  .xl\\:to-green-900 {
    --gradient-to-color: #22543d;
  }

  .xl\\:to-teal-100 {
    --gradient-to-color: #e6fffa;
  }

  .xl\\:to-teal-200 {
    --gradient-to-color: #b2f5ea;
  }

  .xl\\:to-teal-300 {
    --gradient-to-color: #81e6d9;
  }

  .xl\\:to-teal-400 {
    --gradient-to-color: #4fd1c5;
  }

  .xl\\:to-teal-500 {
    --gradient-to-color: #38b2ac;
  }

  .xl\\:to-teal-600 {
    --gradient-to-color: #319795;
  }

  .xl\\:to-teal-700 {
    --gradient-to-color: #2c7a7b;
  }

  .xl\\:to-teal-800 {
    --gradient-to-color: #285e61;
  }

  .xl\\:to-teal-900 {
    --gradient-to-color: #234e52;
  }

  .xl\\:to-blue-100 {
    --gradient-to-color: #ebf8ff;
  }

  .xl\\:to-blue-200 {
    --gradient-to-color: #bee3f8;
  }

  .xl\\:to-blue-300 {
    --gradient-to-color: #90cdf4;
  }

  .xl\\:to-blue-400 {
    --gradient-to-color: #63b3ed;
  }

  .xl\\:to-blue-500 {
    --gradient-to-color: #4299e1;
  }

  .xl\\:to-blue-600 {
    --gradient-to-color: #3182ce;
  }

  .xl\\:to-blue-700 {
    --gradient-to-color: #2b6cb0;
  }

  .xl\\:to-blue-800 {
    --gradient-to-color: #2c5282;
  }

  .xl\\:to-blue-900 {
    --gradient-to-color: #2a4365;
  }

  .xl\\:to-indigo-100 {
    --gradient-to-color: #ebf4ff;
  }

  .xl\\:to-indigo-200 {
    --gradient-to-color: #c3dafe;
  }

  .xl\\:to-indigo-300 {
    --gradient-to-color: #a3bffa;
  }

  .xl\\:to-indigo-400 {
    --gradient-to-color: #7f9cf5;
  }

  .xl\\:to-indigo-500 {
    --gradient-to-color: #667eea;
  }

  .xl\\:to-indigo-600 {
    --gradient-to-color: #5a67d8;
  }

  .xl\\:to-indigo-700 {
    --gradient-to-color: #4c51bf;
  }

  .xl\\:to-indigo-800 {
    --gradient-to-color: #434190;
  }

  .xl\\:to-indigo-900 {
    --gradient-to-color: #3c366b;
  }

  .xl\\:to-purple-100 {
    --gradient-to-color: #faf5ff;
  }

  .xl\\:to-purple-200 {
    --gradient-to-color: #e9d8fd;
  }

  .xl\\:to-purple-300 {
    --gradient-to-color: #d6bcfa;
  }

  .xl\\:to-purple-400 {
    --gradient-to-color: #b794f4;
  }

  .xl\\:to-purple-500 {
    --gradient-to-color: #9f7aea;
  }

  .xl\\:to-purple-600 {
    --gradient-to-color: #805ad5;
  }

  .xl\\:to-purple-700 {
    --gradient-to-color: #6b46c1;
  }

  .xl\\:to-purple-800 {
    --gradient-to-color: #553c9a;
  }

  .xl\\:to-purple-900 {
    --gradient-to-color: #44337a;
  }

  .xl\\:to-pink-100 {
    --gradient-to-color: #fff5f7;
  }

  .xl\\:to-pink-200 {
    --gradient-to-color: #fed7e2;
  }

  .xl\\:to-pink-300 {
    --gradient-to-color: #fbb6ce;
  }

  .xl\\:to-pink-400 {
    --gradient-to-color: #f687b3;
  }

  .xl\\:to-pink-500 {
    --gradient-to-color: #ed64a6;
  }

  .xl\\:to-pink-600 {
    --gradient-to-color: #d53f8c;
  }

  .xl\\:to-pink-700 {
    --gradient-to-color: #b83280;
  }

  .xl\\:to-pink-800 {
    --gradient-to-color: #97266d;
  }

  .xl\\:to-pink-900 {
    --gradient-to-color: #702459;
  }

  .xl\\:hover\\:from-transparent:hover {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:hover\\:from-current:hover {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:from-black:hover {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:hover\\:from-white:hover {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:from-gray-100:hover {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .xl\\:hover\\:from-gray-200:hover {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .xl\\:hover\\:from-gray-300:hover {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .xl\\:hover\\:from-gray-400:hover {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .xl\\:hover\\:from-gray-500:hover {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .xl\\:hover\\:from-gray-600:hover {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .xl\\:hover\\:from-gray-700:hover {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .xl\\:hover\\:from-gray-800:hover {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .xl\\:hover\\:from-gray-900:hover {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .xl\\:hover\\:from-red-100:hover {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .xl\\:hover\\:from-red-200:hover {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .xl\\:hover\\:from-red-300:hover {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .xl\\:hover\\:from-red-400:hover {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .xl\\:hover\\:from-red-500:hover {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .xl\\:hover\\:from-red-600:hover {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .xl\\:hover\\:from-red-700:hover {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .xl\\:hover\\:from-red-800:hover {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .xl\\:hover\\:from-red-900:hover {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .xl\\:hover\\:from-orange-100:hover {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .xl\\:hover\\:from-orange-200:hover {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .xl\\:hover\\:from-orange-300:hover {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .xl\\:hover\\:from-orange-400:hover {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .xl\\:hover\\:from-orange-500:hover {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .xl\\:hover\\:from-orange-600:hover {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .xl\\:hover\\:from-orange-700:hover {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .xl\\:hover\\:from-orange-800:hover {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .xl\\:hover\\:from-orange-900:hover {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .xl\\:hover\\:from-yellow-100:hover {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .xl\\:hover\\:from-yellow-200:hover {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .xl\\:hover\\:from-yellow-300:hover {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .xl\\:hover\\:from-yellow-400:hover {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .xl\\:hover\\:from-yellow-500:hover {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .xl\\:hover\\:from-yellow-600:hover {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .xl\\:hover\\:from-yellow-700:hover {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .xl\\:hover\\:from-yellow-800:hover {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .xl\\:hover\\:from-yellow-900:hover {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .xl\\:hover\\:from-green-100:hover {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .xl\\:hover\\:from-green-200:hover {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .xl\\:hover\\:from-green-300:hover {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .xl\\:hover\\:from-green-400:hover {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .xl\\:hover\\:from-green-500:hover {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .xl\\:hover\\:from-green-600:hover {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .xl\\:hover\\:from-green-700:hover {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .xl\\:hover\\:from-green-800:hover {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .xl\\:hover\\:from-green-900:hover {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .xl\\:hover\\:from-teal-100:hover {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .xl\\:hover\\:from-teal-200:hover {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .xl\\:hover\\:from-teal-300:hover {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .xl\\:hover\\:from-teal-400:hover {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .xl\\:hover\\:from-teal-500:hover {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .xl\\:hover\\:from-teal-600:hover {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .xl\\:hover\\:from-teal-700:hover {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .xl\\:hover\\:from-teal-800:hover {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .xl\\:hover\\:from-teal-900:hover {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .xl\\:hover\\:from-blue-100:hover {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .xl\\:hover\\:from-blue-200:hover {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .xl\\:hover\\:from-blue-300:hover {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .xl\\:hover\\:from-blue-400:hover {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .xl\\:hover\\:from-blue-500:hover {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .xl\\:hover\\:from-blue-600:hover {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .xl\\:hover\\:from-blue-700:hover {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .xl\\:hover\\:from-blue-800:hover {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .xl\\:hover\\:from-blue-900:hover {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .xl\\:hover\\:from-indigo-100:hover {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .xl\\:hover\\:from-indigo-200:hover {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .xl\\:hover\\:from-indigo-300:hover {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .xl\\:hover\\:from-indigo-400:hover {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .xl\\:hover\\:from-indigo-500:hover {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .xl\\:hover\\:from-indigo-600:hover {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .xl\\:hover\\:from-indigo-700:hover {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .xl\\:hover\\:from-indigo-800:hover {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .xl\\:hover\\:from-indigo-900:hover {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .xl\\:hover\\:from-purple-100:hover {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .xl\\:hover\\:from-purple-200:hover {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .xl\\:hover\\:from-purple-300:hover {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .xl\\:hover\\:from-purple-400:hover {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .xl\\:hover\\:from-purple-500:hover {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .xl\\:hover\\:from-purple-600:hover {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .xl\\:hover\\:from-purple-700:hover {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .xl\\:hover\\:from-purple-800:hover {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .xl\\:hover\\:from-purple-900:hover {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .xl\\:hover\\:from-pink-100:hover {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .xl\\:hover\\:from-pink-200:hover {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .xl\\:hover\\:from-pink-300:hover {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .xl\\:hover\\:from-pink-400:hover {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .xl\\:hover\\:from-pink-500:hover {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .xl\\:hover\\:from-pink-600:hover {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .xl\\:hover\\:from-pink-700:hover {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .xl\\:hover\\:from-pink-800:hover {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .xl\\:hover\\:from-pink-900:hover {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .xl\\:hover\\:via-transparent:hover {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:hover\\:via-current:hover {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:via-black:hover {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:hover\\:via-white:hover {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:via-gray-100:hover {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .xl\\:hover\\:via-gray-200:hover {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .xl\\:hover\\:via-gray-300:hover {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .xl\\:hover\\:via-gray-400:hover {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .xl\\:hover\\:via-gray-500:hover {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .xl\\:hover\\:via-gray-600:hover {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .xl\\:hover\\:via-gray-700:hover {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .xl\\:hover\\:via-gray-800:hover {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .xl\\:hover\\:via-gray-900:hover {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .xl\\:hover\\:via-red-100:hover {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .xl\\:hover\\:via-red-200:hover {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .xl\\:hover\\:via-red-300:hover {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .xl\\:hover\\:via-red-400:hover {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .xl\\:hover\\:via-red-500:hover {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .xl\\:hover\\:via-red-600:hover {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .xl\\:hover\\:via-red-700:hover {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .xl\\:hover\\:via-red-800:hover {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .xl\\:hover\\:via-red-900:hover {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .xl\\:hover\\:via-orange-100:hover {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .xl\\:hover\\:via-orange-200:hover {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .xl\\:hover\\:via-orange-300:hover {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .xl\\:hover\\:via-orange-400:hover {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .xl\\:hover\\:via-orange-500:hover {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .xl\\:hover\\:via-orange-600:hover {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .xl\\:hover\\:via-orange-700:hover {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .xl\\:hover\\:via-orange-800:hover {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .xl\\:hover\\:via-orange-900:hover {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .xl\\:hover\\:via-yellow-100:hover {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .xl\\:hover\\:via-yellow-200:hover {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .xl\\:hover\\:via-yellow-300:hover {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .xl\\:hover\\:via-yellow-400:hover {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .xl\\:hover\\:via-yellow-500:hover {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .xl\\:hover\\:via-yellow-600:hover {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .xl\\:hover\\:via-yellow-700:hover {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .xl\\:hover\\:via-yellow-800:hover {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .xl\\:hover\\:via-yellow-900:hover {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .xl\\:hover\\:via-green-100:hover {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .xl\\:hover\\:via-green-200:hover {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .xl\\:hover\\:via-green-300:hover {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .xl\\:hover\\:via-green-400:hover {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .xl\\:hover\\:via-green-500:hover {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .xl\\:hover\\:via-green-600:hover {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .xl\\:hover\\:via-green-700:hover {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .xl\\:hover\\:via-green-800:hover {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .xl\\:hover\\:via-green-900:hover {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .xl\\:hover\\:via-teal-100:hover {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .xl\\:hover\\:via-teal-200:hover {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .xl\\:hover\\:via-teal-300:hover {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .xl\\:hover\\:via-teal-400:hover {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .xl\\:hover\\:via-teal-500:hover {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .xl\\:hover\\:via-teal-600:hover {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .xl\\:hover\\:via-teal-700:hover {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .xl\\:hover\\:via-teal-800:hover {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .xl\\:hover\\:via-teal-900:hover {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .xl\\:hover\\:via-blue-100:hover {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .xl\\:hover\\:via-blue-200:hover {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .xl\\:hover\\:via-blue-300:hover {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .xl\\:hover\\:via-blue-400:hover {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .xl\\:hover\\:via-blue-500:hover {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .xl\\:hover\\:via-blue-600:hover {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .xl\\:hover\\:via-blue-700:hover {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .xl\\:hover\\:via-blue-800:hover {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .xl\\:hover\\:via-blue-900:hover {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .xl\\:hover\\:via-indigo-100:hover {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .xl\\:hover\\:via-indigo-200:hover {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .xl\\:hover\\:via-indigo-300:hover {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .xl\\:hover\\:via-indigo-400:hover {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .xl\\:hover\\:via-indigo-500:hover {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .xl\\:hover\\:via-indigo-600:hover {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .xl\\:hover\\:via-indigo-700:hover {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .xl\\:hover\\:via-indigo-800:hover {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .xl\\:hover\\:via-indigo-900:hover {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .xl\\:hover\\:via-purple-100:hover {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .xl\\:hover\\:via-purple-200:hover {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .xl\\:hover\\:via-purple-300:hover {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .xl\\:hover\\:via-purple-400:hover {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .xl\\:hover\\:via-purple-500:hover {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .xl\\:hover\\:via-purple-600:hover {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .xl\\:hover\\:via-purple-700:hover {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .xl\\:hover\\:via-purple-800:hover {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .xl\\:hover\\:via-purple-900:hover {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .xl\\:hover\\:via-pink-100:hover {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .xl\\:hover\\:via-pink-200:hover {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .xl\\:hover\\:via-pink-300:hover {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .xl\\:hover\\:via-pink-400:hover {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .xl\\:hover\\:via-pink-500:hover {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .xl\\:hover\\:via-pink-600:hover {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .xl\\:hover\\:via-pink-700:hover {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .xl\\:hover\\:via-pink-800:hover {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .xl\\:hover\\:via-pink-900:hover {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .xl\\:hover\\:to-transparent:hover {
    --gradient-to-color: transparent;
  }

  .xl\\:hover\\:to-current:hover {
    --gradient-to-color: currentColor;
  }

  .xl\\:hover\\:to-black:hover {
    --gradient-to-color: #000;
  }

  .xl\\:hover\\:to-white:hover {
    --gradient-to-color: #fff;
  }

  .xl\\:hover\\:to-gray-100:hover {
    --gradient-to-color: #f7fafc;
  }

  .xl\\:hover\\:to-gray-200:hover {
    --gradient-to-color: #edf2f7;
  }

  .xl\\:hover\\:to-gray-300:hover {
    --gradient-to-color: #e2e8f0;
  }

  .xl\\:hover\\:to-gray-400:hover {
    --gradient-to-color: #cbd5e0;
  }

  .xl\\:hover\\:to-gray-500:hover {
    --gradient-to-color: #a0aec0;
  }

  .xl\\:hover\\:to-gray-600:hover {
    --gradient-to-color: #718096;
  }

  .xl\\:hover\\:to-gray-700:hover {
    --gradient-to-color: #4a5568;
  }

  .xl\\:hover\\:to-gray-800:hover {
    --gradient-to-color: #2d3748;
  }

  .xl\\:hover\\:to-gray-900:hover {
    --gradient-to-color: #1a202c;
  }

  .xl\\:hover\\:to-red-100:hover {
    --gradient-to-color: #fff5f5;
  }

  .xl\\:hover\\:to-red-200:hover {
    --gradient-to-color: #fed7d7;
  }

  .xl\\:hover\\:to-red-300:hover {
    --gradient-to-color: #feb2b2;
  }

  .xl\\:hover\\:to-red-400:hover {
    --gradient-to-color: #fc8181;
  }

  .xl\\:hover\\:to-red-500:hover {
    --gradient-to-color: #f56565;
  }

  .xl\\:hover\\:to-red-600:hover {
    --gradient-to-color: #e53e3e;
  }

  .xl\\:hover\\:to-red-700:hover {
    --gradient-to-color: #c53030;
  }

  .xl\\:hover\\:to-red-800:hover {
    --gradient-to-color: #9b2c2c;
  }

  .xl\\:hover\\:to-red-900:hover {
    --gradient-to-color: #742a2a;
  }

  .xl\\:hover\\:to-orange-100:hover {
    --gradient-to-color: #fffaf0;
  }

  .xl\\:hover\\:to-orange-200:hover {
    --gradient-to-color: #feebc8;
  }

  .xl\\:hover\\:to-orange-300:hover {
    --gradient-to-color: #fbd38d;
  }

  .xl\\:hover\\:to-orange-400:hover {
    --gradient-to-color: #f6ad55;
  }

  .xl\\:hover\\:to-orange-500:hover {
    --gradient-to-color: #ed8936;
  }

  .xl\\:hover\\:to-orange-600:hover {
    --gradient-to-color: #dd6b20;
  }

  .xl\\:hover\\:to-orange-700:hover {
    --gradient-to-color: #c05621;
  }

  .xl\\:hover\\:to-orange-800:hover {
    --gradient-to-color: #9c4221;
  }

  .xl\\:hover\\:to-orange-900:hover {
    --gradient-to-color: #7b341e;
  }

  .xl\\:hover\\:to-yellow-100:hover {
    --gradient-to-color: #fffff0;
  }

  .xl\\:hover\\:to-yellow-200:hover {
    --gradient-to-color: #fefcbf;
  }

  .xl\\:hover\\:to-yellow-300:hover {
    --gradient-to-color: #faf089;
  }

  .xl\\:hover\\:to-yellow-400:hover {
    --gradient-to-color: #f6e05e;
  }

  .xl\\:hover\\:to-yellow-500:hover {
    --gradient-to-color: #ecc94b;
  }

  .xl\\:hover\\:to-yellow-600:hover {
    --gradient-to-color: #d69e2e;
  }

  .xl\\:hover\\:to-yellow-700:hover {
    --gradient-to-color: #b7791f;
  }

  .xl\\:hover\\:to-yellow-800:hover {
    --gradient-to-color: #975a16;
  }

  .xl\\:hover\\:to-yellow-900:hover {
    --gradient-to-color: #744210;
  }

  .xl\\:hover\\:to-green-100:hover {
    --gradient-to-color: #f0fff4;
  }

  .xl\\:hover\\:to-green-200:hover {
    --gradient-to-color: #c6f6d5;
  }

  .xl\\:hover\\:to-green-300:hover {
    --gradient-to-color: #9ae6b4;
  }

  .xl\\:hover\\:to-green-400:hover {
    --gradient-to-color: #68d391;
  }

  .xl\\:hover\\:to-green-500:hover {
    --gradient-to-color: #48bb78;
  }

  .xl\\:hover\\:to-green-600:hover {
    --gradient-to-color: #38a169;
  }

  .xl\\:hover\\:to-green-700:hover {
    --gradient-to-color: #2f855a;
  }

  .xl\\:hover\\:to-green-800:hover {
    --gradient-to-color: #276749;
  }

  .xl\\:hover\\:to-green-900:hover {
    --gradient-to-color: #22543d;
  }

  .xl\\:hover\\:to-teal-100:hover {
    --gradient-to-color: #e6fffa;
  }

  .xl\\:hover\\:to-teal-200:hover {
    --gradient-to-color: #b2f5ea;
  }

  .xl\\:hover\\:to-teal-300:hover {
    --gradient-to-color: #81e6d9;
  }

  .xl\\:hover\\:to-teal-400:hover {
    --gradient-to-color: #4fd1c5;
  }

  .xl\\:hover\\:to-teal-500:hover {
    --gradient-to-color: #38b2ac;
  }

  .xl\\:hover\\:to-teal-600:hover {
    --gradient-to-color: #319795;
  }

  .xl\\:hover\\:to-teal-700:hover {
    --gradient-to-color: #2c7a7b;
  }

  .xl\\:hover\\:to-teal-800:hover {
    --gradient-to-color: #285e61;
  }

  .xl\\:hover\\:to-teal-900:hover {
    --gradient-to-color: #234e52;
  }

  .xl\\:hover\\:to-blue-100:hover {
    --gradient-to-color: #ebf8ff;
  }

  .xl\\:hover\\:to-blue-200:hover {
    --gradient-to-color: #bee3f8;
  }

  .xl\\:hover\\:to-blue-300:hover {
    --gradient-to-color: #90cdf4;
  }

  .xl\\:hover\\:to-blue-400:hover {
    --gradient-to-color: #63b3ed;
  }

  .xl\\:hover\\:to-blue-500:hover {
    --gradient-to-color: #4299e1;
  }

  .xl\\:hover\\:to-blue-600:hover {
    --gradient-to-color: #3182ce;
  }

  .xl\\:hover\\:to-blue-700:hover {
    --gradient-to-color: #2b6cb0;
  }

  .xl\\:hover\\:to-blue-800:hover {
    --gradient-to-color: #2c5282;
  }

  .xl\\:hover\\:to-blue-900:hover {
    --gradient-to-color: #2a4365;
  }

  .xl\\:hover\\:to-indigo-100:hover {
    --gradient-to-color: #ebf4ff;
  }

  .xl\\:hover\\:to-indigo-200:hover {
    --gradient-to-color: #c3dafe;
  }

  .xl\\:hover\\:to-indigo-300:hover {
    --gradient-to-color: #a3bffa;
  }

  .xl\\:hover\\:to-indigo-400:hover {
    --gradient-to-color: #7f9cf5;
  }

  .xl\\:hover\\:to-indigo-500:hover {
    --gradient-to-color: #667eea;
  }

  .xl\\:hover\\:to-indigo-600:hover {
    --gradient-to-color: #5a67d8;
  }

  .xl\\:hover\\:to-indigo-700:hover {
    --gradient-to-color: #4c51bf;
  }

  .xl\\:hover\\:to-indigo-800:hover {
    --gradient-to-color: #434190;
  }

  .xl\\:hover\\:to-indigo-900:hover {
    --gradient-to-color: #3c366b;
  }

  .xl\\:hover\\:to-purple-100:hover {
    --gradient-to-color: #faf5ff;
  }

  .xl\\:hover\\:to-purple-200:hover {
    --gradient-to-color: #e9d8fd;
  }

  .xl\\:hover\\:to-purple-300:hover {
    --gradient-to-color: #d6bcfa;
  }

  .xl\\:hover\\:to-purple-400:hover {
    --gradient-to-color: #b794f4;
  }

  .xl\\:hover\\:to-purple-500:hover {
    --gradient-to-color: #9f7aea;
  }

  .xl\\:hover\\:to-purple-600:hover {
    --gradient-to-color: #805ad5;
  }

  .xl\\:hover\\:to-purple-700:hover {
    --gradient-to-color: #6b46c1;
  }

  .xl\\:hover\\:to-purple-800:hover {
    --gradient-to-color: #553c9a;
  }

  .xl\\:hover\\:to-purple-900:hover {
    --gradient-to-color: #44337a;
  }

  .xl\\:hover\\:to-pink-100:hover {
    --gradient-to-color: #fff5f7;
  }

  .xl\\:hover\\:to-pink-200:hover {
    --gradient-to-color: #fed7e2;
  }

  .xl\\:hover\\:to-pink-300:hover {
    --gradient-to-color: #fbb6ce;
  }

  .xl\\:hover\\:to-pink-400:hover {
    --gradient-to-color: #f687b3;
  }

  .xl\\:hover\\:to-pink-500:hover {
    --gradient-to-color: #ed64a6;
  }

  .xl\\:hover\\:to-pink-600:hover {
    --gradient-to-color: #d53f8c;
  }

  .xl\\:hover\\:to-pink-700:hover {
    --gradient-to-color: #b83280;
  }

  .xl\\:hover\\:to-pink-800:hover {
    --gradient-to-color: #97266d;
  }

  .xl\\:hover\\:to-pink-900:hover {
    --gradient-to-color: #702459;
  }

  .xl\\:focus\\:from-transparent:focus {
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:focus\\:from-current:focus {
    --gradient-from-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:from-black:focus {
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:focus\\:from-white:focus {
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:from-gray-100:focus {
    --gradient-from-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .xl\\:focus\\:from-gray-200:focus {
    --gradient-from-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .xl\\:focus\\:from-gray-300:focus {
    --gradient-from-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .xl\\:focus\\:from-gray-400:focus {
    --gradient-from-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .xl\\:focus\\:from-gray-500:focus {
    --gradient-from-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .xl\\:focus\\:from-gray-600:focus {
    --gradient-from-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .xl\\:focus\\:from-gray-700:focus {
    --gradient-from-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .xl\\:focus\\:from-gray-800:focus {
    --gradient-from-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .xl\\:focus\\:from-gray-900:focus {
    --gradient-from-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .xl\\:focus\\:from-red-100:focus {
    --gradient-from-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .xl\\:focus\\:from-red-200:focus {
    --gradient-from-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .xl\\:focus\\:from-red-300:focus {
    --gradient-from-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .xl\\:focus\\:from-red-400:focus {
    --gradient-from-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .xl\\:focus\\:from-red-500:focus {
    --gradient-from-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .xl\\:focus\\:from-red-600:focus {
    --gradient-from-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .xl\\:focus\\:from-red-700:focus {
    --gradient-from-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .xl\\:focus\\:from-red-800:focus {
    --gradient-from-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .xl\\:focus\\:from-red-900:focus {
    --gradient-from-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .xl\\:focus\\:from-orange-100:focus {
    --gradient-from-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .xl\\:focus\\:from-orange-200:focus {
    --gradient-from-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .xl\\:focus\\:from-orange-300:focus {
    --gradient-from-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .xl\\:focus\\:from-orange-400:focus {
    --gradient-from-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .xl\\:focus\\:from-orange-500:focus {
    --gradient-from-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .xl\\:focus\\:from-orange-600:focus {
    --gradient-from-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .xl\\:focus\\:from-orange-700:focus {
    --gradient-from-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .xl\\:focus\\:from-orange-800:focus {
    --gradient-from-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .xl\\:focus\\:from-orange-900:focus {
    --gradient-from-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .xl\\:focus\\:from-yellow-100:focus {
    --gradient-from-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .xl\\:focus\\:from-yellow-200:focus {
    --gradient-from-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .xl\\:focus\\:from-yellow-300:focus {
    --gradient-from-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .xl\\:focus\\:from-yellow-400:focus {
    --gradient-from-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .xl\\:focus\\:from-yellow-500:focus {
    --gradient-from-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .xl\\:focus\\:from-yellow-600:focus {
    --gradient-from-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .xl\\:focus\\:from-yellow-700:focus {
    --gradient-from-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .xl\\:focus\\:from-yellow-800:focus {
    --gradient-from-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .xl\\:focus\\:from-yellow-900:focus {
    --gradient-from-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .xl\\:focus\\:from-green-100:focus {
    --gradient-from-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .xl\\:focus\\:from-green-200:focus {
    --gradient-from-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .xl\\:focus\\:from-green-300:focus {
    --gradient-from-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .xl\\:focus\\:from-green-400:focus {
    --gradient-from-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .xl\\:focus\\:from-green-500:focus {
    --gradient-from-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .xl\\:focus\\:from-green-600:focus {
    --gradient-from-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .xl\\:focus\\:from-green-700:focus {
    --gradient-from-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .xl\\:focus\\:from-green-800:focus {
    --gradient-from-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .xl\\:focus\\:from-green-900:focus {
    --gradient-from-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .xl\\:focus\\:from-teal-100:focus {
    --gradient-from-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .xl\\:focus\\:from-teal-200:focus {
    --gradient-from-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .xl\\:focus\\:from-teal-300:focus {
    --gradient-from-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .xl\\:focus\\:from-teal-400:focus {
    --gradient-from-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .xl\\:focus\\:from-teal-500:focus {
    --gradient-from-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .xl\\:focus\\:from-teal-600:focus {
    --gradient-from-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .xl\\:focus\\:from-teal-700:focus {
    --gradient-from-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .xl\\:focus\\:from-teal-800:focus {
    --gradient-from-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .xl\\:focus\\:from-teal-900:focus {
    --gradient-from-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .xl\\:focus\\:from-blue-100:focus {
    --gradient-from-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .xl\\:focus\\:from-blue-200:focus {
    --gradient-from-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .xl\\:focus\\:from-blue-300:focus {
    --gradient-from-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .xl\\:focus\\:from-blue-400:focus {
    --gradient-from-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .xl\\:focus\\:from-blue-500:focus {
    --gradient-from-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .xl\\:focus\\:from-blue-600:focus {
    --gradient-from-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .xl\\:focus\\:from-blue-700:focus {
    --gradient-from-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .xl\\:focus\\:from-blue-800:focus {
    --gradient-from-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .xl\\:focus\\:from-blue-900:focus {
    --gradient-from-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .xl\\:focus\\:from-indigo-100:focus {
    --gradient-from-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .xl\\:focus\\:from-indigo-200:focus {
    --gradient-from-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .xl\\:focus\\:from-indigo-300:focus {
    --gradient-from-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .xl\\:focus\\:from-indigo-400:focus {
    --gradient-from-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .xl\\:focus\\:from-indigo-500:focus {
    --gradient-from-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .xl\\:focus\\:from-indigo-600:focus {
    --gradient-from-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .xl\\:focus\\:from-indigo-700:focus {
    --gradient-from-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .xl\\:focus\\:from-indigo-800:focus {
    --gradient-from-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .xl\\:focus\\:from-indigo-900:focus {
    --gradient-from-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .xl\\:focus\\:from-purple-100:focus {
    --gradient-from-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .xl\\:focus\\:from-purple-200:focus {
    --gradient-from-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .xl\\:focus\\:from-purple-300:focus {
    --gradient-from-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .xl\\:focus\\:from-purple-400:focus {
    --gradient-from-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .xl\\:focus\\:from-purple-500:focus {
    --gradient-from-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .xl\\:focus\\:from-purple-600:focus {
    --gradient-from-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .xl\\:focus\\:from-purple-700:focus {
    --gradient-from-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .xl\\:focus\\:from-purple-800:focus {
    --gradient-from-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .xl\\:focus\\:from-purple-900:focus {
    --gradient-from-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .xl\\:focus\\:from-pink-100:focus {
    --gradient-from-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .xl\\:focus\\:from-pink-200:focus {
    --gradient-from-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .xl\\:focus\\:from-pink-300:focus {
    --gradient-from-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .xl\\:focus\\:from-pink-400:focus {
    --gradient-from-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .xl\\:focus\\:from-pink-500:focus {
    --gradient-from-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .xl\\:focus\\:from-pink-600:focus {
    --gradient-from-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .xl\\:focus\\:from-pink-700:focus {
    --gradient-from-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .xl\\:focus\\:from-pink-800:focus {
    --gradient-from-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .xl\\:focus\\:from-pink-900:focus {
    --gradient-from-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .xl\\:focus\\:via-transparent:focus {
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:focus\\:via-current:focus {
    --gradient-via-color: currentColor;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:via-black:focus {
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:focus\\:via-white:focus {
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:via-gray-100:focus {
    --gradient-via-color: #f7fafc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));
  }

  .xl\\:focus\\:via-gray-200:focus {
    --gradient-via-color: #edf2f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));
  }

  .xl\\:focus\\:via-gray-300:focus {
    --gradient-via-color: #e2e8f0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));
  }

  .xl\\:focus\\:via-gray-400:focus {
    --gradient-via-color: #cbd5e0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));
  }

  .xl\\:focus\\:via-gray-500:focus {
    --gradient-via-color: #a0aec0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));
  }

  .xl\\:focus\\:via-gray-600:focus {
    --gradient-via-color: #718096;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));
  }

  .xl\\:focus\\:via-gray-700:focus {
    --gradient-via-color: #4a5568;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));
  }

  .xl\\:focus\\:via-gray-800:focus {
    --gradient-via-color: #2d3748;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));
  }

  .xl\\:focus\\:via-gray-900:focus {
    --gradient-via-color: #1a202c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));
  }

  .xl\\:focus\\:via-red-100:focus {
    --gradient-via-color: #fff5f5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));
  }

  .xl\\:focus\\:via-red-200:focus {
    --gradient-via-color: #fed7d7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));
  }

  .xl\\:focus\\:via-red-300:focus {
    --gradient-via-color: #feb2b2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));
  }

  .xl\\:focus\\:via-red-400:focus {
    --gradient-via-color: #fc8181;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));
  }

  .xl\\:focus\\:via-red-500:focus {
    --gradient-via-color: #f56565;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));
  }

  .xl\\:focus\\:via-red-600:focus {
    --gradient-via-color: #e53e3e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));
  }

  .xl\\:focus\\:via-red-700:focus {
    --gradient-via-color: #c53030;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));
  }

  .xl\\:focus\\:via-red-800:focus {
    --gradient-via-color: #9b2c2c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));
  }

  .xl\\:focus\\:via-red-900:focus {
    --gradient-via-color: #742a2a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));
  }

  .xl\\:focus\\:via-orange-100:focus {
    --gradient-via-color: #fffaf0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));
  }

  .xl\\:focus\\:via-orange-200:focus {
    --gradient-via-color: #feebc8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));
  }

  .xl\\:focus\\:via-orange-300:focus {
    --gradient-via-color: #fbd38d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));
  }

  .xl\\:focus\\:via-orange-400:focus {
    --gradient-via-color: #f6ad55;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));
  }

  .xl\\:focus\\:via-orange-500:focus {
    --gradient-via-color: #ed8936;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));
  }

  .xl\\:focus\\:via-orange-600:focus {
    --gradient-via-color: #dd6b20;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));
  }

  .xl\\:focus\\:via-orange-700:focus {
    --gradient-via-color: #c05621;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));
  }

  .xl\\:focus\\:via-orange-800:focus {
    --gradient-via-color: #9c4221;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));
  }

  .xl\\:focus\\:via-orange-900:focus {
    --gradient-via-color: #7b341e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));
  }

  .xl\\:focus\\:via-yellow-100:focus {
    --gradient-via-color: #fffff0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));
  }

  .xl\\:focus\\:via-yellow-200:focus {
    --gradient-via-color: #fefcbf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));
  }

  .xl\\:focus\\:via-yellow-300:focus {
    --gradient-via-color: #faf089;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));
  }

  .xl\\:focus\\:via-yellow-400:focus {
    --gradient-via-color: #f6e05e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));
  }

  .xl\\:focus\\:via-yellow-500:focus {
    --gradient-via-color: #ecc94b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));
  }

  .xl\\:focus\\:via-yellow-600:focus {
    --gradient-via-color: #d69e2e;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));
  }

  .xl\\:focus\\:via-yellow-700:focus {
    --gradient-via-color: #b7791f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));
  }

  .xl\\:focus\\:via-yellow-800:focus {
    --gradient-via-color: #975a16;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));
  }

  .xl\\:focus\\:via-yellow-900:focus {
    --gradient-via-color: #744210;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));
  }

  .xl\\:focus\\:via-green-100:focus {
    --gradient-via-color: #f0fff4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));
  }

  .xl\\:focus\\:via-green-200:focus {
    --gradient-via-color: #c6f6d5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));
  }

  .xl\\:focus\\:via-green-300:focus {
    --gradient-via-color: #9ae6b4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));
  }

  .xl\\:focus\\:via-green-400:focus {
    --gradient-via-color: #68d391;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));
  }

  .xl\\:focus\\:via-green-500:focus {
    --gradient-via-color: #48bb78;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));
  }

  .xl\\:focus\\:via-green-600:focus {
    --gradient-via-color: #38a169;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));
  }

  .xl\\:focus\\:via-green-700:focus {
    --gradient-via-color: #2f855a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));
  }

  .xl\\:focus\\:via-green-800:focus {
    --gradient-via-color: #276749;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));
  }

  .xl\\:focus\\:via-green-900:focus {
    --gradient-via-color: #22543d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));
  }

  .xl\\:focus\\:via-teal-100:focus {
    --gradient-via-color: #e6fffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));
  }

  .xl\\:focus\\:via-teal-200:focus {
    --gradient-via-color: #b2f5ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));
  }

  .xl\\:focus\\:via-teal-300:focus {
    --gradient-via-color: #81e6d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));
  }

  .xl\\:focus\\:via-teal-400:focus {
    --gradient-via-color: #4fd1c5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));
  }

  .xl\\:focus\\:via-teal-500:focus {
    --gradient-via-color: #38b2ac;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));
  }

  .xl\\:focus\\:via-teal-600:focus {
    --gradient-via-color: #319795;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));
  }

  .xl\\:focus\\:via-teal-700:focus {
    --gradient-via-color: #2c7a7b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));
  }

  .xl\\:focus\\:via-teal-800:focus {
    --gradient-via-color: #285e61;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));
  }

  .xl\\:focus\\:via-teal-900:focus {
    --gradient-via-color: #234e52;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));
  }

  .xl\\:focus\\:via-blue-100:focus {
    --gradient-via-color: #ebf8ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));
  }

  .xl\\:focus\\:via-blue-200:focus {
    --gradient-via-color: #bee3f8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));
  }

  .xl\\:focus\\:via-blue-300:focus {
    --gradient-via-color: #90cdf4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));
  }

  .xl\\:focus\\:via-blue-400:focus {
    --gradient-via-color: #63b3ed;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));
  }

  .xl\\:focus\\:via-blue-500:focus {
    --gradient-via-color: #4299e1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));
  }

  .xl\\:focus\\:via-blue-600:focus {
    --gradient-via-color: #3182ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));
  }

  .xl\\:focus\\:via-blue-700:focus {
    --gradient-via-color: #2b6cb0;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));
  }

  .xl\\:focus\\:via-blue-800:focus {
    --gradient-via-color: #2c5282;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));
  }

  .xl\\:focus\\:via-blue-900:focus {
    --gradient-via-color: #2a4365;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));
  }

  .xl\\:focus\\:via-indigo-100:focus {
    --gradient-via-color: #ebf4ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));
  }

  .xl\\:focus\\:via-indigo-200:focus {
    --gradient-via-color: #c3dafe;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));
  }

  .xl\\:focus\\:via-indigo-300:focus {
    --gradient-via-color: #a3bffa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));
  }

  .xl\\:focus\\:via-indigo-400:focus {
    --gradient-via-color: #7f9cf5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));
  }

  .xl\\:focus\\:via-indigo-500:focus {
    --gradient-via-color: #667eea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));
  }

  .xl\\:focus\\:via-indigo-600:focus {
    --gradient-via-color: #5a67d8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));
  }

  .xl\\:focus\\:via-indigo-700:focus {
    --gradient-via-color: #4c51bf;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));
  }

  .xl\\:focus\\:via-indigo-800:focus {
    --gradient-via-color: #434190;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));
  }

  .xl\\:focus\\:via-indigo-900:focus {
    --gradient-via-color: #3c366b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));
  }

  .xl\\:focus\\:via-purple-100:focus {
    --gradient-via-color: #faf5ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));
  }

  .xl\\:focus\\:via-purple-200:focus {
    --gradient-via-color: #e9d8fd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));
  }

  .xl\\:focus\\:via-purple-300:focus {
    --gradient-via-color: #d6bcfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));
  }

  .xl\\:focus\\:via-purple-400:focus {
    --gradient-via-color: #b794f4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));
  }

  .xl\\:focus\\:via-purple-500:focus {
    --gradient-via-color: #9f7aea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));
  }

  .xl\\:focus\\:via-purple-600:focus {
    --gradient-via-color: #805ad5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));
  }

  .xl\\:focus\\:via-purple-700:focus {
    --gradient-via-color: #6b46c1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));
  }

  .xl\\:focus\\:via-purple-800:focus {
    --gradient-via-color: #553c9a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));
  }

  .xl\\:focus\\:via-purple-900:focus {
    --gradient-via-color: #44337a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));
  }

  .xl\\:focus\\:via-pink-100:focus {
    --gradient-via-color: #fff5f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));
  }

  .xl\\:focus\\:via-pink-200:focus {
    --gradient-via-color: #fed7e2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));
  }

  .xl\\:focus\\:via-pink-300:focus {
    --gradient-via-color: #fbb6ce;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));
  }

  .xl\\:focus\\:via-pink-400:focus {
    --gradient-via-color: #f687b3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));
  }

  .xl\\:focus\\:via-pink-500:focus {
    --gradient-via-color: #ed64a6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));
  }

  .xl\\:focus\\:via-pink-600:focus {
    --gradient-via-color: #d53f8c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));
  }

  .xl\\:focus\\:via-pink-700:focus {
    --gradient-via-color: #b83280;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));
  }

  .xl\\:focus\\:via-pink-800:focus {
    --gradient-via-color: #97266d;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));
  }

  .xl\\:focus\\:via-pink-900:focus {
    --gradient-via-color: #702459;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));
  }

  .xl\\:focus\\:to-transparent:focus {
    --gradient-to-color: transparent;
  }

  .xl\\:focus\\:to-current:focus {
    --gradient-to-color: currentColor;
  }

  .xl\\:focus\\:to-black:focus {
    --gradient-to-color: #000;
  }

  .xl\\:focus\\:to-white:focus {
    --gradient-to-color: #fff;
  }

  .xl\\:focus\\:to-gray-100:focus {
    --gradient-to-color: #f7fafc;
  }

  .xl\\:focus\\:to-gray-200:focus {
    --gradient-to-color: #edf2f7;
  }

  .xl\\:focus\\:to-gray-300:focus {
    --gradient-to-color: #e2e8f0;
  }

  .xl\\:focus\\:to-gray-400:focus {
    --gradient-to-color: #cbd5e0;
  }

  .xl\\:focus\\:to-gray-500:focus {
    --gradient-to-color: #a0aec0;
  }

  .xl\\:focus\\:to-gray-600:focus {
    --gradient-to-color: #718096;
  }

  .xl\\:focus\\:to-gray-700:focus {
    --gradient-to-color: #4a5568;
  }

  .xl\\:focus\\:to-gray-800:focus {
    --gradient-to-color: #2d3748;
  }

  .xl\\:focus\\:to-gray-900:focus {
    --gradient-to-color: #1a202c;
  }

  .xl\\:focus\\:to-red-100:focus {
    --gradient-to-color: #fff5f5;
  }

  .xl\\:focus\\:to-red-200:focus {
    --gradient-to-color: #fed7d7;
  }

  .xl\\:focus\\:to-red-300:focus {
    --gradient-to-color: #feb2b2;
  }

  .xl\\:focus\\:to-red-400:focus {
    --gradient-to-color: #fc8181;
  }

  .xl\\:focus\\:to-red-500:focus {
    --gradient-to-color: #f56565;
  }

  .xl\\:focus\\:to-red-600:focus {
    --gradient-to-color: #e53e3e;
  }

  .xl\\:focus\\:to-red-700:focus {
    --gradient-to-color: #c53030;
  }

  .xl\\:focus\\:to-red-800:focus {
    --gradient-to-color: #9b2c2c;
  }

  .xl\\:focus\\:to-red-900:focus {
    --gradient-to-color: #742a2a;
  }

  .xl\\:focus\\:to-orange-100:focus {
    --gradient-to-color: #fffaf0;
  }

  .xl\\:focus\\:to-orange-200:focus {
    --gradient-to-color: #feebc8;
  }

  .xl\\:focus\\:to-orange-300:focus {
    --gradient-to-color: #fbd38d;
  }

  .xl\\:focus\\:to-orange-400:focus {
    --gradient-to-color: #f6ad55;
  }

  .xl\\:focus\\:to-orange-500:focus {
    --gradient-to-color: #ed8936;
  }

  .xl\\:focus\\:to-orange-600:focus {
    --gradient-to-color: #dd6b20;
  }

  .xl\\:focus\\:to-orange-700:focus {
    --gradient-to-color: #c05621;
  }

  .xl\\:focus\\:to-orange-800:focus {
    --gradient-to-color: #9c4221;
  }

  .xl\\:focus\\:to-orange-900:focus {
    --gradient-to-color: #7b341e;
  }

  .xl\\:focus\\:to-yellow-100:focus {
    --gradient-to-color: #fffff0;
  }

  .xl\\:focus\\:to-yellow-200:focus {
    --gradient-to-color: #fefcbf;
  }

  .xl\\:focus\\:to-yellow-300:focus {
    --gradient-to-color: #faf089;
  }

  .xl\\:focus\\:to-yellow-400:focus {
    --gradient-to-color: #f6e05e;
  }

  .xl\\:focus\\:to-yellow-500:focus {
    --gradient-to-color: #ecc94b;
  }

  .xl\\:focus\\:to-yellow-600:focus {
    --gradient-to-color: #d69e2e;
  }

  .xl\\:focus\\:to-yellow-700:focus {
    --gradient-to-color: #b7791f;
  }

  .xl\\:focus\\:to-yellow-800:focus {
    --gradient-to-color: #975a16;
  }

  .xl\\:focus\\:to-yellow-900:focus {
    --gradient-to-color: #744210;
  }

  .xl\\:focus\\:to-green-100:focus {
    --gradient-to-color: #f0fff4;
  }

  .xl\\:focus\\:to-green-200:focus {
    --gradient-to-color: #c6f6d5;
  }

  .xl\\:focus\\:to-green-300:focus {
    --gradient-to-color: #9ae6b4;
  }

  .xl\\:focus\\:to-green-400:focus {
    --gradient-to-color: #68d391;
  }

  .xl\\:focus\\:to-green-500:focus {
    --gradient-to-color: #48bb78;
  }

  .xl\\:focus\\:to-green-600:focus {
    --gradient-to-color: #38a169;
  }

  .xl\\:focus\\:to-green-700:focus {
    --gradient-to-color: #2f855a;
  }

  .xl\\:focus\\:to-green-800:focus {
    --gradient-to-color: #276749;
  }

  .xl\\:focus\\:to-green-900:focus {
    --gradient-to-color: #22543d;
  }

  .xl\\:focus\\:to-teal-100:focus {
    --gradient-to-color: #e6fffa;
  }

  .xl\\:focus\\:to-teal-200:focus {
    --gradient-to-color: #b2f5ea;
  }

  .xl\\:focus\\:to-teal-300:focus {
    --gradient-to-color: #81e6d9;
  }

  .xl\\:focus\\:to-teal-400:focus {
    --gradient-to-color: #4fd1c5;
  }

  .xl\\:focus\\:to-teal-500:focus {
    --gradient-to-color: #38b2ac;
  }

  .xl\\:focus\\:to-teal-600:focus {
    --gradient-to-color: #319795;
  }

  .xl\\:focus\\:to-teal-700:focus {
    --gradient-to-color: #2c7a7b;
  }

  .xl\\:focus\\:to-teal-800:focus {
    --gradient-to-color: #285e61;
  }

  .xl\\:focus\\:to-teal-900:focus {
    --gradient-to-color: #234e52;
  }

  .xl\\:focus\\:to-blue-100:focus {
    --gradient-to-color: #ebf8ff;
  }

  .xl\\:focus\\:to-blue-200:focus {
    --gradient-to-color: #bee3f8;
  }

  .xl\\:focus\\:to-blue-300:focus {
    --gradient-to-color: #90cdf4;
  }

  .xl\\:focus\\:to-blue-400:focus {
    --gradient-to-color: #63b3ed;
  }

  .xl\\:focus\\:to-blue-500:focus {
    --gradient-to-color: #4299e1;
  }

  .xl\\:focus\\:to-blue-600:focus {
    --gradient-to-color: #3182ce;
  }

  .xl\\:focus\\:to-blue-700:focus {
    --gradient-to-color: #2b6cb0;
  }

  .xl\\:focus\\:to-blue-800:focus {
    --gradient-to-color: #2c5282;
  }

  .xl\\:focus\\:to-blue-900:focus {
    --gradient-to-color: #2a4365;
  }

  .xl\\:focus\\:to-indigo-100:focus {
    --gradient-to-color: #ebf4ff;
  }

  .xl\\:focus\\:to-indigo-200:focus {
    --gradient-to-color: #c3dafe;
  }

  .xl\\:focus\\:to-indigo-300:focus {
    --gradient-to-color: #a3bffa;
  }

  .xl\\:focus\\:to-indigo-400:focus {
    --gradient-to-color: #7f9cf5;
  }

  .xl\\:focus\\:to-indigo-500:focus {
    --gradient-to-color: #667eea;
  }

  .xl\\:focus\\:to-indigo-600:focus {
    --gradient-to-color: #5a67d8;
  }

  .xl\\:focus\\:to-indigo-700:focus {
    --gradient-to-color: #4c51bf;
  }

  .xl\\:focus\\:to-indigo-800:focus {
    --gradient-to-color: #434190;
  }

  .xl\\:focus\\:to-indigo-900:focus {
    --gradient-to-color: #3c366b;
  }

  .xl\\:focus\\:to-purple-100:focus {
    --gradient-to-color: #faf5ff;
  }

  .xl\\:focus\\:to-purple-200:focus {
    --gradient-to-color: #e9d8fd;
  }

  .xl\\:focus\\:to-purple-300:focus {
    --gradient-to-color: #d6bcfa;
  }

  .xl\\:focus\\:to-purple-400:focus {
    --gradient-to-color: #b794f4;
  }

  .xl\\:focus\\:to-purple-500:focus {
    --gradient-to-color: #9f7aea;
  }

  .xl\\:focus\\:to-purple-600:focus {
    --gradient-to-color: #805ad5;
  }

  .xl\\:focus\\:to-purple-700:focus {
    --gradient-to-color: #6b46c1;
  }

  .xl\\:focus\\:to-purple-800:focus {
    --gradient-to-color: #553c9a;
  }

  .xl\\:focus\\:to-purple-900:focus {
    --gradient-to-color: #44337a;
  }

  .xl\\:focus\\:to-pink-100:focus {
    --gradient-to-color: #fff5f7;
  }

  .xl\\:focus\\:to-pink-200:focus {
    --gradient-to-color: #fed7e2;
  }

  .xl\\:focus\\:to-pink-300:focus {
    --gradient-to-color: #fbb6ce;
  }

  .xl\\:focus\\:to-pink-400:focus {
    --gradient-to-color: #f687b3;
  }

  .xl\\:focus\\:to-pink-500:focus {
    --gradient-to-color: #ed64a6;
  }

  .xl\\:focus\\:to-pink-600:focus {
    --gradient-to-color: #d53f8c;
  }

  .xl\\:focus\\:to-pink-700:focus {
    --gradient-to-color: #b83280;
  }

  .xl\\:focus\\:to-pink-800:focus {
    --gradient-to-color: #97266d;
  }

  .xl\\:focus\\:to-pink-900:focus {
    --gradient-to-color: #702459;
  }

  .xl\\:bg-opacity-0 {
    --bg-opacity: 0;
  }

  .xl\\:bg-opacity-25 {
    --bg-opacity: 0.25;
  }

  .xl\\:bg-opacity-50 {
    --bg-opacity: 0.5;
  }

  .xl\\:bg-opacity-75 {
    --bg-opacity: 0.75;
  }

  .xl\\:bg-opacity-100 {
    --bg-opacity: 1;
  }

  .xl\\:hover\\:bg-opacity-0:hover {
    --bg-opacity: 0;
  }

  .xl\\:hover\\:bg-opacity-25:hover {
    --bg-opacity: 0.25;
  }

  .xl\\:hover\\:bg-opacity-50:hover {
    --bg-opacity: 0.5;
  }

  .xl\\:hover\\:bg-opacity-75:hover {
    --bg-opacity: 0.75;
  }

  .xl\\:hover\\:bg-opacity-100:hover {
    --bg-opacity: 1;
  }

  .xl\\:focus\\:bg-opacity-0:focus {
    --bg-opacity: 0;
  }

  .xl\\:focus\\:bg-opacity-25:focus {
    --bg-opacity: 0.25;
  }

  .xl\\:focus\\:bg-opacity-50:focus {
    --bg-opacity: 0.5;
  }

  .xl\\:focus\\:bg-opacity-75:focus {
    --bg-opacity: 0.75;
  }

  .xl\\:focus\\:bg-opacity-100:focus {
    --bg-opacity: 1;
  }

  .xl\\:bg-bottom {
    background-position: bottom;
  }

  .xl\\:bg-center {
    background-position: center;
  }

  .xl\\:bg-left {
    background-position: left;
  }

  .xl\\:bg-left-bottom {
    background-position: left bottom;
  }

  .xl\\:bg-left-top {
    background-position: left top;
  }

  .xl\\:bg-right {
    background-position: right;
  }

  .xl\\:bg-right-bottom {
    background-position: right bottom;
  }

  .xl\\:bg-right-top {
    background-position: right top;
  }

  .xl\\:bg-top {
    background-position: top;
  }

  .xl\\:bg-repeat {
    background-repeat: repeat;
  }

  .xl\\:bg-no-repeat {
    background-repeat: no-repeat;
  }

  .xl\\:bg-repeat-x {
    background-repeat: repeat-x;
  }

  .xl\\:bg-repeat-y {
    background-repeat: repeat-y;
  }

  .xl\\:bg-repeat-round {
    background-repeat: round;
  }

  .xl\\:bg-repeat-space {
    background-repeat: space;
  }

  .xl\\:bg-auto {
    background-size: auto;
  }

  .xl\\:bg-cover {
    background-size: cover;
  }

  .xl\\:bg-contain {
    background-size: contain;
  }

  .xl\\:border-collapse {
    border-collapse: collapse;
  }

  .xl\\:border-separate {
    border-collapse: separate;
  }

  .xl\\:border-transparent {
    border-color: transparent;
  }

  .xl\\:border-current {
    border-color: currentColor;
  }

  .xl\\:border-black {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .xl\\:border-white {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .xl\\:border-gray-100 {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .xl\\:border-gray-200 {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .xl\\:border-gray-300 {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .xl\\:border-gray-400 {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .xl\\:border-gray-500 {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .xl\\:border-gray-600 {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .xl\\:border-gray-700 {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .xl\\:border-gray-800 {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .xl\\:border-gray-900 {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .xl\\:border-red-100 {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .xl\\:border-red-200 {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .xl\\:border-red-300 {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .xl\\:border-red-400 {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .xl\\:border-red-500 {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .xl\\:border-red-600 {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .xl\\:border-red-700 {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .xl\\:border-red-800 {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .xl\\:border-red-900 {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .xl\\:border-orange-100 {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .xl\\:border-orange-200 {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .xl\\:border-orange-300 {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .xl\\:border-orange-400 {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .xl\\:border-orange-500 {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .xl\\:border-orange-600 {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .xl\\:border-orange-700 {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .xl\\:border-orange-800 {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .xl\\:border-orange-900 {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .xl\\:border-yellow-100 {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .xl\\:border-yellow-200 {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .xl\\:border-yellow-300 {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .xl\\:border-yellow-400 {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .xl\\:border-yellow-500 {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .xl\\:border-yellow-600 {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .xl\\:border-yellow-700 {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .xl\\:border-yellow-800 {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .xl\\:border-yellow-900 {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .xl\\:border-green-100 {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .xl\\:border-green-200 {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .xl\\:border-green-300 {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .xl\\:border-green-400 {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .xl\\:border-green-500 {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .xl\\:border-green-600 {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .xl\\:border-green-700 {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .xl\\:border-green-800 {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .xl\\:border-green-900 {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .xl\\:border-teal-100 {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .xl\\:border-teal-200 {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .xl\\:border-teal-300 {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .xl\\:border-teal-400 {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .xl\\:border-teal-500 {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .xl\\:border-teal-600 {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .xl\\:border-teal-700 {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .xl\\:border-teal-800 {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .xl\\:border-teal-900 {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .xl\\:border-blue-100 {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .xl\\:border-blue-200 {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .xl\\:border-blue-300 {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .xl\\:border-blue-400 {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .xl\\:border-blue-500 {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .xl\\:border-blue-600 {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .xl\\:border-blue-700 {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .xl\\:border-blue-800 {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .xl\\:border-blue-900 {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .xl\\:border-indigo-100 {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .xl\\:border-indigo-200 {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .xl\\:border-indigo-300 {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .xl\\:border-indigo-400 {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .xl\\:border-indigo-500 {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .xl\\:border-indigo-600 {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .xl\\:border-indigo-700 {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .xl\\:border-indigo-800 {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .xl\\:border-indigo-900 {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .xl\\:border-purple-100 {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .xl\\:border-purple-200 {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .xl\\:border-purple-300 {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .xl\\:border-purple-400 {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .xl\\:border-purple-500 {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .xl\\:border-purple-600 {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .xl\\:border-purple-700 {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .xl\\:border-purple-800 {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .xl\\:border-purple-900 {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .xl\\:border-pink-100 {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .xl\\:border-pink-200 {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .xl\\:border-pink-300 {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .xl\\:border-pink-400 {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .xl\\:border-pink-500 {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .xl\\:border-pink-600 {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .xl\\:border-pink-700 {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .xl\\:border-pink-800 {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .xl\\:border-pink-900 {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .xl\\:hover\\:border-transparent:hover {
    border-color: transparent;
  }

  .xl\\:hover\\:border-current:hover {
    border-color: currentColor;
  }

  .xl\\:hover\\:border-black:hover {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .xl\\:hover\\:border-white:hover {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-100:hover {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-200:hover {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-300:hover {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-400:hover {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-500:hover {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-600:hover {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-700:hover {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-800:hover {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-900:hover {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-100:hover {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-200:hover {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-300:hover {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-400:hover {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-500:hover {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-600:hover {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-700:hover {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-800:hover {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-900:hover {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-100:hover {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-200:hover {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-300:hover {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-400:hover {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-500:hover {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-600:hover {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-700:hover {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-800:hover {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-900:hover {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-100:hover {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-200:hover {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-300:hover {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-400:hover {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-500:hover {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-600:hover {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-700:hover {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-800:hover {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-900:hover {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-100:hover {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-200:hover {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-300:hover {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-400:hover {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-500:hover {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-600:hover {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-700:hover {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-800:hover {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-900:hover {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-100:hover {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-200:hover {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-300:hover {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-400:hover {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-500:hover {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-600:hover {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-700:hover {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-800:hover {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .xl\\:hover\\:border-teal-900:hover {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-100:hover {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-200:hover {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-300:hover {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-400:hover {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-500:hover {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-600:hover {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-700:hover {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-800:hover {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-900:hover {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-100:hover {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-200:hover {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-300:hover {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-400:hover {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-500:hover {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-600:hover {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-700:hover {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-800:hover {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .xl\\:hover\\:border-indigo-900:hover {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-100:hover {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-200:hover {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-300:hover {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-400:hover {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-500:hover {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-600:hover {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-700:hover {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-800:hover {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .xl\\:hover\\:border-purple-900:hover {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-100:hover {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-200:hover {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-300:hover {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-400:hover {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-500:hover {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-600:hover {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-700:hover {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-800:hover {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .xl\\:hover\\:border-pink-900:hover {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .xl\\:focus\\:border-transparent:focus {
    border-color: transparent;
  }

  .xl\\:focus\\:border-current:focus {
    border-color: currentColor;
  }

  .xl\\:focus\\:border-black:focus {
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .xl\\:focus\\:border-white:focus {
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-100:focus {
    --border-opacity: 1;
    border-color: #f7fafc;
    border-color: rgba(247, 250, 252, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-200:focus {
    --border-opacity: 1;
    border-color: #edf2f7;
    border-color: rgba(237, 242, 247, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-300:focus {
    --border-opacity: 1;
    border-color: #e2e8f0;
    border-color: rgba(226, 232, 240, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-400:focus {
    --border-opacity: 1;
    border-color: #cbd5e0;
    border-color: rgba(203, 213, 224, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-500:focus {
    --border-opacity: 1;
    border-color: #a0aec0;
    border-color: rgba(160, 174, 192, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-600:focus {
    --border-opacity: 1;
    border-color: #718096;
    border-color: rgba(113, 128, 150, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-700:focus {
    --border-opacity: 1;
    border-color: #4a5568;
    border-color: rgba(74, 85, 104, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-800:focus {
    --border-opacity: 1;
    border-color: #2d3748;
    border-color: rgba(45, 55, 72, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-900:focus {
    --border-opacity: 1;
    border-color: #1a202c;
    border-color: rgba(26, 32, 44, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-100:focus {
    --border-opacity: 1;
    border-color: #fff5f5;
    border-color: rgba(255, 245, 245, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-200:focus {
    --border-opacity: 1;
    border-color: #fed7d7;
    border-color: rgba(254, 215, 215, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-300:focus {
    --border-opacity: 1;
    border-color: #feb2b2;
    border-color: rgba(254, 178, 178, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-400:focus {
    --border-opacity: 1;
    border-color: #fc8181;
    border-color: rgba(252, 129, 129, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-500:focus {
    --border-opacity: 1;
    border-color: #f56565;
    border-color: rgba(245, 101, 101, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-600:focus {
    --border-opacity: 1;
    border-color: #e53e3e;
    border-color: rgba(229, 62, 62, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-700:focus {
    --border-opacity: 1;
    border-color: #c53030;
    border-color: rgba(197, 48, 48, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-800:focus {
    --border-opacity: 1;
    border-color: #9b2c2c;
    border-color: rgba(155, 44, 44, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-900:focus {
    --border-opacity: 1;
    border-color: #742a2a;
    border-color: rgba(116, 42, 42, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-100:focus {
    --border-opacity: 1;
    border-color: #fffaf0;
    border-color: rgba(255, 250, 240, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-200:focus {
    --border-opacity: 1;
    border-color: #feebc8;
    border-color: rgba(254, 235, 200, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-300:focus {
    --border-opacity: 1;
    border-color: #fbd38d;
    border-color: rgba(251, 211, 141, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-400:focus {
    --border-opacity: 1;
    border-color: #f6ad55;
    border-color: rgba(246, 173, 85, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-500:focus {
    --border-opacity: 1;
    border-color: #ed8936;
    border-color: rgba(237, 137, 54, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-600:focus {
    --border-opacity: 1;
    border-color: #dd6b20;
    border-color: rgba(221, 107, 32, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-700:focus {
    --border-opacity: 1;
    border-color: #c05621;
    border-color: rgba(192, 86, 33, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-800:focus {
    --border-opacity: 1;
    border-color: #9c4221;
    border-color: rgba(156, 66, 33, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-900:focus {
    --border-opacity: 1;
    border-color: #7b341e;
    border-color: rgba(123, 52, 30, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-100:focus {
    --border-opacity: 1;
    border-color: #fffff0;
    border-color: rgba(255, 255, 240, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-200:focus {
    --border-opacity: 1;
    border-color: #fefcbf;
    border-color: rgba(254, 252, 191, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-300:focus {
    --border-opacity: 1;
    border-color: #faf089;
    border-color: rgba(250, 240, 137, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-400:focus {
    --border-opacity: 1;
    border-color: #f6e05e;
    border-color: rgba(246, 224, 94, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-500:focus {
    --border-opacity: 1;
    border-color: #ecc94b;
    border-color: rgba(236, 201, 75, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-600:focus {
    --border-opacity: 1;
    border-color: #d69e2e;
    border-color: rgba(214, 158, 46, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-700:focus {
    --border-opacity: 1;
    border-color: #b7791f;
    border-color: rgba(183, 121, 31, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-800:focus {
    --border-opacity: 1;
    border-color: #975a16;
    border-color: rgba(151, 90, 22, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-900:focus {
    --border-opacity: 1;
    border-color: #744210;
    border-color: rgba(116, 66, 16, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-100:focus {
    --border-opacity: 1;
    border-color: #f0fff4;
    border-color: rgba(240, 255, 244, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-200:focus {
    --border-opacity: 1;
    border-color: #c6f6d5;
    border-color: rgba(198, 246, 213, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-300:focus {
    --border-opacity: 1;
    border-color: #9ae6b4;
    border-color: rgba(154, 230, 180, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-400:focus {
    --border-opacity: 1;
    border-color: #68d391;
    border-color: rgba(104, 211, 145, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-500:focus {
    --border-opacity: 1;
    border-color: #48bb78;
    border-color: rgba(72, 187, 120, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-600:focus {
    --border-opacity: 1;
    border-color: #38a169;
    border-color: rgba(56, 161, 105, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-700:focus {
    --border-opacity: 1;
    border-color: #2f855a;
    border-color: rgba(47, 133, 90, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-800:focus {
    --border-opacity: 1;
    border-color: #276749;
    border-color: rgba(39, 103, 73, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-900:focus {
    --border-opacity: 1;
    border-color: #22543d;
    border-color: rgba(34, 84, 61, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-100:focus {
    --border-opacity: 1;
    border-color: #e6fffa;
    border-color: rgba(230, 255, 250, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-200:focus {
    --border-opacity: 1;
    border-color: #b2f5ea;
    border-color: rgba(178, 245, 234, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-300:focus {
    --border-opacity: 1;
    border-color: #81e6d9;
    border-color: rgba(129, 230, 217, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-400:focus {
    --border-opacity: 1;
    border-color: #4fd1c5;
    border-color: rgba(79, 209, 197, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-500:focus {
    --border-opacity: 1;
    border-color: #38b2ac;
    border-color: rgba(56, 178, 172, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-600:focus {
    --border-opacity: 1;
    border-color: #319795;
    border-color: rgba(49, 151, 149, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-700:focus {
    --border-opacity: 1;
    border-color: #2c7a7b;
    border-color: rgba(44, 122, 123, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-800:focus {
    --border-opacity: 1;
    border-color: #285e61;
    border-color: rgba(40, 94, 97, var(--border-opacity));
  }

  .xl\\:focus\\:border-teal-900:focus {
    --border-opacity: 1;
    border-color: #234e52;
    border-color: rgba(35, 78, 82, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-100:focus {
    --border-opacity: 1;
    border-color: #ebf8ff;
    border-color: rgba(235, 248, 255, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-200:focus {
    --border-opacity: 1;
    border-color: #bee3f8;
    border-color: rgba(190, 227, 248, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-300:focus {
    --border-opacity: 1;
    border-color: #90cdf4;
    border-color: rgba(144, 205, 244, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-400:focus {
    --border-opacity: 1;
    border-color: #63b3ed;
    border-color: rgba(99, 179, 237, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-500:focus {
    --border-opacity: 1;
    border-color: #4299e1;
    border-color: rgba(66, 153, 225, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-600:focus {
    --border-opacity: 1;
    border-color: #3182ce;
    border-color: rgba(49, 130, 206, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-700:focus {
    --border-opacity: 1;
    border-color: #2b6cb0;
    border-color: rgba(43, 108, 176, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-800:focus {
    --border-opacity: 1;
    border-color: #2c5282;
    border-color: rgba(44, 82, 130, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-900:focus {
    --border-opacity: 1;
    border-color: #2a4365;
    border-color: rgba(42, 67, 101, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-100:focus {
    --border-opacity: 1;
    border-color: #ebf4ff;
    border-color: rgba(235, 244, 255, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-200:focus {
    --border-opacity: 1;
    border-color: #c3dafe;
    border-color: rgba(195, 218, 254, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-300:focus {
    --border-opacity: 1;
    border-color: #a3bffa;
    border-color: rgba(163, 191, 250, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-400:focus {
    --border-opacity: 1;
    border-color: #7f9cf5;
    border-color: rgba(127, 156, 245, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-500:focus {
    --border-opacity: 1;
    border-color: #667eea;
    border-color: rgba(102, 126, 234, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-600:focus {
    --border-opacity: 1;
    border-color: #5a67d8;
    border-color: rgba(90, 103, 216, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-700:focus {
    --border-opacity: 1;
    border-color: #4c51bf;
    border-color: rgba(76, 81, 191, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-800:focus {
    --border-opacity: 1;
    border-color: #434190;
    border-color: rgba(67, 65, 144, var(--border-opacity));
  }

  .xl\\:focus\\:border-indigo-900:focus {
    --border-opacity: 1;
    border-color: #3c366b;
    border-color: rgba(60, 54, 107, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-100:focus {
    --border-opacity: 1;
    border-color: #faf5ff;
    border-color: rgba(250, 245, 255, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-200:focus {
    --border-opacity: 1;
    border-color: #e9d8fd;
    border-color: rgba(233, 216, 253, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-300:focus {
    --border-opacity: 1;
    border-color: #d6bcfa;
    border-color: rgba(214, 188, 250, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-400:focus {
    --border-opacity: 1;
    border-color: #b794f4;
    border-color: rgba(183, 148, 244, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-500:focus {
    --border-opacity: 1;
    border-color: #9f7aea;
    border-color: rgba(159, 122, 234, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-600:focus {
    --border-opacity: 1;
    border-color: #805ad5;
    border-color: rgba(128, 90, 213, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-700:focus {
    --border-opacity: 1;
    border-color: #6b46c1;
    border-color: rgba(107, 70, 193, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-800:focus {
    --border-opacity: 1;
    border-color: #553c9a;
    border-color: rgba(85, 60, 154, var(--border-opacity));
  }

  .xl\\:focus\\:border-purple-900:focus {
    --border-opacity: 1;
    border-color: #44337a;
    border-color: rgba(68, 51, 122, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-100:focus {
    --border-opacity: 1;
    border-color: #fff5f7;
    border-color: rgba(255, 245, 247, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-200:focus {
    --border-opacity: 1;
    border-color: #fed7e2;
    border-color: rgba(254, 215, 226, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-300:focus {
    --border-opacity: 1;
    border-color: #fbb6ce;
    border-color: rgba(251, 182, 206, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-400:focus {
    --border-opacity: 1;
    border-color: #f687b3;
    border-color: rgba(246, 135, 179, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-500:focus {
    --border-opacity: 1;
    border-color: #ed64a6;
    border-color: rgba(237, 100, 166, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-600:focus {
    --border-opacity: 1;
    border-color: #d53f8c;
    border-color: rgba(213, 63, 140, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-700:focus {
    --border-opacity: 1;
    border-color: #b83280;
    border-color: rgba(184, 50, 128, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-800:focus {
    --border-opacity: 1;
    border-color: #97266d;
    border-color: rgba(151, 38, 109, var(--border-opacity));
  }

  .xl\\:focus\\:border-pink-900:focus {
    --border-opacity: 1;
    border-color: #702459;
    border-color: rgba(112, 36, 89, var(--border-opacity));
  }

  .xl\\:border-opacity-0 {
    --border-opacity: 0;
  }

  .xl\\:border-opacity-25 {
    --border-opacity: 0.25;
  }

  .xl\\:border-opacity-50 {
    --border-opacity: 0.5;
  }

  .xl\\:border-opacity-75 {
    --border-opacity: 0.75;
  }

  .xl\\:border-opacity-100 {
    --border-opacity: 1;
  }

  .xl\\:hover\\:border-opacity-0:hover {
    --border-opacity: 0;
  }

  .xl\\:hover\\:border-opacity-25:hover {
    --border-opacity: 0.25;
  }

  .xl\\:hover\\:border-opacity-50:hover {
    --border-opacity: 0.5;
  }

  .xl\\:hover\\:border-opacity-75:hover {
    --border-opacity: 0.75;
  }

  .xl\\:hover\\:border-opacity-100:hover {
    --border-opacity: 1;
  }

  .xl\\:focus\\:border-opacity-0:focus {
    --border-opacity: 0;
  }

  .xl\\:focus\\:border-opacity-25:focus {
    --border-opacity: 0.25;
  }

  .xl\\:focus\\:border-opacity-50:focus {
    --border-opacity: 0.5;
  }

  .xl\\:focus\\:border-opacity-75:focus {
    --border-opacity: 0.75;
  }

  .xl\\:focus\\:border-opacity-100:focus {
    --border-opacity: 1;
  }

  .xl\\:rounded-none {
    border-radius: 0;
  }

  .xl\\:rounded-sm {
    border-radius: 0.125rem;
  }

  .xl\\:rounded {
    border-radius: 0.25rem;
  }

  .xl\\:rounded-md {
    border-radius: 0.375rem;
  }

  .xl\\:rounded-lg {
    border-radius: 0.5rem;
  }

  .xl\\:rounded-xl {
    border-radius: 0.75rem;
  }

  .xl\\:rounded-2xl {
    border-radius: 1rem;
  }

  .xl\\:rounded-3xl {
    border-radius: 1.5rem;
  }

  .xl\\:rounded-full {
    border-radius: 9999px;
  }

  .xl\\:rounded-t-none {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .xl\\:rounded-r-none {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .xl\\:rounded-b-none {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .xl\\:rounded-l-none {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .xl\\:rounded-t-sm {
    border-top-left-radius: 0.125rem;
    border-top-right-radius: 0.125rem;
  }

  .xl\\:rounded-r-sm {
    border-top-right-radius: 0.125rem;
    border-bottom-right-radius: 0.125rem;
  }

  .xl\\:rounded-b-sm {
    border-bottom-right-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }

  .xl\\:rounded-l-sm {
    border-top-left-radius: 0.125rem;
    border-bottom-left-radius: 0.125rem;
  }

  .xl\\:rounded-t {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .xl\\:rounded-r {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }

  .xl\\:rounded-b {
    border-bottom-right-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .xl\\:rounded-l {
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem;
  }

  .xl\\:rounded-t-md {
    border-top-left-radius: 0.375rem;
    border-top-right-radius: 0.375rem;
  }

  .xl\\:rounded-r-md {
    border-top-right-radius: 0.375rem;
    border-bottom-right-radius: 0.375rem;
  }

  .xl\\:rounded-b-md {
    border-bottom-right-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }

  .xl\\:rounded-l-md {
    border-top-left-radius: 0.375rem;
    border-bottom-left-radius: 0.375rem;
  }

  .xl\\:rounded-t-lg {
    border-top-left-radius: 0.5rem;
    border-top-right-radius: 0.5rem;
  }

  .xl\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .xl\\:rounded-b-lg {
    border-bottom-right-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .xl\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .xl\\:rounded-t-xl {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }

  .xl\\:rounded-r-xl {
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }

  .xl\\:rounded-b-xl {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .xl\\:rounded-l-xl {
    border-top-left-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }

  .xl\\:rounded-t-2xl {
    border-top-left-radius: 1rem;
    border-top-right-radius: 1rem;
  }

  .xl\\:rounded-r-2xl {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
  }

  .xl\\:rounded-b-2xl {
    border-bottom-right-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .xl\\:rounded-l-2xl {
    border-top-left-radius: 1rem;
    border-bottom-left-radius: 1rem;
  }

  .xl\\:rounded-t-3xl {
    border-top-left-radius: 1.5rem;
    border-top-right-radius: 1.5rem;
  }

  .xl\\:rounded-r-3xl {
    border-top-right-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
  }

  .xl\\:rounded-b-3xl {
    border-bottom-right-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .xl\\:rounded-l-3xl {
    border-top-left-radius: 1.5rem;
    border-bottom-left-radius: 1.5rem;
  }

  .xl\\:rounded-t-full {
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .xl\\:rounded-r-full {
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .xl\\:rounded-b-full {
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .xl\\:rounded-l-full {
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .xl\\:rounded-tl-none {
    border-top-left-radius: 0;
  }

  .xl\\:rounded-tr-none {
    border-top-right-radius: 0;
  }

  .xl\\:rounded-br-none {
    border-bottom-right-radius: 0;
  }

  .xl\\:rounded-bl-none {
    border-bottom-left-radius: 0;
  }

  .xl\\:rounded-tl-sm {
    border-top-left-radius: 0.125rem;
  }

  .xl\\:rounded-tr-sm {
    border-top-right-radius: 0.125rem;
  }

  .xl\\:rounded-br-sm {
    border-bottom-right-radius: 0.125rem;
  }

  .xl\\:rounded-bl-sm {
    border-bottom-left-radius: 0.125rem;
  }

  .xl\\:rounded-tl {
    border-top-left-radius: 0.25rem;
  }

  .xl\\:rounded-tr {
    border-top-right-radius: 0.25rem;
  }

  .xl\\:rounded-br {
    border-bottom-right-radius: 0.25rem;
  }

  .xl\\:rounded-bl {
    border-bottom-left-radius: 0.25rem;
  }

  .xl\\:rounded-tl-md {
    border-top-left-radius: 0.375rem;
  }

  .xl\\:rounded-tr-md {
    border-top-right-radius: 0.375rem;
  }

  .xl\\:rounded-br-md {
    border-bottom-right-radius: 0.375rem;
  }

  .xl\\:rounded-bl-md {
    border-bottom-left-radius: 0.375rem;
  }

  .xl\\:rounded-tl-lg {
    border-top-left-radius: 0.5rem;
  }

  .xl\\:rounded-tr-lg {
    border-top-right-radius: 0.5rem;
  }

  .xl\\:rounded-br-lg {
    border-bottom-right-radius: 0.5rem;
  }

  .xl\\:rounded-bl-lg {
    border-bottom-left-radius: 0.5rem;
  }

  .xl\\:rounded-tl-xl {
    border-top-left-radius: 0.75rem;
  }

  .xl\\:rounded-tr-xl {
    border-top-right-radius: 0.75rem;
  }

  .xl\\:rounded-br-xl {
    border-bottom-right-radius: 0.75rem;
  }

  .xl\\:rounded-bl-xl {
    border-bottom-left-radius: 0.75rem;
  }

  .xl\\:rounded-tl-2xl {
    border-top-left-radius: 1rem;
  }

  .xl\\:rounded-tr-2xl {
    border-top-right-radius: 1rem;
  }

  .xl\\:rounded-br-2xl {
    border-bottom-right-radius: 1rem;
  }

  .xl\\:rounded-bl-2xl {
    border-bottom-left-radius: 1rem;
  }

  .xl\\:rounded-tl-3xl {
    border-top-left-radius: 1.5rem;
  }

  .xl\\:rounded-tr-3xl {
    border-top-right-radius: 1.5rem;
  }

  .xl\\:rounded-br-3xl {
    border-bottom-right-radius: 1.5rem;
  }

  .xl\\:rounded-bl-3xl {
    border-bottom-left-radius: 1.5rem;
  }

  .xl\\:rounded-tl-full {
    border-top-left-radius: 9999px;
  }

  .xl\\:rounded-tr-full {
    border-top-right-radius: 9999px;
  }

  .xl\\:rounded-br-full {
    border-bottom-right-radius: 9999px;
  }

  .xl\\:rounded-bl-full {
    border-bottom-left-radius: 9999px;
  }

  .xl\\:border-solid {
    border-style: solid;
  }

  .xl\\:border-dashed {
    border-style: dashed;
  }

  .xl\\:border-dotted {
    border-style: dotted;
  }

  .xl\\:border-double {
    border-style: double;
  }

  .xl\\:border-none {
    border-style: none;
  }

  .xl\\:border-0 {
    border-width: 0;
  }

  .xl\\:border-2 {
    border-width: 2px;
  }

  .xl\\:border-4 {
    border-width: 4px;
  }

  .xl\\:border-8 {
    border-width: 8px;
  }

  .xl\\:border {
    border-width: 1px;
  }

  .xl\\:border-t-0 {
    border-top-width: 0;
  }

  .xl\\:border-r-0 {
    border-right-width: 0;
  }

  .xl\\:border-b-0 {
    border-bottom-width: 0;
  }

  .xl\\:border-l-0 {
    border-left-width: 0;
  }

  .xl\\:border-t-2 {
    border-top-width: 2px;
  }

  .xl\\:border-r-2 {
    border-right-width: 2px;
  }

  .xl\\:border-b-2 {
    border-bottom-width: 2px;
  }

  .xl\\:border-l-2 {
    border-left-width: 2px;
  }

  .xl\\:border-t-4 {
    border-top-width: 4px;
  }

  .xl\\:border-r-4 {
    border-right-width: 4px;
  }

  .xl\\:border-b-4 {
    border-bottom-width: 4px;
  }

  .xl\\:border-l-4 {
    border-left-width: 4px;
  }

  .xl\\:border-t-8 {
    border-top-width: 8px;
  }

  .xl\\:border-r-8 {
    border-right-width: 8px;
  }

  .xl\\:border-b-8 {
    border-bottom-width: 8px;
  }

  .xl\\:border-l-8 {
    border-left-width: 8px;
  }

  .xl\\:border-t {
    border-top-width: 1px;
  }

  .xl\\:border-r {
    border-right-width: 1px;
  }

  .xl\\:border-b {
    border-bottom-width: 1px;
  }

  .xl\\:border-l {
    border-left-width: 1px;
  }

  .xl\\:box-border {
    box-sizing: border-box;
  }

  .xl\\:box-content {
    box-sizing: content-box;
  }

  .xl\\:cursor-auto {
    cursor: auto;
  }

  .xl\\:cursor-default {
    cursor: default;
  }

  .xl\\:cursor-pointer {
    cursor: pointer;
  }

  .xl\\:cursor-wait {
    cursor: wait;
  }

  .xl\\:cursor-text {
    cursor: text;
  }

  .xl\\:cursor-move {
    cursor: move;
  }

  .xl\\:cursor-not-allowed {
    cursor: not-allowed;
  }

  .xl\\:block {
    display: block;
  }

  .xl\\:inline-block {
    display: inline-block;
  }

  .xl\\:inline {
    display: inline;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:inline-flex {
    display: inline-flex;
  }

  .xl\\:table {
    display: table;
  }

  .xl\\:table-caption {
    display: table-caption;
  }

  .xl\\:table-cell {
    display: table-cell;
  }

  .xl\\:table-column {
    display: table-column;
  }

  .xl\\:table-column-group {
    display: table-column-group;
  }

  .xl\\:table-footer-group {
    display: table-footer-group;
  }

  .xl\\:table-header-group {
    display: table-header-group;
  }

  .xl\\:table-row-group {
    display: table-row-group;
  }

  .xl\\:table-row {
    display: table-row;
  }

  .xl\\:flow-root {
    display: flow-root;
  }

  .xl\\:grid {
    display: grid;
  }

  .xl\\:inline-grid {
    display: inline-grid;
  }

  .xl\\:contents {
    display: contents;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:flex-row-reverse {
    flex-direction: row-reverse;
  }

  .xl\\:flex-col {
    flex-direction: column;
  }

  .xl\\:flex-col-reverse {
    flex-direction: column-reverse;
  }

  .xl\\:flex-wrap {
    flex-wrap: wrap;
  }

  .xl\\:flex-wrap-reverse {
    flex-wrap: wrap-reverse;
  }

  .xl\\:flex-no-wrap {
    flex-wrap: nowrap;
  }

  .xl\\:place-items-auto {
    place-items: auto;
  }

  .xl\\:place-items-start {
    place-items: start;
  }

  .xl\\:place-items-end {
    place-items: end;
  }

  .xl\\:place-items-center {
    place-items: center;
  }

  .xl\\:place-items-stretch {
    place-items: stretch;
  }

  .xl\\:place-content-center {
    place-content: center;
  }

  .xl\\:place-content-start {
    place-content: start;
  }

  .xl\\:place-content-end {
    place-content: end;
  }

  .xl\\:place-content-between {
    place-content: space-between;
  }

  .xl\\:place-content-around {
    place-content: space-around;
  }

  .xl\\:place-content-evenly {
    place-content: space-evenly;
  }

  .xl\\:place-content-stretch {
    place-content: stretch;
  }

  .xl\\:place-self-auto {
    place-self: auto;
  }

  .xl\\:place-self-start {
    place-self: start;
  }

  .xl\\:place-self-end {
    place-self: end;
  }

  .xl\\:place-self-center {
    place-self: center;
  }

  .xl\\:place-self-stretch {
    place-self: stretch;
  }

  .xl\\:items-start {
    align-items: flex-start;
  }

  .xl\\:items-end {
    align-items: flex-end;
  }

  .xl\\:items-center {
    align-items: center;
  }

  .xl\\:items-baseline {
    align-items: baseline;
  }

  .xl\\:items-stretch {
    align-items: stretch;
  }

  .xl\\:content-center {
    align-content: center;
  }

  .xl\\:content-start {
    align-content: flex-start;
  }

  .xl\\:content-end {
    align-content: flex-end;
  }

  .xl\\:content-between {
    align-content: space-between;
  }

  .xl\\:content-around {
    align-content: space-around;
  }

  .xl\\:content-evenly {
    align-content: space-evenly;
  }

  .xl\\:self-auto {
    align-self: auto;
  }

  .xl\\:self-start {
    align-self: flex-start;
  }

  .xl\\:self-end {
    align-self: flex-end;
  }

  .xl\\:self-center {
    align-self: center;
  }

  .xl\\:self-stretch {
    align-self: stretch;
  }

  .xl\\:justify-items-auto {
    justify-items: auto;
  }

  .xl\\:justify-items-start {
    justify-items: start;
  }

  .xl\\:justify-items-end {
    justify-items: end;
  }

  .xl\\:justify-items-center {
    justify-items: center;
  }

  .xl\\:justify-items-stretch {
    justify-items: stretch;
  }

  .xl\\:justify-start {
    justify-content: flex-start;
  }

  .xl\\:justify-end {
    justify-content: flex-end;
  }

  .xl\\:justify-center {
    justify-content: center;
  }

  .xl\\:justify-between {
    justify-content: space-between;
  }

  .xl\\:justify-around {
    justify-content: space-around;
  }

  .xl\\:justify-evenly {
    justify-content: space-evenly;
  }

  .xl\\:justify-self-auto {
    justify-self: auto;
  }

  .xl\\:justify-self-start {
    justify-self: start;
  }

  .xl\\:justify-self-end {
    justify-self: end;
  }

  .xl\\:justify-self-center {
    justify-self: center;
  }

  .xl\\:justify-self-stretch {
    justify-self: stretch;
  }

  .xl\\:flex-1 {
    flex: 1 1;
  }

  .xl\\:flex-auto {
    flex: 1 1 auto;
  }

  .xl\\:flex-initial {
    flex: 0 1 auto;
  }

  .xl\\:flex-none {
    flex: none;
  }

  .xl\\:flex-grow-0 {
    flex-grow: 0;
  }

  .xl\\:flex-grow {
    flex-grow: 1;
  }

  .xl\\:flex-shrink-0 {
    flex-shrink: 0;
  }

  .xl\\:flex-shrink {
    flex-shrink: 1;
  }

  .xl\\:order-1 {
    order: 1;
  }

  .xl\\:order-2 {
    order: 2;
  }

  .xl\\:order-3 {
    order: 3;
  }

  .xl\\:order-4 {
    order: 4;
  }

  .xl\\:order-5 {
    order: 5;
  }

  .xl\\:order-6 {
    order: 6;
  }

  .xl\\:order-7 {
    order: 7;
  }

  .xl\\:order-8 {
    order: 8;
  }

  .xl\\:order-9 {
    order: 9;
  }

  .xl\\:order-10 {
    order: 10;
  }

  .xl\\:order-11 {
    order: 11;
  }

  .xl\\:order-12 {
    order: 12;
  }

  .xl\\:order-first {
    order: -9999;
  }

  .xl\\:order-last {
    order: 9999;
  }

  .xl\\:order-none {
    order: 0;
  }

  .xl\\:float-right {
    float: right;
  }

  .xl\\:float-left {
    float: left;
  }

  .xl\\:float-none {
    float: none;
  }

  .xl\\:clearfix:after {
    content: "";
    display: table;
    clear: both;
  }

  .xl\\:clear-left {
    clear: left;
  }

  .xl\\:clear-right {
    clear: right;
  }

  .xl\\:clear-both {
    clear: both;
  }

  .xl\\:clear-none {
    clear: none;
  }

  .xl\\:font-sans {
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .xl\\:font-serif {
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .xl\\:font-mono {
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .xl\\:font-hairline {
    font-weight: 100;
  }

  .xl\\:font-thin {
    font-weight: 200;
  }

  .xl\\:font-light {
    font-weight: 300;
  }

  .xl\\:font-normal {
    font-weight: 400;
  }

  .xl\\:font-medium {
    font-weight: 500;
  }

  .xl\\:font-semibold {
    font-weight: 600;
  }

  .xl\\:font-bold {
    font-weight: 700;
  }

  .xl\\:font-extrabold {
    font-weight: 800;
  }

  .xl\\:font-black {
    font-weight: 900;
  }

  .xl\\:hover\\:font-hairline:hover {
    font-weight: 100;
  }

  .xl\\:hover\\:font-thin:hover {
    font-weight: 200;
  }

  .xl\\:hover\\:font-light:hover {
    font-weight: 300;
  }

  .xl\\:hover\\:font-normal:hover {
    font-weight: 400;
  }

  .xl\\:hover\\:font-medium:hover {
    font-weight: 500;
  }

  .xl\\:hover\\:font-semibold:hover {
    font-weight: 600;
  }

  .xl\\:hover\\:font-bold:hover {
    font-weight: 700;
  }

  .xl\\:hover\\:font-extrabold:hover {
    font-weight: 800;
  }

  .xl\\:hover\\:font-black:hover {
    font-weight: 900;
  }

  .xl\\:focus\\:font-hairline:focus {
    font-weight: 100;
  }

  .xl\\:focus\\:font-thin:focus {
    font-weight: 200;
  }

  .xl\\:focus\\:font-light:focus {
    font-weight: 300;
  }

  .xl\\:focus\\:font-normal:focus {
    font-weight: 400;
  }

  .xl\\:focus\\:font-medium:focus {
    font-weight: 500;
  }

  .xl\\:focus\\:font-semibold:focus {
    font-weight: 600;
  }

  .xl\\:focus\\:font-bold:focus {
    font-weight: 700;
  }

  .xl\\:focus\\:font-extrabold:focus {
    font-weight: 800;
  }

  .xl\\:focus\\:font-black:focus {
    font-weight: 900;
  }

  .xl\\:h-0 {
    height: 0;
  }

  .xl\\:h-1 {
    height: 0.25rem;
  }

  .xl\\:h-2 {
    height: 0.5rem;
  }

  .xl\\:h-3 {
    height: 0.75rem;
  }

  .xl\\:h-4 {
    height: 1rem;
  }

  .xl\\:h-5 {
    height: 1.25rem;
  }

  .xl\\:h-6 {
    height: 1.5rem;
  }

  .xl\\:h-8 {
    height: 2rem;
  }

  .xl\\:h-10 {
    height: 2.5rem;
  }

  .xl\\:h-12 {
    height: 3rem;
  }

  .xl\\:h-16 {
    height: 4rem;
  }

  .xl\\:h-20 {
    height: 5rem;
  }

  .xl\\:h-24 {
    height: 6rem;
  }

  .xl\\:h-32 {
    height: 8rem;
  }

  .xl\\:h-40 {
    height: 10rem;
  }

  .xl\\:h-48 {
    height: 12rem;
  }

  .xl\\:h-56 {
    height: 14rem;
  }

  .xl\\:h-64 {
    height: 16rem;
  }

  .xl\\:h-auto {
    height: auto;
  }

  .xl\\:h-px {
    height: 1px;
  }

  .xl\\:h-full {
    height: 100%;
  }

  .xl\\:h-screen {
    height: 100vh;
  }

  .xl\\:text-15 {
    font-size: 0.9375rem;
  }

  .xl\\:text-xs {
    font-size: 0.75rem;
  }

  .xl\\:text-sm {
    font-size: 0.875rem;
  }

  .xl\\:text-base {
    font-size: 1rem;
  }

  .xl\\:text-lg {
    font-size: 1.125rem;
  }

  .xl\\:text-xl {
    font-size: 1.25rem;
  }

  .xl\\:text-1\\.5xl {
    font-size: 1.375rem;
  }

  .xl\\:text-2xl {
    font-size: 1.5rem;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
  }

  .xl\\:text-4xl {
    font-size: 2.25rem;
  }

  .xl\\:text-5xl {
    font-size: 3rem;
  }

  .xl\\:text-6xl {
    font-size: 4rem;
  }

  .xl\\:leading-3 {
    line-height: 0.75rem;
  }

  .xl\\:leading-4 {
    line-height: 1rem;
  }

  .xl\\:leading-5 {
    line-height: 1.25rem;
  }

  .xl\\:leading-6 {
    line-height: 1.5rem;
  }

  .xl\\:leading-7 {
    line-height: 1.75rem;
  }

  .xl\\:leading-8 {
    line-height: 2rem;
  }

  .xl\\:leading-9 {
    line-height: 2.25rem;
  }

  .xl\\:leading-10 {
    line-height: 2.5rem;
  }

  .xl\\:leading-none {
    line-height: 1;
  }

  .xl\\:leading-tight {
    line-height: 1.25;
  }

  .xl\\:leading-snug {
    line-height: 1.375;
  }

  .xl\\:leading-normal {
    line-height: 1.5;
  }

  .xl\\:leading-relaxed {
    line-height: 1.625;
  }

  .xl\\:leading-loose {
    line-height: 2;
  }

  .xl\\:list-inside {
    list-style-position: inside;
  }

  .xl\\:list-outside {
    list-style-position: outside;
  }

  .xl\\:list-none {
    list-style-type: none;
  }

  .xl\\:list-disc {
    list-style-type: disc;
  }

  .xl\\:list-decimal {
    list-style-type: decimal;
  }

  .xl\\:m-0 {
    margin: 0;
  }

  .xl\\:m-1 {
    margin: 0.25rem;
  }

  .xl\\:m-2 {
    margin: 0.5rem;
  }

  .xl\\:m-3 {
    margin: 0.75rem;
  }

  .xl\\:m-4 {
    margin: 1rem;
  }

  .xl\\:m-5 {
    margin: 1.25rem;
  }

  .xl\\:m-6 {
    margin: 1.5rem;
  }

  .xl\\:m-8 {
    margin: 2rem;
  }

  .xl\\:m-10 {
    margin: 2.5rem;
  }

  .xl\\:m-12 {
    margin: 3rem;
  }

  .xl\\:m-16 {
    margin: 4rem;
  }

  .xl\\:m-20 {
    margin: 5rem;
  }

  .xl\\:m-24 {
    margin: 6rem;
  }

  .xl\\:m-32 {
    margin: 8rem;
  }

  .xl\\:m-40 {
    margin: 10rem;
  }

  .xl\\:m-48 {
    margin: 12rem;
  }

  .xl\\:m-56 {
    margin: 14rem;
  }

  .xl\\:m-64 {
    margin: 16rem;
  }

  .xl\\:m-auto {
    margin: auto;
  }

  .xl\\:m-px {
    margin: 1px;
  }

  .xl\\:-m-1 {
    margin: -0.25rem;
  }

  .xl\\:-m-2 {
    margin: -0.5rem;
  }

  .xl\\:-m-3 {
    margin: -0.75rem;
  }

  .xl\\:-m-4 {
    margin: -1rem;
  }

  .xl\\:-m-5 {
    margin: -1.25rem;
  }

  .xl\\:-m-6 {
    margin: -1.5rem;
  }

  .xl\\:-m-8 {
    margin: -2rem;
  }

  .xl\\:-m-10 {
    margin: -2.5rem;
  }

  .xl\\:-m-12 {
    margin: -3rem;
  }

  .xl\\:-m-16 {
    margin: -4rem;
  }

  .xl\\:-m-20 {
    margin: -5rem;
  }

  .xl\\:-m-24 {
    margin: -6rem;
  }

  .xl\\:-m-32 {
    margin: -8rem;
  }

  .xl\\:-m-40 {
    margin: -10rem;
  }

  .xl\\:-m-48 {
    margin: -12rem;
  }

  .xl\\:-m-56 {
    margin: -14rem;
  }

  .xl\\:-m-64 {
    margin: -16rem;
  }

  .xl\\:-m-px {
    margin: -1px;
  }

  .xl\\:my-0 {
    margin-top: 0;
    margin-bottom: 0;
  }

  .xl\\:mx-0 {
    margin-left: 0;
    margin-right: 0;
  }

  .xl\\:my-1 {
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .xl\\:mx-1 {
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .xl\\:my-2 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .xl\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .xl\\:my-3 {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .xl\\:mx-3 {
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .xl\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .xl\\:mx-4 {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .xl\\:my-5 {
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .xl\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .xl\\:my-6 {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .xl\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .xl\\:my-8 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .xl\\:mx-8 {
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .xl\\:my-10 {
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .xl\\:mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .xl\\:my-12 {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .xl\\:mx-12 {
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .xl\\:my-16 {
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .xl\\:mx-16 {
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .xl\\:my-20 {
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .xl\\:mx-20 {
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .xl\\:my-24 {
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .xl\\:mx-24 {
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .xl\\:my-32 {
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .xl\\:mx-32 {
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .xl\\:my-40 {
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .xl\\:mx-40 {
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .xl\\:my-48 {
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .xl\\:mx-48 {
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .xl\\:my-56 {
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .xl\\:mx-56 {
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .xl\\:my-64 {
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .xl\\:mx-64 {
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .xl\\:my-auto {
    margin-top: auto;
    margin-bottom: auto;
  }

  .xl\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .xl\\:my-px {
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .xl\\:mx-px {
    margin-left: 1px;
    margin-right: 1px;
  }

  .xl\\:-my-1 {
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .xl\\:-mx-1 {
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .xl\\:-my-2 {
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .xl\\:-mx-2 {
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .xl\\:-my-3 {
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .xl\\:-mx-3 {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .xl\\:-my-4 {
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .xl\\:-mx-4 {
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .xl\\:-my-5 {
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .xl\\:-mx-5 {
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .xl\\:-my-6 {
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .xl\\:-mx-6 {
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .xl\\:-my-8 {
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .xl\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .xl\\:-my-10 {
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .xl\\:-mx-10 {
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .xl\\:-my-12 {
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .xl\\:-mx-12 {
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .xl\\:-my-16 {
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .xl\\:-mx-16 {
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .xl\\:-my-20 {
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .xl\\:-mx-20 {
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .xl\\:-my-24 {
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .xl\\:-mx-24 {
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .xl\\:-my-32 {
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .xl\\:-mx-32 {
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .xl\\:-my-40 {
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .xl\\:-mx-40 {
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .xl\\:-my-48 {
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .xl\\:-mx-48 {
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .xl\\:-my-56 {
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .xl\\:-mx-56 {
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .xl\\:-my-64 {
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .xl\\:-mx-64 {
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .xl\\:-my-px {
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .xl\\:-mx-px {
    margin-left: -1px;
    margin-right: -1px;
  }

  .xl\\:mt-0 {
    margin-top: 0;
  }

  .xl\\:mr-0 {
    margin-right: 0;
  }

  .xl\\:mb-0 {
    margin-bottom: 0;
  }

  .xl\\:ml-0 {
    margin-left: 0;
  }

  .xl\\:mt-1 {
    margin-top: 0.25rem;
  }

  .xl\\:mr-1 {
    margin-right: 0.25rem;
  }

  .xl\\:mb-1 {
    margin-bottom: 0.25rem;
  }

  .xl\\:ml-1 {
    margin-left: 0.25rem;
  }

  .xl\\:mt-2 {
    margin-top: 0.5rem;
  }

  .xl\\:mr-2 {
    margin-right: 0.5rem;
  }

  .xl\\:mb-2 {
    margin-bottom: 0.5rem;
  }

  .xl\\:ml-2 {
    margin-left: 0.5rem;
  }

  .xl\\:mt-3 {
    margin-top: 0.75rem;
  }

  .xl\\:mr-3 {
    margin-right: 0.75rem;
  }

  .xl\\:mb-3 {
    margin-bottom: 0.75rem;
  }

  .xl\\:ml-3 {
    margin-left: 0.75rem;
  }

  .xl\\:mt-4 {
    margin-top: 1rem;
  }

  .xl\\:mr-4 {
    margin-right: 1rem;
  }

  .xl\\:mb-4 {
    margin-bottom: 1rem;
  }

  .xl\\:ml-4 {
    margin-left: 1rem;
  }

  .xl\\:mt-5 {
    margin-top: 1.25rem;
  }

  .xl\\:mr-5 {
    margin-right: 1.25rem;
  }

  .xl\\:mb-5 {
    margin-bottom: 1.25rem;
  }

  .xl\\:ml-5 {
    margin-left: 1.25rem;
  }

  .xl\\:mt-6 {
    margin-top: 1.5rem;
  }

  .xl\\:mr-6 {
    margin-right: 1.5rem;
  }

  .xl\\:mb-6 {
    margin-bottom: 1.5rem;
  }

  .xl\\:ml-6 {
    margin-left: 1.5rem;
  }

  .xl\\:mt-8 {
    margin-top: 2rem;
  }

  .xl\\:mr-8 {
    margin-right: 2rem;
  }

  .xl\\:mb-8 {
    margin-bottom: 2rem;
  }

  .xl\\:ml-8 {
    margin-left: 2rem;
  }

  .xl\\:mt-10 {
    margin-top: 2.5rem;
  }

  .xl\\:mr-10 {
    margin-right: 2.5rem;
  }

  .xl\\:mb-10 {
    margin-bottom: 2.5rem;
  }

  .xl\\:ml-10 {
    margin-left: 2.5rem;
  }

  .xl\\:mt-12 {
    margin-top: 3rem;
  }

  .xl\\:mr-12 {
    margin-right: 3rem;
  }

  .xl\\:mb-12 {
    margin-bottom: 3rem;
  }

  .xl\\:ml-12 {
    margin-left: 3rem;
  }

  .xl\\:mt-16 {
    margin-top: 4rem;
  }

  .xl\\:mr-16 {
    margin-right: 4rem;
  }

  .xl\\:mb-16 {
    margin-bottom: 4rem;
  }

  .xl\\:ml-16 {
    margin-left: 4rem;
  }

  .xl\\:mt-20 {
    margin-top: 5rem;
  }

  .xl\\:mr-20 {
    margin-right: 5rem;
  }

  .xl\\:mb-20 {
    margin-bottom: 5rem;
  }

  .xl\\:ml-20 {
    margin-left: 5rem;
  }

  .xl\\:mt-24 {
    margin-top: 6rem;
  }

  .xl\\:mr-24 {
    margin-right: 6rem;
  }

  .xl\\:mb-24 {
    margin-bottom: 6rem;
  }

  .xl\\:ml-24 {
    margin-left: 6rem;
  }

  .xl\\:mt-32 {
    margin-top: 8rem;
  }

  .xl\\:mr-32 {
    margin-right: 8rem;
  }

  .xl\\:mb-32 {
    margin-bottom: 8rem;
  }

  .xl\\:ml-32 {
    margin-left: 8rem;
  }

  .xl\\:mt-40 {
    margin-top: 10rem;
  }

  .xl\\:mr-40 {
    margin-right: 10rem;
  }

  .xl\\:mb-40 {
    margin-bottom: 10rem;
  }

  .xl\\:ml-40 {
    margin-left: 10rem;
  }

  .xl\\:mt-48 {
    margin-top: 12rem;
  }

  .xl\\:mr-48 {
    margin-right: 12rem;
  }

  .xl\\:mb-48 {
    margin-bottom: 12rem;
  }

  .xl\\:ml-48 {
    margin-left: 12rem;
  }

  .xl\\:mt-56 {
    margin-top: 14rem;
  }

  .xl\\:mr-56 {
    margin-right: 14rem;
  }

  .xl\\:mb-56 {
    margin-bottom: 14rem;
  }

  .xl\\:ml-56 {
    margin-left: 14rem;
  }

  .xl\\:mt-64 {
    margin-top: 16rem;
  }

  .xl\\:mr-64 {
    margin-right: 16rem;
  }

  .xl\\:mb-64 {
    margin-bottom: 16rem;
  }

  .xl\\:ml-64 {
    margin-left: 16rem;
  }

  .xl\\:mt-auto {
    margin-top: auto;
  }

  .xl\\:mr-auto {
    margin-right: auto;
  }

  .xl\\:mb-auto {
    margin-bottom: auto;
  }

  .xl\\:ml-auto {
    margin-left: auto;
  }

  .xl\\:mt-px {
    margin-top: 1px;
  }

  .xl\\:mr-px {
    margin-right: 1px;
  }

  .xl\\:mb-px {
    margin-bottom: 1px;
  }

  .xl\\:ml-px {
    margin-left: 1px;
  }

  .xl\\:-mt-1 {
    margin-top: -0.25rem;
  }

  .xl\\:-mr-1 {
    margin-right: -0.25rem;
  }

  .xl\\:-mb-1 {
    margin-bottom: -0.25rem;
  }

  .xl\\:-ml-1 {
    margin-left: -0.25rem;
  }

  .xl\\:-mt-2 {
    margin-top: -0.5rem;
  }

  .xl\\:-mr-2 {
    margin-right: -0.5rem;
  }

  .xl\\:-mb-2 {
    margin-bottom: -0.5rem;
  }

  .xl\\:-ml-2 {
    margin-left: -0.5rem;
  }

  .xl\\:-mt-3 {
    margin-top: -0.75rem;
  }

  .xl\\:-mr-3 {
    margin-right: -0.75rem;
  }

  .xl\\:-mb-3 {
    margin-bottom: -0.75rem;
  }

  .xl\\:-ml-3 {
    margin-left: -0.75rem;
  }

  .xl\\:-mt-4 {
    margin-top: -1rem;
  }

  .xl\\:-mr-4 {
    margin-right: -1rem;
  }

  .xl\\:-mb-4 {
    margin-bottom: -1rem;
  }

  .xl\\:-ml-4 {
    margin-left: -1rem;
  }

  .xl\\:-mt-5 {
    margin-top: -1.25rem;
  }

  .xl\\:-mr-5 {
    margin-right: -1.25rem;
  }

  .xl\\:-mb-5 {
    margin-bottom: -1.25rem;
  }

  .xl\\:-ml-5 {
    margin-left: -1.25rem;
  }

  .xl\\:-mt-6 {
    margin-top: -1.5rem;
  }

  .xl\\:-mr-6 {
    margin-right: -1.5rem;
  }

  .xl\\:-mb-6 {
    margin-bottom: -1.5rem;
  }

  .xl\\:-ml-6 {
    margin-left: -1.5rem;
  }

  .xl\\:-mt-8 {
    margin-top: -2rem;
  }

  .xl\\:-mr-8 {
    margin-right: -2rem;
  }

  .xl\\:-mb-8 {
    margin-bottom: -2rem;
  }

  .xl\\:-ml-8 {
    margin-left: -2rem;
  }

  .xl\\:-mt-10 {
    margin-top: -2.5rem;
  }

  .xl\\:-mr-10 {
    margin-right: -2.5rem;
  }

  .xl\\:-mb-10 {
    margin-bottom: -2.5rem;
  }

  .xl\\:-ml-10 {
    margin-left: -2.5rem;
  }

  .xl\\:-mt-12 {
    margin-top: -3rem;
  }

  .xl\\:-mr-12 {
    margin-right: -3rem;
  }

  .xl\\:-mb-12 {
    margin-bottom: -3rem;
  }

  .xl\\:-ml-12 {
    margin-left: -3rem;
  }

  .xl\\:-mt-16 {
    margin-top: -4rem;
  }

  .xl\\:-mr-16 {
    margin-right: -4rem;
  }

  .xl\\:-mb-16 {
    margin-bottom: -4rem;
  }

  .xl\\:-ml-16 {
    margin-left: -4rem;
  }

  .xl\\:-mt-20 {
    margin-top: -5rem;
  }

  .xl\\:-mr-20 {
    margin-right: -5rem;
  }

  .xl\\:-mb-20 {
    margin-bottom: -5rem;
  }

  .xl\\:-ml-20 {
    margin-left: -5rem;
  }

  .xl\\:-mt-24 {
    margin-top: -6rem;
  }

  .xl\\:-mr-24 {
    margin-right: -6rem;
  }

  .xl\\:-mb-24 {
    margin-bottom: -6rem;
  }

  .xl\\:-ml-24 {
    margin-left: -6rem;
  }

  .xl\\:-mt-32 {
    margin-top: -8rem;
  }

  .xl\\:-mr-32 {
    margin-right: -8rem;
  }

  .xl\\:-mb-32 {
    margin-bottom: -8rem;
  }

  .xl\\:-ml-32 {
    margin-left: -8rem;
  }

  .xl\\:-mt-40 {
    margin-top: -10rem;
  }

  .xl\\:-mr-40 {
    margin-right: -10rem;
  }

  .xl\\:-mb-40 {
    margin-bottom: -10rem;
  }

  .xl\\:-ml-40 {
    margin-left: -10rem;
  }

  .xl\\:-mt-48 {
    margin-top: -12rem;
  }

  .xl\\:-mr-48 {
    margin-right: -12rem;
  }

  .xl\\:-mb-48 {
    margin-bottom: -12rem;
  }

  .xl\\:-ml-48 {
    margin-left: -12rem;
  }

  .xl\\:-mt-56 {
    margin-top: -14rem;
  }

  .xl\\:-mr-56 {
    margin-right: -14rem;
  }

  .xl\\:-mb-56 {
    margin-bottom: -14rem;
  }

  .xl\\:-ml-56 {
    margin-left: -14rem;
  }

  .xl\\:-mt-64 {
    margin-top: -16rem;
  }

  .xl\\:-mr-64 {
    margin-right: -16rem;
  }

  .xl\\:-mb-64 {
    margin-bottom: -16rem;
  }

  .xl\\:-ml-64 {
    margin-left: -16rem;
  }

  .xl\\:-mt-px {
    margin-top: -1px;
  }

  .xl\\:-mr-px {
    margin-right: -1px;
  }

  .xl\\:-mb-px {
    margin-bottom: -1px;
  }

  .xl\\:-ml-px {
    margin-left: -1px;
  }

  .xl\\:max-h-full {
    max-height: 100%;
  }

  .xl\\:max-h-screen {
    max-height: 100vh;
  }

  .xl\\:max-w-none {
    max-width: none;
  }

  .xl\\:max-w-xs {
    max-width: 20rem;
  }

  .xl\\:max-w-sm {
    max-width: 24rem;
  }

  .xl\\:max-w-md {
    max-width: 28rem;
  }

  .xl\\:max-w-lg {
    max-width: 32rem;
  }

  .xl\\:max-w-xl {
    max-width: 36rem;
  }

  .xl\\:max-w-2xl {
    max-width: 42rem;
  }

  .xl\\:max-w-3xl {
    max-width: 48rem;
  }

  .xl\\:max-w-4xl {
    max-width: 56rem;
  }

  .xl\\:max-w-5xl {
    max-width: 64rem;
  }

  .xl\\:max-w-6xl {
    max-width: 72rem;
  }

  .xl\\:max-w-full {
    max-width: 100%;
  }

  .xl\\:max-w-screen-sm {
    max-width: 640px;
  }

  .xl\\:max-w-screen-md {
    max-width: 768px;
  }

  .xl\\:max-w-screen-lg {
    max-width: 1024px;
  }

  .xl\\:max-w-screen-xl {
    max-width: 1280px;
  }

  .xl\\:min-h-0 {
    min-height: 0;
  }

  .xl\\:min-h-full {
    min-height: 100%;
  }

  .xl\\:min-h-screen {
    min-height: 100vh;
  }

  .xl\\:min-w-0 {
    min-width: 0;
  }

  .xl\\:min-w-full {
    min-width: 100%;
  }

  .xl\\:object-contain {
    object-fit: contain;
  }

  .xl\\:object-cover {
    object-fit: cover;
  }

  .xl\\:object-fill {
    object-fit: fill;
  }

  .xl\\:object-none {
    object-fit: none;
  }

  .xl\\:object-scale-down {
    object-fit: scale-down;
  }

  .xl\\:object-bottom {
    object-position: bottom;
  }

  .xl\\:object-center {
    object-position: center;
  }

  .xl\\:object-left {
    object-position: left;
  }

  .xl\\:object-left-bottom {
    object-position: left bottom;
  }

  .xl\\:object-left-top {
    object-position: left top;
  }

  .xl\\:object-right {
    object-position: right;
  }

  .xl\\:object-right-bottom {
    object-position: right bottom;
  }

  .xl\\:object-right-top {
    object-position: right top;
  }

  .xl\\:object-top {
    object-position: top;
  }

  .xl\\:opacity-0 {
    opacity: 0;
  }

  .xl\\:opacity-25 {
    opacity: 0.25;
  }

  .xl\\:opacity-50 {
    opacity: 0.5;
  }

  .xl\\:opacity-75 {
    opacity: 0.75;
  }

  .xl\\:opacity-100 {
    opacity: 1;
  }

  .xl\\:hover\\:opacity-0:hover {
    opacity: 0;
  }

  .xl\\:hover\\:opacity-25:hover {
    opacity: 0.25;
  }

  .xl\\:hover\\:opacity-50:hover {
    opacity: 0.5;
  }

  .xl\\:hover\\:opacity-75:hover {
    opacity: 0.75;
  }

  .xl\\:hover\\:opacity-100:hover {
    opacity: 1;
  }

  .xl\\:focus\\:opacity-0:focus {
    opacity: 0;
  }

  .xl\\:focus\\:opacity-25:focus {
    opacity: 0.25;
  }

  .xl\\:focus\\:opacity-50:focus {
    opacity: 0.5;
  }

  .xl\\:focus\\:opacity-75:focus {
    opacity: 0.75;
  }

  .xl\\:focus\\:opacity-100:focus {
    opacity: 1;
  }

  .xl\\:outline-none {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .xl\\:outline-white {
    outline: 2px dotted white;
    outline-offset: 2px;
  }

  .xl\\:outline-black {
    outline: 2px dotted black;
    outline-offset: 2px;
  }

  .xl\\:focus\\:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

  .xl\\:focus\\:outline-white:focus {
    outline: 2px dotted white;
    outline-offset: 2px;
  }

  .xl\\:focus\\:outline-black:focus {
    outline: 2px dotted black;
    outline-offset: 2px;
  }

  .xl\\:overflow-auto {
    overflow: auto;
  }

  .xl\\:overflow-hidden {
    overflow: hidden;
  }

  .xl\\:overflow-visible {
    overflow: visible;
  }

  .xl\\:overflow-scroll {
    overflow: scroll;
  }

  .xl\\:overflow-x-auto {
    overflow-x: auto;
  }

  .xl\\:overflow-y-auto {
    overflow-y: auto;
  }

  .xl\\:overflow-x-hidden {
    overflow-x: hidden;
  }

  .xl\\:overflow-y-hidden {
    overflow-y: hidden;
  }

  .xl\\:overflow-x-visible {
    overflow-x: visible;
  }

  .xl\\:overflow-y-visible {
    overflow-y: visible;
  }

  .xl\\:overflow-x-scroll {
    overflow-x: scroll;
  }

  .xl\\:overflow-y-scroll {
    overflow-y: scroll;
  }

  .xl\\:scrolling-touch {
    -webkit-overflow-scrolling: touch;
  }

  .xl\\:scrolling-auto {
    -webkit-overflow-scrolling: auto;
  }

  .xl\\:overscroll-auto {
    overscroll-behavior: auto;
  }

  .xl\\:overscroll-contain {
    overscroll-behavior: contain;
  }

  .xl\\:overscroll-none {
    overscroll-behavior: none;
  }

  .xl\\:overscroll-y-auto {
    overscroll-behavior-y: auto;
  }

  .xl\\:overscroll-y-contain {
    overscroll-behavior-y: contain;
  }

  .xl\\:overscroll-y-none {
    overscroll-behavior-y: none;
  }

  .xl\\:overscroll-x-auto {
    overscroll-behavior-x: auto;
  }

  .xl\\:overscroll-x-contain {
    overscroll-behavior-x: contain;
  }

  .xl\\:overscroll-x-none {
    overscroll-behavior-x: none;
  }

  .xl\\:p-0 {
    padding: 0;
  }

  .xl\\:p-1 {
    padding: 0.25rem;
  }

  .xl\\:p-2 {
    padding: 0.5rem;
  }

  .xl\\:p-3 {
    padding: 0.75rem;
  }

  .xl\\:p-4 {
    padding: 1rem;
  }

  .xl\\:p-5 {
    padding: 1.25rem;
  }

  .xl\\:p-6 {
    padding: 1.5rem;
  }

  .xl\\:p-8 {
    padding: 2rem;
  }

  .xl\\:p-10 {
    padding: 2.5rem;
  }

  .xl\\:p-12 {
    padding: 3rem;
  }

  .xl\\:p-16 {
    padding: 4rem;
  }

  .xl\\:p-20 {
    padding: 5rem;
  }

  .xl\\:p-24 {
    padding: 6rem;
  }

  .xl\\:p-32 {
    padding: 8rem;
  }

  .xl\\:p-40 {
    padding: 10rem;
  }

  .xl\\:p-48 {
    padding: 12rem;
  }

  .xl\\:p-56 {
    padding: 14rem;
  }

  .xl\\:p-64 {
    padding: 16rem;
  }

  .xl\\:p-px {
    padding: 1px;
  }

  .xl\\:py-0 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .xl\\:px-0 {
    padding-left: 0;
    padding-right: 0;
  }

  .xl\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .xl\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .xl\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .xl\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .xl\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .xl\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .xl\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .xl\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .xl\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .xl\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .xl\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .xl\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .xl\\:py-10 {
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .xl\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .xl\\:py-12 {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .xl\\:px-12 {
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .xl\\:py-16 {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .xl\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .xl\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .xl\\:py-24 {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .xl\\:px-24 {
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .xl\\:py-32 {
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .xl\\:px-32 {
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .xl\\:py-40 {
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .xl\\:px-40 {
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .xl\\:py-48 {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .xl\\:px-48 {
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .xl\\:py-56 {
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .xl\\:px-56 {
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .xl\\:py-64 {
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .xl\\:px-64 {
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .xl\\:py-px {
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .xl\\:px-px {
    padding-left: 1px;
    padding-right: 1px;
  }

  .xl\\:pt-0 {
    padding-top: 0;
  }

  .xl\\:pr-0 {
    padding-right: 0;
  }

  .xl\\:pb-0 {
    padding-bottom: 0;
  }

  .xl\\:pl-0 {
    padding-left: 0;
  }

  .xl\\:pt-1 {
    padding-top: 0.25rem;
  }

  .xl\\:pr-1 {
    padding-right: 0.25rem;
  }

  .xl\\:pb-1 {
    padding-bottom: 0.25rem;
  }

  .xl\\:pl-1 {
    padding-left: 0.25rem;
  }

  .xl\\:pt-2 {
    padding-top: 0.5rem;
  }

  .xl\\:pr-2 {
    padding-right: 0.5rem;
  }

  .xl\\:pb-2 {
    padding-bottom: 0.5rem;
  }

  .xl\\:pl-2 {
    padding-left: 0.5rem;
  }

  .xl\\:pt-3 {
    padding-top: 0.75rem;
  }

  .xl\\:pr-3 {
    padding-right: 0.75rem;
  }

  .xl\\:pb-3 {
    padding-bottom: 0.75rem;
  }

  .xl\\:pl-3 {
    padding-left: 0.75rem;
  }

  .xl\\:pt-4 {
    padding-top: 1rem;
  }

  .xl\\:pr-4 {
    padding-right: 1rem;
  }

  .xl\\:pb-4 {
    padding-bottom: 1rem;
  }

  .xl\\:pl-4 {
    padding-left: 1rem;
  }

  .xl\\:pt-5 {
    padding-top: 1.25rem;
  }

  .xl\\:pr-5 {
    padding-right: 1.25rem;
  }

  .xl\\:pb-5 {
    padding-bottom: 1.25rem;
  }

  .xl\\:pl-5 {
    padding-left: 1.25rem;
  }

  .xl\\:pt-6 {
    padding-top: 1.5rem;
  }

  .xl\\:pr-6 {
    padding-right: 1.5rem;
  }

  .xl\\:pb-6 {
    padding-bottom: 1.5rem;
  }

  .xl\\:pl-6 {
    padding-left: 1.5rem;
  }

  .xl\\:pt-8 {
    padding-top: 2rem;
  }

  .xl\\:pr-8 {
    padding-right: 2rem;
  }

  .xl\\:pb-8 {
    padding-bottom: 2rem;
  }

  .xl\\:pl-8 {
    padding-left: 2rem;
  }

  .xl\\:pt-10 {
    padding-top: 2.5rem;
  }

  .xl\\:pr-10 {
    padding-right: 2.5rem;
  }

  .xl\\:pb-10 {
    padding-bottom: 2.5rem;
  }

  .xl\\:pl-10 {
    padding-left: 2.5rem;
  }

  .xl\\:pt-12 {
    padding-top: 3rem;
  }

  .xl\\:pr-12 {
    padding-right: 3rem;
  }

  .xl\\:pb-12 {
    padding-bottom: 3rem;
  }

  .xl\\:pl-12 {
    padding-left: 3rem;
  }

  .xl\\:pt-16 {
    padding-top: 4rem;
  }

  .xl\\:pr-16 {
    padding-right: 4rem;
  }

  .xl\\:pb-16 {
    padding-bottom: 4rem;
  }

  .xl\\:pl-16 {
    padding-left: 4rem;
  }

  .xl\\:pt-20 {
    padding-top: 5rem;
  }

  .xl\\:pr-20 {
    padding-right: 5rem;
  }

  .xl\\:pb-20 {
    padding-bottom: 5rem;
  }

  .xl\\:pl-20 {
    padding-left: 5rem;
  }

  .xl\\:pt-24 {
    padding-top: 6rem;
  }

  .xl\\:pr-24 {
    padding-right: 6rem;
  }

  .xl\\:pb-24 {
    padding-bottom: 6rem;
  }

  .xl\\:pl-24 {
    padding-left: 6rem;
  }

  .xl\\:pt-32 {
    padding-top: 8rem;
  }

  .xl\\:pr-32 {
    padding-right: 8rem;
  }

  .xl\\:pb-32 {
    padding-bottom: 8rem;
  }

  .xl\\:pl-32 {
    padding-left: 8rem;
  }

  .xl\\:pt-40 {
    padding-top: 10rem;
  }

  .xl\\:pr-40 {
    padding-right: 10rem;
  }

  .xl\\:pb-40 {
    padding-bottom: 10rem;
  }

  .xl\\:pl-40 {
    padding-left: 10rem;
  }

  .xl\\:pt-48 {
    padding-top: 12rem;
  }

  .xl\\:pr-48 {
    padding-right: 12rem;
  }

  .xl\\:pb-48 {
    padding-bottom: 12rem;
  }

  .xl\\:pl-48 {
    padding-left: 12rem;
  }

  .xl\\:pt-56 {
    padding-top: 14rem;
  }

  .xl\\:pr-56 {
    padding-right: 14rem;
  }

  .xl\\:pb-56 {
    padding-bottom: 14rem;
  }

  .xl\\:pl-56 {
    padding-left: 14rem;
  }

  .xl\\:pt-64 {
    padding-top: 16rem;
  }

  .xl\\:pr-64 {
    padding-right: 16rem;
  }

  .xl\\:pb-64 {
    padding-bottom: 16rem;
  }

  .xl\\:pl-64 {
    padding-left: 16rem;
  }

  .xl\\:pt-px {
    padding-top: 1px;
  }

  .xl\\:pr-px {
    padding-right: 1px;
  }

  .xl\\:pb-px {
    padding-bottom: 1px;
  }

  .xl\\:pl-px {
    padding-left: 1px;
  }

  .xl\\:placeholder-transparent::placeholder {
    color: transparent;
  }

  .xl\\:placeholder-current::placeholder {
    color: currentColor;
  }

  .xl\\:placeholder-black::placeholder {
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .xl\\:placeholder-white::placeholder {
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-100::placeholder {
    --placeholder-opacity: 1;
    color: #f7fafc;
    color: rgba(247, 250, 252, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-200::placeholder {
    --placeholder-opacity: 1;
    color: #edf2f7;
    color: rgba(237, 242, 247, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-300::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-400::placeholder {
    --placeholder-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-500::placeholder {
    --placeholder-opacity: 1;
    color: #a0aec0;
    color: rgba(160, 174, 192, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-600::placeholder {
    --placeholder-opacity: 1;
    color: #718096;
    color: rgba(113, 128, 150, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-700::placeholder {
    --placeholder-opacity: 1;
    color: #4a5568;
    color: rgba(74, 85, 104, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-800::placeholder {
    --placeholder-opacity: 1;
    color: #2d3748;
    color: rgba(45, 55, 72, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-900::placeholder {
    --placeholder-opacity: 1;
    color: #1a202c;
    color: rgba(26, 32, 44, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-100::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f5;
    color: rgba(255, 245, 245, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-200::placeholder {
    --placeholder-opacity: 1;
    color: #fed7d7;
    color: rgba(254, 215, 215, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-300::placeholder {
    --placeholder-opacity: 1;
    color: #feb2b2;
    color: rgba(254, 178, 178, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-400::placeholder {
    --placeholder-opacity: 1;
    color: #fc8181;
    color: rgba(252, 129, 129, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-500::placeholder {
    --placeholder-opacity: 1;
    color: #f56565;
    color: rgba(245, 101, 101, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-600::placeholder {
    --placeholder-opacity: 1;
    color: #e53e3e;
    color: rgba(229, 62, 62, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-700::placeholder {
    --placeholder-opacity: 1;
    color: #c53030;
    color: rgba(197, 48, 48, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-800::placeholder {
    --placeholder-opacity: 1;
    color: #9b2c2c;
    color: rgba(155, 44, 44, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-900::placeholder {
    --placeholder-opacity: 1;
    color: #742a2a;
    color: rgba(116, 42, 42, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-100::placeholder {
    --placeholder-opacity: 1;
    color: #fffaf0;
    color: rgba(255, 250, 240, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-200::placeholder {
    --placeholder-opacity: 1;
    color: #feebc8;
    color: rgba(254, 235, 200, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-300::placeholder {
    --placeholder-opacity: 1;
    color: #fbd38d;
    color: rgba(251, 211, 141, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-400::placeholder {
    --placeholder-opacity: 1;
    color: #f6ad55;
    color: rgba(246, 173, 85, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-500::placeholder {
    --placeholder-opacity: 1;
    color: #ed8936;
    color: rgba(237, 137, 54, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-600::placeholder {
    --placeholder-opacity: 1;
    color: #dd6b20;
    color: rgba(221, 107, 32, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-700::placeholder {
    --placeholder-opacity: 1;
    color: #c05621;
    color: rgba(192, 86, 33, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-800::placeholder {
    --placeholder-opacity: 1;
    color: #9c4221;
    color: rgba(156, 66, 33, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-900::placeholder {
    --placeholder-opacity: 1;
    color: #7b341e;
    color: rgba(123, 52, 30, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-100::placeholder {
    --placeholder-opacity: 1;
    color: #fffff0;
    color: rgba(255, 255, 240, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-200::placeholder {
    --placeholder-opacity: 1;
    color: #fefcbf;
    color: rgba(254, 252, 191, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-300::placeholder {
    --placeholder-opacity: 1;
    color: #faf089;
    color: rgba(250, 240, 137, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-400::placeholder {
    --placeholder-opacity: 1;
    color: #f6e05e;
    color: rgba(246, 224, 94, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-500::placeholder {
    --placeholder-opacity: 1;
    color: #ecc94b;
    color: rgba(236, 201, 75, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-600::placeholder {
    --placeholder-opacity: 1;
    color: #d69e2e;
    color: rgba(214, 158, 46, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-700::placeholder {
    --placeholder-opacity: 1;
    color: #b7791f;
    color: rgba(183, 121, 31, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-800::placeholder {
    --placeholder-opacity: 1;
    color: #975a16;
    color: rgba(151, 90, 22, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-900::placeholder {
    --placeholder-opacity: 1;
    color: #744210;
    color: rgba(116, 66, 16, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-100::placeholder {
    --placeholder-opacity: 1;
    color: #f0fff4;
    color: rgba(240, 255, 244, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-200::placeholder {
    --placeholder-opacity: 1;
    color: #c6f6d5;
    color: rgba(198, 246, 213, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-300::placeholder {
    --placeholder-opacity: 1;
    color: #9ae6b4;
    color: rgba(154, 230, 180, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-400::placeholder {
    --placeholder-opacity: 1;
    color: #68d391;
    color: rgba(104, 211, 145, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-500::placeholder {
    --placeholder-opacity: 1;
    color: #48bb78;
    color: rgba(72, 187, 120, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-600::placeholder {
    --placeholder-opacity: 1;
    color: #38a169;
    color: rgba(56, 161, 105, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-700::placeholder {
    --placeholder-opacity: 1;
    color: #2f855a;
    color: rgba(47, 133, 90, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-800::placeholder {
    --placeholder-opacity: 1;
    color: #276749;
    color: rgba(39, 103, 73, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-900::placeholder {
    --placeholder-opacity: 1;
    color: #22543d;
    color: rgba(34, 84, 61, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-100::placeholder {
    --placeholder-opacity: 1;
    color: #e6fffa;
    color: rgba(230, 255, 250, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-200::placeholder {
    --placeholder-opacity: 1;
    color: #b2f5ea;
    color: rgba(178, 245, 234, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-300::placeholder {
    --placeholder-opacity: 1;
    color: #81e6d9;
    color: rgba(129, 230, 217, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-400::placeholder {
    --placeholder-opacity: 1;
    color: #4fd1c5;
    color: rgba(79, 209, 197, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-500::placeholder {
    --placeholder-opacity: 1;
    color: #38b2ac;
    color: rgba(56, 178, 172, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-600::placeholder {
    --placeholder-opacity: 1;
    color: #319795;
    color: rgba(49, 151, 149, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-700::placeholder {
    --placeholder-opacity: 1;
    color: #2c7a7b;
    color: rgba(44, 122, 123, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-800::placeholder {
    --placeholder-opacity: 1;
    color: #285e61;
    color: rgba(40, 94, 97, var(--placeholder-opacity));
  }

  .xl\\:placeholder-teal-900::placeholder {
    --placeholder-opacity: 1;
    color: #234e52;
    color: rgba(35, 78, 82, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-100::placeholder {
    --placeholder-opacity: 1;
    color: #ebf8ff;
    color: rgba(235, 248, 255, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-200::placeholder {
    --placeholder-opacity: 1;
    color: #bee3f8;
    color: rgba(190, 227, 248, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-300::placeholder {
    --placeholder-opacity: 1;
    color: #90cdf4;
    color: rgba(144, 205, 244, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-400::placeholder {
    --placeholder-opacity: 1;
    color: #63b3ed;
    color: rgba(99, 179, 237, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-500::placeholder {
    --placeholder-opacity: 1;
    color: #4299e1;
    color: rgba(66, 153, 225, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-600::placeholder {
    --placeholder-opacity: 1;
    color: #3182ce;
    color: rgba(49, 130, 206, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-700::placeholder {
    --placeholder-opacity: 1;
    color: #2b6cb0;
    color: rgba(43, 108, 176, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-800::placeholder {
    --placeholder-opacity: 1;
    color: #2c5282;
    color: rgba(44, 82, 130, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-900::placeholder {
    --placeholder-opacity: 1;
    color: #2a4365;
    color: rgba(42, 67, 101, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-100::placeholder {
    --placeholder-opacity: 1;
    color: #ebf4ff;
    color: rgba(235, 244, 255, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-200::placeholder {
    --placeholder-opacity: 1;
    color: #c3dafe;
    color: rgba(195, 218, 254, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-300::placeholder {
    --placeholder-opacity: 1;
    color: #a3bffa;
    color: rgba(163, 191, 250, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-400::placeholder {
    --placeholder-opacity: 1;
    color: #7f9cf5;
    color: rgba(127, 156, 245, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-500::placeholder {
    --placeholder-opacity: 1;
    color: #667eea;
    color: rgba(102, 126, 234, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-600::placeholder {
    --placeholder-opacity: 1;
    color: #5a67d8;
    color: rgba(90, 103, 216, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-700::placeholder {
    --placeholder-opacity: 1;
    color: #4c51bf;
    color: rgba(76, 81, 191, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-800::placeholder {
    --placeholder-opacity: 1;
    color: #434190;
    color: rgba(67, 65, 144, var(--placeholder-opacity));
  }

  .xl\\:placeholder-indigo-900::placeholder {
    --placeholder-opacity: 1;
    color: #3c366b;
    color: rgba(60, 54, 107, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-100::placeholder {
    --placeholder-opacity: 1;
    color: #faf5ff;
    color: rgba(250, 245, 255, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-200::placeholder {
    --placeholder-opacity: 1;
    color: #e9d8fd;
    color: rgba(233, 216, 253, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-300::placeholder {
    --placeholder-opacity: 1;
    color: #d6bcfa;
    color: rgba(214, 188, 250, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-400::placeholder {
    --placeholder-opacity: 1;
    color: #b794f4;
    color: rgba(183, 148, 244, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-500::placeholder {
    --placeholder-opacity: 1;
    color: #9f7aea;
    color: rgba(159, 122, 234, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-600::placeholder {
    --placeholder-opacity: 1;
    color: #805ad5;
    color: rgba(128, 90, 213, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-700::placeholder {
    --placeholder-opacity: 1;
    color: #6b46c1;
    color: rgba(107, 70, 193, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-800::placeholder {
    --placeholder-opacity: 1;
    color: #553c9a;
    color: rgba(85, 60, 154, var(--placeholder-opacity));
  }

  .xl\\:placeholder-purple-900::placeholder {
    --placeholder-opacity: 1;
    color: #44337a;
    color: rgba(68, 51, 122, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-100::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f7;
    color: rgba(255, 245, 247, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-200::placeholder {
    --placeholder-opacity: 1;
    color: #fed7e2;
    color: rgba(254, 215, 226, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-300::placeholder {
    --placeholder-opacity: 1;
    color: #fbb6ce;
    color: rgba(251, 182, 206, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-400::placeholder {
    --placeholder-opacity: 1;
    color: #f687b3;
    color: rgba(246, 135, 179, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-500::placeholder {
    --placeholder-opacity: 1;
    color: #ed64a6;
    color: rgba(237, 100, 166, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-600::placeholder {
    --placeholder-opacity: 1;
    color: #d53f8c;
    color: rgba(213, 63, 140, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-700::placeholder {
    --placeholder-opacity: 1;
    color: #b83280;
    color: rgba(184, 50, 128, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-800::placeholder {
    --placeholder-opacity: 1;
    color: #97266d;
    color: rgba(151, 38, 109, var(--placeholder-opacity));
  }

  .xl\\:placeholder-pink-900::placeholder {
    --placeholder-opacity: 1;
    color: #702459;
    color: rgba(112, 36, 89, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-transparent:focus::placeholder {
    color: transparent;
  }

  .xl\\:focus\\:placeholder-current:focus::placeholder {
    color: currentColor;
  }

  .xl\\:focus\\:placeholder-black:focus::placeholder {
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-white:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f7fafc;
    color: rgba(247, 250, 252, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #edf2f7;
    color: rgba(237, 242, 247, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e2e8f0;
    color: rgba(226, 232, 240, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #cbd5e0;
    color: rgba(203, 213, 224, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a0aec0;
    color: rgba(160, 174, 192, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #718096;
    color: rgba(113, 128, 150, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4a5568;
    color: rgba(74, 85, 104, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2d3748;
    color: rgba(45, 55, 72, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #1a202c;
    color: rgba(26, 32, 44, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f5;
    color: rgba(255, 245, 245, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fed7d7;
    color: rgba(254, 215, 215, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feb2b2;
    color: rgba(254, 178, 178, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fc8181;
    color: rgba(252, 129, 129, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f56565;
    color: rgba(245, 101, 101, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e53e3e;
    color: rgba(229, 62, 62, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c53030;
    color: rgba(197, 48, 48, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9b2c2c;
    color: rgba(155, 44, 44, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #742a2a;
    color: rgba(116, 42, 42, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fffaf0;
    color: rgba(255, 250, 240, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #feebc8;
    color: rgba(254, 235, 200, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbd38d;
    color: rgba(251, 211, 141, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6ad55;
    color: rgba(246, 173, 85, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ed8936;
    color: rgba(237, 137, 54, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #dd6b20;
    color: rgba(221, 107, 32, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c05621;
    color: rgba(192, 86, 33, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9c4221;
    color: rgba(156, 66, 33, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7b341e;
    color: rgba(123, 52, 30, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fffff0;
    color: rgba(255, 255, 240, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fefcbf;
    color: rgba(254, 252, 191, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faf089;
    color: rgba(250, 240, 137, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f6e05e;
    color: rgba(246, 224, 94, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ecc94b;
    color: rgba(236, 201, 75, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d69e2e;
    color: rgba(214, 158, 46, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b7791f;
    color: rgba(183, 121, 31, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #975a16;
    color: rgba(151, 90, 22, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #744210;
    color: rgba(116, 66, 16, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f0fff4;
    color: rgba(240, 255, 244, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c6f6d5;
    color: rgba(198, 246, 213, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9ae6b4;
    color: rgba(154, 230, 180, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #68d391;
    color: rgba(104, 211, 145, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #48bb78;
    color: rgba(72, 187, 120, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #38a169;
    color: rgba(56, 161, 105, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2f855a;
    color: rgba(47, 133, 90, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #276749;
    color: rgba(39, 103, 73, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #22543d;
    color: rgba(34, 84, 61, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e6fffa;
    color: rgba(230, 255, 250, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b2f5ea;
    color: rgba(178, 245, 234, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #81e6d9;
    color: rgba(129, 230, 217, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4fd1c5;
    color: rgba(79, 209, 197, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #38b2ac;
    color: rgba(56, 178, 172, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #319795;
    color: rgba(49, 151, 149, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2c7a7b;
    color: rgba(44, 122, 123, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #285e61;
    color: rgba(40, 94, 97, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-teal-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #234e52;
    color: rgba(35, 78, 82, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf8ff;
    color: rgba(235, 248, 255, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #bee3f8;
    color: rgba(190, 227, 248, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #90cdf4;
    color: rgba(144, 205, 244, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #63b3ed;
    color: rgba(99, 179, 237, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4299e1;
    color: rgba(66, 153, 225, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3182ce;
    color: rgba(49, 130, 206, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2b6cb0;
    color: rgba(43, 108, 176, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2c5282;
    color: rgba(44, 82, 130, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #2a4365;
    color: rgba(42, 67, 101, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ebf4ff;
    color: rgba(235, 244, 255, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #c3dafe;
    color: rgba(195, 218, 254, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #a3bffa;
    color: rgba(163, 191, 250, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #7f9cf5;
    color: rgba(127, 156, 245, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #667eea;
    color: rgba(102, 126, 234, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #5a67d8;
    color: rgba(90, 103, 216, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #4c51bf;
    color: rgba(76, 81, 191, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #434190;
    color: rgba(67, 65, 144, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-indigo-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #3c366b;
    color: rgba(60, 54, 107, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #faf5ff;
    color: rgba(250, 245, 255, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #e9d8fd;
    color: rgba(233, 216, 253, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d6bcfa;
    color: rgba(214, 188, 250, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b794f4;
    color: rgba(183, 148, 244, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #9f7aea;
    color: rgba(159, 122, 234, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #805ad5;
    color: rgba(128, 90, 213, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #6b46c1;
    color: rgba(107, 70, 193, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #553c9a;
    color: rgba(85, 60, 154, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-purple-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #44337a;
    color: rgba(68, 51, 122, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-100:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fff5f7;
    color: rgba(255, 245, 247, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-200:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fed7e2;
    color: rgba(254, 215, 226, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-300:focus::placeholder {
    --placeholder-opacity: 1;
    color: #fbb6ce;
    color: rgba(251, 182, 206, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-400:focus::placeholder {
    --placeholder-opacity: 1;
    color: #f687b3;
    color: rgba(246, 135, 179, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-500:focus::placeholder {
    --placeholder-opacity: 1;
    color: #ed64a6;
    color: rgba(237, 100, 166, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-600:focus::placeholder {
    --placeholder-opacity: 1;
    color: #d53f8c;
    color: rgba(213, 63, 140, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-700:focus::placeholder {
    --placeholder-opacity: 1;
    color: #b83280;
    color: rgba(184, 50, 128, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-800:focus::placeholder {
    --placeholder-opacity: 1;
    color: #97266d;
    color: rgba(151, 38, 109, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-pink-900:focus::placeholder {
    --placeholder-opacity: 1;
    color: #702459;
    color: rgba(112, 36, 89, var(--placeholder-opacity));
  }

  .xl\\:placeholder-opacity-0::placeholder {
    --placeholder-opacity: 0;
  }

  .xl\\:placeholder-opacity-25::placeholder {
    --placeholder-opacity: 0.25;
  }

  .xl\\:placeholder-opacity-50::placeholder {
    --placeholder-opacity: 0.5;
  }

  .xl\\:placeholder-opacity-75::placeholder {
    --placeholder-opacity: 0.75;
  }

  .xl\\:placeholder-opacity-100::placeholder {
    --placeholder-opacity: 1;
  }

  .xl\\:focus\\:placeholder-opacity-0:focus::placeholder {
    --placeholder-opacity: 0;
  }

  .xl\\:focus\\:placeholder-opacity-25:focus::placeholder {
    --placeholder-opacity: 0.25;
  }

  .xl\\:focus\\:placeholder-opacity-50:focus::placeholder {
    --placeholder-opacity: 0.5;
  }

  .xl\\:focus\\:placeholder-opacity-75:focus::placeholder {
    --placeholder-opacity: 0.75;
  }

  .xl\\:focus\\:placeholder-opacity-100:focus::placeholder {
    --placeholder-opacity: 1;
  }

  .xl\\:pointer-events-none {
    pointer-events: none;
  }

  .xl\\:pointer-events-auto {
    pointer-events: auto;
  }

  .xl\\:static {
    position: static;
  }

  .xl\\:fixed {
    position: fixed;
  }

  .xl\\:absolute {
    position: absolute;
  }

  .xl\\:relative {
    position: relative;
  }

  .xl\\:sticky {
    position: sticky;
  }

  .xl\\:inset-0 {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .xl\\:inset-auto {
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .xl\\:inset-y-0 {
    top: 0;
    bottom: 0;
  }

  .xl\\:inset-x-0 {
    right: 0;
    left: 0;
  }

  .xl\\:inset-y-auto {
    top: auto;
    bottom: auto;
  }

  .xl\\:inset-x-auto {
    right: auto;
    left: auto;
  }

  .xl\\:top-0 {
    top: 0;
  }

  .xl\\:right-0 {
    right: 0;
  }

  .xl\\:bottom-0 {
    bottom: 0;
  }

  .xl\\:left-0 {
    left: 0;
  }

  .xl\\:top-auto {
    top: auto;
  }

  .xl\\:right-auto {
    right: auto;
  }

  .xl\\:bottom-auto {
    bottom: auto;
  }

  .xl\\:left-auto {
    left: auto;
  }

  .xl\\:resize-none {
    resize: none;
  }

  .xl\\:resize-y {
    resize: vertical;
  }

  .xl\\:resize-x {
    resize: horizontal;
  }

  .xl\\:resize {
    resize: both;
  }

  .xl\\:shadow-xs {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .xl\\:shadow-sm {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .xl\\:shadow {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .xl\\:shadow-md {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:shadow-lg {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .xl\\:shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .xl\\:shadow-2xl {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .xl\\:shadow-inner {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .xl\\:shadow-outline {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .xl\\:shadow-none {
    box-shadow: none;
  }

  .xl\\:hover\\:shadow-xs:hover {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .xl\\:hover\\:shadow-sm:hover {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .xl\\:hover\\:shadow:hover {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .xl\\:hover\\:shadow-md:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:hover\\:shadow-lg:hover {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .xl\\:hover\\:shadow-xl:hover {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .xl\\:hover\\:shadow-2xl:hover {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .xl\\:hover\\:shadow-inner:hover {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .xl\\:hover\\:shadow-outline:hover {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .xl\\:hover\\:shadow-none:hover {
    box-shadow: none;
  }

  .xl\\:focus\\:shadow-xs:focus {
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);
  }

  .xl\\:focus\\:shadow-sm:focus {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }

  .xl\\:focus\\:shadow:focus {
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }

  .xl\\:focus\\:shadow-md:focus {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:focus\\:shadow-lg:focus {
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .xl\\:focus\\:shadow-xl:focus {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .xl\\:focus\\:shadow-2xl:focus {
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .xl\\:focus\\:shadow-inner:focus {
    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  }

  .xl\\:focus\\:shadow-outline:focus {
    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  }

  .xl\\:focus\\:shadow-none:focus {
    box-shadow: none;
  }

  .xl\\:fill-current {
    fill: currentColor;
  }

  .xl\\:stroke-current {
    stroke: currentColor;
  }

  .xl\\:stroke-0 {
    stroke-width: 0;
  }

  .xl\\:stroke-1 {
    stroke-width: 1;
  }

  .xl\\:stroke-2 {
    stroke-width: 2;
  }

  .xl\\:table-auto {
    table-layout: auto;
  }

  .xl\\:table-fixed {
    table-layout: fixed;
  }

  .xl\\:text-left {
    text-align: left;
  }

  .xl\\:text-center {
    text-align: center;
  }

  .xl\\:text-right {
    text-align: right;
  }

  .xl\\:text-justify {
    text-align: justify;
  }

  .xl\\:text-blue {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .xl\\:text-primaryText {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .xl\\:text-red {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue:hover {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .xl\\:hover\\:text-primaryText:hover {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .xl\\:hover\\:text-red:hover {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue:focus {
    --text-opacity: 1;
    color: #2C7FFF;
    color: rgba(44, 127, 255, var(--text-opacity));
  }

  .xl\\:focus\\:text-primaryText:focus {
    --text-opacity: 1;
    color: #0E264B;
    color: rgba(14, 38, 75, var(--text-opacity));
  }

  .xl\\:focus\\:text-red:focus {
    --text-opacity: 1;
    color: #FF2759;
    color: rgba(255, 39, 89, var(--text-opacity));
  }

  .xl\\:text-opacity-0 {
    --text-opacity: 0;
  }

  .xl\\:text-opacity-25 {
    --text-opacity: 0.25;
  }

  .xl\\:text-opacity-50 {
    --text-opacity: 0.5;
  }

  .xl\\:text-opacity-75 {
    --text-opacity: 0.75;
  }

  .xl\\:text-opacity-100 {
    --text-opacity: 1;
  }

  .xl\\:hover\\:text-opacity-0:hover {
    --text-opacity: 0;
  }

  .xl\\:hover\\:text-opacity-25:hover {
    --text-opacity: 0.25;
  }

  .xl\\:hover\\:text-opacity-50:hover {
    --text-opacity: 0.5;
  }

  .xl\\:hover\\:text-opacity-75:hover {
    --text-opacity: 0.75;
  }

  .xl\\:hover\\:text-opacity-100:hover {
    --text-opacity: 1;
  }

  .xl\\:focus\\:text-opacity-0:focus {
    --text-opacity: 0;
  }

  .xl\\:focus\\:text-opacity-25:focus {
    --text-opacity: 0.25;
  }

  .xl\\:focus\\:text-opacity-50:focus {
    --text-opacity: 0.5;
  }

  .xl\\:focus\\:text-opacity-75:focus {
    --text-opacity: 0.75;
  }

  .xl\\:focus\\:text-opacity-100:focus {
    --text-opacity: 1;
  }

  .xl\\:italic {
    font-style: italic;
  }

  .xl\\:not-italic {
    font-style: normal;
  }

  .xl\\:uppercase {
    text-transform: uppercase;
  }

  .xl\\:lowercase {
    text-transform: lowercase;
  }

  .xl\\:capitalize {
    text-transform: capitalize;
  }

  .xl\\:normal-case {
    text-transform: none;
  }

  .xl\\:underline {
    text-decoration: underline;
  }

  .xl\\:line-through {
    text-decoration: line-through;
  }

  .xl\\:no-underline {
    text-decoration: none;
  }

  .xl\\:hover\\:underline:hover {
    text-decoration: underline;
  }

  .xl\\:hover\\:line-through:hover {
    text-decoration: line-through;
  }

  .xl\\:hover\\:no-underline:hover {
    text-decoration: none;
  }

  .xl\\:focus\\:underline:focus {
    text-decoration: underline;
  }

  .xl\\:focus\\:line-through:focus {
    text-decoration: line-through;
  }

  .xl\\:focus\\:no-underline:focus {
    text-decoration: none;
  }

  .xl\\:antialiased {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .xl\\:subpixel-antialiased {
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .xl\\:ordinal, .xl\\:slashed-zero, .xl\\:lining-nums, .xl\\:oldstyle-nums, .xl\\:proportional-nums, .xl\\:tabular-nums, .xl\\:diagonal-fractions, .xl\\:stacked-fractions {
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .xl\\:normal-nums {
    font-variant-numeric: normal;
  }

  .xl\\:ordinal {
    --font-variant-numeric-ordinal: ordinal;
  }

  .xl\\:slashed-zero {
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .xl\\:lining-nums {
    --font-variant-numeric-figure: lining-nums;
  }

  .xl\\:oldstyle-nums {
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .xl\\:proportional-nums {
    --font-variant-numeric-spacing: proportional-nums;
  }

  .xl\\:tabular-nums {
    --font-variant-numeric-spacing: tabular-nums;
  }

  .xl\\:diagonal-fractions {
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .xl\\:stacked-fractions {
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .xl\\:tracking-tighter {
    letter-spacing: -0.05em;
  }

  .xl\\:tracking-tight {
    letter-spacing: -0.025em;
  }

  .xl\\:tracking-normal {
    letter-spacing: 0;
  }

  .xl\\:tracking-wide {
    letter-spacing: 0.025em;
  }

  .xl\\:tracking-wider {
    letter-spacing: 0.05em;
  }

  .xl\\:tracking-widest {
    letter-spacing: 0.1em;
  }

  .xl\\:select-none {
    -webkit-user-select: none;
    user-select: none;
  }

  .xl\\:select-text {
    -webkit-user-select: text;
    user-select: text;
  }

  .xl\\:select-all {
    -webkit-user-select: all;
    user-select: all;
  }

  .xl\\:select-auto {
    -webkit-user-select: auto;
    user-select: auto;
  }

  .xl\\:align-baseline {
    vertical-align: baseline;
  }

  .xl\\:align-top {
    vertical-align: top;
  }

  .xl\\:align-middle {
    vertical-align: middle;
  }

  .xl\\:align-bottom {
    vertical-align: bottom;
  }

  .xl\\:align-text-top {
    vertical-align: text-top;
  }

  .xl\\:align-text-bottom {
    vertical-align: text-bottom;
  }

  .xl\\:visible {
    visibility: visible;
  }

  .xl\\:invisible {
    visibility: hidden;
  }

  .xl\\:whitespace-normal {
    white-space: normal;
  }

  .xl\\:whitespace-no-wrap {
    white-space: nowrap;
  }

  .xl\\:whitespace-pre {
    white-space: pre;
  }

  .xl\\:whitespace-pre-line {
    white-space: pre-line;
  }

  .xl\\:whitespace-pre-wrap {
    white-space: pre-wrap;
  }

  .xl\\:break-normal {
    word-wrap: normal;
    overflow-wrap: normal;
    word-break: normal;
  }

  .xl\\:break-words {
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .xl\\:break-all {
    word-break: break-all;
  }

  .xl\\:truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .xl\\:w-0 {
    width: 0;
  }

  .xl\\:w-1 {
    width: 0.25rem;
  }

  .xl\\:w-2 {
    width: 0.5rem;
  }

  .xl\\:w-3 {
    width: 0.75rem;
  }

  .xl\\:w-4 {
    width: 1rem;
  }

  .xl\\:w-5 {
    width: 1.25rem;
  }

  .xl\\:w-6 {
    width: 1.5rem;
  }

  .xl\\:w-8 {
    width: 2rem;
  }

  .xl\\:w-10 {
    width: 2.5rem;
  }

  .xl\\:w-12 {
    width: 3rem;
  }

  .xl\\:w-16 {
    width: 4rem;
  }

  .xl\\:w-20 {
    width: 5rem;
  }

  .xl\\:w-24 {
    width: 6rem;
  }

  .xl\\:w-32 {
    width: 8rem;
  }

  .xl\\:w-40 {
    width: 10rem;
  }

  .xl\\:w-48 {
    width: 12rem;
  }

  .xl\\:w-56 {
    width: 14rem;
  }

  .xl\\:w-64 {
    width: 16rem;
  }

  .xl\\:w-auto {
    width: auto;
  }

  .xl\\:w-px {
    width: 1px;
  }

  .xl\\:w-1\\/2 {
    width: 50%;
  }

  .xl\\:w-1\\/3 {
    width: 33.333333%;
  }

  .xl\\:w-2\\/3 {
    width: 66.666667%;
  }

  .xl\\:w-1\\/4 {
    width: 25%;
  }

  .xl\\:w-2\\/4 {
    width: 50%;
  }

  .xl\\:w-3\\/4 {
    width: 75%;
  }

  .xl\\:w-1\\/5 {
    width: 20%;
  }

  .xl\\:w-2\\/5 {
    width: 40%;
  }

  .xl\\:w-3\\/5 {
    width: 60%;
  }

  .xl\\:w-4\\/5 {
    width: 80%;
  }

  .xl\\:w-1\\/6 {
    width: 16.666667%;
  }

  .xl\\:w-2\\/6 {
    width: 33.333333%;
  }

  .xl\\:w-3\\/6 {
    width: 50%;
  }

  .xl\\:w-4\\/6 {
    width: 66.666667%;
  }

  .xl\\:w-5\\/6 {
    width: 83.333333%;
  }

  .xl\\:w-1\\/12 {
    width: 8.333333%;
  }

  .xl\\:w-2\\/12 {
    width: 16.666667%;
  }

  .xl\\:w-3\\/12 {
    width: 25%;
  }

  .xl\\:w-4\\/12 {
    width: 33.333333%;
  }

  .xl\\:w-5\\/12 {
    width: 41.666667%;
  }

  .xl\\:w-6\\/12 {
    width: 50%;
  }

  .xl\\:w-7\\/12 {
    width: 58.333333%;
  }

  .xl\\:w-8\\/12 {
    width: 66.666667%;
  }

  .xl\\:w-9\\/12 {
    width: 75%;
  }

  .xl\\:w-10\\/12 {
    width: 83.333333%;
  }

  .xl\\:w-11\\/12 {
    width: 91.666667%;
  }

  .xl\\:w-full {
    width: 100%;
  }

  .xl\\:w-screen {
    width: 100vw;
  }

  .xl\\:z-0 {
    z-index: 0;
  }

  .xl\\:z-10 {
    z-index: 10;
  }

  .xl\\:z-20 {
    z-index: 20;
  }

  .xl\\:z-30 {
    z-index: 30;
  }

  .xl\\:z-40 {
    z-index: 40;
  }

  .xl\\:z-50 {
    z-index: 50;
  }

  .xl\\:z-auto {
    z-index: auto;
  }

  .xl\\:gap-0 {
    grid-gap: 0;
    gap: 0;
  }

  .xl\\:gap-1 {
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .xl\\:gap-2 {
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .xl\\:gap-3 {
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .xl\\:gap-4 {
    grid-gap: 1rem;
    gap: 1rem;
  }

  .xl\\:gap-5 {
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .xl\\:gap-6 {
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .xl\\:gap-8 {
    grid-gap: 2rem;
    gap: 2rem;
  }

  .xl\\:gap-10 {
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .xl\\:gap-12 {
    grid-gap: 3rem;
    gap: 3rem;
  }

  .xl\\:gap-16 {
    grid-gap: 4rem;
    gap: 4rem;
  }

  .xl\\:gap-20 {
    grid-gap: 5rem;
    gap: 5rem;
  }

  .xl\\:gap-24 {
    grid-gap: 6rem;
    gap: 6rem;
  }

  .xl\\:gap-32 {
    grid-gap: 8rem;
    gap: 8rem;
  }

  .xl\\:gap-40 {
    grid-gap: 10rem;
    gap: 10rem;
  }

  .xl\\:gap-48 {
    grid-gap: 12rem;
    gap: 12rem;
  }

  .xl\\:gap-56 {
    grid-gap: 14rem;
    gap: 14rem;
  }

  .xl\\:gap-64 {
    grid-gap: 16rem;
    gap: 16rem;
  }

  .xl\\:gap-px {
    grid-gap: 1px;
    gap: 1px;
  }

  .xl\\:col-gap-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }

  .xl\\:col-gap-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }

  .xl\\:col-gap-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }

  .xl\\:col-gap-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }

  .xl\\:col-gap-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }

  .xl\\:col-gap-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .xl\\:col-gap-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .xl\\:col-gap-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }

  .xl\\:col-gap-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .xl\\:col-gap-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }

  .xl\\:col-gap-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }

  .xl\\:col-gap-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }

  .xl\\:col-gap-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }

  .xl\\:col-gap-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }

  .xl\\:col-gap-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }

  .xl\\:col-gap-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }

  .xl\\:col-gap-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }

  .xl\\:col-gap-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }

  .xl\\:col-gap-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }

  .xl\\:gap-x-0 {
    grid-column-gap: 0;
    column-gap: 0;
  }

  .xl\\:gap-x-1 {
    grid-column-gap: 0.25rem;
    column-gap: 0.25rem;
  }

  .xl\\:gap-x-2 {
    grid-column-gap: 0.5rem;
    column-gap: 0.5rem;
  }

  .xl\\:gap-x-3 {
    grid-column-gap: 0.75rem;
    column-gap: 0.75rem;
  }

  .xl\\:gap-x-4 {
    grid-column-gap: 1rem;
    column-gap: 1rem;
  }

  .xl\\:gap-x-5 {
    grid-column-gap: 1.25rem;
    column-gap: 1.25rem;
  }

  .xl\\:gap-x-6 {
    grid-column-gap: 1.5rem;
    column-gap: 1.5rem;
  }

  .xl\\:gap-x-8 {
    grid-column-gap: 2rem;
    column-gap: 2rem;
  }

  .xl\\:gap-x-10 {
    grid-column-gap: 2.5rem;
    column-gap: 2.5rem;
  }

  .xl\\:gap-x-12 {
    grid-column-gap: 3rem;
    column-gap: 3rem;
  }

  .xl\\:gap-x-16 {
    grid-column-gap: 4rem;
    column-gap: 4rem;
  }

  .xl\\:gap-x-20 {
    grid-column-gap: 5rem;
    column-gap: 5rem;
  }

  .xl\\:gap-x-24 {
    grid-column-gap: 6rem;
    column-gap: 6rem;
  }

  .xl\\:gap-x-32 {
    grid-column-gap: 8rem;
    column-gap: 8rem;
  }

  .xl\\:gap-x-40 {
    grid-column-gap: 10rem;
    column-gap: 10rem;
  }

  .xl\\:gap-x-48 {
    grid-column-gap: 12rem;
    column-gap: 12rem;
  }

  .xl\\:gap-x-56 {
    grid-column-gap: 14rem;
    column-gap: 14rem;
  }

  .xl\\:gap-x-64 {
    grid-column-gap: 16rem;
    column-gap: 16rem;
  }

  .xl\\:gap-x-px {
    grid-column-gap: 1px;
    column-gap: 1px;
  }

  .xl\\:row-gap-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }

  .xl\\:row-gap-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .xl\\:row-gap-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .xl\\:row-gap-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .xl\\:row-gap-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .xl\\:row-gap-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .xl\\:row-gap-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .xl\\:row-gap-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .xl\\:row-gap-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .xl\\:row-gap-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .xl\\:row-gap-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .xl\\:row-gap-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .xl\\:row-gap-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .xl\\:row-gap-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .xl\\:row-gap-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .xl\\:row-gap-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .xl\\:row-gap-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .xl\\:row-gap-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .xl\\:row-gap-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .xl\\:gap-y-0 {
    grid-row-gap: 0;
    row-gap: 0;
  }

  .xl\\:gap-y-1 {
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .xl\\:gap-y-2 {
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .xl\\:gap-y-3 {
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .xl\\:gap-y-4 {
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .xl\\:gap-y-5 {
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .xl\\:gap-y-6 {
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .xl\\:gap-y-8 {
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .xl\\:gap-y-10 {
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .xl\\:gap-y-12 {
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .xl\\:gap-y-16 {
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .xl\\:gap-y-20 {
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .xl\\:gap-y-24 {
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .xl\\:gap-y-32 {
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .xl\\:gap-y-40 {
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .xl\\:gap-y-48 {
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .xl\\:gap-y-56 {
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .xl\\:gap-y-64 {
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .xl\\:gap-y-px {
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .xl\\:grid-flow-row {
    grid-auto-flow: row;
  }

  .xl\\:grid-flow-col {
    grid-auto-flow: column;
  }

  .xl\\:grid-flow-row-dense {
    grid-auto-flow: row dense;
  }

  .xl\\:grid-flow-col-dense {
    grid-auto-flow: column dense;
  }

  .xl\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .xl\\:grid-cols-8 {
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .xl\\:grid-cols-9 {
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .xl\\:grid-cols-10 {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .xl\\:grid-cols-11 {
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .xl\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .xl\\:grid-cols-none {
    grid-template-columns: none;
  }

  .xl\\:auto-cols-auto {
    grid-auto-columns: auto;
  }

  .xl\\:auto-cols-min {
    grid-auto-columns: min-content;
  }

  .xl\\:auto-cols-max {
    grid-auto-columns: max-content;
  }

  .xl\\:auto-cols-fr {
    grid-auto-columns: minmax(0, 1fr);
  }

  .xl\\:col-auto {
    grid-column: auto;
  }

  .xl\\:col-span-1 {
    grid-column: span 1/span 1;
  }

  .xl\\:col-span-2 {
    grid-column: span 2/span 2;
  }

  .xl\\:col-span-3 {
    grid-column: span 3/span 3;
  }

  .xl\\:col-span-4 {
    grid-column: span 4/span 4;
  }

  .xl\\:col-span-5 {
    grid-column: span 5/span 5;
  }

  .xl\\:col-span-6 {
    grid-column: span 6/span 6;
  }

  .xl\\:col-span-7 {
    grid-column: span 7/span 7;
  }

  .xl\\:col-span-8 {
    grid-column: span 8/span 8;
  }

  .xl\\:col-span-9 {
    grid-column: span 9/span 9;
  }

  .xl\\:col-span-10 {
    grid-column: span 10/span 10;
  }

  .xl\\:col-span-11 {
    grid-column: span 11/span 11;
  }

  .xl\\:col-span-12 {
    grid-column: span 12/span 12;
  }

  .xl\\:col-span-full {
    grid-column: 1/-1;
  }

  .xl\\:col-start-1 {
    grid-column-start: 1;
  }

  .xl\\:col-start-2 {
    grid-column-start: 2;
  }

  .xl\\:col-start-3 {
    grid-column-start: 3;
  }

  .xl\\:col-start-4 {
    grid-column-start: 4;
  }

  .xl\\:col-start-5 {
    grid-column-start: 5;
  }

  .xl\\:col-start-6 {
    grid-column-start: 6;
  }

  .xl\\:col-start-7 {
    grid-column-start: 7;
  }

  .xl\\:col-start-8 {
    grid-column-start: 8;
  }

  .xl\\:col-start-9 {
    grid-column-start: 9;
  }

  .xl\\:col-start-10 {
    grid-column-start: 10;
  }

  .xl\\:col-start-11 {
    grid-column-start: 11;
  }

  .xl\\:col-start-12 {
    grid-column-start: 12;
  }

  .xl\\:col-start-13 {
    grid-column-start: 13;
  }

  .xl\\:col-start-auto {
    grid-column-start: auto;
  }

  .xl\\:col-end-1 {
    grid-column-end: 1;
  }

  .xl\\:col-end-2 {
    grid-column-end: 2;
  }

  .xl\\:col-end-3 {
    grid-column-end: 3;
  }

  .xl\\:col-end-4 {
    grid-column-end: 4;
  }

  .xl\\:col-end-5 {
    grid-column-end: 5;
  }

  .xl\\:col-end-6 {
    grid-column-end: 6;
  }

  .xl\\:col-end-7 {
    grid-column-end: 7;
  }

  .xl\\:col-end-8 {
    grid-column-end: 8;
  }

  .xl\\:col-end-9 {
    grid-column-end: 9;
  }

  .xl\\:col-end-10 {
    grid-column-end: 10;
  }

  .xl\\:col-end-11 {
    grid-column-end: 11;
  }

  .xl\\:col-end-12 {
    grid-column-end: 12;
  }

  .xl\\:col-end-13 {
    grid-column-end: 13;
  }

  .xl\\:col-end-auto {
    grid-column-end: auto;
  }

  .xl\\:grid-rows-1 {
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-rows-2 {
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-rows-3 {
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-rows-4 {
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-rows-5 {
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-rows-6 {
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-rows-none {
    grid-template-rows: none;
  }

  .xl\\:auto-rows-auto {
    grid-auto-rows: auto;
  }

  .xl\\:auto-rows-min {
    grid-auto-rows: min-content;
  }

  .xl\\:auto-rows-max {
    grid-auto-rows: max-content;
  }

  .xl\\:auto-rows-fr {
    grid-auto-rows: minmax(0, 1fr);
  }

  .xl\\:row-auto {
    grid-row: auto;
  }

  .xl\\:row-span-1 {
    grid-row: span 1/span 1;
  }

  .xl\\:row-span-2 {
    grid-row: span 2/span 2;
  }

  .xl\\:row-span-3 {
    grid-row: span 3/span 3;
  }

  .xl\\:row-span-4 {
    grid-row: span 4/span 4;
  }

  .xl\\:row-span-5 {
    grid-row: span 5/span 5;
  }

  .xl\\:row-span-6 {
    grid-row: span 6/span 6;
  }

  .xl\\:row-span-full {
    grid-row: 1/-1;
  }

  .xl\\:row-start-1 {
    grid-row-start: 1;
  }

  .xl\\:row-start-2 {
    grid-row-start: 2;
  }

  .xl\\:row-start-3 {
    grid-row-start: 3;
  }

  .xl\\:row-start-4 {
    grid-row-start: 4;
  }

  .xl\\:row-start-5 {
    grid-row-start: 5;
  }

  .xl\\:row-start-6 {
    grid-row-start: 6;
  }

  .xl\\:row-start-7 {
    grid-row-start: 7;
  }

  .xl\\:row-start-auto {
    grid-row-start: auto;
  }

  .xl\\:row-end-1 {
    grid-row-end: 1;
  }

  .xl\\:row-end-2 {
    grid-row-end: 2;
  }

  .xl\\:row-end-3 {
    grid-row-end: 3;
  }

  .xl\\:row-end-4 {
    grid-row-end: 4;
  }

  .xl\\:row-end-5 {
    grid-row-end: 5;
  }

  .xl\\:row-end-6 {
    grid-row-end: 6;
  }

  .xl\\:row-end-7 {
    grid-row-end: 7;
  }

  .xl\\:row-end-auto {
    grid-row-end: auto;
  }

  .xl\\:transform {
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .xl\\:transform-none {
    transform: none;
  }

  .xl\\:origin-center {
    transform-origin: center;
  }

  .xl\\:origin-top {
    transform-origin: top;
  }

  .xl\\:origin-top-right {
    transform-origin: top right;
  }

  .xl\\:origin-right {
    transform-origin: right;
  }

  .xl\\:origin-bottom-right {
    transform-origin: bottom right;
  }

  .xl\\:origin-bottom {
    transform-origin: bottom;
  }

  .xl\\:origin-bottom-left {
    transform-origin: bottom left;
  }

  .xl\\:origin-left {
    transform-origin: left;
  }

  .xl\\:origin-top-left {
    transform-origin: top left;
  }

  .xl\\:scale-0 {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .xl\\:scale-50 {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .xl\\:scale-75 {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .xl\\:scale-90 {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .xl\\:scale-95 {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .xl\\:scale-100 {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .xl\\:scale-105 {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .xl\\:scale-110 {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .xl\\:scale-125 {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .xl\\:scale-150 {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .xl\\:scale-x-0 {
    --transform-scale-x: 0;
  }

  .xl\\:scale-x-50 {
    --transform-scale-x: .5;
  }

  .xl\\:scale-x-75 {
    --transform-scale-x: .75;
  }

  .xl\\:scale-x-90 {
    --transform-scale-x: .9;
  }

  .xl\\:scale-x-95 {
    --transform-scale-x: .95;
  }

  .xl\\:scale-x-100 {
    --transform-scale-x: 1;
  }

  .xl\\:scale-x-105 {
    --transform-scale-x: 1.05;
  }

  .xl\\:scale-x-110 {
    --transform-scale-x: 1.1;
  }

  .xl\\:scale-x-125 {
    --transform-scale-x: 1.25;
  }

  .xl\\:scale-x-150 {
    --transform-scale-x: 1.5;
  }

  .xl\\:scale-y-0 {
    --transform-scale-y: 0;
  }

  .xl\\:scale-y-50 {
    --transform-scale-y: .5;
  }

  .xl\\:scale-y-75 {
    --transform-scale-y: .75;
  }

  .xl\\:scale-y-90 {
    --transform-scale-y: .9;
  }

  .xl\\:scale-y-95 {
    --transform-scale-y: .95;
  }

  .xl\\:scale-y-100 {
    --transform-scale-y: 1;
  }

  .xl\\:scale-y-105 {
    --transform-scale-y: 1.05;
  }

  .xl\\:scale-y-110 {
    --transform-scale-y: 1.1;
  }

  .xl\\:scale-y-125 {
    --transform-scale-y: 1.25;
  }

  .xl\\:scale-y-150 {
    --transform-scale-y: 1.5;
  }

  .xl\\:hover\\:scale-0:hover {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .xl\\:hover\\:scale-50:hover {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .xl\\:hover\\:scale-75:hover {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .xl\\:hover\\:scale-90:hover {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .xl\\:hover\\:scale-95:hover {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .xl\\:hover\\:scale-100:hover {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .xl\\:hover\\:scale-105:hover {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .xl\\:hover\\:scale-110:hover {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .xl\\:hover\\:scale-125:hover {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .xl\\:hover\\:scale-150:hover {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .xl\\:hover\\:scale-x-0:hover {
    --transform-scale-x: 0;
  }

  .xl\\:hover\\:scale-x-50:hover {
    --transform-scale-x: .5;
  }

  .xl\\:hover\\:scale-x-75:hover {
    --transform-scale-x: .75;
  }

  .xl\\:hover\\:scale-x-90:hover {
    --transform-scale-x: .9;
  }

  .xl\\:hover\\:scale-x-95:hover {
    --transform-scale-x: .95;
  }

  .xl\\:hover\\:scale-x-100:hover {
    --transform-scale-x: 1;
  }

  .xl\\:hover\\:scale-x-105:hover {
    --transform-scale-x: 1.05;
  }

  .xl\\:hover\\:scale-x-110:hover {
    --transform-scale-x: 1.1;
  }

  .xl\\:hover\\:scale-x-125:hover {
    --transform-scale-x: 1.25;
  }

  .xl\\:hover\\:scale-x-150:hover {
    --transform-scale-x: 1.5;
  }

  .xl\\:hover\\:scale-y-0:hover {
    --transform-scale-y: 0;
  }

  .xl\\:hover\\:scale-y-50:hover {
    --transform-scale-y: .5;
  }

  .xl\\:hover\\:scale-y-75:hover {
    --transform-scale-y: .75;
  }

  .xl\\:hover\\:scale-y-90:hover {
    --transform-scale-y: .9;
  }

  .xl\\:hover\\:scale-y-95:hover {
    --transform-scale-y: .95;
  }

  .xl\\:hover\\:scale-y-100:hover {
    --transform-scale-y: 1;
  }

  .xl\\:hover\\:scale-y-105:hover {
    --transform-scale-y: 1.05;
  }

  .xl\\:hover\\:scale-y-110:hover {
    --transform-scale-y: 1.1;
  }

  .xl\\:hover\\:scale-y-125:hover {
    --transform-scale-y: 1.25;
  }

  .xl\\:hover\\:scale-y-150:hover {
    --transform-scale-y: 1.5;
  }

  .xl\\:focus\\:scale-0:focus {
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .xl\\:focus\\:scale-50:focus {
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .xl\\:focus\\:scale-75:focus {
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .xl\\:focus\\:scale-90:focus {
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .xl\\:focus\\:scale-95:focus {
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .xl\\:focus\\:scale-100:focus {
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .xl\\:focus\\:scale-105:focus {
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .xl\\:focus\\:scale-110:focus {
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .xl\\:focus\\:scale-125:focus {
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .xl\\:focus\\:scale-150:focus {
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .xl\\:focus\\:scale-x-0:focus {
    --transform-scale-x: 0;
  }

  .xl\\:focus\\:scale-x-50:focus {
    --transform-scale-x: .5;
  }

  .xl\\:focus\\:scale-x-75:focus {
    --transform-scale-x: .75;
  }

  .xl\\:focus\\:scale-x-90:focus {
    --transform-scale-x: .9;
  }

  .xl\\:focus\\:scale-x-95:focus {
    --transform-scale-x: .95;
  }

  .xl\\:focus\\:scale-x-100:focus {
    --transform-scale-x: 1;
  }

  .xl\\:focus\\:scale-x-105:focus {
    --transform-scale-x: 1.05;
  }

  .xl\\:focus\\:scale-x-110:focus {
    --transform-scale-x: 1.1;
  }

  .xl\\:focus\\:scale-x-125:focus {
    --transform-scale-x: 1.25;
  }

  .xl\\:focus\\:scale-x-150:focus {
    --transform-scale-x: 1.5;
  }

  .xl\\:focus\\:scale-y-0:focus {
    --transform-scale-y: 0;
  }

  .xl\\:focus\\:scale-y-50:focus {
    --transform-scale-y: .5;
  }

  .xl\\:focus\\:scale-y-75:focus {
    --transform-scale-y: .75;
  }

  .xl\\:focus\\:scale-y-90:focus {
    --transform-scale-y: .9;
  }

  .xl\\:focus\\:scale-y-95:focus {
    --transform-scale-y: .95;
  }

  .xl\\:focus\\:scale-y-100:focus {
    --transform-scale-y: 1;
  }

  .xl\\:focus\\:scale-y-105:focus {
    --transform-scale-y: 1.05;
  }

  .xl\\:focus\\:scale-y-110:focus {
    --transform-scale-y: 1.1;
  }

  .xl\\:focus\\:scale-y-125:focus {
    --transform-scale-y: 1.25;
  }

  .xl\\:focus\\:scale-y-150:focus {
    --transform-scale-y: 1.5;
  }

  .xl\\:rotate-0 {
    --transform-rotate: 0;
  }

  .xl\\:rotate-1 {
    --transform-rotate: 1deg;
  }

  .xl\\:rotate-2 {
    --transform-rotate: 2deg;
  }

  .xl\\:rotate-3 {
    --transform-rotate: 3deg;
  }

  .xl\\:rotate-6 {
    --transform-rotate: 6deg;
  }

  .xl\\:rotate-12 {
    --transform-rotate: 12deg;
  }

  .xl\\:rotate-45 {
    --transform-rotate: 45deg;
  }

  .xl\\:rotate-90 {
    --transform-rotate: 90deg;
  }

  .xl\\:rotate-180 {
    --transform-rotate: 180deg;
  }

  .xl\\:-rotate-180 {
    --transform-rotate: -180deg;
  }

  .xl\\:-rotate-90 {
    --transform-rotate: -90deg;
  }

  .xl\\:-rotate-45 {
    --transform-rotate: -45deg;
  }

  .xl\\:-rotate-12 {
    --transform-rotate: -12deg;
  }

  .xl\\:-rotate-6 {
    --transform-rotate: -6deg;
  }

  .xl\\:-rotate-3 {
    --transform-rotate: -3deg;
  }

  .xl\\:-rotate-2 {
    --transform-rotate: -2deg;
  }

  .xl\\:-rotate-1 {
    --transform-rotate: -1deg;
  }

  .xl\\:hover\\:rotate-0:hover {
    --transform-rotate: 0;
  }

  .xl\\:hover\\:rotate-1:hover {
    --transform-rotate: 1deg;
  }

  .xl\\:hover\\:rotate-2:hover {
    --transform-rotate: 2deg;
  }

  .xl\\:hover\\:rotate-3:hover {
    --transform-rotate: 3deg;
  }

  .xl\\:hover\\:rotate-6:hover {
    --transform-rotate: 6deg;
  }

  .xl\\:hover\\:rotate-12:hover {
    --transform-rotate: 12deg;
  }

  .xl\\:hover\\:rotate-45:hover {
    --transform-rotate: 45deg;
  }

  .xl\\:hover\\:rotate-90:hover {
    --transform-rotate: 90deg;
  }

  .xl\\:hover\\:rotate-180:hover {
    --transform-rotate: 180deg;
  }

  .xl\\:hover\\:-rotate-180:hover {
    --transform-rotate: -180deg;
  }

  .xl\\:hover\\:-rotate-90:hover {
    --transform-rotate: -90deg;
  }

  .xl\\:hover\\:-rotate-45:hover {
    --transform-rotate: -45deg;
  }

  .xl\\:hover\\:-rotate-12:hover {
    --transform-rotate: -12deg;
  }

  .xl\\:hover\\:-rotate-6:hover {
    --transform-rotate: -6deg;
  }

  .xl\\:hover\\:-rotate-3:hover {
    --transform-rotate: -3deg;
  }

  .xl\\:hover\\:-rotate-2:hover {
    --transform-rotate: -2deg;
  }

  .xl\\:hover\\:-rotate-1:hover {
    --transform-rotate: -1deg;
  }

  .xl\\:focus\\:rotate-0:focus {
    --transform-rotate: 0;
  }

  .xl\\:focus\\:rotate-1:focus {
    --transform-rotate: 1deg;
  }

  .xl\\:focus\\:rotate-2:focus {
    --transform-rotate: 2deg;
  }

  .xl\\:focus\\:rotate-3:focus {
    --transform-rotate: 3deg;
  }

  .xl\\:focus\\:rotate-6:focus {
    --transform-rotate: 6deg;
  }

  .xl\\:focus\\:rotate-12:focus {
    --transform-rotate: 12deg;
  }

  .xl\\:focus\\:rotate-45:focus {
    --transform-rotate: 45deg;
  }

  .xl\\:focus\\:rotate-90:focus {
    --transform-rotate: 90deg;
  }

  .xl\\:focus\\:rotate-180:focus {
    --transform-rotate: 180deg;
  }

  .xl\\:focus\\:-rotate-180:focus {
    --transform-rotate: -180deg;
  }

  .xl\\:focus\\:-rotate-90:focus {
    --transform-rotate: -90deg;
  }

  .xl\\:focus\\:-rotate-45:focus {
    --transform-rotate: -45deg;
  }

  .xl\\:focus\\:-rotate-12:focus {
    --transform-rotate: -12deg;
  }

  .xl\\:focus\\:-rotate-6:focus {
    --transform-rotate: -6deg;
  }

  .xl\\:focus\\:-rotate-3:focus {
    --transform-rotate: -3deg;
  }

  .xl\\:focus\\:-rotate-2:focus {
    --transform-rotate: -2deg;
  }

  .xl\\:focus\\:-rotate-1:focus {
    --transform-rotate: -1deg;
  }

  .xl\\:translate-x-0 {
    --transform-translate-x: 0;
  }

  .xl\\:translate-x-1 {
    --transform-translate-x: 0.25rem;
  }

  .xl\\:translate-x-2 {
    --transform-translate-x: 0.5rem;
  }

  .xl\\:translate-x-3 {
    --transform-translate-x: 0.75rem;
  }

  .xl\\:translate-x-4 {
    --transform-translate-x: 1rem;
  }

  .xl\\:translate-x-5 {
    --transform-translate-x: 1.25rem;
  }

  .xl\\:translate-x-6 {
    --transform-translate-x: 1.5rem;
  }

  .xl\\:translate-x-8 {
    --transform-translate-x: 2rem;
  }

  .xl\\:translate-x-10 {
    --transform-translate-x: 2.5rem;
  }

  .xl\\:translate-x-12 {
    --transform-translate-x: 3rem;
  }

  .xl\\:translate-x-16 {
    --transform-translate-x: 4rem;
  }

  .xl\\:translate-x-20 {
    --transform-translate-x: 5rem;
  }

  .xl\\:translate-x-24 {
    --transform-translate-x: 6rem;
  }

  .xl\\:translate-x-32 {
    --transform-translate-x: 8rem;
  }

  .xl\\:translate-x-40 {
    --transform-translate-x: 10rem;
  }

  .xl\\:translate-x-48 {
    --transform-translate-x: 12rem;
  }

  .xl\\:translate-x-56 {
    --transform-translate-x: 14rem;
  }

  .xl\\:translate-x-64 {
    --transform-translate-x: 16rem;
  }

  .xl\\:translate-x-px {
    --transform-translate-x: 1px;
  }

  .xl\\:-translate-x-1 {
    --transform-translate-x: -0.25rem;
  }

  .xl\\:-translate-x-2 {
    --transform-translate-x: -0.5rem;
  }

  .xl\\:-translate-x-3 {
    --transform-translate-x: -0.75rem;
  }

  .xl\\:-translate-x-4 {
    --transform-translate-x: -1rem;
  }

  .xl\\:-translate-x-5 {
    --transform-translate-x: -1.25rem;
  }

  .xl\\:-translate-x-6 {
    --transform-translate-x: -1.5rem;
  }

  .xl\\:-translate-x-8 {
    --transform-translate-x: -2rem;
  }

  .xl\\:-translate-x-10 {
    --transform-translate-x: -2.5rem;
  }

  .xl\\:-translate-x-12 {
    --transform-translate-x: -3rem;
  }

  .xl\\:-translate-x-16 {
    --transform-translate-x: -4rem;
  }

  .xl\\:-translate-x-20 {
    --transform-translate-x: -5rem;
  }

  .xl\\:-translate-x-24 {
    --transform-translate-x: -6rem;
  }

  .xl\\:-translate-x-32 {
    --transform-translate-x: -8rem;
  }

  .xl\\:-translate-x-40 {
    --transform-translate-x: -10rem;
  }

  .xl\\:-translate-x-48 {
    --transform-translate-x: -12rem;
  }

  .xl\\:-translate-x-56 {
    --transform-translate-x: -14rem;
  }

  .xl\\:-translate-x-64 {
    --transform-translate-x: -16rem;
  }

  .xl\\:-translate-x-px {
    --transform-translate-x: -1px;
  }

  .xl\\:-translate-x-full {
    --transform-translate-x: -100%;
  }

  .xl\\:-translate-x-1\\/2 {
    --transform-translate-x: -50%;
  }

  .xl\\:translate-x-1\\/2 {
    --transform-translate-x: 50%;
  }

  .xl\\:translate-x-full {
    --transform-translate-x: 100%;
  }

  .xl\\:translate-y-0 {
    --transform-translate-y: 0;
  }

  .xl\\:translate-y-1 {
    --transform-translate-y: 0.25rem;
  }

  .xl\\:translate-y-2 {
    --transform-translate-y: 0.5rem;
  }

  .xl\\:translate-y-3 {
    --transform-translate-y: 0.75rem;
  }

  .xl\\:translate-y-4 {
    --transform-translate-y: 1rem;
  }

  .xl\\:translate-y-5 {
    --transform-translate-y: 1.25rem;
  }

  .xl\\:translate-y-6 {
    --transform-translate-y: 1.5rem;
  }

  .xl\\:translate-y-8 {
    --transform-translate-y: 2rem;
  }

  .xl\\:translate-y-10 {
    --transform-translate-y: 2.5rem;
  }

  .xl\\:translate-y-12 {
    --transform-translate-y: 3rem;
  }

  .xl\\:translate-y-16 {
    --transform-translate-y: 4rem;
  }

  .xl\\:translate-y-20 {
    --transform-translate-y: 5rem;
  }

  .xl\\:translate-y-24 {
    --transform-translate-y: 6rem;
  }

  .xl\\:translate-y-32 {
    --transform-translate-y: 8rem;
  }

  .xl\\:translate-y-40 {
    --transform-translate-y: 10rem;
  }

  .xl\\:translate-y-48 {
    --transform-translate-y: 12rem;
  }

  .xl\\:translate-y-56 {
    --transform-translate-y: 14rem;
  }

  .xl\\:translate-y-64 {
    --transform-translate-y: 16rem;
  }

  .xl\\:translate-y-px {
    --transform-translate-y: 1px;
  }

  .xl\\:-translate-y-1 {
    --transform-translate-y: -0.25rem;
  }

  .xl\\:-translate-y-2 {
    --transform-translate-y: -0.5rem;
  }

  .xl\\:-translate-y-3 {
    --transform-translate-y: -0.75rem;
  }

  .xl\\:-translate-y-4 {
    --transform-translate-y: -1rem;
  }

  .xl\\:-translate-y-5 {
    --transform-translate-y: -1.25rem;
  }

  .xl\\:-translate-y-6 {
    --transform-translate-y: -1.5rem;
  }

  .xl\\:-translate-y-8 {
    --transform-translate-y: -2rem;
  }

  .xl\\:-translate-y-10 {
    --transform-translate-y: -2.5rem;
  }

  .xl\\:-translate-y-12 {
    --transform-translate-y: -3rem;
  }

  .xl\\:-translate-y-16 {
    --transform-translate-y: -4rem;
  }

  .xl\\:-translate-y-20 {
    --transform-translate-y: -5rem;
  }

  .xl\\:-translate-y-24 {
    --transform-translate-y: -6rem;
  }

  .xl\\:-translate-y-32 {
    --transform-translate-y: -8rem;
  }

  .xl\\:-translate-y-40 {
    --transform-translate-y: -10rem;
  }

  .xl\\:-translate-y-48 {
    --transform-translate-y: -12rem;
  }

  .xl\\:-translate-y-56 {
    --transform-translate-y: -14rem;
  }

  .xl\\:-translate-y-64 {
    --transform-translate-y: -16rem;
  }

  .xl\\:-translate-y-px {
    --transform-translate-y: -1px;
  }

  .xl\\:-translate-y-full {
    --transform-translate-y: -100%;
  }

  .xl\\:-translate-y-1\\/2 {
    --transform-translate-y: -50%;
  }

  .xl\\:translate-y-1\\/2 {
    --transform-translate-y: 50%;
  }

  .xl\\:translate-y-full {
    --transform-translate-y: 100%;
  }

  .xl\\:hover\\:translate-x-0:hover {
    --transform-translate-x: 0;
  }

  .xl\\:hover\\:translate-x-1:hover {
    --transform-translate-x: 0.25rem;
  }

  .xl\\:hover\\:translate-x-2:hover {
    --transform-translate-x: 0.5rem;
  }

  .xl\\:hover\\:translate-x-3:hover {
    --transform-translate-x: 0.75rem;
  }

  .xl\\:hover\\:translate-x-4:hover {
    --transform-translate-x: 1rem;
  }

  .xl\\:hover\\:translate-x-5:hover {
    --transform-translate-x: 1.25rem;
  }

  .xl\\:hover\\:translate-x-6:hover {
    --transform-translate-x: 1.5rem;
  }

  .xl\\:hover\\:translate-x-8:hover {
    --transform-translate-x: 2rem;
  }

  .xl\\:hover\\:translate-x-10:hover {
    --transform-translate-x: 2.5rem;
  }

  .xl\\:hover\\:translate-x-12:hover {
    --transform-translate-x: 3rem;
  }

  .xl\\:hover\\:translate-x-16:hover {
    --transform-translate-x: 4rem;
  }

  .xl\\:hover\\:translate-x-20:hover {
    --transform-translate-x: 5rem;
  }

  .xl\\:hover\\:translate-x-24:hover {
    --transform-translate-x: 6rem;
  }

  .xl\\:hover\\:translate-x-32:hover {
    --transform-translate-x: 8rem;
  }

  .xl\\:hover\\:translate-x-40:hover {
    --transform-translate-x: 10rem;
  }

  .xl\\:hover\\:translate-x-48:hover {
    --transform-translate-x: 12rem;
  }

  .xl\\:hover\\:translate-x-56:hover {
    --transform-translate-x: 14rem;
  }

  .xl\\:hover\\:translate-x-64:hover {
    --transform-translate-x: 16rem;
  }

  .xl\\:hover\\:translate-x-px:hover {
    --transform-translate-x: 1px;
  }

  .xl\\:hover\\:-translate-x-1:hover {
    --transform-translate-x: -0.25rem;
  }

  .xl\\:hover\\:-translate-x-2:hover {
    --transform-translate-x: -0.5rem;
  }

  .xl\\:hover\\:-translate-x-3:hover {
    --transform-translate-x: -0.75rem;
  }

  .xl\\:hover\\:-translate-x-4:hover {
    --transform-translate-x: -1rem;
  }

  .xl\\:hover\\:-translate-x-5:hover {
    --transform-translate-x: -1.25rem;
  }

  .xl\\:hover\\:-translate-x-6:hover {
    --transform-translate-x: -1.5rem;
  }

  .xl\\:hover\\:-translate-x-8:hover {
    --transform-translate-x: -2rem;
  }

  .xl\\:hover\\:-translate-x-10:hover {
    --transform-translate-x: -2.5rem;
  }

  .xl\\:hover\\:-translate-x-12:hover {
    --transform-translate-x: -3rem;
  }

  .xl\\:hover\\:-translate-x-16:hover {
    --transform-translate-x: -4rem;
  }

  .xl\\:hover\\:-translate-x-20:hover {
    --transform-translate-x: -5rem;
  }

  .xl\\:hover\\:-translate-x-24:hover {
    --transform-translate-x: -6rem;
  }

  .xl\\:hover\\:-translate-x-32:hover {
    --transform-translate-x: -8rem;
  }

  .xl\\:hover\\:-translate-x-40:hover {
    --transform-translate-x: -10rem;
  }

  .xl\\:hover\\:-translate-x-48:hover {
    --transform-translate-x: -12rem;
  }

  .xl\\:hover\\:-translate-x-56:hover {
    --transform-translate-x: -14rem;
  }

  .xl\\:hover\\:-translate-x-64:hover {
    --transform-translate-x: -16rem;
  }

  .xl\\:hover\\:-translate-x-px:hover {
    --transform-translate-x: -1px;
  }

  .xl\\:hover\\:-translate-x-full:hover {
    --transform-translate-x: -100%;
  }

  .xl\\:hover\\:-translate-x-1\\/2:hover {
    --transform-translate-x: -50%;
  }

  .xl\\:hover\\:translate-x-1\\/2:hover {
    --transform-translate-x: 50%;
  }

  .xl\\:hover\\:translate-x-full:hover {
    --transform-translate-x: 100%;
  }

  .xl\\:hover\\:translate-y-0:hover {
    --transform-translate-y: 0;
  }

  .xl\\:hover\\:translate-y-1:hover {
    --transform-translate-y: 0.25rem;
  }

  .xl\\:hover\\:translate-y-2:hover {
    --transform-translate-y: 0.5rem;
  }

  .xl\\:hover\\:translate-y-3:hover {
    --transform-translate-y: 0.75rem;
  }

  .xl\\:hover\\:translate-y-4:hover {
    --transform-translate-y: 1rem;
  }

  .xl\\:hover\\:translate-y-5:hover {
    --transform-translate-y: 1.25rem;
  }

  .xl\\:hover\\:translate-y-6:hover {
    --transform-translate-y: 1.5rem;
  }

  .xl\\:hover\\:translate-y-8:hover {
    --transform-translate-y: 2rem;
  }

  .xl\\:hover\\:translate-y-10:hover {
    --transform-translate-y: 2.5rem;
  }

  .xl\\:hover\\:translate-y-12:hover {
    --transform-translate-y: 3rem;
  }

  .xl\\:hover\\:translate-y-16:hover {
    --transform-translate-y: 4rem;
  }

  .xl\\:hover\\:translate-y-20:hover {
    --transform-translate-y: 5rem;
  }

  .xl\\:hover\\:translate-y-24:hover {
    --transform-translate-y: 6rem;
  }

  .xl\\:hover\\:translate-y-32:hover {
    --transform-translate-y: 8rem;
  }

  .xl\\:hover\\:translate-y-40:hover {
    --transform-translate-y: 10rem;
  }

  .xl\\:hover\\:translate-y-48:hover {
    --transform-translate-y: 12rem;
  }

  .xl\\:hover\\:translate-y-56:hover {
    --transform-translate-y: 14rem;
  }

  .xl\\:hover\\:translate-y-64:hover {
    --transform-translate-y: 16rem;
  }

  .xl\\:hover\\:translate-y-px:hover {
    --transform-translate-y: 1px;
  }

  .xl\\:hover\\:-translate-y-1:hover {
    --transform-translate-y: -0.25rem;
  }

  .xl\\:hover\\:-translate-y-2:hover {
    --transform-translate-y: -0.5rem;
  }

  .xl\\:hover\\:-translate-y-3:hover {
    --transform-translate-y: -0.75rem;
  }

  .xl\\:hover\\:-translate-y-4:hover {
    --transform-translate-y: -1rem;
  }

  .xl\\:hover\\:-translate-y-5:hover {
    --transform-translate-y: -1.25rem;
  }

  .xl\\:hover\\:-translate-y-6:hover {
    --transform-translate-y: -1.5rem;
  }

  .xl\\:hover\\:-translate-y-8:hover {
    --transform-translate-y: -2rem;
  }

  .xl\\:hover\\:-translate-y-10:hover {
    --transform-translate-y: -2.5rem;
  }

  .xl\\:hover\\:-translate-y-12:hover {
    --transform-translate-y: -3rem;
  }

  .xl\\:hover\\:-translate-y-16:hover {
    --transform-translate-y: -4rem;
  }

  .xl\\:hover\\:-translate-y-20:hover {
    --transform-translate-y: -5rem;
  }

  .xl\\:hover\\:-translate-y-24:hover {
    --transform-translate-y: -6rem;
  }

  .xl\\:hover\\:-translate-y-32:hover {
    --transform-translate-y: -8rem;
  }

  .xl\\:hover\\:-translate-y-40:hover {
    --transform-translate-y: -10rem;
  }

  .xl\\:hover\\:-translate-y-48:hover {
    --transform-translate-y: -12rem;
  }

  .xl\\:hover\\:-translate-y-56:hover {
    --transform-translate-y: -14rem;
  }

  .xl\\:hover\\:-translate-y-64:hover {
    --transform-translate-y: -16rem;
  }

  .xl\\:hover\\:-translate-y-px:hover {
    --transform-translate-y: -1px;
  }

  .xl\\:hover\\:-translate-y-full:hover {
    --transform-translate-y: -100%;
  }

  .xl\\:hover\\:-translate-y-1\\/2:hover {
    --transform-translate-y: -50%;
  }

  .xl\\:hover\\:translate-y-1\\/2:hover {
    --transform-translate-y: 50%;
  }

  .xl\\:hover\\:translate-y-full:hover {
    --transform-translate-y: 100%;
  }

  .xl\\:focus\\:translate-x-0:focus {
    --transform-translate-x: 0;
  }

  .xl\\:focus\\:translate-x-1:focus {
    --transform-translate-x: 0.25rem;
  }

  .xl\\:focus\\:translate-x-2:focus {
    --transform-translate-x: 0.5rem;
  }

  .xl\\:focus\\:translate-x-3:focus {
    --transform-translate-x: 0.75rem;
  }

  .xl\\:focus\\:translate-x-4:focus {
    --transform-translate-x: 1rem;
  }

  .xl\\:focus\\:translate-x-5:focus {
    --transform-translate-x: 1.25rem;
  }

  .xl\\:focus\\:translate-x-6:focus {
    --transform-translate-x: 1.5rem;
  }

  .xl\\:focus\\:translate-x-8:focus {
    --transform-translate-x: 2rem;
  }

  .xl\\:focus\\:translate-x-10:focus {
    --transform-translate-x: 2.5rem;
  }

  .xl\\:focus\\:translate-x-12:focus {
    --transform-translate-x: 3rem;
  }

  .xl\\:focus\\:translate-x-16:focus {
    --transform-translate-x: 4rem;
  }

  .xl\\:focus\\:translate-x-20:focus {
    --transform-translate-x: 5rem;
  }

  .xl\\:focus\\:translate-x-24:focus {
    --transform-translate-x: 6rem;
  }

  .xl\\:focus\\:translate-x-32:focus {
    --transform-translate-x: 8rem;
  }

  .xl\\:focus\\:translate-x-40:focus {
    --transform-translate-x: 10rem;
  }

  .xl\\:focus\\:translate-x-48:focus {
    --transform-translate-x: 12rem;
  }

  .xl\\:focus\\:translate-x-56:focus {
    --transform-translate-x: 14rem;
  }

  .xl\\:focus\\:translate-x-64:focus {
    --transform-translate-x: 16rem;
  }

  .xl\\:focus\\:translate-x-px:focus {
    --transform-translate-x: 1px;
  }

  .xl\\:focus\\:-translate-x-1:focus {
    --transform-translate-x: -0.25rem;
  }

  .xl\\:focus\\:-translate-x-2:focus {
    --transform-translate-x: -0.5rem;
  }

  .xl\\:focus\\:-translate-x-3:focus {
    --transform-translate-x: -0.75rem;
  }

  .xl\\:focus\\:-translate-x-4:focus {
    --transform-translate-x: -1rem;
  }

  .xl\\:focus\\:-translate-x-5:focus {
    --transform-translate-x: -1.25rem;
  }

  .xl\\:focus\\:-translate-x-6:focus {
    --transform-translate-x: -1.5rem;
  }

  .xl\\:focus\\:-translate-x-8:focus {
    --transform-translate-x: -2rem;
  }

  .xl\\:focus\\:-translate-x-10:focus {
    --transform-translate-x: -2.5rem;
  }

  .xl\\:focus\\:-translate-x-12:focus {
    --transform-translate-x: -3rem;
  }

  .xl\\:focus\\:-translate-x-16:focus {
    --transform-translate-x: -4rem;
  }

  .xl\\:focus\\:-translate-x-20:focus {
    --transform-translate-x: -5rem;
  }

  .xl\\:focus\\:-translate-x-24:focus {
    --transform-translate-x: -6rem;
  }

  .xl\\:focus\\:-translate-x-32:focus {
    --transform-translate-x: -8rem;
  }

  .xl\\:focus\\:-translate-x-40:focus {
    --transform-translate-x: -10rem;
  }

  .xl\\:focus\\:-translate-x-48:focus {
    --transform-translate-x: -12rem;
  }

  .xl\\:focus\\:-translate-x-56:focus {
    --transform-translate-x: -14rem;
  }

  .xl\\:focus\\:-translate-x-64:focus {
    --transform-translate-x: -16rem;
  }

  .xl\\:focus\\:-translate-x-px:focus {
    --transform-translate-x: -1px;
  }

  .xl\\:focus\\:-translate-x-full:focus {
    --transform-translate-x: -100%;
  }

  .xl\\:focus\\:-translate-x-1\\/2:focus {
    --transform-translate-x: -50%;
  }

  .xl\\:focus\\:translate-x-1\\/2:focus {
    --transform-translate-x: 50%;
  }

  .xl\\:focus\\:translate-x-full:focus {
    --transform-translate-x: 100%;
  }

  .xl\\:focus\\:translate-y-0:focus {
    --transform-translate-y: 0;
  }

  .xl\\:focus\\:translate-y-1:focus {
    --transform-translate-y: 0.25rem;
  }

  .xl\\:focus\\:translate-y-2:focus {
    --transform-translate-y: 0.5rem;
  }

  .xl\\:focus\\:translate-y-3:focus {
    --transform-translate-y: 0.75rem;
  }

  .xl\\:focus\\:translate-y-4:focus {
    --transform-translate-y: 1rem;
  }

  .xl\\:focus\\:translate-y-5:focus {
    --transform-translate-y: 1.25rem;
  }

  .xl\\:focus\\:translate-y-6:focus {
    --transform-translate-y: 1.5rem;
  }

  .xl\\:focus\\:translate-y-8:focus {
    --transform-translate-y: 2rem;
  }

  .xl\\:focus\\:translate-y-10:focus {
    --transform-translate-y: 2.5rem;
  }

  .xl\\:focus\\:translate-y-12:focus {
    --transform-translate-y: 3rem;
  }

  .xl\\:focus\\:translate-y-16:focus {
    --transform-translate-y: 4rem;
  }

  .xl\\:focus\\:translate-y-20:focus {
    --transform-translate-y: 5rem;
  }

  .xl\\:focus\\:translate-y-24:focus {
    --transform-translate-y: 6rem;
  }

  .xl\\:focus\\:translate-y-32:focus {
    --transform-translate-y: 8rem;
  }

  .xl\\:focus\\:translate-y-40:focus {
    --transform-translate-y: 10rem;
  }

  .xl\\:focus\\:translate-y-48:focus {
    --transform-translate-y: 12rem;
  }

  .xl\\:focus\\:translate-y-56:focus {
    --transform-translate-y: 14rem;
  }

  .xl\\:focus\\:translate-y-64:focus {
    --transform-translate-y: 16rem;
  }

  .xl\\:focus\\:translate-y-px:focus {
    --transform-translate-y: 1px;
  }

  .xl\\:focus\\:-translate-y-1:focus {
    --transform-translate-y: -0.25rem;
  }

  .xl\\:focus\\:-translate-y-2:focus {
    --transform-translate-y: -0.5rem;
  }

  .xl\\:focus\\:-translate-y-3:focus {
    --transform-translate-y: -0.75rem;
  }

  .xl\\:focus\\:-translate-y-4:focus {
    --transform-translate-y: -1rem;
  }

  .xl\\:focus\\:-translate-y-5:focus {
    --transform-translate-y: -1.25rem;
  }

  .xl\\:focus\\:-translate-y-6:focus {
    --transform-translate-y: -1.5rem;
  }

  .xl\\:focus\\:-translate-y-8:focus {
    --transform-translate-y: -2rem;
  }

  .xl\\:focus\\:-translate-y-10:focus {
    --transform-translate-y: -2.5rem;
  }

  .xl\\:focus\\:-translate-y-12:focus {
    --transform-translate-y: -3rem;
  }

  .xl\\:focus\\:-translate-y-16:focus {
    --transform-translate-y: -4rem;
  }

  .xl\\:focus\\:-translate-y-20:focus {
    --transform-translate-y: -5rem;
  }

  .xl\\:focus\\:-translate-y-24:focus {
    --transform-translate-y: -6rem;
  }

  .xl\\:focus\\:-translate-y-32:focus {
    --transform-translate-y: -8rem;
  }

  .xl\\:focus\\:-translate-y-40:focus {
    --transform-translate-y: -10rem;
  }

  .xl\\:focus\\:-translate-y-48:focus {
    --transform-translate-y: -12rem;
  }

  .xl\\:focus\\:-translate-y-56:focus {
    --transform-translate-y: -14rem;
  }

  .xl\\:focus\\:-translate-y-64:focus {
    --transform-translate-y: -16rem;
  }

  .xl\\:focus\\:-translate-y-px:focus {
    --transform-translate-y: -1px;
  }

  .xl\\:focus\\:-translate-y-full:focus {
    --transform-translate-y: -100%;
  }

  .xl\\:focus\\:-translate-y-1\\/2:focus {
    --transform-translate-y: -50%;
  }

  .xl\\:focus\\:translate-y-1\\/2:focus {
    --transform-translate-y: 50%;
  }

  .xl\\:focus\\:translate-y-full:focus {
    --transform-translate-y: 100%;
  }

  .xl\\:skew-x-0 {
    --transform-skew-x: 0;
  }

  .xl\\:skew-x-1 {
    --transform-skew-x: 1deg;
  }

  .xl\\:skew-x-2 {
    --transform-skew-x: 2deg;
  }

  .xl\\:skew-x-3 {
    --transform-skew-x: 3deg;
  }

  .xl\\:skew-x-6 {
    --transform-skew-x: 6deg;
  }

  .xl\\:skew-x-12 {
    --transform-skew-x: 12deg;
  }

  .xl\\:-skew-x-12 {
    --transform-skew-x: -12deg;
  }

  .xl\\:-skew-x-6 {
    --transform-skew-x: -6deg;
  }

  .xl\\:-skew-x-3 {
    --transform-skew-x: -3deg;
  }

  .xl\\:-skew-x-2 {
    --transform-skew-x: -2deg;
  }

  .xl\\:-skew-x-1 {
    --transform-skew-x: -1deg;
  }

  .xl\\:skew-y-0 {
    --transform-skew-y: 0;
  }

  .xl\\:skew-y-1 {
    --transform-skew-y: 1deg;
  }

  .xl\\:skew-y-2 {
    --transform-skew-y: 2deg;
  }

  .xl\\:skew-y-3 {
    --transform-skew-y: 3deg;
  }

  .xl\\:skew-y-6 {
    --transform-skew-y: 6deg;
  }

  .xl\\:skew-y-12 {
    --transform-skew-y: 12deg;
  }

  .xl\\:-skew-y-12 {
    --transform-skew-y: -12deg;
  }

  .xl\\:-skew-y-6 {
    --transform-skew-y: -6deg;
  }

  .xl\\:-skew-y-3 {
    --transform-skew-y: -3deg;
  }

  .xl\\:-skew-y-2 {
    --transform-skew-y: -2deg;
  }

  .xl\\:-skew-y-1 {
    --transform-skew-y: -1deg;
  }

  .xl\\:hover\\:skew-x-0:hover {
    --transform-skew-x: 0;
  }

  .xl\\:hover\\:skew-x-1:hover {
    --transform-skew-x: 1deg;
  }

  .xl\\:hover\\:skew-x-2:hover {
    --transform-skew-x: 2deg;
  }

  .xl\\:hover\\:skew-x-3:hover {
    --transform-skew-x: 3deg;
  }

  .xl\\:hover\\:skew-x-6:hover {
    --transform-skew-x: 6deg;
  }

  .xl\\:hover\\:skew-x-12:hover {
    --transform-skew-x: 12deg;
  }

  .xl\\:hover\\:-skew-x-12:hover {
    --transform-skew-x: -12deg;
  }

  .xl\\:hover\\:-skew-x-6:hover {
    --transform-skew-x: -6deg;
  }

  .xl\\:hover\\:-skew-x-3:hover {
    --transform-skew-x: -3deg;
  }

  .xl\\:hover\\:-skew-x-2:hover {
    --transform-skew-x: -2deg;
  }

  .xl\\:hover\\:-skew-x-1:hover {
    --transform-skew-x: -1deg;
  }

  .xl\\:hover\\:skew-y-0:hover {
    --transform-skew-y: 0;
  }

  .xl\\:hover\\:skew-y-1:hover {
    --transform-skew-y: 1deg;
  }

  .xl\\:hover\\:skew-y-2:hover {
    --transform-skew-y: 2deg;
  }

  .xl\\:hover\\:skew-y-3:hover {
    --transform-skew-y: 3deg;
  }

  .xl\\:hover\\:skew-y-6:hover {
    --transform-skew-y: 6deg;
  }

  .xl\\:hover\\:skew-y-12:hover {
    --transform-skew-y: 12deg;
  }

  .xl\\:hover\\:-skew-y-12:hover {
    --transform-skew-y: -12deg;
  }

  .xl\\:hover\\:-skew-y-6:hover {
    --transform-skew-y: -6deg;
  }

  .xl\\:hover\\:-skew-y-3:hover {
    --transform-skew-y: -3deg;
  }

  .xl\\:hover\\:-skew-y-2:hover {
    --transform-skew-y: -2deg;
  }

  .xl\\:hover\\:-skew-y-1:hover {
    --transform-skew-y: -1deg;
  }

  .xl\\:focus\\:skew-x-0:focus {
    --transform-skew-x: 0;
  }

  .xl\\:focus\\:skew-x-1:focus {
    --transform-skew-x: 1deg;
  }

  .xl\\:focus\\:skew-x-2:focus {
    --transform-skew-x: 2deg;
  }

  .xl\\:focus\\:skew-x-3:focus {
    --transform-skew-x: 3deg;
  }

  .xl\\:focus\\:skew-x-6:focus {
    --transform-skew-x: 6deg;
  }

  .xl\\:focus\\:skew-x-12:focus {
    --transform-skew-x: 12deg;
  }

  .xl\\:focus\\:-skew-x-12:focus {
    --transform-skew-x: -12deg;
  }

  .xl\\:focus\\:-skew-x-6:focus {
    --transform-skew-x: -6deg;
  }

  .xl\\:focus\\:-skew-x-3:focus {
    --transform-skew-x: -3deg;
  }

  .xl\\:focus\\:-skew-x-2:focus {
    --transform-skew-x: -2deg;
  }

  .xl\\:focus\\:-skew-x-1:focus {
    --transform-skew-x: -1deg;
  }

  .xl\\:focus\\:skew-y-0:focus {
    --transform-skew-y: 0;
  }

  .xl\\:focus\\:skew-y-1:focus {
    --transform-skew-y: 1deg;
  }

  .xl\\:focus\\:skew-y-2:focus {
    --transform-skew-y: 2deg;
  }

  .xl\\:focus\\:skew-y-3:focus {
    --transform-skew-y: 3deg;
  }

  .xl\\:focus\\:skew-y-6:focus {
    --transform-skew-y: 6deg;
  }

  .xl\\:focus\\:skew-y-12:focus {
    --transform-skew-y: 12deg;
  }

  .xl\\:focus\\:-skew-y-12:focus {
    --transform-skew-y: -12deg;
  }

  .xl\\:focus\\:-skew-y-6:focus {
    --transform-skew-y: -6deg;
  }

  .xl\\:focus\\:-skew-y-3:focus {
    --transform-skew-y: -3deg;
  }

  .xl\\:focus\\:-skew-y-2:focus {
    --transform-skew-y: -2deg;
  }

  .xl\\:focus\\:-skew-y-1:focus {
    --transform-skew-y: -1deg;
  }

  .xl\\:transition-none {
    transition-property: none;
  }

  .xl\\:transition-all {
    transition-property: all;
  }

  .xl\\:transition {
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .xl\\:transition-colors {
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .xl\\:transition-opacity {
    transition-property: opacity;
  }

  .xl\\:transition-shadow {
    transition-property: box-shadow;
  }

  .xl\\:transition-transform {
    transition-property: transform;
  }

  .xl\\:ease-linear {
    transition-timing-function: linear;
  }

  .xl\\:ease-in {
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .xl\\:ease-out {
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .xl\\:ease-in-out {
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .xl\\:duration-75 {
    transition-duration: 75ms;
  }

  .xl\\:duration-100 {
    transition-duration: 100ms;
  }

  .xl\\:duration-150 {
    transition-duration: 150ms;
  }

  .xl\\:duration-200 {
    transition-duration: 200ms;
  }

  .xl\\:duration-300 {
    transition-duration: 300ms;
  }

  .xl\\:duration-500 {
    transition-duration: 500ms;
  }

  .xl\\:duration-700 {
    transition-duration: 700ms;
  }

  .xl\\:duration-1000 {
    transition-duration: 1000ms;
  }

  .xl\\:delay-75 {
    transition-delay: 75ms;
  }

  .xl\\:delay-100 {
    transition-delay: 100ms;
  }

  .xl\\:delay-150 {
    transition-delay: 150ms;
  }

  .xl\\:delay-200 {
    transition-delay: 200ms;
  }

  .xl\\:delay-300 {
    transition-delay: 300ms;
  }

  .xl\\:delay-500 {
    transition-delay: 500ms;
  }

  .xl\\:delay-700 {
    transition-delay: 700ms;
  }

  .xl\\:delay-1000 {
    transition-delay: 1000ms;
  }

  .xl\\:animate-none {
    animation: none;
  }

  .xl\\:animate-spin {
    animation: spin 1s linear infinite;
  }

  .xl\\:animate-ping {
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .xl\\:animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .xl\\:animate-bounce {
    animation: bounce 1s infinite;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/tailwind-output.css"],"names":[],"mappings":"AAAA,2EAAA;;AAEA;+EAAA;;AAGA;;;EAAA;;AAKA;EACE,iBAAA,EAAA,MAAA;EACA,8BAAA,EAAA,MAAA;AAFF;;AAKA;+EAAA;;AAGA;;EAAA;;AAIA;EACE,SAAA;AAJF;;AAOA;;EAAA;;AAIA;EACE,cAAA;AALF;;AAQA;;;EAAA;;AAKA;EACE,cAAA;EACA,gBAAA;AANF;;AASA;+EAAA;;AAGA;;;EAAA;;AAKA;EACE,uBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;AARF;;AAWA;;;EAAA;;AAKA;EACE,iCAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;AATF;;AAYA;+EAAA;;AAGA;;EAAA;;AAIA;EACE,6BAAA;AAXF;;AAcA;;;EAAA;;AAKA;EACE,mBAAA,EAAA,MAAA;EACA,0BAAA,EAAA,MAAA;EACA,yCAAA;EACQ,iCAAA,EAAA,MAAA;AAZV;;AAeA;;EAAA;;AAIA;;EAEE,mBAAA;AAbF;;AAgBA;;;EAAA;;AAKA;;;EAGE,iCAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;AAdF;;AAiBA;;EAAA;;AAIA;EACE,cAAA;AAfF;;AAkBA;;;EAAA;;AAKA;;EAEE,cAAA;EACA,cAAA;EACA,kBAAA;EACA,wBAAA;AAhBF;;AAmBA;EACE,eAAA;AAhBF;;AAmBA;EACE,WAAA;AAhBF;;AAmBA;+EAAA;;AAGA;;EAAA;;AAIA;EACE,kBAAA;AAlBF;;AAqBA;+EAAA;;AAGA;;;EAAA;;AAKA;;;;;EAKE,oBAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,iBAAA,EAAA,MAAA;EACA,SAAA,EAAA,MAAA;AApBF;;AAuBA;;;EAAA;;AAKA;QACQ,MAAA;EACN,iBAAA;AArBF;;AAwBA;;;EAAA;;AAKA;SACS,MAAA;EACP,oBAAA;AAtBF;;AAyBA;;EAAA;;AAIA;;;;EAIE,0BAAA;AAvBF;;AA0BA;;EAAA;;AAIA;;;;EAIE,kBAAA;EACA,UAAA;AAxBF;;AA2BA;;EAAA;;AAIA;;;;EAIE,8BAAA;AAzBF;;AA4BA;;EAAA;;AAIA;EACE,8BAAA;AA1BF;;AA6BA;;;;;EAAA;;AAOA;EACE,sBAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,cAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;AA3BF;;AA8BA;;EAAA;;AAIA;EACE,wBAAA;AA5BF;;AA+BA;;EAAA;;AAIA;EACE,cAAA;AA7BF;;AAgCA;;;EAAA;;AAKA;;EAEE,sBAAA,EAAA,MAAA;EACA,UAAA,EAAA,MAAA;AA9BF;;AAiCA;;EAAA;;AAIA;;EAEE,YAAA;AA/BF;;AAkCA;;;EAAA;;AAKA;EACE,6BAAA,EAAA,MAAA;EACA,oBAAA,EAAA,MAAA;AAhCF;;AAmCA;;EAAA;;AAIA;EACE,wBAAA;AAjCF;;AAoCA;;;EAAA;;AAKA;EACE,0BAAA,EAAA,MAAA;EACA,aAAA,EAAA,MAAA;AAlCF;;AAqCA;+EAAA;;AAGA;;EAAA;;AAIA;EACE,cAAA;AApCF;;AAuCA;;EAAA;;AAIA;EACE,kBAAA;AArCF;;AAwCA;+EAAA;;AAGA;;EAAA;;AAIA;EACE,aAAA;AAvCF;;AA0CA;;EAAA;;AAIA;EACE,aAAA;AAxCF;;AA2CA;;;;EAAA;;AAMA;;EAAA;;AAIA;;;;;;;;;;;;;EAaE,SAAA;AA1CF;;AA6CA;EACE,6BAAA;EACA,sBAAA;AA1CF;;AA6CA;;;EAAA;;AAKA;EACE,mBAAA;EACA,0CAAA;AA3CF;;AA8CA;EACE,SAAA;EACA,UAAA;AA3CF;;AA8CA;;EAEE,gBAAA;EACA,SAAA;EACA,UAAA;AA3CF;;AA8CA;;EAAA;;AAIA;;;;;EAAA;;AAOA;EACE,6MAAA,EAAA,MAAA;EACA,gBAAA,EAAA,MAAA;AA7CF;;AAgDA;;;;;;;;;;;;;;;;;;;;;;;;EAAA;;AA0BA;;;EAGE,sBAAA,EAAA,MAAA;EACA,eAAA,EAAA,MAAA;EACA,mBAAA,EAAA,MAAA;EACA,qBAAA,EAAA,MAAA;AA9CF;;AAiDA;;EAAA;;AAIA;EACE,qBAAA;AA/CF;;AAkDA;;;;;;;;EAAA;;AAUA;EACE,mBAAA;AAhDF;;AAmDA;EACE,gBAAA;AAhDF;;AAmDA;;EAEE,cAAA;AAhDF;;AAmDA;;EAEE,eAAA;AAhDF;;AAmDA;EACE,yBAAA;AAhDF;;AAmDA;;;;;;EAME,kBAAA;EACA,oBAAA;AAhDF;;AAmDA;;;EAAA;;AAKA;EACE,cAAA;EACA,wBAAA;AAjDF;;AAoDA;;;;;;EAAA;;AAQA;;;;;EAKE,UAAA;EACA,oBAAA;EACA,cAAA;AAlDF;;AAqDA;;;;;EAAA;;AAOA;;;;EAIE,iFAAA;AAnDF;;AAsDA;;;;;;EAAA;;AAQA;;;;;;;;EAQE,cAAA;EACA,sBAAA;AApDF;;AAuDA;;;;;EAAA;;AAOA;;EAEE,eAAA;EACA,YAAA;AArDF;;AAwDA;EACE,WAAA;AArDF;;AAwDA;EACE;IACE,gBAAA;EArDF;AACF;;AAwDA;EACE;IACE,gBAAA;EAtDF;AACF;;AAyDA;EACE;IACE,iBAAA;EAvDF;AACF;;AA0DA;EACE;IACE,iBAAA;EAxDF;AACF;;AA2DA;EACE,oBAAA;EACA,oDAAA;EACA,iDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,gDAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,wDAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,oDAAA;EACA,yDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uDAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,mDAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,wDAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,oDAAA;EACA,yDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,iDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,wDAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,oDAAA;EACA,yDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uDAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,mDAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,iDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uDAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,mDAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,iDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,iDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,iDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,iDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,iDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,oDAAA;EACA,iDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,gDAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,yDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,0DAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,wDAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,oDAAA;EACA,yDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,yDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,0DAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,yDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,0DAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,wDAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,oDAAA;EACA,yDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,wDAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,oDAAA;EACA,yDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,sDAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,kDAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uDAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,mDAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uDAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,mDAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uDAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,mDAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uDAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,mDAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qDAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,iDAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,2DAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,uDAAA;EACA,4DAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,2DAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,uDAAA;EACA,4DAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,2DAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,uDAAA;EACA,4DAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,2DAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,uDAAA;EACA,4DAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,2DAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,uDAAA;EACA,4DAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,kBAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,kBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;EACQ,qBAAA;AAzDV;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,sBAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,sBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,sBAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,sBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,sBAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,sBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,yBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,sEAAA;AAzDF;;AA4DA;EACE,4EAAA;AAzDF;;AA4DA;EACE,wEAAA;AAzDF;;AA4DA;EACE,+EAAA;AAzDF;;AA4DA;EACE,yEAAA;AAzDF;;AA4DA;EACE,8EAAA;AAzDF;;AA4DA;EACE,uEAAA;AAzDF;;AA4DA;EACE,2EAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,8FAAA;AAzDF;;AA4DA;EACE,mCAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,2BAAA;EACA,8FAAA;AAzDF;;AA4DA;EACE,2BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,iCAAA;EACA,yHAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,0BAAA;EACA,yHAAA;AAzDF;;AA4DA;EACE,0BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,8FAAA;AAzDF;;AA4DA;EACE,mCAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,2BAAA;EACA,8FAAA;AAzDF;;AA4DA;EACE,2BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,iCAAA;EACA,yHAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,0BAAA;EACA,yHAAA;AAzDF;;AA4DA;EACE,0BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,8FAAA;AAzDF;;AA4DA;EACE,mCAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,2BAAA;EACA,8FAAA;AAzDF;;AA4DA;EACE,2BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,oGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mGAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,kGAAA;AAzDF;;AA4DA;EACE,iCAAA;EACA,yHAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,0BAAA;EACA,yHAAA;AAzDF;;AA4DA;EACE,0BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,+HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,8HAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,6HAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,kBAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,kBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,kBAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,kBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,kBAAA;EACA,kDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,kBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,wDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,uDAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,qBAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;EACA,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,4BAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,4BAAA;AAzDF;;AA4DA;EACE,gCAAA;EACA,iCAAA;AAzDF;;AA4DA;EACE,iCAAA;EACA,oCAAA;AAzDF;;AA4DA;EACE,oCAAA;EACA,mCAAA;AAzDF;;AA4DA;EACE,gCAAA;EACA,mCAAA;AAzDF;;AA4DA;EACE,+BAAA;EACA,gCAAA;AAzDF;;AA4DA;EACE,gCAAA;EACA,mCAAA;AAzDF;;AA4DA;EACE,mCAAA;EACA,kCAAA;AAzDF;;AA4DA;EACE,+BAAA;EACA,kCAAA;AAzDF;;AA4DA;EACE,gCAAA;EACA,iCAAA;AAzDF;;AA4DA;EACE,iCAAA;EACA,oCAAA;AAzDF;;AA4DA;EACE,oCAAA;EACA,mCAAA;AAzDF;;AA4DA;EACE,gCAAA;EACA,mCAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;EACA,kCAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iCAAA;AAzDF;;AA4DA;EACE,+BAAA;EACA,gCAAA;AAzDF;;AA4DA;EACE,gCAAA;EACA,mCAAA;AAzDF;;AA4DA;EACE,mCAAA;EACA,kCAAA;AAzDF;;AA4DA;EACE,+BAAA;EACA,kCAAA;AAzDF;;AA4DA;EACE,4BAAA;EACA,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;EACA,gCAAA;AAzDF;;AA4DA;EACE,gCAAA;EACA,+BAAA;AAzDF;;AA4DA;EACE,4BAAA;EACA,+BAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;EACA,kCAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;EACA,kCAAA;AAzDF;;AA4DA;EACE,kCAAA;EACA,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,iCAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,oCAAA;AAzDF;;AA4DA;EACE,mCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,mCAAA;AAzDF;;AA4DA;EACE,kCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,oCAAA;AAzDF;;AA4DA;EACE,mCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,kCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,mCAAA;AAzDF;;AA4DA;EACE,kCAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,kCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,kCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,SAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,SAAA;AAzDF;;AA4DA;EACE,SAAA;AAzDF;;AA4DA;EACE,SAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,6MAAA;AAzDF;;AA4DA;EACE,8DAAA;AAzDF;;AA4DA;EACE,iFAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,SAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,SAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,aAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,8BAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,oBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,WAAA;EACA,gDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,WAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,WAAA;EACA,gDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,WAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,mDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,sDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,qDAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,cAAA;EACA,oDAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AAzDF;;AA4DA;EACE,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAzDF;;AA4DA;EACE,MAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,QAAA;EACA,OAAA;AAzDF;;AA4DA;EACE,SAAA;EACA,YAAA;AAzDF;;AA4DA;EACE,WAAA;EACA,UAAA;AAzDF;;AA4DA;EACE,MAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,SAAA;AAzDF;;AA4DA;EACE,OAAA;AAzDF;;AA4DA;EACE,SAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,yCAAA;AAzDF;;AA4DA;EACE,2CAAA;AAzDF;;AA4DA;EACE,2EAAA;AAzDF;;AA4DA;EACE,iFAAA;AAzDF;;AA4DA;EACE,mFAAA;AAzDF;;AA4DA;EACE,qFAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,yCAAA;AAzDF;;AA4DA;EACE,2CAAA;AAzDF;;AA4DA;EACE,2EAAA;AAzDF;;AA4DA;EACE,iFAAA;AAzDF;;AA4DA;EACE,mFAAA;AAzDF;;AA4DA;EACE,qFAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,yCAAA;AAzDF;;AA4DA;EACE,2CAAA;AAzDF;;AA4DA;EACE,2EAAA;AAzDF;;AA4DA;EACE,iFAAA;AAzDF;;AA4DA;EACE,mFAAA;AAzDF;;AA4DA;EACE,qFAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,8CAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,4CAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,6CAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,8CAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,4CAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,6CAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,8CAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,4CAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,cAAA;EACA,6CAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,mCAAA;EACA,kCAAA;AAzDF;;AA4DA;EACE,4BAAA;EACA,6BAAA;AAzDF;;AA4DA;EACE,iEAAA;EACA,sEAAA;EACA,gEAAA;EACA,iEAAA;EACA,kEAAA;EACA,8MAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,uCAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,0CAAA;AAzDF;;AA4DA;EACE,4CAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,4CAAA;AAzDF;;AA4DA;EACE,mDAAA;AAzDF;;AA4DA;EACE,kDAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACQ,iBAAA;AAzDV;;AA4DA;EACE,yBAAA;EACQ,iBAAA;AAzDV;;AA4DA;EACE,wBAAA;EACQ,gBAAA;AAzDV;;AA4DA;EACE,yBAAA;EACQ,iBAAA;AAzDV;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,qBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,QAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,gBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,YAAA;AAzDF;;AA4DA;EACE,UAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,WAAA;AAzDF;;AA4DA;EACE,aAAA;AAzDF;;AA4DA;EACE,WAAA;EACA,MAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,YAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,WAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,YAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,YAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,WAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,gBAAA;EACA,WAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,cAAA;EACA,SAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,UAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,UAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,UAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,UAAA;AAzDF;;AA4DA;EACE,aAAA;EACA,QAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,mBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,kBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,UAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,YAAA;AAzDF;;AA4DA;EACE,eAAA;EACA,UAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,qBAAA;EACA,gBAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,oBAAA;EACA,eAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,kBAAA;EACA,aAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,mBAAA;EACA,cAAA;AAzDF;;AA4DA;EACE,iBAAA;EACA,YAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,gDAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,iDAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,mBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,6CAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,cAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,iBAAA;AAzDF;;AA4DA;EACE,oBAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,kBAAA;AAzDF;;AA4DA;EACE,0BAAA;EACA,0BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sBAAA;EACA,4PAAA;AAzDF;;AA4DA;EACE,eAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;EACA,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;EACA,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;EACA,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;EACA,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,iCAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,gCAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,6BAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,qBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE,wGAAA;AAzDF;;AA4DA;EACE,wEAAA;AAzDF;;AA4DA;EACE,4BAAA;AAzDF;;AA4DA;EACE,+BAAA;AAzDF;;AA4DA;EACE,8BAAA;AAzDF;;AA4DA;EACE,kCAAA;AAzDF;;AA4DA;EACE,sDAAA;AAzDF;;AA4DA;EACE,sDAAA;AAzDF;;AA4DA;EACE,wDAAA;AAzDF;;AA4DA;EACE,yBAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,0BAAA;AAzDF;;AA4DA;EACE,2BAAA;AAzDF;;AA4DA;EACE,sBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,uBAAA;AAzDF;;AA4DA;EACE,wBAAA;AAzDF;;AA4DA;EACE;IACE,yBAAA;EAzDF;AACF;;AA4DA;EACE;IACE,mBAAA;IACA,UAAA;EA1DF;AACF;;AA6DA;EACE;IACE,YAAA;EA3DF;AACF;;AA8DA;EACE;IACE,2BAAA;IACA,qDAAA;EA5DF;;EA+DA;IACE,eAAA;IACA,qDAAA;EA7DF;AACF;;AAgEA;EACE,eAAA;AA9DF;;AAiEA;EACE,kCAAA;AA9DF;;AAiEA;EACE,sDAAA;AA9DF;;AAiEA;EACE,yDAAA;AA9DF;;AAiEA;EACE,6BAAA;AA9DF;;AAiEA;EACE;IACE,WAAA;EA9DF;AACF;;AAgEE;EACE;IACE,gBAAA;EA9DJ;AACF;;AAiEE;EACE;IACE,gBAAA;EA/DJ;AACF;;AAkEE;EACE;IACE,iBAAA;EAhEJ;AACF;;AAmEE;EACE;IACE,iBAAA;EAjEJ;AACF;;AAuCA;EA6BE;IACE,oBAAA;IACA,oDAAA;IACA,iDAAA;EAjEF;;EAoEA;IACE,oBAAA;IACA,gDAAA;IACA,qDAAA;EAlEF;;EAqEA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAnEF;;EAsEA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EApEF;;EAuEA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EArEF;;EAwEA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAtEF;;EAyEA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAvEF;;EA0EA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAxEF;;EA2EA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAzEF;;EA4EA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA1EF;;EA6EA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EA3EF;;EA8EA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EA5EF;;EA+EA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EA7EF;;EAgFA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EA9EF;;EAiFA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EA/EF;;EAkFA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAhFF;;EAmFA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAjFF;;EAoFA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAlFF;;EAqFA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAnFF;;EAsFA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EApFF;;EAuFA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EArFF;;EAwFA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAtFF;;EAyFA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAvFF;;EA0FA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAxFF;;EA2FA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAzFF;;EA4FA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA1FF;;EA6FA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EA3FF;;EA8FA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA5FF;;EA+FA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA7FF;;EAgGA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA9FF;;EAiGA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA/FF;;EAkGA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAhGF;;EAmGA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAjGF;;EAoGA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAlGF;;EAqGA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAnGF;;EAsGA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EApGF;;EAuGA;IACE,oBAAA;IACA,oDAAA;IACA,iDAAA;EArGF;;EAwGA;IACE,oBAAA;IACA,gDAAA;IACA,qDAAA;EAtGF;;EAyGA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EAvGF;;EA0GA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EAxGF;;EA2GA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAzGF;;EA4GA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EA1GF;;EA6GA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EA3GF;;EA8GA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EA5GF;;EA+GA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA7GF;;EAgHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA9GF;;EAiHA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EA/GF;;EAkHA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EAhHF;;EAmHA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAjHF;;EAoHA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAlHF;;EAqHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAnHF;;EAsHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EApHF;;EAuHA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EArHF;;EAwHA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAtHF;;EAyHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAvHF;;EA0HA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAxHF;;EA2HA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAzHF;;EA4HA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA1HF;;EA6HA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA3HF;;EA8HA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA5HF;;EA+HA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA7HF;;EAgIA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA9HF;;EAiIA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA/HF;;EAkIA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAhIF;;EAmIA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAjIF;;EAoIA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAlIF;;EAqIA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAnIF;;EAsIA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EApIF;;EAuIA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EArIF;;EAwIA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAtIF;;EAyIA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAvIF;;EA0IA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAxIF;;EA2IA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAzIF;;EA4IA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA1IF;;EA6IA;IACE,oBAAA;EA3IF;;EA8IA;IACE,oBAAA;EA5IF;;EA+IA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA7IF;;EAgJA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EA9IF;;EAiJA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA/IF;;EAkJA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAhJF;;EAmJA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EAjJF;;EAoJA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAlJF;;EAqJA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EAnJF;;EAsJA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EApJF;;EAuJA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EArJF;;EAwJA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAtJF;;EAyJA;IACE,qBAAA;EAvJF;;EA0JA;IACE,qBAAA;EAxJF;;EA2JA;IACE,yBAAA;EAzJF;;EA4JA;IACE,0BAAA;EA1JF;;EA6JA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EA3JF;;EA8JA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EA5JF;;EA+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7JF;;EAgKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9JF;;EAiKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/JF;;EAkKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhKF;;EAmKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjKF;;EAoKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlKF;;EAqKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnKF;;EAsKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EApKF;;EAuKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EArKF;;EAwKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtKF;;EAyKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvKF;;EA0KA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxKF;;EA2KA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzKF;;EA4KA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1KF;;EA6KA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3KF;;EA8KA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5KF;;EA+KA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7KF;;EAgLA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9KF;;EAiLA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/KF;;EAkLA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhLF;;EAmLA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjLF;;EAoLA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlLF;;EAqLA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnLF;;EAsLA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApLF;;EAuLA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EArLF;;EAwLA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtLF;;EAyLA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvLF;;EA0LA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxLF;;EA2LA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzLF;;EA4LA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1LF;;EA6LA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3LF;;EA8LA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5LF;;EA+LA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7LF;;EAgMA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9LF;;EAiMA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/LF;;EAkMA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhMF;;EAmMA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjMF;;EAoMA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlMF;;EAqMA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnMF;;EAsMA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApMF;;EAuMA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArMF;;EAwMA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtMF;;EAyMA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvMF;;EA0MA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxMF;;EA2MA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAzMF;;EA4MA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1MF;;EA6MA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3MF;;EA8MA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5MF;;EA+MA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7MF;;EAgNA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9MF;;EAiNA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/MF;;EAkNA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhNF;;EAmNA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAjNF;;EAoNA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAlNF;;EAqNA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnNF;;EAsNA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApNF;;EAuNA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArNF;;EAwNA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtNF;;EAyNA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvNF;;EA0NA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxNF;;EA2NA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzNF;;EA4NA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1NF;;EA6NA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3NF;;EA8NA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5NF;;EA+NA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7NF;;EAgOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9NF;;EAiOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/NF;;EAkOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhOF;;EAmOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjOF;;EAoOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAlOF;;EAqOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnOF;;EAsOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EApOF;;EAuOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArOF;;EAwOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtOF;;EAyOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvOF;;EA0OA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxOF;;EA2OA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzOF;;EA4OA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1OF;;EA6OA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3OF;;EA8OA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5OF;;EA+OA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7OF;;EAgPA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9OF;;EAiPA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/OF;;EAkPA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhPF;;EAmPA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjPF;;EAoPA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlPF;;EAqPA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnPF;;EAsPA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApPF;;EAuPA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArPF;;EAwPA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtPF;;EAyPA;IACE,mBAAA;EAvPF;;EA0PA;IACE,oBAAA;EAxPF;;EA2PA;IACE,oBAAA;EAzPF;;EA4PA;IACE,oBAAA;EA1PF;;EA6PA;IACE,kBAAA;EA3PF;;EA8PA;IACE,mBAAA;EA5PF;;EA+PA;IACE,sBAAA;EA7PF;;EAgQA;IACE,qBAAA;EA9PF;;EAiQA;IACE,sBAAA;EA/PF;;EAkQA;IACE,mBAAA;EAhQF;;EAmQA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;EAjQF;;EAoQA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EAlQF;;EAqQA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;EAnQF;;EAsQA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EApQF;;EAuQA;IACE,gBAAA;EArQF;;EAwQA;IACE,4BAAA;EAtQF;;EAyQA;IACE,4BAAA;EAvQF;;EA0QA;IACE,6BAAA;EAxQF;;EA2QA;IACE,2BAAA;EAzQF;;EA4QA;IACE,4BAAA;EA1QF;;EA6QA;IACE,4BAAA;EA3QF;;EA8QA;IACE,6BAAA;IACQ,qBAAA;EA5QV;;EA+QA;IACE,6BAAA;EA7QF;;EAgRA;IACE,8BAAA;EA9QF;;EAiRA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA/QF;;EAkRA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EAhRF;;EAmRA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjRF;;EAoRA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlRF;;EAqRA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnRF;;EAsRA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApRF;;EAuRA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArRF;;EAwRA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtRF;;EAyRA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvRF;;EA0RA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAxRF;;EA2RA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAzRF;;EA4RA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1RF;;EA6RA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3RF;;EA8RA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5RF;;EA+RA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7RF;;EAgSA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9RF;;EAiSA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/RF;;EAkSA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAhSF;;EAmSA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAjSF;;EAoSA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAlSF;;EAqSA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnSF;;EAsSA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApSF;;EAuSA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArSF;;EAwSA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtSF;;EAySA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvSF;;EA0SA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxSF;;EA2SA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAzSF;;EA4SA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1SF;;EA6SA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3SF;;EA8SA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5SF;;EA+SA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7SF;;EAgTA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9SF;;EAiTA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/SF;;EAkTA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhTF;;EAmTA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjTF;;EAoTA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAlTF;;EAqTA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAnTF;;EAsTA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EApTF;;EAuTA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArTF;;EAwTA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtTF;;EAyTA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvTF;;EA0TA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxTF;;EA2TA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAzTF;;EA4TA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1TF;;EA6TA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3TF;;EA8TA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5TF;;EA+TA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA7TF;;EAgUA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9TF;;EAiUA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/TF;;EAkUA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhUF;;EAmUA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjUF;;EAoUA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAlUF;;EAqUA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAnUF;;EAsUA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApUF;;EAuUA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EArUF;;EAwUA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAtUF;;EAyUA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvUF;;EA0UA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxUF;;EA2UA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzUF;;EA4UA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1UF;;EA6UA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA3UF;;EA8UA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5UF;;EA+UA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7UF;;EAgVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9UF;;EAiVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/UF;;EAkVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhVF;;EAmVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjVF;;EAoVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlVF;;EAqVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnVF;;EAsVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApVF;;EAuVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EArVF;;EAwVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtVF;;EAyVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvVF;;EA0VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxVF;;EA2VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzVF;;EA4VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1VF;;EA6VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3VF;;EA8VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5VF;;EA+VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7VF;;EAgWA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9VF;;EAiWA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/VF;;EAkWA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAhWF;;EAmWA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAjWF;;EAoWA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlWF;;EAqWA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnWF;;EAsWA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApWF;;EAuWA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArWF;;EAwWA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtWF;;EAyWA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvWF;;EA0WA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxWF;;EA2WA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAzWF;;EA4WA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1WF;;EA6WA;IACE,6BAAA;EA3WF;;EA8WA;IACE,8BAAA;EA5WF;;EA+WA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA7WF;;EAgXA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA9WF;;EAiXA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/WF;;EAkXA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhXF;;EAmXA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjXF;;EAoXA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlXF;;EAqXA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnXF;;EAsXA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApXF;;EAuXA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EArXF;;EAwXA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAtXF;;EAyXA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAvXF;;EA0XA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxXF;;EA2XA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzXF;;EA4XA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1XF;;EA6XA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3XF;;EA8XA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5XF;;EA+XA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7XF;;EAgYA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9XF;;EAiYA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/XF;;EAkYA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAhYF;;EAmYA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjYF;;EAoYA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlYF;;EAqYA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnYF;;EAsYA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApYF;;EAuYA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EArYF;;EAwYA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtYF;;EAyYA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvYF;;EA0YA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxYF;;EA2YA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAzYF;;EA4YA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1YF;;EA6YA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3YF;;EA8YA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5YF;;EA+YA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7YF;;EAgZA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9YF;;EAiZA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/YF;;EAkZA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhZF;;EAmZA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAjZF;;EAoZA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAlZF;;EAqZA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnZF;;EAsZA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApZF;;EAuZA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArZF;;EAwZA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtZF;;EAyZA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvZF;;EA0ZA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxZF;;EA2ZA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAzZF;;EA4ZA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1ZF;;EA6ZA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA3ZF;;EA8ZA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5ZF;;EA+ZA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7ZF;;EAgaA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9ZF;;EAiaA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/ZF;;EAkaA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhaF;;EAmaA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjaF;;EAoaA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAlaF;;EAqaA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAnaF;;EAsaA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EApaF;;EAuaA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAraF;;EAwaA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtaF;;EAyaA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvaF;;EA0aA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxaF;;EA2aA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAzaF;;EA4aA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1aF;;EA6aA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA3aF;;EA8aA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5aF;;EA+aA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7aF;;EAgbA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9aF;;EAibA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/aF;;EAkbA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhbF;;EAmbA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjbF;;EAobA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlbF;;EAqbA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAnbF;;EAsbA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EApbF;;EAubA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EArbF;;EAwbA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtbF;;EAybA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvbF;;EA0bA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxbF;;EA2bA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzbF;;EA4bA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1bF;;EA6bA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3bF;;EA8bA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5bF;;EA+bA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7bF;;EAgcA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9bF;;EAicA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/bF;;EAkcA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhcF;;EAmcA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjcF;;EAocA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlcF;;EAqcA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAncF;;EAscA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApcF;;EAucA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EArcF;;EAwcA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtcF;;EAycA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvcF;;EA0cA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxcF;;EA2cA;IACE,6BAAA;EAzcF;;EA4cA;IACE,8BAAA;EA1cF;;EA6cA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA3cF;;EA8cA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA5cF;;EA+cA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7cF;;EAgdA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9cF;;EAidA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/cF;;EAkdA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhdF;;EAmdA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjdF;;EAodA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAldF;;EAqdA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAndF;;EAsdA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EApdF;;EAudA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EArdF;;EAwdA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtdF;;EAydA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvdF;;EA0dA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxdF;;EA2dA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzdF;;EA4dA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1dF;;EA6dA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3dF;;EA8dA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5dF;;EA+dA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7dF;;EAgeA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9dF;;EAieA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/dF;;EAkeA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAheF;;EAmeA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjeF;;EAoeA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAleF;;EAqeA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAneF;;EAseA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApeF;;EAueA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAreF;;EAweA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAteF;;EAyeA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAveF;;EA0eA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxeF;;EA2eA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzeF;;EA4eA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1eF;;EA6eA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA3eF;;EA8eA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5eF;;EA+eA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7eF;;EAgfA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9eF;;EAifA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/eF;;EAkfA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAhfF;;EAmfA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjfF;;EAofA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlfF;;EAqfA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnfF;;EAsfA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApfF;;EAufA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EArfF;;EAwfA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtfF;;EAyfA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvfF;;EA0fA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxfF;;EA2fA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAzfF;;EA4fA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1fF;;EA6fA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3fF;;EA8fA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5fF;;EA+fA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7fF;;EAggBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9fF;;EAigBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/fF;;EAkgBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhgBF;;EAmgBA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAjgBF;;EAogBA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAlgBF;;EAqgBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAngBF;;EAsgBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApgBF;;EAugBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArgBF;;EAwgBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtgBF;;EAygBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvgBF;;EA0gBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxgBF;;EA2gBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAzgBF;;EA4gBA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1gBF;;EA6gBA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3gBF;;EA8gBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5gBF;;EA+gBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7gBF;;EAghBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9gBF;;EAihBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/gBF;;EAkhBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhhBF;;EAmhBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjhBF;;EAohBA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAlhBF;;EAqhBA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAnhBF;;EAshBA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAphBF;;EAuhBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArhBF;;EAwhBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAthBF;;EAyhBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvhBF;;EA0hBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxhBF;;EA2hBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzhBF;;EA4hBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1hBF;;EA6hBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA3hBF;;EA8hBA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5hBF;;EA+hBA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7hBF;;EAgiBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9hBF;;EAiiBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/hBF;;EAkiBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhiBF;;EAmiBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjiBF;;EAoiBA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAliBF;;EAqiBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAniBF;;EAsiBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApiBF;;EAuiBA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAriBF;;EAwiBA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtiBF;;EAyiBA;IACE,sBAAA;EAviBF;;EA0iBA;IACE,sEAAA;EAxiBF;;EA2iBA;IACE,4EAAA;EAziBF;;EA4iBA;IACE,wEAAA;EA1iBF;;EA6iBA;IACE,+EAAA;EA3iBF;;EA8iBA;IACE,yEAAA;EA5iBF;;EA+iBA;IACE,8EAAA;EA7iBF;;EAgjBA;IACE,uEAAA;EA9iBF;;EAijBA;IACE,2EAAA;EA/iBF;;EAkjBA;IACE,kCAAA;IACA,8FAAA;EAhjBF;;EAmjBA;IACE,mCAAA;IACA,oGAAA;EAjjBF;;EAojBA;IACE,2BAAA;IACA,8FAAA;EAljBF;;EAqjBA;IACE,2BAAA;IACA,oGAAA;EAnjBF;;EAsjBA;IACE,8BAAA;IACA,oGAAA;EApjBF;;EAujBA;IACE,8BAAA;IACA,oGAAA;EArjBF;;EAwjBA;IACE,8BAAA;IACA,oGAAA;EAtjBF;;EAyjBA;IACE,8BAAA;IACA,oGAAA;EAvjBF;;EA0jBA;IACE,8BAAA;IACA,oGAAA;EAxjBF;;EA2jBA;IACE,8BAAA;IACA,oGAAA;EAzjBF;;EA4jBA;IACE,8BAAA;IACA,kGAAA;EA1jBF;;EA6jBA;IACE,8BAAA;IACA,iGAAA;EA3jBF;;EA8jBA;IACE,8BAAA;IACA,iGAAA;EA5jBF;;EA+jBA;IACE,8BAAA;IACA,oGAAA;EA7jBF;;EAgkBA;IACE,8BAAA;IACA,oGAAA;EA9jBF;;EAikBA;IACE,8BAAA;IACA,oGAAA;EA/jBF;;EAkkBA;IACE,8BAAA;IACA,oGAAA;EAhkBF;;EAmkBA;IACE,8BAAA;IACA,oGAAA;EAjkBF;;EAokBA;IACE,8BAAA;IACA,kGAAA;EAlkBF;;EAqkBA;IACE,8BAAA;IACA,kGAAA;EAnkBF;;EAskBA;IACE,8BAAA;IACA,kGAAA;EApkBF;;EAukBA;IACE,8BAAA;IACA,kGAAA;EArkBF;;EAwkBA;IACE,8BAAA;IACA,oGAAA;EAtkBF;;EAykBA;IACE,8BAAA;IACA,oGAAA;EAvkBF;;EA0kBA;IACE,8BAAA;IACA,oGAAA;EAxkBF;;EA2kBA;IACE,8BAAA;IACA,mGAAA;EAzkBF;;EA4kBA;IACE,8BAAA;IACA,mGAAA;EA1kBF;;EA6kBA;IACE,8BAAA;IACA,mGAAA;EA3kBF;;EA8kBA;IACE,8BAAA;IACA,kGAAA;EA5kBF;;EA+kBA;IACE,8BAAA;IACA,kGAAA;EA7kBF;;EAglBA;IACE,8BAAA;IACA,kGAAA;EA9kBF;;EAilBA;IACE,8BAAA;IACA,oGAAA;EA/kBF;;EAklBA;IACE,8BAAA;IACA,oGAAA;EAhlBF;;EAmlBA;IACE,8BAAA;IACA,oGAAA;EAjlBF;;EAolBA;IACE,8BAAA;IACA,mGAAA;EAllBF;;EAqlBA;IACE,8BAAA;IACA,mGAAA;EAnlBF;;EAslBA;IACE,8BAAA;IACA,mGAAA;EAplBF;;EAulBA;IACE,8BAAA;IACA,mGAAA;EArlBF;;EAwlBA;IACE,8BAAA;IACA,kGAAA;EAtlBF;;EAylBA;IACE,8BAAA;IACA,kGAAA;EAvlBF;;EA0lBA;IACE,8BAAA;IACA,oGAAA;EAxlBF;;EA2lBA;IACE,8BAAA;IACA,oGAAA;EAzlBF;;EA4lBA;IACE,8BAAA;IACA,oGAAA;EA1lBF;;EA6lBA;IACE,8BAAA;IACA,oGAAA;EA3lBF;;EA8lBA;IACE,8BAAA;IACA,mGAAA;EA5lBF;;EA+lBA;IACE,8BAAA;IACA,mGAAA;EA7lBF;;EAgmBA;IACE,8BAAA;IACA,kGAAA;EA9lBF;;EAimBA;IACE,8BAAA;IACA,kGAAA;EA/lBF;;EAkmBA;IACE,8BAAA;IACA,iGAAA;EAhmBF;;EAmmBA;IACE,8BAAA;IACA,oGAAA;EAjmBF;;EAomBA;IACE,8BAAA;IACA,oGAAA;EAlmBF;;EAqmBA;IACE,8BAAA;IACA,oGAAA;EAnmBF;;EAsmBA;IACE,8BAAA;IACA,mGAAA;EApmBF;;EAumBA;IACE,8BAAA;IACA,mGAAA;EArmBF;;EAwmBA;IACE,8BAAA;IACA,mGAAA;EAtmBF;;EAymBA;IACE,8BAAA;IACA,mGAAA;EAvmBF;;EA0mBA;IACE,8BAAA;IACA,iGAAA;EAxmBF;;EA2mBA;IACE,8BAAA;IACA,iGAAA;EAzmBF;;EA4mBA;IACE,8BAAA;IACA,oGAAA;EA1mBF;;EA6mBA;IACE,8BAAA;IACA,oGAAA;EA3mBF;;EA8mBA;IACE,8BAAA;IACA,oGAAA;EA5mBF;;EA+mBA;IACE,8BAAA;IACA,mGAAA;EA7mBF;;EAgnBA;IACE,8BAAA;IACA,mGAAA;EA9mBF;;EAinBA;IACE,8BAAA;IACA,mGAAA;EA/mBF;;EAknBA;IACE,8BAAA;IACA,mGAAA;EAhnBF;;EAmnBA;IACE,8BAAA;IACA,kGAAA;EAjnBF;;EAonBA;IACE,8BAAA;IACA,kGAAA;EAlnBF;;EAqnBA;IACE,8BAAA;IACA,oGAAA;EAnnBF;;EAsnBA;IACE,8BAAA;IACA,oGAAA;EApnBF;;EAunBA;IACE,8BAAA;IACA,oGAAA;EArnBF;;EAwnBA;IACE,8BAAA;IACA,oGAAA;EAtnBF;;EAynBA;IACE,8BAAA;IACA,oGAAA;EAvnBF;;EA0nBA;IACE,8BAAA;IACA,mGAAA;EAxnBF;;EA2nBA;IACE,8BAAA;IACA,kGAAA;EAznBF;;EA4nBA;IACE,8BAAA;IACA,kGAAA;EA1nBF;;EA6nBA;IACE,8BAAA;IACA,kGAAA;EA3nBF;;EA8nBA;IACE,8BAAA;IACA,oGAAA;EA5nBF;;EA+nBA;IACE,8BAAA;IACA,oGAAA;EA7nBF;;EAgoBA;IACE,8BAAA;IACA,oGAAA;EA9nBF;;EAioBA;IACE,8BAAA;IACA,oGAAA;EA/nBF;;EAkoBA;IACE,8BAAA;IACA,oGAAA;EAhoBF;;EAmoBA;IACE,8BAAA;IACA,mGAAA;EAjoBF;;EAooBA;IACE,8BAAA;IACA,mGAAA;EAloBF;;EAqoBA;IACE,8BAAA;IACA,kGAAA;EAnoBF;;EAsoBA;IACE,8BAAA;IACA,kGAAA;EApoBF;;EAuoBA;IACE,8BAAA;IACA,oGAAA;EAroBF;;EAwoBA;IACE,8BAAA;IACA,oGAAA;EAtoBF;;EAyoBA;IACE,8BAAA;IACA,oGAAA;EAvoBF;;EA0oBA;IACE,8BAAA;IACA,oGAAA;EAxoBF;;EA2oBA;IACE,8BAAA;IACA,oGAAA;EAzoBF;;EA4oBA;IACE,8BAAA;IACA,mGAAA;EA1oBF;;EA6oBA;IACE,8BAAA;IACA,mGAAA;EA3oBF;;EA8oBA;IACE,8BAAA;IACA,mGAAA;EA5oBF;;EA+oBA;IACE,8BAAA;IACA,kGAAA;EA7oBF;;EAgpBA;IACE,iCAAA;IACA,yHAAA;EA9oBF;;EAipBA;IACE,kCAAA;IACA,+HAAA;EA/oBF;;EAkpBA;IACE,0BAAA;IACA,yHAAA;EAhpBF;;EAmpBA;IACE,0BAAA;IACA,+HAAA;EAjpBF;;EAopBA;IACE,6BAAA;IACA,+HAAA;EAlpBF;;EAqpBA;IACE,6BAAA;IACA,+HAAA;EAnpBF;;EAspBA;IACE,6BAAA;IACA,+HAAA;EAppBF;;EAupBA;IACE,6BAAA;IACA,+HAAA;EArpBF;;EAwpBA;IACE,6BAAA;IACA,+HAAA;EAtpBF;;EAypBA;IACE,6BAAA;IACA,+HAAA;EAvpBF;;EA0pBA;IACE,6BAAA;IACA,6HAAA;EAxpBF;;EA2pBA;IACE,6BAAA;IACA,4HAAA;EAzpBF;;EA4pBA;IACE,6BAAA;IACA,4HAAA;EA1pBF;;EA6pBA;IACE,6BAAA;IACA,+HAAA;EA3pBF;;EA8pBA;IACE,6BAAA;IACA,+HAAA;EA5pBF;;EA+pBA;IACE,6BAAA;IACA,+HAAA;EA7pBF;;EAgqBA;IACE,6BAAA;IACA,+HAAA;EA9pBF;;EAiqBA;IACE,6BAAA;IACA,+HAAA;EA/pBF;;EAkqBA;IACE,6BAAA;IACA,6HAAA;EAhqBF;;EAmqBA;IACE,6BAAA;IACA,6HAAA;EAjqBF;;EAoqBA;IACE,6BAAA;IACA,6HAAA;EAlqBF;;EAqqBA;IACE,6BAAA;IACA,6HAAA;EAnqBF;;EAsqBA;IACE,6BAAA;IACA,+HAAA;EApqBF;;EAuqBA;IACE,6BAAA;IACA,+HAAA;EArqBF;;EAwqBA;IACE,6BAAA;IACA,+HAAA;EAtqBF;;EAyqBA;IACE,6BAAA;IACA,8HAAA;EAvqBF;;EA0qBA;IACE,6BAAA;IACA,8HAAA;EAxqBF;;EA2qBA;IACE,6BAAA;IACA,8HAAA;EAzqBF;;EA4qBA;IACE,6BAAA;IACA,6HAAA;EA1qBF;;EA6qBA;IACE,6BAAA;IACA,6HAAA;EA3qBF;;EA8qBA;IACE,6BAAA;IACA,6HAAA;EA5qBF;;EA+qBA;IACE,6BAAA;IACA,+HAAA;EA7qBF;;EAgrBA;IACE,6BAAA;IACA,+HAAA;EA9qBF;;EAirBA;IACE,6BAAA;IACA,+HAAA;EA/qBF;;EAkrBA;IACE,6BAAA;IACA,8HAAA;EAhrBF;;EAmrBA;IACE,6BAAA;IACA,8HAAA;EAjrBF;;EAorBA;IACE,6BAAA;IACA,8HAAA;EAlrBF;;EAqrBA;IACE,6BAAA;IACA,8HAAA;EAnrBF;;EAsrBA;IACE,6BAAA;IACA,6HAAA;EAprBF;;EAurBA;IACE,6BAAA;IACA,6HAAA;EArrBF;;EAwrBA;IACE,6BAAA;IACA,+HAAA;EAtrBF;;EAyrBA;IACE,6BAAA;IACA,+HAAA;EAvrBF;;EA0rBA;IACE,6BAAA;IACA,+HAAA;EAxrBF;;EA2rBA;IACE,6BAAA;IACA,+HAAA;EAzrBF;;EA4rBA;IACE,6BAAA;IACA,8HAAA;EA1rBF;;EA6rBA;IACE,6BAAA;IACA,8HAAA;EA3rBF;;EA8rBA;IACE,6BAAA;IACA,6HAAA;EA5rBF;;EA+rBA;IACE,6BAAA;IACA,6HAAA;EA7rBF;;EAgsBA;IACE,6BAAA;IACA,4HAAA;EA9rBF;;EAisBA;IACE,6BAAA;IACA,+HAAA;EA/rBF;;EAksBA;IACE,6BAAA;IACA,+HAAA;EAhsBF;;EAmsBA;IACE,6BAAA;IACA,+HAAA;EAjsBF;;EAosBA;IACE,6BAAA;IACA,8HAAA;EAlsBF;;EAqsBA;IACE,6BAAA;IACA,8HAAA;EAnsBF;;EAssBA;IACE,6BAAA;IACA,8HAAA;EApsBF;;EAusBA;IACE,6BAAA;IACA,8HAAA;EArsBF;;EAwsBA;IACE,6BAAA;IACA,4HAAA;EAtsBF;;EAysBA;IACE,6BAAA;IACA,4HAAA;EAvsBF;;EA0sBA;IACE,6BAAA;IACA,+HAAA;EAxsBF;;EA2sBA;IACE,6BAAA;IACA,+HAAA;EAzsBF;;EA4sBA;IACE,6BAAA;IACA,+HAAA;EA1sBF;;EA6sBA;IACE,6BAAA;IACA,8HAAA;EA3sBF;;EA8sBA;IACE,6BAAA;IACA,8HAAA;EA5sBF;;EA+sBA;IACE,6BAAA;IACA,8HAAA;EA7sBF;;EAgtBA;IACE,6BAAA;IACA,8HAAA;EA9sBF;;EAitBA;IACE,6BAAA;IACA,6HAAA;EA/sBF;;EAktBA;IACE,6BAAA;IACA,6HAAA;EAhtBF;;EAmtBA;IACE,6BAAA;IACA,+HAAA;EAjtBF;;EAotBA;IACE,6BAAA;IACA,+HAAA;EAltBF;;EAqtBA;IACE,6BAAA;IACA,+HAAA;EAntBF;;EAstBA;IACE,6BAAA;IACA,+HAAA;EAptBF;;EAutBA;IACE,6BAAA;IACA,+HAAA;EArtBF;;EAwtBA;IACE,6BAAA;IACA,8HAAA;EAttBF;;EAytBA;IACE,6BAAA;IACA,6HAAA;EAvtBF;;EA0tBA;IACE,6BAAA;IACA,6HAAA;EAxtBF;;EA2tBA;IACE,6BAAA;IACA,6HAAA;EAztBF;;EA4tBA;IACE,6BAAA;IACA,+HAAA;EA1tBF;;EA6tBA;IACE,6BAAA;IACA,+HAAA;EA3tBF;;EA8tBA;IACE,6BAAA;IACA,+HAAA;EA5tBF;;EA+tBA;IACE,6BAAA;IACA,+HAAA;EA7tBF;;EAguBA;IACE,6BAAA;IACA,+HAAA;EA9tBF;;EAiuBA;IACE,6BAAA;IACA,8HAAA;EA/tBF;;EAkuBA;IACE,6BAAA;IACA,8HAAA;EAhuBF;;EAmuBA;IACE,6BAAA;IACA,6HAAA;EAjuBF;;EAouBA;IACE,6BAAA;IACA,6HAAA;EAluBF;;EAquBA;IACE,6BAAA;IACA,+HAAA;EAnuBF;;EAsuBA;IACE,6BAAA;IACA,+HAAA;EApuBF;;EAuuBA;IACE,6BAAA;IACA,+HAAA;EAruBF;;EAwuBA;IACE,6BAAA;IACA,+HAAA;EAtuBF;;EAyuBA;IACE,6BAAA;IACA,+HAAA;EAvuBF;;EA0uBA;IACE,6BAAA;IACA,8HAAA;EAxuBF;;EA2uBA;IACE,6BAAA;IACA,8HAAA;EAzuBF;;EA4uBA;IACE,6BAAA;IACA,8HAAA;EA1uBF;;EA6uBA;IACE,6BAAA;IACA,6HAAA;EA3uBF;;EA8uBA;IACE,gCAAA;EA5uBF;;EA+uBA;IACE,iCAAA;EA7uBF;;EAgvBA;IACE,yBAAA;EA9uBF;;EAivBA;IACE,yBAAA;EA/uBF;;EAkvBA;IACE,4BAAA;EAhvBF;;EAmvBA;IACE,4BAAA;EAjvBF;;EAovBA;IACE,4BAAA;EAlvBF;;EAqvBA;IACE,4BAAA;EAnvBF;;EAsvBA;IACE,4BAAA;EApvBF;;EAuvBA;IACE,4BAAA;EArvBF;;EAwvBA;IACE,4BAAA;EAtvBF;;EAyvBA;IACE,4BAAA;EAvvBF;;EA0vBA;IACE,4BAAA;EAxvBF;;EA2vBA;IACE,4BAAA;EAzvBF;;EA4vBA;IACE,4BAAA;EA1vBF;;EA6vBA;IACE,4BAAA;EA3vBF;;EA8vBA;IACE,4BAAA;EA5vBF;;EA+vBA;IACE,4BAAA;EA7vBF;;EAgwBA;IACE,4BAAA;EA9vBF;;EAiwBA;IACE,4BAAA;EA/vBF;;EAkwBA;IACE,4BAAA;EAhwBF;;EAmwBA;IACE,4BAAA;EAjwBF;;EAowBA;IACE,4BAAA;EAlwBF;;EAqwBA;IACE,4BAAA;EAnwBF;;EAswBA;IACE,4BAAA;EApwBF;;EAuwBA;IACE,4BAAA;EArwBF;;EAwwBA;IACE,4BAAA;EAtwBF;;EAywBA;IACE,4BAAA;EAvwBF;;EA0wBA;IACE,4BAAA;EAxwBF;;EA2wBA;IACE,4BAAA;EAzwBF;;EA4wBA;IACE,4BAAA;EA1wBF;;EA6wBA;IACE,4BAAA;EA3wBF;;EA8wBA;IACE,4BAAA;EA5wBF;;EA+wBA;IACE,4BAAA;EA7wBF;;EAgxBA;IACE,4BAAA;EA9wBF;;EAixBA;IACE,4BAAA;EA/wBF;;EAkxBA;IACE,4BAAA;EAhxBF;;EAmxBA;IACE,4BAAA;EAjxBF;;EAoxBA;IACE,4BAAA;EAlxBF;;EAqxBA;IACE,4BAAA;EAnxBF;;EAsxBA;IACE,4BAAA;EApxBF;;EAuxBA;IACE,4BAAA;EArxBF;;EAwxBA;IACE,4BAAA;EAtxBF;;EAyxBA;IACE,4BAAA;EAvxBF;;EA0xBA;IACE,4BAAA;EAxxBF;;EA2xBA;IACE,4BAAA;EAzxBF;;EA4xBA;IACE,4BAAA;EA1xBF;;EA6xBA;IACE,4BAAA;EA3xBF;;EA8xBA;IACE,4BAAA;EA5xBF;;EA+xBA;IACE,4BAAA;EA7xBF;;EAgyBA;IACE,4BAAA;EA9xBF;;EAiyBA;IACE,4BAAA;EA/xBF;;EAkyBA;IACE,4BAAA;EAhyBF;;EAmyBA;IACE,4BAAA;EAjyBF;;EAoyBA;IACE,4BAAA;EAlyBF;;EAqyBA;IACE,4BAAA;EAnyBF;;EAsyBA;IACE,4BAAA;EApyBF;;EAuyBA;IACE,4BAAA;EAryBF;;EAwyBA;IACE,4BAAA;EAtyBF;;EAyyBA;IACE,4BAAA;EAvyBF;;EA0yBA;IACE,4BAAA;EAxyBF;;EA2yBA;IACE,4BAAA;EAzyBF;;EA4yBA;IACE,4BAAA;EA1yBF;;EA6yBA;IACE,4BAAA;EA3yBF;;EA8yBA;IACE,4BAAA;EA5yBF;;EA+yBA;IACE,4BAAA;EA7yBF;;EAgzBA;IACE,4BAAA;EA9yBF;;EAizBA;IACE,4BAAA;EA/yBF;;EAkzBA;IACE,4BAAA;EAhzBF;;EAmzBA;IACE,4BAAA;EAjzBF;;EAozBA;IACE,4BAAA;EAlzBF;;EAqzBA;IACE,4BAAA;EAnzBF;;EAszBA;IACE,4BAAA;EApzBF;;EAuzBA;IACE,4BAAA;EArzBF;;EAwzBA;IACE,4BAAA;EAtzBF;;EAyzBA;IACE,4BAAA;EAvzBF;;EA0zBA;IACE,4BAAA;EAxzBF;;EA2zBA;IACE,4BAAA;EAzzBF;;EA4zBA;IACE,4BAAA;EA1zBF;;EA6zBA;IACE,4BAAA;EA3zBF;;EA8zBA;IACE,4BAAA;EA5zBF;;EA+zBA;IACE,4BAAA;EA7zBF;;EAg0BA;IACE,4BAAA;EA9zBF;;EAi0BA;IACE,4BAAA;EA/zBF;;EAk0BA;IACE,4BAAA;EAh0BF;;EAm0BA;IACE,4BAAA;EAj0BF;;EAo0BA;IACE,4BAAA;EAl0BF;;EAq0BA;IACE,4BAAA;EAn0BF;;EAs0BA;IACE,4BAAA;EAp0BF;;EAu0BA;IACE,4BAAA;EAr0BF;;EAw0BA;IACE,4BAAA;EAt0BF;;EAy0BA;IACE,4BAAA;EAv0BF;;EA00BA;IACE,4BAAA;EAx0BF;;EA20BA;IACE,4BAAA;EAz0BF;;EA40BA;IACE,kCAAA;IACA,8FAAA;EA10BF;;EA60BA;IACE,mCAAA;IACA,oGAAA;EA30BF;;EA80BA;IACE,2BAAA;IACA,8FAAA;EA50BF;;EA+0BA;IACE,2BAAA;IACA,oGAAA;EA70BF;;EAg1BA;IACE,8BAAA;IACA,oGAAA;EA90BF;;EAi1BA;IACE,8BAAA;IACA,oGAAA;EA/0BF;;EAk1BA;IACE,8BAAA;IACA,oGAAA;EAh1BF;;EAm1BA;IACE,8BAAA;IACA,oGAAA;EAj1BF;;EAo1BA;IACE,8BAAA;IACA,oGAAA;EAl1BF;;EAq1BA;IACE,8BAAA;IACA,oGAAA;EAn1BF;;EAs1BA;IACE,8BAAA;IACA,kGAAA;EAp1BF;;EAu1BA;IACE,8BAAA;IACA,iGAAA;EAr1BF;;EAw1BA;IACE,8BAAA;IACA,iGAAA;EAt1BF;;EAy1BA;IACE,8BAAA;IACA,oGAAA;EAv1BF;;EA01BA;IACE,8BAAA;IACA,oGAAA;EAx1BF;;EA21BA;IACE,8BAAA;IACA,oGAAA;EAz1BF;;EA41BA;IACE,8BAAA;IACA,oGAAA;EA11BF;;EA61BA;IACE,8BAAA;IACA,oGAAA;EA31BF;;EA81BA;IACE,8BAAA;IACA,kGAAA;EA51BF;;EA+1BA;IACE,8BAAA;IACA,kGAAA;EA71BF;;EAg2BA;IACE,8BAAA;IACA,kGAAA;EA91BF;;EAi2BA;IACE,8BAAA;IACA,kGAAA;EA/1BF;;EAk2BA;IACE,8BAAA;IACA,oGAAA;EAh2BF;;EAm2BA;IACE,8BAAA;IACA,oGAAA;EAj2BF;;EAo2BA;IACE,8BAAA;IACA,oGAAA;EAl2BF;;EAq2BA;IACE,8BAAA;IACA,mGAAA;EAn2BF;;EAs2BA;IACE,8BAAA;IACA,mGAAA;EAp2BF;;EAu2BA;IACE,8BAAA;IACA,mGAAA;EAr2BF;;EAw2BA;IACE,8BAAA;IACA,kGAAA;EAt2BF;;EAy2BA;IACE,8BAAA;IACA,kGAAA;EAv2BF;;EA02BA;IACE,8BAAA;IACA,kGAAA;EAx2BF;;EA22BA;IACE,8BAAA;IACA,oGAAA;EAz2BF;;EA42BA;IACE,8BAAA;IACA,oGAAA;EA12BF;;EA62BA;IACE,8BAAA;IACA,oGAAA;EA32BF;;EA82BA;IACE,8BAAA;IACA,mGAAA;EA52BF;;EA+2BA;IACE,8BAAA;IACA,mGAAA;EA72BF;;EAg3BA;IACE,8BAAA;IACA,mGAAA;EA92BF;;EAi3BA;IACE,8BAAA;IACA,mGAAA;EA/2BF;;EAk3BA;IACE,8BAAA;IACA,kGAAA;EAh3BF;;EAm3BA;IACE,8BAAA;IACA,kGAAA;EAj3BF;;EAo3BA;IACE,8BAAA;IACA,oGAAA;EAl3BF;;EAq3BA;IACE,8BAAA;IACA,oGAAA;EAn3BF;;EAs3BA;IACE,8BAAA;IACA,oGAAA;EAp3BF;;EAu3BA;IACE,8BAAA;IACA,oGAAA;EAr3BF;;EAw3BA;IACE,8BAAA;IACA,mGAAA;EAt3BF;;EAy3BA;IACE,8BAAA;IACA,mGAAA;EAv3BF;;EA03BA;IACE,8BAAA;IACA,kGAAA;EAx3BF;;EA23BA;IACE,8BAAA;IACA,kGAAA;EAz3BF;;EA43BA;IACE,8BAAA;IACA,iGAAA;EA13BF;;EA63BA;IACE,8BAAA;IACA,oGAAA;EA33BF;;EA83BA;IACE,8BAAA;IACA,oGAAA;EA53BF;;EA+3BA;IACE,8BAAA;IACA,oGAAA;EA73BF;;EAg4BA;IACE,8BAAA;IACA,mGAAA;EA93BF;;EAi4BA;IACE,8BAAA;IACA,mGAAA;EA/3BF;;EAk4BA;IACE,8BAAA;IACA,mGAAA;EAh4BF;;EAm4BA;IACE,8BAAA;IACA,mGAAA;EAj4BF;;EAo4BA;IACE,8BAAA;IACA,iGAAA;EAl4BF;;EAq4BA;IACE,8BAAA;IACA,iGAAA;EAn4BF;;EAs4BA;IACE,8BAAA;IACA,oGAAA;EAp4BF;;EAu4BA;IACE,8BAAA;IACA,oGAAA;EAr4BF;;EAw4BA;IACE,8BAAA;IACA,oGAAA;EAt4BF;;EAy4BA;IACE,8BAAA;IACA,mGAAA;EAv4BF;;EA04BA;IACE,8BAAA;IACA,mGAAA;EAx4BF;;EA24BA;IACE,8BAAA;IACA,mGAAA;EAz4BF;;EA44BA;IACE,8BAAA;IACA,mGAAA;EA14BF;;EA64BA;IACE,8BAAA;IACA,kGAAA;EA34BF;;EA84BA;IACE,8BAAA;IACA,kGAAA;EA54BF;;EA+4BA;IACE,8BAAA;IACA,oGAAA;EA74BF;;EAg5BA;IACE,8BAAA;IACA,oGAAA;EA94BF;;EAi5BA;IACE,8BAAA;IACA,oGAAA;EA/4BF;;EAk5BA;IACE,8BAAA;IACA,oGAAA;EAh5BF;;EAm5BA;IACE,8BAAA;IACA,oGAAA;EAj5BF;;EAo5BA;IACE,8BAAA;IACA,mGAAA;EAl5BF;;EAq5BA;IACE,8BAAA;IACA,kGAAA;EAn5BF;;EAs5BA;IACE,8BAAA;IACA,kGAAA;EAp5BF;;EAu5BA;IACE,8BAAA;IACA,kGAAA;EAr5BF;;EAw5BA;IACE,8BAAA;IACA,oGAAA;EAt5BF;;EAy5BA;IACE,8BAAA;IACA,oGAAA;EAv5BF;;EA05BA;IACE,8BAAA;IACA,oGAAA;EAx5BF;;EA25BA;IACE,8BAAA;IACA,oGAAA;EAz5BF;;EA45BA;IACE,8BAAA;IACA,oGAAA;EA15BF;;EA65BA;IACE,8BAAA;IACA,mGAAA;EA35BF;;EA85BA;IACE,8BAAA;IACA,mGAAA;EA55BF;;EA+5BA;IACE,8BAAA;IACA,kGAAA;EA75BF;;EAg6BA;IACE,8BAAA;IACA,kGAAA;EA95BF;;EAi6BA;IACE,8BAAA;IACA,oGAAA;EA/5BF;;EAk6BA;IACE,8BAAA;IACA,oGAAA;EAh6BF;;EAm6BA;IACE,8BAAA;IACA,oGAAA;EAj6BF;;EAo6BA;IACE,8BAAA;IACA,oGAAA;EAl6BF;;EAq6BA;IACE,8BAAA;IACA,oGAAA;EAn6BF;;EAs6BA;IACE,8BAAA;IACA,mGAAA;EAp6BF;;EAu6BA;IACE,8BAAA;IACA,mGAAA;EAr6BF;;EAw6BA;IACE,8BAAA;IACA,mGAAA;EAt6BF;;EAy6BA;IACE,8BAAA;IACA,kGAAA;EAv6BF;;EA06BA;IACE,iCAAA;IACA,yHAAA;EAx6BF;;EA26BA;IACE,kCAAA;IACA,+HAAA;EAz6BF;;EA46BA;IACE,0BAAA;IACA,yHAAA;EA16BF;;EA66BA;IACE,0BAAA;IACA,+HAAA;EA36BF;;EA86BA;IACE,6BAAA;IACA,+HAAA;EA56BF;;EA+6BA;IACE,6BAAA;IACA,+HAAA;EA76BF;;EAg7BA;IACE,6BAAA;IACA,+HAAA;EA96BF;;EAi7BA;IACE,6BAAA;IACA,+HAAA;EA/6BF;;EAk7BA;IACE,6BAAA;IACA,+HAAA;EAh7BF;;EAm7BA;IACE,6BAAA;IACA,+HAAA;EAj7BF;;EAo7BA;IACE,6BAAA;IACA,6HAAA;EAl7BF;;EAq7BA;IACE,6BAAA;IACA,4HAAA;EAn7BF;;EAs7BA;IACE,6BAAA;IACA,4HAAA;EAp7BF;;EAu7BA;IACE,6BAAA;IACA,+HAAA;EAr7BF;;EAw7BA;IACE,6BAAA;IACA,+HAAA;EAt7BF;;EAy7BA;IACE,6BAAA;IACA,+HAAA;EAv7BF;;EA07BA;IACE,6BAAA;IACA,+HAAA;EAx7BF;;EA27BA;IACE,6BAAA;IACA,+HAAA;EAz7BF;;EA47BA;IACE,6BAAA;IACA,6HAAA;EA17BF;;EA67BA;IACE,6BAAA;IACA,6HAAA;EA37BF;;EA87BA;IACE,6BAAA;IACA,6HAAA;EA57BF;;EA+7BA;IACE,6BAAA;IACA,6HAAA;EA77BF;;EAg8BA;IACE,6BAAA;IACA,+HAAA;EA97BF;;EAi8BA;IACE,6BAAA;IACA,+HAAA;EA/7BF;;EAk8BA;IACE,6BAAA;IACA,+HAAA;EAh8BF;;EAm8BA;IACE,6BAAA;IACA,8HAAA;EAj8BF;;EAo8BA;IACE,6BAAA;IACA,8HAAA;EAl8BF;;EAq8BA;IACE,6BAAA;IACA,8HAAA;EAn8BF;;EAs8BA;IACE,6BAAA;IACA,6HAAA;EAp8BF;;EAu8BA;IACE,6BAAA;IACA,6HAAA;EAr8BF;;EAw8BA;IACE,6BAAA;IACA,6HAAA;EAt8BF;;EAy8BA;IACE,6BAAA;IACA,+HAAA;EAv8BF;;EA08BA;IACE,6BAAA;IACA,+HAAA;EAx8BF;;EA28BA;IACE,6BAAA;IACA,+HAAA;EAz8BF;;EA48BA;IACE,6BAAA;IACA,8HAAA;EA18BF;;EA68BA;IACE,6BAAA;IACA,8HAAA;EA38BF;;EA88BA;IACE,6BAAA;IACA,8HAAA;EA58BF;;EA+8BA;IACE,6BAAA;IACA,8HAAA;EA78BF;;EAg9BA;IACE,6BAAA;IACA,6HAAA;EA98BF;;EAi9BA;IACE,6BAAA;IACA,6HAAA;EA/8BF;;EAk9BA;IACE,6BAAA;IACA,+HAAA;EAh9BF;;EAm9BA;IACE,6BAAA;IACA,+HAAA;EAj9BF;;EAo9BA;IACE,6BAAA;IACA,+HAAA;EAl9BF;;EAq9BA;IACE,6BAAA;IACA,+HAAA;EAn9BF;;EAs9BA;IACE,6BAAA;IACA,8HAAA;EAp9BF;;EAu9BA;IACE,6BAAA;IACA,8HAAA;EAr9BF;;EAw9BA;IACE,6BAAA;IACA,6HAAA;EAt9BF;;EAy9BA;IACE,6BAAA;IACA,6HAAA;EAv9BF;;EA09BA;IACE,6BAAA;IACA,4HAAA;EAx9BF;;EA29BA;IACE,6BAAA;IACA,+HAAA;EAz9BF;;EA49BA;IACE,6BAAA;IACA,+HAAA;EA19BF;;EA69BA;IACE,6BAAA;IACA,+HAAA;EA39BF;;EA89BA;IACE,6BAAA;IACA,8HAAA;EA59BF;;EA+9BA;IACE,6BAAA;IACA,8HAAA;EA79BF;;EAg+BA;IACE,6BAAA;IACA,8HAAA;EA99BF;;EAi+BA;IACE,6BAAA;IACA,8HAAA;EA/9BF;;EAk+BA;IACE,6BAAA;IACA,4HAAA;EAh+BF;;EAm+BA;IACE,6BAAA;IACA,4HAAA;EAj+BF;;EAo+BA;IACE,6BAAA;IACA,+HAAA;EAl+BF;;EAq+BA;IACE,6BAAA;IACA,+HAAA;EAn+BF;;EAs+BA;IACE,6BAAA;IACA,+HAAA;EAp+BF;;EAu+BA;IACE,6BAAA;IACA,8HAAA;EAr+BF;;EAw+BA;IACE,6BAAA;IACA,8HAAA;EAt+BF;;EAy+BA;IACE,6BAAA;IACA,8HAAA;EAv+BF;;EA0+BA;IACE,6BAAA;IACA,8HAAA;EAx+BF;;EA2+BA;IACE,6BAAA;IACA,6HAAA;EAz+BF;;EA4+BA;IACE,6BAAA;IACA,6HAAA;EA1+BF;;EA6+BA;IACE,6BAAA;IACA,+HAAA;EA3+BF;;EA8+BA;IACE,6BAAA;IACA,+HAAA;EA5+BF;;EA++BA;IACE,6BAAA;IACA,+HAAA;EA7+BF;;EAg/BA;IACE,6BAAA;IACA,+HAAA;EA9+BF;;EAi/BA;IACE,6BAAA;IACA,+HAAA;EA/+BF;;EAk/BA;IACE,6BAAA;IACA,8HAAA;EAh/BF;;EAm/BA;IACE,6BAAA;IACA,6HAAA;EAj/BF;;EAo/BA;IACE,6BAAA;IACA,6HAAA;EAl/BF;;EAq/BA;IACE,6BAAA;IACA,6HAAA;EAn/BF;;EAs/BA;IACE,6BAAA;IACA,+HAAA;EAp/BF;;EAu/BA;IACE,6BAAA;IACA,+HAAA;EAr/BF;;EAw/BA;IACE,6BAAA;IACA,+HAAA;EAt/BF;;EAy/BA;IACE,6BAAA;IACA,+HAAA;EAv/BF;;EA0/BA;IACE,6BAAA;IACA,+HAAA;EAx/BF;;EA2/BA;IACE,6BAAA;IACA,8HAAA;EAz/BF;;EA4/BA;IACE,6BAAA;IACA,8HAAA;EA1/BF;;EA6/BA;IACE,6BAAA;IACA,6HAAA;EA3/BF;;EA8/BA;IACE,6BAAA;IACA,6HAAA;EA5/BF;;EA+/BA;IACE,6BAAA;IACA,+HAAA;EA7/BF;;EAggCA;IACE,6BAAA;IACA,+HAAA;EA9/BF;;EAigCA;IACE,6BAAA;IACA,+HAAA;EA//BF;;EAkgCA;IACE,6BAAA;IACA,+HAAA;EAhgCF;;EAmgCA;IACE,6BAAA;IACA,+HAAA;EAjgCF;;EAogCA;IACE,6BAAA;IACA,8HAAA;EAlgCF;;EAqgCA;IACE,6BAAA;IACA,8HAAA;EAngCF;;EAsgCA;IACE,6BAAA;IACA,8HAAA;EApgCF;;EAugCA;IACE,6BAAA;IACA,6HAAA;EArgCF;;EAwgCA;IACE,gCAAA;EAtgCF;;EAygCA;IACE,iCAAA;EAvgCF;;EA0gCA;IACE,yBAAA;EAxgCF;;EA2gCA;IACE,yBAAA;EAzgCF;;EA4gCA;IACE,4BAAA;EA1gCF;;EA6gCA;IACE,4BAAA;EA3gCF;;EA8gCA;IACE,4BAAA;EA5gCF;;EA+gCA;IACE,4BAAA;EA7gCF;;EAghCA;IACE,4BAAA;EA9gCF;;EAihCA;IACE,4BAAA;EA/gCF;;EAkhCA;IACE,4BAAA;EAhhCF;;EAmhCA;IACE,4BAAA;EAjhCF;;EAohCA;IACE,4BAAA;EAlhCF;;EAqhCA;IACE,4BAAA;EAnhCF;;EAshCA;IACE,4BAAA;EAphCF;;EAuhCA;IACE,4BAAA;EArhCF;;EAwhCA;IACE,4BAAA;EAthCF;;EAyhCA;IACE,4BAAA;EAvhCF;;EA0hCA;IACE,4BAAA;EAxhCF;;EA2hCA;IACE,4BAAA;EAzhCF;;EA4hCA;IACE,4BAAA;EA1hCF;;EA6hCA;IACE,4BAAA;EA3hCF;;EA8hCA;IACE,4BAAA;EA5hCF;;EA+hCA;IACE,4BAAA;EA7hCF;;EAgiCA;IACE,4BAAA;EA9hCF;;EAiiCA;IACE,4BAAA;EA/hCF;;EAkiCA;IACE,4BAAA;EAhiCF;;EAmiCA;IACE,4BAAA;EAjiCF;;EAoiCA;IACE,4BAAA;EAliCF;;EAqiCA;IACE,4BAAA;EAniCF;;EAsiCA;IACE,4BAAA;EApiCF;;EAuiCA;IACE,4BAAA;EAriCF;;EAwiCA;IACE,4BAAA;EAtiCF;;EAyiCA;IACE,4BAAA;EAviCF;;EA0iCA;IACE,4BAAA;EAxiCF;;EA2iCA;IACE,4BAAA;EAziCF;;EA4iCA;IACE,4BAAA;EA1iCF;;EA6iCA;IACE,4BAAA;EA3iCF;;EA8iCA;IACE,4BAAA;EA5iCF;;EA+iCA;IACE,4BAAA;EA7iCF;;EAgjCA;IACE,4BAAA;EA9iCF;;EAijCA;IACE,4BAAA;EA/iCF;;EAkjCA;IACE,4BAAA;EAhjCF;;EAmjCA;IACE,4BAAA;EAjjCF;;EAojCA;IACE,4BAAA;EAljCF;;EAqjCA;IACE,4BAAA;EAnjCF;;EAsjCA;IACE,4BAAA;EApjCF;;EAujCA;IACE,4BAAA;EArjCF;;EAwjCA;IACE,4BAAA;EAtjCF;;EAyjCA;IACE,4BAAA;EAvjCF;;EA0jCA;IACE,4BAAA;EAxjCF;;EA2jCA;IACE,4BAAA;EAzjCF;;EA4jCA;IACE,4BAAA;EA1jCF;;EA6jCA;IACE,4BAAA;EA3jCF;;EA8jCA;IACE,4BAAA;EA5jCF;;EA+jCA;IACE,4BAAA;EA7jCF;;EAgkCA;IACE,4BAAA;EA9jCF;;EAikCA;IACE,4BAAA;EA/jCF;;EAkkCA;IACE,4BAAA;EAhkCF;;EAmkCA;IACE,4BAAA;EAjkCF;;EAokCA;IACE,4BAAA;EAlkCF;;EAqkCA;IACE,4BAAA;EAnkCF;;EAskCA;IACE,4BAAA;EApkCF;;EAukCA;IACE,4BAAA;EArkCF;;EAwkCA;IACE,4BAAA;EAtkCF;;EAykCA;IACE,4BAAA;EAvkCF;;EA0kCA;IACE,4BAAA;EAxkCF;;EA2kCA;IACE,4BAAA;EAzkCF;;EA4kCA;IACE,4BAAA;EA1kCF;;EA6kCA;IACE,4BAAA;EA3kCF;;EA8kCA;IACE,4BAAA;EA5kCF;;EA+kCA;IACE,4BAAA;EA7kCF;;EAglCA;IACE,4BAAA;EA9kCF;;EAilCA;IACE,4BAAA;EA/kCF;;EAklCA;IACE,4BAAA;EAhlCF;;EAmlCA;IACE,4BAAA;EAjlCF;;EAolCA;IACE,4BAAA;EAllCF;;EAqlCA;IACE,4BAAA;EAnlCF;;EAslCA;IACE,4BAAA;EAplCF;;EAulCA;IACE,4BAAA;EArlCF;;EAwlCA;IACE,4BAAA;EAtlCF;;EAylCA;IACE,4BAAA;EAvlCF;;EA0lCA;IACE,4BAAA;EAxlCF;;EA2lCA;IACE,4BAAA;EAzlCF;;EA4lCA;IACE,4BAAA;EA1lCF;;EA6lCA;IACE,4BAAA;EA3lCF;;EA8lCA;IACE,4BAAA;EA5lCF;;EA+lCA;IACE,4BAAA;EA7lCF;;EAgmCA;IACE,4BAAA;EA9lCF;;EAimCA;IACE,4BAAA;EA/lCF;;EAkmCA;IACE,4BAAA;EAhmCF;;EAmmCA;IACE,4BAAA;EAjmCF;;EAomCA;IACE,4BAAA;EAlmCF;;EAqmCA;IACE,4BAAA;EAnmCF;;EAsmCA;IACE,kCAAA;IACA,8FAAA;EApmCF;;EAumCA;IACE,mCAAA;IACA,oGAAA;EArmCF;;EAwmCA;IACE,2BAAA;IACA,8FAAA;EAtmCF;;EAymCA;IACE,2BAAA;IACA,oGAAA;EAvmCF;;EA0mCA;IACE,8BAAA;IACA,oGAAA;EAxmCF;;EA2mCA;IACE,8BAAA;IACA,oGAAA;EAzmCF;;EA4mCA;IACE,8BAAA;IACA,oGAAA;EA1mCF;;EA6mCA;IACE,8BAAA;IACA,oGAAA;EA3mCF;;EA8mCA;IACE,8BAAA;IACA,oGAAA;EA5mCF;;EA+mCA;IACE,8BAAA;IACA,oGAAA;EA7mCF;;EAgnCA;IACE,8BAAA;IACA,kGAAA;EA9mCF;;EAinCA;IACE,8BAAA;IACA,iGAAA;EA/mCF;;EAknCA;IACE,8BAAA;IACA,iGAAA;EAhnCF;;EAmnCA;IACE,8BAAA;IACA,oGAAA;EAjnCF;;EAonCA;IACE,8BAAA;IACA,oGAAA;EAlnCF;;EAqnCA;IACE,8BAAA;IACA,oGAAA;EAnnCF;;EAsnCA;IACE,8BAAA;IACA,oGAAA;EApnCF;;EAunCA;IACE,8BAAA;IACA,oGAAA;EArnCF;;EAwnCA;IACE,8BAAA;IACA,kGAAA;EAtnCF;;EAynCA;IACE,8BAAA;IACA,kGAAA;EAvnCF;;EA0nCA;IACE,8BAAA;IACA,kGAAA;EAxnCF;;EA2nCA;IACE,8BAAA;IACA,kGAAA;EAznCF;;EA4nCA;IACE,8BAAA;IACA,oGAAA;EA1nCF;;EA6nCA;IACE,8BAAA;IACA,oGAAA;EA3nCF;;EA8nCA;IACE,8BAAA;IACA,oGAAA;EA5nCF;;EA+nCA;IACE,8BAAA;IACA,mGAAA;EA7nCF;;EAgoCA;IACE,8BAAA;IACA,mGAAA;EA9nCF;;EAioCA;IACE,8BAAA;IACA,mGAAA;EA/nCF;;EAkoCA;IACE,8BAAA;IACA,kGAAA;EAhoCF;;EAmoCA;IACE,8BAAA;IACA,kGAAA;EAjoCF;;EAooCA;IACE,8BAAA;IACA,kGAAA;EAloCF;;EAqoCA;IACE,8BAAA;IACA,oGAAA;EAnoCF;;EAsoCA;IACE,8BAAA;IACA,oGAAA;EApoCF;;EAuoCA;IACE,8BAAA;IACA,oGAAA;EAroCF;;EAwoCA;IACE,8BAAA;IACA,mGAAA;EAtoCF;;EAyoCA;IACE,8BAAA;IACA,mGAAA;EAvoCF;;EA0oCA;IACE,8BAAA;IACA,mGAAA;EAxoCF;;EA2oCA;IACE,8BAAA;IACA,mGAAA;EAzoCF;;EA4oCA;IACE,8BAAA;IACA,kGAAA;EA1oCF;;EA6oCA;IACE,8BAAA;IACA,kGAAA;EA3oCF;;EA8oCA;IACE,8BAAA;IACA,oGAAA;EA5oCF;;EA+oCA;IACE,8BAAA;IACA,oGAAA;EA7oCF;;EAgpCA;IACE,8BAAA;IACA,oGAAA;EA9oCF;;EAipCA;IACE,8BAAA;IACA,oGAAA;EA/oCF;;EAkpCA;IACE,8BAAA;IACA,mGAAA;EAhpCF;;EAmpCA;IACE,8BAAA;IACA,mGAAA;EAjpCF;;EAopCA;IACE,8BAAA;IACA,kGAAA;EAlpCF;;EAqpCA;IACE,8BAAA;IACA,kGAAA;EAnpCF;;EAspCA;IACE,8BAAA;IACA,iGAAA;EAppCF;;EAupCA;IACE,8BAAA;IACA,oGAAA;EArpCF;;EAwpCA;IACE,8BAAA;IACA,oGAAA;EAtpCF;;EAypCA;IACE,8BAAA;IACA,oGAAA;EAvpCF;;EA0pCA;IACE,8BAAA;IACA,mGAAA;EAxpCF;;EA2pCA;IACE,8BAAA;IACA,mGAAA;EAzpCF;;EA4pCA;IACE,8BAAA;IACA,mGAAA;EA1pCF;;EA6pCA;IACE,8BAAA;IACA,mGAAA;EA3pCF;;EA8pCA;IACE,8BAAA;IACA,iGAAA;EA5pCF;;EA+pCA;IACE,8BAAA;IACA,iGAAA;EA7pCF;;EAgqCA;IACE,8BAAA;IACA,oGAAA;EA9pCF;;EAiqCA;IACE,8BAAA;IACA,oGAAA;EA/pCF;;EAkqCA;IACE,8BAAA;IACA,oGAAA;EAhqCF;;EAmqCA;IACE,8BAAA;IACA,mGAAA;EAjqCF;;EAoqCA;IACE,8BAAA;IACA,mGAAA;EAlqCF;;EAqqCA;IACE,8BAAA;IACA,mGAAA;EAnqCF;;EAsqCA;IACE,8BAAA;IACA,mGAAA;EApqCF;;EAuqCA;IACE,8BAAA;IACA,kGAAA;EArqCF;;EAwqCA;IACE,8BAAA;IACA,kGAAA;EAtqCF;;EAyqCA;IACE,8BAAA;IACA,oGAAA;EAvqCF;;EA0qCA;IACE,8BAAA;IACA,oGAAA;EAxqCF;;EA2qCA;IACE,8BAAA;IACA,oGAAA;EAzqCF;;EA4qCA;IACE,8BAAA;IACA,oGAAA;EA1qCF;;EA6qCA;IACE,8BAAA;IACA,oGAAA;EA3qCF;;EA8qCA;IACE,8BAAA;IACA,mGAAA;EA5qCF;;EA+qCA;IACE,8BAAA;IACA,kGAAA;EA7qCF;;EAgrCA;IACE,8BAAA;IACA,kGAAA;EA9qCF;;EAirCA;IACE,8BAAA;IACA,kGAAA;EA/qCF;;EAkrCA;IACE,8BAAA;IACA,oGAAA;EAhrCF;;EAmrCA;IACE,8BAAA;IACA,oGAAA;EAjrCF;;EAorCA;IACE,8BAAA;IACA,oGAAA;EAlrCF;;EAqrCA;IACE,8BAAA;IACA,oGAAA;EAnrCF;;EAsrCA;IACE,8BAAA;IACA,oGAAA;EAprCF;;EAurCA;IACE,8BAAA;IACA,mGAAA;EArrCF;;EAwrCA;IACE,8BAAA;IACA,mGAAA;EAtrCF;;EAyrCA;IACE,8BAAA;IACA,kGAAA;EAvrCF;;EA0rCA;IACE,8BAAA;IACA,kGAAA;EAxrCF;;EA2rCA;IACE,8BAAA;IACA,oGAAA;EAzrCF;;EA4rCA;IACE,8BAAA;IACA,oGAAA;EA1rCF;;EA6rCA;IACE,8BAAA;IACA,oGAAA;EA3rCF;;EA8rCA;IACE,8BAAA;IACA,oGAAA;EA5rCF;;EA+rCA;IACE,8BAAA;IACA,oGAAA;EA7rCF;;EAgsCA;IACE,8BAAA;IACA,mGAAA;EA9rCF;;EAisCA;IACE,8BAAA;IACA,mGAAA;EA/rCF;;EAksCA;IACE,8BAAA;IACA,mGAAA;EAhsCF;;EAmsCA;IACE,8BAAA;IACA,kGAAA;EAjsCF;;EAosCA;IACE,iCAAA;IACA,yHAAA;EAlsCF;;EAqsCA;IACE,kCAAA;IACA,+HAAA;EAnsCF;;EAssCA;IACE,0BAAA;IACA,yHAAA;EApsCF;;EAusCA;IACE,0BAAA;IACA,+HAAA;EArsCF;;EAwsCA;IACE,6BAAA;IACA,+HAAA;EAtsCF;;EAysCA;IACE,6BAAA;IACA,+HAAA;EAvsCF;;EA0sCA;IACE,6BAAA;IACA,+HAAA;EAxsCF;;EA2sCA;IACE,6BAAA;IACA,+HAAA;EAzsCF;;EA4sCA;IACE,6BAAA;IACA,+HAAA;EA1sCF;;EA6sCA;IACE,6BAAA;IACA,+HAAA;EA3sCF;;EA8sCA;IACE,6BAAA;IACA,6HAAA;EA5sCF;;EA+sCA;IACE,6BAAA;IACA,4HAAA;EA7sCF;;EAgtCA;IACE,6BAAA;IACA,4HAAA;EA9sCF;;EAitCA;IACE,6BAAA;IACA,+HAAA;EA/sCF;;EAktCA;IACE,6BAAA;IACA,+HAAA;EAhtCF;;EAmtCA;IACE,6BAAA;IACA,+HAAA;EAjtCF;;EAotCA;IACE,6BAAA;IACA,+HAAA;EAltCF;;EAqtCA;IACE,6BAAA;IACA,+HAAA;EAntCF;;EAstCA;IACE,6BAAA;IACA,6HAAA;EAptCF;;EAutCA;IACE,6BAAA;IACA,6HAAA;EArtCF;;EAwtCA;IACE,6BAAA;IACA,6HAAA;EAttCF;;EAytCA;IACE,6BAAA;IACA,6HAAA;EAvtCF;;EA0tCA;IACE,6BAAA;IACA,+HAAA;EAxtCF;;EA2tCA;IACE,6BAAA;IACA,+HAAA;EAztCF;;EA4tCA;IACE,6BAAA;IACA,+HAAA;EA1tCF;;EA6tCA;IACE,6BAAA;IACA,8HAAA;EA3tCF;;EA8tCA;IACE,6BAAA;IACA,8HAAA;EA5tCF;;EA+tCA;IACE,6BAAA;IACA,8HAAA;EA7tCF;;EAguCA;IACE,6BAAA;IACA,6HAAA;EA9tCF;;EAiuCA;IACE,6BAAA;IACA,6HAAA;EA/tCF;;EAkuCA;IACE,6BAAA;IACA,6HAAA;EAhuCF;;EAmuCA;IACE,6BAAA;IACA,+HAAA;EAjuCF;;EAouCA;IACE,6BAAA;IACA,+HAAA;EAluCF;;EAquCA;IACE,6BAAA;IACA,+HAAA;EAnuCF;;EAsuCA;IACE,6BAAA;IACA,8HAAA;EApuCF;;EAuuCA;IACE,6BAAA;IACA,8HAAA;EAruCF;;EAwuCA;IACE,6BAAA;IACA,8HAAA;EAtuCF;;EAyuCA;IACE,6BAAA;IACA,8HAAA;EAvuCF;;EA0uCA;IACE,6BAAA;IACA,6HAAA;EAxuCF;;EA2uCA;IACE,6BAAA;IACA,6HAAA;EAzuCF;;EA4uCA;IACE,6BAAA;IACA,+HAAA;EA1uCF;;EA6uCA;IACE,6BAAA;IACA,+HAAA;EA3uCF;;EA8uCA;IACE,6BAAA;IACA,+HAAA;EA5uCF;;EA+uCA;IACE,6BAAA;IACA,+HAAA;EA7uCF;;EAgvCA;IACE,6BAAA;IACA,8HAAA;EA9uCF;;EAivCA;IACE,6BAAA;IACA,8HAAA;EA/uCF;;EAkvCA;IACE,6BAAA;IACA,6HAAA;EAhvCF;;EAmvCA;IACE,6BAAA;IACA,6HAAA;EAjvCF;;EAovCA;IACE,6BAAA;IACA,4HAAA;EAlvCF;;EAqvCA;IACE,6BAAA;IACA,+HAAA;EAnvCF;;EAsvCA;IACE,6BAAA;IACA,+HAAA;EApvCF;;EAuvCA;IACE,6BAAA;IACA,+HAAA;EArvCF;;EAwvCA;IACE,6BAAA;IACA,8HAAA;EAtvCF;;EAyvCA;IACE,6BAAA;IACA,8HAAA;EAvvCF;;EA0vCA;IACE,6BAAA;IACA,8HAAA;EAxvCF;;EA2vCA;IACE,6BAAA;IACA,8HAAA;EAzvCF;;EA4vCA;IACE,6BAAA;IACA,4HAAA;EA1vCF;;EA6vCA;IACE,6BAAA;IACA,4HAAA;EA3vCF;;EA8vCA;IACE,6BAAA;IACA,+HAAA;EA5vCF;;EA+vCA;IACE,6BAAA;IACA,+HAAA;EA7vCF;;EAgwCA;IACE,6BAAA;IACA,+HAAA;EA9vCF;;EAiwCA;IACE,6BAAA;IACA,8HAAA;EA/vCF;;EAkwCA;IACE,6BAAA;IACA,8HAAA;EAhwCF;;EAmwCA;IACE,6BAAA;IACA,8HAAA;EAjwCF;;EAowCA;IACE,6BAAA;IACA,8HAAA;EAlwCF;;EAqwCA;IACE,6BAAA;IACA,6HAAA;EAnwCF;;EAswCA;IACE,6BAAA;IACA,6HAAA;EApwCF;;EAuwCA;IACE,6BAAA;IACA,+HAAA;EArwCF;;EAwwCA;IACE,6BAAA;IACA,+HAAA;EAtwCF;;EAywCA;IACE,6BAAA;IACA,+HAAA;EAvwCF;;EA0wCA;IACE,6BAAA;IACA,+HAAA;EAxwCF;;EA2wCA;IACE,6BAAA;IACA,+HAAA;EAzwCF;;EA4wCA;IACE,6BAAA;IACA,8HAAA;EA1wCF;;EA6wCA;IACE,6BAAA;IACA,6HAAA;EA3wCF;;EA8wCA;IACE,6BAAA;IACA,6HAAA;EA5wCF;;EA+wCA;IACE,6BAAA;IACA,6HAAA;EA7wCF;;EAgxCA;IACE,6BAAA;IACA,+HAAA;EA9wCF;;EAixCA;IACE,6BAAA;IACA,+HAAA;EA/wCF;;EAkxCA;IACE,6BAAA;IACA,+HAAA;EAhxCF;;EAmxCA;IACE,6BAAA;IACA,+HAAA;EAjxCF;;EAoxCA;IACE,6BAAA;IACA,+HAAA;EAlxCF;;EAqxCA;IACE,6BAAA;IACA,8HAAA;EAnxCF;;EAsxCA;IACE,6BAAA;IACA,8HAAA;EApxCF;;EAuxCA;IACE,6BAAA;IACA,6HAAA;EArxCF;;EAwxCA;IACE,6BAAA;IACA,6HAAA;EAtxCF;;EAyxCA;IACE,6BAAA;IACA,+HAAA;EAvxCF;;EA0xCA;IACE,6BAAA;IACA,+HAAA;EAxxCF;;EA2xCA;IACE,6BAAA;IACA,+HAAA;EAzxCF;;EA4xCA;IACE,6BAAA;IACA,+HAAA;EA1xCF;;EA6xCA;IACE,6BAAA;IACA,+HAAA;EA3xCF;;EA8xCA;IACE,6BAAA;IACA,8HAAA;EA5xCF;;EA+xCA;IACE,6BAAA;IACA,8HAAA;EA7xCF;;EAgyCA;IACE,6BAAA;IACA,8HAAA;EA9xCF;;EAiyCA;IACE,6BAAA;IACA,6HAAA;EA/xCF;;EAkyCA;IACE,gCAAA;EAhyCF;;EAmyCA;IACE,iCAAA;EAjyCF;;EAoyCA;IACE,yBAAA;EAlyCF;;EAqyCA;IACE,yBAAA;EAnyCF;;EAsyCA;IACE,4BAAA;EApyCF;;EAuyCA;IACE,4BAAA;EAryCF;;EAwyCA;IACE,4BAAA;EAtyCF;;EAyyCA;IACE,4BAAA;EAvyCF;;EA0yCA;IACE,4BAAA;EAxyCF;;EA2yCA;IACE,4BAAA;EAzyCF;;EA4yCA;IACE,4BAAA;EA1yCF;;EA6yCA;IACE,4BAAA;EA3yCF;;EA8yCA;IACE,4BAAA;EA5yCF;;EA+yCA;IACE,4BAAA;EA7yCF;;EAgzCA;IACE,4BAAA;EA9yCF;;EAizCA;IACE,4BAAA;EA/yCF;;EAkzCA;IACE,4BAAA;EAhzCF;;EAmzCA;IACE,4BAAA;EAjzCF;;EAozCA;IACE,4BAAA;EAlzCF;;EAqzCA;IACE,4BAAA;EAnzCF;;EAszCA;IACE,4BAAA;EApzCF;;EAuzCA;IACE,4BAAA;EArzCF;;EAwzCA;IACE,4BAAA;EAtzCF;;EAyzCA;IACE,4BAAA;EAvzCF;;EA0zCA;IACE,4BAAA;EAxzCF;;EA2zCA;IACE,4BAAA;EAzzCF;;EA4zCA;IACE,4BAAA;EA1zCF;;EA6zCA;IACE,4BAAA;EA3zCF;;EA8zCA;IACE,4BAAA;EA5zCF;;EA+zCA;IACE,4BAAA;EA7zCF;;EAg0CA;IACE,4BAAA;EA9zCF;;EAi0CA;IACE,4BAAA;EA/zCF;;EAk0CA;IACE,4BAAA;EAh0CF;;EAm0CA;IACE,4BAAA;EAj0CF;;EAo0CA;IACE,4BAAA;EAl0CF;;EAq0CA;IACE,4BAAA;EAn0CF;;EAs0CA;IACE,4BAAA;EAp0CF;;EAu0CA;IACE,4BAAA;EAr0CF;;EAw0CA;IACE,4BAAA;EAt0CF;;EAy0CA;IACE,4BAAA;EAv0CF;;EA00CA;IACE,4BAAA;EAx0CF;;EA20CA;IACE,4BAAA;EAz0CF;;EA40CA;IACE,4BAAA;EA10CF;;EA60CA;IACE,4BAAA;EA30CF;;EA80CA;IACE,4BAAA;EA50CF;;EA+0CA;IACE,4BAAA;EA70CF;;EAg1CA;IACE,4BAAA;EA90CF;;EAi1CA;IACE,4BAAA;EA/0CF;;EAk1CA;IACE,4BAAA;EAh1CF;;EAm1CA;IACE,4BAAA;EAj1CF;;EAo1CA;IACE,4BAAA;EAl1CF;;EAq1CA;IACE,4BAAA;EAn1CF;;EAs1CA;IACE,4BAAA;EAp1CF;;EAu1CA;IACE,4BAAA;EAr1CF;;EAw1CA;IACE,4BAAA;EAt1CF;;EAy1CA;IACE,4BAAA;EAv1CF;;EA01CA;IACE,4BAAA;EAx1CF;;EA21CA;IACE,4BAAA;EAz1CF;;EA41CA;IACE,4BAAA;EA11CF;;EA61CA;IACE,4BAAA;EA31CF;;EA81CA;IACE,4BAAA;EA51CF;;EA+1CA;IACE,4BAAA;EA71CF;;EAg2CA;IACE,4BAAA;EA91CF;;EAi2CA;IACE,4BAAA;EA/1CF;;EAk2CA;IACE,4BAAA;EAh2CF;;EAm2CA;IACE,4BAAA;EAj2CF;;EAo2CA;IACE,4BAAA;EAl2CF;;EAq2CA;IACE,4BAAA;EAn2CF;;EAs2CA;IACE,4BAAA;EAp2CF;;EAu2CA;IACE,4BAAA;EAr2CF;;EAw2CA;IACE,4BAAA;EAt2CF;;EAy2CA;IACE,4BAAA;EAv2CF;;EA02CA;IACE,4BAAA;EAx2CF;;EA22CA;IACE,4BAAA;EAz2CF;;EA42CA;IACE,4BAAA;EA12CF;;EA62CA;IACE,4BAAA;EA32CF;;EA82CA;IACE,4BAAA;EA52CF;;EA+2CA;IACE,4BAAA;EA72CF;;EAg3CA;IACE,4BAAA;EA92CF;;EAi3CA;IACE,4BAAA;EA/2CF;;EAk3CA;IACE,4BAAA;EAh3CF;;EAm3CA;IACE,4BAAA;EAj3CF;;EAo3CA;IACE,4BAAA;EAl3CF;;EAq3CA;IACE,4BAAA;EAn3CF;;EAs3CA;IACE,4BAAA;EAp3CF;;EAu3CA;IACE,4BAAA;EAr3CF;;EAw3CA;IACE,4BAAA;EAt3CF;;EAy3CA;IACE,4BAAA;EAv3CF;;EA03CA;IACE,4BAAA;EAx3CF;;EA23CA;IACE,4BAAA;EAz3CF;;EA43CA;IACE,4BAAA;EA13CF;;EA63CA;IACE,4BAAA;EA33CF;;EA83CA;IACE,4BAAA;EA53CF;;EA+3CA;IACE,4BAAA;EA73CF;;EAg4CA;IACE,eAAA;EA93CF;;EAi4CA;IACE,kBAAA;EA/3CF;;EAk4CA;IACE,iBAAA;EAh4CF;;EAm4CA;IACE,kBAAA;EAj4CF;;EAo4CA;IACE,eAAA;EAl4CF;;EAq4CA;IACE,eAAA;EAn4CF;;EAs4CA;IACE,kBAAA;EAp4CF;;EAu4CA;IACE,iBAAA;EAr4CF;;EAw4CA;IACE,kBAAA;EAt4CF;;EAy4CA;IACE,eAAA;EAv4CF;;EA04CA;IACE,eAAA;EAx4CF;;EA24CA;IACE,kBAAA;EAz4CF;;EA44CA;IACE,iBAAA;EA14CF;;EA64CA;IACE,kBAAA;EA34CF;;EA84CA;IACE,eAAA;EA54CF;;EA+4CA;IACE,2BAAA;EA74CF;;EAg5CA;IACE,2BAAA;EA94CF;;EAi5CA;IACE,yBAAA;EA/4CF;;EAk5CA;IACE,gCAAA;EAh5CF;;EAm5CA;IACE,6BAAA;EAj5CF;;EAo5CA;IACE,0BAAA;EAl5CF;;EAq5CA;IACE,iCAAA;EAn5CF;;EAs5CA;IACE,8BAAA;EAp5CF;;EAu5CA;IACE,wBAAA;EAr5CF;;EAw5CA;IACE,yBAAA;EAt5CF;;EAy5CA;IACE,4BAAA;EAv5CF;;EA05CA;IACE,2BAAA;EAx5CF;;EA25CA;IACE,2BAAA;EAz5CF;;EA45CA;IACE,wBAAA;EA15CF;;EA65CA;IACE,wBAAA;EA35CF;;EA85CA;IACE,qBAAA;EA55CF;;EA+5CA;IACE,sBAAA;EA75CF;;EAg6CA;IACE,wBAAA;EA95CF;;EAi6CA;IACE,yBAAA;EA/5CF;;EAk6CA;IACE,yBAAA;EAh6CF;;EAm6CA;IACE,yBAAA;EAj6CF;;EAo6CA;IACE,0BAAA;EAl6CF;;EAq6CA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EAn6CF;;EAs6CA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAp6CF;;EAu6CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr6CF;;EAw6CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt6CF;;EAy6CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv6CF;;EA06CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx6CF;;EA26CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz6CF;;EA46CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA16CF;;EA66CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA36CF;;EA86CA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA56CF;;EA+6CA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA76CF;;EAg7CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA96CF;;EAi7CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/6CF;;EAk7CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh7CF;;EAm7CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj7CF;;EAo7CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl7CF;;EAq7CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn7CF;;EAs7CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAp7CF;;EAu7CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAr7CF;;EAw7CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAt7CF;;EAy7CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv7CF;;EA07CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx7CF;;EA27CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz7CF;;EA47CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA17CF;;EA67CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA37CF;;EA87CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA57CF;;EA+7CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA77CF;;EAg8CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA97CF;;EAi8CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/7CF;;EAk8CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh8CF;;EAm8CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj8CF;;EAo8CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl8CF;;EAq8CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn8CF;;EAs8CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAp8CF;;EAu8CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAr8CF;;EAw8CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAt8CF;;EAy8CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAv8CF;;EA08CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAx8CF;;EA28CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz8CF;;EA48CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA18CF;;EA68CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA38CF;;EA88CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA58CF;;EA+8CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA78CF;;EAg9CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA98CF;;EAi9CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/8CF;;EAk9CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAh9CF;;EAm9CA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAj9CF;;EAo9CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl9CF;;EAq9CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn9CF;;EAs9CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp9CF;;EAu9CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAr9CF;;EAw9CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAt9CF;;EAy9CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAv9CF;;EA09CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx9CF;;EA29CA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAz9CF;;EA49CA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA19CF;;EA69CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA39CF;;EA89CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA59CF;;EA+9CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA79CF;;EAg+CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA99CF;;EAi+CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/9CF;;EAk+CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAh+CF;;EAm+CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj+CF;;EAo+CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl+CF;;EAq+CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn+CF;;EAs+CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp+CF;;EAu+CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr+CF;;EAw+CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt+CF;;EAy+CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv+CF;;EA0+CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx+CF;;EA2+CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz+CF;;EA4+CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1+CF;;EA6+CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3+CF;;EA8+CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5+CF;;EA++CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7+CF;;EAg/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9+CF;;EAi/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/+CF;;EAk/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh/CF;;EAm/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj/CF;;EAo/CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl/CF;;EAq/CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn/CF;;EAs/CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAp/CF;;EAu/CA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAr/CF;;EAw/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt/CF;;EAy/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv/CF;;EA0/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx/CF;;EA2/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz/CF;;EA4/CA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1/CF;;EA6/CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3/CF;;EA8/CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5/CF;;EA+/CA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7/CF;;EAggDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9/CF;;EAigDA;IACE,yBAAA;EA//CF;;EAkgDA;IACE,0BAAA;EAhgDF;;EAmgDA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EAjgDF;;EAogDA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAlgDF;;EAqgDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAngDF;;EAsgDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApgDF;;EAugDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArgDF;;EAwgDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtgDF;;EAygDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvgDF;;EA0gDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxgDF;;EA2gDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzgDF;;EA4gDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA1gDF;;EA6gDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA3gDF;;EA8gDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5gDF;;EA+gDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7gDF;;EAghDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9gDF;;EAihDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/gDF;;EAkhDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhhDF;;EAmhDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjhDF;;EAohDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAlhDF;;EAqhDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnhDF;;EAshDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAphDF;;EAuhDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArhDF;;EAwhDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAthDF;;EAyhDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvhDF;;EA0hDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxhDF;;EA2hDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzhDF;;EA4hDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1hDF;;EA6hDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3hDF;;EA8hDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5hDF;;EA+hDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7hDF;;EAgiDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9hDF;;EAiiDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/hDF;;EAkiDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhiDF;;EAmiDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjiDF;;EAoiDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAliDF;;EAqiDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAniDF;;EAsiDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApiDF;;EAuiDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAriDF;;EAwiDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtiDF;;EAyiDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAviDF;;EA0iDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxiDF;;EA2iDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAziDF;;EA4iDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1iDF;;EA6iDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3iDF;;EA8iDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5iDF;;EA+iDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7iDF;;EAgjDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9iDF;;EAijDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA/iDF;;EAkjDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhjDF;;EAmjDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjjDF;;EAojDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAljDF;;EAqjDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnjDF;;EAsjDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApjDF;;EAujDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArjDF;;EAwjDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtjDF;;EAyjDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAvjDF;;EA0jDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAxjDF;;EA2jDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzjDF;;EA4jDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1jDF;;EA6jDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3jDF;;EA8jDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5jDF;;EA+jDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7jDF;;EAgkDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9jDF;;EAikDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/jDF;;EAkkDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhkDF;;EAmkDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjkDF;;EAokDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlkDF;;EAqkDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnkDF;;EAskDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApkDF;;EAukDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArkDF;;EAwkDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtkDF;;EAykDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvkDF;;EA0kDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxkDF;;EA2kDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzkDF;;EA4kDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1kDF;;EA6kDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3kDF;;EA8kDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5kDF;;EA+kDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7kDF;;EAglDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9kDF;;EAilDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/kDF;;EAklDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhlDF;;EAmlDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjlDF;;EAolDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAllDF;;EAqlDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnlDF;;EAslDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAplDF;;EAulDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArlDF;;EAwlDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtlDF;;EAylDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvlDF;;EA0lDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxlDF;;EA2lDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzlDF;;EA4lDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1lDF;;EA6lDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3lDF;;EA8lDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5lDF;;EA+lDA;IACE,yBAAA;EA7lDF;;EAgmDA;IACE,0BAAA;EA9lDF;;EAimDA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EA/lDF;;EAkmDA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAhmDF;;EAmmDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjmDF;;EAomDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlmDF;;EAqmDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnmDF;;EAsmDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApmDF;;EAumDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArmDF;;EAwmDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtmDF;;EAymDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvmDF;;EA0mDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAxmDF;;EA2mDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAzmDF;;EA4mDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1mDF;;EA6mDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3mDF;;EA8mDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5mDF;;EA+mDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7mDF;;EAgnDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9mDF;;EAinDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/mDF;;EAknDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhnDF;;EAmnDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjnDF;;EAonDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAlnDF;;EAqnDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnnDF;;EAsnDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApnDF;;EAunDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArnDF;;EAwnDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtnDF;;EAynDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvnDF;;EA0nDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxnDF;;EA2nDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAznDF;;EA4nDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1nDF;;EA6nDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3nDF;;EA8nDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5nDF;;EA+nDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7nDF;;EAgoDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9nDF;;EAioDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/nDF;;EAkoDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhoDF;;EAmoDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjoDF;;EAooDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAloDF;;EAqoDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnoDF;;EAsoDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EApoDF;;EAuoDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAroDF;;EAwoDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtoDF;;EAyoDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvoDF;;EA0oDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxoDF;;EA2oDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzoDF;;EA4oDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1oDF;;EA6oDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3oDF;;EA8oDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5oDF;;EA+oDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA7oDF;;EAgpDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9oDF;;EAipDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/oDF;;EAkpDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhpDF;;EAmpDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjpDF;;EAopDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlpDF;;EAqpDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnpDF;;EAspDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAppDF;;EAupDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EArpDF;;EAwpDA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAtpDF;;EAypDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvpDF;;EA0pDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxpDF;;EA2pDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzpDF;;EA4pDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1pDF;;EA6pDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3pDF;;EA8pDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5pDF;;EA+pDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7pDF;;EAgqDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9pDF;;EAiqDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/pDF;;EAkqDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhqDF;;EAmqDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjqDF;;EAoqDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlqDF;;EAqqDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnqDF;;EAsqDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApqDF;;EAuqDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArqDF;;EAwqDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtqDF;;EAyqDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvqDF;;EA0qDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxqDF;;EA2qDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzqDF;;EA4qDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1qDF;;EA6qDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3qDF;;EA8qDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5qDF;;EA+qDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7qDF;;EAgrDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9qDF;;EAirDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/qDF;;EAkrDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhrDF;;EAmrDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjrDF;;EAorDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlrDF;;EAqrDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnrDF;;EAsrDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAprDF;;EAurDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArrDF;;EAwrDA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtrDF;;EAyrDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvrDF;;EA0rDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxrDF;;EA2rDA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzrDF;;EA4rDA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1rDF;;EA6rDA;IACE,mBAAA;EA3rDF;;EA8rDA;IACE,sBAAA;EA5rDF;;EA+rDA;IACE,qBAAA;EA7rDF;;EAgsDA;IACE,sBAAA;EA9rDF;;EAisDA;IACE,mBAAA;EA/rDF;;EAksDA;IACE,mBAAA;EAhsDF;;EAmsDA;IACE,sBAAA;EAjsDF;;EAosDA;IACE,qBAAA;EAlsDF;;EAqsDA;IACE,sBAAA;EAnsDF;;EAssDA;IACE,mBAAA;EApsDF;;EAusDA;IACE,mBAAA;EArsDF;;EAwsDA;IACE,sBAAA;EAtsDF;;EAysDA;IACE,qBAAA;EAvsDF;;EA0sDA;IACE,sBAAA;EAxsDF;;EA2sDA;IACE,mBAAA;EAzsDF;;EA4sDA;IACE,gBAAA;EA1sDF;;EA6sDA;IACE,uBAAA;EA3sDF;;EA8sDA;IACE,sBAAA;EA5sDF;;EA+sDA;IACE,uBAAA;EA7sDF;;EAgtDA;IACE,qBAAA;EA9sDF;;EAitDA;IACE,sBAAA;EA/sDF;;EAktDA;IACE,mBAAA;EAhtDF;;EAmtDA;IACE,qBAAA;EAjtDF;;EAotDA;IACE,qBAAA;EAltDF;;EAqtDA;IACE,yBAAA;IACA,0BAAA;EAntDF;;EAstDA;IACE,0BAAA;IACA,6BAAA;EAptDF;;EAutDA;IACE,6BAAA;IACA,4BAAA;EArtDF;;EAwtDA;IACE,yBAAA;IACA,4BAAA;EAttDF;;EAytDA;IACE,gCAAA;IACA,iCAAA;EAvtDF;;EA0tDA;IACE,iCAAA;IACA,oCAAA;EAxtDF;;EA2tDA;IACE,oCAAA;IACA,mCAAA;EAztDF;;EA4tDA;IACE,gCAAA;IACA,mCAAA;EA1tDF;;EA6tDA;IACE,+BAAA;IACA,gCAAA;EA3tDF;;EA8tDA;IACE,gCAAA;IACA,mCAAA;EA5tDF;;EA+tDA;IACE,mCAAA;IACA,kCAAA;EA7tDF;;EAguDA;IACE,+BAAA;IACA,kCAAA;EA9tDF;;EAiuDA;IACE,gCAAA;IACA,iCAAA;EA/tDF;;EAkuDA;IACE,iCAAA;IACA,oCAAA;EAhuDF;;EAmuDA;IACE,oCAAA;IACA,mCAAA;EAjuDF;;EAouDA;IACE,gCAAA;IACA,mCAAA;EAluDF;;EAquDA;IACE,8BAAA;IACA,+BAAA;EAnuDF;;EAsuDA;IACE,+BAAA;IACA,kCAAA;EApuDF;;EAuuDA;IACE,kCAAA;IACA,iCAAA;EAruDF;;EAwuDA;IACE,8BAAA;IACA,iCAAA;EAtuDF;;EAyuDA;IACE,+BAAA;IACA,gCAAA;EAvuDF;;EA0uDA;IACE,gCAAA;IACA,mCAAA;EAxuDF;;EA2uDA;IACE,mCAAA;IACA,kCAAA;EAzuDF;;EA4uDA;IACE,+BAAA;IACA,kCAAA;EA1uDF;;EA6uDA;IACE,4BAAA;IACA,6BAAA;EA3uDF;;EA8uDA;IACE,6BAAA;IACA,gCAAA;EA5uDF;;EA+uDA;IACE,gCAAA;IACA,+BAAA;EA7uDF;;EAgvDA;IACE,4BAAA;IACA,+BAAA;EA9uDF;;EAivDA;IACE,8BAAA;IACA,+BAAA;EA/uDF;;EAkvDA;IACE,+BAAA;IACA,kCAAA;EAhvDF;;EAmvDA;IACE,kCAAA;IACA,iCAAA;EAjvDF;;EAovDA;IACE,8BAAA;IACA,iCAAA;EAlvDF;;EAqvDA;IACE,8BAAA;IACA,+BAAA;EAnvDF;;EAsvDA;IACE,+BAAA;IACA,kCAAA;EApvDF;;EAuvDA;IACE,kCAAA;IACA,iCAAA;EArvDF;;EAwvDA;IACE,8BAAA;IACA,iCAAA;EAtvDF;;EAyvDA;IACE,yBAAA;EAvvDF;;EA0vDA;IACE,0BAAA;EAxvDF;;EA2vDA;IACE,6BAAA;EAzvDF;;EA4vDA;IACE,4BAAA;EA1vDF;;EA6vDA;IACE,gCAAA;EA3vDF;;EA8vDA;IACE,iCAAA;EA5vDF;;EA+vDA;IACE,oCAAA;EA7vDF;;EAgwDA;IACE,mCAAA;EA9vDF;;EAiwDA;IACE,+BAAA;EA/vDF;;EAkwDA;IACE,gCAAA;EAhwDF;;EAmwDA;IACE,mCAAA;EAjwDF;;EAowDA;IACE,kCAAA;EAlwDF;;EAqwDA;IACE,gCAAA;EAnwDF;;EAswDA;IACE,iCAAA;EApwDF;;EAuwDA;IACE,oCAAA;EArwDF;;EAwwDA;IACE,mCAAA;EAtwDF;;EAywDA;IACE,8BAAA;EAvwDF;;EA0wDA;IACE,+BAAA;EAxwDF;;EA2wDA;IACE,kCAAA;EAzwDF;;EA4wDA;IACE,iCAAA;EA1wDF;;EA6wDA;IACE,+BAAA;EA3wDF;;EA8wDA;IACE,gCAAA;EA5wDF;;EA+wDA;IACE,mCAAA;EA7wDF;;EAgxDA;IACE,kCAAA;EA9wDF;;EAixDA;IACE,4BAAA;EA/wDF;;EAkxDA;IACE,6BAAA;EAhxDF;;EAmxDA;IACE,gCAAA;EAjxDF;;EAoxDA;IACE,+BAAA;EAlxDF;;EAqxDA;IACE,8BAAA;EAnxDF;;EAsxDA;IACE,+BAAA;EApxDF;;EAuxDA;IACE,kCAAA;EArxDF;;EAwxDA;IACE,iCAAA;EAtxDF;;EAyxDA;IACE,8BAAA;EAvxDF;;EA0xDA;IACE,+BAAA;EAxxDF;;EA2xDA;IACE,kCAAA;EAzxDF;;EA4xDA;IACE,iCAAA;EA1xDF;;EA6xDA;IACE,mBAAA;EA3xDF;;EA8xDA;IACE,oBAAA;EA5xDF;;EA+xDA;IACE,oBAAA;EA7xDF;;EAgyDA;IACE,oBAAA;EA9xDF;;EAiyDA;IACE,kBAAA;EA/xDF;;EAkyDA;IACE,eAAA;EAhyDF;;EAmyDA;IACE,iBAAA;EAjyDF;;EAoyDA;IACE,iBAAA;EAlyDF;;EAqyDA;IACE,iBAAA;EAnyDF;;EAsyDA;IACE,iBAAA;EApyDF;;EAuyDA;IACE,mBAAA;EAryDF;;EAwyDA;IACE,qBAAA;EAtyDF;;EAyyDA;IACE,sBAAA;EAvyDF;;EA0yDA;IACE,oBAAA;EAxyDF;;EA2yDA;IACE,qBAAA;EAzyDF;;EA4yDA;IACE,uBAAA;EA1yDF;;EA6yDA;IACE,wBAAA;EA3yDF;;EA8yDA;IACE,sBAAA;EA5yDF;;EA+yDA;IACE,qBAAA;EA7yDF;;EAgzDA;IACE,uBAAA;EA9yDF;;EAizDA;IACE,wBAAA;EA/yDF;;EAkzDA;IACE,sBAAA;EAhzDF;;EAmzDA;IACE,qBAAA;EAjzDF;;EAozDA;IACE,uBAAA;EAlzDF;;EAqzDA;IACE,wBAAA;EAnzDF;;EAszDA;IACE,sBAAA;EApzDF;;EAuzDA;IACE,qBAAA;EArzDF;;EAwzDA;IACE,uBAAA;EAtzDF;;EAyzDA;IACE,wBAAA;EAvzDF;;EA0zDA;IACE,sBAAA;EAxzDF;;EA2zDA;IACE,sBAAA;EAzzDF;;EA4zDA;IACE,uBAAA;EA1zDF;;EA6zDA;IACE,YAAA;EA3zDF;;EA8zDA;IACE,eAAA;EA5zDF;;EA+zDA;IACE,eAAA;EA7zDF;;EAg0DA;IACE,YAAA;EA9zDF;;EAi0DA;IACE,YAAA;EA/zDF;;EAk0DA;IACE,YAAA;EAh0DF;;EAm0DA;IACE,mBAAA;EAj0DF;;EAo0DA;IACE,cAAA;EAl0DF;;EAq0DA;IACE,qBAAA;EAn0DF;;EAs0DA;IACE,eAAA;EAp0DF;;EAu0DA;IACE,aAAA;EAr0DF;;EAw0DA;IACE,oBAAA;EAt0DF;;EAy0DA;IACE,cAAA;EAv0DF;;EA00DA;IACE,sBAAA;EAx0DF;;EA20DA;IACE,mBAAA;EAz0DF;;EA40DA;IACE,qBAAA;EA10DF;;EA60DA;IACE,2BAAA;EA30DF;;EA80DA;IACE,2BAAA;EA50DF;;EA+0DA;IACE,2BAAA;EA70DF;;EAg1DA;IACE,wBAAA;EA90DF;;EAi1DA;IACE,kBAAA;EA/0DF;;EAk1DA;IACE,kBAAA;EAh1DF;;EAm1DA;IACE,aAAA;EAj1DF;;EAo1DA;IACE,oBAAA;EAl1DF;;EAq1DA;IACE,iBAAA;EAn1DF;;EAs1DA;IACE,aAAA;EAp1DF;;EAu1DA;IACE,mBAAA;EAr1DF;;EAw1DA;IACE,2BAAA;EAt1DF;;EAy1DA;IACE,sBAAA;EAv1DF;;EA01DA;IACE,8BAAA;EAx1DF;;EA21DA;IACE,eAAA;EAz1DF;;EA41DA;IACE,uBAAA;EA11DF;;EA61DA;IACE,iBAAA;EA31DF;;EA81DA;IACE,iBAAA;EA51DF;;EA+1DA;IACE,kBAAA;EA71DF;;EAg2DA;IACE,gBAAA;EA91DF;;EAi2DA;IACE,mBAAA;EA/1DF;;EAk2DA;IACE,oBAAA;EAh2DF;;EAm2DA;IACE,qBAAA;EAj2DF;;EAo2DA;IACE,oBAAA;EAl2DF;;EAq2DA;IACE,kBAAA;EAn2DF;;EAs2DA;IACE,4BAAA;EAp2DF;;EAu2DA;IACE,2BAAA;EAr2DF;;EAw2DA;IACE,2BAAA;EAt2DF;;EAy2DA;IACE,sBAAA;EAv2DF;;EA02DA;IACE,gBAAA;EAx2DF;;EA22DA;IACE,iBAAA;EAz2DF;;EA42DA;IACE,eAAA;EA12DF;;EA62DA;IACE,kBAAA;EA32DF;;EA82DA;IACE,mBAAA;EA52DF;;EA+2DA;IACE,uBAAA;EA72DF;;EAg3DA;IACE,qBAAA;EA92DF;;EAi3DA;IACE,mBAAA;EA/2DF;;EAk3DA;IACE,qBAAA;EAh3DF;;EAm3DA;IACE,oBAAA;EAj3DF;;EAo3DA;IACE,qBAAA;EAl3DF;;EAq3DA;IACE,yBAAA;EAn3DF;;EAs3DA;IACE,uBAAA;EAp3DF;;EAu3DA;IACE,4BAAA;EAr3DF;;EAw3DA;IACE,2BAAA;EAt3DF;;EAy3DA;IACE,2BAAA;EAv3DF;;EA03DA;IACE,gBAAA;EAx3DF;;EA23DA;IACE,sBAAA;EAz3DF;;EA43DA;IACE,oBAAA;EA13DF;;EA63DA;IACE,kBAAA;EA33DF;;EA83DA;IACE,mBAAA;EA53DF;;EA+3DA;IACE,mBAAA;EA73DF;;EAg4DA;IACE,oBAAA;EA93DF;;EAi4DA;IACE,kBAAA;EA/3DF;;EAk4DA;IACE,qBAAA;EAh4DF;;EAm4DA;IACE,sBAAA;EAj4DF;;EAo4DA;IACE,2BAAA;EAl4DF;;EAq4DA;IACE,yBAAA;EAn4DF;;EAs4DA;IACE,uBAAA;EAp4DF;;EAu4DA;IACE,8BAAA;EAr4DF;;EAw4DA;IACE,6BAAA;EAt4DF;;EAy4DA;IACE,6BAAA;EAv4DF;;EA04DA;IACE,kBAAA;EAx4DF;;EA24DA;IACE,mBAAA;EAz4DF;;EA44DA;IACE,iBAAA;EA14DF;;EA64DA;IACE,oBAAA;EA34DF;;EA84DA;IACE,qBAAA;EA54DF;;EA+4DA;IACE,SAAA;EA74DF;;EAg5DA;IACE,cAAA;EA94DF;;EAi5DA;IACE,cAAA;EA/4DF;;EAk5DA;IACE,UAAA;EAh5DF;;EAm5DA;IACE,YAAA;EAj5DF;;EAo5DA;IACE,YAAA;EAl5DF;;EAq5DA;IACE,cAAA;EAn5DF;;EAs5DA;IACE,cAAA;EAp5DF;;EAu5DA;IACE,QAAA;EAr5DF;;EAw5DA;IACE,QAAA;EAt5DF;;EAy5DA;IACE,QAAA;EAv5DF;;EA05DA;IACE,QAAA;EAx5DF;;EA25DA;IACE,QAAA;EAz5DF;;EA45DA;IACE,QAAA;EA15DF;;EA65DA;IACE,QAAA;EA35DF;;EA85DA;IACE,QAAA;EA55DF;;EA+5DA;IACE,QAAA;EA75DF;;EAg6DA;IACE,SAAA;EA95DF;;EAi6DA;IACE,SAAA;EA/5DF;;EAk6DA;IACE,SAAA;EAh6DF;;EAm6DA;IACE,YAAA;EAj6DF;;EAo6DA;IACE,WAAA;EAl6DF;;EAq6DA;IACE,QAAA;EAn6DF;;EAs6DA;IACE,YAAA;EAp6DF;;EAu6DA;IACE,WAAA;EAr6DF;;EAw6DA;IACE,WAAA;EAt6DF;;EAy6DA;IACE,WAAA;IACA,cAAA;IACA,WAAA;EAv6DF;;EA06DA;IACE,WAAA;EAx6DF;;EA26DA;IACE,YAAA;EAz6DF;;EA46DA;IACE,WAAA;EA16DF;;EA66DA;IACE,WAAA;EA36DF;;EA86DA;IACE,6MAAA;EA56DF;;EA+6DA;IACE,8DAAA;EA76DF;;EAg7DA;IACE,iFAAA;EA96DF;;EAi7DA;IACE,gBAAA;EA/6DF;;EAk7DA;IACE,gBAAA;EAh7DF;;EAm7DA;IACE,gBAAA;EAj7DF;;EAo7DA;IACE,gBAAA;EAl7DF;;EAq7DA;IACE,gBAAA;EAn7DF;;EAs7DA;IACE,gBAAA;EAp7DF;;EAu7DA;IACE,gBAAA;EAr7DF;;EAw7DA;IACE,gBAAA;EAt7DF;;EAy7DA;IACE,gBAAA;EAv7DF;;EA07DA;IACE,gBAAA;EAx7DF;;EA27DA;IACE,gBAAA;EAz7DF;;EA47DA;IACE,gBAAA;EA17DF;;EA67DA;IACE,gBAAA;EA37DF;;EA87DA;IACE,gBAAA;EA57DF;;EA+7DA;IACE,gBAAA;EA77DF;;EAg8DA;IACE,gBAAA;EA97DF;;EAi8DA;IACE,gBAAA;EA/7DF;;EAk8DA;IACE,gBAAA;EAh8DF;;EAm8DA;IACE,gBAAA;EAj8DF;;EAo8DA;IACE,gBAAA;EAl8DF;;EAq8DA;IACE,gBAAA;EAn8DF;;EAs8DA;IACE,gBAAA;EAp8DF;;EAu8DA;IACE,gBAAA;EAr8DF;;EAw8DA;IACE,gBAAA;EAt8DF;;EAy8DA;IACE,gBAAA;EAv8DF;;EA08DA;IACE,gBAAA;EAx8DF;;EA28DA;IACE,gBAAA;EAz8DF;;EA48DA;IACE,SAAA;EA18DF;;EA68DA;IACE,eAAA;EA38DF;;EA88DA;IACE,cAAA;EA58DF;;EA+8DA;IACE,eAAA;EA78DF;;EAg9DA;IACE,YAAA;EA98DF;;EAi9DA;IACE,eAAA;EA/8DF;;EAk9DA;IACE,cAAA;EAh9DF;;EAm9DA;IACE,YAAA;EAj9DF;;EAo9DA;IACE,cAAA;EAl9DF;;EAq9DA;IACE,YAAA;EAn9DF;;EAs9DA;IACE,YAAA;EAp9DF;;EAu9DA;IACE,YAAA;EAr9DF;;EAw9DA;IACE,YAAA;EAt9DF;;EAy9DA;IACE,YAAA;EAv9DF;;EA09DA;IACE,aAAA;EAx9DF;;EA29DA;IACE,aAAA;EAz9DF;;EA49DA;IACE,aAAA;EA19DF;;EA69DA;IACE,aAAA;EA39DF;;EA89DA;IACE,YAAA;EA59DF;;EA+9DA;IACE,WAAA;EA79DF;;EAg+DA;IACE,YAAA;EA99DF;;EAi+DA;IACE,aAAA;EA/9DF;;EAk+DA;IACE,oBAAA;EAh+DF;;EAm+DA;IACE,kBAAA;EAj+DF;;EAo+DA;IACE,mBAAA;EAl+DF;;EAq+DA;IACE,eAAA;EAn+DF;;EAs+DA;IACE,mBAAA;EAp+DF;;EAu+DA;IACE,kBAAA;EAr+DF;;EAw+DA;IACE,mBAAA;EAt+DF;;EAy+DA;IACE,iBAAA;EAv+DF;;EA0+DA;IACE,mBAAA;EAx+DF;;EA2+DA;IACE,kBAAA;EAz+DF;;EA4+DA;IACE,eAAA;EA1+DF;;EA6+DA;IACE,eAAA;EA3+DF;;EA8+DA;IACE,oBAAA;EA5+DF;;EA++DA;IACE,iBAAA;EA7+DF;;EAg/DA;IACE,oBAAA;EA9+DF;;EAi/DA;IACE,mBAAA;EA/+DF;;EAk/DA;IACE,oBAAA;EAh/DF;;EAm/DA;IACE,iBAAA;EAj/DF;;EAo/DA;IACE,oBAAA;EAl/DF;;EAq/DA;IACE,mBAAA;EAn/DF;;EAs/DA;IACE,cAAA;EAp/DF;;EAu/DA;IACE,iBAAA;EAr/DF;;EAw/DA;IACE,kBAAA;EAt/DF;;EAy/DA;IACE,gBAAA;EAv/DF;;EA0/DA;IACE,kBAAA;EAx/DF;;EA2/DA;IACE,cAAA;EAz/DF;;EA4/DA;IACE,2BAAA;EA1/DF;;EA6/DA;IACE,4BAAA;EA3/DF;;EA8/DA;IACE,qBAAA;EA5/DF;;EA+/DA;IACE,qBAAA;EA7/DF;;EAggEA;IACE,wBAAA;EA9/DF;;EAigEA;IACE,SAAA;EA//DF;;EAkgEA;IACE,eAAA;EAhgEF;;EAmgEA;IACE,cAAA;EAjgEF;;EAogEA;IACE,eAAA;EAlgEF;;EAqgEA;IACE,YAAA;EAngEF;;EAsgEA;IACE,eAAA;EApgEF;;EAugEA;IACE,cAAA;EArgEF;;EAwgEA;IACE,YAAA;EAtgEF;;EAygEA;IACE,cAAA;EAvgEF;;EA0gEA;IACE,YAAA;EAxgEF;;EA2gEA;IACE,YAAA;EAzgEF;;EA4gEA;IACE,YAAA;EA1gEF;;EA6gEA;IACE,YAAA;EA3gEF;;EA8gEA;IACE,YAAA;EA5gEF;;EA+gEA;IACE,aAAA;EA7gEF;;EAghEA;IACE,aAAA;EA9gEF;;EAihEA;IACE,aAAA;EA/gEF;;EAkhEA;IACE,aAAA;EAhhEF;;EAmhEA;IACE,YAAA;EAjhEF;;EAohEA;IACE,WAAA;EAlhEF;;EAqhEA;IACE,gBAAA;EAnhEF;;EAshEA;IACE,eAAA;EAphEF;;EAuhEA;IACE,gBAAA;EArhEF;;EAwhEA;IACE,aAAA;EAthEF;;EAyhEA;IACE,gBAAA;EAvhEF;;EA0hEA;IACE,eAAA;EAxhEF;;EA2hEA;IACE,aAAA;EAzhEF;;EA4hEA;IACE,eAAA;EA1hEF;;EA6hEA;IACE,aAAA;EA3hEF;;EA8hEA;IACE,aAAA;EA5hEF;;EA+hEA;IACE,aAAA;EA7hEF;;EAgiEA;IACE,aAAA;EA9hEF;;EAiiEA;IACE,aAAA;EA/hEF;;EAkiEA;IACE,cAAA;EAhiEF;;EAmiEA;IACE,cAAA;EAjiEF;;EAoiEA;IACE,cAAA;EAliEF;;EAqiEA;IACE,cAAA;EAniEF;;EAsiEA;IACE,YAAA;EApiEF;;EAuiEA;IACE,aAAA;IACA,gBAAA;EAriEF;;EAwiEA;IACE,cAAA;IACA,eAAA;EAtiEF;;EAyiEA;IACE,mBAAA;IACA,sBAAA;EAviEF;;EA0iEA;IACE,oBAAA;IACA,qBAAA;EAxiEF;;EA2iEA;IACE,kBAAA;IACA,qBAAA;EAziEF;;EA4iEA;IACE,mBAAA;IACA,oBAAA;EA1iEF;;EA6iEA;IACE,mBAAA;IACA,sBAAA;EA3iEF;;EA8iEA;IACE,oBAAA;IACA,qBAAA;EA5iEF;;EA+iEA;IACE,gBAAA;IACA,mBAAA;EA7iEF;;EAgjEA;IACE,iBAAA;IACA,kBAAA;EA9iEF;;EAijEA;IACE,mBAAA;IACA,sBAAA;EA/iEF;;EAkjEA;IACE,oBAAA;IACA,qBAAA;EAhjEF;;EAmjEA;IACE,kBAAA;IACA,qBAAA;EAjjEF;;EAojEA;IACE,mBAAA;IACA,oBAAA;EAljEF;;EAqjEA;IACE,gBAAA;IACA,mBAAA;EAnjEF;;EAsjEA;IACE,iBAAA;IACA,kBAAA;EApjEF;;EAujEA;IACE,kBAAA;IACA,qBAAA;EArjEF;;EAwjEA;IACE,mBAAA;IACA,oBAAA;EAtjEF;;EAyjEA;IACE,gBAAA;IACA,mBAAA;EAvjEF;;EA0jEA;IACE,iBAAA;IACA,kBAAA;EAxjEF;;EA2jEA;IACE,gBAAA;IACA,mBAAA;EAzjEF;;EA4jEA;IACE,iBAAA;IACA,kBAAA;EA1jEF;;EA6jEA;IACE,gBAAA;IACA,mBAAA;EA3jEF;;EA8jEA;IACE,iBAAA;IACA,kBAAA;EA5jEF;;EA+jEA;IACE,gBAAA;IACA,mBAAA;EA7jEF;;EAgkEA;IACE,iBAAA;IACA,kBAAA;EA9jEF;;EAikEA;IACE,gBAAA;IACA,mBAAA;EA/jEF;;EAkkEA;IACE,iBAAA;IACA,kBAAA;EAhkEF;;EAmkEA;IACE,iBAAA;IACA,oBAAA;EAjkEF;;EAokEA;IACE,kBAAA;IACA,mBAAA;EAlkEF;;EAqkEA;IACE,iBAAA;IACA,oBAAA;EAnkEF;;EAskEA;IACE,kBAAA;IACA,mBAAA;EApkEF;;EAukEA;IACE,iBAAA;IACA,oBAAA;EArkEF;;EAwkEA;IACE,kBAAA;IACA,mBAAA;EAtkEF;;EAykEA;IACE,iBAAA;IACA,oBAAA;EAvkEF;;EA0kEA;IACE,kBAAA;IACA,mBAAA;EAxkEF;;EA2kEA;IACE,gBAAA;IACA,mBAAA;EAzkEF;;EA4kEA;IACE,iBAAA;IACA,kBAAA;EA1kEF;;EA6kEA;IACE,eAAA;IACA,kBAAA;EA3kEF;;EA8kEA;IACE,gBAAA;IACA,iBAAA;EA5kEF;;EA+kEA;IACE,oBAAA;IACA,uBAAA;EA7kEF;;EAglEA;IACE,qBAAA;IACA,sBAAA;EA9kEF;;EAilEA;IACE,mBAAA;IACA,sBAAA;EA/kEF;;EAklEA;IACE,oBAAA;IACA,qBAAA;EAhlEF;;EAmlEA;IACE,oBAAA;IACA,uBAAA;EAjlEF;;EAolEA;IACE,qBAAA;IACA,sBAAA;EAllEF;;EAqlEA;IACE,iBAAA;IACA,oBAAA;EAnlEF;;EAslEA;IACE,kBAAA;IACA,mBAAA;EAplEF;;EAulEA;IACE,oBAAA;IACA,uBAAA;EArlEF;;EAwlEA;IACE,qBAAA;IACA,sBAAA;EAtlEF;;EAylEA;IACE,mBAAA;IACA,sBAAA;EAvlEF;;EA0lEA;IACE,oBAAA;IACA,qBAAA;EAxlEF;;EA2lEA;IACE,iBAAA;IACA,oBAAA;EAzlEF;;EA4lEA;IACE,kBAAA;IACA,mBAAA;EA1lEF;;EA6lEA;IACE,mBAAA;IACA,sBAAA;EA3lEF;;EA8lEA;IACE,oBAAA;IACA,qBAAA;EA5lEF;;EA+lEA;IACE,iBAAA;IACA,oBAAA;EA7lEF;;EAgmEA;IACE,kBAAA;IACA,mBAAA;EA9lEF;;EAimEA;IACE,iBAAA;IACA,oBAAA;EA/lEF;;EAkmEA;IACE,kBAAA;IACA,mBAAA;EAhmEF;;EAmmEA;IACE,iBAAA;IACA,oBAAA;EAjmEF;;EAomEA;IACE,kBAAA;IACA,mBAAA;EAlmEF;;EAqmEA;IACE,iBAAA;IACA,oBAAA;EAnmEF;;EAsmEA;IACE,kBAAA;IACA,mBAAA;EApmEF;;EAumEA;IACE,iBAAA;IACA,oBAAA;EArmEF;;EAwmEA;IACE,kBAAA;IACA,mBAAA;EAtmEF;;EAymEA;IACE,kBAAA;IACA,qBAAA;EAvmEF;;EA0mEA;IACE,mBAAA;IACA,oBAAA;EAxmEF;;EA2mEA;IACE,kBAAA;IACA,qBAAA;EAzmEF;;EA4mEA;IACE,mBAAA;IACA,oBAAA;EA1mEF;;EA6mEA;IACE,kBAAA;IACA,qBAAA;EA3mEF;;EA8mEA;IACE,mBAAA;IACA,oBAAA;EA5mEF;;EA+mEA;IACE,kBAAA;IACA,qBAAA;EA7mEF;;EAgnEA;IACE,mBAAA;IACA,oBAAA;EA9mEF;;EAinEA;IACE,gBAAA;IACA,mBAAA;EA/mEF;;EAknEA;IACE,iBAAA;IACA,kBAAA;EAhnEF;;EAmnEA;IACE,aAAA;EAjnEF;;EAonEA;IACE,eAAA;EAlnEF;;EAqnEA;IACE,gBAAA;EAnnEF;;EAsnEA;IACE,cAAA;EApnEF;;EAunEA;IACE,mBAAA;EArnEF;;EAwnEA;IACE,qBAAA;EAtnEF;;EAynEA;IACE,sBAAA;EAvnEF;;EA0nEA;IACE,oBAAA;EAxnEF;;EA2nEA;IACE,kBAAA;EAznEF;;EA4nEA;IACE,oBAAA;EA1nEF;;EA6nEA;IACE,qBAAA;EA3nEF;;EA8nEA;IACE,mBAAA;EA5nEF;;EA+nEA;IACE,mBAAA;EA7nEF;;EAgoEA;IACE,qBAAA;EA9nEF;;EAioEA;IACE,sBAAA;EA/nEF;;EAkoEA;IACE,oBAAA;EAhoEF;;EAmoEA;IACE,gBAAA;EAjoEF;;EAooEA;IACE,kBAAA;EAloEF;;EAqoEA;IACE,mBAAA;EAnoEF;;EAsoEA;IACE,iBAAA;EApoEF;;EAuoEA;IACE,mBAAA;EAroEF;;EAwoEA;IACE,qBAAA;EAtoEF;;EAyoEA;IACE,sBAAA;EAvoEF;;EA0oEA;IACE,oBAAA;EAxoEF;;EA2oEA;IACE,kBAAA;EAzoEF;;EA4oEA;IACE,oBAAA;EA1oEF;;EA6oEA;IACE,qBAAA;EA3oEF;;EA8oEA;IACE,mBAAA;EA5oEF;;EA+oEA;IACE,gBAAA;EA7oEF;;EAgpEA;IACE,kBAAA;EA9oEF;;EAipEA;IACE,mBAAA;EA/oEF;;EAkpEA;IACE,iBAAA;EAhpEF;;EAmpEA;IACE,kBAAA;EAjpEF;;EAopEA;IACE,oBAAA;EAlpEF;;EAqpEA;IACE,qBAAA;EAnpEF;;EAspEA;IACE,mBAAA;EAppEF;;EAupEA;IACE,gBAAA;EArpEF;;EAwpEA;IACE,kBAAA;EAtpEF;;EAypEA;IACE,mBAAA;EAvpEF;;EA0pEA;IACE,iBAAA;EAxpEF;;EA2pEA;IACE,gBAAA;EAzpEF;;EA4pEA;IACE,kBAAA;EA1pEF;;EA6pEA;IACE,mBAAA;EA3pEF;;EA8pEA;IACE,iBAAA;EA5pEF;;EA+pEA;IACE,gBAAA;EA7pEF;;EAgqEA;IACE,kBAAA;EA9pEF;;EAiqEA;IACE,mBAAA;EA/pEF;;EAkqEA;IACE,iBAAA;EAhqEF;;EAmqEA;IACE,gBAAA;EAjqEF;;EAoqEA;IACE,kBAAA;EAlqEF;;EAqqEA;IACE,mBAAA;EAnqEF;;EAsqEA;IACE,iBAAA;EApqEF;;EAuqEA;IACE,gBAAA;EArqEF;;EAwqEA;IACE,kBAAA;EAtqEF;;EAyqEA;IACE,mBAAA;EAvqEF;;EA0qEA;IACE,iBAAA;EAxqEF;;EA2qEA;IACE,iBAAA;EAzqEF;;EA4qEA;IACE,mBAAA;EA1qEF;;EA6qEA;IACE,oBAAA;EA3qEF;;EA8qEA;IACE,kBAAA;EA5qEF;;EA+qEA;IACE,iBAAA;EA7qEF;;EAgrEA;IACE,mBAAA;EA9qEF;;EAirEA;IACE,oBAAA;EA/qEF;;EAkrEA;IACE,kBAAA;EAhrEF;;EAmrEA;IACE,iBAAA;EAjrEF;;EAorEA;IACE,mBAAA;EAlrEF;;EAqrEA;IACE,oBAAA;EAnrEF;;EAsrEA;IACE,kBAAA;EAprEF;;EAurEA;IACE,iBAAA;EArrEF;;EAwrEA;IACE,mBAAA;EAtrEF;;EAyrEA;IACE,oBAAA;EAvrEF;;EA0rEA;IACE,kBAAA;EAxrEF;;EA2rEA;IACE,gBAAA;EAzrEF;;EA4rEA;IACE,kBAAA;EA1rEF;;EA6rEA;IACE,mBAAA;EA3rEF;;EA8rEA;IACE,iBAAA;EA5rEF;;EA+rEA;IACE,eAAA;EA7rEF;;EAgsEA;IACE,iBAAA;EA9rEF;;EAisEA;IACE,kBAAA;EA/rEF;;EAksEA;IACE,gBAAA;EAhsEF;;EAmsEA;IACE,oBAAA;EAjsEF;;EAosEA;IACE,sBAAA;EAlsEF;;EAqsEA;IACE,uBAAA;EAnsEF;;EAssEA;IACE,qBAAA;EApsEF;;EAusEA;IACE,mBAAA;EArsEF;;EAwsEA;IACE,qBAAA;EAtsEF;;EAysEA;IACE,sBAAA;EAvsEF;;EA0sEA;IACE,oBAAA;EAxsEF;;EA2sEA;IACE,oBAAA;EAzsEF;;EA4sEA;IACE,sBAAA;EA1sEF;;EA6sEA;IACE,uBAAA;EA3sEF;;EA8sEA;IACE,qBAAA;EA5sEF;;EA+sEA;IACE,iBAAA;EA7sEF;;EAgtEA;IACE,mBAAA;EA9sEF;;EAitEA;IACE,oBAAA;EA/sEF;;EAktEA;IACE,kBAAA;EAhtEF;;EAmtEA;IACE,oBAAA;EAjtEF;;EAotEA;IACE,sBAAA;EAltEF;;EAqtEA;IACE,uBAAA;EAntEF;;EAstEA;IACE,qBAAA;EAptEF;;EAutEA;IACE,mBAAA;EArtEF;;EAwtEA;IACE,qBAAA;EAttEF;;EAytEA;IACE,sBAAA;EAvtEF;;EA0tEA;IACE,oBAAA;EAxtEF;;EA2tEA;IACE,iBAAA;EAztEF;;EA4tEA;IACE,mBAAA;EA1tEF;;EA6tEA;IACE,oBAAA;EA3tEF;;EA8tEA;IACE,kBAAA;EA5tEF;;EA+tEA;IACE,mBAAA;EA7tEF;;EAguEA;IACE,qBAAA;EA9tEF;;EAiuEA;IACE,sBAAA;EA/tEF;;EAkuEA;IACE,oBAAA;EAhuEF;;EAmuEA;IACE,iBAAA;EAjuEF;;EAouEA;IACE,mBAAA;EAluEF;;EAquEA;IACE,oBAAA;EAnuEF;;EAsuEA;IACE,kBAAA;EApuEF;;EAuuEA;IACE,iBAAA;EAruEF;;EAwuEA;IACE,mBAAA;EAtuEF;;EAyuEA;IACE,oBAAA;EAvuEF;;EA0uEA;IACE,kBAAA;EAxuEF;;EA2uEA;IACE,iBAAA;EAzuEF;;EA4uEA;IACE,mBAAA;EA1uEF;;EA6uEA;IACE,oBAAA;EA3uEF;;EA8uEA;IACE,kBAAA;EA5uEF;;EA+uEA;IACE,iBAAA;EA7uEF;;EAgvEA;IACE,mBAAA;EA9uEF;;EAivEA;IACE,oBAAA;EA/uEF;;EAkvEA;IACE,kBAAA;EAhvEF;;EAmvEA;IACE,iBAAA;EAjvEF;;EAovEA;IACE,mBAAA;EAlvEF;;EAqvEA;IACE,oBAAA;EAnvEF;;EAsvEA;IACE,kBAAA;EApvEF;;EAuvEA;IACE,kBAAA;EArvEF;;EAwvEA;IACE,oBAAA;EAtvEF;;EAyvEA;IACE,qBAAA;EAvvEF;;EA0vEA;IACE,mBAAA;EAxvEF;;EA2vEA;IACE,kBAAA;EAzvEF;;EA4vEA;IACE,oBAAA;EA1vEF;;EA6vEA;IACE,qBAAA;EA3vEF;;EA8vEA;IACE,mBAAA;EA5vEF;;EA+vEA;IACE,kBAAA;EA7vEF;;EAgwEA;IACE,oBAAA;EA9vEF;;EAiwEA;IACE,qBAAA;EA/vEF;;EAkwEA;IACE,mBAAA;EAhwEF;;EAmwEA;IACE,kBAAA;EAjwEF;;EAowEA;IACE,oBAAA;EAlwEF;;EAqwEA;IACE,qBAAA;EAnwEF;;EAswEA;IACE,mBAAA;EApwEF;;EAuwEA;IACE,gBAAA;EArwEF;;EAwwEA;IACE,kBAAA;EAtwEF;;EAywEA;IACE,mBAAA;EAvwEF;;EA0wEA;IACE,iBAAA;EAxwEF;;EA2wEA;IACE,gBAAA;EAzwEF;;EA4wEA;IACE,iBAAA;EA1wEF;;EA6wEA;IACE,eAAA;EA3wEF;;EA8wEA;IACE,gBAAA;EA5wEF;;EA+wEA;IACE,gBAAA;EA7wEF;;EAgxEA;IACE,gBAAA;EA9wEF;;EAixEA;IACE,gBAAA;EA/wEF;;EAkxEA;IACE,gBAAA;EAhxEF;;EAmxEA;IACE,gBAAA;EAjxEF;;EAoxEA;IACE,gBAAA;EAlxEF;;EAqxEA;IACE,gBAAA;EAnxEF;;EAsxEA;IACE,gBAAA;EApxEF;;EAuxEA;IACE,gBAAA;EArxEF;;EAwxEA;IACE,eAAA;EAtxEF;;EAyxEA;IACE,gBAAA;EAvxEF;;EA0xEA;IACE,gBAAA;EAxxEF;;EA2xEA;IACE,iBAAA;EAzxEF;;EA4xEA;IACE,iBAAA;EA1xEF;;EA6xEA;IACE,aAAA;EA3xEF;;EA8xEA;IACE,gBAAA;EA5xEF;;EA+xEA;IACE,iBAAA;EA7xEF;;EAgyEA;IACE,YAAA;EA9xEF;;EAiyEA;IACE,eAAA;EA/xEF;;EAkyEA;IACE,mBAAA;EAhyEF;;EAmyEA;IACE,iBAAA;EAjyEF;;EAoyEA;IACE,gBAAA;EAlyEF;;EAqyEA;IACE,gBAAA;EAnyEF;;EAsyEA;IACE,sBAAA;EApyEF;;EAuyEA;IACE,uBAAA;EAryEF;;EAwyEA;IACE,uBAAA;EAtyEF;;EAyyEA;IACE,qBAAA;EAvyEF;;EA0yEA;IACE,4BAAA;EAxyEF;;EA2yEA;IACE,yBAAA;EAzyEF;;EA4yEA;IACE,sBAAA;EA1yEF;;EA6yEA;IACE,6BAAA;EA3yEF;;EA8yEA;IACE,0BAAA;EA5yEF;;EA+yEA;IACE,oBAAA;EA7yEF;;EAgzEA;IACE,UAAA;EA9yEF;;EAizEA;IACE,aAAA;EA/yEF;;EAkzEA;IACE,YAAA;EAhzEF;;EAmzEA;IACE,aAAA;EAjzEF;;EAozEA;IACE,UAAA;EAlzEF;;EAqzEA;IACE,UAAA;EAnzEF;;EAszEA;IACE,aAAA;EApzEF;;EAuzEA;IACE,YAAA;EArzEF;;EAwzEA;IACE,aAAA;EAtzEF;;EAyzEA;IACE,UAAA;EAvzEF;;EA0zEA;IACE,UAAA;EAxzEF;;EA2zEA;IACE,aAAA;EAzzEF;;EA4zEA;IACE,YAAA;EA1zEF;;EA6zEA;IACE,aAAA;EA3zEF;;EA8zEA;IACE,UAAA;EA5zEF;;EA+zEA;IACE,8BAAA;IACA,mBAAA;EA7zEF;;EAg0EA;IACE,yBAAA;IACA,mBAAA;EA9zEF;;EAi0EA;IACE,yBAAA;IACA,mBAAA;EA/zEF;;EAk0EA;IACE,8BAAA;IACA,mBAAA;EAh0EF;;EAm0EA;IACE,yBAAA;IACA,mBAAA;EAj0EF;;EAo0EA;IACE,yBAAA;IACA,mBAAA;EAl0EF;;EAq0EA;IACE,cAAA;EAn0EF;;EAs0EA;IACE,gBAAA;EAp0EF;;EAu0EA;IACE,iBAAA;EAr0EF;;EAw0EA;IACE,gBAAA;EAt0EF;;EAy0EA;IACE,gBAAA;EAv0EF;;EA00EA;IACE,gBAAA;EAx0EF;;EA20EA;IACE,kBAAA;EAz0EF;;EA40EA;IACE,kBAAA;EA10EF;;EA60EA;IACE,mBAAA;EA30EF;;EA80EA;IACE,mBAAA;EA50EF;;EA+0EA;IACE,kBAAA;EA70EF;;EAg1EA;IACE,kBAAA;EA90EF;;EAi1EA;IACE,iCAAA;EA/0EF;;EAk1EA;IACE,gCAAA;EAh1EF;;EAm1EA;IACE,yBAAA;EAj1EF;;EAo1EA;IACE,4BAAA;EAl1EF;;EAq1EA;IACE,yBAAA;EAn1EF;;EAs1EA;IACE,2BAAA;EAp1EF;;EAu1EA;IACE,8BAAA;EAr1EF;;EAw1EA;IACE,2BAAA;EAt1EF;;EAy1EA;IACE,2BAAA;EAv1EF;;EA01EA;IACE,8BAAA;EAx1EF;;EA21EA;IACE,2BAAA;EAz1EF;;EA41EA;IACE,UAAA;EA11EF;;EA61EA;IACE,gBAAA;EA31EF;;EA81EA;IACE,eAAA;EA51EF;;EA+1EA;IACE,gBAAA;EA71EF;;EAg2EA;IACE,aAAA;EA91EF;;EAi2EA;IACE,gBAAA;EA/1EF;;EAk2EA;IACE,eAAA;EAh2EF;;EAm2EA;IACE,aAAA;EAj2EF;;EAo2EA;IACE,eAAA;EAl2EF;;EAq2EA;IACE,aAAA;EAn2EF;;EAs2EA;IACE,aAAA;EAp2EF;;EAu2EA;IACE,aAAA;EAr2EF;;EAw2EA;IACE,aAAA;EAt2EF;;EAy2EA;IACE,aAAA;EAv2EF;;EA02EA;IACE,cAAA;EAx2EF;;EA22EA;IACE,cAAA;EAz2EF;;EA42EA;IACE,cAAA;EA12EF;;EA62EA;IACE,cAAA;EA32EF;;EA82EA;IACE,YAAA;EA52EF;;EA+2EA;IACE,cAAA;IACA,iBAAA;EA72EF;;EAg3EA;IACE,eAAA;IACA,gBAAA;EA92EF;;EAi3EA;IACE,oBAAA;IACA,uBAAA;EA/2EF;;EAk3EA;IACE,qBAAA;IACA,sBAAA;EAh3EF;;EAm3EA;IACE,mBAAA;IACA,sBAAA;EAj3EF;;EAo3EA;IACE,oBAAA;IACA,qBAAA;EAl3EF;;EAq3EA;IACE,oBAAA;IACA,uBAAA;EAn3EF;;EAs3EA;IACE,qBAAA;IACA,sBAAA;EAp3EF;;EAu3EA;IACE,iBAAA;IACA,oBAAA;EAr3EF;;EAw3EA;IACE,kBAAA;IACA,mBAAA;EAt3EF;;EAy3EA;IACE,oBAAA;IACA,uBAAA;EAv3EF;;EA03EA;IACE,qBAAA;IACA,sBAAA;EAx3EF;;EA23EA;IACE,mBAAA;IACA,sBAAA;EAz3EF;;EA43EA;IACE,oBAAA;IACA,qBAAA;EA13EF;;EA63EA;IACE,iBAAA;IACA,oBAAA;EA33EF;;EA83EA;IACE,kBAAA;IACA,mBAAA;EA53EF;;EA+3EA;IACE,mBAAA;IACA,sBAAA;EA73EF;;EAg4EA;IACE,oBAAA;IACA,qBAAA;EA93EF;;EAi4EA;IACE,iBAAA;IACA,oBAAA;EA/3EF;;EAk4EA;IACE,kBAAA;IACA,mBAAA;EAh4EF;;EAm4EA;IACE,iBAAA;IACA,oBAAA;EAj4EF;;EAo4EA;IACE,kBAAA;IACA,mBAAA;EAl4EF;;EAq4EA;IACE,iBAAA;IACA,oBAAA;EAn4EF;;EAs4EA;IACE,kBAAA;IACA,mBAAA;EAp4EF;;EAu4EA;IACE,iBAAA;IACA,oBAAA;EAr4EF;;EAw4EA;IACE,kBAAA;IACA,mBAAA;EAt4EF;;EAy4EA;IACE,iBAAA;IACA,oBAAA;EAv4EF;;EA04EA;IACE,kBAAA;IACA,mBAAA;EAx4EF;;EA24EA;IACE,kBAAA;IACA,qBAAA;EAz4EF;;EA44EA;IACE,mBAAA;IACA,oBAAA;EA14EF;;EA64EA;IACE,kBAAA;IACA,qBAAA;EA34EF;;EA84EA;IACE,mBAAA;IACA,oBAAA;EA54EF;;EA+4EA;IACE,kBAAA;IACA,qBAAA;EA74EF;;EAg5EA;IACE,mBAAA;IACA,oBAAA;EA94EF;;EAi5EA;IACE,kBAAA;IACA,qBAAA;EA/4EF;;EAk5EA;IACE,mBAAA;IACA,oBAAA;EAh5EF;;EAm5EA;IACE,gBAAA;IACA,mBAAA;EAj5EF;;EAo5EA;IACE,iBAAA;IACA,kBAAA;EAl5EF;;EAq5EA;IACE,cAAA;EAn5EF;;EAs5EA;IACE,gBAAA;EAp5EF;;EAu5EA;IACE,iBAAA;EAr5EF;;EAw5EA;IACE,eAAA;EAt5EF;;EAy5EA;IACE,oBAAA;EAv5EF;;EA05EA;IACE,sBAAA;EAx5EF;;EA25EA;IACE,uBAAA;EAz5EF;;EA45EA;IACE,qBAAA;EA15EF;;EA65EA;IACE,mBAAA;EA35EF;;EA85EA;IACE,qBAAA;EA55EF;;EA+5EA;IACE,sBAAA;EA75EF;;EAg6EA;IACE,oBAAA;EA95EF;;EAi6EA;IACE,oBAAA;EA/5EF;;EAk6EA;IACE,sBAAA;EAh6EF;;EAm6EA;IACE,uBAAA;EAj6EF;;EAo6EA;IACE,qBAAA;EAl6EF;;EAq6EA;IACE,iBAAA;EAn6EF;;EAs6EA;IACE,mBAAA;EAp6EF;;EAu6EA;IACE,oBAAA;EAr6EF;;EAw6EA;IACE,kBAAA;EAt6EF;;EAy6EA;IACE,oBAAA;EAv6EF;;EA06EA;IACE,sBAAA;EAx6EF;;EA26EA;IACE,uBAAA;EAz6EF;;EA46EA;IACE,qBAAA;EA16EF;;EA66EA;IACE,mBAAA;EA36EF;;EA86EA;IACE,qBAAA;EA56EF;;EA+6EA;IACE,sBAAA;EA76EF;;EAg7EA;IACE,oBAAA;EA96EF;;EAi7EA;IACE,iBAAA;EA/6EF;;EAk7EA;IACE,mBAAA;EAh7EF;;EAm7EA;IACE,oBAAA;EAj7EF;;EAo7EA;IACE,kBAAA;EAl7EF;;EAq7EA;IACE,mBAAA;EAn7EF;;EAs7EA;IACE,qBAAA;EAp7EF;;EAu7EA;IACE,sBAAA;EAr7EF;;EAw7EA;IACE,oBAAA;EAt7EF;;EAy7EA;IACE,iBAAA;EAv7EF;;EA07EA;IACE,mBAAA;EAx7EF;;EA27EA;IACE,oBAAA;EAz7EF;;EA47EA;IACE,kBAAA;EA17EF;;EA67EA;IACE,iBAAA;EA37EF;;EA87EA;IACE,mBAAA;EA57EF;;EA+7EA;IACE,oBAAA;EA77EF;;EAg8EA;IACE,kBAAA;EA97EF;;EAi8EA;IACE,iBAAA;EA/7EF;;EAk8EA;IACE,mBAAA;EAh8EF;;EAm8EA;IACE,oBAAA;EAj8EF;;EAo8EA;IACE,kBAAA;EAl8EF;;EAq8EA;IACE,iBAAA;EAn8EF;;EAs8EA;IACE,mBAAA;EAp8EF;;EAu8EA;IACE,oBAAA;EAr8EF;;EAw8EA;IACE,kBAAA;EAt8EF;;EAy8EA;IACE,iBAAA;EAv8EF;;EA08EA;IACE,mBAAA;EAx8EF;;EA28EA;IACE,oBAAA;EAz8EF;;EA48EA;IACE,kBAAA;EA18EF;;EA68EA;IACE,kBAAA;EA38EF;;EA88EA;IACE,oBAAA;EA58EF;;EA+8EA;IACE,qBAAA;EA78EF;;EAg9EA;IACE,mBAAA;EA98EF;;EAi9EA;IACE,kBAAA;EA/8EF;;EAk9EA;IACE,oBAAA;EAh9EF;;EAm9EA;IACE,qBAAA;EAj9EF;;EAo9EA;IACE,mBAAA;EAl9EF;;EAq9EA;IACE,kBAAA;EAn9EF;;EAs9EA;IACE,oBAAA;EAp9EF;;EAu9EA;IACE,qBAAA;EAr9EF;;EAw9EA;IACE,mBAAA;EAt9EF;;EAy9EA;IACE,kBAAA;EAv9EF;;EA09EA;IACE,oBAAA;EAx9EF;;EA29EA;IACE,qBAAA;EAz9EF;;EA49EA;IACE,mBAAA;EA19EF;;EA69EA;IACE,gBAAA;EA39EF;;EA89EA;IACE,kBAAA;EA59EF;;EA+9EA;IACE,mBAAA;EA79EF;;EAg+EA;IACE,iBAAA;EA99EF;;EAi+EA;IACE,kBAAA;EA/9EF;;EAk+EA;IACE,mBAAA;EAh+EF;;EAm+EA;IACE,wBAAA;IACA,WAAA;IACA,gDAAA;EAj+EF;;EAo+EA;IACE,wBAAA;IACA,WAAA;IACA,sDAAA;EAl+EF;;EAq+EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn+EF;;EAs+EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp+EF;;EAu+EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr+EF;;EAw+EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt+EF;;EAy+EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv+EF;;EA0+EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAx+EF;;EA2+EA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAz+EF;;EA4+EA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA1+EF;;EA6+EA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA3+EF;;EA8+EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5+EF;;EA++EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7+EF;;EAg/EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9+EF;;EAi/EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/+EF;;EAk/EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAh/EF;;EAm/EA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAj/EF;;EAo/EA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAl/EF;;EAq/EA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAn/EF;;EAs/EA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAp/EF;;EAu/EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr/EF;;EAw/EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt/EF;;EAy/EA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv/EF;;EA0/EA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAx/EF;;EA2/EA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAz/EF;;EA4/EA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1/EF;;EA6/EA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA3/EF;;EA8/EA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA5/EF;;EA+/EA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA7/EF;;EAggFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9/EF;;EAigFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA//EF;;EAkgFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhgFF;;EAmgFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAjgFF;;EAogFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAlgFF;;EAqgFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAngFF;;EAsgFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EApgFF;;EAugFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EArgFF;;EAwgFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAtgFF;;EAygFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvgFF;;EA0gFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxgFF;;EA2gFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAzgFF;;EA4gFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1gFF;;EA6gFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA3gFF;;EA8gFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA5gFF;;EA+gFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA7gFF;;EAghFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA9gFF;;EAihFA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA/gFF;;EAkhFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhhFF;;EAmhFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjhFF;;EAohFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlhFF;;EAqhFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAnhFF;;EAshFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAphFF;;EAuhFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EArhFF;;EAwhFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAthFF;;EAyhFA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAvhFF;;EA0hFA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAxhFF;;EA2hFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAzhFF;;EA4hFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1hFF;;EA6hFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3hFF;;EA8hFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA5hFF;;EA+hFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA7hFF;;EAgiFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9hFF;;EAiiFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/hFF;;EAkiFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAhiFF;;EAmiFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAjiFF;;EAoiFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAliFF;;EAqiFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAniFF;;EAsiFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApiFF;;EAuiFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAriFF;;EAwiFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtiFF;;EAyiFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAviFF;;EA0iFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAxiFF;;EA2iFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAziFF;;EA4iFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA1iFF;;EA6iFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3iFF;;EA8iFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5iFF;;EA+iFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7iFF;;EAgjFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9iFF;;EAijFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/iFF;;EAkjFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAhjFF;;EAmjFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAjjFF;;EAojFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAljFF;;EAqjFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAnjFF;;EAsjFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApjFF;;EAujFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArjFF;;EAwjFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtjFF;;EAyjFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvjFF;;EA0jFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxjFF;;EA2jFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAzjFF;;EA4jFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1jFF;;EA6jFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA3jFF;;EA8jFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA5jFF;;EA+jFA;IACE,kBAAA;EA7jFF;;EAgkFA;IACE,mBAAA;EA9jFF;;EAikFA;IACE,wBAAA;IACA,WAAA;IACA,gDAAA;EA/jFF;;EAkkFA;IACE,wBAAA;IACA,WAAA;IACA,sDAAA;EAhkFF;;EAmkFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjkFF;;EAokFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlkFF;;EAqkFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnkFF;;EAskFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApkFF;;EAukFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArkFF;;EAwkFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtkFF;;EAykFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAvkFF;;EA0kFA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAxkFF;;EA2kFA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAzkFF;;EA4kFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1kFF;;EA6kFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3kFF;;EA8kFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5kFF;;EA+kFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7kFF;;EAglFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9kFF;;EAilFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/kFF;;EAklFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAhlFF;;EAmlFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAjlFF;;EAolFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAllFF;;EAqlFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnlFF;;EAslFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAplFF;;EAulFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArlFF;;EAwlFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAtlFF;;EAylFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAvlFF;;EA0lFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAxlFF;;EA2lFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAzlFF;;EA4lFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA1lFF;;EA6lFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA3lFF;;EA8lFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5lFF;;EA+lFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7lFF;;EAgmFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9lFF;;EAimFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/lFF;;EAkmFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAhmFF;;EAmmFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAjmFF;;EAomFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAlmFF;;EAqmFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAnmFF;;EAsmFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EApmFF;;EAumFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArmFF;;EAwmFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtmFF;;EAymFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvmFF;;EA0mFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxmFF;;EA2mFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAzmFF;;EA4mFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1mFF;;EA6mFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA3mFF;;EA8mFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA5mFF;;EA+mFA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA7mFF;;EAgnFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9mFF;;EAinFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/mFF;;EAknFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhnFF;;EAmnFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAjnFF;;EAonFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAlnFF;;EAqnFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAnnFF;;EAsnFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EApnFF;;EAunFA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EArnFF;;EAwnFA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAtnFF;;EAynFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvnFF;;EA0nFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxnFF;;EA2nFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAznFF;;EA4nFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1nFF;;EA6nFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA3nFF;;EA8nFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA5nFF;;EA+nFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA7nFF;;EAgoFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA9nFF;;EAioFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/nFF;;EAkoFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhoFF;;EAmoFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjoFF;;EAooFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAloFF;;EAqoFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnoFF;;EAsoFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApoFF;;EAuoFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAroFF;;EAwoFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAtoFF;;EAyoFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAvoFF;;EA0oFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAxoFF;;EA2oFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAzoFF;;EA4oFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1oFF;;EA6oFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3oFF;;EA8oFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5oFF;;EA+oFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7oFF;;EAgpFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9oFF;;EAipFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/oFF;;EAkpFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAhpFF;;EAmpFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAjpFF;;EAopFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlpFF;;EAqpFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnpFF;;EAspFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAppFF;;EAupFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArpFF;;EAwpFA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtpFF;;EAypFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAvpFF;;EA0pFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAxpFF;;EA2pFA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAzpFF;;EA4pFA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA1pFF;;EA6pFA;IACE,wBAAA;EA3pFF;;EA8pFA;IACE,2BAAA;EA5pFF;;EA+pFA;IACE,0BAAA;EA7pFF;;EAgqFA;IACE,2BAAA;EA9pFF;;EAiqFA;IACE,wBAAA;EA/pFF;;EAkqFA;IACE,wBAAA;EAhqFF;;EAmqFA;IACE,2BAAA;EAjqFF;;EAoqFA;IACE,0BAAA;EAlqFF;;EAqqFA;IACE,2BAAA;EAnqFF;;EAsqFA;IACE,wBAAA;EApqFF;;EAuqFA;IACE,oBAAA;EArqFF;;EAwqFA;IACE,oBAAA;EAtqFF;;EAyqFA;IACE,gBAAA;EAvqFF;;EA0qFA;IACE,eAAA;EAxqFF;;EA2qFA;IACE,kBAAA;EAzqFF;;EA4qFA;IACE,kBAAA;EA1qFF;;EA6qFA;IACE,gBAAA;EA3qFF;;EA8qFA;IACE,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;EA5qFF;;EA+qFA;IACE,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EA7qFF;;EAgrFA;IACE,MAAA;IACA,SAAA;EA9qFF;;EAirFA;IACE,QAAA;IACA,OAAA;EA/qFF;;EAkrFA;IACE,SAAA;IACA,YAAA;EAhrFF;;EAmrFA;IACE,WAAA;IACA,UAAA;EAjrFF;;EAorFA;IACE,MAAA;EAlrFF;;EAqrFA;IACE,QAAA;EAnrFF;;EAsrFA;IACE,SAAA;EAprFF;;EAurFA;IACE,OAAA;EArrFF;;EAwrFA;IACE,SAAA;EAtrFF;;EAyrFA;IACE,WAAA;EAvrFF;;EA0rFA;IACE,YAAA;EAxrFF;;EA2rFA;IACE,UAAA;EAzrFF;;EA4rFA;IACE,YAAA;EA1rFF;;EA6rFA;IACE,gBAAA;EA3rFF;;EA8rFA;IACE,kBAAA;EA5rFF;;EA+rFA;IACE,YAAA;EA7rFF;;EAgsFA;IACE,yCAAA;EA9rFF;;EAisFA;IACE,2CAAA;EA/rFF;;EAksFA;IACE,2EAAA;EAhsFF;;EAmsFA;IACE,iFAAA;EAjsFF;;EAosFA;IACE,mFAAA;EAlsFF;;EAqsFA;IACE,qFAAA;EAnsFF;;EAssFA;IACE,iDAAA;EApsFF;;EAusFA;IACE,iDAAA;EArsFF;;EAwsFA;IACE,6CAAA;EAtsFF;;EAysFA;IACE,gBAAA;EAvsFF;;EA0sFA;IACE,yCAAA;EAxsFF;;EA2sFA;IACE,2CAAA;EAzsFF;;EA4sFA;IACE,2EAAA;EA1sFF;;EA6sFA;IACE,iFAAA;EA3sFF;;EA8sFA;IACE,mFAAA;EA5sFF;;EA+sFA;IACE,qFAAA;EA7sFF;;EAgtFA;IACE,iDAAA;EA9sFF;;EAitFA;IACE,iDAAA;EA/sFF;;EAktFA;IACE,6CAAA;EAhtFF;;EAmtFA;IACE,gBAAA;EAjtFF;;EAotFA;IACE,yCAAA;EAltFF;;EAqtFA;IACE,2CAAA;EAntFF;;EAstFA;IACE,2EAAA;EAptFF;;EAutFA;IACE,iFAAA;EArtFF;;EAwtFA;IACE,mFAAA;EAttFF;;EAytFA;IACE,qFAAA;EAvtFF;;EA0tFA;IACE,iDAAA;EAxtFF;;EA2tFA;IACE,iDAAA;EAztFF;;EA4tFA;IACE,6CAAA;EA1tFF;;EA6tFA;IACE,gBAAA;EA3tFF;;EA8tFA;IACE,kBAAA;EA5tFF;;EA+tFA;IACE,oBAAA;EA7tFF;;EAguFA;IACE,eAAA;EA9tFF;;EAiuFA;IACE,eAAA;EA/tFF;;EAkuFA;IACE,eAAA;EAhuFF;;EAmuFA;IACE,kBAAA;EAjuFF;;EAouFA;IACE,mBAAA;EAluFF;;EAquFA;IACE,gBAAA;EAnuFF;;EAsuFA;IACE,kBAAA;EApuFF;;EAuuFA;IACE,iBAAA;EAruFF;;EAwuFA;IACE,mBAAA;EAtuFF;;EAyuFA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EAvuFF;;EA0uFA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EAxuFF;;EA2uFA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EAzuFF;;EA4uFA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EA1uFF;;EA6uFA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EA3uFF;;EA8uFA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EA5uFF;;EA+uFA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EA7uFF;;EAgvFA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EA9uFF;;EAivFA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EA/uFF;;EAkvFA;IACE,iBAAA;EAhvFF;;EAmvFA;IACE,oBAAA;EAjvFF;;EAovFA;IACE,mBAAA;EAlvFF;;EAqvFA;IACE,oBAAA;EAnvFF;;EAsvFA;IACE,iBAAA;EApvFF;;EAuvFA;IACE,iBAAA;EArvFF;;EAwvFA;IACE,oBAAA;EAtvFF;;EAyvFA;IACE,mBAAA;EAvvFF;;EA0vFA;IACE,oBAAA;EAxvFF;;EA2vFA;IACE,iBAAA;EAzvFF;;EA4vFA;IACE,iBAAA;EA1vFF;;EA6vFA;IACE,oBAAA;EA3vFF;;EA8vFA;IACE,mBAAA;EA5vFF;;EA+vFA;IACE,oBAAA;EA7vFF;;EAgwFA;IACE,iBAAA;EA9vFF;;EAiwFA;IACE,kBAAA;EA/vFF;;EAkwFA;IACE,kBAAA;EAhwFF;;EAmwFA;IACE,yBAAA;EAjwFF;;EAowFA;IACE,yBAAA;EAlwFF;;EAqwFA;IACE,0BAAA;EAnwFF;;EAswFA;IACE,oBAAA;EApwFF;;EAuwFA;IACE,0BAAA;EArwFF;;EAwwFA;IACE,6BAAA;EAtwFF;;EAywFA;IACE,qBAAA;EAvwFF;;EA0wFA;IACE,0BAAA;EAxwFF;;EA2wFA;IACE,6BAAA;EAzwFF;;EA4wFA;IACE,qBAAA;EA1wFF;;EA6wFA;IACE,0BAAA;EA3wFF;;EA8wFA;IACE,6BAAA;EA5wFF;;EA+wFA;IACE,qBAAA;EA7wFF;;EAgxFA;IACE,mCAAA;IACA,kCAAA;EA9wFF;;EAixFA;IACE,4BAAA;IACA,6BAAA;EA/wFF;;EAkxFA;IACE,iEAAA;IACA,sEAAA;IACA,gEAAA;IACA,iEAAA;IACA,kEAAA;IACA,8MAAA;EAhxFF;;EAmxFA;IACE,4BAAA;EAjxFF;;EAoxFA;IACE,uCAAA;EAlxFF;;EAqxFA;IACE,iDAAA;EAnxFF;;EAsxFA;IACE,0CAAA;EApxFF;;EAuxFA;IACE,4CAAA;EArxFF;;EAwxFA;IACE,iDAAA;EAtxFF;;EAyxFA;IACE,4CAAA;EAvxFF;;EA0xFA;IACE,mDAAA;EAxxFF;;EA2xFA;IACE,kDAAA;EAzxFF;;EA4xFA;IACE,uBAAA;EA1xFF;;EA6xFA;IACE,wBAAA;EA3xFF;;EA8xFA;IACE,iBAAA;EA5xFF;;EA+xFA;IACE,uBAAA;EA7xFF;;EAgyFA;IACE,sBAAA;EA9xFF;;EAiyFA;IACE,qBAAA;EA/xFF;;EAkyFA;IACE,yBAAA;IACQ,iBAAA;EAhyFV;;EAmyFA;IACE,yBAAA;IACQ,iBAAA;EAjyFV;;EAoyFA;IACE,wBAAA;IACQ,gBAAA;EAlyFV;;EAqyFA;IACE,yBAAA;IACQ,iBAAA;EAnyFV;;EAsyFA;IACE,wBAAA;EApyFF;;EAuyFA;IACE,mBAAA;EAryFF;;EAwyFA;IACE,sBAAA;EAtyFF;;EAyyFA;IACE,sBAAA;EAvyFF;;EA0yFA;IACE,wBAAA;EAxyFF;;EA2yFA;IACE,2BAAA;EAzyFF;;EA4yFA;IACE,mBAAA;EA1yFF;;EA6yFA;IACE,kBAAA;EA3yFF;;EA8yFA;IACE,mBAAA;EA5yFF;;EA+yFA;IACE,mBAAA;EA7yFF;;EAgzFA;IACE,gBAAA;EA9yFF;;EAizFA;IACE,qBAAA;EA/yFF;;EAkzFA;IACE,qBAAA;EAhzFF;;EAmzFA;IACE,iBAAA;IACA,qBAAA;IACA,kBAAA;EAjzFF;;EAozFA;IACE,qBAAA;IACA,yBAAA;EAlzFF;;EAqzFA;IACE,qBAAA;EAnzFF;;EAszFA;IACE,gBAAA;IACA,uBAAA;IACA,mBAAA;EApzFF;;EAuzFA;IACE,QAAA;EArzFF;;EAwzFA;IACE,cAAA;EAtzFF;;EAyzFA;IACE,aAAA;EAvzFF;;EA0zFA;IACE,cAAA;EAxzFF;;EA2zFA;IACE,WAAA;EAzzFF;;EA4zFA;IACE,cAAA;EA1zFF;;EA6zFA;IACE,aAAA;EA3zFF;;EA8zFA;IACE,WAAA;EA5zFF;;EA+zFA;IACE,aAAA;EA7zFF;;EAg0FA;IACE,WAAA;EA9zFF;;EAi0FA;IACE,WAAA;EA/zFF;;EAk0FA;IACE,WAAA;EAh0FF;;EAm0FA;IACE,WAAA;EAj0FF;;EAo0FA;IACE,WAAA;EAl0FF;;EAq0FA;IACE,YAAA;EAn0FF;;EAs0FA;IACE,YAAA;EAp0FF;;EAu0FA;IACE,YAAA;EAr0FF;;EAw0FA;IACE,YAAA;EAt0FF;;EAy0FA;IACE,WAAA;EAv0FF;;EA00FA;IACE,UAAA;EAx0FF;;EA20FA;IACE,UAAA;EAz0FF;;EA40FA;IACE,iBAAA;EA10FF;;EA60FA;IACE,iBAAA;EA30FF;;EA80FA;IACE,UAAA;EA50FF;;EA+0FA;IACE,UAAA;EA70FF;;EAg1FA;IACE,UAAA;EA90FF;;EAi1FA;IACE,UAAA;EA/0FF;;EAk1FA;IACE,UAAA;EAh1FF;;EAm1FA;IACE,UAAA;EAj1FF;;EAo1FA;IACE,UAAA;EAl1FF;;EAq1FA;IACE,iBAAA;EAn1FF;;EAs1FA;IACE,iBAAA;EAp1FF;;EAu1FA;IACE,UAAA;EAr1FF;;EAw1FA;IACE,iBAAA;EAt1FF;;EAy1FA;IACE,iBAAA;EAv1FF;;EA01FA;IACE,gBAAA;EAx1FF;;EA21FA;IACE,iBAAA;EAz1FF;;EA41FA;IACE,UAAA;EA11FF;;EA61FA;IACE,iBAAA;EA31FF;;EA81FA;IACE,iBAAA;EA51FF;;EA+1FA;IACE,UAAA;EA71FF;;EAg2FA;IACE,iBAAA;EA91FF;;EAi2FA;IACE,iBAAA;EA/1FF;;EAk2FA;IACE,UAAA;EAh2FF;;EAm2FA;IACE,iBAAA;EAj2FF;;EAo2FA;IACE,iBAAA;EAl2FF;;EAq2FA;IACE,WAAA;EAn2FF;;EAs2FA;IACE,YAAA;EAp2FF;;EAu2FA;IACE,UAAA;EAr2FF;;EAw2FA;IACE,WAAA;EAt2FF;;EAy2FA;IACE,WAAA;EAv2FF;;EA02FA;IACE,WAAA;EAx2FF;;EA22FA;IACE,WAAA;EAz2FF;;EA42FA;IACE,WAAA;EA12FF;;EA62FA;IACE,aAAA;EA32FF;;EA82FA;IACE,WAAA;IACA,MAAA;EA52FF;;EA+2FA;IACE,iBAAA;IACA,YAAA;EA72FF;;EAg3FA;IACE,gBAAA;IACA,WAAA;EA92FF;;EAi3FA;IACE,iBAAA;IACA,YAAA;EA/2FF;;EAk3FA;IACE,cAAA;IACA,SAAA;EAh3FF;;EAm3FA;IACE,iBAAA;IACA,YAAA;EAj3FF;;EAo3FA;IACE,gBAAA;IACA,WAAA;EAl3FF;;EAq3FA;IACE,cAAA;IACA,SAAA;EAn3FF;;EAs3FA;IACE,gBAAA;IACA,WAAA;EAp3FF;;EAu3FA;IACE,cAAA;IACA,SAAA;EAr3FF;;EAw3FA;IACE,cAAA;IACA,SAAA;EAt3FF;;EAy3FA;IACE,cAAA;IACA,SAAA;EAv3FF;;EA03FA;IACE,cAAA;IACA,SAAA;EAx3FF;;EA23FA;IACE,cAAA;IACA,SAAA;EAz3FF;;EA43FA;IACE,eAAA;IACA,UAAA;EA13FF;;EA63FA;IACE,eAAA;IACA,UAAA;EA33FF;;EA83FA;IACE,eAAA;IACA,UAAA;EA53FF;;EA+3FA;IACE,eAAA;IACA,UAAA;EA73FF;;EAg4FA;IACE,aAAA;IACA,QAAA;EA93FF;;EAi4FA;IACE,kBAAA;IACA,aAAA;EA/3FF;;EAk4FA;IACE,wBAAA;IACA,mBAAA;EAh4FF;;EAm4FA;IACE,uBAAA;IACA,kBAAA;EAj4FF;;EAo4FA;IACE,wBAAA;IACA,mBAAA;EAl4FF;;EAq4FA;IACE,qBAAA;IACA,gBAAA;EAn4FF;;EAs4FA;IACE,wBAAA;IACA,mBAAA;EAp4FF;;EAu4FA;IACE,uBAAA;IACA,kBAAA;EAr4FF;;EAw4FA;IACE,qBAAA;IACA,gBAAA;EAt4FF;;EAy4FA;IACE,uBAAA;IACA,kBAAA;EAv4FF;;EA04FA;IACE,qBAAA;IACA,gBAAA;EAx4FF;;EA24FA;IACE,qBAAA;IACA,gBAAA;EAz4FF;;EA44FA;IACE,qBAAA;IACA,gBAAA;EA14FF;;EA64FA;IACE,qBAAA;IACA,gBAAA;EA34FF;;EA84FA;IACE,qBAAA;IACA,gBAAA;EA54FF;;EA+4FA;IACE,sBAAA;IACA,iBAAA;EA74FF;;EAg5FA;IACE,sBAAA;IACA,iBAAA;EA94FF;;EAi5FA;IACE,sBAAA;IACA,iBAAA;EA/4FF;;EAk5FA;IACE,sBAAA;IACA,iBAAA;EAh5FF;;EAm5FA;IACE,oBAAA;IACA,eAAA;EAj5FF;;EAo5FA;IACE,kBAAA;IACA,aAAA;EAl5FF;;EAq5FA;IACE,wBAAA;IACA,mBAAA;EAn5FF;;EAs5FA;IACE,uBAAA;IACA,kBAAA;EAp5FF;;EAu5FA;IACE,wBAAA;IACA,mBAAA;EAr5FF;;EAw5FA;IACE,qBAAA;IACA,gBAAA;EAt5FF;;EAy5FA;IACE,wBAAA;IACA,mBAAA;EAv5FF;;EA05FA;IACE,uBAAA;IACA,kBAAA;EAx5FF;;EA25FA;IACE,qBAAA;IACA,gBAAA;EAz5FF;;EA45FA;IACE,uBAAA;IACA,kBAAA;EA15FF;;EA65FA;IACE,qBAAA;IACA,gBAAA;EA35FF;;EA85FA;IACE,qBAAA;IACA,gBAAA;EA55FF;;EA+5FA;IACE,qBAAA;IACA,gBAAA;EA75FF;;EAg6FA;IACE,qBAAA;IACA,gBAAA;EA95FF;;EAi6FA;IACE,qBAAA;IACA,gBAAA;EA/5FF;;EAk6FA;IACE,sBAAA;IACA,iBAAA;EAh6FF;;EAm6FA;IACE,sBAAA;IACA,iBAAA;EAj6FF;;EAo6FA;IACE,sBAAA;IACA,iBAAA;EAl6FF;;EAq6FA;IACE,sBAAA;IACA,iBAAA;EAn6FF;;EAs6FA;IACE,oBAAA;IACA,eAAA;EAp6FF;;EAu6FA;IACE,eAAA;IACA,UAAA;EAr6FF;;EAw6FA;IACE,qBAAA;IACA,gBAAA;EAt6FF;;EAy6FA;IACE,oBAAA;IACA,eAAA;EAv6FF;;EA06FA;IACE,qBAAA;IACA,gBAAA;EAx6FF;;EA26FA;IACE,kBAAA;IACA,aAAA;EAz6FF;;EA46FA;IACE,qBAAA;IACA,gBAAA;EA16FF;;EA66FA;IACE,oBAAA;IACA,eAAA;EA36FF;;EA86FA;IACE,kBAAA;IACA,aAAA;EA56FF;;EA+6FA;IACE,oBAAA;IACA,eAAA;EA76FF;;EAg7FA;IACE,kBAAA;IACA,aAAA;EA96FF;;EAi7FA;IACE,kBAAA;IACA,aAAA;EA/6FF;;EAk7FA;IACE,kBAAA;IACA,aAAA;EAh7FF;;EAm7FA;IACE,kBAAA;IACA,aAAA;EAj7FF;;EAo7FA;IACE,kBAAA;IACA,aAAA;EAl7FF;;EAq7FA;IACE,mBAAA;IACA,cAAA;EAn7FF;;EAs7FA;IACE,mBAAA;IACA,cAAA;EAp7FF;;EAu7FA;IACE,mBAAA;IACA,cAAA;EAr7FF;;EAw7FA;IACE,mBAAA;IACA,cAAA;EAt7FF;;EAy7FA;IACE,iBAAA;IACA,YAAA;EAv7FF;;EA07FA;IACE,eAAA;IACA,UAAA;EAx7FF;;EA27FA;IACE,qBAAA;IACA,gBAAA;EAz7FF;;EA47FA;IACE,oBAAA;IACA,eAAA;EA17FF;;EA67FA;IACE,qBAAA;IACA,gBAAA;EA37FF;;EA87FA;IACE,kBAAA;IACA,aAAA;EA57FF;;EA+7FA;IACE,qBAAA;IACA,gBAAA;EA77FF;;EAg8FA;IACE,oBAAA;IACA,eAAA;EA97FF;;EAi8FA;IACE,kBAAA;IACA,aAAA;EA/7FF;;EAk8FA;IACE,oBAAA;IACA,eAAA;EAh8FF;;EAm8FA;IACE,kBAAA;IACA,aAAA;EAj8FF;;EAo8FA;IACE,kBAAA;IACA,aAAA;EAl8FF;;EAq8FA;IACE,kBAAA;IACA,aAAA;EAn8FF;;EAs8FA;IACE,kBAAA;IACA,aAAA;EAp8FF;;EAu8FA;IACE,kBAAA;IACA,aAAA;EAr8FF;;EAw8FA;IACE,mBAAA;IACA,cAAA;EAt8FF;;EAy8FA;IACE,mBAAA;IACA,cAAA;EAv8FF;;EA08FA;IACE,mBAAA;IACA,cAAA;EAx8FF;;EA28FA;IACE,mBAAA;IACA,cAAA;EAz8FF;;EA48FA;IACE,iBAAA;IACA,YAAA;EA18FF;;EA68FA;IACE,mBAAA;EA38FF;;EA88FA;IACE,sBAAA;EA58FF;;EA+8FA;IACE,yBAAA;EA78FF;;EAg9FA;IACE,4BAAA;EA98FF;;EAi9FA;IACE,gDAAA;EA/8FF;;EAk9FA;IACE,gDAAA;EAh9FF;;EAm9FA;IACE,gDAAA;EAj9FF;;EAo9FA;IACE,gDAAA;EAl9FF;;EAq9FA;IACE,gDAAA;EAn9FF;;EAs9FA;IACE,gDAAA;EAp9FF;;EAu9FA;IACE,gDAAA;EAr9FF;;EAw9FA;IACE,gDAAA;EAt9FF;;EAy9FA;IACE,gDAAA;EAv9FF;;EA09FA;IACE,iDAAA;EAx9FF;;EA29FA;IACE,iDAAA;EAz9FF;;EA49FA;IACE,iDAAA;EA19FF;;EA69FA;IACE,2BAAA;EA39FF;;EA89FA;IACE,uBAAA;EA59FF;;EA+9FA;IACE,8BAAA;EA79FF;;EAg+FA;IACE,8BAAA;EA99FF;;EAi+FA;IACE,iCAAA;EA/9FF;;EAk+FA;IACE,iBAAA;EAh+FF;;EAm+FA;IACE,0BAAA;EAj+FF;;EAo+FA;IACE,0BAAA;EAl+FF;;EAq+FA;IACE,0BAAA;EAn+FF;;EAs+FA;IACE,0BAAA;EAp+FF;;EAu+FA;IACE,0BAAA;EAr+FF;;EAw+FA;IACE,0BAAA;EAt+FF;;EAy+FA;IACE,0BAAA;EAv+FF;;EA0+FA;IACE,0BAAA;EAx+FF;;EA2+FA;IACE,0BAAA;EAz+FF;;EA4+FA;IACE,4BAAA;EA1+FF;;EA6+FA;IACE,4BAAA;EA3+FF;;EA8+FA;IACE,4BAAA;EA5+FF;;EA++FA;IACE,iBAAA;EA7+FF;;EAg/FA;IACE,oBAAA;EA9+FF;;EAi/FA;IACE,oBAAA;EA/+FF;;EAk/FA;IACE,oBAAA;EAh/FF;;EAm/FA;IACE,oBAAA;EAj/FF;;EAo/FA;IACE,oBAAA;EAl/FF;;EAq/FA;IACE,oBAAA;EAn/FF;;EAs/FA;IACE,oBAAA;EAp/FF;;EAu/FA;IACE,oBAAA;EAr/FF;;EAw/FA;IACE,oBAAA;EAt/FF;;EAy/FA;IACE,qBAAA;EAv/FF;;EA0/FA;IACE,qBAAA;EAx/FF;;EA2/FA;IACE,qBAAA;EAz/FF;;EA4/FA;IACE,qBAAA;EA1/FF;;EA6/FA;IACE,uBAAA;EA3/FF;;EA8/FA;IACE,kBAAA;EA5/FF;;EA+/FA;IACE,kBAAA;EA7/FF;;EAggGA;IACE,kBAAA;EA9/FF;;EAigGA;IACE,kBAAA;EA//FF;;EAkgGA;IACE,kBAAA;EAhgGF;;EAmgGA;IACE,kBAAA;EAjgGF;;EAogGA;IACE,kBAAA;EAlgGF;;EAqgGA;IACE,kBAAA;EAngGF;;EAsgGA;IACE,kBAAA;EApgGF;;EAugGA;IACE,mBAAA;EArgGF;;EAwgGA;IACE,mBAAA;EAtgGF;;EAygGA;IACE,mBAAA;EAvgGF;;EA0gGA;IACE,mBAAA;EAxgGF;;EA2gGA;IACE,qBAAA;EAzgGF;;EA4gGA;IACE,6CAAA;EA1gGF;;EA6gGA;IACE,6CAAA;EA3gGF;;EA8gGA;IACE,6CAAA;EA5gGF;;EA+gGA;IACE,6CAAA;EA7gGF;;EAghGA;IACE,6CAAA;EA9gGF;;EAihGA;IACE,6CAAA;EA/gGF;;EAkhGA;IACE,wBAAA;EAhhGF;;EAmhGA;IACE,oBAAA;EAjhGF;;EAohGA;IACE,2BAAA;EAlhGF;;EAqhGA;IACE,2BAAA;EAnhGF;;EAshGA;IACE,8BAAA;EAphGF;;EAuhGA;IACE,cAAA;EArhGF;;EAwhGA;IACE,uBAAA;EAthGF;;EAyhGA;IACE,uBAAA;EAvhGF;;EA0hGA;IACE,uBAAA;EAxhGF;;EA2hGA;IACE,uBAAA;EAzhGF;;EA4hGA;IACE,uBAAA;EA1hGF;;EA6hGA;IACE,uBAAA;EA3hGF;;EA8hGA;IACE,cAAA;EA5hGF;;EA+hGA;IACE,iBAAA;EA7hGF;;EAgiGA;IACE,iBAAA;EA9hGF;;EAiiGA;IACE,iBAAA;EA/hGF;;EAkiGA;IACE,iBAAA;EAhiGF;;EAmiGA;IACE,iBAAA;EAjiGF;;EAoiGA;IACE,iBAAA;EAliGF;;EAqiGA;IACE,iBAAA;EAniGF;;EAsiGA;IACE,oBAAA;EApiGF;;EAuiGA;IACE,eAAA;EAriGF;;EAwiGA;IACE,eAAA;EAtiGF;;EAyiGA;IACE,eAAA;EAviGF;;EA0iGA;IACE,eAAA;EAxiGF;;EA2iGA;IACE,eAAA;EAziGF;;EA4iGA;IACE,eAAA;EA1iGF;;EA6iGA;IACE,eAAA;EA3iGF;;EA8iGA;IACE,kBAAA;EA5iGF;;EA+iGA;IACE,0BAAA;IACA,0BAAA;IACA,qBAAA;IACA,qBAAA;IACA,qBAAA;IACA,sBAAA;IACA,sBAAA;IACA,4PAAA;EA7iGF;;EAgjGA;IACE,eAAA;EA9iGF;;EAijGA;IACE,wBAAA;EA/iGF;;EAkjGA;IACE,qBAAA;EAhjGF;;EAmjGA;IACE,2BAAA;EAjjGF;;EAojGA;IACE,uBAAA;EAljGF;;EAqjGA;IACE,8BAAA;EAnjGF;;EAsjGA;IACE,wBAAA;EApjGF;;EAujGA;IACE,6BAAA;EArjGF;;EAwjGA;IACE,sBAAA;EAtjGF;;EAyjGA;IACE,0BAAA;EAvjGF;;EA0jGA;IACE,sBAAA;IACA,sBAAA;EAxjGF;;EA2jGA;IACE,uBAAA;IACA,uBAAA;EAzjGF;;EA4jGA;IACE,wBAAA;IACA,wBAAA;EA1jGF;;EA6jGA;IACE,uBAAA;IACA,uBAAA;EA3jGF;;EA8jGA;IACE,wBAAA;IACA,wBAAA;EA5jGF;;EA+jGA;IACE,sBAAA;IACA,sBAAA;EA7jGF;;EAgkGA;IACE,yBAAA;IACA,yBAAA;EA9jGF;;EAikGA;IACE,wBAAA;IACA,wBAAA;EA/jGF;;EAkkGA;IACE,yBAAA;IACA,yBAAA;EAhkGF;;EAmkGA;IACE,wBAAA;IACA,wBAAA;EAjkGF;;EAokGA;IACE,sBAAA;EAlkGF;;EAqkGA;IACE,uBAAA;EAnkGF;;EAskGA;IACE,wBAAA;EApkGF;;EAukGA;IACE,uBAAA;EArkGF;;EAwkGA;IACE,wBAAA;EAtkGF;;EAykGA;IACE,sBAAA;EAvkGF;;EA0kGA;IACE,yBAAA;EAxkGF;;EA2kGA;IACE,wBAAA;EAzkGF;;EA4kGA;IACE,yBAAA;EA1kGF;;EA6kGA;IACE,wBAAA;EA3kGF;;EA8kGA;IACE,sBAAA;EA5kGF;;EA+kGA;IACE,uBAAA;EA7kGF;;EAglGA;IACE,wBAAA;EA9kGF;;EAilGA;IACE,uBAAA;EA/kGF;;EAklGA;IACE,wBAAA;EAhlGF;;EAmlGA;IACE,sBAAA;EAjlGF;;EAolGA;IACE,yBAAA;EAllGF;;EAqlGA;IACE,wBAAA;EAnlGF;;EAslGA;IACE,yBAAA;EAplGF;;EAulGA;IACE,wBAAA;EArlGF;;EAwlGA;IACE,sBAAA;IACA,sBAAA;EAtlGF;;EAylGA;IACE,uBAAA;IACA,uBAAA;EAvlGF;;EA0lGA;IACE,wBAAA;IACA,wBAAA;EAxlGF;;EA2lGA;IACE,uBAAA;IACA,uBAAA;EAzlGF;;EA4lGA;IACE,wBAAA;IACA,wBAAA;EA1lGF;;EA6lGA;IACE,sBAAA;IACA,sBAAA;EA3lGF;;EA8lGA;IACE,yBAAA;IACA,yBAAA;EA5lGF;;EA+lGA;IACE,wBAAA;IACA,wBAAA;EA7lGF;;EAgmGA;IACE,yBAAA;IACA,yBAAA;EA9lGF;;EAimGA;IACE,wBAAA;IACA,wBAAA;EA/lGF;;EAkmGA;IACE,sBAAA;EAhmGF;;EAmmGA;IACE,uBAAA;EAjmGF;;EAomGA;IACE,wBAAA;EAlmGF;;EAqmGA;IACE,uBAAA;EAnmGF;;EAsmGA;IACE,wBAAA;EApmGF;;EAumGA;IACE,sBAAA;EArmGF;;EAwmGA;IACE,yBAAA;EAtmGF;;EAymGA;IACE,wBAAA;EAvmGF;;EA0mGA;IACE,yBAAA;EAxmGF;;EA2mGA;IACE,wBAAA;EAzmGF;;EA4mGA;IACE,sBAAA;EA1mGF;;EA6mGA;IACE,uBAAA;EA3mGF;;EA8mGA;IACE,wBAAA;EA5mGF;;EA+mGA;IACE,uBAAA;EA7mGF;;EAgnGA;IACE,wBAAA;EA9mGF;;EAinGA;IACE,sBAAA;EA/mGF;;EAknGA;IACE,yBAAA;EAhnGF;;EAmnGA;IACE,wBAAA;EAjnGF;;EAonGA;IACE,yBAAA;EAlnGF;;EAqnGA;IACE,wBAAA;EAnnGF;;EAsnGA;IACE,sBAAA;IACA,sBAAA;EApnGF;;EAunGA;IACE,uBAAA;IACA,uBAAA;EArnGF;;EAwnGA;IACE,wBAAA;IACA,wBAAA;EAtnGF;;EAynGA;IACE,uBAAA;IACA,uBAAA;EAvnGF;;EA0nGA;IACE,wBAAA;IACA,wBAAA;EAxnGF;;EA2nGA;IACE,sBAAA;IACA,sBAAA;EAznGF;;EA4nGA;IACE,yBAAA;IACA,yBAAA;EA1nGF;;EA6nGA;IACE,wBAAA;IACA,wBAAA;EA3nGF;;EA8nGA;IACE,yBAAA;IACA,yBAAA;EA5nGF;;EA+nGA;IACE,wBAAA;IACA,wBAAA;EA7nGF;;EAgoGA;IACE,sBAAA;EA9nGF;;EAioGA;IACE,uBAAA;EA/nGF;;EAkoGA;IACE,wBAAA;EAhoGF;;EAmoGA;IACE,uBAAA;EAjoGF;;EAooGA;IACE,wBAAA;EAloGF;;EAqoGA;IACE,sBAAA;EAnoGF;;EAsoGA;IACE,yBAAA;EApoGF;;EAuoGA;IACE,wBAAA;EAroGF;;EAwoGA;IACE,yBAAA;EAtoGF;;EAyoGA;IACE,wBAAA;EAvoGF;;EA0oGA;IACE,sBAAA;EAxoGF;;EA2oGA;IACE,uBAAA;EAzoGF;;EA4oGA;IACE,wBAAA;EA1oGF;;EA6oGA;IACE,uBAAA;EA3oGF;;EA8oGA;IACE,wBAAA;EA5oGF;;EA+oGA;IACE,sBAAA;EA7oGF;;EAgpGA;IACE,yBAAA;EA9oGF;;EAipGA;IACE,wBAAA;EA/oGF;;EAkpGA;IACE,yBAAA;EAhpGF;;EAmpGA;IACE,wBAAA;EAjpGF;;EAopGA;IACE,qBAAA;EAlpGF;;EAqpGA;IACE,wBAAA;EAnpGF;;EAspGA;IACE,wBAAA;EAppGF;;EAupGA;IACE,wBAAA;EArpGF;;EAwpGA;IACE,wBAAA;EAtpGF;;EAypGA;IACE,yBAAA;EAvpGF;;EA0pGA;IACE,yBAAA;EAxpGF;;EA2pGA;IACE,yBAAA;EAzpGF;;EA4pGA;IACE,0BAAA;EA1pGF;;EA6pGA;IACE,2BAAA;EA3pGF;;EA8pGA;IACE,0BAAA;EA5pGF;;EA+pGA;IACE,0BAAA;EA7pGF;;EAgqGA;IACE,0BAAA;EA9pGF;;EAiqGA;IACE,yBAAA;EA/pGF;;EAkqGA;IACE,yBAAA;EAhqGF;;EAmqGA;IACE,yBAAA;EAjqGF;;EAoqGA;IACE,yBAAA;EAlqGF;;EAqqGA;IACE,qBAAA;EAnqGF;;EAsqGA;IACE,wBAAA;EApqGF;;EAuqGA;IACE,wBAAA;EArqGF;;EAwqGA;IACE,wBAAA;EAtqGF;;EAyqGA;IACE,wBAAA;EAvqGF;;EA0qGA;IACE,yBAAA;EAxqGF;;EA2qGA;IACE,yBAAA;EAzqGF;;EA4qGA;IACE,yBAAA;EA1qGF;;EA6qGA;IACE,0BAAA;EA3qGF;;EA8qGA;IACE,2BAAA;EA5qGF;;EA+qGA;IACE,0BAAA;EA7qGF;;EAgrGA;IACE,0BAAA;EA9qGF;;EAirGA;IACE,0BAAA;EA/qGF;;EAkrGA;IACE,yBAAA;EAhrGF;;EAmrGA;IACE,yBAAA;EAjrGF;;EAorGA;IACE,yBAAA;EAlrGF;;EAqrGA;IACE,yBAAA;EAnrGF;;EAsrGA;IACE,qBAAA;EAprGF;;EAurGA;IACE,wBAAA;EArrGF;;EAwrGA;IACE,wBAAA;EAtrGF;;EAyrGA;IACE,wBAAA;EAvrGF;;EA0rGA;IACE,wBAAA;EAxrGF;;EA2rGA;IACE,yBAAA;EAzrGF;;EA4rGA;IACE,yBAAA;EA1rGF;;EA6rGA;IACE,yBAAA;EA3rGF;;EA8rGA;IACE,0BAAA;EA5rGF;;EA+rGA;IACE,2BAAA;EA7rGF;;EAgsGA;IACE,0BAAA;EA9rGF;;EAisGA;IACE,0BAAA;EA/rGF;;EAksGA;IACE,0BAAA;EAhsGF;;EAmsGA;IACE,yBAAA;EAjsGF;;EAosGA;IACE,yBAAA;EAlsGF;;EAqsGA;IACE,yBAAA;EAnsGF;;EAssGA;IACE,yBAAA;EApsGF;;EAusGA;IACE,0BAAA;EArsGF;;EAwsGA;IACE,gCAAA;EAtsGF;;EAysGA;IACE,+BAAA;EAvsGF;;EA0sGA;IACE,gCAAA;EAxsGF;;EA2sGA;IACE,6BAAA;EAzsGF;;EA4sGA;IACE,gCAAA;EA1sGF;;EA6sGA;IACE,+BAAA;EA3sGF;;EA8sGA;IACE,6BAAA;EA5sGF;;EA+sGA;IACE,+BAAA;EA7sGF;;EAgtGA;IACE,6BAAA;EA9sGF;;EAitGA;IACE,6BAAA;EA/sGF;;EAktGA;IACE,6BAAA;EAhtGF;;EAmtGA;IACE,6BAAA;EAjtGF;;EAotGA;IACE,6BAAA;EAltGF;;EAqtGA;IACE,8BAAA;EAntGF;;EAstGA;IACE,8BAAA;EAptGF;;EAutGA;IACE,8BAAA;EArtGF;;EAwtGA;IACE,8BAAA;EAttGF;;EAytGA;IACE,4BAAA;EAvtGF;;EA0tGA;IACE,iCAAA;EAxtGF;;EA2tGA;IACE,gCAAA;EAztGF;;EA4tGA;IACE,iCAAA;EA1tGF;;EA6tGA;IACE,8BAAA;EA3tGF;;EA8tGA;IACE,iCAAA;EA5tGF;;EA+tGA;IACE,gCAAA;EA7tGF;;EAguGA;IACE,8BAAA;EA9tGF;;EAiuGA;IACE,gCAAA;EA/tGF;;EAkuGA;IACE,8BAAA;EAhuGF;;EAmuGA;IACE,8BAAA;EAjuGF;;EAouGA;IACE,8BAAA;EAluGF;;EAquGA;IACE,8BAAA;EAnuGF;;EAsuGA;IACE,8BAAA;EApuGF;;EAuuGA;IACE,+BAAA;EAruGF;;EAwuGA;IACE,+BAAA;EAtuGF;;EAyuGA;IACE,+BAAA;EAvuGF;;EA0uGA;IACE,+BAAA;EAxuGF;;EA2uGA;IACE,6BAAA;EAzuGF;;EA4uGA;IACE,8BAAA;EA1uGF;;EA6uGA;IACE,6BAAA;EA3uGF;;EA8uGA;IACE,4BAAA;EA5uGF;;EA+uGA;IACE,6BAAA;EA7uGF;;EAgvGA;IACE,0BAAA;EA9uGF;;EAivGA;IACE,gCAAA;EA/uGF;;EAkvGA;IACE,+BAAA;EAhvGF;;EAmvGA;IACE,gCAAA;EAjvGF;;EAovGA;IACE,6BAAA;EAlvGF;;EAqvGA;IACE,gCAAA;EAnvGF;;EAsvGA;IACE,+BAAA;EApvGF;;EAuvGA;IACE,6BAAA;EArvGF;;EAwvGA;IACE,+BAAA;EAtvGF;;EAyvGA;IACE,6BAAA;EAvvGF;;EA0vGA;IACE,6BAAA;EAxvGF;;EA2vGA;IACE,6BAAA;EAzvGF;;EA4vGA;IACE,6BAAA;EA1vGF;;EA6vGA;IACE,6BAAA;EA3vGF;;EA8vGA;IACE,8BAAA;EA5vGF;;EA+vGA;IACE,8BAAA;EA7vGF;;EAgwGA;IACE,8BAAA;EA9vGF;;EAiwGA;IACE,8BAAA;EA/vGF;;EAkwGA;IACE,4BAAA;EAhwGF;;EAmwGA;IACE,iCAAA;EAjwGF;;EAowGA;IACE,gCAAA;EAlwGF;;EAqwGA;IACE,iCAAA;EAnwGF;;EAswGA;IACE,8BAAA;EApwGF;;EAuwGA;IACE,iCAAA;EArwGF;;EAwwGA;IACE,gCAAA;EAtwGF;;EAywGA;IACE,8BAAA;EAvwGF;;EA0wGA;IACE,gCAAA;EAxwGF;;EA2wGA;IACE,8BAAA;EAzwGF;;EA4wGA;IACE,8BAAA;EA1wGF;;EA6wGA;IACE,8BAAA;EA3wGF;;EA8wGA;IACE,8BAAA;EA5wGF;;EA+wGA;IACE,8BAAA;EA7wGF;;EAgxGA;IACE,+BAAA;EA9wGF;;EAixGA;IACE,+BAAA;EA/wGF;;EAkxGA;IACE,+BAAA;EAhxGF;;EAmxGA;IACE,+BAAA;EAjxGF;;EAoxGA;IACE,6BAAA;EAlxGF;;EAqxGA;IACE,8BAAA;EAnxGF;;EAsxGA;IACE,6BAAA;EApxGF;;EAuxGA;IACE,4BAAA;EArxGF;;EAwxGA;IACE,6BAAA;EAtxGF;;EAyxGA;IACE,0BAAA;EAvxGF;;EA0xGA;IACE,gCAAA;EAxxGF;;EA2xGA;IACE,+BAAA;EAzxGF;;EA4xGA;IACE,gCAAA;EA1xGF;;EA6xGA;IACE,6BAAA;EA3xGF;;EA8xGA;IACE,gCAAA;EA5xGF;;EA+xGA;IACE,+BAAA;EA7xGF;;EAgyGA;IACE,6BAAA;EA9xGF;;EAiyGA;IACE,+BAAA;EA/xGF;;EAkyGA;IACE,6BAAA;EAhyGF;;EAmyGA;IACE,6BAAA;EAjyGF;;EAoyGA;IACE,6BAAA;EAlyGF;;EAqyGA;IACE,6BAAA;EAnyGF;;EAsyGA;IACE,6BAAA;EApyGF;;EAuyGA;IACE,8BAAA;EAryGF;;EAwyGA;IACE,8BAAA;EAtyGF;;EAyyGA;IACE,8BAAA;EAvyGF;;EA0yGA;IACE,8BAAA;EAxyGF;;EA2yGA;IACE,4BAAA;EAzyGF;;EA4yGA;IACE,iCAAA;EA1yGF;;EA6yGA;IACE,gCAAA;EA3yGF;;EA8yGA;IACE,iCAAA;EA5yGF;;EA+yGA;IACE,8BAAA;EA7yGF;;EAgzGA;IACE,iCAAA;EA9yGF;;EAizGA;IACE,gCAAA;EA/yGF;;EAkzGA;IACE,8BAAA;EAhzGF;;EAmzGA;IACE,gCAAA;EAjzGF;;EAozGA;IACE,8BAAA;EAlzGF;;EAqzGA;IACE,8BAAA;EAnzGF;;EAszGA;IACE,8BAAA;EApzGF;;EAuzGA;IACE,8BAAA;EArzGF;;EAwzGA;IACE,8BAAA;EAtzGF;;EAyzGA;IACE,+BAAA;EAvzGF;;EA0zGA;IACE,+BAAA;EAxzGF;;EA2zGA;IACE,+BAAA;EAzzGF;;EA4zGA;IACE,+BAAA;EA1zGF;;EA6zGA;IACE,6BAAA;EA3zGF;;EA8zGA;IACE,8BAAA;EA5zGF;;EA+zGA;IACE,6BAAA;EA7zGF;;EAg0GA;IACE,4BAAA;EA9zGF;;EAi0GA;IACE,6BAAA;EA/zGF;;EAk0GA;IACE,0BAAA;EAh0GF;;EAm0GA;IACE,gCAAA;EAj0GF;;EAo0GA;IACE,+BAAA;EAl0GF;;EAq0GA;IACE,gCAAA;EAn0GF;;EAs0GA;IACE,6BAAA;EAp0GF;;EAu0GA;IACE,gCAAA;EAr0GF;;EAw0GA;IACE,+BAAA;EAt0GF;;EAy0GA;IACE,6BAAA;EAv0GF;;EA00GA;IACE,+BAAA;EAx0GF;;EA20GA;IACE,6BAAA;EAz0GF;;EA40GA;IACE,6BAAA;EA10GF;;EA60GA;IACE,6BAAA;EA30GF;;EA80GA;IACE,6BAAA;EA50GF;;EA+0GA;IACE,6BAAA;EA70GF;;EAg1GA;IACE,8BAAA;EA90GF;;EAi1GA;IACE,8BAAA;EA/0GF;;EAk1GA;IACE,8BAAA;EAh1GF;;EAm1GA;IACE,8BAAA;EAj1GF;;EAo1GA;IACE,4BAAA;EAl1GF;;EAq1GA;IACE,iCAAA;EAn1GF;;EAs1GA;IACE,gCAAA;EAp1GF;;EAu1GA;IACE,iCAAA;EAr1GF;;EAw1GA;IACE,8BAAA;EAt1GF;;EAy1GA;IACE,iCAAA;EAv1GF;;EA01GA;IACE,gCAAA;EAx1GF;;EA21GA;IACE,8BAAA;EAz1GF;;EA41GA;IACE,gCAAA;EA11GF;;EA61GA;IACE,8BAAA;EA31GF;;EA81GA;IACE,8BAAA;EA51GF;;EA+1GA;IACE,8BAAA;EA71GF;;EAg2GA;IACE,8BAAA;EA91GF;;EAi2GA;IACE,8BAAA;EA/1GF;;EAk2GA;IACE,+BAAA;EAh2GF;;EAm2GA;IACE,+BAAA;EAj2GF;;EAo2GA;IACE,+BAAA;EAl2GF;;EAq2GA;IACE,+BAAA;EAn2GF;;EAs2GA;IACE,6BAAA;EAp2GF;;EAu2GA;IACE,8BAAA;EAr2GF;;EAw2GA;IACE,6BAAA;EAt2GF;;EAy2GA;IACE,4BAAA;EAv2GF;;EA02GA;IACE,6BAAA;EAx2GF;;EA22GA;IACE,0BAAA;EAz2GF;;EA42GA;IACE,gCAAA;EA12GF;;EA62GA;IACE,+BAAA;EA32GF;;EA82GA;IACE,gCAAA;EA52GF;;EA+2GA;IACE,6BAAA;EA72GF;;EAg3GA;IACE,gCAAA;EA92GF;;EAi3GA;IACE,+BAAA;EA/2GF;;EAk3GA;IACE,6BAAA;EAh3GF;;EAm3GA;IACE,+BAAA;EAj3GF;;EAo3GA;IACE,6BAAA;EAl3GF;;EAq3GA;IACE,6BAAA;EAn3GF;;EAs3GA;IACE,6BAAA;EAp3GF;;EAu3GA;IACE,6BAAA;EAr3GF;;EAw3GA;IACE,6BAAA;EAt3GF;;EAy3GA;IACE,8BAAA;EAv3GF;;EA03GA;IACE,8BAAA;EAx3GF;;EA23GA;IACE,8BAAA;EAz3GF;;EA43GA;IACE,8BAAA;EA13GF;;EA63GA;IACE,4BAAA;EA33GF;;EA83GA;IACE,iCAAA;EA53GF;;EA+3GA;IACE,gCAAA;EA73GF;;EAg4GA;IACE,iCAAA;EA93GF;;EAi4GA;IACE,8BAAA;EA/3GF;;EAk4GA;IACE,iCAAA;EAh4GF;;EAm4GA;IACE,gCAAA;EAj4GF;;EAo4GA;IACE,8BAAA;EAl4GF;;EAq4GA;IACE,gCAAA;EAn4GF;;EAs4GA;IACE,8BAAA;EAp4GF;;EAu4GA;IACE,8BAAA;EAr4GF;;EAw4GA;IACE,8BAAA;EAt4GF;;EAy4GA;IACE,8BAAA;EAv4GF;;EA04GA;IACE,8BAAA;EAx4GF;;EA24GA;IACE,+BAAA;EAz4GF;;EA44GA;IACE,+BAAA;EA14GF;;EA64GA;IACE,+BAAA;EA34GF;;EA84GA;IACE,+BAAA;EA54GF;;EA+4GA;IACE,6BAAA;EA74GF;;EAg5GA;IACE,8BAAA;EA94GF;;EAi5GA;IACE,6BAAA;EA/4GF;;EAk5GA;IACE,4BAAA;EAh5GF;;EAm5GA;IACE,6BAAA;EAj5GF;;EAo5GA;IACE,0BAAA;EAl5GF;;EAq5GA;IACE,gCAAA;EAn5GF;;EAs5GA;IACE,+BAAA;EAp5GF;;EAu5GA;IACE,gCAAA;EAr5GF;;EAw5GA;IACE,6BAAA;EAt5GF;;EAy5GA;IACE,gCAAA;EAv5GF;;EA05GA;IACE,+BAAA;EAx5GF;;EA25GA;IACE,6BAAA;EAz5GF;;EA45GA;IACE,+BAAA;EA15GF;;EA65GA;IACE,6BAAA;EA35GF;;EA85GA;IACE,6BAAA;EA55GF;;EA+5GA;IACE,6BAAA;EA75GF;;EAg6GA;IACE,6BAAA;EA95GF;;EAi6GA;IACE,6BAAA;EA/5GF;;EAk6GA;IACE,8BAAA;EAh6GF;;EAm6GA;IACE,8BAAA;EAj6GF;;EAo6GA;IACE,8BAAA;EAl6GF;;EAq6GA;IACE,8BAAA;EAn6GF;;EAs6GA;IACE,4BAAA;EAp6GF;;EAu6GA;IACE,iCAAA;EAr6GF;;EAw6GA;IACE,gCAAA;EAt6GF;;EAy6GA;IACE,iCAAA;EAv6GF;;EA06GA;IACE,8BAAA;EAx6GF;;EA26GA;IACE,iCAAA;EAz6GF;;EA46GA;IACE,gCAAA;EA16GF;;EA66GA;IACE,8BAAA;EA36GF;;EA86GA;IACE,gCAAA;EA56GF;;EA+6GA;IACE,8BAAA;EA76GF;;EAg7GA;IACE,8BAAA;EA96GF;;EAi7GA;IACE,8BAAA;EA/6GF;;EAk7GA;IACE,8BAAA;EAh7GF;;EAm7GA;IACE,8BAAA;EAj7GF;;EAo7GA;IACE,+BAAA;EAl7GF;;EAq7GA;IACE,+BAAA;EAn7GF;;EAs7GA;IACE,+BAAA;EAp7GF;;EAu7GA;IACE,+BAAA;EAr7GF;;EAw7GA;IACE,6BAAA;EAt7GF;;EAy7GA;IACE,8BAAA;EAv7GF;;EA07GA;IACE,6BAAA;EAx7GF;;EA27GA;IACE,4BAAA;EAz7GF;;EA47GA;IACE,6BAAA;EA17GF;;EA67GA;IACE,qBAAA;EA37GF;;EA87GA;IACE,wBAAA;EA57GF;;EA+7GA;IACE,wBAAA;EA77GF;;EAg8GA;IACE,wBAAA;EA97GF;;EAi8GA;IACE,wBAAA;EA/7GF;;EAk8GA;IACE,yBAAA;EAh8GF;;EAm8GA;IACE,0BAAA;EAj8GF;;EAo8GA;IACE,yBAAA;EAl8GF;;EAq8GA;IACE,yBAAA;EAn8GF;;EAs8GA;IACE,yBAAA;EAp8GF;;EAu8GA;IACE,yBAAA;EAr8GF;;EAw8GA;IACE,qBAAA;EAt8GF;;EAy8GA;IACE,wBAAA;EAv8GF;;EA08GA;IACE,wBAAA;EAx8GF;;EA28GA;IACE,wBAAA;EAz8GF;;EA48GA;IACE,wBAAA;EA18GF;;EA68GA;IACE,yBAAA;EA38GF;;EA88GA;IACE,0BAAA;EA58GF;;EA+8GA;IACE,yBAAA;EA78GF;;EAg9GA;IACE,yBAAA;EA98GF;;EAi9GA;IACE,yBAAA;EA/8GF;;EAk9GA;IACE,yBAAA;EAh9GF;;EAm9GA;IACE,qBAAA;EAj9GF;;EAo9GA;IACE,wBAAA;EAl9GF;;EAq9GA;IACE,wBAAA;EAn9GF;;EAs9GA;IACE,wBAAA;EAp9GF;;EAu9GA;IACE,wBAAA;EAr9GF;;EAw9GA;IACE,yBAAA;EAt9GF;;EAy9GA;IACE,0BAAA;EAv9GF;;EA09GA;IACE,yBAAA;EAx9GF;;EA29GA;IACE,yBAAA;EAz9GF;;EA49GA;IACE,yBAAA;EA19GF;;EA69GA;IACE,yBAAA;EA39GF;;EA89GA;IACE,qBAAA;EA59GF;;EA+9GA;IACE,wBAAA;EA79GF;;EAg+GA;IACE,wBAAA;EA99GF;;EAi+GA;IACE,wBAAA;EA/9GF;;EAk+GA;IACE,wBAAA;EAh+GF;;EAm+GA;IACE,yBAAA;EAj+GF;;EAo+GA;IACE,0BAAA;EAl+GF;;EAq+GA;IACE,yBAAA;EAn+GF;;EAs+GA;IACE,yBAAA;EAp+GF;;EAu+GA;IACE,yBAAA;EAr+GF;;EAw+GA;IACE,yBAAA;EAt+GF;;EAy+GA;IACE,qBAAA;EAv+GF;;EA0+GA;IACE,wBAAA;EAx+GF;;EA2+GA;IACE,wBAAA;EAz+GF;;EA4+GA;IACE,wBAAA;EA1+GF;;EA6+GA;IACE,wBAAA;EA3+GF;;EA8+GA;IACE,yBAAA;EA5+GF;;EA++GA;IACE,0BAAA;EA7+GF;;EAg/GA;IACE,yBAAA;EA9+GF;;EAi/GA;IACE,yBAAA;EA/+GF;;EAk/GA;IACE,yBAAA;EAh/GF;;EAm/GA;IACE,yBAAA;EAj/GF;;EAo/GA;IACE,qBAAA;EAl/GF;;EAq/GA;IACE,wBAAA;EAn/GF;;EAs/GA;IACE,wBAAA;EAp/GF;;EAu/GA;IACE,wBAAA;EAr/GF;;EAw/GA;IACE,wBAAA;EAt/GF;;EAy/GA;IACE,yBAAA;EAv/GF;;EA0/GA;IACE,0BAAA;EAx/GF;;EA2/GA;IACE,yBAAA;EAz/GF;;EA4/GA;IACE,yBAAA;EA1/GF;;EA6/GA;IACE,yBAAA;EA3/GF;;EA8/GA;IACE,yBAAA;EA5/GF;;EA+/GA;IACE,yBAAA;EA7/GF;;EAggHA;IACE,wBAAA;EA9/GF;;EAigHA;IACE,wGAAA;EA//GF;;EAkgHA;IACE,wEAAA;EAhgHF;;EAmgHA;IACE,4BAAA;EAjgHF;;EAogHA;IACE,+BAAA;EAlgHF;;EAqgHA;IACE,8BAAA;EAngHF;;EAsgHA;IACE,kCAAA;EApgHF;;EAugHA;IACE,sDAAA;EArgHF;;EAwgHA;IACE,sDAAA;EAtgHF;;EAygHA;IACE,wDAAA;EAvgHF;;EA0gHA;IACE,yBAAA;EAxgHF;;EA2gHA;IACE,0BAAA;EAzgHF;;EA4gHA;IACE,0BAAA;EA1gHF;;EA6gHA;IACE,0BAAA;EA3gHF;;EA8gHA;IACE,0BAAA;EA5gHF;;EA+gHA;IACE,0BAAA;EA7gHF;;EAghHA;IACE,0BAAA;EA9gHF;;EAihHA;IACE,2BAAA;EA/gHF;;EAkhHA;IACE,sBAAA;EAhhHF;;EAmhHA;IACE,uBAAA;EAjhHF;;EAohHA;IACE,uBAAA;EAlhHF;;EAqhHA;IACE,uBAAA;EAnhHF;;EAshHA;IACE,uBAAA;EAphHF;;EAuhHA;IACE,uBAAA;EArhHF;;EAwhHA;IACE,uBAAA;EAthHF;;EAyhHA;IACE,wBAAA;EAvhHF;;EA0hHA;IACE,eAAA;EAxhHF;;EA2hHA;IACE,kCAAA;EAzhHF;;EA4hHA;IACE,sDAAA;EA1hHF;;EA6hHA;IACE,yDAAA;EA3hHF;;EA8hHA;IACE,6BAAA;EA5hHF;AACF;;AA+hHA;EACE;IACE,WAAA;EA7hHF;AACF;;AA+hHE;EACE;IACE,gBAAA;EA7hHJ;AACF;;AAgiHE;EACE;IACE,gBAAA;EA9hHJ;AACF;;AAiiHE;EACE;IACE,iBAAA;EA/hHJ;AACF;;AAkiHE;EACE;IACE,iBAAA;EAhiHJ;AACF;;AAsgHA;EA6BE;IACE,oBAAA;IACA,oDAAA;IACA,iDAAA;EAhiHF;;EAmiHA;IACE,oBAAA;IACA,gDAAA;IACA,qDAAA;EAjiHF;;EAoiHA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAliHF;;EAqiHA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAniHF;;EAsiHA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EApiHF;;EAuiHA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAriHF;;EAwiHA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAtiHF;;EAyiHA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAviHF;;EA0iHA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAxiHF;;EA2iHA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAziHF;;EA4iHA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EA1iHF;;EA6iHA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EA3iHF;;EA8iHA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EA5iHF;;EA+iHA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EA7iHF;;EAgjHA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EA9iHF;;EAijHA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA/iHF;;EAkjHA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAhjHF;;EAmjHA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAjjHF;;EAojHA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAljHF;;EAqjHA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAnjHF;;EAsjHA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EApjHF;;EAujHA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EArjHF;;EAwjHA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAtjHF;;EAyjHA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAvjHF;;EA0jHA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAxjHF;;EA2jHA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAzjHF;;EA4jHA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EA1jHF;;EA6jHA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA3jHF;;EA8jHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA5jHF;;EA+jHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA7jHF;;EAgkHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA9jHF;;EAikHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA/jHF;;EAkkHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAhkHF;;EAmkHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAjkHF;;EAokHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAlkHF;;EAqkHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAnkHF;;EAskHA;IACE,oBAAA;IACA,oDAAA;IACA,iDAAA;EApkHF;;EAukHA;IACE,oBAAA;IACA,gDAAA;IACA,qDAAA;EArkHF;;EAwkHA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EAtkHF;;EAykHA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EAvkHF;;EA0kHA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAxkHF;;EA2kHA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAzkHF;;EA4kHA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EA1kHF;;EA6kHA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EA3kHF;;EA8kHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA5kHF;;EA+kHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA7kHF;;EAglHA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EA9kHF;;EAilHA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EA/kHF;;EAklHA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAhlHF;;EAmlHA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAjlHF;;EAolHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAllHF;;EAqlHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAnlHF;;EAslHA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAplHF;;EAulHA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EArlHF;;EAwlHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAtlHF;;EAylHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAvlHF;;EA0lHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAxlHF;;EA2lHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAzlHF;;EA4lHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA1lHF;;EA6lHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA3lHF;;EA8lHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA5lHF;;EA+lHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA7lHF;;EAgmHA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA9lHF;;EAimHA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA/lHF;;EAkmHA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAhmHF;;EAmmHA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAjmHF;;EAomHA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAlmHF;;EAqmHA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAnmHF;;EAsmHA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EApmHF;;EAumHA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EArmHF;;EAwmHA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAtmHF;;EAymHA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAvmHF;;EA0mHA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAxmHF;;EA2mHA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAzmHF;;EA4mHA;IACE,oBAAA;EA1mHF;;EA6mHA;IACE,oBAAA;EA3mHF;;EA8mHA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA5mHF;;EA+mHA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EA7mHF;;EAgnHA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA9mHF;;EAinHA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EA/mHF;;EAknHA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EAhnHF;;EAmnHA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAjnHF;;EAonHA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EAlnHF;;EAqnHA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAnnHF;;EAsnHA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EApnHF;;EAunHA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EArnHF;;EAwnHA;IACE,qBAAA;EAtnHF;;EAynHA;IACE,qBAAA;EAvnHF;;EA0nHA;IACE,yBAAA;EAxnHF;;EA2nHA;IACE,0BAAA;EAznHF;;EA4nHA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EA1nHF;;EA6nHA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EA3nHF;;EA8nHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5nHF;;EA+nHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7nHF;;EAgoHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9nHF;;EAioHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/nHF;;EAkoHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhoHF;;EAmoHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjoHF;;EAooHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAloHF;;EAqoHA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAnoHF;;EAsoHA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EApoHF;;EAuoHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAroHF;;EAwoHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtoHF;;EAyoHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvoHF;;EA0oHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxoHF;;EA2oHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzoHF;;EA4oHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1oHF;;EA6oHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3oHF;;EA8oHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5oHF;;EA+oHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7oHF;;EAgpHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9oHF;;EAipHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/oHF;;EAkpHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhpHF;;EAmpHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjpHF;;EAopHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlpHF;;EAqpHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnpHF;;EAspHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAppHF;;EAupHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EArpHF;;EAwpHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtpHF;;EAypHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvpHF;;EA0pHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxpHF;;EA2pHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzpHF;;EA4pHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1pHF;;EA6pHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3pHF;;EA8pHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5pHF;;EA+pHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7pHF;;EAgqHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9pHF;;EAiqHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/pHF;;EAkqHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhqHF;;EAmqHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjqHF;;EAoqHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlqHF;;EAqqHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnqHF;;EAsqHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApqHF;;EAuqHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArqHF;;EAwqHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtqHF;;EAyqHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvqHF;;EA0qHA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAxqHF;;EA2qHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzqHF;;EA4qHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1qHF;;EA6qHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3qHF;;EA8qHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5qHF;;EA+qHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7qHF;;EAgrHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9qHF;;EAirHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/qHF;;EAkrHA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAhrHF;;EAmrHA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAjrHF;;EAorHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlrHF;;EAqrHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnrHF;;EAsrHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAprHF;;EAurHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArrHF;;EAwrHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtrHF;;EAyrHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvrHF;;EA0rHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxrHF;;EA2rHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzrHF;;EA4rHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1rHF;;EA6rHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3rHF;;EA8rHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5rHF;;EA+rHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7rHF;;EAgsHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9rHF;;EAisHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/rHF;;EAksHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhsHF;;EAmsHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjsHF;;EAosHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAlsHF;;EAqsHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnsHF;;EAssHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApsHF;;EAusHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArsHF;;EAwsHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtsHF;;EAysHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvsHF;;EA0sHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxsHF;;EA2sHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzsHF;;EA4sHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1sHF;;EA6sHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3sHF;;EA8sHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5sHF;;EA+sHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7sHF;;EAgtHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9sHF;;EAitHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/sHF;;EAktHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhtHF;;EAmtHA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjtHF;;EAotHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAltHF;;EAqtHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAntHF;;EAstHA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAptHF;;EAutHA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EArtHF;;EAwtHA;IACE,mBAAA;EAttHF;;EAytHA;IACE,oBAAA;EAvtHF;;EA0tHA;IACE,oBAAA;EAxtHF;;EA2tHA;IACE,oBAAA;EAztHF;;EA4tHA;IACE,kBAAA;EA1tHF;;EA6tHA;IACE,mBAAA;EA3tHF;;EA8tHA;IACE,sBAAA;EA5tHF;;EA+tHA;IACE,qBAAA;EA7tHF;;EAguHA;IACE,sBAAA;EA9tHF;;EAiuHA;IACE,mBAAA;EA/tHF;;EAkuHA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;EAhuHF;;EAmuHA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EAjuHF;;EAouHA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;EAluHF;;EAquHA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EAnuHF;;EAsuHA;IACE,gBAAA;EApuHF;;EAuuHA;IACE,4BAAA;EAruHF;;EAwuHA;IACE,4BAAA;EAtuHF;;EAyuHA;IACE,6BAAA;EAvuHF;;EA0uHA;IACE,2BAAA;EAxuHF;;EA2uHA;IACE,4BAAA;EAzuHF;;EA4uHA;IACE,4BAAA;EA1uHF;;EA6uHA;IACE,6BAAA;IACQ,qBAAA;EA3uHV;;EA8uHA;IACE,6BAAA;EA5uHF;;EA+uHA;IACE,8BAAA;EA7uHF;;EAgvHA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA9uHF;;EAivHA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA/uHF;;EAkvHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhvHF;;EAmvHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjvHF;;EAovHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlvHF;;EAqvHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnvHF;;EAsvHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApvHF;;EAuvHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArvHF;;EAwvHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtvHF;;EAyvHA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAvvHF;;EA0vHA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAxvHF;;EA2vHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzvHF;;EA4vHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1vHF;;EA6vHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3vHF;;EA8vHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5vHF;;EA+vHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7vHF;;EAgwHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9vHF;;EAiwHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/vHF;;EAkwHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAhwHF;;EAmwHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAjwHF;;EAowHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlwHF;;EAqwHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnwHF;;EAswHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApwHF;;EAuwHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EArwHF;;EAwwHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtwHF;;EAywHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvwHF;;EA0wHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxwHF;;EA2wHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAzwHF;;EA4wHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1wHF;;EA6wHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3wHF;;EA8wHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5wHF;;EA+wHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7wHF;;EAgxHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9wHF;;EAixHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/wHF;;EAkxHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhxHF;;EAmxHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjxHF;;EAoxHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAlxHF;;EAqxHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAnxHF;;EAsxHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApxHF;;EAuxHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArxHF;;EAwxHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtxHF;;EAyxHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvxHF;;EA0xHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxxHF;;EA2xHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAzxHF;;EA4xHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1xHF;;EA6xHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3xHF;;EA8xHA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA5xHF;;EA+xHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7xHF;;EAgyHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9xHF;;EAiyHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/xHF;;EAkyHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhyHF;;EAmyHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjyHF;;EAoyHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAlyHF;;EAqyHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAnyHF;;EAsyHA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EApyHF;;EAuyHA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAryHF;;EAwyHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtyHF;;EAyyHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvyHF;;EA0yHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxyHF;;EA2yHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAzyHF;;EA4yHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1yHF;;EA6yHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA3yHF;;EA8yHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5yHF;;EA+yHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7yHF;;EAgzHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9yHF;;EAizHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/yHF;;EAkzHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhzHF;;EAmzHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjzHF;;EAozHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlzHF;;EAqzHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnzHF;;EAszHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApzHF;;EAuzHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EArzHF;;EAwzHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtzHF;;EAyzHA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvzHF;;EA0zHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxzHF;;EA2zHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzzHF;;EA4zHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1zHF;;EA6zHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3zHF;;EA8zHA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5zHF;;EA+zHA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7zHF;;EAg0HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9zHF;;EAi0HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/zHF;;EAk0HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAh0HF;;EAm0HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj0HF;;EAo0HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl0HF;;EAq0HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn0HF;;EAs0HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp0HF;;EAu0HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr0HF;;EAw0HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt0HF;;EAy0HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAv0HF;;EA00HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAx0HF;;EA20HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAz0HF;;EA40HA;IACE,6BAAA;EA10HF;;EA60HA;IACE,8BAAA;EA30HF;;EA80HA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA50HF;;EA+0HA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA70HF;;EAg1HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA90HF;;EAi1HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/0HF;;EAk1HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh1HF;;EAm1HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj1HF;;EAo1HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl1HF;;EAq1HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn1HF;;EAs1HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAp1HF;;EAu1HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAr1HF;;EAw1HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAt1HF;;EAy1HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv1HF;;EA01HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx1HF;;EA21HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz1HF;;EA41HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA11HF;;EA61HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA31HF;;EA81HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA51HF;;EA+1HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA71HF;;EAg2HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA91HF;;EAi2HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/1HF;;EAk2HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh2HF;;EAm2HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj2HF;;EAo2HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl2HF;;EAq2HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn2HF;;EAs2HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp2HF;;EAu2HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr2HF;;EAw2HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAt2HF;;EAy2HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAv2HF;;EA02HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAx2HF;;EA22HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz2HF;;EA42HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA12HF;;EA62HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA32HF;;EA82HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA52HF;;EA+2HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA72HF;;EAg3HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA92HF;;EAi3HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/2HF;;EAk3HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAh3HF;;EAm3HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAj3HF;;EAo3HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl3HF;;EAq3HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn3HF;;EAs3HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp3HF;;EAu3HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr3HF;;EAw3HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt3HF;;EAy3HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAv3HF;;EA03HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAx3HF;;EA23HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAz3HF;;EA43HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA13HF;;EA63HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA33HF;;EA83HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA53HF;;EA+3HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA73HF;;EAg4HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA93HF;;EAi4HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/3HF;;EAk4HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAh4HF;;EAm4HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAj4HF;;EAo4HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAl4HF;;EAq4HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAn4HF;;EAs4HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp4HF;;EAu4HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr4HF;;EAw4HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt4HF;;EAy4HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAv4HF;;EA04HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAx4HF;;EA24HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAz4HF;;EA44HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA14HF;;EA64HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA34HF;;EA84HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA54HF;;EA+4HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA74HF;;EAg5HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA94HF;;EAi5HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/4HF;;EAk5HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh5HF;;EAm5HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj5HF;;EAo5HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAl5HF;;EAq5HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAn5HF;;EAs5HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAp5HF;;EAu5HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAr5HF;;EAw5HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt5HF;;EAy5HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv5HF;;EA05HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx5HF;;EA25HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz5HF;;EA45HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA15HF;;EA65HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA35HF;;EA85HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA55HF;;EA+5HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA75HF;;EAg6HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA95HF;;EAi6HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/5HF;;EAk6HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh6HF;;EAm6HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj6HF;;EAo6HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl6HF;;EAq6HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn6HF;;EAs6HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp6HF;;EAu6HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr6HF;;EAw6HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt6HF;;EAy6HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAv6HF;;EA06HA;IACE,6BAAA;EAx6HF;;EA26HA;IACE,8BAAA;EAz6HF;;EA46HA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA16HF;;EA66HA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA36HF;;EA86HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA56HF;;EA+6HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA76HF;;EAg7HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA96HF;;EAi7HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/6HF;;EAk7HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh7HF;;EAm7HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj7HF;;EAo7HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAl7HF;;EAq7HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAn7HF;;EAs7HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAp7HF;;EAu7HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr7HF;;EAw7HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt7HF;;EAy7HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv7HF;;EA07HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx7HF;;EA27HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz7HF;;EA47HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA17HF;;EA67HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA37HF;;EA87HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA57HF;;EA+7HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA77HF;;EAg8HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA97HF;;EAi8HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/7HF;;EAk8HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh8HF;;EAm8HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAj8HF;;EAo8HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAl8HF;;EAq8HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn8HF;;EAs8HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAp8HF;;EAu8HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAr8HF;;EAw8HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAt8HF;;EAy8HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv8HF;;EA08HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx8HF;;EA28HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz8HF;;EA48HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA18HF;;EA68HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA38HF;;EA88HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA58HF;;EA+8HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA78HF;;EAg9HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA98HF;;EAi9HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/8HF;;EAk9HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh9HF;;EAm9HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj9HF;;EAo9HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl9HF;;EAq9HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn9HF;;EAs9HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp9HF;;EAu9HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr9HF;;EAw9HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAt9HF;;EAy9HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAv9HF;;EA09HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAx9HF;;EA29HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz9HF;;EA49HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA19HF;;EA69HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA39HF;;EA89HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA59HF;;EA+9HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA79HF;;EAg+HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA99HF;;EAi+HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/9HF;;EAk+HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAh+HF;;EAm+HA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAj+HF;;EAo+HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl+HF;;EAq+HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn+HF;;EAs+HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp+HF;;EAu+HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr+HF;;EAw+HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt+HF;;EAy+HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAv+HF;;EA0+HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAx+HF;;EA2+HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAz+HF;;EA4+HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1+HF;;EA6+HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3+HF;;EA8+HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5+HF;;EA++HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7+HF;;EAg/HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9+HF;;EAi/HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/+HF;;EAk/HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAh/HF;;EAm/HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAj/HF;;EAo/HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAl/HF;;EAq/HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAn/HF;;EAs/HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp/HF;;EAu/HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr/HF;;EAw/HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt/HF;;EAy/HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv/HF;;EA0/HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx/HF;;EA2/HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAz/HF;;EA4/HA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1/HF;;EA6/HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3/HF;;EA8/HA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5/HF;;EA+/HA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7/HF;;EAggIA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9/HF;;EAigIA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA//HF;;EAkgIA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhgIF;;EAmgIA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjgIF;;EAogIA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAlgIF;;EAqgIA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAngIF;;EAsgIA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApgIF;;EAugIA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EArgIF;;EAwgIA;IACE,sBAAA;EAtgIF;;EAygIA;IACE,sEAAA;EAvgIF;;EA0gIA;IACE,4EAAA;EAxgIF;;EA2gIA;IACE,wEAAA;EAzgIF;;EA4gIA;IACE,+EAAA;EA1gIF;;EA6gIA;IACE,yEAAA;EA3gIF;;EA8gIA;IACE,8EAAA;EA5gIF;;EA+gIA;IACE,uEAAA;EA7gIF;;EAghIA;IACE,2EAAA;EA9gIF;;EAihIA;IACE,kCAAA;IACA,8FAAA;EA/gIF;;EAkhIA;IACE,mCAAA;IACA,oGAAA;EAhhIF;;EAmhIA;IACE,2BAAA;IACA,8FAAA;EAjhIF;;EAohIA;IACE,2BAAA;IACA,oGAAA;EAlhIF;;EAqhIA;IACE,8BAAA;IACA,oGAAA;EAnhIF;;EAshIA;IACE,8BAAA;IACA,oGAAA;EAphIF;;EAuhIA;IACE,8BAAA;IACA,oGAAA;EArhIF;;EAwhIA;IACE,8BAAA;IACA,oGAAA;EAthIF;;EAyhIA;IACE,8BAAA;IACA,oGAAA;EAvhIF;;EA0hIA;IACE,8BAAA;IACA,oGAAA;EAxhIF;;EA2hIA;IACE,8BAAA;IACA,kGAAA;EAzhIF;;EA4hIA;IACE,8BAAA;IACA,iGAAA;EA1hIF;;EA6hIA;IACE,8BAAA;IACA,iGAAA;EA3hIF;;EA8hIA;IACE,8BAAA;IACA,oGAAA;EA5hIF;;EA+hIA;IACE,8BAAA;IACA,oGAAA;EA7hIF;;EAgiIA;IACE,8BAAA;IACA,oGAAA;EA9hIF;;EAiiIA;IACE,8BAAA;IACA,oGAAA;EA/hIF;;EAkiIA;IACE,8BAAA;IACA,oGAAA;EAhiIF;;EAmiIA;IACE,8BAAA;IACA,kGAAA;EAjiIF;;EAoiIA;IACE,8BAAA;IACA,kGAAA;EAliIF;;EAqiIA;IACE,8BAAA;IACA,kGAAA;EAniIF;;EAsiIA;IACE,8BAAA;IACA,kGAAA;EApiIF;;EAuiIA;IACE,8BAAA;IACA,oGAAA;EAriIF;;EAwiIA;IACE,8BAAA;IACA,oGAAA;EAtiIF;;EAyiIA;IACE,8BAAA;IACA,oGAAA;EAviIF;;EA0iIA;IACE,8BAAA;IACA,mGAAA;EAxiIF;;EA2iIA;IACE,8BAAA;IACA,mGAAA;EAziIF;;EA4iIA;IACE,8BAAA;IACA,mGAAA;EA1iIF;;EA6iIA;IACE,8BAAA;IACA,kGAAA;EA3iIF;;EA8iIA;IACE,8BAAA;IACA,kGAAA;EA5iIF;;EA+iIA;IACE,8BAAA;IACA,kGAAA;EA7iIF;;EAgjIA;IACE,8BAAA;IACA,oGAAA;EA9iIF;;EAijIA;IACE,8BAAA;IACA,oGAAA;EA/iIF;;EAkjIA;IACE,8BAAA;IACA,oGAAA;EAhjIF;;EAmjIA;IACE,8BAAA;IACA,mGAAA;EAjjIF;;EAojIA;IACE,8BAAA;IACA,mGAAA;EAljIF;;EAqjIA;IACE,8BAAA;IACA,mGAAA;EAnjIF;;EAsjIA;IACE,8BAAA;IACA,mGAAA;EApjIF;;EAujIA;IACE,8BAAA;IACA,kGAAA;EArjIF;;EAwjIA;IACE,8BAAA;IACA,kGAAA;EAtjIF;;EAyjIA;IACE,8BAAA;IACA,oGAAA;EAvjIF;;EA0jIA;IACE,8BAAA;IACA,oGAAA;EAxjIF;;EA2jIA;IACE,8BAAA;IACA,oGAAA;EAzjIF;;EA4jIA;IACE,8BAAA;IACA,oGAAA;EA1jIF;;EA6jIA;IACE,8BAAA;IACA,mGAAA;EA3jIF;;EA8jIA;IACE,8BAAA;IACA,mGAAA;EA5jIF;;EA+jIA;IACE,8BAAA;IACA,kGAAA;EA7jIF;;EAgkIA;IACE,8BAAA;IACA,kGAAA;EA9jIF;;EAikIA;IACE,8BAAA;IACA,iGAAA;EA/jIF;;EAkkIA;IACE,8BAAA;IACA,oGAAA;EAhkIF;;EAmkIA;IACE,8BAAA;IACA,oGAAA;EAjkIF;;EAokIA;IACE,8BAAA;IACA,oGAAA;EAlkIF;;EAqkIA;IACE,8BAAA;IACA,mGAAA;EAnkIF;;EAskIA;IACE,8BAAA;IACA,mGAAA;EApkIF;;EAukIA;IACE,8BAAA;IACA,mGAAA;EArkIF;;EAwkIA;IACE,8BAAA;IACA,mGAAA;EAtkIF;;EAykIA;IACE,8BAAA;IACA,iGAAA;EAvkIF;;EA0kIA;IACE,8BAAA;IACA,iGAAA;EAxkIF;;EA2kIA;IACE,8BAAA;IACA,oGAAA;EAzkIF;;EA4kIA;IACE,8BAAA;IACA,oGAAA;EA1kIF;;EA6kIA;IACE,8BAAA;IACA,oGAAA;EA3kIF;;EA8kIA;IACE,8BAAA;IACA,mGAAA;EA5kIF;;EA+kIA;IACE,8BAAA;IACA,mGAAA;EA7kIF;;EAglIA;IACE,8BAAA;IACA,mGAAA;EA9kIF;;EAilIA;IACE,8BAAA;IACA,mGAAA;EA/kIF;;EAklIA;IACE,8BAAA;IACA,kGAAA;EAhlIF;;EAmlIA;IACE,8BAAA;IACA,kGAAA;EAjlIF;;EAolIA;IACE,8BAAA;IACA,oGAAA;EAllIF;;EAqlIA;IACE,8BAAA;IACA,oGAAA;EAnlIF;;EAslIA;IACE,8BAAA;IACA,oGAAA;EAplIF;;EAulIA;IACE,8BAAA;IACA,oGAAA;EArlIF;;EAwlIA;IACE,8BAAA;IACA,oGAAA;EAtlIF;;EAylIA;IACE,8BAAA;IACA,mGAAA;EAvlIF;;EA0lIA;IACE,8BAAA;IACA,kGAAA;EAxlIF;;EA2lIA;IACE,8BAAA;IACA,kGAAA;EAzlIF;;EA4lIA;IACE,8BAAA;IACA,kGAAA;EA1lIF;;EA6lIA;IACE,8BAAA;IACA,oGAAA;EA3lIF;;EA8lIA;IACE,8BAAA;IACA,oGAAA;EA5lIF;;EA+lIA;IACE,8BAAA;IACA,oGAAA;EA7lIF;;EAgmIA;IACE,8BAAA;IACA,oGAAA;EA9lIF;;EAimIA;IACE,8BAAA;IACA,oGAAA;EA/lIF;;EAkmIA;IACE,8BAAA;IACA,mGAAA;EAhmIF;;EAmmIA;IACE,8BAAA;IACA,mGAAA;EAjmIF;;EAomIA;IACE,8BAAA;IACA,kGAAA;EAlmIF;;EAqmIA;IACE,8BAAA;IACA,kGAAA;EAnmIF;;EAsmIA;IACE,8BAAA;IACA,oGAAA;EApmIF;;EAumIA;IACE,8BAAA;IACA,oGAAA;EArmIF;;EAwmIA;IACE,8BAAA;IACA,oGAAA;EAtmIF;;EAymIA;IACE,8BAAA;IACA,oGAAA;EAvmIF;;EA0mIA;IACE,8BAAA;IACA,oGAAA;EAxmIF;;EA2mIA;IACE,8BAAA;IACA,mGAAA;EAzmIF;;EA4mIA;IACE,8BAAA;IACA,mGAAA;EA1mIF;;EA6mIA;IACE,8BAAA;IACA,mGAAA;EA3mIF;;EA8mIA;IACE,8BAAA;IACA,kGAAA;EA5mIF;;EA+mIA;IACE,iCAAA;IACA,yHAAA;EA7mIF;;EAgnIA;IACE,kCAAA;IACA,+HAAA;EA9mIF;;EAinIA;IACE,0BAAA;IACA,yHAAA;EA/mIF;;EAknIA;IACE,0BAAA;IACA,+HAAA;EAhnIF;;EAmnIA;IACE,6BAAA;IACA,+HAAA;EAjnIF;;EAonIA;IACE,6BAAA;IACA,+HAAA;EAlnIF;;EAqnIA;IACE,6BAAA;IACA,+HAAA;EAnnIF;;EAsnIA;IACE,6BAAA;IACA,+HAAA;EApnIF;;EAunIA;IACE,6BAAA;IACA,+HAAA;EArnIF;;EAwnIA;IACE,6BAAA;IACA,+HAAA;EAtnIF;;EAynIA;IACE,6BAAA;IACA,6HAAA;EAvnIF;;EA0nIA;IACE,6BAAA;IACA,4HAAA;EAxnIF;;EA2nIA;IACE,6BAAA;IACA,4HAAA;EAznIF;;EA4nIA;IACE,6BAAA;IACA,+HAAA;EA1nIF;;EA6nIA;IACE,6BAAA;IACA,+HAAA;EA3nIF;;EA8nIA;IACE,6BAAA;IACA,+HAAA;EA5nIF;;EA+nIA;IACE,6BAAA;IACA,+HAAA;EA7nIF;;EAgoIA;IACE,6BAAA;IACA,+HAAA;EA9nIF;;EAioIA;IACE,6BAAA;IACA,6HAAA;EA/nIF;;EAkoIA;IACE,6BAAA;IACA,6HAAA;EAhoIF;;EAmoIA;IACE,6BAAA;IACA,6HAAA;EAjoIF;;EAooIA;IACE,6BAAA;IACA,6HAAA;EAloIF;;EAqoIA;IACE,6BAAA;IACA,+HAAA;EAnoIF;;EAsoIA;IACE,6BAAA;IACA,+HAAA;EApoIF;;EAuoIA;IACE,6BAAA;IACA,+HAAA;EAroIF;;EAwoIA;IACE,6BAAA;IACA,8HAAA;EAtoIF;;EAyoIA;IACE,6BAAA;IACA,8HAAA;EAvoIF;;EA0oIA;IACE,6BAAA;IACA,8HAAA;EAxoIF;;EA2oIA;IACE,6BAAA;IACA,6HAAA;EAzoIF;;EA4oIA;IACE,6BAAA;IACA,6HAAA;EA1oIF;;EA6oIA;IACE,6BAAA;IACA,6HAAA;EA3oIF;;EA8oIA;IACE,6BAAA;IACA,+HAAA;EA5oIF;;EA+oIA;IACE,6BAAA;IACA,+HAAA;EA7oIF;;EAgpIA;IACE,6BAAA;IACA,+HAAA;EA9oIF;;EAipIA;IACE,6BAAA;IACA,8HAAA;EA/oIF;;EAkpIA;IACE,6BAAA;IACA,8HAAA;EAhpIF;;EAmpIA;IACE,6BAAA;IACA,8HAAA;EAjpIF;;EAopIA;IACE,6BAAA;IACA,8HAAA;EAlpIF;;EAqpIA;IACE,6BAAA;IACA,6HAAA;EAnpIF;;EAspIA;IACE,6BAAA;IACA,6HAAA;EAppIF;;EAupIA;IACE,6BAAA;IACA,+HAAA;EArpIF;;EAwpIA;IACE,6BAAA;IACA,+HAAA;EAtpIF;;EAypIA;IACE,6BAAA;IACA,+HAAA;EAvpIF;;EA0pIA;IACE,6BAAA;IACA,+HAAA;EAxpIF;;EA2pIA;IACE,6BAAA;IACA,8HAAA;EAzpIF;;EA4pIA;IACE,6BAAA;IACA,8HAAA;EA1pIF;;EA6pIA;IACE,6BAAA;IACA,6HAAA;EA3pIF;;EA8pIA;IACE,6BAAA;IACA,6HAAA;EA5pIF;;EA+pIA;IACE,6BAAA;IACA,4HAAA;EA7pIF;;EAgqIA;IACE,6BAAA;IACA,+HAAA;EA9pIF;;EAiqIA;IACE,6BAAA;IACA,+HAAA;EA/pIF;;EAkqIA;IACE,6BAAA;IACA,+HAAA;EAhqIF;;EAmqIA;IACE,6BAAA;IACA,8HAAA;EAjqIF;;EAoqIA;IACE,6BAAA;IACA,8HAAA;EAlqIF;;EAqqIA;IACE,6BAAA;IACA,8HAAA;EAnqIF;;EAsqIA;IACE,6BAAA;IACA,8HAAA;EApqIF;;EAuqIA;IACE,6BAAA;IACA,4HAAA;EArqIF;;EAwqIA;IACE,6BAAA;IACA,4HAAA;EAtqIF;;EAyqIA;IACE,6BAAA;IACA,+HAAA;EAvqIF;;EA0qIA;IACE,6BAAA;IACA,+HAAA;EAxqIF;;EA2qIA;IACE,6BAAA;IACA,+HAAA;EAzqIF;;EA4qIA;IACE,6BAAA;IACA,8HAAA;EA1qIF;;EA6qIA;IACE,6BAAA;IACA,8HAAA;EA3qIF;;EA8qIA;IACE,6BAAA;IACA,8HAAA;EA5qIF;;EA+qIA;IACE,6BAAA;IACA,8HAAA;EA7qIF;;EAgrIA;IACE,6BAAA;IACA,6HAAA;EA9qIF;;EAirIA;IACE,6BAAA;IACA,6HAAA;EA/qIF;;EAkrIA;IACE,6BAAA;IACA,+HAAA;EAhrIF;;EAmrIA;IACE,6BAAA;IACA,+HAAA;EAjrIF;;EAorIA;IACE,6BAAA;IACA,+HAAA;EAlrIF;;EAqrIA;IACE,6BAAA;IACA,+HAAA;EAnrIF;;EAsrIA;IACE,6BAAA;IACA,+HAAA;EAprIF;;EAurIA;IACE,6BAAA;IACA,8HAAA;EArrIF;;EAwrIA;IACE,6BAAA;IACA,6HAAA;EAtrIF;;EAyrIA;IACE,6BAAA;IACA,6HAAA;EAvrIF;;EA0rIA;IACE,6BAAA;IACA,6HAAA;EAxrIF;;EA2rIA;IACE,6BAAA;IACA,+HAAA;EAzrIF;;EA4rIA;IACE,6BAAA;IACA,+HAAA;EA1rIF;;EA6rIA;IACE,6BAAA;IACA,+HAAA;EA3rIF;;EA8rIA;IACE,6BAAA;IACA,+HAAA;EA5rIF;;EA+rIA;IACE,6BAAA;IACA,+HAAA;EA7rIF;;EAgsIA;IACE,6BAAA;IACA,8HAAA;EA9rIF;;EAisIA;IACE,6BAAA;IACA,8HAAA;EA/rIF;;EAksIA;IACE,6BAAA;IACA,6HAAA;EAhsIF;;EAmsIA;IACE,6BAAA;IACA,6HAAA;EAjsIF;;EAosIA;IACE,6BAAA;IACA,+HAAA;EAlsIF;;EAqsIA;IACE,6BAAA;IACA,+HAAA;EAnsIF;;EAssIA;IACE,6BAAA;IACA,+HAAA;EApsIF;;EAusIA;IACE,6BAAA;IACA,+HAAA;EArsIF;;EAwsIA;IACE,6BAAA;IACA,+HAAA;EAtsIF;;EAysIA;IACE,6BAAA;IACA,8HAAA;EAvsIF;;EA0sIA;IACE,6BAAA;IACA,8HAAA;EAxsIF;;EA2sIA;IACE,6BAAA;IACA,8HAAA;EAzsIF;;EA4sIA;IACE,6BAAA;IACA,6HAAA;EA1sIF;;EA6sIA;IACE,gCAAA;EA3sIF;;EA8sIA;IACE,iCAAA;EA5sIF;;EA+sIA;IACE,yBAAA;EA7sIF;;EAgtIA;IACE,yBAAA;EA9sIF;;EAitIA;IACE,4BAAA;EA/sIF;;EAktIA;IACE,4BAAA;EAhtIF;;EAmtIA;IACE,4BAAA;EAjtIF;;EAotIA;IACE,4BAAA;EAltIF;;EAqtIA;IACE,4BAAA;EAntIF;;EAstIA;IACE,4BAAA;EAptIF;;EAutIA;IACE,4BAAA;EArtIF;;EAwtIA;IACE,4BAAA;EAttIF;;EAytIA;IACE,4BAAA;EAvtIF;;EA0tIA;IACE,4BAAA;EAxtIF;;EA2tIA;IACE,4BAAA;EAztIF;;EA4tIA;IACE,4BAAA;EA1tIF;;EA6tIA;IACE,4BAAA;EA3tIF;;EA8tIA;IACE,4BAAA;EA5tIF;;EA+tIA;IACE,4BAAA;EA7tIF;;EAguIA;IACE,4BAAA;EA9tIF;;EAiuIA;IACE,4BAAA;EA/tIF;;EAkuIA;IACE,4BAAA;EAhuIF;;EAmuIA;IACE,4BAAA;EAjuIF;;EAouIA;IACE,4BAAA;EAluIF;;EAquIA;IACE,4BAAA;EAnuIF;;EAsuIA;IACE,4BAAA;EApuIF;;EAuuIA;IACE,4BAAA;EAruIF;;EAwuIA;IACE,4BAAA;EAtuIF;;EAyuIA;IACE,4BAAA;EAvuIF;;EA0uIA;IACE,4BAAA;EAxuIF;;EA2uIA;IACE,4BAAA;EAzuIF;;EA4uIA;IACE,4BAAA;EA1uIF;;EA6uIA;IACE,4BAAA;EA3uIF;;EA8uIA;IACE,4BAAA;EA5uIF;;EA+uIA;IACE,4BAAA;EA7uIF;;EAgvIA;IACE,4BAAA;EA9uIF;;EAivIA;IACE,4BAAA;EA/uIF;;EAkvIA;IACE,4BAAA;EAhvIF;;EAmvIA;IACE,4BAAA;EAjvIF;;EAovIA;IACE,4BAAA;EAlvIF;;EAqvIA;IACE,4BAAA;EAnvIF;;EAsvIA;IACE,4BAAA;EApvIF;;EAuvIA;IACE,4BAAA;EArvIF;;EAwvIA;IACE,4BAAA;EAtvIF;;EAyvIA;IACE,4BAAA;EAvvIF;;EA0vIA;IACE,4BAAA;EAxvIF;;EA2vIA;IACE,4BAAA;EAzvIF;;EA4vIA;IACE,4BAAA;EA1vIF;;EA6vIA;IACE,4BAAA;EA3vIF;;EA8vIA;IACE,4BAAA;EA5vIF;;EA+vIA;IACE,4BAAA;EA7vIF;;EAgwIA;IACE,4BAAA;EA9vIF;;EAiwIA;IACE,4BAAA;EA/vIF;;EAkwIA;IACE,4BAAA;EAhwIF;;EAmwIA;IACE,4BAAA;EAjwIF;;EAowIA;IACE,4BAAA;EAlwIF;;EAqwIA;IACE,4BAAA;EAnwIF;;EAswIA;IACE,4BAAA;EApwIF;;EAuwIA;IACE,4BAAA;EArwIF;;EAwwIA;IACE,4BAAA;EAtwIF;;EAywIA;IACE,4BAAA;EAvwIF;;EA0wIA;IACE,4BAAA;EAxwIF;;EA2wIA;IACE,4BAAA;EAzwIF;;EA4wIA;IACE,4BAAA;EA1wIF;;EA6wIA;IACE,4BAAA;EA3wIF;;EA8wIA;IACE,4BAAA;EA5wIF;;EA+wIA;IACE,4BAAA;EA7wIF;;EAgxIA;IACE,4BAAA;EA9wIF;;EAixIA;IACE,4BAAA;EA/wIF;;EAkxIA;IACE,4BAAA;EAhxIF;;EAmxIA;IACE,4BAAA;EAjxIF;;EAoxIA;IACE,4BAAA;EAlxIF;;EAqxIA;IACE,4BAAA;EAnxIF;;EAsxIA;IACE,4BAAA;EApxIF;;EAuxIA;IACE,4BAAA;EArxIF;;EAwxIA;IACE,4BAAA;EAtxIF;;EAyxIA;IACE,4BAAA;EAvxIF;;EA0xIA;IACE,4BAAA;EAxxIF;;EA2xIA;IACE,4BAAA;EAzxIF;;EA4xIA;IACE,4BAAA;EA1xIF;;EA6xIA;IACE,4BAAA;EA3xIF;;EA8xIA;IACE,4BAAA;EA5xIF;;EA+xIA;IACE,4BAAA;EA7xIF;;EAgyIA;IACE,4BAAA;EA9xIF;;EAiyIA;IACE,4BAAA;EA/xIF;;EAkyIA;IACE,4BAAA;EAhyIF;;EAmyIA;IACE,4BAAA;EAjyIF;;EAoyIA;IACE,4BAAA;EAlyIF;;EAqyIA;IACE,4BAAA;EAnyIF;;EAsyIA;IACE,4BAAA;EApyIF;;EAuyIA;IACE,4BAAA;EAryIF;;EAwyIA;IACE,4BAAA;EAtyIF;;EAyyIA;IACE,4BAAA;EAvyIF;;EA0yIA;IACE,4BAAA;EAxyIF;;EA2yIA;IACE,kCAAA;IACA,8FAAA;EAzyIF;;EA4yIA;IACE,mCAAA;IACA,oGAAA;EA1yIF;;EA6yIA;IACE,2BAAA;IACA,8FAAA;EA3yIF;;EA8yIA;IACE,2BAAA;IACA,oGAAA;EA5yIF;;EA+yIA;IACE,8BAAA;IACA,oGAAA;EA7yIF;;EAgzIA;IACE,8BAAA;IACA,oGAAA;EA9yIF;;EAizIA;IACE,8BAAA;IACA,oGAAA;EA/yIF;;EAkzIA;IACE,8BAAA;IACA,oGAAA;EAhzIF;;EAmzIA;IACE,8BAAA;IACA,oGAAA;EAjzIF;;EAozIA;IACE,8BAAA;IACA,oGAAA;EAlzIF;;EAqzIA;IACE,8BAAA;IACA,kGAAA;EAnzIF;;EAszIA;IACE,8BAAA;IACA,iGAAA;EApzIF;;EAuzIA;IACE,8BAAA;IACA,iGAAA;EArzIF;;EAwzIA;IACE,8BAAA;IACA,oGAAA;EAtzIF;;EAyzIA;IACE,8BAAA;IACA,oGAAA;EAvzIF;;EA0zIA;IACE,8BAAA;IACA,oGAAA;EAxzIF;;EA2zIA;IACE,8BAAA;IACA,oGAAA;EAzzIF;;EA4zIA;IACE,8BAAA;IACA,oGAAA;EA1zIF;;EA6zIA;IACE,8BAAA;IACA,kGAAA;EA3zIF;;EA8zIA;IACE,8BAAA;IACA,kGAAA;EA5zIF;;EA+zIA;IACE,8BAAA;IACA,kGAAA;EA7zIF;;EAg0IA;IACE,8BAAA;IACA,kGAAA;EA9zIF;;EAi0IA;IACE,8BAAA;IACA,oGAAA;EA/zIF;;EAk0IA;IACE,8BAAA;IACA,oGAAA;EAh0IF;;EAm0IA;IACE,8BAAA;IACA,oGAAA;EAj0IF;;EAo0IA;IACE,8BAAA;IACA,mGAAA;EAl0IF;;EAq0IA;IACE,8BAAA;IACA,mGAAA;EAn0IF;;EAs0IA;IACE,8BAAA;IACA,mGAAA;EAp0IF;;EAu0IA;IACE,8BAAA;IACA,kGAAA;EAr0IF;;EAw0IA;IACE,8BAAA;IACA,kGAAA;EAt0IF;;EAy0IA;IACE,8BAAA;IACA,kGAAA;EAv0IF;;EA00IA;IACE,8BAAA;IACA,oGAAA;EAx0IF;;EA20IA;IACE,8BAAA;IACA,oGAAA;EAz0IF;;EA40IA;IACE,8BAAA;IACA,oGAAA;EA10IF;;EA60IA;IACE,8BAAA;IACA,mGAAA;EA30IF;;EA80IA;IACE,8BAAA;IACA,mGAAA;EA50IF;;EA+0IA;IACE,8BAAA;IACA,mGAAA;EA70IF;;EAg1IA;IACE,8BAAA;IACA,mGAAA;EA90IF;;EAi1IA;IACE,8BAAA;IACA,kGAAA;EA/0IF;;EAk1IA;IACE,8BAAA;IACA,kGAAA;EAh1IF;;EAm1IA;IACE,8BAAA;IACA,oGAAA;EAj1IF;;EAo1IA;IACE,8BAAA;IACA,oGAAA;EAl1IF;;EAq1IA;IACE,8BAAA;IACA,oGAAA;EAn1IF;;EAs1IA;IACE,8BAAA;IACA,oGAAA;EAp1IF;;EAu1IA;IACE,8BAAA;IACA,mGAAA;EAr1IF;;EAw1IA;IACE,8BAAA;IACA,mGAAA;EAt1IF;;EAy1IA;IACE,8BAAA;IACA,kGAAA;EAv1IF;;EA01IA;IACE,8BAAA;IACA,kGAAA;EAx1IF;;EA21IA;IACE,8BAAA;IACA,iGAAA;EAz1IF;;EA41IA;IACE,8BAAA;IACA,oGAAA;EA11IF;;EA61IA;IACE,8BAAA;IACA,oGAAA;EA31IF;;EA81IA;IACE,8BAAA;IACA,oGAAA;EA51IF;;EA+1IA;IACE,8BAAA;IACA,mGAAA;EA71IF;;EAg2IA;IACE,8BAAA;IACA,mGAAA;EA91IF;;EAi2IA;IACE,8BAAA;IACA,mGAAA;EA/1IF;;EAk2IA;IACE,8BAAA;IACA,mGAAA;EAh2IF;;EAm2IA;IACE,8BAAA;IACA,iGAAA;EAj2IF;;EAo2IA;IACE,8BAAA;IACA,iGAAA;EAl2IF;;EAq2IA;IACE,8BAAA;IACA,oGAAA;EAn2IF;;EAs2IA;IACE,8BAAA;IACA,oGAAA;EAp2IF;;EAu2IA;IACE,8BAAA;IACA,oGAAA;EAr2IF;;EAw2IA;IACE,8BAAA;IACA,mGAAA;EAt2IF;;EAy2IA;IACE,8BAAA;IACA,mGAAA;EAv2IF;;EA02IA;IACE,8BAAA;IACA,mGAAA;EAx2IF;;EA22IA;IACE,8BAAA;IACA,mGAAA;EAz2IF;;EA42IA;IACE,8BAAA;IACA,kGAAA;EA12IF;;EA62IA;IACE,8BAAA;IACA,kGAAA;EA32IF;;EA82IA;IACE,8BAAA;IACA,oGAAA;EA52IF;;EA+2IA;IACE,8BAAA;IACA,oGAAA;EA72IF;;EAg3IA;IACE,8BAAA;IACA,oGAAA;EA92IF;;EAi3IA;IACE,8BAAA;IACA,oGAAA;EA/2IF;;EAk3IA;IACE,8BAAA;IACA,oGAAA;EAh3IF;;EAm3IA;IACE,8BAAA;IACA,mGAAA;EAj3IF;;EAo3IA;IACE,8BAAA;IACA,kGAAA;EAl3IF;;EAq3IA;IACE,8BAAA;IACA,kGAAA;EAn3IF;;EAs3IA;IACE,8BAAA;IACA,kGAAA;EAp3IF;;EAu3IA;IACE,8BAAA;IACA,oGAAA;EAr3IF;;EAw3IA;IACE,8BAAA;IACA,oGAAA;EAt3IF;;EAy3IA;IACE,8BAAA;IACA,oGAAA;EAv3IF;;EA03IA;IACE,8BAAA;IACA,oGAAA;EAx3IF;;EA23IA;IACE,8BAAA;IACA,oGAAA;EAz3IF;;EA43IA;IACE,8BAAA;IACA,mGAAA;EA13IF;;EA63IA;IACE,8BAAA;IACA,mGAAA;EA33IF;;EA83IA;IACE,8BAAA;IACA,kGAAA;EA53IF;;EA+3IA;IACE,8BAAA;IACA,kGAAA;EA73IF;;EAg4IA;IACE,8BAAA;IACA,oGAAA;EA93IF;;EAi4IA;IACE,8BAAA;IACA,oGAAA;EA/3IF;;EAk4IA;IACE,8BAAA;IACA,oGAAA;EAh4IF;;EAm4IA;IACE,8BAAA;IACA,oGAAA;EAj4IF;;EAo4IA;IACE,8BAAA;IACA,oGAAA;EAl4IF;;EAq4IA;IACE,8BAAA;IACA,mGAAA;EAn4IF;;EAs4IA;IACE,8BAAA;IACA,mGAAA;EAp4IF;;EAu4IA;IACE,8BAAA;IACA,mGAAA;EAr4IF;;EAw4IA;IACE,8BAAA;IACA,kGAAA;EAt4IF;;EAy4IA;IACE,iCAAA;IACA,yHAAA;EAv4IF;;EA04IA;IACE,kCAAA;IACA,+HAAA;EAx4IF;;EA24IA;IACE,0BAAA;IACA,yHAAA;EAz4IF;;EA44IA;IACE,0BAAA;IACA,+HAAA;EA14IF;;EA64IA;IACE,6BAAA;IACA,+HAAA;EA34IF;;EA84IA;IACE,6BAAA;IACA,+HAAA;EA54IF;;EA+4IA;IACE,6BAAA;IACA,+HAAA;EA74IF;;EAg5IA;IACE,6BAAA;IACA,+HAAA;EA94IF;;EAi5IA;IACE,6BAAA;IACA,+HAAA;EA/4IF;;EAk5IA;IACE,6BAAA;IACA,+HAAA;EAh5IF;;EAm5IA;IACE,6BAAA;IACA,6HAAA;EAj5IF;;EAo5IA;IACE,6BAAA;IACA,4HAAA;EAl5IF;;EAq5IA;IACE,6BAAA;IACA,4HAAA;EAn5IF;;EAs5IA;IACE,6BAAA;IACA,+HAAA;EAp5IF;;EAu5IA;IACE,6BAAA;IACA,+HAAA;EAr5IF;;EAw5IA;IACE,6BAAA;IACA,+HAAA;EAt5IF;;EAy5IA;IACE,6BAAA;IACA,+HAAA;EAv5IF;;EA05IA;IACE,6BAAA;IACA,+HAAA;EAx5IF;;EA25IA;IACE,6BAAA;IACA,6HAAA;EAz5IF;;EA45IA;IACE,6BAAA;IACA,6HAAA;EA15IF;;EA65IA;IACE,6BAAA;IACA,6HAAA;EA35IF;;EA85IA;IACE,6BAAA;IACA,6HAAA;EA55IF;;EA+5IA;IACE,6BAAA;IACA,+HAAA;EA75IF;;EAg6IA;IACE,6BAAA;IACA,+HAAA;EA95IF;;EAi6IA;IACE,6BAAA;IACA,+HAAA;EA/5IF;;EAk6IA;IACE,6BAAA;IACA,8HAAA;EAh6IF;;EAm6IA;IACE,6BAAA;IACA,8HAAA;EAj6IF;;EAo6IA;IACE,6BAAA;IACA,8HAAA;EAl6IF;;EAq6IA;IACE,6BAAA;IACA,6HAAA;EAn6IF;;EAs6IA;IACE,6BAAA;IACA,6HAAA;EAp6IF;;EAu6IA;IACE,6BAAA;IACA,6HAAA;EAr6IF;;EAw6IA;IACE,6BAAA;IACA,+HAAA;EAt6IF;;EAy6IA;IACE,6BAAA;IACA,+HAAA;EAv6IF;;EA06IA;IACE,6BAAA;IACA,+HAAA;EAx6IF;;EA26IA;IACE,6BAAA;IACA,8HAAA;EAz6IF;;EA46IA;IACE,6BAAA;IACA,8HAAA;EA16IF;;EA66IA;IACE,6BAAA;IACA,8HAAA;EA36IF;;EA86IA;IACE,6BAAA;IACA,8HAAA;EA56IF;;EA+6IA;IACE,6BAAA;IACA,6HAAA;EA76IF;;EAg7IA;IACE,6BAAA;IACA,6HAAA;EA96IF;;EAi7IA;IACE,6BAAA;IACA,+HAAA;EA/6IF;;EAk7IA;IACE,6BAAA;IACA,+HAAA;EAh7IF;;EAm7IA;IACE,6BAAA;IACA,+HAAA;EAj7IF;;EAo7IA;IACE,6BAAA;IACA,+HAAA;EAl7IF;;EAq7IA;IACE,6BAAA;IACA,8HAAA;EAn7IF;;EAs7IA;IACE,6BAAA;IACA,8HAAA;EAp7IF;;EAu7IA;IACE,6BAAA;IACA,6HAAA;EAr7IF;;EAw7IA;IACE,6BAAA;IACA,6HAAA;EAt7IF;;EAy7IA;IACE,6BAAA;IACA,4HAAA;EAv7IF;;EA07IA;IACE,6BAAA;IACA,+HAAA;EAx7IF;;EA27IA;IACE,6BAAA;IACA,+HAAA;EAz7IF;;EA47IA;IACE,6BAAA;IACA,+HAAA;EA17IF;;EA67IA;IACE,6BAAA;IACA,8HAAA;EA37IF;;EA87IA;IACE,6BAAA;IACA,8HAAA;EA57IF;;EA+7IA;IACE,6BAAA;IACA,8HAAA;EA77IF;;EAg8IA;IACE,6BAAA;IACA,8HAAA;EA97IF;;EAi8IA;IACE,6BAAA;IACA,4HAAA;EA/7IF;;EAk8IA;IACE,6BAAA;IACA,4HAAA;EAh8IF;;EAm8IA;IACE,6BAAA;IACA,+HAAA;EAj8IF;;EAo8IA;IACE,6BAAA;IACA,+HAAA;EAl8IF;;EAq8IA;IACE,6BAAA;IACA,+HAAA;EAn8IF;;EAs8IA;IACE,6BAAA;IACA,8HAAA;EAp8IF;;EAu8IA;IACE,6BAAA;IACA,8HAAA;EAr8IF;;EAw8IA;IACE,6BAAA;IACA,8HAAA;EAt8IF;;EAy8IA;IACE,6BAAA;IACA,8HAAA;EAv8IF;;EA08IA;IACE,6BAAA;IACA,6HAAA;EAx8IF;;EA28IA;IACE,6BAAA;IACA,6HAAA;EAz8IF;;EA48IA;IACE,6BAAA;IACA,+HAAA;EA18IF;;EA68IA;IACE,6BAAA;IACA,+HAAA;EA38IF;;EA88IA;IACE,6BAAA;IACA,+HAAA;EA58IF;;EA+8IA;IACE,6BAAA;IACA,+HAAA;EA78IF;;EAg9IA;IACE,6BAAA;IACA,+HAAA;EA98IF;;EAi9IA;IACE,6BAAA;IACA,8HAAA;EA/8IF;;EAk9IA;IACE,6BAAA;IACA,6HAAA;EAh9IF;;EAm9IA;IACE,6BAAA;IACA,6HAAA;EAj9IF;;EAo9IA;IACE,6BAAA;IACA,6HAAA;EAl9IF;;EAq9IA;IACE,6BAAA;IACA,+HAAA;EAn9IF;;EAs9IA;IACE,6BAAA;IACA,+HAAA;EAp9IF;;EAu9IA;IACE,6BAAA;IACA,+HAAA;EAr9IF;;EAw9IA;IACE,6BAAA;IACA,+HAAA;EAt9IF;;EAy9IA;IACE,6BAAA;IACA,+HAAA;EAv9IF;;EA09IA;IACE,6BAAA;IACA,8HAAA;EAx9IF;;EA29IA;IACE,6BAAA;IACA,8HAAA;EAz9IF;;EA49IA;IACE,6BAAA;IACA,6HAAA;EA19IF;;EA69IA;IACE,6BAAA;IACA,6HAAA;EA39IF;;EA89IA;IACE,6BAAA;IACA,+HAAA;EA59IF;;EA+9IA;IACE,6BAAA;IACA,+HAAA;EA79IF;;EAg+IA;IACE,6BAAA;IACA,+HAAA;EA99IF;;EAi+IA;IACE,6BAAA;IACA,+HAAA;EA/9IF;;EAk+IA;IACE,6BAAA;IACA,+HAAA;EAh+IF;;EAm+IA;IACE,6BAAA;IACA,8HAAA;EAj+IF;;EAo+IA;IACE,6BAAA;IACA,8HAAA;EAl+IF;;EAq+IA;IACE,6BAAA;IACA,8HAAA;EAn+IF;;EAs+IA;IACE,6BAAA;IACA,6HAAA;EAp+IF;;EAu+IA;IACE,gCAAA;EAr+IF;;EAw+IA;IACE,iCAAA;EAt+IF;;EAy+IA;IACE,yBAAA;EAv+IF;;EA0+IA;IACE,yBAAA;EAx+IF;;EA2+IA;IACE,4BAAA;EAz+IF;;EA4+IA;IACE,4BAAA;EA1+IF;;EA6+IA;IACE,4BAAA;EA3+IF;;EA8+IA;IACE,4BAAA;EA5+IF;;EA++IA;IACE,4BAAA;EA7+IF;;EAg/IA;IACE,4BAAA;EA9+IF;;EAi/IA;IACE,4BAAA;EA/+IF;;EAk/IA;IACE,4BAAA;EAh/IF;;EAm/IA;IACE,4BAAA;EAj/IF;;EAo/IA;IACE,4BAAA;EAl/IF;;EAq/IA;IACE,4BAAA;EAn/IF;;EAs/IA;IACE,4BAAA;EAp/IF;;EAu/IA;IACE,4BAAA;EAr/IF;;EAw/IA;IACE,4BAAA;EAt/IF;;EAy/IA;IACE,4BAAA;EAv/IF;;EA0/IA;IACE,4BAAA;EAx/IF;;EA2/IA;IACE,4BAAA;EAz/IF;;EA4/IA;IACE,4BAAA;EA1/IF;;EA6/IA;IACE,4BAAA;EA3/IF;;EA8/IA;IACE,4BAAA;EA5/IF;;EA+/IA;IACE,4BAAA;EA7/IF;;EAggJA;IACE,4BAAA;EA9/IF;;EAigJA;IACE,4BAAA;EA//IF;;EAkgJA;IACE,4BAAA;EAhgJF;;EAmgJA;IACE,4BAAA;EAjgJF;;EAogJA;IACE,4BAAA;EAlgJF;;EAqgJA;IACE,4BAAA;EAngJF;;EAsgJA;IACE,4BAAA;EApgJF;;EAugJA;IACE,4BAAA;EArgJF;;EAwgJA;IACE,4BAAA;EAtgJF;;EAygJA;IACE,4BAAA;EAvgJF;;EA0gJA;IACE,4BAAA;EAxgJF;;EA2gJA;IACE,4BAAA;EAzgJF;;EA4gJA;IACE,4BAAA;EA1gJF;;EA6gJA;IACE,4BAAA;EA3gJF;;EA8gJA;IACE,4BAAA;EA5gJF;;EA+gJA;IACE,4BAAA;EA7gJF;;EAghJA;IACE,4BAAA;EA9gJF;;EAihJA;IACE,4BAAA;EA/gJF;;EAkhJA;IACE,4BAAA;EAhhJF;;EAmhJA;IACE,4BAAA;EAjhJF;;EAohJA;IACE,4BAAA;EAlhJF;;EAqhJA;IACE,4BAAA;EAnhJF;;EAshJA;IACE,4BAAA;EAphJF;;EAuhJA;IACE,4BAAA;EArhJF;;EAwhJA;IACE,4BAAA;EAthJF;;EAyhJA;IACE,4BAAA;EAvhJF;;EA0hJA;IACE,4BAAA;EAxhJF;;EA2hJA;IACE,4BAAA;EAzhJF;;EA4hJA;IACE,4BAAA;EA1hJF;;EA6hJA;IACE,4BAAA;EA3hJF;;EA8hJA;IACE,4BAAA;EA5hJF;;EA+hJA;IACE,4BAAA;EA7hJF;;EAgiJA;IACE,4BAAA;EA9hJF;;EAiiJA;IACE,4BAAA;EA/hJF;;EAkiJA;IACE,4BAAA;EAhiJF;;EAmiJA;IACE,4BAAA;EAjiJF;;EAoiJA;IACE,4BAAA;EAliJF;;EAqiJA;IACE,4BAAA;EAniJF;;EAsiJA;IACE,4BAAA;EApiJF;;EAuiJA;IACE,4BAAA;EAriJF;;EAwiJA;IACE,4BAAA;EAtiJF;;EAyiJA;IACE,4BAAA;EAviJF;;EA0iJA;IACE,4BAAA;EAxiJF;;EA2iJA;IACE,4BAAA;EAziJF;;EA4iJA;IACE,4BAAA;EA1iJF;;EA6iJA;IACE,4BAAA;EA3iJF;;EA8iJA;IACE,4BAAA;EA5iJF;;EA+iJA;IACE,4BAAA;EA7iJF;;EAgjJA;IACE,4BAAA;EA9iJF;;EAijJA;IACE,4BAAA;EA/iJF;;EAkjJA;IACE,4BAAA;EAhjJF;;EAmjJA;IACE,4BAAA;EAjjJF;;EAojJA;IACE,4BAAA;EAljJF;;EAqjJA;IACE,4BAAA;EAnjJF;;EAsjJA;IACE,4BAAA;EApjJF;;EAujJA;IACE,4BAAA;EArjJF;;EAwjJA;IACE,4BAAA;EAtjJF;;EAyjJA;IACE,4BAAA;EAvjJF;;EA0jJA;IACE,4BAAA;EAxjJF;;EA2jJA;IACE,4BAAA;EAzjJF;;EA4jJA;IACE,4BAAA;EA1jJF;;EA6jJA;IACE,4BAAA;EA3jJF;;EA8jJA;IACE,4BAAA;EA5jJF;;EA+jJA;IACE,4BAAA;EA7jJF;;EAgkJA;IACE,4BAAA;EA9jJF;;EAikJA;IACE,4BAAA;EA/jJF;;EAkkJA;IACE,4BAAA;EAhkJF;;EAmkJA;IACE,4BAAA;EAjkJF;;EAokJA;IACE,4BAAA;EAlkJF;;EAqkJA;IACE,kCAAA;IACA,8FAAA;EAnkJF;;EAskJA;IACE,mCAAA;IACA,oGAAA;EApkJF;;EAukJA;IACE,2BAAA;IACA,8FAAA;EArkJF;;EAwkJA;IACE,2BAAA;IACA,oGAAA;EAtkJF;;EAykJA;IACE,8BAAA;IACA,oGAAA;EAvkJF;;EA0kJA;IACE,8BAAA;IACA,oGAAA;EAxkJF;;EA2kJA;IACE,8BAAA;IACA,oGAAA;EAzkJF;;EA4kJA;IACE,8BAAA;IACA,oGAAA;EA1kJF;;EA6kJA;IACE,8BAAA;IACA,oGAAA;EA3kJF;;EA8kJA;IACE,8BAAA;IACA,oGAAA;EA5kJF;;EA+kJA;IACE,8BAAA;IACA,kGAAA;EA7kJF;;EAglJA;IACE,8BAAA;IACA,iGAAA;EA9kJF;;EAilJA;IACE,8BAAA;IACA,iGAAA;EA/kJF;;EAklJA;IACE,8BAAA;IACA,oGAAA;EAhlJF;;EAmlJA;IACE,8BAAA;IACA,oGAAA;EAjlJF;;EAolJA;IACE,8BAAA;IACA,oGAAA;EAllJF;;EAqlJA;IACE,8BAAA;IACA,oGAAA;EAnlJF;;EAslJA;IACE,8BAAA;IACA,oGAAA;EAplJF;;EAulJA;IACE,8BAAA;IACA,kGAAA;EArlJF;;EAwlJA;IACE,8BAAA;IACA,kGAAA;EAtlJF;;EAylJA;IACE,8BAAA;IACA,kGAAA;EAvlJF;;EA0lJA;IACE,8BAAA;IACA,kGAAA;EAxlJF;;EA2lJA;IACE,8BAAA;IACA,oGAAA;EAzlJF;;EA4lJA;IACE,8BAAA;IACA,oGAAA;EA1lJF;;EA6lJA;IACE,8BAAA;IACA,oGAAA;EA3lJF;;EA8lJA;IACE,8BAAA;IACA,mGAAA;EA5lJF;;EA+lJA;IACE,8BAAA;IACA,mGAAA;EA7lJF;;EAgmJA;IACE,8BAAA;IACA,mGAAA;EA9lJF;;EAimJA;IACE,8BAAA;IACA,kGAAA;EA/lJF;;EAkmJA;IACE,8BAAA;IACA,kGAAA;EAhmJF;;EAmmJA;IACE,8BAAA;IACA,kGAAA;EAjmJF;;EAomJA;IACE,8BAAA;IACA,oGAAA;EAlmJF;;EAqmJA;IACE,8BAAA;IACA,oGAAA;EAnmJF;;EAsmJA;IACE,8BAAA;IACA,oGAAA;EApmJF;;EAumJA;IACE,8BAAA;IACA,mGAAA;EArmJF;;EAwmJA;IACE,8BAAA;IACA,mGAAA;EAtmJF;;EAymJA;IACE,8BAAA;IACA,mGAAA;EAvmJF;;EA0mJA;IACE,8BAAA;IACA,mGAAA;EAxmJF;;EA2mJA;IACE,8BAAA;IACA,kGAAA;EAzmJF;;EA4mJA;IACE,8BAAA;IACA,kGAAA;EA1mJF;;EA6mJA;IACE,8BAAA;IACA,oGAAA;EA3mJF;;EA8mJA;IACE,8BAAA;IACA,oGAAA;EA5mJF;;EA+mJA;IACE,8BAAA;IACA,oGAAA;EA7mJF;;EAgnJA;IACE,8BAAA;IACA,oGAAA;EA9mJF;;EAinJA;IACE,8BAAA;IACA,mGAAA;EA/mJF;;EAknJA;IACE,8BAAA;IACA,mGAAA;EAhnJF;;EAmnJA;IACE,8BAAA;IACA,kGAAA;EAjnJF;;EAonJA;IACE,8BAAA;IACA,kGAAA;EAlnJF;;EAqnJA;IACE,8BAAA;IACA,iGAAA;EAnnJF;;EAsnJA;IACE,8BAAA;IACA,oGAAA;EApnJF;;EAunJA;IACE,8BAAA;IACA,oGAAA;EArnJF;;EAwnJA;IACE,8BAAA;IACA,oGAAA;EAtnJF;;EAynJA;IACE,8BAAA;IACA,mGAAA;EAvnJF;;EA0nJA;IACE,8BAAA;IACA,mGAAA;EAxnJF;;EA2nJA;IACE,8BAAA;IACA,mGAAA;EAznJF;;EA4nJA;IACE,8BAAA;IACA,mGAAA;EA1nJF;;EA6nJA;IACE,8BAAA;IACA,iGAAA;EA3nJF;;EA8nJA;IACE,8BAAA;IACA,iGAAA;EA5nJF;;EA+nJA;IACE,8BAAA;IACA,oGAAA;EA7nJF;;EAgoJA;IACE,8BAAA;IACA,oGAAA;EA9nJF;;EAioJA;IACE,8BAAA;IACA,oGAAA;EA/nJF;;EAkoJA;IACE,8BAAA;IACA,mGAAA;EAhoJF;;EAmoJA;IACE,8BAAA;IACA,mGAAA;EAjoJF;;EAooJA;IACE,8BAAA;IACA,mGAAA;EAloJF;;EAqoJA;IACE,8BAAA;IACA,mGAAA;EAnoJF;;EAsoJA;IACE,8BAAA;IACA,kGAAA;EApoJF;;EAuoJA;IACE,8BAAA;IACA,kGAAA;EAroJF;;EAwoJA;IACE,8BAAA;IACA,oGAAA;EAtoJF;;EAyoJA;IACE,8BAAA;IACA,oGAAA;EAvoJF;;EA0oJA;IACE,8BAAA;IACA,oGAAA;EAxoJF;;EA2oJA;IACE,8BAAA;IACA,oGAAA;EAzoJF;;EA4oJA;IACE,8BAAA;IACA,oGAAA;EA1oJF;;EA6oJA;IACE,8BAAA;IACA,mGAAA;EA3oJF;;EA8oJA;IACE,8BAAA;IACA,kGAAA;EA5oJF;;EA+oJA;IACE,8BAAA;IACA,kGAAA;EA7oJF;;EAgpJA;IACE,8BAAA;IACA,kGAAA;EA9oJF;;EAipJA;IACE,8BAAA;IACA,oGAAA;EA/oJF;;EAkpJA;IACE,8BAAA;IACA,oGAAA;EAhpJF;;EAmpJA;IACE,8BAAA;IACA,oGAAA;EAjpJF;;EAopJA;IACE,8BAAA;IACA,oGAAA;EAlpJF;;EAqpJA;IACE,8BAAA;IACA,oGAAA;EAnpJF;;EAspJA;IACE,8BAAA;IACA,mGAAA;EAppJF;;EAupJA;IACE,8BAAA;IACA,mGAAA;EArpJF;;EAwpJA;IACE,8BAAA;IACA,kGAAA;EAtpJF;;EAypJA;IACE,8BAAA;IACA,kGAAA;EAvpJF;;EA0pJA;IACE,8BAAA;IACA,oGAAA;EAxpJF;;EA2pJA;IACE,8BAAA;IACA,oGAAA;EAzpJF;;EA4pJA;IACE,8BAAA;IACA,oGAAA;EA1pJF;;EA6pJA;IACE,8BAAA;IACA,oGAAA;EA3pJF;;EA8pJA;IACE,8BAAA;IACA,oGAAA;EA5pJF;;EA+pJA;IACE,8BAAA;IACA,mGAAA;EA7pJF;;EAgqJA;IACE,8BAAA;IACA,mGAAA;EA9pJF;;EAiqJA;IACE,8BAAA;IACA,mGAAA;EA/pJF;;EAkqJA;IACE,8BAAA;IACA,kGAAA;EAhqJF;;EAmqJA;IACE,iCAAA;IACA,yHAAA;EAjqJF;;EAoqJA;IACE,kCAAA;IACA,+HAAA;EAlqJF;;EAqqJA;IACE,0BAAA;IACA,yHAAA;EAnqJF;;EAsqJA;IACE,0BAAA;IACA,+HAAA;EApqJF;;EAuqJA;IACE,6BAAA;IACA,+HAAA;EArqJF;;EAwqJA;IACE,6BAAA;IACA,+HAAA;EAtqJF;;EAyqJA;IACE,6BAAA;IACA,+HAAA;EAvqJF;;EA0qJA;IACE,6BAAA;IACA,+HAAA;EAxqJF;;EA2qJA;IACE,6BAAA;IACA,+HAAA;EAzqJF;;EA4qJA;IACE,6BAAA;IACA,+HAAA;EA1qJF;;EA6qJA;IACE,6BAAA;IACA,6HAAA;EA3qJF;;EA8qJA;IACE,6BAAA;IACA,4HAAA;EA5qJF;;EA+qJA;IACE,6BAAA;IACA,4HAAA;EA7qJF;;EAgrJA;IACE,6BAAA;IACA,+HAAA;EA9qJF;;EAirJA;IACE,6BAAA;IACA,+HAAA;EA/qJF;;EAkrJA;IACE,6BAAA;IACA,+HAAA;EAhrJF;;EAmrJA;IACE,6BAAA;IACA,+HAAA;EAjrJF;;EAorJA;IACE,6BAAA;IACA,+HAAA;EAlrJF;;EAqrJA;IACE,6BAAA;IACA,6HAAA;EAnrJF;;EAsrJA;IACE,6BAAA;IACA,6HAAA;EAprJF;;EAurJA;IACE,6BAAA;IACA,6HAAA;EArrJF;;EAwrJA;IACE,6BAAA;IACA,6HAAA;EAtrJF;;EAyrJA;IACE,6BAAA;IACA,+HAAA;EAvrJF;;EA0rJA;IACE,6BAAA;IACA,+HAAA;EAxrJF;;EA2rJA;IACE,6BAAA;IACA,+HAAA;EAzrJF;;EA4rJA;IACE,6BAAA;IACA,8HAAA;EA1rJF;;EA6rJA;IACE,6BAAA;IACA,8HAAA;EA3rJF;;EA8rJA;IACE,6BAAA;IACA,8HAAA;EA5rJF;;EA+rJA;IACE,6BAAA;IACA,6HAAA;EA7rJF;;EAgsJA;IACE,6BAAA;IACA,6HAAA;EA9rJF;;EAisJA;IACE,6BAAA;IACA,6HAAA;EA/rJF;;EAksJA;IACE,6BAAA;IACA,+HAAA;EAhsJF;;EAmsJA;IACE,6BAAA;IACA,+HAAA;EAjsJF;;EAosJA;IACE,6BAAA;IACA,+HAAA;EAlsJF;;EAqsJA;IACE,6BAAA;IACA,8HAAA;EAnsJF;;EAssJA;IACE,6BAAA;IACA,8HAAA;EApsJF;;EAusJA;IACE,6BAAA;IACA,8HAAA;EArsJF;;EAwsJA;IACE,6BAAA;IACA,8HAAA;EAtsJF;;EAysJA;IACE,6BAAA;IACA,6HAAA;EAvsJF;;EA0sJA;IACE,6BAAA;IACA,6HAAA;EAxsJF;;EA2sJA;IACE,6BAAA;IACA,+HAAA;EAzsJF;;EA4sJA;IACE,6BAAA;IACA,+HAAA;EA1sJF;;EA6sJA;IACE,6BAAA;IACA,+HAAA;EA3sJF;;EA8sJA;IACE,6BAAA;IACA,+HAAA;EA5sJF;;EA+sJA;IACE,6BAAA;IACA,8HAAA;EA7sJF;;EAgtJA;IACE,6BAAA;IACA,8HAAA;EA9sJF;;EAitJA;IACE,6BAAA;IACA,6HAAA;EA/sJF;;EAktJA;IACE,6BAAA;IACA,6HAAA;EAhtJF;;EAmtJA;IACE,6BAAA;IACA,4HAAA;EAjtJF;;EAotJA;IACE,6BAAA;IACA,+HAAA;EAltJF;;EAqtJA;IACE,6BAAA;IACA,+HAAA;EAntJF;;EAstJA;IACE,6BAAA;IACA,+HAAA;EAptJF;;EAutJA;IACE,6BAAA;IACA,8HAAA;EArtJF;;EAwtJA;IACE,6BAAA;IACA,8HAAA;EAttJF;;EAytJA;IACE,6BAAA;IACA,8HAAA;EAvtJF;;EA0tJA;IACE,6BAAA;IACA,8HAAA;EAxtJF;;EA2tJA;IACE,6BAAA;IACA,4HAAA;EAztJF;;EA4tJA;IACE,6BAAA;IACA,4HAAA;EA1tJF;;EA6tJA;IACE,6BAAA;IACA,+HAAA;EA3tJF;;EA8tJA;IACE,6BAAA;IACA,+HAAA;EA5tJF;;EA+tJA;IACE,6BAAA;IACA,+HAAA;EA7tJF;;EAguJA;IACE,6BAAA;IACA,8HAAA;EA9tJF;;EAiuJA;IACE,6BAAA;IACA,8HAAA;EA/tJF;;EAkuJA;IACE,6BAAA;IACA,8HAAA;EAhuJF;;EAmuJA;IACE,6BAAA;IACA,8HAAA;EAjuJF;;EAouJA;IACE,6BAAA;IACA,6HAAA;EAluJF;;EAquJA;IACE,6BAAA;IACA,6HAAA;EAnuJF;;EAsuJA;IACE,6BAAA;IACA,+HAAA;EApuJF;;EAuuJA;IACE,6BAAA;IACA,+HAAA;EAruJF;;EAwuJA;IACE,6BAAA;IACA,+HAAA;EAtuJF;;EAyuJA;IACE,6BAAA;IACA,+HAAA;EAvuJF;;EA0uJA;IACE,6BAAA;IACA,+HAAA;EAxuJF;;EA2uJA;IACE,6BAAA;IACA,8HAAA;EAzuJF;;EA4uJA;IACE,6BAAA;IACA,6HAAA;EA1uJF;;EA6uJA;IACE,6BAAA;IACA,6HAAA;EA3uJF;;EA8uJA;IACE,6BAAA;IACA,6HAAA;EA5uJF;;EA+uJA;IACE,6BAAA;IACA,+HAAA;EA7uJF;;EAgvJA;IACE,6BAAA;IACA,+HAAA;EA9uJF;;EAivJA;IACE,6BAAA;IACA,+HAAA;EA/uJF;;EAkvJA;IACE,6BAAA;IACA,+HAAA;EAhvJF;;EAmvJA;IACE,6BAAA;IACA,+HAAA;EAjvJF;;EAovJA;IACE,6BAAA;IACA,8HAAA;EAlvJF;;EAqvJA;IACE,6BAAA;IACA,8HAAA;EAnvJF;;EAsvJA;IACE,6BAAA;IACA,6HAAA;EApvJF;;EAuvJA;IACE,6BAAA;IACA,6HAAA;EArvJF;;EAwvJA;IACE,6BAAA;IACA,+HAAA;EAtvJF;;EAyvJA;IACE,6BAAA;IACA,+HAAA;EAvvJF;;EA0vJA;IACE,6BAAA;IACA,+HAAA;EAxvJF;;EA2vJA;IACE,6BAAA;IACA,+HAAA;EAzvJF;;EA4vJA;IACE,6BAAA;IACA,+HAAA;EA1vJF;;EA6vJA;IACE,6BAAA;IACA,8HAAA;EA3vJF;;EA8vJA;IACE,6BAAA;IACA,8HAAA;EA5vJF;;EA+vJA;IACE,6BAAA;IACA,8HAAA;EA7vJF;;EAgwJA;IACE,6BAAA;IACA,6HAAA;EA9vJF;;EAiwJA;IACE,gCAAA;EA/vJF;;EAkwJA;IACE,iCAAA;EAhwJF;;EAmwJA;IACE,yBAAA;EAjwJF;;EAowJA;IACE,yBAAA;EAlwJF;;EAqwJA;IACE,4BAAA;EAnwJF;;EAswJA;IACE,4BAAA;EApwJF;;EAuwJA;IACE,4BAAA;EArwJF;;EAwwJA;IACE,4BAAA;EAtwJF;;EAywJA;IACE,4BAAA;EAvwJF;;EA0wJA;IACE,4BAAA;EAxwJF;;EA2wJA;IACE,4BAAA;EAzwJF;;EA4wJA;IACE,4BAAA;EA1wJF;;EA6wJA;IACE,4BAAA;EA3wJF;;EA8wJA;IACE,4BAAA;EA5wJF;;EA+wJA;IACE,4BAAA;EA7wJF;;EAgxJA;IACE,4BAAA;EA9wJF;;EAixJA;IACE,4BAAA;EA/wJF;;EAkxJA;IACE,4BAAA;EAhxJF;;EAmxJA;IACE,4BAAA;EAjxJF;;EAoxJA;IACE,4BAAA;EAlxJF;;EAqxJA;IACE,4BAAA;EAnxJF;;EAsxJA;IACE,4BAAA;EApxJF;;EAuxJA;IACE,4BAAA;EArxJF;;EAwxJA;IACE,4BAAA;EAtxJF;;EAyxJA;IACE,4BAAA;EAvxJF;;EA0xJA;IACE,4BAAA;EAxxJF;;EA2xJA;IACE,4BAAA;EAzxJF;;EA4xJA;IACE,4BAAA;EA1xJF;;EA6xJA;IACE,4BAAA;EA3xJF;;EA8xJA;IACE,4BAAA;EA5xJF;;EA+xJA;IACE,4BAAA;EA7xJF;;EAgyJA;IACE,4BAAA;EA9xJF;;EAiyJA;IACE,4BAAA;EA/xJF;;EAkyJA;IACE,4BAAA;EAhyJF;;EAmyJA;IACE,4BAAA;EAjyJF;;EAoyJA;IACE,4BAAA;EAlyJF;;EAqyJA;IACE,4BAAA;EAnyJF;;EAsyJA;IACE,4BAAA;EApyJF;;EAuyJA;IACE,4BAAA;EAryJF;;EAwyJA;IACE,4BAAA;EAtyJF;;EAyyJA;IACE,4BAAA;EAvyJF;;EA0yJA;IACE,4BAAA;EAxyJF;;EA2yJA;IACE,4BAAA;EAzyJF;;EA4yJA;IACE,4BAAA;EA1yJF;;EA6yJA;IACE,4BAAA;EA3yJF;;EA8yJA;IACE,4BAAA;EA5yJF;;EA+yJA;IACE,4BAAA;EA7yJF;;EAgzJA;IACE,4BAAA;EA9yJF;;EAizJA;IACE,4BAAA;EA/yJF;;EAkzJA;IACE,4BAAA;EAhzJF;;EAmzJA;IACE,4BAAA;EAjzJF;;EAozJA;IACE,4BAAA;EAlzJF;;EAqzJA;IACE,4BAAA;EAnzJF;;EAszJA;IACE,4BAAA;EApzJF;;EAuzJA;IACE,4BAAA;EArzJF;;EAwzJA;IACE,4BAAA;EAtzJF;;EAyzJA;IACE,4BAAA;EAvzJF;;EA0zJA;IACE,4BAAA;EAxzJF;;EA2zJA;IACE,4BAAA;EAzzJF;;EA4zJA;IACE,4BAAA;EA1zJF;;EA6zJA;IACE,4BAAA;EA3zJF;;EA8zJA;IACE,4BAAA;EA5zJF;;EA+zJA;IACE,4BAAA;EA7zJF;;EAg0JA;IACE,4BAAA;EA9zJF;;EAi0JA;IACE,4BAAA;EA/zJF;;EAk0JA;IACE,4BAAA;EAh0JF;;EAm0JA;IACE,4BAAA;EAj0JF;;EAo0JA;IACE,4BAAA;EAl0JF;;EAq0JA;IACE,4BAAA;EAn0JF;;EAs0JA;IACE,4BAAA;EAp0JF;;EAu0JA;IACE,4BAAA;EAr0JF;;EAw0JA;IACE,4BAAA;EAt0JF;;EAy0JA;IACE,4BAAA;EAv0JF;;EA00JA;IACE,4BAAA;EAx0JF;;EA20JA;IACE,4BAAA;EAz0JF;;EA40JA;IACE,4BAAA;EA10JF;;EA60JA;IACE,4BAAA;EA30JF;;EA80JA;IACE,4BAAA;EA50JF;;EA+0JA;IACE,4BAAA;EA70JF;;EAg1JA;IACE,4BAAA;EA90JF;;EAi1JA;IACE,4BAAA;EA/0JF;;EAk1JA;IACE,4BAAA;EAh1JF;;EAm1JA;IACE,4BAAA;EAj1JF;;EAo1JA;IACE,4BAAA;EAl1JF;;EAq1JA;IACE,4BAAA;EAn1JF;;EAs1JA;IACE,4BAAA;EAp1JF;;EAu1JA;IACE,4BAAA;EAr1JF;;EAw1JA;IACE,4BAAA;EAt1JF;;EAy1JA;IACE,4BAAA;EAv1JF;;EA01JA;IACE,4BAAA;EAx1JF;;EA21JA;IACE,4BAAA;EAz1JF;;EA41JA;IACE,4BAAA;EA11JF;;EA61JA;IACE,4BAAA;EA31JF;;EA81JA;IACE,4BAAA;EA51JF;;EA+1JA;IACE,eAAA;EA71JF;;EAg2JA;IACE,kBAAA;EA91JF;;EAi2JA;IACE,iBAAA;EA/1JF;;EAk2JA;IACE,kBAAA;EAh2JF;;EAm2JA;IACE,eAAA;EAj2JF;;EAo2JA;IACE,eAAA;EAl2JF;;EAq2JA;IACE,kBAAA;EAn2JF;;EAs2JA;IACE,iBAAA;EAp2JF;;EAu2JA;IACE,kBAAA;EAr2JF;;EAw2JA;IACE,eAAA;EAt2JF;;EAy2JA;IACE,eAAA;EAv2JF;;EA02JA;IACE,kBAAA;EAx2JF;;EA22JA;IACE,iBAAA;EAz2JF;;EA42JA;IACE,kBAAA;EA12JF;;EA62JA;IACE,eAAA;EA32JF;;EA82JA;IACE,2BAAA;EA52JF;;EA+2JA;IACE,2BAAA;EA72JF;;EAg3JA;IACE,yBAAA;EA92JF;;EAi3JA;IACE,gCAAA;EA/2JF;;EAk3JA;IACE,6BAAA;EAh3JF;;EAm3JA;IACE,0BAAA;EAj3JF;;EAo3JA;IACE,iCAAA;EAl3JF;;EAq3JA;IACE,8BAAA;EAn3JF;;EAs3JA;IACE,wBAAA;EAp3JF;;EAu3JA;IACE,yBAAA;EAr3JF;;EAw3JA;IACE,4BAAA;EAt3JF;;EAy3JA;IACE,2BAAA;EAv3JF;;EA03JA;IACE,2BAAA;EAx3JF;;EA23JA;IACE,wBAAA;EAz3JF;;EA43JA;IACE,wBAAA;EA13JF;;EA63JA;IACE,qBAAA;EA33JF;;EA83JA;IACE,sBAAA;EA53JF;;EA+3JA;IACE,wBAAA;EA73JF;;EAg4JA;IACE,yBAAA;EA93JF;;EAi4JA;IACE,yBAAA;EA/3JF;;EAk4JA;IACE,yBAAA;EAh4JF;;EAm4JA;IACE,0BAAA;EAj4JF;;EAo4JA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EAl4JF;;EAq4JA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAn4JF;;EAs4JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp4JF;;EAu4JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr4JF;;EAw4JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt4JF;;EAy4JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv4JF;;EA04JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx4JF;;EA24JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz4JF;;EA44JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA14JF;;EA64JA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA34JF;;EA84JA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA54JF;;EA+4JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA74JF;;EAg5JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA94JF;;EAi5JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/4JF;;EAk5JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh5JF;;EAm5JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj5JF;;EAo5JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl5JF;;EAq5JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn5JF;;EAs5JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAp5JF;;EAu5JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAr5JF;;EAw5JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt5JF;;EAy5JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv5JF;;EA05JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx5JF;;EA25JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz5JF;;EA45JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA15JF;;EA65JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA35JF;;EA85JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA55JF;;EA+5JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA75JF;;EAg6JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA95JF;;EAi6JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/5JF;;EAk6JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh6JF;;EAm6JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj6JF;;EAo6JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl6JF;;EAq6JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn6JF;;EAs6JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAp6JF;;EAu6JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAr6JF;;EAw6JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAt6JF;;EAy6JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAv6JF;;EA06JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx6JF;;EA26JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz6JF;;EA46JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA16JF;;EA66JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA36JF;;EA86JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA56JF;;EA+6JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA76JF;;EAg7JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA96JF;;EAi7JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/6JF;;EAk7JA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAh7JF;;EAm7JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj7JF;;EAo7JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl7JF;;EAq7JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn7JF;;EAs7JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAp7JF;;EAu7JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAr7JF;;EAw7JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAt7JF;;EAy7JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAv7JF;;EA07JA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAx7JF;;EA27JA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAz7JF;;EA47JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA17JF;;EA67JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA37JF;;EA87JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA57JF;;EA+7JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA77JF;;EAg8JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA97JF;;EAi8JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/7JF;;EAk8JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAh8JF;;EAm8JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAj8JF;;EAo8JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl8JF;;EAq8JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn8JF;;EAs8JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp8JF;;EAu8JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr8JF;;EAw8JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt8JF;;EAy8JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv8JF;;EA08JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx8JF;;EA28JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAz8JF;;EA48JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA18JF;;EA68JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA38JF;;EA88JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA58JF;;EA+8JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA78JF;;EAg9JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA98JF;;EAi9JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/8JF;;EAk9JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh9JF;;EAm9JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj9JF;;EAo9JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl9JF;;EAq9JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn9JF;;EAs9JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAp9JF;;EAu9JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr9JF;;EAw9JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt9JF;;EAy9JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv9JF;;EA09JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx9JF;;EA29JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz9JF;;EA49JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA19JF;;EA69JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA39JF;;EA89JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA59JF;;EA+9JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA79JF;;EAg+JA;IACE,yBAAA;EA99JF;;EAi+JA;IACE,0BAAA;EA/9JF;;EAk+JA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EAh+JF;;EAm+JA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAj+JF;;EAo+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl+JF;;EAq+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn+JF;;EAs+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp+JF;;EAu+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr+JF;;EAw+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt+JF;;EAy+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv+JF;;EA0+JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAx+JF;;EA2+JA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAz+JF;;EA4+JA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA1+JF;;EA6+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3+JF;;EA8+JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5+JF;;EA++JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7+JF;;EAg/JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9+JF;;EAi/JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/+JF;;EAk/JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAh/JF;;EAm/JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAj/JF;;EAo/JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl/JF;;EAq/JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn/JF;;EAs/JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp/JF;;EAu/JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr/JF;;EAw/JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt/JF;;EAy/JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAv/JF;;EA0/JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx/JF;;EA2/JA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz/JF;;EA4/JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1/JF;;EA6/JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3/JF;;EA8/JA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5/JF;;EA+/JA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7/JF;;EAggKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9/JF;;EAigKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA//JF;;EAkgKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhgKF;;EAmgKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjgKF;;EAogKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlgKF;;EAqgKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAngKF;;EAsgKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EApgKF;;EAugKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EArgKF;;EAwgKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtgKF;;EAygKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvgKF;;EA0gKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxgKF;;EA2gKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzgKF;;EA4gKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1gKF;;EA6gKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3gKF;;EA8gKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5gKF;;EA+gKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7gKF;;EAghKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA9gKF;;EAihKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/gKF;;EAkhKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhhKF;;EAmhKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjhKF;;EAohKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlhKF;;EAqhKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnhKF;;EAshKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAphKF;;EAuhKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArhKF;;EAwhKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAthKF;;EAyhKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAvhKF;;EA0hKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxhKF;;EA2hKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzhKF;;EA4hKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1hKF;;EA6hKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3hKF;;EA8hKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5hKF;;EA+hKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7hKF;;EAgiKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9hKF;;EAiiKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/hKF;;EAkiKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhiKF;;EAmiKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjiKF;;EAoiKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAliKF;;EAqiKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAniKF;;EAsiKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApiKF;;EAuiKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAriKF;;EAwiKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtiKF;;EAyiKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAviKF;;EA0iKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxiKF;;EA2iKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAziKF;;EA4iKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1iKF;;EA6iKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3iKF;;EA8iKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5iKF;;EA+iKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7iKF;;EAgjKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9iKF;;EAijKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/iKF;;EAkjKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhjKF;;EAmjKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjjKF;;EAojKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAljKF;;EAqjKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnjKF;;EAsjKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApjKF;;EAujKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArjKF;;EAwjKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtjKF;;EAyjKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvjKF;;EA0jKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxjKF;;EA2jKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzjKF;;EA4jKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1jKF;;EA6jKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3jKF;;EA8jKA;IACE,yBAAA;EA5jKF;;EA+jKA;IACE,0BAAA;EA7jKF;;EAgkKA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EA9jKF;;EAikKA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EA/jKF;;EAkkKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhkKF;;EAmkKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjkKF;;EAokKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlkKF;;EAqkKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnkKF;;EAskKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApkKF;;EAukKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArkKF;;EAwkKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtkKF;;EAykKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAvkKF;;EA0kKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAxkKF;;EA2kKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzkKF;;EA4kKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1kKF;;EA6kKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3kKF;;EA8kKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5kKF;;EA+kKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7kKF;;EAglKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9kKF;;EAilKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/kKF;;EAklKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhlKF;;EAmlKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjlKF;;EAolKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAllKF;;EAqlKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnlKF;;EAslKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAplKF;;EAulKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArlKF;;EAwlKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtlKF;;EAylKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvlKF;;EA0lKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxlKF;;EA2lKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzlKF;;EA4lKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1lKF;;EA6lKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3lKF;;EA8lKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5lKF;;EA+lKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7lKF;;EAgmKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9lKF;;EAimKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/lKF;;EAkmKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhmKF;;EAmmKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjmKF;;EAomKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAlmKF;;EAqmKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnmKF;;EAsmKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApmKF;;EAumKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArmKF;;EAwmKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtmKF;;EAymKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvmKF;;EA0mKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxmKF;;EA2mKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzmKF;;EA4mKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1mKF;;EA6mKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3mKF;;EA8mKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA5mKF;;EA+mKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7mKF;;EAgnKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9mKF;;EAinKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/mKF;;EAknKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhnKF;;EAmnKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjnKF;;EAonKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlnKF;;EAqnKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnnKF;;EAsnKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EApnKF;;EAunKA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EArnKF;;EAwnKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtnKF;;EAynKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvnKF;;EA0nKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxnKF;;EA2nKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAznKF;;EA4nKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1nKF;;EA6nKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3nKF;;EA8nKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5nKF;;EA+nKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7nKF;;EAgoKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9nKF;;EAioKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/nKF;;EAkoKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhoKF;;EAmoKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjoKF;;EAooKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAloKF;;EAqoKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnoKF;;EAsoKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApoKF;;EAuoKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAroKF;;EAwoKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtoKF;;EAyoKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvoKF;;EA0oKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxoKF;;EA2oKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzoKF;;EA4oKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1oKF;;EA6oKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3oKF;;EA8oKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5oKF;;EA+oKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7oKF;;EAgpKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9oKF;;EAipKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/oKF;;EAkpKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhpKF;;EAmpKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjpKF;;EAopKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlpKF;;EAqpKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnpKF;;EAspKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAppKF;;EAupKA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArpKF;;EAwpKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtpKF;;EAypKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvpKF;;EA0pKA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxpKF;;EA2pKA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzpKF;;EA4pKA;IACE,mBAAA;EA1pKF;;EA6pKA;IACE,sBAAA;EA3pKF;;EA8pKA;IACE,qBAAA;EA5pKF;;EA+pKA;IACE,sBAAA;EA7pKF;;EAgqKA;IACE,mBAAA;EA9pKF;;EAiqKA;IACE,mBAAA;EA/pKF;;EAkqKA;IACE,sBAAA;EAhqKF;;EAmqKA;IACE,qBAAA;EAjqKF;;EAoqKA;IACE,sBAAA;EAlqKF;;EAqqKA;IACE,mBAAA;EAnqKF;;EAsqKA;IACE,mBAAA;EApqKF;;EAuqKA;IACE,sBAAA;EArqKF;;EAwqKA;IACE,qBAAA;EAtqKF;;EAyqKA;IACE,sBAAA;EAvqKF;;EA0qKA;IACE,mBAAA;EAxqKF;;EA2qKA;IACE,gBAAA;EAzqKF;;EA4qKA;IACE,uBAAA;EA1qKF;;EA6qKA;IACE,sBAAA;EA3qKF;;EA8qKA;IACE,uBAAA;EA5qKF;;EA+qKA;IACE,qBAAA;EA7qKF;;EAgrKA;IACE,sBAAA;EA9qKF;;EAirKA;IACE,mBAAA;EA/qKF;;EAkrKA;IACE,qBAAA;EAhrKF;;EAmrKA;IACE,qBAAA;EAjrKF;;EAorKA;IACE,yBAAA;IACA,0BAAA;EAlrKF;;EAqrKA;IACE,0BAAA;IACA,6BAAA;EAnrKF;;EAsrKA;IACE,6BAAA;IACA,4BAAA;EAprKF;;EAurKA;IACE,yBAAA;IACA,4BAAA;EArrKF;;EAwrKA;IACE,gCAAA;IACA,iCAAA;EAtrKF;;EAyrKA;IACE,iCAAA;IACA,oCAAA;EAvrKF;;EA0rKA;IACE,oCAAA;IACA,mCAAA;EAxrKF;;EA2rKA;IACE,gCAAA;IACA,mCAAA;EAzrKF;;EA4rKA;IACE,+BAAA;IACA,gCAAA;EA1rKF;;EA6rKA;IACE,gCAAA;IACA,mCAAA;EA3rKF;;EA8rKA;IACE,mCAAA;IACA,kCAAA;EA5rKF;;EA+rKA;IACE,+BAAA;IACA,kCAAA;EA7rKF;;EAgsKA;IACE,gCAAA;IACA,iCAAA;EA9rKF;;EAisKA;IACE,iCAAA;IACA,oCAAA;EA/rKF;;EAksKA;IACE,oCAAA;IACA,mCAAA;EAhsKF;;EAmsKA;IACE,gCAAA;IACA,mCAAA;EAjsKF;;EAosKA;IACE,8BAAA;IACA,+BAAA;EAlsKF;;EAqsKA;IACE,+BAAA;IACA,kCAAA;EAnsKF;;EAssKA;IACE,kCAAA;IACA,iCAAA;EApsKF;;EAusKA;IACE,8BAAA;IACA,iCAAA;EArsKF;;EAwsKA;IACE,+BAAA;IACA,gCAAA;EAtsKF;;EAysKA;IACE,gCAAA;IACA,mCAAA;EAvsKF;;EA0sKA;IACE,mCAAA;IACA,kCAAA;EAxsKF;;EA2sKA;IACE,+BAAA;IACA,kCAAA;EAzsKF;;EA4sKA;IACE,4BAAA;IACA,6BAAA;EA1sKF;;EA6sKA;IACE,6BAAA;IACA,gCAAA;EA3sKF;;EA8sKA;IACE,gCAAA;IACA,+BAAA;EA5sKF;;EA+sKA;IACE,4BAAA;IACA,+BAAA;EA7sKF;;EAgtKA;IACE,8BAAA;IACA,+BAAA;EA9sKF;;EAitKA;IACE,+BAAA;IACA,kCAAA;EA/sKF;;EAktKA;IACE,kCAAA;IACA,iCAAA;EAhtKF;;EAmtKA;IACE,8BAAA;IACA,iCAAA;EAjtKF;;EAotKA;IACE,8BAAA;IACA,+BAAA;EAltKF;;EAqtKA;IACE,+BAAA;IACA,kCAAA;EAntKF;;EAstKA;IACE,kCAAA;IACA,iCAAA;EAptKF;;EAutKA;IACE,8BAAA;IACA,iCAAA;EArtKF;;EAwtKA;IACE,yBAAA;EAttKF;;EAytKA;IACE,0BAAA;EAvtKF;;EA0tKA;IACE,6BAAA;EAxtKF;;EA2tKA;IACE,4BAAA;EAztKF;;EA4tKA;IACE,gCAAA;EA1tKF;;EA6tKA;IACE,iCAAA;EA3tKF;;EA8tKA;IACE,oCAAA;EA5tKF;;EA+tKA;IACE,mCAAA;EA7tKF;;EAguKA;IACE,+BAAA;EA9tKF;;EAiuKA;IACE,gCAAA;EA/tKF;;EAkuKA;IACE,mCAAA;EAhuKF;;EAmuKA;IACE,kCAAA;EAjuKF;;EAouKA;IACE,gCAAA;EAluKF;;EAquKA;IACE,iCAAA;EAnuKF;;EAsuKA;IACE,oCAAA;EApuKF;;EAuuKA;IACE,mCAAA;EAruKF;;EAwuKA;IACE,8BAAA;EAtuKF;;EAyuKA;IACE,+BAAA;EAvuKF;;EA0uKA;IACE,kCAAA;EAxuKF;;EA2uKA;IACE,iCAAA;EAzuKF;;EA4uKA;IACE,+BAAA;EA1uKF;;EA6uKA;IACE,gCAAA;EA3uKF;;EA8uKA;IACE,mCAAA;EA5uKF;;EA+uKA;IACE,kCAAA;EA7uKF;;EAgvKA;IACE,4BAAA;EA9uKF;;EAivKA;IACE,6BAAA;EA/uKF;;EAkvKA;IACE,gCAAA;EAhvKF;;EAmvKA;IACE,+BAAA;EAjvKF;;EAovKA;IACE,8BAAA;EAlvKF;;EAqvKA;IACE,+BAAA;EAnvKF;;EAsvKA;IACE,kCAAA;EApvKF;;EAuvKA;IACE,iCAAA;EArvKF;;EAwvKA;IACE,8BAAA;EAtvKF;;EAyvKA;IACE,+BAAA;EAvvKF;;EA0vKA;IACE,kCAAA;EAxvKF;;EA2vKA;IACE,iCAAA;EAzvKF;;EA4vKA;IACE,mBAAA;EA1vKF;;EA6vKA;IACE,oBAAA;EA3vKF;;EA8vKA;IACE,oBAAA;EA5vKF;;EA+vKA;IACE,oBAAA;EA7vKF;;EAgwKA;IACE,kBAAA;EA9vKF;;EAiwKA;IACE,eAAA;EA/vKF;;EAkwKA;IACE,iBAAA;EAhwKF;;EAmwKA;IACE,iBAAA;EAjwKF;;EAowKA;IACE,iBAAA;EAlwKF;;EAqwKA;IACE,iBAAA;EAnwKF;;EAswKA;IACE,mBAAA;EApwKF;;EAuwKA;IACE,qBAAA;EArwKF;;EAwwKA;IACE,sBAAA;EAtwKF;;EAywKA;IACE,oBAAA;EAvwKF;;EA0wKA;IACE,qBAAA;EAxwKF;;EA2wKA;IACE,uBAAA;EAzwKF;;EA4wKA;IACE,wBAAA;EA1wKF;;EA6wKA;IACE,sBAAA;EA3wKF;;EA8wKA;IACE,qBAAA;EA5wKF;;EA+wKA;IACE,uBAAA;EA7wKF;;EAgxKA;IACE,wBAAA;EA9wKF;;EAixKA;IACE,sBAAA;EA/wKF;;EAkxKA;IACE,qBAAA;EAhxKF;;EAmxKA;IACE,uBAAA;EAjxKF;;EAoxKA;IACE,wBAAA;EAlxKF;;EAqxKA;IACE,sBAAA;EAnxKF;;EAsxKA;IACE,qBAAA;EApxKF;;EAuxKA;IACE,uBAAA;EArxKF;;EAwxKA;IACE,wBAAA;EAtxKF;;EAyxKA;IACE,sBAAA;EAvxKF;;EA0xKA;IACE,sBAAA;EAxxKF;;EA2xKA;IACE,uBAAA;EAzxKF;;EA4xKA;IACE,YAAA;EA1xKF;;EA6xKA;IACE,eAAA;EA3xKF;;EA8xKA;IACE,eAAA;EA5xKF;;EA+xKA;IACE,YAAA;EA7xKF;;EAgyKA;IACE,YAAA;EA9xKF;;EAiyKA;IACE,YAAA;EA/xKF;;EAkyKA;IACE,mBAAA;EAhyKF;;EAmyKA;IACE,cAAA;EAjyKF;;EAoyKA;IACE,qBAAA;EAlyKF;;EAqyKA;IACE,eAAA;EAnyKF;;EAsyKA;IACE,aAAA;EApyKF;;EAuyKA;IACE,oBAAA;EAryKF;;EAwyKA;IACE,cAAA;EAtyKF;;EAyyKA;IACE,sBAAA;EAvyKF;;EA0yKA;IACE,mBAAA;EAxyKF;;EA2yKA;IACE,qBAAA;EAzyKF;;EA4yKA;IACE,2BAAA;EA1yKF;;EA6yKA;IACE,2BAAA;EA3yKF;;EA8yKA;IACE,2BAAA;EA5yKF;;EA+yKA;IACE,wBAAA;EA7yKF;;EAgzKA;IACE,kBAAA;EA9yKF;;EAizKA;IACE,kBAAA;EA/yKF;;EAkzKA;IACE,aAAA;EAhzKF;;EAmzKA;IACE,oBAAA;EAjzKF;;EAozKA;IACE,iBAAA;EAlzKF;;EAqzKA;IACE,aAAA;EAnzKF;;EAszKA;IACE,mBAAA;EApzKF;;EAuzKA;IACE,2BAAA;EArzKF;;EAwzKA;IACE,sBAAA;EAtzKF;;EAyzKA;IACE,8BAAA;EAvzKF;;EA0zKA;IACE,eAAA;EAxzKF;;EA2zKA;IACE,uBAAA;EAzzKF;;EA4zKA;IACE,iBAAA;EA1zKF;;EA6zKA;IACE,iBAAA;EA3zKF;;EA8zKA;IACE,kBAAA;EA5zKF;;EA+zKA;IACE,gBAAA;EA7zKF;;EAg0KA;IACE,mBAAA;EA9zKF;;EAi0KA;IACE,oBAAA;EA/zKF;;EAk0KA;IACE,qBAAA;EAh0KF;;EAm0KA;IACE,oBAAA;EAj0KF;;EAo0KA;IACE,kBAAA;EAl0KF;;EAq0KA;IACE,4BAAA;EAn0KF;;EAs0KA;IACE,2BAAA;EAp0KF;;EAu0KA;IACE,2BAAA;EAr0KF;;EAw0KA;IACE,sBAAA;EAt0KF;;EAy0KA;IACE,gBAAA;EAv0KF;;EA00KA;IACE,iBAAA;EAx0KF;;EA20KA;IACE,eAAA;EAz0KF;;EA40KA;IACE,kBAAA;EA10KF;;EA60KA;IACE,mBAAA;EA30KF;;EA80KA;IACE,uBAAA;EA50KF;;EA+0KA;IACE,qBAAA;EA70KF;;EAg1KA;IACE,mBAAA;EA90KF;;EAi1KA;IACE,qBAAA;EA/0KF;;EAk1KA;IACE,oBAAA;EAh1KF;;EAm1KA;IACE,qBAAA;EAj1KF;;EAo1KA;IACE,yBAAA;EAl1KF;;EAq1KA;IACE,uBAAA;EAn1KF;;EAs1KA;IACE,4BAAA;EAp1KF;;EAu1KA;IACE,2BAAA;EAr1KF;;EAw1KA;IACE,2BAAA;EAt1KF;;EAy1KA;IACE,gBAAA;EAv1KF;;EA01KA;IACE,sBAAA;EAx1KF;;EA21KA;IACE,oBAAA;EAz1KF;;EA41KA;IACE,kBAAA;EA11KF;;EA61KA;IACE,mBAAA;EA31KF;;EA81KA;IACE,mBAAA;EA51KF;;EA+1KA;IACE,oBAAA;EA71KF;;EAg2KA;IACE,kBAAA;EA91KF;;EAi2KA;IACE,qBAAA;EA/1KF;;EAk2KA;IACE,sBAAA;EAh2KF;;EAm2KA;IACE,2BAAA;EAj2KF;;EAo2KA;IACE,yBAAA;EAl2KF;;EAq2KA;IACE,uBAAA;EAn2KF;;EAs2KA;IACE,8BAAA;EAp2KF;;EAu2KA;IACE,6BAAA;EAr2KF;;EAw2KA;IACE,6BAAA;EAt2KF;;EAy2KA;IACE,kBAAA;EAv2KF;;EA02KA;IACE,mBAAA;EAx2KF;;EA22KA;IACE,iBAAA;EAz2KF;;EA42KA;IACE,oBAAA;EA12KF;;EA62KA;IACE,qBAAA;EA32KF;;EA82KA;IACE,SAAA;EA52KF;;EA+2KA;IACE,cAAA;EA72KF;;EAg3KA;IACE,cAAA;EA92KF;;EAi3KA;IACE,UAAA;EA/2KF;;EAk3KA;IACE,YAAA;EAh3KF;;EAm3KA;IACE,YAAA;EAj3KF;;EAo3KA;IACE,cAAA;EAl3KF;;EAq3KA;IACE,cAAA;EAn3KF;;EAs3KA;IACE,QAAA;EAp3KF;;EAu3KA;IACE,QAAA;EAr3KF;;EAw3KA;IACE,QAAA;EAt3KF;;EAy3KA;IACE,QAAA;EAv3KF;;EA03KA;IACE,QAAA;EAx3KF;;EA23KA;IACE,QAAA;EAz3KF;;EA43KA;IACE,QAAA;EA13KF;;EA63KA;IACE,QAAA;EA33KF;;EA83KA;IACE,QAAA;EA53KF;;EA+3KA;IACE,SAAA;EA73KF;;EAg4KA;IACE,SAAA;EA93KF;;EAi4KA;IACE,SAAA;EA/3KF;;EAk4KA;IACE,YAAA;EAh4KF;;EAm4KA;IACE,WAAA;EAj4KF;;EAo4KA;IACE,QAAA;EAl4KF;;EAq4KA;IACE,YAAA;EAn4KF;;EAs4KA;IACE,WAAA;EAp4KF;;EAu4KA;IACE,WAAA;EAr4KF;;EAw4KA;IACE,WAAA;IACA,cAAA;IACA,WAAA;EAt4KF;;EAy4KA;IACE,WAAA;EAv4KF;;EA04KA;IACE,YAAA;EAx4KF;;EA24KA;IACE,WAAA;EAz4KF;;EA44KA;IACE,WAAA;EA14KF;;EA64KA;IACE,6MAAA;EA34KF;;EA84KA;IACE,8DAAA;EA54KF;;EA+4KA;IACE,iFAAA;EA74KF;;EAg5KA;IACE,gBAAA;EA94KF;;EAi5KA;IACE,gBAAA;EA/4KF;;EAk5KA;IACE,gBAAA;EAh5KF;;EAm5KA;IACE,gBAAA;EAj5KF;;EAo5KA;IACE,gBAAA;EAl5KF;;EAq5KA;IACE,gBAAA;EAn5KF;;EAs5KA;IACE,gBAAA;EAp5KF;;EAu5KA;IACE,gBAAA;EAr5KF;;EAw5KA;IACE,gBAAA;EAt5KF;;EAy5KA;IACE,gBAAA;EAv5KF;;EA05KA;IACE,gBAAA;EAx5KF;;EA25KA;IACE,gBAAA;EAz5KF;;EA45KA;IACE,gBAAA;EA15KF;;EA65KA;IACE,gBAAA;EA35KF;;EA85KA;IACE,gBAAA;EA55KF;;EA+5KA;IACE,gBAAA;EA75KF;;EAg6KA;IACE,gBAAA;EA95KF;;EAi6KA;IACE,gBAAA;EA/5KF;;EAk6KA;IACE,gBAAA;EAh6KF;;EAm6KA;IACE,gBAAA;EAj6KF;;EAo6KA;IACE,gBAAA;EAl6KF;;EAq6KA;IACE,gBAAA;EAn6KF;;EAs6KA;IACE,gBAAA;EAp6KF;;EAu6KA;IACE,gBAAA;EAr6KF;;EAw6KA;IACE,gBAAA;EAt6KF;;EAy6KA;IACE,gBAAA;EAv6KF;;EA06KA;IACE,gBAAA;EAx6KF;;EA26KA;IACE,SAAA;EAz6KF;;EA46KA;IACE,eAAA;EA16KF;;EA66KA;IACE,cAAA;EA36KF;;EA86KA;IACE,eAAA;EA56KF;;EA+6KA;IACE,YAAA;EA76KF;;EAg7KA;IACE,eAAA;EA96KF;;EAi7KA;IACE,cAAA;EA/6KF;;EAk7KA;IACE,YAAA;EAh7KF;;EAm7KA;IACE,cAAA;EAj7KF;;EAo7KA;IACE,YAAA;EAl7KF;;EAq7KA;IACE,YAAA;EAn7KF;;EAs7KA;IACE,YAAA;EAp7KF;;EAu7KA;IACE,YAAA;EAr7KF;;EAw7KA;IACE,YAAA;EAt7KF;;EAy7KA;IACE,aAAA;EAv7KF;;EA07KA;IACE,aAAA;EAx7KF;;EA27KA;IACE,aAAA;EAz7KF;;EA47KA;IACE,aAAA;EA17KF;;EA67KA;IACE,YAAA;EA37KF;;EA87KA;IACE,WAAA;EA57KF;;EA+7KA;IACE,YAAA;EA77KF;;EAg8KA;IACE,aAAA;EA97KF;;EAi8KA;IACE,oBAAA;EA/7KF;;EAk8KA;IACE,kBAAA;EAh8KF;;EAm8KA;IACE,mBAAA;EAj8KF;;EAo8KA;IACE,eAAA;EAl8KF;;EAq8KA;IACE,mBAAA;EAn8KF;;EAs8KA;IACE,kBAAA;EAp8KF;;EAu8KA;IACE,mBAAA;EAr8KF;;EAw8KA;IACE,iBAAA;EAt8KF;;EAy8KA;IACE,mBAAA;EAv8KF;;EA08KA;IACE,kBAAA;EAx8KF;;EA28KA;IACE,eAAA;EAz8KF;;EA48KA;IACE,eAAA;EA18KF;;EA68KA;IACE,oBAAA;EA38KF;;EA88KA;IACE,iBAAA;EA58KF;;EA+8KA;IACE,oBAAA;EA78KF;;EAg9KA;IACE,mBAAA;EA98KF;;EAi9KA;IACE,oBAAA;EA/8KF;;EAk9KA;IACE,iBAAA;EAh9KF;;EAm9KA;IACE,oBAAA;EAj9KF;;EAo9KA;IACE,mBAAA;EAl9KF;;EAq9KA;IACE,cAAA;EAn9KF;;EAs9KA;IACE,iBAAA;EAp9KF;;EAu9KA;IACE,kBAAA;EAr9KF;;EAw9KA;IACE,gBAAA;EAt9KF;;EAy9KA;IACE,kBAAA;EAv9KF;;EA09KA;IACE,cAAA;EAx9KF;;EA29KA;IACE,2BAAA;EAz9KF;;EA49KA;IACE,4BAAA;EA19KF;;EA69KA;IACE,qBAAA;EA39KF;;EA89KA;IACE,qBAAA;EA59KF;;EA+9KA;IACE,wBAAA;EA79KF;;EAg+KA;IACE,SAAA;EA99KF;;EAi+KA;IACE,eAAA;EA/9KF;;EAk+KA;IACE,cAAA;EAh+KF;;EAm+KA;IACE,eAAA;EAj+KF;;EAo+KA;IACE,YAAA;EAl+KF;;EAq+KA;IACE,eAAA;EAn+KF;;EAs+KA;IACE,cAAA;EAp+KF;;EAu+KA;IACE,YAAA;EAr+KF;;EAw+KA;IACE,cAAA;EAt+KF;;EAy+KA;IACE,YAAA;EAv+KF;;EA0+KA;IACE,YAAA;EAx+KF;;EA2+KA;IACE,YAAA;EAz+KF;;EA4+KA;IACE,YAAA;EA1+KF;;EA6+KA;IACE,YAAA;EA3+KF;;EA8+KA;IACE,aAAA;EA5+KF;;EA++KA;IACE,aAAA;EA7+KF;;EAg/KA;IACE,aAAA;EA9+KF;;EAi/KA;IACE,aAAA;EA/+KF;;EAk/KA;IACE,YAAA;EAh/KF;;EAm/KA;IACE,WAAA;EAj/KF;;EAo/KA;IACE,gBAAA;EAl/KF;;EAq/KA;IACE,eAAA;EAn/KF;;EAs/KA;IACE,gBAAA;EAp/KF;;EAu/KA;IACE,aAAA;EAr/KF;;EAw/KA;IACE,gBAAA;EAt/KF;;EAy/KA;IACE,eAAA;EAv/KF;;EA0/KA;IACE,aAAA;EAx/KF;;EA2/KA;IACE,eAAA;EAz/KF;;EA4/KA;IACE,aAAA;EA1/KF;;EA6/KA;IACE,aAAA;EA3/KF;;EA8/KA;IACE,aAAA;EA5/KF;;EA+/KA;IACE,aAAA;EA7/KF;;EAggLA;IACE,aAAA;EA9/KF;;EAigLA;IACE,cAAA;EA//KF;;EAkgLA;IACE,cAAA;EAhgLF;;EAmgLA;IACE,cAAA;EAjgLF;;EAogLA;IACE,cAAA;EAlgLF;;EAqgLA;IACE,YAAA;EAngLF;;EAsgLA;IACE,aAAA;IACA,gBAAA;EApgLF;;EAugLA;IACE,cAAA;IACA,eAAA;EArgLF;;EAwgLA;IACE,mBAAA;IACA,sBAAA;EAtgLF;;EAygLA;IACE,oBAAA;IACA,qBAAA;EAvgLF;;EA0gLA;IACE,kBAAA;IACA,qBAAA;EAxgLF;;EA2gLA;IACE,mBAAA;IACA,oBAAA;EAzgLF;;EA4gLA;IACE,mBAAA;IACA,sBAAA;EA1gLF;;EA6gLA;IACE,oBAAA;IACA,qBAAA;EA3gLF;;EA8gLA;IACE,gBAAA;IACA,mBAAA;EA5gLF;;EA+gLA;IACE,iBAAA;IACA,kBAAA;EA7gLF;;EAghLA;IACE,mBAAA;IACA,sBAAA;EA9gLF;;EAihLA;IACE,oBAAA;IACA,qBAAA;EA/gLF;;EAkhLA;IACE,kBAAA;IACA,qBAAA;EAhhLF;;EAmhLA;IACE,mBAAA;IACA,oBAAA;EAjhLF;;EAohLA;IACE,gBAAA;IACA,mBAAA;EAlhLF;;EAqhLA;IACE,iBAAA;IACA,kBAAA;EAnhLF;;EAshLA;IACE,kBAAA;IACA,qBAAA;EAphLF;;EAuhLA;IACE,mBAAA;IACA,oBAAA;EArhLF;;EAwhLA;IACE,gBAAA;IACA,mBAAA;EAthLF;;EAyhLA;IACE,iBAAA;IACA,kBAAA;EAvhLF;;EA0hLA;IACE,gBAAA;IACA,mBAAA;EAxhLF;;EA2hLA;IACE,iBAAA;IACA,kBAAA;EAzhLF;;EA4hLA;IACE,gBAAA;IACA,mBAAA;EA1hLF;;EA6hLA;IACE,iBAAA;IACA,kBAAA;EA3hLF;;EA8hLA;IACE,gBAAA;IACA,mBAAA;EA5hLF;;EA+hLA;IACE,iBAAA;IACA,kBAAA;EA7hLF;;EAgiLA;IACE,gBAAA;IACA,mBAAA;EA9hLF;;EAiiLA;IACE,iBAAA;IACA,kBAAA;EA/hLF;;EAkiLA;IACE,iBAAA;IACA,oBAAA;EAhiLF;;EAmiLA;IACE,kBAAA;IACA,mBAAA;EAjiLF;;EAoiLA;IACE,iBAAA;IACA,oBAAA;EAliLF;;EAqiLA;IACE,kBAAA;IACA,mBAAA;EAniLF;;EAsiLA;IACE,iBAAA;IACA,oBAAA;EApiLF;;EAuiLA;IACE,kBAAA;IACA,mBAAA;EAriLF;;EAwiLA;IACE,iBAAA;IACA,oBAAA;EAtiLF;;EAyiLA;IACE,kBAAA;IACA,mBAAA;EAviLF;;EA0iLA;IACE,gBAAA;IACA,mBAAA;EAxiLF;;EA2iLA;IACE,iBAAA;IACA,kBAAA;EAziLF;;EA4iLA;IACE,eAAA;IACA,kBAAA;EA1iLF;;EA6iLA;IACE,gBAAA;IACA,iBAAA;EA3iLF;;EA8iLA;IACE,oBAAA;IACA,uBAAA;EA5iLF;;EA+iLA;IACE,qBAAA;IACA,sBAAA;EA7iLF;;EAgjLA;IACE,mBAAA;IACA,sBAAA;EA9iLF;;EAijLA;IACE,oBAAA;IACA,qBAAA;EA/iLF;;EAkjLA;IACE,oBAAA;IACA,uBAAA;EAhjLF;;EAmjLA;IACE,qBAAA;IACA,sBAAA;EAjjLF;;EAojLA;IACE,iBAAA;IACA,oBAAA;EAljLF;;EAqjLA;IACE,kBAAA;IACA,mBAAA;EAnjLF;;EAsjLA;IACE,oBAAA;IACA,uBAAA;EApjLF;;EAujLA;IACE,qBAAA;IACA,sBAAA;EArjLF;;EAwjLA;IACE,mBAAA;IACA,sBAAA;EAtjLF;;EAyjLA;IACE,oBAAA;IACA,qBAAA;EAvjLF;;EA0jLA;IACE,iBAAA;IACA,oBAAA;EAxjLF;;EA2jLA;IACE,kBAAA;IACA,mBAAA;EAzjLF;;EA4jLA;IACE,mBAAA;IACA,sBAAA;EA1jLF;;EA6jLA;IACE,oBAAA;IACA,qBAAA;EA3jLF;;EA8jLA;IACE,iBAAA;IACA,oBAAA;EA5jLF;;EA+jLA;IACE,kBAAA;IACA,mBAAA;EA7jLF;;EAgkLA;IACE,iBAAA;IACA,oBAAA;EA9jLF;;EAikLA;IACE,kBAAA;IACA,mBAAA;EA/jLF;;EAkkLA;IACE,iBAAA;IACA,oBAAA;EAhkLF;;EAmkLA;IACE,kBAAA;IACA,mBAAA;EAjkLF;;EAokLA;IACE,iBAAA;IACA,oBAAA;EAlkLF;;EAqkLA;IACE,kBAAA;IACA,mBAAA;EAnkLF;;EAskLA;IACE,iBAAA;IACA,oBAAA;EApkLF;;EAukLA;IACE,kBAAA;IACA,mBAAA;EArkLF;;EAwkLA;IACE,kBAAA;IACA,qBAAA;EAtkLF;;EAykLA;IACE,mBAAA;IACA,oBAAA;EAvkLF;;EA0kLA;IACE,kBAAA;IACA,qBAAA;EAxkLF;;EA2kLA;IACE,mBAAA;IACA,oBAAA;EAzkLF;;EA4kLA;IACE,kBAAA;IACA,qBAAA;EA1kLF;;EA6kLA;IACE,mBAAA;IACA,oBAAA;EA3kLF;;EA8kLA;IACE,kBAAA;IACA,qBAAA;EA5kLF;;EA+kLA;IACE,mBAAA;IACA,oBAAA;EA7kLF;;EAglLA;IACE,gBAAA;IACA,mBAAA;EA9kLF;;EAilLA;IACE,iBAAA;IACA,kBAAA;EA/kLF;;EAklLA;IACE,aAAA;EAhlLF;;EAmlLA;IACE,eAAA;EAjlLF;;EAolLA;IACE,gBAAA;EAllLF;;EAqlLA;IACE,cAAA;EAnlLF;;EAslLA;IACE,mBAAA;EAplLF;;EAulLA;IACE,qBAAA;EArlLF;;EAwlLA;IACE,sBAAA;EAtlLF;;EAylLA;IACE,oBAAA;EAvlLF;;EA0lLA;IACE,kBAAA;EAxlLF;;EA2lLA;IACE,oBAAA;EAzlLF;;EA4lLA;IACE,qBAAA;EA1lLF;;EA6lLA;IACE,mBAAA;EA3lLF;;EA8lLA;IACE,mBAAA;EA5lLF;;EA+lLA;IACE,qBAAA;EA7lLF;;EAgmLA;IACE,sBAAA;EA9lLF;;EAimLA;IACE,oBAAA;EA/lLF;;EAkmLA;IACE,gBAAA;EAhmLF;;EAmmLA;IACE,kBAAA;EAjmLF;;EAomLA;IACE,mBAAA;EAlmLF;;EAqmLA;IACE,iBAAA;EAnmLF;;EAsmLA;IACE,mBAAA;EApmLF;;EAumLA;IACE,qBAAA;EArmLF;;EAwmLA;IACE,sBAAA;EAtmLF;;EAymLA;IACE,oBAAA;EAvmLF;;EA0mLA;IACE,kBAAA;EAxmLF;;EA2mLA;IACE,oBAAA;EAzmLF;;EA4mLA;IACE,qBAAA;EA1mLF;;EA6mLA;IACE,mBAAA;EA3mLF;;EA8mLA;IACE,gBAAA;EA5mLF;;EA+mLA;IACE,kBAAA;EA7mLF;;EAgnLA;IACE,mBAAA;EA9mLF;;EAinLA;IACE,iBAAA;EA/mLF;;EAknLA;IACE,kBAAA;EAhnLF;;EAmnLA;IACE,oBAAA;EAjnLF;;EAonLA;IACE,qBAAA;EAlnLF;;EAqnLA;IACE,mBAAA;EAnnLF;;EAsnLA;IACE,gBAAA;EApnLF;;EAunLA;IACE,kBAAA;EArnLF;;EAwnLA;IACE,mBAAA;EAtnLF;;EAynLA;IACE,iBAAA;EAvnLF;;EA0nLA;IACE,gBAAA;EAxnLF;;EA2nLA;IACE,kBAAA;EAznLF;;EA4nLA;IACE,mBAAA;EA1nLF;;EA6nLA;IACE,iBAAA;EA3nLF;;EA8nLA;IACE,gBAAA;EA5nLF;;EA+nLA;IACE,kBAAA;EA7nLF;;EAgoLA;IACE,mBAAA;EA9nLF;;EAioLA;IACE,iBAAA;EA/nLF;;EAkoLA;IACE,gBAAA;EAhoLF;;EAmoLA;IACE,kBAAA;EAjoLF;;EAooLA;IACE,mBAAA;EAloLF;;EAqoLA;IACE,iBAAA;EAnoLF;;EAsoLA;IACE,gBAAA;EApoLF;;EAuoLA;IACE,kBAAA;EAroLF;;EAwoLA;IACE,mBAAA;EAtoLF;;EAyoLA;IACE,iBAAA;EAvoLF;;EA0oLA;IACE,iBAAA;EAxoLF;;EA2oLA;IACE,mBAAA;EAzoLF;;EA4oLA;IACE,oBAAA;EA1oLF;;EA6oLA;IACE,kBAAA;EA3oLF;;EA8oLA;IACE,iBAAA;EA5oLF;;EA+oLA;IACE,mBAAA;EA7oLF;;EAgpLA;IACE,oBAAA;EA9oLF;;EAipLA;IACE,kBAAA;EA/oLF;;EAkpLA;IACE,iBAAA;EAhpLF;;EAmpLA;IACE,mBAAA;EAjpLF;;EAopLA;IACE,oBAAA;EAlpLF;;EAqpLA;IACE,kBAAA;EAnpLF;;EAspLA;IACE,iBAAA;EAppLF;;EAupLA;IACE,mBAAA;EArpLF;;EAwpLA;IACE,oBAAA;EAtpLF;;EAypLA;IACE,kBAAA;EAvpLF;;EA0pLA;IACE,gBAAA;EAxpLF;;EA2pLA;IACE,kBAAA;EAzpLF;;EA4pLA;IACE,mBAAA;EA1pLF;;EA6pLA;IACE,iBAAA;EA3pLF;;EA8pLA;IACE,eAAA;EA5pLF;;EA+pLA;IACE,iBAAA;EA7pLF;;EAgqLA;IACE,kBAAA;EA9pLF;;EAiqLA;IACE,gBAAA;EA/pLF;;EAkqLA;IACE,oBAAA;EAhqLF;;EAmqLA;IACE,sBAAA;EAjqLF;;EAoqLA;IACE,uBAAA;EAlqLF;;EAqqLA;IACE,qBAAA;EAnqLF;;EAsqLA;IACE,mBAAA;EApqLF;;EAuqLA;IACE,qBAAA;EArqLF;;EAwqLA;IACE,sBAAA;EAtqLF;;EAyqLA;IACE,oBAAA;EAvqLF;;EA0qLA;IACE,oBAAA;EAxqLF;;EA2qLA;IACE,sBAAA;EAzqLF;;EA4qLA;IACE,uBAAA;EA1qLF;;EA6qLA;IACE,qBAAA;EA3qLF;;EA8qLA;IACE,iBAAA;EA5qLF;;EA+qLA;IACE,mBAAA;EA7qLF;;EAgrLA;IACE,oBAAA;EA9qLF;;EAirLA;IACE,kBAAA;EA/qLF;;EAkrLA;IACE,oBAAA;EAhrLF;;EAmrLA;IACE,sBAAA;EAjrLF;;EAorLA;IACE,uBAAA;EAlrLF;;EAqrLA;IACE,qBAAA;EAnrLF;;EAsrLA;IACE,mBAAA;EAprLF;;EAurLA;IACE,qBAAA;EArrLF;;EAwrLA;IACE,sBAAA;EAtrLF;;EAyrLA;IACE,oBAAA;EAvrLF;;EA0rLA;IACE,iBAAA;EAxrLF;;EA2rLA;IACE,mBAAA;EAzrLF;;EA4rLA;IACE,oBAAA;EA1rLF;;EA6rLA;IACE,kBAAA;EA3rLF;;EA8rLA;IACE,mBAAA;EA5rLF;;EA+rLA;IACE,qBAAA;EA7rLF;;EAgsLA;IACE,sBAAA;EA9rLF;;EAisLA;IACE,oBAAA;EA/rLF;;EAksLA;IACE,iBAAA;EAhsLF;;EAmsLA;IACE,mBAAA;EAjsLF;;EAosLA;IACE,oBAAA;EAlsLF;;EAqsLA;IACE,kBAAA;EAnsLF;;EAssLA;IACE,iBAAA;EApsLF;;EAusLA;IACE,mBAAA;EArsLF;;EAwsLA;IACE,oBAAA;EAtsLF;;EAysLA;IACE,kBAAA;EAvsLF;;EA0sLA;IACE,iBAAA;EAxsLF;;EA2sLA;IACE,mBAAA;EAzsLF;;EA4sLA;IACE,oBAAA;EA1sLF;;EA6sLA;IACE,kBAAA;EA3sLF;;EA8sLA;IACE,iBAAA;EA5sLF;;EA+sLA;IACE,mBAAA;EA7sLF;;EAgtLA;IACE,oBAAA;EA9sLF;;EAitLA;IACE,kBAAA;EA/sLF;;EAktLA;IACE,iBAAA;EAhtLF;;EAmtLA;IACE,mBAAA;EAjtLF;;EAotLA;IACE,oBAAA;EAltLF;;EAqtLA;IACE,kBAAA;EAntLF;;EAstLA;IACE,kBAAA;EAptLF;;EAutLA;IACE,oBAAA;EArtLF;;EAwtLA;IACE,qBAAA;EAttLF;;EAytLA;IACE,mBAAA;EAvtLF;;EA0tLA;IACE,kBAAA;EAxtLF;;EA2tLA;IACE,oBAAA;EAztLF;;EA4tLA;IACE,qBAAA;EA1tLF;;EA6tLA;IACE,mBAAA;EA3tLF;;EA8tLA;IACE,kBAAA;EA5tLF;;EA+tLA;IACE,oBAAA;EA7tLF;;EAguLA;IACE,qBAAA;EA9tLF;;EAiuLA;IACE,mBAAA;EA/tLF;;EAkuLA;IACE,kBAAA;EAhuLF;;EAmuLA;IACE,oBAAA;EAjuLF;;EAouLA;IACE,qBAAA;EAluLF;;EAquLA;IACE,mBAAA;EAnuLF;;EAsuLA;IACE,gBAAA;EApuLF;;EAuuLA;IACE,kBAAA;EAruLF;;EAwuLA;IACE,mBAAA;EAtuLF;;EAyuLA;IACE,iBAAA;EAvuLF;;EA0uLA;IACE,gBAAA;EAxuLF;;EA2uLA;IACE,iBAAA;EAzuLF;;EA4uLA;IACE,eAAA;EA1uLF;;EA6uLA;IACE,gBAAA;EA3uLF;;EA8uLA;IACE,gBAAA;EA5uLF;;EA+uLA;IACE,gBAAA;EA7uLF;;EAgvLA;IACE,gBAAA;EA9uLF;;EAivLA;IACE,gBAAA;EA/uLF;;EAkvLA;IACE,gBAAA;EAhvLF;;EAmvLA;IACE,gBAAA;EAjvLF;;EAovLA;IACE,gBAAA;EAlvLF;;EAqvLA;IACE,gBAAA;EAnvLF;;EAsvLA;IACE,gBAAA;EApvLF;;EAuvLA;IACE,eAAA;EArvLF;;EAwvLA;IACE,gBAAA;EAtvLF;;EAyvLA;IACE,gBAAA;EAvvLF;;EA0vLA;IACE,iBAAA;EAxvLF;;EA2vLA;IACE,iBAAA;EAzvLF;;EA4vLA;IACE,aAAA;EA1vLF;;EA6vLA;IACE,gBAAA;EA3vLF;;EA8vLA;IACE,iBAAA;EA5vLF;;EA+vLA;IACE,YAAA;EA7vLF;;EAgwLA;IACE,eAAA;EA9vLF;;EAiwLA;IACE,mBAAA;EA/vLF;;EAkwLA;IACE,iBAAA;EAhwLF;;EAmwLA;IACE,gBAAA;EAjwLF;;EAowLA;IACE,gBAAA;EAlwLF;;EAqwLA;IACE,sBAAA;EAnwLF;;EAswLA;IACE,uBAAA;EApwLF;;EAuwLA;IACE,uBAAA;EArwLF;;EAwwLA;IACE,qBAAA;EAtwLF;;EAywLA;IACE,4BAAA;EAvwLF;;EA0wLA;IACE,yBAAA;EAxwLF;;EA2wLA;IACE,sBAAA;EAzwLF;;EA4wLA;IACE,6BAAA;EA1wLF;;EA6wLA;IACE,0BAAA;EA3wLF;;EA8wLA;IACE,oBAAA;EA5wLF;;EA+wLA;IACE,UAAA;EA7wLF;;EAgxLA;IACE,aAAA;EA9wLF;;EAixLA;IACE,YAAA;EA/wLF;;EAkxLA;IACE,aAAA;EAhxLF;;EAmxLA;IACE,UAAA;EAjxLF;;EAoxLA;IACE,UAAA;EAlxLF;;EAqxLA;IACE,aAAA;EAnxLF;;EAsxLA;IACE,YAAA;EApxLF;;EAuxLA;IACE,aAAA;EArxLF;;EAwxLA;IACE,UAAA;EAtxLF;;EAyxLA;IACE,UAAA;EAvxLF;;EA0xLA;IACE,aAAA;EAxxLF;;EA2xLA;IACE,YAAA;EAzxLF;;EA4xLA;IACE,aAAA;EA1xLF;;EA6xLA;IACE,UAAA;EA3xLF;;EA8xLA;IACE,8BAAA;IACA,mBAAA;EA5xLF;;EA+xLA;IACE,yBAAA;IACA,mBAAA;EA7xLF;;EAgyLA;IACE,yBAAA;IACA,mBAAA;EA9xLF;;EAiyLA;IACE,8BAAA;IACA,mBAAA;EA/xLF;;EAkyLA;IACE,yBAAA;IACA,mBAAA;EAhyLF;;EAmyLA;IACE,yBAAA;IACA,mBAAA;EAjyLF;;EAoyLA;IACE,cAAA;EAlyLF;;EAqyLA;IACE,gBAAA;EAnyLF;;EAsyLA;IACE,iBAAA;EApyLF;;EAuyLA;IACE,gBAAA;EAryLF;;EAwyLA;IACE,gBAAA;EAtyLF;;EAyyLA;IACE,gBAAA;EAvyLF;;EA0yLA;IACE,kBAAA;EAxyLF;;EA2yLA;IACE,kBAAA;EAzyLF;;EA4yLA;IACE,mBAAA;EA1yLF;;EA6yLA;IACE,mBAAA;EA3yLF;;EA8yLA;IACE,kBAAA;EA5yLF;;EA+yLA;IACE,kBAAA;EA7yLF;;EAgzLA;IACE,iCAAA;EA9yLF;;EAizLA;IACE,gCAAA;EA/yLF;;EAkzLA;IACE,yBAAA;EAhzLF;;EAmzLA;IACE,4BAAA;EAjzLF;;EAozLA;IACE,yBAAA;EAlzLF;;EAqzLA;IACE,2BAAA;EAnzLF;;EAszLA;IACE,8BAAA;EApzLF;;EAuzLA;IACE,2BAAA;EArzLF;;EAwzLA;IACE,2BAAA;EAtzLF;;EAyzLA;IACE,8BAAA;EAvzLF;;EA0zLA;IACE,2BAAA;EAxzLF;;EA2zLA;IACE,UAAA;EAzzLF;;EA4zLA;IACE,gBAAA;EA1zLF;;EA6zLA;IACE,eAAA;EA3zLF;;EA8zLA;IACE,gBAAA;EA5zLF;;EA+zLA;IACE,aAAA;EA7zLF;;EAg0LA;IACE,gBAAA;EA9zLF;;EAi0LA;IACE,eAAA;EA/zLF;;EAk0LA;IACE,aAAA;EAh0LF;;EAm0LA;IACE,eAAA;EAj0LF;;EAo0LA;IACE,aAAA;EAl0LF;;EAq0LA;IACE,aAAA;EAn0LF;;EAs0LA;IACE,aAAA;EAp0LF;;EAu0LA;IACE,aAAA;EAr0LF;;EAw0LA;IACE,aAAA;EAt0LF;;EAy0LA;IACE,cAAA;EAv0LF;;EA00LA;IACE,cAAA;EAx0LF;;EA20LA;IACE,cAAA;EAz0LF;;EA40LA;IACE,cAAA;EA10LF;;EA60LA;IACE,YAAA;EA30LF;;EA80LA;IACE,cAAA;IACA,iBAAA;EA50LF;;EA+0LA;IACE,eAAA;IACA,gBAAA;EA70LF;;EAg1LA;IACE,oBAAA;IACA,uBAAA;EA90LF;;EAi1LA;IACE,qBAAA;IACA,sBAAA;EA/0LF;;EAk1LA;IACE,mBAAA;IACA,sBAAA;EAh1LF;;EAm1LA;IACE,oBAAA;IACA,qBAAA;EAj1LF;;EAo1LA;IACE,oBAAA;IACA,uBAAA;EAl1LF;;EAq1LA;IACE,qBAAA;IACA,sBAAA;EAn1LF;;EAs1LA;IACE,iBAAA;IACA,oBAAA;EAp1LF;;EAu1LA;IACE,kBAAA;IACA,mBAAA;EAr1LF;;EAw1LA;IACE,oBAAA;IACA,uBAAA;EAt1LF;;EAy1LA;IACE,qBAAA;IACA,sBAAA;EAv1LF;;EA01LA;IACE,mBAAA;IACA,sBAAA;EAx1LF;;EA21LA;IACE,oBAAA;IACA,qBAAA;EAz1LF;;EA41LA;IACE,iBAAA;IACA,oBAAA;EA11LF;;EA61LA;IACE,kBAAA;IACA,mBAAA;EA31LF;;EA81LA;IACE,mBAAA;IACA,sBAAA;EA51LF;;EA+1LA;IACE,oBAAA;IACA,qBAAA;EA71LF;;EAg2LA;IACE,iBAAA;IACA,oBAAA;EA91LF;;EAi2LA;IACE,kBAAA;IACA,mBAAA;EA/1LF;;EAk2LA;IACE,iBAAA;IACA,oBAAA;EAh2LF;;EAm2LA;IACE,kBAAA;IACA,mBAAA;EAj2LF;;EAo2LA;IACE,iBAAA;IACA,oBAAA;EAl2LF;;EAq2LA;IACE,kBAAA;IACA,mBAAA;EAn2LF;;EAs2LA;IACE,iBAAA;IACA,oBAAA;EAp2LF;;EAu2LA;IACE,kBAAA;IACA,mBAAA;EAr2LF;;EAw2LA;IACE,iBAAA;IACA,oBAAA;EAt2LF;;EAy2LA;IACE,kBAAA;IACA,mBAAA;EAv2LF;;EA02LA;IACE,kBAAA;IACA,qBAAA;EAx2LF;;EA22LA;IACE,mBAAA;IACA,oBAAA;EAz2LF;;EA42LA;IACE,kBAAA;IACA,qBAAA;EA12LF;;EA62LA;IACE,mBAAA;IACA,oBAAA;EA32LF;;EA82LA;IACE,kBAAA;IACA,qBAAA;EA52LF;;EA+2LA;IACE,mBAAA;IACA,oBAAA;EA72LF;;EAg3LA;IACE,kBAAA;IACA,qBAAA;EA92LF;;EAi3LA;IACE,mBAAA;IACA,oBAAA;EA/2LF;;EAk3LA;IACE,gBAAA;IACA,mBAAA;EAh3LF;;EAm3LA;IACE,iBAAA;IACA,kBAAA;EAj3LF;;EAo3LA;IACE,cAAA;EAl3LF;;EAq3LA;IACE,gBAAA;EAn3LF;;EAs3LA;IACE,iBAAA;EAp3LF;;EAu3LA;IACE,eAAA;EAr3LF;;EAw3LA;IACE,oBAAA;EAt3LF;;EAy3LA;IACE,sBAAA;EAv3LF;;EA03LA;IACE,uBAAA;EAx3LF;;EA23LA;IACE,qBAAA;EAz3LF;;EA43LA;IACE,mBAAA;EA13LF;;EA63LA;IACE,qBAAA;EA33LF;;EA83LA;IACE,sBAAA;EA53LF;;EA+3LA;IACE,oBAAA;EA73LF;;EAg4LA;IACE,oBAAA;EA93LF;;EAi4LA;IACE,sBAAA;EA/3LF;;EAk4LA;IACE,uBAAA;EAh4LF;;EAm4LA;IACE,qBAAA;EAj4LF;;EAo4LA;IACE,iBAAA;EAl4LF;;EAq4LA;IACE,mBAAA;EAn4LF;;EAs4LA;IACE,oBAAA;EAp4LF;;EAu4LA;IACE,kBAAA;EAr4LF;;EAw4LA;IACE,oBAAA;EAt4LF;;EAy4LA;IACE,sBAAA;EAv4LF;;EA04LA;IACE,uBAAA;EAx4LF;;EA24LA;IACE,qBAAA;EAz4LF;;EA44LA;IACE,mBAAA;EA14LF;;EA64LA;IACE,qBAAA;EA34LF;;EA84LA;IACE,sBAAA;EA54LF;;EA+4LA;IACE,oBAAA;EA74LF;;EAg5LA;IACE,iBAAA;EA94LF;;EAi5LA;IACE,mBAAA;EA/4LF;;EAk5LA;IACE,oBAAA;EAh5LF;;EAm5LA;IACE,kBAAA;EAj5LF;;EAo5LA;IACE,mBAAA;EAl5LF;;EAq5LA;IACE,qBAAA;EAn5LF;;EAs5LA;IACE,sBAAA;EAp5LF;;EAu5LA;IACE,oBAAA;EAr5LF;;EAw5LA;IACE,iBAAA;EAt5LF;;EAy5LA;IACE,mBAAA;EAv5LF;;EA05LA;IACE,oBAAA;EAx5LF;;EA25LA;IACE,kBAAA;EAz5LF;;EA45LA;IACE,iBAAA;EA15LF;;EA65LA;IACE,mBAAA;EA35LF;;EA85LA;IACE,oBAAA;EA55LF;;EA+5LA;IACE,kBAAA;EA75LF;;EAg6LA;IACE,iBAAA;EA95LF;;EAi6LA;IACE,mBAAA;EA/5LF;;EAk6LA;IACE,oBAAA;EAh6LF;;EAm6LA;IACE,kBAAA;EAj6LF;;EAo6LA;IACE,iBAAA;EAl6LF;;EAq6LA;IACE,mBAAA;EAn6LF;;EAs6LA;IACE,oBAAA;EAp6LF;;EAu6LA;IACE,kBAAA;EAr6LF;;EAw6LA;IACE,iBAAA;EAt6LF;;EAy6LA;IACE,mBAAA;EAv6LF;;EA06LA;IACE,oBAAA;EAx6LF;;EA26LA;IACE,kBAAA;EAz6LF;;EA46LA;IACE,kBAAA;EA16LF;;EA66LA;IACE,oBAAA;EA36LF;;EA86LA;IACE,qBAAA;EA56LF;;EA+6LA;IACE,mBAAA;EA76LF;;EAg7LA;IACE,kBAAA;EA96LF;;EAi7LA;IACE,oBAAA;EA/6LF;;EAk7LA;IACE,qBAAA;EAh7LF;;EAm7LA;IACE,mBAAA;EAj7LF;;EAo7LA;IACE,kBAAA;EAl7LF;;EAq7LA;IACE,oBAAA;EAn7LF;;EAs7LA;IACE,qBAAA;EAp7LF;;EAu7LA;IACE,mBAAA;EAr7LF;;EAw7LA;IACE,kBAAA;EAt7LF;;EAy7LA;IACE,oBAAA;EAv7LF;;EA07LA;IACE,qBAAA;EAx7LF;;EA27LA;IACE,mBAAA;EAz7LF;;EA47LA;IACE,gBAAA;EA17LF;;EA67LA;IACE,kBAAA;EA37LF;;EA87LA;IACE,mBAAA;EA57LF;;EA+7LA;IACE,iBAAA;EA77LF;;EAg8LA;IACE,kBAAA;EA97LF;;EAi8LA;IACE,mBAAA;EA/7LF;;EAk8LA;IACE,wBAAA;IACA,WAAA;IACA,gDAAA;EAh8LF;;EAm8LA;IACE,wBAAA;IACA,WAAA;IACA,sDAAA;EAj8LF;;EAo8LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl8LF;;EAq8LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn8LF;;EAs8LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp8LF;;EAu8LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr8LF;;EAw8LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt8LF;;EAy8LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv8LF;;EA08LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAx8LF;;EA28LA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAz8LF;;EA48LA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA18LF;;EA68LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA38LF;;EA88LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA58LF;;EA+8LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA78LF;;EAg9LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA98LF;;EAi9LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/8LF;;EAk9LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAh9LF;;EAm9LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAj9LF;;EAo9LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAl9LF;;EAq9LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAn9LF;;EAs9LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp9LF;;EAu9LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr9LF;;EAw9LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt9LF;;EAy9LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAv9LF;;EA09LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAx9LF;;EA29LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAz9LF;;EA49LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA19LF;;EA69LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA39LF;;EA89LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA59LF;;EA+9LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA79LF;;EAg+LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA99LF;;EAi+LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/9LF;;EAk+LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAh+LF;;EAm+LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAj+LF;;EAo+LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAl+LF;;EAq+LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAn+LF;;EAs+LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAp+LF;;EAu+LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAr+LF;;EAw+LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt+LF;;EAy+LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv+LF;;EA0+LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAx+LF;;EA2+LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAz+LF;;EA4+LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1+LF;;EA6+LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA3+LF;;EA8+LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA5+LF;;EA++LA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA7+LF;;EAg/LA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA9+LF;;EAi/LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/+LF;;EAk/LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAh/LF;;EAm/LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAj/LF;;EAo/LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAl/LF;;EAq/LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAn/LF;;EAs/LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAp/LF;;EAu/LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAr/LF;;EAw/LA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAt/LF;;EAy/LA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAv/LF;;EA0/LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAx/LF;;EA2/LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAz/LF;;EA4/LA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1/LF;;EA6/LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA3/LF;;EA8/LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA5/LF;;EA+/LA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA7/LF;;EAggMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9/LF;;EAigMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA//LF;;EAkgMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAhgMF;;EAmgMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjgMF;;EAogMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlgMF;;EAqgMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAngMF;;EAsgMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApgMF;;EAugMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArgMF;;EAwgMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAtgMF;;EAygMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAvgMF;;EA0gMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAxgMF;;EA2gMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAzgMF;;EA4gMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1gMF;;EA6gMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3gMF;;EA8gMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5gMF;;EA+gMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7gMF;;EAghMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9gMF;;EAihMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/gMF;;EAkhMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAhhMF;;EAmhMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAjhMF;;EAohMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAlhMF;;EAqhMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnhMF;;EAshMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAphMF;;EAuhMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArhMF;;EAwhMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAthMF;;EAyhMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvhMF;;EA0hMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAxhMF;;EA2hMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAzhMF;;EA4hMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1hMF;;EA6hMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA3hMF;;EA8hMA;IACE,kBAAA;EA5hMF;;EA+hMA;IACE,mBAAA;EA7hMF;;EAgiMA;IACE,wBAAA;IACA,WAAA;IACA,gDAAA;EA9hMF;;EAiiMA;IACE,wBAAA;IACA,WAAA;IACA,sDAAA;EA/hMF;;EAkiMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhiMF;;EAmiMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjiMF;;EAoiMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAliMF;;EAqiMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAniMF;;EAsiMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApiMF;;EAuiMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAriMF;;EAwiMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAtiMF;;EAyiMA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAviMF;;EA0iMA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAxiMF;;EA2iMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAziMF;;EA4iMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1iMF;;EA6iMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3iMF;;EA8iMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5iMF;;EA+iMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7iMF;;EAgjMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA9iMF;;EAijMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/iMF;;EAkjMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAhjMF;;EAmjMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAjjMF;;EAojMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAljMF;;EAqjMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnjMF;;EAsjMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApjMF;;EAujMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EArjMF;;EAwjMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAtjMF;;EAyjMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAvjMF;;EA0jMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAxjMF;;EA2jMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAzjMF;;EA4jMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA1jMF;;EA6jMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3jMF;;EA8jMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5jMF;;EA+jMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7jMF;;EAgkMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9jMF;;EAikMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/jMF;;EAkkMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAhkMF;;EAmkMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAjkMF;;EAokMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAlkMF;;EAqkMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAnkMF;;EAskMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApkMF;;EAukMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArkMF;;EAwkMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtkMF;;EAykMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvkMF;;EA0kMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAxkMF;;EA2kMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAzkMF;;EA4kMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA1kMF;;EA6kMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA3kMF;;EA8kMA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA5kMF;;EA+kMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7kMF;;EAglMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9kMF;;EAilMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/kMF;;EAklMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAhlMF;;EAmlMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAjlMF;;EAolMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAllMF;;EAqlMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAnlMF;;EAslMA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAplMF;;EAulMA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EArlMF;;EAwlMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtlMF;;EAylMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvlMF;;EA0lMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxlMF;;EA2lMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAzlMF;;EA4lMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1lMF;;EA6lMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA3lMF;;EA8lMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA5lMF;;EA+lMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA7lMF;;EAgmMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA9lMF;;EAimMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/lMF;;EAkmMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhmMF;;EAmmMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjmMF;;EAomMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlmMF;;EAqmMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnmMF;;EAsmMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EApmMF;;EAumMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EArmMF;;EAwmMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAtmMF;;EAymMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAvmMF;;EA0mMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxmMF;;EA2mMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAzmMF;;EA4mMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1mMF;;EA6mMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3mMF;;EA8mMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5mMF;;EA+mMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA7mMF;;EAgnMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9mMF;;EAinMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/mMF;;EAknMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAhnMF;;EAmnMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjnMF;;EAonMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlnMF;;EAqnMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnnMF;;EAsnMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApnMF;;EAunMA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArnMF;;EAwnMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAtnMF;;EAynMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAvnMF;;EA0nMA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAxnMF;;EA2nMA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAznMF;;EA4nMA;IACE,wBAAA;EA1nMF;;EA6nMA;IACE,2BAAA;EA3nMF;;EA8nMA;IACE,0BAAA;EA5nMF;;EA+nMA;IACE,2BAAA;EA7nMF;;EAgoMA;IACE,wBAAA;EA9nMF;;EAioMA;IACE,wBAAA;EA/nMF;;EAkoMA;IACE,2BAAA;EAhoMF;;EAmoMA;IACE,0BAAA;EAjoMF;;EAooMA;IACE,2BAAA;EAloMF;;EAqoMA;IACE,wBAAA;EAnoMF;;EAsoMA;IACE,oBAAA;EApoMF;;EAuoMA;IACE,oBAAA;EAroMF;;EAwoMA;IACE,gBAAA;EAtoMF;;EAyoMA;IACE,eAAA;EAvoMF;;EA0oMA;IACE,kBAAA;EAxoMF;;EA2oMA;IACE,kBAAA;EAzoMF;;EA4oMA;IACE,gBAAA;EA1oMF;;EA6oMA;IACE,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;EA3oMF;;EA8oMA;IACE,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EA5oMF;;EA+oMA;IACE,MAAA;IACA,SAAA;EA7oMF;;EAgpMA;IACE,QAAA;IACA,OAAA;EA9oMF;;EAipMA;IACE,SAAA;IACA,YAAA;EA/oMF;;EAkpMA;IACE,WAAA;IACA,UAAA;EAhpMF;;EAmpMA;IACE,MAAA;EAjpMF;;EAopMA;IACE,QAAA;EAlpMF;;EAqpMA;IACE,SAAA;EAnpMF;;EAspMA;IACE,OAAA;EAppMF;;EAupMA;IACE,SAAA;EArpMF;;EAwpMA;IACE,WAAA;EAtpMF;;EAypMA;IACE,YAAA;EAvpMF;;EA0pMA;IACE,UAAA;EAxpMF;;EA2pMA;IACE,YAAA;EAzpMF;;EA4pMA;IACE,gBAAA;EA1pMF;;EA6pMA;IACE,kBAAA;EA3pMF;;EA8pMA;IACE,YAAA;EA5pMF;;EA+pMA;IACE,yCAAA;EA7pMF;;EAgqMA;IACE,2CAAA;EA9pMF;;EAiqMA;IACE,2EAAA;EA/pMF;;EAkqMA;IACE,iFAAA;EAhqMF;;EAmqMA;IACE,mFAAA;EAjqMF;;EAoqMA;IACE,qFAAA;EAlqMF;;EAqqMA;IACE,iDAAA;EAnqMF;;EAsqMA;IACE,iDAAA;EApqMF;;EAuqMA;IACE,6CAAA;EArqMF;;EAwqMA;IACE,gBAAA;EAtqMF;;EAyqMA;IACE,yCAAA;EAvqMF;;EA0qMA;IACE,2CAAA;EAxqMF;;EA2qMA;IACE,2EAAA;EAzqMF;;EA4qMA;IACE,iFAAA;EA1qMF;;EA6qMA;IACE,mFAAA;EA3qMF;;EA8qMA;IACE,qFAAA;EA5qMF;;EA+qMA;IACE,iDAAA;EA7qMF;;EAgrMA;IACE,iDAAA;EA9qMF;;EAirMA;IACE,6CAAA;EA/qMF;;EAkrMA;IACE,gBAAA;EAhrMF;;EAmrMA;IACE,yCAAA;EAjrMF;;EAorMA;IACE,2CAAA;EAlrMF;;EAqrMA;IACE,2EAAA;EAnrMF;;EAsrMA;IACE,iFAAA;EAprMF;;EAurMA;IACE,mFAAA;EArrMF;;EAwrMA;IACE,qFAAA;EAtrMF;;EAyrMA;IACE,iDAAA;EAvrMF;;EA0rMA;IACE,iDAAA;EAxrMF;;EA2rMA;IACE,6CAAA;EAzrMF;;EA4rMA;IACE,gBAAA;EA1rMF;;EA6rMA;IACE,kBAAA;EA3rMF;;EA8rMA;IACE,oBAAA;EA5rMF;;EA+rMA;IACE,eAAA;EA7rMF;;EAgsMA;IACE,eAAA;EA9rMF;;EAisMA;IACE,eAAA;EA/rMF;;EAksMA;IACE,kBAAA;EAhsMF;;EAmsMA;IACE,mBAAA;EAjsMF;;EAosMA;IACE,gBAAA;EAlsMF;;EAqsMA;IACE,kBAAA;EAnsMF;;EAssMA;IACE,iBAAA;EApsMF;;EAusMA;IACE,mBAAA;EArsMF;;EAwsMA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EAtsMF;;EAysMA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EAvsMF;;EA0sMA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EAxsMF;;EA2sMA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EAzsMF;;EA4sMA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EA1sMF;;EA6sMA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EA3sMF;;EA8sMA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EA5sMF;;EA+sMA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EA7sMF;;EAgtMA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EA9sMF;;EAitMA;IACE,iBAAA;EA/sMF;;EAktMA;IACE,oBAAA;EAhtMF;;EAmtMA;IACE,mBAAA;EAjtMF;;EAotMA;IACE,oBAAA;EAltMF;;EAqtMA;IACE,iBAAA;EAntMF;;EAstMA;IACE,iBAAA;EAptMF;;EAutMA;IACE,oBAAA;EArtMF;;EAwtMA;IACE,mBAAA;EAttMF;;EAytMA;IACE,oBAAA;EAvtMF;;EA0tMA;IACE,iBAAA;EAxtMF;;EA2tMA;IACE,iBAAA;EAztMF;;EA4tMA;IACE,oBAAA;EA1tMF;;EA6tMA;IACE,mBAAA;EA3tMF;;EA8tMA;IACE,oBAAA;EA5tMF;;EA+tMA;IACE,iBAAA;EA7tMF;;EAguMA;IACE,kBAAA;EA9tMF;;EAiuMA;IACE,kBAAA;EA/tMF;;EAkuMA;IACE,yBAAA;EAhuMF;;EAmuMA;IACE,yBAAA;EAjuMF;;EAouMA;IACE,0BAAA;EAluMF;;EAquMA;IACE,oBAAA;EAnuMF;;EAsuMA;IACE,0BAAA;EApuMF;;EAuuMA;IACE,6BAAA;EAruMF;;EAwuMA;IACE,qBAAA;EAtuMF;;EAyuMA;IACE,0BAAA;EAvuMF;;EA0uMA;IACE,6BAAA;EAxuMF;;EA2uMA;IACE,qBAAA;EAzuMF;;EA4uMA;IACE,0BAAA;EA1uMF;;EA6uMA;IACE,6BAAA;EA3uMF;;EA8uMA;IACE,qBAAA;EA5uMF;;EA+uMA;IACE,mCAAA;IACA,kCAAA;EA7uMF;;EAgvMA;IACE,4BAAA;IACA,6BAAA;EA9uMF;;EAivMA;IACE,iEAAA;IACA,sEAAA;IACA,gEAAA;IACA,iEAAA;IACA,kEAAA;IACA,8MAAA;EA/uMF;;EAkvMA;IACE,4BAAA;EAhvMF;;EAmvMA;IACE,uCAAA;EAjvMF;;EAovMA;IACE,iDAAA;EAlvMF;;EAqvMA;IACE,0CAAA;EAnvMF;;EAsvMA;IACE,4CAAA;EApvMF;;EAuvMA;IACE,iDAAA;EArvMF;;EAwvMA;IACE,4CAAA;EAtvMF;;EAyvMA;IACE,mDAAA;EAvvMF;;EA0vMA;IACE,kDAAA;EAxvMF;;EA2vMA;IACE,uBAAA;EAzvMF;;EA4vMA;IACE,wBAAA;EA1vMF;;EA6vMA;IACE,iBAAA;EA3vMF;;EA8vMA;IACE,uBAAA;EA5vMF;;EA+vMA;IACE,sBAAA;EA7vMF;;EAgwMA;IACE,qBAAA;EA9vMF;;EAiwMA;IACE,yBAAA;IACQ,iBAAA;EA/vMV;;EAkwMA;IACE,yBAAA;IACQ,iBAAA;EAhwMV;;EAmwMA;IACE,wBAAA;IACQ,gBAAA;EAjwMV;;EAowMA;IACE,yBAAA;IACQ,iBAAA;EAlwMV;;EAqwMA;IACE,wBAAA;EAnwMF;;EAswMA;IACE,mBAAA;EApwMF;;EAuwMA;IACE,sBAAA;EArwMF;;EAwwMA;IACE,sBAAA;EAtwMF;;EAywMA;IACE,wBAAA;EAvwMF;;EA0wMA;IACE,2BAAA;EAxwMF;;EA2wMA;IACE,mBAAA;EAzwMF;;EA4wMA;IACE,kBAAA;EA1wMF;;EA6wMA;IACE,mBAAA;EA3wMF;;EA8wMA;IACE,mBAAA;EA5wMF;;EA+wMA;IACE,gBAAA;EA7wMF;;EAgxMA;IACE,qBAAA;EA9wMF;;EAixMA;IACE,qBAAA;EA/wMF;;EAkxMA;IACE,iBAAA;IACA,qBAAA;IACA,kBAAA;EAhxMF;;EAmxMA;IACE,qBAAA;IACA,yBAAA;EAjxMF;;EAoxMA;IACE,qBAAA;EAlxMF;;EAqxMA;IACE,gBAAA;IACA,uBAAA;IACA,mBAAA;EAnxMF;;EAsxMA;IACE,QAAA;EApxMF;;EAuxMA;IACE,cAAA;EArxMF;;EAwxMA;IACE,aAAA;EAtxMF;;EAyxMA;IACE,cAAA;EAvxMF;;EA0xMA;IACE,WAAA;EAxxMF;;EA2xMA;IACE,cAAA;EAzxMF;;EA4xMA;IACE,aAAA;EA1xMF;;EA6xMA;IACE,WAAA;EA3xMF;;EA8xMA;IACE,aAAA;EA5xMF;;EA+xMA;IACE,WAAA;EA7xMF;;EAgyMA;IACE,WAAA;EA9xMF;;EAiyMA;IACE,WAAA;EA/xMF;;EAkyMA;IACE,WAAA;EAhyMF;;EAmyMA;IACE,WAAA;EAjyMF;;EAoyMA;IACE,YAAA;EAlyMF;;EAqyMA;IACE,YAAA;EAnyMF;;EAsyMA;IACE,YAAA;EApyMF;;EAuyMA;IACE,YAAA;EAryMF;;EAwyMA;IACE,WAAA;EAtyMF;;EAyyMA;IACE,UAAA;EAvyMF;;EA0yMA;IACE,UAAA;EAxyMF;;EA2yMA;IACE,iBAAA;EAzyMF;;EA4yMA;IACE,iBAAA;EA1yMF;;EA6yMA;IACE,UAAA;EA3yMF;;EA8yMA;IACE,UAAA;EA5yMF;;EA+yMA;IACE,UAAA;EA7yMF;;EAgzMA;IACE,UAAA;EA9yMF;;EAizMA;IACE,UAAA;EA/yMF;;EAkzMA;IACE,UAAA;EAhzMF;;EAmzMA;IACE,UAAA;EAjzMF;;EAozMA;IACE,iBAAA;EAlzMF;;EAqzMA;IACE,iBAAA;EAnzMF;;EAszMA;IACE,UAAA;EApzMF;;EAuzMA;IACE,iBAAA;EArzMF;;EAwzMA;IACE,iBAAA;EAtzMF;;EAyzMA;IACE,gBAAA;EAvzMF;;EA0zMA;IACE,iBAAA;EAxzMF;;EA2zMA;IACE,UAAA;EAzzMF;;EA4zMA;IACE,iBAAA;EA1zMF;;EA6zMA;IACE,iBAAA;EA3zMF;;EA8zMA;IACE,UAAA;EA5zMF;;EA+zMA;IACE,iBAAA;EA7zMF;;EAg0MA;IACE,iBAAA;EA9zMF;;EAi0MA;IACE,UAAA;EA/zMF;;EAk0MA;IACE,iBAAA;EAh0MF;;EAm0MA;IACE,iBAAA;EAj0MF;;EAo0MA;IACE,WAAA;EAl0MF;;EAq0MA;IACE,YAAA;EAn0MF;;EAs0MA;IACE,UAAA;EAp0MF;;EAu0MA;IACE,WAAA;EAr0MF;;EAw0MA;IACE,WAAA;EAt0MF;;EAy0MA;IACE,WAAA;EAv0MF;;EA00MA;IACE,WAAA;EAx0MF;;EA20MA;IACE,WAAA;EAz0MF;;EA40MA;IACE,aAAA;EA10MF;;EA60MA;IACE,WAAA;IACA,MAAA;EA30MF;;EA80MA;IACE,iBAAA;IACA,YAAA;EA50MF;;EA+0MA;IACE,gBAAA;IACA,WAAA;EA70MF;;EAg1MA;IACE,iBAAA;IACA,YAAA;EA90MF;;EAi1MA;IACE,cAAA;IACA,SAAA;EA/0MF;;EAk1MA;IACE,iBAAA;IACA,YAAA;EAh1MF;;EAm1MA;IACE,gBAAA;IACA,WAAA;EAj1MF;;EAo1MA;IACE,cAAA;IACA,SAAA;EAl1MF;;EAq1MA;IACE,gBAAA;IACA,WAAA;EAn1MF;;EAs1MA;IACE,cAAA;IACA,SAAA;EAp1MF;;EAu1MA;IACE,cAAA;IACA,SAAA;EAr1MF;;EAw1MA;IACE,cAAA;IACA,SAAA;EAt1MF;;EAy1MA;IACE,cAAA;IACA,SAAA;EAv1MF;;EA01MA;IACE,cAAA;IACA,SAAA;EAx1MF;;EA21MA;IACE,eAAA;IACA,UAAA;EAz1MF;;EA41MA;IACE,eAAA;IACA,UAAA;EA11MF;;EA61MA;IACE,eAAA;IACA,UAAA;EA31MF;;EA81MA;IACE,eAAA;IACA,UAAA;EA51MF;;EA+1MA;IACE,aAAA;IACA,QAAA;EA71MF;;EAg2MA;IACE,kBAAA;IACA,aAAA;EA91MF;;EAi2MA;IACE,wBAAA;IACA,mBAAA;EA/1MF;;EAk2MA;IACE,uBAAA;IACA,kBAAA;EAh2MF;;EAm2MA;IACE,wBAAA;IACA,mBAAA;EAj2MF;;EAo2MA;IACE,qBAAA;IACA,gBAAA;EAl2MF;;EAq2MA;IACE,wBAAA;IACA,mBAAA;EAn2MF;;EAs2MA;IACE,uBAAA;IACA,kBAAA;EAp2MF;;EAu2MA;IACE,qBAAA;IACA,gBAAA;EAr2MF;;EAw2MA;IACE,uBAAA;IACA,kBAAA;EAt2MF;;EAy2MA;IACE,qBAAA;IACA,gBAAA;EAv2MF;;EA02MA;IACE,qBAAA;IACA,gBAAA;EAx2MF;;EA22MA;IACE,qBAAA;IACA,gBAAA;EAz2MF;;EA42MA;IACE,qBAAA;IACA,gBAAA;EA12MF;;EA62MA;IACE,qBAAA;IACA,gBAAA;EA32MF;;EA82MA;IACE,sBAAA;IACA,iBAAA;EA52MF;;EA+2MA;IACE,sBAAA;IACA,iBAAA;EA72MF;;EAg3MA;IACE,sBAAA;IACA,iBAAA;EA92MF;;EAi3MA;IACE,sBAAA;IACA,iBAAA;EA/2MF;;EAk3MA;IACE,oBAAA;IACA,eAAA;EAh3MF;;EAm3MA;IACE,kBAAA;IACA,aAAA;EAj3MF;;EAo3MA;IACE,wBAAA;IACA,mBAAA;EAl3MF;;EAq3MA;IACE,uBAAA;IACA,kBAAA;EAn3MF;;EAs3MA;IACE,wBAAA;IACA,mBAAA;EAp3MF;;EAu3MA;IACE,qBAAA;IACA,gBAAA;EAr3MF;;EAw3MA;IACE,wBAAA;IACA,mBAAA;EAt3MF;;EAy3MA;IACE,uBAAA;IACA,kBAAA;EAv3MF;;EA03MA;IACE,qBAAA;IACA,gBAAA;EAx3MF;;EA23MA;IACE,uBAAA;IACA,kBAAA;EAz3MF;;EA43MA;IACE,qBAAA;IACA,gBAAA;EA13MF;;EA63MA;IACE,qBAAA;IACA,gBAAA;EA33MF;;EA83MA;IACE,qBAAA;IACA,gBAAA;EA53MF;;EA+3MA;IACE,qBAAA;IACA,gBAAA;EA73MF;;EAg4MA;IACE,qBAAA;IACA,gBAAA;EA93MF;;EAi4MA;IACE,sBAAA;IACA,iBAAA;EA/3MF;;EAk4MA;IACE,sBAAA;IACA,iBAAA;EAh4MF;;EAm4MA;IACE,sBAAA;IACA,iBAAA;EAj4MF;;EAo4MA;IACE,sBAAA;IACA,iBAAA;EAl4MF;;EAq4MA;IACE,oBAAA;IACA,eAAA;EAn4MF;;EAs4MA;IACE,eAAA;IACA,UAAA;EAp4MF;;EAu4MA;IACE,qBAAA;IACA,gBAAA;EAr4MF;;EAw4MA;IACE,oBAAA;IACA,eAAA;EAt4MF;;EAy4MA;IACE,qBAAA;IACA,gBAAA;EAv4MF;;EA04MA;IACE,kBAAA;IACA,aAAA;EAx4MF;;EA24MA;IACE,qBAAA;IACA,gBAAA;EAz4MF;;EA44MA;IACE,oBAAA;IACA,eAAA;EA14MF;;EA64MA;IACE,kBAAA;IACA,aAAA;EA34MF;;EA84MA;IACE,oBAAA;IACA,eAAA;EA54MF;;EA+4MA;IACE,kBAAA;IACA,aAAA;EA74MF;;EAg5MA;IACE,kBAAA;IACA,aAAA;EA94MF;;EAi5MA;IACE,kBAAA;IACA,aAAA;EA/4MF;;EAk5MA;IACE,kBAAA;IACA,aAAA;EAh5MF;;EAm5MA;IACE,kBAAA;IACA,aAAA;EAj5MF;;EAo5MA;IACE,mBAAA;IACA,cAAA;EAl5MF;;EAq5MA;IACE,mBAAA;IACA,cAAA;EAn5MF;;EAs5MA;IACE,mBAAA;IACA,cAAA;EAp5MF;;EAu5MA;IACE,mBAAA;IACA,cAAA;EAr5MF;;EAw5MA;IACE,iBAAA;IACA,YAAA;EAt5MF;;EAy5MA;IACE,eAAA;IACA,UAAA;EAv5MF;;EA05MA;IACE,qBAAA;IACA,gBAAA;EAx5MF;;EA25MA;IACE,oBAAA;IACA,eAAA;EAz5MF;;EA45MA;IACE,qBAAA;IACA,gBAAA;EA15MF;;EA65MA;IACE,kBAAA;IACA,aAAA;EA35MF;;EA85MA;IACE,qBAAA;IACA,gBAAA;EA55MF;;EA+5MA;IACE,oBAAA;IACA,eAAA;EA75MF;;EAg6MA;IACE,kBAAA;IACA,aAAA;EA95MF;;EAi6MA;IACE,oBAAA;IACA,eAAA;EA/5MF;;EAk6MA;IACE,kBAAA;IACA,aAAA;EAh6MF;;EAm6MA;IACE,kBAAA;IACA,aAAA;EAj6MF;;EAo6MA;IACE,kBAAA;IACA,aAAA;EAl6MF;;EAq6MA;IACE,kBAAA;IACA,aAAA;EAn6MF;;EAs6MA;IACE,kBAAA;IACA,aAAA;EAp6MF;;EAu6MA;IACE,mBAAA;IACA,cAAA;EAr6MF;;EAw6MA;IACE,mBAAA;IACA,cAAA;EAt6MF;;EAy6MA;IACE,mBAAA;IACA,cAAA;EAv6MF;;EA06MA;IACE,mBAAA;IACA,cAAA;EAx6MF;;EA26MA;IACE,iBAAA;IACA,YAAA;EAz6MF;;EA46MA;IACE,mBAAA;EA16MF;;EA66MA;IACE,sBAAA;EA36MF;;EA86MA;IACE,yBAAA;EA56MF;;EA+6MA;IACE,4BAAA;EA76MF;;EAg7MA;IACE,gDAAA;EA96MF;;EAi7MA;IACE,gDAAA;EA/6MF;;EAk7MA;IACE,gDAAA;EAh7MF;;EAm7MA;IACE,gDAAA;EAj7MF;;EAo7MA;IACE,gDAAA;EAl7MF;;EAq7MA;IACE,gDAAA;EAn7MF;;EAs7MA;IACE,gDAAA;EAp7MF;;EAu7MA;IACE,gDAAA;EAr7MF;;EAw7MA;IACE,gDAAA;EAt7MF;;EAy7MA;IACE,iDAAA;EAv7MF;;EA07MA;IACE,iDAAA;EAx7MF;;EA27MA;IACE,iDAAA;EAz7MF;;EA47MA;IACE,2BAAA;EA17MF;;EA67MA;IACE,uBAAA;EA37MF;;EA87MA;IACE,8BAAA;EA57MF;;EA+7MA;IACE,8BAAA;EA77MF;;EAg8MA;IACE,iCAAA;EA97MF;;EAi8MA;IACE,iBAAA;EA/7MF;;EAk8MA;IACE,0BAAA;EAh8MF;;EAm8MA;IACE,0BAAA;EAj8MF;;EAo8MA;IACE,0BAAA;EAl8MF;;EAq8MA;IACE,0BAAA;EAn8MF;;EAs8MA;IACE,0BAAA;EAp8MF;;EAu8MA;IACE,0BAAA;EAr8MF;;EAw8MA;IACE,0BAAA;EAt8MF;;EAy8MA;IACE,0BAAA;EAv8MF;;EA08MA;IACE,0BAAA;EAx8MF;;EA28MA;IACE,4BAAA;EAz8MF;;EA48MA;IACE,4BAAA;EA18MF;;EA68MA;IACE,4BAAA;EA38MF;;EA88MA;IACE,iBAAA;EA58MF;;EA+8MA;IACE,oBAAA;EA78MF;;EAg9MA;IACE,oBAAA;EA98MF;;EAi9MA;IACE,oBAAA;EA/8MF;;EAk9MA;IACE,oBAAA;EAh9MF;;EAm9MA;IACE,oBAAA;EAj9MF;;EAo9MA;IACE,oBAAA;EAl9MF;;EAq9MA;IACE,oBAAA;EAn9MF;;EAs9MA;IACE,oBAAA;EAp9MF;;EAu9MA;IACE,oBAAA;EAr9MF;;EAw9MA;IACE,qBAAA;EAt9MF;;EAy9MA;IACE,qBAAA;EAv9MF;;EA09MA;IACE,qBAAA;EAx9MF;;EA29MA;IACE,qBAAA;EAz9MF;;EA49MA;IACE,uBAAA;EA19MF;;EA69MA;IACE,kBAAA;EA39MF;;EA89MA;IACE,kBAAA;EA59MF;;EA+9MA;IACE,kBAAA;EA79MF;;EAg+MA;IACE,kBAAA;EA99MF;;EAi+MA;IACE,kBAAA;EA/9MF;;EAk+MA;IACE,kBAAA;EAh+MF;;EAm+MA;IACE,kBAAA;EAj+MF;;EAo+MA;IACE,kBAAA;EAl+MF;;EAq+MA;IACE,kBAAA;EAn+MF;;EAs+MA;IACE,mBAAA;EAp+MF;;EAu+MA;IACE,mBAAA;EAr+MF;;EAw+MA;IACE,mBAAA;EAt+MF;;EAy+MA;IACE,mBAAA;EAv+MF;;EA0+MA;IACE,qBAAA;EAx+MF;;EA2+MA;IACE,6CAAA;EAz+MF;;EA4+MA;IACE,6CAAA;EA1+MF;;EA6+MA;IACE,6CAAA;EA3+MF;;EA8+MA;IACE,6CAAA;EA5+MF;;EA++MA;IACE,6CAAA;EA7+MF;;EAg/MA;IACE,6CAAA;EA9+MF;;EAi/MA;IACE,wBAAA;EA/+MF;;EAk/MA;IACE,oBAAA;EAh/MF;;EAm/MA;IACE,2BAAA;EAj/MF;;EAo/MA;IACE,2BAAA;EAl/MF;;EAq/MA;IACE,8BAAA;EAn/MF;;EAs/MA;IACE,cAAA;EAp/MF;;EAu/MA;IACE,uBAAA;EAr/MF;;EAw/MA;IACE,uBAAA;EAt/MF;;EAy/MA;IACE,uBAAA;EAv/MF;;EA0/MA;IACE,uBAAA;EAx/MF;;EA2/MA;IACE,uBAAA;EAz/MF;;EA4/MA;IACE,uBAAA;EA1/MF;;EA6/MA;IACE,cAAA;EA3/MF;;EA8/MA;IACE,iBAAA;EA5/MF;;EA+/MA;IACE,iBAAA;EA7/MF;;EAggNA;IACE,iBAAA;EA9/MF;;EAigNA;IACE,iBAAA;EA//MF;;EAkgNA;IACE,iBAAA;EAhgNF;;EAmgNA;IACE,iBAAA;EAjgNF;;EAogNA;IACE,iBAAA;EAlgNF;;EAqgNA;IACE,oBAAA;EAngNF;;EAsgNA;IACE,eAAA;EApgNF;;EAugNA;IACE,eAAA;EArgNF;;EAwgNA;IACE,eAAA;EAtgNF;;EAygNA;IACE,eAAA;EAvgNF;;EA0gNA;IACE,eAAA;EAxgNF;;EA2gNA;IACE,eAAA;EAzgNF;;EA4gNA;IACE,eAAA;EA1gNF;;EA6gNA;IACE,kBAAA;EA3gNF;;EA8gNA;IACE,0BAAA;IACA,0BAAA;IACA,qBAAA;IACA,qBAAA;IACA,qBAAA;IACA,sBAAA;IACA,sBAAA;IACA,4PAAA;EA5gNF;;EA+gNA;IACE,eAAA;EA7gNF;;EAghNA;IACE,wBAAA;EA9gNF;;EAihNA;IACE,qBAAA;EA/gNF;;EAkhNA;IACE,2BAAA;EAhhNF;;EAmhNA;IACE,uBAAA;EAjhNF;;EAohNA;IACE,8BAAA;EAlhNF;;EAqhNA;IACE,wBAAA;EAnhNF;;EAshNA;IACE,6BAAA;EAphNF;;EAuhNA;IACE,sBAAA;EArhNF;;EAwhNA;IACE,0BAAA;EAthNF;;EAyhNA;IACE,sBAAA;IACA,sBAAA;EAvhNF;;EA0hNA;IACE,uBAAA;IACA,uBAAA;EAxhNF;;EA2hNA;IACE,wBAAA;IACA,wBAAA;EAzhNF;;EA4hNA;IACE,uBAAA;IACA,uBAAA;EA1hNF;;EA6hNA;IACE,wBAAA;IACA,wBAAA;EA3hNF;;EA8hNA;IACE,sBAAA;IACA,sBAAA;EA5hNF;;EA+hNA;IACE,yBAAA;IACA,yBAAA;EA7hNF;;EAgiNA;IACE,wBAAA;IACA,wBAAA;EA9hNF;;EAiiNA;IACE,yBAAA;IACA,yBAAA;EA/hNF;;EAkiNA;IACE,wBAAA;IACA,wBAAA;EAhiNF;;EAmiNA;IACE,sBAAA;EAjiNF;;EAoiNA;IACE,uBAAA;EAliNF;;EAqiNA;IACE,wBAAA;EAniNF;;EAsiNA;IACE,uBAAA;EApiNF;;EAuiNA;IACE,wBAAA;EAriNF;;EAwiNA;IACE,sBAAA;EAtiNF;;EAyiNA;IACE,yBAAA;EAviNF;;EA0iNA;IACE,wBAAA;EAxiNF;;EA2iNA;IACE,yBAAA;EAziNF;;EA4iNA;IACE,wBAAA;EA1iNF;;EA6iNA;IACE,sBAAA;EA3iNF;;EA8iNA;IACE,uBAAA;EA5iNF;;EA+iNA;IACE,wBAAA;EA7iNF;;EAgjNA;IACE,uBAAA;EA9iNF;;EAijNA;IACE,wBAAA;EA/iNF;;EAkjNA;IACE,sBAAA;EAhjNF;;EAmjNA;IACE,yBAAA;EAjjNF;;EAojNA;IACE,wBAAA;EAljNF;;EAqjNA;IACE,yBAAA;EAnjNF;;EAsjNA;IACE,wBAAA;EApjNF;;EAujNA;IACE,sBAAA;IACA,sBAAA;EArjNF;;EAwjNA;IACE,uBAAA;IACA,uBAAA;EAtjNF;;EAyjNA;IACE,wBAAA;IACA,wBAAA;EAvjNF;;EA0jNA;IACE,uBAAA;IACA,uBAAA;EAxjNF;;EA2jNA;IACE,wBAAA;IACA,wBAAA;EAzjNF;;EA4jNA;IACE,sBAAA;IACA,sBAAA;EA1jNF;;EA6jNA;IACE,yBAAA;IACA,yBAAA;EA3jNF;;EA8jNA;IACE,wBAAA;IACA,wBAAA;EA5jNF;;EA+jNA;IACE,yBAAA;IACA,yBAAA;EA7jNF;;EAgkNA;IACE,wBAAA;IACA,wBAAA;EA9jNF;;EAikNA;IACE,sBAAA;EA/jNF;;EAkkNA;IACE,uBAAA;EAhkNF;;EAmkNA;IACE,wBAAA;EAjkNF;;EAokNA;IACE,uBAAA;EAlkNF;;EAqkNA;IACE,wBAAA;EAnkNF;;EAskNA;IACE,sBAAA;EApkNF;;EAukNA;IACE,yBAAA;EArkNF;;EAwkNA;IACE,wBAAA;EAtkNF;;EAykNA;IACE,yBAAA;EAvkNF;;EA0kNA;IACE,wBAAA;EAxkNF;;EA2kNA;IACE,sBAAA;EAzkNF;;EA4kNA;IACE,uBAAA;EA1kNF;;EA6kNA;IACE,wBAAA;EA3kNF;;EA8kNA;IACE,uBAAA;EA5kNF;;EA+kNA;IACE,wBAAA;EA7kNF;;EAglNA;IACE,sBAAA;EA9kNF;;EAilNA;IACE,yBAAA;EA/kNF;;EAklNA;IACE,wBAAA;EAhlNF;;EAmlNA;IACE,yBAAA;EAjlNF;;EAolNA;IACE,wBAAA;EAllNF;;EAqlNA;IACE,sBAAA;IACA,sBAAA;EAnlNF;;EAslNA;IACE,uBAAA;IACA,uBAAA;EAplNF;;EAulNA;IACE,wBAAA;IACA,wBAAA;EArlNF;;EAwlNA;IACE,uBAAA;IACA,uBAAA;EAtlNF;;EAylNA;IACE,wBAAA;IACA,wBAAA;EAvlNF;;EA0lNA;IACE,sBAAA;IACA,sBAAA;EAxlNF;;EA2lNA;IACE,yBAAA;IACA,yBAAA;EAzlNF;;EA4lNA;IACE,wBAAA;IACA,wBAAA;EA1lNF;;EA6lNA;IACE,yBAAA;IACA,yBAAA;EA3lNF;;EA8lNA;IACE,wBAAA;IACA,wBAAA;EA5lNF;;EA+lNA;IACE,sBAAA;EA7lNF;;EAgmNA;IACE,uBAAA;EA9lNF;;EAimNA;IACE,wBAAA;EA/lNF;;EAkmNA;IACE,uBAAA;EAhmNF;;EAmmNA;IACE,wBAAA;EAjmNF;;EAomNA;IACE,sBAAA;EAlmNF;;EAqmNA;IACE,yBAAA;EAnmNF;;EAsmNA;IACE,wBAAA;EApmNF;;EAumNA;IACE,yBAAA;EArmNF;;EAwmNA;IACE,wBAAA;EAtmNF;;EAymNA;IACE,sBAAA;EAvmNF;;EA0mNA;IACE,uBAAA;EAxmNF;;EA2mNA;IACE,wBAAA;EAzmNF;;EA4mNA;IACE,uBAAA;EA1mNF;;EA6mNA;IACE,wBAAA;EA3mNF;;EA8mNA;IACE,sBAAA;EA5mNF;;EA+mNA;IACE,yBAAA;EA7mNF;;EAgnNA;IACE,wBAAA;EA9mNF;;EAinNA;IACE,yBAAA;EA/mNF;;EAknNA;IACE,wBAAA;EAhnNF;;EAmnNA;IACE,qBAAA;EAjnNF;;EAonNA;IACE,wBAAA;EAlnNF;;EAqnNA;IACE,wBAAA;EAnnNF;;EAsnNA;IACE,wBAAA;EApnNF;;EAunNA;IACE,wBAAA;EArnNF;;EAwnNA;IACE,yBAAA;EAtnNF;;EAynNA;IACE,yBAAA;EAvnNF;;EA0nNA;IACE,yBAAA;EAxnNF;;EA2nNA;IACE,0BAAA;EAznNF;;EA4nNA;IACE,2BAAA;EA1nNF;;EA6nNA;IACE,0BAAA;EA3nNF;;EA8nNA;IACE,0BAAA;EA5nNF;;EA+nNA;IACE,0BAAA;EA7nNF;;EAgoNA;IACE,yBAAA;EA9nNF;;EAioNA;IACE,yBAAA;EA/nNF;;EAkoNA;IACE,yBAAA;EAhoNF;;EAmoNA;IACE,yBAAA;EAjoNF;;EAooNA;IACE,qBAAA;EAloNF;;EAqoNA;IACE,wBAAA;EAnoNF;;EAsoNA;IACE,wBAAA;EApoNF;;EAuoNA;IACE,wBAAA;EAroNF;;EAwoNA;IACE,wBAAA;EAtoNF;;EAyoNA;IACE,yBAAA;EAvoNF;;EA0oNA;IACE,yBAAA;EAxoNF;;EA2oNA;IACE,yBAAA;EAzoNF;;EA4oNA;IACE,0BAAA;EA1oNF;;EA6oNA;IACE,2BAAA;EA3oNF;;EA8oNA;IACE,0BAAA;EA5oNF;;EA+oNA;IACE,0BAAA;EA7oNF;;EAgpNA;IACE,0BAAA;EA9oNF;;EAipNA;IACE,yBAAA;EA/oNF;;EAkpNA;IACE,yBAAA;EAhpNF;;EAmpNA;IACE,yBAAA;EAjpNF;;EAopNA;IACE,yBAAA;EAlpNF;;EAqpNA;IACE,qBAAA;EAnpNF;;EAspNA;IACE,wBAAA;EAppNF;;EAupNA;IACE,wBAAA;EArpNF;;EAwpNA;IACE,wBAAA;EAtpNF;;EAypNA;IACE,wBAAA;EAvpNF;;EA0pNA;IACE,yBAAA;EAxpNF;;EA2pNA;IACE,yBAAA;EAzpNF;;EA4pNA;IACE,yBAAA;EA1pNF;;EA6pNA;IACE,0BAAA;EA3pNF;;EA8pNA;IACE,2BAAA;EA5pNF;;EA+pNA;IACE,0BAAA;EA7pNF;;EAgqNA;IACE,0BAAA;EA9pNF;;EAiqNA;IACE,0BAAA;EA/pNF;;EAkqNA;IACE,yBAAA;EAhqNF;;EAmqNA;IACE,yBAAA;EAjqNF;;EAoqNA;IACE,yBAAA;EAlqNF;;EAqqNA;IACE,yBAAA;EAnqNF;;EAsqNA;IACE,0BAAA;EApqNF;;EAuqNA;IACE,gCAAA;EArqNF;;EAwqNA;IACE,+BAAA;EAtqNF;;EAyqNA;IACE,gCAAA;EAvqNF;;EA0qNA;IACE,6BAAA;EAxqNF;;EA2qNA;IACE,gCAAA;EAzqNF;;EA4qNA;IACE,+BAAA;EA1qNF;;EA6qNA;IACE,6BAAA;EA3qNF;;EA8qNA;IACE,+BAAA;EA5qNF;;EA+qNA;IACE,6BAAA;EA7qNF;;EAgrNA;IACE,6BAAA;EA9qNF;;EAirNA;IACE,6BAAA;EA/qNF;;EAkrNA;IACE,6BAAA;EAhrNF;;EAmrNA;IACE,6BAAA;EAjrNF;;EAorNA;IACE,8BAAA;EAlrNF;;EAqrNA;IACE,8BAAA;EAnrNF;;EAsrNA;IACE,8BAAA;EAprNF;;EAurNA;IACE,8BAAA;EArrNF;;EAwrNA;IACE,4BAAA;EAtrNF;;EAyrNA;IACE,iCAAA;EAvrNF;;EA0rNA;IACE,gCAAA;EAxrNF;;EA2rNA;IACE,iCAAA;EAzrNF;;EA4rNA;IACE,8BAAA;EA1rNF;;EA6rNA;IACE,iCAAA;EA3rNF;;EA8rNA;IACE,gCAAA;EA5rNF;;EA+rNA;IACE,8BAAA;EA7rNF;;EAgsNA;IACE,gCAAA;EA9rNF;;EAisNA;IACE,8BAAA;EA/rNF;;EAksNA;IACE,8BAAA;EAhsNF;;EAmsNA;IACE,8BAAA;EAjsNF;;EAosNA;IACE,8BAAA;EAlsNF;;EAqsNA;IACE,8BAAA;EAnsNF;;EAssNA;IACE,+BAAA;EApsNF;;EAusNA;IACE,+BAAA;EArsNF;;EAwsNA;IACE,+BAAA;EAtsNF;;EAysNA;IACE,+BAAA;EAvsNF;;EA0sNA;IACE,6BAAA;EAxsNF;;EA2sNA;IACE,8BAAA;EAzsNF;;EA4sNA;IACE,6BAAA;EA1sNF;;EA6sNA;IACE,4BAAA;EA3sNF;;EA8sNA;IACE,6BAAA;EA5sNF;;EA+sNA;IACE,0BAAA;EA7sNF;;EAgtNA;IACE,gCAAA;EA9sNF;;EAitNA;IACE,+BAAA;EA/sNF;;EAktNA;IACE,gCAAA;EAhtNF;;EAmtNA;IACE,6BAAA;EAjtNF;;EAotNA;IACE,gCAAA;EAltNF;;EAqtNA;IACE,+BAAA;EAntNF;;EAstNA;IACE,6BAAA;EAptNF;;EAutNA;IACE,+BAAA;EArtNF;;EAwtNA;IACE,6BAAA;EAttNF;;EAytNA;IACE,6BAAA;EAvtNF;;EA0tNA;IACE,6BAAA;EAxtNF;;EA2tNA;IACE,6BAAA;EAztNF;;EA4tNA;IACE,6BAAA;EA1tNF;;EA6tNA;IACE,8BAAA;EA3tNF;;EA8tNA;IACE,8BAAA;EA5tNF;;EA+tNA;IACE,8BAAA;EA7tNF;;EAguNA;IACE,8BAAA;EA9tNF;;EAiuNA;IACE,4BAAA;EA/tNF;;EAkuNA;IACE,iCAAA;EAhuNF;;EAmuNA;IACE,gCAAA;EAjuNF;;EAouNA;IACE,iCAAA;EAluNF;;EAquNA;IACE,8BAAA;EAnuNF;;EAsuNA;IACE,iCAAA;EApuNF;;EAuuNA;IACE,gCAAA;EAruNF;;EAwuNA;IACE,8BAAA;EAtuNF;;EAyuNA;IACE,gCAAA;EAvuNF;;EA0uNA;IACE,8BAAA;EAxuNF;;EA2uNA;IACE,8BAAA;EAzuNF;;EA4uNA;IACE,8BAAA;EA1uNF;;EA6uNA;IACE,8BAAA;EA3uNF;;EA8uNA;IACE,8BAAA;EA5uNF;;EA+uNA;IACE,+BAAA;EA7uNF;;EAgvNA;IACE,+BAAA;EA9uNF;;EAivNA;IACE,+BAAA;EA/uNF;;EAkvNA;IACE,+BAAA;EAhvNF;;EAmvNA;IACE,6BAAA;EAjvNF;;EAovNA;IACE,8BAAA;EAlvNF;;EAqvNA;IACE,6BAAA;EAnvNF;;EAsvNA;IACE,4BAAA;EApvNF;;EAuvNA;IACE,6BAAA;EArvNF;;EAwvNA;IACE,0BAAA;EAtvNF;;EAyvNA;IACE,gCAAA;EAvvNF;;EA0vNA;IACE,+BAAA;EAxvNF;;EA2vNA;IACE,gCAAA;EAzvNF;;EA4vNA;IACE,6BAAA;EA1vNF;;EA6vNA;IACE,gCAAA;EA3vNF;;EA8vNA;IACE,+BAAA;EA5vNF;;EA+vNA;IACE,6BAAA;EA7vNF;;EAgwNA;IACE,+BAAA;EA9vNF;;EAiwNA;IACE,6BAAA;EA/vNF;;EAkwNA;IACE,6BAAA;EAhwNF;;EAmwNA;IACE,6BAAA;EAjwNF;;EAowNA;IACE,6BAAA;EAlwNF;;EAqwNA;IACE,6BAAA;EAnwNF;;EAswNA;IACE,8BAAA;EApwNF;;EAuwNA;IACE,8BAAA;EArwNF;;EAwwNA;IACE,8BAAA;EAtwNF;;EAywNA;IACE,8BAAA;EAvwNF;;EA0wNA;IACE,4BAAA;EAxwNF;;EA2wNA;IACE,iCAAA;EAzwNF;;EA4wNA;IACE,gCAAA;EA1wNF;;EA6wNA;IACE,iCAAA;EA3wNF;;EA8wNA;IACE,8BAAA;EA5wNF;;EA+wNA;IACE,iCAAA;EA7wNF;;EAgxNA;IACE,gCAAA;EA9wNF;;EAixNA;IACE,8BAAA;EA/wNF;;EAkxNA;IACE,gCAAA;EAhxNF;;EAmxNA;IACE,8BAAA;EAjxNF;;EAoxNA;IACE,8BAAA;EAlxNF;;EAqxNA;IACE,8BAAA;EAnxNF;;EAsxNA;IACE,8BAAA;EApxNF;;EAuxNA;IACE,8BAAA;EArxNF;;EAwxNA;IACE,+BAAA;EAtxNF;;EAyxNA;IACE,+BAAA;EAvxNF;;EA0xNA;IACE,+BAAA;EAxxNF;;EA2xNA;IACE,+BAAA;EAzxNF;;EA4xNA;IACE,6BAAA;EA1xNF;;EA6xNA;IACE,8BAAA;EA3xNF;;EA8xNA;IACE,6BAAA;EA5xNF;;EA+xNA;IACE,4BAAA;EA7xNF;;EAgyNA;IACE,6BAAA;EA9xNF;;EAiyNA;IACE,0BAAA;EA/xNF;;EAkyNA;IACE,gCAAA;EAhyNF;;EAmyNA;IACE,+BAAA;EAjyNF;;EAoyNA;IACE,gCAAA;EAlyNF;;EAqyNA;IACE,6BAAA;EAnyNF;;EAsyNA;IACE,gCAAA;EApyNF;;EAuyNA;IACE,+BAAA;EAryNF;;EAwyNA;IACE,6BAAA;EAtyNF;;EAyyNA;IACE,+BAAA;EAvyNF;;EA0yNA;IACE,6BAAA;EAxyNF;;EA2yNA;IACE,6BAAA;EAzyNF;;EA4yNA;IACE,6BAAA;EA1yNF;;EA6yNA;IACE,6BAAA;EA3yNF;;EA8yNA;IACE,6BAAA;EA5yNF;;EA+yNA;IACE,8BAAA;EA7yNF;;EAgzNA;IACE,8BAAA;EA9yNF;;EAizNA;IACE,8BAAA;EA/yNF;;EAkzNA;IACE,8BAAA;EAhzNF;;EAmzNA;IACE,4BAAA;EAjzNF;;EAozNA;IACE,iCAAA;EAlzNF;;EAqzNA;IACE,gCAAA;EAnzNF;;EAszNA;IACE,iCAAA;EApzNF;;EAuzNA;IACE,8BAAA;EArzNF;;EAwzNA;IACE,iCAAA;EAtzNF;;EAyzNA;IACE,gCAAA;EAvzNF;;EA0zNA;IACE,8BAAA;EAxzNF;;EA2zNA;IACE,gCAAA;EAzzNF;;EA4zNA;IACE,8BAAA;EA1zNF;;EA6zNA;IACE,8BAAA;EA3zNF;;EA8zNA;IACE,8BAAA;EA5zNF;;EA+zNA;IACE,8BAAA;EA7zNF;;EAg0NA;IACE,8BAAA;EA9zNF;;EAi0NA;IACE,+BAAA;EA/zNF;;EAk0NA;IACE,+BAAA;EAh0NF;;EAm0NA;IACE,+BAAA;EAj0NF;;EAo0NA;IACE,+BAAA;EAl0NF;;EAq0NA;IACE,6BAAA;EAn0NF;;EAs0NA;IACE,8BAAA;EAp0NF;;EAu0NA;IACE,6BAAA;EAr0NF;;EAw0NA;IACE,4BAAA;EAt0NF;;EAy0NA;IACE,6BAAA;EAv0NF;;EA00NA;IACE,0BAAA;EAx0NF;;EA20NA;IACE,gCAAA;EAz0NF;;EA40NA;IACE,+BAAA;EA10NF;;EA60NA;IACE,gCAAA;EA30NF;;EA80NA;IACE,6BAAA;EA50NF;;EA+0NA;IACE,gCAAA;EA70NF;;EAg1NA;IACE,+BAAA;EA90NF;;EAi1NA;IACE,6BAAA;EA/0NF;;EAk1NA;IACE,+BAAA;EAh1NF;;EAm1NA;IACE,6BAAA;EAj1NF;;EAo1NA;IACE,6BAAA;EAl1NF;;EAq1NA;IACE,6BAAA;EAn1NF;;EAs1NA;IACE,6BAAA;EAp1NF;;EAu1NA;IACE,6BAAA;EAr1NF;;EAw1NA;IACE,8BAAA;EAt1NF;;EAy1NA;IACE,8BAAA;EAv1NF;;EA01NA;IACE,8BAAA;EAx1NF;;EA21NA;IACE,8BAAA;EAz1NF;;EA41NA;IACE,4BAAA;EA11NF;;EA61NA;IACE,iCAAA;EA31NF;;EA81NA;IACE,gCAAA;EA51NF;;EA+1NA;IACE,iCAAA;EA71NF;;EAg2NA;IACE,8BAAA;EA91NF;;EAi2NA;IACE,iCAAA;EA/1NF;;EAk2NA;IACE,gCAAA;EAh2NF;;EAm2NA;IACE,8BAAA;EAj2NF;;EAo2NA;IACE,gCAAA;EAl2NF;;EAq2NA;IACE,8BAAA;EAn2NF;;EAs2NA;IACE,8BAAA;EAp2NF;;EAu2NA;IACE,8BAAA;EAr2NF;;EAw2NA;IACE,8BAAA;EAt2NF;;EAy2NA;IACE,8BAAA;EAv2NF;;EA02NA;IACE,+BAAA;EAx2NF;;EA22NA;IACE,+BAAA;EAz2NF;;EA42NA;IACE,+BAAA;EA12NF;;EA62NA;IACE,+BAAA;EA32NF;;EA82NA;IACE,6BAAA;EA52NF;;EA+2NA;IACE,8BAAA;EA72NF;;EAg3NA;IACE,6BAAA;EA92NF;;EAi3NA;IACE,4BAAA;EA/2NF;;EAk3NA;IACE,6BAAA;EAh3NF;;EAm3NA;IACE,0BAAA;EAj3NF;;EAo3NA;IACE,gCAAA;EAl3NF;;EAq3NA;IACE,+BAAA;EAn3NF;;EAs3NA;IACE,gCAAA;EAp3NF;;EAu3NA;IACE,6BAAA;EAr3NF;;EAw3NA;IACE,gCAAA;EAt3NF;;EAy3NA;IACE,+BAAA;EAv3NF;;EA03NA;IACE,6BAAA;EAx3NF;;EA23NA;IACE,+BAAA;EAz3NF;;EA43NA;IACE,6BAAA;EA13NF;;EA63NA;IACE,6BAAA;EA33NF;;EA83NA;IACE,6BAAA;EA53NF;;EA+3NA;IACE,6BAAA;EA73NF;;EAg4NA;IACE,6BAAA;EA93NF;;EAi4NA;IACE,8BAAA;EA/3NF;;EAk4NA;IACE,8BAAA;EAh4NF;;EAm4NA;IACE,8BAAA;EAj4NF;;EAo4NA;IACE,8BAAA;EAl4NF;;EAq4NA;IACE,4BAAA;EAn4NF;;EAs4NA;IACE,iCAAA;EAp4NF;;EAu4NA;IACE,gCAAA;EAr4NF;;EAw4NA;IACE,iCAAA;EAt4NF;;EAy4NA;IACE,8BAAA;EAv4NF;;EA04NA;IACE,iCAAA;EAx4NF;;EA24NA;IACE,gCAAA;EAz4NF;;EA44NA;IACE,8BAAA;EA14NF;;EA64NA;IACE,gCAAA;EA34NF;;EA84NA;IACE,8BAAA;EA54NF;;EA+4NA;IACE,8BAAA;EA74NF;;EAg5NA;IACE,8BAAA;EA94NF;;EAi5NA;IACE,8BAAA;EA/4NF;;EAk5NA;IACE,8BAAA;EAh5NF;;EAm5NA;IACE,+BAAA;EAj5NF;;EAo5NA;IACE,+BAAA;EAl5NF;;EAq5NA;IACE,+BAAA;EAn5NF;;EAs5NA;IACE,+BAAA;EAp5NF;;EAu5NA;IACE,6BAAA;EAr5NF;;EAw5NA;IACE,8BAAA;EAt5NF;;EAy5NA;IACE,6BAAA;EAv5NF;;EA05NA;IACE,4BAAA;EAx5NF;;EA25NA;IACE,6BAAA;EAz5NF;;EA45NA;IACE,qBAAA;EA15NF;;EA65NA;IACE,wBAAA;EA35NF;;EA85NA;IACE,wBAAA;EA55NF;;EA+5NA;IACE,wBAAA;EA75NF;;EAg6NA;IACE,wBAAA;EA95NF;;EAi6NA;IACE,yBAAA;EA/5NF;;EAk6NA;IACE,0BAAA;EAh6NF;;EAm6NA;IACE,yBAAA;EAj6NF;;EAo6NA;IACE,yBAAA;EAl6NF;;EAq6NA;IACE,yBAAA;EAn6NF;;EAs6NA;IACE,yBAAA;EAp6NF;;EAu6NA;IACE,qBAAA;EAr6NF;;EAw6NA;IACE,wBAAA;EAt6NF;;EAy6NA;IACE,wBAAA;EAv6NF;;EA06NA;IACE,wBAAA;EAx6NF;;EA26NA;IACE,wBAAA;EAz6NF;;EA46NA;IACE,yBAAA;EA16NF;;EA66NA;IACE,0BAAA;EA36NF;;EA86NA;IACE,yBAAA;EA56NF;;EA+6NA;IACE,yBAAA;EA76NF;;EAg7NA;IACE,yBAAA;EA96NF;;EAi7NA;IACE,yBAAA;EA/6NF;;EAk7NA;IACE,qBAAA;EAh7NF;;EAm7NA;IACE,wBAAA;EAj7NF;;EAo7NA;IACE,wBAAA;EAl7NF;;EAq7NA;IACE,wBAAA;EAn7NF;;EAs7NA;IACE,wBAAA;EAp7NF;;EAu7NA;IACE,yBAAA;EAr7NF;;EAw7NA;IACE,0BAAA;EAt7NF;;EAy7NA;IACE,yBAAA;EAv7NF;;EA07NA;IACE,yBAAA;EAx7NF;;EA27NA;IACE,yBAAA;EAz7NF;;EA47NA;IACE,yBAAA;EA17NF;;EA67NA;IACE,qBAAA;EA37NF;;EA87NA;IACE,wBAAA;EA57NF;;EA+7NA;IACE,wBAAA;EA77NF;;EAg8NA;IACE,wBAAA;EA97NF;;EAi8NA;IACE,wBAAA;EA/7NF;;EAk8NA;IACE,yBAAA;EAh8NF;;EAm8NA;IACE,0BAAA;EAj8NF;;EAo8NA;IACE,yBAAA;EAl8NF;;EAq8NA;IACE,yBAAA;EAn8NF;;EAs8NA;IACE,yBAAA;EAp8NF;;EAu8NA;IACE,yBAAA;EAr8NF;;EAw8NA;IACE,qBAAA;EAt8NF;;EAy8NA;IACE,wBAAA;EAv8NF;;EA08NA;IACE,wBAAA;EAx8NF;;EA28NA;IACE,wBAAA;EAz8NF;;EA48NA;IACE,wBAAA;EA18NF;;EA68NA;IACE,yBAAA;EA38NF;;EA88NA;IACE,0BAAA;EA58NF;;EA+8NA;IACE,yBAAA;EA78NF;;EAg9NA;IACE,yBAAA;EA98NF;;EAi9NA;IACE,yBAAA;EA/8NF;;EAk9NA;IACE,yBAAA;EAh9NF;;EAm9NA;IACE,qBAAA;EAj9NF;;EAo9NA;IACE,wBAAA;EAl9NF;;EAq9NA;IACE,wBAAA;EAn9NF;;EAs9NA;IACE,wBAAA;EAp9NF;;EAu9NA;IACE,wBAAA;EAr9NF;;EAw9NA;IACE,yBAAA;EAt9NF;;EAy9NA;IACE,0BAAA;EAv9NF;;EA09NA;IACE,yBAAA;EAx9NF;;EA29NA;IACE,yBAAA;EAz9NF;;EA49NA;IACE,yBAAA;EA19NF;;EA69NA;IACE,yBAAA;EA39NF;;EA89NA;IACE,yBAAA;EA59NF;;EA+9NA;IACE,wBAAA;EA79NF;;EAg+NA;IACE,wGAAA;EA99NF;;EAi+NA;IACE,wEAAA;EA/9NF;;EAk+NA;IACE,4BAAA;EAh+NF;;EAm+NA;IACE,+BAAA;EAj+NF;;EAo+NA;IACE,8BAAA;EAl+NF;;EAq+NA;IACE,kCAAA;EAn+NF;;EAs+NA;IACE,sDAAA;EAp+NF;;EAu+NA;IACE,sDAAA;EAr+NF;;EAw+NA;IACE,wDAAA;EAt+NF;;EAy+NA;IACE,yBAAA;EAv+NF;;EA0+NA;IACE,0BAAA;EAx+NF;;EA2+NA;IACE,0BAAA;EAz+NF;;EA4+NA;IACE,0BAAA;EA1+NF;;EA6+NA;IACE,0BAAA;EA3+NF;;EA8+NA;IACE,0BAAA;EA5+NF;;EA++NA;IACE,0BAAA;EA7+NF;;EAg/NA;IACE,2BAAA;EA9+NF;;EAi/NA;IACE,sBAAA;EA/+NF;;EAk/NA;IACE,uBAAA;EAh/NF;;EAm/NA;IACE,uBAAA;EAj/NF;;EAo/NA;IACE,uBAAA;EAl/NF;;EAq/NA;IACE,uBAAA;EAn/NF;;EAs/NA;IACE,uBAAA;EAp/NF;;EAu/NA;IACE,uBAAA;EAr/NF;;EAw/NA;IACE,wBAAA;EAt/NF;;EAy/NA;IACE,eAAA;EAv/NF;;EA0/NA;IACE,kCAAA;EAx/NF;;EA2/NA;IACE,sDAAA;EAz/NF;;EA4/NA;IACE,yDAAA;EA1/NF;;EA6/NA;IACE,6BAAA;EA3/NF;AACF;;AA8/NA;EACE;IACE,WAAA;EA5/NF;AACF;;AA8/NE;EACE;IACE,gBAAA;EA5/NJ;AACF;;AA+/NE;EACE;IACE,gBAAA;EA7/NJ;AACF;;AAggOE;EACE;IACE,iBAAA;EA9/NJ;AACF;;AAigOE;EACE;IACE,iBAAA;EA//NJ;AACF;;AAq+NA;EA6BE;IACE,oBAAA;IACA,oDAAA;IACA,iDAAA;EA//NF;;EAkgOA;IACE,oBAAA;IACA,gDAAA;IACA,qDAAA;EAhgOF;;EAmgOA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAjgOF;;EAogOA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAlgOF;;EAqgOA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAngOF;;EAsgOA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EApgOF;;EAugOA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EArgOF;;EAwgOA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAtgOF;;EAygOA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAvgOF;;EA0gOA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAxgOF;;EA2gOA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAzgOF;;EA4gOA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EA1gOF;;EA6gOA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EA3gOF;;EA8gOA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EA5gOF;;EA+gOA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EA7gOF;;EAghOA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA9gOF;;EAihOA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EA/gOF;;EAkhOA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAhhOF;;EAmhOA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAjhOF;;EAohOA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAlhOF;;EAqhOA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAnhOF;;EAshOA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAphOF;;EAuhOA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EArhOF;;EAwhOA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAthOF;;EAyhOA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAvhOF;;EA0hOA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAxhOF;;EA2hOA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAzhOF;;EA4hOA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA1hOF;;EA6hOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA3hOF;;EA8hOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA5hOF;;EA+hOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA7hOF;;EAgiOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA9hOF;;EAiiOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA/hOF;;EAkiOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAhiOF;;EAmiOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAjiOF;;EAoiOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAliOF;;EAqiOA;IACE,oBAAA;IACA,oDAAA;IACA,iDAAA;EAniOF;;EAsiOA;IACE,oBAAA;IACA,gDAAA;IACA,qDAAA;EApiOF;;EAuiOA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EAriOF;;EAwiOA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EAtiOF;;EAyiOA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAviOF;;EA0iOA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAxiOF;;EA2iOA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EAziOF;;EA4iOA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EA1iOF;;EA6iOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA3iOF;;EA8iOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA5iOF;;EA+iOA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EA7iOF;;EAgjOA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EA9iOF;;EAijOA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EA/iOF;;EAkjOA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAhjOF;;EAmjOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAjjOF;;EAojOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAljOF;;EAqjOA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAnjOF;;EAsjOA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EApjOF;;EAujOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EArjOF;;EAwjOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAtjOF;;EAyjOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAvjOF;;EA0jOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAxjOF;;EA2jOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAzjOF;;EA4jOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA1jOF;;EA6jOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA3jOF;;EA8jOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA5jOF;;EA+jOA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA7jOF;;EAgkOA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA9jOF;;EAikOA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EA/jOF;;EAkkOA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAhkOF;;EAmkOA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAjkOF;;EAokOA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAlkOF;;EAqkOA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAnkOF;;EAskOA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EApkOF;;EAukOA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EArkOF;;EAwkOA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAtkOF;;EAykOA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAvkOF;;EA0kOA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAxkOF;;EA2kOA;IACE,oBAAA;EAzkOF;;EA4kOA;IACE,oBAAA;EA1kOF;;EA6kOA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA3kOF;;EA8kOA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EA5kOF;;EA+kOA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA7kOF;;EAglOA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EA9kOF;;EAilOA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA/kOF;;EAklOA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAhlOF;;EAmlOA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EAjlOF;;EAolOA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAllOF;;EAqlOA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EAnlOF;;EAslOA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAplOF;;EAulOA;IACE,qBAAA;EArlOF;;EAwlOA;IACE,qBAAA;EAtlOF;;EAylOA;IACE,yBAAA;EAvlOF;;EA0lOA;IACE,0BAAA;EAxlOF;;EA2lOA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EAzlOF;;EA4lOA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EA1lOF;;EA6lOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3lOF;;EA8lOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5lOF;;EA+lOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7lOF;;EAgmOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9lOF;;EAimOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/lOF;;EAkmOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhmOF;;EAmmOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjmOF;;EAomOA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAlmOF;;EAqmOA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAnmOF;;EAsmOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApmOF;;EAumOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArmOF;;EAwmOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtmOF;;EAymOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvmOF;;EA0mOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxmOF;;EA2mOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzmOF;;EA4mOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1mOF;;EA6mOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3mOF;;EA8mOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5mOF;;EA+mOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7mOF;;EAgnOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9mOF;;EAinOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/mOF;;EAknOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhnOF;;EAmnOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjnOF;;EAonOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlnOF;;EAqnOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnnOF;;EAsnOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EApnOF;;EAunOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EArnOF;;EAwnOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtnOF;;EAynOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvnOF;;EA0nOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxnOF;;EA2nOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAznOF;;EA4nOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1nOF;;EA6nOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3nOF;;EA8nOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5nOF;;EA+nOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7nOF;;EAgoOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9nOF;;EAioOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/nOF;;EAkoOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhoOF;;EAmoOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjoOF;;EAooOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAloOF;;EAqoOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnoOF;;EAsoOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApoOF;;EAuoOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAroOF;;EAwoOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtoOF;;EAyoOA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAvoOF;;EA0oOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxoOF;;EA2oOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzoOF;;EA4oOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1oOF;;EA6oOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3oOF;;EA8oOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5oOF;;EA+oOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7oOF;;EAgpOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9oOF;;EAipOA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA/oOF;;EAkpOA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAhpOF;;EAmpOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjpOF;;EAopOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlpOF;;EAqpOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnpOF;;EAspOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAppOF;;EAupOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArpOF;;EAwpOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtpOF;;EAypOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvpOF;;EA0pOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxpOF;;EA2pOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzpOF;;EA4pOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1pOF;;EA6pOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3pOF;;EA8pOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5pOF;;EA+pOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7pOF;;EAgqOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9pOF;;EAiqOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/pOF;;EAkqOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhqOF;;EAmqOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjqOF;;EAoqOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAlqOF;;EAqqOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnqOF;;EAsqOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApqOF;;EAuqOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArqOF;;EAwqOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtqOF;;EAyqOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvqOF;;EA0qOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxqOF;;EA2qOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzqOF;;EA4qOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1qOF;;EA6qOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3qOF;;EA8qOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5qOF;;EA+qOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7qOF;;EAgrOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9qOF;;EAirOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/qOF;;EAkrOA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhrOF;;EAmrOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjrOF;;EAorOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlrOF;;EAqrOA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnrOF;;EAsrOA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAprOF;;EAurOA;IACE,mBAAA;EArrOF;;EAwrOA;IACE,oBAAA;EAtrOF;;EAyrOA;IACE,oBAAA;EAvrOF;;EA0rOA;IACE,oBAAA;EAxrOF;;EA2rOA;IACE,kBAAA;EAzrOF;;EA4rOA;IACE,mBAAA;EA1rOF;;EA6rOA;IACE,sBAAA;EA3rOF;;EA8rOA;IACE,qBAAA;EA5rOF;;EA+rOA;IACE,sBAAA;EA7rOF;;EAgsOA;IACE,mBAAA;EA9rOF;;EAisOA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;EA/rOF;;EAksOA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EAhsOF;;EAmsOA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;EAjsOF;;EAosOA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EAlsOF;;EAqsOA;IACE,gBAAA;EAnsOF;;EAssOA;IACE,4BAAA;EApsOF;;EAusOA;IACE,4BAAA;EArsOF;;EAwsOA;IACE,6BAAA;EAtsOF;;EAysOA;IACE,2BAAA;EAvsOF;;EA0sOA;IACE,4BAAA;EAxsOF;;EA2sOA;IACE,4BAAA;EAzsOF;;EA4sOA;IACE,6BAAA;IACQ,qBAAA;EA1sOV;;EA6sOA;IACE,6BAAA;EA3sOF;;EA8sOA;IACE,8BAAA;EA5sOF;;EA+sOA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA7sOF;;EAgtOA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA9sOF;;EAitOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/sOF;;EAktOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhtOF;;EAmtOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjtOF;;EAotOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAltOF;;EAqtOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAntOF;;EAstOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAptOF;;EAutOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EArtOF;;EAwtOA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAttOF;;EAytOA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAvtOF;;EA0tOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxtOF;;EA2tOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAztOF;;EA4tOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1tOF;;EA6tOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3tOF;;EA8tOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5tOF;;EA+tOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7tOF;;EAguOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9tOF;;EAiuOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/tOF;;EAkuOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAhuOF;;EAmuOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjuOF;;EAouOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAluOF;;EAquOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnuOF;;EAsuOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApuOF;;EAuuOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAruOF;;EAwuOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtuOF;;EAyuOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvuOF;;EA0uOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxuOF;;EA2uOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAzuOF;;EA4uOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1uOF;;EA6uOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3uOF;;EA8uOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5uOF;;EA+uOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7uOF;;EAgvOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9uOF;;EAivOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/uOF;;EAkvOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhvOF;;EAmvOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAjvOF;;EAovOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAlvOF;;EAqvOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnvOF;;EAsvOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApvOF;;EAuvOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArvOF;;EAwvOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtvOF;;EAyvOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvvOF;;EA0vOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxvOF;;EA2vOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAzvOF;;EA4vOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1vOF;;EA6vOA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA3vOF;;EA8vOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5vOF;;EA+vOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7vOF;;EAgwOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9vOF;;EAiwOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/vOF;;EAkwOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhwOF;;EAmwOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjwOF;;EAowOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAlwOF;;EAqwOA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAnwOF;;EAswOA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EApwOF;;EAuwOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArwOF;;EAwwOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtwOF;;EAywOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvwOF;;EA0wOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxwOF;;EA2wOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAzwOF;;EA4wOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1wOF;;EA6wOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA3wOF;;EA8wOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5wOF;;EA+wOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7wOF;;EAgxOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9wOF;;EAixOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/wOF;;EAkxOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhxOF;;EAmxOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjxOF;;EAoxOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlxOF;;EAqxOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAnxOF;;EAsxOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EApxOF;;EAuxOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EArxOF;;EAwxOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtxOF;;EAyxOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvxOF;;EA0xOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxxOF;;EA2xOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzxOF;;EA4xOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1xOF;;EA6xOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3xOF;;EA8xOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5xOF;;EA+xOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7xOF;;EAgyOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9xOF;;EAiyOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/xOF;;EAkyOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhyOF;;EAmyOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjyOF;;EAoyOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlyOF;;EAqyOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnyOF;;EAsyOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApyOF;;EAuyOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAryOF;;EAwyOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtyOF;;EAyyOA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvyOF;;EA0yOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxyOF;;EA2yOA;IACE,6BAAA;EAzyOF;;EA4yOA;IACE,8BAAA;EA1yOF;;EA6yOA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA3yOF;;EA8yOA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA5yOF;;EA+yOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7yOF;;EAgzOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9yOF;;EAizOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/yOF;;EAkzOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhzOF;;EAmzOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjzOF;;EAozOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlzOF;;EAqzOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAnzOF;;EAszOA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EApzOF;;EAuzOA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EArzOF;;EAwzOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtzOF;;EAyzOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvzOF;;EA0zOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxzOF;;EA2zOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzzOF;;EA4zOA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1zOF;;EA6zOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3zOF;;EA8zOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5zOF;;EA+zOA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7zOF;;EAg0OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9zOF;;EAi0OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/zOF;;EAk0OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh0OF;;EAm0OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj0OF;;EAo0OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAl0OF;;EAq0OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn0OF;;EAs0OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp0OF;;EAu0OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAr0OF;;EAw0OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAt0OF;;EAy0OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAv0OF;;EA00OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx0OF;;EA20OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz0OF;;EA40OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA10OF;;EA60OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA30OF;;EA80OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA50OF;;EA+0OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA70OF;;EAg1OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA90OF;;EAi1OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/0OF;;EAk1OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAh1OF;;EAm1OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj1OF;;EAo1OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl1OF;;EAq1OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn1OF;;EAs1OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp1OF;;EAu1OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr1OF;;EAw1OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt1OF;;EAy1OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAv1OF;;EA01OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAx1OF;;EA21OA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAz1OF;;EA41OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA11OF;;EA61OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA31OF;;EA81OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA51OF;;EA+1OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA71OF;;EAg2OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA91OF;;EAi2OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/1OF;;EAk2OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAh2OF;;EAm2OA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAj2OF;;EAo2OA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAl2OF;;EAq2OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn2OF;;EAs2OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp2OF;;EAu2OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr2OF;;EAw2OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt2OF;;EAy2OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAv2OF;;EA02OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAx2OF;;EA22OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAz2OF;;EA42OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA12OF;;EA62OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA32OF;;EA82OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA52OF;;EA+2OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA72OF;;EAg3OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA92OF;;EAi3OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/2OF;;EAk3OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh3OF;;EAm3OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAj3OF;;EAo3OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAl3OF;;EAq3OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAn3OF;;EAs3OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAp3OF;;EAu3OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr3OF;;EAw3OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt3OF;;EAy3OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv3OF;;EA03OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx3OF;;EA23OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz3OF;;EA43OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA13OF;;EA63OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA33OF;;EA83OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA53OF;;EA+3OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA73OF;;EAg4OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA93OF;;EAi4OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/3OF;;EAk4OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh4OF;;EAm4OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj4OF;;EAo4OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl4OF;;EAq4OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn4OF;;EAs4OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp4OF;;EAu4OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr4OF;;EAw4OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAt4OF;;EAy4OA;IACE,6BAAA;EAv4OF;;EA04OA;IACE,8BAAA;EAx4OF;;EA24OA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EAz4OF;;EA44OA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA14OF;;EA64OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA34OF;;EA84OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA54OF;;EA+4OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA74OF;;EAg5OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA94OF;;EAi5OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/4OF;;EAk5OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh5OF;;EAm5OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAj5OF;;EAo5OA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAl5OF;;EAq5OA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAn5OF;;EAs5OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp5OF;;EAu5OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr5OF;;EAw5OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt5OF;;EAy5OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv5OF;;EA05OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx5OF;;EA25OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAz5OF;;EA45OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA15OF;;EA65OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA35OF;;EA85OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA55OF;;EA+5OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA75OF;;EAg6OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA95OF;;EAi6OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/5OF;;EAk6OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAh6OF;;EAm6OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAj6OF;;EAo6OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAl6OF;;EAq6OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAn6OF;;EAs6OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAp6OF;;EAu6OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAr6OF;;EAw6OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt6OF;;EAy6OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv6OF;;EA06OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx6OF;;EA26OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAz6OF;;EA46OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA16OF;;EA66OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA36OF;;EA86OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA56OF;;EA+6OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA76OF;;EAg7OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA96OF;;EAi7OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/6OF;;EAk7OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh7OF;;EAm7OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj7OF;;EAo7OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl7OF;;EAq7OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn7OF;;EAs7OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp7OF;;EAu7OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAr7OF;;EAw7OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAt7OF;;EAy7OA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAv7OF;;EA07OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx7OF;;EA27OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz7OF;;EA47OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA17OF;;EA67OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA37OF;;EA87OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA57OF;;EA+7OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA77OF;;EAg8OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA97OF;;EAi8OA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA/7OF;;EAk8OA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAh8OF;;EAm8OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj8OF;;EAo8OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl8OF;;EAq8OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn8OF;;EAs8OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp8OF;;EAu8OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr8OF;;EAw8OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt8OF;;EAy8OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAv8OF;;EA08OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAx8OF;;EA28OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAz8OF;;EA48OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA18OF;;EA68OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA38OF;;EA88OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA58OF;;EA+8OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA78OF;;EAg9OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA98OF;;EAi9OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/8OF;;EAk9OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAh9OF;;EAm9OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAj9OF;;EAo9OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAl9OF;;EAq9OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn9OF;;EAs9OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp9OF;;EAu9OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr9OF;;EAw9OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt9OF;;EAy9OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv9OF;;EA09OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAx9OF;;EA29OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAz9OF;;EA49OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA19OF;;EA69OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA39OF;;EA89OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA59OF;;EA+9OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA79OF;;EAg+OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA99OF;;EAi+OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/9OF;;EAk+OA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh+OF;;EAm+OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAj+OF;;EAo+OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAl+OF;;EAq+OA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn+OF;;EAs+OA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAp+OF;;EAu+OA;IACE,sBAAA;EAr+OF;;EAw+OA;IACE,sEAAA;EAt+OF;;EAy+OA;IACE,4EAAA;EAv+OF;;EA0+OA;IACE,wEAAA;EAx+OF;;EA2+OA;IACE,+EAAA;EAz+OF;;EA4+OA;IACE,yEAAA;EA1+OF;;EA6+OA;IACE,8EAAA;EA3+OF;;EA8+OA;IACE,uEAAA;EA5+OF;;EA++OA;IACE,2EAAA;EA7+OF;;EAg/OA;IACE,kCAAA;IACA,8FAAA;EA9+OF;;EAi/OA;IACE,mCAAA;IACA,oGAAA;EA/+OF;;EAk/OA;IACE,2BAAA;IACA,8FAAA;EAh/OF;;EAm/OA;IACE,2BAAA;IACA,oGAAA;EAj/OF;;EAo/OA;IACE,8BAAA;IACA,oGAAA;EAl/OF;;EAq/OA;IACE,8BAAA;IACA,oGAAA;EAn/OF;;EAs/OA;IACE,8BAAA;IACA,oGAAA;EAp/OF;;EAu/OA;IACE,8BAAA;IACA,oGAAA;EAr/OF;;EAw/OA;IACE,8BAAA;IACA,oGAAA;EAt/OF;;EAy/OA;IACE,8BAAA;IACA,oGAAA;EAv/OF;;EA0/OA;IACE,8BAAA;IACA,kGAAA;EAx/OF;;EA2/OA;IACE,8BAAA;IACA,iGAAA;EAz/OF;;EA4/OA;IACE,8BAAA;IACA,iGAAA;EA1/OF;;EA6/OA;IACE,8BAAA;IACA,oGAAA;EA3/OF;;EA8/OA;IACE,8BAAA;IACA,oGAAA;EA5/OF;;EA+/OA;IACE,8BAAA;IACA,oGAAA;EA7/OF;;EAggPA;IACE,8BAAA;IACA,oGAAA;EA9/OF;;EAigPA;IACE,8BAAA;IACA,oGAAA;EA//OF;;EAkgPA;IACE,8BAAA;IACA,kGAAA;EAhgPF;;EAmgPA;IACE,8BAAA;IACA,kGAAA;EAjgPF;;EAogPA;IACE,8BAAA;IACA,kGAAA;EAlgPF;;EAqgPA;IACE,8BAAA;IACA,kGAAA;EAngPF;;EAsgPA;IACE,8BAAA;IACA,oGAAA;EApgPF;;EAugPA;IACE,8BAAA;IACA,oGAAA;EArgPF;;EAwgPA;IACE,8BAAA;IACA,oGAAA;EAtgPF;;EAygPA;IACE,8BAAA;IACA,mGAAA;EAvgPF;;EA0gPA;IACE,8BAAA;IACA,mGAAA;EAxgPF;;EA2gPA;IACE,8BAAA;IACA,mGAAA;EAzgPF;;EA4gPA;IACE,8BAAA;IACA,kGAAA;EA1gPF;;EA6gPA;IACE,8BAAA;IACA,kGAAA;EA3gPF;;EA8gPA;IACE,8BAAA;IACA,kGAAA;EA5gPF;;EA+gPA;IACE,8BAAA;IACA,oGAAA;EA7gPF;;EAghPA;IACE,8BAAA;IACA,oGAAA;EA9gPF;;EAihPA;IACE,8BAAA;IACA,oGAAA;EA/gPF;;EAkhPA;IACE,8BAAA;IACA,mGAAA;EAhhPF;;EAmhPA;IACE,8BAAA;IACA,mGAAA;EAjhPF;;EAohPA;IACE,8BAAA;IACA,mGAAA;EAlhPF;;EAqhPA;IACE,8BAAA;IACA,mGAAA;EAnhPF;;EAshPA;IACE,8BAAA;IACA,kGAAA;EAphPF;;EAuhPA;IACE,8BAAA;IACA,kGAAA;EArhPF;;EAwhPA;IACE,8BAAA;IACA,oGAAA;EAthPF;;EAyhPA;IACE,8BAAA;IACA,oGAAA;EAvhPF;;EA0hPA;IACE,8BAAA;IACA,oGAAA;EAxhPF;;EA2hPA;IACE,8BAAA;IACA,oGAAA;EAzhPF;;EA4hPA;IACE,8BAAA;IACA,mGAAA;EA1hPF;;EA6hPA;IACE,8BAAA;IACA,mGAAA;EA3hPF;;EA8hPA;IACE,8BAAA;IACA,kGAAA;EA5hPF;;EA+hPA;IACE,8BAAA;IACA,kGAAA;EA7hPF;;EAgiPA;IACE,8BAAA;IACA,iGAAA;EA9hPF;;EAiiPA;IACE,8BAAA;IACA,oGAAA;EA/hPF;;EAkiPA;IACE,8BAAA;IACA,oGAAA;EAhiPF;;EAmiPA;IACE,8BAAA;IACA,oGAAA;EAjiPF;;EAoiPA;IACE,8BAAA;IACA,mGAAA;EAliPF;;EAqiPA;IACE,8BAAA;IACA,mGAAA;EAniPF;;EAsiPA;IACE,8BAAA;IACA,mGAAA;EApiPF;;EAuiPA;IACE,8BAAA;IACA,mGAAA;EAriPF;;EAwiPA;IACE,8BAAA;IACA,iGAAA;EAtiPF;;EAyiPA;IACE,8BAAA;IACA,iGAAA;EAviPF;;EA0iPA;IACE,8BAAA;IACA,oGAAA;EAxiPF;;EA2iPA;IACE,8BAAA;IACA,oGAAA;EAziPF;;EA4iPA;IACE,8BAAA;IACA,oGAAA;EA1iPF;;EA6iPA;IACE,8BAAA;IACA,mGAAA;EA3iPF;;EA8iPA;IACE,8BAAA;IACA,mGAAA;EA5iPF;;EA+iPA;IACE,8BAAA;IACA,mGAAA;EA7iPF;;EAgjPA;IACE,8BAAA;IACA,mGAAA;EA9iPF;;EAijPA;IACE,8BAAA;IACA,kGAAA;EA/iPF;;EAkjPA;IACE,8BAAA;IACA,kGAAA;EAhjPF;;EAmjPA;IACE,8BAAA;IACA,oGAAA;EAjjPF;;EAojPA;IACE,8BAAA;IACA,oGAAA;EAljPF;;EAqjPA;IACE,8BAAA;IACA,oGAAA;EAnjPF;;EAsjPA;IACE,8BAAA;IACA,oGAAA;EApjPF;;EAujPA;IACE,8BAAA;IACA,oGAAA;EArjPF;;EAwjPA;IACE,8BAAA;IACA,mGAAA;EAtjPF;;EAyjPA;IACE,8BAAA;IACA,kGAAA;EAvjPF;;EA0jPA;IACE,8BAAA;IACA,kGAAA;EAxjPF;;EA2jPA;IACE,8BAAA;IACA,kGAAA;EAzjPF;;EA4jPA;IACE,8BAAA;IACA,oGAAA;EA1jPF;;EA6jPA;IACE,8BAAA;IACA,oGAAA;EA3jPF;;EA8jPA;IACE,8BAAA;IACA,oGAAA;EA5jPF;;EA+jPA;IACE,8BAAA;IACA,oGAAA;EA7jPF;;EAgkPA;IACE,8BAAA;IACA,oGAAA;EA9jPF;;EAikPA;IACE,8BAAA;IACA,mGAAA;EA/jPF;;EAkkPA;IACE,8BAAA;IACA,mGAAA;EAhkPF;;EAmkPA;IACE,8BAAA;IACA,kGAAA;EAjkPF;;EAokPA;IACE,8BAAA;IACA,kGAAA;EAlkPF;;EAqkPA;IACE,8BAAA;IACA,oGAAA;EAnkPF;;EAskPA;IACE,8BAAA;IACA,oGAAA;EApkPF;;EAukPA;IACE,8BAAA;IACA,oGAAA;EArkPF;;EAwkPA;IACE,8BAAA;IACA,oGAAA;EAtkPF;;EAykPA;IACE,8BAAA;IACA,oGAAA;EAvkPF;;EA0kPA;IACE,8BAAA;IACA,mGAAA;EAxkPF;;EA2kPA;IACE,8BAAA;IACA,mGAAA;EAzkPF;;EA4kPA;IACE,8BAAA;IACA,mGAAA;EA1kPF;;EA6kPA;IACE,8BAAA;IACA,kGAAA;EA3kPF;;EA8kPA;IACE,iCAAA;IACA,yHAAA;EA5kPF;;EA+kPA;IACE,kCAAA;IACA,+HAAA;EA7kPF;;EAglPA;IACE,0BAAA;IACA,yHAAA;EA9kPF;;EAilPA;IACE,0BAAA;IACA,+HAAA;EA/kPF;;EAklPA;IACE,6BAAA;IACA,+HAAA;EAhlPF;;EAmlPA;IACE,6BAAA;IACA,+HAAA;EAjlPF;;EAolPA;IACE,6BAAA;IACA,+HAAA;EAllPF;;EAqlPA;IACE,6BAAA;IACA,+HAAA;EAnlPF;;EAslPA;IACE,6BAAA;IACA,+HAAA;EAplPF;;EAulPA;IACE,6BAAA;IACA,+HAAA;EArlPF;;EAwlPA;IACE,6BAAA;IACA,6HAAA;EAtlPF;;EAylPA;IACE,6BAAA;IACA,4HAAA;EAvlPF;;EA0lPA;IACE,6BAAA;IACA,4HAAA;EAxlPF;;EA2lPA;IACE,6BAAA;IACA,+HAAA;EAzlPF;;EA4lPA;IACE,6BAAA;IACA,+HAAA;EA1lPF;;EA6lPA;IACE,6BAAA;IACA,+HAAA;EA3lPF;;EA8lPA;IACE,6BAAA;IACA,+HAAA;EA5lPF;;EA+lPA;IACE,6BAAA;IACA,+HAAA;EA7lPF;;EAgmPA;IACE,6BAAA;IACA,6HAAA;EA9lPF;;EAimPA;IACE,6BAAA;IACA,6HAAA;EA/lPF;;EAkmPA;IACE,6BAAA;IACA,6HAAA;EAhmPF;;EAmmPA;IACE,6BAAA;IACA,6HAAA;EAjmPF;;EAomPA;IACE,6BAAA;IACA,+HAAA;EAlmPF;;EAqmPA;IACE,6BAAA;IACA,+HAAA;EAnmPF;;EAsmPA;IACE,6BAAA;IACA,+HAAA;EApmPF;;EAumPA;IACE,6BAAA;IACA,8HAAA;EArmPF;;EAwmPA;IACE,6BAAA;IACA,8HAAA;EAtmPF;;EAymPA;IACE,6BAAA;IACA,8HAAA;EAvmPF;;EA0mPA;IACE,6BAAA;IACA,6HAAA;EAxmPF;;EA2mPA;IACE,6BAAA;IACA,6HAAA;EAzmPF;;EA4mPA;IACE,6BAAA;IACA,6HAAA;EA1mPF;;EA6mPA;IACE,6BAAA;IACA,+HAAA;EA3mPF;;EA8mPA;IACE,6BAAA;IACA,+HAAA;EA5mPF;;EA+mPA;IACE,6BAAA;IACA,+HAAA;EA7mPF;;EAgnPA;IACE,6BAAA;IACA,8HAAA;EA9mPF;;EAinPA;IACE,6BAAA;IACA,8HAAA;EA/mPF;;EAknPA;IACE,6BAAA;IACA,8HAAA;EAhnPF;;EAmnPA;IACE,6BAAA;IACA,8HAAA;EAjnPF;;EAonPA;IACE,6BAAA;IACA,6HAAA;EAlnPF;;EAqnPA;IACE,6BAAA;IACA,6HAAA;EAnnPF;;EAsnPA;IACE,6BAAA;IACA,+HAAA;EApnPF;;EAunPA;IACE,6BAAA;IACA,+HAAA;EArnPF;;EAwnPA;IACE,6BAAA;IACA,+HAAA;EAtnPF;;EAynPA;IACE,6BAAA;IACA,+HAAA;EAvnPF;;EA0nPA;IACE,6BAAA;IACA,8HAAA;EAxnPF;;EA2nPA;IACE,6BAAA;IACA,8HAAA;EAznPF;;EA4nPA;IACE,6BAAA;IACA,6HAAA;EA1nPF;;EA6nPA;IACE,6BAAA;IACA,6HAAA;EA3nPF;;EA8nPA;IACE,6BAAA;IACA,4HAAA;EA5nPF;;EA+nPA;IACE,6BAAA;IACA,+HAAA;EA7nPF;;EAgoPA;IACE,6BAAA;IACA,+HAAA;EA9nPF;;EAioPA;IACE,6BAAA;IACA,+HAAA;EA/nPF;;EAkoPA;IACE,6BAAA;IACA,8HAAA;EAhoPF;;EAmoPA;IACE,6BAAA;IACA,8HAAA;EAjoPF;;EAooPA;IACE,6BAAA;IACA,8HAAA;EAloPF;;EAqoPA;IACE,6BAAA;IACA,8HAAA;EAnoPF;;EAsoPA;IACE,6BAAA;IACA,4HAAA;EApoPF;;EAuoPA;IACE,6BAAA;IACA,4HAAA;EAroPF;;EAwoPA;IACE,6BAAA;IACA,+HAAA;EAtoPF;;EAyoPA;IACE,6BAAA;IACA,+HAAA;EAvoPF;;EA0oPA;IACE,6BAAA;IACA,+HAAA;EAxoPF;;EA2oPA;IACE,6BAAA;IACA,8HAAA;EAzoPF;;EA4oPA;IACE,6BAAA;IACA,8HAAA;EA1oPF;;EA6oPA;IACE,6BAAA;IACA,8HAAA;EA3oPF;;EA8oPA;IACE,6BAAA;IACA,8HAAA;EA5oPF;;EA+oPA;IACE,6BAAA;IACA,6HAAA;EA7oPF;;EAgpPA;IACE,6BAAA;IACA,6HAAA;EA9oPF;;EAipPA;IACE,6BAAA;IACA,+HAAA;EA/oPF;;EAkpPA;IACE,6BAAA;IACA,+HAAA;EAhpPF;;EAmpPA;IACE,6BAAA;IACA,+HAAA;EAjpPF;;EAopPA;IACE,6BAAA;IACA,+HAAA;EAlpPF;;EAqpPA;IACE,6BAAA;IACA,+HAAA;EAnpPF;;EAspPA;IACE,6BAAA;IACA,8HAAA;EAppPF;;EAupPA;IACE,6BAAA;IACA,6HAAA;EArpPF;;EAwpPA;IACE,6BAAA;IACA,6HAAA;EAtpPF;;EAypPA;IACE,6BAAA;IACA,6HAAA;EAvpPF;;EA0pPA;IACE,6BAAA;IACA,+HAAA;EAxpPF;;EA2pPA;IACE,6BAAA;IACA,+HAAA;EAzpPF;;EA4pPA;IACE,6BAAA;IACA,+HAAA;EA1pPF;;EA6pPA;IACE,6BAAA;IACA,+HAAA;EA3pPF;;EA8pPA;IACE,6BAAA;IACA,+HAAA;EA5pPF;;EA+pPA;IACE,6BAAA;IACA,8HAAA;EA7pPF;;EAgqPA;IACE,6BAAA;IACA,8HAAA;EA9pPF;;EAiqPA;IACE,6BAAA;IACA,6HAAA;EA/pPF;;EAkqPA;IACE,6BAAA;IACA,6HAAA;EAhqPF;;EAmqPA;IACE,6BAAA;IACA,+HAAA;EAjqPF;;EAoqPA;IACE,6BAAA;IACA,+HAAA;EAlqPF;;EAqqPA;IACE,6BAAA;IACA,+HAAA;EAnqPF;;EAsqPA;IACE,6BAAA;IACA,+HAAA;EApqPF;;EAuqPA;IACE,6BAAA;IACA,+HAAA;EArqPF;;EAwqPA;IACE,6BAAA;IACA,8HAAA;EAtqPF;;EAyqPA;IACE,6BAAA;IACA,8HAAA;EAvqPF;;EA0qPA;IACE,6BAAA;IACA,8HAAA;EAxqPF;;EA2qPA;IACE,6BAAA;IACA,6HAAA;EAzqPF;;EA4qPA;IACE,gCAAA;EA1qPF;;EA6qPA;IACE,iCAAA;EA3qPF;;EA8qPA;IACE,yBAAA;EA5qPF;;EA+qPA;IACE,yBAAA;EA7qPF;;EAgrPA;IACE,4BAAA;EA9qPF;;EAirPA;IACE,4BAAA;EA/qPF;;EAkrPA;IACE,4BAAA;EAhrPF;;EAmrPA;IACE,4BAAA;EAjrPF;;EAorPA;IACE,4BAAA;EAlrPF;;EAqrPA;IACE,4BAAA;EAnrPF;;EAsrPA;IACE,4BAAA;EAprPF;;EAurPA;IACE,4BAAA;EArrPF;;EAwrPA;IACE,4BAAA;EAtrPF;;EAyrPA;IACE,4BAAA;EAvrPF;;EA0rPA;IACE,4BAAA;EAxrPF;;EA2rPA;IACE,4BAAA;EAzrPF;;EA4rPA;IACE,4BAAA;EA1rPF;;EA6rPA;IACE,4BAAA;EA3rPF;;EA8rPA;IACE,4BAAA;EA5rPF;;EA+rPA;IACE,4BAAA;EA7rPF;;EAgsPA;IACE,4BAAA;EA9rPF;;EAisPA;IACE,4BAAA;EA/rPF;;EAksPA;IACE,4BAAA;EAhsPF;;EAmsPA;IACE,4BAAA;EAjsPF;;EAosPA;IACE,4BAAA;EAlsPF;;EAqsPA;IACE,4BAAA;EAnsPF;;EAssPA;IACE,4BAAA;EApsPF;;EAusPA;IACE,4BAAA;EArsPF;;EAwsPA;IACE,4BAAA;EAtsPF;;EAysPA;IACE,4BAAA;EAvsPF;;EA0sPA;IACE,4BAAA;EAxsPF;;EA2sPA;IACE,4BAAA;EAzsPF;;EA4sPA;IACE,4BAAA;EA1sPF;;EA6sPA;IACE,4BAAA;EA3sPF;;EA8sPA;IACE,4BAAA;EA5sPF;;EA+sPA;IACE,4BAAA;EA7sPF;;EAgtPA;IACE,4BAAA;EA9sPF;;EAitPA;IACE,4BAAA;EA/sPF;;EAktPA;IACE,4BAAA;EAhtPF;;EAmtPA;IACE,4BAAA;EAjtPF;;EAotPA;IACE,4BAAA;EAltPF;;EAqtPA;IACE,4BAAA;EAntPF;;EAstPA;IACE,4BAAA;EAptPF;;EAutPA;IACE,4BAAA;EArtPF;;EAwtPA;IACE,4BAAA;EAttPF;;EAytPA;IACE,4BAAA;EAvtPF;;EA0tPA;IACE,4BAAA;EAxtPF;;EA2tPA;IACE,4BAAA;EAztPF;;EA4tPA;IACE,4BAAA;EA1tPF;;EA6tPA;IACE,4BAAA;EA3tPF;;EA8tPA;IACE,4BAAA;EA5tPF;;EA+tPA;IACE,4BAAA;EA7tPF;;EAguPA;IACE,4BAAA;EA9tPF;;EAiuPA;IACE,4BAAA;EA/tPF;;EAkuPA;IACE,4BAAA;EAhuPF;;EAmuPA;IACE,4BAAA;EAjuPF;;EAouPA;IACE,4BAAA;EAluPF;;EAquPA;IACE,4BAAA;EAnuPF;;EAsuPA;IACE,4BAAA;EApuPF;;EAuuPA;IACE,4BAAA;EAruPF;;EAwuPA;IACE,4BAAA;EAtuPF;;EAyuPA;IACE,4BAAA;EAvuPF;;EA0uPA;IACE,4BAAA;EAxuPF;;EA2uPA;IACE,4BAAA;EAzuPF;;EA4uPA;IACE,4BAAA;EA1uPF;;EA6uPA;IACE,4BAAA;EA3uPF;;EA8uPA;IACE,4BAAA;EA5uPF;;EA+uPA;IACE,4BAAA;EA7uPF;;EAgvPA;IACE,4BAAA;EA9uPF;;EAivPA;IACE,4BAAA;EA/uPF;;EAkvPA;IACE,4BAAA;EAhvPF;;EAmvPA;IACE,4BAAA;EAjvPF;;EAovPA;IACE,4BAAA;EAlvPF;;EAqvPA;IACE,4BAAA;EAnvPF;;EAsvPA;IACE,4BAAA;EApvPF;;EAuvPA;IACE,4BAAA;EArvPF;;EAwvPA;IACE,4BAAA;EAtvPF;;EAyvPA;IACE,4BAAA;EAvvPF;;EA0vPA;IACE,4BAAA;EAxvPF;;EA2vPA;IACE,4BAAA;EAzvPF;;EA4vPA;IACE,4BAAA;EA1vPF;;EA6vPA;IACE,4BAAA;EA3vPF;;EA8vPA;IACE,4BAAA;EA5vPF;;EA+vPA;IACE,4BAAA;EA7vPF;;EAgwPA;IACE,4BAAA;EA9vPF;;EAiwPA;IACE,4BAAA;EA/vPF;;EAkwPA;IACE,4BAAA;EAhwPF;;EAmwPA;IACE,4BAAA;EAjwPF;;EAowPA;IACE,4BAAA;EAlwPF;;EAqwPA;IACE,4BAAA;EAnwPF;;EAswPA;IACE,4BAAA;EApwPF;;EAuwPA;IACE,4BAAA;EArwPF;;EAwwPA;IACE,4BAAA;EAtwPF;;EAywPA;IACE,4BAAA;EAvwPF;;EA0wPA;IACE,kCAAA;IACA,8FAAA;EAxwPF;;EA2wPA;IACE,mCAAA;IACA,oGAAA;EAzwPF;;EA4wPA;IACE,2BAAA;IACA,8FAAA;EA1wPF;;EA6wPA;IACE,2BAAA;IACA,oGAAA;EA3wPF;;EA8wPA;IACE,8BAAA;IACA,oGAAA;EA5wPF;;EA+wPA;IACE,8BAAA;IACA,oGAAA;EA7wPF;;EAgxPA;IACE,8BAAA;IACA,oGAAA;EA9wPF;;EAixPA;IACE,8BAAA;IACA,oGAAA;EA/wPF;;EAkxPA;IACE,8BAAA;IACA,oGAAA;EAhxPF;;EAmxPA;IACE,8BAAA;IACA,oGAAA;EAjxPF;;EAoxPA;IACE,8BAAA;IACA,kGAAA;EAlxPF;;EAqxPA;IACE,8BAAA;IACA,iGAAA;EAnxPF;;EAsxPA;IACE,8BAAA;IACA,iGAAA;EApxPF;;EAuxPA;IACE,8BAAA;IACA,oGAAA;EArxPF;;EAwxPA;IACE,8BAAA;IACA,oGAAA;EAtxPF;;EAyxPA;IACE,8BAAA;IACA,oGAAA;EAvxPF;;EA0xPA;IACE,8BAAA;IACA,oGAAA;EAxxPF;;EA2xPA;IACE,8BAAA;IACA,oGAAA;EAzxPF;;EA4xPA;IACE,8BAAA;IACA,kGAAA;EA1xPF;;EA6xPA;IACE,8BAAA;IACA,kGAAA;EA3xPF;;EA8xPA;IACE,8BAAA;IACA,kGAAA;EA5xPF;;EA+xPA;IACE,8BAAA;IACA,kGAAA;EA7xPF;;EAgyPA;IACE,8BAAA;IACA,oGAAA;EA9xPF;;EAiyPA;IACE,8BAAA;IACA,oGAAA;EA/xPF;;EAkyPA;IACE,8BAAA;IACA,oGAAA;EAhyPF;;EAmyPA;IACE,8BAAA;IACA,mGAAA;EAjyPF;;EAoyPA;IACE,8BAAA;IACA,mGAAA;EAlyPF;;EAqyPA;IACE,8BAAA;IACA,mGAAA;EAnyPF;;EAsyPA;IACE,8BAAA;IACA,kGAAA;EApyPF;;EAuyPA;IACE,8BAAA;IACA,kGAAA;EAryPF;;EAwyPA;IACE,8BAAA;IACA,kGAAA;EAtyPF;;EAyyPA;IACE,8BAAA;IACA,oGAAA;EAvyPF;;EA0yPA;IACE,8BAAA;IACA,oGAAA;EAxyPF;;EA2yPA;IACE,8BAAA;IACA,oGAAA;EAzyPF;;EA4yPA;IACE,8BAAA;IACA,mGAAA;EA1yPF;;EA6yPA;IACE,8BAAA;IACA,mGAAA;EA3yPF;;EA8yPA;IACE,8BAAA;IACA,mGAAA;EA5yPF;;EA+yPA;IACE,8BAAA;IACA,mGAAA;EA7yPF;;EAgzPA;IACE,8BAAA;IACA,kGAAA;EA9yPF;;EAizPA;IACE,8BAAA;IACA,kGAAA;EA/yPF;;EAkzPA;IACE,8BAAA;IACA,oGAAA;EAhzPF;;EAmzPA;IACE,8BAAA;IACA,oGAAA;EAjzPF;;EAozPA;IACE,8BAAA;IACA,oGAAA;EAlzPF;;EAqzPA;IACE,8BAAA;IACA,oGAAA;EAnzPF;;EAszPA;IACE,8BAAA;IACA,mGAAA;EApzPF;;EAuzPA;IACE,8BAAA;IACA,mGAAA;EArzPF;;EAwzPA;IACE,8BAAA;IACA,kGAAA;EAtzPF;;EAyzPA;IACE,8BAAA;IACA,kGAAA;EAvzPF;;EA0zPA;IACE,8BAAA;IACA,iGAAA;EAxzPF;;EA2zPA;IACE,8BAAA;IACA,oGAAA;EAzzPF;;EA4zPA;IACE,8BAAA;IACA,oGAAA;EA1zPF;;EA6zPA;IACE,8BAAA;IACA,oGAAA;EA3zPF;;EA8zPA;IACE,8BAAA;IACA,mGAAA;EA5zPF;;EA+zPA;IACE,8BAAA;IACA,mGAAA;EA7zPF;;EAg0PA;IACE,8BAAA;IACA,mGAAA;EA9zPF;;EAi0PA;IACE,8BAAA;IACA,mGAAA;EA/zPF;;EAk0PA;IACE,8BAAA;IACA,iGAAA;EAh0PF;;EAm0PA;IACE,8BAAA;IACA,iGAAA;EAj0PF;;EAo0PA;IACE,8BAAA;IACA,oGAAA;EAl0PF;;EAq0PA;IACE,8BAAA;IACA,oGAAA;EAn0PF;;EAs0PA;IACE,8BAAA;IACA,oGAAA;EAp0PF;;EAu0PA;IACE,8BAAA;IACA,mGAAA;EAr0PF;;EAw0PA;IACE,8BAAA;IACA,mGAAA;EAt0PF;;EAy0PA;IACE,8BAAA;IACA,mGAAA;EAv0PF;;EA00PA;IACE,8BAAA;IACA,mGAAA;EAx0PF;;EA20PA;IACE,8BAAA;IACA,kGAAA;EAz0PF;;EA40PA;IACE,8BAAA;IACA,kGAAA;EA10PF;;EA60PA;IACE,8BAAA;IACA,oGAAA;EA30PF;;EA80PA;IACE,8BAAA;IACA,oGAAA;EA50PF;;EA+0PA;IACE,8BAAA;IACA,oGAAA;EA70PF;;EAg1PA;IACE,8BAAA;IACA,oGAAA;EA90PF;;EAi1PA;IACE,8BAAA;IACA,oGAAA;EA/0PF;;EAk1PA;IACE,8BAAA;IACA,mGAAA;EAh1PF;;EAm1PA;IACE,8BAAA;IACA,kGAAA;EAj1PF;;EAo1PA;IACE,8BAAA;IACA,kGAAA;EAl1PF;;EAq1PA;IACE,8BAAA;IACA,kGAAA;EAn1PF;;EAs1PA;IACE,8BAAA;IACA,oGAAA;EAp1PF;;EAu1PA;IACE,8BAAA;IACA,oGAAA;EAr1PF;;EAw1PA;IACE,8BAAA;IACA,oGAAA;EAt1PF;;EAy1PA;IACE,8BAAA;IACA,oGAAA;EAv1PF;;EA01PA;IACE,8BAAA;IACA,oGAAA;EAx1PF;;EA21PA;IACE,8BAAA;IACA,mGAAA;EAz1PF;;EA41PA;IACE,8BAAA;IACA,mGAAA;EA11PF;;EA61PA;IACE,8BAAA;IACA,kGAAA;EA31PF;;EA81PA;IACE,8BAAA;IACA,kGAAA;EA51PF;;EA+1PA;IACE,8BAAA;IACA,oGAAA;EA71PF;;EAg2PA;IACE,8BAAA;IACA,oGAAA;EA91PF;;EAi2PA;IACE,8BAAA;IACA,oGAAA;EA/1PF;;EAk2PA;IACE,8BAAA;IACA,oGAAA;EAh2PF;;EAm2PA;IACE,8BAAA;IACA,oGAAA;EAj2PF;;EAo2PA;IACE,8BAAA;IACA,mGAAA;EAl2PF;;EAq2PA;IACE,8BAAA;IACA,mGAAA;EAn2PF;;EAs2PA;IACE,8BAAA;IACA,mGAAA;EAp2PF;;EAu2PA;IACE,8BAAA;IACA,kGAAA;EAr2PF;;EAw2PA;IACE,iCAAA;IACA,yHAAA;EAt2PF;;EAy2PA;IACE,kCAAA;IACA,+HAAA;EAv2PF;;EA02PA;IACE,0BAAA;IACA,yHAAA;EAx2PF;;EA22PA;IACE,0BAAA;IACA,+HAAA;EAz2PF;;EA42PA;IACE,6BAAA;IACA,+HAAA;EA12PF;;EA62PA;IACE,6BAAA;IACA,+HAAA;EA32PF;;EA82PA;IACE,6BAAA;IACA,+HAAA;EA52PF;;EA+2PA;IACE,6BAAA;IACA,+HAAA;EA72PF;;EAg3PA;IACE,6BAAA;IACA,+HAAA;EA92PF;;EAi3PA;IACE,6BAAA;IACA,+HAAA;EA/2PF;;EAk3PA;IACE,6BAAA;IACA,6HAAA;EAh3PF;;EAm3PA;IACE,6BAAA;IACA,4HAAA;EAj3PF;;EAo3PA;IACE,6BAAA;IACA,4HAAA;EAl3PF;;EAq3PA;IACE,6BAAA;IACA,+HAAA;EAn3PF;;EAs3PA;IACE,6BAAA;IACA,+HAAA;EAp3PF;;EAu3PA;IACE,6BAAA;IACA,+HAAA;EAr3PF;;EAw3PA;IACE,6BAAA;IACA,+HAAA;EAt3PF;;EAy3PA;IACE,6BAAA;IACA,+HAAA;EAv3PF;;EA03PA;IACE,6BAAA;IACA,6HAAA;EAx3PF;;EA23PA;IACE,6BAAA;IACA,6HAAA;EAz3PF;;EA43PA;IACE,6BAAA;IACA,6HAAA;EA13PF;;EA63PA;IACE,6BAAA;IACA,6HAAA;EA33PF;;EA83PA;IACE,6BAAA;IACA,+HAAA;EA53PF;;EA+3PA;IACE,6BAAA;IACA,+HAAA;EA73PF;;EAg4PA;IACE,6BAAA;IACA,+HAAA;EA93PF;;EAi4PA;IACE,6BAAA;IACA,8HAAA;EA/3PF;;EAk4PA;IACE,6BAAA;IACA,8HAAA;EAh4PF;;EAm4PA;IACE,6BAAA;IACA,8HAAA;EAj4PF;;EAo4PA;IACE,6BAAA;IACA,6HAAA;EAl4PF;;EAq4PA;IACE,6BAAA;IACA,6HAAA;EAn4PF;;EAs4PA;IACE,6BAAA;IACA,6HAAA;EAp4PF;;EAu4PA;IACE,6BAAA;IACA,+HAAA;EAr4PF;;EAw4PA;IACE,6BAAA;IACA,+HAAA;EAt4PF;;EAy4PA;IACE,6BAAA;IACA,+HAAA;EAv4PF;;EA04PA;IACE,6BAAA;IACA,8HAAA;EAx4PF;;EA24PA;IACE,6BAAA;IACA,8HAAA;EAz4PF;;EA44PA;IACE,6BAAA;IACA,8HAAA;EA14PF;;EA64PA;IACE,6BAAA;IACA,8HAAA;EA34PF;;EA84PA;IACE,6BAAA;IACA,6HAAA;EA54PF;;EA+4PA;IACE,6BAAA;IACA,6HAAA;EA74PF;;EAg5PA;IACE,6BAAA;IACA,+HAAA;EA94PF;;EAi5PA;IACE,6BAAA;IACA,+HAAA;EA/4PF;;EAk5PA;IACE,6BAAA;IACA,+HAAA;EAh5PF;;EAm5PA;IACE,6BAAA;IACA,+HAAA;EAj5PF;;EAo5PA;IACE,6BAAA;IACA,8HAAA;EAl5PF;;EAq5PA;IACE,6BAAA;IACA,8HAAA;EAn5PF;;EAs5PA;IACE,6BAAA;IACA,6HAAA;EAp5PF;;EAu5PA;IACE,6BAAA;IACA,6HAAA;EAr5PF;;EAw5PA;IACE,6BAAA;IACA,4HAAA;EAt5PF;;EAy5PA;IACE,6BAAA;IACA,+HAAA;EAv5PF;;EA05PA;IACE,6BAAA;IACA,+HAAA;EAx5PF;;EA25PA;IACE,6BAAA;IACA,+HAAA;EAz5PF;;EA45PA;IACE,6BAAA;IACA,8HAAA;EA15PF;;EA65PA;IACE,6BAAA;IACA,8HAAA;EA35PF;;EA85PA;IACE,6BAAA;IACA,8HAAA;EA55PF;;EA+5PA;IACE,6BAAA;IACA,8HAAA;EA75PF;;EAg6PA;IACE,6BAAA;IACA,4HAAA;EA95PF;;EAi6PA;IACE,6BAAA;IACA,4HAAA;EA/5PF;;EAk6PA;IACE,6BAAA;IACA,+HAAA;EAh6PF;;EAm6PA;IACE,6BAAA;IACA,+HAAA;EAj6PF;;EAo6PA;IACE,6BAAA;IACA,+HAAA;EAl6PF;;EAq6PA;IACE,6BAAA;IACA,8HAAA;EAn6PF;;EAs6PA;IACE,6BAAA;IACA,8HAAA;EAp6PF;;EAu6PA;IACE,6BAAA;IACA,8HAAA;EAr6PF;;EAw6PA;IACE,6BAAA;IACA,8HAAA;EAt6PF;;EAy6PA;IACE,6BAAA;IACA,6HAAA;EAv6PF;;EA06PA;IACE,6BAAA;IACA,6HAAA;EAx6PF;;EA26PA;IACE,6BAAA;IACA,+HAAA;EAz6PF;;EA46PA;IACE,6BAAA;IACA,+HAAA;EA16PF;;EA66PA;IACE,6BAAA;IACA,+HAAA;EA36PF;;EA86PA;IACE,6BAAA;IACA,+HAAA;EA56PF;;EA+6PA;IACE,6BAAA;IACA,+HAAA;EA76PF;;EAg7PA;IACE,6BAAA;IACA,8HAAA;EA96PF;;EAi7PA;IACE,6BAAA;IACA,6HAAA;EA/6PF;;EAk7PA;IACE,6BAAA;IACA,6HAAA;EAh7PF;;EAm7PA;IACE,6BAAA;IACA,6HAAA;EAj7PF;;EAo7PA;IACE,6BAAA;IACA,+HAAA;EAl7PF;;EAq7PA;IACE,6BAAA;IACA,+HAAA;EAn7PF;;EAs7PA;IACE,6BAAA;IACA,+HAAA;EAp7PF;;EAu7PA;IACE,6BAAA;IACA,+HAAA;EAr7PF;;EAw7PA;IACE,6BAAA;IACA,+HAAA;EAt7PF;;EAy7PA;IACE,6BAAA;IACA,8HAAA;EAv7PF;;EA07PA;IACE,6BAAA;IACA,8HAAA;EAx7PF;;EA27PA;IACE,6BAAA;IACA,6HAAA;EAz7PF;;EA47PA;IACE,6BAAA;IACA,6HAAA;EA17PF;;EA67PA;IACE,6BAAA;IACA,+HAAA;EA37PF;;EA87PA;IACE,6BAAA;IACA,+HAAA;EA57PF;;EA+7PA;IACE,6BAAA;IACA,+HAAA;EA77PF;;EAg8PA;IACE,6BAAA;IACA,+HAAA;EA97PF;;EAi8PA;IACE,6BAAA;IACA,+HAAA;EA/7PF;;EAk8PA;IACE,6BAAA;IACA,8HAAA;EAh8PF;;EAm8PA;IACE,6BAAA;IACA,8HAAA;EAj8PF;;EAo8PA;IACE,6BAAA;IACA,8HAAA;EAl8PF;;EAq8PA;IACE,6BAAA;IACA,6HAAA;EAn8PF;;EAs8PA;IACE,gCAAA;EAp8PF;;EAu8PA;IACE,iCAAA;EAr8PF;;EAw8PA;IACE,yBAAA;EAt8PF;;EAy8PA;IACE,yBAAA;EAv8PF;;EA08PA;IACE,4BAAA;EAx8PF;;EA28PA;IACE,4BAAA;EAz8PF;;EA48PA;IACE,4BAAA;EA18PF;;EA68PA;IACE,4BAAA;EA38PF;;EA88PA;IACE,4BAAA;EA58PF;;EA+8PA;IACE,4BAAA;EA78PF;;EAg9PA;IACE,4BAAA;EA98PF;;EAi9PA;IACE,4BAAA;EA/8PF;;EAk9PA;IACE,4BAAA;EAh9PF;;EAm9PA;IACE,4BAAA;EAj9PF;;EAo9PA;IACE,4BAAA;EAl9PF;;EAq9PA;IACE,4BAAA;EAn9PF;;EAs9PA;IACE,4BAAA;EAp9PF;;EAu9PA;IACE,4BAAA;EAr9PF;;EAw9PA;IACE,4BAAA;EAt9PF;;EAy9PA;IACE,4BAAA;EAv9PF;;EA09PA;IACE,4BAAA;EAx9PF;;EA29PA;IACE,4BAAA;EAz9PF;;EA49PA;IACE,4BAAA;EA19PF;;EA69PA;IACE,4BAAA;EA39PF;;EA89PA;IACE,4BAAA;EA59PF;;EA+9PA;IACE,4BAAA;EA79PF;;EAg+PA;IACE,4BAAA;EA99PF;;EAi+PA;IACE,4BAAA;EA/9PF;;EAk+PA;IACE,4BAAA;EAh+PF;;EAm+PA;IACE,4BAAA;EAj+PF;;EAo+PA;IACE,4BAAA;EAl+PF;;EAq+PA;IACE,4BAAA;EAn+PF;;EAs+PA;IACE,4BAAA;EAp+PF;;EAu+PA;IACE,4BAAA;EAr+PF;;EAw+PA;IACE,4BAAA;EAt+PF;;EAy+PA;IACE,4BAAA;EAv+PF;;EA0+PA;IACE,4BAAA;EAx+PF;;EA2+PA;IACE,4BAAA;EAz+PF;;EA4+PA;IACE,4BAAA;EA1+PF;;EA6+PA;IACE,4BAAA;EA3+PF;;EA8+PA;IACE,4BAAA;EA5+PF;;EA++PA;IACE,4BAAA;EA7+PF;;EAg/PA;IACE,4BAAA;EA9+PF;;EAi/PA;IACE,4BAAA;EA/+PF;;EAk/PA;IACE,4BAAA;EAh/PF;;EAm/PA;IACE,4BAAA;EAj/PF;;EAo/PA;IACE,4BAAA;EAl/PF;;EAq/PA;IACE,4BAAA;EAn/PF;;EAs/PA;IACE,4BAAA;EAp/PF;;EAu/PA;IACE,4BAAA;EAr/PF;;EAw/PA;IACE,4BAAA;EAt/PF;;EAy/PA;IACE,4BAAA;EAv/PF;;EA0/PA;IACE,4BAAA;EAx/PF;;EA2/PA;IACE,4BAAA;EAz/PF;;EA4/PA;IACE,4BAAA;EA1/PF;;EA6/PA;IACE,4BAAA;EA3/PF;;EA8/PA;IACE,4BAAA;EA5/PF;;EA+/PA;IACE,4BAAA;EA7/PF;;EAggQA;IACE,4BAAA;EA9/PF;;EAigQA;IACE,4BAAA;EA//PF;;EAkgQA;IACE,4BAAA;EAhgQF;;EAmgQA;IACE,4BAAA;EAjgQF;;EAogQA;IACE,4BAAA;EAlgQF;;EAqgQA;IACE,4BAAA;EAngQF;;EAsgQA;IACE,4BAAA;EApgQF;;EAugQA;IACE,4BAAA;EArgQF;;EAwgQA;IACE,4BAAA;EAtgQF;;EAygQA;IACE,4BAAA;EAvgQF;;EA0gQA;IACE,4BAAA;EAxgQF;;EA2gQA;IACE,4BAAA;EAzgQF;;EA4gQA;IACE,4BAAA;EA1gQF;;EA6gQA;IACE,4BAAA;EA3gQF;;EA8gQA;IACE,4BAAA;EA5gQF;;EA+gQA;IACE,4BAAA;EA7gQF;;EAghQA;IACE,4BAAA;EA9gQF;;EAihQA;IACE,4BAAA;EA/gQF;;EAkhQA;IACE,4BAAA;EAhhQF;;EAmhQA;IACE,4BAAA;EAjhQF;;EAohQA;IACE,4BAAA;EAlhQF;;EAqhQA;IACE,4BAAA;EAnhQF;;EAshQA;IACE,4BAAA;EAphQF;;EAuhQA;IACE,4BAAA;EArhQF;;EAwhQA;IACE,4BAAA;EAthQF;;EAyhQA;IACE,4BAAA;EAvhQF;;EA0hQA;IACE,4BAAA;EAxhQF;;EA2hQA;IACE,4BAAA;EAzhQF;;EA4hQA;IACE,4BAAA;EA1hQF;;EA6hQA;IACE,4BAAA;EA3hQF;;EA8hQA;IACE,4BAAA;EA5hQF;;EA+hQA;IACE,4BAAA;EA7hQF;;EAgiQA;IACE,4BAAA;EA9hQF;;EAiiQA;IACE,4BAAA;EA/hQF;;EAkiQA;IACE,4BAAA;EAhiQF;;EAmiQA;IACE,4BAAA;EAjiQF;;EAoiQA;IACE,kCAAA;IACA,8FAAA;EAliQF;;EAqiQA;IACE,mCAAA;IACA,oGAAA;EAniQF;;EAsiQA;IACE,2BAAA;IACA,8FAAA;EApiQF;;EAuiQA;IACE,2BAAA;IACA,oGAAA;EAriQF;;EAwiQA;IACE,8BAAA;IACA,oGAAA;EAtiQF;;EAyiQA;IACE,8BAAA;IACA,oGAAA;EAviQF;;EA0iQA;IACE,8BAAA;IACA,oGAAA;EAxiQF;;EA2iQA;IACE,8BAAA;IACA,oGAAA;EAziQF;;EA4iQA;IACE,8BAAA;IACA,oGAAA;EA1iQF;;EA6iQA;IACE,8BAAA;IACA,oGAAA;EA3iQF;;EA8iQA;IACE,8BAAA;IACA,kGAAA;EA5iQF;;EA+iQA;IACE,8BAAA;IACA,iGAAA;EA7iQF;;EAgjQA;IACE,8BAAA;IACA,iGAAA;EA9iQF;;EAijQA;IACE,8BAAA;IACA,oGAAA;EA/iQF;;EAkjQA;IACE,8BAAA;IACA,oGAAA;EAhjQF;;EAmjQA;IACE,8BAAA;IACA,oGAAA;EAjjQF;;EAojQA;IACE,8BAAA;IACA,oGAAA;EAljQF;;EAqjQA;IACE,8BAAA;IACA,oGAAA;EAnjQF;;EAsjQA;IACE,8BAAA;IACA,kGAAA;EApjQF;;EAujQA;IACE,8BAAA;IACA,kGAAA;EArjQF;;EAwjQA;IACE,8BAAA;IACA,kGAAA;EAtjQF;;EAyjQA;IACE,8BAAA;IACA,kGAAA;EAvjQF;;EA0jQA;IACE,8BAAA;IACA,oGAAA;EAxjQF;;EA2jQA;IACE,8BAAA;IACA,oGAAA;EAzjQF;;EA4jQA;IACE,8BAAA;IACA,oGAAA;EA1jQF;;EA6jQA;IACE,8BAAA;IACA,mGAAA;EA3jQF;;EA8jQA;IACE,8BAAA;IACA,mGAAA;EA5jQF;;EA+jQA;IACE,8BAAA;IACA,mGAAA;EA7jQF;;EAgkQA;IACE,8BAAA;IACA,kGAAA;EA9jQF;;EAikQA;IACE,8BAAA;IACA,kGAAA;EA/jQF;;EAkkQA;IACE,8BAAA;IACA,kGAAA;EAhkQF;;EAmkQA;IACE,8BAAA;IACA,oGAAA;EAjkQF;;EAokQA;IACE,8BAAA;IACA,oGAAA;EAlkQF;;EAqkQA;IACE,8BAAA;IACA,oGAAA;EAnkQF;;EAskQA;IACE,8BAAA;IACA,mGAAA;EApkQF;;EAukQA;IACE,8BAAA;IACA,mGAAA;EArkQF;;EAwkQA;IACE,8BAAA;IACA,mGAAA;EAtkQF;;EAykQA;IACE,8BAAA;IACA,mGAAA;EAvkQF;;EA0kQA;IACE,8BAAA;IACA,kGAAA;EAxkQF;;EA2kQA;IACE,8BAAA;IACA,kGAAA;EAzkQF;;EA4kQA;IACE,8BAAA;IACA,oGAAA;EA1kQF;;EA6kQA;IACE,8BAAA;IACA,oGAAA;EA3kQF;;EA8kQA;IACE,8BAAA;IACA,oGAAA;EA5kQF;;EA+kQA;IACE,8BAAA;IACA,oGAAA;EA7kQF;;EAglQA;IACE,8BAAA;IACA,mGAAA;EA9kQF;;EAilQA;IACE,8BAAA;IACA,mGAAA;EA/kQF;;EAklQA;IACE,8BAAA;IACA,kGAAA;EAhlQF;;EAmlQA;IACE,8BAAA;IACA,kGAAA;EAjlQF;;EAolQA;IACE,8BAAA;IACA,iGAAA;EAllQF;;EAqlQA;IACE,8BAAA;IACA,oGAAA;EAnlQF;;EAslQA;IACE,8BAAA;IACA,oGAAA;EAplQF;;EAulQA;IACE,8BAAA;IACA,oGAAA;EArlQF;;EAwlQA;IACE,8BAAA;IACA,mGAAA;EAtlQF;;EAylQA;IACE,8BAAA;IACA,mGAAA;EAvlQF;;EA0lQA;IACE,8BAAA;IACA,mGAAA;EAxlQF;;EA2lQA;IACE,8BAAA;IACA,mGAAA;EAzlQF;;EA4lQA;IACE,8BAAA;IACA,iGAAA;EA1lQF;;EA6lQA;IACE,8BAAA;IACA,iGAAA;EA3lQF;;EA8lQA;IACE,8BAAA;IACA,oGAAA;EA5lQF;;EA+lQA;IACE,8BAAA;IACA,oGAAA;EA7lQF;;EAgmQA;IACE,8BAAA;IACA,oGAAA;EA9lQF;;EAimQA;IACE,8BAAA;IACA,mGAAA;EA/lQF;;EAkmQA;IACE,8BAAA;IACA,mGAAA;EAhmQF;;EAmmQA;IACE,8BAAA;IACA,mGAAA;EAjmQF;;EAomQA;IACE,8BAAA;IACA,mGAAA;EAlmQF;;EAqmQA;IACE,8BAAA;IACA,kGAAA;EAnmQF;;EAsmQA;IACE,8BAAA;IACA,kGAAA;EApmQF;;EAumQA;IACE,8BAAA;IACA,oGAAA;EArmQF;;EAwmQA;IACE,8BAAA;IACA,oGAAA;EAtmQF;;EAymQA;IACE,8BAAA;IACA,oGAAA;EAvmQF;;EA0mQA;IACE,8BAAA;IACA,oGAAA;EAxmQF;;EA2mQA;IACE,8BAAA;IACA,oGAAA;EAzmQF;;EA4mQA;IACE,8BAAA;IACA,mGAAA;EA1mQF;;EA6mQA;IACE,8BAAA;IACA,kGAAA;EA3mQF;;EA8mQA;IACE,8BAAA;IACA,kGAAA;EA5mQF;;EA+mQA;IACE,8BAAA;IACA,kGAAA;EA7mQF;;EAgnQA;IACE,8BAAA;IACA,oGAAA;EA9mQF;;EAinQA;IACE,8BAAA;IACA,oGAAA;EA/mQF;;EAknQA;IACE,8BAAA;IACA,oGAAA;EAhnQF;;EAmnQA;IACE,8BAAA;IACA,oGAAA;EAjnQF;;EAonQA;IACE,8BAAA;IACA,oGAAA;EAlnQF;;EAqnQA;IACE,8BAAA;IACA,mGAAA;EAnnQF;;EAsnQA;IACE,8BAAA;IACA,mGAAA;EApnQF;;EAunQA;IACE,8BAAA;IACA,kGAAA;EArnQF;;EAwnQA;IACE,8BAAA;IACA,kGAAA;EAtnQF;;EAynQA;IACE,8BAAA;IACA,oGAAA;EAvnQF;;EA0nQA;IACE,8BAAA;IACA,oGAAA;EAxnQF;;EA2nQA;IACE,8BAAA;IACA,oGAAA;EAznQF;;EA4nQA;IACE,8BAAA;IACA,oGAAA;EA1nQF;;EA6nQA;IACE,8BAAA;IACA,oGAAA;EA3nQF;;EA8nQA;IACE,8BAAA;IACA,mGAAA;EA5nQF;;EA+nQA;IACE,8BAAA;IACA,mGAAA;EA7nQF;;EAgoQA;IACE,8BAAA;IACA,mGAAA;EA9nQF;;EAioQA;IACE,8BAAA;IACA,kGAAA;EA/nQF;;EAkoQA;IACE,iCAAA;IACA,yHAAA;EAhoQF;;EAmoQA;IACE,kCAAA;IACA,+HAAA;EAjoQF;;EAooQA;IACE,0BAAA;IACA,yHAAA;EAloQF;;EAqoQA;IACE,0BAAA;IACA,+HAAA;EAnoQF;;EAsoQA;IACE,6BAAA;IACA,+HAAA;EApoQF;;EAuoQA;IACE,6BAAA;IACA,+HAAA;EAroQF;;EAwoQA;IACE,6BAAA;IACA,+HAAA;EAtoQF;;EAyoQA;IACE,6BAAA;IACA,+HAAA;EAvoQF;;EA0oQA;IACE,6BAAA;IACA,+HAAA;EAxoQF;;EA2oQA;IACE,6BAAA;IACA,+HAAA;EAzoQF;;EA4oQA;IACE,6BAAA;IACA,6HAAA;EA1oQF;;EA6oQA;IACE,6BAAA;IACA,4HAAA;EA3oQF;;EA8oQA;IACE,6BAAA;IACA,4HAAA;EA5oQF;;EA+oQA;IACE,6BAAA;IACA,+HAAA;EA7oQF;;EAgpQA;IACE,6BAAA;IACA,+HAAA;EA9oQF;;EAipQA;IACE,6BAAA;IACA,+HAAA;EA/oQF;;EAkpQA;IACE,6BAAA;IACA,+HAAA;EAhpQF;;EAmpQA;IACE,6BAAA;IACA,+HAAA;EAjpQF;;EAopQA;IACE,6BAAA;IACA,6HAAA;EAlpQF;;EAqpQA;IACE,6BAAA;IACA,6HAAA;EAnpQF;;EAspQA;IACE,6BAAA;IACA,6HAAA;EAppQF;;EAupQA;IACE,6BAAA;IACA,6HAAA;EArpQF;;EAwpQA;IACE,6BAAA;IACA,+HAAA;EAtpQF;;EAypQA;IACE,6BAAA;IACA,+HAAA;EAvpQF;;EA0pQA;IACE,6BAAA;IACA,+HAAA;EAxpQF;;EA2pQA;IACE,6BAAA;IACA,8HAAA;EAzpQF;;EA4pQA;IACE,6BAAA;IACA,8HAAA;EA1pQF;;EA6pQA;IACE,6BAAA;IACA,8HAAA;EA3pQF;;EA8pQA;IACE,6BAAA;IACA,6HAAA;EA5pQF;;EA+pQA;IACE,6BAAA;IACA,6HAAA;EA7pQF;;EAgqQA;IACE,6BAAA;IACA,6HAAA;EA9pQF;;EAiqQA;IACE,6BAAA;IACA,+HAAA;EA/pQF;;EAkqQA;IACE,6BAAA;IACA,+HAAA;EAhqQF;;EAmqQA;IACE,6BAAA;IACA,+HAAA;EAjqQF;;EAoqQA;IACE,6BAAA;IACA,8HAAA;EAlqQF;;EAqqQA;IACE,6BAAA;IACA,8HAAA;EAnqQF;;EAsqQA;IACE,6BAAA;IACA,8HAAA;EApqQF;;EAuqQA;IACE,6BAAA;IACA,8HAAA;EArqQF;;EAwqQA;IACE,6BAAA;IACA,6HAAA;EAtqQF;;EAyqQA;IACE,6BAAA;IACA,6HAAA;EAvqQF;;EA0qQA;IACE,6BAAA;IACA,+HAAA;EAxqQF;;EA2qQA;IACE,6BAAA;IACA,+HAAA;EAzqQF;;EA4qQA;IACE,6BAAA;IACA,+HAAA;EA1qQF;;EA6qQA;IACE,6BAAA;IACA,+HAAA;EA3qQF;;EA8qQA;IACE,6BAAA;IACA,8HAAA;EA5qQF;;EA+qQA;IACE,6BAAA;IACA,8HAAA;EA7qQF;;EAgrQA;IACE,6BAAA;IACA,6HAAA;EA9qQF;;EAirQA;IACE,6BAAA;IACA,6HAAA;EA/qQF;;EAkrQA;IACE,6BAAA;IACA,4HAAA;EAhrQF;;EAmrQA;IACE,6BAAA;IACA,+HAAA;EAjrQF;;EAorQA;IACE,6BAAA;IACA,+HAAA;EAlrQF;;EAqrQA;IACE,6BAAA;IACA,+HAAA;EAnrQF;;EAsrQA;IACE,6BAAA;IACA,8HAAA;EAprQF;;EAurQA;IACE,6BAAA;IACA,8HAAA;EArrQF;;EAwrQA;IACE,6BAAA;IACA,8HAAA;EAtrQF;;EAyrQA;IACE,6BAAA;IACA,8HAAA;EAvrQF;;EA0rQA;IACE,6BAAA;IACA,4HAAA;EAxrQF;;EA2rQA;IACE,6BAAA;IACA,4HAAA;EAzrQF;;EA4rQA;IACE,6BAAA;IACA,+HAAA;EA1rQF;;EA6rQA;IACE,6BAAA;IACA,+HAAA;EA3rQF;;EA8rQA;IACE,6BAAA;IACA,+HAAA;EA5rQF;;EA+rQA;IACE,6BAAA;IACA,8HAAA;EA7rQF;;EAgsQA;IACE,6BAAA;IACA,8HAAA;EA9rQF;;EAisQA;IACE,6BAAA;IACA,8HAAA;EA/rQF;;EAksQA;IACE,6BAAA;IACA,8HAAA;EAhsQF;;EAmsQA;IACE,6BAAA;IACA,6HAAA;EAjsQF;;EAosQA;IACE,6BAAA;IACA,6HAAA;EAlsQF;;EAqsQA;IACE,6BAAA;IACA,+HAAA;EAnsQF;;EAssQA;IACE,6BAAA;IACA,+HAAA;EApsQF;;EAusQA;IACE,6BAAA;IACA,+HAAA;EArsQF;;EAwsQA;IACE,6BAAA;IACA,+HAAA;EAtsQF;;EAysQA;IACE,6BAAA;IACA,+HAAA;EAvsQF;;EA0sQA;IACE,6BAAA;IACA,8HAAA;EAxsQF;;EA2sQA;IACE,6BAAA;IACA,6HAAA;EAzsQF;;EA4sQA;IACE,6BAAA;IACA,6HAAA;EA1sQF;;EA6sQA;IACE,6BAAA;IACA,6HAAA;EA3sQF;;EA8sQA;IACE,6BAAA;IACA,+HAAA;EA5sQF;;EA+sQA;IACE,6BAAA;IACA,+HAAA;EA7sQF;;EAgtQA;IACE,6BAAA;IACA,+HAAA;EA9sQF;;EAitQA;IACE,6BAAA;IACA,+HAAA;EA/sQF;;EAktQA;IACE,6BAAA;IACA,+HAAA;EAhtQF;;EAmtQA;IACE,6BAAA;IACA,8HAAA;EAjtQF;;EAotQA;IACE,6BAAA;IACA,8HAAA;EAltQF;;EAqtQA;IACE,6BAAA;IACA,6HAAA;EAntQF;;EAstQA;IACE,6BAAA;IACA,6HAAA;EAptQF;;EAutQA;IACE,6BAAA;IACA,+HAAA;EArtQF;;EAwtQA;IACE,6BAAA;IACA,+HAAA;EAttQF;;EAytQA;IACE,6BAAA;IACA,+HAAA;EAvtQF;;EA0tQA;IACE,6BAAA;IACA,+HAAA;EAxtQF;;EA2tQA;IACE,6BAAA;IACA,+HAAA;EAztQF;;EA4tQA;IACE,6BAAA;IACA,8HAAA;EA1tQF;;EA6tQA;IACE,6BAAA;IACA,8HAAA;EA3tQF;;EA8tQA;IACE,6BAAA;IACA,8HAAA;EA5tQF;;EA+tQA;IACE,6BAAA;IACA,6HAAA;EA7tQF;;EAguQA;IACE,gCAAA;EA9tQF;;EAiuQA;IACE,iCAAA;EA/tQF;;EAkuQA;IACE,yBAAA;EAhuQF;;EAmuQA;IACE,yBAAA;EAjuQF;;EAouQA;IACE,4BAAA;EAluQF;;EAquQA;IACE,4BAAA;EAnuQF;;EAsuQA;IACE,4BAAA;EApuQF;;EAuuQA;IACE,4BAAA;EAruQF;;EAwuQA;IACE,4BAAA;EAtuQF;;EAyuQA;IACE,4BAAA;EAvuQF;;EA0uQA;IACE,4BAAA;EAxuQF;;EA2uQA;IACE,4BAAA;EAzuQF;;EA4uQA;IACE,4BAAA;EA1uQF;;EA6uQA;IACE,4BAAA;EA3uQF;;EA8uQA;IACE,4BAAA;EA5uQF;;EA+uQA;IACE,4BAAA;EA7uQF;;EAgvQA;IACE,4BAAA;EA9uQF;;EAivQA;IACE,4BAAA;EA/uQF;;EAkvQA;IACE,4BAAA;EAhvQF;;EAmvQA;IACE,4BAAA;EAjvQF;;EAovQA;IACE,4BAAA;EAlvQF;;EAqvQA;IACE,4BAAA;EAnvQF;;EAsvQA;IACE,4BAAA;EApvQF;;EAuvQA;IACE,4BAAA;EArvQF;;EAwvQA;IACE,4BAAA;EAtvQF;;EAyvQA;IACE,4BAAA;EAvvQF;;EA0vQA;IACE,4BAAA;EAxvQF;;EA2vQA;IACE,4BAAA;EAzvQF;;EA4vQA;IACE,4BAAA;EA1vQF;;EA6vQA;IACE,4BAAA;EA3vQF;;EA8vQA;IACE,4BAAA;EA5vQF;;EA+vQA;IACE,4BAAA;EA7vQF;;EAgwQA;IACE,4BAAA;EA9vQF;;EAiwQA;IACE,4BAAA;EA/vQF;;EAkwQA;IACE,4BAAA;EAhwQF;;EAmwQA;IACE,4BAAA;EAjwQF;;EAowQA;IACE,4BAAA;EAlwQF;;EAqwQA;IACE,4BAAA;EAnwQF;;EAswQA;IACE,4BAAA;EApwQF;;EAuwQA;IACE,4BAAA;EArwQF;;EAwwQA;IACE,4BAAA;EAtwQF;;EAywQA;IACE,4BAAA;EAvwQF;;EA0wQA;IACE,4BAAA;EAxwQF;;EA2wQA;IACE,4BAAA;EAzwQF;;EA4wQA;IACE,4BAAA;EA1wQF;;EA6wQA;IACE,4BAAA;EA3wQF;;EA8wQA;IACE,4BAAA;EA5wQF;;EA+wQA;IACE,4BAAA;EA7wQF;;EAgxQA;IACE,4BAAA;EA9wQF;;EAixQA;IACE,4BAAA;EA/wQF;;EAkxQA;IACE,4BAAA;EAhxQF;;EAmxQA;IACE,4BAAA;EAjxQF;;EAoxQA;IACE,4BAAA;EAlxQF;;EAqxQA;IACE,4BAAA;EAnxQF;;EAsxQA;IACE,4BAAA;EApxQF;;EAuxQA;IACE,4BAAA;EArxQF;;EAwxQA;IACE,4BAAA;EAtxQF;;EAyxQA;IACE,4BAAA;EAvxQF;;EA0xQA;IACE,4BAAA;EAxxQF;;EA2xQA;IACE,4BAAA;EAzxQF;;EA4xQA;IACE,4BAAA;EA1xQF;;EA6xQA;IACE,4BAAA;EA3xQF;;EA8xQA;IACE,4BAAA;EA5xQF;;EA+xQA;IACE,4BAAA;EA7xQF;;EAgyQA;IACE,4BAAA;EA9xQF;;EAiyQA;IACE,4BAAA;EA/xQF;;EAkyQA;IACE,4BAAA;EAhyQF;;EAmyQA;IACE,4BAAA;EAjyQF;;EAoyQA;IACE,4BAAA;EAlyQF;;EAqyQA;IACE,4BAAA;EAnyQF;;EAsyQA;IACE,4BAAA;EApyQF;;EAuyQA;IACE,4BAAA;EAryQF;;EAwyQA;IACE,4BAAA;EAtyQF;;EAyyQA;IACE,4BAAA;EAvyQF;;EA0yQA;IACE,4BAAA;EAxyQF;;EA2yQA;IACE,4BAAA;EAzyQF;;EA4yQA;IACE,4BAAA;EA1yQF;;EA6yQA;IACE,4BAAA;EA3yQF;;EA8yQA;IACE,4BAAA;EA5yQF;;EA+yQA;IACE,4BAAA;EA7yQF;;EAgzQA;IACE,4BAAA;EA9yQF;;EAizQA;IACE,4BAAA;EA/yQF;;EAkzQA;IACE,4BAAA;EAhzQF;;EAmzQA;IACE,4BAAA;EAjzQF;;EAozQA;IACE,4BAAA;EAlzQF;;EAqzQA;IACE,4BAAA;EAnzQF;;EAszQA;IACE,4BAAA;EApzQF;;EAuzQA;IACE,4BAAA;EArzQF;;EAwzQA;IACE,4BAAA;EAtzQF;;EAyzQA;IACE,4BAAA;EAvzQF;;EA0zQA;IACE,4BAAA;EAxzQF;;EA2zQA;IACE,4BAAA;EAzzQF;;EA4zQA;IACE,4BAAA;EA1zQF;;EA6zQA;IACE,4BAAA;EA3zQF;;EA8zQA;IACE,eAAA;EA5zQF;;EA+zQA;IACE,kBAAA;EA7zQF;;EAg0QA;IACE,iBAAA;EA9zQF;;EAi0QA;IACE,kBAAA;EA/zQF;;EAk0QA;IACE,eAAA;EAh0QF;;EAm0QA;IACE,eAAA;EAj0QF;;EAo0QA;IACE,kBAAA;EAl0QF;;EAq0QA;IACE,iBAAA;EAn0QF;;EAs0QA;IACE,kBAAA;EAp0QF;;EAu0QA;IACE,eAAA;EAr0QF;;EAw0QA;IACE,eAAA;EAt0QF;;EAy0QA;IACE,kBAAA;EAv0QF;;EA00QA;IACE,iBAAA;EAx0QF;;EA20QA;IACE,kBAAA;EAz0QF;;EA40QA;IACE,eAAA;EA10QF;;EA60QA;IACE,2BAAA;EA30QF;;EA80QA;IACE,2BAAA;EA50QF;;EA+0QA;IACE,yBAAA;EA70QF;;EAg1QA;IACE,gCAAA;EA90QF;;EAi1QA;IACE,6BAAA;EA/0QF;;EAk1QA;IACE,0BAAA;EAh1QF;;EAm1QA;IACE,iCAAA;EAj1QF;;EAo1QA;IACE,8BAAA;EAl1QF;;EAq1QA;IACE,wBAAA;EAn1QF;;EAs1QA;IACE,yBAAA;EAp1QF;;EAu1QA;IACE,4BAAA;EAr1QF;;EAw1QA;IACE,2BAAA;EAt1QF;;EAy1QA;IACE,2BAAA;EAv1QF;;EA01QA;IACE,wBAAA;EAx1QF;;EA21QA;IACE,wBAAA;EAz1QF;;EA41QA;IACE,qBAAA;EA11QF;;EA61QA;IACE,sBAAA;EA31QF;;EA81QA;IACE,wBAAA;EA51QF;;EA+1QA;IACE,yBAAA;EA71QF;;EAg2QA;IACE,yBAAA;EA91QF;;EAi2QA;IACE,yBAAA;EA/1QF;;EAk2QA;IACE,0BAAA;EAh2QF;;EAm2QA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EAj2QF;;EAo2QA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAl2QF;;EAq2QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn2QF;;EAs2QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp2QF;;EAu2QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr2QF;;EAw2QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt2QF;;EAy2QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv2QF;;EA02QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx2QF;;EA22QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAz2QF;;EA42QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA12QF;;EA62QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA32QF;;EA82QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA52QF;;EA+2QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA72QF;;EAg3QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA92QF;;EAi3QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/2QF;;EAk3QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh3QF;;EAm3QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAj3QF;;EAo3QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl3QF;;EAq3QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn3QF;;EAs3QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAp3QF;;EAu3QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr3QF;;EAw3QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt3QF;;EAy3QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv3QF;;EA03QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx3QF;;EA23QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz3QF;;EA43QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA13QF;;EA63QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA33QF;;EA83QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA53QF;;EA+3QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA73QF;;EAg4QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA93QF;;EAi4QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/3QF;;EAk4QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh4QF;;EAm4QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj4QF;;EAo4QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl4QF;;EAq4QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn4QF;;EAs4QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAp4QF;;EAu4QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAr4QF;;EAw4QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAt4QF;;EAy4QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv4QF;;EA04QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx4QF;;EA24QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz4QF;;EA44QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA14QF;;EA64QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA34QF;;EA84QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA54QF;;EA+4QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA74QF;;EAg5QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA94QF;;EAi5QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA/4QF;;EAk5QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh5QF;;EAm5QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj5QF;;EAo5QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl5QF;;EAq5QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn5QF;;EAs5QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAp5QF;;EAu5QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAr5QF;;EAw5QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAt5QF;;EAy5QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAv5QF;;EA05QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAx5QF;;EA25QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz5QF;;EA45QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA15QF;;EA65QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA35QF;;EA85QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA55QF;;EA+5QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA75QF;;EAg6QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA95QF;;EAi6QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/5QF;;EAk6QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAh6QF;;EAm6QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAj6QF;;EAo6QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl6QF;;EAq6QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn6QF;;EAs6QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp6QF;;EAu6QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr6QF;;EAw6QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt6QF;;EAy6QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAv6QF;;EA06QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAx6QF;;EA26QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAz6QF;;EA46QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA16QF;;EA66QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA36QF;;EA86QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA56QF;;EA+6QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA76QF;;EAg7QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA96QF;;EAi7QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/6QF;;EAk7QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAh7QF;;EAm7QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj7QF;;EAo7QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl7QF;;EAq7QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn7QF;;EAs7QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp7QF;;EAu7QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr7QF;;EAw7QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt7QF;;EAy7QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv7QF;;EA07QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx7QF;;EA27QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz7QF;;EA47QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA17QF;;EA67QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA37QF;;EA87QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA57QF;;EA+7QA;IACE,yBAAA;EA77QF;;EAg8QA;IACE,0BAAA;EA97QF;;EAi8QA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EA/7QF;;EAk8QA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAh8QF;;EAm8QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj8QF;;EAo8QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl8QF;;EAq8QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn8QF;;EAs8QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp8QF;;EAu8QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr8QF;;EAw8QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt8QF;;EAy8QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAv8QF;;EA08QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAx8QF;;EA28QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAz8QF;;EA48QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA18QF;;EA68QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA38QF;;EA88QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA58QF;;EA+8QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA78QF;;EAg9QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA98QF;;EAi9QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/8QF;;EAk9QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAh9QF;;EAm9QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAj9QF;;EAo9QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl9QF;;EAq9QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn9QF;;EAs9QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp9QF;;EAu9QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr9QF;;EAw9QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAt9QF;;EAy9QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAv9QF;;EA09QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx9QF;;EA29QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAz9QF;;EA49QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA19QF;;EA69QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA39QF;;EA89QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA59QF;;EA+9QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA79QF;;EAg+QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA99QF;;EAi+QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/9QF;;EAk+QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAh+QF;;EAm+QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj+QF;;EAo+QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl+QF;;EAq+QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn+QF;;EAs+QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAp+QF;;EAu+QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr+QF;;EAw+QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt+QF;;EAy+QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv+QF;;EA0+QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx+QF;;EA2+QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz+QF;;EA4+QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1+QF;;EA6+QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3+QF;;EA8+QA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5+QF;;EA++QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA7+QF;;EAg/QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9+QF;;EAi/QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/+QF;;EAk/QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh/QF;;EAm/QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj/QF;;EAo/QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl/QF;;EAq/QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn/QF;;EAs/QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAp/QF;;EAu/QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAr/QF;;EAw/QA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAt/QF;;EAy/QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv/QF;;EA0/QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx/QF;;EA2/QA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz/QF;;EA4/QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1/QF;;EA6/QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3/QF;;EA8/QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5/QF;;EA+/QA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7/QF;;EAggRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9/QF;;EAigRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA//QF;;EAkgRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhgRF;;EAmgRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjgRF;;EAogRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlgRF;;EAqgRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAngRF;;EAsgRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApgRF;;EAugRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArgRF;;EAwgRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtgRF;;EAygRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvgRF;;EA0gRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxgRF;;EA2gRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzgRF;;EA4gRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1gRF;;EA6gRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3gRF;;EA8gRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5gRF;;EA+gRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7gRF;;EAghRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9gRF;;EAihRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/gRF;;EAkhRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhhRF;;EAmhRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjhRF;;EAohRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlhRF;;EAqhRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnhRF;;EAshRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAphRF;;EAuhRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArhRF;;EAwhRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAthRF;;EAyhRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvhRF;;EA0hRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxhRF;;EA2hRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzhRF;;EA4hRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1hRF;;EA6hRA;IACE,yBAAA;EA3hRF;;EA8hRA;IACE,0BAAA;EA5hRF;;EA+hRA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EA7hRF;;EAgiRA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EA9hRF;;EAiiRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/hRF;;EAkiRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhiRF;;EAmiRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjiRF;;EAoiRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAliRF;;EAqiRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAniRF;;EAsiRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApiRF;;EAuiRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAriRF;;EAwiRA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAtiRF;;EAyiRA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAviRF;;EA0iRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxiRF;;EA2iRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAziRF;;EA4iRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1iRF;;EA6iRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3iRF;;EA8iRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5iRF;;EA+iRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7iRF;;EAgjRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9iRF;;EAijRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/iRF;;EAkjRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhjRF;;EAmjRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjjRF;;EAojRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAljRF;;EAqjRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnjRF;;EAsjRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApjRF;;EAujRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArjRF;;EAwjRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtjRF;;EAyjRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvjRF;;EA0jRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxjRF;;EA2jRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzjRF;;EA4jRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1jRF;;EA6jRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3jRF;;EA8jRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5jRF;;EA+jRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7jRF;;EAgkRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9jRF;;EAikRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/jRF;;EAkkRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhkRF;;EAmkRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjkRF;;EAokRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAlkRF;;EAqkRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnkRF;;EAskRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApkRF;;EAukRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArkRF;;EAwkRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtkRF;;EAykRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvkRF;;EA0kRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxkRF;;EA2kRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzkRF;;EA4kRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1kRF;;EA6kRA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA3kRF;;EA8kRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5kRF;;EA+kRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7kRF;;EAglRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9kRF;;EAilRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/kRF;;EAklRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhlRF;;EAmlRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjlRF;;EAolRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAllRF;;EAqlRA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAnlRF;;EAslRA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAplRF;;EAulRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArlRF;;EAwlRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtlRF;;EAylRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvlRF;;EA0lRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxlRF;;EA2lRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzlRF;;EA4lRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1lRF;;EA6lRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3lRF;;EA8lRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5lRF;;EA+lRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7lRF;;EAgmRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9lRF;;EAimRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/lRF;;EAkmRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhmRF;;EAmmRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjmRF;;EAomRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlmRF;;EAqmRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnmRF;;EAsmRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EApmRF;;EAumRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EArmRF;;EAwmRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAtmRF;;EAymRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvmRF;;EA0mRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxmRF;;EA2mRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzmRF;;EA4mRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1mRF;;EA6mRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3mRF;;EA8mRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5mRF;;EA+mRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7mRF;;EAgnRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9mRF;;EAinRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/mRF;;EAknRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhnRF;;EAmnRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjnRF;;EAonRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlnRF;;EAqnRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnnRF;;EAsnRA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApnRF;;EAunRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArnRF;;EAwnRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtnRF;;EAynRA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvnRF;;EA0nRA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxnRF;;EA2nRA;IACE,mBAAA;EAznRF;;EA4nRA;IACE,sBAAA;EA1nRF;;EA6nRA;IACE,qBAAA;EA3nRF;;EA8nRA;IACE,sBAAA;EA5nRF;;EA+nRA;IACE,mBAAA;EA7nRF;;EAgoRA;IACE,mBAAA;EA9nRF;;EAioRA;IACE,sBAAA;EA/nRF;;EAkoRA;IACE,qBAAA;EAhoRF;;EAmoRA;IACE,sBAAA;EAjoRF;;EAooRA;IACE,mBAAA;EAloRF;;EAqoRA;IACE,mBAAA;EAnoRF;;EAsoRA;IACE,sBAAA;EApoRF;;EAuoRA;IACE,qBAAA;EAroRF;;EAwoRA;IACE,sBAAA;EAtoRF;;EAyoRA;IACE,mBAAA;EAvoRF;;EA0oRA;IACE,gBAAA;EAxoRF;;EA2oRA;IACE,uBAAA;EAzoRF;;EA4oRA;IACE,sBAAA;EA1oRF;;EA6oRA;IACE,uBAAA;EA3oRF;;EA8oRA;IACE,qBAAA;EA5oRF;;EA+oRA;IACE,sBAAA;EA7oRF;;EAgpRA;IACE,mBAAA;EA9oRF;;EAipRA;IACE,qBAAA;EA/oRF;;EAkpRA;IACE,qBAAA;EAhpRF;;EAmpRA;IACE,yBAAA;IACA,0BAAA;EAjpRF;;EAopRA;IACE,0BAAA;IACA,6BAAA;EAlpRF;;EAqpRA;IACE,6BAAA;IACA,4BAAA;EAnpRF;;EAspRA;IACE,yBAAA;IACA,4BAAA;EAppRF;;EAupRA;IACE,gCAAA;IACA,iCAAA;EArpRF;;EAwpRA;IACE,iCAAA;IACA,oCAAA;EAtpRF;;EAypRA;IACE,oCAAA;IACA,mCAAA;EAvpRF;;EA0pRA;IACE,gCAAA;IACA,mCAAA;EAxpRF;;EA2pRA;IACE,+BAAA;IACA,gCAAA;EAzpRF;;EA4pRA;IACE,gCAAA;IACA,mCAAA;EA1pRF;;EA6pRA;IACE,mCAAA;IACA,kCAAA;EA3pRF;;EA8pRA;IACE,+BAAA;IACA,kCAAA;EA5pRF;;EA+pRA;IACE,gCAAA;IACA,iCAAA;EA7pRF;;EAgqRA;IACE,iCAAA;IACA,oCAAA;EA9pRF;;EAiqRA;IACE,oCAAA;IACA,mCAAA;EA/pRF;;EAkqRA;IACE,gCAAA;IACA,mCAAA;EAhqRF;;EAmqRA;IACE,8BAAA;IACA,+BAAA;EAjqRF;;EAoqRA;IACE,+BAAA;IACA,kCAAA;EAlqRF;;EAqqRA;IACE,kCAAA;IACA,iCAAA;EAnqRF;;EAsqRA;IACE,8BAAA;IACA,iCAAA;EApqRF;;EAuqRA;IACE,+BAAA;IACA,gCAAA;EArqRF;;EAwqRA;IACE,gCAAA;IACA,mCAAA;EAtqRF;;EAyqRA;IACE,mCAAA;IACA,kCAAA;EAvqRF;;EA0qRA;IACE,+BAAA;IACA,kCAAA;EAxqRF;;EA2qRA;IACE,4BAAA;IACA,6BAAA;EAzqRF;;EA4qRA;IACE,6BAAA;IACA,gCAAA;EA1qRF;;EA6qRA;IACE,gCAAA;IACA,+BAAA;EA3qRF;;EA8qRA;IACE,4BAAA;IACA,+BAAA;EA5qRF;;EA+qRA;IACE,8BAAA;IACA,+BAAA;EA7qRF;;EAgrRA;IACE,+BAAA;IACA,kCAAA;EA9qRF;;EAirRA;IACE,kCAAA;IACA,iCAAA;EA/qRF;;EAkrRA;IACE,8BAAA;IACA,iCAAA;EAhrRF;;EAmrRA;IACE,8BAAA;IACA,+BAAA;EAjrRF;;EAorRA;IACE,+BAAA;IACA,kCAAA;EAlrRF;;EAqrRA;IACE,kCAAA;IACA,iCAAA;EAnrRF;;EAsrRA;IACE,8BAAA;IACA,iCAAA;EAprRF;;EAurRA;IACE,yBAAA;EArrRF;;EAwrRA;IACE,0BAAA;EAtrRF;;EAyrRA;IACE,6BAAA;EAvrRF;;EA0rRA;IACE,4BAAA;EAxrRF;;EA2rRA;IACE,gCAAA;EAzrRF;;EA4rRA;IACE,iCAAA;EA1rRF;;EA6rRA;IACE,oCAAA;EA3rRF;;EA8rRA;IACE,mCAAA;EA5rRF;;EA+rRA;IACE,+BAAA;EA7rRF;;EAgsRA;IACE,gCAAA;EA9rRF;;EAisRA;IACE,mCAAA;EA/rRF;;EAksRA;IACE,kCAAA;EAhsRF;;EAmsRA;IACE,gCAAA;EAjsRF;;EAosRA;IACE,iCAAA;EAlsRF;;EAqsRA;IACE,oCAAA;EAnsRF;;EAssRA;IACE,mCAAA;EApsRF;;EAusRA;IACE,8BAAA;EArsRF;;EAwsRA;IACE,+BAAA;EAtsRF;;EAysRA;IACE,kCAAA;EAvsRF;;EA0sRA;IACE,iCAAA;EAxsRF;;EA2sRA;IACE,+BAAA;EAzsRF;;EA4sRA;IACE,gCAAA;EA1sRF;;EA6sRA;IACE,mCAAA;EA3sRF;;EA8sRA;IACE,kCAAA;EA5sRF;;EA+sRA;IACE,4BAAA;EA7sRF;;EAgtRA;IACE,6BAAA;EA9sRF;;EAitRA;IACE,gCAAA;EA/sRF;;EAktRA;IACE,+BAAA;EAhtRF;;EAmtRA;IACE,8BAAA;EAjtRF;;EAotRA;IACE,+BAAA;EAltRF;;EAqtRA;IACE,kCAAA;EAntRF;;EAstRA;IACE,iCAAA;EAptRF;;EAutRA;IACE,8BAAA;EArtRF;;EAwtRA;IACE,+BAAA;EAttRF;;EAytRA;IACE,kCAAA;EAvtRF;;EA0tRA;IACE,iCAAA;EAxtRF;;EA2tRA;IACE,mBAAA;EAztRF;;EA4tRA;IACE,oBAAA;EA1tRF;;EA6tRA;IACE,oBAAA;EA3tRF;;EA8tRA;IACE,oBAAA;EA5tRF;;EA+tRA;IACE,kBAAA;EA7tRF;;EAguRA;IACE,eAAA;EA9tRF;;EAiuRA;IACE,iBAAA;EA/tRF;;EAkuRA;IACE,iBAAA;EAhuRF;;EAmuRA;IACE,iBAAA;EAjuRF;;EAouRA;IACE,iBAAA;EAluRF;;EAquRA;IACE,mBAAA;EAnuRF;;EAsuRA;IACE,qBAAA;EApuRF;;EAuuRA;IACE,sBAAA;EAruRF;;EAwuRA;IACE,oBAAA;EAtuRF;;EAyuRA;IACE,qBAAA;EAvuRF;;EA0uRA;IACE,uBAAA;EAxuRF;;EA2uRA;IACE,wBAAA;EAzuRF;;EA4uRA;IACE,sBAAA;EA1uRF;;EA6uRA;IACE,qBAAA;EA3uRF;;EA8uRA;IACE,uBAAA;EA5uRF;;EA+uRA;IACE,wBAAA;EA7uRF;;EAgvRA;IACE,sBAAA;EA9uRF;;EAivRA;IACE,qBAAA;EA/uRF;;EAkvRA;IACE,uBAAA;EAhvRF;;EAmvRA;IACE,wBAAA;EAjvRF;;EAovRA;IACE,sBAAA;EAlvRF;;EAqvRA;IACE,qBAAA;EAnvRF;;EAsvRA;IACE,uBAAA;EApvRF;;EAuvRA;IACE,wBAAA;EArvRF;;EAwvRA;IACE,sBAAA;EAtvRF;;EAyvRA;IACE,sBAAA;EAvvRF;;EA0vRA;IACE,uBAAA;EAxvRF;;EA2vRA;IACE,YAAA;EAzvRF;;EA4vRA;IACE,eAAA;EA1vRF;;EA6vRA;IACE,eAAA;EA3vRF;;EA8vRA;IACE,YAAA;EA5vRF;;EA+vRA;IACE,YAAA;EA7vRF;;EAgwRA;IACE,YAAA;EA9vRF;;EAiwRA;IACE,mBAAA;EA/vRF;;EAkwRA;IACE,cAAA;EAhwRF;;EAmwRA;IACE,qBAAA;EAjwRF;;EAowRA;IACE,eAAA;EAlwRF;;EAqwRA;IACE,aAAA;EAnwRF;;EAswRA;IACE,oBAAA;EApwRF;;EAuwRA;IACE,cAAA;EArwRF;;EAwwRA;IACE,sBAAA;EAtwRF;;EAywRA;IACE,mBAAA;EAvwRF;;EA0wRA;IACE,qBAAA;EAxwRF;;EA2wRA;IACE,2BAAA;EAzwRF;;EA4wRA;IACE,2BAAA;EA1wRF;;EA6wRA;IACE,2BAAA;EA3wRF;;EA8wRA;IACE,wBAAA;EA5wRF;;EA+wRA;IACE,kBAAA;EA7wRF;;EAgxRA;IACE,kBAAA;EA9wRF;;EAixRA;IACE,aAAA;EA/wRF;;EAkxRA;IACE,oBAAA;EAhxRF;;EAmxRA;IACE,iBAAA;EAjxRF;;EAoxRA;IACE,aAAA;EAlxRF;;EAqxRA;IACE,mBAAA;EAnxRF;;EAsxRA;IACE,2BAAA;EApxRF;;EAuxRA;IACE,sBAAA;EArxRF;;EAwxRA;IACE,8BAAA;EAtxRF;;EAyxRA;IACE,eAAA;EAvxRF;;EA0xRA;IACE,uBAAA;EAxxRF;;EA2xRA;IACE,iBAAA;EAzxRF;;EA4xRA;IACE,iBAAA;EA1xRF;;EA6xRA;IACE,kBAAA;EA3xRF;;EA8xRA;IACE,gBAAA;EA5xRF;;EA+xRA;IACE,mBAAA;EA7xRF;;EAgyRA;IACE,oBAAA;EA9xRF;;EAiyRA;IACE,qBAAA;EA/xRF;;EAkyRA;IACE,oBAAA;EAhyRF;;EAmyRA;IACE,kBAAA;EAjyRF;;EAoyRA;IACE,4BAAA;EAlyRF;;EAqyRA;IACE,2BAAA;EAnyRF;;EAsyRA;IACE,2BAAA;EApyRF;;EAuyRA;IACE,sBAAA;EAryRF;;EAwyRA;IACE,gBAAA;EAtyRF;;EAyyRA;IACE,iBAAA;EAvyRF;;EA0yRA;IACE,eAAA;EAxyRF;;EA2yRA;IACE,kBAAA;EAzyRF;;EA4yRA;IACE,mBAAA;EA1yRF;;EA6yRA;IACE,uBAAA;EA3yRF;;EA8yRA;IACE,qBAAA;EA5yRF;;EA+yRA;IACE,mBAAA;EA7yRF;;EAgzRA;IACE,qBAAA;EA9yRF;;EAizRA;IACE,oBAAA;EA/yRF;;EAkzRA;IACE,qBAAA;EAhzRF;;EAmzRA;IACE,yBAAA;EAjzRF;;EAozRA;IACE,uBAAA;EAlzRF;;EAqzRA;IACE,4BAAA;EAnzRF;;EAszRA;IACE,2BAAA;EApzRF;;EAuzRA;IACE,2BAAA;EArzRF;;EAwzRA;IACE,gBAAA;EAtzRF;;EAyzRA;IACE,sBAAA;EAvzRF;;EA0zRA;IACE,oBAAA;EAxzRF;;EA2zRA;IACE,kBAAA;EAzzRF;;EA4zRA;IACE,mBAAA;EA1zRF;;EA6zRA;IACE,mBAAA;EA3zRF;;EA8zRA;IACE,oBAAA;EA5zRF;;EA+zRA;IACE,kBAAA;EA7zRF;;EAg0RA;IACE,qBAAA;EA9zRF;;EAi0RA;IACE,sBAAA;EA/zRF;;EAk0RA;IACE,2BAAA;EAh0RF;;EAm0RA;IACE,yBAAA;EAj0RF;;EAo0RA;IACE,uBAAA;EAl0RF;;EAq0RA;IACE,8BAAA;EAn0RF;;EAs0RA;IACE,6BAAA;EAp0RF;;EAu0RA;IACE,6BAAA;EAr0RF;;EAw0RA;IACE,kBAAA;EAt0RF;;EAy0RA;IACE,mBAAA;EAv0RF;;EA00RA;IACE,iBAAA;EAx0RF;;EA20RA;IACE,oBAAA;EAz0RF;;EA40RA;IACE,qBAAA;EA10RF;;EA60RA;IACE,SAAA;EA30RF;;EA80RA;IACE,cAAA;EA50RF;;EA+0RA;IACE,cAAA;EA70RF;;EAg1RA;IACE,UAAA;EA90RF;;EAi1RA;IACE,YAAA;EA/0RF;;EAk1RA;IACE,YAAA;EAh1RF;;EAm1RA;IACE,cAAA;EAj1RF;;EAo1RA;IACE,cAAA;EAl1RF;;EAq1RA;IACE,QAAA;EAn1RF;;EAs1RA;IACE,QAAA;EAp1RF;;EAu1RA;IACE,QAAA;EAr1RF;;EAw1RA;IACE,QAAA;EAt1RF;;EAy1RA;IACE,QAAA;EAv1RF;;EA01RA;IACE,QAAA;EAx1RF;;EA21RA;IACE,QAAA;EAz1RF;;EA41RA;IACE,QAAA;EA11RF;;EA61RA;IACE,QAAA;EA31RF;;EA81RA;IACE,SAAA;EA51RF;;EA+1RA;IACE,SAAA;EA71RF;;EAg2RA;IACE,SAAA;EA91RF;;EAi2RA;IACE,YAAA;EA/1RF;;EAk2RA;IACE,WAAA;EAh2RF;;EAm2RA;IACE,QAAA;EAj2RF;;EAo2RA;IACE,YAAA;EAl2RF;;EAq2RA;IACE,WAAA;EAn2RF;;EAs2RA;IACE,WAAA;EAp2RF;;EAu2RA;IACE,WAAA;IACA,cAAA;IACA,WAAA;EAr2RF;;EAw2RA;IACE,WAAA;EAt2RF;;EAy2RA;IACE,YAAA;EAv2RF;;EA02RA;IACE,WAAA;EAx2RF;;EA22RA;IACE,WAAA;EAz2RF;;EA42RA;IACE,6MAAA;EA12RF;;EA62RA;IACE,8DAAA;EA32RF;;EA82RA;IACE,iFAAA;EA52RF;;EA+2RA;IACE,gBAAA;EA72RF;;EAg3RA;IACE,gBAAA;EA92RF;;EAi3RA;IACE,gBAAA;EA/2RF;;EAk3RA;IACE,gBAAA;EAh3RF;;EAm3RA;IACE,gBAAA;EAj3RF;;EAo3RA;IACE,gBAAA;EAl3RF;;EAq3RA;IACE,gBAAA;EAn3RF;;EAs3RA;IACE,gBAAA;EAp3RF;;EAu3RA;IACE,gBAAA;EAr3RF;;EAw3RA;IACE,gBAAA;EAt3RF;;EAy3RA;IACE,gBAAA;EAv3RF;;EA03RA;IACE,gBAAA;EAx3RF;;EA23RA;IACE,gBAAA;EAz3RF;;EA43RA;IACE,gBAAA;EA13RF;;EA63RA;IACE,gBAAA;EA33RF;;EA83RA;IACE,gBAAA;EA53RF;;EA+3RA;IACE,gBAAA;EA73RF;;EAg4RA;IACE,gBAAA;EA93RF;;EAi4RA;IACE,gBAAA;EA/3RF;;EAk4RA;IACE,gBAAA;EAh4RF;;EAm4RA;IACE,gBAAA;EAj4RF;;EAo4RA;IACE,gBAAA;EAl4RF;;EAq4RA;IACE,gBAAA;EAn4RF;;EAs4RA;IACE,gBAAA;EAp4RF;;EAu4RA;IACE,gBAAA;EAr4RF;;EAw4RA;IACE,gBAAA;EAt4RF;;EAy4RA;IACE,gBAAA;EAv4RF;;EA04RA;IACE,SAAA;EAx4RF;;EA24RA;IACE,eAAA;EAz4RF;;EA44RA;IACE,cAAA;EA14RF;;EA64RA;IACE,eAAA;EA34RF;;EA84RA;IACE,YAAA;EA54RF;;EA+4RA;IACE,eAAA;EA74RF;;EAg5RA;IACE,cAAA;EA94RF;;EAi5RA;IACE,YAAA;EA/4RF;;EAk5RA;IACE,cAAA;EAh5RF;;EAm5RA;IACE,YAAA;EAj5RF;;EAo5RA;IACE,YAAA;EAl5RF;;EAq5RA;IACE,YAAA;EAn5RF;;EAs5RA;IACE,YAAA;EAp5RF;;EAu5RA;IACE,YAAA;EAr5RF;;EAw5RA;IACE,aAAA;EAt5RF;;EAy5RA;IACE,aAAA;EAv5RF;;EA05RA;IACE,aAAA;EAx5RF;;EA25RA;IACE,aAAA;EAz5RF;;EA45RA;IACE,YAAA;EA15RF;;EA65RA;IACE,WAAA;EA35RF;;EA85RA;IACE,YAAA;EA55RF;;EA+5RA;IACE,aAAA;EA75RF;;EAg6RA;IACE,oBAAA;EA95RF;;EAi6RA;IACE,kBAAA;EA/5RF;;EAk6RA;IACE,mBAAA;EAh6RF;;EAm6RA;IACE,eAAA;EAj6RF;;EAo6RA;IACE,mBAAA;EAl6RF;;EAq6RA;IACE,kBAAA;EAn6RF;;EAs6RA;IACE,mBAAA;EAp6RF;;EAu6RA;IACE,iBAAA;EAr6RF;;EAw6RA;IACE,mBAAA;EAt6RF;;EAy6RA;IACE,kBAAA;EAv6RF;;EA06RA;IACE,eAAA;EAx6RF;;EA26RA;IACE,eAAA;EAz6RF;;EA46RA;IACE,oBAAA;EA16RF;;EA66RA;IACE,iBAAA;EA36RF;;EA86RA;IACE,oBAAA;EA56RF;;EA+6RA;IACE,mBAAA;EA76RF;;EAg7RA;IACE,oBAAA;EA96RF;;EAi7RA;IACE,iBAAA;EA/6RF;;EAk7RA;IACE,oBAAA;EAh7RF;;EAm7RA;IACE,mBAAA;EAj7RF;;EAo7RA;IACE,cAAA;EAl7RF;;EAq7RA;IACE,iBAAA;EAn7RF;;EAs7RA;IACE,kBAAA;EAp7RF;;EAu7RA;IACE,gBAAA;EAr7RF;;EAw7RA;IACE,kBAAA;EAt7RF;;EAy7RA;IACE,cAAA;EAv7RF;;EA07RA;IACE,2BAAA;EAx7RF;;EA27RA;IACE,4BAAA;EAz7RF;;EA47RA;IACE,qBAAA;EA17RF;;EA67RA;IACE,qBAAA;EA37RF;;EA87RA;IACE,wBAAA;EA57RF;;EA+7RA;IACE,SAAA;EA77RF;;EAg8RA;IACE,eAAA;EA97RF;;EAi8RA;IACE,cAAA;EA/7RF;;EAk8RA;IACE,eAAA;EAh8RF;;EAm8RA;IACE,YAAA;EAj8RF;;EAo8RA;IACE,eAAA;EAl8RF;;EAq8RA;IACE,cAAA;EAn8RF;;EAs8RA;IACE,YAAA;EAp8RF;;EAu8RA;IACE,cAAA;EAr8RF;;EAw8RA;IACE,YAAA;EAt8RF;;EAy8RA;IACE,YAAA;EAv8RF;;EA08RA;IACE,YAAA;EAx8RF;;EA28RA;IACE,YAAA;EAz8RF;;EA48RA;IACE,YAAA;EA18RF;;EA68RA;IACE,aAAA;EA38RF;;EA88RA;IACE,aAAA;EA58RF;;EA+8RA;IACE,aAAA;EA78RF;;EAg9RA;IACE,aAAA;EA98RF;;EAi9RA;IACE,YAAA;EA/8RF;;EAk9RA;IACE,WAAA;EAh9RF;;EAm9RA;IACE,gBAAA;EAj9RF;;EAo9RA;IACE,eAAA;EAl9RF;;EAq9RA;IACE,gBAAA;EAn9RF;;EAs9RA;IACE,aAAA;EAp9RF;;EAu9RA;IACE,gBAAA;EAr9RF;;EAw9RA;IACE,eAAA;EAt9RF;;EAy9RA;IACE,aAAA;EAv9RF;;EA09RA;IACE,eAAA;EAx9RF;;EA29RA;IACE,aAAA;EAz9RF;;EA49RA;IACE,aAAA;EA19RF;;EA69RA;IACE,aAAA;EA39RF;;EA89RA;IACE,aAAA;EA59RF;;EA+9RA;IACE,aAAA;EA79RF;;EAg+RA;IACE,cAAA;EA99RF;;EAi+RA;IACE,cAAA;EA/9RF;;EAk+RA;IACE,cAAA;EAh+RF;;EAm+RA;IACE,cAAA;EAj+RF;;EAo+RA;IACE,YAAA;EAl+RF;;EAq+RA;IACE,aAAA;IACA,gBAAA;EAn+RF;;EAs+RA;IACE,cAAA;IACA,eAAA;EAp+RF;;EAu+RA;IACE,mBAAA;IACA,sBAAA;EAr+RF;;EAw+RA;IACE,oBAAA;IACA,qBAAA;EAt+RF;;EAy+RA;IACE,kBAAA;IACA,qBAAA;EAv+RF;;EA0+RA;IACE,mBAAA;IACA,oBAAA;EAx+RF;;EA2+RA;IACE,mBAAA;IACA,sBAAA;EAz+RF;;EA4+RA;IACE,oBAAA;IACA,qBAAA;EA1+RF;;EA6+RA;IACE,gBAAA;IACA,mBAAA;EA3+RF;;EA8+RA;IACE,iBAAA;IACA,kBAAA;EA5+RF;;EA++RA;IACE,mBAAA;IACA,sBAAA;EA7+RF;;EAg/RA;IACE,oBAAA;IACA,qBAAA;EA9+RF;;EAi/RA;IACE,kBAAA;IACA,qBAAA;EA/+RF;;EAk/RA;IACE,mBAAA;IACA,oBAAA;EAh/RF;;EAm/RA;IACE,gBAAA;IACA,mBAAA;EAj/RF;;EAo/RA;IACE,iBAAA;IACA,kBAAA;EAl/RF;;EAq/RA;IACE,kBAAA;IACA,qBAAA;EAn/RF;;EAs/RA;IACE,mBAAA;IACA,oBAAA;EAp/RF;;EAu/RA;IACE,gBAAA;IACA,mBAAA;EAr/RF;;EAw/RA;IACE,iBAAA;IACA,kBAAA;EAt/RF;;EAy/RA;IACE,gBAAA;IACA,mBAAA;EAv/RF;;EA0/RA;IACE,iBAAA;IACA,kBAAA;EAx/RF;;EA2/RA;IACE,gBAAA;IACA,mBAAA;EAz/RF;;EA4/RA;IACE,iBAAA;IACA,kBAAA;EA1/RF;;EA6/RA;IACE,gBAAA;IACA,mBAAA;EA3/RF;;EA8/RA;IACE,iBAAA;IACA,kBAAA;EA5/RF;;EA+/RA;IACE,gBAAA;IACA,mBAAA;EA7/RF;;EAggSA;IACE,iBAAA;IACA,kBAAA;EA9/RF;;EAigSA;IACE,iBAAA;IACA,oBAAA;EA//RF;;EAkgSA;IACE,kBAAA;IACA,mBAAA;EAhgSF;;EAmgSA;IACE,iBAAA;IACA,oBAAA;EAjgSF;;EAogSA;IACE,kBAAA;IACA,mBAAA;EAlgSF;;EAqgSA;IACE,iBAAA;IACA,oBAAA;EAngSF;;EAsgSA;IACE,kBAAA;IACA,mBAAA;EApgSF;;EAugSA;IACE,iBAAA;IACA,oBAAA;EArgSF;;EAwgSA;IACE,kBAAA;IACA,mBAAA;EAtgSF;;EAygSA;IACE,gBAAA;IACA,mBAAA;EAvgSF;;EA0gSA;IACE,iBAAA;IACA,kBAAA;EAxgSF;;EA2gSA;IACE,eAAA;IACA,kBAAA;EAzgSF;;EA4gSA;IACE,gBAAA;IACA,iBAAA;EA1gSF;;EA6gSA;IACE,oBAAA;IACA,uBAAA;EA3gSF;;EA8gSA;IACE,qBAAA;IACA,sBAAA;EA5gSF;;EA+gSA;IACE,mBAAA;IACA,sBAAA;EA7gSF;;EAghSA;IACE,oBAAA;IACA,qBAAA;EA9gSF;;EAihSA;IACE,oBAAA;IACA,uBAAA;EA/gSF;;EAkhSA;IACE,qBAAA;IACA,sBAAA;EAhhSF;;EAmhSA;IACE,iBAAA;IACA,oBAAA;EAjhSF;;EAohSA;IACE,kBAAA;IACA,mBAAA;EAlhSF;;EAqhSA;IACE,oBAAA;IACA,uBAAA;EAnhSF;;EAshSA;IACE,qBAAA;IACA,sBAAA;EAphSF;;EAuhSA;IACE,mBAAA;IACA,sBAAA;EArhSF;;EAwhSA;IACE,oBAAA;IACA,qBAAA;EAthSF;;EAyhSA;IACE,iBAAA;IACA,oBAAA;EAvhSF;;EA0hSA;IACE,kBAAA;IACA,mBAAA;EAxhSF;;EA2hSA;IACE,mBAAA;IACA,sBAAA;EAzhSF;;EA4hSA;IACE,oBAAA;IACA,qBAAA;EA1hSF;;EA6hSA;IACE,iBAAA;IACA,oBAAA;EA3hSF;;EA8hSA;IACE,kBAAA;IACA,mBAAA;EA5hSF;;EA+hSA;IACE,iBAAA;IACA,oBAAA;EA7hSF;;EAgiSA;IACE,kBAAA;IACA,mBAAA;EA9hSF;;EAiiSA;IACE,iBAAA;IACA,oBAAA;EA/hSF;;EAkiSA;IACE,kBAAA;IACA,mBAAA;EAhiSF;;EAmiSA;IACE,iBAAA;IACA,oBAAA;EAjiSF;;EAoiSA;IACE,kBAAA;IACA,mBAAA;EAliSF;;EAqiSA;IACE,iBAAA;IACA,oBAAA;EAniSF;;EAsiSA;IACE,kBAAA;IACA,mBAAA;EApiSF;;EAuiSA;IACE,kBAAA;IACA,qBAAA;EAriSF;;EAwiSA;IACE,mBAAA;IACA,oBAAA;EAtiSF;;EAyiSA;IACE,kBAAA;IACA,qBAAA;EAviSF;;EA0iSA;IACE,mBAAA;IACA,oBAAA;EAxiSF;;EA2iSA;IACE,kBAAA;IACA,qBAAA;EAziSF;;EA4iSA;IACE,mBAAA;IACA,oBAAA;EA1iSF;;EA6iSA;IACE,kBAAA;IACA,qBAAA;EA3iSF;;EA8iSA;IACE,mBAAA;IACA,oBAAA;EA5iSF;;EA+iSA;IACE,gBAAA;IACA,mBAAA;EA7iSF;;EAgjSA;IACE,iBAAA;IACA,kBAAA;EA9iSF;;EAijSA;IACE,aAAA;EA/iSF;;EAkjSA;IACE,eAAA;EAhjSF;;EAmjSA;IACE,gBAAA;EAjjSF;;EAojSA;IACE,cAAA;EAljSF;;EAqjSA;IACE,mBAAA;EAnjSF;;EAsjSA;IACE,qBAAA;EApjSF;;EAujSA;IACE,sBAAA;EArjSF;;EAwjSA;IACE,oBAAA;EAtjSF;;EAyjSA;IACE,kBAAA;EAvjSF;;EA0jSA;IACE,oBAAA;EAxjSF;;EA2jSA;IACE,qBAAA;EAzjSF;;EA4jSA;IACE,mBAAA;EA1jSF;;EA6jSA;IACE,mBAAA;EA3jSF;;EA8jSA;IACE,qBAAA;EA5jSF;;EA+jSA;IACE,sBAAA;EA7jSF;;EAgkSA;IACE,oBAAA;EA9jSF;;EAikSA;IACE,gBAAA;EA/jSF;;EAkkSA;IACE,kBAAA;EAhkSF;;EAmkSA;IACE,mBAAA;EAjkSF;;EAokSA;IACE,iBAAA;EAlkSF;;EAqkSA;IACE,mBAAA;EAnkSF;;EAskSA;IACE,qBAAA;EApkSF;;EAukSA;IACE,sBAAA;EArkSF;;EAwkSA;IACE,oBAAA;EAtkSF;;EAykSA;IACE,kBAAA;EAvkSF;;EA0kSA;IACE,oBAAA;EAxkSF;;EA2kSA;IACE,qBAAA;EAzkSF;;EA4kSA;IACE,mBAAA;EA1kSF;;EA6kSA;IACE,gBAAA;EA3kSF;;EA8kSA;IACE,kBAAA;EA5kSF;;EA+kSA;IACE,mBAAA;EA7kSF;;EAglSA;IACE,iBAAA;EA9kSF;;EAilSA;IACE,kBAAA;EA/kSF;;EAklSA;IACE,oBAAA;EAhlSF;;EAmlSA;IACE,qBAAA;EAjlSF;;EAolSA;IACE,mBAAA;EAllSF;;EAqlSA;IACE,gBAAA;EAnlSF;;EAslSA;IACE,kBAAA;EAplSF;;EAulSA;IACE,mBAAA;EArlSF;;EAwlSA;IACE,iBAAA;EAtlSF;;EAylSA;IACE,gBAAA;EAvlSF;;EA0lSA;IACE,kBAAA;EAxlSF;;EA2lSA;IACE,mBAAA;EAzlSF;;EA4lSA;IACE,iBAAA;EA1lSF;;EA6lSA;IACE,gBAAA;EA3lSF;;EA8lSA;IACE,kBAAA;EA5lSF;;EA+lSA;IACE,mBAAA;EA7lSF;;EAgmSA;IACE,iBAAA;EA9lSF;;EAimSA;IACE,gBAAA;EA/lSF;;EAkmSA;IACE,kBAAA;EAhmSF;;EAmmSA;IACE,mBAAA;EAjmSF;;EAomSA;IACE,iBAAA;EAlmSF;;EAqmSA;IACE,gBAAA;EAnmSF;;EAsmSA;IACE,kBAAA;EApmSF;;EAumSA;IACE,mBAAA;EArmSF;;EAwmSA;IACE,iBAAA;EAtmSF;;EAymSA;IACE,iBAAA;EAvmSF;;EA0mSA;IACE,mBAAA;EAxmSF;;EA2mSA;IACE,oBAAA;EAzmSF;;EA4mSA;IACE,kBAAA;EA1mSF;;EA6mSA;IACE,iBAAA;EA3mSF;;EA8mSA;IACE,mBAAA;EA5mSF;;EA+mSA;IACE,oBAAA;EA7mSF;;EAgnSA;IACE,kBAAA;EA9mSF;;EAinSA;IACE,iBAAA;EA/mSF;;EAknSA;IACE,mBAAA;EAhnSF;;EAmnSA;IACE,oBAAA;EAjnSF;;EAonSA;IACE,kBAAA;EAlnSF;;EAqnSA;IACE,iBAAA;EAnnSF;;EAsnSA;IACE,mBAAA;EApnSF;;EAunSA;IACE,oBAAA;EArnSF;;EAwnSA;IACE,kBAAA;EAtnSF;;EAynSA;IACE,gBAAA;EAvnSF;;EA0nSA;IACE,kBAAA;EAxnSF;;EA2nSA;IACE,mBAAA;EAznSF;;EA4nSA;IACE,iBAAA;EA1nSF;;EA6nSA;IACE,eAAA;EA3nSF;;EA8nSA;IACE,iBAAA;EA5nSF;;EA+nSA;IACE,kBAAA;EA7nSF;;EAgoSA;IACE,gBAAA;EA9nSF;;EAioSA;IACE,oBAAA;EA/nSF;;EAkoSA;IACE,sBAAA;EAhoSF;;EAmoSA;IACE,uBAAA;EAjoSF;;EAooSA;IACE,qBAAA;EAloSF;;EAqoSA;IACE,mBAAA;EAnoSF;;EAsoSA;IACE,qBAAA;EApoSF;;EAuoSA;IACE,sBAAA;EAroSF;;EAwoSA;IACE,oBAAA;EAtoSF;;EAyoSA;IACE,oBAAA;EAvoSF;;EA0oSA;IACE,sBAAA;EAxoSF;;EA2oSA;IACE,uBAAA;EAzoSF;;EA4oSA;IACE,qBAAA;EA1oSF;;EA6oSA;IACE,iBAAA;EA3oSF;;EA8oSA;IACE,mBAAA;EA5oSF;;EA+oSA;IACE,oBAAA;EA7oSF;;EAgpSA;IACE,kBAAA;EA9oSF;;EAipSA;IACE,oBAAA;EA/oSF;;EAkpSA;IACE,sBAAA;EAhpSF;;EAmpSA;IACE,uBAAA;EAjpSF;;EAopSA;IACE,qBAAA;EAlpSF;;EAqpSA;IACE,mBAAA;EAnpSF;;EAspSA;IACE,qBAAA;EAppSF;;EAupSA;IACE,sBAAA;EArpSF;;EAwpSA;IACE,oBAAA;EAtpSF;;EAypSA;IACE,iBAAA;EAvpSF;;EA0pSA;IACE,mBAAA;EAxpSF;;EA2pSA;IACE,oBAAA;EAzpSF;;EA4pSA;IACE,kBAAA;EA1pSF;;EA6pSA;IACE,mBAAA;EA3pSF;;EA8pSA;IACE,qBAAA;EA5pSF;;EA+pSA;IACE,sBAAA;EA7pSF;;EAgqSA;IACE,oBAAA;EA9pSF;;EAiqSA;IACE,iBAAA;EA/pSF;;EAkqSA;IACE,mBAAA;EAhqSF;;EAmqSA;IACE,oBAAA;EAjqSF;;EAoqSA;IACE,kBAAA;EAlqSF;;EAqqSA;IACE,iBAAA;EAnqSF;;EAsqSA;IACE,mBAAA;EApqSF;;EAuqSA;IACE,oBAAA;EArqSF;;EAwqSA;IACE,kBAAA;EAtqSF;;EAyqSA;IACE,iBAAA;EAvqSF;;EA0qSA;IACE,mBAAA;EAxqSF;;EA2qSA;IACE,oBAAA;EAzqSF;;EA4qSA;IACE,kBAAA;EA1qSF;;EA6qSA;IACE,iBAAA;EA3qSF;;EA8qSA;IACE,mBAAA;EA5qSF;;EA+qSA;IACE,oBAAA;EA7qSF;;EAgrSA;IACE,kBAAA;EA9qSF;;EAirSA;IACE,iBAAA;EA/qSF;;EAkrSA;IACE,mBAAA;EAhrSF;;EAmrSA;IACE,oBAAA;EAjrSF;;EAorSA;IACE,kBAAA;EAlrSF;;EAqrSA;IACE,kBAAA;EAnrSF;;EAsrSA;IACE,oBAAA;EAprSF;;EAurSA;IACE,qBAAA;EArrSF;;EAwrSA;IACE,mBAAA;EAtrSF;;EAyrSA;IACE,kBAAA;EAvrSF;;EA0rSA;IACE,oBAAA;EAxrSF;;EA2rSA;IACE,qBAAA;EAzrSF;;EA4rSA;IACE,mBAAA;EA1rSF;;EA6rSA;IACE,kBAAA;EA3rSF;;EA8rSA;IACE,oBAAA;EA5rSF;;EA+rSA;IACE,qBAAA;EA7rSF;;EAgsSA;IACE,mBAAA;EA9rSF;;EAisSA;IACE,kBAAA;EA/rSF;;EAksSA;IACE,oBAAA;EAhsSF;;EAmsSA;IACE,qBAAA;EAjsSF;;EAosSA;IACE,mBAAA;EAlsSF;;EAqsSA;IACE,gBAAA;EAnsSF;;EAssSA;IACE,kBAAA;EApsSF;;EAusSA;IACE,mBAAA;EArsSF;;EAwsSA;IACE,iBAAA;EAtsSF;;EAysSA;IACE,gBAAA;EAvsSF;;EA0sSA;IACE,iBAAA;EAxsSF;;EA2sSA;IACE,eAAA;EAzsSF;;EA4sSA;IACE,gBAAA;EA1sSF;;EA6sSA;IACE,gBAAA;EA3sSF;;EA8sSA;IACE,gBAAA;EA5sSF;;EA+sSA;IACE,gBAAA;EA7sSF;;EAgtSA;IACE,gBAAA;EA9sSF;;EAitSA;IACE,gBAAA;EA/sSF;;EAktSA;IACE,gBAAA;EAhtSF;;EAmtSA;IACE,gBAAA;EAjtSF;;EAotSA;IACE,gBAAA;EAltSF;;EAqtSA;IACE,gBAAA;EAntSF;;EAstSA;IACE,eAAA;EAptSF;;EAutSA;IACE,gBAAA;EArtSF;;EAwtSA;IACE,gBAAA;EAttSF;;EAytSA;IACE,iBAAA;EAvtSF;;EA0tSA;IACE,iBAAA;EAxtSF;;EA2tSA;IACE,aAAA;EAztSF;;EA4tSA;IACE,gBAAA;EA1tSF;;EA6tSA;IACE,iBAAA;EA3tSF;;EA8tSA;IACE,YAAA;EA5tSF;;EA+tSA;IACE,eAAA;EA7tSF;;EAguSA;IACE,mBAAA;EA9tSF;;EAiuSA;IACE,iBAAA;EA/tSF;;EAkuSA;IACE,gBAAA;EAhuSF;;EAmuSA;IACE,gBAAA;EAjuSF;;EAouSA;IACE,sBAAA;EAluSF;;EAquSA;IACE,uBAAA;EAnuSF;;EAsuSA;IACE,uBAAA;EApuSF;;EAuuSA;IACE,qBAAA;EAruSF;;EAwuSA;IACE,4BAAA;EAtuSF;;EAyuSA;IACE,yBAAA;EAvuSF;;EA0uSA;IACE,sBAAA;EAxuSF;;EA2uSA;IACE,6BAAA;EAzuSF;;EA4uSA;IACE,0BAAA;EA1uSF;;EA6uSA;IACE,oBAAA;EA3uSF;;EA8uSA;IACE,UAAA;EA5uSF;;EA+uSA;IACE,aAAA;EA7uSF;;EAgvSA;IACE,YAAA;EA9uSF;;EAivSA;IACE,aAAA;EA/uSF;;EAkvSA;IACE,UAAA;EAhvSF;;EAmvSA;IACE,UAAA;EAjvSF;;EAovSA;IACE,aAAA;EAlvSF;;EAqvSA;IACE,YAAA;EAnvSF;;EAsvSA;IACE,aAAA;EApvSF;;EAuvSA;IACE,UAAA;EArvSF;;EAwvSA;IACE,UAAA;EAtvSF;;EAyvSA;IACE,aAAA;EAvvSF;;EA0vSA;IACE,YAAA;EAxvSF;;EA2vSA;IACE,aAAA;EAzvSF;;EA4vSA;IACE,UAAA;EA1vSF;;EA6vSA;IACE,8BAAA;IACA,mBAAA;EA3vSF;;EA8vSA;IACE,yBAAA;IACA,mBAAA;EA5vSF;;EA+vSA;IACE,yBAAA;IACA,mBAAA;EA7vSF;;EAgwSA;IACE,8BAAA;IACA,mBAAA;EA9vSF;;EAiwSA;IACE,yBAAA;IACA,mBAAA;EA/vSF;;EAkwSA;IACE,yBAAA;IACA,mBAAA;EAhwSF;;EAmwSA;IACE,cAAA;EAjwSF;;EAowSA;IACE,gBAAA;EAlwSF;;EAqwSA;IACE,iBAAA;EAnwSF;;EAswSA;IACE,gBAAA;EApwSF;;EAuwSA;IACE,gBAAA;EArwSF;;EAwwSA;IACE,gBAAA;EAtwSF;;EAywSA;IACE,kBAAA;EAvwSF;;EA0wSA;IACE,kBAAA;EAxwSF;;EA2wSA;IACE,mBAAA;EAzwSF;;EA4wSA;IACE,mBAAA;EA1wSF;;EA6wSA;IACE,kBAAA;EA3wSF;;EA8wSA;IACE,kBAAA;EA5wSF;;EA+wSA;IACE,iCAAA;EA7wSF;;EAgxSA;IACE,gCAAA;EA9wSF;;EAixSA;IACE,yBAAA;EA/wSF;;EAkxSA;IACE,4BAAA;EAhxSF;;EAmxSA;IACE,yBAAA;EAjxSF;;EAoxSA;IACE,2BAAA;EAlxSF;;EAqxSA;IACE,8BAAA;EAnxSF;;EAsxSA;IACE,2BAAA;EApxSF;;EAuxSA;IACE,2BAAA;EArxSF;;EAwxSA;IACE,8BAAA;EAtxSF;;EAyxSA;IACE,2BAAA;EAvxSF;;EA0xSA;IACE,UAAA;EAxxSF;;EA2xSA;IACE,gBAAA;EAzxSF;;EA4xSA;IACE,eAAA;EA1xSF;;EA6xSA;IACE,gBAAA;EA3xSF;;EA8xSA;IACE,aAAA;EA5xSF;;EA+xSA;IACE,gBAAA;EA7xSF;;EAgySA;IACE,eAAA;EA9xSF;;EAiySA;IACE,aAAA;EA/xSF;;EAkySA;IACE,eAAA;EAhySF;;EAmySA;IACE,aAAA;EAjySF;;EAoySA;IACE,aAAA;EAlySF;;EAqySA;IACE,aAAA;EAnySF;;EAsySA;IACE,aAAA;EApySF;;EAuySA;IACE,aAAA;EArySF;;EAwySA;IACE,cAAA;EAtySF;;EAyySA;IACE,cAAA;EAvySF;;EA0ySA;IACE,cAAA;EAxySF;;EA2ySA;IACE,cAAA;EAzySF;;EA4ySA;IACE,YAAA;EA1ySF;;EA6ySA;IACE,cAAA;IACA,iBAAA;EA3ySF;;EA8ySA;IACE,eAAA;IACA,gBAAA;EA5ySF;;EA+ySA;IACE,oBAAA;IACA,uBAAA;EA7ySF;;EAgzSA;IACE,qBAAA;IACA,sBAAA;EA9ySF;;EAizSA;IACE,mBAAA;IACA,sBAAA;EA/ySF;;EAkzSA;IACE,oBAAA;IACA,qBAAA;EAhzSF;;EAmzSA;IACE,oBAAA;IACA,uBAAA;EAjzSF;;EAozSA;IACE,qBAAA;IACA,sBAAA;EAlzSF;;EAqzSA;IACE,iBAAA;IACA,oBAAA;EAnzSF;;EAszSA;IACE,kBAAA;IACA,mBAAA;EApzSF;;EAuzSA;IACE,oBAAA;IACA,uBAAA;EArzSF;;EAwzSA;IACE,qBAAA;IACA,sBAAA;EAtzSF;;EAyzSA;IACE,mBAAA;IACA,sBAAA;EAvzSF;;EA0zSA;IACE,oBAAA;IACA,qBAAA;EAxzSF;;EA2zSA;IACE,iBAAA;IACA,oBAAA;EAzzSF;;EA4zSA;IACE,kBAAA;IACA,mBAAA;EA1zSF;;EA6zSA;IACE,mBAAA;IACA,sBAAA;EA3zSF;;EA8zSA;IACE,oBAAA;IACA,qBAAA;EA5zSF;;EA+zSA;IACE,iBAAA;IACA,oBAAA;EA7zSF;;EAg0SA;IACE,kBAAA;IACA,mBAAA;EA9zSF;;EAi0SA;IACE,iBAAA;IACA,oBAAA;EA/zSF;;EAk0SA;IACE,kBAAA;IACA,mBAAA;EAh0SF;;EAm0SA;IACE,iBAAA;IACA,oBAAA;EAj0SF;;EAo0SA;IACE,kBAAA;IACA,mBAAA;EAl0SF;;EAq0SA;IACE,iBAAA;IACA,oBAAA;EAn0SF;;EAs0SA;IACE,kBAAA;IACA,mBAAA;EAp0SF;;EAu0SA;IACE,iBAAA;IACA,oBAAA;EAr0SF;;EAw0SA;IACE,kBAAA;IACA,mBAAA;EAt0SF;;EAy0SA;IACE,kBAAA;IACA,qBAAA;EAv0SF;;EA00SA;IACE,mBAAA;IACA,oBAAA;EAx0SF;;EA20SA;IACE,kBAAA;IACA,qBAAA;EAz0SF;;EA40SA;IACE,mBAAA;IACA,oBAAA;EA10SF;;EA60SA;IACE,kBAAA;IACA,qBAAA;EA30SF;;EA80SA;IACE,mBAAA;IACA,oBAAA;EA50SF;;EA+0SA;IACE,kBAAA;IACA,qBAAA;EA70SF;;EAg1SA;IACE,mBAAA;IACA,oBAAA;EA90SF;;EAi1SA;IACE,gBAAA;IACA,mBAAA;EA/0SF;;EAk1SA;IACE,iBAAA;IACA,kBAAA;EAh1SF;;EAm1SA;IACE,cAAA;EAj1SF;;EAo1SA;IACE,gBAAA;EAl1SF;;EAq1SA;IACE,iBAAA;EAn1SF;;EAs1SA;IACE,eAAA;EAp1SF;;EAu1SA;IACE,oBAAA;EAr1SF;;EAw1SA;IACE,sBAAA;EAt1SF;;EAy1SA;IACE,uBAAA;EAv1SF;;EA01SA;IACE,qBAAA;EAx1SF;;EA21SA;IACE,mBAAA;EAz1SF;;EA41SA;IACE,qBAAA;EA11SF;;EA61SA;IACE,sBAAA;EA31SF;;EA81SA;IACE,oBAAA;EA51SF;;EA+1SA;IACE,oBAAA;EA71SF;;EAg2SA;IACE,sBAAA;EA91SF;;EAi2SA;IACE,uBAAA;EA/1SF;;EAk2SA;IACE,qBAAA;EAh2SF;;EAm2SA;IACE,iBAAA;EAj2SF;;EAo2SA;IACE,mBAAA;EAl2SF;;EAq2SA;IACE,oBAAA;EAn2SF;;EAs2SA;IACE,kBAAA;EAp2SF;;EAu2SA;IACE,oBAAA;EAr2SF;;EAw2SA;IACE,sBAAA;EAt2SF;;EAy2SA;IACE,uBAAA;EAv2SF;;EA02SA;IACE,qBAAA;EAx2SF;;EA22SA;IACE,mBAAA;EAz2SF;;EA42SA;IACE,qBAAA;EA12SF;;EA62SA;IACE,sBAAA;EA32SF;;EA82SA;IACE,oBAAA;EA52SF;;EA+2SA;IACE,iBAAA;EA72SF;;EAg3SA;IACE,mBAAA;EA92SF;;EAi3SA;IACE,oBAAA;EA/2SF;;EAk3SA;IACE,kBAAA;EAh3SF;;EAm3SA;IACE,mBAAA;EAj3SF;;EAo3SA;IACE,qBAAA;EAl3SF;;EAq3SA;IACE,sBAAA;EAn3SF;;EAs3SA;IACE,oBAAA;EAp3SF;;EAu3SA;IACE,iBAAA;EAr3SF;;EAw3SA;IACE,mBAAA;EAt3SF;;EAy3SA;IACE,oBAAA;EAv3SF;;EA03SA;IACE,kBAAA;EAx3SF;;EA23SA;IACE,iBAAA;EAz3SF;;EA43SA;IACE,mBAAA;EA13SF;;EA63SA;IACE,oBAAA;EA33SF;;EA83SA;IACE,kBAAA;EA53SF;;EA+3SA;IACE,iBAAA;EA73SF;;EAg4SA;IACE,mBAAA;EA93SF;;EAi4SA;IACE,oBAAA;EA/3SF;;EAk4SA;IACE,kBAAA;EAh4SF;;EAm4SA;IACE,iBAAA;EAj4SF;;EAo4SA;IACE,mBAAA;EAl4SF;;EAq4SA;IACE,oBAAA;EAn4SF;;EAs4SA;IACE,kBAAA;EAp4SF;;EAu4SA;IACE,iBAAA;EAr4SF;;EAw4SA;IACE,mBAAA;EAt4SF;;EAy4SA;IACE,oBAAA;EAv4SF;;EA04SA;IACE,kBAAA;EAx4SF;;EA24SA;IACE,kBAAA;EAz4SF;;EA44SA;IACE,oBAAA;EA14SF;;EA64SA;IACE,qBAAA;EA34SF;;EA84SA;IACE,mBAAA;EA54SF;;EA+4SA;IACE,kBAAA;EA74SF;;EAg5SA;IACE,oBAAA;EA94SF;;EAi5SA;IACE,qBAAA;EA/4SF;;EAk5SA;IACE,mBAAA;EAh5SF;;EAm5SA;IACE,kBAAA;EAj5SF;;EAo5SA;IACE,oBAAA;EAl5SF;;EAq5SA;IACE,qBAAA;EAn5SF;;EAs5SA;IACE,mBAAA;EAp5SF;;EAu5SA;IACE,kBAAA;EAr5SF;;EAw5SA;IACE,oBAAA;EAt5SF;;EAy5SA;IACE,qBAAA;EAv5SF;;EA05SA;IACE,mBAAA;EAx5SF;;EA25SA;IACE,gBAAA;EAz5SF;;EA45SA;IACE,kBAAA;EA15SF;;EA65SA;IACE,mBAAA;EA35SF;;EA85SA;IACE,iBAAA;EA55SF;;EA+5SA;IACE,kBAAA;EA75SF;;EAg6SA;IACE,mBAAA;EA95SF;;EAi6SA;IACE,wBAAA;IACA,WAAA;IACA,gDAAA;EA/5SF;;EAk6SA;IACE,wBAAA;IACA,WAAA;IACA,sDAAA;EAh6SF;;EAm6SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAj6SF;;EAo6SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl6SF;;EAq6SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn6SF;;EAs6SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp6SF;;EAu6SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr6SF;;EAw6SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt6SF;;EAy6SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAv6SF;;EA06SA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAx6SF;;EA26SA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAz6SF;;EA46SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA16SF;;EA66SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA36SF;;EA86SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA56SF;;EA+6SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA76SF;;EAg7SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA96SF;;EAi7SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/6SF;;EAk7SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAh7SF;;EAm7SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAj7SF;;EAo7SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAl7SF;;EAq7SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn7SF;;EAs7SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp7SF;;EAu7SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr7SF;;EAw7SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAt7SF;;EAy7SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAv7SF;;EA07SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAx7SF;;EA27SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAz7SF;;EA47SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA17SF;;EA67SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA37SF;;EA87SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA57SF;;EA+7SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA77SF;;EAg8SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA97SF;;EAi8SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/7SF;;EAk8SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAh8SF;;EAm8SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAj8SF;;EAo8SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAl8SF;;EAq8SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAn8SF;;EAs8SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAp8SF;;EAu8SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr8SF;;EAw8SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt8SF;;EAy8SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv8SF;;EA08SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAx8SF;;EA28SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAz8SF;;EA48SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA18SF;;EA68SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA38SF;;EA88SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA58SF;;EA+8SA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA78SF;;EAg9SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA98SF;;EAi9SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/8SF;;EAk9SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAh9SF;;EAm9SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAj9SF;;EAo9SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAl9SF;;EAq9SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAn9SF;;EAs9SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAp9SF;;EAu9SA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAr9SF;;EAw9SA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAt9SF;;EAy9SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv9SF;;EA09SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAx9SF;;EA29SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAz9SF;;EA49SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA19SF;;EA69SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA39SF;;EA89SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA59SF;;EA+9SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA79SF;;EAg+SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA99SF;;EAi+SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/9SF;;EAk+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAh+SF;;EAm+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAj+SF;;EAo+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl+SF;;EAq+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn+SF;;EAs+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp+SF;;EAu+SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAr+SF;;EAw+SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAt+SF;;EAy+SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAv+SF;;EA0+SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAx+SF;;EA2+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAz+SF;;EA4+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1+SF;;EA6+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3+SF;;EA8+SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5+SF;;EA++SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7+SF;;EAg/SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9+SF;;EAi/SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/+SF;;EAk/SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAh/SF;;EAm/SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAj/SF;;EAo/SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl/SF;;EAq/SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn/SF;;EAs/SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp/SF;;EAu/SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr/SF;;EAw/SA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt/SF;;EAy/SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAv/SF;;EA0/SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAx/SF;;EA2/SA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAz/SF;;EA4/SA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA1/SF;;EA6/SA;IACE,kBAAA;EA3/SF;;EA8/SA;IACE,mBAAA;EA5/SF;;EA+/SA;IACE,wBAAA;IACA,WAAA;IACA,gDAAA;EA7/SF;;EAggTA;IACE,wBAAA;IACA,WAAA;IACA,sDAAA;EA9/SF;;EAigTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA//SF;;EAkgTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhgTF;;EAmgTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjgTF;;EAogTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlgTF;;EAqgTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAngTF;;EAsgTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApgTF;;EAugTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EArgTF;;EAwgTA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAtgTF;;EAygTA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAvgTF;;EA0gTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxgTF;;EA2gTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAzgTF;;EA4gTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1gTF;;EA6gTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3gTF;;EA8gTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5gTF;;EA+gTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA7gTF;;EAghTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA9gTF;;EAihTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/gTF;;EAkhTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAhhTF;;EAmhTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjhTF;;EAohTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlhTF;;EAqhTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnhTF;;EAshTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAphTF;;EAuhTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EArhTF;;EAwhTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAthTF;;EAyhTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAvhTF;;EA0hTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAxhTF;;EA2hTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAzhTF;;EA4hTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1hTF;;EA6hTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3hTF;;EA8hTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5hTF;;EA+hTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA7hTF;;EAgiTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9hTF;;EAiiTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/hTF;;EAkiTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAhiTF;;EAmiTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAjiTF;;EAoiTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAliTF;;EAqiTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAniTF;;EAsiTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApiTF;;EAuiTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAriTF;;EAwiTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtiTF;;EAyiTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAviTF;;EA0iTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAxiTF;;EA2iTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAziTF;;EA4iTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA1iTF;;EA6iTA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA3iTF;;EA8iTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5iTF;;EA+iTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7iTF;;EAgjTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9iTF;;EAijTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/iTF;;EAkjTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAhjTF;;EAmjTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAjjTF;;EAojTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAljTF;;EAqjTA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAnjTF;;EAsjTA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EApjTF;;EAujTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArjTF;;EAwjTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtjTF;;EAyjTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvjTF;;EA0jTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAxjTF;;EA2jTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAzjTF;;EA4jTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1jTF;;EA6jTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA3jTF;;EA8jTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA5jTF;;EA+jTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA7jTF;;EAgkTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9jTF;;EAikTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/jTF;;EAkkTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhkTF;;EAmkTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjkTF;;EAokTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlkTF;;EAqkTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAnkTF;;EAskTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EApkTF;;EAukTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EArkTF;;EAwkTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAtkTF;;EAykTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAvkTF;;EA0kTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxkTF;;EA2kTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAzkTF;;EA4kTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1kTF;;EA6kTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3kTF;;EA8kTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA5kTF;;EA+kTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA7kTF;;EAglTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA9kTF;;EAilTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/kTF;;EAklTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhlTF;;EAmlTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjlTF;;EAolTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAllTF;;EAqlTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnlTF;;EAslTA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAplTF;;EAulTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EArlTF;;EAwlTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAtlTF;;EAylTA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAvlTF;;EA0lTA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAxlTF;;EA2lTA;IACE,wBAAA;EAzlTF;;EA4lTA;IACE,2BAAA;EA1lTF;;EA6lTA;IACE,0BAAA;EA3lTF;;EA8lTA;IACE,2BAAA;EA5lTF;;EA+lTA;IACE,wBAAA;EA7lTF;;EAgmTA;IACE,wBAAA;EA9lTF;;EAimTA;IACE,2BAAA;EA/lTF;;EAkmTA;IACE,0BAAA;EAhmTF;;EAmmTA;IACE,2BAAA;EAjmTF;;EAomTA;IACE,wBAAA;EAlmTF;;EAqmTA;IACE,oBAAA;EAnmTF;;EAsmTA;IACE,oBAAA;EApmTF;;EAumTA;IACE,gBAAA;EArmTF;;EAwmTA;IACE,eAAA;EAtmTF;;EAymTA;IACE,kBAAA;EAvmTF;;EA0mTA;IACE,kBAAA;EAxmTF;;EA2mTA;IACE,gBAAA;EAzmTF;;EA4mTA;IACE,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;EA1mTF;;EA6mTA;IACE,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EA3mTF;;EA8mTA;IACE,MAAA;IACA,SAAA;EA5mTF;;EA+mTA;IACE,QAAA;IACA,OAAA;EA7mTF;;EAgnTA;IACE,SAAA;IACA,YAAA;EA9mTF;;EAinTA;IACE,WAAA;IACA,UAAA;EA/mTF;;EAknTA;IACE,MAAA;EAhnTF;;EAmnTA;IACE,QAAA;EAjnTF;;EAonTA;IACE,SAAA;EAlnTF;;EAqnTA;IACE,OAAA;EAnnTF;;EAsnTA;IACE,SAAA;EApnTF;;EAunTA;IACE,WAAA;EArnTF;;EAwnTA;IACE,YAAA;EAtnTF;;EAynTA;IACE,UAAA;EAvnTF;;EA0nTA;IACE,YAAA;EAxnTF;;EA2nTA;IACE,gBAAA;EAznTF;;EA4nTA;IACE,kBAAA;EA1nTF;;EA6nTA;IACE,YAAA;EA3nTF;;EA8nTA;IACE,yCAAA;EA5nTF;;EA+nTA;IACE,2CAAA;EA7nTF;;EAgoTA;IACE,2EAAA;EA9nTF;;EAioTA;IACE,iFAAA;EA/nTF;;EAkoTA;IACE,mFAAA;EAhoTF;;EAmoTA;IACE,qFAAA;EAjoTF;;EAooTA;IACE,iDAAA;EAloTF;;EAqoTA;IACE,iDAAA;EAnoTF;;EAsoTA;IACE,6CAAA;EApoTF;;EAuoTA;IACE,gBAAA;EAroTF;;EAwoTA;IACE,yCAAA;EAtoTF;;EAyoTA;IACE,2CAAA;EAvoTF;;EA0oTA;IACE,2EAAA;EAxoTF;;EA2oTA;IACE,iFAAA;EAzoTF;;EA4oTA;IACE,mFAAA;EA1oTF;;EA6oTA;IACE,qFAAA;EA3oTF;;EA8oTA;IACE,iDAAA;EA5oTF;;EA+oTA;IACE,iDAAA;EA7oTF;;EAgpTA;IACE,6CAAA;EA9oTF;;EAipTA;IACE,gBAAA;EA/oTF;;EAkpTA;IACE,yCAAA;EAhpTF;;EAmpTA;IACE,2CAAA;EAjpTF;;EAopTA;IACE,2EAAA;EAlpTF;;EAqpTA;IACE,iFAAA;EAnpTF;;EAspTA;IACE,mFAAA;EAppTF;;EAupTA;IACE,qFAAA;EArpTF;;EAwpTA;IACE,iDAAA;EAtpTF;;EAypTA;IACE,iDAAA;EAvpTF;;EA0pTA;IACE,6CAAA;EAxpTF;;EA2pTA;IACE,gBAAA;EAzpTF;;EA4pTA;IACE,kBAAA;EA1pTF;;EA6pTA;IACE,oBAAA;EA3pTF;;EA8pTA;IACE,eAAA;EA5pTF;;EA+pTA;IACE,eAAA;EA7pTF;;EAgqTA;IACE,eAAA;EA9pTF;;EAiqTA;IACE,kBAAA;EA/pTF;;EAkqTA;IACE,mBAAA;EAhqTF;;EAmqTA;IACE,gBAAA;EAjqTF;;EAoqTA;IACE,kBAAA;EAlqTF;;EAqqTA;IACE,iBAAA;EAnqTF;;EAsqTA;IACE,mBAAA;EApqTF;;EAuqTA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EArqTF;;EAwqTA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EAtqTF;;EAyqTA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EAvqTF;;EA0qTA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EAxqTF;;EA2qTA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EAzqTF;;EA4qTA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EA1qTF;;EA6qTA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EA3qTF;;EA8qTA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EA5qTF;;EA+qTA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EA7qTF;;EAgrTA;IACE,iBAAA;EA9qTF;;EAirTA;IACE,oBAAA;EA/qTF;;EAkrTA;IACE,mBAAA;EAhrTF;;EAmrTA;IACE,oBAAA;EAjrTF;;EAorTA;IACE,iBAAA;EAlrTF;;EAqrTA;IACE,iBAAA;EAnrTF;;EAsrTA;IACE,oBAAA;EAprTF;;EAurTA;IACE,mBAAA;EArrTF;;EAwrTA;IACE,oBAAA;EAtrTF;;EAyrTA;IACE,iBAAA;EAvrTF;;EA0rTA;IACE,iBAAA;EAxrTF;;EA2rTA;IACE,oBAAA;EAzrTF;;EA4rTA;IACE,mBAAA;EA1rTF;;EA6rTA;IACE,oBAAA;EA3rTF;;EA8rTA;IACE,iBAAA;EA5rTF;;EA+rTA;IACE,kBAAA;EA7rTF;;EAgsTA;IACE,kBAAA;EA9rTF;;EAisTA;IACE,yBAAA;EA/rTF;;EAksTA;IACE,yBAAA;EAhsTF;;EAmsTA;IACE,0BAAA;EAjsTF;;EAosTA;IACE,oBAAA;EAlsTF;;EAqsTA;IACE,0BAAA;EAnsTF;;EAssTA;IACE,6BAAA;EApsTF;;EAusTA;IACE,qBAAA;EArsTF;;EAwsTA;IACE,0BAAA;EAtsTF;;EAysTA;IACE,6BAAA;EAvsTF;;EA0sTA;IACE,qBAAA;EAxsTF;;EA2sTA;IACE,0BAAA;EAzsTF;;EA4sTA;IACE,6BAAA;EA1sTF;;EA6sTA;IACE,qBAAA;EA3sTF;;EA8sTA;IACE,mCAAA;IACA,kCAAA;EA5sTF;;EA+sTA;IACE,4BAAA;IACA,6BAAA;EA7sTF;;EAgtTA;IACE,iEAAA;IACA,sEAAA;IACA,gEAAA;IACA,iEAAA;IACA,kEAAA;IACA,8MAAA;EA9sTF;;EAitTA;IACE,4BAAA;EA/sTF;;EAktTA;IACE,uCAAA;EAhtTF;;EAmtTA;IACE,iDAAA;EAjtTF;;EAotTA;IACE,0CAAA;EAltTF;;EAqtTA;IACE,4CAAA;EAntTF;;EAstTA;IACE,iDAAA;EAptTF;;EAutTA;IACE,4CAAA;EArtTF;;EAwtTA;IACE,mDAAA;EAttTF;;EAytTA;IACE,kDAAA;EAvtTF;;EA0tTA;IACE,uBAAA;EAxtTF;;EA2tTA;IACE,wBAAA;EAztTF;;EA4tTA;IACE,iBAAA;EA1tTF;;EA6tTA;IACE,uBAAA;EA3tTF;;EA8tTA;IACE,sBAAA;EA5tTF;;EA+tTA;IACE,qBAAA;EA7tTF;;EAguTA;IACE,yBAAA;IACQ,iBAAA;EA9tTV;;EAiuTA;IACE,yBAAA;IACQ,iBAAA;EA/tTV;;EAkuTA;IACE,wBAAA;IACQ,gBAAA;EAhuTV;;EAmuTA;IACE,yBAAA;IACQ,iBAAA;EAjuTV;;EAouTA;IACE,wBAAA;EAluTF;;EAquTA;IACE,mBAAA;EAnuTF;;EAsuTA;IACE,sBAAA;EApuTF;;EAuuTA;IACE,sBAAA;EAruTF;;EAwuTA;IACE,wBAAA;EAtuTF;;EAyuTA;IACE,2BAAA;EAvuTF;;EA0uTA;IACE,mBAAA;EAxuTF;;EA2uTA;IACE,kBAAA;EAzuTF;;EA4uTA;IACE,mBAAA;EA1uTF;;EA6uTA;IACE,mBAAA;EA3uTF;;EA8uTA;IACE,gBAAA;EA5uTF;;EA+uTA;IACE,qBAAA;EA7uTF;;EAgvTA;IACE,qBAAA;EA9uTF;;EAivTA;IACE,iBAAA;IACA,qBAAA;IACA,kBAAA;EA/uTF;;EAkvTA;IACE,qBAAA;IACA,yBAAA;EAhvTF;;EAmvTA;IACE,qBAAA;EAjvTF;;EAovTA;IACE,gBAAA;IACA,uBAAA;IACA,mBAAA;EAlvTF;;EAqvTA;IACE,QAAA;EAnvTF;;EAsvTA;IACE,cAAA;EApvTF;;EAuvTA;IACE,aAAA;EArvTF;;EAwvTA;IACE,cAAA;EAtvTF;;EAyvTA;IACE,WAAA;EAvvTF;;EA0vTA;IACE,cAAA;EAxvTF;;EA2vTA;IACE,aAAA;EAzvTF;;EA4vTA;IACE,WAAA;EA1vTF;;EA6vTA;IACE,aAAA;EA3vTF;;EA8vTA;IACE,WAAA;EA5vTF;;EA+vTA;IACE,WAAA;EA7vTF;;EAgwTA;IACE,WAAA;EA9vTF;;EAiwTA;IACE,WAAA;EA/vTF;;EAkwTA;IACE,WAAA;EAhwTF;;EAmwTA;IACE,YAAA;EAjwTF;;EAowTA;IACE,YAAA;EAlwTF;;EAqwTA;IACE,YAAA;EAnwTF;;EAswTA;IACE,YAAA;EApwTF;;EAuwTA;IACE,WAAA;EArwTF;;EAwwTA;IACE,UAAA;EAtwTF;;EAywTA;IACE,UAAA;EAvwTF;;EA0wTA;IACE,iBAAA;EAxwTF;;EA2wTA;IACE,iBAAA;EAzwTF;;EA4wTA;IACE,UAAA;EA1wTF;;EA6wTA;IACE,UAAA;EA3wTF;;EA8wTA;IACE,UAAA;EA5wTF;;EA+wTA;IACE,UAAA;EA7wTF;;EAgxTA;IACE,UAAA;EA9wTF;;EAixTA;IACE,UAAA;EA/wTF;;EAkxTA;IACE,UAAA;EAhxTF;;EAmxTA;IACE,iBAAA;EAjxTF;;EAoxTA;IACE,iBAAA;EAlxTF;;EAqxTA;IACE,UAAA;EAnxTF;;EAsxTA;IACE,iBAAA;EApxTF;;EAuxTA;IACE,iBAAA;EArxTF;;EAwxTA;IACE,gBAAA;EAtxTF;;EAyxTA;IACE,iBAAA;EAvxTF;;EA0xTA;IACE,UAAA;EAxxTF;;EA2xTA;IACE,iBAAA;EAzxTF;;EA4xTA;IACE,iBAAA;EA1xTF;;EA6xTA;IACE,UAAA;EA3xTF;;EA8xTA;IACE,iBAAA;EA5xTF;;EA+xTA;IACE,iBAAA;EA7xTF;;EAgyTA;IACE,UAAA;EA9xTF;;EAiyTA;IACE,iBAAA;EA/xTF;;EAkyTA;IACE,iBAAA;EAhyTF;;EAmyTA;IACE,WAAA;EAjyTF;;EAoyTA;IACE,YAAA;EAlyTF;;EAqyTA;IACE,UAAA;EAnyTF;;EAsyTA;IACE,WAAA;EApyTF;;EAuyTA;IACE,WAAA;EAryTF;;EAwyTA;IACE,WAAA;EAtyTF;;EAyyTA;IACE,WAAA;EAvyTF;;EA0yTA;IACE,WAAA;EAxyTF;;EA2yTA;IACE,aAAA;EAzyTF;;EA4yTA;IACE,WAAA;IACA,MAAA;EA1yTF;;EA6yTA;IACE,iBAAA;IACA,YAAA;EA3yTF;;EA8yTA;IACE,gBAAA;IACA,WAAA;EA5yTF;;EA+yTA;IACE,iBAAA;IACA,YAAA;EA7yTF;;EAgzTA;IACE,cAAA;IACA,SAAA;EA9yTF;;EAizTA;IACE,iBAAA;IACA,YAAA;EA/yTF;;EAkzTA;IACE,gBAAA;IACA,WAAA;EAhzTF;;EAmzTA;IACE,cAAA;IACA,SAAA;EAjzTF;;EAozTA;IACE,gBAAA;IACA,WAAA;EAlzTF;;EAqzTA;IACE,cAAA;IACA,SAAA;EAnzTF;;EAszTA;IACE,cAAA;IACA,SAAA;EApzTF;;EAuzTA;IACE,cAAA;IACA,SAAA;EArzTF;;EAwzTA;IACE,cAAA;IACA,SAAA;EAtzTF;;EAyzTA;IACE,cAAA;IACA,SAAA;EAvzTF;;EA0zTA;IACE,eAAA;IACA,UAAA;EAxzTF;;EA2zTA;IACE,eAAA;IACA,UAAA;EAzzTF;;EA4zTA;IACE,eAAA;IACA,UAAA;EA1zTF;;EA6zTA;IACE,eAAA;IACA,UAAA;EA3zTF;;EA8zTA;IACE,aAAA;IACA,QAAA;EA5zTF;;EA+zTA;IACE,kBAAA;IACA,aAAA;EA7zTF;;EAg0TA;IACE,wBAAA;IACA,mBAAA;EA9zTF;;EAi0TA;IACE,uBAAA;IACA,kBAAA;EA/zTF;;EAk0TA;IACE,wBAAA;IACA,mBAAA;EAh0TF;;EAm0TA;IACE,qBAAA;IACA,gBAAA;EAj0TF;;EAo0TA;IACE,wBAAA;IACA,mBAAA;EAl0TF;;EAq0TA;IACE,uBAAA;IACA,kBAAA;EAn0TF;;EAs0TA;IACE,qBAAA;IACA,gBAAA;EAp0TF;;EAu0TA;IACE,uBAAA;IACA,kBAAA;EAr0TF;;EAw0TA;IACE,qBAAA;IACA,gBAAA;EAt0TF;;EAy0TA;IACE,qBAAA;IACA,gBAAA;EAv0TF;;EA00TA;IACE,qBAAA;IACA,gBAAA;EAx0TF;;EA20TA;IACE,qBAAA;IACA,gBAAA;EAz0TF;;EA40TA;IACE,qBAAA;IACA,gBAAA;EA10TF;;EA60TA;IACE,sBAAA;IACA,iBAAA;EA30TF;;EA80TA;IACE,sBAAA;IACA,iBAAA;EA50TF;;EA+0TA;IACE,sBAAA;IACA,iBAAA;EA70TF;;EAg1TA;IACE,sBAAA;IACA,iBAAA;EA90TF;;EAi1TA;IACE,oBAAA;IACA,eAAA;EA/0TF;;EAk1TA;IACE,kBAAA;IACA,aAAA;EAh1TF;;EAm1TA;IACE,wBAAA;IACA,mBAAA;EAj1TF;;EAo1TA;IACE,uBAAA;IACA,kBAAA;EAl1TF;;EAq1TA;IACE,wBAAA;IACA,mBAAA;EAn1TF;;EAs1TA;IACE,qBAAA;IACA,gBAAA;EAp1TF;;EAu1TA;IACE,wBAAA;IACA,mBAAA;EAr1TF;;EAw1TA;IACE,uBAAA;IACA,kBAAA;EAt1TF;;EAy1TA;IACE,qBAAA;IACA,gBAAA;EAv1TF;;EA01TA;IACE,uBAAA;IACA,kBAAA;EAx1TF;;EA21TA;IACE,qBAAA;IACA,gBAAA;EAz1TF;;EA41TA;IACE,qBAAA;IACA,gBAAA;EA11TF;;EA61TA;IACE,qBAAA;IACA,gBAAA;EA31TF;;EA81TA;IACE,qBAAA;IACA,gBAAA;EA51TF;;EA+1TA;IACE,qBAAA;IACA,gBAAA;EA71TF;;EAg2TA;IACE,sBAAA;IACA,iBAAA;EA91TF;;EAi2TA;IACE,sBAAA;IACA,iBAAA;EA/1TF;;EAk2TA;IACE,sBAAA;IACA,iBAAA;EAh2TF;;EAm2TA;IACE,sBAAA;IACA,iBAAA;EAj2TF;;EAo2TA;IACE,oBAAA;IACA,eAAA;EAl2TF;;EAq2TA;IACE,eAAA;IACA,UAAA;EAn2TF;;EAs2TA;IACE,qBAAA;IACA,gBAAA;EAp2TF;;EAu2TA;IACE,oBAAA;IACA,eAAA;EAr2TF;;EAw2TA;IACE,qBAAA;IACA,gBAAA;EAt2TF;;EAy2TA;IACE,kBAAA;IACA,aAAA;EAv2TF;;EA02TA;IACE,qBAAA;IACA,gBAAA;EAx2TF;;EA22TA;IACE,oBAAA;IACA,eAAA;EAz2TF;;EA42TA;IACE,kBAAA;IACA,aAAA;EA12TF;;EA62TA;IACE,oBAAA;IACA,eAAA;EA32TF;;EA82TA;IACE,kBAAA;IACA,aAAA;EA52TF;;EA+2TA;IACE,kBAAA;IACA,aAAA;EA72TF;;EAg3TA;IACE,kBAAA;IACA,aAAA;EA92TF;;EAi3TA;IACE,kBAAA;IACA,aAAA;EA/2TF;;EAk3TA;IACE,kBAAA;IACA,aAAA;EAh3TF;;EAm3TA;IACE,mBAAA;IACA,cAAA;EAj3TF;;EAo3TA;IACE,mBAAA;IACA,cAAA;EAl3TF;;EAq3TA;IACE,mBAAA;IACA,cAAA;EAn3TF;;EAs3TA;IACE,mBAAA;IACA,cAAA;EAp3TF;;EAu3TA;IACE,iBAAA;IACA,YAAA;EAr3TF;;EAw3TA;IACE,eAAA;IACA,UAAA;EAt3TF;;EAy3TA;IACE,qBAAA;IACA,gBAAA;EAv3TF;;EA03TA;IACE,oBAAA;IACA,eAAA;EAx3TF;;EA23TA;IACE,qBAAA;IACA,gBAAA;EAz3TF;;EA43TA;IACE,kBAAA;IACA,aAAA;EA13TF;;EA63TA;IACE,qBAAA;IACA,gBAAA;EA33TF;;EA83TA;IACE,oBAAA;IACA,eAAA;EA53TF;;EA+3TA;IACE,kBAAA;IACA,aAAA;EA73TF;;EAg4TA;IACE,oBAAA;IACA,eAAA;EA93TF;;EAi4TA;IACE,kBAAA;IACA,aAAA;EA/3TF;;EAk4TA;IACE,kBAAA;IACA,aAAA;EAh4TF;;EAm4TA;IACE,kBAAA;IACA,aAAA;EAj4TF;;EAo4TA;IACE,kBAAA;IACA,aAAA;EAl4TF;;EAq4TA;IACE,kBAAA;IACA,aAAA;EAn4TF;;EAs4TA;IACE,mBAAA;IACA,cAAA;EAp4TF;;EAu4TA;IACE,mBAAA;IACA,cAAA;EAr4TF;;EAw4TA;IACE,mBAAA;IACA,cAAA;EAt4TF;;EAy4TA;IACE,mBAAA;IACA,cAAA;EAv4TF;;EA04TA;IACE,iBAAA;IACA,YAAA;EAx4TF;;EA24TA;IACE,mBAAA;EAz4TF;;EA44TA;IACE,sBAAA;EA14TF;;EA64TA;IACE,yBAAA;EA34TF;;EA84TA;IACE,4BAAA;EA54TF;;EA+4TA;IACE,gDAAA;EA74TF;;EAg5TA;IACE,gDAAA;EA94TF;;EAi5TA;IACE,gDAAA;EA/4TF;;EAk5TA;IACE,gDAAA;EAh5TF;;EAm5TA;IACE,gDAAA;EAj5TF;;EAo5TA;IACE,gDAAA;EAl5TF;;EAq5TA;IACE,gDAAA;EAn5TF;;EAs5TA;IACE,gDAAA;EAp5TF;;EAu5TA;IACE,gDAAA;EAr5TF;;EAw5TA;IACE,iDAAA;EAt5TF;;EAy5TA;IACE,iDAAA;EAv5TF;;EA05TA;IACE,iDAAA;EAx5TF;;EA25TA;IACE,2BAAA;EAz5TF;;EA45TA;IACE,uBAAA;EA15TF;;EA65TA;IACE,8BAAA;EA35TF;;EA85TA;IACE,8BAAA;EA55TF;;EA+5TA;IACE,iCAAA;EA75TF;;EAg6TA;IACE,iBAAA;EA95TF;;EAi6TA;IACE,0BAAA;EA/5TF;;EAk6TA;IACE,0BAAA;EAh6TF;;EAm6TA;IACE,0BAAA;EAj6TF;;EAo6TA;IACE,0BAAA;EAl6TF;;EAq6TA;IACE,0BAAA;EAn6TF;;EAs6TA;IACE,0BAAA;EAp6TF;;EAu6TA;IACE,0BAAA;EAr6TF;;EAw6TA;IACE,0BAAA;EAt6TF;;EAy6TA;IACE,0BAAA;EAv6TF;;EA06TA;IACE,4BAAA;EAx6TF;;EA26TA;IACE,4BAAA;EAz6TF;;EA46TA;IACE,4BAAA;EA16TF;;EA66TA;IACE,iBAAA;EA36TF;;EA86TA;IACE,oBAAA;EA56TF;;EA+6TA;IACE,oBAAA;EA76TF;;EAg7TA;IACE,oBAAA;EA96TF;;EAi7TA;IACE,oBAAA;EA/6TF;;EAk7TA;IACE,oBAAA;EAh7TF;;EAm7TA;IACE,oBAAA;EAj7TF;;EAo7TA;IACE,oBAAA;EAl7TF;;EAq7TA;IACE,oBAAA;EAn7TF;;EAs7TA;IACE,oBAAA;EAp7TF;;EAu7TA;IACE,qBAAA;EAr7TF;;EAw7TA;IACE,qBAAA;EAt7TF;;EAy7TA;IACE,qBAAA;EAv7TF;;EA07TA;IACE,qBAAA;EAx7TF;;EA27TA;IACE,uBAAA;EAz7TF;;EA47TA;IACE,kBAAA;EA17TF;;EA67TA;IACE,kBAAA;EA37TF;;EA87TA;IACE,kBAAA;EA57TF;;EA+7TA;IACE,kBAAA;EA77TF;;EAg8TA;IACE,kBAAA;EA97TF;;EAi8TA;IACE,kBAAA;EA/7TF;;EAk8TA;IACE,kBAAA;EAh8TF;;EAm8TA;IACE,kBAAA;EAj8TF;;EAo8TA;IACE,kBAAA;EAl8TF;;EAq8TA;IACE,mBAAA;EAn8TF;;EAs8TA;IACE,mBAAA;EAp8TF;;EAu8TA;IACE,mBAAA;EAr8TF;;EAw8TA;IACE,mBAAA;EAt8TF;;EAy8TA;IACE,qBAAA;EAv8TF;;EA08TA;IACE,6CAAA;EAx8TF;;EA28TA;IACE,6CAAA;EAz8TF;;EA48TA;IACE,6CAAA;EA18TF;;EA68TA;IACE,6CAAA;EA38TF;;EA88TA;IACE,6CAAA;EA58TF;;EA+8TA;IACE,6CAAA;EA78TF;;EAg9TA;IACE,wBAAA;EA98TF;;EAi9TA;IACE,oBAAA;EA/8TF;;EAk9TA;IACE,2BAAA;EAh9TF;;EAm9TA;IACE,2BAAA;EAj9TF;;EAo9TA;IACE,8BAAA;EAl9TF;;EAq9TA;IACE,cAAA;EAn9TF;;EAs9TA;IACE,uBAAA;EAp9TF;;EAu9TA;IACE,uBAAA;EAr9TF;;EAw9TA;IACE,uBAAA;EAt9TF;;EAy9TA;IACE,uBAAA;EAv9TF;;EA09TA;IACE,uBAAA;EAx9TF;;EA29TA;IACE,uBAAA;EAz9TF;;EA49TA;IACE,cAAA;EA19TF;;EA69TA;IACE,iBAAA;EA39TF;;EA89TA;IACE,iBAAA;EA59TF;;EA+9TA;IACE,iBAAA;EA79TF;;EAg+TA;IACE,iBAAA;EA99TF;;EAi+TA;IACE,iBAAA;EA/9TF;;EAk+TA;IACE,iBAAA;EAh+TF;;EAm+TA;IACE,iBAAA;EAj+TF;;EAo+TA;IACE,oBAAA;EAl+TF;;EAq+TA;IACE,eAAA;EAn+TF;;EAs+TA;IACE,eAAA;EAp+TF;;EAu+TA;IACE,eAAA;EAr+TF;;EAw+TA;IACE,eAAA;EAt+TF;;EAy+TA;IACE,eAAA;EAv+TF;;EA0+TA;IACE,eAAA;EAx+TF;;EA2+TA;IACE,eAAA;EAz+TF;;EA4+TA;IACE,kBAAA;EA1+TF;;EA6+TA;IACE,0BAAA;IACA,0BAAA;IACA,qBAAA;IACA,qBAAA;IACA,qBAAA;IACA,sBAAA;IACA,sBAAA;IACA,4PAAA;EA3+TF;;EA8+TA;IACE,eAAA;EA5+TF;;EA++TA;IACE,wBAAA;EA7+TF;;EAg/TA;IACE,qBAAA;EA9+TF;;EAi/TA;IACE,2BAAA;EA/+TF;;EAk/TA;IACE,uBAAA;EAh/TF;;EAm/TA;IACE,8BAAA;EAj/TF;;EAo/TA;IACE,wBAAA;EAl/TF;;EAq/TA;IACE,6BAAA;EAn/TF;;EAs/TA;IACE,sBAAA;EAp/TF;;EAu/TA;IACE,0BAAA;EAr/TF;;EAw/TA;IACE,sBAAA;IACA,sBAAA;EAt/TF;;EAy/TA;IACE,uBAAA;IACA,uBAAA;EAv/TF;;EA0/TA;IACE,wBAAA;IACA,wBAAA;EAx/TF;;EA2/TA;IACE,uBAAA;IACA,uBAAA;EAz/TF;;EA4/TA;IACE,wBAAA;IACA,wBAAA;EA1/TF;;EA6/TA;IACE,sBAAA;IACA,sBAAA;EA3/TF;;EA8/TA;IACE,yBAAA;IACA,yBAAA;EA5/TF;;EA+/TA;IACE,wBAAA;IACA,wBAAA;EA7/TF;;EAggUA;IACE,yBAAA;IACA,yBAAA;EA9/TF;;EAigUA;IACE,wBAAA;IACA,wBAAA;EA//TF;;EAkgUA;IACE,sBAAA;EAhgUF;;EAmgUA;IACE,uBAAA;EAjgUF;;EAogUA;IACE,wBAAA;EAlgUF;;EAqgUA;IACE,uBAAA;EAngUF;;EAsgUA;IACE,wBAAA;EApgUF;;EAugUA;IACE,sBAAA;EArgUF;;EAwgUA;IACE,yBAAA;EAtgUF;;EAygUA;IACE,wBAAA;EAvgUF;;EA0gUA;IACE,yBAAA;EAxgUF;;EA2gUA;IACE,wBAAA;EAzgUF;;EA4gUA;IACE,sBAAA;EA1gUF;;EA6gUA;IACE,uBAAA;EA3gUF;;EA8gUA;IACE,wBAAA;EA5gUF;;EA+gUA;IACE,uBAAA;EA7gUF;;EAghUA;IACE,wBAAA;EA9gUF;;EAihUA;IACE,sBAAA;EA/gUF;;EAkhUA;IACE,yBAAA;EAhhUF;;EAmhUA;IACE,wBAAA;EAjhUF;;EAohUA;IACE,yBAAA;EAlhUF;;EAqhUA;IACE,wBAAA;EAnhUF;;EAshUA;IACE,sBAAA;IACA,sBAAA;EAphUF;;EAuhUA;IACE,uBAAA;IACA,uBAAA;EArhUF;;EAwhUA;IACE,wBAAA;IACA,wBAAA;EAthUF;;EAyhUA;IACE,uBAAA;IACA,uBAAA;EAvhUF;;EA0hUA;IACE,wBAAA;IACA,wBAAA;EAxhUF;;EA2hUA;IACE,sBAAA;IACA,sBAAA;EAzhUF;;EA4hUA;IACE,yBAAA;IACA,yBAAA;EA1hUF;;EA6hUA;IACE,wBAAA;IACA,wBAAA;EA3hUF;;EA8hUA;IACE,yBAAA;IACA,yBAAA;EA5hUF;;EA+hUA;IACE,wBAAA;IACA,wBAAA;EA7hUF;;EAgiUA;IACE,sBAAA;EA9hUF;;EAiiUA;IACE,uBAAA;EA/hUF;;EAkiUA;IACE,wBAAA;EAhiUF;;EAmiUA;IACE,uBAAA;EAjiUF;;EAoiUA;IACE,wBAAA;EAliUF;;EAqiUA;IACE,sBAAA;EAniUF;;EAsiUA;IACE,yBAAA;EApiUF;;EAuiUA;IACE,wBAAA;EAriUF;;EAwiUA;IACE,yBAAA;EAtiUF;;EAyiUA;IACE,wBAAA;EAviUF;;EA0iUA;IACE,sBAAA;EAxiUF;;EA2iUA;IACE,uBAAA;EAziUF;;EA4iUA;IACE,wBAAA;EA1iUF;;EA6iUA;IACE,uBAAA;EA3iUF;;EA8iUA;IACE,wBAAA;EA5iUF;;EA+iUA;IACE,sBAAA;EA7iUF;;EAgjUA;IACE,yBAAA;EA9iUF;;EAijUA;IACE,wBAAA;EA/iUF;;EAkjUA;IACE,yBAAA;EAhjUF;;EAmjUA;IACE,wBAAA;EAjjUF;;EAojUA;IACE,sBAAA;IACA,sBAAA;EAljUF;;EAqjUA;IACE,uBAAA;IACA,uBAAA;EAnjUF;;EAsjUA;IACE,wBAAA;IACA,wBAAA;EApjUF;;EAujUA;IACE,uBAAA;IACA,uBAAA;EArjUF;;EAwjUA;IACE,wBAAA;IACA,wBAAA;EAtjUF;;EAyjUA;IACE,sBAAA;IACA,sBAAA;EAvjUF;;EA0jUA;IACE,yBAAA;IACA,yBAAA;EAxjUF;;EA2jUA;IACE,wBAAA;IACA,wBAAA;EAzjUF;;EA4jUA;IACE,yBAAA;IACA,yBAAA;EA1jUF;;EA6jUA;IACE,wBAAA;IACA,wBAAA;EA3jUF;;EA8jUA;IACE,sBAAA;EA5jUF;;EA+jUA;IACE,uBAAA;EA7jUF;;EAgkUA;IACE,wBAAA;EA9jUF;;EAikUA;IACE,uBAAA;EA/jUF;;EAkkUA;IACE,wBAAA;EAhkUF;;EAmkUA;IACE,sBAAA;EAjkUF;;EAokUA;IACE,yBAAA;EAlkUF;;EAqkUA;IACE,wBAAA;EAnkUF;;EAskUA;IACE,yBAAA;EApkUF;;EAukUA;IACE,wBAAA;EArkUF;;EAwkUA;IACE,sBAAA;EAtkUF;;EAykUA;IACE,uBAAA;EAvkUF;;EA0kUA;IACE,wBAAA;EAxkUF;;EA2kUA;IACE,uBAAA;EAzkUF;;EA4kUA;IACE,wBAAA;EA1kUF;;EA6kUA;IACE,sBAAA;EA3kUF;;EA8kUA;IACE,yBAAA;EA5kUF;;EA+kUA;IACE,wBAAA;EA7kUF;;EAglUA;IACE,yBAAA;EA9kUF;;EAilUA;IACE,wBAAA;EA/kUF;;EAklUA;IACE,qBAAA;EAhlUF;;EAmlUA;IACE,wBAAA;EAjlUF;;EAolUA;IACE,wBAAA;EAllUF;;EAqlUA;IACE,wBAAA;EAnlUF;;EAslUA;IACE,wBAAA;EAplUF;;EAulUA;IACE,yBAAA;EArlUF;;EAwlUA;IACE,yBAAA;EAtlUF;;EAylUA;IACE,yBAAA;EAvlUF;;EA0lUA;IACE,0BAAA;EAxlUF;;EA2lUA;IACE,2BAAA;EAzlUF;;EA4lUA;IACE,0BAAA;EA1lUF;;EA6lUA;IACE,0BAAA;EA3lUF;;EA8lUA;IACE,0BAAA;EA5lUF;;EA+lUA;IACE,yBAAA;EA7lUF;;EAgmUA;IACE,yBAAA;EA9lUF;;EAimUA;IACE,yBAAA;EA/lUF;;EAkmUA;IACE,yBAAA;EAhmUF;;EAmmUA;IACE,qBAAA;EAjmUF;;EAomUA;IACE,wBAAA;EAlmUF;;EAqmUA;IACE,wBAAA;EAnmUF;;EAsmUA;IACE,wBAAA;EApmUF;;EAumUA;IACE,wBAAA;EArmUF;;EAwmUA;IACE,yBAAA;EAtmUF;;EAymUA;IACE,yBAAA;EAvmUF;;EA0mUA;IACE,yBAAA;EAxmUF;;EA2mUA;IACE,0BAAA;EAzmUF;;EA4mUA;IACE,2BAAA;EA1mUF;;EA6mUA;IACE,0BAAA;EA3mUF;;EA8mUA;IACE,0BAAA;EA5mUF;;EA+mUA;IACE,0BAAA;EA7mUF;;EAgnUA;IACE,yBAAA;EA9mUF;;EAinUA;IACE,yBAAA;EA/mUF;;EAknUA;IACE,yBAAA;EAhnUF;;EAmnUA;IACE,yBAAA;EAjnUF;;EAonUA;IACE,qBAAA;EAlnUF;;EAqnUA;IACE,wBAAA;EAnnUF;;EAsnUA;IACE,wBAAA;EApnUF;;EAunUA;IACE,wBAAA;EArnUF;;EAwnUA;IACE,wBAAA;EAtnUF;;EAynUA;IACE,yBAAA;EAvnUF;;EA0nUA;IACE,yBAAA;EAxnUF;;EA2nUA;IACE,yBAAA;EAznUF;;EA4nUA;IACE,0BAAA;EA1nUF;;EA6nUA;IACE,2BAAA;EA3nUF;;EA8nUA;IACE,0BAAA;EA5nUF;;EA+nUA;IACE,0BAAA;EA7nUF;;EAgoUA;IACE,0BAAA;EA9nUF;;EAioUA;IACE,yBAAA;EA/nUF;;EAkoUA;IACE,yBAAA;EAhoUF;;EAmoUA;IACE,yBAAA;EAjoUF;;EAooUA;IACE,yBAAA;EAloUF;;EAqoUA;IACE,0BAAA;EAnoUF;;EAsoUA;IACE,gCAAA;EApoUF;;EAuoUA;IACE,+BAAA;EAroUF;;EAwoUA;IACE,gCAAA;EAtoUF;;EAyoUA;IACE,6BAAA;EAvoUF;;EA0oUA;IACE,gCAAA;EAxoUF;;EA2oUA;IACE,+BAAA;EAzoUF;;EA4oUA;IACE,6BAAA;EA1oUF;;EA6oUA;IACE,+BAAA;EA3oUF;;EA8oUA;IACE,6BAAA;EA5oUF;;EA+oUA;IACE,6BAAA;EA7oUF;;EAgpUA;IACE,6BAAA;EA9oUF;;EAipUA;IACE,6BAAA;EA/oUF;;EAkpUA;IACE,6BAAA;EAhpUF;;EAmpUA;IACE,8BAAA;EAjpUF;;EAopUA;IACE,8BAAA;EAlpUF;;EAqpUA;IACE,8BAAA;EAnpUF;;EAspUA;IACE,8BAAA;EAppUF;;EAupUA;IACE,4BAAA;EArpUF;;EAwpUA;IACE,iCAAA;EAtpUF;;EAypUA;IACE,gCAAA;EAvpUF;;EA0pUA;IACE,iCAAA;EAxpUF;;EA2pUA;IACE,8BAAA;EAzpUF;;EA4pUA;IACE,iCAAA;EA1pUF;;EA6pUA;IACE,gCAAA;EA3pUF;;EA8pUA;IACE,8BAAA;EA5pUF;;EA+pUA;IACE,gCAAA;EA7pUF;;EAgqUA;IACE,8BAAA;EA9pUF;;EAiqUA;IACE,8BAAA;EA/pUF;;EAkqUA;IACE,8BAAA;EAhqUF;;EAmqUA;IACE,8BAAA;EAjqUF;;EAoqUA;IACE,8BAAA;EAlqUF;;EAqqUA;IACE,+BAAA;EAnqUF;;EAsqUA;IACE,+BAAA;EApqUF;;EAuqUA;IACE,+BAAA;EArqUF;;EAwqUA;IACE,+BAAA;EAtqUF;;EAyqUA;IACE,6BAAA;EAvqUF;;EA0qUA;IACE,8BAAA;EAxqUF;;EA2qUA;IACE,6BAAA;EAzqUF;;EA4qUA;IACE,4BAAA;EA1qUF;;EA6qUA;IACE,6BAAA;EA3qUF;;EA8qUA;IACE,0BAAA;EA5qUF;;EA+qUA;IACE,gCAAA;EA7qUF;;EAgrUA;IACE,+BAAA;EA9qUF;;EAirUA;IACE,gCAAA;EA/qUF;;EAkrUA;IACE,6BAAA;EAhrUF;;EAmrUA;IACE,gCAAA;EAjrUF;;EAorUA;IACE,+BAAA;EAlrUF;;EAqrUA;IACE,6BAAA;EAnrUF;;EAsrUA;IACE,+BAAA;EAprUF;;EAurUA;IACE,6BAAA;EArrUF;;EAwrUA;IACE,6BAAA;EAtrUF;;EAyrUA;IACE,6BAAA;EAvrUF;;EA0rUA;IACE,6BAAA;EAxrUF;;EA2rUA;IACE,6BAAA;EAzrUF;;EA4rUA;IACE,8BAAA;EA1rUF;;EA6rUA;IACE,8BAAA;EA3rUF;;EA8rUA;IACE,8BAAA;EA5rUF;;EA+rUA;IACE,8BAAA;EA7rUF;;EAgsUA;IACE,4BAAA;EA9rUF;;EAisUA;IACE,iCAAA;EA/rUF;;EAksUA;IACE,gCAAA;EAhsUF;;EAmsUA;IACE,iCAAA;EAjsUF;;EAosUA;IACE,8BAAA;EAlsUF;;EAqsUA;IACE,iCAAA;EAnsUF;;EAssUA;IACE,gCAAA;EApsUF;;EAusUA;IACE,8BAAA;EArsUF;;EAwsUA;IACE,gCAAA;EAtsUF;;EAysUA;IACE,8BAAA;EAvsUF;;EA0sUA;IACE,8BAAA;EAxsUF;;EA2sUA;IACE,8BAAA;EAzsUF;;EA4sUA;IACE,8BAAA;EA1sUF;;EA6sUA;IACE,8BAAA;EA3sUF;;EA8sUA;IACE,+BAAA;EA5sUF;;EA+sUA;IACE,+BAAA;EA7sUF;;EAgtUA;IACE,+BAAA;EA9sUF;;EAitUA;IACE,+BAAA;EA/sUF;;EAktUA;IACE,6BAAA;EAhtUF;;EAmtUA;IACE,8BAAA;EAjtUF;;EAotUA;IACE,6BAAA;EAltUF;;EAqtUA;IACE,4BAAA;EAntUF;;EAstUA;IACE,6BAAA;EAptUF;;EAutUA;IACE,0BAAA;EArtUF;;EAwtUA;IACE,gCAAA;EAttUF;;EAytUA;IACE,+BAAA;EAvtUF;;EA0tUA;IACE,gCAAA;EAxtUF;;EA2tUA;IACE,6BAAA;EAztUF;;EA4tUA;IACE,gCAAA;EA1tUF;;EA6tUA;IACE,+BAAA;EA3tUF;;EA8tUA;IACE,6BAAA;EA5tUF;;EA+tUA;IACE,+BAAA;EA7tUF;;EAguUA;IACE,6BAAA;EA9tUF;;EAiuUA;IACE,6BAAA;EA/tUF;;EAkuUA;IACE,6BAAA;EAhuUF;;EAmuUA;IACE,6BAAA;EAjuUF;;EAouUA;IACE,6BAAA;EAluUF;;EAquUA;IACE,8BAAA;EAnuUF;;EAsuUA;IACE,8BAAA;EApuUF;;EAuuUA;IACE,8BAAA;EAruUF;;EAwuUA;IACE,8BAAA;EAtuUF;;EAyuUA;IACE,4BAAA;EAvuUF;;EA0uUA;IACE,iCAAA;EAxuUF;;EA2uUA;IACE,gCAAA;EAzuUF;;EA4uUA;IACE,iCAAA;EA1uUF;;EA6uUA;IACE,8BAAA;EA3uUF;;EA8uUA;IACE,iCAAA;EA5uUF;;EA+uUA;IACE,gCAAA;EA7uUF;;EAgvUA;IACE,8BAAA;EA9uUF;;EAivUA;IACE,gCAAA;EA/uUF;;EAkvUA;IACE,8BAAA;EAhvUF;;EAmvUA;IACE,8BAAA;EAjvUF;;EAovUA;IACE,8BAAA;EAlvUF;;EAqvUA;IACE,8BAAA;EAnvUF;;EAsvUA;IACE,8BAAA;EApvUF;;EAuvUA;IACE,+BAAA;EArvUF;;EAwvUA;IACE,+BAAA;EAtvUF;;EAyvUA;IACE,+BAAA;EAvvUF;;EA0vUA;IACE,+BAAA;EAxvUF;;EA2vUA;IACE,6BAAA;EAzvUF;;EA4vUA;IACE,8BAAA;EA1vUF;;EA6vUA;IACE,6BAAA;EA3vUF;;EA8vUA;IACE,4BAAA;EA5vUF;;EA+vUA;IACE,6BAAA;EA7vUF;;EAgwUA;IACE,0BAAA;EA9vUF;;EAiwUA;IACE,gCAAA;EA/vUF;;EAkwUA;IACE,+BAAA;EAhwUF;;EAmwUA;IACE,gCAAA;EAjwUF;;EAowUA;IACE,6BAAA;EAlwUF;;EAqwUA;IACE,gCAAA;EAnwUF;;EAswUA;IACE,+BAAA;EApwUF;;EAuwUA;IACE,6BAAA;EArwUF;;EAwwUA;IACE,+BAAA;EAtwUF;;EAywUA;IACE,6BAAA;EAvwUF;;EA0wUA;IACE,6BAAA;EAxwUF;;EA2wUA;IACE,6BAAA;EAzwUF;;EA4wUA;IACE,6BAAA;EA1wUF;;EA6wUA;IACE,6BAAA;EA3wUF;;EA8wUA;IACE,8BAAA;EA5wUF;;EA+wUA;IACE,8BAAA;EA7wUF;;EAgxUA;IACE,8BAAA;EA9wUF;;EAixUA;IACE,8BAAA;EA/wUF;;EAkxUA;IACE,4BAAA;EAhxUF;;EAmxUA;IACE,iCAAA;EAjxUF;;EAoxUA;IACE,gCAAA;EAlxUF;;EAqxUA;IACE,iCAAA;EAnxUF;;EAsxUA;IACE,8BAAA;EApxUF;;EAuxUA;IACE,iCAAA;EArxUF;;EAwxUA;IACE,gCAAA;EAtxUF;;EAyxUA;IACE,8BAAA;EAvxUF;;EA0xUA;IACE,gCAAA;EAxxUF;;EA2xUA;IACE,8BAAA;EAzxUF;;EA4xUA;IACE,8BAAA;EA1xUF;;EA6xUA;IACE,8BAAA;EA3xUF;;EA8xUA;IACE,8BAAA;EA5xUF;;EA+xUA;IACE,8BAAA;EA7xUF;;EAgyUA;IACE,+BAAA;EA9xUF;;EAiyUA;IACE,+BAAA;EA/xUF;;EAkyUA;IACE,+BAAA;EAhyUF;;EAmyUA;IACE,+BAAA;EAjyUF;;EAoyUA;IACE,6BAAA;EAlyUF;;EAqyUA;IACE,8BAAA;EAnyUF;;EAsyUA;IACE,6BAAA;EApyUF;;EAuyUA;IACE,4BAAA;EAryUF;;EAwyUA;IACE,6BAAA;EAtyUF;;EAyyUA;IACE,0BAAA;EAvyUF;;EA0yUA;IACE,gCAAA;EAxyUF;;EA2yUA;IACE,+BAAA;EAzyUF;;EA4yUA;IACE,gCAAA;EA1yUF;;EA6yUA;IACE,6BAAA;EA3yUF;;EA8yUA;IACE,gCAAA;EA5yUF;;EA+yUA;IACE,+BAAA;EA7yUF;;EAgzUA;IACE,6BAAA;EA9yUF;;EAizUA;IACE,+BAAA;EA/yUF;;EAkzUA;IACE,6BAAA;EAhzUF;;EAmzUA;IACE,6BAAA;EAjzUF;;EAozUA;IACE,6BAAA;EAlzUF;;EAqzUA;IACE,6BAAA;EAnzUF;;EAszUA;IACE,6BAAA;EApzUF;;EAuzUA;IACE,8BAAA;EArzUF;;EAwzUA;IACE,8BAAA;EAtzUF;;EAyzUA;IACE,8BAAA;EAvzUF;;EA0zUA;IACE,8BAAA;EAxzUF;;EA2zUA;IACE,4BAAA;EAzzUF;;EA4zUA;IACE,iCAAA;EA1zUF;;EA6zUA;IACE,gCAAA;EA3zUF;;EA8zUA;IACE,iCAAA;EA5zUF;;EA+zUA;IACE,8BAAA;EA7zUF;;EAg0UA;IACE,iCAAA;EA9zUF;;EAi0UA;IACE,gCAAA;EA/zUF;;EAk0UA;IACE,8BAAA;EAh0UF;;EAm0UA;IACE,gCAAA;EAj0UF;;EAo0UA;IACE,8BAAA;EAl0UF;;EAq0UA;IACE,8BAAA;EAn0UF;;EAs0UA;IACE,8BAAA;EAp0UF;;EAu0UA;IACE,8BAAA;EAr0UF;;EAw0UA;IACE,8BAAA;EAt0UF;;EAy0UA;IACE,+BAAA;EAv0UF;;EA00UA;IACE,+BAAA;EAx0UF;;EA20UA;IACE,+BAAA;EAz0UF;;EA40UA;IACE,+BAAA;EA10UF;;EA60UA;IACE,6BAAA;EA30UF;;EA80UA;IACE,8BAAA;EA50UF;;EA+0UA;IACE,6BAAA;EA70UF;;EAg1UA;IACE,4BAAA;EA90UF;;EAi1UA;IACE,6BAAA;EA/0UF;;EAk1UA;IACE,0BAAA;EAh1UF;;EAm1UA;IACE,gCAAA;EAj1UF;;EAo1UA;IACE,+BAAA;EAl1UF;;EAq1UA;IACE,gCAAA;EAn1UF;;EAs1UA;IACE,6BAAA;EAp1UF;;EAu1UA;IACE,gCAAA;EAr1UF;;EAw1UA;IACE,+BAAA;EAt1UF;;EAy1UA;IACE,6BAAA;EAv1UF;;EA01UA;IACE,+BAAA;EAx1UF;;EA21UA;IACE,6BAAA;EAz1UF;;EA41UA;IACE,6BAAA;EA11UF;;EA61UA;IACE,6BAAA;EA31UF;;EA81UA;IACE,6BAAA;EA51UF;;EA+1UA;IACE,6BAAA;EA71UF;;EAg2UA;IACE,8BAAA;EA91UF;;EAi2UA;IACE,8BAAA;EA/1UF;;EAk2UA;IACE,8BAAA;EAh2UF;;EAm2UA;IACE,8BAAA;EAj2UF;;EAo2UA;IACE,4BAAA;EAl2UF;;EAq2UA;IACE,iCAAA;EAn2UF;;EAs2UA;IACE,gCAAA;EAp2UF;;EAu2UA;IACE,iCAAA;EAr2UF;;EAw2UA;IACE,8BAAA;EAt2UF;;EAy2UA;IACE,iCAAA;EAv2UF;;EA02UA;IACE,gCAAA;EAx2UF;;EA22UA;IACE,8BAAA;EAz2UF;;EA42UA;IACE,gCAAA;EA12UF;;EA62UA;IACE,8BAAA;EA32UF;;EA82UA;IACE,8BAAA;EA52UF;;EA+2UA;IACE,8BAAA;EA72UF;;EAg3UA;IACE,8BAAA;EA92UF;;EAi3UA;IACE,8BAAA;EA/2UF;;EAk3UA;IACE,+BAAA;EAh3UF;;EAm3UA;IACE,+BAAA;EAj3UF;;EAo3UA;IACE,+BAAA;EAl3UF;;EAq3UA;IACE,+BAAA;EAn3UF;;EAs3UA;IACE,6BAAA;EAp3UF;;EAu3UA;IACE,8BAAA;EAr3UF;;EAw3UA;IACE,6BAAA;EAt3UF;;EAy3UA;IACE,4BAAA;EAv3UF;;EA03UA;IACE,6BAAA;EAx3UF;;EA23UA;IACE,qBAAA;EAz3UF;;EA43UA;IACE,wBAAA;EA13UF;;EA63UA;IACE,wBAAA;EA33UF;;EA83UA;IACE,wBAAA;EA53UF;;EA+3UA;IACE,wBAAA;EA73UF;;EAg4UA;IACE,yBAAA;EA93UF;;EAi4UA;IACE,0BAAA;EA/3UF;;EAk4UA;IACE,yBAAA;EAh4UF;;EAm4UA;IACE,yBAAA;EAj4UF;;EAo4UA;IACE,yBAAA;EAl4UF;;EAq4UA;IACE,yBAAA;EAn4UF;;EAs4UA;IACE,qBAAA;EAp4UF;;EAu4UA;IACE,wBAAA;EAr4UF;;EAw4UA;IACE,wBAAA;EAt4UF;;EAy4UA;IACE,wBAAA;EAv4UF;;EA04UA;IACE,wBAAA;EAx4UF;;EA24UA;IACE,yBAAA;EAz4UF;;EA44UA;IACE,0BAAA;EA14UF;;EA64UA;IACE,yBAAA;EA34UF;;EA84UA;IACE,yBAAA;EA54UF;;EA+4UA;IACE,yBAAA;EA74UF;;EAg5UA;IACE,yBAAA;EA94UF;;EAi5UA;IACE,qBAAA;EA/4UF;;EAk5UA;IACE,wBAAA;EAh5UF;;EAm5UA;IACE,wBAAA;EAj5UF;;EAo5UA;IACE,wBAAA;EAl5UF;;EAq5UA;IACE,wBAAA;EAn5UF;;EAs5UA;IACE,yBAAA;EAp5UF;;EAu5UA;IACE,0BAAA;EAr5UF;;EAw5UA;IACE,yBAAA;EAt5UF;;EAy5UA;IACE,yBAAA;EAv5UF;;EA05UA;IACE,yBAAA;EAx5UF;;EA25UA;IACE,yBAAA;EAz5UF;;EA45UA;IACE,qBAAA;EA15UF;;EA65UA;IACE,wBAAA;EA35UF;;EA85UA;IACE,wBAAA;EA55UF;;EA+5UA;IACE,wBAAA;EA75UF;;EAg6UA;IACE,wBAAA;EA95UF;;EAi6UA;IACE,yBAAA;EA/5UF;;EAk6UA;IACE,0BAAA;EAh6UF;;EAm6UA;IACE,yBAAA;EAj6UF;;EAo6UA;IACE,yBAAA;EAl6UF;;EAq6UA;IACE,yBAAA;EAn6UF;;EAs6UA;IACE,yBAAA;EAp6UF;;EAu6UA;IACE,qBAAA;EAr6UF;;EAw6UA;IACE,wBAAA;EAt6UF;;EAy6UA;IACE,wBAAA;EAv6UF;;EA06UA;IACE,wBAAA;EAx6UF;;EA26UA;IACE,wBAAA;EAz6UF;;EA46UA;IACE,yBAAA;EA16UF;;EA66UA;IACE,0BAAA;EA36UF;;EA86UA;IACE,yBAAA;EA56UF;;EA+6UA;IACE,yBAAA;EA76UF;;EAg7UA;IACE,yBAAA;EA96UF;;EAi7UA;IACE,yBAAA;EA/6UF;;EAk7UA;IACE,qBAAA;EAh7UF;;EAm7UA;IACE,wBAAA;EAj7UF;;EAo7UA;IACE,wBAAA;EAl7UF;;EAq7UA;IACE,wBAAA;EAn7UF;;EAs7UA;IACE,wBAAA;EAp7UF;;EAu7UA;IACE,yBAAA;EAr7UF;;EAw7UA;IACE,0BAAA;EAt7UF;;EAy7UA;IACE,yBAAA;EAv7UF;;EA07UA;IACE,yBAAA;EAx7UF;;EA27UA;IACE,yBAAA;EAz7UF;;EA47UA;IACE,yBAAA;EA17UF;;EA67UA;IACE,yBAAA;EA37UF;;EA87UA;IACE,wBAAA;EA57UF;;EA+7UA;IACE,wGAAA;EA77UF;;EAg8UA;IACE,wEAAA;EA97UF;;EAi8UA;IACE,4BAAA;EA/7UF;;EAk8UA;IACE,+BAAA;EAh8UF;;EAm8UA;IACE,8BAAA;EAj8UF;;EAo8UA;IACE,kCAAA;EAl8UF;;EAq8UA;IACE,sDAAA;EAn8UF;;EAs8UA;IACE,sDAAA;EAp8UF;;EAu8UA;IACE,wDAAA;EAr8UF;;EAw8UA;IACE,yBAAA;EAt8UF;;EAy8UA;IACE,0BAAA;EAv8UF;;EA08UA;IACE,0BAAA;EAx8UF;;EA28UA;IACE,0BAAA;EAz8UF;;EA48UA;IACE,0BAAA;EA18UF;;EA68UA;IACE,0BAAA;EA38UF;;EA88UA;IACE,0BAAA;EA58UF;;EA+8UA;IACE,2BAAA;EA78UF;;EAg9UA;IACE,sBAAA;EA98UF;;EAi9UA;IACE,uBAAA;EA/8UF;;EAk9UA;IACE,uBAAA;EAh9UF;;EAm9UA;IACE,uBAAA;EAj9UF;;EAo9UA;IACE,uBAAA;EAl9UF;;EAq9UA;IACE,uBAAA;EAn9UF;;EAs9UA;IACE,uBAAA;EAp9UF;;EAu9UA;IACE,wBAAA;EAr9UF;;EAw9UA;IACE,eAAA;EAt9UF;;EAy9UA;IACE,kCAAA;EAv9UF;;EA09UA;IACE,sDAAA;EAx9UF;;EA29UA;IACE,yDAAA;EAz9UF;;EA49UA;IACE,6BAAA;EA19UF;AACF;;AA69UA;EACE;IACE,WAAA;EA39UF;AACF;;AA69UE;EACE;IACE,gBAAA;EA39UJ;AACF;;AA89UE;EACE;IACE,gBAAA;EA59UJ;AACF;;AA+9UE;EACE;IACE,iBAAA;EA79UJ;AACF;;AAg+UE;EACE;IACE,iBAAA;EA99UJ;AACF;;AAo8UA;EA6BE;IACE,oBAAA;IACA,oDAAA;IACA,iDAAA;EA99UF;;EAi+UA;IACE,oBAAA;IACA,gDAAA;IACA,qDAAA;EA/9UF;;EAk+UA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAh+UF;;EAm+UA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAj+UF;;EAo+UA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAl+UF;;EAq+UA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAn+UF;;EAs+UA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAp+UF;;EAu+UA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAr+UF;;EAw+UA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAt+UF;;EAy+UA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAv+UF;;EA0+UA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAx+UF;;EA2+UA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAz+UF;;EA4+UA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EA1+UF;;EA6+UA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EA3+UF;;EA8+UA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EA5+UF;;EA++UA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EA7+UF;;EAg/UA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EA9+UF;;EAi/UA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EA/+UF;;EAk/UA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAh/UF;;EAm/UA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAj/UF;;EAo/UA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAl/UF;;EAq/UA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAn/UF;;EAs/UA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAp/UF;;EAu/UA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAr/UF;;EAw/UA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAt/UF;;EAy/UA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAv/UF;;EA0/UA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAx/UF;;EA2/UA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAz/UF;;EA4/UA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA1/UF;;EA6/UA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA3/UF;;EA8/UA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA5/UF;;EA+/UA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA7/UF;;EAggVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA9/UF;;EAigVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA//UF;;EAkgVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAhgVF;;EAmgVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAjgVF;;EAogVA;IACE,oBAAA;IACA,oDAAA;IACA,iDAAA;EAlgVF;;EAqgVA;IACE,oBAAA;IACA,gDAAA;IACA,qDAAA;EAngVF;;EAsgVA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EApgVF;;EAugVA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EArgVF;;EAwgVA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAtgVF;;EAygVA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAvgVF;;EA0gVA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EAxgVF;;EA2gVA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EAzgVF;;EA4gVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA1gVF;;EA6gVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA3gVF;;EA8gVA;IACE,oBAAA;IACA,yDAAA;IACA,sDAAA;EA5gVF;;EA+gVA;IACE,oBAAA;IACA,qDAAA;IACA,0DAAA;EA7gVF;;EAghVA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EA9gVF;;EAihVA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EA/gVF;;EAkhVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAhhVF;;EAmhVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAjhVF;;EAohVA;IACE,oBAAA;IACA,wDAAA;IACA,qDAAA;EAlhVF;;EAqhVA;IACE,oBAAA;IACA,oDAAA;IACA,yDAAA;EAnhVF;;EAshVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAphVF;;EAuhVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EArhVF;;EAwhVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAthVF;;EAyhVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAvhVF;;EA0hVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EAxhVF;;EA2hVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EAzhVF;;EA4hVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA1hVF;;EA6hVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA3hVF;;EA8hVA;IACE,oBAAA;IACA,sDAAA;IACA,mDAAA;EA5hVF;;EA+hVA;IACE,oBAAA;IACA,kDAAA;IACA,uDAAA;EA7hVF;;EAgiVA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EA9hVF;;EAiiVA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EA/hVF;;EAkiVA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAhiVF;;EAmiVA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAjiVF;;EAoiVA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EAliVF;;EAqiVA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAniVF;;EAsiVA;IACE,oBAAA;IACA,uDAAA;IACA,oDAAA;EApiVF;;EAuiVA;IACE,oBAAA;IACA,mDAAA;IACA,wDAAA;EAriVF;;EAwiVA;IACE,oBAAA;IACA,qDAAA;IACA,kDAAA;EAtiVF;;EAyiVA;IACE,oBAAA;IACA,iDAAA;IACA,sDAAA;EAviVF;;EA0iVA;IACE,oBAAA;EAxiVF;;EA2iVA;IACE,oBAAA;EAziVF;;EA4iVA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA1iVF;;EA6iVA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EA3iVF;;EA8iVA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA5iVF;;EA+iVA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EA7iVF;;EAgjVA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EA9iVF;;EAijVA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EA/iVF;;EAkjVA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EAhjVF;;EAmjVA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAjjVF;;EAojVA;IACE,qBAAA;IACA,2DAAA;IACA,wDAAA;EAljVF;;EAqjVA;IACE,qBAAA;IACA,uDAAA;IACA,4DAAA;EAnjVF;;EAsjVA;IACE,qBAAA;EApjVF;;EAujVA;IACE,qBAAA;EArjVF;;EAwjVA;IACE,yBAAA;EAtjVF;;EAyjVA;IACE,0BAAA;EAvjVF;;EA0jVA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EAxjVF;;EA2jVA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAzjVF;;EA4jVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1jVF;;EA6jVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3jVF;;EA8jVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5jVF;;EA+jVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7jVF;;EAgkVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9jVF;;EAikVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/jVF;;EAkkVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhkVF;;EAmkVA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAjkVF;;EAokVA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAlkVF;;EAqkVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnkVF;;EAskVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApkVF;;EAukVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArkVF;;EAwkVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtkVF;;EAykVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvkVF;;EA0kVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxkVF;;EA2kVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzkVF;;EA4kVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1kVF;;EA6kVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3kVF;;EA8kVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5kVF;;EA+kVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7kVF;;EAglVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9kVF;;EAilVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/kVF;;EAklVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhlVF;;EAmlVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjlVF;;EAolVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAllVF;;EAqlVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnlVF;;EAslVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAplVF;;EAulVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArlVF;;EAwlVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtlVF;;EAylVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvlVF;;EA0lVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxlVF;;EA2lVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzlVF;;EA4lVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1lVF;;EA6lVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3lVF;;EA8lVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5lVF;;EA+lVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7lVF;;EAgmVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9lVF;;EAimVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/lVF;;EAkmVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhmVF;;EAmmVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjmVF;;EAomVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlmVF;;EAqmVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnmVF;;EAsmVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EApmVF;;EAumVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EArmVF;;EAwmVA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAtmVF;;EAymVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvmVF;;EA0mVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxmVF;;EA2mVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzmVF;;EA4mVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1mVF;;EA6mVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3mVF;;EA8mVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5mVF;;EA+mVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7mVF;;EAgnVA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA9mVF;;EAinVA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA/mVF;;EAknVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhnVF;;EAmnVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjnVF;;EAonVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlnVF;;EAqnVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnnVF;;EAsnVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EApnVF;;EAunVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArnVF;;EAwnVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtnVF;;EAynVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvnVF;;EA0nVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxnVF;;EA2nVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAznVF;;EA4nVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1nVF;;EA6nVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3nVF;;EA8nVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5nVF;;EA+nVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7nVF;;EAgoVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9nVF;;EAioVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/nVF;;EAkoVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhoVF;;EAmoVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjoVF;;EAooVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAloVF;;EAqoVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnoVF;;EAsoVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApoVF;;EAuoVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAroVF;;EAwoVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtoVF;;EAyoVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvoVF;;EA0oVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxoVF;;EA2oVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAzoVF;;EA4oVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA1oVF;;EA6oVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3oVF;;EA8oVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5oVF;;EA+oVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7oVF;;EAgpVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9oVF;;EAipVA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/oVF;;EAkpVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhpVF;;EAmpVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjpVF;;EAopVA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlpVF;;EAqpVA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnpVF;;EAspVA;IACE,mBAAA;EAppVF;;EAupVA;IACE,oBAAA;EArpVF;;EAwpVA;IACE,oBAAA;EAtpVF;;EAypVA;IACE,oBAAA;EAvpVF;;EA0pVA;IACE,kBAAA;EAxpVF;;EA2pVA;IACE,mBAAA;EAzpVF;;EA4pVA;IACE,sBAAA;EA1pVF;;EA6pVA;IACE,qBAAA;EA3pVF;;EA8pVA;IACE,sBAAA;EA5pVF;;EA+pVA;IACE,mBAAA;EA7pVF;;EAgqVA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;EA9pVF;;EAiqVA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EA/pVF;;EAkqVA;IACE,kBAAA;IACA,UAAA;IACA,WAAA;IACA,UAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;EAhqVF;;EAmqVA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;IACA,iBAAA;IACA,UAAA;IACA,mBAAA;EAjqVF;;EAoqVA;IACE,gBAAA;EAlqVF;;EAqqVA;IACE,4BAAA;EAnqVF;;EAsqVA;IACE,4BAAA;EApqVF;;EAuqVA;IACE,6BAAA;EArqVF;;EAwqVA;IACE,2BAAA;EAtqVF;;EAyqVA;IACE,4BAAA;EAvqVF;;EA0qVA;IACE,4BAAA;EAxqVF;;EA2qVA;IACE,6BAAA;IACQ,qBAAA;EAzqVV;;EA4qVA;IACE,6BAAA;EA1qVF;;EA6qVA;IACE,8BAAA;EA3qVF;;EA8qVA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA5qVF;;EA+qVA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA7qVF;;EAgrVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9qVF;;EAirVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/qVF;;EAkrVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhrVF;;EAmrVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjrVF;;EAorVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlrVF;;EAqrVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnrVF;;EAsrVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAprVF;;EAurVA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EArrVF;;EAwrVA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAtrVF;;EAyrVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvrVF;;EA0rVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxrVF;;EA2rVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzrVF;;EA4rVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1rVF;;EA6rVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3rVF;;EA8rVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5rVF;;EA+rVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7rVF;;EAgsVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9rVF;;EAisVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/rVF;;EAksVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhsVF;;EAmsVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjsVF;;EAosVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlsVF;;EAqsVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAnsVF;;EAssVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApsVF;;EAusVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EArsVF;;EAwsVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtsVF;;EAysVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvsVF;;EA0sVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxsVF;;EA2sVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzsVF;;EA4sVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1sVF;;EA6sVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3sVF;;EA8sVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5sVF;;EA+sVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7sVF;;EAgtVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9sVF;;EAitVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/sVF;;EAktVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAhtVF;;EAmtVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAjtVF;;EAotVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAltVF;;EAqtVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAntVF;;EAstVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAptVF;;EAutVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArtVF;;EAwtVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAttVF;;EAytVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvtVF;;EA0tVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAxtVF;;EA2tVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAztVF;;EA4tVA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA1tVF;;EA6tVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3tVF;;EA8tVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5tVF;;EA+tVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7tVF;;EAguVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9tVF;;EAiuVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/tVF;;EAkuVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAhuVF;;EAmuVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjuVF;;EAouVA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAluVF;;EAquVA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAnuVF;;EAsuVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EApuVF;;EAuuVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAruVF;;EAwuVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtuVF;;EAyuVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAvuVF;;EA0uVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAxuVF;;EA2uVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAzuVF;;EA4uVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1uVF;;EA6uVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3uVF;;EA8uVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5uVF;;EA+uVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7uVF;;EAgvVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9uVF;;EAivVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/uVF;;EAkvVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhvVF;;EAmvVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjvVF;;EAovVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAlvVF;;EAqvVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAnvVF;;EAsvVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EApvVF;;EAuvVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EArvVF;;EAwvVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtvVF;;EAyvVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvvVF;;EA0vVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxvVF;;EA2vVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzvVF;;EA4vVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1vVF;;EA6vVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA3vVF;;EA8vVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5vVF;;EA+vVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7vVF;;EAgwVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9vVF;;EAiwVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/vVF;;EAkwVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhwVF;;EAmwVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjwVF;;EAowVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlwVF;;EAqwVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnwVF;;EAswVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApwVF;;EAuwVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EArwVF;;EAwwVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAtwVF;;EAywVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvwVF;;EA0wVA;IACE,6BAAA;EAxwVF;;EA2wVA;IACE,8BAAA;EAzwVF;;EA4wVA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EA1wVF;;EA6wVA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EA3wVF;;EA8wVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA5wVF;;EA+wVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA7wVF;;EAgxVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9wVF;;EAixVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/wVF;;EAkxVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhxVF;;EAmxVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjxVF;;EAoxVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAlxVF;;EAqxVA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAnxVF;;EAsxVA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EApxVF;;EAuxVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EArxVF;;EAwxVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAtxVF;;EAyxVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvxVF;;EA0xVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxxVF;;EA2xVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzxVF;;EA4xVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA1xVF;;EA6xVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA3xVF;;EA8xVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA5xVF;;EA+xVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA7xVF;;EAgyVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA9xVF;;EAiyVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/xVF;;EAkyVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhyVF;;EAmyVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAjyVF;;EAoyVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAlyVF;;EAqyVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAnyVF;;EAsyVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EApyVF;;EAuyVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAryVF;;EAwyVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtyVF;;EAyyVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAvyVF;;EA0yVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAxyVF;;EA2yVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzyVF;;EA4yVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA1yVF;;EA6yVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA3yVF;;EA8yVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5yVF;;EA+yVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7yVF;;EAgzVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA9yVF;;EAizVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/yVF;;EAkzVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAhzVF;;EAmzVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAjzVF;;EAozVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAlzVF;;EAqzVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAnzVF;;EAszVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EApzVF;;EAuzVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EArzVF;;EAwzVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAtzVF;;EAyzVA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAvzVF;;EA0zVA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAxzVF;;EA2zVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAzzVF;;EA4zVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA1zVF;;EA6zVA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA3zVF;;EA8zVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA5zVF;;EA+zVA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA7zVF;;EAg0VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA9zVF;;EAi0VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/zVF;;EAk0VA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAh0VF;;EAm0VA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAj0VF;;EAo0VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl0VF;;EAq0VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn0VF;;EAs0VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp0VF;;EAu0VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr0VF;;EAw0VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt0VF;;EAy0VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAv0VF;;EA00VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAx0VF;;EA20VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAz0VF;;EA40VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA10VF;;EA60VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA30VF;;EA80VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA50VF;;EA+0VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA70VF;;EAg1VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA90VF;;EAi1VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/0VF;;EAk1VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAh1VF;;EAm1VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAj1VF;;EAo1VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAl1VF;;EAq1VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAn1VF;;EAs1VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp1VF;;EAu1VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr1VF;;EAw1VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt1VF;;EAy1VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv1VF;;EA01VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx1VF;;EA21VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAz1VF;;EA41VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA11VF;;EA61VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA31VF;;EA81VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA51VF;;EA+1VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA71VF;;EAg2VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA91VF;;EAi2VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/1VF;;EAk2VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh2VF;;EAm2VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj2VF;;EAo2VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAl2VF;;EAq2VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn2VF;;EAs2VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp2VF;;EAu2VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAr2VF;;EAw2VA;IACE,6BAAA;EAt2VF;;EAy2VA;IACE,8BAAA;EAv2VF;;EA02VA;IACE,eAAA;IACA,sBAAA;IACA,kDAAA;EAx2VF;;EA22VA;IACE,eAAA;IACA,sBAAA;IACA,wDAAA;EAz2VF;;EA42VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA12VF;;EA62VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA32VF;;EA82VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA52VF;;EA+2VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA72VF;;EAg3VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA92VF;;EAi3VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/2VF;;EAk3VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAh3VF;;EAm3VA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAj3VF;;EAo3VA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAl3VF;;EAq3VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn3VF;;EAs3VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp3VF;;EAu3VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr3VF;;EAw3VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt3VF;;EAy3VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv3VF;;EA03VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAx3VF;;EA23VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAz3VF;;EA43VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA13VF;;EA63VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA33VF;;EA83VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA53VF;;EA+3VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA73VF;;EAg4VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA93VF;;EAi4VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA/3VF;;EAk4VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAh4VF;;EAm4VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAj4VF;;EAo4VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAl4VF;;EAq4VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAn4VF;;EAs4VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAp4VF;;EAu4VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr4VF;;EAw4VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt4VF;;EAy4VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv4VF;;EA04VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAx4VF;;EA24VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAz4VF;;EA44VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA14VF;;EA64VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA34VF;;EA84VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA54VF;;EA+4VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA74VF;;EAg5VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA94VF;;EAi5VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/4VF;;EAk5VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh5VF;;EAm5VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj5VF;;EAo5VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAl5VF;;EAq5VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn5VF;;EAs5VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAp5VF;;EAu5VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAr5VF;;EAw5VA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EAt5VF;;EAy5VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAv5VF;;EA05VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAx5VF;;EA25VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz5VF;;EA45VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA15VF;;EA65VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA35VF;;EA85VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA55VF;;EA+5VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA75VF;;EAg6VA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA95VF;;EAi6VA;IACE,eAAA;IACA,yBAAA;IACA,qDAAA;EA/5VF;;EAk6VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAh6VF;;EAm6VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAj6VF;;EAo6VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl6VF;;EAq6VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAn6VF;;EAs6VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAp6VF;;EAu6VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAr6VF;;EAw6VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAt6VF;;EAy6VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAv6VF;;EA06VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAx6VF;;EA26VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAz6VF;;EA46VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA16VF;;EA66VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA36VF;;EA86VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA56VF;;EA+6VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA76VF;;EAg7VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EA96VF;;EAi7VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA/6VF;;EAk7VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAh7VF;;EAm7VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAj7VF;;EAo7VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAl7VF;;EAq7VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAn7VF;;EAs7VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAp7VF;;EAu7VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAr7VF;;EAw7VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EAt7VF;;EAy7VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAv7VF;;EA07VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAx7VF;;EA27VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAz7VF;;EA47VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EA17VF;;EA67VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA37VF;;EA87VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA57VF;;EA+7VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA77VF;;EAg8VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA97VF;;EAi8VA;IACE,eAAA;IACA,yBAAA;IACA,wDAAA;EA/7VF;;EAk8VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAh8VF;;EAm8VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAj8VF;;EAo8VA;IACE,eAAA;IACA,yBAAA;IACA,uDAAA;EAl8VF;;EAq8VA;IACE,eAAA;IACA,yBAAA;IACA,sDAAA;EAn8VF;;EAs8VA;IACE,sBAAA;EAp8VF;;EAu8VA;IACE,sEAAA;EAr8VF;;EAw8VA;IACE,4EAAA;EAt8VF;;EAy8VA;IACE,wEAAA;EAv8VF;;EA08VA;IACE,+EAAA;EAx8VF;;EA28VA;IACE,yEAAA;EAz8VF;;EA48VA;IACE,8EAAA;EA18VF;;EA68VA;IACE,uEAAA;EA38VF;;EA88VA;IACE,2EAAA;EA58VF;;EA+8VA;IACE,kCAAA;IACA,8FAAA;EA78VF;;EAg9VA;IACE,mCAAA;IACA,oGAAA;EA98VF;;EAi9VA;IACE,2BAAA;IACA,8FAAA;EA/8VF;;EAk9VA;IACE,2BAAA;IACA,oGAAA;EAh9VF;;EAm9VA;IACE,8BAAA;IACA,oGAAA;EAj9VF;;EAo9VA;IACE,8BAAA;IACA,oGAAA;EAl9VF;;EAq9VA;IACE,8BAAA;IACA,oGAAA;EAn9VF;;EAs9VA;IACE,8BAAA;IACA,oGAAA;EAp9VF;;EAu9VA;IACE,8BAAA;IACA,oGAAA;EAr9VF;;EAw9VA;IACE,8BAAA;IACA,oGAAA;EAt9VF;;EAy9VA;IACE,8BAAA;IACA,kGAAA;EAv9VF;;EA09VA;IACE,8BAAA;IACA,iGAAA;EAx9VF;;EA29VA;IACE,8BAAA;IACA,iGAAA;EAz9VF;;EA49VA;IACE,8BAAA;IACA,oGAAA;EA19VF;;EA69VA;IACE,8BAAA;IACA,oGAAA;EA39VF;;EA89VA;IACE,8BAAA;IACA,oGAAA;EA59VF;;EA+9VA;IACE,8BAAA;IACA,oGAAA;EA79VF;;EAg+VA;IACE,8BAAA;IACA,oGAAA;EA99VF;;EAi+VA;IACE,8BAAA;IACA,kGAAA;EA/9VF;;EAk+VA;IACE,8BAAA;IACA,kGAAA;EAh+VF;;EAm+VA;IACE,8BAAA;IACA,kGAAA;EAj+VF;;EAo+VA;IACE,8BAAA;IACA,kGAAA;EAl+VF;;EAq+VA;IACE,8BAAA;IACA,oGAAA;EAn+VF;;EAs+VA;IACE,8BAAA;IACA,oGAAA;EAp+VF;;EAu+VA;IACE,8BAAA;IACA,oGAAA;EAr+VF;;EAw+VA;IACE,8BAAA;IACA,mGAAA;EAt+VF;;EAy+VA;IACE,8BAAA;IACA,mGAAA;EAv+VF;;EA0+VA;IACE,8BAAA;IACA,mGAAA;EAx+VF;;EA2+VA;IACE,8BAAA;IACA,kGAAA;EAz+VF;;EA4+VA;IACE,8BAAA;IACA,kGAAA;EA1+VF;;EA6+VA;IACE,8BAAA;IACA,kGAAA;EA3+VF;;EA8+VA;IACE,8BAAA;IACA,oGAAA;EA5+VF;;EA++VA;IACE,8BAAA;IACA,oGAAA;EA7+VF;;EAg/VA;IACE,8BAAA;IACA,oGAAA;EA9+VF;;EAi/VA;IACE,8BAAA;IACA,mGAAA;EA/+VF;;EAk/VA;IACE,8BAAA;IACA,mGAAA;EAh/VF;;EAm/VA;IACE,8BAAA;IACA,mGAAA;EAj/VF;;EAo/VA;IACE,8BAAA;IACA,mGAAA;EAl/VF;;EAq/VA;IACE,8BAAA;IACA,kGAAA;EAn/VF;;EAs/VA;IACE,8BAAA;IACA,kGAAA;EAp/VF;;EAu/VA;IACE,8BAAA;IACA,oGAAA;EAr/VF;;EAw/VA;IACE,8BAAA;IACA,oGAAA;EAt/VF;;EAy/VA;IACE,8BAAA;IACA,oGAAA;EAv/VF;;EA0/VA;IACE,8BAAA;IACA,oGAAA;EAx/VF;;EA2/VA;IACE,8BAAA;IACA,mGAAA;EAz/VF;;EA4/VA;IACE,8BAAA;IACA,mGAAA;EA1/VF;;EA6/VA;IACE,8BAAA;IACA,kGAAA;EA3/VF;;EA8/VA;IACE,8BAAA;IACA,kGAAA;EA5/VF;;EA+/VA;IACE,8BAAA;IACA,iGAAA;EA7/VF;;EAggWA;IACE,8BAAA;IACA,oGAAA;EA9/VF;;EAigWA;IACE,8BAAA;IACA,oGAAA;EA//VF;;EAkgWA;IACE,8BAAA;IACA,oGAAA;EAhgWF;;EAmgWA;IACE,8BAAA;IACA,mGAAA;EAjgWF;;EAogWA;IACE,8BAAA;IACA,mGAAA;EAlgWF;;EAqgWA;IACE,8BAAA;IACA,mGAAA;EAngWF;;EAsgWA;IACE,8BAAA;IACA,mGAAA;EApgWF;;EAugWA;IACE,8BAAA;IACA,iGAAA;EArgWF;;EAwgWA;IACE,8BAAA;IACA,iGAAA;EAtgWF;;EAygWA;IACE,8BAAA;IACA,oGAAA;EAvgWF;;EA0gWA;IACE,8BAAA;IACA,oGAAA;EAxgWF;;EA2gWA;IACE,8BAAA;IACA,oGAAA;EAzgWF;;EA4gWA;IACE,8BAAA;IACA,mGAAA;EA1gWF;;EA6gWA;IACE,8BAAA;IACA,mGAAA;EA3gWF;;EA8gWA;IACE,8BAAA;IACA,mGAAA;EA5gWF;;EA+gWA;IACE,8BAAA;IACA,mGAAA;EA7gWF;;EAghWA;IACE,8BAAA;IACA,kGAAA;EA9gWF;;EAihWA;IACE,8BAAA;IACA,kGAAA;EA/gWF;;EAkhWA;IACE,8BAAA;IACA,oGAAA;EAhhWF;;EAmhWA;IACE,8BAAA;IACA,oGAAA;EAjhWF;;EAohWA;IACE,8BAAA;IACA,oGAAA;EAlhWF;;EAqhWA;IACE,8BAAA;IACA,oGAAA;EAnhWF;;EAshWA;IACE,8BAAA;IACA,oGAAA;EAphWF;;EAuhWA;IACE,8BAAA;IACA,mGAAA;EArhWF;;EAwhWA;IACE,8BAAA;IACA,kGAAA;EAthWF;;EAyhWA;IACE,8BAAA;IACA,kGAAA;EAvhWF;;EA0hWA;IACE,8BAAA;IACA,kGAAA;EAxhWF;;EA2hWA;IACE,8BAAA;IACA,oGAAA;EAzhWF;;EA4hWA;IACE,8BAAA;IACA,oGAAA;EA1hWF;;EA6hWA;IACE,8BAAA;IACA,oGAAA;EA3hWF;;EA8hWA;IACE,8BAAA;IACA,oGAAA;EA5hWF;;EA+hWA;IACE,8BAAA;IACA,oGAAA;EA7hWF;;EAgiWA;IACE,8BAAA;IACA,mGAAA;EA9hWF;;EAiiWA;IACE,8BAAA;IACA,mGAAA;EA/hWF;;EAkiWA;IACE,8BAAA;IACA,kGAAA;EAhiWF;;EAmiWA;IACE,8BAAA;IACA,kGAAA;EAjiWF;;EAoiWA;IACE,8BAAA;IACA,oGAAA;EAliWF;;EAqiWA;IACE,8BAAA;IACA,oGAAA;EAniWF;;EAsiWA;IACE,8BAAA;IACA,oGAAA;EApiWF;;EAuiWA;IACE,8BAAA;IACA,oGAAA;EAriWF;;EAwiWA;IACE,8BAAA;IACA,oGAAA;EAtiWF;;EAyiWA;IACE,8BAAA;IACA,mGAAA;EAviWF;;EA0iWA;IACE,8BAAA;IACA,mGAAA;EAxiWF;;EA2iWA;IACE,8BAAA;IACA,mGAAA;EAziWF;;EA4iWA;IACE,8BAAA;IACA,kGAAA;EA1iWF;;EA6iWA;IACE,iCAAA;IACA,yHAAA;EA3iWF;;EA8iWA;IACE,kCAAA;IACA,+HAAA;EA5iWF;;EA+iWA;IACE,0BAAA;IACA,yHAAA;EA7iWF;;EAgjWA;IACE,0BAAA;IACA,+HAAA;EA9iWF;;EAijWA;IACE,6BAAA;IACA,+HAAA;EA/iWF;;EAkjWA;IACE,6BAAA;IACA,+HAAA;EAhjWF;;EAmjWA;IACE,6BAAA;IACA,+HAAA;EAjjWF;;EAojWA;IACE,6BAAA;IACA,+HAAA;EAljWF;;EAqjWA;IACE,6BAAA;IACA,+HAAA;EAnjWF;;EAsjWA;IACE,6BAAA;IACA,+HAAA;EApjWF;;EAujWA;IACE,6BAAA;IACA,6HAAA;EArjWF;;EAwjWA;IACE,6BAAA;IACA,4HAAA;EAtjWF;;EAyjWA;IACE,6BAAA;IACA,4HAAA;EAvjWF;;EA0jWA;IACE,6BAAA;IACA,+HAAA;EAxjWF;;EA2jWA;IACE,6BAAA;IACA,+HAAA;EAzjWF;;EA4jWA;IACE,6BAAA;IACA,+HAAA;EA1jWF;;EA6jWA;IACE,6BAAA;IACA,+HAAA;EA3jWF;;EA8jWA;IACE,6BAAA;IACA,+HAAA;EA5jWF;;EA+jWA;IACE,6BAAA;IACA,6HAAA;EA7jWF;;EAgkWA;IACE,6BAAA;IACA,6HAAA;EA9jWF;;EAikWA;IACE,6BAAA;IACA,6HAAA;EA/jWF;;EAkkWA;IACE,6BAAA;IACA,6HAAA;EAhkWF;;EAmkWA;IACE,6BAAA;IACA,+HAAA;EAjkWF;;EAokWA;IACE,6BAAA;IACA,+HAAA;EAlkWF;;EAqkWA;IACE,6BAAA;IACA,+HAAA;EAnkWF;;EAskWA;IACE,6BAAA;IACA,8HAAA;EApkWF;;EAukWA;IACE,6BAAA;IACA,8HAAA;EArkWF;;EAwkWA;IACE,6BAAA;IACA,8HAAA;EAtkWF;;EAykWA;IACE,6BAAA;IACA,6HAAA;EAvkWF;;EA0kWA;IACE,6BAAA;IACA,6HAAA;EAxkWF;;EA2kWA;IACE,6BAAA;IACA,6HAAA;EAzkWF;;EA4kWA;IACE,6BAAA;IACA,+HAAA;EA1kWF;;EA6kWA;IACE,6BAAA;IACA,+HAAA;EA3kWF;;EA8kWA;IACE,6BAAA;IACA,+HAAA;EA5kWF;;EA+kWA;IACE,6BAAA;IACA,8HAAA;EA7kWF;;EAglWA;IACE,6BAAA;IACA,8HAAA;EA9kWF;;EAilWA;IACE,6BAAA;IACA,8HAAA;EA/kWF;;EAklWA;IACE,6BAAA;IACA,8HAAA;EAhlWF;;EAmlWA;IACE,6BAAA;IACA,6HAAA;EAjlWF;;EAolWA;IACE,6BAAA;IACA,6HAAA;EAllWF;;EAqlWA;IACE,6BAAA;IACA,+HAAA;EAnlWF;;EAslWA;IACE,6BAAA;IACA,+HAAA;EAplWF;;EAulWA;IACE,6BAAA;IACA,+HAAA;EArlWF;;EAwlWA;IACE,6BAAA;IACA,+HAAA;EAtlWF;;EAylWA;IACE,6BAAA;IACA,8HAAA;EAvlWF;;EA0lWA;IACE,6BAAA;IACA,8HAAA;EAxlWF;;EA2lWA;IACE,6BAAA;IACA,6HAAA;EAzlWF;;EA4lWA;IACE,6BAAA;IACA,6HAAA;EA1lWF;;EA6lWA;IACE,6BAAA;IACA,4HAAA;EA3lWF;;EA8lWA;IACE,6BAAA;IACA,+HAAA;EA5lWF;;EA+lWA;IACE,6BAAA;IACA,+HAAA;EA7lWF;;EAgmWA;IACE,6BAAA;IACA,+HAAA;EA9lWF;;EAimWA;IACE,6BAAA;IACA,8HAAA;EA/lWF;;EAkmWA;IACE,6BAAA;IACA,8HAAA;EAhmWF;;EAmmWA;IACE,6BAAA;IACA,8HAAA;EAjmWF;;EAomWA;IACE,6BAAA;IACA,8HAAA;EAlmWF;;EAqmWA;IACE,6BAAA;IACA,4HAAA;EAnmWF;;EAsmWA;IACE,6BAAA;IACA,4HAAA;EApmWF;;EAumWA;IACE,6BAAA;IACA,+HAAA;EArmWF;;EAwmWA;IACE,6BAAA;IACA,+HAAA;EAtmWF;;EAymWA;IACE,6BAAA;IACA,+HAAA;EAvmWF;;EA0mWA;IACE,6BAAA;IACA,8HAAA;EAxmWF;;EA2mWA;IACE,6BAAA;IACA,8HAAA;EAzmWF;;EA4mWA;IACE,6BAAA;IACA,8HAAA;EA1mWF;;EA6mWA;IACE,6BAAA;IACA,8HAAA;EA3mWF;;EA8mWA;IACE,6BAAA;IACA,6HAAA;EA5mWF;;EA+mWA;IACE,6BAAA;IACA,6HAAA;EA7mWF;;EAgnWA;IACE,6BAAA;IACA,+HAAA;EA9mWF;;EAinWA;IACE,6BAAA;IACA,+HAAA;EA/mWF;;EAknWA;IACE,6BAAA;IACA,+HAAA;EAhnWF;;EAmnWA;IACE,6BAAA;IACA,+HAAA;EAjnWF;;EAonWA;IACE,6BAAA;IACA,+HAAA;EAlnWF;;EAqnWA;IACE,6BAAA;IACA,8HAAA;EAnnWF;;EAsnWA;IACE,6BAAA;IACA,6HAAA;EApnWF;;EAunWA;IACE,6BAAA;IACA,6HAAA;EArnWF;;EAwnWA;IACE,6BAAA;IACA,6HAAA;EAtnWF;;EAynWA;IACE,6BAAA;IACA,+HAAA;EAvnWF;;EA0nWA;IACE,6BAAA;IACA,+HAAA;EAxnWF;;EA2nWA;IACE,6BAAA;IACA,+HAAA;EAznWF;;EA4nWA;IACE,6BAAA;IACA,+HAAA;EA1nWF;;EA6nWA;IACE,6BAAA;IACA,+HAAA;EA3nWF;;EA8nWA;IACE,6BAAA;IACA,8HAAA;EA5nWF;;EA+nWA;IACE,6BAAA;IACA,8HAAA;EA7nWF;;EAgoWA;IACE,6BAAA;IACA,6HAAA;EA9nWF;;EAioWA;IACE,6BAAA;IACA,6HAAA;EA/nWF;;EAkoWA;IACE,6BAAA;IACA,+HAAA;EAhoWF;;EAmoWA;IACE,6BAAA;IACA,+HAAA;EAjoWF;;EAooWA;IACE,6BAAA;IACA,+HAAA;EAloWF;;EAqoWA;IACE,6BAAA;IACA,+HAAA;EAnoWF;;EAsoWA;IACE,6BAAA;IACA,+HAAA;EApoWF;;EAuoWA;IACE,6BAAA;IACA,8HAAA;EAroWF;;EAwoWA;IACE,6BAAA;IACA,8HAAA;EAtoWF;;EAyoWA;IACE,6BAAA;IACA,8HAAA;EAvoWF;;EA0oWA;IACE,6BAAA;IACA,6HAAA;EAxoWF;;EA2oWA;IACE,gCAAA;EAzoWF;;EA4oWA;IACE,iCAAA;EA1oWF;;EA6oWA;IACE,yBAAA;EA3oWF;;EA8oWA;IACE,yBAAA;EA5oWF;;EA+oWA;IACE,4BAAA;EA7oWF;;EAgpWA;IACE,4BAAA;EA9oWF;;EAipWA;IACE,4BAAA;EA/oWF;;EAkpWA;IACE,4BAAA;EAhpWF;;EAmpWA;IACE,4BAAA;EAjpWF;;EAopWA;IACE,4BAAA;EAlpWF;;EAqpWA;IACE,4BAAA;EAnpWF;;EAspWA;IACE,4BAAA;EAppWF;;EAupWA;IACE,4BAAA;EArpWF;;EAwpWA;IACE,4BAAA;EAtpWF;;EAypWA;IACE,4BAAA;EAvpWF;;EA0pWA;IACE,4BAAA;EAxpWF;;EA2pWA;IACE,4BAAA;EAzpWF;;EA4pWA;IACE,4BAAA;EA1pWF;;EA6pWA;IACE,4BAAA;EA3pWF;;EA8pWA;IACE,4BAAA;EA5pWF;;EA+pWA;IACE,4BAAA;EA7pWF;;EAgqWA;IACE,4BAAA;EA9pWF;;EAiqWA;IACE,4BAAA;EA/pWF;;EAkqWA;IACE,4BAAA;EAhqWF;;EAmqWA;IACE,4BAAA;EAjqWF;;EAoqWA;IACE,4BAAA;EAlqWF;;EAqqWA;IACE,4BAAA;EAnqWF;;EAsqWA;IACE,4BAAA;EApqWF;;EAuqWA;IACE,4BAAA;EArqWF;;EAwqWA;IACE,4BAAA;EAtqWF;;EAyqWA;IACE,4BAAA;EAvqWF;;EA0qWA;IACE,4BAAA;EAxqWF;;EA2qWA;IACE,4BAAA;EAzqWF;;EA4qWA;IACE,4BAAA;EA1qWF;;EA6qWA;IACE,4BAAA;EA3qWF;;EA8qWA;IACE,4BAAA;EA5qWF;;EA+qWA;IACE,4BAAA;EA7qWF;;EAgrWA;IACE,4BAAA;EA9qWF;;EAirWA;IACE,4BAAA;EA/qWF;;EAkrWA;IACE,4BAAA;EAhrWF;;EAmrWA;IACE,4BAAA;EAjrWF;;EAorWA;IACE,4BAAA;EAlrWF;;EAqrWA;IACE,4BAAA;EAnrWF;;EAsrWA;IACE,4BAAA;EAprWF;;EAurWA;IACE,4BAAA;EArrWF;;EAwrWA;IACE,4BAAA;EAtrWF;;EAyrWA;IACE,4BAAA;EAvrWF;;EA0rWA;IACE,4BAAA;EAxrWF;;EA2rWA;IACE,4BAAA;EAzrWF;;EA4rWA;IACE,4BAAA;EA1rWF;;EA6rWA;IACE,4BAAA;EA3rWF;;EA8rWA;IACE,4BAAA;EA5rWF;;EA+rWA;IACE,4BAAA;EA7rWF;;EAgsWA;IACE,4BAAA;EA9rWF;;EAisWA;IACE,4BAAA;EA/rWF;;EAksWA;IACE,4BAAA;EAhsWF;;EAmsWA;IACE,4BAAA;EAjsWF;;EAosWA;IACE,4BAAA;EAlsWF;;EAqsWA;IACE,4BAAA;EAnsWF;;EAssWA;IACE,4BAAA;EApsWF;;EAusWA;IACE,4BAAA;EArsWF;;EAwsWA;IACE,4BAAA;EAtsWF;;EAysWA;IACE,4BAAA;EAvsWF;;EA0sWA;IACE,4BAAA;EAxsWF;;EA2sWA;IACE,4BAAA;EAzsWF;;EA4sWA;IACE,4BAAA;EA1sWF;;EA6sWA;IACE,4BAAA;EA3sWF;;EA8sWA;IACE,4BAAA;EA5sWF;;EA+sWA;IACE,4BAAA;EA7sWF;;EAgtWA;IACE,4BAAA;EA9sWF;;EAitWA;IACE,4BAAA;EA/sWF;;EAktWA;IACE,4BAAA;EAhtWF;;EAmtWA;IACE,4BAAA;EAjtWF;;EAotWA;IACE,4BAAA;EAltWF;;EAqtWA;IACE,4BAAA;EAntWF;;EAstWA;IACE,4BAAA;EAptWF;;EAutWA;IACE,4BAAA;EArtWF;;EAwtWA;IACE,4BAAA;EAttWF;;EAytWA;IACE,4BAAA;EAvtWF;;EA0tWA;IACE,4BAAA;EAxtWF;;EA2tWA;IACE,4BAAA;EAztWF;;EA4tWA;IACE,4BAAA;EA1tWF;;EA6tWA;IACE,4BAAA;EA3tWF;;EA8tWA;IACE,4BAAA;EA5tWF;;EA+tWA;IACE,4BAAA;EA7tWF;;EAguWA;IACE,4BAAA;EA9tWF;;EAiuWA;IACE,4BAAA;EA/tWF;;EAkuWA;IACE,4BAAA;EAhuWF;;EAmuWA;IACE,4BAAA;EAjuWF;;EAouWA;IACE,4BAAA;EAluWF;;EAquWA;IACE,4BAAA;EAnuWF;;EAsuWA;IACE,4BAAA;EApuWF;;EAuuWA;IACE,4BAAA;EAruWF;;EAwuWA;IACE,4BAAA;EAtuWF;;EAyuWA;IACE,kCAAA;IACA,8FAAA;EAvuWF;;EA0uWA;IACE,mCAAA;IACA,oGAAA;EAxuWF;;EA2uWA;IACE,2BAAA;IACA,8FAAA;EAzuWF;;EA4uWA;IACE,2BAAA;IACA,oGAAA;EA1uWF;;EA6uWA;IACE,8BAAA;IACA,oGAAA;EA3uWF;;EA8uWA;IACE,8BAAA;IACA,oGAAA;EA5uWF;;EA+uWA;IACE,8BAAA;IACA,oGAAA;EA7uWF;;EAgvWA;IACE,8BAAA;IACA,oGAAA;EA9uWF;;EAivWA;IACE,8BAAA;IACA,oGAAA;EA/uWF;;EAkvWA;IACE,8BAAA;IACA,oGAAA;EAhvWF;;EAmvWA;IACE,8BAAA;IACA,kGAAA;EAjvWF;;EAovWA;IACE,8BAAA;IACA,iGAAA;EAlvWF;;EAqvWA;IACE,8BAAA;IACA,iGAAA;EAnvWF;;EAsvWA;IACE,8BAAA;IACA,oGAAA;EApvWF;;EAuvWA;IACE,8BAAA;IACA,oGAAA;EArvWF;;EAwvWA;IACE,8BAAA;IACA,oGAAA;EAtvWF;;EAyvWA;IACE,8BAAA;IACA,oGAAA;EAvvWF;;EA0vWA;IACE,8BAAA;IACA,oGAAA;EAxvWF;;EA2vWA;IACE,8BAAA;IACA,kGAAA;EAzvWF;;EA4vWA;IACE,8BAAA;IACA,kGAAA;EA1vWF;;EA6vWA;IACE,8BAAA;IACA,kGAAA;EA3vWF;;EA8vWA;IACE,8BAAA;IACA,kGAAA;EA5vWF;;EA+vWA;IACE,8BAAA;IACA,oGAAA;EA7vWF;;EAgwWA;IACE,8BAAA;IACA,oGAAA;EA9vWF;;EAiwWA;IACE,8BAAA;IACA,oGAAA;EA/vWF;;EAkwWA;IACE,8BAAA;IACA,mGAAA;EAhwWF;;EAmwWA;IACE,8BAAA;IACA,mGAAA;EAjwWF;;EAowWA;IACE,8BAAA;IACA,mGAAA;EAlwWF;;EAqwWA;IACE,8BAAA;IACA,kGAAA;EAnwWF;;EAswWA;IACE,8BAAA;IACA,kGAAA;EApwWF;;EAuwWA;IACE,8BAAA;IACA,kGAAA;EArwWF;;EAwwWA;IACE,8BAAA;IACA,oGAAA;EAtwWF;;EAywWA;IACE,8BAAA;IACA,oGAAA;EAvwWF;;EA0wWA;IACE,8BAAA;IACA,oGAAA;EAxwWF;;EA2wWA;IACE,8BAAA;IACA,mGAAA;EAzwWF;;EA4wWA;IACE,8BAAA;IACA,mGAAA;EA1wWF;;EA6wWA;IACE,8BAAA;IACA,mGAAA;EA3wWF;;EA8wWA;IACE,8BAAA;IACA,mGAAA;EA5wWF;;EA+wWA;IACE,8BAAA;IACA,kGAAA;EA7wWF;;EAgxWA;IACE,8BAAA;IACA,kGAAA;EA9wWF;;EAixWA;IACE,8BAAA;IACA,oGAAA;EA/wWF;;EAkxWA;IACE,8BAAA;IACA,oGAAA;EAhxWF;;EAmxWA;IACE,8BAAA;IACA,oGAAA;EAjxWF;;EAoxWA;IACE,8BAAA;IACA,oGAAA;EAlxWF;;EAqxWA;IACE,8BAAA;IACA,mGAAA;EAnxWF;;EAsxWA;IACE,8BAAA;IACA,mGAAA;EApxWF;;EAuxWA;IACE,8BAAA;IACA,kGAAA;EArxWF;;EAwxWA;IACE,8BAAA;IACA,kGAAA;EAtxWF;;EAyxWA;IACE,8BAAA;IACA,iGAAA;EAvxWF;;EA0xWA;IACE,8BAAA;IACA,oGAAA;EAxxWF;;EA2xWA;IACE,8BAAA;IACA,oGAAA;EAzxWF;;EA4xWA;IACE,8BAAA;IACA,oGAAA;EA1xWF;;EA6xWA;IACE,8BAAA;IACA,mGAAA;EA3xWF;;EA8xWA;IACE,8BAAA;IACA,mGAAA;EA5xWF;;EA+xWA;IACE,8BAAA;IACA,mGAAA;EA7xWF;;EAgyWA;IACE,8BAAA;IACA,mGAAA;EA9xWF;;EAiyWA;IACE,8BAAA;IACA,iGAAA;EA/xWF;;EAkyWA;IACE,8BAAA;IACA,iGAAA;EAhyWF;;EAmyWA;IACE,8BAAA;IACA,oGAAA;EAjyWF;;EAoyWA;IACE,8BAAA;IACA,oGAAA;EAlyWF;;EAqyWA;IACE,8BAAA;IACA,oGAAA;EAnyWF;;EAsyWA;IACE,8BAAA;IACA,mGAAA;EApyWF;;EAuyWA;IACE,8BAAA;IACA,mGAAA;EAryWF;;EAwyWA;IACE,8BAAA;IACA,mGAAA;EAtyWF;;EAyyWA;IACE,8BAAA;IACA,mGAAA;EAvyWF;;EA0yWA;IACE,8BAAA;IACA,kGAAA;EAxyWF;;EA2yWA;IACE,8BAAA;IACA,kGAAA;EAzyWF;;EA4yWA;IACE,8BAAA;IACA,oGAAA;EA1yWF;;EA6yWA;IACE,8BAAA;IACA,oGAAA;EA3yWF;;EA8yWA;IACE,8BAAA;IACA,oGAAA;EA5yWF;;EA+yWA;IACE,8BAAA;IACA,oGAAA;EA7yWF;;EAgzWA;IACE,8BAAA;IACA,oGAAA;EA9yWF;;EAizWA;IACE,8BAAA;IACA,mGAAA;EA/yWF;;EAkzWA;IACE,8BAAA;IACA,kGAAA;EAhzWF;;EAmzWA;IACE,8BAAA;IACA,kGAAA;EAjzWF;;EAozWA;IACE,8BAAA;IACA,kGAAA;EAlzWF;;EAqzWA;IACE,8BAAA;IACA,oGAAA;EAnzWF;;EAszWA;IACE,8BAAA;IACA,oGAAA;EApzWF;;EAuzWA;IACE,8BAAA;IACA,oGAAA;EArzWF;;EAwzWA;IACE,8BAAA;IACA,oGAAA;EAtzWF;;EAyzWA;IACE,8BAAA;IACA,oGAAA;EAvzWF;;EA0zWA;IACE,8BAAA;IACA,mGAAA;EAxzWF;;EA2zWA;IACE,8BAAA;IACA,mGAAA;EAzzWF;;EA4zWA;IACE,8BAAA;IACA,kGAAA;EA1zWF;;EA6zWA;IACE,8BAAA;IACA,kGAAA;EA3zWF;;EA8zWA;IACE,8BAAA;IACA,oGAAA;EA5zWF;;EA+zWA;IACE,8BAAA;IACA,oGAAA;EA7zWF;;EAg0WA;IACE,8BAAA;IACA,oGAAA;EA9zWF;;EAi0WA;IACE,8BAAA;IACA,oGAAA;EA/zWF;;EAk0WA;IACE,8BAAA;IACA,oGAAA;EAh0WF;;EAm0WA;IACE,8BAAA;IACA,mGAAA;EAj0WF;;EAo0WA;IACE,8BAAA;IACA,mGAAA;EAl0WF;;EAq0WA;IACE,8BAAA;IACA,mGAAA;EAn0WF;;EAs0WA;IACE,8BAAA;IACA,kGAAA;EAp0WF;;EAu0WA;IACE,iCAAA;IACA,yHAAA;EAr0WF;;EAw0WA;IACE,kCAAA;IACA,+HAAA;EAt0WF;;EAy0WA;IACE,0BAAA;IACA,yHAAA;EAv0WF;;EA00WA;IACE,0BAAA;IACA,+HAAA;EAx0WF;;EA20WA;IACE,6BAAA;IACA,+HAAA;EAz0WF;;EA40WA;IACE,6BAAA;IACA,+HAAA;EA10WF;;EA60WA;IACE,6BAAA;IACA,+HAAA;EA30WF;;EA80WA;IACE,6BAAA;IACA,+HAAA;EA50WF;;EA+0WA;IACE,6BAAA;IACA,+HAAA;EA70WF;;EAg1WA;IACE,6BAAA;IACA,+HAAA;EA90WF;;EAi1WA;IACE,6BAAA;IACA,6HAAA;EA/0WF;;EAk1WA;IACE,6BAAA;IACA,4HAAA;EAh1WF;;EAm1WA;IACE,6BAAA;IACA,4HAAA;EAj1WF;;EAo1WA;IACE,6BAAA;IACA,+HAAA;EAl1WF;;EAq1WA;IACE,6BAAA;IACA,+HAAA;EAn1WF;;EAs1WA;IACE,6BAAA;IACA,+HAAA;EAp1WF;;EAu1WA;IACE,6BAAA;IACA,+HAAA;EAr1WF;;EAw1WA;IACE,6BAAA;IACA,+HAAA;EAt1WF;;EAy1WA;IACE,6BAAA;IACA,6HAAA;EAv1WF;;EA01WA;IACE,6BAAA;IACA,6HAAA;EAx1WF;;EA21WA;IACE,6BAAA;IACA,6HAAA;EAz1WF;;EA41WA;IACE,6BAAA;IACA,6HAAA;EA11WF;;EA61WA;IACE,6BAAA;IACA,+HAAA;EA31WF;;EA81WA;IACE,6BAAA;IACA,+HAAA;EA51WF;;EA+1WA;IACE,6BAAA;IACA,+HAAA;EA71WF;;EAg2WA;IACE,6BAAA;IACA,8HAAA;EA91WF;;EAi2WA;IACE,6BAAA;IACA,8HAAA;EA/1WF;;EAk2WA;IACE,6BAAA;IACA,8HAAA;EAh2WF;;EAm2WA;IACE,6BAAA;IACA,6HAAA;EAj2WF;;EAo2WA;IACE,6BAAA;IACA,6HAAA;EAl2WF;;EAq2WA;IACE,6BAAA;IACA,6HAAA;EAn2WF;;EAs2WA;IACE,6BAAA;IACA,+HAAA;EAp2WF;;EAu2WA;IACE,6BAAA;IACA,+HAAA;EAr2WF;;EAw2WA;IACE,6BAAA;IACA,+HAAA;EAt2WF;;EAy2WA;IACE,6BAAA;IACA,8HAAA;EAv2WF;;EA02WA;IACE,6BAAA;IACA,8HAAA;EAx2WF;;EA22WA;IACE,6BAAA;IACA,8HAAA;EAz2WF;;EA42WA;IACE,6BAAA;IACA,8HAAA;EA12WF;;EA62WA;IACE,6BAAA;IACA,6HAAA;EA32WF;;EA82WA;IACE,6BAAA;IACA,6HAAA;EA52WF;;EA+2WA;IACE,6BAAA;IACA,+HAAA;EA72WF;;EAg3WA;IACE,6BAAA;IACA,+HAAA;EA92WF;;EAi3WA;IACE,6BAAA;IACA,+HAAA;EA/2WF;;EAk3WA;IACE,6BAAA;IACA,+HAAA;EAh3WF;;EAm3WA;IACE,6BAAA;IACA,8HAAA;EAj3WF;;EAo3WA;IACE,6BAAA;IACA,8HAAA;EAl3WF;;EAq3WA;IACE,6BAAA;IACA,6HAAA;EAn3WF;;EAs3WA;IACE,6BAAA;IACA,6HAAA;EAp3WF;;EAu3WA;IACE,6BAAA;IACA,4HAAA;EAr3WF;;EAw3WA;IACE,6BAAA;IACA,+HAAA;EAt3WF;;EAy3WA;IACE,6BAAA;IACA,+HAAA;EAv3WF;;EA03WA;IACE,6BAAA;IACA,+HAAA;EAx3WF;;EA23WA;IACE,6BAAA;IACA,8HAAA;EAz3WF;;EA43WA;IACE,6BAAA;IACA,8HAAA;EA13WF;;EA63WA;IACE,6BAAA;IACA,8HAAA;EA33WF;;EA83WA;IACE,6BAAA;IACA,8HAAA;EA53WF;;EA+3WA;IACE,6BAAA;IACA,4HAAA;EA73WF;;EAg4WA;IACE,6BAAA;IACA,4HAAA;EA93WF;;EAi4WA;IACE,6BAAA;IACA,+HAAA;EA/3WF;;EAk4WA;IACE,6BAAA;IACA,+HAAA;EAh4WF;;EAm4WA;IACE,6BAAA;IACA,+HAAA;EAj4WF;;EAo4WA;IACE,6BAAA;IACA,8HAAA;EAl4WF;;EAq4WA;IACE,6BAAA;IACA,8HAAA;EAn4WF;;EAs4WA;IACE,6BAAA;IACA,8HAAA;EAp4WF;;EAu4WA;IACE,6BAAA;IACA,8HAAA;EAr4WF;;EAw4WA;IACE,6BAAA;IACA,6HAAA;EAt4WF;;EAy4WA;IACE,6BAAA;IACA,6HAAA;EAv4WF;;EA04WA;IACE,6BAAA;IACA,+HAAA;EAx4WF;;EA24WA;IACE,6BAAA;IACA,+HAAA;EAz4WF;;EA44WA;IACE,6BAAA;IACA,+HAAA;EA14WF;;EA64WA;IACE,6BAAA;IACA,+HAAA;EA34WF;;EA84WA;IACE,6BAAA;IACA,+HAAA;EA54WF;;EA+4WA;IACE,6BAAA;IACA,8HAAA;EA74WF;;EAg5WA;IACE,6BAAA;IACA,6HAAA;EA94WF;;EAi5WA;IACE,6BAAA;IACA,6HAAA;EA/4WF;;EAk5WA;IACE,6BAAA;IACA,6HAAA;EAh5WF;;EAm5WA;IACE,6BAAA;IACA,+HAAA;EAj5WF;;EAo5WA;IACE,6BAAA;IACA,+HAAA;EAl5WF;;EAq5WA;IACE,6BAAA;IACA,+HAAA;EAn5WF;;EAs5WA;IACE,6BAAA;IACA,+HAAA;EAp5WF;;EAu5WA;IACE,6BAAA;IACA,+HAAA;EAr5WF;;EAw5WA;IACE,6BAAA;IACA,8HAAA;EAt5WF;;EAy5WA;IACE,6BAAA;IACA,8HAAA;EAv5WF;;EA05WA;IACE,6BAAA;IACA,6HAAA;EAx5WF;;EA25WA;IACE,6BAAA;IACA,6HAAA;EAz5WF;;EA45WA;IACE,6BAAA;IACA,+HAAA;EA15WF;;EA65WA;IACE,6BAAA;IACA,+HAAA;EA35WF;;EA85WA;IACE,6BAAA;IACA,+HAAA;EA55WF;;EA+5WA;IACE,6BAAA;IACA,+HAAA;EA75WF;;EAg6WA;IACE,6BAAA;IACA,+HAAA;EA95WF;;EAi6WA;IACE,6BAAA;IACA,8HAAA;EA/5WF;;EAk6WA;IACE,6BAAA;IACA,8HAAA;EAh6WF;;EAm6WA;IACE,6BAAA;IACA,8HAAA;EAj6WF;;EAo6WA;IACE,6BAAA;IACA,6HAAA;EAl6WF;;EAq6WA;IACE,gCAAA;EAn6WF;;EAs6WA;IACE,iCAAA;EAp6WF;;EAu6WA;IACE,yBAAA;EAr6WF;;EAw6WA;IACE,yBAAA;EAt6WF;;EAy6WA;IACE,4BAAA;EAv6WF;;EA06WA;IACE,4BAAA;EAx6WF;;EA26WA;IACE,4BAAA;EAz6WF;;EA46WA;IACE,4BAAA;EA16WF;;EA66WA;IACE,4BAAA;EA36WF;;EA86WA;IACE,4BAAA;EA56WF;;EA+6WA;IACE,4BAAA;EA76WF;;EAg7WA;IACE,4BAAA;EA96WF;;EAi7WA;IACE,4BAAA;EA/6WF;;EAk7WA;IACE,4BAAA;EAh7WF;;EAm7WA;IACE,4BAAA;EAj7WF;;EAo7WA;IACE,4BAAA;EAl7WF;;EAq7WA;IACE,4BAAA;EAn7WF;;EAs7WA;IACE,4BAAA;EAp7WF;;EAu7WA;IACE,4BAAA;EAr7WF;;EAw7WA;IACE,4BAAA;EAt7WF;;EAy7WA;IACE,4BAAA;EAv7WF;;EA07WA;IACE,4BAAA;EAx7WF;;EA27WA;IACE,4BAAA;EAz7WF;;EA47WA;IACE,4BAAA;EA17WF;;EA67WA;IACE,4BAAA;EA37WF;;EA87WA;IACE,4BAAA;EA57WF;;EA+7WA;IACE,4BAAA;EA77WF;;EAg8WA;IACE,4BAAA;EA97WF;;EAi8WA;IACE,4BAAA;EA/7WF;;EAk8WA;IACE,4BAAA;EAh8WF;;EAm8WA;IACE,4BAAA;EAj8WF;;EAo8WA;IACE,4BAAA;EAl8WF;;EAq8WA;IACE,4BAAA;EAn8WF;;EAs8WA;IACE,4BAAA;EAp8WF;;EAu8WA;IACE,4BAAA;EAr8WF;;EAw8WA;IACE,4BAAA;EAt8WF;;EAy8WA;IACE,4BAAA;EAv8WF;;EA08WA;IACE,4BAAA;EAx8WF;;EA28WA;IACE,4BAAA;EAz8WF;;EA48WA;IACE,4BAAA;EA18WF;;EA68WA;IACE,4BAAA;EA38WF;;EA88WA;IACE,4BAAA;EA58WF;;EA+8WA;IACE,4BAAA;EA78WF;;EAg9WA;IACE,4BAAA;EA98WF;;EAi9WA;IACE,4BAAA;EA/8WF;;EAk9WA;IACE,4BAAA;EAh9WF;;EAm9WA;IACE,4BAAA;EAj9WF;;EAo9WA;IACE,4BAAA;EAl9WF;;EAq9WA;IACE,4BAAA;EAn9WF;;EAs9WA;IACE,4BAAA;EAp9WF;;EAu9WA;IACE,4BAAA;EAr9WF;;EAw9WA;IACE,4BAAA;EAt9WF;;EAy9WA;IACE,4BAAA;EAv9WF;;EA09WA;IACE,4BAAA;EAx9WF;;EA29WA;IACE,4BAAA;EAz9WF;;EA49WA;IACE,4BAAA;EA19WF;;EA69WA;IACE,4BAAA;EA39WF;;EA89WA;IACE,4BAAA;EA59WF;;EA+9WA;IACE,4BAAA;EA79WF;;EAg+WA;IACE,4BAAA;EA99WF;;EAi+WA;IACE,4BAAA;EA/9WF;;EAk+WA;IACE,4BAAA;EAh+WF;;EAm+WA;IACE,4BAAA;EAj+WF;;EAo+WA;IACE,4BAAA;EAl+WF;;EAq+WA;IACE,4BAAA;EAn+WF;;EAs+WA;IACE,4BAAA;EAp+WF;;EAu+WA;IACE,4BAAA;EAr+WF;;EAw+WA;IACE,4BAAA;EAt+WF;;EAy+WA;IACE,4BAAA;EAv+WF;;EA0+WA;IACE,4BAAA;EAx+WF;;EA2+WA;IACE,4BAAA;EAz+WF;;EA4+WA;IACE,4BAAA;EA1+WF;;EA6+WA;IACE,4BAAA;EA3+WF;;EA8+WA;IACE,4BAAA;EA5+WF;;EA++WA;IACE,4BAAA;EA7+WF;;EAg/WA;IACE,4BAAA;EA9+WF;;EAi/WA;IACE,4BAAA;EA/+WF;;EAk/WA;IACE,4BAAA;EAh/WF;;EAm/WA;IACE,4BAAA;EAj/WF;;EAo/WA;IACE,4BAAA;EAl/WF;;EAq/WA;IACE,4BAAA;EAn/WF;;EAs/WA;IACE,4BAAA;EAp/WF;;EAu/WA;IACE,4BAAA;EAr/WF;;EAw/WA;IACE,4BAAA;EAt/WF;;EAy/WA;IACE,4BAAA;EAv/WF;;EA0/WA;IACE,4BAAA;EAx/WF;;EA2/WA;IACE,4BAAA;EAz/WF;;EA4/WA;IACE,4BAAA;EA1/WF;;EA6/WA;IACE,4BAAA;EA3/WF;;EA8/WA;IACE,4BAAA;EA5/WF;;EA+/WA;IACE,4BAAA;EA7/WF;;EAggXA;IACE,4BAAA;EA9/WF;;EAigXA;IACE,4BAAA;EA//WF;;EAkgXA;IACE,4BAAA;EAhgXF;;EAmgXA;IACE,kCAAA;IACA,8FAAA;EAjgXF;;EAogXA;IACE,mCAAA;IACA,oGAAA;EAlgXF;;EAqgXA;IACE,2BAAA;IACA,8FAAA;EAngXF;;EAsgXA;IACE,2BAAA;IACA,oGAAA;EApgXF;;EAugXA;IACE,8BAAA;IACA,oGAAA;EArgXF;;EAwgXA;IACE,8BAAA;IACA,oGAAA;EAtgXF;;EAygXA;IACE,8BAAA;IACA,oGAAA;EAvgXF;;EA0gXA;IACE,8BAAA;IACA,oGAAA;EAxgXF;;EA2gXA;IACE,8BAAA;IACA,oGAAA;EAzgXF;;EA4gXA;IACE,8BAAA;IACA,oGAAA;EA1gXF;;EA6gXA;IACE,8BAAA;IACA,kGAAA;EA3gXF;;EA8gXA;IACE,8BAAA;IACA,iGAAA;EA5gXF;;EA+gXA;IACE,8BAAA;IACA,iGAAA;EA7gXF;;EAghXA;IACE,8BAAA;IACA,oGAAA;EA9gXF;;EAihXA;IACE,8BAAA;IACA,oGAAA;EA/gXF;;EAkhXA;IACE,8BAAA;IACA,oGAAA;EAhhXF;;EAmhXA;IACE,8BAAA;IACA,oGAAA;EAjhXF;;EAohXA;IACE,8BAAA;IACA,oGAAA;EAlhXF;;EAqhXA;IACE,8BAAA;IACA,kGAAA;EAnhXF;;EAshXA;IACE,8BAAA;IACA,kGAAA;EAphXF;;EAuhXA;IACE,8BAAA;IACA,kGAAA;EArhXF;;EAwhXA;IACE,8BAAA;IACA,kGAAA;EAthXF;;EAyhXA;IACE,8BAAA;IACA,oGAAA;EAvhXF;;EA0hXA;IACE,8BAAA;IACA,oGAAA;EAxhXF;;EA2hXA;IACE,8BAAA;IACA,oGAAA;EAzhXF;;EA4hXA;IACE,8BAAA;IACA,mGAAA;EA1hXF;;EA6hXA;IACE,8BAAA;IACA,mGAAA;EA3hXF;;EA8hXA;IACE,8BAAA;IACA,mGAAA;EA5hXF;;EA+hXA;IACE,8BAAA;IACA,kGAAA;EA7hXF;;EAgiXA;IACE,8BAAA;IACA,kGAAA;EA9hXF;;EAiiXA;IACE,8BAAA;IACA,kGAAA;EA/hXF;;EAkiXA;IACE,8BAAA;IACA,oGAAA;EAhiXF;;EAmiXA;IACE,8BAAA;IACA,oGAAA;EAjiXF;;EAoiXA;IACE,8BAAA;IACA,oGAAA;EAliXF;;EAqiXA;IACE,8BAAA;IACA,mGAAA;EAniXF;;EAsiXA;IACE,8BAAA;IACA,mGAAA;EApiXF;;EAuiXA;IACE,8BAAA;IACA,mGAAA;EAriXF;;EAwiXA;IACE,8BAAA;IACA,mGAAA;EAtiXF;;EAyiXA;IACE,8BAAA;IACA,kGAAA;EAviXF;;EA0iXA;IACE,8BAAA;IACA,kGAAA;EAxiXF;;EA2iXA;IACE,8BAAA;IACA,oGAAA;EAziXF;;EA4iXA;IACE,8BAAA;IACA,oGAAA;EA1iXF;;EA6iXA;IACE,8BAAA;IACA,oGAAA;EA3iXF;;EA8iXA;IACE,8BAAA;IACA,oGAAA;EA5iXF;;EA+iXA;IACE,8BAAA;IACA,mGAAA;EA7iXF;;EAgjXA;IACE,8BAAA;IACA,mGAAA;EA9iXF;;EAijXA;IACE,8BAAA;IACA,kGAAA;EA/iXF;;EAkjXA;IACE,8BAAA;IACA,kGAAA;EAhjXF;;EAmjXA;IACE,8BAAA;IACA,iGAAA;EAjjXF;;EAojXA;IACE,8BAAA;IACA,oGAAA;EAljXF;;EAqjXA;IACE,8BAAA;IACA,oGAAA;EAnjXF;;EAsjXA;IACE,8BAAA;IACA,oGAAA;EApjXF;;EAujXA;IACE,8BAAA;IACA,mGAAA;EArjXF;;EAwjXA;IACE,8BAAA;IACA,mGAAA;EAtjXF;;EAyjXA;IACE,8BAAA;IACA,mGAAA;EAvjXF;;EA0jXA;IACE,8BAAA;IACA,mGAAA;EAxjXF;;EA2jXA;IACE,8BAAA;IACA,iGAAA;EAzjXF;;EA4jXA;IACE,8BAAA;IACA,iGAAA;EA1jXF;;EA6jXA;IACE,8BAAA;IACA,oGAAA;EA3jXF;;EA8jXA;IACE,8BAAA;IACA,oGAAA;EA5jXF;;EA+jXA;IACE,8BAAA;IACA,oGAAA;EA7jXF;;EAgkXA;IACE,8BAAA;IACA,mGAAA;EA9jXF;;EAikXA;IACE,8BAAA;IACA,mGAAA;EA/jXF;;EAkkXA;IACE,8BAAA;IACA,mGAAA;EAhkXF;;EAmkXA;IACE,8BAAA;IACA,mGAAA;EAjkXF;;EAokXA;IACE,8BAAA;IACA,kGAAA;EAlkXF;;EAqkXA;IACE,8BAAA;IACA,kGAAA;EAnkXF;;EAskXA;IACE,8BAAA;IACA,oGAAA;EApkXF;;EAukXA;IACE,8BAAA;IACA,oGAAA;EArkXF;;EAwkXA;IACE,8BAAA;IACA,oGAAA;EAtkXF;;EAykXA;IACE,8BAAA;IACA,oGAAA;EAvkXF;;EA0kXA;IACE,8BAAA;IACA,oGAAA;EAxkXF;;EA2kXA;IACE,8BAAA;IACA,mGAAA;EAzkXF;;EA4kXA;IACE,8BAAA;IACA,kGAAA;EA1kXF;;EA6kXA;IACE,8BAAA;IACA,kGAAA;EA3kXF;;EA8kXA;IACE,8BAAA;IACA,kGAAA;EA5kXF;;EA+kXA;IACE,8BAAA;IACA,oGAAA;EA7kXF;;EAglXA;IACE,8BAAA;IACA,oGAAA;EA9kXF;;EAilXA;IACE,8BAAA;IACA,oGAAA;EA/kXF;;EAklXA;IACE,8BAAA;IACA,oGAAA;EAhlXF;;EAmlXA;IACE,8BAAA;IACA,oGAAA;EAjlXF;;EAolXA;IACE,8BAAA;IACA,mGAAA;EAllXF;;EAqlXA;IACE,8BAAA;IACA,mGAAA;EAnlXF;;EAslXA;IACE,8BAAA;IACA,kGAAA;EAplXF;;EAulXA;IACE,8BAAA;IACA,kGAAA;EArlXF;;EAwlXA;IACE,8BAAA;IACA,oGAAA;EAtlXF;;EAylXA;IACE,8BAAA;IACA,oGAAA;EAvlXF;;EA0lXA;IACE,8BAAA;IACA,oGAAA;EAxlXF;;EA2lXA;IACE,8BAAA;IACA,oGAAA;EAzlXF;;EA4lXA;IACE,8BAAA;IACA,oGAAA;EA1lXF;;EA6lXA;IACE,8BAAA;IACA,mGAAA;EA3lXF;;EA8lXA;IACE,8BAAA;IACA,mGAAA;EA5lXF;;EA+lXA;IACE,8BAAA;IACA,mGAAA;EA7lXF;;EAgmXA;IACE,8BAAA;IACA,kGAAA;EA9lXF;;EAimXA;IACE,iCAAA;IACA,yHAAA;EA/lXF;;EAkmXA;IACE,kCAAA;IACA,+HAAA;EAhmXF;;EAmmXA;IACE,0BAAA;IACA,yHAAA;EAjmXF;;EAomXA;IACE,0BAAA;IACA,+HAAA;EAlmXF;;EAqmXA;IACE,6BAAA;IACA,+HAAA;EAnmXF;;EAsmXA;IACE,6BAAA;IACA,+HAAA;EApmXF;;EAumXA;IACE,6BAAA;IACA,+HAAA;EArmXF;;EAwmXA;IACE,6BAAA;IACA,+HAAA;EAtmXF;;EAymXA;IACE,6BAAA;IACA,+HAAA;EAvmXF;;EA0mXA;IACE,6BAAA;IACA,+HAAA;EAxmXF;;EA2mXA;IACE,6BAAA;IACA,6HAAA;EAzmXF;;EA4mXA;IACE,6BAAA;IACA,4HAAA;EA1mXF;;EA6mXA;IACE,6BAAA;IACA,4HAAA;EA3mXF;;EA8mXA;IACE,6BAAA;IACA,+HAAA;EA5mXF;;EA+mXA;IACE,6BAAA;IACA,+HAAA;EA7mXF;;EAgnXA;IACE,6BAAA;IACA,+HAAA;EA9mXF;;EAinXA;IACE,6BAAA;IACA,+HAAA;EA/mXF;;EAknXA;IACE,6BAAA;IACA,+HAAA;EAhnXF;;EAmnXA;IACE,6BAAA;IACA,6HAAA;EAjnXF;;EAonXA;IACE,6BAAA;IACA,6HAAA;EAlnXF;;EAqnXA;IACE,6BAAA;IACA,6HAAA;EAnnXF;;EAsnXA;IACE,6BAAA;IACA,6HAAA;EApnXF;;EAunXA;IACE,6BAAA;IACA,+HAAA;EArnXF;;EAwnXA;IACE,6BAAA;IACA,+HAAA;EAtnXF;;EAynXA;IACE,6BAAA;IACA,+HAAA;EAvnXF;;EA0nXA;IACE,6BAAA;IACA,8HAAA;EAxnXF;;EA2nXA;IACE,6BAAA;IACA,8HAAA;EAznXF;;EA4nXA;IACE,6BAAA;IACA,8HAAA;EA1nXF;;EA6nXA;IACE,6BAAA;IACA,6HAAA;EA3nXF;;EA8nXA;IACE,6BAAA;IACA,6HAAA;EA5nXF;;EA+nXA;IACE,6BAAA;IACA,6HAAA;EA7nXF;;EAgoXA;IACE,6BAAA;IACA,+HAAA;EA9nXF;;EAioXA;IACE,6BAAA;IACA,+HAAA;EA/nXF;;EAkoXA;IACE,6BAAA;IACA,+HAAA;EAhoXF;;EAmoXA;IACE,6BAAA;IACA,8HAAA;EAjoXF;;EAooXA;IACE,6BAAA;IACA,8HAAA;EAloXF;;EAqoXA;IACE,6BAAA;IACA,8HAAA;EAnoXF;;EAsoXA;IACE,6BAAA;IACA,8HAAA;EApoXF;;EAuoXA;IACE,6BAAA;IACA,6HAAA;EAroXF;;EAwoXA;IACE,6BAAA;IACA,6HAAA;EAtoXF;;EAyoXA;IACE,6BAAA;IACA,+HAAA;EAvoXF;;EA0oXA;IACE,6BAAA;IACA,+HAAA;EAxoXF;;EA2oXA;IACE,6BAAA;IACA,+HAAA;EAzoXF;;EA4oXA;IACE,6BAAA;IACA,+HAAA;EA1oXF;;EA6oXA;IACE,6BAAA;IACA,8HAAA;EA3oXF;;EA8oXA;IACE,6BAAA;IACA,8HAAA;EA5oXF;;EA+oXA;IACE,6BAAA;IACA,6HAAA;EA7oXF;;EAgpXA;IACE,6BAAA;IACA,6HAAA;EA9oXF;;EAipXA;IACE,6BAAA;IACA,4HAAA;EA/oXF;;EAkpXA;IACE,6BAAA;IACA,+HAAA;EAhpXF;;EAmpXA;IACE,6BAAA;IACA,+HAAA;EAjpXF;;EAopXA;IACE,6BAAA;IACA,+HAAA;EAlpXF;;EAqpXA;IACE,6BAAA;IACA,8HAAA;EAnpXF;;EAspXA;IACE,6BAAA;IACA,8HAAA;EAppXF;;EAupXA;IACE,6BAAA;IACA,8HAAA;EArpXF;;EAwpXA;IACE,6BAAA;IACA,8HAAA;EAtpXF;;EAypXA;IACE,6BAAA;IACA,4HAAA;EAvpXF;;EA0pXA;IACE,6BAAA;IACA,4HAAA;EAxpXF;;EA2pXA;IACE,6BAAA;IACA,+HAAA;EAzpXF;;EA4pXA;IACE,6BAAA;IACA,+HAAA;EA1pXF;;EA6pXA;IACE,6BAAA;IACA,+HAAA;EA3pXF;;EA8pXA;IACE,6BAAA;IACA,8HAAA;EA5pXF;;EA+pXA;IACE,6BAAA;IACA,8HAAA;EA7pXF;;EAgqXA;IACE,6BAAA;IACA,8HAAA;EA9pXF;;EAiqXA;IACE,6BAAA;IACA,8HAAA;EA/pXF;;EAkqXA;IACE,6BAAA;IACA,6HAAA;EAhqXF;;EAmqXA;IACE,6BAAA;IACA,6HAAA;EAjqXF;;EAoqXA;IACE,6BAAA;IACA,+HAAA;EAlqXF;;EAqqXA;IACE,6BAAA;IACA,+HAAA;EAnqXF;;EAsqXA;IACE,6BAAA;IACA,+HAAA;EApqXF;;EAuqXA;IACE,6BAAA;IACA,+HAAA;EArqXF;;EAwqXA;IACE,6BAAA;IACA,+HAAA;EAtqXF;;EAyqXA;IACE,6BAAA;IACA,8HAAA;EAvqXF;;EA0qXA;IACE,6BAAA;IACA,6HAAA;EAxqXF;;EA2qXA;IACE,6BAAA;IACA,6HAAA;EAzqXF;;EA4qXA;IACE,6BAAA;IACA,6HAAA;EA1qXF;;EA6qXA;IACE,6BAAA;IACA,+HAAA;EA3qXF;;EA8qXA;IACE,6BAAA;IACA,+HAAA;EA5qXF;;EA+qXA;IACE,6BAAA;IACA,+HAAA;EA7qXF;;EAgrXA;IACE,6BAAA;IACA,+HAAA;EA9qXF;;EAirXA;IACE,6BAAA;IACA,+HAAA;EA/qXF;;EAkrXA;IACE,6BAAA;IACA,8HAAA;EAhrXF;;EAmrXA;IACE,6BAAA;IACA,8HAAA;EAjrXF;;EAorXA;IACE,6BAAA;IACA,6HAAA;EAlrXF;;EAqrXA;IACE,6BAAA;IACA,6HAAA;EAnrXF;;EAsrXA;IACE,6BAAA;IACA,+HAAA;EAprXF;;EAurXA;IACE,6BAAA;IACA,+HAAA;EArrXF;;EAwrXA;IACE,6BAAA;IACA,+HAAA;EAtrXF;;EAyrXA;IACE,6BAAA;IACA,+HAAA;EAvrXF;;EA0rXA;IACE,6BAAA;IACA,+HAAA;EAxrXF;;EA2rXA;IACE,6BAAA;IACA,8HAAA;EAzrXF;;EA4rXA;IACE,6BAAA;IACA,8HAAA;EA1rXF;;EA6rXA;IACE,6BAAA;IACA,8HAAA;EA3rXF;;EA8rXA;IACE,6BAAA;IACA,6HAAA;EA5rXF;;EA+rXA;IACE,gCAAA;EA7rXF;;EAgsXA;IACE,iCAAA;EA9rXF;;EAisXA;IACE,yBAAA;EA/rXF;;EAksXA;IACE,yBAAA;EAhsXF;;EAmsXA;IACE,4BAAA;EAjsXF;;EAosXA;IACE,4BAAA;EAlsXF;;EAqsXA;IACE,4BAAA;EAnsXF;;EAssXA;IACE,4BAAA;EApsXF;;EAusXA;IACE,4BAAA;EArsXF;;EAwsXA;IACE,4BAAA;EAtsXF;;EAysXA;IACE,4BAAA;EAvsXF;;EA0sXA;IACE,4BAAA;EAxsXF;;EA2sXA;IACE,4BAAA;EAzsXF;;EA4sXA;IACE,4BAAA;EA1sXF;;EA6sXA;IACE,4BAAA;EA3sXF;;EA8sXA;IACE,4BAAA;EA5sXF;;EA+sXA;IACE,4BAAA;EA7sXF;;EAgtXA;IACE,4BAAA;EA9sXF;;EAitXA;IACE,4BAAA;EA/sXF;;EAktXA;IACE,4BAAA;EAhtXF;;EAmtXA;IACE,4BAAA;EAjtXF;;EAotXA;IACE,4BAAA;EAltXF;;EAqtXA;IACE,4BAAA;EAntXF;;EAstXA;IACE,4BAAA;EAptXF;;EAutXA;IACE,4BAAA;EArtXF;;EAwtXA;IACE,4BAAA;EAttXF;;EAytXA;IACE,4BAAA;EAvtXF;;EA0tXA;IACE,4BAAA;EAxtXF;;EA2tXA;IACE,4BAAA;EAztXF;;EA4tXA;IACE,4BAAA;EA1tXF;;EA6tXA;IACE,4BAAA;EA3tXF;;EA8tXA;IACE,4BAAA;EA5tXF;;EA+tXA;IACE,4BAAA;EA7tXF;;EAguXA;IACE,4BAAA;EA9tXF;;EAiuXA;IACE,4BAAA;EA/tXF;;EAkuXA;IACE,4BAAA;EAhuXF;;EAmuXA;IACE,4BAAA;EAjuXF;;EAouXA;IACE,4BAAA;EAluXF;;EAquXA;IACE,4BAAA;EAnuXF;;EAsuXA;IACE,4BAAA;EApuXF;;EAuuXA;IACE,4BAAA;EAruXF;;EAwuXA;IACE,4BAAA;EAtuXF;;EAyuXA;IACE,4BAAA;EAvuXF;;EA0uXA;IACE,4BAAA;EAxuXF;;EA2uXA;IACE,4BAAA;EAzuXF;;EA4uXA;IACE,4BAAA;EA1uXF;;EA6uXA;IACE,4BAAA;EA3uXF;;EA8uXA;IACE,4BAAA;EA5uXF;;EA+uXA;IACE,4BAAA;EA7uXF;;EAgvXA;IACE,4BAAA;EA9uXF;;EAivXA;IACE,4BAAA;EA/uXF;;EAkvXA;IACE,4BAAA;EAhvXF;;EAmvXA;IACE,4BAAA;EAjvXF;;EAovXA;IACE,4BAAA;EAlvXF;;EAqvXA;IACE,4BAAA;EAnvXF;;EAsvXA;IACE,4BAAA;EApvXF;;EAuvXA;IACE,4BAAA;EArvXF;;EAwvXA;IACE,4BAAA;EAtvXF;;EAyvXA;IACE,4BAAA;EAvvXF;;EA0vXA;IACE,4BAAA;EAxvXF;;EA2vXA;IACE,4BAAA;EAzvXF;;EA4vXA;IACE,4BAAA;EA1vXF;;EA6vXA;IACE,4BAAA;EA3vXF;;EA8vXA;IACE,4BAAA;EA5vXF;;EA+vXA;IACE,4BAAA;EA7vXF;;EAgwXA;IACE,4BAAA;EA9vXF;;EAiwXA;IACE,4BAAA;EA/vXF;;EAkwXA;IACE,4BAAA;EAhwXF;;EAmwXA;IACE,4BAAA;EAjwXF;;EAowXA;IACE,4BAAA;EAlwXF;;EAqwXA;IACE,4BAAA;EAnwXF;;EAswXA;IACE,4BAAA;EApwXF;;EAuwXA;IACE,4BAAA;EArwXF;;EAwwXA;IACE,4BAAA;EAtwXF;;EAywXA;IACE,4BAAA;EAvwXF;;EA0wXA;IACE,4BAAA;EAxwXF;;EA2wXA;IACE,4BAAA;EAzwXF;;EA4wXA;IACE,4BAAA;EA1wXF;;EA6wXA;IACE,4BAAA;EA3wXF;;EA8wXA;IACE,4BAAA;EA5wXF;;EA+wXA;IACE,4BAAA;EA7wXF;;EAgxXA;IACE,4BAAA;EA9wXF;;EAixXA;IACE,4BAAA;EA/wXF;;EAkxXA;IACE,4BAAA;EAhxXF;;EAmxXA;IACE,4BAAA;EAjxXF;;EAoxXA;IACE,4BAAA;EAlxXF;;EAqxXA;IACE,4BAAA;EAnxXF;;EAsxXA;IACE,4BAAA;EApxXF;;EAuxXA;IACE,4BAAA;EArxXF;;EAwxXA;IACE,4BAAA;EAtxXF;;EAyxXA;IACE,4BAAA;EAvxXF;;EA0xXA;IACE,4BAAA;EAxxXF;;EA2xXA;IACE,4BAAA;EAzxXF;;EA4xXA;IACE,4BAAA;EA1xXF;;EA6xXA;IACE,eAAA;EA3xXF;;EA8xXA;IACE,kBAAA;EA5xXF;;EA+xXA;IACE,iBAAA;EA7xXF;;EAgyXA;IACE,kBAAA;EA9xXF;;EAiyXA;IACE,eAAA;EA/xXF;;EAkyXA;IACE,eAAA;EAhyXF;;EAmyXA;IACE,kBAAA;EAjyXF;;EAoyXA;IACE,iBAAA;EAlyXF;;EAqyXA;IACE,kBAAA;EAnyXF;;EAsyXA;IACE,eAAA;EApyXF;;EAuyXA;IACE,eAAA;EAryXF;;EAwyXA;IACE,kBAAA;EAtyXF;;EAyyXA;IACE,iBAAA;EAvyXF;;EA0yXA;IACE,kBAAA;EAxyXF;;EA2yXA;IACE,eAAA;EAzyXF;;EA4yXA;IACE,2BAAA;EA1yXF;;EA6yXA;IACE,2BAAA;EA3yXF;;EA8yXA;IACE,yBAAA;EA5yXF;;EA+yXA;IACE,gCAAA;EA7yXF;;EAgzXA;IACE,6BAAA;EA9yXF;;EAizXA;IACE,0BAAA;EA/yXF;;EAkzXA;IACE,iCAAA;EAhzXF;;EAmzXA;IACE,8BAAA;EAjzXF;;EAozXA;IACE,wBAAA;EAlzXF;;EAqzXA;IACE,yBAAA;EAnzXF;;EAszXA;IACE,4BAAA;EApzXF;;EAuzXA;IACE,2BAAA;EArzXF;;EAwzXA;IACE,2BAAA;EAtzXF;;EAyzXA;IACE,wBAAA;EAvzXF;;EA0zXA;IACE,wBAAA;EAxzXF;;EA2zXA;IACE,qBAAA;EAzzXF;;EA4zXA;IACE,sBAAA;EA1zXF;;EA6zXA;IACE,wBAAA;EA3zXF;;EA8zXA;IACE,yBAAA;EA5zXF;;EA+zXA;IACE,yBAAA;EA7zXF;;EAg0XA;IACE,yBAAA;EA9zXF;;EAi0XA;IACE,0BAAA;EA/zXF;;EAk0XA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EAh0XF;;EAm0XA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EAj0XF;;EAo0XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl0XF;;EAq0XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn0XF;;EAs0XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp0XF;;EAu0XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr0XF;;EAw0XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt0XF;;EAy0XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv0XF;;EA00XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAx0XF;;EA20XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAz0XF;;EA40XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA10XF;;EA60XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA30XF;;EA80XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA50XF;;EA+0XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA70XF;;EAg1XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA90XF;;EAi1XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/0XF;;EAk1XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAh1XF;;EAm1XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAj1XF;;EAo1XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl1XF;;EAq1XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn1XF;;EAs1XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp1XF;;EAu1XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr1XF;;EAw1XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt1XF;;EAy1XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAv1XF;;EA01XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx1XF;;EA21XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz1XF;;EA41XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA11XF;;EA61XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA31XF;;EA81XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA51XF;;EA+1XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA71XF;;EAg2XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA91XF;;EAi2XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/1XF;;EAk2XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAh2XF;;EAm2XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj2XF;;EAo2XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl2XF;;EAq2XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn2XF;;EAs2XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAp2XF;;EAu2XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAr2XF;;EAw2XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt2XF;;EAy2XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv2XF;;EA02XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx2XF;;EA22XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz2XF;;EA42XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA12XF;;EA62XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA32XF;;EA82XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA52XF;;EA+2XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA72XF;;EAg3XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA92XF;;EAi3XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/2XF;;EAk3XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh3XF;;EAm3XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj3XF;;EAo3XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl3XF;;EAq3XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn3XF;;EAs3XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAp3XF;;EAu3XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAr3XF;;EAw3XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAt3XF;;EAy3XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAv3XF;;EA03XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx3XF;;EA23XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz3XF;;EA43XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA13XF;;EA63XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA33XF;;EA83XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA53XF;;EA+3XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA73XF;;EAg4XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA93XF;;EAi4XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/3XF;;EAk4XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAh4XF;;EAm4XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj4XF;;EAo4XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl4XF;;EAq4XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn4XF;;EAs4XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp4XF;;EAu4XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr4XF;;EAw4XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAt4XF;;EAy4XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAv4XF;;EA04XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAx4XF;;EA24XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAz4XF;;EA44XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA14XF;;EA64XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA34XF;;EA84XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA54XF;;EA+4XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA74XF;;EAg5XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA94XF;;EAi5XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/4XF;;EAk5XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAh5XF;;EAm5XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAj5XF;;EAo5XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl5XF;;EAq5XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn5XF;;EAs5XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp5XF;;EAu5XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr5XF;;EAw5XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt5XF;;EAy5XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv5XF;;EA05XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx5XF;;EA25XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz5XF;;EA45XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA15XF;;EA65XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA35XF;;EA85XA;IACE,yBAAA;EA55XF;;EA+5XA;IACE,0BAAA;EA75XF;;EAg6XA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EA95XF;;EAi6XA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EA/5XF;;EAk6XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh6XF;;EAm6XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj6XF;;EAo6XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl6XF;;EAq6XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn6XF;;EAs6XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp6XF;;EAu6XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr6XF;;EAw6XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAt6XF;;EAy6XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAv6XF;;EA06XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAx6XF;;EA26XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz6XF;;EA46XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA16XF;;EA66XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA36XF;;EA86XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA56XF;;EA+6XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA76XF;;EAg7XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA96XF;;EAi7XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/6XF;;EAk7XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAh7XF;;EAm7XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAj7XF;;EAo7XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl7XF;;EAq7XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn7XF;;EAs7XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp7XF;;EAu7XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAr7XF;;EAw7XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAt7XF;;EAy7XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAv7XF;;EA07XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAx7XF;;EA27XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAz7XF;;EA47XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA17XF;;EA67XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA37XF;;EA87XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA57XF;;EA+7XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA77XF;;EAg8XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA97XF;;EAi8XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/7XF;;EAk8XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAh8XF;;EAm8XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj8XF;;EAo8XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAl8XF;;EAq8XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAn8XF;;EAs8XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp8XF;;EAu8XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr8XF;;EAw8XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt8XF;;EAy8XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv8XF;;EA08XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx8XF;;EA28XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz8XF;;EA48XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA18XF;;EA68XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA38XF;;EA88XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA58XF;;EA+8XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA78XF;;EAg9XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA98XF;;EAi9XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/8XF;;EAk9XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAh9XF;;EAm9XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAj9XF;;EAo9XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAl9XF;;EAq9XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAn9XF;;EAs9XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAp9XF;;EAu9XA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAr9XF;;EAw9XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAt9XF;;EAy9XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAv9XF;;EA09XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx9XF;;EA29XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAz9XF;;EA49XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA19XF;;EA69XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA39XF;;EA89XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA59XF;;EA+9XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA79XF;;EAg+XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA99XF;;EAi+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/9XF;;EAk+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAh+XF;;EAm+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj+XF;;EAo+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl+XF;;EAq+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn+XF;;EAs+XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAp+XF;;EAu+XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAr+XF;;EAw+XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAt+XF;;EAy+XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAv+XF;;EA0+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAx+XF;;EA2+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAz+XF;;EA4+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1+XF;;EA6+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3+XF;;EA8+XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5+XF;;EA++XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7+XF;;EAg/XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9+XF;;EAi/XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/+XF;;EAk/XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAh/XF;;EAm/XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAj/XF;;EAo/XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAl/XF;;EAq/XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAn/XF;;EAs/XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAp/XF;;EAu/XA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAr/XF;;EAw/XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAt/XF;;EAy/XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAv/XF;;EA0/XA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAx/XF;;EA2/XA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAz/XF;;EA4/XA;IACE,yBAAA;EA1/XF;;EA6/XA;IACE,0BAAA;EA3/XF;;EA8/XA;IACE,mBAAA;IACA,kBAAA;IACA,kDAAA;EA5/XF;;EA+/XA;IACE,mBAAA;IACA,kBAAA;IACA,wDAAA;EA7/XF;;EAggYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9/XF;;EAigYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA//XF;;EAkgYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhgYF;;EAmgYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjgYF;;EAogYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlgYF;;EAqgYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAngYF;;EAsgYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EApgYF;;EAugYA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EArgYF;;EAwgYA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAtgYF;;EAygYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvgYF;;EA0gYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxgYF;;EA2gYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzgYF;;EA4gYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1gYF;;EA6gYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3gYF;;EA8gYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5gYF;;EA+gYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7gYF;;EAghYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9gYF;;EAihYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA/gYF;;EAkhYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhhYF;;EAmhYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjhYF;;EAohYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAlhYF;;EAqhYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAnhYF;;EAshYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAphYF;;EAuhYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArhYF;;EAwhYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAthYF;;EAyhYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvhYF;;EA0hYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxhYF;;EA2hYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzhYF;;EA4hYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1hYF;;EA6hYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3hYF;;EA8hYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5hYF;;EA+hYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA7hYF;;EAgiYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9hYF;;EAiiYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/hYF;;EAkiYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAhiYF;;EAmiYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAjiYF;;EAoiYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAliYF;;EAqiYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAniYF;;EAsiYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApiYF;;EAuiYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAriYF;;EAwiYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtiYF;;EAyiYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAviYF;;EA0iYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAxiYF;;EA2iYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAziYF;;EA4iYA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EA1iYF;;EA6iYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA3iYF;;EA8iYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA5iYF;;EA+iYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7iYF;;EAgjYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA9iYF;;EAijYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA/iYF;;EAkjYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAhjYF;;EAmjYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAjjYF;;EAojYA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAljYF;;EAqjYA;IACE,mBAAA;IACA,qBAAA;IACA,qDAAA;EAnjYF;;EAsjYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EApjYF;;EAujYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EArjYF;;EAwjYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtjYF;;EAyjYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAvjYF;;EA0jYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAxjYF;;EA2jYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAzjYF;;EA4jYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA1jYF;;EA6jYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA3jYF;;EA8jYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA5jYF;;EA+jYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA7jYF;;EAgkYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA9jYF;;EAikYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/jYF;;EAkkYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhkYF;;EAmkYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjkYF;;EAokYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAlkYF;;EAqkYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAnkYF;;EAskYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EApkYF;;EAukYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EArkYF;;EAwkYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAtkYF;;EAykYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAvkYF;;EA0kYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAxkYF;;EA2kYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAzkYF;;EA4kYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA1kYF;;EA6kYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA3kYF;;EA8kYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EA5kYF;;EA+kYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA7kYF;;EAglYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EA9kYF;;EAilYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EA/kYF;;EAklYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAhlYF;;EAmlYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAjlYF;;EAolYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAllYF;;EAqlYA;IACE,mBAAA;IACA,qBAAA;IACA,wDAAA;EAnlYF;;EAslYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAplYF;;EAulYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EArlYF;;EAwlYA;IACE,mBAAA;IACA,qBAAA;IACA,uDAAA;EAtlYF;;EAylYA;IACE,mBAAA;IACA,qBAAA;IACA,sDAAA;EAvlYF;;EA0lYA;IACE,mBAAA;EAxlYF;;EA2lYA;IACE,sBAAA;EAzlYF;;EA4lYA;IACE,qBAAA;EA1lYF;;EA6lYA;IACE,sBAAA;EA3lYF;;EA8lYA;IACE,mBAAA;EA5lYF;;EA+lYA;IACE,mBAAA;EA7lYF;;EAgmYA;IACE,sBAAA;EA9lYF;;EAimYA;IACE,qBAAA;EA/lYF;;EAkmYA;IACE,sBAAA;EAhmYF;;EAmmYA;IACE,mBAAA;EAjmYF;;EAomYA;IACE,mBAAA;EAlmYF;;EAqmYA;IACE,sBAAA;EAnmYF;;EAsmYA;IACE,qBAAA;EApmYF;;EAumYA;IACE,sBAAA;EArmYF;;EAwmYA;IACE,mBAAA;EAtmYF;;EAymYA;IACE,gBAAA;EAvmYF;;EA0mYA;IACE,uBAAA;EAxmYF;;EA2mYA;IACE,sBAAA;EAzmYF;;EA4mYA;IACE,uBAAA;EA1mYF;;EA6mYA;IACE,qBAAA;EA3mYF;;EA8mYA;IACE,sBAAA;EA5mYF;;EA+mYA;IACE,mBAAA;EA7mYF;;EAgnYA;IACE,qBAAA;EA9mYF;;EAinYA;IACE,qBAAA;EA/mYF;;EAknYA;IACE,yBAAA;IACA,0BAAA;EAhnYF;;EAmnYA;IACE,0BAAA;IACA,6BAAA;EAjnYF;;EAonYA;IACE,6BAAA;IACA,4BAAA;EAlnYF;;EAqnYA;IACE,yBAAA;IACA,4BAAA;EAnnYF;;EAsnYA;IACE,gCAAA;IACA,iCAAA;EApnYF;;EAunYA;IACE,iCAAA;IACA,oCAAA;EArnYF;;EAwnYA;IACE,oCAAA;IACA,mCAAA;EAtnYF;;EAynYA;IACE,gCAAA;IACA,mCAAA;EAvnYF;;EA0nYA;IACE,+BAAA;IACA,gCAAA;EAxnYF;;EA2nYA;IACE,gCAAA;IACA,mCAAA;EAznYF;;EA4nYA;IACE,mCAAA;IACA,kCAAA;EA1nYF;;EA6nYA;IACE,+BAAA;IACA,kCAAA;EA3nYF;;EA8nYA;IACE,gCAAA;IACA,iCAAA;EA5nYF;;EA+nYA;IACE,iCAAA;IACA,oCAAA;EA7nYF;;EAgoYA;IACE,oCAAA;IACA,mCAAA;EA9nYF;;EAioYA;IACE,gCAAA;IACA,mCAAA;EA/nYF;;EAkoYA;IACE,8BAAA;IACA,+BAAA;EAhoYF;;EAmoYA;IACE,+BAAA;IACA,kCAAA;EAjoYF;;EAooYA;IACE,kCAAA;IACA,iCAAA;EAloYF;;EAqoYA;IACE,8BAAA;IACA,iCAAA;EAnoYF;;EAsoYA;IACE,+BAAA;IACA,gCAAA;EApoYF;;EAuoYA;IACE,gCAAA;IACA,mCAAA;EAroYF;;EAwoYA;IACE,mCAAA;IACA,kCAAA;EAtoYF;;EAyoYA;IACE,+BAAA;IACA,kCAAA;EAvoYF;;EA0oYA;IACE,4BAAA;IACA,6BAAA;EAxoYF;;EA2oYA;IACE,6BAAA;IACA,gCAAA;EAzoYF;;EA4oYA;IACE,gCAAA;IACA,+BAAA;EA1oYF;;EA6oYA;IACE,4BAAA;IACA,+BAAA;EA3oYF;;EA8oYA;IACE,8BAAA;IACA,+BAAA;EA5oYF;;EA+oYA;IACE,+BAAA;IACA,kCAAA;EA7oYF;;EAgpYA;IACE,kCAAA;IACA,iCAAA;EA9oYF;;EAipYA;IACE,8BAAA;IACA,iCAAA;EA/oYF;;EAkpYA;IACE,8BAAA;IACA,+BAAA;EAhpYF;;EAmpYA;IACE,+BAAA;IACA,kCAAA;EAjpYF;;EAopYA;IACE,kCAAA;IACA,iCAAA;EAlpYF;;EAqpYA;IACE,8BAAA;IACA,iCAAA;EAnpYF;;EAspYA;IACE,yBAAA;EAppYF;;EAupYA;IACE,0BAAA;EArpYF;;EAwpYA;IACE,6BAAA;EAtpYF;;EAypYA;IACE,4BAAA;EAvpYF;;EA0pYA;IACE,gCAAA;EAxpYF;;EA2pYA;IACE,iCAAA;EAzpYF;;EA4pYA;IACE,oCAAA;EA1pYF;;EA6pYA;IACE,mCAAA;EA3pYF;;EA8pYA;IACE,+BAAA;EA5pYF;;EA+pYA;IACE,gCAAA;EA7pYF;;EAgqYA;IACE,mCAAA;EA9pYF;;EAiqYA;IACE,kCAAA;EA/pYF;;EAkqYA;IACE,gCAAA;EAhqYF;;EAmqYA;IACE,iCAAA;EAjqYF;;EAoqYA;IACE,oCAAA;EAlqYF;;EAqqYA;IACE,mCAAA;EAnqYF;;EAsqYA;IACE,8BAAA;EApqYF;;EAuqYA;IACE,+BAAA;EArqYF;;EAwqYA;IACE,kCAAA;EAtqYF;;EAyqYA;IACE,iCAAA;EAvqYF;;EA0qYA;IACE,+BAAA;EAxqYF;;EA2qYA;IACE,gCAAA;EAzqYF;;EA4qYA;IACE,mCAAA;EA1qYF;;EA6qYA;IACE,kCAAA;EA3qYF;;EA8qYA;IACE,4BAAA;EA5qYF;;EA+qYA;IACE,6BAAA;EA7qYF;;EAgrYA;IACE,gCAAA;EA9qYF;;EAirYA;IACE,+BAAA;EA/qYF;;EAkrYA;IACE,8BAAA;EAhrYF;;EAmrYA;IACE,+BAAA;EAjrYF;;EAorYA;IACE,kCAAA;EAlrYF;;EAqrYA;IACE,iCAAA;EAnrYF;;EAsrYA;IACE,8BAAA;EAprYF;;EAurYA;IACE,+BAAA;EArrYF;;EAwrYA;IACE,kCAAA;EAtrYF;;EAyrYA;IACE,iCAAA;EAvrYF;;EA0rYA;IACE,mBAAA;EAxrYF;;EA2rYA;IACE,oBAAA;EAzrYF;;EA4rYA;IACE,oBAAA;EA1rYF;;EA6rYA;IACE,oBAAA;EA3rYF;;EA8rYA;IACE,kBAAA;EA5rYF;;EA+rYA;IACE,eAAA;EA7rYF;;EAgsYA;IACE,iBAAA;EA9rYF;;EAisYA;IACE,iBAAA;EA/rYF;;EAksYA;IACE,iBAAA;EAhsYF;;EAmsYA;IACE,iBAAA;EAjsYF;;EAosYA;IACE,mBAAA;EAlsYF;;EAqsYA;IACE,qBAAA;EAnsYF;;EAssYA;IACE,sBAAA;EApsYF;;EAusYA;IACE,oBAAA;EArsYF;;EAwsYA;IACE,qBAAA;EAtsYF;;EAysYA;IACE,uBAAA;EAvsYF;;EA0sYA;IACE,wBAAA;EAxsYF;;EA2sYA;IACE,sBAAA;EAzsYF;;EA4sYA;IACE,qBAAA;EA1sYF;;EA6sYA;IACE,uBAAA;EA3sYF;;EA8sYA;IACE,wBAAA;EA5sYF;;EA+sYA;IACE,sBAAA;EA7sYF;;EAgtYA;IACE,qBAAA;EA9sYF;;EAitYA;IACE,uBAAA;EA/sYF;;EAktYA;IACE,wBAAA;EAhtYF;;EAmtYA;IACE,sBAAA;EAjtYF;;EAotYA;IACE,qBAAA;EAltYF;;EAqtYA;IACE,uBAAA;EAntYF;;EAstYA;IACE,wBAAA;EAptYF;;EAutYA;IACE,sBAAA;EArtYF;;EAwtYA;IACE,sBAAA;EAttYF;;EAytYA;IACE,uBAAA;EAvtYF;;EA0tYA;IACE,YAAA;EAxtYF;;EA2tYA;IACE,eAAA;EAztYF;;EA4tYA;IACE,eAAA;EA1tYF;;EA6tYA;IACE,YAAA;EA3tYF;;EA8tYA;IACE,YAAA;EA5tYF;;EA+tYA;IACE,YAAA;EA7tYF;;EAguYA;IACE,mBAAA;EA9tYF;;EAiuYA;IACE,cAAA;EA/tYF;;EAkuYA;IACE,qBAAA;EAhuYF;;EAmuYA;IACE,eAAA;EAjuYF;;EAouYA;IACE,aAAA;EAluYF;;EAquYA;IACE,oBAAA;EAnuYF;;EAsuYA;IACE,cAAA;EApuYF;;EAuuYA;IACE,sBAAA;EAruYF;;EAwuYA;IACE,mBAAA;EAtuYF;;EAyuYA;IACE,qBAAA;EAvuYF;;EA0uYA;IACE,2BAAA;EAxuYF;;EA2uYA;IACE,2BAAA;EAzuYF;;EA4uYA;IACE,2BAAA;EA1uYF;;EA6uYA;IACE,wBAAA;EA3uYF;;EA8uYA;IACE,kBAAA;EA5uYF;;EA+uYA;IACE,kBAAA;EA7uYF;;EAgvYA;IACE,aAAA;EA9uYF;;EAivYA;IACE,oBAAA;EA/uYF;;EAkvYA;IACE,iBAAA;EAhvYF;;EAmvYA;IACE,aAAA;EAjvYF;;EAovYA;IACE,mBAAA;EAlvYF;;EAqvYA;IACE,2BAAA;EAnvYF;;EAsvYA;IACE,sBAAA;EApvYF;;EAuvYA;IACE,8BAAA;EArvYF;;EAwvYA;IACE,eAAA;EAtvYF;;EAyvYA;IACE,uBAAA;EAvvYF;;EA0vYA;IACE,iBAAA;EAxvYF;;EA2vYA;IACE,iBAAA;EAzvYF;;EA4vYA;IACE,kBAAA;EA1vYF;;EA6vYA;IACE,gBAAA;EA3vYF;;EA8vYA;IACE,mBAAA;EA5vYF;;EA+vYA;IACE,oBAAA;EA7vYF;;EAgwYA;IACE,qBAAA;EA9vYF;;EAiwYA;IACE,oBAAA;EA/vYF;;EAkwYA;IACE,kBAAA;EAhwYF;;EAmwYA;IACE,4BAAA;EAjwYF;;EAowYA;IACE,2BAAA;EAlwYF;;EAqwYA;IACE,2BAAA;EAnwYF;;EAswYA;IACE,sBAAA;EApwYF;;EAuwYA;IACE,gBAAA;EArwYF;;EAwwYA;IACE,iBAAA;EAtwYF;;EAywYA;IACE,eAAA;EAvwYF;;EA0wYA;IACE,kBAAA;EAxwYF;;EA2wYA;IACE,mBAAA;EAzwYF;;EA4wYA;IACE,uBAAA;EA1wYF;;EA6wYA;IACE,qBAAA;EA3wYF;;EA8wYA;IACE,mBAAA;EA5wYF;;EA+wYA;IACE,qBAAA;EA7wYF;;EAgxYA;IACE,oBAAA;EA9wYF;;EAixYA;IACE,qBAAA;EA/wYF;;EAkxYA;IACE,yBAAA;EAhxYF;;EAmxYA;IACE,uBAAA;EAjxYF;;EAoxYA;IACE,4BAAA;EAlxYF;;EAqxYA;IACE,2BAAA;EAnxYF;;EAsxYA;IACE,2BAAA;EApxYF;;EAuxYA;IACE,gBAAA;EArxYF;;EAwxYA;IACE,sBAAA;EAtxYF;;EAyxYA;IACE,oBAAA;EAvxYF;;EA0xYA;IACE,kBAAA;EAxxYF;;EA2xYA;IACE,mBAAA;EAzxYF;;EA4xYA;IACE,mBAAA;EA1xYF;;EA6xYA;IACE,oBAAA;EA3xYF;;EA8xYA;IACE,kBAAA;EA5xYF;;EA+xYA;IACE,qBAAA;EA7xYF;;EAgyYA;IACE,sBAAA;EA9xYF;;EAiyYA;IACE,2BAAA;EA/xYF;;EAkyYA;IACE,yBAAA;EAhyYF;;EAmyYA;IACE,uBAAA;EAjyYF;;EAoyYA;IACE,8BAAA;EAlyYF;;EAqyYA;IACE,6BAAA;EAnyYF;;EAsyYA;IACE,6BAAA;EApyYF;;EAuyYA;IACE,kBAAA;EAryYF;;EAwyYA;IACE,mBAAA;EAtyYF;;EAyyYA;IACE,iBAAA;EAvyYF;;EA0yYA;IACE,oBAAA;EAxyYF;;EA2yYA;IACE,qBAAA;EAzyYF;;EA4yYA;IACE,SAAA;EA1yYF;;EA6yYA;IACE,cAAA;EA3yYF;;EA8yYA;IACE,cAAA;EA5yYF;;EA+yYA;IACE,UAAA;EA7yYF;;EAgzYA;IACE,YAAA;EA9yYF;;EAizYA;IACE,YAAA;EA/yYF;;EAkzYA;IACE,cAAA;EAhzYF;;EAmzYA;IACE,cAAA;EAjzYF;;EAozYA;IACE,QAAA;EAlzYF;;EAqzYA;IACE,QAAA;EAnzYF;;EAszYA;IACE,QAAA;EApzYF;;EAuzYA;IACE,QAAA;EArzYF;;EAwzYA;IACE,QAAA;EAtzYF;;EAyzYA;IACE,QAAA;EAvzYF;;EA0zYA;IACE,QAAA;EAxzYF;;EA2zYA;IACE,QAAA;EAzzYF;;EA4zYA;IACE,QAAA;EA1zYF;;EA6zYA;IACE,SAAA;EA3zYF;;EA8zYA;IACE,SAAA;EA5zYF;;EA+zYA;IACE,SAAA;EA7zYF;;EAg0YA;IACE,YAAA;EA9zYF;;EAi0YA;IACE,WAAA;EA/zYF;;EAk0YA;IACE,QAAA;EAh0YF;;EAm0YA;IACE,YAAA;EAj0YF;;EAo0YA;IACE,WAAA;EAl0YF;;EAq0YA;IACE,WAAA;EAn0YF;;EAs0YA;IACE,WAAA;IACA,cAAA;IACA,WAAA;EAp0YF;;EAu0YA;IACE,WAAA;EAr0YF;;EAw0YA;IACE,YAAA;EAt0YF;;EAy0YA;IACE,WAAA;EAv0YF;;EA00YA;IACE,WAAA;EAx0YF;;EA20YA;IACE,6MAAA;EAz0YF;;EA40YA;IACE,8DAAA;EA10YF;;EA60YA;IACE,iFAAA;EA30YF;;EA80YA;IACE,gBAAA;EA50YF;;EA+0YA;IACE,gBAAA;EA70YF;;EAg1YA;IACE,gBAAA;EA90YF;;EAi1YA;IACE,gBAAA;EA/0YF;;EAk1YA;IACE,gBAAA;EAh1YF;;EAm1YA;IACE,gBAAA;EAj1YF;;EAo1YA;IACE,gBAAA;EAl1YF;;EAq1YA;IACE,gBAAA;EAn1YF;;EAs1YA;IACE,gBAAA;EAp1YF;;EAu1YA;IACE,gBAAA;EAr1YF;;EAw1YA;IACE,gBAAA;EAt1YF;;EAy1YA;IACE,gBAAA;EAv1YF;;EA01YA;IACE,gBAAA;EAx1YF;;EA21YA;IACE,gBAAA;EAz1YF;;EA41YA;IACE,gBAAA;EA11YF;;EA61YA;IACE,gBAAA;EA31YF;;EA81YA;IACE,gBAAA;EA51YF;;EA+1YA;IACE,gBAAA;EA71YF;;EAg2YA;IACE,gBAAA;EA91YF;;EAi2YA;IACE,gBAAA;EA/1YF;;EAk2YA;IACE,gBAAA;EAh2YF;;EAm2YA;IACE,gBAAA;EAj2YF;;EAo2YA;IACE,gBAAA;EAl2YF;;EAq2YA;IACE,gBAAA;EAn2YF;;EAs2YA;IACE,gBAAA;EAp2YF;;EAu2YA;IACE,gBAAA;EAr2YF;;EAw2YA;IACE,gBAAA;EAt2YF;;EAy2YA;IACE,SAAA;EAv2YF;;EA02YA;IACE,eAAA;EAx2YF;;EA22YA;IACE,cAAA;EAz2YF;;EA42YA;IACE,eAAA;EA12YF;;EA62YA;IACE,YAAA;EA32YF;;EA82YA;IACE,eAAA;EA52YF;;EA+2YA;IACE,cAAA;EA72YF;;EAg3YA;IACE,YAAA;EA92YF;;EAi3YA;IACE,cAAA;EA/2YF;;EAk3YA;IACE,YAAA;EAh3YF;;EAm3YA;IACE,YAAA;EAj3YF;;EAo3YA;IACE,YAAA;EAl3YF;;EAq3YA;IACE,YAAA;EAn3YF;;EAs3YA;IACE,YAAA;EAp3YF;;EAu3YA;IACE,aAAA;EAr3YF;;EAw3YA;IACE,aAAA;EAt3YF;;EAy3YA;IACE,aAAA;EAv3YF;;EA03YA;IACE,aAAA;EAx3YF;;EA23YA;IACE,YAAA;EAz3YF;;EA43YA;IACE,WAAA;EA13YF;;EA63YA;IACE,YAAA;EA33YF;;EA83YA;IACE,aAAA;EA53YF;;EA+3YA;IACE,oBAAA;EA73YF;;EAg4YA;IACE,kBAAA;EA93YF;;EAi4YA;IACE,mBAAA;EA/3YF;;EAk4YA;IACE,eAAA;EAh4YF;;EAm4YA;IACE,mBAAA;EAj4YF;;EAo4YA;IACE,kBAAA;EAl4YF;;EAq4YA;IACE,mBAAA;EAn4YF;;EAs4YA;IACE,iBAAA;EAp4YF;;EAu4YA;IACE,mBAAA;EAr4YF;;EAw4YA;IACE,kBAAA;EAt4YF;;EAy4YA;IACE,eAAA;EAv4YF;;EA04YA;IACE,eAAA;EAx4YF;;EA24YA;IACE,oBAAA;EAz4YF;;EA44YA;IACE,iBAAA;EA14YF;;EA64YA;IACE,oBAAA;EA34YF;;EA84YA;IACE,mBAAA;EA54YF;;EA+4YA;IACE,oBAAA;EA74YF;;EAg5YA;IACE,iBAAA;EA94YF;;EAi5YA;IACE,oBAAA;EA/4YF;;EAk5YA;IACE,mBAAA;EAh5YF;;EAm5YA;IACE,cAAA;EAj5YF;;EAo5YA;IACE,iBAAA;EAl5YF;;EAq5YA;IACE,kBAAA;EAn5YF;;EAs5YA;IACE,gBAAA;EAp5YF;;EAu5YA;IACE,kBAAA;EAr5YF;;EAw5YA;IACE,cAAA;EAt5YF;;EAy5YA;IACE,2BAAA;EAv5YF;;EA05YA;IACE,4BAAA;EAx5YF;;EA25YA;IACE,qBAAA;EAz5YF;;EA45YA;IACE,qBAAA;EA15YF;;EA65YA;IACE,wBAAA;EA35YF;;EA85YA;IACE,SAAA;EA55YF;;EA+5YA;IACE,eAAA;EA75YF;;EAg6YA;IACE,cAAA;EA95YF;;EAi6YA;IACE,eAAA;EA/5YF;;EAk6YA;IACE,YAAA;EAh6YF;;EAm6YA;IACE,eAAA;EAj6YF;;EAo6YA;IACE,cAAA;EAl6YF;;EAq6YA;IACE,YAAA;EAn6YF;;EAs6YA;IACE,cAAA;EAp6YF;;EAu6YA;IACE,YAAA;EAr6YF;;EAw6YA;IACE,YAAA;EAt6YF;;EAy6YA;IACE,YAAA;EAv6YF;;EA06YA;IACE,YAAA;EAx6YF;;EA26YA;IACE,YAAA;EAz6YF;;EA46YA;IACE,aAAA;EA16YF;;EA66YA;IACE,aAAA;EA36YF;;EA86YA;IACE,aAAA;EA56YF;;EA+6YA;IACE,aAAA;EA76YF;;EAg7YA;IACE,YAAA;EA96YF;;EAi7YA;IACE,WAAA;EA/6YF;;EAk7YA;IACE,gBAAA;EAh7YF;;EAm7YA;IACE,eAAA;EAj7YF;;EAo7YA;IACE,gBAAA;EAl7YF;;EAq7YA;IACE,aAAA;EAn7YF;;EAs7YA;IACE,gBAAA;EAp7YF;;EAu7YA;IACE,eAAA;EAr7YF;;EAw7YA;IACE,aAAA;EAt7YF;;EAy7YA;IACE,eAAA;EAv7YF;;EA07YA;IACE,aAAA;EAx7YF;;EA27YA;IACE,aAAA;EAz7YF;;EA47YA;IACE,aAAA;EA17YF;;EA67YA;IACE,aAAA;EA37YF;;EA87YA;IACE,aAAA;EA57YF;;EA+7YA;IACE,cAAA;EA77YF;;EAg8YA;IACE,cAAA;EA97YF;;EAi8YA;IACE,cAAA;EA/7YF;;EAk8YA;IACE,cAAA;EAh8YF;;EAm8YA;IACE,YAAA;EAj8YF;;EAo8YA;IACE,aAAA;IACA,gBAAA;EAl8YF;;EAq8YA;IACE,cAAA;IACA,eAAA;EAn8YF;;EAs8YA;IACE,mBAAA;IACA,sBAAA;EAp8YF;;EAu8YA;IACE,oBAAA;IACA,qBAAA;EAr8YF;;EAw8YA;IACE,kBAAA;IACA,qBAAA;EAt8YF;;EAy8YA;IACE,mBAAA;IACA,oBAAA;EAv8YF;;EA08YA;IACE,mBAAA;IACA,sBAAA;EAx8YF;;EA28YA;IACE,oBAAA;IACA,qBAAA;EAz8YF;;EA48YA;IACE,gBAAA;IACA,mBAAA;EA18YF;;EA68YA;IACE,iBAAA;IACA,kBAAA;EA38YF;;EA88YA;IACE,mBAAA;IACA,sBAAA;EA58YF;;EA+8YA;IACE,oBAAA;IACA,qBAAA;EA78YF;;EAg9YA;IACE,kBAAA;IACA,qBAAA;EA98YF;;EAi9YA;IACE,mBAAA;IACA,oBAAA;EA/8YF;;EAk9YA;IACE,gBAAA;IACA,mBAAA;EAh9YF;;EAm9YA;IACE,iBAAA;IACA,kBAAA;EAj9YF;;EAo9YA;IACE,kBAAA;IACA,qBAAA;EAl9YF;;EAq9YA;IACE,mBAAA;IACA,oBAAA;EAn9YF;;EAs9YA;IACE,gBAAA;IACA,mBAAA;EAp9YF;;EAu9YA;IACE,iBAAA;IACA,kBAAA;EAr9YF;;EAw9YA;IACE,gBAAA;IACA,mBAAA;EAt9YF;;EAy9YA;IACE,iBAAA;IACA,kBAAA;EAv9YF;;EA09YA;IACE,gBAAA;IACA,mBAAA;EAx9YF;;EA29YA;IACE,iBAAA;IACA,kBAAA;EAz9YF;;EA49YA;IACE,gBAAA;IACA,mBAAA;EA19YF;;EA69YA;IACE,iBAAA;IACA,kBAAA;EA39YF;;EA89YA;IACE,gBAAA;IACA,mBAAA;EA59YF;;EA+9YA;IACE,iBAAA;IACA,kBAAA;EA79YF;;EAg+YA;IACE,iBAAA;IACA,oBAAA;EA99YF;;EAi+YA;IACE,kBAAA;IACA,mBAAA;EA/9YF;;EAk+YA;IACE,iBAAA;IACA,oBAAA;EAh+YF;;EAm+YA;IACE,kBAAA;IACA,mBAAA;EAj+YF;;EAo+YA;IACE,iBAAA;IACA,oBAAA;EAl+YF;;EAq+YA;IACE,kBAAA;IACA,mBAAA;EAn+YF;;EAs+YA;IACE,iBAAA;IACA,oBAAA;EAp+YF;;EAu+YA;IACE,kBAAA;IACA,mBAAA;EAr+YF;;EAw+YA;IACE,gBAAA;IACA,mBAAA;EAt+YF;;EAy+YA;IACE,iBAAA;IACA,kBAAA;EAv+YF;;EA0+YA;IACE,eAAA;IACA,kBAAA;EAx+YF;;EA2+YA;IACE,gBAAA;IACA,iBAAA;EAz+YF;;EA4+YA;IACE,oBAAA;IACA,uBAAA;EA1+YF;;EA6+YA;IACE,qBAAA;IACA,sBAAA;EA3+YF;;EA8+YA;IACE,mBAAA;IACA,sBAAA;EA5+YF;;EA++YA;IACE,oBAAA;IACA,qBAAA;EA7+YF;;EAg/YA;IACE,oBAAA;IACA,uBAAA;EA9+YF;;EAi/YA;IACE,qBAAA;IACA,sBAAA;EA/+YF;;EAk/YA;IACE,iBAAA;IACA,oBAAA;EAh/YF;;EAm/YA;IACE,kBAAA;IACA,mBAAA;EAj/YF;;EAo/YA;IACE,oBAAA;IACA,uBAAA;EAl/YF;;EAq/YA;IACE,qBAAA;IACA,sBAAA;EAn/YF;;EAs/YA;IACE,mBAAA;IACA,sBAAA;EAp/YF;;EAu/YA;IACE,oBAAA;IACA,qBAAA;EAr/YF;;EAw/YA;IACE,iBAAA;IACA,oBAAA;EAt/YF;;EAy/YA;IACE,kBAAA;IACA,mBAAA;EAv/YF;;EA0/YA;IACE,mBAAA;IACA,sBAAA;EAx/YF;;EA2/YA;IACE,oBAAA;IACA,qBAAA;EAz/YF;;EA4/YA;IACE,iBAAA;IACA,oBAAA;EA1/YF;;EA6/YA;IACE,kBAAA;IACA,mBAAA;EA3/YF;;EA8/YA;IACE,iBAAA;IACA,oBAAA;EA5/YF;;EA+/YA;IACE,kBAAA;IACA,mBAAA;EA7/YF;;EAggZA;IACE,iBAAA;IACA,oBAAA;EA9/YF;;EAigZA;IACE,kBAAA;IACA,mBAAA;EA//YF;;EAkgZA;IACE,iBAAA;IACA,oBAAA;EAhgZF;;EAmgZA;IACE,kBAAA;IACA,mBAAA;EAjgZF;;EAogZA;IACE,iBAAA;IACA,oBAAA;EAlgZF;;EAqgZA;IACE,kBAAA;IACA,mBAAA;EAngZF;;EAsgZA;IACE,kBAAA;IACA,qBAAA;EApgZF;;EAugZA;IACE,mBAAA;IACA,oBAAA;EArgZF;;EAwgZA;IACE,kBAAA;IACA,qBAAA;EAtgZF;;EAygZA;IACE,mBAAA;IACA,oBAAA;EAvgZF;;EA0gZA;IACE,kBAAA;IACA,qBAAA;EAxgZF;;EA2gZA;IACE,mBAAA;IACA,oBAAA;EAzgZF;;EA4gZA;IACE,kBAAA;IACA,qBAAA;EA1gZF;;EA6gZA;IACE,mBAAA;IACA,oBAAA;EA3gZF;;EA8gZA;IACE,gBAAA;IACA,mBAAA;EA5gZF;;EA+gZA;IACE,iBAAA;IACA,kBAAA;EA7gZF;;EAghZA;IACE,aAAA;EA9gZF;;EAihZA;IACE,eAAA;EA/gZF;;EAkhZA;IACE,gBAAA;EAhhZF;;EAmhZA;IACE,cAAA;EAjhZF;;EAohZA;IACE,mBAAA;EAlhZF;;EAqhZA;IACE,qBAAA;EAnhZF;;EAshZA;IACE,sBAAA;EAphZF;;EAuhZA;IACE,oBAAA;EArhZF;;EAwhZA;IACE,kBAAA;EAthZF;;EAyhZA;IACE,oBAAA;EAvhZF;;EA0hZA;IACE,qBAAA;EAxhZF;;EA2hZA;IACE,mBAAA;EAzhZF;;EA4hZA;IACE,mBAAA;EA1hZF;;EA6hZA;IACE,qBAAA;EA3hZF;;EA8hZA;IACE,sBAAA;EA5hZF;;EA+hZA;IACE,oBAAA;EA7hZF;;EAgiZA;IACE,gBAAA;EA9hZF;;EAiiZA;IACE,kBAAA;EA/hZF;;EAkiZA;IACE,mBAAA;EAhiZF;;EAmiZA;IACE,iBAAA;EAjiZF;;EAoiZA;IACE,mBAAA;EAliZF;;EAqiZA;IACE,qBAAA;EAniZF;;EAsiZA;IACE,sBAAA;EApiZF;;EAuiZA;IACE,oBAAA;EAriZF;;EAwiZA;IACE,kBAAA;EAtiZF;;EAyiZA;IACE,oBAAA;EAviZF;;EA0iZA;IACE,qBAAA;EAxiZF;;EA2iZA;IACE,mBAAA;EAziZF;;EA4iZA;IACE,gBAAA;EA1iZF;;EA6iZA;IACE,kBAAA;EA3iZF;;EA8iZA;IACE,mBAAA;EA5iZF;;EA+iZA;IACE,iBAAA;EA7iZF;;EAgjZA;IACE,kBAAA;EA9iZF;;EAijZA;IACE,oBAAA;EA/iZF;;EAkjZA;IACE,qBAAA;EAhjZF;;EAmjZA;IACE,mBAAA;EAjjZF;;EAojZA;IACE,gBAAA;EAljZF;;EAqjZA;IACE,kBAAA;EAnjZF;;EAsjZA;IACE,mBAAA;EApjZF;;EAujZA;IACE,iBAAA;EArjZF;;EAwjZA;IACE,gBAAA;EAtjZF;;EAyjZA;IACE,kBAAA;EAvjZF;;EA0jZA;IACE,mBAAA;EAxjZF;;EA2jZA;IACE,iBAAA;EAzjZF;;EA4jZA;IACE,gBAAA;EA1jZF;;EA6jZA;IACE,kBAAA;EA3jZF;;EA8jZA;IACE,mBAAA;EA5jZF;;EA+jZA;IACE,iBAAA;EA7jZF;;EAgkZA;IACE,gBAAA;EA9jZF;;EAikZA;IACE,kBAAA;EA/jZF;;EAkkZA;IACE,mBAAA;EAhkZF;;EAmkZA;IACE,iBAAA;EAjkZF;;EAokZA;IACE,gBAAA;EAlkZF;;EAqkZA;IACE,kBAAA;EAnkZF;;EAskZA;IACE,mBAAA;EApkZF;;EAukZA;IACE,iBAAA;EArkZF;;EAwkZA;IACE,iBAAA;EAtkZF;;EAykZA;IACE,mBAAA;EAvkZF;;EA0kZA;IACE,oBAAA;EAxkZF;;EA2kZA;IACE,kBAAA;EAzkZF;;EA4kZA;IACE,iBAAA;EA1kZF;;EA6kZA;IACE,mBAAA;EA3kZF;;EA8kZA;IACE,oBAAA;EA5kZF;;EA+kZA;IACE,kBAAA;EA7kZF;;EAglZA;IACE,iBAAA;EA9kZF;;EAilZA;IACE,mBAAA;EA/kZF;;EAklZA;IACE,oBAAA;EAhlZF;;EAmlZA;IACE,kBAAA;EAjlZF;;EAolZA;IACE,iBAAA;EAllZF;;EAqlZA;IACE,mBAAA;EAnlZF;;EAslZA;IACE,oBAAA;EAplZF;;EAulZA;IACE,kBAAA;EArlZF;;EAwlZA;IACE,gBAAA;EAtlZF;;EAylZA;IACE,kBAAA;EAvlZF;;EA0lZA;IACE,mBAAA;EAxlZF;;EA2lZA;IACE,iBAAA;EAzlZF;;EA4lZA;IACE,eAAA;EA1lZF;;EA6lZA;IACE,iBAAA;EA3lZF;;EA8lZA;IACE,kBAAA;EA5lZF;;EA+lZA;IACE,gBAAA;EA7lZF;;EAgmZA;IACE,oBAAA;EA9lZF;;EAimZA;IACE,sBAAA;EA/lZF;;EAkmZA;IACE,uBAAA;EAhmZF;;EAmmZA;IACE,qBAAA;EAjmZF;;EAomZA;IACE,mBAAA;EAlmZF;;EAqmZA;IACE,qBAAA;EAnmZF;;EAsmZA;IACE,sBAAA;EApmZF;;EAumZA;IACE,oBAAA;EArmZF;;EAwmZA;IACE,oBAAA;EAtmZF;;EAymZA;IACE,sBAAA;EAvmZF;;EA0mZA;IACE,uBAAA;EAxmZF;;EA2mZA;IACE,qBAAA;EAzmZF;;EA4mZA;IACE,iBAAA;EA1mZF;;EA6mZA;IACE,mBAAA;EA3mZF;;EA8mZA;IACE,oBAAA;EA5mZF;;EA+mZA;IACE,kBAAA;EA7mZF;;EAgnZA;IACE,oBAAA;EA9mZF;;EAinZA;IACE,sBAAA;EA/mZF;;EAknZA;IACE,uBAAA;EAhnZF;;EAmnZA;IACE,qBAAA;EAjnZF;;EAonZA;IACE,mBAAA;EAlnZF;;EAqnZA;IACE,qBAAA;EAnnZF;;EAsnZA;IACE,sBAAA;EApnZF;;EAunZA;IACE,oBAAA;EArnZF;;EAwnZA;IACE,iBAAA;EAtnZF;;EAynZA;IACE,mBAAA;EAvnZF;;EA0nZA;IACE,oBAAA;EAxnZF;;EA2nZA;IACE,kBAAA;EAznZF;;EA4nZA;IACE,mBAAA;EA1nZF;;EA6nZA;IACE,qBAAA;EA3nZF;;EA8nZA;IACE,sBAAA;EA5nZF;;EA+nZA;IACE,oBAAA;EA7nZF;;EAgoZA;IACE,iBAAA;EA9nZF;;EAioZA;IACE,mBAAA;EA/nZF;;EAkoZA;IACE,oBAAA;EAhoZF;;EAmoZA;IACE,kBAAA;EAjoZF;;EAooZA;IACE,iBAAA;EAloZF;;EAqoZA;IACE,mBAAA;EAnoZF;;EAsoZA;IACE,oBAAA;EApoZF;;EAuoZA;IACE,kBAAA;EAroZF;;EAwoZA;IACE,iBAAA;EAtoZF;;EAyoZA;IACE,mBAAA;EAvoZF;;EA0oZA;IACE,oBAAA;EAxoZF;;EA2oZA;IACE,kBAAA;EAzoZF;;EA4oZA;IACE,iBAAA;EA1oZF;;EA6oZA;IACE,mBAAA;EA3oZF;;EA8oZA;IACE,oBAAA;EA5oZF;;EA+oZA;IACE,kBAAA;EA7oZF;;EAgpZA;IACE,iBAAA;EA9oZF;;EAipZA;IACE,mBAAA;EA/oZF;;EAkpZA;IACE,oBAAA;EAhpZF;;EAmpZA;IACE,kBAAA;EAjpZF;;EAopZA;IACE,kBAAA;EAlpZF;;EAqpZA;IACE,oBAAA;EAnpZF;;EAspZA;IACE,qBAAA;EAppZF;;EAupZA;IACE,mBAAA;EArpZF;;EAwpZA;IACE,kBAAA;EAtpZF;;EAypZA;IACE,oBAAA;EAvpZF;;EA0pZA;IACE,qBAAA;EAxpZF;;EA2pZA;IACE,mBAAA;EAzpZF;;EA4pZA;IACE,kBAAA;EA1pZF;;EA6pZA;IACE,oBAAA;EA3pZF;;EA8pZA;IACE,qBAAA;EA5pZF;;EA+pZA;IACE,mBAAA;EA7pZF;;EAgqZA;IACE,kBAAA;EA9pZF;;EAiqZA;IACE,oBAAA;EA/pZF;;EAkqZA;IACE,qBAAA;EAhqZF;;EAmqZA;IACE,mBAAA;EAjqZF;;EAoqZA;IACE,gBAAA;EAlqZF;;EAqqZA;IACE,kBAAA;EAnqZF;;EAsqZA;IACE,mBAAA;EApqZF;;EAuqZA;IACE,iBAAA;EArqZF;;EAwqZA;IACE,gBAAA;EAtqZF;;EAyqZA;IACE,iBAAA;EAvqZF;;EA0qZA;IACE,eAAA;EAxqZF;;EA2qZA;IACE,gBAAA;EAzqZF;;EA4qZA;IACE,gBAAA;EA1qZF;;EA6qZA;IACE,gBAAA;EA3qZF;;EA8qZA;IACE,gBAAA;EA5qZF;;EA+qZA;IACE,gBAAA;EA7qZF;;EAgrZA;IACE,gBAAA;EA9qZF;;EAirZA;IACE,gBAAA;EA/qZF;;EAkrZA;IACE,gBAAA;EAhrZF;;EAmrZA;IACE,gBAAA;EAjrZF;;EAorZA;IACE,gBAAA;EAlrZF;;EAqrZA;IACE,eAAA;EAnrZF;;EAsrZA;IACE,gBAAA;EAprZF;;EAurZA;IACE,gBAAA;EArrZF;;EAwrZA;IACE,iBAAA;EAtrZF;;EAyrZA;IACE,iBAAA;EAvrZF;;EA0rZA;IACE,aAAA;EAxrZF;;EA2rZA;IACE,gBAAA;EAzrZF;;EA4rZA;IACE,iBAAA;EA1rZF;;EA6rZA;IACE,YAAA;EA3rZF;;EA8rZA;IACE,eAAA;EA5rZF;;EA+rZA;IACE,mBAAA;EA7rZF;;EAgsZA;IACE,iBAAA;EA9rZF;;EAisZA;IACE,gBAAA;EA/rZF;;EAksZA;IACE,gBAAA;EAhsZF;;EAmsZA;IACE,sBAAA;EAjsZF;;EAosZA;IACE,uBAAA;EAlsZF;;EAqsZA;IACE,uBAAA;EAnsZF;;EAssZA;IACE,qBAAA;EApsZF;;EAusZA;IACE,4BAAA;EArsZF;;EAwsZA;IACE,yBAAA;EAtsZF;;EAysZA;IACE,sBAAA;EAvsZF;;EA0sZA;IACE,6BAAA;EAxsZF;;EA2sZA;IACE,0BAAA;EAzsZF;;EA4sZA;IACE,oBAAA;EA1sZF;;EA6sZA;IACE,UAAA;EA3sZF;;EA8sZA;IACE,aAAA;EA5sZF;;EA+sZA;IACE,YAAA;EA7sZF;;EAgtZA;IACE,aAAA;EA9sZF;;EAitZA;IACE,UAAA;EA/sZF;;EAktZA;IACE,UAAA;EAhtZF;;EAmtZA;IACE,aAAA;EAjtZF;;EAotZA;IACE,YAAA;EAltZF;;EAqtZA;IACE,aAAA;EAntZF;;EAstZA;IACE,UAAA;EAptZF;;EAutZA;IACE,UAAA;EArtZF;;EAwtZA;IACE,aAAA;EAttZF;;EAytZA;IACE,YAAA;EAvtZF;;EA0tZA;IACE,aAAA;EAxtZF;;EA2tZA;IACE,UAAA;EAztZF;;EA4tZA;IACE,8BAAA;IACA,mBAAA;EA1tZF;;EA6tZA;IACE,yBAAA;IACA,mBAAA;EA3tZF;;EA8tZA;IACE,yBAAA;IACA,mBAAA;EA5tZF;;EA+tZA;IACE,8BAAA;IACA,mBAAA;EA7tZF;;EAguZA;IACE,yBAAA;IACA,mBAAA;EA9tZF;;EAiuZA;IACE,yBAAA;IACA,mBAAA;EA/tZF;;EAkuZA;IACE,cAAA;EAhuZF;;EAmuZA;IACE,gBAAA;EAjuZF;;EAouZA;IACE,iBAAA;EAluZF;;EAquZA;IACE,gBAAA;EAnuZF;;EAsuZA;IACE,gBAAA;EApuZF;;EAuuZA;IACE,gBAAA;EAruZF;;EAwuZA;IACE,kBAAA;EAtuZF;;EAyuZA;IACE,kBAAA;EAvuZF;;EA0uZA;IACE,mBAAA;EAxuZF;;EA2uZA;IACE,mBAAA;EAzuZF;;EA4uZA;IACE,kBAAA;EA1uZF;;EA6uZA;IACE,kBAAA;EA3uZF;;EA8uZA;IACE,iCAAA;EA5uZF;;EA+uZA;IACE,gCAAA;EA7uZF;;EAgvZA;IACE,yBAAA;EA9uZF;;EAivZA;IACE,4BAAA;EA/uZF;;EAkvZA;IACE,yBAAA;EAhvZF;;EAmvZA;IACE,2BAAA;EAjvZF;;EAovZA;IACE,8BAAA;EAlvZF;;EAqvZA;IACE,2BAAA;EAnvZF;;EAsvZA;IACE,2BAAA;EApvZF;;EAuvZA;IACE,8BAAA;EArvZF;;EAwvZA;IACE,2BAAA;EAtvZF;;EAyvZA;IACE,UAAA;EAvvZF;;EA0vZA;IACE,gBAAA;EAxvZF;;EA2vZA;IACE,eAAA;EAzvZF;;EA4vZA;IACE,gBAAA;EA1vZF;;EA6vZA;IACE,aAAA;EA3vZF;;EA8vZA;IACE,gBAAA;EA5vZF;;EA+vZA;IACE,eAAA;EA7vZF;;EAgwZA;IACE,aAAA;EA9vZF;;EAiwZA;IACE,eAAA;EA/vZF;;EAkwZA;IACE,aAAA;EAhwZF;;EAmwZA;IACE,aAAA;EAjwZF;;EAowZA;IACE,aAAA;EAlwZF;;EAqwZA;IACE,aAAA;EAnwZF;;EAswZA;IACE,aAAA;EApwZF;;EAuwZA;IACE,cAAA;EArwZF;;EAwwZA;IACE,cAAA;EAtwZF;;EAywZA;IACE,cAAA;EAvwZF;;EA0wZA;IACE,cAAA;EAxwZF;;EA2wZA;IACE,YAAA;EAzwZF;;EA4wZA;IACE,cAAA;IACA,iBAAA;EA1wZF;;EA6wZA;IACE,eAAA;IACA,gBAAA;EA3wZF;;EA8wZA;IACE,oBAAA;IACA,uBAAA;EA5wZF;;EA+wZA;IACE,qBAAA;IACA,sBAAA;EA7wZF;;EAgxZA;IACE,mBAAA;IACA,sBAAA;EA9wZF;;EAixZA;IACE,oBAAA;IACA,qBAAA;EA/wZF;;EAkxZA;IACE,oBAAA;IACA,uBAAA;EAhxZF;;EAmxZA;IACE,qBAAA;IACA,sBAAA;EAjxZF;;EAoxZA;IACE,iBAAA;IACA,oBAAA;EAlxZF;;EAqxZA;IACE,kBAAA;IACA,mBAAA;EAnxZF;;EAsxZA;IACE,oBAAA;IACA,uBAAA;EApxZF;;EAuxZA;IACE,qBAAA;IACA,sBAAA;EArxZF;;EAwxZA;IACE,mBAAA;IACA,sBAAA;EAtxZF;;EAyxZA;IACE,oBAAA;IACA,qBAAA;EAvxZF;;EA0xZA;IACE,iBAAA;IACA,oBAAA;EAxxZF;;EA2xZA;IACE,kBAAA;IACA,mBAAA;EAzxZF;;EA4xZA;IACE,mBAAA;IACA,sBAAA;EA1xZF;;EA6xZA;IACE,oBAAA;IACA,qBAAA;EA3xZF;;EA8xZA;IACE,iBAAA;IACA,oBAAA;EA5xZF;;EA+xZA;IACE,kBAAA;IACA,mBAAA;EA7xZF;;EAgyZA;IACE,iBAAA;IACA,oBAAA;EA9xZF;;EAiyZA;IACE,kBAAA;IACA,mBAAA;EA/xZF;;EAkyZA;IACE,iBAAA;IACA,oBAAA;EAhyZF;;EAmyZA;IACE,kBAAA;IACA,mBAAA;EAjyZF;;EAoyZA;IACE,iBAAA;IACA,oBAAA;EAlyZF;;EAqyZA;IACE,kBAAA;IACA,mBAAA;EAnyZF;;EAsyZA;IACE,iBAAA;IACA,oBAAA;EApyZF;;EAuyZA;IACE,kBAAA;IACA,mBAAA;EAryZF;;EAwyZA;IACE,kBAAA;IACA,qBAAA;EAtyZF;;EAyyZA;IACE,mBAAA;IACA,oBAAA;EAvyZF;;EA0yZA;IACE,kBAAA;IACA,qBAAA;EAxyZF;;EA2yZA;IACE,mBAAA;IACA,oBAAA;EAzyZF;;EA4yZA;IACE,kBAAA;IACA,qBAAA;EA1yZF;;EA6yZA;IACE,mBAAA;IACA,oBAAA;EA3yZF;;EA8yZA;IACE,kBAAA;IACA,qBAAA;EA5yZF;;EA+yZA;IACE,mBAAA;IACA,oBAAA;EA7yZF;;EAgzZA;IACE,gBAAA;IACA,mBAAA;EA9yZF;;EAizZA;IACE,iBAAA;IACA,kBAAA;EA/yZF;;EAkzZA;IACE,cAAA;EAhzZF;;EAmzZA;IACE,gBAAA;EAjzZF;;EAozZA;IACE,iBAAA;EAlzZF;;EAqzZA;IACE,eAAA;EAnzZF;;EAszZA;IACE,oBAAA;EApzZF;;EAuzZA;IACE,sBAAA;EArzZF;;EAwzZA;IACE,uBAAA;EAtzZF;;EAyzZA;IACE,qBAAA;EAvzZF;;EA0zZA;IACE,mBAAA;EAxzZF;;EA2zZA;IACE,qBAAA;EAzzZF;;EA4zZA;IACE,sBAAA;EA1zZF;;EA6zZA;IACE,oBAAA;EA3zZF;;EA8zZA;IACE,oBAAA;EA5zZF;;EA+zZA;IACE,sBAAA;EA7zZF;;EAg0ZA;IACE,uBAAA;EA9zZF;;EAi0ZA;IACE,qBAAA;EA/zZF;;EAk0ZA;IACE,iBAAA;EAh0ZF;;EAm0ZA;IACE,mBAAA;EAj0ZF;;EAo0ZA;IACE,oBAAA;EAl0ZF;;EAq0ZA;IACE,kBAAA;EAn0ZF;;EAs0ZA;IACE,oBAAA;EAp0ZF;;EAu0ZA;IACE,sBAAA;EAr0ZF;;EAw0ZA;IACE,uBAAA;EAt0ZF;;EAy0ZA;IACE,qBAAA;EAv0ZF;;EA00ZA;IACE,mBAAA;EAx0ZF;;EA20ZA;IACE,qBAAA;EAz0ZF;;EA40ZA;IACE,sBAAA;EA10ZF;;EA60ZA;IACE,oBAAA;EA30ZF;;EA80ZA;IACE,iBAAA;EA50ZF;;EA+0ZA;IACE,mBAAA;EA70ZF;;EAg1ZA;IACE,oBAAA;EA90ZF;;EAi1ZA;IACE,kBAAA;EA/0ZF;;EAk1ZA;IACE,mBAAA;EAh1ZF;;EAm1ZA;IACE,qBAAA;EAj1ZF;;EAo1ZA;IACE,sBAAA;EAl1ZF;;EAq1ZA;IACE,oBAAA;EAn1ZF;;EAs1ZA;IACE,iBAAA;EAp1ZF;;EAu1ZA;IACE,mBAAA;EAr1ZF;;EAw1ZA;IACE,oBAAA;EAt1ZF;;EAy1ZA;IACE,kBAAA;EAv1ZF;;EA01ZA;IACE,iBAAA;EAx1ZF;;EA21ZA;IACE,mBAAA;EAz1ZF;;EA41ZA;IACE,oBAAA;EA11ZF;;EA61ZA;IACE,kBAAA;EA31ZF;;EA81ZA;IACE,iBAAA;EA51ZF;;EA+1ZA;IACE,mBAAA;EA71ZF;;EAg2ZA;IACE,oBAAA;EA91ZF;;EAi2ZA;IACE,kBAAA;EA/1ZF;;EAk2ZA;IACE,iBAAA;EAh2ZF;;EAm2ZA;IACE,mBAAA;EAj2ZF;;EAo2ZA;IACE,oBAAA;EAl2ZF;;EAq2ZA;IACE,kBAAA;EAn2ZF;;EAs2ZA;IACE,iBAAA;EAp2ZF;;EAu2ZA;IACE,mBAAA;EAr2ZF;;EAw2ZA;IACE,oBAAA;EAt2ZF;;EAy2ZA;IACE,kBAAA;EAv2ZF;;EA02ZA;IACE,kBAAA;EAx2ZF;;EA22ZA;IACE,oBAAA;EAz2ZF;;EA42ZA;IACE,qBAAA;EA12ZF;;EA62ZA;IACE,mBAAA;EA32ZF;;EA82ZA;IACE,kBAAA;EA52ZF;;EA+2ZA;IACE,oBAAA;EA72ZF;;EAg3ZA;IACE,qBAAA;EA92ZF;;EAi3ZA;IACE,mBAAA;EA/2ZF;;EAk3ZA;IACE,kBAAA;EAh3ZF;;EAm3ZA;IACE,oBAAA;EAj3ZF;;EAo3ZA;IACE,qBAAA;EAl3ZF;;EAq3ZA;IACE,mBAAA;EAn3ZF;;EAs3ZA;IACE,kBAAA;EAp3ZF;;EAu3ZA;IACE,oBAAA;EAr3ZF;;EAw3ZA;IACE,qBAAA;EAt3ZF;;EAy3ZA;IACE,mBAAA;EAv3ZF;;EA03ZA;IACE,gBAAA;EAx3ZF;;EA23ZA;IACE,kBAAA;EAz3ZF;;EA43ZA;IACE,mBAAA;EA13ZF;;EA63ZA;IACE,iBAAA;EA33ZF;;EA83ZA;IACE,kBAAA;EA53ZF;;EA+3ZA;IACE,mBAAA;EA73ZF;;EAg4ZA;IACE,wBAAA;IACA,WAAA;IACA,gDAAA;EA93ZF;;EAi4ZA;IACE,wBAAA;IACA,WAAA;IACA,sDAAA;EA/3ZF;;EAk4ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAh4ZF;;EAm4ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAj4ZF;;EAo4ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl4ZF;;EAq4ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn4ZF;;EAs4ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp4ZF;;EAu4ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr4ZF;;EAw4ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAt4ZF;;EAy4ZA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAv4ZF;;EA04ZA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAx4ZF;;EA24ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAz4ZF;;EA44ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA14ZF;;EA64ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA34ZF;;EA84ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA54ZF;;EA+4ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA74ZF;;EAg5ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA94ZF;;EAi5ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/4ZF;;EAk5ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAh5ZF;;EAm5ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAj5ZF;;EAo5ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl5ZF;;EAq5ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn5ZF;;EAs5ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp5ZF;;EAu5ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAr5ZF;;EAw5ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAt5ZF;;EAy5ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAv5ZF;;EA05ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAx5ZF;;EA25ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAz5ZF;;EA45ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA15ZF;;EA65ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA35ZF;;EA85ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA55ZF;;EA+5ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA75ZF;;EAg6ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA95ZF;;EAi6ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/5ZF;;EAk6ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAh6ZF;;EAm6ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAj6ZF;;EAo6ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAl6ZF;;EAq6ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAn6ZF;;EAs6ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp6ZF;;EAu6ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr6ZF;;EAw6ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt6ZF;;EAy6ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv6ZF;;EA06ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAx6ZF;;EA26ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAz6ZF;;EA46ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA16ZF;;EA66ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA36ZF;;EA86ZA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA56ZF;;EA+6ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA76ZF;;EAg7ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA96ZF;;EAi7ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/6ZF;;EAk7ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAh7ZF;;EAm7ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAj7ZF;;EAo7ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAl7ZF;;EAq7ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAn7ZF;;EAs7ZA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAp7ZF;;EAu7ZA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAr7ZF;;EAw7ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAt7ZF;;EAy7ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv7ZF;;EA07ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAx7ZF;;EA27ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAz7ZF;;EA47ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA17ZF;;EA67ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA37ZF;;EA87ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA57ZF;;EA+7ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA77ZF;;EAg8ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA97ZF;;EAi8ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/7ZF;;EAk8ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAh8ZF;;EAm8ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAj8ZF;;EAo8ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl8ZF;;EAq8ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn8ZF;;EAs8ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAp8ZF;;EAu8ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAr8ZF;;EAw8ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAt8ZF;;EAy8ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAv8ZF;;EA08ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAx8ZF;;EA28ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAz8ZF;;EA48ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA18ZF;;EA68ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA38ZF;;EA88ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA58ZF;;EA+8ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA78ZF;;EAg9ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA98ZF;;EAi9ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/8ZF;;EAk9ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAh9ZF;;EAm9ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAj9ZF;;EAo9ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl9ZF;;EAq9ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn9ZF;;EAs9ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAp9ZF;;EAu9ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAr9ZF;;EAw9ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAt9ZF;;EAy9ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAv9ZF;;EA09ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAx9ZF;;EA29ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAz9ZF;;EA49ZA;IACE,kBAAA;EA19ZF;;EA69ZA;IACE,mBAAA;EA39ZF;;EA89ZA;IACE,wBAAA;IACA,WAAA;IACA,gDAAA;EA59ZF;;EA+9ZA;IACE,wBAAA;IACA,WAAA;IACA,sDAAA;EA79ZF;;EAg+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA99ZF;;EAi+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/9ZF;;EAk+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAh+ZF;;EAm+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAj+ZF;;EAo+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl+ZF;;EAq+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAn+ZF;;EAs+ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAp+ZF;;EAu+ZA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAr+ZF;;EAw+ZA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAt+ZF;;EAy+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAv+ZF;;EA0+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAx+ZF;;EA2+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAz+ZF;;EA4+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1+ZF;;EA6+ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3+ZF;;EA8+ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA5+ZF;;EA++ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA7+ZF;;EAg/ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA9+ZF;;EAi/ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA/+ZF;;EAk/ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAh/ZF;;EAm/ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAj/ZF;;EAo/ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAl/ZF;;EAq/ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAn/ZF;;EAs/ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAp/ZF;;EAu/ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAr/ZF;;EAw/ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAt/ZF;;EAy/ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAv/ZF;;EA0/ZA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAx/ZF;;EA2/ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAz/ZF;;EA4/ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1/ZF;;EA6/ZA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3/ZF;;EA8/ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA5/ZF;;EA+/ZA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA7/ZF;;EAggaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9/ZF;;EAigaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA//ZF;;EAkgaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAhgaF;;EAmgaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAjgaF;;EAogaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAlgaF;;EAqgaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAngaF;;EAsgaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EApgaF;;EAugaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArgaF;;EAwgaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAtgaF;;EAygaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAvgaF;;EA0gaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAxgaF;;EA2gaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAzgaF;;EA4gaA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EA1gaF;;EA6gaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA3gaF;;EA8gaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA5gaF;;EA+gaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7gaF;;EAghaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA9gaF;;EAihaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA/gaF;;EAkhaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAhhaF;;EAmhaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAjhaF;;EAohaA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAlhaF;;EAqhaA;IACE,wBAAA;IACA,cAAA;IACA,mDAAA;EAnhaF;;EAshaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAphaF;;EAuhaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EArhaF;;EAwhaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAthaF;;EAyhaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAvhaF;;EA0haA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAxhaF;;EA2haA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAzhaF;;EA4haA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA1haF;;EA6haA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA3haF;;EA8haA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA5haF;;EA+haA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA7haF;;EAgiaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA9haF;;EAiiaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/haF;;EAkiaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhiaF;;EAmiaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjiaF;;EAoiaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAliaF;;EAqiaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAniaF;;EAsiaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EApiaF;;EAuiaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAriaF;;EAwiaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAtiaF;;EAyiaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAviaF;;EA0iaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAxiaF;;EA2iaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAziaF;;EA4iaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA1iaF;;EA6iaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA3iaF;;EA8iaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EA5iaF;;EA+iaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA7iaF;;EAgjaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EA9iaF;;EAijaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EA/iaF;;EAkjaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAhjaF;;EAmjaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAjjaF;;EAojaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAljaF;;EAqjaA;IACE,wBAAA;IACA,cAAA;IACA,sDAAA;EAnjaF;;EAsjaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EApjaF;;EAujaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EArjaF;;EAwjaA;IACE,wBAAA;IACA,cAAA;IACA,qDAAA;EAtjaF;;EAyjaA;IACE,wBAAA;IACA,cAAA;IACA,oDAAA;EAvjaF;;EA0jaA;IACE,wBAAA;EAxjaF;;EA2jaA;IACE,2BAAA;EAzjaF;;EA4jaA;IACE,0BAAA;EA1jaF;;EA6jaA;IACE,2BAAA;EA3jaF;;EA8jaA;IACE,wBAAA;EA5jaF;;EA+jaA;IACE,wBAAA;EA7jaF;;EAgkaA;IACE,2BAAA;EA9jaF;;EAikaA;IACE,0BAAA;EA/jaF;;EAkkaA;IACE,2BAAA;EAhkaF;;EAmkaA;IACE,wBAAA;EAjkaF;;EAokaA;IACE,oBAAA;EAlkaF;;EAqkaA;IACE,oBAAA;EAnkaF;;EAskaA;IACE,gBAAA;EApkaF;;EAukaA;IACE,eAAA;EArkaF;;EAwkaA;IACE,kBAAA;EAtkaF;;EAykaA;IACE,kBAAA;EAvkaF;;EA0kaA;IACE,gBAAA;EAxkaF;;EA2kaA;IACE,MAAA;IACA,QAAA;IACA,SAAA;IACA,OAAA;EAzkaF;;EA4kaA;IACE,SAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EA1kaF;;EA6kaA;IACE,MAAA;IACA,SAAA;EA3kaF;;EA8kaA;IACE,QAAA;IACA,OAAA;EA5kaF;;EA+kaA;IACE,SAAA;IACA,YAAA;EA7kaF;;EAglaA;IACE,WAAA;IACA,UAAA;EA9kaF;;EAilaA;IACE,MAAA;EA/kaF;;EAklaA;IACE,QAAA;EAhlaF;;EAmlaA;IACE,SAAA;EAjlaF;;EAolaA;IACE,OAAA;EAllaF;;EAqlaA;IACE,SAAA;EAnlaF;;EAslaA;IACE,WAAA;EAplaF;;EAulaA;IACE,YAAA;EArlaF;;EAwlaA;IACE,UAAA;EAtlaF;;EAylaA;IACE,YAAA;EAvlaF;;EA0laA;IACE,gBAAA;EAxlaF;;EA2laA;IACE,kBAAA;EAzlaF;;EA4laA;IACE,YAAA;EA1laF;;EA6laA;IACE,yCAAA;EA3laF;;EA8laA;IACE,2CAAA;EA5laF;;EA+laA;IACE,2EAAA;EA7laF;;EAgmaA;IACE,iFAAA;EA9laF;;EAimaA;IACE,mFAAA;EA/laF;;EAkmaA;IACE,qFAAA;EAhmaF;;EAmmaA;IACE,iDAAA;EAjmaF;;EAomaA;IACE,iDAAA;EAlmaF;;EAqmaA;IACE,6CAAA;EAnmaF;;EAsmaA;IACE,gBAAA;EApmaF;;EAumaA;IACE,yCAAA;EArmaF;;EAwmaA;IACE,2CAAA;EAtmaF;;EAymaA;IACE,2EAAA;EAvmaF;;EA0maA;IACE,iFAAA;EAxmaF;;EA2maA;IACE,mFAAA;EAzmaF;;EA4maA;IACE,qFAAA;EA1maF;;EA6maA;IACE,iDAAA;EA3maF;;EA8maA;IACE,iDAAA;EA5maF;;EA+maA;IACE,6CAAA;EA7maF;;EAgnaA;IACE,gBAAA;EA9maF;;EAinaA;IACE,yCAAA;EA/maF;;EAknaA;IACE,2CAAA;EAhnaF;;EAmnaA;IACE,2EAAA;EAjnaF;;EAonaA;IACE,iFAAA;EAlnaF;;EAqnaA;IACE,mFAAA;EAnnaF;;EAsnaA;IACE,qFAAA;EApnaF;;EAunaA;IACE,iDAAA;EArnaF;;EAwnaA;IACE,iDAAA;EAtnaF;;EAynaA;IACE,6CAAA;EAvnaF;;EA0naA;IACE,gBAAA;EAxnaF;;EA2naA;IACE,kBAAA;EAznaF;;EA4naA;IACE,oBAAA;EA1naF;;EA6naA;IACE,eAAA;EA3naF;;EA8naA;IACE,eAAA;EA5naF;;EA+naA;IACE,eAAA;EA7naF;;EAgoaA;IACE,kBAAA;EA9naF;;EAioaA;IACE,mBAAA;EA/naF;;EAkoaA;IACE,gBAAA;EAhoaF;;EAmoaA;IACE,kBAAA;EAjoaF;;EAooaA;IACE,iBAAA;EAloaF;;EAqoaA;IACE,mBAAA;EAnoaF;;EAsoaA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EApoaF;;EAuoaA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EAroaF;;EAwoaA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EAtoaF;;EAyoaA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EAvoaF;;EA0oaA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EAxoaF;;EA2oaA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EAzoaF;;EA4oaA;IACE,iBAAA;IACA,cAAA;IACA,8CAAA;EA1oaF;;EA6oaA;IACE,iBAAA;IACA,cAAA;IACA,4CAAA;EA3oaF;;EA8oaA;IACE,iBAAA;IACA,cAAA;IACA,6CAAA;EA5oaF;;EA+oaA;IACE,iBAAA;EA7oaF;;EAgpaA;IACE,oBAAA;EA9oaF;;EAipaA;IACE,mBAAA;EA/oaF;;EAkpaA;IACE,oBAAA;EAhpaF;;EAmpaA;IACE,iBAAA;EAjpaF;;EAopaA;IACE,iBAAA;EAlpaF;;EAqpaA;IACE,oBAAA;EAnpaF;;EAspaA;IACE,mBAAA;EAppaF;;EAupaA;IACE,oBAAA;EArpaF;;EAwpaA;IACE,iBAAA;EAtpaF;;EAypaA;IACE,iBAAA;EAvpaF;;EA0paA;IACE,oBAAA;EAxpaF;;EA2paA;IACE,mBAAA;EAzpaF;;EA4paA;IACE,oBAAA;EA1paF;;EA6paA;IACE,iBAAA;EA3paF;;EA8paA;IACE,kBAAA;EA5paF;;EA+paA;IACE,kBAAA;EA7paF;;EAgqaA;IACE,yBAAA;EA9paF;;EAiqaA;IACE,yBAAA;EA/paF;;EAkqaA;IACE,0BAAA;EAhqaF;;EAmqaA;IACE,oBAAA;EAjqaF;;EAoqaA;IACE,0BAAA;EAlqaF;;EAqqaA;IACE,6BAAA;EAnqaF;;EAsqaA;IACE,qBAAA;EApqaF;;EAuqaA;IACE,0BAAA;EArqaF;;EAwqaA;IACE,6BAAA;EAtqaF;;EAyqaA;IACE,qBAAA;EAvqaF;;EA0qaA;IACE,0BAAA;EAxqaF;;EA2qaA;IACE,6BAAA;EAzqaF;;EA4qaA;IACE,qBAAA;EA1qaF;;EA6qaA;IACE,mCAAA;IACA,kCAAA;EA3qaF;;EA8qaA;IACE,4BAAA;IACA,6BAAA;EA5qaF;;EA+qaA;IACE,iEAAA;IACA,sEAAA;IACA,gEAAA;IACA,iEAAA;IACA,kEAAA;IACA,8MAAA;EA7qaF;;EAgraA;IACE,4BAAA;EA9qaF;;EAiraA;IACE,uCAAA;EA/qaF;;EAkraA;IACE,iDAAA;EAhraF;;EAmraA;IACE,0CAAA;EAjraF;;EAoraA;IACE,4CAAA;EAlraF;;EAqraA;IACE,iDAAA;EAnraF;;EAsraA;IACE,4CAAA;EApraF;;EAuraA;IACE,mDAAA;EArraF;;EAwraA;IACE,kDAAA;EAtraF;;EAyraA;IACE,uBAAA;EAvraF;;EA0raA;IACE,wBAAA;EAxraF;;EA2raA;IACE,iBAAA;EAzraF;;EA4raA;IACE,uBAAA;EA1raF;;EA6raA;IACE,sBAAA;EA3raF;;EA8raA;IACE,qBAAA;EA5raF;;EA+raA;IACE,yBAAA;IACQ,iBAAA;EA7raV;;EAgsaA;IACE,yBAAA;IACQ,iBAAA;EA9raV;;EAisaA;IACE,wBAAA;IACQ,gBAAA;EA/raV;;EAksaA;IACE,yBAAA;IACQ,iBAAA;EAhsaV;;EAmsaA;IACE,wBAAA;EAjsaF;;EAosaA;IACE,mBAAA;EAlsaF;;EAqsaA;IACE,sBAAA;EAnsaF;;EAssaA;IACE,sBAAA;EApsaF;;EAusaA;IACE,wBAAA;EArsaF;;EAwsaA;IACE,2BAAA;EAtsaF;;EAysaA;IACE,mBAAA;EAvsaF;;EA0saA;IACE,kBAAA;EAxsaF;;EA2saA;IACE,mBAAA;EAzsaF;;EA4saA;IACE,mBAAA;EA1saF;;EA6saA;IACE,gBAAA;EA3saF;;EA8saA;IACE,qBAAA;EA5saF;;EA+saA;IACE,qBAAA;EA7saF;;EAgtaA;IACE,iBAAA;IACA,qBAAA;IACA,kBAAA;EA9saF;;EAitaA;IACE,qBAAA;IACA,yBAAA;EA/saF;;EAktaA;IACE,qBAAA;EAhtaF;;EAmtaA;IACE,gBAAA;IACA,uBAAA;IACA,mBAAA;EAjtaF;;EAotaA;IACE,QAAA;EAltaF;;EAqtaA;IACE,cAAA;EAntaF;;EAstaA;IACE,aAAA;EAptaF;;EAutaA;IACE,cAAA;EArtaF;;EAwtaA;IACE,WAAA;EAttaF;;EAytaA;IACE,cAAA;EAvtaF;;EA0taA;IACE,aAAA;EAxtaF;;EA2taA;IACE,WAAA;EAztaF;;EA4taA;IACE,aAAA;EA1taF;;EA6taA;IACE,WAAA;EA3taF;;EA8taA;IACE,WAAA;EA5taF;;EA+taA;IACE,WAAA;EA7taF;;EAguaA;IACE,WAAA;EA9taF;;EAiuaA;IACE,WAAA;EA/taF;;EAkuaA;IACE,YAAA;EAhuaF;;EAmuaA;IACE,YAAA;EAjuaF;;EAouaA;IACE,YAAA;EAluaF;;EAquaA;IACE,YAAA;EAnuaF;;EAsuaA;IACE,WAAA;EApuaF;;EAuuaA;IACE,UAAA;EAruaF;;EAwuaA;IACE,UAAA;EAtuaF;;EAyuaA;IACE,iBAAA;EAvuaF;;EA0uaA;IACE,iBAAA;EAxuaF;;EA2uaA;IACE,UAAA;EAzuaF;;EA4uaA;IACE,UAAA;EA1uaF;;EA6uaA;IACE,UAAA;EA3uaF;;EA8uaA;IACE,UAAA;EA5uaF;;EA+uaA;IACE,UAAA;EA7uaF;;EAgvaA;IACE,UAAA;EA9uaF;;EAivaA;IACE,UAAA;EA/uaF;;EAkvaA;IACE,iBAAA;EAhvaF;;EAmvaA;IACE,iBAAA;EAjvaF;;EAovaA;IACE,UAAA;EAlvaF;;EAqvaA;IACE,iBAAA;EAnvaF;;EAsvaA;IACE,iBAAA;EApvaF;;EAuvaA;IACE,gBAAA;EArvaF;;EAwvaA;IACE,iBAAA;EAtvaF;;EAyvaA;IACE,UAAA;EAvvaF;;EA0vaA;IACE,iBAAA;EAxvaF;;EA2vaA;IACE,iBAAA;EAzvaF;;EA4vaA;IACE,UAAA;EA1vaF;;EA6vaA;IACE,iBAAA;EA3vaF;;EA8vaA;IACE,iBAAA;EA5vaF;;EA+vaA;IACE,UAAA;EA7vaF;;EAgwaA;IACE,iBAAA;EA9vaF;;EAiwaA;IACE,iBAAA;EA/vaF;;EAkwaA;IACE,WAAA;EAhwaF;;EAmwaA;IACE,YAAA;EAjwaF;;EAowaA;IACE,UAAA;EAlwaF;;EAqwaA;IACE,WAAA;EAnwaF;;EAswaA;IACE,WAAA;EApwaF;;EAuwaA;IACE,WAAA;EArwaF;;EAwwaA;IACE,WAAA;EAtwaF;;EAywaA;IACE,WAAA;EAvwaF;;EA0waA;IACE,aAAA;EAxwaF;;EA2waA;IACE,WAAA;IACA,MAAA;EAzwaF;;EA4waA;IACE,iBAAA;IACA,YAAA;EA1waF;;EA6waA;IACE,gBAAA;IACA,WAAA;EA3waF;;EA8waA;IACE,iBAAA;IACA,YAAA;EA5waF;;EA+waA;IACE,cAAA;IACA,SAAA;EA7waF;;EAgxaA;IACE,iBAAA;IACA,YAAA;EA9waF;;EAixaA;IACE,gBAAA;IACA,WAAA;EA/waF;;EAkxaA;IACE,cAAA;IACA,SAAA;EAhxaF;;EAmxaA;IACE,gBAAA;IACA,WAAA;EAjxaF;;EAoxaA;IACE,cAAA;IACA,SAAA;EAlxaF;;EAqxaA;IACE,cAAA;IACA,SAAA;EAnxaF;;EAsxaA;IACE,cAAA;IACA,SAAA;EApxaF;;EAuxaA;IACE,cAAA;IACA,SAAA;EArxaF;;EAwxaA;IACE,cAAA;IACA,SAAA;EAtxaF;;EAyxaA;IACE,eAAA;IACA,UAAA;EAvxaF;;EA0xaA;IACE,eAAA;IACA,UAAA;EAxxaF;;EA2xaA;IACE,eAAA;IACA,UAAA;EAzxaF;;EA4xaA;IACE,eAAA;IACA,UAAA;EA1xaF;;EA6xaA;IACE,aAAA;IACA,QAAA;EA3xaF;;EA8xaA;IACE,kBAAA;IACA,aAAA;EA5xaF;;EA+xaA;IACE,wBAAA;IACA,mBAAA;EA7xaF;;EAgyaA;IACE,uBAAA;IACA,kBAAA;EA9xaF;;EAiyaA;IACE,wBAAA;IACA,mBAAA;EA/xaF;;EAkyaA;IACE,qBAAA;IACA,gBAAA;EAhyaF;;EAmyaA;IACE,wBAAA;IACA,mBAAA;EAjyaF;;EAoyaA;IACE,uBAAA;IACA,kBAAA;EAlyaF;;EAqyaA;IACE,qBAAA;IACA,gBAAA;EAnyaF;;EAsyaA;IACE,uBAAA;IACA,kBAAA;EApyaF;;EAuyaA;IACE,qBAAA;IACA,gBAAA;EAryaF;;EAwyaA;IACE,qBAAA;IACA,gBAAA;EAtyaF;;EAyyaA;IACE,qBAAA;IACA,gBAAA;EAvyaF;;EA0yaA;IACE,qBAAA;IACA,gBAAA;EAxyaF;;EA2yaA;IACE,qBAAA;IACA,gBAAA;EAzyaF;;EA4yaA;IACE,sBAAA;IACA,iBAAA;EA1yaF;;EA6yaA;IACE,sBAAA;IACA,iBAAA;EA3yaF;;EA8yaA;IACE,sBAAA;IACA,iBAAA;EA5yaF;;EA+yaA;IACE,sBAAA;IACA,iBAAA;EA7yaF;;EAgzaA;IACE,oBAAA;IACA,eAAA;EA9yaF;;EAizaA;IACE,kBAAA;IACA,aAAA;EA/yaF;;EAkzaA;IACE,wBAAA;IACA,mBAAA;EAhzaF;;EAmzaA;IACE,uBAAA;IACA,kBAAA;EAjzaF;;EAozaA;IACE,wBAAA;IACA,mBAAA;EAlzaF;;EAqzaA;IACE,qBAAA;IACA,gBAAA;EAnzaF;;EAszaA;IACE,wBAAA;IACA,mBAAA;EApzaF;;EAuzaA;IACE,uBAAA;IACA,kBAAA;EArzaF;;EAwzaA;IACE,qBAAA;IACA,gBAAA;EAtzaF;;EAyzaA;IACE,uBAAA;IACA,kBAAA;EAvzaF;;EA0zaA;IACE,qBAAA;IACA,gBAAA;EAxzaF;;EA2zaA;IACE,qBAAA;IACA,gBAAA;EAzzaF;;EA4zaA;IACE,qBAAA;IACA,gBAAA;EA1zaF;;EA6zaA;IACE,qBAAA;IACA,gBAAA;EA3zaF;;EA8zaA;IACE,qBAAA;IACA,gBAAA;EA5zaF;;EA+zaA;IACE,sBAAA;IACA,iBAAA;EA7zaF;;EAg0aA;IACE,sBAAA;IACA,iBAAA;EA9zaF;;EAi0aA;IACE,sBAAA;IACA,iBAAA;EA/zaF;;EAk0aA;IACE,sBAAA;IACA,iBAAA;EAh0aF;;EAm0aA;IACE,oBAAA;IACA,eAAA;EAj0aF;;EAo0aA;IACE,eAAA;IACA,UAAA;EAl0aF;;EAq0aA;IACE,qBAAA;IACA,gBAAA;EAn0aF;;EAs0aA;IACE,oBAAA;IACA,eAAA;EAp0aF;;EAu0aA;IACE,qBAAA;IACA,gBAAA;EAr0aF;;EAw0aA;IACE,kBAAA;IACA,aAAA;EAt0aF;;EAy0aA;IACE,qBAAA;IACA,gBAAA;EAv0aF;;EA00aA;IACE,oBAAA;IACA,eAAA;EAx0aF;;EA20aA;IACE,kBAAA;IACA,aAAA;EAz0aF;;EA40aA;IACE,oBAAA;IACA,eAAA;EA10aF;;EA60aA;IACE,kBAAA;IACA,aAAA;EA30aF;;EA80aA;IACE,kBAAA;IACA,aAAA;EA50aF;;EA+0aA;IACE,kBAAA;IACA,aAAA;EA70aF;;EAg1aA;IACE,kBAAA;IACA,aAAA;EA90aF;;EAi1aA;IACE,kBAAA;IACA,aAAA;EA/0aF;;EAk1aA;IACE,mBAAA;IACA,cAAA;EAh1aF;;EAm1aA;IACE,mBAAA;IACA,cAAA;EAj1aF;;EAo1aA;IACE,mBAAA;IACA,cAAA;EAl1aF;;EAq1aA;IACE,mBAAA;IACA,cAAA;EAn1aF;;EAs1aA;IACE,iBAAA;IACA,YAAA;EAp1aF;;EAu1aA;IACE,eAAA;IACA,UAAA;EAr1aF;;EAw1aA;IACE,qBAAA;IACA,gBAAA;EAt1aF;;EAy1aA;IACE,oBAAA;IACA,eAAA;EAv1aF;;EA01aA;IACE,qBAAA;IACA,gBAAA;EAx1aF;;EA21aA;IACE,kBAAA;IACA,aAAA;EAz1aF;;EA41aA;IACE,qBAAA;IACA,gBAAA;EA11aF;;EA61aA;IACE,oBAAA;IACA,eAAA;EA31aF;;EA81aA;IACE,kBAAA;IACA,aAAA;EA51aF;;EA+1aA;IACE,oBAAA;IACA,eAAA;EA71aF;;EAg2aA;IACE,kBAAA;IACA,aAAA;EA91aF;;EAi2aA;IACE,kBAAA;IACA,aAAA;EA/1aF;;EAk2aA;IACE,kBAAA;IACA,aAAA;EAh2aF;;EAm2aA;IACE,kBAAA;IACA,aAAA;EAj2aF;;EAo2aA;IACE,kBAAA;IACA,aAAA;EAl2aF;;EAq2aA;IACE,mBAAA;IACA,cAAA;EAn2aF;;EAs2aA;IACE,mBAAA;IACA,cAAA;EAp2aF;;EAu2aA;IACE,mBAAA;IACA,cAAA;EAr2aF;;EAw2aA;IACE,mBAAA;IACA,cAAA;EAt2aF;;EAy2aA;IACE,iBAAA;IACA,YAAA;EAv2aF;;EA02aA;IACE,mBAAA;EAx2aF;;EA22aA;IACE,sBAAA;EAz2aF;;EA42aA;IACE,yBAAA;EA12aF;;EA62aA;IACE,4BAAA;EA32aF;;EA82aA;IACE,gDAAA;EA52aF;;EA+2aA;IACE,gDAAA;EA72aF;;EAg3aA;IACE,gDAAA;EA92aF;;EAi3aA;IACE,gDAAA;EA/2aF;;EAk3aA;IACE,gDAAA;EAh3aF;;EAm3aA;IACE,gDAAA;EAj3aF;;EAo3aA;IACE,gDAAA;EAl3aF;;EAq3aA;IACE,gDAAA;EAn3aF;;EAs3aA;IACE,gDAAA;EAp3aF;;EAu3aA;IACE,iDAAA;EAr3aF;;EAw3aA;IACE,iDAAA;EAt3aF;;EAy3aA;IACE,iDAAA;EAv3aF;;EA03aA;IACE,2BAAA;EAx3aF;;EA23aA;IACE,uBAAA;EAz3aF;;EA43aA;IACE,8BAAA;EA13aF;;EA63aA;IACE,8BAAA;EA33aF;;EA83aA;IACE,iCAAA;EA53aF;;EA+3aA;IACE,iBAAA;EA73aF;;EAg4aA;IACE,0BAAA;EA93aF;;EAi4aA;IACE,0BAAA;EA/3aF;;EAk4aA;IACE,0BAAA;EAh4aF;;EAm4aA;IACE,0BAAA;EAj4aF;;EAo4aA;IACE,0BAAA;EAl4aF;;EAq4aA;IACE,0BAAA;EAn4aF;;EAs4aA;IACE,0BAAA;EAp4aF;;EAu4aA;IACE,0BAAA;EAr4aF;;EAw4aA;IACE,0BAAA;EAt4aF;;EAy4aA;IACE,4BAAA;EAv4aF;;EA04aA;IACE,4BAAA;EAx4aF;;EA24aA;IACE,4BAAA;EAz4aF;;EA44aA;IACE,iBAAA;EA14aF;;EA64aA;IACE,oBAAA;EA34aF;;EA84aA;IACE,oBAAA;EA54aF;;EA+4aA;IACE,oBAAA;EA74aF;;EAg5aA;IACE,oBAAA;EA94aF;;EAi5aA;IACE,oBAAA;EA/4aF;;EAk5aA;IACE,oBAAA;EAh5aF;;EAm5aA;IACE,oBAAA;EAj5aF;;EAo5aA;IACE,oBAAA;EAl5aF;;EAq5aA;IACE,oBAAA;EAn5aF;;EAs5aA;IACE,qBAAA;EAp5aF;;EAu5aA;IACE,qBAAA;EAr5aF;;EAw5aA;IACE,qBAAA;EAt5aF;;EAy5aA;IACE,qBAAA;EAv5aF;;EA05aA;IACE,uBAAA;EAx5aF;;EA25aA;IACE,kBAAA;EAz5aF;;EA45aA;IACE,kBAAA;EA15aF;;EA65aA;IACE,kBAAA;EA35aF;;EA85aA;IACE,kBAAA;EA55aF;;EA+5aA;IACE,kBAAA;EA75aF;;EAg6aA;IACE,kBAAA;EA95aF;;EAi6aA;IACE,kBAAA;EA/5aF;;EAk6aA;IACE,kBAAA;EAh6aF;;EAm6aA;IACE,kBAAA;EAj6aF;;EAo6aA;IACE,mBAAA;EAl6aF;;EAq6aA;IACE,mBAAA;EAn6aF;;EAs6aA;IACE,mBAAA;EAp6aF;;EAu6aA;IACE,mBAAA;EAr6aF;;EAw6aA;IACE,qBAAA;EAt6aF;;EAy6aA;IACE,6CAAA;EAv6aF;;EA06aA;IACE,6CAAA;EAx6aF;;EA26aA;IACE,6CAAA;EAz6aF;;EA46aA;IACE,6CAAA;EA16aF;;EA66aA;IACE,6CAAA;EA36aF;;EA86aA;IACE,6CAAA;EA56aF;;EA+6aA;IACE,wBAAA;EA76aF;;EAg7aA;IACE,oBAAA;EA96aF;;EAi7aA;IACE,2BAAA;EA/6aF;;EAk7aA;IACE,2BAAA;EAh7aF;;EAm7aA;IACE,8BAAA;EAj7aF;;EAo7aA;IACE,cAAA;EAl7aF;;EAq7aA;IACE,uBAAA;EAn7aF;;EAs7aA;IACE,uBAAA;EAp7aF;;EAu7aA;IACE,uBAAA;EAr7aF;;EAw7aA;IACE,uBAAA;EAt7aF;;EAy7aA;IACE,uBAAA;EAv7aF;;EA07aA;IACE,uBAAA;EAx7aF;;EA27aA;IACE,cAAA;EAz7aF;;EA47aA;IACE,iBAAA;EA17aF;;EA67aA;IACE,iBAAA;EA37aF;;EA87aA;IACE,iBAAA;EA57aF;;EA+7aA;IACE,iBAAA;EA77aF;;EAg8aA;IACE,iBAAA;EA97aF;;EAi8aA;IACE,iBAAA;EA/7aF;;EAk8aA;IACE,iBAAA;EAh8aF;;EAm8aA;IACE,oBAAA;EAj8aF;;EAo8aA;IACE,eAAA;EAl8aF;;EAq8aA;IACE,eAAA;EAn8aF;;EAs8aA;IACE,eAAA;EAp8aF;;EAu8aA;IACE,eAAA;EAr8aF;;EAw8aA;IACE,eAAA;EAt8aF;;EAy8aA;IACE,eAAA;EAv8aF;;EA08aA;IACE,eAAA;EAx8aF;;EA28aA;IACE,kBAAA;EAz8aF;;EA48aA;IACE,0BAAA;IACA,0BAAA;IACA,qBAAA;IACA,qBAAA;IACA,qBAAA;IACA,sBAAA;IACA,sBAAA;IACA,4PAAA;EA18aF;;EA68aA;IACE,eAAA;EA38aF;;EA88aA;IACE,wBAAA;EA58aF;;EA+8aA;IACE,qBAAA;EA78aF;;EAg9aA;IACE,2BAAA;EA98aF;;EAi9aA;IACE,uBAAA;EA/8aF;;EAk9aA;IACE,8BAAA;EAh9aF;;EAm9aA;IACE,wBAAA;EAj9aF;;EAo9aA;IACE,6BAAA;EAl9aF;;EAq9aA;IACE,sBAAA;EAn9aF;;EAs9aA;IACE,0BAAA;EAp9aF;;EAu9aA;IACE,sBAAA;IACA,sBAAA;EAr9aF;;EAw9aA;IACE,uBAAA;IACA,uBAAA;EAt9aF;;EAy9aA;IACE,wBAAA;IACA,wBAAA;EAv9aF;;EA09aA;IACE,uBAAA;IACA,uBAAA;EAx9aF;;EA29aA;IACE,wBAAA;IACA,wBAAA;EAz9aF;;EA49aA;IACE,sBAAA;IACA,sBAAA;EA19aF;;EA69aA;IACE,yBAAA;IACA,yBAAA;EA39aF;;EA89aA;IACE,wBAAA;IACA,wBAAA;EA59aF;;EA+9aA;IACE,yBAAA;IACA,yBAAA;EA79aF;;EAg+aA;IACE,wBAAA;IACA,wBAAA;EA99aF;;EAi+aA;IACE,sBAAA;EA/9aF;;EAk+aA;IACE,uBAAA;EAh+aF;;EAm+aA;IACE,wBAAA;EAj+aF;;EAo+aA;IACE,uBAAA;EAl+aF;;EAq+aA;IACE,wBAAA;EAn+aF;;EAs+aA;IACE,sBAAA;EAp+aF;;EAu+aA;IACE,yBAAA;EAr+aF;;EAw+aA;IACE,wBAAA;EAt+aF;;EAy+aA;IACE,yBAAA;EAv+aF;;EA0+aA;IACE,wBAAA;EAx+aF;;EA2+aA;IACE,sBAAA;EAz+aF;;EA4+aA;IACE,uBAAA;EA1+aF;;EA6+aA;IACE,wBAAA;EA3+aF;;EA8+aA;IACE,uBAAA;EA5+aF;;EA++aA;IACE,wBAAA;EA7+aF;;EAg/aA;IACE,sBAAA;EA9+aF;;EAi/aA;IACE,yBAAA;EA/+aF;;EAk/aA;IACE,wBAAA;EAh/aF;;EAm/aA;IACE,yBAAA;EAj/aF;;EAo/aA;IACE,wBAAA;EAl/aF;;EAq/aA;IACE,sBAAA;IACA,sBAAA;EAn/aF;;EAs/aA;IACE,uBAAA;IACA,uBAAA;EAp/aF;;EAu/aA;IACE,wBAAA;IACA,wBAAA;EAr/aF;;EAw/aA;IACE,uBAAA;IACA,uBAAA;EAt/aF;;EAy/aA;IACE,wBAAA;IACA,wBAAA;EAv/aF;;EA0/aA;IACE,sBAAA;IACA,sBAAA;EAx/aF;;EA2/aA;IACE,yBAAA;IACA,yBAAA;EAz/aF;;EA4/aA;IACE,wBAAA;IACA,wBAAA;EA1/aF;;EA6/aA;IACE,yBAAA;IACA,yBAAA;EA3/aF;;EA8/aA;IACE,wBAAA;IACA,wBAAA;EA5/aF;;EA+/aA;IACE,sBAAA;EA7/aF;;EAggbA;IACE,uBAAA;EA9/aF;;EAigbA;IACE,wBAAA;EA//aF;;EAkgbA;IACE,uBAAA;EAhgbF;;EAmgbA;IACE,wBAAA;EAjgbF;;EAogbA;IACE,sBAAA;EAlgbF;;EAqgbA;IACE,yBAAA;EAngbF;;EAsgbA;IACE,wBAAA;EApgbF;;EAugbA;IACE,yBAAA;EArgbF;;EAwgbA;IACE,wBAAA;EAtgbF;;EAygbA;IACE,sBAAA;EAvgbF;;EA0gbA;IACE,uBAAA;EAxgbF;;EA2gbA;IACE,wBAAA;EAzgbF;;EA4gbA;IACE,uBAAA;EA1gbF;;EA6gbA;IACE,wBAAA;EA3gbF;;EA8gbA;IACE,sBAAA;EA5gbF;;EA+gbA;IACE,yBAAA;EA7gbF;;EAghbA;IACE,wBAAA;EA9gbF;;EAihbA;IACE,yBAAA;EA/gbF;;EAkhbA;IACE,wBAAA;EAhhbF;;EAmhbA;IACE,sBAAA;IACA,sBAAA;EAjhbF;;EAohbA;IACE,uBAAA;IACA,uBAAA;EAlhbF;;EAqhbA;IACE,wBAAA;IACA,wBAAA;EAnhbF;;EAshbA;IACE,uBAAA;IACA,uBAAA;EAphbF;;EAuhbA;IACE,wBAAA;IACA,wBAAA;EArhbF;;EAwhbA;IACE,sBAAA;IACA,sBAAA;EAthbF;;EAyhbA;IACE,yBAAA;IACA,yBAAA;EAvhbF;;EA0hbA;IACE,wBAAA;IACA,wBAAA;EAxhbF;;EA2hbA;IACE,yBAAA;IACA,yBAAA;EAzhbF;;EA4hbA;IACE,wBAAA;IACA,wBAAA;EA1hbF;;EA6hbA;IACE,sBAAA;EA3hbF;;EA8hbA;IACE,uBAAA;EA5hbF;;EA+hbA;IACE,wBAAA;EA7hbF;;EAgibA;IACE,uBAAA;EA9hbF;;EAiibA;IACE,wBAAA;EA/hbF;;EAkibA;IACE,sBAAA;EAhibF;;EAmibA;IACE,yBAAA;EAjibF;;EAoibA;IACE,wBAAA;EAlibF;;EAqibA;IACE,yBAAA;EAnibF;;EAsibA;IACE,wBAAA;EApibF;;EAuibA;IACE,sBAAA;EAribF;;EAwibA;IACE,uBAAA;EAtibF;;EAyibA;IACE,wBAAA;EAvibF;;EA0ibA;IACE,uBAAA;EAxibF;;EA2ibA;IACE,wBAAA;EAzibF;;EA4ibA;IACE,sBAAA;EA1ibF;;EA6ibA;IACE,yBAAA;EA3ibF;;EA8ibA;IACE,wBAAA;EA5ibF;;EA+ibA;IACE,yBAAA;EA7ibF;;EAgjbA;IACE,wBAAA;EA9ibF;;EAijbA;IACE,qBAAA;EA/ibF;;EAkjbA;IACE,wBAAA;EAhjbF;;EAmjbA;IACE,wBAAA;EAjjbF;;EAojbA;IACE,wBAAA;EAljbF;;EAqjbA;IACE,wBAAA;EAnjbF;;EAsjbA;IACE,yBAAA;EApjbF;;EAujbA;IACE,yBAAA;EArjbF;;EAwjbA;IACE,yBAAA;EAtjbF;;EAyjbA;IACE,0BAAA;EAvjbF;;EA0jbA;IACE,2BAAA;EAxjbF;;EA2jbA;IACE,0BAAA;EAzjbF;;EA4jbA;IACE,0BAAA;EA1jbF;;EA6jbA;IACE,0BAAA;EA3jbF;;EA8jbA;IACE,yBAAA;EA5jbF;;EA+jbA;IACE,yBAAA;EA7jbF;;EAgkbA;IACE,yBAAA;EA9jbF;;EAikbA;IACE,yBAAA;EA/jbF;;EAkkbA;IACE,qBAAA;EAhkbF;;EAmkbA;IACE,wBAAA;EAjkbF;;EAokbA;IACE,wBAAA;EAlkbF;;EAqkbA;IACE,wBAAA;EAnkbF;;EAskbA;IACE,wBAAA;EApkbF;;EAukbA;IACE,yBAAA;EArkbF;;EAwkbA;IACE,yBAAA;EAtkbF;;EAykbA;IACE,yBAAA;EAvkbF;;EA0kbA;IACE,0BAAA;EAxkbF;;EA2kbA;IACE,2BAAA;EAzkbF;;EA4kbA;IACE,0BAAA;EA1kbF;;EA6kbA;IACE,0BAAA;EA3kbF;;EA8kbA;IACE,0BAAA;EA5kbF;;EA+kbA;IACE,yBAAA;EA7kbF;;EAglbA;IACE,yBAAA;EA9kbF;;EAilbA;IACE,yBAAA;EA/kbF;;EAklbA;IACE,yBAAA;EAhlbF;;EAmlbA;IACE,qBAAA;EAjlbF;;EAolbA;IACE,wBAAA;EAllbF;;EAqlbA;IACE,wBAAA;EAnlbF;;EAslbA;IACE,wBAAA;EAplbF;;EAulbA;IACE,wBAAA;EArlbF;;EAwlbA;IACE,yBAAA;EAtlbF;;EAylbA;IACE,yBAAA;EAvlbF;;EA0lbA;IACE,yBAAA;EAxlbF;;EA2lbA;IACE,0BAAA;EAzlbF;;EA4lbA;IACE,2BAAA;EA1lbF;;EA6lbA;IACE,0BAAA;EA3lbF;;EA8lbA;IACE,0BAAA;EA5lbF;;EA+lbA;IACE,0BAAA;EA7lbF;;EAgmbA;IACE,yBAAA;EA9lbF;;EAimbA;IACE,yBAAA;EA/lbF;;EAkmbA;IACE,yBAAA;EAhmbF;;EAmmbA;IACE,yBAAA;EAjmbF;;EAombA;IACE,0BAAA;EAlmbF;;EAqmbA;IACE,gCAAA;EAnmbF;;EAsmbA;IACE,+BAAA;EApmbF;;EAumbA;IACE,gCAAA;EArmbF;;EAwmbA;IACE,6BAAA;EAtmbF;;EAymbA;IACE,gCAAA;EAvmbF;;EA0mbA;IACE,+BAAA;EAxmbF;;EA2mbA;IACE,6BAAA;EAzmbF;;EA4mbA;IACE,+BAAA;EA1mbF;;EA6mbA;IACE,6BAAA;EA3mbF;;EA8mbA;IACE,6BAAA;EA5mbF;;EA+mbA;IACE,6BAAA;EA7mbF;;EAgnbA;IACE,6BAAA;EA9mbF;;EAinbA;IACE,6BAAA;EA/mbF;;EAknbA;IACE,8BAAA;EAhnbF;;EAmnbA;IACE,8BAAA;EAjnbF;;EAonbA;IACE,8BAAA;EAlnbF;;EAqnbA;IACE,8BAAA;EAnnbF;;EAsnbA;IACE,4BAAA;EApnbF;;EAunbA;IACE,iCAAA;EArnbF;;EAwnbA;IACE,gCAAA;EAtnbF;;EAynbA;IACE,iCAAA;EAvnbF;;EA0nbA;IACE,8BAAA;EAxnbF;;EA2nbA;IACE,iCAAA;EAznbF;;EA4nbA;IACE,gCAAA;EA1nbF;;EA6nbA;IACE,8BAAA;EA3nbF;;EA8nbA;IACE,gCAAA;EA5nbF;;EA+nbA;IACE,8BAAA;EA7nbF;;EAgobA;IACE,8BAAA;EA9nbF;;EAiobA;IACE,8BAAA;EA/nbF;;EAkobA;IACE,8BAAA;EAhobF;;EAmobA;IACE,8BAAA;EAjobF;;EAoobA;IACE,+BAAA;EAlobF;;EAqobA;IACE,+BAAA;EAnobF;;EAsobA;IACE,+BAAA;EApobF;;EAuobA;IACE,+BAAA;EArobF;;EAwobA;IACE,6BAAA;EAtobF;;EAyobA;IACE,8BAAA;EAvobF;;EA0obA;IACE,6BAAA;EAxobF;;EA2obA;IACE,4BAAA;EAzobF;;EA4obA;IACE,6BAAA;EA1obF;;EA6obA;IACE,0BAAA;EA3obF;;EA8obA;IACE,gCAAA;EA5obF;;EA+obA;IACE,+BAAA;EA7obF;;EAgpbA;IACE,gCAAA;EA9obF;;EAipbA;IACE,6BAAA;EA/obF;;EAkpbA;IACE,gCAAA;EAhpbF;;EAmpbA;IACE,+BAAA;EAjpbF;;EAopbA;IACE,6BAAA;EAlpbF;;EAqpbA;IACE,+BAAA;EAnpbF;;EAspbA;IACE,6BAAA;EAppbF;;EAupbA;IACE,6BAAA;EArpbF;;EAwpbA;IACE,6BAAA;EAtpbF;;EAypbA;IACE,6BAAA;EAvpbF;;EA0pbA;IACE,6BAAA;EAxpbF;;EA2pbA;IACE,8BAAA;EAzpbF;;EA4pbA;IACE,8BAAA;EA1pbF;;EA6pbA;IACE,8BAAA;EA3pbF;;EA8pbA;IACE,8BAAA;EA5pbF;;EA+pbA;IACE,4BAAA;EA7pbF;;EAgqbA;IACE,iCAAA;EA9pbF;;EAiqbA;IACE,gCAAA;EA/pbF;;EAkqbA;IACE,iCAAA;EAhqbF;;EAmqbA;IACE,8BAAA;EAjqbF;;EAoqbA;IACE,iCAAA;EAlqbF;;EAqqbA;IACE,gCAAA;EAnqbF;;EAsqbA;IACE,8BAAA;EApqbF;;EAuqbA;IACE,gCAAA;EArqbF;;EAwqbA;IACE,8BAAA;EAtqbF;;EAyqbA;IACE,8BAAA;EAvqbF;;EA0qbA;IACE,8BAAA;EAxqbF;;EA2qbA;IACE,8BAAA;EAzqbF;;EA4qbA;IACE,8BAAA;EA1qbF;;EA6qbA;IACE,+BAAA;EA3qbF;;EA8qbA;IACE,+BAAA;EA5qbF;;EA+qbA;IACE,+BAAA;EA7qbF;;EAgrbA;IACE,+BAAA;EA9qbF;;EAirbA;IACE,6BAAA;EA/qbF;;EAkrbA;IACE,8BAAA;EAhrbF;;EAmrbA;IACE,6BAAA;EAjrbF;;EAorbA;IACE,4BAAA;EAlrbF;;EAqrbA;IACE,6BAAA;EAnrbF;;EAsrbA;IACE,0BAAA;EAprbF;;EAurbA;IACE,gCAAA;EArrbF;;EAwrbA;IACE,+BAAA;EAtrbF;;EAyrbA;IACE,gCAAA;EAvrbF;;EA0rbA;IACE,6BAAA;EAxrbF;;EA2rbA;IACE,gCAAA;EAzrbF;;EA4rbA;IACE,+BAAA;EA1rbF;;EA6rbA;IACE,6BAAA;EA3rbF;;EA8rbA;IACE,+BAAA;EA5rbF;;EA+rbA;IACE,6BAAA;EA7rbF;;EAgsbA;IACE,6BAAA;EA9rbF;;EAisbA;IACE,6BAAA;EA/rbF;;EAksbA;IACE,6BAAA;EAhsbF;;EAmsbA;IACE,6BAAA;EAjsbF;;EAosbA;IACE,8BAAA;EAlsbF;;EAqsbA;IACE,8BAAA;EAnsbF;;EAssbA;IACE,8BAAA;EApsbF;;EAusbA;IACE,8BAAA;EArsbF;;EAwsbA;IACE,4BAAA;EAtsbF;;EAysbA;IACE,iCAAA;EAvsbF;;EA0sbA;IACE,gCAAA;EAxsbF;;EA2sbA;IACE,iCAAA;EAzsbF;;EA4sbA;IACE,8BAAA;EA1sbF;;EA6sbA;IACE,iCAAA;EA3sbF;;EA8sbA;IACE,gCAAA;EA5sbF;;EA+sbA;IACE,8BAAA;EA7sbF;;EAgtbA;IACE,gCAAA;EA9sbF;;EAitbA;IACE,8BAAA;EA/sbF;;EAktbA;IACE,8BAAA;EAhtbF;;EAmtbA;IACE,8BAAA;EAjtbF;;EAotbA;IACE,8BAAA;EAltbF;;EAqtbA;IACE,8BAAA;EAntbF;;EAstbA;IACE,+BAAA;EAptbF;;EAutbA;IACE,+BAAA;EArtbF;;EAwtbA;IACE,+BAAA;EAttbF;;EAytbA;IACE,+BAAA;EAvtbF;;EA0tbA;IACE,6BAAA;EAxtbF;;EA2tbA;IACE,8BAAA;EAztbF;;EA4tbA;IACE,6BAAA;EA1tbF;;EA6tbA;IACE,4BAAA;EA3tbF;;EA8tbA;IACE,6BAAA;EA5tbF;;EA+tbA;IACE,0BAAA;EA7tbF;;EAgubA;IACE,gCAAA;EA9tbF;;EAiubA;IACE,+BAAA;EA/tbF;;EAkubA;IACE,gCAAA;EAhubF;;EAmubA;IACE,6BAAA;EAjubF;;EAoubA;IACE,gCAAA;EAlubF;;EAqubA;IACE,+BAAA;EAnubF;;EAsubA;IACE,6BAAA;EApubF;;EAuubA;IACE,+BAAA;EArubF;;EAwubA;IACE,6BAAA;EAtubF;;EAyubA;IACE,6BAAA;EAvubF;;EA0ubA;IACE,6BAAA;EAxubF;;EA2ubA;IACE,6BAAA;EAzubF;;EA4ubA;IACE,6BAAA;EA1ubF;;EA6ubA;IACE,8BAAA;EA3ubF;;EA8ubA;IACE,8BAAA;EA5ubF;;EA+ubA;IACE,8BAAA;EA7ubF;;EAgvbA;IACE,8BAAA;EA9ubF;;EAivbA;IACE,4BAAA;EA/ubF;;EAkvbA;IACE,iCAAA;EAhvbF;;EAmvbA;IACE,gCAAA;EAjvbF;;EAovbA;IACE,iCAAA;EAlvbF;;EAqvbA;IACE,8BAAA;EAnvbF;;EAsvbA;IACE,iCAAA;EApvbF;;EAuvbA;IACE,gCAAA;EArvbF;;EAwvbA;IACE,8BAAA;EAtvbF;;EAyvbA;IACE,gCAAA;EAvvbF;;EA0vbA;IACE,8BAAA;EAxvbF;;EA2vbA;IACE,8BAAA;EAzvbF;;EA4vbA;IACE,8BAAA;EA1vbF;;EA6vbA;IACE,8BAAA;EA3vbF;;EA8vbA;IACE,8BAAA;EA5vbF;;EA+vbA;IACE,+BAAA;EA7vbF;;EAgwbA;IACE,+BAAA;EA9vbF;;EAiwbA;IACE,+BAAA;EA/vbF;;EAkwbA;IACE,+BAAA;EAhwbF;;EAmwbA;IACE,6BAAA;EAjwbF;;EAowbA;IACE,8BAAA;EAlwbF;;EAqwbA;IACE,6BAAA;EAnwbF;;EAswbA;IACE,4BAAA;EApwbF;;EAuwbA;IACE,6BAAA;EArwbF;;EAwwbA;IACE,0BAAA;EAtwbF;;EAywbA;IACE,gCAAA;EAvwbF;;EA0wbA;IACE,+BAAA;EAxwbF;;EA2wbA;IACE,gCAAA;EAzwbF;;EA4wbA;IACE,6BAAA;EA1wbF;;EA6wbA;IACE,gCAAA;EA3wbF;;EA8wbA;IACE,+BAAA;EA5wbF;;EA+wbA;IACE,6BAAA;EA7wbF;;EAgxbA;IACE,+BAAA;EA9wbF;;EAixbA;IACE,6BAAA;EA/wbF;;EAkxbA;IACE,6BAAA;EAhxbF;;EAmxbA;IACE,6BAAA;EAjxbF;;EAoxbA;IACE,6BAAA;EAlxbF;;EAqxbA;IACE,6BAAA;EAnxbF;;EAsxbA;IACE,8BAAA;EApxbF;;EAuxbA;IACE,8BAAA;EArxbF;;EAwxbA;IACE,8BAAA;EAtxbF;;EAyxbA;IACE,8BAAA;EAvxbF;;EA0xbA;IACE,4BAAA;EAxxbF;;EA2xbA;IACE,iCAAA;EAzxbF;;EA4xbA;IACE,gCAAA;EA1xbF;;EA6xbA;IACE,iCAAA;EA3xbF;;EA8xbA;IACE,8BAAA;EA5xbF;;EA+xbA;IACE,iCAAA;EA7xbF;;EAgybA;IACE,gCAAA;EA9xbF;;EAiybA;IACE,8BAAA;EA/xbF;;EAkybA;IACE,gCAAA;EAhybF;;EAmybA;IACE,8BAAA;EAjybF;;EAoybA;IACE,8BAAA;EAlybF;;EAqybA;IACE,8BAAA;EAnybF;;EAsybA;IACE,8BAAA;EApybF;;EAuybA;IACE,8BAAA;EArybF;;EAwybA;IACE,+BAAA;EAtybF;;EAyybA;IACE,+BAAA;EAvybF;;EA0ybA;IACE,+BAAA;EAxybF;;EA2ybA;IACE,+BAAA;EAzybF;;EA4ybA;IACE,6BAAA;EA1ybF;;EA6ybA;IACE,8BAAA;EA3ybF;;EA8ybA;IACE,6BAAA;EA5ybF;;EA+ybA;IACE,4BAAA;EA7ybF;;EAgzbA;IACE,6BAAA;EA9ybF;;EAizbA;IACE,0BAAA;EA/ybF;;EAkzbA;IACE,gCAAA;EAhzbF;;EAmzbA;IACE,+BAAA;EAjzbF;;EAozbA;IACE,gCAAA;EAlzbF;;EAqzbA;IACE,6BAAA;EAnzbF;;EAszbA;IACE,gCAAA;EApzbF;;EAuzbA;IACE,+BAAA;EArzbF;;EAwzbA;IACE,6BAAA;EAtzbF;;EAyzbA;IACE,+BAAA;EAvzbF;;EA0zbA;IACE,6BAAA;EAxzbF;;EA2zbA;IACE,6BAAA;EAzzbF;;EA4zbA;IACE,6BAAA;EA1zbF;;EA6zbA;IACE,6BAAA;EA3zbF;;EA8zbA;IACE,6BAAA;EA5zbF;;EA+zbA;IACE,8BAAA;EA7zbF;;EAg0bA;IACE,8BAAA;EA9zbF;;EAi0bA;IACE,8BAAA;EA/zbF;;EAk0bA;IACE,8BAAA;EAh0bF;;EAm0bA;IACE,4BAAA;EAj0bF;;EAo0bA;IACE,iCAAA;EAl0bF;;EAq0bA;IACE,gCAAA;EAn0bF;;EAs0bA;IACE,iCAAA;EAp0bF;;EAu0bA;IACE,8BAAA;EAr0bF;;EAw0bA;IACE,iCAAA;EAt0bF;;EAy0bA;IACE,gCAAA;EAv0bF;;EA00bA;IACE,8BAAA;EAx0bF;;EA20bA;IACE,gCAAA;EAz0bF;;EA40bA;IACE,8BAAA;EA10bF;;EA60bA;IACE,8BAAA;EA30bF;;EA80bA;IACE,8BAAA;EA50bF;;EA+0bA;IACE,8BAAA;EA70bF;;EAg1bA;IACE,8BAAA;EA90bF;;EAi1bA;IACE,+BAAA;EA/0bF;;EAk1bA;IACE,+BAAA;EAh1bF;;EAm1bA;IACE,+BAAA;EAj1bF;;EAo1bA;IACE,+BAAA;EAl1bF;;EAq1bA;IACE,6BAAA;EAn1bF;;EAs1bA;IACE,8BAAA;EAp1bF;;EAu1bA;IACE,6BAAA;EAr1bF;;EAw1bA;IACE,4BAAA;EAt1bF;;EAy1bA;IACE,6BAAA;EAv1bF;;EA01bA;IACE,qBAAA;EAx1bF;;EA21bA;IACE,wBAAA;EAz1bF;;EA41bA;IACE,wBAAA;EA11bF;;EA61bA;IACE,wBAAA;EA31bF;;EA81bA;IACE,wBAAA;EA51bF;;EA+1bA;IACE,yBAAA;EA71bF;;EAg2bA;IACE,0BAAA;EA91bF;;EAi2bA;IACE,yBAAA;EA/1bF;;EAk2bA;IACE,yBAAA;EAh2bF;;EAm2bA;IACE,yBAAA;EAj2bF;;EAo2bA;IACE,yBAAA;EAl2bF;;EAq2bA;IACE,qBAAA;EAn2bF;;EAs2bA;IACE,wBAAA;EAp2bF;;EAu2bA;IACE,wBAAA;EAr2bF;;EAw2bA;IACE,wBAAA;EAt2bF;;EAy2bA;IACE,wBAAA;EAv2bF;;EA02bA;IACE,yBAAA;EAx2bF;;EA22bA;IACE,0BAAA;EAz2bF;;EA42bA;IACE,yBAAA;EA12bF;;EA62bA;IACE,yBAAA;EA32bF;;EA82bA;IACE,yBAAA;EA52bF;;EA+2bA;IACE,yBAAA;EA72bF;;EAg3bA;IACE,qBAAA;EA92bF;;EAi3bA;IACE,wBAAA;EA/2bF;;EAk3bA;IACE,wBAAA;EAh3bF;;EAm3bA;IACE,wBAAA;EAj3bF;;EAo3bA;IACE,wBAAA;EAl3bF;;EAq3bA;IACE,yBAAA;EAn3bF;;EAs3bA;IACE,0BAAA;EAp3bF;;EAu3bA;IACE,yBAAA;EAr3bF;;EAw3bA;IACE,yBAAA;EAt3bF;;EAy3bA;IACE,yBAAA;EAv3bF;;EA03bA;IACE,yBAAA;EAx3bF;;EA23bA;IACE,qBAAA;EAz3bF;;EA43bA;IACE,wBAAA;EA13bF;;EA63bA;IACE,wBAAA;EA33bF;;EA83bA;IACE,wBAAA;EA53bF;;EA+3bA;IACE,wBAAA;EA73bF;;EAg4bA;IACE,yBAAA;EA93bF;;EAi4bA;IACE,0BAAA;EA/3bF;;EAk4bA;IACE,yBAAA;EAh4bF;;EAm4bA;IACE,yBAAA;EAj4bF;;EAo4bA;IACE,yBAAA;EAl4bF;;EAq4bA;IACE,yBAAA;EAn4bF;;EAs4bA;IACE,qBAAA;EAp4bF;;EAu4bA;IACE,wBAAA;EAr4bF;;EAw4bA;IACE,wBAAA;EAt4bF;;EAy4bA;IACE,wBAAA;EAv4bF;;EA04bA;IACE,wBAAA;EAx4bF;;EA24bA;IACE,yBAAA;EAz4bF;;EA44bA;IACE,0BAAA;EA14bF;;EA64bA;IACE,yBAAA;EA34bF;;EA84bA;IACE,yBAAA;EA54bF;;EA+4bA;IACE,yBAAA;EA74bF;;EAg5bA;IACE,yBAAA;EA94bF;;EAi5bA;IACE,qBAAA;EA/4bF;;EAk5bA;IACE,wBAAA;EAh5bF;;EAm5bA;IACE,wBAAA;EAj5bF;;EAo5bA;IACE,wBAAA;EAl5bF;;EAq5bA;IACE,wBAAA;EAn5bF;;EAs5bA;IACE,yBAAA;EAp5bF;;EAu5bA;IACE,0BAAA;EAr5bF;;EAw5bA;IACE,yBAAA;EAt5bF;;EAy5bA;IACE,yBAAA;EAv5bF;;EA05bA;IACE,yBAAA;EAx5bF;;EA25bA;IACE,yBAAA;EAz5bF;;EA45bA;IACE,yBAAA;EA15bF;;EA65bA;IACE,wBAAA;EA35bF;;EA85bA;IACE,wGAAA;EA55bF;;EA+5bA;IACE,wEAAA;EA75bF;;EAg6bA;IACE,4BAAA;EA95bF;;EAi6bA;IACE,+BAAA;EA/5bF;;EAk6bA;IACE,8BAAA;EAh6bF;;EAm6bA;IACE,kCAAA;EAj6bF;;EAo6bA;IACE,sDAAA;EAl6bF;;EAq6bA;IACE,sDAAA;EAn6bF;;EAs6bA;IACE,wDAAA;EAp6bF;;EAu6bA;IACE,yBAAA;EAr6bF;;EAw6bA;IACE,0BAAA;EAt6bF;;EAy6bA;IACE,0BAAA;EAv6bF;;EA06bA;IACE,0BAAA;EAx6bF;;EA26bA;IACE,0BAAA;EAz6bF;;EA46bA;IACE,0BAAA;EA16bF;;EA66bA;IACE,0BAAA;EA36bF;;EA86bA;IACE,2BAAA;EA56bF;;EA+6bA;IACE,sBAAA;EA76bF;;EAg7bA;IACE,uBAAA;EA96bF;;EAi7bA;IACE,uBAAA;EA/6bF;;EAk7bA;IACE,uBAAA;EAh7bF;;EAm7bA;IACE,uBAAA;EAj7bF;;EAo7bA;IACE,uBAAA;EAl7bF;;EAq7bA;IACE,uBAAA;EAn7bF;;EAs7bA;IACE,wBAAA;EAp7bF;;EAu7bA;IACE,eAAA;EAr7bF;;EAw7bA;IACE,kCAAA;EAt7bF;;EAy7bA;IACE,sDAAA;EAv7bF;;EA07bA;IACE,yDAAA;EAx7bF;;EA27bA;IACE,6BAAA;EAz7bF;AACF","sourcesContent":["/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in iOS.\n */\n\nhtml {\n  line-height: 1.15; /* 1 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers.\n */\n\nbody {\n  margin: 0;\n}\n\n/**\n * Render the `main` element consistently in IE.\n */\n\nmain {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\n\nh1 {\n  font-size: 2em;\n  margin: 0.67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\n\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * Remove the gray background on active links in IE 10.\n */\n\na {\n  background-color: transparent;\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57-\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\n\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\n\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font size in all browsers.\n */\n\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\n\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -0.25em;\n}\n\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Remove the border on images inside links in IE 10.\n */\n\nimg {\n  border-style: none;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers.\n * 2. Remove the margin in Firefox and Safari.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\n\nbutton,\ninput { /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\n\nbutton,\nselect { /* 1 */\n  text-transform: none;\n}\n\n/**\n * Correct the inability to style clickable types in iOS and Safari.\n */\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\n\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\n\nfieldset {\n  padding: 0.35em 0.75em 0.625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\n\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\n\nprogress {\n  vertical-align: baseline;\n}\n\n/**\n * Remove the default vertical scrollbar in IE 10+.\n */\n\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10.\n * 2. Remove the padding in IE 10.\n */\n\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding in Chrome and Safari on macOS.\n */\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in Edge, IE 10+, and Firefox.\n */\n\ndetails {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\n\nsummary {\n  display: list-item;\n}\n\n/* Misc\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10+.\n */\n\ntemplate {\n  display: none;\n}\n\n/**\n * Add the correct display in IE 10.\n */\n\n[hidden] {\n  display: none;\n}\n\n/**\n * Manually forked from SUIT CSS Base: https://github.com/suitcss/base\n * A thin layer on top of normalize.css that provides a starting point more\n * suitable for web applications.\n */\n\n/**\n * Removes the default spacing and border for appropriate elements.\n */\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n  margin: 0;\n}\n\nbutton {\n  background-color: transparent;\n  background-image: none;\n}\n\n/**\n * Work around a Firefox/IE bug where the transparent `button` background\n * results in a loss of the default `button` focus styles.\n */\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\nfieldset {\n  margin: 0;\n  padding: 0;\n}\n\nol,\nul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n/**\n * Tailwind custom reset styles\n */\n\n/**\n * 1. Use the user's configured `sans` font-family (with Tailwind's default\n *    sans-serif font stack as a fallback) as a sane default.\n * 2. Use Tailwind's default \"normal\" line-height so the user isn't forced\n *    to override it to ensure consistency even when using the default theme.\n */\n\nhtml {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"; /* 1 */\n  line-height: 1.5; /* 2 */\n}\n\n/**\n * 1. Prevent padding and border from affecting element width.\n *\n *    We used to set this in the html element and inherit from\n *    the parent element for everything else. This caused issues\n *    in shadow-dom-enhanced elements like <details> where the content\n *    is wrapped by a div with box-sizing set to `content-box`.\n *\n *    https://github.com/mozdevs/cssremedy/issues/4\n *\n *\n * 2. Allow adding a border to an element by just adding a border-width.\n *\n *    By default, the way the browser specifies that an element should have no\n *    border is by setting it's border-style to `none` in the user-agent\n *    stylesheet.\n *\n *    In order to easily add borders to elements by just setting the `border-width`\n *    property, we change the default border-style for all elements to `solid`, and\n *    use border-width to hide them instead. This way our `border` utilities only\n *    need to set the `border-width` property instead of the entire `border`\n *    shorthand, making our border utilities much more straightforward to compose.\n *\n *    https://github.com/tailwindcss/tailwindcss/pull/116\n */\n\n*,\n::before,\n::after {\n  box-sizing: border-box; /* 1 */\n  border-width: 0; /* 2 */\n  border-style: solid; /* 2 */\n  border-color: #e2e8f0; /* 2 */\n}\n\n/*\n * Ensure horizontal rules are visible by default\n */\n\nhr {\n  border-top-width: 1px;\n}\n\n/**\n * Undo the `border-style: none` reset that Normalize applies to images so that\n * our `border-{width}` utilities have the expected effect.\n *\n * The Normalize reset is unnecessary for us since we default the border-width\n * to 0 on all elements.\n *\n * https://github.com/tailwindcss/tailwindcss/issues/362\n */\n\nimg {\n  border-style: solid;\n}\n\ntextarea {\n  resize: vertical;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  color: #a0aec0;\n}\n\nbutton,\n[role=\"button\"] {\n  cursor: pointer;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n/**\n * Reset links to optimize for opt-in styling instead of\n * opt-out.\n */\n\na {\n  color: inherit;\n  text-decoration: inherit;\n}\n\n/**\n * Reset form element properties that are easy to forget to\n * style explicitly so you don't inadvertently introduce\n * styles that deviate from your design system. These styles\n * supplement a partial reset that is already applied by\n * normalize.css.\n */\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  padding: 0;\n  line-height: inherit;\n  color: inherit;\n}\n\n/**\n * Use the configured 'mono' font family for elements that\n * are expected to be rendered with a monospace font, falling\n * back to the system monospace stack if there is no configured\n * 'mono' font family.\n */\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n/**\n * Make replaced elements `display: block` by default as that's\n * the behavior you want almost all of the time. Inspired by\n * CSS Remedy, with `svg` added as well.\n *\n * https://github.com/mozdevs/cssremedy/issues/14\n */\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n  display: block;\n  vertical-align: middle;\n}\n\n/**\n * Constrain images and videos to the parent width and preserve\n * their instrinsic aspect ratio.\n *\n * https://github.com/mozdevs/cssremedy/issues/14\n */\n\nimg,\nvideo {\n  max-width: 100%;\n  height: auto;\n}\n\n.container {\n  width: 100%;\n}\n\n@media (min-width: 640px) {\n  .container {\n    max-width: 640px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container {\n    max-width: 768px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .container {\n    max-width: 1024px;\n  }\n}\n\n@media (min-width: 1280px) {\n  .container {\n    max-width: 1280px;\n  }\n}\n\n.space-y-0 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0px * var(--space-y-reverse));\n}\n\n.space-x-0 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0px * var(--space-x-reverse));\n  margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-1 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.25rem * var(--space-y-reverse));\n}\n\n.space-x-1 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.25rem * var(--space-x-reverse));\n  margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-2 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.5rem * var(--space-y-reverse));\n}\n\n.space-x-2 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.5rem * var(--space-x-reverse));\n  margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-3 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(0.75rem * var(--space-y-reverse));\n}\n\n.space-x-3 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(0.75rem * var(--space-x-reverse));\n  margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-4 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1rem * var(--space-y-reverse));\n}\n\n.space-x-4 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1rem * var(--space-x-reverse));\n  margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-5 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1.25rem * var(--space-y-reverse));\n}\n\n.space-x-5 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1.25rem * var(--space-x-reverse));\n  margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-6 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1.5rem * var(--space-y-reverse));\n}\n\n.space-x-6 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1.5rem * var(--space-x-reverse));\n  margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-8 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(2rem * var(--space-y-reverse));\n}\n\n.space-x-8 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(2rem * var(--space-x-reverse));\n  margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-10 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(2.5rem * var(--space-y-reverse));\n}\n\n.space-x-10 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(2.5rem * var(--space-x-reverse));\n  margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-12 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(3rem * var(--space-y-reverse));\n}\n\n.space-x-12 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(3rem * var(--space-x-reverse));\n  margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-16 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(4rem * var(--space-y-reverse));\n}\n\n.space-x-16 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(4rem * var(--space-x-reverse));\n  margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-20 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(5rem * var(--space-y-reverse));\n}\n\n.space-x-20 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(5rem * var(--space-x-reverse));\n  margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-24 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(6rem * var(--space-y-reverse));\n}\n\n.space-x-24 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(6rem * var(--space-x-reverse));\n  margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-32 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(8rem * var(--space-y-reverse));\n}\n\n.space-x-32 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(8rem * var(--space-x-reverse));\n  margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-40 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(10rem * var(--space-y-reverse));\n}\n\n.space-x-40 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(10rem * var(--space-x-reverse));\n  margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-48 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(12rem * var(--space-y-reverse));\n}\n\n.space-x-48 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(12rem * var(--space-x-reverse));\n  margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-56 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(14rem * var(--space-y-reverse));\n}\n\n.space-x-56 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(14rem * var(--space-x-reverse));\n  margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-64 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(16rem * var(--space-y-reverse));\n}\n\n.space-x-64 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(16rem * var(--space-x-reverse));\n  margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-px > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(1px * var(--space-y-reverse));\n}\n\n.space-x-px > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(1px * var(--space-x-reverse));\n  margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-1 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n}\n\n.-space-x-1 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.25rem * var(--space-x-reverse));\n  margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-2 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n}\n\n.-space-x-2 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.5rem * var(--space-x-reverse));\n  margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-3 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n}\n\n.-space-x-3 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-0.75rem * var(--space-x-reverse));\n  margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-4 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1rem * var(--space-y-reverse));\n}\n\n.-space-x-4 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1rem * var(--space-x-reverse));\n  margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-5 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n}\n\n.-space-x-5 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1.25rem * var(--space-x-reverse));\n  margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-6 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n}\n\n.-space-x-6 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1.5rem * var(--space-x-reverse));\n  margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-8 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-2rem * var(--space-y-reverse));\n}\n\n.-space-x-8 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-2rem * var(--space-x-reverse));\n  margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-10 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n}\n\n.-space-x-10 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-2.5rem * var(--space-x-reverse));\n  margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-12 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-3rem * var(--space-y-reverse));\n}\n\n.-space-x-12 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-3rem * var(--space-x-reverse));\n  margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-16 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-4rem * var(--space-y-reverse));\n}\n\n.-space-x-16 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-4rem * var(--space-x-reverse));\n  margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-20 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-5rem * var(--space-y-reverse));\n}\n\n.-space-x-20 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-5rem * var(--space-x-reverse));\n  margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-24 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-6rem * var(--space-y-reverse));\n}\n\n.-space-x-24 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-6rem * var(--space-x-reverse));\n  margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-32 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-8rem * var(--space-y-reverse));\n}\n\n.-space-x-32 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-8rem * var(--space-x-reverse));\n  margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-40 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-10rem * var(--space-y-reverse));\n}\n\n.-space-x-40 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-10rem * var(--space-x-reverse));\n  margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-48 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-12rem * var(--space-y-reverse));\n}\n\n.-space-x-48 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-12rem * var(--space-x-reverse));\n  margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-56 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-14rem * var(--space-y-reverse));\n}\n\n.-space-x-56 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-14rem * var(--space-x-reverse));\n  margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-64 > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-16rem * var(--space-y-reverse));\n}\n\n.-space-x-64 > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-16rem * var(--space-x-reverse));\n  margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n}\n\n.-space-y-px > :not(template) ~ :not(template) {\n  --space-y-reverse: 0;\n  margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n  margin-bottom: calc(-1px * var(--space-y-reverse));\n}\n\n.-space-x-px > :not(template) ~ :not(template) {\n  --space-x-reverse: 0;\n  margin-right: calc(-1px * var(--space-x-reverse));\n  margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n}\n\n.space-y-reverse > :not(template) ~ :not(template) {\n  --space-y-reverse: 1;\n}\n\n.space-x-reverse > :not(template) ~ :not(template) {\n  --space-x-reverse: 1;\n}\n\n.divide-y-0 > :not(template) ~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(0px * var(--divide-y-reverse));\n}\n\n.divide-x-0 > :not(template) ~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(0px * var(--divide-x-reverse));\n  border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n}\n\n.divide-y-2 > :not(template) ~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(2px * var(--divide-y-reverse));\n}\n\n.divide-x-2 > :not(template) ~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(2px * var(--divide-x-reverse));\n  border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n}\n\n.divide-y-4 > :not(template) ~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(4px * var(--divide-y-reverse));\n}\n\n.divide-x-4 > :not(template) ~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(4px * var(--divide-x-reverse));\n  border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n}\n\n.divide-y-8 > :not(template) ~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(8px * var(--divide-y-reverse));\n}\n\n.divide-x-8 > :not(template) ~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(8px * var(--divide-x-reverse));\n  border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n}\n\n.divide-y > :not(template) ~ :not(template) {\n  --divide-y-reverse: 0;\n  border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n  border-bottom-width: calc(1px * var(--divide-y-reverse));\n}\n\n.divide-x > :not(template) ~ :not(template) {\n  --divide-x-reverse: 0;\n  border-right-width: calc(1px * var(--divide-x-reverse));\n  border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n}\n\n.divide-y-reverse > :not(template) ~ :not(template) {\n  --divide-y-reverse: 1;\n}\n\n.divide-x-reverse > :not(template) ~ :not(template) {\n  --divide-x-reverse: 1;\n}\n\n.divide-transparent > :not(template) ~ :not(template) {\n  border-color: transparent;\n}\n\n.divide-current > :not(template) ~ :not(template) {\n  border-color: currentColor;\n}\n\n.divide-black > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #000;\n  border-color: rgba(0, 0, 0, var(--divide-opacity));\n}\n\n.divide-white > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fff;\n  border-color: rgba(255, 255, 255, var(--divide-opacity));\n}\n\n.divide-gray-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f7fafc;\n  border-color: rgba(247, 250, 252, var(--divide-opacity));\n}\n\n.divide-gray-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #edf2f7;\n  border-color: rgba(237, 242, 247, var(--divide-opacity));\n}\n\n.divide-gray-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--divide-opacity));\n}\n\n.divide-gray-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #cbd5e0;\n  border-color: rgba(203, 213, 224, var(--divide-opacity));\n}\n\n.divide-gray-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #a0aec0;\n  border-color: rgba(160, 174, 192, var(--divide-opacity));\n}\n\n.divide-gray-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #718096;\n  border-color: rgba(113, 128, 150, var(--divide-opacity));\n}\n\n.divide-gray-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #4a5568;\n  border-color: rgba(74, 85, 104, var(--divide-opacity));\n}\n\n.divide-gray-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #2d3748;\n  border-color: rgba(45, 55, 72, var(--divide-opacity));\n}\n\n.divide-gray-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #1a202c;\n  border-color: rgba(26, 32, 44, var(--divide-opacity));\n}\n\n.divide-red-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fff5f5;\n  border-color: rgba(255, 245, 245, var(--divide-opacity));\n}\n\n.divide-red-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fed7d7;\n  border-color: rgba(254, 215, 215, var(--divide-opacity));\n}\n\n.divide-red-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #feb2b2;\n  border-color: rgba(254, 178, 178, var(--divide-opacity));\n}\n\n.divide-red-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fc8181;\n  border-color: rgba(252, 129, 129, var(--divide-opacity));\n}\n\n.divide-red-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f56565;\n  border-color: rgba(245, 101, 101, var(--divide-opacity));\n}\n\n.divide-red-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e53e3e;\n  border-color: rgba(229, 62, 62, var(--divide-opacity));\n}\n\n.divide-red-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #c53030;\n  border-color: rgba(197, 48, 48, var(--divide-opacity));\n}\n\n.divide-red-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #9b2c2c;\n  border-color: rgba(155, 44, 44, var(--divide-opacity));\n}\n\n.divide-red-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #742a2a;\n  border-color: rgba(116, 42, 42, var(--divide-opacity));\n}\n\n.divide-orange-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fffaf0;\n  border-color: rgba(255, 250, 240, var(--divide-opacity));\n}\n\n.divide-orange-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #feebc8;\n  border-color: rgba(254, 235, 200, var(--divide-opacity));\n}\n\n.divide-orange-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fbd38d;\n  border-color: rgba(251, 211, 141, var(--divide-opacity));\n}\n\n.divide-orange-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f6ad55;\n  border-color: rgba(246, 173, 85, var(--divide-opacity));\n}\n\n.divide-orange-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ed8936;\n  border-color: rgba(237, 137, 54, var(--divide-opacity));\n}\n\n.divide-orange-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #dd6b20;\n  border-color: rgba(221, 107, 32, var(--divide-opacity));\n}\n\n.divide-orange-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #c05621;\n  border-color: rgba(192, 86, 33, var(--divide-opacity));\n}\n\n.divide-orange-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #9c4221;\n  border-color: rgba(156, 66, 33, var(--divide-opacity));\n}\n\n.divide-orange-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #7b341e;\n  border-color: rgba(123, 52, 30, var(--divide-opacity));\n}\n\n.divide-yellow-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fffff0;\n  border-color: rgba(255, 255, 240, var(--divide-opacity));\n}\n\n.divide-yellow-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fefcbf;\n  border-color: rgba(254, 252, 191, var(--divide-opacity));\n}\n\n.divide-yellow-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #faf089;\n  border-color: rgba(250, 240, 137, var(--divide-opacity));\n}\n\n.divide-yellow-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f6e05e;\n  border-color: rgba(246, 224, 94, var(--divide-opacity));\n}\n\n.divide-yellow-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ecc94b;\n  border-color: rgba(236, 201, 75, var(--divide-opacity));\n}\n\n.divide-yellow-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #d69e2e;\n  border-color: rgba(214, 158, 46, var(--divide-opacity));\n}\n\n.divide-yellow-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #b7791f;\n  border-color: rgba(183, 121, 31, var(--divide-opacity));\n}\n\n.divide-yellow-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #975a16;\n  border-color: rgba(151, 90, 22, var(--divide-opacity));\n}\n\n.divide-yellow-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #744210;\n  border-color: rgba(116, 66, 16, var(--divide-opacity));\n}\n\n.divide-green-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f0fff4;\n  border-color: rgba(240, 255, 244, var(--divide-opacity));\n}\n\n.divide-green-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #c6f6d5;\n  border-color: rgba(198, 246, 213, var(--divide-opacity));\n}\n\n.divide-green-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #9ae6b4;\n  border-color: rgba(154, 230, 180, var(--divide-opacity));\n}\n\n.divide-green-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #68d391;\n  border-color: rgba(104, 211, 145, var(--divide-opacity));\n}\n\n.divide-green-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #48bb78;\n  border-color: rgba(72, 187, 120, var(--divide-opacity));\n}\n\n.divide-green-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #38a169;\n  border-color: rgba(56, 161, 105, var(--divide-opacity));\n}\n\n.divide-green-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #2f855a;\n  border-color: rgba(47, 133, 90, var(--divide-opacity));\n}\n\n.divide-green-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #276749;\n  border-color: rgba(39, 103, 73, var(--divide-opacity));\n}\n\n.divide-green-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #22543d;\n  border-color: rgba(34, 84, 61, var(--divide-opacity));\n}\n\n.divide-teal-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e6fffa;\n  border-color: rgba(230, 255, 250, var(--divide-opacity));\n}\n\n.divide-teal-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #b2f5ea;\n  border-color: rgba(178, 245, 234, var(--divide-opacity));\n}\n\n.divide-teal-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #81e6d9;\n  border-color: rgba(129, 230, 217, var(--divide-opacity));\n}\n\n.divide-teal-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #4fd1c5;\n  border-color: rgba(79, 209, 197, var(--divide-opacity));\n}\n\n.divide-teal-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #38b2ac;\n  border-color: rgba(56, 178, 172, var(--divide-opacity));\n}\n\n.divide-teal-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #319795;\n  border-color: rgba(49, 151, 149, var(--divide-opacity));\n}\n\n.divide-teal-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #2c7a7b;\n  border-color: rgba(44, 122, 123, var(--divide-opacity));\n}\n\n.divide-teal-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #285e61;\n  border-color: rgba(40, 94, 97, var(--divide-opacity));\n}\n\n.divide-teal-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #234e52;\n  border-color: rgba(35, 78, 82, var(--divide-opacity));\n}\n\n.divide-blue-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ebf8ff;\n  border-color: rgba(235, 248, 255, var(--divide-opacity));\n}\n\n.divide-blue-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #bee3f8;\n  border-color: rgba(190, 227, 248, var(--divide-opacity));\n}\n\n.divide-blue-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #90cdf4;\n  border-color: rgba(144, 205, 244, var(--divide-opacity));\n}\n\n.divide-blue-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #63b3ed;\n  border-color: rgba(99, 179, 237, var(--divide-opacity));\n}\n\n.divide-blue-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #4299e1;\n  border-color: rgba(66, 153, 225, var(--divide-opacity));\n}\n\n.divide-blue-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #3182ce;\n  border-color: rgba(49, 130, 206, var(--divide-opacity));\n}\n\n.divide-blue-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #2b6cb0;\n  border-color: rgba(43, 108, 176, var(--divide-opacity));\n}\n\n.divide-blue-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #2c5282;\n  border-color: rgba(44, 82, 130, var(--divide-opacity));\n}\n\n.divide-blue-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #2a4365;\n  border-color: rgba(42, 67, 101, var(--divide-opacity));\n}\n\n.divide-indigo-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ebf4ff;\n  border-color: rgba(235, 244, 255, var(--divide-opacity));\n}\n\n.divide-indigo-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #c3dafe;\n  border-color: rgba(195, 218, 254, var(--divide-opacity));\n}\n\n.divide-indigo-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #a3bffa;\n  border-color: rgba(163, 191, 250, var(--divide-opacity));\n}\n\n.divide-indigo-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #7f9cf5;\n  border-color: rgba(127, 156, 245, var(--divide-opacity));\n}\n\n.divide-indigo-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #667eea;\n  border-color: rgba(102, 126, 234, var(--divide-opacity));\n}\n\n.divide-indigo-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #5a67d8;\n  border-color: rgba(90, 103, 216, var(--divide-opacity));\n}\n\n.divide-indigo-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #4c51bf;\n  border-color: rgba(76, 81, 191, var(--divide-opacity));\n}\n\n.divide-indigo-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #434190;\n  border-color: rgba(67, 65, 144, var(--divide-opacity));\n}\n\n.divide-indigo-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #3c366b;\n  border-color: rgba(60, 54, 107, var(--divide-opacity));\n}\n\n.divide-purple-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #faf5ff;\n  border-color: rgba(250, 245, 255, var(--divide-opacity));\n}\n\n.divide-purple-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #e9d8fd;\n  border-color: rgba(233, 216, 253, var(--divide-opacity));\n}\n\n.divide-purple-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #d6bcfa;\n  border-color: rgba(214, 188, 250, var(--divide-opacity));\n}\n\n.divide-purple-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #b794f4;\n  border-color: rgba(183, 148, 244, var(--divide-opacity));\n}\n\n.divide-purple-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #9f7aea;\n  border-color: rgba(159, 122, 234, var(--divide-opacity));\n}\n\n.divide-purple-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #805ad5;\n  border-color: rgba(128, 90, 213, var(--divide-opacity));\n}\n\n.divide-purple-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #6b46c1;\n  border-color: rgba(107, 70, 193, var(--divide-opacity));\n}\n\n.divide-purple-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #553c9a;\n  border-color: rgba(85, 60, 154, var(--divide-opacity));\n}\n\n.divide-purple-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #44337a;\n  border-color: rgba(68, 51, 122, var(--divide-opacity));\n}\n\n.divide-pink-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fff5f7;\n  border-color: rgba(255, 245, 247, var(--divide-opacity));\n}\n\n.divide-pink-200 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fed7e2;\n  border-color: rgba(254, 215, 226, var(--divide-opacity));\n}\n\n.divide-pink-300 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #fbb6ce;\n  border-color: rgba(251, 182, 206, var(--divide-opacity));\n}\n\n.divide-pink-400 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #f687b3;\n  border-color: rgba(246, 135, 179, var(--divide-opacity));\n}\n\n.divide-pink-500 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #ed64a6;\n  border-color: rgba(237, 100, 166, var(--divide-opacity));\n}\n\n.divide-pink-600 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #d53f8c;\n  border-color: rgba(213, 63, 140, var(--divide-opacity));\n}\n\n.divide-pink-700 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #b83280;\n  border-color: rgba(184, 50, 128, var(--divide-opacity));\n}\n\n.divide-pink-800 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #97266d;\n  border-color: rgba(151, 38, 109, var(--divide-opacity));\n}\n\n.divide-pink-900 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n  border-color: #702459;\n  border-color: rgba(112, 36, 89, var(--divide-opacity));\n}\n\n.divide-solid > :not(template) ~ :not(template) {\n  border-style: solid;\n}\n\n.divide-dashed > :not(template) ~ :not(template) {\n  border-style: dashed;\n}\n\n.divide-dotted > :not(template) ~ :not(template) {\n  border-style: dotted;\n}\n\n.divide-double > :not(template) ~ :not(template) {\n  border-style: double;\n}\n\n.divide-none > :not(template) ~ :not(template) {\n  border-style: none;\n}\n\n.divide-opacity-0 > :not(template) ~ :not(template) {\n  --divide-opacity: 0;\n}\n\n.divide-opacity-25 > :not(template) ~ :not(template) {\n  --divide-opacity: 0.25;\n}\n\n.divide-opacity-50 > :not(template) ~ :not(template) {\n  --divide-opacity: 0.5;\n}\n\n.divide-opacity-75 > :not(template) ~ :not(template) {\n  --divide-opacity: 0.75;\n}\n\n.divide-opacity-100 > :not(template) ~ :not(template) {\n  --divide-opacity: 1;\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.not-sr-only {\n  position: static;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.focus\\:sr-only:focus {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.focus\\:not-sr-only:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.appearance-none {\n  appearance: none;\n}\n\n.bg-fixed {\n  background-attachment: fixed;\n}\n\n.bg-local {\n  background-attachment: local;\n}\n\n.bg-scroll {\n  background-attachment: scroll;\n}\n\n.bg-clip-border {\n  background-clip: border-box;\n}\n\n.bg-clip-padding {\n  background-clip: padding-box;\n}\n\n.bg-clip-content {\n  background-clip: content-box;\n}\n\n.bg-clip-text {\n  -webkit-background-clip: text;\n          background-clip: text;\n}\n\n.bg-transparent {\n  background-color: transparent;\n}\n\n.bg-current {\n  background-color: currentColor;\n}\n\n.bg-black {\n  --bg-opacity: 1;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n\n.bg-white {\n  --bg-opacity: 1;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n\n.bg-gray-100 {\n  --bg-opacity: 1;\n  background-color: #f7fafc;\n  background-color: rgba(247, 250, 252, var(--bg-opacity));\n}\n\n.bg-gray-200 {\n  --bg-opacity: 1;\n  background-color: #edf2f7;\n  background-color: rgba(237, 242, 247, var(--bg-opacity));\n}\n\n.bg-gray-300 {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n\n.bg-gray-400 {\n  --bg-opacity: 1;\n  background-color: #cbd5e0;\n  background-color: rgba(203, 213, 224, var(--bg-opacity));\n}\n\n.bg-gray-500 {\n  --bg-opacity: 1;\n  background-color: #a0aec0;\n  background-color: rgba(160, 174, 192, var(--bg-opacity));\n}\n\n.bg-gray-600 {\n  --bg-opacity: 1;\n  background-color: #718096;\n  background-color: rgba(113, 128, 150, var(--bg-opacity));\n}\n\n.bg-gray-700 {\n  --bg-opacity: 1;\n  background-color: #4a5568;\n  background-color: rgba(74, 85, 104, var(--bg-opacity));\n}\n\n.bg-gray-800 {\n  --bg-opacity: 1;\n  background-color: #2d3748;\n  background-color: rgba(45, 55, 72, var(--bg-opacity));\n}\n\n.bg-gray-900 {\n  --bg-opacity: 1;\n  background-color: #1a202c;\n  background-color: rgba(26, 32, 44, var(--bg-opacity));\n}\n\n.bg-red-100 {\n  --bg-opacity: 1;\n  background-color: #fff5f5;\n  background-color: rgba(255, 245, 245, var(--bg-opacity));\n}\n\n.bg-red-200 {\n  --bg-opacity: 1;\n  background-color: #fed7d7;\n  background-color: rgba(254, 215, 215, var(--bg-opacity));\n}\n\n.bg-red-300 {\n  --bg-opacity: 1;\n  background-color: #feb2b2;\n  background-color: rgba(254, 178, 178, var(--bg-opacity));\n}\n\n.bg-red-400 {\n  --bg-opacity: 1;\n  background-color: #fc8181;\n  background-color: rgba(252, 129, 129, var(--bg-opacity));\n}\n\n.bg-red-500 {\n  --bg-opacity: 1;\n  background-color: #f56565;\n  background-color: rgba(245, 101, 101, var(--bg-opacity));\n}\n\n.bg-red-600 {\n  --bg-opacity: 1;\n  background-color: #e53e3e;\n  background-color: rgba(229, 62, 62, var(--bg-opacity));\n}\n\n.bg-red-700 {\n  --bg-opacity: 1;\n  background-color: #c53030;\n  background-color: rgba(197, 48, 48, var(--bg-opacity));\n}\n\n.bg-red-800 {\n  --bg-opacity: 1;\n  background-color: #9b2c2c;\n  background-color: rgba(155, 44, 44, var(--bg-opacity));\n}\n\n.bg-red-900 {\n  --bg-opacity: 1;\n  background-color: #742a2a;\n  background-color: rgba(116, 42, 42, var(--bg-opacity));\n}\n\n.bg-orange-100 {\n  --bg-opacity: 1;\n  background-color: #fffaf0;\n  background-color: rgba(255, 250, 240, var(--bg-opacity));\n}\n\n.bg-orange-200 {\n  --bg-opacity: 1;\n  background-color: #feebc8;\n  background-color: rgba(254, 235, 200, var(--bg-opacity));\n}\n\n.bg-orange-300 {\n  --bg-opacity: 1;\n  background-color: #fbd38d;\n  background-color: rgba(251, 211, 141, var(--bg-opacity));\n}\n\n.bg-orange-400 {\n  --bg-opacity: 1;\n  background-color: #f6ad55;\n  background-color: rgba(246, 173, 85, var(--bg-opacity));\n}\n\n.bg-orange-500 {\n  --bg-opacity: 1;\n  background-color: #ed8936;\n  background-color: rgba(237, 137, 54, var(--bg-opacity));\n}\n\n.bg-orange-600 {\n  --bg-opacity: 1;\n  background-color: #dd6b20;\n  background-color: rgba(221, 107, 32, var(--bg-opacity));\n}\n\n.bg-orange-700 {\n  --bg-opacity: 1;\n  background-color: #c05621;\n  background-color: rgba(192, 86, 33, var(--bg-opacity));\n}\n\n.bg-orange-800 {\n  --bg-opacity: 1;\n  background-color: #9c4221;\n  background-color: rgba(156, 66, 33, var(--bg-opacity));\n}\n\n.bg-orange-900 {\n  --bg-opacity: 1;\n  background-color: #7b341e;\n  background-color: rgba(123, 52, 30, var(--bg-opacity));\n}\n\n.bg-yellow-100 {\n  --bg-opacity: 1;\n  background-color: #fffff0;\n  background-color: rgba(255, 255, 240, var(--bg-opacity));\n}\n\n.bg-yellow-200 {\n  --bg-opacity: 1;\n  background-color: #fefcbf;\n  background-color: rgba(254, 252, 191, var(--bg-opacity));\n}\n\n.bg-yellow-300 {\n  --bg-opacity: 1;\n  background-color: #faf089;\n  background-color: rgba(250, 240, 137, var(--bg-opacity));\n}\n\n.bg-yellow-400 {\n  --bg-opacity: 1;\n  background-color: #f6e05e;\n  background-color: rgba(246, 224, 94, var(--bg-opacity));\n}\n\n.bg-yellow-500 {\n  --bg-opacity: 1;\n  background-color: #ecc94b;\n  background-color: rgba(236, 201, 75, var(--bg-opacity));\n}\n\n.bg-yellow-600 {\n  --bg-opacity: 1;\n  background-color: #d69e2e;\n  background-color: rgba(214, 158, 46, var(--bg-opacity));\n}\n\n.bg-yellow-700 {\n  --bg-opacity: 1;\n  background-color: #b7791f;\n  background-color: rgba(183, 121, 31, var(--bg-opacity));\n}\n\n.bg-yellow-800 {\n  --bg-opacity: 1;\n  background-color: #975a16;\n  background-color: rgba(151, 90, 22, var(--bg-opacity));\n}\n\n.bg-yellow-900 {\n  --bg-opacity: 1;\n  background-color: #744210;\n  background-color: rgba(116, 66, 16, var(--bg-opacity));\n}\n\n.bg-green-100 {\n  --bg-opacity: 1;\n  background-color: #f0fff4;\n  background-color: rgba(240, 255, 244, var(--bg-opacity));\n}\n\n.bg-green-200 {\n  --bg-opacity: 1;\n  background-color: #c6f6d5;\n  background-color: rgba(198, 246, 213, var(--bg-opacity));\n}\n\n.bg-green-300 {\n  --bg-opacity: 1;\n  background-color: #9ae6b4;\n  background-color: rgba(154, 230, 180, var(--bg-opacity));\n}\n\n.bg-green-400 {\n  --bg-opacity: 1;\n  background-color: #68d391;\n  background-color: rgba(104, 211, 145, var(--bg-opacity));\n}\n\n.bg-green-500 {\n  --bg-opacity: 1;\n  background-color: #48bb78;\n  background-color: rgba(72, 187, 120, var(--bg-opacity));\n}\n\n.bg-green-600 {\n  --bg-opacity: 1;\n  background-color: #38a169;\n  background-color: rgba(56, 161, 105, var(--bg-opacity));\n}\n\n.bg-green-700 {\n  --bg-opacity: 1;\n  background-color: #2f855a;\n  background-color: rgba(47, 133, 90, var(--bg-opacity));\n}\n\n.bg-green-800 {\n  --bg-opacity: 1;\n  background-color: #276749;\n  background-color: rgba(39, 103, 73, var(--bg-opacity));\n}\n\n.bg-green-900 {\n  --bg-opacity: 1;\n  background-color: #22543d;\n  background-color: rgba(34, 84, 61, var(--bg-opacity));\n}\n\n.bg-teal-100 {\n  --bg-opacity: 1;\n  background-color: #e6fffa;\n  background-color: rgba(230, 255, 250, var(--bg-opacity));\n}\n\n.bg-teal-200 {\n  --bg-opacity: 1;\n  background-color: #b2f5ea;\n  background-color: rgba(178, 245, 234, var(--bg-opacity));\n}\n\n.bg-teal-300 {\n  --bg-opacity: 1;\n  background-color: #81e6d9;\n  background-color: rgba(129, 230, 217, var(--bg-opacity));\n}\n\n.bg-teal-400 {\n  --bg-opacity: 1;\n  background-color: #4fd1c5;\n  background-color: rgba(79, 209, 197, var(--bg-opacity));\n}\n\n.bg-teal-500 {\n  --bg-opacity: 1;\n  background-color: #38b2ac;\n  background-color: rgba(56, 178, 172, var(--bg-opacity));\n}\n\n.bg-teal-600 {\n  --bg-opacity: 1;\n  background-color: #319795;\n  background-color: rgba(49, 151, 149, var(--bg-opacity));\n}\n\n.bg-teal-700 {\n  --bg-opacity: 1;\n  background-color: #2c7a7b;\n  background-color: rgba(44, 122, 123, var(--bg-opacity));\n}\n\n.bg-teal-800 {\n  --bg-opacity: 1;\n  background-color: #285e61;\n  background-color: rgba(40, 94, 97, var(--bg-opacity));\n}\n\n.bg-teal-900 {\n  --bg-opacity: 1;\n  background-color: #234e52;\n  background-color: rgba(35, 78, 82, var(--bg-opacity));\n}\n\n.bg-blue-100 {\n  --bg-opacity: 1;\n  background-color: #ebf8ff;\n  background-color: rgba(235, 248, 255, var(--bg-opacity));\n}\n\n.bg-blue-200 {\n  --bg-opacity: 1;\n  background-color: #bee3f8;\n  background-color: rgba(190, 227, 248, var(--bg-opacity));\n}\n\n.bg-blue-300 {\n  --bg-opacity: 1;\n  background-color: #90cdf4;\n  background-color: rgba(144, 205, 244, var(--bg-opacity));\n}\n\n.bg-blue-400 {\n  --bg-opacity: 1;\n  background-color: #63b3ed;\n  background-color: rgba(99, 179, 237, var(--bg-opacity));\n}\n\n.bg-blue-500 {\n  --bg-opacity: 1;\n  background-color: #4299e1;\n  background-color: rgba(66, 153, 225, var(--bg-opacity));\n}\n\n.bg-blue-600 {\n  --bg-opacity: 1;\n  background-color: #3182ce;\n  background-color: rgba(49, 130, 206, var(--bg-opacity));\n}\n\n.bg-blue-700 {\n  --bg-opacity: 1;\n  background-color: #2b6cb0;\n  background-color: rgba(43, 108, 176, var(--bg-opacity));\n}\n\n.bg-blue-800 {\n  --bg-opacity: 1;\n  background-color: #2c5282;\n  background-color: rgba(44, 82, 130, var(--bg-opacity));\n}\n\n.bg-blue-900 {\n  --bg-opacity: 1;\n  background-color: #2a4365;\n  background-color: rgba(42, 67, 101, var(--bg-opacity));\n}\n\n.bg-indigo-100 {\n  --bg-opacity: 1;\n  background-color: #ebf4ff;\n  background-color: rgba(235, 244, 255, var(--bg-opacity));\n}\n\n.bg-indigo-200 {\n  --bg-opacity: 1;\n  background-color: #c3dafe;\n  background-color: rgba(195, 218, 254, var(--bg-opacity));\n}\n\n.bg-indigo-300 {\n  --bg-opacity: 1;\n  background-color: #a3bffa;\n  background-color: rgba(163, 191, 250, var(--bg-opacity));\n}\n\n.bg-indigo-400 {\n  --bg-opacity: 1;\n  background-color: #7f9cf5;\n  background-color: rgba(127, 156, 245, var(--bg-opacity));\n}\n\n.bg-indigo-500 {\n  --bg-opacity: 1;\n  background-color: #667eea;\n  background-color: rgba(102, 126, 234, var(--bg-opacity));\n}\n\n.bg-indigo-600 {\n  --bg-opacity: 1;\n  background-color: #5a67d8;\n  background-color: rgba(90, 103, 216, var(--bg-opacity));\n}\n\n.bg-indigo-700 {\n  --bg-opacity: 1;\n  background-color: #4c51bf;\n  background-color: rgba(76, 81, 191, var(--bg-opacity));\n}\n\n.bg-indigo-800 {\n  --bg-opacity: 1;\n  background-color: #434190;\n  background-color: rgba(67, 65, 144, var(--bg-opacity));\n}\n\n.bg-indigo-900 {\n  --bg-opacity: 1;\n  background-color: #3c366b;\n  background-color: rgba(60, 54, 107, var(--bg-opacity));\n}\n\n.bg-purple-100 {\n  --bg-opacity: 1;\n  background-color: #faf5ff;\n  background-color: rgba(250, 245, 255, var(--bg-opacity));\n}\n\n.bg-purple-200 {\n  --bg-opacity: 1;\n  background-color: #e9d8fd;\n  background-color: rgba(233, 216, 253, var(--bg-opacity));\n}\n\n.bg-purple-300 {\n  --bg-opacity: 1;\n  background-color: #d6bcfa;\n  background-color: rgba(214, 188, 250, var(--bg-opacity));\n}\n\n.bg-purple-400 {\n  --bg-opacity: 1;\n  background-color: #b794f4;\n  background-color: rgba(183, 148, 244, var(--bg-opacity));\n}\n\n.bg-purple-500 {\n  --bg-opacity: 1;\n  background-color: #9f7aea;\n  background-color: rgba(159, 122, 234, var(--bg-opacity));\n}\n\n.bg-purple-600 {\n  --bg-opacity: 1;\n  background-color: #805ad5;\n  background-color: rgba(128, 90, 213, var(--bg-opacity));\n}\n\n.bg-purple-700 {\n  --bg-opacity: 1;\n  background-color: #6b46c1;\n  background-color: rgba(107, 70, 193, var(--bg-opacity));\n}\n\n.bg-purple-800 {\n  --bg-opacity: 1;\n  background-color: #553c9a;\n  background-color: rgba(85, 60, 154, var(--bg-opacity));\n}\n\n.bg-purple-900 {\n  --bg-opacity: 1;\n  background-color: #44337a;\n  background-color: rgba(68, 51, 122, var(--bg-opacity));\n}\n\n.bg-pink-100 {\n  --bg-opacity: 1;\n  background-color: #fff5f7;\n  background-color: rgba(255, 245, 247, var(--bg-opacity));\n}\n\n.bg-pink-200 {\n  --bg-opacity: 1;\n  background-color: #fed7e2;\n  background-color: rgba(254, 215, 226, var(--bg-opacity));\n}\n\n.bg-pink-300 {\n  --bg-opacity: 1;\n  background-color: #fbb6ce;\n  background-color: rgba(251, 182, 206, var(--bg-opacity));\n}\n\n.bg-pink-400 {\n  --bg-opacity: 1;\n  background-color: #f687b3;\n  background-color: rgba(246, 135, 179, var(--bg-opacity));\n}\n\n.bg-pink-500 {\n  --bg-opacity: 1;\n  background-color: #ed64a6;\n  background-color: rgba(237, 100, 166, var(--bg-opacity));\n}\n\n.bg-pink-600 {\n  --bg-opacity: 1;\n  background-color: #d53f8c;\n  background-color: rgba(213, 63, 140, var(--bg-opacity));\n}\n\n.bg-pink-700 {\n  --bg-opacity: 1;\n  background-color: #b83280;\n  background-color: rgba(184, 50, 128, var(--bg-opacity));\n}\n\n.bg-pink-800 {\n  --bg-opacity: 1;\n  background-color: #97266d;\n  background-color: rgba(151, 38, 109, var(--bg-opacity));\n}\n\n.bg-pink-900 {\n  --bg-opacity: 1;\n  background-color: #702459;\n  background-color: rgba(112, 36, 89, var(--bg-opacity));\n}\n\n.hover\\:bg-transparent:hover {\n  background-color: transparent;\n}\n\n.hover\\:bg-current:hover {\n  background-color: currentColor;\n}\n\n.hover\\:bg-black:hover {\n  --bg-opacity: 1;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n\n.hover\\:bg-white:hover {\n  --bg-opacity: 1;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-100:hover {\n  --bg-opacity: 1;\n  background-color: #f7fafc;\n  background-color: rgba(247, 250, 252, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-200:hover {\n  --bg-opacity: 1;\n  background-color: #edf2f7;\n  background-color: rgba(237, 242, 247, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-300:hover {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-400:hover {\n  --bg-opacity: 1;\n  background-color: #cbd5e0;\n  background-color: rgba(203, 213, 224, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-500:hover {\n  --bg-opacity: 1;\n  background-color: #a0aec0;\n  background-color: rgba(160, 174, 192, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-600:hover {\n  --bg-opacity: 1;\n  background-color: #718096;\n  background-color: rgba(113, 128, 150, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-700:hover {\n  --bg-opacity: 1;\n  background-color: #4a5568;\n  background-color: rgba(74, 85, 104, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-800:hover {\n  --bg-opacity: 1;\n  background-color: #2d3748;\n  background-color: rgba(45, 55, 72, var(--bg-opacity));\n}\n\n.hover\\:bg-gray-900:hover {\n  --bg-opacity: 1;\n  background-color: #1a202c;\n  background-color: rgba(26, 32, 44, var(--bg-opacity));\n}\n\n.hover\\:bg-red-100:hover {\n  --bg-opacity: 1;\n  background-color: #fff5f5;\n  background-color: rgba(255, 245, 245, var(--bg-opacity));\n}\n\n.hover\\:bg-red-200:hover {\n  --bg-opacity: 1;\n  background-color: #fed7d7;\n  background-color: rgba(254, 215, 215, var(--bg-opacity));\n}\n\n.hover\\:bg-red-300:hover {\n  --bg-opacity: 1;\n  background-color: #feb2b2;\n  background-color: rgba(254, 178, 178, var(--bg-opacity));\n}\n\n.hover\\:bg-red-400:hover {\n  --bg-opacity: 1;\n  background-color: #fc8181;\n  background-color: rgba(252, 129, 129, var(--bg-opacity));\n}\n\n.hover\\:bg-red-500:hover {\n  --bg-opacity: 1;\n  background-color: #f56565;\n  background-color: rgba(245, 101, 101, var(--bg-opacity));\n}\n\n.hover\\:bg-red-600:hover {\n  --bg-opacity: 1;\n  background-color: #e53e3e;\n  background-color: rgba(229, 62, 62, var(--bg-opacity));\n}\n\n.hover\\:bg-red-700:hover {\n  --bg-opacity: 1;\n  background-color: #c53030;\n  background-color: rgba(197, 48, 48, var(--bg-opacity));\n}\n\n.hover\\:bg-red-800:hover {\n  --bg-opacity: 1;\n  background-color: #9b2c2c;\n  background-color: rgba(155, 44, 44, var(--bg-opacity));\n}\n\n.hover\\:bg-red-900:hover {\n  --bg-opacity: 1;\n  background-color: #742a2a;\n  background-color: rgba(116, 42, 42, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-100:hover {\n  --bg-opacity: 1;\n  background-color: #fffaf0;\n  background-color: rgba(255, 250, 240, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-200:hover {\n  --bg-opacity: 1;\n  background-color: #feebc8;\n  background-color: rgba(254, 235, 200, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-300:hover {\n  --bg-opacity: 1;\n  background-color: #fbd38d;\n  background-color: rgba(251, 211, 141, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-400:hover {\n  --bg-opacity: 1;\n  background-color: #f6ad55;\n  background-color: rgba(246, 173, 85, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-500:hover {\n  --bg-opacity: 1;\n  background-color: #ed8936;\n  background-color: rgba(237, 137, 54, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-600:hover {\n  --bg-opacity: 1;\n  background-color: #dd6b20;\n  background-color: rgba(221, 107, 32, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-700:hover {\n  --bg-opacity: 1;\n  background-color: #c05621;\n  background-color: rgba(192, 86, 33, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-800:hover {\n  --bg-opacity: 1;\n  background-color: #9c4221;\n  background-color: rgba(156, 66, 33, var(--bg-opacity));\n}\n\n.hover\\:bg-orange-900:hover {\n  --bg-opacity: 1;\n  background-color: #7b341e;\n  background-color: rgba(123, 52, 30, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-100:hover {\n  --bg-opacity: 1;\n  background-color: #fffff0;\n  background-color: rgba(255, 255, 240, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-200:hover {\n  --bg-opacity: 1;\n  background-color: #fefcbf;\n  background-color: rgba(254, 252, 191, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-300:hover {\n  --bg-opacity: 1;\n  background-color: #faf089;\n  background-color: rgba(250, 240, 137, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-400:hover {\n  --bg-opacity: 1;\n  background-color: #f6e05e;\n  background-color: rgba(246, 224, 94, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-500:hover {\n  --bg-opacity: 1;\n  background-color: #ecc94b;\n  background-color: rgba(236, 201, 75, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-600:hover {\n  --bg-opacity: 1;\n  background-color: #d69e2e;\n  background-color: rgba(214, 158, 46, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-700:hover {\n  --bg-opacity: 1;\n  background-color: #b7791f;\n  background-color: rgba(183, 121, 31, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-800:hover {\n  --bg-opacity: 1;\n  background-color: #975a16;\n  background-color: rgba(151, 90, 22, var(--bg-opacity));\n}\n\n.hover\\:bg-yellow-900:hover {\n  --bg-opacity: 1;\n  background-color: #744210;\n  background-color: rgba(116, 66, 16, var(--bg-opacity));\n}\n\n.hover\\:bg-green-100:hover {\n  --bg-opacity: 1;\n  background-color: #f0fff4;\n  background-color: rgba(240, 255, 244, var(--bg-opacity));\n}\n\n.hover\\:bg-green-200:hover {\n  --bg-opacity: 1;\n  background-color: #c6f6d5;\n  background-color: rgba(198, 246, 213, var(--bg-opacity));\n}\n\n.hover\\:bg-green-300:hover {\n  --bg-opacity: 1;\n  background-color: #9ae6b4;\n  background-color: rgba(154, 230, 180, var(--bg-opacity));\n}\n\n.hover\\:bg-green-400:hover {\n  --bg-opacity: 1;\n  background-color: #68d391;\n  background-color: rgba(104, 211, 145, var(--bg-opacity));\n}\n\n.hover\\:bg-green-500:hover {\n  --bg-opacity: 1;\n  background-color: #48bb78;\n  background-color: rgba(72, 187, 120, var(--bg-opacity));\n}\n\n.hover\\:bg-green-600:hover {\n  --bg-opacity: 1;\n  background-color: #38a169;\n  background-color: rgba(56, 161, 105, var(--bg-opacity));\n}\n\n.hover\\:bg-green-700:hover {\n  --bg-opacity: 1;\n  background-color: #2f855a;\n  background-color: rgba(47, 133, 90, var(--bg-opacity));\n}\n\n.hover\\:bg-green-800:hover {\n  --bg-opacity: 1;\n  background-color: #276749;\n  background-color: rgba(39, 103, 73, var(--bg-opacity));\n}\n\n.hover\\:bg-green-900:hover {\n  --bg-opacity: 1;\n  background-color: #22543d;\n  background-color: rgba(34, 84, 61, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-100:hover {\n  --bg-opacity: 1;\n  background-color: #e6fffa;\n  background-color: rgba(230, 255, 250, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-200:hover {\n  --bg-opacity: 1;\n  background-color: #b2f5ea;\n  background-color: rgba(178, 245, 234, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-300:hover {\n  --bg-opacity: 1;\n  background-color: #81e6d9;\n  background-color: rgba(129, 230, 217, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-400:hover {\n  --bg-opacity: 1;\n  background-color: #4fd1c5;\n  background-color: rgba(79, 209, 197, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-500:hover {\n  --bg-opacity: 1;\n  background-color: #38b2ac;\n  background-color: rgba(56, 178, 172, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-600:hover {\n  --bg-opacity: 1;\n  background-color: #319795;\n  background-color: rgba(49, 151, 149, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-700:hover {\n  --bg-opacity: 1;\n  background-color: #2c7a7b;\n  background-color: rgba(44, 122, 123, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-800:hover {\n  --bg-opacity: 1;\n  background-color: #285e61;\n  background-color: rgba(40, 94, 97, var(--bg-opacity));\n}\n\n.hover\\:bg-teal-900:hover {\n  --bg-opacity: 1;\n  background-color: #234e52;\n  background-color: rgba(35, 78, 82, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-100:hover {\n  --bg-opacity: 1;\n  background-color: #ebf8ff;\n  background-color: rgba(235, 248, 255, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-200:hover {\n  --bg-opacity: 1;\n  background-color: #bee3f8;\n  background-color: rgba(190, 227, 248, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-300:hover {\n  --bg-opacity: 1;\n  background-color: #90cdf4;\n  background-color: rgba(144, 205, 244, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-400:hover {\n  --bg-opacity: 1;\n  background-color: #63b3ed;\n  background-color: rgba(99, 179, 237, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-500:hover {\n  --bg-opacity: 1;\n  background-color: #4299e1;\n  background-color: rgba(66, 153, 225, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-600:hover {\n  --bg-opacity: 1;\n  background-color: #3182ce;\n  background-color: rgba(49, 130, 206, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-700:hover {\n  --bg-opacity: 1;\n  background-color: #2b6cb0;\n  background-color: rgba(43, 108, 176, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-800:hover {\n  --bg-opacity: 1;\n  background-color: #2c5282;\n  background-color: rgba(44, 82, 130, var(--bg-opacity));\n}\n\n.hover\\:bg-blue-900:hover {\n  --bg-opacity: 1;\n  background-color: #2a4365;\n  background-color: rgba(42, 67, 101, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-100:hover {\n  --bg-opacity: 1;\n  background-color: #ebf4ff;\n  background-color: rgba(235, 244, 255, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-200:hover {\n  --bg-opacity: 1;\n  background-color: #c3dafe;\n  background-color: rgba(195, 218, 254, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-300:hover {\n  --bg-opacity: 1;\n  background-color: #a3bffa;\n  background-color: rgba(163, 191, 250, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-400:hover {\n  --bg-opacity: 1;\n  background-color: #7f9cf5;\n  background-color: rgba(127, 156, 245, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-500:hover {\n  --bg-opacity: 1;\n  background-color: #667eea;\n  background-color: rgba(102, 126, 234, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-600:hover {\n  --bg-opacity: 1;\n  background-color: #5a67d8;\n  background-color: rgba(90, 103, 216, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-700:hover {\n  --bg-opacity: 1;\n  background-color: #4c51bf;\n  background-color: rgba(76, 81, 191, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-800:hover {\n  --bg-opacity: 1;\n  background-color: #434190;\n  background-color: rgba(67, 65, 144, var(--bg-opacity));\n}\n\n.hover\\:bg-indigo-900:hover {\n  --bg-opacity: 1;\n  background-color: #3c366b;\n  background-color: rgba(60, 54, 107, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-100:hover {\n  --bg-opacity: 1;\n  background-color: #faf5ff;\n  background-color: rgba(250, 245, 255, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-200:hover {\n  --bg-opacity: 1;\n  background-color: #e9d8fd;\n  background-color: rgba(233, 216, 253, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-300:hover {\n  --bg-opacity: 1;\n  background-color: #d6bcfa;\n  background-color: rgba(214, 188, 250, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-400:hover {\n  --bg-opacity: 1;\n  background-color: #b794f4;\n  background-color: rgba(183, 148, 244, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-500:hover {\n  --bg-opacity: 1;\n  background-color: #9f7aea;\n  background-color: rgba(159, 122, 234, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-600:hover {\n  --bg-opacity: 1;\n  background-color: #805ad5;\n  background-color: rgba(128, 90, 213, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-700:hover {\n  --bg-opacity: 1;\n  background-color: #6b46c1;\n  background-color: rgba(107, 70, 193, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-800:hover {\n  --bg-opacity: 1;\n  background-color: #553c9a;\n  background-color: rgba(85, 60, 154, var(--bg-opacity));\n}\n\n.hover\\:bg-purple-900:hover {\n  --bg-opacity: 1;\n  background-color: #44337a;\n  background-color: rgba(68, 51, 122, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-100:hover {\n  --bg-opacity: 1;\n  background-color: #fff5f7;\n  background-color: rgba(255, 245, 247, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-200:hover {\n  --bg-opacity: 1;\n  background-color: #fed7e2;\n  background-color: rgba(254, 215, 226, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-300:hover {\n  --bg-opacity: 1;\n  background-color: #fbb6ce;\n  background-color: rgba(251, 182, 206, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-400:hover {\n  --bg-opacity: 1;\n  background-color: #f687b3;\n  background-color: rgba(246, 135, 179, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-500:hover {\n  --bg-opacity: 1;\n  background-color: #ed64a6;\n  background-color: rgba(237, 100, 166, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-600:hover {\n  --bg-opacity: 1;\n  background-color: #d53f8c;\n  background-color: rgba(213, 63, 140, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-700:hover {\n  --bg-opacity: 1;\n  background-color: #b83280;\n  background-color: rgba(184, 50, 128, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-800:hover {\n  --bg-opacity: 1;\n  background-color: #97266d;\n  background-color: rgba(151, 38, 109, var(--bg-opacity));\n}\n\n.hover\\:bg-pink-900:hover {\n  --bg-opacity: 1;\n  background-color: #702459;\n  background-color: rgba(112, 36, 89, var(--bg-opacity));\n}\n\n.focus\\:bg-transparent:focus {\n  background-color: transparent;\n}\n\n.focus\\:bg-current:focus {\n  background-color: currentColor;\n}\n\n.focus\\:bg-black:focus {\n  --bg-opacity: 1;\n  background-color: #000;\n  background-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n\n.focus\\:bg-white:focus {\n  --bg-opacity: 1;\n  background-color: #fff;\n  background-color: rgba(255, 255, 255, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-100:focus {\n  --bg-opacity: 1;\n  background-color: #f7fafc;\n  background-color: rgba(247, 250, 252, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-200:focus {\n  --bg-opacity: 1;\n  background-color: #edf2f7;\n  background-color: rgba(237, 242, 247, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-300:focus {\n  --bg-opacity: 1;\n  background-color: #e2e8f0;\n  background-color: rgba(226, 232, 240, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-400:focus {\n  --bg-opacity: 1;\n  background-color: #cbd5e0;\n  background-color: rgba(203, 213, 224, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-500:focus {\n  --bg-opacity: 1;\n  background-color: #a0aec0;\n  background-color: rgba(160, 174, 192, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-600:focus {\n  --bg-opacity: 1;\n  background-color: #718096;\n  background-color: rgba(113, 128, 150, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-700:focus {\n  --bg-opacity: 1;\n  background-color: #4a5568;\n  background-color: rgba(74, 85, 104, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-800:focus {\n  --bg-opacity: 1;\n  background-color: #2d3748;\n  background-color: rgba(45, 55, 72, var(--bg-opacity));\n}\n\n.focus\\:bg-gray-900:focus {\n  --bg-opacity: 1;\n  background-color: #1a202c;\n  background-color: rgba(26, 32, 44, var(--bg-opacity));\n}\n\n.focus\\:bg-red-100:focus {\n  --bg-opacity: 1;\n  background-color: #fff5f5;\n  background-color: rgba(255, 245, 245, var(--bg-opacity));\n}\n\n.focus\\:bg-red-200:focus {\n  --bg-opacity: 1;\n  background-color: #fed7d7;\n  background-color: rgba(254, 215, 215, var(--bg-opacity));\n}\n\n.focus\\:bg-red-300:focus {\n  --bg-opacity: 1;\n  background-color: #feb2b2;\n  background-color: rgba(254, 178, 178, var(--bg-opacity));\n}\n\n.focus\\:bg-red-400:focus {\n  --bg-opacity: 1;\n  background-color: #fc8181;\n  background-color: rgba(252, 129, 129, var(--bg-opacity));\n}\n\n.focus\\:bg-red-500:focus {\n  --bg-opacity: 1;\n  background-color: #f56565;\n  background-color: rgba(245, 101, 101, var(--bg-opacity));\n}\n\n.focus\\:bg-red-600:focus {\n  --bg-opacity: 1;\n  background-color: #e53e3e;\n  background-color: rgba(229, 62, 62, var(--bg-opacity));\n}\n\n.focus\\:bg-red-700:focus {\n  --bg-opacity: 1;\n  background-color: #c53030;\n  background-color: rgba(197, 48, 48, var(--bg-opacity));\n}\n\n.focus\\:bg-red-800:focus {\n  --bg-opacity: 1;\n  background-color: #9b2c2c;\n  background-color: rgba(155, 44, 44, var(--bg-opacity));\n}\n\n.focus\\:bg-red-900:focus {\n  --bg-opacity: 1;\n  background-color: #742a2a;\n  background-color: rgba(116, 42, 42, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-100:focus {\n  --bg-opacity: 1;\n  background-color: #fffaf0;\n  background-color: rgba(255, 250, 240, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-200:focus {\n  --bg-opacity: 1;\n  background-color: #feebc8;\n  background-color: rgba(254, 235, 200, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-300:focus {\n  --bg-opacity: 1;\n  background-color: #fbd38d;\n  background-color: rgba(251, 211, 141, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-400:focus {\n  --bg-opacity: 1;\n  background-color: #f6ad55;\n  background-color: rgba(246, 173, 85, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-500:focus {\n  --bg-opacity: 1;\n  background-color: #ed8936;\n  background-color: rgba(237, 137, 54, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-600:focus {\n  --bg-opacity: 1;\n  background-color: #dd6b20;\n  background-color: rgba(221, 107, 32, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-700:focus {\n  --bg-opacity: 1;\n  background-color: #c05621;\n  background-color: rgba(192, 86, 33, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-800:focus {\n  --bg-opacity: 1;\n  background-color: #9c4221;\n  background-color: rgba(156, 66, 33, var(--bg-opacity));\n}\n\n.focus\\:bg-orange-900:focus {\n  --bg-opacity: 1;\n  background-color: #7b341e;\n  background-color: rgba(123, 52, 30, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-100:focus {\n  --bg-opacity: 1;\n  background-color: #fffff0;\n  background-color: rgba(255, 255, 240, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-200:focus {\n  --bg-opacity: 1;\n  background-color: #fefcbf;\n  background-color: rgba(254, 252, 191, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-300:focus {\n  --bg-opacity: 1;\n  background-color: #faf089;\n  background-color: rgba(250, 240, 137, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-400:focus {\n  --bg-opacity: 1;\n  background-color: #f6e05e;\n  background-color: rgba(246, 224, 94, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-500:focus {\n  --bg-opacity: 1;\n  background-color: #ecc94b;\n  background-color: rgba(236, 201, 75, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-600:focus {\n  --bg-opacity: 1;\n  background-color: #d69e2e;\n  background-color: rgba(214, 158, 46, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-700:focus {\n  --bg-opacity: 1;\n  background-color: #b7791f;\n  background-color: rgba(183, 121, 31, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-800:focus {\n  --bg-opacity: 1;\n  background-color: #975a16;\n  background-color: rgba(151, 90, 22, var(--bg-opacity));\n}\n\n.focus\\:bg-yellow-900:focus {\n  --bg-opacity: 1;\n  background-color: #744210;\n  background-color: rgba(116, 66, 16, var(--bg-opacity));\n}\n\n.focus\\:bg-green-100:focus {\n  --bg-opacity: 1;\n  background-color: #f0fff4;\n  background-color: rgba(240, 255, 244, var(--bg-opacity));\n}\n\n.focus\\:bg-green-200:focus {\n  --bg-opacity: 1;\n  background-color: #c6f6d5;\n  background-color: rgba(198, 246, 213, var(--bg-opacity));\n}\n\n.focus\\:bg-green-300:focus {\n  --bg-opacity: 1;\n  background-color: #9ae6b4;\n  background-color: rgba(154, 230, 180, var(--bg-opacity));\n}\n\n.focus\\:bg-green-400:focus {\n  --bg-opacity: 1;\n  background-color: #68d391;\n  background-color: rgba(104, 211, 145, var(--bg-opacity));\n}\n\n.focus\\:bg-green-500:focus {\n  --bg-opacity: 1;\n  background-color: #48bb78;\n  background-color: rgba(72, 187, 120, var(--bg-opacity));\n}\n\n.focus\\:bg-green-600:focus {\n  --bg-opacity: 1;\n  background-color: #38a169;\n  background-color: rgba(56, 161, 105, var(--bg-opacity));\n}\n\n.focus\\:bg-green-700:focus {\n  --bg-opacity: 1;\n  background-color: #2f855a;\n  background-color: rgba(47, 133, 90, var(--bg-opacity));\n}\n\n.focus\\:bg-green-800:focus {\n  --bg-opacity: 1;\n  background-color: #276749;\n  background-color: rgba(39, 103, 73, var(--bg-opacity));\n}\n\n.focus\\:bg-green-900:focus {\n  --bg-opacity: 1;\n  background-color: #22543d;\n  background-color: rgba(34, 84, 61, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-100:focus {\n  --bg-opacity: 1;\n  background-color: #e6fffa;\n  background-color: rgba(230, 255, 250, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-200:focus {\n  --bg-opacity: 1;\n  background-color: #b2f5ea;\n  background-color: rgba(178, 245, 234, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-300:focus {\n  --bg-opacity: 1;\n  background-color: #81e6d9;\n  background-color: rgba(129, 230, 217, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-400:focus {\n  --bg-opacity: 1;\n  background-color: #4fd1c5;\n  background-color: rgba(79, 209, 197, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-500:focus {\n  --bg-opacity: 1;\n  background-color: #38b2ac;\n  background-color: rgba(56, 178, 172, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-600:focus {\n  --bg-opacity: 1;\n  background-color: #319795;\n  background-color: rgba(49, 151, 149, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-700:focus {\n  --bg-opacity: 1;\n  background-color: #2c7a7b;\n  background-color: rgba(44, 122, 123, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-800:focus {\n  --bg-opacity: 1;\n  background-color: #285e61;\n  background-color: rgba(40, 94, 97, var(--bg-opacity));\n}\n\n.focus\\:bg-teal-900:focus {\n  --bg-opacity: 1;\n  background-color: #234e52;\n  background-color: rgba(35, 78, 82, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-100:focus {\n  --bg-opacity: 1;\n  background-color: #ebf8ff;\n  background-color: rgba(235, 248, 255, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-200:focus {\n  --bg-opacity: 1;\n  background-color: #bee3f8;\n  background-color: rgba(190, 227, 248, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-300:focus {\n  --bg-opacity: 1;\n  background-color: #90cdf4;\n  background-color: rgba(144, 205, 244, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-400:focus {\n  --bg-opacity: 1;\n  background-color: #63b3ed;\n  background-color: rgba(99, 179, 237, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-500:focus {\n  --bg-opacity: 1;\n  background-color: #4299e1;\n  background-color: rgba(66, 153, 225, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-600:focus {\n  --bg-opacity: 1;\n  background-color: #3182ce;\n  background-color: rgba(49, 130, 206, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-700:focus {\n  --bg-opacity: 1;\n  background-color: #2b6cb0;\n  background-color: rgba(43, 108, 176, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-800:focus {\n  --bg-opacity: 1;\n  background-color: #2c5282;\n  background-color: rgba(44, 82, 130, var(--bg-opacity));\n}\n\n.focus\\:bg-blue-900:focus {\n  --bg-opacity: 1;\n  background-color: #2a4365;\n  background-color: rgba(42, 67, 101, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-100:focus {\n  --bg-opacity: 1;\n  background-color: #ebf4ff;\n  background-color: rgba(235, 244, 255, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-200:focus {\n  --bg-opacity: 1;\n  background-color: #c3dafe;\n  background-color: rgba(195, 218, 254, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-300:focus {\n  --bg-opacity: 1;\n  background-color: #a3bffa;\n  background-color: rgba(163, 191, 250, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-400:focus {\n  --bg-opacity: 1;\n  background-color: #7f9cf5;\n  background-color: rgba(127, 156, 245, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-500:focus {\n  --bg-opacity: 1;\n  background-color: #667eea;\n  background-color: rgba(102, 126, 234, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-600:focus {\n  --bg-opacity: 1;\n  background-color: #5a67d8;\n  background-color: rgba(90, 103, 216, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-700:focus {\n  --bg-opacity: 1;\n  background-color: #4c51bf;\n  background-color: rgba(76, 81, 191, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-800:focus {\n  --bg-opacity: 1;\n  background-color: #434190;\n  background-color: rgba(67, 65, 144, var(--bg-opacity));\n}\n\n.focus\\:bg-indigo-900:focus {\n  --bg-opacity: 1;\n  background-color: #3c366b;\n  background-color: rgba(60, 54, 107, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-100:focus {\n  --bg-opacity: 1;\n  background-color: #faf5ff;\n  background-color: rgba(250, 245, 255, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-200:focus {\n  --bg-opacity: 1;\n  background-color: #e9d8fd;\n  background-color: rgba(233, 216, 253, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-300:focus {\n  --bg-opacity: 1;\n  background-color: #d6bcfa;\n  background-color: rgba(214, 188, 250, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-400:focus {\n  --bg-opacity: 1;\n  background-color: #b794f4;\n  background-color: rgba(183, 148, 244, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-500:focus {\n  --bg-opacity: 1;\n  background-color: #9f7aea;\n  background-color: rgba(159, 122, 234, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-600:focus {\n  --bg-opacity: 1;\n  background-color: #805ad5;\n  background-color: rgba(128, 90, 213, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-700:focus {\n  --bg-opacity: 1;\n  background-color: #6b46c1;\n  background-color: rgba(107, 70, 193, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-800:focus {\n  --bg-opacity: 1;\n  background-color: #553c9a;\n  background-color: rgba(85, 60, 154, var(--bg-opacity));\n}\n\n.focus\\:bg-purple-900:focus {\n  --bg-opacity: 1;\n  background-color: #44337a;\n  background-color: rgba(68, 51, 122, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-100:focus {\n  --bg-opacity: 1;\n  background-color: #fff5f7;\n  background-color: rgba(255, 245, 247, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-200:focus {\n  --bg-opacity: 1;\n  background-color: #fed7e2;\n  background-color: rgba(254, 215, 226, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-300:focus {\n  --bg-opacity: 1;\n  background-color: #fbb6ce;\n  background-color: rgba(251, 182, 206, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-400:focus {\n  --bg-opacity: 1;\n  background-color: #f687b3;\n  background-color: rgba(246, 135, 179, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-500:focus {\n  --bg-opacity: 1;\n  background-color: #ed64a6;\n  background-color: rgba(237, 100, 166, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-600:focus {\n  --bg-opacity: 1;\n  background-color: #d53f8c;\n  background-color: rgba(213, 63, 140, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-700:focus {\n  --bg-opacity: 1;\n  background-color: #b83280;\n  background-color: rgba(184, 50, 128, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-800:focus {\n  --bg-opacity: 1;\n  background-color: #97266d;\n  background-color: rgba(151, 38, 109, var(--bg-opacity));\n}\n\n.focus\\:bg-pink-900:focus {\n  --bg-opacity: 1;\n  background-color: #702459;\n  background-color: rgba(112, 36, 89, var(--bg-opacity));\n}\n\n.bg-none {\n  background-image: none;\n}\n\n.bg-gradient-to-t {\n  background-image: linear-gradient(to top, var(--gradient-color-stops));\n}\n\n.bg-gradient-to-tr {\n  background-image: linear-gradient(to top right, var(--gradient-color-stops));\n}\n\n.bg-gradient-to-r {\n  background-image: linear-gradient(to right, var(--gradient-color-stops));\n}\n\n.bg-gradient-to-br {\n  background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n}\n\n.bg-gradient-to-b {\n  background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n}\n\n.bg-gradient-to-bl {\n  background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n}\n\n.bg-gradient-to-l {\n  background-image: linear-gradient(to left, var(--gradient-color-stops));\n}\n\n.bg-gradient-to-tl {\n  background-image: linear-gradient(to top left, var(--gradient-color-stops));\n}\n\n.from-transparent {\n  --gradient-from-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.from-current {\n  --gradient-from-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.from-black {\n  --gradient-from-color: #000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.from-white {\n  --gradient-from-color: #fff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.from-gray-100 {\n  --gradient-from-color: #f7fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n}\n\n.from-gray-200 {\n  --gradient-from-color: #edf2f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n}\n\n.from-gray-300 {\n  --gradient-from-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n\n.from-gray-400 {\n  --gradient-from-color: #cbd5e0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n}\n\n.from-gray-500 {\n  --gradient-from-color: #a0aec0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n}\n\n.from-gray-600 {\n  --gradient-from-color: #718096;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n}\n\n.from-gray-700 {\n  --gradient-from-color: #4a5568;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n}\n\n.from-gray-800 {\n  --gradient-from-color: #2d3748;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n}\n\n.from-gray-900 {\n  --gradient-from-color: #1a202c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n}\n\n.from-red-100 {\n  --gradient-from-color: #fff5f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n}\n\n.from-red-200 {\n  --gradient-from-color: #fed7d7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n}\n\n.from-red-300 {\n  --gradient-from-color: #feb2b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n}\n\n.from-red-400 {\n  --gradient-from-color: #fc8181;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n}\n\n.from-red-500 {\n  --gradient-from-color: #f56565;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n}\n\n.from-red-600 {\n  --gradient-from-color: #e53e3e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n}\n\n.from-red-700 {\n  --gradient-from-color: #c53030;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n}\n\n.from-red-800 {\n  --gradient-from-color: #9b2c2c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n}\n\n.from-red-900 {\n  --gradient-from-color: #742a2a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n}\n\n.from-orange-100 {\n  --gradient-from-color: #fffaf0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n}\n\n.from-orange-200 {\n  --gradient-from-color: #feebc8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n}\n\n.from-orange-300 {\n  --gradient-from-color: #fbd38d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n}\n\n.from-orange-400 {\n  --gradient-from-color: #f6ad55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n}\n\n.from-orange-500 {\n  --gradient-from-color: #ed8936;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n}\n\n.from-orange-600 {\n  --gradient-from-color: #dd6b20;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n}\n\n.from-orange-700 {\n  --gradient-from-color: #c05621;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n}\n\n.from-orange-800 {\n  --gradient-from-color: #9c4221;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n}\n\n.from-orange-900 {\n  --gradient-from-color: #7b341e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n}\n\n.from-yellow-100 {\n  --gradient-from-color: #fffff0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n}\n\n.from-yellow-200 {\n  --gradient-from-color: #fefcbf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n}\n\n.from-yellow-300 {\n  --gradient-from-color: #faf089;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n}\n\n.from-yellow-400 {\n  --gradient-from-color: #f6e05e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n}\n\n.from-yellow-500 {\n  --gradient-from-color: #ecc94b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n}\n\n.from-yellow-600 {\n  --gradient-from-color: #d69e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n}\n\n.from-yellow-700 {\n  --gradient-from-color: #b7791f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n}\n\n.from-yellow-800 {\n  --gradient-from-color: #975a16;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n}\n\n.from-yellow-900 {\n  --gradient-from-color: #744210;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n}\n\n.from-green-100 {\n  --gradient-from-color: #f0fff4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n}\n\n.from-green-200 {\n  --gradient-from-color: #c6f6d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n}\n\n.from-green-300 {\n  --gradient-from-color: #9ae6b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n}\n\n.from-green-400 {\n  --gradient-from-color: #68d391;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n}\n\n.from-green-500 {\n  --gradient-from-color: #48bb78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n}\n\n.from-green-600 {\n  --gradient-from-color: #38a169;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n}\n\n.from-green-700 {\n  --gradient-from-color: #2f855a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n}\n\n.from-green-800 {\n  --gradient-from-color: #276749;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n}\n\n.from-green-900 {\n  --gradient-from-color: #22543d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n}\n\n.from-teal-100 {\n  --gradient-from-color: #e6fffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n}\n\n.from-teal-200 {\n  --gradient-from-color: #b2f5ea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n}\n\n.from-teal-300 {\n  --gradient-from-color: #81e6d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n}\n\n.from-teal-400 {\n  --gradient-from-color: #4fd1c5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n}\n\n.from-teal-500 {\n  --gradient-from-color: #38b2ac;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n}\n\n.from-teal-600 {\n  --gradient-from-color: #319795;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n}\n\n.from-teal-700 {\n  --gradient-from-color: #2c7a7b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n}\n\n.from-teal-800 {\n  --gradient-from-color: #285e61;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n}\n\n.from-teal-900 {\n  --gradient-from-color: #234e52;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n}\n\n.from-blue-100 {\n  --gradient-from-color: #ebf8ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n}\n\n.from-blue-200 {\n  --gradient-from-color: #bee3f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n}\n\n.from-blue-300 {\n  --gradient-from-color: #90cdf4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n}\n\n.from-blue-400 {\n  --gradient-from-color: #63b3ed;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n}\n\n.from-blue-500 {\n  --gradient-from-color: #4299e1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n}\n\n.from-blue-600 {\n  --gradient-from-color: #3182ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n}\n\n.from-blue-700 {\n  --gradient-from-color: #2b6cb0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n}\n\n.from-blue-800 {\n  --gradient-from-color: #2c5282;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n}\n\n.from-blue-900 {\n  --gradient-from-color: #2a4365;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n}\n\n.from-indigo-100 {\n  --gradient-from-color: #ebf4ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n}\n\n.from-indigo-200 {\n  --gradient-from-color: #c3dafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n}\n\n.from-indigo-300 {\n  --gradient-from-color: #a3bffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n}\n\n.from-indigo-400 {\n  --gradient-from-color: #7f9cf5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n}\n\n.from-indigo-500 {\n  --gradient-from-color: #667eea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n}\n\n.from-indigo-600 {\n  --gradient-from-color: #5a67d8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n}\n\n.from-indigo-700 {\n  --gradient-from-color: #4c51bf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n}\n\n.from-indigo-800 {\n  --gradient-from-color: #434190;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n}\n\n.from-indigo-900 {\n  --gradient-from-color: #3c366b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n}\n\n.from-purple-100 {\n  --gradient-from-color: #faf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n}\n\n.from-purple-200 {\n  --gradient-from-color: #e9d8fd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n}\n\n.from-purple-300 {\n  --gradient-from-color: #d6bcfa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n}\n\n.from-purple-400 {\n  --gradient-from-color: #b794f4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n}\n\n.from-purple-500 {\n  --gradient-from-color: #9f7aea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n}\n\n.from-purple-600 {\n  --gradient-from-color: #805ad5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n}\n\n.from-purple-700 {\n  --gradient-from-color: #6b46c1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n}\n\n.from-purple-800 {\n  --gradient-from-color: #553c9a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n}\n\n.from-purple-900 {\n  --gradient-from-color: #44337a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n}\n\n.from-pink-100 {\n  --gradient-from-color: #fff5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n}\n\n.from-pink-200 {\n  --gradient-from-color: #fed7e2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n}\n\n.from-pink-300 {\n  --gradient-from-color: #fbb6ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n}\n\n.from-pink-400 {\n  --gradient-from-color: #f687b3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n}\n\n.from-pink-500 {\n  --gradient-from-color: #ed64a6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n}\n\n.from-pink-600 {\n  --gradient-from-color: #d53f8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n}\n\n.from-pink-700 {\n  --gradient-from-color: #b83280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n}\n\n.from-pink-800 {\n  --gradient-from-color: #97266d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n}\n\n.from-pink-900 {\n  --gradient-from-color: #702459;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n}\n\n.via-transparent {\n  --gradient-via-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.via-current {\n  --gradient-via-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.via-black {\n  --gradient-via-color: #000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.via-white {\n  --gradient-via-color: #fff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.via-gray-100 {\n  --gradient-via-color: #f7fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n}\n\n.via-gray-200 {\n  --gradient-via-color: #edf2f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n}\n\n.via-gray-300 {\n  --gradient-via-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n\n.via-gray-400 {\n  --gradient-via-color: #cbd5e0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n}\n\n.via-gray-500 {\n  --gradient-via-color: #a0aec0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n}\n\n.via-gray-600 {\n  --gradient-via-color: #718096;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n}\n\n.via-gray-700 {\n  --gradient-via-color: #4a5568;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n}\n\n.via-gray-800 {\n  --gradient-via-color: #2d3748;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n}\n\n.via-gray-900 {\n  --gradient-via-color: #1a202c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n}\n\n.via-red-100 {\n  --gradient-via-color: #fff5f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n}\n\n.via-red-200 {\n  --gradient-via-color: #fed7d7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n}\n\n.via-red-300 {\n  --gradient-via-color: #feb2b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n}\n\n.via-red-400 {\n  --gradient-via-color: #fc8181;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n}\n\n.via-red-500 {\n  --gradient-via-color: #f56565;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n}\n\n.via-red-600 {\n  --gradient-via-color: #e53e3e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n}\n\n.via-red-700 {\n  --gradient-via-color: #c53030;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n}\n\n.via-red-800 {\n  --gradient-via-color: #9b2c2c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n}\n\n.via-red-900 {\n  --gradient-via-color: #742a2a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n}\n\n.via-orange-100 {\n  --gradient-via-color: #fffaf0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n}\n\n.via-orange-200 {\n  --gradient-via-color: #feebc8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n}\n\n.via-orange-300 {\n  --gradient-via-color: #fbd38d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n}\n\n.via-orange-400 {\n  --gradient-via-color: #f6ad55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n}\n\n.via-orange-500 {\n  --gradient-via-color: #ed8936;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n}\n\n.via-orange-600 {\n  --gradient-via-color: #dd6b20;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n}\n\n.via-orange-700 {\n  --gradient-via-color: #c05621;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n}\n\n.via-orange-800 {\n  --gradient-via-color: #9c4221;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n}\n\n.via-orange-900 {\n  --gradient-via-color: #7b341e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n}\n\n.via-yellow-100 {\n  --gradient-via-color: #fffff0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n}\n\n.via-yellow-200 {\n  --gradient-via-color: #fefcbf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n}\n\n.via-yellow-300 {\n  --gradient-via-color: #faf089;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n}\n\n.via-yellow-400 {\n  --gradient-via-color: #f6e05e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n}\n\n.via-yellow-500 {\n  --gradient-via-color: #ecc94b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n}\n\n.via-yellow-600 {\n  --gradient-via-color: #d69e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n}\n\n.via-yellow-700 {\n  --gradient-via-color: #b7791f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n}\n\n.via-yellow-800 {\n  --gradient-via-color: #975a16;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n}\n\n.via-yellow-900 {\n  --gradient-via-color: #744210;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n}\n\n.via-green-100 {\n  --gradient-via-color: #f0fff4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n}\n\n.via-green-200 {\n  --gradient-via-color: #c6f6d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n}\n\n.via-green-300 {\n  --gradient-via-color: #9ae6b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n}\n\n.via-green-400 {\n  --gradient-via-color: #68d391;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n}\n\n.via-green-500 {\n  --gradient-via-color: #48bb78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n}\n\n.via-green-600 {\n  --gradient-via-color: #38a169;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n}\n\n.via-green-700 {\n  --gradient-via-color: #2f855a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n}\n\n.via-green-800 {\n  --gradient-via-color: #276749;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n}\n\n.via-green-900 {\n  --gradient-via-color: #22543d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n}\n\n.via-teal-100 {\n  --gradient-via-color: #e6fffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n}\n\n.via-teal-200 {\n  --gradient-via-color: #b2f5ea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n}\n\n.via-teal-300 {\n  --gradient-via-color: #81e6d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n}\n\n.via-teal-400 {\n  --gradient-via-color: #4fd1c5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n}\n\n.via-teal-500 {\n  --gradient-via-color: #38b2ac;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n}\n\n.via-teal-600 {\n  --gradient-via-color: #319795;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n}\n\n.via-teal-700 {\n  --gradient-via-color: #2c7a7b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n}\n\n.via-teal-800 {\n  --gradient-via-color: #285e61;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n}\n\n.via-teal-900 {\n  --gradient-via-color: #234e52;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n}\n\n.via-blue-100 {\n  --gradient-via-color: #ebf8ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n}\n\n.via-blue-200 {\n  --gradient-via-color: #bee3f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n}\n\n.via-blue-300 {\n  --gradient-via-color: #90cdf4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n}\n\n.via-blue-400 {\n  --gradient-via-color: #63b3ed;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n}\n\n.via-blue-500 {\n  --gradient-via-color: #4299e1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n}\n\n.via-blue-600 {\n  --gradient-via-color: #3182ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n}\n\n.via-blue-700 {\n  --gradient-via-color: #2b6cb0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n}\n\n.via-blue-800 {\n  --gradient-via-color: #2c5282;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n}\n\n.via-blue-900 {\n  --gradient-via-color: #2a4365;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n}\n\n.via-indigo-100 {\n  --gradient-via-color: #ebf4ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n}\n\n.via-indigo-200 {\n  --gradient-via-color: #c3dafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n}\n\n.via-indigo-300 {\n  --gradient-via-color: #a3bffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n}\n\n.via-indigo-400 {\n  --gradient-via-color: #7f9cf5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n}\n\n.via-indigo-500 {\n  --gradient-via-color: #667eea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n}\n\n.via-indigo-600 {\n  --gradient-via-color: #5a67d8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n}\n\n.via-indigo-700 {\n  --gradient-via-color: #4c51bf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n}\n\n.via-indigo-800 {\n  --gradient-via-color: #434190;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n}\n\n.via-indigo-900 {\n  --gradient-via-color: #3c366b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n}\n\n.via-purple-100 {\n  --gradient-via-color: #faf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n}\n\n.via-purple-200 {\n  --gradient-via-color: #e9d8fd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n}\n\n.via-purple-300 {\n  --gradient-via-color: #d6bcfa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n}\n\n.via-purple-400 {\n  --gradient-via-color: #b794f4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n}\n\n.via-purple-500 {\n  --gradient-via-color: #9f7aea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n}\n\n.via-purple-600 {\n  --gradient-via-color: #805ad5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n}\n\n.via-purple-700 {\n  --gradient-via-color: #6b46c1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n}\n\n.via-purple-800 {\n  --gradient-via-color: #553c9a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n}\n\n.via-purple-900 {\n  --gradient-via-color: #44337a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n}\n\n.via-pink-100 {\n  --gradient-via-color: #fff5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n}\n\n.via-pink-200 {\n  --gradient-via-color: #fed7e2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n}\n\n.via-pink-300 {\n  --gradient-via-color: #fbb6ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n}\n\n.via-pink-400 {\n  --gradient-via-color: #f687b3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n}\n\n.via-pink-500 {\n  --gradient-via-color: #ed64a6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n}\n\n.via-pink-600 {\n  --gradient-via-color: #d53f8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n}\n\n.via-pink-700 {\n  --gradient-via-color: #b83280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n}\n\n.via-pink-800 {\n  --gradient-via-color: #97266d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n}\n\n.via-pink-900 {\n  --gradient-via-color: #702459;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n}\n\n.to-transparent {\n  --gradient-to-color: transparent;\n}\n\n.to-current {\n  --gradient-to-color: currentColor;\n}\n\n.to-black {\n  --gradient-to-color: #000;\n}\n\n.to-white {\n  --gradient-to-color: #fff;\n}\n\n.to-gray-100 {\n  --gradient-to-color: #f7fafc;\n}\n\n.to-gray-200 {\n  --gradient-to-color: #edf2f7;\n}\n\n.to-gray-300 {\n  --gradient-to-color: #e2e8f0;\n}\n\n.to-gray-400 {\n  --gradient-to-color: #cbd5e0;\n}\n\n.to-gray-500 {\n  --gradient-to-color: #a0aec0;\n}\n\n.to-gray-600 {\n  --gradient-to-color: #718096;\n}\n\n.to-gray-700 {\n  --gradient-to-color: #4a5568;\n}\n\n.to-gray-800 {\n  --gradient-to-color: #2d3748;\n}\n\n.to-gray-900 {\n  --gradient-to-color: #1a202c;\n}\n\n.to-red-100 {\n  --gradient-to-color: #fff5f5;\n}\n\n.to-red-200 {\n  --gradient-to-color: #fed7d7;\n}\n\n.to-red-300 {\n  --gradient-to-color: #feb2b2;\n}\n\n.to-red-400 {\n  --gradient-to-color: #fc8181;\n}\n\n.to-red-500 {\n  --gradient-to-color: #f56565;\n}\n\n.to-red-600 {\n  --gradient-to-color: #e53e3e;\n}\n\n.to-red-700 {\n  --gradient-to-color: #c53030;\n}\n\n.to-red-800 {\n  --gradient-to-color: #9b2c2c;\n}\n\n.to-red-900 {\n  --gradient-to-color: #742a2a;\n}\n\n.to-orange-100 {\n  --gradient-to-color: #fffaf0;\n}\n\n.to-orange-200 {\n  --gradient-to-color: #feebc8;\n}\n\n.to-orange-300 {\n  --gradient-to-color: #fbd38d;\n}\n\n.to-orange-400 {\n  --gradient-to-color: #f6ad55;\n}\n\n.to-orange-500 {\n  --gradient-to-color: #ed8936;\n}\n\n.to-orange-600 {\n  --gradient-to-color: #dd6b20;\n}\n\n.to-orange-700 {\n  --gradient-to-color: #c05621;\n}\n\n.to-orange-800 {\n  --gradient-to-color: #9c4221;\n}\n\n.to-orange-900 {\n  --gradient-to-color: #7b341e;\n}\n\n.to-yellow-100 {\n  --gradient-to-color: #fffff0;\n}\n\n.to-yellow-200 {\n  --gradient-to-color: #fefcbf;\n}\n\n.to-yellow-300 {\n  --gradient-to-color: #faf089;\n}\n\n.to-yellow-400 {\n  --gradient-to-color: #f6e05e;\n}\n\n.to-yellow-500 {\n  --gradient-to-color: #ecc94b;\n}\n\n.to-yellow-600 {\n  --gradient-to-color: #d69e2e;\n}\n\n.to-yellow-700 {\n  --gradient-to-color: #b7791f;\n}\n\n.to-yellow-800 {\n  --gradient-to-color: #975a16;\n}\n\n.to-yellow-900 {\n  --gradient-to-color: #744210;\n}\n\n.to-green-100 {\n  --gradient-to-color: #f0fff4;\n}\n\n.to-green-200 {\n  --gradient-to-color: #c6f6d5;\n}\n\n.to-green-300 {\n  --gradient-to-color: #9ae6b4;\n}\n\n.to-green-400 {\n  --gradient-to-color: #68d391;\n}\n\n.to-green-500 {\n  --gradient-to-color: #48bb78;\n}\n\n.to-green-600 {\n  --gradient-to-color: #38a169;\n}\n\n.to-green-700 {\n  --gradient-to-color: #2f855a;\n}\n\n.to-green-800 {\n  --gradient-to-color: #276749;\n}\n\n.to-green-900 {\n  --gradient-to-color: #22543d;\n}\n\n.to-teal-100 {\n  --gradient-to-color: #e6fffa;\n}\n\n.to-teal-200 {\n  --gradient-to-color: #b2f5ea;\n}\n\n.to-teal-300 {\n  --gradient-to-color: #81e6d9;\n}\n\n.to-teal-400 {\n  --gradient-to-color: #4fd1c5;\n}\n\n.to-teal-500 {\n  --gradient-to-color: #38b2ac;\n}\n\n.to-teal-600 {\n  --gradient-to-color: #319795;\n}\n\n.to-teal-700 {\n  --gradient-to-color: #2c7a7b;\n}\n\n.to-teal-800 {\n  --gradient-to-color: #285e61;\n}\n\n.to-teal-900 {\n  --gradient-to-color: #234e52;\n}\n\n.to-blue-100 {\n  --gradient-to-color: #ebf8ff;\n}\n\n.to-blue-200 {\n  --gradient-to-color: #bee3f8;\n}\n\n.to-blue-300 {\n  --gradient-to-color: #90cdf4;\n}\n\n.to-blue-400 {\n  --gradient-to-color: #63b3ed;\n}\n\n.to-blue-500 {\n  --gradient-to-color: #4299e1;\n}\n\n.to-blue-600 {\n  --gradient-to-color: #3182ce;\n}\n\n.to-blue-700 {\n  --gradient-to-color: #2b6cb0;\n}\n\n.to-blue-800 {\n  --gradient-to-color: #2c5282;\n}\n\n.to-blue-900 {\n  --gradient-to-color: #2a4365;\n}\n\n.to-indigo-100 {\n  --gradient-to-color: #ebf4ff;\n}\n\n.to-indigo-200 {\n  --gradient-to-color: #c3dafe;\n}\n\n.to-indigo-300 {\n  --gradient-to-color: #a3bffa;\n}\n\n.to-indigo-400 {\n  --gradient-to-color: #7f9cf5;\n}\n\n.to-indigo-500 {\n  --gradient-to-color: #667eea;\n}\n\n.to-indigo-600 {\n  --gradient-to-color: #5a67d8;\n}\n\n.to-indigo-700 {\n  --gradient-to-color: #4c51bf;\n}\n\n.to-indigo-800 {\n  --gradient-to-color: #434190;\n}\n\n.to-indigo-900 {\n  --gradient-to-color: #3c366b;\n}\n\n.to-purple-100 {\n  --gradient-to-color: #faf5ff;\n}\n\n.to-purple-200 {\n  --gradient-to-color: #e9d8fd;\n}\n\n.to-purple-300 {\n  --gradient-to-color: #d6bcfa;\n}\n\n.to-purple-400 {\n  --gradient-to-color: #b794f4;\n}\n\n.to-purple-500 {\n  --gradient-to-color: #9f7aea;\n}\n\n.to-purple-600 {\n  --gradient-to-color: #805ad5;\n}\n\n.to-purple-700 {\n  --gradient-to-color: #6b46c1;\n}\n\n.to-purple-800 {\n  --gradient-to-color: #553c9a;\n}\n\n.to-purple-900 {\n  --gradient-to-color: #44337a;\n}\n\n.to-pink-100 {\n  --gradient-to-color: #fff5f7;\n}\n\n.to-pink-200 {\n  --gradient-to-color: #fed7e2;\n}\n\n.to-pink-300 {\n  --gradient-to-color: #fbb6ce;\n}\n\n.to-pink-400 {\n  --gradient-to-color: #f687b3;\n}\n\n.to-pink-500 {\n  --gradient-to-color: #ed64a6;\n}\n\n.to-pink-600 {\n  --gradient-to-color: #d53f8c;\n}\n\n.to-pink-700 {\n  --gradient-to-color: #b83280;\n}\n\n.to-pink-800 {\n  --gradient-to-color: #97266d;\n}\n\n.to-pink-900 {\n  --gradient-to-color: #702459;\n}\n\n.hover\\:from-transparent:hover {\n  --gradient-from-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.hover\\:from-current:hover {\n  --gradient-from-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.hover\\:from-black:hover {\n  --gradient-from-color: #000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.hover\\:from-white:hover {\n  --gradient-from-color: #fff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.hover\\:from-gray-100:hover {\n  --gradient-from-color: #f7fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n}\n\n.hover\\:from-gray-200:hover {\n  --gradient-from-color: #edf2f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n}\n\n.hover\\:from-gray-300:hover {\n  --gradient-from-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n\n.hover\\:from-gray-400:hover {\n  --gradient-from-color: #cbd5e0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n}\n\n.hover\\:from-gray-500:hover {\n  --gradient-from-color: #a0aec0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n}\n\n.hover\\:from-gray-600:hover {\n  --gradient-from-color: #718096;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n}\n\n.hover\\:from-gray-700:hover {\n  --gradient-from-color: #4a5568;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n}\n\n.hover\\:from-gray-800:hover {\n  --gradient-from-color: #2d3748;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n}\n\n.hover\\:from-gray-900:hover {\n  --gradient-from-color: #1a202c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n}\n\n.hover\\:from-red-100:hover {\n  --gradient-from-color: #fff5f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n}\n\n.hover\\:from-red-200:hover {\n  --gradient-from-color: #fed7d7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n}\n\n.hover\\:from-red-300:hover {\n  --gradient-from-color: #feb2b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n}\n\n.hover\\:from-red-400:hover {\n  --gradient-from-color: #fc8181;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n}\n\n.hover\\:from-red-500:hover {\n  --gradient-from-color: #f56565;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n}\n\n.hover\\:from-red-600:hover {\n  --gradient-from-color: #e53e3e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n}\n\n.hover\\:from-red-700:hover {\n  --gradient-from-color: #c53030;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n}\n\n.hover\\:from-red-800:hover {\n  --gradient-from-color: #9b2c2c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n}\n\n.hover\\:from-red-900:hover {\n  --gradient-from-color: #742a2a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n}\n\n.hover\\:from-orange-100:hover {\n  --gradient-from-color: #fffaf0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n}\n\n.hover\\:from-orange-200:hover {\n  --gradient-from-color: #feebc8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n}\n\n.hover\\:from-orange-300:hover {\n  --gradient-from-color: #fbd38d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n}\n\n.hover\\:from-orange-400:hover {\n  --gradient-from-color: #f6ad55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n}\n\n.hover\\:from-orange-500:hover {\n  --gradient-from-color: #ed8936;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n}\n\n.hover\\:from-orange-600:hover {\n  --gradient-from-color: #dd6b20;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n}\n\n.hover\\:from-orange-700:hover {\n  --gradient-from-color: #c05621;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n}\n\n.hover\\:from-orange-800:hover {\n  --gradient-from-color: #9c4221;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n}\n\n.hover\\:from-orange-900:hover {\n  --gradient-from-color: #7b341e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n}\n\n.hover\\:from-yellow-100:hover {\n  --gradient-from-color: #fffff0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n}\n\n.hover\\:from-yellow-200:hover {\n  --gradient-from-color: #fefcbf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n}\n\n.hover\\:from-yellow-300:hover {\n  --gradient-from-color: #faf089;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n}\n\n.hover\\:from-yellow-400:hover {\n  --gradient-from-color: #f6e05e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n}\n\n.hover\\:from-yellow-500:hover {\n  --gradient-from-color: #ecc94b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n}\n\n.hover\\:from-yellow-600:hover {\n  --gradient-from-color: #d69e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n}\n\n.hover\\:from-yellow-700:hover {\n  --gradient-from-color: #b7791f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n}\n\n.hover\\:from-yellow-800:hover {\n  --gradient-from-color: #975a16;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n}\n\n.hover\\:from-yellow-900:hover {\n  --gradient-from-color: #744210;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n}\n\n.hover\\:from-green-100:hover {\n  --gradient-from-color: #f0fff4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n}\n\n.hover\\:from-green-200:hover {\n  --gradient-from-color: #c6f6d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n}\n\n.hover\\:from-green-300:hover {\n  --gradient-from-color: #9ae6b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n}\n\n.hover\\:from-green-400:hover {\n  --gradient-from-color: #68d391;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n}\n\n.hover\\:from-green-500:hover {\n  --gradient-from-color: #48bb78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n}\n\n.hover\\:from-green-600:hover {\n  --gradient-from-color: #38a169;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n}\n\n.hover\\:from-green-700:hover {\n  --gradient-from-color: #2f855a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n}\n\n.hover\\:from-green-800:hover {\n  --gradient-from-color: #276749;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n}\n\n.hover\\:from-green-900:hover {\n  --gradient-from-color: #22543d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n}\n\n.hover\\:from-teal-100:hover {\n  --gradient-from-color: #e6fffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n}\n\n.hover\\:from-teal-200:hover {\n  --gradient-from-color: #b2f5ea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n}\n\n.hover\\:from-teal-300:hover {\n  --gradient-from-color: #81e6d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n}\n\n.hover\\:from-teal-400:hover {\n  --gradient-from-color: #4fd1c5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n}\n\n.hover\\:from-teal-500:hover {\n  --gradient-from-color: #38b2ac;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n}\n\n.hover\\:from-teal-600:hover {\n  --gradient-from-color: #319795;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n}\n\n.hover\\:from-teal-700:hover {\n  --gradient-from-color: #2c7a7b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n}\n\n.hover\\:from-teal-800:hover {\n  --gradient-from-color: #285e61;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n}\n\n.hover\\:from-teal-900:hover {\n  --gradient-from-color: #234e52;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n}\n\n.hover\\:from-blue-100:hover {\n  --gradient-from-color: #ebf8ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n}\n\n.hover\\:from-blue-200:hover {\n  --gradient-from-color: #bee3f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n}\n\n.hover\\:from-blue-300:hover {\n  --gradient-from-color: #90cdf4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n}\n\n.hover\\:from-blue-400:hover {\n  --gradient-from-color: #63b3ed;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n}\n\n.hover\\:from-blue-500:hover {\n  --gradient-from-color: #4299e1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n}\n\n.hover\\:from-blue-600:hover {\n  --gradient-from-color: #3182ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n}\n\n.hover\\:from-blue-700:hover {\n  --gradient-from-color: #2b6cb0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n}\n\n.hover\\:from-blue-800:hover {\n  --gradient-from-color: #2c5282;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n}\n\n.hover\\:from-blue-900:hover {\n  --gradient-from-color: #2a4365;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n}\n\n.hover\\:from-indigo-100:hover {\n  --gradient-from-color: #ebf4ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n}\n\n.hover\\:from-indigo-200:hover {\n  --gradient-from-color: #c3dafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n}\n\n.hover\\:from-indigo-300:hover {\n  --gradient-from-color: #a3bffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n}\n\n.hover\\:from-indigo-400:hover {\n  --gradient-from-color: #7f9cf5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n}\n\n.hover\\:from-indigo-500:hover {\n  --gradient-from-color: #667eea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n}\n\n.hover\\:from-indigo-600:hover {\n  --gradient-from-color: #5a67d8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n}\n\n.hover\\:from-indigo-700:hover {\n  --gradient-from-color: #4c51bf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n}\n\n.hover\\:from-indigo-800:hover {\n  --gradient-from-color: #434190;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n}\n\n.hover\\:from-indigo-900:hover {\n  --gradient-from-color: #3c366b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n}\n\n.hover\\:from-purple-100:hover {\n  --gradient-from-color: #faf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n}\n\n.hover\\:from-purple-200:hover {\n  --gradient-from-color: #e9d8fd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n}\n\n.hover\\:from-purple-300:hover {\n  --gradient-from-color: #d6bcfa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n}\n\n.hover\\:from-purple-400:hover {\n  --gradient-from-color: #b794f4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n}\n\n.hover\\:from-purple-500:hover {\n  --gradient-from-color: #9f7aea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n}\n\n.hover\\:from-purple-600:hover {\n  --gradient-from-color: #805ad5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n}\n\n.hover\\:from-purple-700:hover {\n  --gradient-from-color: #6b46c1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n}\n\n.hover\\:from-purple-800:hover {\n  --gradient-from-color: #553c9a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n}\n\n.hover\\:from-purple-900:hover {\n  --gradient-from-color: #44337a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n}\n\n.hover\\:from-pink-100:hover {\n  --gradient-from-color: #fff5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n}\n\n.hover\\:from-pink-200:hover {\n  --gradient-from-color: #fed7e2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n}\n\n.hover\\:from-pink-300:hover {\n  --gradient-from-color: #fbb6ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n}\n\n.hover\\:from-pink-400:hover {\n  --gradient-from-color: #f687b3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n}\n\n.hover\\:from-pink-500:hover {\n  --gradient-from-color: #ed64a6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n}\n\n.hover\\:from-pink-600:hover {\n  --gradient-from-color: #d53f8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n}\n\n.hover\\:from-pink-700:hover {\n  --gradient-from-color: #b83280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n}\n\n.hover\\:from-pink-800:hover {\n  --gradient-from-color: #97266d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n}\n\n.hover\\:from-pink-900:hover {\n  --gradient-from-color: #702459;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n}\n\n.hover\\:via-transparent:hover {\n  --gradient-via-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.hover\\:via-current:hover {\n  --gradient-via-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.hover\\:via-black:hover {\n  --gradient-via-color: #000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.hover\\:via-white:hover {\n  --gradient-via-color: #fff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.hover\\:via-gray-100:hover {\n  --gradient-via-color: #f7fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n}\n\n.hover\\:via-gray-200:hover {\n  --gradient-via-color: #edf2f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n}\n\n.hover\\:via-gray-300:hover {\n  --gradient-via-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n\n.hover\\:via-gray-400:hover {\n  --gradient-via-color: #cbd5e0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n}\n\n.hover\\:via-gray-500:hover {\n  --gradient-via-color: #a0aec0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n}\n\n.hover\\:via-gray-600:hover {\n  --gradient-via-color: #718096;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n}\n\n.hover\\:via-gray-700:hover {\n  --gradient-via-color: #4a5568;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n}\n\n.hover\\:via-gray-800:hover {\n  --gradient-via-color: #2d3748;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n}\n\n.hover\\:via-gray-900:hover {\n  --gradient-via-color: #1a202c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n}\n\n.hover\\:via-red-100:hover {\n  --gradient-via-color: #fff5f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n}\n\n.hover\\:via-red-200:hover {\n  --gradient-via-color: #fed7d7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n}\n\n.hover\\:via-red-300:hover {\n  --gradient-via-color: #feb2b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n}\n\n.hover\\:via-red-400:hover {\n  --gradient-via-color: #fc8181;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n}\n\n.hover\\:via-red-500:hover {\n  --gradient-via-color: #f56565;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n}\n\n.hover\\:via-red-600:hover {\n  --gradient-via-color: #e53e3e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n}\n\n.hover\\:via-red-700:hover {\n  --gradient-via-color: #c53030;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n}\n\n.hover\\:via-red-800:hover {\n  --gradient-via-color: #9b2c2c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n}\n\n.hover\\:via-red-900:hover {\n  --gradient-via-color: #742a2a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n}\n\n.hover\\:via-orange-100:hover {\n  --gradient-via-color: #fffaf0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n}\n\n.hover\\:via-orange-200:hover {\n  --gradient-via-color: #feebc8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n}\n\n.hover\\:via-orange-300:hover {\n  --gradient-via-color: #fbd38d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n}\n\n.hover\\:via-orange-400:hover {\n  --gradient-via-color: #f6ad55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n}\n\n.hover\\:via-orange-500:hover {\n  --gradient-via-color: #ed8936;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n}\n\n.hover\\:via-orange-600:hover {\n  --gradient-via-color: #dd6b20;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n}\n\n.hover\\:via-orange-700:hover {\n  --gradient-via-color: #c05621;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n}\n\n.hover\\:via-orange-800:hover {\n  --gradient-via-color: #9c4221;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n}\n\n.hover\\:via-orange-900:hover {\n  --gradient-via-color: #7b341e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n}\n\n.hover\\:via-yellow-100:hover {\n  --gradient-via-color: #fffff0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n}\n\n.hover\\:via-yellow-200:hover {\n  --gradient-via-color: #fefcbf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n}\n\n.hover\\:via-yellow-300:hover {\n  --gradient-via-color: #faf089;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n}\n\n.hover\\:via-yellow-400:hover {\n  --gradient-via-color: #f6e05e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n}\n\n.hover\\:via-yellow-500:hover {\n  --gradient-via-color: #ecc94b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n}\n\n.hover\\:via-yellow-600:hover {\n  --gradient-via-color: #d69e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n}\n\n.hover\\:via-yellow-700:hover {\n  --gradient-via-color: #b7791f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n}\n\n.hover\\:via-yellow-800:hover {\n  --gradient-via-color: #975a16;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n}\n\n.hover\\:via-yellow-900:hover {\n  --gradient-via-color: #744210;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n}\n\n.hover\\:via-green-100:hover {\n  --gradient-via-color: #f0fff4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n}\n\n.hover\\:via-green-200:hover {\n  --gradient-via-color: #c6f6d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n}\n\n.hover\\:via-green-300:hover {\n  --gradient-via-color: #9ae6b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n}\n\n.hover\\:via-green-400:hover {\n  --gradient-via-color: #68d391;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n}\n\n.hover\\:via-green-500:hover {\n  --gradient-via-color: #48bb78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n}\n\n.hover\\:via-green-600:hover {\n  --gradient-via-color: #38a169;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n}\n\n.hover\\:via-green-700:hover {\n  --gradient-via-color: #2f855a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n}\n\n.hover\\:via-green-800:hover {\n  --gradient-via-color: #276749;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n}\n\n.hover\\:via-green-900:hover {\n  --gradient-via-color: #22543d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n}\n\n.hover\\:via-teal-100:hover {\n  --gradient-via-color: #e6fffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n}\n\n.hover\\:via-teal-200:hover {\n  --gradient-via-color: #b2f5ea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n}\n\n.hover\\:via-teal-300:hover {\n  --gradient-via-color: #81e6d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n}\n\n.hover\\:via-teal-400:hover {\n  --gradient-via-color: #4fd1c5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n}\n\n.hover\\:via-teal-500:hover {\n  --gradient-via-color: #38b2ac;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n}\n\n.hover\\:via-teal-600:hover {\n  --gradient-via-color: #319795;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n}\n\n.hover\\:via-teal-700:hover {\n  --gradient-via-color: #2c7a7b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n}\n\n.hover\\:via-teal-800:hover {\n  --gradient-via-color: #285e61;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n}\n\n.hover\\:via-teal-900:hover {\n  --gradient-via-color: #234e52;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n}\n\n.hover\\:via-blue-100:hover {\n  --gradient-via-color: #ebf8ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n}\n\n.hover\\:via-blue-200:hover {\n  --gradient-via-color: #bee3f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n}\n\n.hover\\:via-blue-300:hover {\n  --gradient-via-color: #90cdf4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n}\n\n.hover\\:via-blue-400:hover {\n  --gradient-via-color: #63b3ed;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n}\n\n.hover\\:via-blue-500:hover {\n  --gradient-via-color: #4299e1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n}\n\n.hover\\:via-blue-600:hover {\n  --gradient-via-color: #3182ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n}\n\n.hover\\:via-blue-700:hover {\n  --gradient-via-color: #2b6cb0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n}\n\n.hover\\:via-blue-800:hover {\n  --gradient-via-color: #2c5282;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n}\n\n.hover\\:via-blue-900:hover {\n  --gradient-via-color: #2a4365;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n}\n\n.hover\\:via-indigo-100:hover {\n  --gradient-via-color: #ebf4ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n}\n\n.hover\\:via-indigo-200:hover {\n  --gradient-via-color: #c3dafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n}\n\n.hover\\:via-indigo-300:hover {\n  --gradient-via-color: #a3bffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n}\n\n.hover\\:via-indigo-400:hover {\n  --gradient-via-color: #7f9cf5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n}\n\n.hover\\:via-indigo-500:hover {\n  --gradient-via-color: #667eea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n}\n\n.hover\\:via-indigo-600:hover {\n  --gradient-via-color: #5a67d8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n}\n\n.hover\\:via-indigo-700:hover {\n  --gradient-via-color: #4c51bf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n}\n\n.hover\\:via-indigo-800:hover {\n  --gradient-via-color: #434190;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n}\n\n.hover\\:via-indigo-900:hover {\n  --gradient-via-color: #3c366b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n}\n\n.hover\\:via-purple-100:hover {\n  --gradient-via-color: #faf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n}\n\n.hover\\:via-purple-200:hover {\n  --gradient-via-color: #e9d8fd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n}\n\n.hover\\:via-purple-300:hover {\n  --gradient-via-color: #d6bcfa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n}\n\n.hover\\:via-purple-400:hover {\n  --gradient-via-color: #b794f4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n}\n\n.hover\\:via-purple-500:hover {\n  --gradient-via-color: #9f7aea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n}\n\n.hover\\:via-purple-600:hover {\n  --gradient-via-color: #805ad5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n}\n\n.hover\\:via-purple-700:hover {\n  --gradient-via-color: #6b46c1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n}\n\n.hover\\:via-purple-800:hover {\n  --gradient-via-color: #553c9a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n}\n\n.hover\\:via-purple-900:hover {\n  --gradient-via-color: #44337a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n}\n\n.hover\\:via-pink-100:hover {\n  --gradient-via-color: #fff5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n}\n\n.hover\\:via-pink-200:hover {\n  --gradient-via-color: #fed7e2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n}\n\n.hover\\:via-pink-300:hover {\n  --gradient-via-color: #fbb6ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n}\n\n.hover\\:via-pink-400:hover {\n  --gradient-via-color: #f687b3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n}\n\n.hover\\:via-pink-500:hover {\n  --gradient-via-color: #ed64a6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n}\n\n.hover\\:via-pink-600:hover {\n  --gradient-via-color: #d53f8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n}\n\n.hover\\:via-pink-700:hover {\n  --gradient-via-color: #b83280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n}\n\n.hover\\:via-pink-800:hover {\n  --gradient-via-color: #97266d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n}\n\n.hover\\:via-pink-900:hover {\n  --gradient-via-color: #702459;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n}\n\n.hover\\:to-transparent:hover {\n  --gradient-to-color: transparent;\n}\n\n.hover\\:to-current:hover {\n  --gradient-to-color: currentColor;\n}\n\n.hover\\:to-black:hover {\n  --gradient-to-color: #000;\n}\n\n.hover\\:to-white:hover {\n  --gradient-to-color: #fff;\n}\n\n.hover\\:to-gray-100:hover {\n  --gradient-to-color: #f7fafc;\n}\n\n.hover\\:to-gray-200:hover {\n  --gradient-to-color: #edf2f7;\n}\n\n.hover\\:to-gray-300:hover {\n  --gradient-to-color: #e2e8f0;\n}\n\n.hover\\:to-gray-400:hover {\n  --gradient-to-color: #cbd5e0;\n}\n\n.hover\\:to-gray-500:hover {\n  --gradient-to-color: #a0aec0;\n}\n\n.hover\\:to-gray-600:hover {\n  --gradient-to-color: #718096;\n}\n\n.hover\\:to-gray-700:hover {\n  --gradient-to-color: #4a5568;\n}\n\n.hover\\:to-gray-800:hover {\n  --gradient-to-color: #2d3748;\n}\n\n.hover\\:to-gray-900:hover {\n  --gradient-to-color: #1a202c;\n}\n\n.hover\\:to-red-100:hover {\n  --gradient-to-color: #fff5f5;\n}\n\n.hover\\:to-red-200:hover {\n  --gradient-to-color: #fed7d7;\n}\n\n.hover\\:to-red-300:hover {\n  --gradient-to-color: #feb2b2;\n}\n\n.hover\\:to-red-400:hover {\n  --gradient-to-color: #fc8181;\n}\n\n.hover\\:to-red-500:hover {\n  --gradient-to-color: #f56565;\n}\n\n.hover\\:to-red-600:hover {\n  --gradient-to-color: #e53e3e;\n}\n\n.hover\\:to-red-700:hover {\n  --gradient-to-color: #c53030;\n}\n\n.hover\\:to-red-800:hover {\n  --gradient-to-color: #9b2c2c;\n}\n\n.hover\\:to-red-900:hover {\n  --gradient-to-color: #742a2a;\n}\n\n.hover\\:to-orange-100:hover {\n  --gradient-to-color: #fffaf0;\n}\n\n.hover\\:to-orange-200:hover {\n  --gradient-to-color: #feebc8;\n}\n\n.hover\\:to-orange-300:hover {\n  --gradient-to-color: #fbd38d;\n}\n\n.hover\\:to-orange-400:hover {\n  --gradient-to-color: #f6ad55;\n}\n\n.hover\\:to-orange-500:hover {\n  --gradient-to-color: #ed8936;\n}\n\n.hover\\:to-orange-600:hover {\n  --gradient-to-color: #dd6b20;\n}\n\n.hover\\:to-orange-700:hover {\n  --gradient-to-color: #c05621;\n}\n\n.hover\\:to-orange-800:hover {\n  --gradient-to-color: #9c4221;\n}\n\n.hover\\:to-orange-900:hover {\n  --gradient-to-color: #7b341e;\n}\n\n.hover\\:to-yellow-100:hover {\n  --gradient-to-color: #fffff0;\n}\n\n.hover\\:to-yellow-200:hover {\n  --gradient-to-color: #fefcbf;\n}\n\n.hover\\:to-yellow-300:hover {\n  --gradient-to-color: #faf089;\n}\n\n.hover\\:to-yellow-400:hover {\n  --gradient-to-color: #f6e05e;\n}\n\n.hover\\:to-yellow-500:hover {\n  --gradient-to-color: #ecc94b;\n}\n\n.hover\\:to-yellow-600:hover {\n  --gradient-to-color: #d69e2e;\n}\n\n.hover\\:to-yellow-700:hover {\n  --gradient-to-color: #b7791f;\n}\n\n.hover\\:to-yellow-800:hover {\n  --gradient-to-color: #975a16;\n}\n\n.hover\\:to-yellow-900:hover {\n  --gradient-to-color: #744210;\n}\n\n.hover\\:to-green-100:hover {\n  --gradient-to-color: #f0fff4;\n}\n\n.hover\\:to-green-200:hover {\n  --gradient-to-color: #c6f6d5;\n}\n\n.hover\\:to-green-300:hover {\n  --gradient-to-color: #9ae6b4;\n}\n\n.hover\\:to-green-400:hover {\n  --gradient-to-color: #68d391;\n}\n\n.hover\\:to-green-500:hover {\n  --gradient-to-color: #48bb78;\n}\n\n.hover\\:to-green-600:hover {\n  --gradient-to-color: #38a169;\n}\n\n.hover\\:to-green-700:hover {\n  --gradient-to-color: #2f855a;\n}\n\n.hover\\:to-green-800:hover {\n  --gradient-to-color: #276749;\n}\n\n.hover\\:to-green-900:hover {\n  --gradient-to-color: #22543d;\n}\n\n.hover\\:to-teal-100:hover {\n  --gradient-to-color: #e6fffa;\n}\n\n.hover\\:to-teal-200:hover {\n  --gradient-to-color: #b2f5ea;\n}\n\n.hover\\:to-teal-300:hover {\n  --gradient-to-color: #81e6d9;\n}\n\n.hover\\:to-teal-400:hover {\n  --gradient-to-color: #4fd1c5;\n}\n\n.hover\\:to-teal-500:hover {\n  --gradient-to-color: #38b2ac;\n}\n\n.hover\\:to-teal-600:hover {\n  --gradient-to-color: #319795;\n}\n\n.hover\\:to-teal-700:hover {\n  --gradient-to-color: #2c7a7b;\n}\n\n.hover\\:to-teal-800:hover {\n  --gradient-to-color: #285e61;\n}\n\n.hover\\:to-teal-900:hover {\n  --gradient-to-color: #234e52;\n}\n\n.hover\\:to-blue-100:hover {\n  --gradient-to-color: #ebf8ff;\n}\n\n.hover\\:to-blue-200:hover {\n  --gradient-to-color: #bee3f8;\n}\n\n.hover\\:to-blue-300:hover {\n  --gradient-to-color: #90cdf4;\n}\n\n.hover\\:to-blue-400:hover {\n  --gradient-to-color: #63b3ed;\n}\n\n.hover\\:to-blue-500:hover {\n  --gradient-to-color: #4299e1;\n}\n\n.hover\\:to-blue-600:hover {\n  --gradient-to-color: #3182ce;\n}\n\n.hover\\:to-blue-700:hover {\n  --gradient-to-color: #2b6cb0;\n}\n\n.hover\\:to-blue-800:hover {\n  --gradient-to-color: #2c5282;\n}\n\n.hover\\:to-blue-900:hover {\n  --gradient-to-color: #2a4365;\n}\n\n.hover\\:to-indigo-100:hover {\n  --gradient-to-color: #ebf4ff;\n}\n\n.hover\\:to-indigo-200:hover {\n  --gradient-to-color: #c3dafe;\n}\n\n.hover\\:to-indigo-300:hover {\n  --gradient-to-color: #a3bffa;\n}\n\n.hover\\:to-indigo-400:hover {\n  --gradient-to-color: #7f9cf5;\n}\n\n.hover\\:to-indigo-500:hover {\n  --gradient-to-color: #667eea;\n}\n\n.hover\\:to-indigo-600:hover {\n  --gradient-to-color: #5a67d8;\n}\n\n.hover\\:to-indigo-700:hover {\n  --gradient-to-color: #4c51bf;\n}\n\n.hover\\:to-indigo-800:hover {\n  --gradient-to-color: #434190;\n}\n\n.hover\\:to-indigo-900:hover {\n  --gradient-to-color: #3c366b;\n}\n\n.hover\\:to-purple-100:hover {\n  --gradient-to-color: #faf5ff;\n}\n\n.hover\\:to-purple-200:hover {\n  --gradient-to-color: #e9d8fd;\n}\n\n.hover\\:to-purple-300:hover {\n  --gradient-to-color: #d6bcfa;\n}\n\n.hover\\:to-purple-400:hover {\n  --gradient-to-color: #b794f4;\n}\n\n.hover\\:to-purple-500:hover {\n  --gradient-to-color: #9f7aea;\n}\n\n.hover\\:to-purple-600:hover {\n  --gradient-to-color: #805ad5;\n}\n\n.hover\\:to-purple-700:hover {\n  --gradient-to-color: #6b46c1;\n}\n\n.hover\\:to-purple-800:hover {\n  --gradient-to-color: #553c9a;\n}\n\n.hover\\:to-purple-900:hover {\n  --gradient-to-color: #44337a;\n}\n\n.hover\\:to-pink-100:hover {\n  --gradient-to-color: #fff5f7;\n}\n\n.hover\\:to-pink-200:hover {\n  --gradient-to-color: #fed7e2;\n}\n\n.hover\\:to-pink-300:hover {\n  --gradient-to-color: #fbb6ce;\n}\n\n.hover\\:to-pink-400:hover {\n  --gradient-to-color: #f687b3;\n}\n\n.hover\\:to-pink-500:hover {\n  --gradient-to-color: #ed64a6;\n}\n\n.hover\\:to-pink-600:hover {\n  --gradient-to-color: #d53f8c;\n}\n\n.hover\\:to-pink-700:hover {\n  --gradient-to-color: #b83280;\n}\n\n.hover\\:to-pink-800:hover {\n  --gradient-to-color: #97266d;\n}\n\n.hover\\:to-pink-900:hover {\n  --gradient-to-color: #702459;\n}\n\n.focus\\:from-transparent:focus {\n  --gradient-from-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.focus\\:from-current:focus {\n  --gradient-from-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.focus\\:from-black:focus {\n  --gradient-from-color: #000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.focus\\:from-white:focus {\n  --gradient-from-color: #fff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.focus\\:from-gray-100:focus {\n  --gradient-from-color: #f7fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n}\n\n.focus\\:from-gray-200:focus {\n  --gradient-from-color: #edf2f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n}\n\n.focus\\:from-gray-300:focus {\n  --gradient-from-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n\n.focus\\:from-gray-400:focus {\n  --gradient-from-color: #cbd5e0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n}\n\n.focus\\:from-gray-500:focus {\n  --gradient-from-color: #a0aec0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n}\n\n.focus\\:from-gray-600:focus {\n  --gradient-from-color: #718096;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n}\n\n.focus\\:from-gray-700:focus {\n  --gradient-from-color: #4a5568;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n}\n\n.focus\\:from-gray-800:focus {\n  --gradient-from-color: #2d3748;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n}\n\n.focus\\:from-gray-900:focus {\n  --gradient-from-color: #1a202c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n}\n\n.focus\\:from-red-100:focus {\n  --gradient-from-color: #fff5f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n}\n\n.focus\\:from-red-200:focus {\n  --gradient-from-color: #fed7d7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n}\n\n.focus\\:from-red-300:focus {\n  --gradient-from-color: #feb2b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n}\n\n.focus\\:from-red-400:focus {\n  --gradient-from-color: #fc8181;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n}\n\n.focus\\:from-red-500:focus {\n  --gradient-from-color: #f56565;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n}\n\n.focus\\:from-red-600:focus {\n  --gradient-from-color: #e53e3e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n}\n\n.focus\\:from-red-700:focus {\n  --gradient-from-color: #c53030;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n}\n\n.focus\\:from-red-800:focus {\n  --gradient-from-color: #9b2c2c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n}\n\n.focus\\:from-red-900:focus {\n  --gradient-from-color: #742a2a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n}\n\n.focus\\:from-orange-100:focus {\n  --gradient-from-color: #fffaf0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n}\n\n.focus\\:from-orange-200:focus {\n  --gradient-from-color: #feebc8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n}\n\n.focus\\:from-orange-300:focus {\n  --gradient-from-color: #fbd38d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n}\n\n.focus\\:from-orange-400:focus {\n  --gradient-from-color: #f6ad55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n}\n\n.focus\\:from-orange-500:focus {\n  --gradient-from-color: #ed8936;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n}\n\n.focus\\:from-orange-600:focus {\n  --gradient-from-color: #dd6b20;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n}\n\n.focus\\:from-orange-700:focus {\n  --gradient-from-color: #c05621;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n}\n\n.focus\\:from-orange-800:focus {\n  --gradient-from-color: #9c4221;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n}\n\n.focus\\:from-orange-900:focus {\n  --gradient-from-color: #7b341e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n}\n\n.focus\\:from-yellow-100:focus {\n  --gradient-from-color: #fffff0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n}\n\n.focus\\:from-yellow-200:focus {\n  --gradient-from-color: #fefcbf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n}\n\n.focus\\:from-yellow-300:focus {\n  --gradient-from-color: #faf089;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n}\n\n.focus\\:from-yellow-400:focus {\n  --gradient-from-color: #f6e05e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n}\n\n.focus\\:from-yellow-500:focus {\n  --gradient-from-color: #ecc94b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n}\n\n.focus\\:from-yellow-600:focus {\n  --gradient-from-color: #d69e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n}\n\n.focus\\:from-yellow-700:focus {\n  --gradient-from-color: #b7791f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n}\n\n.focus\\:from-yellow-800:focus {\n  --gradient-from-color: #975a16;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n}\n\n.focus\\:from-yellow-900:focus {\n  --gradient-from-color: #744210;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n}\n\n.focus\\:from-green-100:focus {\n  --gradient-from-color: #f0fff4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n}\n\n.focus\\:from-green-200:focus {\n  --gradient-from-color: #c6f6d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n}\n\n.focus\\:from-green-300:focus {\n  --gradient-from-color: #9ae6b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n}\n\n.focus\\:from-green-400:focus {\n  --gradient-from-color: #68d391;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n}\n\n.focus\\:from-green-500:focus {\n  --gradient-from-color: #48bb78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n}\n\n.focus\\:from-green-600:focus {\n  --gradient-from-color: #38a169;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n}\n\n.focus\\:from-green-700:focus {\n  --gradient-from-color: #2f855a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n}\n\n.focus\\:from-green-800:focus {\n  --gradient-from-color: #276749;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n}\n\n.focus\\:from-green-900:focus {\n  --gradient-from-color: #22543d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n}\n\n.focus\\:from-teal-100:focus {\n  --gradient-from-color: #e6fffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n}\n\n.focus\\:from-teal-200:focus {\n  --gradient-from-color: #b2f5ea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n}\n\n.focus\\:from-teal-300:focus {\n  --gradient-from-color: #81e6d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n}\n\n.focus\\:from-teal-400:focus {\n  --gradient-from-color: #4fd1c5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n}\n\n.focus\\:from-teal-500:focus {\n  --gradient-from-color: #38b2ac;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n}\n\n.focus\\:from-teal-600:focus {\n  --gradient-from-color: #319795;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n}\n\n.focus\\:from-teal-700:focus {\n  --gradient-from-color: #2c7a7b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n}\n\n.focus\\:from-teal-800:focus {\n  --gradient-from-color: #285e61;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n}\n\n.focus\\:from-teal-900:focus {\n  --gradient-from-color: #234e52;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n}\n\n.focus\\:from-blue-100:focus {\n  --gradient-from-color: #ebf8ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n}\n\n.focus\\:from-blue-200:focus {\n  --gradient-from-color: #bee3f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n}\n\n.focus\\:from-blue-300:focus {\n  --gradient-from-color: #90cdf4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n}\n\n.focus\\:from-blue-400:focus {\n  --gradient-from-color: #63b3ed;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n}\n\n.focus\\:from-blue-500:focus {\n  --gradient-from-color: #4299e1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n}\n\n.focus\\:from-blue-600:focus {\n  --gradient-from-color: #3182ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n}\n\n.focus\\:from-blue-700:focus {\n  --gradient-from-color: #2b6cb0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n}\n\n.focus\\:from-blue-800:focus {\n  --gradient-from-color: #2c5282;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n}\n\n.focus\\:from-blue-900:focus {\n  --gradient-from-color: #2a4365;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n}\n\n.focus\\:from-indigo-100:focus {\n  --gradient-from-color: #ebf4ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n}\n\n.focus\\:from-indigo-200:focus {\n  --gradient-from-color: #c3dafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n}\n\n.focus\\:from-indigo-300:focus {\n  --gradient-from-color: #a3bffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n}\n\n.focus\\:from-indigo-400:focus {\n  --gradient-from-color: #7f9cf5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n}\n\n.focus\\:from-indigo-500:focus {\n  --gradient-from-color: #667eea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n}\n\n.focus\\:from-indigo-600:focus {\n  --gradient-from-color: #5a67d8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n}\n\n.focus\\:from-indigo-700:focus {\n  --gradient-from-color: #4c51bf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n}\n\n.focus\\:from-indigo-800:focus {\n  --gradient-from-color: #434190;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n}\n\n.focus\\:from-indigo-900:focus {\n  --gradient-from-color: #3c366b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n}\n\n.focus\\:from-purple-100:focus {\n  --gradient-from-color: #faf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n}\n\n.focus\\:from-purple-200:focus {\n  --gradient-from-color: #e9d8fd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n}\n\n.focus\\:from-purple-300:focus {\n  --gradient-from-color: #d6bcfa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n}\n\n.focus\\:from-purple-400:focus {\n  --gradient-from-color: #b794f4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n}\n\n.focus\\:from-purple-500:focus {\n  --gradient-from-color: #9f7aea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n}\n\n.focus\\:from-purple-600:focus {\n  --gradient-from-color: #805ad5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n}\n\n.focus\\:from-purple-700:focus {\n  --gradient-from-color: #6b46c1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n}\n\n.focus\\:from-purple-800:focus {\n  --gradient-from-color: #553c9a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n}\n\n.focus\\:from-purple-900:focus {\n  --gradient-from-color: #44337a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n}\n\n.focus\\:from-pink-100:focus {\n  --gradient-from-color: #fff5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n}\n\n.focus\\:from-pink-200:focus {\n  --gradient-from-color: #fed7e2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n}\n\n.focus\\:from-pink-300:focus {\n  --gradient-from-color: #fbb6ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n}\n\n.focus\\:from-pink-400:focus {\n  --gradient-from-color: #f687b3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n}\n\n.focus\\:from-pink-500:focus {\n  --gradient-from-color: #ed64a6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n}\n\n.focus\\:from-pink-600:focus {\n  --gradient-from-color: #d53f8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n}\n\n.focus\\:from-pink-700:focus {\n  --gradient-from-color: #b83280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n}\n\n.focus\\:from-pink-800:focus {\n  --gradient-from-color: #97266d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n}\n\n.focus\\:from-pink-900:focus {\n  --gradient-from-color: #702459;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n}\n\n.focus\\:via-transparent:focus {\n  --gradient-via-color: transparent;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.focus\\:via-current:focus {\n  --gradient-via-color: currentColor;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.focus\\:via-black:focus {\n  --gradient-via-color: #000;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n}\n\n.focus\\:via-white:focus {\n  --gradient-via-color: #fff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n}\n\n.focus\\:via-gray-100:focus {\n  --gradient-via-color: #f7fafc;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n}\n\n.focus\\:via-gray-200:focus {\n  --gradient-via-color: #edf2f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n}\n\n.focus\\:via-gray-300:focus {\n  --gradient-via-color: #e2e8f0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n}\n\n.focus\\:via-gray-400:focus {\n  --gradient-via-color: #cbd5e0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n}\n\n.focus\\:via-gray-500:focus {\n  --gradient-via-color: #a0aec0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n}\n\n.focus\\:via-gray-600:focus {\n  --gradient-via-color: #718096;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n}\n\n.focus\\:via-gray-700:focus {\n  --gradient-via-color: #4a5568;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n}\n\n.focus\\:via-gray-800:focus {\n  --gradient-via-color: #2d3748;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n}\n\n.focus\\:via-gray-900:focus {\n  --gradient-via-color: #1a202c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n}\n\n.focus\\:via-red-100:focus {\n  --gradient-via-color: #fff5f5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n}\n\n.focus\\:via-red-200:focus {\n  --gradient-via-color: #fed7d7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n}\n\n.focus\\:via-red-300:focus {\n  --gradient-via-color: #feb2b2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n}\n\n.focus\\:via-red-400:focus {\n  --gradient-via-color: #fc8181;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n}\n\n.focus\\:via-red-500:focus {\n  --gradient-via-color: #f56565;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n}\n\n.focus\\:via-red-600:focus {\n  --gradient-via-color: #e53e3e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n}\n\n.focus\\:via-red-700:focus {\n  --gradient-via-color: #c53030;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n}\n\n.focus\\:via-red-800:focus {\n  --gradient-via-color: #9b2c2c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n}\n\n.focus\\:via-red-900:focus {\n  --gradient-via-color: #742a2a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n}\n\n.focus\\:via-orange-100:focus {\n  --gradient-via-color: #fffaf0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n}\n\n.focus\\:via-orange-200:focus {\n  --gradient-via-color: #feebc8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n}\n\n.focus\\:via-orange-300:focus {\n  --gradient-via-color: #fbd38d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n}\n\n.focus\\:via-orange-400:focus {\n  --gradient-via-color: #f6ad55;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n}\n\n.focus\\:via-orange-500:focus {\n  --gradient-via-color: #ed8936;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n}\n\n.focus\\:via-orange-600:focus {\n  --gradient-via-color: #dd6b20;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n}\n\n.focus\\:via-orange-700:focus {\n  --gradient-via-color: #c05621;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n}\n\n.focus\\:via-orange-800:focus {\n  --gradient-via-color: #9c4221;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n}\n\n.focus\\:via-orange-900:focus {\n  --gradient-via-color: #7b341e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n}\n\n.focus\\:via-yellow-100:focus {\n  --gradient-via-color: #fffff0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n}\n\n.focus\\:via-yellow-200:focus {\n  --gradient-via-color: #fefcbf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n}\n\n.focus\\:via-yellow-300:focus {\n  --gradient-via-color: #faf089;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n}\n\n.focus\\:via-yellow-400:focus {\n  --gradient-via-color: #f6e05e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n}\n\n.focus\\:via-yellow-500:focus {\n  --gradient-via-color: #ecc94b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n}\n\n.focus\\:via-yellow-600:focus {\n  --gradient-via-color: #d69e2e;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n}\n\n.focus\\:via-yellow-700:focus {\n  --gradient-via-color: #b7791f;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n}\n\n.focus\\:via-yellow-800:focus {\n  --gradient-via-color: #975a16;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n}\n\n.focus\\:via-yellow-900:focus {\n  --gradient-via-color: #744210;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n}\n\n.focus\\:via-green-100:focus {\n  --gradient-via-color: #f0fff4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n}\n\n.focus\\:via-green-200:focus {\n  --gradient-via-color: #c6f6d5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n}\n\n.focus\\:via-green-300:focus {\n  --gradient-via-color: #9ae6b4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n}\n\n.focus\\:via-green-400:focus {\n  --gradient-via-color: #68d391;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n}\n\n.focus\\:via-green-500:focus {\n  --gradient-via-color: #48bb78;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n}\n\n.focus\\:via-green-600:focus {\n  --gradient-via-color: #38a169;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n}\n\n.focus\\:via-green-700:focus {\n  --gradient-via-color: #2f855a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n}\n\n.focus\\:via-green-800:focus {\n  --gradient-via-color: #276749;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n}\n\n.focus\\:via-green-900:focus {\n  --gradient-via-color: #22543d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n}\n\n.focus\\:via-teal-100:focus {\n  --gradient-via-color: #e6fffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n}\n\n.focus\\:via-teal-200:focus {\n  --gradient-via-color: #b2f5ea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n}\n\n.focus\\:via-teal-300:focus {\n  --gradient-via-color: #81e6d9;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n}\n\n.focus\\:via-teal-400:focus {\n  --gradient-via-color: #4fd1c5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n}\n\n.focus\\:via-teal-500:focus {\n  --gradient-via-color: #38b2ac;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n}\n\n.focus\\:via-teal-600:focus {\n  --gradient-via-color: #319795;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n}\n\n.focus\\:via-teal-700:focus {\n  --gradient-via-color: #2c7a7b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n}\n\n.focus\\:via-teal-800:focus {\n  --gradient-via-color: #285e61;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n}\n\n.focus\\:via-teal-900:focus {\n  --gradient-via-color: #234e52;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n}\n\n.focus\\:via-blue-100:focus {\n  --gradient-via-color: #ebf8ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n}\n\n.focus\\:via-blue-200:focus {\n  --gradient-via-color: #bee3f8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n}\n\n.focus\\:via-blue-300:focus {\n  --gradient-via-color: #90cdf4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n}\n\n.focus\\:via-blue-400:focus {\n  --gradient-via-color: #63b3ed;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n}\n\n.focus\\:via-blue-500:focus {\n  --gradient-via-color: #4299e1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n}\n\n.focus\\:via-blue-600:focus {\n  --gradient-via-color: #3182ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n}\n\n.focus\\:via-blue-700:focus {\n  --gradient-via-color: #2b6cb0;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n}\n\n.focus\\:via-blue-800:focus {\n  --gradient-via-color: #2c5282;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n}\n\n.focus\\:via-blue-900:focus {\n  --gradient-via-color: #2a4365;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n}\n\n.focus\\:via-indigo-100:focus {\n  --gradient-via-color: #ebf4ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n}\n\n.focus\\:via-indigo-200:focus {\n  --gradient-via-color: #c3dafe;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n}\n\n.focus\\:via-indigo-300:focus {\n  --gradient-via-color: #a3bffa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n}\n\n.focus\\:via-indigo-400:focus {\n  --gradient-via-color: #7f9cf5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n}\n\n.focus\\:via-indigo-500:focus {\n  --gradient-via-color: #667eea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n}\n\n.focus\\:via-indigo-600:focus {\n  --gradient-via-color: #5a67d8;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n}\n\n.focus\\:via-indigo-700:focus {\n  --gradient-via-color: #4c51bf;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n}\n\n.focus\\:via-indigo-800:focus {\n  --gradient-via-color: #434190;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n}\n\n.focus\\:via-indigo-900:focus {\n  --gradient-via-color: #3c366b;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n}\n\n.focus\\:via-purple-100:focus {\n  --gradient-via-color: #faf5ff;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n}\n\n.focus\\:via-purple-200:focus {\n  --gradient-via-color: #e9d8fd;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n}\n\n.focus\\:via-purple-300:focus {\n  --gradient-via-color: #d6bcfa;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n}\n\n.focus\\:via-purple-400:focus {\n  --gradient-via-color: #b794f4;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n}\n\n.focus\\:via-purple-500:focus {\n  --gradient-via-color: #9f7aea;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n}\n\n.focus\\:via-purple-600:focus {\n  --gradient-via-color: #805ad5;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n}\n\n.focus\\:via-purple-700:focus {\n  --gradient-via-color: #6b46c1;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n}\n\n.focus\\:via-purple-800:focus {\n  --gradient-via-color: #553c9a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n}\n\n.focus\\:via-purple-900:focus {\n  --gradient-via-color: #44337a;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n}\n\n.focus\\:via-pink-100:focus {\n  --gradient-via-color: #fff5f7;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n}\n\n.focus\\:via-pink-200:focus {\n  --gradient-via-color: #fed7e2;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n}\n\n.focus\\:via-pink-300:focus {\n  --gradient-via-color: #fbb6ce;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n}\n\n.focus\\:via-pink-400:focus {\n  --gradient-via-color: #f687b3;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n}\n\n.focus\\:via-pink-500:focus {\n  --gradient-via-color: #ed64a6;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n}\n\n.focus\\:via-pink-600:focus {\n  --gradient-via-color: #d53f8c;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n}\n\n.focus\\:via-pink-700:focus {\n  --gradient-via-color: #b83280;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n}\n\n.focus\\:via-pink-800:focus {\n  --gradient-via-color: #97266d;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n}\n\n.focus\\:via-pink-900:focus {\n  --gradient-via-color: #702459;\n  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n}\n\n.focus\\:to-transparent:focus {\n  --gradient-to-color: transparent;\n}\n\n.focus\\:to-current:focus {\n  --gradient-to-color: currentColor;\n}\n\n.focus\\:to-black:focus {\n  --gradient-to-color: #000;\n}\n\n.focus\\:to-white:focus {\n  --gradient-to-color: #fff;\n}\n\n.focus\\:to-gray-100:focus {\n  --gradient-to-color: #f7fafc;\n}\n\n.focus\\:to-gray-200:focus {\n  --gradient-to-color: #edf2f7;\n}\n\n.focus\\:to-gray-300:focus {\n  --gradient-to-color: #e2e8f0;\n}\n\n.focus\\:to-gray-400:focus {\n  --gradient-to-color: #cbd5e0;\n}\n\n.focus\\:to-gray-500:focus {\n  --gradient-to-color: #a0aec0;\n}\n\n.focus\\:to-gray-600:focus {\n  --gradient-to-color: #718096;\n}\n\n.focus\\:to-gray-700:focus {\n  --gradient-to-color: #4a5568;\n}\n\n.focus\\:to-gray-800:focus {\n  --gradient-to-color: #2d3748;\n}\n\n.focus\\:to-gray-900:focus {\n  --gradient-to-color: #1a202c;\n}\n\n.focus\\:to-red-100:focus {\n  --gradient-to-color: #fff5f5;\n}\n\n.focus\\:to-red-200:focus {\n  --gradient-to-color: #fed7d7;\n}\n\n.focus\\:to-red-300:focus {\n  --gradient-to-color: #feb2b2;\n}\n\n.focus\\:to-red-400:focus {\n  --gradient-to-color: #fc8181;\n}\n\n.focus\\:to-red-500:focus {\n  --gradient-to-color: #f56565;\n}\n\n.focus\\:to-red-600:focus {\n  --gradient-to-color: #e53e3e;\n}\n\n.focus\\:to-red-700:focus {\n  --gradient-to-color: #c53030;\n}\n\n.focus\\:to-red-800:focus {\n  --gradient-to-color: #9b2c2c;\n}\n\n.focus\\:to-red-900:focus {\n  --gradient-to-color: #742a2a;\n}\n\n.focus\\:to-orange-100:focus {\n  --gradient-to-color: #fffaf0;\n}\n\n.focus\\:to-orange-200:focus {\n  --gradient-to-color: #feebc8;\n}\n\n.focus\\:to-orange-300:focus {\n  --gradient-to-color: #fbd38d;\n}\n\n.focus\\:to-orange-400:focus {\n  --gradient-to-color: #f6ad55;\n}\n\n.focus\\:to-orange-500:focus {\n  --gradient-to-color: #ed8936;\n}\n\n.focus\\:to-orange-600:focus {\n  --gradient-to-color: #dd6b20;\n}\n\n.focus\\:to-orange-700:focus {\n  --gradient-to-color: #c05621;\n}\n\n.focus\\:to-orange-800:focus {\n  --gradient-to-color: #9c4221;\n}\n\n.focus\\:to-orange-900:focus {\n  --gradient-to-color: #7b341e;\n}\n\n.focus\\:to-yellow-100:focus {\n  --gradient-to-color: #fffff0;\n}\n\n.focus\\:to-yellow-200:focus {\n  --gradient-to-color: #fefcbf;\n}\n\n.focus\\:to-yellow-300:focus {\n  --gradient-to-color: #faf089;\n}\n\n.focus\\:to-yellow-400:focus {\n  --gradient-to-color: #f6e05e;\n}\n\n.focus\\:to-yellow-500:focus {\n  --gradient-to-color: #ecc94b;\n}\n\n.focus\\:to-yellow-600:focus {\n  --gradient-to-color: #d69e2e;\n}\n\n.focus\\:to-yellow-700:focus {\n  --gradient-to-color: #b7791f;\n}\n\n.focus\\:to-yellow-800:focus {\n  --gradient-to-color: #975a16;\n}\n\n.focus\\:to-yellow-900:focus {\n  --gradient-to-color: #744210;\n}\n\n.focus\\:to-green-100:focus {\n  --gradient-to-color: #f0fff4;\n}\n\n.focus\\:to-green-200:focus {\n  --gradient-to-color: #c6f6d5;\n}\n\n.focus\\:to-green-300:focus {\n  --gradient-to-color: #9ae6b4;\n}\n\n.focus\\:to-green-400:focus {\n  --gradient-to-color: #68d391;\n}\n\n.focus\\:to-green-500:focus {\n  --gradient-to-color: #48bb78;\n}\n\n.focus\\:to-green-600:focus {\n  --gradient-to-color: #38a169;\n}\n\n.focus\\:to-green-700:focus {\n  --gradient-to-color: #2f855a;\n}\n\n.focus\\:to-green-800:focus {\n  --gradient-to-color: #276749;\n}\n\n.focus\\:to-green-900:focus {\n  --gradient-to-color: #22543d;\n}\n\n.focus\\:to-teal-100:focus {\n  --gradient-to-color: #e6fffa;\n}\n\n.focus\\:to-teal-200:focus {\n  --gradient-to-color: #b2f5ea;\n}\n\n.focus\\:to-teal-300:focus {\n  --gradient-to-color: #81e6d9;\n}\n\n.focus\\:to-teal-400:focus {\n  --gradient-to-color: #4fd1c5;\n}\n\n.focus\\:to-teal-500:focus {\n  --gradient-to-color: #38b2ac;\n}\n\n.focus\\:to-teal-600:focus {\n  --gradient-to-color: #319795;\n}\n\n.focus\\:to-teal-700:focus {\n  --gradient-to-color: #2c7a7b;\n}\n\n.focus\\:to-teal-800:focus {\n  --gradient-to-color: #285e61;\n}\n\n.focus\\:to-teal-900:focus {\n  --gradient-to-color: #234e52;\n}\n\n.focus\\:to-blue-100:focus {\n  --gradient-to-color: #ebf8ff;\n}\n\n.focus\\:to-blue-200:focus {\n  --gradient-to-color: #bee3f8;\n}\n\n.focus\\:to-blue-300:focus {\n  --gradient-to-color: #90cdf4;\n}\n\n.focus\\:to-blue-400:focus {\n  --gradient-to-color: #63b3ed;\n}\n\n.focus\\:to-blue-500:focus {\n  --gradient-to-color: #4299e1;\n}\n\n.focus\\:to-blue-600:focus {\n  --gradient-to-color: #3182ce;\n}\n\n.focus\\:to-blue-700:focus {\n  --gradient-to-color: #2b6cb0;\n}\n\n.focus\\:to-blue-800:focus {\n  --gradient-to-color: #2c5282;\n}\n\n.focus\\:to-blue-900:focus {\n  --gradient-to-color: #2a4365;\n}\n\n.focus\\:to-indigo-100:focus {\n  --gradient-to-color: #ebf4ff;\n}\n\n.focus\\:to-indigo-200:focus {\n  --gradient-to-color: #c3dafe;\n}\n\n.focus\\:to-indigo-300:focus {\n  --gradient-to-color: #a3bffa;\n}\n\n.focus\\:to-indigo-400:focus {\n  --gradient-to-color: #7f9cf5;\n}\n\n.focus\\:to-indigo-500:focus {\n  --gradient-to-color: #667eea;\n}\n\n.focus\\:to-indigo-600:focus {\n  --gradient-to-color: #5a67d8;\n}\n\n.focus\\:to-indigo-700:focus {\n  --gradient-to-color: #4c51bf;\n}\n\n.focus\\:to-indigo-800:focus {\n  --gradient-to-color: #434190;\n}\n\n.focus\\:to-indigo-900:focus {\n  --gradient-to-color: #3c366b;\n}\n\n.focus\\:to-purple-100:focus {\n  --gradient-to-color: #faf5ff;\n}\n\n.focus\\:to-purple-200:focus {\n  --gradient-to-color: #e9d8fd;\n}\n\n.focus\\:to-purple-300:focus {\n  --gradient-to-color: #d6bcfa;\n}\n\n.focus\\:to-purple-400:focus {\n  --gradient-to-color: #b794f4;\n}\n\n.focus\\:to-purple-500:focus {\n  --gradient-to-color: #9f7aea;\n}\n\n.focus\\:to-purple-600:focus {\n  --gradient-to-color: #805ad5;\n}\n\n.focus\\:to-purple-700:focus {\n  --gradient-to-color: #6b46c1;\n}\n\n.focus\\:to-purple-800:focus {\n  --gradient-to-color: #553c9a;\n}\n\n.focus\\:to-purple-900:focus {\n  --gradient-to-color: #44337a;\n}\n\n.focus\\:to-pink-100:focus {\n  --gradient-to-color: #fff5f7;\n}\n\n.focus\\:to-pink-200:focus {\n  --gradient-to-color: #fed7e2;\n}\n\n.focus\\:to-pink-300:focus {\n  --gradient-to-color: #fbb6ce;\n}\n\n.focus\\:to-pink-400:focus {\n  --gradient-to-color: #f687b3;\n}\n\n.focus\\:to-pink-500:focus {\n  --gradient-to-color: #ed64a6;\n}\n\n.focus\\:to-pink-600:focus {\n  --gradient-to-color: #d53f8c;\n}\n\n.focus\\:to-pink-700:focus {\n  --gradient-to-color: #b83280;\n}\n\n.focus\\:to-pink-800:focus {\n  --gradient-to-color: #97266d;\n}\n\n.focus\\:to-pink-900:focus {\n  --gradient-to-color: #702459;\n}\n\n.bg-opacity-0 {\n  --bg-opacity: 0;\n}\n\n.bg-opacity-25 {\n  --bg-opacity: 0.25;\n}\n\n.bg-opacity-50 {\n  --bg-opacity: 0.5;\n}\n\n.bg-opacity-75 {\n  --bg-opacity: 0.75;\n}\n\n.bg-opacity-100 {\n  --bg-opacity: 1;\n}\n\n.hover\\:bg-opacity-0:hover {\n  --bg-opacity: 0;\n}\n\n.hover\\:bg-opacity-25:hover {\n  --bg-opacity: 0.25;\n}\n\n.hover\\:bg-opacity-50:hover {\n  --bg-opacity: 0.5;\n}\n\n.hover\\:bg-opacity-75:hover {\n  --bg-opacity: 0.75;\n}\n\n.hover\\:bg-opacity-100:hover {\n  --bg-opacity: 1;\n}\n\n.focus\\:bg-opacity-0:focus {\n  --bg-opacity: 0;\n}\n\n.focus\\:bg-opacity-25:focus {\n  --bg-opacity: 0.25;\n}\n\n.focus\\:bg-opacity-50:focus {\n  --bg-opacity: 0.5;\n}\n\n.focus\\:bg-opacity-75:focus {\n  --bg-opacity: 0.75;\n}\n\n.focus\\:bg-opacity-100:focus {\n  --bg-opacity: 1;\n}\n\n.bg-bottom {\n  background-position: bottom;\n}\n\n.bg-center {\n  background-position: center;\n}\n\n.bg-left {\n  background-position: left;\n}\n\n.bg-left-bottom {\n  background-position: left bottom;\n}\n\n.bg-left-top {\n  background-position: left top;\n}\n\n.bg-right {\n  background-position: right;\n}\n\n.bg-right-bottom {\n  background-position: right bottom;\n}\n\n.bg-right-top {\n  background-position: right top;\n}\n\n.bg-top {\n  background-position: top;\n}\n\n.bg-repeat {\n  background-repeat: repeat;\n}\n\n.bg-no-repeat {\n  background-repeat: no-repeat;\n}\n\n.bg-repeat-x {\n  background-repeat: repeat-x;\n}\n\n.bg-repeat-y {\n  background-repeat: repeat-y;\n}\n\n.bg-repeat-round {\n  background-repeat: round;\n}\n\n.bg-repeat-space {\n  background-repeat: space;\n}\n\n.bg-auto {\n  background-size: auto;\n}\n\n.bg-cover {\n  background-size: cover;\n}\n\n.bg-contain {\n  background-size: contain;\n}\n\n.border-collapse {\n  border-collapse: collapse;\n}\n\n.border-separate {\n  border-collapse: separate;\n}\n\n.border-transparent {\n  border-color: transparent;\n}\n\n.border-current {\n  border-color: currentColor;\n}\n\n.border-black {\n  --border-opacity: 1;\n  border-color: #000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n\n.border-white {\n  --border-opacity: 1;\n  border-color: #fff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n\n.border-gray-100 {\n  --border-opacity: 1;\n  border-color: #f7fafc;\n  border-color: rgba(247, 250, 252, var(--border-opacity));\n}\n\n.border-gray-200 {\n  --border-opacity: 1;\n  border-color: #edf2f7;\n  border-color: rgba(237, 242, 247, var(--border-opacity));\n}\n\n.border-gray-300 {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n\n.border-gray-400 {\n  --border-opacity: 1;\n  border-color: #cbd5e0;\n  border-color: rgba(203, 213, 224, var(--border-opacity));\n}\n\n.border-gray-500 {\n  --border-opacity: 1;\n  border-color: #a0aec0;\n  border-color: rgba(160, 174, 192, var(--border-opacity));\n}\n\n.border-gray-600 {\n  --border-opacity: 1;\n  border-color: #718096;\n  border-color: rgba(113, 128, 150, var(--border-opacity));\n}\n\n.border-gray-700 {\n  --border-opacity: 1;\n  border-color: #4a5568;\n  border-color: rgba(74, 85, 104, var(--border-opacity));\n}\n\n.border-gray-800 {\n  --border-opacity: 1;\n  border-color: #2d3748;\n  border-color: rgba(45, 55, 72, var(--border-opacity));\n}\n\n.border-gray-900 {\n  --border-opacity: 1;\n  border-color: #1a202c;\n  border-color: rgba(26, 32, 44, var(--border-opacity));\n}\n\n.border-red-100 {\n  --border-opacity: 1;\n  border-color: #fff5f5;\n  border-color: rgba(255, 245, 245, var(--border-opacity));\n}\n\n.border-red-200 {\n  --border-opacity: 1;\n  border-color: #fed7d7;\n  border-color: rgba(254, 215, 215, var(--border-opacity));\n}\n\n.border-red-300 {\n  --border-opacity: 1;\n  border-color: #feb2b2;\n  border-color: rgba(254, 178, 178, var(--border-opacity));\n}\n\n.border-red-400 {\n  --border-opacity: 1;\n  border-color: #fc8181;\n  border-color: rgba(252, 129, 129, var(--border-opacity));\n}\n\n.border-red-500 {\n  --border-opacity: 1;\n  border-color: #f56565;\n  border-color: rgba(245, 101, 101, var(--border-opacity));\n}\n\n.border-red-600 {\n  --border-opacity: 1;\n  border-color: #e53e3e;\n  border-color: rgba(229, 62, 62, var(--border-opacity));\n}\n\n.border-red-700 {\n  --border-opacity: 1;\n  border-color: #c53030;\n  border-color: rgba(197, 48, 48, var(--border-opacity));\n}\n\n.border-red-800 {\n  --border-opacity: 1;\n  border-color: #9b2c2c;\n  border-color: rgba(155, 44, 44, var(--border-opacity));\n}\n\n.border-red-900 {\n  --border-opacity: 1;\n  border-color: #742a2a;\n  border-color: rgba(116, 42, 42, var(--border-opacity));\n}\n\n.border-orange-100 {\n  --border-opacity: 1;\n  border-color: #fffaf0;\n  border-color: rgba(255, 250, 240, var(--border-opacity));\n}\n\n.border-orange-200 {\n  --border-opacity: 1;\n  border-color: #feebc8;\n  border-color: rgba(254, 235, 200, var(--border-opacity));\n}\n\n.border-orange-300 {\n  --border-opacity: 1;\n  border-color: #fbd38d;\n  border-color: rgba(251, 211, 141, var(--border-opacity));\n}\n\n.border-orange-400 {\n  --border-opacity: 1;\n  border-color: #f6ad55;\n  border-color: rgba(246, 173, 85, var(--border-opacity));\n}\n\n.border-orange-500 {\n  --border-opacity: 1;\n  border-color: #ed8936;\n  border-color: rgba(237, 137, 54, var(--border-opacity));\n}\n\n.border-orange-600 {\n  --border-opacity: 1;\n  border-color: #dd6b20;\n  border-color: rgba(221, 107, 32, var(--border-opacity));\n}\n\n.border-orange-700 {\n  --border-opacity: 1;\n  border-color: #c05621;\n  border-color: rgba(192, 86, 33, var(--border-opacity));\n}\n\n.border-orange-800 {\n  --border-opacity: 1;\n  border-color: #9c4221;\n  border-color: rgba(156, 66, 33, var(--border-opacity));\n}\n\n.border-orange-900 {\n  --border-opacity: 1;\n  border-color: #7b341e;\n  border-color: rgba(123, 52, 30, var(--border-opacity));\n}\n\n.border-yellow-100 {\n  --border-opacity: 1;\n  border-color: #fffff0;\n  border-color: rgba(255, 255, 240, var(--border-opacity));\n}\n\n.border-yellow-200 {\n  --border-opacity: 1;\n  border-color: #fefcbf;\n  border-color: rgba(254, 252, 191, var(--border-opacity));\n}\n\n.border-yellow-300 {\n  --border-opacity: 1;\n  border-color: #faf089;\n  border-color: rgba(250, 240, 137, var(--border-opacity));\n}\n\n.border-yellow-400 {\n  --border-opacity: 1;\n  border-color: #f6e05e;\n  border-color: rgba(246, 224, 94, var(--border-opacity));\n}\n\n.border-yellow-500 {\n  --border-opacity: 1;\n  border-color: #ecc94b;\n  border-color: rgba(236, 201, 75, var(--border-opacity));\n}\n\n.border-yellow-600 {\n  --border-opacity: 1;\n  border-color: #d69e2e;\n  border-color: rgba(214, 158, 46, var(--border-opacity));\n}\n\n.border-yellow-700 {\n  --border-opacity: 1;\n  border-color: #b7791f;\n  border-color: rgba(183, 121, 31, var(--border-opacity));\n}\n\n.border-yellow-800 {\n  --border-opacity: 1;\n  border-color: #975a16;\n  border-color: rgba(151, 90, 22, var(--border-opacity));\n}\n\n.border-yellow-900 {\n  --border-opacity: 1;\n  border-color: #744210;\n  border-color: rgba(116, 66, 16, var(--border-opacity));\n}\n\n.border-green-100 {\n  --border-opacity: 1;\n  border-color: #f0fff4;\n  border-color: rgba(240, 255, 244, var(--border-opacity));\n}\n\n.border-green-200 {\n  --border-opacity: 1;\n  border-color: #c6f6d5;\n  border-color: rgba(198, 246, 213, var(--border-opacity));\n}\n\n.border-green-300 {\n  --border-opacity: 1;\n  border-color: #9ae6b4;\n  border-color: rgba(154, 230, 180, var(--border-opacity));\n}\n\n.border-green-400 {\n  --border-opacity: 1;\n  border-color: #68d391;\n  border-color: rgba(104, 211, 145, var(--border-opacity));\n}\n\n.border-green-500 {\n  --border-opacity: 1;\n  border-color: #48bb78;\n  border-color: rgba(72, 187, 120, var(--border-opacity));\n}\n\n.border-green-600 {\n  --border-opacity: 1;\n  border-color: #38a169;\n  border-color: rgba(56, 161, 105, var(--border-opacity));\n}\n\n.border-green-700 {\n  --border-opacity: 1;\n  border-color: #2f855a;\n  border-color: rgba(47, 133, 90, var(--border-opacity));\n}\n\n.border-green-800 {\n  --border-opacity: 1;\n  border-color: #276749;\n  border-color: rgba(39, 103, 73, var(--border-opacity));\n}\n\n.border-green-900 {\n  --border-opacity: 1;\n  border-color: #22543d;\n  border-color: rgba(34, 84, 61, var(--border-opacity));\n}\n\n.border-teal-100 {\n  --border-opacity: 1;\n  border-color: #e6fffa;\n  border-color: rgba(230, 255, 250, var(--border-opacity));\n}\n\n.border-teal-200 {\n  --border-opacity: 1;\n  border-color: #b2f5ea;\n  border-color: rgba(178, 245, 234, var(--border-opacity));\n}\n\n.border-teal-300 {\n  --border-opacity: 1;\n  border-color: #81e6d9;\n  border-color: rgba(129, 230, 217, var(--border-opacity));\n}\n\n.border-teal-400 {\n  --border-opacity: 1;\n  border-color: #4fd1c5;\n  border-color: rgba(79, 209, 197, var(--border-opacity));\n}\n\n.border-teal-500 {\n  --border-opacity: 1;\n  border-color: #38b2ac;\n  border-color: rgba(56, 178, 172, var(--border-opacity));\n}\n\n.border-teal-600 {\n  --border-opacity: 1;\n  border-color: #319795;\n  border-color: rgba(49, 151, 149, var(--border-opacity));\n}\n\n.border-teal-700 {\n  --border-opacity: 1;\n  border-color: #2c7a7b;\n  border-color: rgba(44, 122, 123, var(--border-opacity));\n}\n\n.border-teal-800 {\n  --border-opacity: 1;\n  border-color: #285e61;\n  border-color: rgba(40, 94, 97, var(--border-opacity));\n}\n\n.border-teal-900 {\n  --border-opacity: 1;\n  border-color: #234e52;\n  border-color: rgba(35, 78, 82, var(--border-opacity));\n}\n\n.border-blue-100 {\n  --border-opacity: 1;\n  border-color: #ebf8ff;\n  border-color: rgba(235, 248, 255, var(--border-opacity));\n}\n\n.border-blue-200 {\n  --border-opacity: 1;\n  border-color: #bee3f8;\n  border-color: rgba(190, 227, 248, var(--border-opacity));\n}\n\n.border-blue-300 {\n  --border-opacity: 1;\n  border-color: #90cdf4;\n  border-color: rgba(144, 205, 244, var(--border-opacity));\n}\n\n.border-blue-400 {\n  --border-opacity: 1;\n  border-color: #63b3ed;\n  border-color: rgba(99, 179, 237, var(--border-opacity));\n}\n\n.border-blue-500 {\n  --border-opacity: 1;\n  border-color: #4299e1;\n  border-color: rgba(66, 153, 225, var(--border-opacity));\n}\n\n.border-blue-600 {\n  --border-opacity: 1;\n  border-color: #3182ce;\n  border-color: rgba(49, 130, 206, var(--border-opacity));\n}\n\n.border-blue-700 {\n  --border-opacity: 1;\n  border-color: #2b6cb0;\n  border-color: rgba(43, 108, 176, var(--border-opacity));\n}\n\n.border-blue-800 {\n  --border-opacity: 1;\n  border-color: #2c5282;\n  border-color: rgba(44, 82, 130, var(--border-opacity));\n}\n\n.border-blue-900 {\n  --border-opacity: 1;\n  border-color: #2a4365;\n  border-color: rgba(42, 67, 101, var(--border-opacity));\n}\n\n.border-indigo-100 {\n  --border-opacity: 1;\n  border-color: #ebf4ff;\n  border-color: rgba(235, 244, 255, var(--border-opacity));\n}\n\n.border-indigo-200 {\n  --border-opacity: 1;\n  border-color: #c3dafe;\n  border-color: rgba(195, 218, 254, var(--border-opacity));\n}\n\n.border-indigo-300 {\n  --border-opacity: 1;\n  border-color: #a3bffa;\n  border-color: rgba(163, 191, 250, var(--border-opacity));\n}\n\n.border-indigo-400 {\n  --border-opacity: 1;\n  border-color: #7f9cf5;\n  border-color: rgba(127, 156, 245, var(--border-opacity));\n}\n\n.border-indigo-500 {\n  --border-opacity: 1;\n  border-color: #667eea;\n  border-color: rgba(102, 126, 234, var(--border-opacity));\n}\n\n.border-indigo-600 {\n  --border-opacity: 1;\n  border-color: #5a67d8;\n  border-color: rgba(90, 103, 216, var(--border-opacity));\n}\n\n.border-indigo-700 {\n  --border-opacity: 1;\n  border-color: #4c51bf;\n  border-color: rgba(76, 81, 191, var(--border-opacity));\n}\n\n.border-indigo-800 {\n  --border-opacity: 1;\n  border-color: #434190;\n  border-color: rgba(67, 65, 144, var(--border-opacity));\n}\n\n.border-indigo-900 {\n  --border-opacity: 1;\n  border-color: #3c366b;\n  border-color: rgba(60, 54, 107, var(--border-opacity));\n}\n\n.border-purple-100 {\n  --border-opacity: 1;\n  border-color: #faf5ff;\n  border-color: rgba(250, 245, 255, var(--border-opacity));\n}\n\n.border-purple-200 {\n  --border-opacity: 1;\n  border-color: #e9d8fd;\n  border-color: rgba(233, 216, 253, var(--border-opacity));\n}\n\n.border-purple-300 {\n  --border-opacity: 1;\n  border-color: #d6bcfa;\n  border-color: rgba(214, 188, 250, var(--border-opacity));\n}\n\n.border-purple-400 {\n  --border-opacity: 1;\n  border-color: #b794f4;\n  border-color: rgba(183, 148, 244, var(--border-opacity));\n}\n\n.border-purple-500 {\n  --border-opacity: 1;\n  border-color: #9f7aea;\n  border-color: rgba(159, 122, 234, var(--border-opacity));\n}\n\n.border-purple-600 {\n  --border-opacity: 1;\n  border-color: #805ad5;\n  border-color: rgba(128, 90, 213, var(--border-opacity));\n}\n\n.border-purple-700 {\n  --border-opacity: 1;\n  border-color: #6b46c1;\n  border-color: rgba(107, 70, 193, var(--border-opacity));\n}\n\n.border-purple-800 {\n  --border-opacity: 1;\n  border-color: #553c9a;\n  border-color: rgba(85, 60, 154, var(--border-opacity));\n}\n\n.border-purple-900 {\n  --border-opacity: 1;\n  border-color: #44337a;\n  border-color: rgba(68, 51, 122, var(--border-opacity));\n}\n\n.border-pink-100 {\n  --border-opacity: 1;\n  border-color: #fff5f7;\n  border-color: rgba(255, 245, 247, var(--border-opacity));\n}\n\n.border-pink-200 {\n  --border-opacity: 1;\n  border-color: #fed7e2;\n  border-color: rgba(254, 215, 226, var(--border-opacity));\n}\n\n.border-pink-300 {\n  --border-opacity: 1;\n  border-color: #fbb6ce;\n  border-color: rgba(251, 182, 206, var(--border-opacity));\n}\n\n.border-pink-400 {\n  --border-opacity: 1;\n  border-color: #f687b3;\n  border-color: rgba(246, 135, 179, var(--border-opacity));\n}\n\n.border-pink-500 {\n  --border-opacity: 1;\n  border-color: #ed64a6;\n  border-color: rgba(237, 100, 166, var(--border-opacity));\n}\n\n.border-pink-600 {\n  --border-opacity: 1;\n  border-color: #d53f8c;\n  border-color: rgba(213, 63, 140, var(--border-opacity));\n}\n\n.border-pink-700 {\n  --border-opacity: 1;\n  border-color: #b83280;\n  border-color: rgba(184, 50, 128, var(--border-opacity));\n}\n\n.border-pink-800 {\n  --border-opacity: 1;\n  border-color: #97266d;\n  border-color: rgba(151, 38, 109, var(--border-opacity));\n}\n\n.border-pink-900 {\n  --border-opacity: 1;\n  border-color: #702459;\n  border-color: rgba(112, 36, 89, var(--border-opacity));\n}\n\n.hover\\:border-transparent:hover {\n  border-color: transparent;\n}\n\n.hover\\:border-current:hover {\n  border-color: currentColor;\n}\n\n.hover\\:border-black:hover {\n  --border-opacity: 1;\n  border-color: #000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n\n.hover\\:border-white:hover {\n  --border-opacity: 1;\n  border-color: #fff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n\n.hover\\:border-gray-100:hover {\n  --border-opacity: 1;\n  border-color: #f7fafc;\n  border-color: rgba(247, 250, 252, var(--border-opacity));\n}\n\n.hover\\:border-gray-200:hover {\n  --border-opacity: 1;\n  border-color: #edf2f7;\n  border-color: rgba(237, 242, 247, var(--border-opacity));\n}\n\n.hover\\:border-gray-300:hover {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n\n.hover\\:border-gray-400:hover {\n  --border-opacity: 1;\n  border-color: #cbd5e0;\n  border-color: rgba(203, 213, 224, var(--border-opacity));\n}\n\n.hover\\:border-gray-500:hover {\n  --border-opacity: 1;\n  border-color: #a0aec0;\n  border-color: rgba(160, 174, 192, var(--border-opacity));\n}\n\n.hover\\:border-gray-600:hover {\n  --border-opacity: 1;\n  border-color: #718096;\n  border-color: rgba(113, 128, 150, var(--border-opacity));\n}\n\n.hover\\:border-gray-700:hover {\n  --border-opacity: 1;\n  border-color: #4a5568;\n  border-color: rgba(74, 85, 104, var(--border-opacity));\n}\n\n.hover\\:border-gray-800:hover {\n  --border-opacity: 1;\n  border-color: #2d3748;\n  border-color: rgba(45, 55, 72, var(--border-opacity));\n}\n\n.hover\\:border-gray-900:hover {\n  --border-opacity: 1;\n  border-color: #1a202c;\n  border-color: rgba(26, 32, 44, var(--border-opacity));\n}\n\n.hover\\:border-red-100:hover {\n  --border-opacity: 1;\n  border-color: #fff5f5;\n  border-color: rgba(255, 245, 245, var(--border-opacity));\n}\n\n.hover\\:border-red-200:hover {\n  --border-opacity: 1;\n  border-color: #fed7d7;\n  border-color: rgba(254, 215, 215, var(--border-opacity));\n}\n\n.hover\\:border-red-300:hover {\n  --border-opacity: 1;\n  border-color: #feb2b2;\n  border-color: rgba(254, 178, 178, var(--border-opacity));\n}\n\n.hover\\:border-red-400:hover {\n  --border-opacity: 1;\n  border-color: #fc8181;\n  border-color: rgba(252, 129, 129, var(--border-opacity));\n}\n\n.hover\\:border-red-500:hover {\n  --border-opacity: 1;\n  border-color: #f56565;\n  border-color: rgba(245, 101, 101, var(--border-opacity));\n}\n\n.hover\\:border-red-600:hover {\n  --border-opacity: 1;\n  border-color: #e53e3e;\n  border-color: rgba(229, 62, 62, var(--border-opacity));\n}\n\n.hover\\:border-red-700:hover {\n  --border-opacity: 1;\n  border-color: #c53030;\n  border-color: rgba(197, 48, 48, var(--border-opacity));\n}\n\n.hover\\:border-red-800:hover {\n  --border-opacity: 1;\n  border-color: #9b2c2c;\n  border-color: rgba(155, 44, 44, var(--border-opacity));\n}\n\n.hover\\:border-red-900:hover {\n  --border-opacity: 1;\n  border-color: #742a2a;\n  border-color: rgba(116, 42, 42, var(--border-opacity));\n}\n\n.hover\\:border-orange-100:hover {\n  --border-opacity: 1;\n  border-color: #fffaf0;\n  border-color: rgba(255, 250, 240, var(--border-opacity));\n}\n\n.hover\\:border-orange-200:hover {\n  --border-opacity: 1;\n  border-color: #feebc8;\n  border-color: rgba(254, 235, 200, var(--border-opacity));\n}\n\n.hover\\:border-orange-300:hover {\n  --border-opacity: 1;\n  border-color: #fbd38d;\n  border-color: rgba(251, 211, 141, var(--border-opacity));\n}\n\n.hover\\:border-orange-400:hover {\n  --border-opacity: 1;\n  border-color: #f6ad55;\n  border-color: rgba(246, 173, 85, var(--border-opacity));\n}\n\n.hover\\:border-orange-500:hover {\n  --border-opacity: 1;\n  border-color: #ed8936;\n  border-color: rgba(237, 137, 54, var(--border-opacity));\n}\n\n.hover\\:border-orange-600:hover {\n  --border-opacity: 1;\n  border-color: #dd6b20;\n  border-color: rgba(221, 107, 32, var(--border-opacity));\n}\n\n.hover\\:border-orange-700:hover {\n  --border-opacity: 1;\n  border-color: #c05621;\n  border-color: rgba(192, 86, 33, var(--border-opacity));\n}\n\n.hover\\:border-orange-800:hover {\n  --border-opacity: 1;\n  border-color: #9c4221;\n  border-color: rgba(156, 66, 33, var(--border-opacity));\n}\n\n.hover\\:border-orange-900:hover {\n  --border-opacity: 1;\n  border-color: #7b341e;\n  border-color: rgba(123, 52, 30, var(--border-opacity));\n}\n\n.hover\\:border-yellow-100:hover {\n  --border-opacity: 1;\n  border-color: #fffff0;\n  border-color: rgba(255, 255, 240, var(--border-opacity));\n}\n\n.hover\\:border-yellow-200:hover {\n  --border-opacity: 1;\n  border-color: #fefcbf;\n  border-color: rgba(254, 252, 191, var(--border-opacity));\n}\n\n.hover\\:border-yellow-300:hover {\n  --border-opacity: 1;\n  border-color: #faf089;\n  border-color: rgba(250, 240, 137, var(--border-opacity));\n}\n\n.hover\\:border-yellow-400:hover {\n  --border-opacity: 1;\n  border-color: #f6e05e;\n  border-color: rgba(246, 224, 94, var(--border-opacity));\n}\n\n.hover\\:border-yellow-500:hover {\n  --border-opacity: 1;\n  border-color: #ecc94b;\n  border-color: rgba(236, 201, 75, var(--border-opacity));\n}\n\n.hover\\:border-yellow-600:hover {\n  --border-opacity: 1;\n  border-color: #d69e2e;\n  border-color: rgba(214, 158, 46, var(--border-opacity));\n}\n\n.hover\\:border-yellow-700:hover {\n  --border-opacity: 1;\n  border-color: #b7791f;\n  border-color: rgba(183, 121, 31, var(--border-opacity));\n}\n\n.hover\\:border-yellow-800:hover {\n  --border-opacity: 1;\n  border-color: #975a16;\n  border-color: rgba(151, 90, 22, var(--border-opacity));\n}\n\n.hover\\:border-yellow-900:hover {\n  --border-opacity: 1;\n  border-color: #744210;\n  border-color: rgba(116, 66, 16, var(--border-opacity));\n}\n\n.hover\\:border-green-100:hover {\n  --border-opacity: 1;\n  border-color: #f0fff4;\n  border-color: rgba(240, 255, 244, var(--border-opacity));\n}\n\n.hover\\:border-green-200:hover {\n  --border-opacity: 1;\n  border-color: #c6f6d5;\n  border-color: rgba(198, 246, 213, var(--border-opacity));\n}\n\n.hover\\:border-green-300:hover {\n  --border-opacity: 1;\n  border-color: #9ae6b4;\n  border-color: rgba(154, 230, 180, var(--border-opacity));\n}\n\n.hover\\:border-green-400:hover {\n  --border-opacity: 1;\n  border-color: #68d391;\n  border-color: rgba(104, 211, 145, var(--border-opacity));\n}\n\n.hover\\:border-green-500:hover {\n  --border-opacity: 1;\n  border-color: #48bb78;\n  border-color: rgba(72, 187, 120, var(--border-opacity));\n}\n\n.hover\\:border-green-600:hover {\n  --border-opacity: 1;\n  border-color: #38a169;\n  border-color: rgba(56, 161, 105, var(--border-opacity));\n}\n\n.hover\\:border-green-700:hover {\n  --border-opacity: 1;\n  border-color: #2f855a;\n  border-color: rgba(47, 133, 90, var(--border-opacity));\n}\n\n.hover\\:border-green-800:hover {\n  --border-opacity: 1;\n  border-color: #276749;\n  border-color: rgba(39, 103, 73, var(--border-opacity));\n}\n\n.hover\\:border-green-900:hover {\n  --border-opacity: 1;\n  border-color: #22543d;\n  border-color: rgba(34, 84, 61, var(--border-opacity));\n}\n\n.hover\\:border-teal-100:hover {\n  --border-opacity: 1;\n  border-color: #e6fffa;\n  border-color: rgba(230, 255, 250, var(--border-opacity));\n}\n\n.hover\\:border-teal-200:hover {\n  --border-opacity: 1;\n  border-color: #b2f5ea;\n  border-color: rgba(178, 245, 234, var(--border-opacity));\n}\n\n.hover\\:border-teal-300:hover {\n  --border-opacity: 1;\n  border-color: #81e6d9;\n  border-color: rgba(129, 230, 217, var(--border-opacity));\n}\n\n.hover\\:border-teal-400:hover {\n  --border-opacity: 1;\n  border-color: #4fd1c5;\n  border-color: rgba(79, 209, 197, var(--border-opacity));\n}\n\n.hover\\:border-teal-500:hover {\n  --border-opacity: 1;\n  border-color: #38b2ac;\n  border-color: rgba(56, 178, 172, var(--border-opacity));\n}\n\n.hover\\:border-teal-600:hover {\n  --border-opacity: 1;\n  border-color: #319795;\n  border-color: rgba(49, 151, 149, var(--border-opacity));\n}\n\n.hover\\:border-teal-700:hover {\n  --border-opacity: 1;\n  border-color: #2c7a7b;\n  border-color: rgba(44, 122, 123, var(--border-opacity));\n}\n\n.hover\\:border-teal-800:hover {\n  --border-opacity: 1;\n  border-color: #285e61;\n  border-color: rgba(40, 94, 97, var(--border-opacity));\n}\n\n.hover\\:border-teal-900:hover {\n  --border-opacity: 1;\n  border-color: #234e52;\n  border-color: rgba(35, 78, 82, var(--border-opacity));\n}\n\n.hover\\:border-blue-100:hover {\n  --border-opacity: 1;\n  border-color: #ebf8ff;\n  border-color: rgba(235, 248, 255, var(--border-opacity));\n}\n\n.hover\\:border-blue-200:hover {\n  --border-opacity: 1;\n  border-color: #bee3f8;\n  border-color: rgba(190, 227, 248, var(--border-opacity));\n}\n\n.hover\\:border-blue-300:hover {\n  --border-opacity: 1;\n  border-color: #90cdf4;\n  border-color: rgba(144, 205, 244, var(--border-opacity));\n}\n\n.hover\\:border-blue-400:hover {\n  --border-opacity: 1;\n  border-color: #63b3ed;\n  border-color: rgba(99, 179, 237, var(--border-opacity));\n}\n\n.hover\\:border-blue-500:hover {\n  --border-opacity: 1;\n  border-color: #4299e1;\n  border-color: rgba(66, 153, 225, var(--border-opacity));\n}\n\n.hover\\:border-blue-600:hover {\n  --border-opacity: 1;\n  border-color: #3182ce;\n  border-color: rgba(49, 130, 206, var(--border-opacity));\n}\n\n.hover\\:border-blue-700:hover {\n  --border-opacity: 1;\n  border-color: #2b6cb0;\n  border-color: rgba(43, 108, 176, var(--border-opacity));\n}\n\n.hover\\:border-blue-800:hover {\n  --border-opacity: 1;\n  border-color: #2c5282;\n  border-color: rgba(44, 82, 130, var(--border-opacity));\n}\n\n.hover\\:border-blue-900:hover {\n  --border-opacity: 1;\n  border-color: #2a4365;\n  border-color: rgba(42, 67, 101, var(--border-opacity));\n}\n\n.hover\\:border-indigo-100:hover {\n  --border-opacity: 1;\n  border-color: #ebf4ff;\n  border-color: rgba(235, 244, 255, var(--border-opacity));\n}\n\n.hover\\:border-indigo-200:hover {\n  --border-opacity: 1;\n  border-color: #c3dafe;\n  border-color: rgba(195, 218, 254, var(--border-opacity));\n}\n\n.hover\\:border-indigo-300:hover {\n  --border-opacity: 1;\n  border-color: #a3bffa;\n  border-color: rgba(163, 191, 250, var(--border-opacity));\n}\n\n.hover\\:border-indigo-400:hover {\n  --border-opacity: 1;\n  border-color: #7f9cf5;\n  border-color: rgba(127, 156, 245, var(--border-opacity));\n}\n\n.hover\\:border-indigo-500:hover {\n  --border-opacity: 1;\n  border-color: #667eea;\n  border-color: rgba(102, 126, 234, var(--border-opacity));\n}\n\n.hover\\:border-indigo-600:hover {\n  --border-opacity: 1;\n  border-color: #5a67d8;\n  border-color: rgba(90, 103, 216, var(--border-opacity));\n}\n\n.hover\\:border-indigo-700:hover {\n  --border-opacity: 1;\n  border-color: #4c51bf;\n  border-color: rgba(76, 81, 191, var(--border-opacity));\n}\n\n.hover\\:border-indigo-800:hover {\n  --border-opacity: 1;\n  border-color: #434190;\n  border-color: rgba(67, 65, 144, var(--border-opacity));\n}\n\n.hover\\:border-indigo-900:hover {\n  --border-opacity: 1;\n  border-color: #3c366b;\n  border-color: rgba(60, 54, 107, var(--border-opacity));\n}\n\n.hover\\:border-purple-100:hover {\n  --border-opacity: 1;\n  border-color: #faf5ff;\n  border-color: rgba(250, 245, 255, var(--border-opacity));\n}\n\n.hover\\:border-purple-200:hover {\n  --border-opacity: 1;\n  border-color: #e9d8fd;\n  border-color: rgba(233, 216, 253, var(--border-opacity));\n}\n\n.hover\\:border-purple-300:hover {\n  --border-opacity: 1;\n  border-color: #d6bcfa;\n  border-color: rgba(214, 188, 250, var(--border-opacity));\n}\n\n.hover\\:border-purple-400:hover {\n  --border-opacity: 1;\n  border-color: #b794f4;\n  border-color: rgba(183, 148, 244, var(--border-opacity));\n}\n\n.hover\\:border-purple-500:hover {\n  --border-opacity: 1;\n  border-color: #9f7aea;\n  border-color: rgba(159, 122, 234, var(--border-opacity));\n}\n\n.hover\\:border-purple-600:hover {\n  --border-opacity: 1;\n  border-color: #805ad5;\n  border-color: rgba(128, 90, 213, var(--border-opacity));\n}\n\n.hover\\:border-purple-700:hover {\n  --border-opacity: 1;\n  border-color: #6b46c1;\n  border-color: rgba(107, 70, 193, var(--border-opacity));\n}\n\n.hover\\:border-purple-800:hover {\n  --border-opacity: 1;\n  border-color: #553c9a;\n  border-color: rgba(85, 60, 154, var(--border-opacity));\n}\n\n.hover\\:border-purple-900:hover {\n  --border-opacity: 1;\n  border-color: #44337a;\n  border-color: rgba(68, 51, 122, var(--border-opacity));\n}\n\n.hover\\:border-pink-100:hover {\n  --border-opacity: 1;\n  border-color: #fff5f7;\n  border-color: rgba(255, 245, 247, var(--border-opacity));\n}\n\n.hover\\:border-pink-200:hover {\n  --border-opacity: 1;\n  border-color: #fed7e2;\n  border-color: rgba(254, 215, 226, var(--border-opacity));\n}\n\n.hover\\:border-pink-300:hover {\n  --border-opacity: 1;\n  border-color: #fbb6ce;\n  border-color: rgba(251, 182, 206, var(--border-opacity));\n}\n\n.hover\\:border-pink-400:hover {\n  --border-opacity: 1;\n  border-color: #f687b3;\n  border-color: rgba(246, 135, 179, var(--border-opacity));\n}\n\n.hover\\:border-pink-500:hover {\n  --border-opacity: 1;\n  border-color: #ed64a6;\n  border-color: rgba(237, 100, 166, var(--border-opacity));\n}\n\n.hover\\:border-pink-600:hover {\n  --border-opacity: 1;\n  border-color: #d53f8c;\n  border-color: rgba(213, 63, 140, var(--border-opacity));\n}\n\n.hover\\:border-pink-700:hover {\n  --border-opacity: 1;\n  border-color: #b83280;\n  border-color: rgba(184, 50, 128, var(--border-opacity));\n}\n\n.hover\\:border-pink-800:hover {\n  --border-opacity: 1;\n  border-color: #97266d;\n  border-color: rgba(151, 38, 109, var(--border-opacity));\n}\n\n.hover\\:border-pink-900:hover {\n  --border-opacity: 1;\n  border-color: #702459;\n  border-color: rgba(112, 36, 89, var(--border-opacity));\n}\n\n.focus\\:border-transparent:focus {\n  border-color: transparent;\n}\n\n.focus\\:border-current:focus {\n  border-color: currentColor;\n}\n\n.focus\\:border-black:focus {\n  --border-opacity: 1;\n  border-color: #000;\n  border-color: rgba(0, 0, 0, var(--border-opacity));\n}\n\n.focus\\:border-white:focus {\n  --border-opacity: 1;\n  border-color: #fff;\n  border-color: rgba(255, 255, 255, var(--border-opacity));\n}\n\n.focus\\:border-gray-100:focus {\n  --border-opacity: 1;\n  border-color: #f7fafc;\n  border-color: rgba(247, 250, 252, var(--border-opacity));\n}\n\n.focus\\:border-gray-200:focus {\n  --border-opacity: 1;\n  border-color: #edf2f7;\n  border-color: rgba(237, 242, 247, var(--border-opacity));\n}\n\n.focus\\:border-gray-300:focus {\n  --border-opacity: 1;\n  border-color: #e2e8f0;\n  border-color: rgba(226, 232, 240, var(--border-opacity));\n}\n\n.focus\\:border-gray-400:focus {\n  --border-opacity: 1;\n  border-color: #cbd5e0;\n  border-color: rgba(203, 213, 224, var(--border-opacity));\n}\n\n.focus\\:border-gray-500:focus {\n  --border-opacity: 1;\n  border-color: #a0aec0;\n  border-color: rgba(160, 174, 192, var(--border-opacity));\n}\n\n.focus\\:border-gray-600:focus {\n  --border-opacity: 1;\n  border-color: #718096;\n  border-color: rgba(113, 128, 150, var(--border-opacity));\n}\n\n.focus\\:border-gray-700:focus {\n  --border-opacity: 1;\n  border-color: #4a5568;\n  border-color: rgba(74, 85, 104, var(--border-opacity));\n}\n\n.focus\\:border-gray-800:focus {\n  --border-opacity: 1;\n  border-color: #2d3748;\n  border-color: rgba(45, 55, 72, var(--border-opacity));\n}\n\n.focus\\:border-gray-900:focus {\n  --border-opacity: 1;\n  border-color: #1a202c;\n  border-color: rgba(26, 32, 44, var(--border-opacity));\n}\n\n.focus\\:border-red-100:focus {\n  --border-opacity: 1;\n  border-color: #fff5f5;\n  border-color: rgba(255, 245, 245, var(--border-opacity));\n}\n\n.focus\\:border-red-200:focus {\n  --border-opacity: 1;\n  border-color: #fed7d7;\n  border-color: rgba(254, 215, 215, var(--border-opacity));\n}\n\n.focus\\:border-red-300:focus {\n  --border-opacity: 1;\n  border-color: #feb2b2;\n  border-color: rgba(254, 178, 178, var(--border-opacity));\n}\n\n.focus\\:border-red-400:focus {\n  --border-opacity: 1;\n  border-color: #fc8181;\n  border-color: rgba(252, 129, 129, var(--border-opacity));\n}\n\n.focus\\:border-red-500:focus {\n  --border-opacity: 1;\n  border-color: #f56565;\n  border-color: rgba(245, 101, 101, var(--border-opacity));\n}\n\n.focus\\:border-red-600:focus {\n  --border-opacity: 1;\n  border-color: #e53e3e;\n  border-color: rgba(229, 62, 62, var(--border-opacity));\n}\n\n.focus\\:border-red-700:focus {\n  --border-opacity: 1;\n  border-color: #c53030;\n  border-color: rgba(197, 48, 48, var(--border-opacity));\n}\n\n.focus\\:border-red-800:focus {\n  --border-opacity: 1;\n  border-color: #9b2c2c;\n  border-color: rgba(155, 44, 44, var(--border-opacity));\n}\n\n.focus\\:border-red-900:focus {\n  --border-opacity: 1;\n  border-color: #742a2a;\n  border-color: rgba(116, 42, 42, var(--border-opacity));\n}\n\n.focus\\:border-orange-100:focus {\n  --border-opacity: 1;\n  border-color: #fffaf0;\n  border-color: rgba(255, 250, 240, var(--border-opacity));\n}\n\n.focus\\:border-orange-200:focus {\n  --border-opacity: 1;\n  border-color: #feebc8;\n  border-color: rgba(254, 235, 200, var(--border-opacity));\n}\n\n.focus\\:border-orange-300:focus {\n  --border-opacity: 1;\n  border-color: #fbd38d;\n  border-color: rgba(251, 211, 141, var(--border-opacity));\n}\n\n.focus\\:border-orange-400:focus {\n  --border-opacity: 1;\n  border-color: #f6ad55;\n  border-color: rgba(246, 173, 85, var(--border-opacity));\n}\n\n.focus\\:border-orange-500:focus {\n  --border-opacity: 1;\n  border-color: #ed8936;\n  border-color: rgba(237, 137, 54, var(--border-opacity));\n}\n\n.focus\\:border-orange-600:focus {\n  --border-opacity: 1;\n  border-color: #dd6b20;\n  border-color: rgba(221, 107, 32, var(--border-opacity));\n}\n\n.focus\\:border-orange-700:focus {\n  --border-opacity: 1;\n  border-color: #c05621;\n  border-color: rgba(192, 86, 33, var(--border-opacity));\n}\n\n.focus\\:border-orange-800:focus {\n  --border-opacity: 1;\n  border-color: #9c4221;\n  border-color: rgba(156, 66, 33, var(--border-opacity));\n}\n\n.focus\\:border-orange-900:focus {\n  --border-opacity: 1;\n  border-color: #7b341e;\n  border-color: rgba(123, 52, 30, var(--border-opacity));\n}\n\n.focus\\:border-yellow-100:focus {\n  --border-opacity: 1;\n  border-color: #fffff0;\n  border-color: rgba(255, 255, 240, var(--border-opacity));\n}\n\n.focus\\:border-yellow-200:focus {\n  --border-opacity: 1;\n  border-color: #fefcbf;\n  border-color: rgba(254, 252, 191, var(--border-opacity));\n}\n\n.focus\\:border-yellow-300:focus {\n  --border-opacity: 1;\n  border-color: #faf089;\n  border-color: rgba(250, 240, 137, var(--border-opacity));\n}\n\n.focus\\:border-yellow-400:focus {\n  --border-opacity: 1;\n  border-color: #f6e05e;\n  border-color: rgba(246, 224, 94, var(--border-opacity));\n}\n\n.focus\\:border-yellow-500:focus {\n  --border-opacity: 1;\n  border-color: #ecc94b;\n  border-color: rgba(236, 201, 75, var(--border-opacity));\n}\n\n.focus\\:border-yellow-600:focus {\n  --border-opacity: 1;\n  border-color: #d69e2e;\n  border-color: rgba(214, 158, 46, var(--border-opacity));\n}\n\n.focus\\:border-yellow-700:focus {\n  --border-opacity: 1;\n  border-color: #b7791f;\n  border-color: rgba(183, 121, 31, var(--border-opacity));\n}\n\n.focus\\:border-yellow-800:focus {\n  --border-opacity: 1;\n  border-color: #975a16;\n  border-color: rgba(151, 90, 22, var(--border-opacity));\n}\n\n.focus\\:border-yellow-900:focus {\n  --border-opacity: 1;\n  border-color: #744210;\n  border-color: rgba(116, 66, 16, var(--border-opacity));\n}\n\n.focus\\:border-green-100:focus {\n  --border-opacity: 1;\n  border-color: #f0fff4;\n  border-color: rgba(240, 255, 244, var(--border-opacity));\n}\n\n.focus\\:border-green-200:focus {\n  --border-opacity: 1;\n  border-color: #c6f6d5;\n  border-color: rgba(198, 246, 213, var(--border-opacity));\n}\n\n.focus\\:border-green-300:focus {\n  --border-opacity: 1;\n  border-color: #9ae6b4;\n  border-color: rgba(154, 230, 180, var(--border-opacity));\n}\n\n.focus\\:border-green-400:focus {\n  --border-opacity: 1;\n  border-color: #68d391;\n  border-color: rgba(104, 211, 145, var(--border-opacity));\n}\n\n.focus\\:border-green-500:focus {\n  --border-opacity: 1;\n  border-color: #48bb78;\n  border-color: rgba(72, 187, 120, var(--border-opacity));\n}\n\n.focus\\:border-green-600:focus {\n  --border-opacity: 1;\n  border-color: #38a169;\n  border-color: rgba(56, 161, 105, var(--border-opacity));\n}\n\n.focus\\:border-green-700:focus {\n  --border-opacity: 1;\n  border-color: #2f855a;\n  border-color: rgba(47, 133, 90, var(--border-opacity));\n}\n\n.focus\\:border-green-800:focus {\n  --border-opacity: 1;\n  border-color: #276749;\n  border-color: rgba(39, 103, 73, var(--border-opacity));\n}\n\n.focus\\:border-green-900:focus {\n  --border-opacity: 1;\n  border-color: #22543d;\n  border-color: rgba(34, 84, 61, var(--border-opacity));\n}\n\n.focus\\:border-teal-100:focus {\n  --border-opacity: 1;\n  border-color: #e6fffa;\n  border-color: rgba(230, 255, 250, var(--border-opacity));\n}\n\n.focus\\:border-teal-200:focus {\n  --border-opacity: 1;\n  border-color: #b2f5ea;\n  border-color: rgba(178, 245, 234, var(--border-opacity));\n}\n\n.focus\\:border-teal-300:focus {\n  --border-opacity: 1;\n  border-color: #81e6d9;\n  border-color: rgba(129, 230, 217, var(--border-opacity));\n}\n\n.focus\\:border-teal-400:focus {\n  --border-opacity: 1;\n  border-color: #4fd1c5;\n  border-color: rgba(79, 209, 197, var(--border-opacity));\n}\n\n.focus\\:border-teal-500:focus {\n  --border-opacity: 1;\n  border-color: #38b2ac;\n  border-color: rgba(56, 178, 172, var(--border-opacity));\n}\n\n.focus\\:border-teal-600:focus {\n  --border-opacity: 1;\n  border-color: #319795;\n  border-color: rgba(49, 151, 149, var(--border-opacity));\n}\n\n.focus\\:border-teal-700:focus {\n  --border-opacity: 1;\n  border-color: #2c7a7b;\n  border-color: rgba(44, 122, 123, var(--border-opacity));\n}\n\n.focus\\:border-teal-800:focus {\n  --border-opacity: 1;\n  border-color: #285e61;\n  border-color: rgba(40, 94, 97, var(--border-opacity));\n}\n\n.focus\\:border-teal-900:focus {\n  --border-opacity: 1;\n  border-color: #234e52;\n  border-color: rgba(35, 78, 82, var(--border-opacity));\n}\n\n.focus\\:border-blue-100:focus {\n  --border-opacity: 1;\n  border-color: #ebf8ff;\n  border-color: rgba(235, 248, 255, var(--border-opacity));\n}\n\n.focus\\:border-blue-200:focus {\n  --border-opacity: 1;\n  border-color: #bee3f8;\n  border-color: rgba(190, 227, 248, var(--border-opacity));\n}\n\n.focus\\:border-blue-300:focus {\n  --border-opacity: 1;\n  border-color: #90cdf4;\n  border-color: rgba(144, 205, 244, var(--border-opacity));\n}\n\n.focus\\:border-blue-400:focus {\n  --border-opacity: 1;\n  border-color: #63b3ed;\n  border-color: rgba(99, 179, 237, var(--border-opacity));\n}\n\n.focus\\:border-blue-500:focus {\n  --border-opacity: 1;\n  border-color: #4299e1;\n  border-color: rgba(66, 153, 225, var(--border-opacity));\n}\n\n.focus\\:border-blue-600:focus {\n  --border-opacity: 1;\n  border-color: #3182ce;\n  border-color: rgba(49, 130, 206, var(--border-opacity));\n}\n\n.focus\\:border-blue-700:focus {\n  --border-opacity: 1;\n  border-color: #2b6cb0;\n  border-color: rgba(43, 108, 176, var(--border-opacity));\n}\n\n.focus\\:border-blue-800:focus {\n  --border-opacity: 1;\n  border-color: #2c5282;\n  border-color: rgba(44, 82, 130, var(--border-opacity));\n}\n\n.focus\\:border-blue-900:focus {\n  --border-opacity: 1;\n  border-color: #2a4365;\n  border-color: rgba(42, 67, 101, var(--border-opacity));\n}\n\n.focus\\:border-indigo-100:focus {\n  --border-opacity: 1;\n  border-color: #ebf4ff;\n  border-color: rgba(235, 244, 255, var(--border-opacity));\n}\n\n.focus\\:border-indigo-200:focus {\n  --border-opacity: 1;\n  border-color: #c3dafe;\n  border-color: rgba(195, 218, 254, var(--border-opacity));\n}\n\n.focus\\:border-indigo-300:focus {\n  --border-opacity: 1;\n  border-color: #a3bffa;\n  border-color: rgba(163, 191, 250, var(--border-opacity));\n}\n\n.focus\\:border-indigo-400:focus {\n  --border-opacity: 1;\n  border-color: #7f9cf5;\n  border-color: rgba(127, 156, 245, var(--border-opacity));\n}\n\n.focus\\:border-indigo-500:focus {\n  --border-opacity: 1;\n  border-color: #667eea;\n  border-color: rgba(102, 126, 234, var(--border-opacity));\n}\n\n.focus\\:border-indigo-600:focus {\n  --border-opacity: 1;\n  border-color: #5a67d8;\n  border-color: rgba(90, 103, 216, var(--border-opacity));\n}\n\n.focus\\:border-indigo-700:focus {\n  --border-opacity: 1;\n  border-color: #4c51bf;\n  border-color: rgba(76, 81, 191, var(--border-opacity));\n}\n\n.focus\\:border-indigo-800:focus {\n  --border-opacity: 1;\n  border-color: #434190;\n  border-color: rgba(67, 65, 144, var(--border-opacity));\n}\n\n.focus\\:border-indigo-900:focus {\n  --border-opacity: 1;\n  border-color: #3c366b;\n  border-color: rgba(60, 54, 107, var(--border-opacity));\n}\n\n.focus\\:border-purple-100:focus {\n  --border-opacity: 1;\n  border-color: #faf5ff;\n  border-color: rgba(250, 245, 255, var(--border-opacity));\n}\n\n.focus\\:border-purple-200:focus {\n  --border-opacity: 1;\n  border-color: #e9d8fd;\n  border-color: rgba(233, 216, 253, var(--border-opacity));\n}\n\n.focus\\:border-purple-300:focus {\n  --border-opacity: 1;\n  border-color: #d6bcfa;\n  border-color: rgba(214, 188, 250, var(--border-opacity));\n}\n\n.focus\\:border-purple-400:focus {\n  --border-opacity: 1;\n  border-color: #b794f4;\n  border-color: rgba(183, 148, 244, var(--border-opacity));\n}\n\n.focus\\:border-purple-500:focus {\n  --border-opacity: 1;\n  border-color: #9f7aea;\n  border-color: rgba(159, 122, 234, var(--border-opacity));\n}\n\n.focus\\:border-purple-600:focus {\n  --border-opacity: 1;\n  border-color: #805ad5;\n  border-color: rgba(128, 90, 213, var(--border-opacity));\n}\n\n.focus\\:border-purple-700:focus {\n  --border-opacity: 1;\n  border-color: #6b46c1;\n  border-color: rgba(107, 70, 193, var(--border-opacity));\n}\n\n.focus\\:border-purple-800:focus {\n  --border-opacity: 1;\n  border-color: #553c9a;\n  border-color: rgba(85, 60, 154, var(--border-opacity));\n}\n\n.focus\\:border-purple-900:focus {\n  --border-opacity: 1;\n  border-color: #44337a;\n  border-color: rgba(68, 51, 122, var(--border-opacity));\n}\n\n.focus\\:border-pink-100:focus {\n  --border-opacity: 1;\n  border-color: #fff5f7;\n  border-color: rgba(255, 245, 247, var(--border-opacity));\n}\n\n.focus\\:border-pink-200:focus {\n  --border-opacity: 1;\n  border-color: #fed7e2;\n  border-color: rgba(254, 215, 226, var(--border-opacity));\n}\n\n.focus\\:border-pink-300:focus {\n  --border-opacity: 1;\n  border-color: #fbb6ce;\n  border-color: rgba(251, 182, 206, var(--border-opacity));\n}\n\n.focus\\:border-pink-400:focus {\n  --border-opacity: 1;\n  border-color: #f687b3;\n  border-color: rgba(246, 135, 179, var(--border-opacity));\n}\n\n.focus\\:border-pink-500:focus {\n  --border-opacity: 1;\n  border-color: #ed64a6;\n  border-color: rgba(237, 100, 166, var(--border-opacity));\n}\n\n.focus\\:border-pink-600:focus {\n  --border-opacity: 1;\n  border-color: #d53f8c;\n  border-color: rgba(213, 63, 140, var(--border-opacity));\n}\n\n.focus\\:border-pink-700:focus {\n  --border-opacity: 1;\n  border-color: #b83280;\n  border-color: rgba(184, 50, 128, var(--border-opacity));\n}\n\n.focus\\:border-pink-800:focus {\n  --border-opacity: 1;\n  border-color: #97266d;\n  border-color: rgba(151, 38, 109, var(--border-opacity));\n}\n\n.focus\\:border-pink-900:focus {\n  --border-opacity: 1;\n  border-color: #702459;\n  border-color: rgba(112, 36, 89, var(--border-opacity));\n}\n\n.border-opacity-0 {\n  --border-opacity: 0;\n}\n\n.border-opacity-25 {\n  --border-opacity: 0.25;\n}\n\n.border-opacity-50 {\n  --border-opacity: 0.5;\n}\n\n.border-opacity-75 {\n  --border-opacity: 0.75;\n}\n\n.border-opacity-100 {\n  --border-opacity: 1;\n}\n\n.hover\\:border-opacity-0:hover {\n  --border-opacity: 0;\n}\n\n.hover\\:border-opacity-25:hover {\n  --border-opacity: 0.25;\n}\n\n.hover\\:border-opacity-50:hover {\n  --border-opacity: 0.5;\n}\n\n.hover\\:border-opacity-75:hover {\n  --border-opacity: 0.75;\n}\n\n.hover\\:border-opacity-100:hover {\n  --border-opacity: 1;\n}\n\n.focus\\:border-opacity-0:focus {\n  --border-opacity: 0;\n}\n\n.focus\\:border-opacity-25:focus {\n  --border-opacity: 0.25;\n}\n\n.focus\\:border-opacity-50:focus {\n  --border-opacity: 0.5;\n}\n\n.focus\\:border-opacity-75:focus {\n  --border-opacity: 0.75;\n}\n\n.focus\\:border-opacity-100:focus {\n  --border-opacity: 1;\n}\n\n.rounded-none {\n  border-radius: 0;\n}\n\n.rounded-sm {\n  border-radius: 0.125rem;\n}\n\n.rounded {\n  border-radius: 0.25rem;\n}\n\n.rounded-md {\n  border-radius: 0.375rem;\n}\n\n.rounded-lg {\n  border-radius: 0.5rem;\n}\n\n.rounded-xl {\n  border-radius: 0.75rem;\n}\n\n.rounded-2xl {\n  border-radius: 1rem;\n}\n\n.rounded-3xl {\n  border-radius: 1.5rem;\n}\n\n.rounded-full {\n  border-radius: 9999px;\n}\n\n.rounded-t-none {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.rounded-r-none {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.rounded-b-none {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rounded-l-none {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.rounded-t-sm {\n  border-top-left-radius: 0.125rem;\n  border-top-right-radius: 0.125rem;\n}\n\n.rounded-r-sm {\n  border-top-right-radius: 0.125rem;\n  border-bottom-right-radius: 0.125rem;\n}\n\n.rounded-b-sm {\n  border-bottom-right-radius: 0.125rem;\n  border-bottom-left-radius: 0.125rem;\n}\n\n.rounded-l-sm {\n  border-top-left-radius: 0.125rem;\n  border-bottom-left-radius: 0.125rem;\n}\n\n.rounded-t {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n}\n\n.rounded-r {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.rounded-b {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.rounded-l {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.rounded-t-md {\n  border-top-left-radius: 0.375rem;\n  border-top-right-radius: 0.375rem;\n}\n\n.rounded-r-md {\n  border-top-right-radius: 0.375rem;\n  border-bottom-right-radius: 0.375rem;\n}\n\n.rounded-b-md {\n  border-bottom-right-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n\n.rounded-l-md {\n  border-top-left-radius: 0.375rem;\n  border-bottom-left-radius: 0.375rem;\n}\n\n.rounded-t-lg {\n  border-top-left-radius: 0.5rem;\n  border-top-right-radius: 0.5rem;\n}\n\n.rounded-r-lg {\n  border-top-right-radius: 0.5rem;\n  border-bottom-right-radius: 0.5rem;\n}\n\n.rounded-b-lg {\n  border-bottom-right-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n\n.rounded-l-lg {\n  border-top-left-radius: 0.5rem;\n  border-bottom-left-radius: 0.5rem;\n}\n\n.rounded-t-xl {\n  border-top-left-radius: 0.75rem;\n  border-top-right-radius: 0.75rem;\n}\n\n.rounded-r-xl {\n  border-top-right-radius: 0.75rem;\n  border-bottom-right-radius: 0.75rem;\n}\n\n.rounded-b-xl {\n  border-bottom-right-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n.rounded-l-xl {\n  border-top-left-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n.rounded-t-2xl {\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n}\n\n.rounded-r-2xl {\n  border-top-right-radius: 1rem;\n  border-bottom-right-radius: 1rem;\n}\n\n.rounded-b-2xl {\n  border-bottom-right-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n}\n\n.rounded-l-2xl {\n  border-top-left-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n}\n\n.rounded-t-3xl {\n  border-top-left-radius: 1.5rem;\n  border-top-right-radius: 1.5rem;\n}\n\n.rounded-r-3xl {\n  border-top-right-radius: 1.5rem;\n  border-bottom-right-radius: 1.5rem;\n}\n\n.rounded-b-3xl {\n  border-bottom-right-radius: 1.5rem;\n  border-bottom-left-radius: 1.5rem;\n}\n\n.rounded-l-3xl {\n  border-top-left-radius: 1.5rem;\n  border-bottom-left-radius: 1.5rem;\n}\n\n.rounded-t-full {\n  border-top-left-radius: 9999px;\n  border-top-right-radius: 9999px;\n}\n\n.rounded-r-full {\n  border-top-right-radius: 9999px;\n  border-bottom-right-radius: 9999px;\n}\n\n.rounded-b-full {\n  border-bottom-right-radius: 9999px;\n  border-bottom-left-radius: 9999px;\n}\n\n.rounded-l-full {\n  border-top-left-radius: 9999px;\n  border-bottom-left-radius: 9999px;\n}\n\n.rounded-tl-none {\n  border-top-left-radius: 0;\n}\n\n.rounded-tr-none {\n  border-top-right-radius: 0;\n}\n\n.rounded-br-none {\n  border-bottom-right-radius: 0;\n}\n\n.rounded-bl-none {\n  border-bottom-left-radius: 0;\n}\n\n.rounded-tl-sm {\n  border-top-left-radius: 0.125rem;\n}\n\n.rounded-tr-sm {\n  border-top-right-radius: 0.125rem;\n}\n\n.rounded-br-sm {\n  border-bottom-right-radius: 0.125rem;\n}\n\n.rounded-bl-sm {\n  border-bottom-left-radius: 0.125rem;\n}\n\n.rounded-tl {\n  border-top-left-radius: 0.25rem;\n}\n\n.rounded-tr {\n  border-top-right-radius: 0.25rem;\n}\n\n.rounded-br {\n  border-bottom-right-radius: 0.25rem;\n}\n\n.rounded-bl {\n  border-bottom-left-radius: 0.25rem;\n}\n\n.rounded-tl-md {\n  border-top-left-radius: 0.375rem;\n}\n\n.rounded-tr-md {\n  border-top-right-radius: 0.375rem;\n}\n\n.rounded-br-md {\n  border-bottom-right-radius: 0.375rem;\n}\n\n.rounded-bl-md {\n  border-bottom-left-radius: 0.375rem;\n}\n\n.rounded-tl-lg {\n  border-top-left-radius: 0.5rem;\n}\n\n.rounded-tr-lg {\n  border-top-right-radius: 0.5rem;\n}\n\n.rounded-br-lg {\n  border-bottom-right-radius: 0.5rem;\n}\n\n.rounded-bl-lg {\n  border-bottom-left-radius: 0.5rem;\n}\n\n.rounded-tl-xl {\n  border-top-left-radius: 0.75rem;\n}\n\n.rounded-tr-xl {\n  border-top-right-radius: 0.75rem;\n}\n\n.rounded-br-xl {\n  border-bottom-right-radius: 0.75rem;\n}\n\n.rounded-bl-xl {\n  border-bottom-left-radius: 0.75rem;\n}\n\n.rounded-tl-2xl {\n  border-top-left-radius: 1rem;\n}\n\n.rounded-tr-2xl {\n  border-top-right-radius: 1rem;\n}\n\n.rounded-br-2xl {\n  border-bottom-right-radius: 1rem;\n}\n\n.rounded-bl-2xl {\n  border-bottom-left-radius: 1rem;\n}\n\n.rounded-tl-3xl {\n  border-top-left-radius: 1.5rem;\n}\n\n.rounded-tr-3xl {\n  border-top-right-radius: 1.5rem;\n}\n\n.rounded-br-3xl {\n  border-bottom-right-radius: 1.5rem;\n}\n\n.rounded-bl-3xl {\n  border-bottom-left-radius: 1.5rem;\n}\n\n.rounded-tl-full {\n  border-top-left-radius: 9999px;\n}\n\n.rounded-tr-full {\n  border-top-right-radius: 9999px;\n}\n\n.rounded-br-full {\n  border-bottom-right-radius: 9999px;\n}\n\n.rounded-bl-full {\n  border-bottom-left-radius: 9999px;\n}\n\n.border-solid {\n  border-style: solid;\n}\n\n.border-dashed {\n  border-style: dashed;\n}\n\n.border-dotted {\n  border-style: dotted;\n}\n\n.border-double {\n  border-style: double;\n}\n\n.border-none {\n  border-style: none;\n}\n\n.border-0 {\n  border-width: 0;\n}\n\n.border-2 {\n  border-width: 2px;\n}\n\n.border-4 {\n  border-width: 4px;\n}\n\n.border-8 {\n  border-width: 8px;\n}\n\n.border {\n  border-width: 1px;\n}\n\n.border-t-0 {\n  border-top-width: 0;\n}\n\n.border-r-0 {\n  border-right-width: 0;\n}\n\n.border-b-0 {\n  border-bottom-width: 0;\n}\n\n.border-l-0 {\n  border-left-width: 0;\n}\n\n.border-t-2 {\n  border-top-width: 2px;\n}\n\n.border-r-2 {\n  border-right-width: 2px;\n}\n\n.border-b-2 {\n  border-bottom-width: 2px;\n}\n\n.border-l-2 {\n  border-left-width: 2px;\n}\n\n.border-t-4 {\n  border-top-width: 4px;\n}\n\n.border-r-4 {\n  border-right-width: 4px;\n}\n\n.border-b-4 {\n  border-bottom-width: 4px;\n}\n\n.border-l-4 {\n  border-left-width: 4px;\n}\n\n.border-t-8 {\n  border-top-width: 8px;\n}\n\n.border-r-8 {\n  border-right-width: 8px;\n}\n\n.border-b-8 {\n  border-bottom-width: 8px;\n}\n\n.border-l-8 {\n  border-left-width: 8px;\n}\n\n.border-t {\n  border-top-width: 1px;\n}\n\n.border-r {\n  border-right-width: 1px;\n}\n\n.border-b {\n  border-bottom-width: 1px;\n}\n\n.border-l {\n  border-left-width: 1px;\n}\n\n.box-border {\n  box-sizing: border-box;\n}\n\n.box-content {\n  box-sizing: content-box;\n}\n\n.cursor-auto {\n  cursor: auto;\n}\n\n.cursor-default {\n  cursor: default;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-wait {\n  cursor: wait;\n}\n\n.cursor-text {\n  cursor: text;\n}\n\n.cursor-move {\n  cursor: move;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n\n.block {\n  display: block;\n}\n\n.inline-block {\n  display: inline-block;\n}\n\n.inline {\n  display: inline;\n}\n\n.flex {\n  display: flex;\n}\n\n.inline-flex {\n  display: inline-flex;\n}\n\n.table {\n  display: table;\n}\n\n.table-caption {\n  display: table-caption;\n}\n\n.table-cell {\n  display: table-cell;\n}\n\n.table-column {\n  display: table-column;\n}\n\n.table-column-group {\n  display: table-column-group;\n}\n\n.table-footer-group {\n  display: table-footer-group;\n}\n\n.table-header-group {\n  display: table-header-group;\n}\n\n.table-row-group {\n  display: table-row-group;\n}\n\n.table-row {\n  display: table-row;\n}\n\n.flow-root {\n  display: flow-root;\n}\n\n.grid {\n  display: grid;\n}\n\n.inline-grid {\n  display: inline-grid;\n}\n\n.contents {\n  display: contents;\n}\n\n.hidden {\n  display: none;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-row-reverse {\n  flex-direction: row-reverse;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-col-reverse {\n  flex-direction: column-reverse;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse;\n}\n\n.flex-no-wrap {\n  flex-wrap: nowrap;\n}\n\n.place-items-auto {\n  place-items: auto;\n}\n\n.place-items-start {\n  place-items: start;\n}\n\n.place-items-end {\n  place-items: end;\n}\n\n.place-items-center {\n  place-items: center;\n}\n\n.place-items-stretch {\n  place-items: stretch;\n}\n\n.place-content-center {\n  place-content: center;\n}\n\n.place-content-start {\n  place-content: start;\n}\n\n.place-content-end {\n  place-content: end;\n}\n\n.place-content-between {\n  place-content: space-between;\n}\n\n.place-content-around {\n  place-content: space-around;\n}\n\n.place-content-evenly {\n  place-content: space-evenly;\n}\n\n.place-content-stretch {\n  place-content: stretch;\n}\n\n.place-self-auto {\n  place-self: auto;\n}\n\n.place-self-start {\n  place-self: start;\n}\n\n.place-self-end {\n  place-self: end;\n}\n\n.place-self-center {\n  place-self: center;\n}\n\n.place-self-stretch {\n  place-self: stretch;\n}\n\n.items-start {\n  align-items: flex-start;\n}\n\n.items-end {\n  align-items: flex-end;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.items-baseline {\n  align-items: baseline;\n}\n\n.items-stretch {\n  align-items: stretch;\n}\n\n.content-center {\n  align-content: center;\n}\n\n.content-start {\n  align-content: flex-start;\n}\n\n.content-end {\n  align-content: flex-end;\n}\n\n.content-between {\n  align-content: space-between;\n}\n\n.content-around {\n  align-content: space-around;\n}\n\n.content-evenly {\n  align-content: space-evenly;\n}\n\n.self-auto {\n  align-self: auto;\n}\n\n.self-start {\n  align-self: flex-start;\n}\n\n.self-end {\n  align-self: flex-end;\n}\n\n.self-center {\n  align-self: center;\n}\n\n.self-stretch {\n  align-self: stretch;\n}\n\n.justify-items-auto {\n  justify-items: auto;\n}\n\n.justify-items-start {\n  justify-items: start;\n}\n\n.justify-items-end {\n  justify-items: end;\n}\n\n.justify-items-center {\n  justify-items: center;\n}\n\n.justify-items-stretch {\n  justify-items: stretch;\n}\n\n.justify-start {\n  justify-content: flex-start;\n}\n\n.justify-end {\n  justify-content: flex-end;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.justify-around {\n  justify-content: space-around;\n}\n\n.justify-evenly {\n  justify-content: space-evenly;\n}\n\n.justify-self-auto {\n  justify-self: auto;\n}\n\n.justify-self-start {\n  justify-self: start;\n}\n\n.justify-self-end {\n  justify-self: end;\n}\n\n.justify-self-center {\n  justify-self: center;\n}\n\n.justify-self-stretch {\n  justify-self: stretch;\n}\n\n.flex-1 {\n  flex: 1 1 0%;\n}\n\n.flex-auto {\n  flex: 1 1 auto;\n}\n\n.flex-initial {\n  flex: 0 1 auto;\n}\n\n.flex-none {\n  flex: none;\n}\n\n.flex-grow-0 {\n  flex-grow: 0;\n}\n\n.flex-grow {\n  flex-grow: 1;\n}\n\n.flex-shrink-0 {\n  flex-shrink: 0;\n}\n\n.flex-shrink {\n  flex-shrink: 1;\n}\n\n.order-1 {\n  order: 1;\n}\n\n.order-2 {\n  order: 2;\n}\n\n.order-3 {\n  order: 3;\n}\n\n.order-4 {\n  order: 4;\n}\n\n.order-5 {\n  order: 5;\n}\n\n.order-6 {\n  order: 6;\n}\n\n.order-7 {\n  order: 7;\n}\n\n.order-8 {\n  order: 8;\n}\n\n.order-9 {\n  order: 9;\n}\n\n.order-10 {\n  order: 10;\n}\n\n.order-11 {\n  order: 11;\n}\n\n.order-12 {\n  order: 12;\n}\n\n.order-first {\n  order: -9999;\n}\n\n.order-last {\n  order: 9999;\n}\n\n.order-none {\n  order: 0;\n}\n\n.float-right {\n  float: right;\n}\n\n.float-left {\n  float: left;\n}\n\n.float-none {\n  float: none;\n}\n\n.clearfix:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.clear-left {\n  clear: left;\n}\n\n.clear-right {\n  clear: right;\n}\n\n.clear-both {\n  clear: both;\n}\n\n.clear-none {\n  clear: none;\n}\n\n.font-sans {\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n}\n\n.font-serif {\n  font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n}\n\n.font-mono {\n  font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n.font-hairline {\n  font-weight: 100;\n}\n\n.font-thin {\n  font-weight: 200;\n}\n\n.font-light {\n  font-weight: 300;\n}\n\n.font-normal {\n  font-weight: 400;\n}\n\n.font-medium {\n  font-weight: 500;\n}\n\n.font-semibold {\n  font-weight: 600;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.font-extrabold {\n  font-weight: 800;\n}\n\n.font-black {\n  font-weight: 900;\n}\n\n.hover\\:font-hairline:hover {\n  font-weight: 100;\n}\n\n.hover\\:font-thin:hover {\n  font-weight: 200;\n}\n\n.hover\\:font-light:hover {\n  font-weight: 300;\n}\n\n.hover\\:font-normal:hover {\n  font-weight: 400;\n}\n\n.hover\\:font-medium:hover {\n  font-weight: 500;\n}\n\n.hover\\:font-semibold:hover {\n  font-weight: 600;\n}\n\n.hover\\:font-bold:hover {\n  font-weight: 700;\n}\n\n.hover\\:font-extrabold:hover {\n  font-weight: 800;\n}\n\n.hover\\:font-black:hover {\n  font-weight: 900;\n}\n\n.focus\\:font-hairline:focus {\n  font-weight: 100;\n}\n\n.focus\\:font-thin:focus {\n  font-weight: 200;\n}\n\n.focus\\:font-light:focus {\n  font-weight: 300;\n}\n\n.focus\\:font-normal:focus {\n  font-weight: 400;\n}\n\n.focus\\:font-medium:focus {\n  font-weight: 500;\n}\n\n.focus\\:font-semibold:focus {\n  font-weight: 600;\n}\n\n.focus\\:font-bold:focus {\n  font-weight: 700;\n}\n\n.focus\\:font-extrabold:focus {\n  font-weight: 800;\n}\n\n.focus\\:font-black:focus {\n  font-weight: 900;\n}\n\n.h-0 {\n  height: 0;\n}\n\n.h-1 {\n  height: 0.25rem;\n}\n\n.h-2 {\n  height: 0.5rem;\n}\n\n.h-3 {\n  height: 0.75rem;\n}\n\n.h-4 {\n  height: 1rem;\n}\n\n.h-5 {\n  height: 1.25rem;\n}\n\n.h-6 {\n  height: 1.5rem;\n}\n\n.h-8 {\n  height: 2rem;\n}\n\n.h-10 {\n  height: 2.5rem;\n}\n\n.h-12 {\n  height: 3rem;\n}\n\n.h-16 {\n  height: 4rem;\n}\n\n.h-20 {\n  height: 5rem;\n}\n\n.h-24 {\n  height: 6rem;\n}\n\n.h-32 {\n  height: 8rem;\n}\n\n.h-40 {\n  height: 10rem;\n}\n\n.h-48 {\n  height: 12rem;\n}\n\n.h-56 {\n  height: 14rem;\n}\n\n.h-64 {\n  height: 16rem;\n}\n\n.h-auto {\n  height: auto;\n}\n\n.h-px {\n  height: 1px;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.h-screen {\n  height: 100vh;\n}\n\n.text-15 {\n  font-size: 0.9375rem;\n}\n\n.text-xs {\n  font-size: 0.75rem;\n}\n\n.text-sm {\n  font-size: 0.875rem;\n}\n\n.text-base {\n  font-size: 1rem;\n}\n\n.text-lg {\n  font-size: 1.125rem;\n}\n\n.text-xl {\n  font-size: 1.25rem;\n}\n\n.text-1\\.5xl {\n  font-size: 1.375rem;\n}\n\n.text-2xl {\n  font-size: 1.5rem;\n}\n\n.text-3xl {\n  font-size: 1.875rem;\n}\n\n.text-4xl {\n  font-size: 2.25rem;\n}\n\n.text-5xl {\n  font-size: 3rem;\n}\n\n.text-6xl {\n  font-size: 4rem;\n}\n\n.leading-3 {\n  line-height: .75rem;\n}\n\n.leading-4 {\n  line-height: 1rem;\n}\n\n.leading-5 {\n  line-height: 1.25rem;\n}\n\n.leading-6 {\n  line-height: 1.5rem;\n}\n\n.leading-7 {\n  line-height: 1.75rem;\n}\n\n.leading-8 {\n  line-height: 2rem;\n}\n\n.leading-9 {\n  line-height: 2.25rem;\n}\n\n.leading-10 {\n  line-height: 2.5rem;\n}\n\n.leading-none {\n  line-height: 1;\n}\n\n.leading-tight {\n  line-height: 1.25;\n}\n\n.leading-snug {\n  line-height: 1.375;\n}\n\n.leading-normal {\n  line-height: 1.5;\n}\n\n.leading-relaxed {\n  line-height: 1.625;\n}\n\n.leading-loose {\n  line-height: 2;\n}\n\n.list-inside {\n  list-style-position: inside;\n}\n\n.list-outside {\n  list-style-position: outside;\n}\n\n.list-none {\n  list-style-type: none;\n}\n\n.list-disc {\n  list-style-type: disc;\n}\n\n.list-decimal {\n  list-style-type: decimal;\n}\n\n.m-0 {\n  margin: 0;\n}\n\n.m-1 {\n  margin: 0.25rem;\n}\n\n.m-2 {\n  margin: 0.5rem;\n}\n\n.m-3 {\n  margin: 0.75rem;\n}\n\n.m-4 {\n  margin: 1rem;\n}\n\n.m-5 {\n  margin: 1.25rem;\n}\n\n.m-6 {\n  margin: 1.5rem;\n}\n\n.m-8 {\n  margin: 2rem;\n}\n\n.m-10 {\n  margin: 2.5rem;\n}\n\n.m-12 {\n  margin: 3rem;\n}\n\n.m-16 {\n  margin: 4rem;\n}\n\n.m-20 {\n  margin: 5rem;\n}\n\n.m-24 {\n  margin: 6rem;\n}\n\n.m-32 {\n  margin: 8rem;\n}\n\n.m-40 {\n  margin: 10rem;\n}\n\n.m-48 {\n  margin: 12rem;\n}\n\n.m-56 {\n  margin: 14rem;\n}\n\n.m-64 {\n  margin: 16rem;\n}\n\n.m-auto {\n  margin: auto;\n}\n\n.m-px {\n  margin: 1px;\n}\n\n.-m-1 {\n  margin: -0.25rem;\n}\n\n.-m-2 {\n  margin: -0.5rem;\n}\n\n.-m-3 {\n  margin: -0.75rem;\n}\n\n.-m-4 {\n  margin: -1rem;\n}\n\n.-m-5 {\n  margin: -1.25rem;\n}\n\n.-m-6 {\n  margin: -1.5rem;\n}\n\n.-m-8 {\n  margin: -2rem;\n}\n\n.-m-10 {\n  margin: -2.5rem;\n}\n\n.-m-12 {\n  margin: -3rem;\n}\n\n.-m-16 {\n  margin: -4rem;\n}\n\n.-m-20 {\n  margin: -5rem;\n}\n\n.-m-24 {\n  margin: -6rem;\n}\n\n.-m-32 {\n  margin: -8rem;\n}\n\n.-m-40 {\n  margin: -10rem;\n}\n\n.-m-48 {\n  margin: -12rem;\n}\n\n.-m-56 {\n  margin: -14rem;\n}\n\n.-m-64 {\n  margin: -16rem;\n}\n\n.-m-px {\n  margin: -1px;\n}\n\n.my-0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.mx-0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.my-1 {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem;\n}\n\n.mx-1 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.my-2 {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.mx-2 {\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n}\n\n.my-3 {\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.mx-3 {\n  margin-left: 0.75rem;\n  margin-right: 0.75rem;\n}\n\n.my-4 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.mx-4 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.my-5 {\n  margin-top: 1.25rem;\n  margin-bottom: 1.25rem;\n}\n\n.mx-5 {\n  margin-left: 1.25rem;\n  margin-right: 1.25rem;\n}\n\n.my-6 {\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n\n.mx-6 {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n\n.my-8 {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n\n.mx-8 {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n\n.my-10 {\n  margin-top: 2.5rem;\n  margin-bottom: 2.5rem;\n}\n\n.mx-10 {\n  margin-left: 2.5rem;\n  margin-right: 2.5rem;\n}\n\n.my-12 {\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n\n.mx-12 {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n\n.my-16 {\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n}\n\n.mx-16 {\n  margin-left: 4rem;\n  margin-right: 4rem;\n}\n\n.my-20 {\n  margin-top: 5rem;\n  margin-bottom: 5rem;\n}\n\n.mx-20 {\n  margin-left: 5rem;\n  margin-right: 5rem;\n}\n\n.my-24 {\n  margin-top: 6rem;\n  margin-bottom: 6rem;\n}\n\n.mx-24 {\n  margin-left: 6rem;\n  margin-right: 6rem;\n}\n\n.my-32 {\n  margin-top: 8rem;\n  margin-bottom: 8rem;\n}\n\n.mx-32 {\n  margin-left: 8rem;\n  margin-right: 8rem;\n}\n\n.my-40 {\n  margin-top: 10rem;\n  margin-bottom: 10rem;\n}\n\n.mx-40 {\n  margin-left: 10rem;\n  margin-right: 10rem;\n}\n\n.my-48 {\n  margin-top: 12rem;\n  margin-bottom: 12rem;\n}\n\n.mx-48 {\n  margin-left: 12rem;\n  margin-right: 12rem;\n}\n\n.my-56 {\n  margin-top: 14rem;\n  margin-bottom: 14rem;\n}\n\n.mx-56 {\n  margin-left: 14rem;\n  margin-right: 14rem;\n}\n\n.my-64 {\n  margin-top: 16rem;\n  margin-bottom: 16rem;\n}\n\n.mx-64 {\n  margin-left: 16rem;\n  margin-right: 16rem;\n}\n\n.my-auto {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.my-px {\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n\n.mx-px {\n  margin-left: 1px;\n  margin-right: 1px;\n}\n\n.-my-1 {\n  margin-top: -0.25rem;\n  margin-bottom: -0.25rem;\n}\n\n.-mx-1 {\n  margin-left: -0.25rem;\n  margin-right: -0.25rem;\n}\n\n.-my-2 {\n  margin-top: -0.5rem;\n  margin-bottom: -0.5rem;\n}\n\n.-mx-2 {\n  margin-left: -0.5rem;\n  margin-right: -0.5rem;\n}\n\n.-my-3 {\n  margin-top: -0.75rem;\n  margin-bottom: -0.75rem;\n}\n\n.-mx-3 {\n  margin-left: -0.75rem;\n  margin-right: -0.75rem;\n}\n\n.-my-4 {\n  margin-top: -1rem;\n  margin-bottom: -1rem;\n}\n\n.-mx-4 {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n\n.-my-5 {\n  margin-top: -1.25rem;\n  margin-bottom: -1.25rem;\n}\n\n.-mx-5 {\n  margin-left: -1.25rem;\n  margin-right: -1.25rem;\n}\n\n.-my-6 {\n  margin-top: -1.5rem;\n  margin-bottom: -1.5rem;\n}\n\n.-mx-6 {\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n}\n\n.-my-8 {\n  margin-top: -2rem;\n  margin-bottom: -2rem;\n}\n\n.-mx-8 {\n  margin-left: -2rem;\n  margin-right: -2rem;\n}\n\n.-my-10 {\n  margin-top: -2.5rem;\n  margin-bottom: -2.5rem;\n}\n\n.-mx-10 {\n  margin-left: -2.5rem;\n  margin-right: -2.5rem;\n}\n\n.-my-12 {\n  margin-top: -3rem;\n  margin-bottom: -3rem;\n}\n\n.-mx-12 {\n  margin-left: -3rem;\n  margin-right: -3rem;\n}\n\n.-my-16 {\n  margin-top: -4rem;\n  margin-bottom: -4rem;\n}\n\n.-mx-16 {\n  margin-left: -4rem;\n  margin-right: -4rem;\n}\n\n.-my-20 {\n  margin-top: -5rem;\n  margin-bottom: -5rem;\n}\n\n.-mx-20 {\n  margin-left: -5rem;\n  margin-right: -5rem;\n}\n\n.-my-24 {\n  margin-top: -6rem;\n  margin-bottom: -6rem;\n}\n\n.-mx-24 {\n  margin-left: -6rem;\n  margin-right: -6rem;\n}\n\n.-my-32 {\n  margin-top: -8rem;\n  margin-bottom: -8rem;\n}\n\n.-mx-32 {\n  margin-left: -8rem;\n  margin-right: -8rem;\n}\n\n.-my-40 {\n  margin-top: -10rem;\n  margin-bottom: -10rem;\n}\n\n.-mx-40 {\n  margin-left: -10rem;\n  margin-right: -10rem;\n}\n\n.-my-48 {\n  margin-top: -12rem;\n  margin-bottom: -12rem;\n}\n\n.-mx-48 {\n  margin-left: -12rem;\n  margin-right: -12rem;\n}\n\n.-my-56 {\n  margin-top: -14rem;\n  margin-bottom: -14rem;\n}\n\n.-mx-56 {\n  margin-left: -14rem;\n  margin-right: -14rem;\n}\n\n.-my-64 {\n  margin-top: -16rem;\n  margin-bottom: -16rem;\n}\n\n.-mx-64 {\n  margin-left: -16rem;\n  margin-right: -16rem;\n}\n\n.-my-px {\n  margin-top: -1px;\n  margin-bottom: -1px;\n}\n\n.-mx-px {\n  margin-left: -1px;\n  margin-right: -1px;\n}\n\n.mt-0 {\n  margin-top: 0;\n}\n\n.mr-0 {\n  margin-right: 0;\n}\n\n.mb-0 {\n  margin-bottom: 0;\n}\n\n.ml-0 {\n  margin-left: 0;\n}\n\n.mt-1 {\n  margin-top: 0.25rem;\n}\n\n.mr-1 {\n  margin-right: 0.25rem;\n}\n\n.mb-1 {\n  margin-bottom: 0.25rem;\n}\n\n.ml-1 {\n  margin-left: 0.25rem;\n}\n\n.mt-2 {\n  margin-top: 0.5rem;\n}\n\n.mr-2 {\n  margin-right: 0.5rem;\n}\n\n.mb-2 {\n  margin-bottom: 0.5rem;\n}\n\n.ml-2 {\n  margin-left: 0.5rem;\n}\n\n.mt-3 {\n  margin-top: 0.75rem;\n}\n\n.mr-3 {\n  margin-right: 0.75rem;\n}\n\n.mb-3 {\n  margin-bottom: 0.75rem;\n}\n\n.ml-3 {\n  margin-left: 0.75rem;\n}\n\n.mt-4 {\n  margin-top: 1rem;\n}\n\n.mr-4 {\n  margin-right: 1rem;\n}\n\n.mb-4 {\n  margin-bottom: 1rem;\n}\n\n.ml-4 {\n  margin-left: 1rem;\n}\n\n.mt-5 {\n  margin-top: 1.25rem;\n}\n\n.mr-5 {\n  margin-right: 1.25rem;\n}\n\n.mb-5 {\n  margin-bottom: 1.25rem;\n}\n\n.ml-5 {\n  margin-left: 1.25rem;\n}\n\n.mt-6 {\n  margin-top: 1.5rem;\n}\n\n.mr-6 {\n  margin-right: 1.5rem;\n}\n\n.mb-6 {\n  margin-bottom: 1.5rem;\n}\n\n.ml-6 {\n  margin-left: 1.5rem;\n}\n\n.mt-8 {\n  margin-top: 2rem;\n}\n\n.mr-8 {\n  margin-right: 2rem;\n}\n\n.mb-8 {\n  margin-bottom: 2rem;\n}\n\n.ml-8 {\n  margin-left: 2rem;\n}\n\n.mt-10 {\n  margin-top: 2.5rem;\n}\n\n.mr-10 {\n  margin-right: 2.5rem;\n}\n\n.mb-10 {\n  margin-bottom: 2.5rem;\n}\n\n.ml-10 {\n  margin-left: 2.5rem;\n}\n\n.mt-12 {\n  margin-top: 3rem;\n}\n\n.mr-12 {\n  margin-right: 3rem;\n}\n\n.mb-12 {\n  margin-bottom: 3rem;\n}\n\n.ml-12 {\n  margin-left: 3rem;\n}\n\n.mt-16 {\n  margin-top: 4rem;\n}\n\n.mr-16 {\n  margin-right: 4rem;\n}\n\n.mb-16 {\n  margin-bottom: 4rem;\n}\n\n.ml-16 {\n  margin-left: 4rem;\n}\n\n.mt-20 {\n  margin-top: 5rem;\n}\n\n.mr-20 {\n  margin-right: 5rem;\n}\n\n.mb-20 {\n  margin-bottom: 5rem;\n}\n\n.ml-20 {\n  margin-left: 5rem;\n}\n\n.mt-24 {\n  margin-top: 6rem;\n}\n\n.mr-24 {\n  margin-right: 6rem;\n}\n\n.mb-24 {\n  margin-bottom: 6rem;\n}\n\n.ml-24 {\n  margin-left: 6rem;\n}\n\n.mt-32 {\n  margin-top: 8rem;\n}\n\n.mr-32 {\n  margin-right: 8rem;\n}\n\n.mb-32 {\n  margin-bottom: 8rem;\n}\n\n.ml-32 {\n  margin-left: 8rem;\n}\n\n.mt-40 {\n  margin-top: 10rem;\n}\n\n.mr-40 {\n  margin-right: 10rem;\n}\n\n.mb-40 {\n  margin-bottom: 10rem;\n}\n\n.ml-40 {\n  margin-left: 10rem;\n}\n\n.mt-48 {\n  margin-top: 12rem;\n}\n\n.mr-48 {\n  margin-right: 12rem;\n}\n\n.mb-48 {\n  margin-bottom: 12rem;\n}\n\n.ml-48 {\n  margin-left: 12rem;\n}\n\n.mt-56 {\n  margin-top: 14rem;\n}\n\n.mr-56 {\n  margin-right: 14rem;\n}\n\n.mb-56 {\n  margin-bottom: 14rem;\n}\n\n.ml-56 {\n  margin-left: 14rem;\n}\n\n.mt-64 {\n  margin-top: 16rem;\n}\n\n.mr-64 {\n  margin-right: 16rem;\n}\n\n.mb-64 {\n  margin-bottom: 16rem;\n}\n\n.ml-64 {\n  margin-left: 16rem;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.mr-auto {\n  margin-right: auto;\n}\n\n.mb-auto {\n  margin-bottom: auto;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.mt-px {\n  margin-top: 1px;\n}\n\n.mr-px {\n  margin-right: 1px;\n}\n\n.mb-px {\n  margin-bottom: 1px;\n}\n\n.ml-px {\n  margin-left: 1px;\n}\n\n.-mt-1 {\n  margin-top: -0.25rem;\n}\n\n.-mr-1 {\n  margin-right: -0.25rem;\n}\n\n.-mb-1 {\n  margin-bottom: -0.25rem;\n}\n\n.-ml-1 {\n  margin-left: -0.25rem;\n}\n\n.-mt-2 {\n  margin-top: -0.5rem;\n}\n\n.-mr-2 {\n  margin-right: -0.5rem;\n}\n\n.-mb-2 {\n  margin-bottom: -0.5rem;\n}\n\n.-ml-2 {\n  margin-left: -0.5rem;\n}\n\n.-mt-3 {\n  margin-top: -0.75rem;\n}\n\n.-mr-3 {\n  margin-right: -0.75rem;\n}\n\n.-mb-3 {\n  margin-bottom: -0.75rem;\n}\n\n.-ml-3 {\n  margin-left: -0.75rem;\n}\n\n.-mt-4 {\n  margin-top: -1rem;\n}\n\n.-mr-4 {\n  margin-right: -1rem;\n}\n\n.-mb-4 {\n  margin-bottom: -1rem;\n}\n\n.-ml-4 {\n  margin-left: -1rem;\n}\n\n.-mt-5 {\n  margin-top: -1.25rem;\n}\n\n.-mr-5 {\n  margin-right: -1.25rem;\n}\n\n.-mb-5 {\n  margin-bottom: -1.25rem;\n}\n\n.-ml-5 {\n  margin-left: -1.25rem;\n}\n\n.-mt-6 {\n  margin-top: -1.5rem;\n}\n\n.-mr-6 {\n  margin-right: -1.5rem;\n}\n\n.-mb-6 {\n  margin-bottom: -1.5rem;\n}\n\n.-ml-6 {\n  margin-left: -1.5rem;\n}\n\n.-mt-8 {\n  margin-top: -2rem;\n}\n\n.-mr-8 {\n  margin-right: -2rem;\n}\n\n.-mb-8 {\n  margin-bottom: -2rem;\n}\n\n.-ml-8 {\n  margin-left: -2rem;\n}\n\n.-mt-10 {\n  margin-top: -2.5rem;\n}\n\n.-mr-10 {\n  margin-right: -2.5rem;\n}\n\n.-mb-10 {\n  margin-bottom: -2.5rem;\n}\n\n.-ml-10 {\n  margin-left: -2.5rem;\n}\n\n.-mt-12 {\n  margin-top: -3rem;\n}\n\n.-mr-12 {\n  margin-right: -3rem;\n}\n\n.-mb-12 {\n  margin-bottom: -3rem;\n}\n\n.-ml-12 {\n  margin-left: -3rem;\n}\n\n.-mt-16 {\n  margin-top: -4rem;\n}\n\n.-mr-16 {\n  margin-right: -4rem;\n}\n\n.-mb-16 {\n  margin-bottom: -4rem;\n}\n\n.-ml-16 {\n  margin-left: -4rem;\n}\n\n.-mt-20 {\n  margin-top: -5rem;\n}\n\n.-mr-20 {\n  margin-right: -5rem;\n}\n\n.-mb-20 {\n  margin-bottom: -5rem;\n}\n\n.-ml-20 {\n  margin-left: -5rem;\n}\n\n.-mt-24 {\n  margin-top: -6rem;\n}\n\n.-mr-24 {\n  margin-right: -6rem;\n}\n\n.-mb-24 {\n  margin-bottom: -6rem;\n}\n\n.-ml-24 {\n  margin-left: -6rem;\n}\n\n.-mt-32 {\n  margin-top: -8rem;\n}\n\n.-mr-32 {\n  margin-right: -8rem;\n}\n\n.-mb-32 {\n  margin-bottom: -8rem;\n}\n\n.-ml-32 {\n  margin-left: -8rem;\n}\n\n.-mt-40 {\n  margin-top: -10rem;\n}\n\n.-mr-40 {\n  margin-right: -10rem;\n}\n\n.-mb-40 {\n  margin-bottom: -10rem;\n}\n\n.-ml-40 {\n  margin-left: -10rem;\n}\n\n.-mt-48 {\n  margin-top: -12rem;\n}\n\n.-mr-48 {\n  margin-right: -12rem;\n}\n\n.-mb-48 {\n  margin-bottom: -12rem;\n}\n\n.-ml-48 {\n  margin-left: -12rem;\n}\n\n.-mt-56 {\n  margin-top: -14rem;\n}\n\n.-mr-56 {\n  margin-right: -14rem;\n}\n\n.-mb-56 {\n  margin-bottom: -14rem;\n}\n\n.-ml-56 {\n  margin-left: -14rem;\n}\n\n.-mt-64 {\n  margin-top: -16rem;\n}\n\n.-mr-64 {\n  margin-right: -16rem;\n}\n\n.-mb-64 {\n  margin-bottom: -16rem;\n}\n\n.-ml-64 {\n  margin-left: -16rem;\n}\n\n.-mt-px {\n  margin-top: -1px;\n}\n\n.-mr-px {\n  margin-right: -1px;\n}\n\n.-mb-px {\n  margin-bottom: -1px;\n}\n\n.-ml-px {\n  margin-left: -1px;\n}\n\n.max-h-full {\n  max-height: 100%;\n}\n\n.max-h-screen {\n  max-height: 100vh;\n}\n\n.max-w-none {\n  max-width: none;\n}\n\n.max-w-xs {\n  max-width: 20rem;\n}\n\n.max-w-sm {\n  max-width: 24rem;\n}\n\n.max-w-md {\n  max-width: 28rem;\n}\n\n.max-w-lg {\n  max-width: 32rem;\n}\n\n.max-w-xl {\n  max-width: 36rem;\n}\n\n.max-w-2xl {\n  max-width: 42rem;\n}\n\n.max-w-3xl {\n  max-width: 48rem;\n}\n\n.max-w-4xl {\n  max-width: 56rem;\n}\n\n.max-w-5xl {\n  max-width: 64rem;\n}\n\n.max-w-6xl {\n  max-width: 72rem;\n}\n\n.max-w-full {\n  max-width: 100%;\n}\n\n.max-w-screen-sm {\n  max-width: 640px;\n}\n\n.max-w-screen-md {\n  max-width: 768px;\n}\n\n.max-w-screen-lg {\n  max-width: 1024px;\n}\n\n.max-w-screen-xl {\n  max-width: 1280px;\n}\n\n.min-h-0 {\n  min-height: 0;\n}\n\n.min-h-full {\n  min-height: 100%;\n}\n\n.min-h-screen {\n  min-height: 100vh;\n}\n\n.min-w-0 {\n  min-width: 0;\n}\n\n.min-w-full {\n  min-width: 100%;\n}\n\n.object-contain {\n  object-fit: contain;\n}\n\n.object-cover {\n  object-fit: cover;\n}\n\n.object-fill {\n  object-fit: fill;\n}\n\n.object-none {\n  object-fit: none;\n}\n\n.object-scale-down {\n  object-fit: scale-down;\n}\n\n.object-bottom {\n  object-position: bottom;\n}\n\n.object-center {\n  object-position: center;\n}\n\n.object-left {\n  object-position: left;\n}\n\n.object-left-bottom {\n  object-position: left bottom;\n}\n\n.object-left-top {\n  object-position: left top;\n}\n\n.object-right {\n  object-position: right;\n}\n\n.object-right-bottom {\n  object-position: right bottom;\n}\n\n.object-right-top {\n  object-position: right top;\n}\n\n.object-top {\n  object-position: top;\n}\n\n.opacity-0 {\n  opacity: 0;\n}\n\n.opacity-25 {\n  opacity: 0.25;\n}\n\n.opacity-50 {\n  opacity: 0.5;\n}\n\n.opacity-75 {\n  opacity: 0.75;\n}\n\n.opacity-100 {\n  opacity: 1;\n}\n\n.hover\\:opacity-0:hover {\n  opacity: 0;\n}\n\n.hover\\:opacity-25:hover {\n  opacity: 0.25;\n}\n\n.hover\\:opacity-50:hover {\n  opacity: 0.5;\n}\n\n.hover\\:opacity-75:hover {\n  opacity: 0.75;\n}\n\n.hover\\:opacity-100:hover {\n  opacity: 1;\n}\n\n.focus\\:opacity-0:focus {\n  opacity: 0;\n}\n\n.focus\\:opacity-25:focus {\n  opacity: 0.25;\n}\n\n.focus\\:opacity-50:focus {\n  opacity: 0.5;\n}\n\n.focus\\:opacity-75:focus {\n  opacity: 0.75;\n}\n\n.focus\\:opacity-100:focus {\n  opacity: 1;\n}\n\n.outline-none {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.outline-white {\n  outline: 2px dotted white;\n  outline-offset: 2px;\n}\n\n.outline-black {\n  outline: 2px dotted black;\n  outline-offset: 2px;\n}\n\n.focus\\:outline-none:focus {\n  outline: 2px solid transparent;\n  outline-offset: 2px;\n}\n\n.focus\\:outline-white:focus {\n  outline: 2px dotted white;\n  outline-offset: 2px;\n}\n\n.focus\\:outline-black:focus {\n  outline: 2px dotted black;\n  outline-offset: 2px;\n}\n\n.overflow-auto {\n  overflow: auto;\n}\n\n.overflow-hidden {\n  overflow: hidden;\n}\n\n.overflow-visible {\n  overflow: visible;\n}\n\n.overflow-scroll {\n  overflow: scroll;\n}\n\n.overflow-x-auto {\n  overflow-x: auto;\n}\n\n.overflow-y-auto {\n  overflow-y: auto;\n}\n\n.overflow-x-hidden {\n  overflow-x: hidden;\n}\n\n.overflow-y-hidden {\n  overflow-y: hidden;\n}\n\n.overflow-x-visible {\n  overflow-x: visible;\n}\n\n.overflow-y-visible {\n  overflow-y: visible;\n}\n\n.overflow-x-scroll {\n  overflow-x: scroll;\n}\n\n.overflow-y-scroll {\n  overflow-y: scroll;\n}\n\n.scrolling-touch {\n  -webkit-overflow-scrolling: touch;\n}\n\n.scrolling-auto {\n  -webkit-overflow-scrolling: auto;\n}\n\n.overscroll-auto {\n  overscroll-behavior: auto;\n}\n\n.overscroll-contain {\n  overscroll-behavior: contain;\n}\n\n.overscroll-none {\n  overscroll-behavior: none;\n}\n\n.overscroll-y-auto {\n  overscroll-behavior-y: auto;\n}\n\n.overscroll-y-contain {\n  overscroll-behavior-y: contain;\n}\n\n.overscroll-y-none {\n  overscroll-behavior-y: none;\n}\n\n.overscroll-x-auto {\n  overscroll-behavior-x: auto;\n}\n\n.overscroll-x-contain {\n  overscroll-behavior-x: contain;\n}\n\n.overscroll-x-none {\n  overscroll-behavior-x: none;\n}\n\n.p-0 {\n  padding: 0;\n}\n\n.p-1 {\n  padding: 0.25rem;\n}\n\n.p-2 {\n  padding: 0.5rem;\n}\n\n.p-3 {\n  padding: 0.75rem;\n}\n\n.p-4 {\n  padding: 1rem;\n}\n\n.p-5 {\n  padding: 1.25rem;\n}\n\n.p-6 {\n  padding: 1.5rem;\n}\n\n.p-8 {\n  padding: 2rem;\n}\n\n.p-10 {\n  padding: 2.5rem;\n}\n\n.p-12 {\n  padding: 3rem;\n}\n\n.p-16 {\n  padding: 4rem;\n}\n\n.p-20 {\n  padding: 5rem;\n}\n\n.p-24 {\n  padding: 6rem;\n}\n\n.p-32 {\n  padding: 8rem;\n}\n\n.p-40 {\n  padding: 10rem;\n}\n\n.p-48 {\n  padding: 12rem;\n}\n\n.p-56 {\n  padding: 14rem;\n}\n\n.p-64 {\n  padding: 16rem;\n}\n\n.p-px {\n  padding: 1px;\n}\n\n.py-0 {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.px-0 {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.py-1 {\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n}\n\n.px-1 {\n  padding-left: 0.25rem;\n  padding-right: 0.25rem;\n}\n\n.py-2 {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.px-2 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n\n.py-3 {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.px-3 {\n  padding-left: 0.75rem;\n  padding-right: 0.75rem;\n}\n\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.py-5 {\n  padding-top: 1.25rem;\n  padding-bottom: 1.25rem;\n}\n\n.px-5 {\n  padding-left: 1.25rem;\n  padding-right: 1.25rem;\n}\n\n.py-6 {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.py-8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n\n.px-8 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n\n.py-10 {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n\n.px-10 {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n\n.py-12 {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n\n.px-12 {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n\n.py-16 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n\n.px-16 {\n  padding-left: 4rem;\n  padding-right: 4rem;\n}\n\n.py-20 {\n  padding-top: 5rem;\n  padding-bottom: 5rem;\n}\n\n.px-20 {\n  padding-left: 5rem;\n  padding-right: 5rem;\n}\n\n.py-24 {\n  padding-top: 6rem;\n  padding-bottom: 6rem;\n}\n\n.px-24 {\n  padding-left: 6rem;\n  padding-right: 6rem;\n}\n\n.py-32 {\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n}\n\n.px-32 {\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n\n.py-40 {\n  padding-top: 10rem;\n  padding-bottom: 10rem;\n}\n\n.px-40 {\n  padding-left: 10rem;\n  padding-right: 10rem;\n}\n\n.py-48 {\n  padding-top: 12rem;\n  padding-bottom: 12rem;\n}\n\n.px-48 {\n  padding-left: 12rem;\n  padding-right: 12rem;\n}\n\n.py-56 {\n  padding-top: 14rem;\n  padding-bottom: 14rem;\n}\n\n.px-56 {\n  padding-left: 14rem;\n  padding-right: 14rem;\n}\n\n.py-64 {\n  padding-top: 16rem;\n  padding-bottom: 16rem;\n}\n\n.px-64 {\n  padding-left: 16rem;\n  padding-right: 16rem;\n}\n\n.py-px {\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n\n.px-px {\n  padding-left: 1px;\n  padding-right: 1px;\n}\n\n.pt-0 {\n  padding-top: 0;\n}\n\n.pr-0 {\n  padding-right: 0;\n}\n\n.pb-0 {\n  padding-bottom: 0;\n}\n\n.pl-0 {\n  padding-left: 0;\n}\n\n.pt-1 {\n  padding-top: 0.25rem;\n}\n\n.pr-1 {\n  padding-right: 0.25rem;\n}\n\n.pb-1 {\n  padding-bottom: 0.25rem;\n}\n\n.pl-1 {\n  padding-left: 0.25rem;\n}\n\n.pt-2 {\n  padding-top: 0.5rem;\n}\n\n.pr-2 {\n  padding-right: 0.5rem;\n}\n\n.pb-2 {\n  padding-bottom: 0.5rem;\n}\n\n.pl-2 {\n  padding-left: 0.5rem;\n}\n\n.pt-3 {\n  padding-top: 0.75rem;\n}\n\n.pr-3 {\n  padding-right: 0.75rem;\n}\n\n.pb-3 {\n  padding-bottom: 0.75rem;\n}\n\n.pl-3 {\n  padding-left: 0.75rem;\n}\n\n.pt-4 {\n  padding-top: 1rem;\n}\n\n.pr-4 {\n  padding-right: 1rem;\n}\n\n.pb-4 {\n  padding-bottom: 1rem;\n}\n\n.pl-4 {\n  padding-left: 1rem;\n}\n\n.pt-5 {\n  padding-top: 1.25rem;\n}\n\n.pr-5 {\n  padding-right: 1.25rem;\n}\n\n.pb-5 {\n  padding-bottom: 1.25rem;\n}\n\n.pl-5 {\n  padding-left: 1.25rem;\n}\n\n.pt-6 {\n  padding-top: 1.5rem;\n}\n\n.pr-6 {\n  padding-right: 1.5rem;\n}\n\n.pb-6 {\n  padding-bottom: 1.5rem;\n}\n\n.pl-6 {\n  padding-left: 1.5rem;\n}\n\n.pt-8 {\n  padding-top: 2rem;\n}\n\n.pr-8 {\n  padding-right: 2rem;\n}\n\n.pb-8 {\n  padding-bottom: 2rem;\n}\n\n.pl-8 {\n  padding-left: 2rem;\n}\n\n.pt-10 {\n  padding-top: 2.5rem;\n}\n\n.pr-10 {\n  padding-right: 2.5rem;\n}\n\n.pb-10 {\n  padding-bottom: 2.5rem;\n}\n\n.pl-10 {\n  padding-left: 2.5rem;\n}\n\n.pt-12 {\n  padding-top: 3rem;\n}\n\n.pr-12 {\n  padding-right: 3rem;\n}\n\n.pb-12 {\n  padding-bottom: 3rem;\n}\n\n.pl-12 {\n  padding-left: 3rem;\n}\n\n.pt-16 {\n  padding-top: 4rem;\n}\n\n.pr-16 {\n  padding-right: 4rem;\n}\n\n.pb-16 {\n  padding-bottom: 4rem;\n}\n\n.pl-16 {\n  padding-left: 4rem;\n}\n\n.pt-20 {\n  padding-top: 5rem;\n}\n\n.pr-20 {\n  padding-right: 5rem;\n}\n\n.pb-20 {\n  padding-bottom: 5rem;\n}\n\n.pl-20 {\n  padding-left: 5rem;\n}\n\n.pt-24 {\n  padding-top: 6rem;\n}\n\n.pr-24 {\n  padding-right: 6rem;\n}\n\n.pb-24 {\n  padding-bottom: 6rem;\n}\n\n.pl-24 {\n  padding-left: 6rem;\n}\n\n.pt-32 {\n  padding-top: 8rem;\n}\n\n.pr-32 {\n  padding-right: 8rem;\n}\n\n.pb-32 {\n  padding-bottom: 8rem;\n}\n\n.pl-32 {\n  padding-left: 8rem;\n}\n\n.pt-40 {\n  padding-top: 10rem;\n}\n\n.pr-40 {\n  padding-right: 10rem;\n}\n\n.pb-40 {\n  padding-bottom: 10rem;\n}\n\n.pl-40 {\n  padding-left: 10rem;\n}\n\n.pt-48 {\n  padding-top: 12rem;\n}\n\n.pr-48 {\n  padding-right: 12rem;\n}\n\n.pb-48 {\n  padding-bottom: 12rem;\n}\n\n.pl-48 {\n  padding-left: 12rem;\n}\n\n.pt-56 {\n  padding-top: 14rem;\n}\n\n.pr-56 {\n  padding-right: 14rem;\n}\n\n.pb-56 {\n  padding-bottom: 14rem;\n}\n\n.pl-56 {\n  padding-left: 14rem;\n}\n\n.pt-64 {\n  padding-top: 16rem;\n}\n\n.pr-64 {\n  padding-right: 16rem;\n}\n\n.pb-64 {\n  padding-bottom: 16rem;\n}\n\n.pl-64 {\n  padding-left: 16rem;\n}\n\n.pt-px {\n  padding-top: 1px;\n}\n\n.pr-px {\n  padding-right: 1px;\n}\n\n.pb-px {\n  padding-bottom: 1px;\n}\n\n.pl-px {\n  padding-left: 1px;\n}\n\n.placeholder-transparent::placeholder {\n  color: transparent;\n}\n\n.placeholder-current::placeholder {\n  color: currentColor;\n}\n\n.placeholder-black::placeholder {\n  --placeholder-opacity: 1;\n  color: #000;\n  color: rgba(0, 0, 0, var(--placeholder-opacity));\n}\n\n.placeholder-white::placeholder {\n  --placeholder-opacity: 1;\n  color: #fff;\n  color: rgba(255, 255, 255, var(--placeholder-opacity));\n}\n\n.placeholder-gray-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #f7fafc;\n  color: rgba(247, 250, 252, var(--placeholder-opacity));\n}\n\n.placeholder-gray-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #edf2f7;\n  color: rgba(237, 242, 247, var(--placeholder-opacity));\n}\n\n.placeholder-gray-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--placeholder-opacity));\n}\n\n.placeholder-gray-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #cbd5e0;\n  color: rgba(203, 213, 224, var(--placeholder-opacity));\n}\n\n.placeholder-gray-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #a0aec0;\n  color: rgba(160, 174, 192, var(--placeholder-opacity));\n}\n\n.placeholder-gray-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #718096;\n  color: rgba(113, 128, 150, var(--placeholder-opacity));\n}\n\n.placeholder-gray-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #4a5568;\n  color: rgba(74, 85, 104, var(--placeholder-opacity));\n}\n\n.placeholder-gray-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #2d3748;\n  color: rgba(45, 55, 72, var(--placeholder-opacity));\n}\n\n.placeholder-gray-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #1a202c;\n  color: rgba(26, 32, 44, var(--placeholder-opacity));\n}\n\n.placeholder-red-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #fff5f5;\n  color: rgba(255, 245, 245, var(--placeholder-opacity));\n}\n\n.placeholder-red-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #fed7d7;\n  color: rgba(254, 215, 215, var(--placeholder-opacity));\n}\n\n.placeholder-red-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #feb2b2;\n  color: rgba(254, 178, 178, var(--placeholder-opacity));\n}\n\n.placeholder-red-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #fc8181;\n  color: rgba(252, 129, 129, var(--placeholder-opacity));\n}\n\n.placeholder-red-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #f56565;\n  color: rgba(245, 101, 101, var(--placeholder-opacity));\n}\n\n.placeholder-red-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #e53e3e;\n  color: rgba(229, 62, 62, var(--placeholder-opacity));\n}\n\n.placeholder-red-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #c53030;\n  color: rgba(197, 48, 48, var(--placeholder-opacity));\n}\n\n.placeholder-red-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #9b2c2c;\n  color: rgba(155, 44, 44, var(--placeholder-opacity));\n}\n\n.placeholder-red-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #742a2a;\n  color: rgba(116, 42, 42, var(--placeholder-opacity));\n}\n\n.placeholder-orange-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #fffaf0;\n  color: rgba(255, 250, 240, var(--placeholder-opacity));\n}\n\n.placeholder-orange-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #feebc8;\n  color: rgba(254, 235, 200, var(--placeholder-opacity));\n}\n\n.placeholder-orange-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #fbd38d;\n  color: rgba(251, 211, 141, var(--placeholder-opacity));\n}\n\n.placeholder-orange-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #f6ad55;\n  color: rgba(246, 173, 85, var(--placeholder-opacity));\n}\n\n.placeholder-orange-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #ed8936;\n  color: rgba(237, 137, 54, var(--placeholder-opacity));\n}\n\n.placeholder-orange-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #dd6b20;\n  color: rgba(221, 107, 32, var(--placeholder-opacity));\n}\n\n.placeholder-orange-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #c05621;\n  color: rgba(192, 86, 33, var(--placeholder-opacity));\n}\n\n.placeholder-orange-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #9c4221;\n  color: rgba(156, 66, 33, var(--placeholder-opacity));\n}\n\n.placeholder-orange-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #7b341e;\n  color: rgba(123, 52, 30, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #fffff0;\n  color: rgba(255, 255, 240, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #fefcbf;\n  color: rgba(254, 252, 191, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #faf089;\n  color: rgba(250, 240, 137, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #f6e05e;\n  color: rgba(246, 224, 94, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #ecc94b;\n  color: rgba(236, 201, 75, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #d69e2e;\n  color: rgba(214, 158, 46, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #b7791f;\n  color: rgba(183, 121, 31, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #975a16;\n  color: rgba(151, 90, 22, var(--placeholder-opacity));\n}\n\n.placeholder-yellow-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #744210;\n  color: rgba(116, 66, 16, var(--placeholder-opacity));\n}\n\n.placeholder-green-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #f0fff4;\n  color: rgba(240, 255, 244, var(--placeholder-opacity));\n}\n\n.placeholder-green-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #c6f6d5;\n  color: rgba(198, 246, 213, var(--placeholder-opacity));\n}\n\n.placeholder-green-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #9ae6b4;\n  color: rgba(154, 230, 180, var(--placeholder-opacity));\n}\n\n.placeholder-green-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #68d391;\n  color: rgba(104, 211, 145, var(--placeholder-opacity));\n}\n\n.placeholder-green-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #48bb78;\n  color: rgba(72, 187, 120, var(--placeholder-opacity));\n}\n\n.placeholder-green-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #38a169;\n  color: rgba(56, 161, 105, var(--placeholder-opacity));\n}\n\n.placeholder-green-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #2f855a;\n  color: rgba(47, 133, 90, var(--placeholder-opacity));\n}\n\n.placeholder-green-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #276749;\n  color: rgba(39, 103, 73, var(--placeholder-opacity));\n}\n\n.placeholder-green-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #22543d;\n  color: rgba(34, 84, 61, var(--placeholder-opacity));\n}\n\n.placeholder-teal-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #e6fffa;\n  color: rgba(230, 255, 250, var(--placeholder-opacity));\n}\n\n.placeholder-teal-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #b2f5ea;\n  color: rgba(178, 245, 234, var(--placeholder-opacity));\n}\n\n.placeholder-teal-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #81e6d9;\n  color: rgba(129, 230, 217, var(--placeholder-opacity));\n}\n\n.placeholder-teal-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #4fd1c5;\n  color: rgba(79, 209, 197, var(--placeholder-opacity));\n}\n\n.placeholder-teal-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #38b2ac;\n  color: rgba(56, 178, 172, var(--placeholder-opacity));\n}\n\n.placeholder-teal-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #319795;\n  color: rgba(49, 151, 149, var(--placeholder-opacity));\n}\n\n.placeholder-teal-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #2c7a7b;\n  color: rgba(44, 122, 123, var(--placeholder-opacity));\n}\n\n.placeholder-teal-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #285e61;\n  color: rgba(40, 94, 97, var(--placeholder-opacity));\n}\n\n.placeholder-teal-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #234e52;\n  color: rgba(35, 78, 82, var(--placeholder-opacity));\n}\n\n.placeholder-blue-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #ebf8ff;\n  color: rgba(235, 248, 255, var(--placeholder-opacity));\n}\n\n.placeholder-blue-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #bee3f8;\n  color: rgba(190, 227, 248, var(--placeholder-opacity));\n}\n\n.placeholder-blue-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #90cdf4;\n  color: rgba(144, 205, 244, var(--placeholder-opacity));\n}\n\n.placeholder-blue-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #63b3ed;\n  color: rgba(99, 179, 237, var(--placeholder-opacity));\n}\n\n.placeholder-blue-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #4299e1;\n  color: rgba(66, 153, 225, var(--placeholder-opacity));\n}\n\n.placeholder-blue-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #3182ce;\n  color: rgba(49, 130, 206, var(--placeholder-opacity));\n}\n\n.placeholder-blue-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #2b6cb0;\n  color: rgba(43, 108, 176, var(--placeholder-opacity));\n}\n\n.placeholder-blue-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #2c5282;\n  color: rgba(44, 82, 130, var(--placeholder-opacity));\n}\n\n.placeholder-blue-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #2a4365;\n  color: rgba(42, 67, 101, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #ebf4ff;\n  color: rgba(235, 244, 255, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #c3dafe;\n  color: rgba(195, 218, 254, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #a3bffa;\n  color: rgba(163, 191, 250, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #7f9cf5;\n  color: rgba(127, 156, 245, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #667eea;\n  color: rgba(102, 126, 234, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #5a67d8;\n  color: rgba(90, 103, 216, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #4c51bf;\n  color: rgba(76, 81, 191, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #434190;\n  color: rgba(67, 65, 144, var(--placeholder-opacity));\n}\n\n.placeholder-indigo-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #3c366b;\n  color: rgba(60, 54, 107, var(--placeholder-opacity));\n}\n\n.placeholder-purple-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #faf5ff;\n  color: rgba(250, 245, 255, var(--placeholder-opacity));\n}\n\n.placeholder-purple-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #e9d8fd;\n  color: rgba(233, 216, 253, var(--placeholder-opacity));\n}\n\n.placeholder-purple-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #d6bcfa;\n  color: rgba(214, 188, 250, var(--placeholder-opacity));\n}\n\n.placeholder-purple-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #b794f4;\n  color: rgba(183, 148, 244, var(--placeholder-opacity));\n}\n\n.placeholder-purple-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #9f7aea;\n  color: rgba(159, 122, 234, var(--placeholder-opacity));\n}\n\n.placeholder-purple-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #805ad5;\n  color: rgba(128, 90, 213, var(--placeholder-opacity));\n}\n\n.placeholder-purple-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #6b46c1;\n  color: rgba(107, 70, 193, var(--placeholder-opacity));\n}\n\n.placeholder-purple-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #553c9a;\n  color: rgba(85, 60, 154, var(--placeholder-opacity));\n}\n\n.placeholder-purple-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #44337a;\n  color: rgba(68, 51, 122, var(--placeholder-opacity));\n}\n\n.placeholder-pink-100::placeholder {\n  --placeholder-opacity: 1;\n  color: #fff5f7;\n  color: rgba(255, 245, 247, var(--placeholder-opacity));\n}\n\n.placeholder-pink-200::placeholder {\n  --placeholder-opacity: 1;\n  color: #fed7e2;\n  color: rgba(254, 215, 226, var(--placeholder-opacity));\n}\n\n.placeholder-pink-300::placeholder {\n  --placeholder-opacity: 1;\n  color: #fbb6ce;\n  color: rgba(251, 182, 206, var(--placeholder-opacity));\n}\n\n.placeholder-pink-400::placeholder {\n  --placeholder-opacity: 1;\n  color: #f687b3;\n  color: rgba(246, 135, 179, var(--placeholder-opacity));\n}\n\n.placeholder-pink-500::placeholder {\n  --placeholder-opacity: 1;\n  color: #ed64a6;\n  color: rgba(237, 100, 166, var(--placeholder-opacity));\n}\n\n.placeholder-pink-600::placeholder {\n  --placeholder-opacity: 1;\n  color: #d53f8c;\n  color: rgba(213, 63, 140, var(--placeholder-opacity));\n}\n\n.placeholder-pink-700::placeholder {\n  --placeholder-opacity: 1;\n  color: #b83280;\n  color: rgba(184, 50, 128, var(--placeholder-opacity));\n}\n\n.placeholder-pink-800::placeholder {\n  --placeholder-opacity: 1;\n  color: #97266d;\n  color: rgba(151, 38, 109, var(--placeholder-opacity));\n}\n\n.placeholder-pink-900::placeholder {\n  --placeholder-opacity: 1;\n  color: #702459;\n  color: rgba(112, 36, 89, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-transparent:focus::placeholder {\n  color: transparent;\n}\n\n.focus\\:placeholder-current:focus::placeholder {\n  color: currentColor;\n}\n\n.focus\\:placeholder-black:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #000;\n  color: rgba(0, 0, 0, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-white:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fff;\n  color: rgba(255, 255, 255, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f7fafc;\n  color: rgba(247, 250, 252, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #edf2f7;\n  color: rgba(237, 242, 247, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e2e8f0;\n  color: rgba(226, 232, 240, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #cbd5e0;\n  color: rgba(203, 213, 224, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #a0aec0;\n  color: rgba(160, 174, 192, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #718096;\n  color: rgba(113, 128, 150, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #4a5568;\n  color: rgba(74, 85, 104, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #2d3748;\n  color: rgba(45, 55, 72, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-gray-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #1a202c;\n  color: rgba(26, 32, 44, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fff5f5;\n  color: rgba(255, 245, 245, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fed7d7;\n  color: rgba(254, 215, 215, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #feb2b2;\n  color: rgba(254, 178, 178, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fc8181;\n  color: rgba(252, 129, 129, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f56565;\n  color: rgba(245, 101, 101, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e53e3e;\n  color: rgba(229, 62, 62, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #c53030;\n  color: rgba(197, 48, 48, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #9b2c2c;\n  color: rgba(155, 44, 44, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-red-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #742a2a;\n  color: rgba(116, 42, 42, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fffaf0;\n  color: rgba(255, 250, 240, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #feebc8;\n  color: rgba(254, 235, 200, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fbd38d;\n  color: rgba(251, 211, 141, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f6ad55;\n  color: rgba(246, 173, 85, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ed8936;\n  color: rgba(237, 137, 54, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #dd6b20;\n  color: rgba(221, 107, 32, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #c05621;\n  color: rgba(192, 86, 33, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #9c4221;\n  color: rgba(156, 66, 33, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-orange-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #7b341e;\n  color: rgba(123, 52, 30, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fffff0;\n  color: rgba(255, 255, 240, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fefcbf;\n  color: rgba(254, 252, 191, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #faf089;\n  color: rgba(250, 240, 137, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f6e05e;\n  color: rgba(246, 224, 94, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ecc94b;\n  color: rgba(236, 201, 75, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #d69e2e;\n  color: rgba(214, 158, 46, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #b7791f;\n  color: rgba(183, 121, 31, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #975a16;\n  color: rgba(151, 90, 22, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-yellow-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #744210;\n  color: rgba(116, 66, 16, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f0fff4;\n  color: rgba(240, 255, 244, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #c6f6d5;\n  color: rgba(198, 246, 213, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #9ae6b4;\n  color: rgba(154, 230, 180, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #68d391;\n  color: rgba(104, 211, 145, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #48bb78;\n  color: rgba(72, 187, 120, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #38a169;\n  color: rgba(56, 161, 105, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #2f855a;\n  color: rgba(47, 133, 90, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #276749;\n  color: rgba(39, 103, 73, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-green-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #22543d;\n  color: rgba(34, 84, 61, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e6fffa;\n  color: rgba(230, 255, 250, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #b2f5ea;\n  color: rgba(178, 245, 234, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #81e6d9;\n  color: rgba(129, 230, 217, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #4fd1c5;\n  color: rgba(79, 209, 197, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #38b2ac;\n  color: rgba(56, 178, 172, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #319795;\n  color: rgba(49, 151, 149, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #2c7a7b;\n  color: rgba(44, 122, 123, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #285e61;\n  color: rgba(40, 94, 97, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-teal-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #234e52;\n  color: rgba(35, 78, 82, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ebf8ff;\n  color: rgba(235, 248, 255, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #bee3f8;\n  color: rgba(190, 227, 248, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #90cdf4;\n  color: rgba(144, 205, 244, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #63b3ed;\n  color: rgba(99, 179, 237, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #4299e1;\n  color: rgba(66, 153, 225, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #3182ce;\n  color: rgba(49, 130, 206, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #2b6cb0;\n  color: rgba(43, 108, 176, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #2c5282;\n  color: rgba(44, 82, 130, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-blue-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #2a4365;\n  color: rgba(42, 67, 101, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ebf4ff;\n  color: rgba(235, 244, 255, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #c3dafe;\n  color: rgba(195, 218, 254, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #a3bffa;\n  color: rgba(163, 191, 250, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #7f9cf5;\n  color: rgba(127, 156, 245, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #667eea;\n  color: rgba(102, 126, 234, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #5a67d8;\n  color: rgba(90, 103, 216, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #4c51bf;\n  color: rgba(76, 81, 191, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #434190;\n  color: rgba(67, 65, 144, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-indigo-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #3c366b;\n  color: rgba(60, 54, 107, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #faf5ff;\n  color: rgba(250, 245, 255, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #e9d8fd;\n  color: rgba(233, 216, 253, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #d6bcfa;\n  color: rgba(214, 188, 250, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #b794f4;\n  color: rgba(183, 148, 244, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #9f7aea;\n  color: rgba(159, 122, 234, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #805ad5;\n  color: rgba(128, 90, 213, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #6b46c1;\n  color: rgba(107, 70, 193, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #553c9a;\n  color: rgba(85, 60, 154, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-purple-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #44337a;\n  color: rgba(68, 51, 122, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-100:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fff5f7;\n  color: rgba(255, 245, 247, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-200:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fed7e2;\n  color: rgba(254, 215, 226, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-300:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #fbb6ce;\n  color: rgba(251, 182, 206, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-400:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #f687b3;\n  color: rgba(246, 135, 179, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-500:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #ed64a6;\n  color: rgba(237, 100, 166, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-600:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #d53f8c;\n  color: rgba(213, 63, 140, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-700:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #b83280;\n  color: rgba(184, 50, 128, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-800:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #97266d;\n  color: rgba(151, 38, 109, var(--placeholder-opacity));\n}\n\n.focus\\:placeholder-pink-900:focus::placeholder {\n  --placeholder-opacity: 1;\n  color: #702459;\n  color: rgba(112, 36, 89, var(--placeholder-opacity));\n}\n\n.placeholder-opacity-0::placeholder {\n  --placeholder-opacity: 0;\n}\n\n.placeholder-opacity-25::placeholder {\n  --placeholder-opacity: 0.25;\n}\n\n.placeholder-opacity-50::placeholder {\n  --placeholder-opacity: 0.5;\n}\n\n.placeholder-opacity-75::placeholder {\n  --placeholder-opacity: 0.75;\n}\n\n.placeholder-opacity-100::placeholder {\n  --placeholder-opacity: 1;\n}\n\n.focus\\:placeholder-opacity-0:focus::placeholder {\n  --placeholder-opacity: 0;\n}\n\n.focus\\:placeholder-opacity-25:focus::placeholder {\n  --placeholder-opacity: 0.25;\n}\n\n.focus\\:placeholder-opacity-50:focus::placeholder {\n  --placeholder-opacity: 0.5;\n}\n\n.focus\\:placeholder-opacity-75:focus::placeholder {\n  --placeholder-opacity: 0.75;\n}\n\n.focus\\:placeholder-opacity-100:focus::placeholder {\n  --placeholder-opacity: 1;\n}\n\n.pointer-events-none {\n  pointer-events: none;\n}\n\n.pointer-events-auto {\n  pointer-events: auto;\n}\n\n.static {\n  position: static;\n}\n\n.fixed {\n  position: fixed;\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.sticky {\n  position: sticky;\n}\n\n.inset-0 {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.inset-auto {\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n}\n\n.inset-y-0 {\n  top: 0;\n  bottom: 0;\n}\n\n.inset-x-0 {\n  right: 0;\n  left: 0;\n}\n\n.inset-y-auto {\n  top: auto;\n  bottom: auto;\n}\n\n.inset-x-auto {\n  right: auto;\n  left: auto;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.right-0 {\n  right: 0;\n}\n\n.bottom-0 {\n  bottom: 0;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.top-auto {\n  top: auto;\n}\n\n.right-auto {\n  right: auto;\n}\n\n.bottom-auto {\n  bottom: auto;\n}\n\n.left-auto {\n  left: auto;\n}\n\n.resize-none {\n  resize: none;\n}\n\n.resize-y {\n  resize: vertical;\n}\n\n.resize-x {\n  resize: horizontal;\n}\n\n.resize {\n  resize: both;\n}\n\n.shadow-xs {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n\n.shadow-sm {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.shadow {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n\n.shadow-md {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.shadow-lg {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.shadow-xl {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.shadow-2xl {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.shadow-inner {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n\n.shadow-outline {\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n}\n\n.shadow-none {\n  box-shadow: none;\n}\n\n.hover\\:shadow-xs:hover {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n\n.hover\\:shadow-sm:hover {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.hover\\:shadow:hover {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n\n.hover\\:shadow-md:hover {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.hover\\:shadow-lg:hover {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.hover\\:shadow-xl:hover {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.hover\\:shadow-2xl:hover {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.hover\\:shadow-inner:hover {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n\n.hover\\:shadow-outline:hover {\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n}\n\n.hover\\:shadow-none:hover {\n  box-shadow: none;\n}\n\n.focus\\:shadow-xs:focus {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n}\n\n.focus\\:shadow-sm:focus {\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n}\n\n.focus\\:shadow:focus {\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n\n.focus\\:shadow-md:focus {\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n.focus\\:shadow-lg:focus {\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.focus\\:shadow-xl:focus {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.focus\\:shadow-2xl:focus {\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n}\n\n.focus\\:shadow-inner:focus {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n}\n\n.focus\\:shadow-outline:focus {\n  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n}\n\n.focus\\:shadow-none:focus {\n  box-shadow: none;\n}\n\n.fill-current {\n  fill: currentColor;\n}\n\n.stroke-current {\n  stroke: currentColor;\n}\n\n.stroke-0 {\n  stroke-width: 0;\n}\n\n.stroke-1 {\n  stroke-width: 1;\n}\n\n.stroke-2 {\n  stroke-width: 2;\n}\n\n.table-auto {\n  table-layout: auto;\n}\n\n.table-fixed {\n  table-layout: fixed;\n}\n\n.text-left {\n  text-align: left;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.text-right {\n  text-align: right;\n}\n\n.text-justify {\n  text-align: justify;\n}\n\n.text-blue {\n  --text-opacity: 1;\n  color: #2C7FFF;\n  color: rgba(44, 127, 255, var(--text-opacity));\n}\n\n.text-primaryText {\n  --text-opacity: 1;\n  color: #0E264B;\n  color: rgba(14, 38, 75, var(--text-opacity));\n}\n\n.text-red {\n  --text-opacity: 1;\n  color: #FF2759;\n  color: rgba(255, 39, 89, var(--text-opacity));\n}\n\n.hover\\:text-blue:hover {\n  --text-opacity: 1;\n  color: #2C7FFF;\n  color: rgba(44, 127, 255, var(--text-opacity));\n}\n\n.hover\\:text-primaryText:hover {\n  --text-opacity: 1;\n  color: #0E264B;\n  color: rgba(14, 38, 75, var(--text-opacity));\n}\n\n.hover\\:text-red:hover {\n  --text-opacity: 1;\n  color: #FF2759;\n  color: rgba(255, 39, 89, var(--text-opacity));\n}\n\n.focus\\:text-blue:focus {\n  --text-opacity: 1;\n  color: #2C7FFF;\n  color: rgba(44, 127, 255, var(--text-opacity));\n}\n\n.focus\\:text-primaryText:focus {\n  --text-opacity: 1;\n  color: #0E264B;\n  color: rgba(14, 38, 75, var(--text-opacity));\n}\n\n.focus\\:text-red:focus {\n  --text-opacity: 1;\n  color: #FF2759;\n  color: rgba(255, 39, 89, var(--text-opacity));\n}\n\n.text-opacity-0 {\n  --text-opacity: 0;\n}\n\n.text-opacity-25 {\n  --text-opacity: 0.25;\n}\n\n.text-opacity-50 {\n  --text-opacity: 0.5;\n}\n\n.text-opacity-75 {\n  --text-opacity: 0.75;\n}\n\n.text-opacity-100 {\n  --text-opacity: 1;\n}\n\n.hover\\:text-opacity-0:hover {\n  --text-opacity: 0;\n}\n\n.hover\\:text-opacity-25:hover {\n  --text-opacity: 0.25;\n}\n\n.hover\\:text-opacity-50:hover {\n  --text-opacity: 0.5;\n}\n\n.hover\\:text-opacity-75:hover {\n  --text-opacity: 0.75;\n}\n\n.hover\\:text-opacity-100:hover {\n  --text-opacity: 1;\n}\n\n.focus\\:text-opacity-0:focus {\n  --text-opacity: 0;\n}\n\n.focus\\:text-opacity-25:focus {\n  --text-opacity: 0.25;\n}\n\n.focus\\:text-opacity-50:focus {\n  --text-opacity: 0.5;\n}\n\n.focus\\:text-opacity-75:focus {\n  --text-opacity: 0.75;\n}\n\n.focus\\:text-opacity-100:focus {\n  --text-opacity: 1;\n}\n\n.italic {\n  font-style: italic;\n}\n\n.not-italic {\n  font-style: normal;\n}\n\n.uppercase {\n  text-transform: uppercase;\n}\n\n.lowercase {\n  text-transform: lowercase;\n}\n\n.capitalize {\n  text-transform: capitalize;\n}\n\n.normal-case {\n  text-transform: none;\n}\n\n.underline {\n  text-decoration: underline;\n}\n\n.line-through {\n  text-decoration: line-through;\n}\n\n.no-underline {\n  text-decoration: none;\n}\n\n.hover\\:underline:hover {\n  text-decoration: underline;\n}\n\n.hover\\:line-through:hover {\n  text-decoration: line-through;\n}\n\n.hover\\:no-underline:hover {\n  text-decoration: none;\n}\n\n.focus\\:underline:focus {\n  text-decoration: underline;\n}\n\n.focus\\:line-through:focus {\n  text-decoration: line-through;\n}\n\n.focus\\:no-underline:focus {\n  text-decoration: none;\n}\n\n.antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.subpixel-antialiased {\n  -webkit-font-smoothing: auto;\n  -moz-osx-font-smoothing: auto;\n}\n\n.ordinal, .slashed-zero, .lining-nums, .oldstyle-nums, .proportional-nums, .tabular-nums, .diagonal-fractions, .stacked-fractions {\n  --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);\n  --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);\n  --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);\n  --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);\n  --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);\n  font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n}\n\n.normal-nums {\n  font-variant-numeric: normal;\n}\n\n.ordinal {\n  --font-variant-numeric-ordinal: ordinal;\n}\n\n.slashed-zero {\n  --font-variant-numeric-slashed-zero: slashed-zero;\n}\n\n.lining-nums {\n  --font-variant-numeric-figure: lining-nums;\n}\n\n.oldstyle-nums {\n  --font-variant-numeric-figure: oldstyle-nums;\n}\n\n.proportional-nums {\n  --font-variant-numeric-spacing: proportional-nums;\n}\n\n.tabular-nums {\n  --font-variant-numeric-spacing: tabular-nums;\n}\n\n.diagonal-fractions {\n  --font-variant-numeric-fraction: diagonal-fractions;\n}\n\n.stacked-fractions {\n  --font-variant-numeric-fraction: stacked-fractions;\n}\n\n.tracking-tighter {\n  letter-spacing: -0.05em;\n}\n\n.tracking-tight {\n  letter-spacing: -0.025em;\n}\n\n.tracking-normal {\n  letter-spacing: 0;\n}\n\n.tracking-wide {\n  letter-spacing: 0.025em;\n}\n\n.tracking-wider {\n  letter-spacing: 0.05em;\n}\n\n.tracking-widest {\n  letter-spacing: 0.1em;\n}\n\n.select-none {\n  -webkit-user-select: none;\n          user-select: none;\n}\n\n.select-text {\n  -webkit-user-select: text;\n          user-select: text;\n}\n\n.select-all {\n  -webkit-user-select: all;\n          user-select: all;\n}\n\n.select-auto {\n  -webkit-user-select: auto;\n          user-select: auto;\n}\n\n.align-baseline {\n  vertical-align: baseline;\n}\n\n.align-top {\n  vertical-align: top;\n}\n\n.align-middle {\n  vertical-align: middle;\n}\n\n.align-bottom {\n  vertical-align: bottom;\n}\n\n.align-text-top {\n  vertical-align: text-top;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom;\n}\n\n.visible {\n  visibility: visible;\n}\n\n.invisible {\n  visibility: hidden;\n}\n\n.whitespace-normal {\n  white-space: normal;\n}\n\n.whitespace-no-wrap {\n  white-space: nowrap;\n}\n\n.whitespace-pre {\n  white-space: pre;\n}\n\n.whitespace-pre-line {\n  white-space: pre-line;\n}\n\n.whitespace-pre-wrap {\n  white-space: pre-wrap;\n}\n\n.break-normal {\n  word-wrap: normal;\n  overflow-wrap: normal;\n  word-break: normal;\n}\n\n.break-words {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.break-all {\n  word-break: break-all;\n}\n\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.w-0 {\n  width: 0;\n}\n\n.w-1 {\n  width: 0.25rem;\n}\n\n.w-2 {\n  width: 0.5rem;\n}\n\n.w-3 {\n  width: 0.75rem;\n}\n\n.w-4 {\n  width: 1rem;\n}\n\n.w-5 {\n  width: 1.25rem;\n}\n\n.w-6 {\n  width: 1.5rem;\n}\n\n.w-8 {\n  width: 2rem;\n}\n\n.w-10 {\n  width: 2.5rem;\n}\n\n.w-12 {\n  width: 3rem;\n}\n\n.w-16 {\n  width: 4rem;\n}\n\n.w-20 {\n  width: 5rem;\n}\n\n.w-24 {\n  width: 6rem;\n}\n\n.w-32 {\n  width: 8rem;\n}\n\n.w-40 {\n  width: 10rem;\n}\n\n.w-48 {\n  width: 12rem;\n}\n\n.w-56 {\n  width: 14rem;\n}\n\n.w-64 {\n  width: 16rem;\n}\n\n.w-auto {\n  width: auto;\n}\n\n.w-px {\n  width: 1px;\n}\n\n.w-1\\/2 {\n  width: 50%;\n}\n\n.w-1\\/3 {\n  width: 33.333333%;\n}\n\n.w-2\\/3 {\n  width: 66.666667%;\n}\n\n.w-1\\/4 {\n  width: 25%;\n}\n\n.w-2\\/4 {\n  width: 50%;\n}\n\n.w-3\\/4 {\n  width: 75%;\n}\n\n.w-1\\/5 {\n  width: 20%;\n}\n\n.w-2\\/5 {\n  width: 40%;\n}\n\n.w-3\\/5 {\n  width: 60%;\n}\n\n.w-4\\/5 {\n  width: 80%;\n}\n\n.w-1\\/6 {\n  width: 16.666667%;\n}\n\n.w-2\\/6 {\n  width: 33.333333%;\n}\n\n.w-3\\/6 {\n  width: 50%;\n}\n\n.w-4\\/6 {\n  width: 66.666667%;\n}\n\n.w-5\\/6 {\n  width: 83.333333%;\n}\n\n.w-1\\/12 {\n  width: 8.333333%;\n}\n\n.w-2\\/12 {\n  width: 16.666667%;\n}\n\n.w-3\\/12 {\n  width: 25%;\n}\n\n.w-4\\/12 {\n  width: 33.333333%;\n}\n\n.w-5\\/12 {\n  width: 41.666667%;\n}\n\n.w-6\\/12 {\n  width: 50%;\n}\n\n.w-7\\/12 {\n  width: 58.333333%;\n}\n\n.w-8\\/12 {\n  width: 66.666667%;\n}\n\n.w-9\\/12 {\n  width: 75%;\n}\n\n.w-10\\/12 {\n  width: 83.333333%;\n}\n\n.w-11\\/12 {\n  width: 91.666667%;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-screen {\n  width: 100vw;\n}\n\n.z-0 {\n  z-index: 0;\n}\n\n.z-10 {\n  z-index: 10;\n}\n\n.z-20 {\n  z-index: 20;\n}\n\n.z-30 {\n  z-index: 30;\n}\n\n.z-40 {\n  z-index: 40;\n}\n\n.z-50 {\n  z-index: 50;\n}\n\n.z-auto {\n  z-index: auto;\n}\n\n.gap-0 {\n  grid-gap: 0;\n  gap: 0;\n}\n\n.gap-1 {\n  grid-gap: 0.25rem;\n  gap: 0.25rem;\n}\n\n.gap-2 {\n  grid-gap: 0.5rem;\n  gap: 0.5rem;\n}\n\n.gap-3 {\n  grid-gap: 0.75rem;\n  gap: 0.75rem;\n}\n\n.gap-4 {\n  grid-gap: 1rem;\n  gap: 1rem;\n}\n\n.gap-5 {\n  grid-gap: 1.25rem;\n  gap: 1.25rem;\n}\n\n.gap-6 {\n  grid-gap: 1.5rem;\n  gap: 1.5rem;\n}\n\n.gap-8 {\n  grid-gap: 2rem;\n  gap: 2rem;\n}\n\n.gap-10 {\n  grid-gap: 2.5rem;\n  gap: 2.5rem;\n}\n\n.gap-12 {\n  grid-gap: 3rem;\n  gap: 3rem;\n}\n\n.gap-16 {\n  grid-gap: 4rem;\n  gap: 4rem;\n}\n\n.gap-20 {\n  grid-gap: 5rem;\n  gap: 5rem;\n}\n\n.gap-24 {\n  grid-gap: 6rem;\n  gap: 6rem;\n}\n\n.gap-32 {\n  grid-gap: 8rem;\n  gap: 8rem;\n}\n\n.gap-40 {\n  grid-gap: 10rem;\n  gap: 10rem;\n}\n\n.gap-48 {\n  grid-gap: 12rem;\n  gap: 12rem;\n}\n\n.gap-56 {\n  grid-gap: 14rem;\n  gap: 14rem;\n}\n\n.gap-64 {\n  grid-gap: 16rem;\n  gap: 16rem;\n}\n\n.gap-px {\n  grid-gap: 1px;\n  gap: 1px;\n}\n\n.col-gap-0 {\n  grid-column-gap: 0;\n  column-gap: 0;\n}\n\n.col-gap-1 {\n  grid-column-gap: 0.25rem;\n  column-gap: 0.25rem;\n}\n\n.col-gap-2 {\n  grid-column-gap: 0.5rem;\n  column-gap: 0.5rem;\n}\n\n.col-gap-3 {\n  grid-column-gap: 0.75rem;\n  column-gap: 0.75rem;\n}\n\n.col-gap-4 {\n  grid-column-gap: 1rem;\n  column-gap: 1rem;\n}\n\n.col-gap-5 {\n  grid-column-gap: 1.25rem;\n  column-gap: 1.25rem;\n}\n\n.col-gap-6 {\n  grid-column-gap: 1.5rem;\n  column-gap: 1.5rem;\n}\n\n.col-gap-8 {\n  grid-column-gap: 2rem;\n  column-gap: 2rem;\n}\n\n.col-gap-10 {\n  grid-column-gap: 2.5rem;\n  column-gap: 2.5rem;\n}\n\n.col-gap-12 {\n  grid-column-gap: 3rem;\n  column-gap: 3rem;\n}\n\n.col-gap-16 {\n  grid-column-gap: 4rem;\n  column-gap: 4rem;\n}\n\n.col-gap-20 {\n  grid-column-gap: 5rem;\n  column-gap: 5rem;\n}\n\n.col-gap-24 {\n  grid-column-gap: 6rem;\n  column-gap: 6rem;\n}\n\n.col-gap-32 {\n  grid-column-gap: 8rem;\n  column-gap: 8rem;\n}\n\n.col-gap-40 {\n  grid-column-gap: 10rem;\n  column-gap: 10rem;\n}\n\n.col-gap-48 {\n  grid-column-gap: 12rem;\n  column-gap: 12rem;\n}\n\n.col-gap-56 {\n  grid-column-gap: 14rem;\n  column-gap: 14rem;\n}\n\n.col-gap-64 {\n  grid-column-gap: 16rem;\n  column-gap: 16rem;\n}\n\n.col-gap-px {\n  grid-column-gap: 1px;\n  column-gap: 1px;\n}\n\n.gap-x-0 {\n  grid-column-gap: 0;\n  column-gap: 0;\n}\n\n.gap-x-1 {\n  grid-column-gap: 0.25rem;\n  column-gap: 0.25rem;\n}\n\n.gap-x-2 {\n  grid-column-gap: 0.5rem;\n  column-gap: 0.5rem;\n}\n\n.gap-x-3 {\n  grid-column-gap: 0.75rem;\n  column-gap: 0.75rem;\n}\n\n.gap-x-4 {\n  grid-column-gap: 1rem;\n  column-gap: 1rem;\n}\n\n.gap-x-5 {\n  grid-column-gap: 1.25rem;\n  column-gap: 1.25rem;\n}\n\n.gap-x-6 {\n  grid-column-gap: 1.5rem;\n  column-gap: 1.5rem;\n}\n\n.gap-x-8 {\n  grid-column-gap: 2rem;\n  column-gap: 2rem;\n}\n\n.gap-x-10 {\n  grid-column-gap: 2.5rem;\n  column-gap: 2.5rem;\n}\n\n.gap-x-12 {\n  grid-column-gap: 3rem;\n  column-gap: 3rem;\n}\n\n.gap-x-16 {\n  grid-column-gap: 4rem;\n  column-gap: 4rem;\n}\n\n.gap-x-20 {\n  grid-column-gap: 5rem;\n  column-gap: 5rem;\n}\n\n.gap-x-24 {\n  grid-column-gap: 6rem;\n  column-gap: 6rem;\n}\n\n.gap-x-32 {\n  grid-column-gap: 8rem;\n  column-gap: 8rem;\n}\n\n.gap-x-40 {\n  grid-column-gap: 10rem;\n  column-gap: 10rem;\n}\n\n.gap-x-48 {\n  grid-column-gap: 12rem;\n  column-gap: 12rem;\n}\n\n.gap-x-56 {\n  grid-column-gap: 14rem;\n  column-gap: 14rem;\n}\n\n.gap-x-64 {\n  grid-column-gap: 16rem;\n  column-gap: 16rem;\n}\n\n.gap-x-px {\n  grid-column-gap: 1px;\n  column-gap: 1px;\n}\n\n.row-gap-0 {\n  grid-row-gap: 0;\n  row-gap: 0;\n}\n\n.row-gap-1 {\n  grid-row-gap: 0.25rem;\n  row-gap: 0.25rem;\n}\n\n.row-gap-2 {\n  grid-row-gap: 0.5rem;\n  row-gap: 0.5rem;\n}\n\n.row-gap-3 {\n  grid-row-gap: 0.75rem;\n  row-gap: 0.75rem;\n}\n\n.row-gap-4 {\n  grid-row-gap: 1rem;\n  row-gap: 1rem;\n}\n\n.row-gap-5 {\n  grid-row-gap: 1.25rem;\n  row-gap: 1.25rem;\n}\n\n.row-gap-6 {\n  grid-row-gap: 1.5rem;\n  row-gap: 1.5rem;\n}\n\n.row-gap-8 {\n  grid-row-gap: 2rem;\n  row-gap: 2rem;\n}\n\n.row-gap-10 {\n  grid-row-gap: 2.5rem;\n  row-gap: 2.5rem;\n}\n\n.row-gap-12 {\n  grid-row-gap: 3rem;\n  row-gap: 3rem;\n}\n\n.row-gap-16 {\n  grid-row-gap: 4rem;\n  row-gap: 4rem;\n}\n\n.row-gap-20 {\n  grid-row-gap: 5rem;\n  row-gap: 5rem;\n}\n\n.row-gap-24 {\n  grid-row-gap: 6rem;\n  row-gap: 6rem;\n}\n\n.row-gap-32 {\n  grid-row-gap: 8rem;\n  row-gap: 8rem;\n}\n\n.row-gap-40 {\n  grid-row-gap: 10rem;\n  row-gap: 10rem;\n}\n\n.row-gap-48 {\n  grid-row-gap: 12rem;\n  row-gap: 12rem;\n}\n\n.row-gap-56 {\n  grid-row-gap: 14rem;\n  row-gap: 14rem;\n}\n\n.row-gap-64 {\n  grid-row-gap: 16rem;\n  row-gap: 16rem;\n}\n\n.row-gap-px {\n  grid-row-gap: 1px;\n  row-gap: 1px;\n}\n\n.gap-y-0 {\n  grid-row-gap: 0;\n  row-gap: 0;\n}\n\n.gap-y-1 {\n  grid-row-gap: 0.25rem;\n  row-gap: 0.25rem;\n}\n\n.gap-y-2 {\n  grid-row-gap: 0.5rem;\n  row-gap: 0.5rem;\n}\n\n.gap-y-3 {\n  grid-row-gap: 0.75rem;\n  row-gap: 0.75rem;\n}\n\n.gap-y-4 {\n  grid-row-gap: 1rem;\n  row-gap: 1rem;\n}\n\n.gap-y-5 {\n  grid-row-gap: 1.25rem;\n  row-gap: 1.25rem;\n}\n\n.gap-y-6 {\n  grid-row-gap: 1.5rem;\n  row-gap: 1.5rem;\n}\n\n.gap-y-8 {\n  grid-row-gap: 2rem;\n  row-gap: 2rem;\n}\n\n.gap-y-10 {\n  grid-row-gap: 2.5rem;\n  row-gap: 2.5rem;\n}\n\n.gap-y-12 {\n  grid-row-gap: 3rem;\n  row-gap: 3rem;\n}\n\n.gap-y-16 {\n  grid-row-gap: 4rem;\n  row-gap: 4rem;\n}\n\n.gap-y-20 {\n  grid-row-gap: 5rem;\n  row-gap: 5rem;\n}\n\n.gap-y-24 {\n  grid-row-gap: 6rem;\n  row-gap: 6rem;\n}\n\n.gap-y-32 {\n  grid-row-gap: 8rem;\n  row-gap: 8rem;\n}\n\n.gap-y-40 {\n  grid-row-gap: 10rem;\n  row-gap: 10rem;\n}\n\n.gap-y-48 {\n  grid-row-gap: 12rem;\n  row-gap: 12rem;\n}\n\n.gap-y-56 {\n  grid-row-gap: 14rem;\n  row-gap: 14rem;\n}\n\n.gap-y-64 {\n  grid-row-gap: 16rem;\n  row-gap: 16rem;\n}\n\n.gap-y-px {\n  grid-row-gap: 1px;\n  row-gap: 1px;\n}\n\n.grid-flow-row {\n  grid-auto-flow: row;\n}\n\n.grid-flow-col {\n  grid-auto-flow: column;\n}\n\n.grid-flow-row-dense {\n  grid-auto-flow: row dense;\n}\n\n.grid-flow-col-dense {\n  grid-auto-flow: column dense;\n}\n\n.grid-cols-1 {\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n}\n\n.grid-cols-2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.grid-cols-3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.grid-cols-4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.grid-cols-5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.grid-cols-6 {\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n}\n\n.grid-cols-7 {\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n}\n\n.grid-cols-8 {\n  grid-template-columns: repeat(8, minmax(0, 1fr));\n}\n\n.grid-cols-9 {\n  grid-template-columns: repeat(9, minmax(0, 1fr));\n}\n\n.grid-cols-10 {\n  grid-template-columns: repeat(10, minmax(0, 1fr));\n}\n\n.grid-cols-11 {\n  grid-template-columns: repeat(11, minmax(0, 1fr));\n}\n\n.grid-cols-12 {\n  grid-template-columns: repeat(12, minmax(0, 1fr));\n}\n\n.grid-cols-none {\n  grid-template-columns: none;\n}\n\n.auto-cols-auto {\n  grid-auto-columns: auto;\n}\n\n.auto-cols-min {\n  grid-auto-columns: min-content;\n}\n\n.auto-cols-max {\n  grid-auto-columns: max-content;\n}\n\n.auto-cols-fr {\n  grid-auto-columns: minmax(0, 1fr);\n}\n\n.col-auto {\n  grid-column: auto;\n}\n\n.col-span-1 {\n  grid-column: span 1 / span 1;\n}\n\n.col-span-2 {\n  grid-column: span 2 / span 2;\n}\n\n.col-span-3 {\n  grid-column: span 3 / span 3;\n}\n\n.col-span-4 {\n  grid-column: span 4 / span 4;\n}\n\n.col-span-5 {\n  grid-column: span 5 / span 5;\n}\n\n.col-span-6 {\n  grid-column: span 6 / span 6;\n}\n\n.col-span-7 {\n  grid-column: span 7 / span 7;\n}\n\n.col-span-8 {\n  grid-column: span 8 / span 8;\n}\n\n.col-span-9 {\n  grid-column: span 9 / span 9;\n}\n\n.col-span-10 {\n  grid-column: span 10 / span 10;\n}\n\n.col-span-11 {\n  grid-column: span 11 / span 11;\n}\n\n.col-span-12 {\n  grid-column: span 12 / span 12;\n}\n\n.col-span-full {\n  grid-column: 1 / -1;\n}\n\n.col-start-1 {\n  grid-column-start: 1;\n}\n\n.col-start-2 {\n  grid-column-start: 2;\n}\n\n.col-start-3 {\n  grid-column-start: 3;\n}\n\n.col-start-4 {\n  grid-column-start: 4;\n}\n\n.col-start-5 {\n  grid-column-start: 5;\n}\n\n.col-start-6 {\n  grid-column-start: 6;\n}\n\n.col-start-7 {\n  grid-column-start: 7;\n}\n\n.col-start-8 {\n  grid-column-start: 8;\n}\n\n.col-start-9 {\n  grid-column-start: 9;\n}\n\n.col-start-10 {\n  grid-column-start: 10;\n}\n\n.col-start-11 {\n  grid-column-start: 11;\n}\n\n.col-start-12 {\n  grid-column-start: 12;\n}\n\n.col-start-13 {\n  grid-column-start: 13;\n}\n\n.col-start-auto {\n  grid-column-start: auto;\n}\n\n.col-end-1 {\n  grid-column-end: 1;\n}\n\n.col-end-2 {\n  grid-column-end: 2;\n}\n\n.col-end-3 {\n  grid-column-end: 3;\n}\n\n.col-end-4 {\n  grid-column-end: 4;\n}\n\n.col-end-5 {\n  grid-column-end: 5;\n}\n\n.col-end-6 {\n  grid-column-end: 6;\n}\n\n.col-end-7 {\n  grid-column-end: 7;\n}\n\n.col-end-8 {\n  grid-column-end: 8;\n}\n\n.col-end-9 {\n  grid-column-end: 9;\n}\n\n.col-end-10 {\n  grid-column-end: 10;\n}\n\n.col-end-11 {\n  grid-column-end: 11;\n}\n\n.col-end-12 {\n  grid-column-end: 12;\n}\n\n.col-end-13 {\n  grid-column-end: 13;\n}\n\n.col-end-auto {\n  grid-column-end: auto;\n}\n\n.grid-rows-1 {\n  grid-template-rows: repeat(1, minmax(0, 1fr));\n}\n\n.grid-rows-2 {\n  grid-template-rows: repeat(2, minmax(0, 1fr));\n}\n\n.grid-rows-3 {\n  grid-template-rows: repeat(3, minmax(0, 1fr));\n}\n\n.grid-rows-4 {\n  grid-template-rows: repeat(4, minmax(0, 1fr));\n}\n\n.grid-rows-5 {\n  grid-template-rows: repeat(5, minmax(0, 1fr));\n}\n\n.grid-rows-6 {\n  grid-template-rows: repeat(6, minmax(0, 1fr));\n}\n\n.grid-rows-none {\n  grid-template-rows: none;\n}\n\n.auto-rows-auto {\n  grid-auto-rows: auto;\n}\n\n.auto-rows-min {\n  grid-auto-rows: min-content;\n}\n\n.auto-rows-max {\n  grid-auto-rows: max-content;\n}\n\n.auto-rows-fr {\n  grid-auto-rows: minmax(0, 1fr);\n}\n\n.row-auto {\n  grid-row: auto;\n}\n\n.row-span-1 {\n  grid-row: span 1 / span 1;\n}\n\n.row-span-2 {\n  grid-row: span 2 / span 2;\n}\n\n.row-span-3 {\n  grid-row: span 3 / span 3;\n}\n\n.row-span-4 {\n  grid-row: span 4 / span 4;\n}\n\n.row-span-5 {\n  grid-row: span 5 / span 5;\n}\n\n.row-span-6 {\n  grid-row: span 6 / span 6;\n}\n\n.row-span-full {\n  grid-row: 1 / -1;\n}\n\n.row-start-1 {\n  grid-row-start: 1;\n}\n\n.row-start-2 {\n  grid-row-start: 2;\n}\n\n.row-start-3 {\n  grid-row-start: 3;\n}\n\n.row-start-4 {\n  grid-row-start: 4;\n}\n\n.row-start-5 {\n  grid-row-start: 5;\n}\n\n.row-start-6 {\n  grid-row-start: 6;\n}\n\n.row-start-7 {\n  grid-row-start: 7;\n}\n\n.row-start-auto {\n  grid-row-start: auto;\n}\n\n.row-end-1 {\n  grid-row-end: 1;\n}\n\n.row-end-2 {\n  grid-row-end: 2;\n}\n\n.row-end-3 {\n  grid-row-end: 3;\n}\n\n.row-end-4 {\n  grid-row-end: 4;\n}\n\n.row-end-5 {\n  grid-row-end: 5;\n}\n\n.row-end-6 {\n  grid-row-end: 6;\n}\n\n.row-end-7 {\n  grid-row-end: 7;\n}\n\n.row-end-auto {\n  grid-row-end: auto;\n}\n\n.transform {\n  --transform-translate-x: 0;\n  --transform-translate-y: 0;\n  --transform-rotate: 0;\n  --transform-skew-x: 0;\n  --transform-skew-y: 0;\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n  transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n}\n\n.transform-none {\n  transform: none;\n}\n\n.origin-center {\n  transform-origin: center;\n}\n\n.origin-top {\n  transform-origin: top;\n}\n\n.origin-top-right {\n  transform-origin: top right;\n}\n\n.origin-right {\n  transform-origin: right;\n}\n\n.origin-bottom-right {\n  transform-origin: bottom right;\n}\n\n.origin-bottom {\n  transform-origin: bottom;\n}\n\n.origin-bottom-left {\n  transform-origin: bottom left;\n}\n\n.origin-left {\n  transform-origin: left;\n}\n\n.origin-top-left {\n  transform-origin: top left;\n}\n\n.scale-0 {\n  --transform-scale-x: 0;\n  --transform-scale-y: 0;\n}\n\n.scale-50 {\n  --transform-scale-x: .5;\n  --transform-scale-y: .5;\n}\n\n.scale-75 {\n  --transform-scale-x: .75;\n  --transform-scale-y: .75;\n}\n\n.scale-90 {\n  --transform-scale-x: .9;\n  --transform-scale-y: .9;\n}\n\n.scale-95 {\n  --transform-scale-x: .95;\n  --transform-scale-y: .95;\n}\n\n.scale-100 {\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n}\n\n.scale-105 {\n  --transform-scale-x: 1.05;\n  --transform-scale-y: 1.05;\n}\n\n.scale-110 {\n  --transform-scale-x: 1.1;\n  --transform-scale-y: 1.1;\n}\n\n.scale-125 {\n  --transform-scale-x: 1.25;\n  --transform-scale-y: 1.25;\n}\n\n.scale-150 {\n  --transform-scale-x: 1.5;\n  --transform-scale-y: 1.5;\n}\n\n.scale-x-0 {\n  --transform-scale-x: 0;\n}\n\n.scale-x-50 {\n  --transform-scale-x: .5;\n}\n\n.scale-x-75 {\n  --transform-scale-x: .75;\n}\n\n.scale-x-90 {\n  --transform-scale-x: .9;\n}\n\n.scale-x-95 {\n  --transform-scale-x: .95;\n}\n\n.scale-x-100 {\n  --transform-scale-x: 1;\n}\n\n.scale-x-105 {\n  --transform-scale-x: 1.05;\n}\n\n.scale-x-110 {\n  --transform-scale-x: 1.1;\n}\n\n.scale-x-125 {\n  --transform-scale-x: 1.25;\n}\n\n.scale-x-150 {\n  --transform-scale-x: 1.5;\n}\n\n.scale-y-0 {\n  --transform-scale-y: 0;\n}\n\n.scale-y-50 {\n  --transform-scale-y: .5;\n}\n\n.scale-y-75 {\n  --transform-scale-y: .75;\n}\n\n.scale-y-90 {\n  --transform-scale-y: .9;\n}\n\n.scale-y-95 {\n  --transform-scale-y: .95;\n}\n\n.scale-y-100 {\n  --transform-scale-y: 1;\n}\n\n.scale-y-105 {\n  --transform-scale-y: 1.05;\n}\n\n.scale-y-110 {\n  --transform-scale-y: 1.1;\n}\n\n.scale-y-125 {\n  --transform-scale-y: 1.25;\n}\n\n.scale-y-150 {\n  --transform-scale-y: 1.5;\n}\n\n.hover\\:scale-0:hover {\n  --transform-scale-x: 0;\n  --transform-scale-y: 0;\n}\n\n.hover\\:scale-50:hover {\n  --transform-scale-x: .5;\n  --transform-scale-y: .5;\n}\n\n.hover\\:scale-75:hover {\n  --transform-scale-x: .75;\n  --transform-scale-y: .75;\n}\n\n.hover\\:scale-90:hover {\n  --transform-scale-x: .9;\n  --transform-scale-y: .9;\n}\n\n.hover\\:scale-95:hover {\n  --transform-scale-x: .95;\n  --transform-scale-y: .95;\n}\n\n.hover\\:scale-100:hover {\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n}\n\n.hover\\:scale-105:hover {\n  --transform-scale-x: 1.05;\n  --transform-scale-y: 1.05;\n}\n\n.hover\\:scale-110:hover {\n  --transform-scale-x: 1.1;\n  --transform-scale-y: 1.1;\n}\n\n.hover\\:scale-125:hover {\n  --transform-scale-x: 1.25;\n  --transform-scale-y: 1.25;\n}\n\n.hover\\:scale-150:hover {\n  --transform-scale-x: 1.5;\n  --transform-scale-y: 1.5;\n}\n\n.hover\\:scale-x-0:hover {\n  --transform-scale-x: 0;\n}\n\n.hover\\:scale-x-50:hover {\n  --transform-scale-x: .5;\n}\n\n.hover\\:scale-x-75:hover {\n  --transform-scale-x: .75;\n}\n\n.hover\\:scale-x-90:hover {\n  --transform-scale-x: .9;\n}\n\n.hover\\:scale-x-95:hover {\n  --transform-scale-x: .95;\n}\n\n.hover\\:scale-x-100:hover {\n  --transform-scale-x: 1;\n}\n\n.hover\\:scale-x-105:hover {\n  --transform-scale-x: 1.05;\n}\n\n.hover\\:scale-x-110:hover {\n  --transform-scale-x: 1.1;\n}\n\n.hover\\:scale-x-125:hover {\n  --transform-scale-x: 1.25;\n}\n\n.hover\\:scale-x-150:hover {\n  --transform-scale-x: 1.5;\n}\n\n.hover\\:scale-y-0:hover {\n  --transform-scale-y: 0;\n}\n\n.hover\\:scale-y-50:hover {\n  --transform-scale-y: .5;\n}\n\n.hover\\:scale-y-75:hover {\n  --transform-scale-y: .75;\n}\n\n.hover\\:scale-y-90:hover {\n  --transform-scale-y: .9;\n}\n\n.hover\\:scale-y-95:hover {\n  --transform-scale-y: .95;\n}\n\n.hover\\:scale-y-100:hover {\n  --transform-scale-y: 1;\n}\n\n.hover\\:scale-y-105:hover {\n  --transform-scale-y: 1.05;\n}\n\n.hover\\:scale-y-110:hover {\n  --transform-scale-y: 1.1;\n}\n\n.hover\\:scale-y-125:hover {\n  --transform-scale-y: 1.25;\n}\n\n.hover\\:scale-y-150:hover {\n  --transform-scale-y: 1.5;\n}\n\n.focus\\:scale-0:focus {\n  --transform-scale-x: 0;\n  --transform-scale-y: 0;\n}\n\n.focus\\:scale-50:focus {\n  --transform-scale-x: .5;\n  --transform-scale-y: .5;\n}\n\n.focus\\:scale-75:focus {\n  --transform-scale-x: .75;\n  --transform-scale-y: .75;\n}\n\n.focus\\:scale-90:focus {\n  --transform-scale-x: .9;\n  --transform-scale-y: .9;\n}\n\n.focus\\:scale-95:focus {\n  --transform-scale-x: .95;\n  --transform-scale-y: .95;\n}\n\n.focus\\:scale-100:focus {\n  --transform-scale-x: 1;\n  --transform-scale-y: 1;\n}\n\n.focus\\:scale-105:focus {\n  --transform-scale-x: 1.05;\n  --transform-scale-y: 1.05;\n}\n\n.focus\\:scale-110:focus {\n  --transform-scale-x: 1.1;\n  --transform-scale-y: 1.1;\n}\n\n.focus\\:scale-125:focus {\n  --transform-scale-x: 1.25;\n  --transform-scale-y: 1.25;\n}\n\n.focus\\:scale-150:focus {\n  --transform-scale-x: 1.5;\n  --transform-scale-y: 1.5;\n}\n\n.focus\\:scale-x-0:focus {\n  --transform-scale-x: 0;\n}\n\n.focus\\:scale-x-50:focus {\n  --transform-scale-x: .5;\n}\n\n.focus\\:scale-x-75:focus {\n  --transform-scale-x: .75;\n}\n\n.focus\\:scale-x-90:focus {\n  --transform-scale-x: .9;\n}\n\n.focus\\:scale-x-95:focus {\n  --transform-scale-x: .95;\n}\n\n.focus\\:scale-x-100:focus {\n  --transform-scale-x: 1;\n}\n\n.focus\\:scale-x-105:focus {\n  --transform-scale-x: 1.05;\n}\n\n.focus\\:scale-x-110:focus {\n  --transform-scale-x: 1.1;\n}\n\n.focus\\:scale-x-125:focus {\n  --transform-scale-x: 1.25;\n}\n\n.focus\\:scale-x-150:focus {\n  --transform-scale-x: 1.5;\n}\n\n.focus\\:scale-y-0:focus {\n  --transform-scale-y: 0;\n}\n\n.focus\\:scale-y-50:focus {\n  --transform-scale-y: .5;\n}\n\n.focus\\:scale-y-75:focus {\n  --transform-scale-y: .75;\n}\n\n.focus\\:scale-y-90:focus {\n  --transform-scale-y: .9;\n}\n\n.focus\\:scale-y-95:focus {\n  --transform-scale-y: .95;\n}\n\n.focus\\:scale-y-100:focus {\n  --transform-scale-y: 1;\n}\n\n.focus\\:scale-y-105:focus {\n  --transform-scale-y: 1.05;\n}\n\n.focus\\:scale-y-110:focus {\n  --transform-scale-y: 1.1;\n}\n\n.focus\\:scale-y-125:focus {\n  --transform-scale-y: 1.25;\n}\n\n.focus\\:scale-y-150:focus {\n  --transform-scale-y: 1.5;\n}\n\n.rotate-0 {\n  --transform-rotate: 0;\n}\n\n.rotate-1 {\n  --transform-rotate: 1deg;\n}\n\n.rotate-2 {\n  --transform-rotate: 2deg;\n}\n\n.rotate-3 {\n  --transform-rotate: 3deg;\n}\n\n.rotate-6 {\n  --transform-rotate: 6deg;\n}\n\n.rotate-12 {\n  --transform-rotate: 12deg;\n}\n\n.rotate-45 {\n  --transform-rotate: 45deg;\n}\n\n.rotate-90 {\n  --transform-rotate: 90deg;\n}\n\n.rotate-180 {\n  --transform-rotate: 180deg;\n}\n\n.-rotate-180 {\n  --transform-rotate: -180deg;\n}\n\n.-rotate-90 {\n  --transform-rotate: -90deg;\n}\n\n.-rotate-45 {\n  --transform-rotate: -45deg;\n}\n\n.-rotate-12 {\n  --transform-rotate: -12deg;\n}\n\n.-rotate-6 {\n  --transform-rotate: -6deg;\n}\n\n.-rotate-3 {\n  --transform-rotate: -3deg;\n}\n\n.-rotate-2 {\n  --transform-rotate: -2deg;\n}\n\n.-rotate-1 {\n  --transform-rotate: -1deg;\n}\n\n.hover\\:rotate-0:hover {\n  --transform-rotate: 0;\n}\n\n.hover\\:rotate-1:hover {\n  --transform-rotate: 1deg;\n}\n\n.hover\\:rotate-2:hover {\n  --transform-rotate: 2deg;\n}\n\n.hover\\:rotate-3:hover {\n  --transform-rotate: 3deg;\n}\n\n.hover\\:rotate-6:hover {\n  --transform-rotate: 6deg;\n}\n\n.hover\\:rotate-12:hover {\n  --transform-rotate: 12deg;\n}\n\n.hover\\:rotate-45:hover {\n  --transform-rotate: 45deg;\n}\n\n.hover\\:rotate-90:hover {\n  --transform-rotate: 90deg;\n}\n\n.hover\\:rotate-180:hover {\n  --transform-rotate: 180deg;\n}\n\n.hover\\:-rotate-180:hover {\n  --transform-rotate: -180deg;\n}\n\n.hover\\:-rotate-90:hover {\n  --transform-rotate: -90deg;\n}\n\n.hover\\:-rotate-45:hover {\n  --transform-rotate: -45deg;\n}\n\n.hover\\:-rotate-12:hover {\n  --transform-rotate: -12deg;\n}\n\n.hover\\:-rotate-6:hover {\n  --transform-rotate: -6deg;\n}\n\n.hover\\:-rotate-3:hover {\n  --transform-rotate: -3deg;\n}\n\n.hover\\:-rotate-2:hover {\n  --transform-rotate: -2deg;\n}\n\n.hover\\:-rotate-1:hover {\n  --transform-rotate: -1deg;\n}\n\n.focus\\:rotate-0:focus {\n  --transform-rotate: 0;\n}\n\n.focus\\:rotate-1:focus {\n  --transform-rotate: 1deg;\n}\n\n.focus\\:rotate-2:focus {\n  --transform-rotate: 2deg;\n}\n\n.focus\\:rotate-3:focus {\n  --transform-rotate: 3deg;\n}\n\n.focus\\:rotate-6:focus {\n  --transform-rotate: 6deg;\n}\n\n.focus\\:rotate-12:focus {\n  --transform-rotate: 12deg;\n}\n\n.focus\\:rotate-45:focus {\n  --transform-rotate: 45deg;\n}\n\n.focus\\:rotate-90:focus {\n  --transform-rotate: 90deg;\n}\n\n.focus\\:rotate-180:focus {\n  --transform-rotate: 180deg;\n}\n\n.focus\\:-rotate-180:focus {\n  --transform-rotate: -180deg;\n}\n\n.focus\\:-rotate-90:focus {\n  --transform-rotate: -90deg;\n}\n\n.focus\\:-rotate-45:focus {\n  --transform-rotate: -45deg;\n}\n\n.focus\\:-rotate-12:focus {\n  --transform-rotate: -12deg;\n}\n\n.focus\\:-rotate-6:focus {\n  --transform-rotate: -6deg;\n}\n\n.focus\\:-rotate-3:focus {\n  --transform-rotate: -3deg;\n}\n\n.focus\\:-rotate-2:focus {\n  --transform-rotate: -2deg;\n}\n\n.focus\\:-rotate-1:focus {\n  --transform-rotate: -1deg;\n}\n\n.translate-x-0 {\n  --transform-translate-x: 0;\n}\n\n.translate-x-1 {\n  --transform-translate-x: 0.25rem;\n}\n\n.translate-x-2 {\n  --transform-translate-x: 0.5rem;\n}\n\n.translate-x-3 {\n  --transform-translate-x: 0.75rem;\n}\n\n.translate-x-4 {\n  --transform-translate-x: 1rem;\n}\n\n.translate-x-5 {\n  --transform-translate-x: 1.25rem;\n}\n\n.translate-x-6 {\n  --transform-translate-x: 1.5rem;\n}\n\n.translate-x-8 {\n  --transform-translate-x: 2rem;\n}\n\n.translate-x-10 {\n  --transform-translate-x: 2.5rem;\n}\n\n.translate-x-12 {\n  --transform-translate-x: 3rem;\n}\n\n.translate-x-16 {\n  --transform-translate-x: 4rem;\n}\n\n.translate-x-20 {\n  --transform-translate-x: 5rem;\n}\n\n.translate-x-24 {\n  --transform-translate-x: 6rem;\n}\n\n.translate-x-32 {\n  --transform-translate-x: 8rem;\n}\n\n.translate-x-40 {\n  --transform-translate-x: 10rem;\n}\n\n.translate-x-48 {\n  --transform-translate-x: 12rem;\n}\n\n.translate-x-56 {\n  --transform-translate-x: 14rem;\n}\n\n.translate-x-64 {\n  --transform-translate-x: 16rem;\n}\n\n.translate-x-px {\n  --transform-translate-x: 1px;\n}\n\n.-translate-x-1 {\n  --transform-translate-x: -0.25rem;\n}\n\n.-translate-x-2 {\n  --transform-translate-x: -0.5rem;\n}\n\n.-translate-x-3 {\n  --transform-translate-x: -0.75rem;\n}\n\n.-translate-x-4 {\n  --transform-translate-x: -1rem;\n}\n\n.-translate-x-5 {\n  --transform-translate-x: -1.25rem;\n}\n\n.-translate-x-6 {\n  --transform-translate-x: -1.5rem;\n}\n\n.-translate-x-8 {\n  --transform-translate-x: -2rem;\n}\n\n.-translate-x-10 {\n  --transform-translate-x: -2.5rem;\n}\n\n.-translate-x-12 {\n  --transform-translate-x: -3rem;\n}\n\n.-translate-x-16 {\n  --transform-translate-x: -4rem;\n}\n\n.-translate-x-20 {\n  --transform-translate-x: -5rem;\n}\n\n.-translate-x-24 {\n  --transform-translate-x: -6rem;\n}\n\n.-translate-x-32 {\n  --transform-translate-x: -8rem;\n}\n\n.-translate-x-40 {\n  --transform-translate-x: -10rem;\n}\n\n.-translate-x-48 {\n  --transform-translate-x: -12rem;\n}\n\n.-translate-x-56 {\n  --transform-translate-x: -14rem;\n}\n\n.-translate-x-64 {\n  --transform-translate-x: -16rem;\n}\n\n.-translate-x-px {\n  --transform-translate-x: -1px;\n}\n\n.-translate-x-full {\n  --transform-translate-x: -100%;\n}\n\n.-translate-x-1\\/2 {\n  --transform-translate-x: -50%;\n}\n\n.translate-x-1\\/2 {\n  --transform-translate-x: 50%;\n}\n\n.translate-x-full {\n  --transform-translate-x: 100%;\n}\n\n.translate-y-0 {\n  --transform-translate-y: 0;\n}\n\n.translate-y-1 {\n  --transform-translate-y: 0.25rem;\n}\n\n.translate-y-2 {\n  --transform-translate-y: 0.5rem;\n}\n\n.translate-y-3 {\n  --transform-translate-y: 0.75rem;\n}\n\n.translate-y-4 {\n  --transform-translate-y: 1rem;\n}\n\n.translate-y-5 {\n  --transform-translate-y: 1.25rem;\n}\n\n.translate-y-6 {\n  --transform-translate-y: 1.5rem;\n}\n\n.translate-y-8 {\n  --transform-translate-y: 2rem;\n}\n\n.translate-y-10 {\n  --transform-translate-y: 2.5rem;\n}\n\n.translate-y-12 {\n  --transform-translate-y: 3rem;\n}\n\n.translate-y-16 {\n  --transform-translate-y: 4rem;\n}\n\n.translate-y-20 {\n  --transform-translate-y: 5rem;\n}\n\n.translate-y-24 {\n  --transform-translate-y: 6rem;\n}\n\n.translate-y-32 {\n  --transform-translate-y: 8rem;\n}\n\n.translate-y-40 {\n  --transform-translate-y: 10rem;\n}\n\n.translate-y-48 {\n  --transform-translate-y: 12rem;\n}\n\n.translate-y-56 {\n  --transform-translate-y: 14rem;\n}\n\n.translate-y-64 {\n  --transform-translate-y: 16rem;\n}\n\n.translate-y-px {\n  --transform-translate-y: 1px;\n}\n\n.-translate-y-1 {\n  --transform-translate-y: -0.25rem;\n}\n\n.-translate-y-2 {\n  --transform-translate-y: -0.5rem;\n}\n\n.-translate-y-3 {\n  --transform-translate-y: -0.75rem;\n}\n\n.-translate-y-4 {\n  --transform-translate-y: -1rem;\n}\n\n.-translate-y-5 {\n  --transform-translate-y: -1.25rem;\n}\n\n.-translate-y-6 {\n  --transform-translate-y: -1.5rem;\n}\n\n.-translate-y-8 {\n  --transform-translate-y: -2rem;\n}\n\n.-translate-y-10 {\n  --transform-translate-y: -2.5rem;\n}\n\n.-translate-y-12 {\n  --transform-translate-y: -3rem;\n}\n\n.-translate-y-16 {\n  --transform-translate-y: -4rem;\n}\n\n.-translate-y-20 {\n  --transform-translate-y: -5rem;\n}\n\n.-translate-y-24 {\n  --transform-translate-y: -6rem;\n}\n\n.-translate-y-32 {\n  --transform-translate-y: -8rem;\n}\n\n.-translate-y-40 {\n  --transform-translate-y: -10rem;\n}\n\n.-translate-y-48 {\n  --transform-translate-y: -12rem;\n}\n\n.-translate-y-56 {\n  --transform-translate-y: -14rem;\n}\n\n.-translate-y-64 {\n  --transform-translate-y: -16rem;\n}\n\n.-translate-y-px {\n  --transform-translate-y: -1px;\n}\n\n.-translate-y-full {\n  --transform-translate-y: -100%;\n}\n\n.-translate-y-1\\/2 {\n  --transform-translate-y: -50%;\n}\n\n.translate-y-1\\/2 {\n  --transform-translate-y: 50%;\n}\n\n.translate-y-full {\n  --transform-translate-y: 100%;\n}\n\n.hover\\:translate-x-0:hover {\n  --transform-translate-x: 0;\n}\n\n.hover\\:translate-x-1:hover {\n  --transform-translate-x: 0.25rem;\n}\n\n.hover\\:translate-x-2:hover {\n  --transform-translate-x: 0.5rem;\n}\n\n.hover\\:translate-x-3:hover {\n  --transform-translate-x: 0.75rem;\n}\n\n.hover\\:translate-x-4:hover {\n  --transform-translate-x: 1rem;\n}\n\n.hover\\:translate-x-5:hover {\n  --transform-translate-x: 1.25rem;\n}\n\n.hover\\:translate-x-6:hover {\n  --transform-translate-x: 1.5rem;\n}\n\n.hover\\:translate-x-8:hover {\n  --transform-translate-x: 2rem;\n}\n\n.hover\\:translate-x-10:hover {\n  --transform-translate-x: 2.5rem;\n}\n\n.hover\\:translate-x-12:hover {\n  --transform-translate-x: 3rem;\n}\n\n.hover\\:translate-x-16:hover {\n  --transform-translate-x: 4rem;\n}\n\n.hover\\:translate-x-20:hover {\n  --transform-translate-x: 5rem;\n}\n\n.hover\\:translate-x-24:hover {\n  --transform-translate-x: 6rem;\n}\n\n.hover\\:translate-x-32:hover {\n  --transform-translate-x: 8rem;\n}\n\n.hover\\:translate-x-40:hover {\n  --transform-translate-x: 10rem;\n}\n\n.hover\\:translate-x-48:hover {\n  --transform-translate-x: 12rem;\n}\n\n.hover\\:translate-x-56:hover {\n  --transform-translate-x: 14rem;\n}\n\n.hover\\:translate-x-64:hover {\n  --transform-translate-x: 16rem;\n}\n\n.hover\\:translate-x-px:hover {\n  --transform-translate-x: 1px;\n}\n\n.hover\\:-translate-x-1:hover {\n  --transform-translate-x: -0.25rem;\n}\n\n.hover\\:-translate-x-2:hover {\n  --transform-translate-x: -0.5rem;\n}\n\n.hover\\:-translate-x-3:hover {\n  --transform-translate-x: -0.75rem;\n}\n\n.hover\\:-translate-x-4:hover {\n  --transform-translate-x: -1rem;\n}\n\n.hover\\:-translate-x-5:hover {\n  --transform-translate-x: -1.25rem;\n}\n\n.hover\\:-translate-x-6:hover {\n  --transform-translate-x: -1.5rem;\n}\n\n.hover\\:-translate-x-8:hover {\n  --transform-translate-x: -2rem;\n}\n\n.hover\\:-translate-x-10:hover {\n  --transform-translate-x: -2.5rem;\n}\n\n.hover\\:-translate-x-12:hover {\n  --transform-translate-x: -3rem;\n}\n\n.hover\\:-translate-x-16:hover {\n  --transform-translate-x: -4rem;\n}\n\n.hover\\:-translate-x-20:hover {\n  --transform-translate-x: -5rem;\n}\n\n.hover\\:-translate-x-24:hover {\n  --transform-translate-x: -6rem;\n}\n\n.hover\\:-translate-x-32:hover {\n  --transform-translate-x: -8rem;\n}\n\n.hover\\:-translate-x-40:hover {\n  --transform-translate-x: -10rem;\n}\n\n.hover\\:-translate-x-48:hover {\n  --transform-translate-x: -12rem;\n}\n\n.hover\\:-translate-x-56:hover {\n  --transform-translate-x: -14rem;\n}\n\n.hover\\:-translate-x-64:hover {\n  --transform-translate-x: -16rem;\n}\n\n.hover\\:-translate-x-px:hover {\n  --transform-translate-x: -1px;\n}\n\n.hover\\:-translate-x-full:hover {\n  --transform-translate-x: -100%;\n}\n\n.hover\\:-translate-x-1\\/2:hover {\n  --transform-translate-x: -50%;\n}\n\n.hover\\:translate-x-1\\/2:hover {\n  --transform-translate-x: 50%;\n}\n\n.hover\\:translate-x-full:hover {\n  --transform-translate-x: 100%;\n}\n\n.hover\\:translate-y-0:hover {\n  --transform-translate-y: 0;\n}\n\n.hover\\:translate-y-1:hover {\n  --transform-translate-y: 0.25rem;\n}\n\n.hover\\:translate-y-2:hover {\n  --transform-translate-y: 0.5rem;\n}\n\n.hover\\:translate-y-3:hover {\n  --transform-translate-y: 0.75rem;\n}\n\n.hover\\:translate-y-4:hover {\n  --transform-translate-y: 1rem;\n}\n\n.hover\\:translate-y-5:hover {\n  --transform-translate-y: 1.25rem;\n}\n\n.hover\\:translate-y-6:hover {\n  --transform-translate-y: 1.5rem;\n}\n\n.hover\\:translate-y-8:hover {\n  --transform-translate-y: 2rem;\n}\n\n.hover\\:translate-y-10:hover {\n  --transform-translate-y: 2.5rem;\n}\n\n.hover\\:translate-y-12:hover {\n  --transform-translate-y: 3rem;\n}\n\n.hover\\:translate-y-16:hover {\n  --transform-translate-y: 4rem;\n}\n\n.hover\\:translate-y-20:hover {\n  --transform-translate-y: 5rem;\n}\n\n.hover\\:translate-y-24:hover {\n  --transform-translate-y: 6rem;\n}\n\n.hover\\:translate-y-32:hover {\n  --transform-translate-y: 8rem;\n}\n\n.hover\\:translate-y-40:hover {\n  --transform-translate-y: 10rem;\n}\n\n.hover\\:translate-y-48:hover {\n  --transform-translate-y: 12rem;\n}\n\n.hover\\:translate-y-56:hover {\n  --transform-translate-y: 14rem;\n}\n\n.hover\\:translate-y-64:hover {\n  --transform-translate-y: 16rem;\n}\n\n.hover\\:translate-y-px:hover {\n  --transform-translate-y: 1px;\n}\n\n.hover\\:-translate-y-1:hover {\n  --transform-translate-y: -0.25rem;\n}\n\n.hover\\:-translate-y-2:hover {\n  --transform-translate-y: -0.5rem;\n}\n\n.hover\\:-translate-y-3:hover {\n  --transform-translate-y: -0.75rem;\n}\n\n.hover\\:-translate-y-4:hover {\n  --transform-translate-y: -1rem;\n}\n\n.hover\\:-translate-y-5:hover {\n  --transform-translate-y: -1.25rem;\n}\n\n.hover\\:-translate-y-6:hover {\n  --transform-translate-y: -1.5rem;\n}\n\n.hover\\:-translate-y-8:hover {\n  --transform-translate-y: -2rem;\n}\n\n.hover\\:-translate-y-10:hover {\n  --transform-translate-y: -2.5rem;\n}\n\n.hover\\:-translate-y-12:hover {\n  --transform-translate-y: -3rem;\n}\n\n.hover\\:-translate-y-16:hover {\n  --transform-translate-y: -4rem;\n}\n\n.hover\\:-translate-y-20:hover {\n  --transform-translate-y: -5rem;\n}\n\n.hover\\:-translate-y-24:hover {\n  --transform-translate-y: -6rem;\n}\n\n.hover\\:-translate-y-32:hover {\n  --transform-translate-y: -8rem;\n}\n\n.hover\\:-translate-y-40:hover {\n  --transform-translate-y: -10rem;\n}\n\n.hover\\:-translate-y-48:hover {\n  --transform-translate-y: -12rem;\n}\n\n.hover\\:-translate-y-56:hover {\n  --transform-translate-y: -14rem;\n}\n\n.hover\\:-translate-y-64:hover {\n  --transform-translate-y: -16rem;\n}\n\n.hover\\:-translate-y-px:hover {\n  --transform-translate-y: -1px;\n}\n\n.hover\\:-translate-y-full:hover {\n  --transform-translate-y: -100%;\n}\n\n.hover\\:-translate-y-1\\/2:hover {\n  --transform-translate-y: -50%;\n}\n\n.hover\\:translate-y-1\\/2:hover {\n  --transform-translate-y: 50%;\n}\n\n.hover\\:translate-y-full:hover {\n  --transform-translate-y: 100%;\n}\n\n.focus\\:translate-x-0:focus {\n  --transform-translate-x: 0;\n}\n\n.focus\\:translate-x-1:focus {\n  --transform-translate-x: 0.25rem;\n}\n\n.focus\\:translate-x-2:focus {\n  --transform-translate-x: 0.5rem;\n}\n\n.focus\\:translate-x-3:focus {\n  --transform-translate-x: 0.75rem;\n}\n\n.focus\\:translate-x-4:focus {\n  --transform-translate-x: 1rem;\n}\n\n.focus\\:translate-x-5:focus {\n  --transform-translate-x: 1.25rem;\n}\n\n.focus\\:translate-x-6:focus {\n  --transform-translate-x: 1.5rem;\n}\n\n.focus\\:translate-x-8:focus {\n  --transform-translate-x: 2rem;\n}\n\n.focus\\:translate-x-10:focus {\n  --transform-translate-x: 2.5rem;\n}\n\n.focus\\:translate-x-12:focus {\n  --transform-translate-x: 3rem;\n}\n\n.focus\\:translate-x-16:focus {\n  --transform-translate-x: 4rem;\n}\n\n.focus\\:translate-x-20:focus {\n  --transform-translate-x: 5rem;\n}\n\n.focus\\:translate-x-24:focus {\n  --transform-translate-x: 6rem;\n}\n\n.focus\\:translate-x-32:focus {\n  --transform-translate-x: 8rem;\n}\n\n.focus\\:translate-x-40:focus {\n  --transform-translate-x: 10rem;\n}\n\n.focus\\:translate-x-48:focus {\n  --transform-translate-x: 12rem;\n}\n\n.focus\\:translate-x-56:focus {\n  --transform-translate-x: 14rem;\n}\n\n.focus\\:translate-x-64:focus {\n  --transform-translate-x: 16rem;\n}\n\n.focus\\:translate-x-px:focus {\n  --transform-translate-x: 1px;\n}\n\n.focus\\:-translate-x-1:focus {\n  --transform-translate-x: -0.25rem;\n}\n\n.focus\\:-translate-x-2:focus {\n  --transform-translate-x: -0.5rem;\n}\n\n.focus\\:-translate-x-3:focus {\n  --transform-translate-x: -0.75rem;\n}\n\n.focus\\:-translate-x-4:focus {\n  --transform-translate-x: -1rem;\n}\n\n.focus\\:-translate-x-5:focus {\n  --transform-translate-x: -1.25rem;\n}\n\n.focus\\:-translate-x-6:focus {\n  --transform-translate-x: -1.5rem;\n}\n\n.focus\\:-translate-x-8:focus {\n  --transform-translate-x: -2rem;\n}\n\n.focus\\:-translate-x-10:focus {\n  --transform-translate-x: -2.5rem;\n}\n\n.focus\\:-translate-x-12:focus {\n  --transform-translate-x: -3rem;\n}\n\n.focus\\:-translate-x-16:focus {\n  --transform-translate-x: -4rem;\n}\n\n.focus\\:-translate-x-20:focus {\n  --transform-translate-x: -5rem;\n}\n\n.focus\\:-translate-x-24:focus {\n  --transform-translate-x: -6rem;\n}\n\n.focus\\:-translate-x-32:focus {\n  --transform-translate-x: -8rem;\n}\n\n.focus\\:-translate-x-40:focus {\n  --transform-translate-x: -10rem;\n}\n\n.focus\\:-translate-x-48:focus {\n  --transform-translate-x: -12rem;\n}\n\n.focus\\:-translate-x-56:focus {\n  --transform-translate-x: -14rem;\n}\n\n.focus\\:-translate-x-64:focus {\n  --transform-translate-x: -16rem;\n}\n\n.focus\\:-translate-x-px:focus {\n  --transform-translate-x: -1px;\n}\n\n.focus\\:-translate-x-full:focus {\n  --transform-translate-x: -100%;\n}\n\n.focus\\:-translate-x-1\\/2:focus {\n  --transform-translate-x: -50%;\n}\n\n.focus\\:translate-x-1\\/2:focus {\n  --transform-translate-x: 50%;\n}\n\n.focus\\:translate-x-full:focus {\n  --transform-translate-x: 100%;\n}\n\n.focus\\:translate-y-0:focus {\n  --transform-translate-y: 0;\n}\n\n.focus\\:translate-y-1:focus {\n  --transform-translate-y: 0.25rem;\n}\n\n.focus\\:translate-y-2:focus {\n  --transform-translate-y: 0.5rem;\n}\n\n.focus\\:translate-y-3:focus {\n  --transform-translate-y: 0.75rem;\n}\n\n.focus\\:translate-y-4:focus {\n  --transform-translate-y: 1rem;\n}\n\n.focus\\:translate-y-5:focus {\n  --transform-translate-y: 1.25rem;\n}\n\n.focus\\:translate-y-6:focus {\n  --transform-translate-y: 1.5rem;\n}\n\n.focus\\:translate-y-8:focus {\n  --transform-translate-y: 2rem;\n}\n\n.focus\\:translate-y-10:focus {\n  --transform-translate-y: 2.5rem;\n}\n\n.focus\\:translate-y-12:focus {\n  --transform-translate-y: 3rem;\n}\n\n.focus\\:translate-y-16:focus {\n  --transform-translate-y: 4rem;\n}\n\n.focus\\:translate-y-20:focus {\n  --transform-translate-y: 5rem;\n}\n\n.focus\\:translate-y-24:focus {\n  --transform-translate-y: 6rem;\n}\n\n.focus\\:translate-y-32:focus {\n  --transform-translate-y: 8rem;\n}\n\n.focus\\:translate-y-40:focus {\n  --transform-translate-y: 10rem;\n}\n\n.focus\\:translate-y-48:focus {\n  --transform-translate-y: 12rem;\n}\n\n.focus\\:translate-y-56:focus {\n  --transform-translate-y: 14rem;\n}\n\n.focus\\:translate-y-64:focus {\n  --transform-translate-y: 16rem;\n}\n\n.focus\\:translate-y-px:focus {\n  --transform-translate-y: 1px;\n}\n\n.focus\\:-translate-y-1:focus {\n  --transform-translate-y: -0.25rem;\n}\n\n.focus\\:-translate-y-2:focus {\n  --transform-translate-y: -0.5rem;\n}\n\n.focus\\:-translate-y-3:focus {\n  --transform-translate-y: -0.75rem;\n}\n\n.focus\\:-translate-y-4:focus {\n  --transform-translate-y: -1rem;\n}\n\n.focus\\:-translate-y-5:focus {\n  --transform-translate-y: -1.25rem;\n}\n\n.focus\\:-translate-y-6:focus {\n  --transform-translate-y: -1.5rem;\n}\n\n.focus\\:-translate-y-8:focus {\n  --transform-translate-y: -2rem;\n}\n\n.focus\\:-translate-y-10:focus {\n  --transform-translate-y: -2.5rem;\n}\n\n.focus\\:-translate-y-12:focus {\n  --transform-translate-y: -3rem;\n}\n\n.focus\\:-translate-y-16:focus {\n  --transform-translate-y: -4rem;\n}\n\n.focus\\:-translate-y-20:focus {\n  --transform-translate-y: -5rem;\n}\n\n.focus\\:-translate-y-24:focus {\n  --transform-translate-y: -6rem;\n}\n\n.focus\\:-translate-y-32:focus {\n  --transform-translate-y: -8rem;\n}\n\n.focus\\:-translate-y-40:focus {\n  --transform-translate-y: -10rem;\n}\n\n.focus\\:-translate-y-48:focus {\n  --transform-translate-y: -12rem;\n}\n\n.focus\\:-translate-y-56:focus {\n  --transform-translate-y: -14rem;\n}\n\n.focus\\:-translate-y-64:focus {\n  --transform-translate-y: -16rem;\n}\n\n.focus\\:-translate-y-px:focus {\n  --transform-translate-y: -1px;\n}\n\n.focus\\:-translate-y-full:focus {\n  --transform-translate-y: -100%;\n}\n\n.focus\\:-translate-y-1\\/2:focus {\n  --transform-translate-y: -50%;\n}\n\n.focus\\:translate-y-1\\/2:focus {\n  --transform-translate-y: 50%;\n}\n\n.focus\\:translate-y-full:focus {\n  --transform-translate-y: 100%;\n}\n\n.skew-x-0 {\n  --transform-skew-x: 0;\n}\n\n.skew-x-1 {\n  --transform-skew-x: 1deg;\n}\n\n.skew-x-2 {\n  --transform-skew-x: 2deg;\n}\n\n.skew-x-3 {\n  --transform-skew-x: 3deg;\n}\n\n.skew-x-6 {\n  --transform-skew-x: 6deg;\n}\n\n.skew-x-12 {\n  --transform-skew-x: 12deg;\n}\n\n.-skew-x-12 {\n  --transform-skew-x: -12deg;\n}\n\n.-skew-x-6 {\n  --transform-skew-x: -6deg;\n}\n\n.-skew-x-3 {\n  --transform-skew-x: -3deg;\n}\n\n.-skew-x-2 {\n  --transform-skew-x: -2deg;\n}\n\n.-skew-x-1 {\n  --transform-skew-x: -1deg;\n}\n\n.skew-y-0 {\n  --transform-skew-y: 0;\n}\n\n.skew-y-1 {\n  --transform-skew-y: 1deg;\n}\n\n.skew-y-2 {\n  --transform-skew-y: 2deg;\n}\n\n.skew-y-3 {\n  --transform-skew-y: 3deg;\n}\n\n.skew-y-6 {\n  --transform-skew-y: 6deg;\n}\n\n.skew-y-12 {\n  --transform-skew-y: 12deg;\n}\n\n.-skew-y-12 {\n  --transform-skew-y: -12deg;\n}\n\n.-skew-y-6 {\n  --transform-skew-y: -6deg;\n}\n\n.-skew-y-3 {\n  --transform-skew-y: -3deg;\n}\n\n.-skew-y-2 {\n  --transform-skew-y: -2deg;\n}\n\n.-skew-y-1 {\n  --transform-skew-y: -1deg;\n}\n\n.hover\\:skew-x-0:hover {\n  --transform-skew-x: 0;\n}\n\n.hover\\:skew-x-1:hover {\n  --transform-skew-x: 1deg;\n}\n\n.hover\\:skew-x-2:hover {\n  --transform-skew-x: 2deg;\n}\n\n.hover\\:skew-x-3:hover {\n  --transform-skew-x: 3deg;\n}\n\n.hover\\:skew-x-6:hover {\n  --transform-skew-x: 6deg;\n}\n\n.hover\\:skew-x-12:hover {\n  --transform-skew-x: 12deg;\n}\n\n.hover\\:-skew-x-12:hover {\n  --transform-skew-x: -12deg;\n}\n\n.hover\\:-skew-x-6:hover {\n  --transform-skew-x: -6deg;\n}\n\n.hover\\:-skew-x-3:hover {\n  --transform-skew-x: -3deg;\n}\n\n.hover\\:-skew-x-2:hover {\n  --transform-skew-x: -2deg;\n}\n\n.hover\\:-skew-x-1:hover {\n  --transform-skew-x: -1deg;\n}\n\n.hover\\:skew-y-0:hover {\n  --transform-skew-y: 0;\n}\n\n.hover\\:skew-y-1:hover {\n  --transform-skew-y: 1deg;\n}\n\n.hover\\:skew-y-2:hover {\n  --transform-skew-y: 2deg;\n}\n\n.hover\\:skew-y-3:hover {\n  --transform-skew-y: 3deg;\n}\n\n.hover\\:skew-y-6:hover {\n  --transform-skew-y: 6deg;\n}\n\n.hover\\:skew-y-12:hover {\n  --transform-skew-y: 12deg;\n}\n\n.hover\\:-skew-y-12:hover {\n  --transform-skew-y: -12deg;\n}\n\n.hover\\:-skew-y-6:hover {\n  --transform-skew-y: -6deg;\n}\n\n.hover\\:-skew-y-3:hover {\n  --transform-skew-y: -3deg;\n}\n\n.hover\\:-skew-y-2:hover {\n  --transform-skew-y: -2deg;\n}\n\n.hover\\:-skew-y-1:hover {\n  --transform-skew-y: -1deg;\n}\n\n.focus\\:skew-x-0:focus {\n  --transform-skew-x: 0;\n}\n\n.focus\\:skew-x-1:focus {\n  --transform-skew-x: 1deg;\n}\n\n.focus\\:skew-x-2:focus {\n  --transform-skew-x: 2deg;\n}\n\n.focus\\:skew-x-3:focus {\n  --transform-skew-x: 3deg;\n}\n\n.focus\\:skew-x-6:focus {\n  --transform-skew-x: 6deg;\n}\n\n.focus\\:skew-x-12:focus {\n  --transform-skew-x: 12deg;\n}\n\n.focus\\:-skew-x-12:focus {\n  --transform-skew-x: -12deg;\n}\n\n.focus\\:-skew-x-6:focus {\n  --transform-skew-x: -6deg;\n}\n\n.focus\\:-skew-x-3:focus {\n  --transform-skew-x: -3deg;\n}\n\n.focus\\:-skew-x-2:focus {\n  --transform-skew-x: -2deg;\n}\n\n.focus\\:-skew-x-1:focus {\n  --transform-skew-x: -1deg;\n}\n\n.focus\\:skew-y-0:focus {\n  --transform-skew-y: 0;\n}\n\n.focus\\:skew-y-1:focus {\n  --transform-skew-y: 1deg;\n}\n\n.focus\\:skew-y-2:focus {\n  --transform-skew-y: 2deg;\n}\n\n.focus\\:skew-y-3:focus {\n  --transform-skew-y: 3deg;\n}\n\n.focus\\:skew-y-6:focus {\n  --transform-skew-y: 6deg;\n}\n\n.focus\\:skew-y-12:focus {\n  --transform-skew-y: 12deg;\n}\n\n.focus\\:-skew-y-12:focus {\n  --transform-skew-y: -12deg;\n}\n\n.focus\\:-skew-y-6:focus {\n  --transform-skew-y: -6deg;\n}\n\n.focus\\:-skew-y-3:focus {\n  --transform-skew-y: -3deg;\n}\n\n.focus\\:-skew-y-2:focus {\n  --transform-skew-y: -2deg;\n}\n\n.focus\\:-skew-y-1:focus {\n  --transform-skew-y: -1deg;\n}\n\n.transition-none {\n  transition-property: none;\n}\n\n.transition-all {\n  transition-property: all;\n}\n\n.transition {\n  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n}\n\n.transition-colors {\n  transition-property: background-color, border-color, color, fill, stroke;\n}\n\n.transition-opacity {\n  transition-property: opacity;\n}\n\n.transition-shadow {\n  transition-property: box-shadow;\n}\n\n.transition-transform {\n  transition-property: transform;\n}\n\n.ease-linear {\n  transition-timing-function: linear;\n}\n\n.ease-in {\n  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n}\n\n.ease-out {\n  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n}\n\n.ease-in-out {\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.duration-75 {\n  transition-duration: 75ms;\n}\n\n.duration-100 {\n  transition-duration: 100ms;\n}\n\n.duration-150 {\n  transition-duration: 150ms;\n}\n\n.duration-200 {\n  transition-duration: 200ms;\n}\n\n.duration-300 {\n  transition-duration: 300ms;\n}\n\n.duration-500 {\n  transition-duration: 500ms;\n}\n\n.duration-700 {\n  transition-duration: 700ms;\n}\n\n.duration-1000 {\n  transition-duration: 1000ms;\n}\n\n.delay-75 {\n  transition-delay: 75ms;\n}\n\n.delay-100 {\n  transition-delay: 100ms;\n}\n\n.delay-150 {\n  transition-delay: 150ms;\n}\n\n.delay-200 {\n  transition-delay: 200ms;\n}\n\n.delay-300 {\n  transition-delay: 300ms;\n}\n\n.delay-500 {\n  transition-delay: 500ms;\n}\n\n.delay-700 {\n  transition-delay: 700ms;\n}\n\n.delay-1000 {\n  transition-delay: 1000ms;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes ping {\n  75%, 100% {\n    transform: scale(2);\n    opacity: 0;\n  }\n}\n\n@keyframes pulse {\n  50% {\n    opacity: .5;\n  }\n}\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(-25%);\n    animation-timing-function: cubic-bezier(0.8,0,1,1);\n  }\n\n  50% {\n    transform: none;\n    animation-timing-function: cubic-bezier(0,0,0.2,1);\n  }\n}\n\n.animate-none {\n  animation: none;\n}\n\n.animate-spin {\n  animation: spin 1s linear infinite;\n}\n\n.animate-ping {\n  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n}\n\n.animate-pulse {\n  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.animate-bounce {\n  animation: bounce 1s infinite;\n}\n\n@media (min-width: 640px) {\n  .sm\\:container {\n    width: 100%;\n  }\n\n  @media (min-width: 640px) {\n    .sm\\:container {\n      max-width: 640px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .sm\\:container {\n      max-width: 768px;\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .sm\\:container {\n      max-width: 1024px;\n    }\n  }\n\n  @media (min-width: 1280px) {\n    .sm\\:container {\n      max-width: 1280px;\n    }\n  }\n\n  .sm\\:space-y-0 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0px * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-0 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0px * var(--space-x-reverse));\n    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-1 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.25rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-1 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.25rem * var(--space-x-reverse));\n    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-2 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.5rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-2 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-3 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.75rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-3 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.75rem * var(--space-x-reverse));\n    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-4 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-4 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1rem * var(--space-x-reverse));\n    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-5 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.25rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-5 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.25rem * var(--space-x-reverse));\n    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-6 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.5rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-6 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.5rem * var(--space-x-reverse));\n    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-8 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-8 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2rem * var(--space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-10 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.5rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-10 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.5rem * var(--space-x-reverse));\n    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-12 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-12 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3rem * var(--space-x-reverse));\n    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-16 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(4rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-16 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(4rem * var(--space-x-reverse));\n    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-20 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(5rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-20 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(5rem * var(--space-x-reverse));\n    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-24 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(6rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-24 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(6rem * var(--space-x-reverse));\n    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-32 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-32 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8rem * var(--space-x-reverse));\n    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-40 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(10rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-40 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(10rem * var(--space-x-reverse));\n    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-48 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(12rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-48 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(12rem * var(--space-x-reverse));\n    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-56 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(14rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-56 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(14rem * var(--space-x-reverse));\n    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-64 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16rem * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-64 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16rem * var(--space-x-reverse));\n    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-px > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1px * var(--space-y-reverse));\n  }\n\n  .sm\\:space-x-px > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1px * var(--space-x-reverse));\n    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-1 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-1 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.25rem * var(--space-x-reverse));\n    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-2 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-2 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.5rem * var(--space-x-reverse));\n    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-3 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-3 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.75rem * var(--space-x-reverse));\n    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-4 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-4 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1rem * var(--space-x-reverse));\n    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-5 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-5 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.25rem * var(--space-x-reverse));\n    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-6 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-6 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.5rem * var(--space-x-reverse));\n    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-8 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-8 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2rem * var(--space-x-reverse));\n    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-10 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-10 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.5rem * var(--space-x-reverse));\n    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-12 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-12 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3rem * var(--space-x-reverse));\n    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-16 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-4rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-16 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-4rem * var(--space-x-reverse));\n    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-20 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-5rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-20 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-5rem * var(--space-x-reverse));\n    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-24 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-6rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-24 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-6rem * var(--space-x-reverse));\n    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-32 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-32 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8rem * var(--space-x-reverse));\n    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-40 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-10rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-40 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-10rem * var(--space-x-reverse));\n    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-48 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-12rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-48 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-12rem * var(--space-x-reverse));\n    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-56 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-14rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-56 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-14rem * var(--space-x-reverse));\n    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-64 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16rem * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-64 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16rem * var(--space-x-reverse));\n    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:-space-y-px > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1px * var(--space-y-reverse));\n  }\n\n  .sm\\:-space-x-px > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1px * var(--space-x-reverse));\n    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .sm\\:space-y-reverse > :not(template) ~ :not(template) {\n    --space-y-reverse: 1;\n  }\n\n  .sm\\:space-x-reverse > :not(template) ~ :not(template) {\n    --space-x-reverse: 1;\n  }\n\n  .sm\\:divide-y-0 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(0px * var(--divide-y-reverse));\n  }\n\n  .sm\\:divide-x-0 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(0px * var(--divide-x-reverse));\n    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .sm\\:divide-y-2 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(2px * var(--divide-y-reverse));\n  }\n\n  .sm\\:divide-x-2 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .sm\\:divide-y-4 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(4px * var(--divide-y-reverse));\n  }\n\n  .sm\\:divide-x-4 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(4px * var(--divide-x-reverse));\n    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .sm\\:divide-y-8 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(8px * var(--divide-y-reverse));\n  }\n\n  .sm\\:divide-x-8 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(8px * var(--divide-x-reverse));\n    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .sm\\:divide-y > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(1px * var(--divide-y-reverse));\n  }\n\n  .sm\\:divide-x > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(1px * var(--divide-x-reverse));\n    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .sm\\:divide-y-reverse > :not(template) ~ :not(template) {\n    --divide-y-reverse: 1;\n  }\n\n  .sm\\:divide-x-reverse > :not(template) ~ :not(template) {\n    --divide-x-reverse: 1;\n  }\n\n  .sm\\:divide-transparent > :not(template) ~ :not(template) {\n    border-color: transparent;\n  }\n\n  .sm\\:divide-current > :not(template) ~ :not(template) {\n    border-color: currentColor;\n  }\n\n  .sm\\:divide-black > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--divide-opacity));\n  }\n\n  .sm\\:divide-white > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--divide-opacity));\n  }\n\n  .sm\\:divide-gray-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--divide-opacity));\n  }\n\n  .sm\\:divide-red-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--divide-opacity));\n  }\n\n  .sm\\:divide-orange-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--divide-opacity));\n  }\n\n  .sm\\:divide-yellow-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--divide-opacity));\n  }\n\n  .sm\\:divide-green-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--divide-opacity));\n  }\n\n  .sm\\:divide-teal-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--divide-opacity));\n  }\n\n  .sm\\:divide-blue-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--divide-opacity));\n  }\n\n  .sm\\:divide-indigo-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--divide-opacity));\n  }\n\n  .sm\\:divide-purple-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--divide-opacity));\n  }\n\n  .sm\\:divide-pink-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--divide-opacity));\n  }\n\n  .sm\\:divide-solid > :not(template) ~ :not(template) {\n    border-style: solid;\n  }\n\n  .sm\\:divide-dashed > :not(template) ~ :not(template) {\n    border-style: dashed;\n  }\n\n  .sm\\:divide-dotted > :not(template) ~ :not(template) {\n    border-style: dotted;\n  }\n\n  .sm\\:divide-double > :not(template) ~ :not(template) {\n    border-style: double;\n  }\n\n  .sm\\:divide-none > :not(template) ~ :not(template) {\n    border-style: none;\n  }\n\n  .sm\\:divide-opacity-0 > :not(template) ~ :not(template) {\n    --divide-opacity: 0;\n  }\n\n  .sm\\:divide-opacity-25 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.25;\n  }\n\n  .sm\\:divide-opacity-50 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.5;\n  }\n\n  .sm\\:divide-opacity-75 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.75;\n  }\n\n  .sm\\:divide-opacity-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n  }\n\n  .sm\\:sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n\n  .sm\\:not-sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n\n  .sm\\:focus\\:sr-only:focus {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n\n  .sm\\:focus\\:not-sr-only:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n\n  .sm\\:appearance-none {\n    appearance: none;\n  }\n\n  .sm\\:bg-fixed {\n    background-attachment: fixed;\n  }\n\n  .sm\\:bg-local {\n    background-attachment: local;\n  }\n\n  .sm\\:bg-scroll {\n    background-attachment: scroll;\n  }\n\n  .sm\\:bg-clip-border {\n    background-clip: border-box;\n  }\n\n  .sm\\:bg-clip-padding {\n    background-clip: padding-box;\n  }\n\n  .sm\\:bg-clip-content {\n    background-clip: content-box;\n  }\n\n  .sm\\:bg-clip-text {\n    -webkit-background-clip: text;\n            background-clip: text;\n  }\n\n  .sm\\:bg-transparent {\n    background-color: transparent;\n  }\n\n  .sm\\:bg-current {\n    background-color: currentColor;\n  }\n\n  .sm\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .sm\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .sm\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .sm\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .sm\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .sm\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .sm\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .sm\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .sm\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .sm\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .sm\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .sm\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n  }\n\n  .sm\\:hover\\:bg-current:hover {\n    background-color: currentColor;\n  }\n\n  .sm\\:hover\\:bg-black:hover {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-white:hover {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-100:hover {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-200:hover {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-300:hover {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-400:hover {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-500:hover {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-600:hover {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-700:hover {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-800:hover {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-red-900:hover {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-100:hover {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-200:hover {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-300:hover {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-400:hover {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-500:hover {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-600:hover {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-700:hover {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-800:hover {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-orange-900:hover {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-100:hover {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-200:hover {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-300:hover {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-400:hover {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-500:hover {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-600:hover {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-700:hover {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-800:hover {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-yellow-900:hover {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-100:hover {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-200:hover {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-300:hover {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-400:hover {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-500:hover {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-600:hover {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-700:hover {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-800:hover {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-green-900:hover {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-100:hover {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-200:hover {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-300:hover {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-400:hover {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-500:hover {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-600:hover {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-700:hover {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-800:hover {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-teal-900:hover {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-100:hover {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-200:hover {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-300:hover {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-400:hover {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-500:hover {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-600:hover {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-700:hover {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-800:hover {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-blue-900:hover {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-100:hover {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-200:hover {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-300:hover {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-400:hover {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-500:hover {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-600:hover {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-700:hover {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-800:hover {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-indigo-900:hover {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-100:hover {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-200:hover {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-300:hover {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-400:hover {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-500:hover {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-600:hover {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-700:hover {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-800:hover {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-purple-900:hover {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-100:hover {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-200:hover {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-300:hover {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-400:hover {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-500:hover {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-600:hover {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-700:hover {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-800:hover {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .sm\\:hover\\:bg-pink-900:hover {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-transparent:focus {\n    background-color: transparent;\n  }\n\n  .sm\\:focus\\:bg-current:focus {\n    background-color: currentColor;\n  }\n\n  .sm\\:focus\\:bg-black:focus {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-white:focus {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-100:focus {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-200:focus {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-300:focus {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-400:focus {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-500:focus {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-600:focus {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-700:focus {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-800:focus {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-red-900:focus {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-100:focus {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-200:focus {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-300:focus {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-400:focus {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-500:focus {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-600:focus {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-700:focus {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-800:focus {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-orange-900:focus {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-100:focus {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-200:focus {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-300:focus {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-400:focus {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-500:focus {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-600:focus {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-700:focus {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-800:focus {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-yellow-900:focus {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-100:focus {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-200:focus {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-300:focus {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-400:focus {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-500:focus {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-600:focus {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-700:focus {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-800:focus {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-green-900:focus {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-100:focus {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-200:focus {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-300:focus {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-400:focus {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-500:focus {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-600:focus {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-700:focus {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-800:focus {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-teal-900:focus {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-100:focus {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-200:focus {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-300:focus {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-400:focus {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-500:focus {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-600:focus {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-700:focus {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-800:focus {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-blue-900:focus {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-100:focus {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-200:focus {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-300:focus {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-400:focus {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-500:focus {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-600:focus {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-700:focus {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-800:focus {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-indigo-900:focus {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-100:focus {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-200:focus {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-300:focus {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-400:focus {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-500:focus {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-600:focus {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-700:focus {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-800:focus {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-purple-900:focus {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-100:focus {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-200:focus {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-300:focus {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-400:focus {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-500:focus {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-600:focus {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-700:focus {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-800:focus {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .sm\\:focus\\:bg-pink-900:focus {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .sm\\:bg-none {\n    background-image: none;\n  }\n\n  .sm\\:bg-gradient-to-t {\n    background-image: linear-gradient(to top, var(--gradient-color-stops));\n  }\n\n  .sm\\:bg-gradient-to-tr {\n    background-image: linear-gradient(to top right, var(--gradient-color-stops));\n  }\n\n  .sm\\:bg-gradient-to-r {\n    background-image: linear-gradient(to right, var(--gradient-color-stops));\n  }\n\n  .sm\\:bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n  }\n\n  .sm\\:bg-gradient-to-b {\n    background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n  }\n\n  .sm\\:bg-gradient-to-bl {\n    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n  }\n\n  .sm\\:bg-gradient-to-l {\n    background-image: linear-gradient(to left, var(--gradient-color-stops));\n  }\n\n  .sm\\:bg-gradient-to-tl {\n    background-image: linear-gradient(to top left, var(--gradient-color-stops));\n  }\n\n  .sm\\:from-transparent {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:from-current {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:from-black {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:from-white {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:from-gray-100 {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .sm\\:from-gray-200 {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .sm\\:from-gray-300 {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .sm\\:from-gray-400 {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .sm\\:from-gray-500 {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .sm\\:from-gray-600 {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .sm\\:from-gray-700 {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .sm\\:from-gray-800 {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .sm\\:from-gray-900 {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .sm\\:from-red-100 {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .sm\\:from-red-200 {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .sm\\:from-red-300 {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .sm\\:from-red-400 {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .sm\\:from-red-500 {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .sm\\:from-red-600 {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .sm\\:from-red-700 {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .sm\\:from-red-800 {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .sm\\:from-red-900 {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .sm\\:from-orange-100 {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .sm\\:from-orange-200 {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .sm\\:from-orange-300 {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .sm\\:from-orange-400 {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .sm\\:from-orange-500 {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .sm\\:from-orange-600 {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .sm\\:from-orange-700 {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .sm\\:from-orange-800 {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .sm\\:from-orange-900 {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .sm\\:from-yellow-100 {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .sm\\:from-yellow-200 {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .sm\\:from-yellow-300 {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .sm\\:from-yellow-400 {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .sm\\:from-yellow-500 {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .sm\\:from-yellow-600 {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .sm\\:from-yellow-700 {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .sm\\:from-yellow-800 {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .sm\\:from-yellow-900 {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .sm\\:from-green-100 {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .sm\\:from-green-200 {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .sm\\:from-green-300 {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .sm\\:from-green-400 {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .sm\\:from-green-500 {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .sm\\:from-green-600 {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .sm\\:from-green-700 {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .sm\\:from-green-800 {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .sm\\:from-green-900 {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .sm\\:from-teal-100 {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .sm\\:from-teal-200 {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .sm\\:from-teal-300 {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .sm\\:from-teal-400 {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .sm\\:from-teal-500 {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .sm\\:from-teal-600 {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .sm\\:from-teal-700 {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .sm\\:from-teal-800 {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .sm\\:from-teal-900 {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .sm\\:from-blue-100 {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .sm\\:from-blue-200 {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .sm\\:from-blue-300 {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .sm\\:from-blue-400 {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .sm\\:from-blue-500 {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .sm\\:from-blue-600 {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .sm\\:from-blue-700 {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .sm\\:from-blue-800 {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .sm\\:from-blue-900 {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .sm\\:from-indigo-100 {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .sm\\:from-indigo-200 {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .sm\\:from-indigo-300 {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .sm\\:from-indigo-400 {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .sm\\:from-indigo-500 {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .sm\\:from-indigo-600 {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .sm\\:from-indigo-700 {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .sm\\:from-indigo-800 {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .sm\\:from-indigo-900 {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .sm\\:from-purple-100 {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .sm\\:from-purple-200 {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .sm\\:from-purple-300 {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .sm\\:from-purple-400 {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .sm\\:from-purple-500 {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .sm\\:from-purple-600 {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .sm\\:from-purple-700 {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .sm\\:from-purple-800 {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .sm\\:from-purple-900 {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .sm\\:from-pink-100 {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .sm\\:from-pink-200 {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .sm\\:from-pink-300 {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .sm\\:from-pink-400 {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .sm\\:from-pink-500 {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .sm\\:from-pink-600 {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .sm\\:from-pink-700 {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .sm\\:from-pink-800 {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .sm\\:from-pink-900 {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .sm\\:via-transparent {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:via-current {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:via-black {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:via-white {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:via-gray-100 {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .sm\\:via-gray-200 {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .sm\\:via-gray-300 {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .sm\\:via-gray-400 {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .sm\\:via-gray-500 {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .sm\\:via-gray-600 {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .sm\\:via-gray-700 {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .sm\\:via-gray-800 {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .sm\\:via-gray-900 {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .sm\\:via-red-100 {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .sm\\:via-red-200 {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .sm\\:via-red-300 {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .sm\\:via-red-400 {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .sm\\:via-red-500 {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .sm\\:via-red-600 {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .sm\\:via-red-700 {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .sm\\:via-red-800 {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .sm\\:via-red-900 {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .sm\\:via-orange-100 {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .sm\\:via-orange-200 {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .sm\\:via-orange-300 {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .sm\\:via-orange-400 {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .sm\\:via-orange-500 {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .sm\\:via-orange-600 {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .sm\\:via-orange-700 {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .sm\\:via-orange-800 {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .sm\\:via-orange-900 {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .sm\\:via-yellow-100 {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .sm\\:via-yellow-200 {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .sm\\:via-yellow-300 {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .sm\\:via-yellow-400 {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .sm\\:via-yellow-500 {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .sm\\:via-yellow-600 {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .sm\\:via-yellow-700 {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .sm\\:via-yellow-800 {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .sm\\:via-yellow-900 {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .sm\\:via-green-100 {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .sm\\:via-green-200 {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .sm\\:via-green-300 {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .sm\\:via-green-400 {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .sm\\:via-green-500 {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .sm\\:via-green-600 {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .sm\\:via-green-700 {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .sm\\:via-green-800 {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .sm\\:via-green-900 {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .sm\\:via-teal-100 {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .sm\\:via-teal-200 {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .sm\\:via-teal-300 {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .sm\\:via-teal-400 {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .sm\\:via-teal-500 {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .sm\\:via-teal-600 {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .sm\\:via-teal-700 {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .sm\\:via-teal-800 {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .sm\\:via-teal-900 {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .sm\\:via-blue-100 {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .sm\\:via-blue-200 {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .sm\\:via-blue-300 {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .sm\\:via-blue-400 {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .sm\\:via-blue-500 {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .sm\\:via-blue-600 {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .sm\\:via-blue-700 {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .sm\\:via-blue-800 {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .sm\\:via-blue-900 {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .sm\\:via-indigo-100 {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .sm\\:via-indigo-200 {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .sm\\:via-indigo-300 {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .sm\\:via-indigo-400 {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .sm\\:via-indigo-500 {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .sm\\:via-indigo-600 {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .sm\\:via-indigo-700 {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .sm\\:via-indigo-800 {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .sm\\:via-indigo-900 {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .sm\\:via-purple-100 {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .sm\\:via-purple-200 {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .sm\\:via-purple-300 {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .sm\\:via-purple-400 {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .sm\\:via-purple-500 {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .sm\\:via-purple-600 {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .sm\\:via-purple-700 {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .sm\\:via-purple-800 {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .sm\\:via-purple-900 {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .sm\\:via-pink-100 {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .sm\\:via-pink-200 {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .sm\\:via-pink-300 {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .sm\\:via-pink-400 {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .sm\\:via-pink-500 {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .sm\\:via-pink-600 {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .sm\\:via-pink-700 {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .sm\\:via-pink-800 {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .sm\\:via-pink-900 {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .sm\\:to-transparent {\n    --gradient-to-color: transparent;\n  }\n\n  .sm\\:to-current {\n    --gradient-to-color: currentColor;\n  }\n\n  .sm\\:to-black {\n    --gradient-to-color: #000;\n  }\n\n  .sm\\:to-white {\n    --gradient-to-color: #fff;\n  }\n\n  .sm\\:to-gray-100 {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .sm\\:to-gray-200 {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .sm\\:to-gray-300 {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .sm\\:to-gray-400 {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .sm\\:to-gray-500 {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .sm\\:to-gray-600 {\n    --gradient-to-color: #718096;\n  }\n\n  .sm\\:to-gray-700 {\n    --gradient-to-color: #4a5568;\n  }\n\n  .sm\\:to-gray-800 {\n    --gradient-to-color: #2d3748;\n  }\n\n  .sm\\:to-gray-900 {\n    --gradient-to-color: #1a202c;\n  }\n\n  .sm\\:to-red-100 {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .sm\\:to-red-200 {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .sm\\:to-red-300 {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .sm\\:to-red-400 {\n    --gradient-to-color: #fc8181;\n  }\n\n  .sm\\:to-red-500 {\n    --gradient-to-color: #f56565;\n  }\n\n  .sm\\:to-red-600 {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .sm\\:to-red-700 {\n    --gradient-to-color: #c53030;\n  }\n\n  .sm\\:to-red-800 {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .sm\\:to-red-900 {\n    --gradient-to-color: #742a2a;\n  }\n\n  .sm\\:to-orange-100 {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .sm\\:to-orange-200 {\n    --gradient-to-color: #feebc8;\n  }\n\n  .sm\\:to-orange-300 {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .sm\\:to-orange-400 {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .sm\\:to-orange-500 {\n    --gradient-to-color: #ed8936;\n  }\n\n  .sm\\:to-orange-600 {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .sm\\:to-orange-700 {\n    --gradient-to-color: #c05621;\n  }\n\n  .sm\\:to-orange-800 {\n    --gradient-to-color: #9c4221;\n  }\n\n  .sm\\:to-orange-900 {\n    --gradient-to-color: #7b341e;\n  }\n\n  .sm\\:to-yellow-100 {\n    --gradient-to-color: #fffff0;\n  }\n\n  .sm\\:to-yellow-200 {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .sm\\:to-yellow-300 {\n    --gradient-to-color: #faf089;\n  }\n\n  .sm\\:to-yellow-400 {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .sm\\:to-yellow-500 {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .sm\\:to-yellow-600 {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .sm\\:to-yellow-700 {\n    --gradient-to-color: #b7791f;\n  }\n\n  .sm\\:to-yellow-800 {\n    --gradient-to-color: #975a16;\n  }\n\n  .sm\\:to-yellow-900 {\n    --gradient-to-color: #744210;\n  }\n\n  .sm\\:to-green-100 {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .sm\\:to-green-200 {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .sm\\:to-green-300 {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .sm\\:to-green-400 {\n    --gradient-to-color: #68d391;\n  }\n\n  .sm\\:to-green-500 {\n    --gradient-to-color: #48bb78;\n  }\n\n  .sm\\:to-green-600 {\n    --gradient-to-color: #38a169;\n  }\n\n  .sm\\:to-green-700 {\n    --gradient-to-color: #2f855a;\n  }\n\n  .sm\\:to-green-800 {\n    --gradient-to-color: #276749;\n  }\n\n  .sm\\:to-green-900 {\n    --gradient-to-color: #22543d;\n  }\n\n  .sm\\:to-teal-100 {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .sm\\:to-teal-200 {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .sm\\:to-teal-300 {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .sm\\:to-teal-400 {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .sm\\:to-teal-500 {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .sm\\:to-teal-600 {\n    --gradient-to-color: #319795;\n  }\n\n  .sm\\:to-teal-700 {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .sm\\:to-teal-800 {\n    --gradient-to-color: #285e61;\n  }\n\n  .sm\\:to-teal-900 {\n    --gradient-to-color: #234e52;\n  }\n\n  .sm\\:to-blue-100 {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .sm\\:to-blue-200 {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .sm\\:to-blue-300 {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .sm\\:to-blue-400 {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .sm\\:to-blue-500 {\n    --gradient-to-color: #4299e1;\n  }\n\n  .sm\\:to-blue-600 {\n    --gradient-to-color: #3182ce;\n  }\n\n  .sm\\:to-blue-700 {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .sm\\:to-blue-800 {\n    --gradient-to-color: #2c5282;\n  }\n\n  .sm\\:to-blue-900 {\n    --gradient-to-color: #2a4365;\n  }\n\n  .sm\\:to-indigo-100 {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .sm\\:to-indigo-200 {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .sm\\:to-indigo-300 {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .sm\\:to-indigo-400 {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .sm\\:to-indigo-500 {\n    --gradient-to-color: #667eea;\n  }\n\n  .sm\\:to-indigo-600 {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .sm\\:to-indigo-700 {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .sm\\:to-indigo-800 {\n    --gradient-to-color: #434190;\n  }\n\n  .sm\\:to-indigo-900 {\n    --gradient-to-color: #3c366b;\n  }\n\n  .sm\\:to-purple-100 {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .sm\\:to-purple-200 {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .sm\\:to-purple-300 {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .sm\\:to-purple-400 {\n    --gradient-to-color: #b794f4;\n  }\n\n  .sm\\:to-purple-500 {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .sm\\:to-purple-600 {\n    --gradient-to-color: #805ad5;\n  }\n\n  .sm\\:to-purple-700 {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .sm\\:to-purple-800 {\n    --gradient-to-color: #553c9a;\n  }\n\n  .sm\\:to-purple-900 {\n    --gradient-to-color: #44337a;\n  }\n\n  .sm\\:to-pink-100 {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .sm\\:to-pink-200 {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .sm\\:to-pink-300 {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .sm\\:to-pink-400 {\n    --gradient-to-color: #f687b3;\n  }\n\n  .sm\\:to-pink-500 {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .sm\\:to-pink-600 {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .sm\\:to-pink-700 {\n    --gradient-to-color: #b83280;\n  }\n\n  .sm\\:to-pink-800 {\n    --gradient-to-color: #97266d;\n  }\n\n  .sm\\:to-pink-900 {\n    --gradient-to-color: #702459;\n  }\n\n  .sm\\:hover\\:from-transparent:hover {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:hover\\:from-current:hover {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:hover\\:from-black:hover {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:hover\\:from-white:hover {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:hover\\:from-gray-100:hover {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .sm\\:hover\\:from-gray-200:hover {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .sm\\:hover\\:from-gray-300:hover {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .sm\\:hover\\:from-gray-400:hover {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .sm\\:hover\\:from-gray-500:hover {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .sm\\:hover\\:from-gray-600:hover {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .sm\\:hover\\:from-gray-700:hover {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .sm\\:hover\\:from-gray-800:hover {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .sm\\:hover\\:from-gray-900:hover {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .sm\\:hover\\:from-red-100:hover {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .sm\\:hover\\:from-red-200:hover {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .sm\\:hover\\:from-red-300:hover {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .sm\\:hover\\:from-red-400:hover {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .sm\\:hover\\:from-red-500:hover {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .sm\\:hover\\:from-red-600:hover {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .sm\\:hover\\:from-red-700:hover {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .sm\\:hover\\:from-red-800:hover {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .sm\\:hover\\:from-red-900:hover {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .sm\\:hover\\:from-orange-100:hover {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .sm\\:hover\\:from-orange-200:hover {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .sm\\:hover\\:from-orange-300:hover {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .sm\\:hover\\:from-orange-400:hover {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .sm\\:hover\\:from-orange-500:hover {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .sm\\:hover\\:from-orange-600:hover {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .sm\\:hover\\:from-orange-700:hover {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .sm\\:hover\\:from-orange-800:hover {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .sm\\:hover\\:from-orange-900:hover {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-100:hover {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-200:hover {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-300:hover {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-400:hover {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-500:hover {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-600:hover {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-700:hover {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-800:hover {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .sm\\:hover\\:from-yellow-900:hover {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .sm\\:hover\\:from-green-100:hover {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .sm\\:hover\\:from-green-200:hover {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .sm\\:hover\\:from-green-300:hover {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .sm\\:hover\\:from-green-400:hover {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .sm\\:hover\\:from-green-500:hover {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .sm\\:hover\\:from-green-600:hover {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .sm\\:hover\\:from-green-700:hover {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .sm\\:hover\\:from-green-800:hover {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .sm\\:hover\\:from-green-900:hover {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .sm\\:hover\\:from-teal-100:hover {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .sm\\:hover\\:from-teal-200:hover {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .sm\\:hover\\:from-teal-300:hover {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .sm\\:hover\\:from-teal-400:hover {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .sm\\:hover\\:from-teal-500:hover {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .sm\\:hover\\:from-teal-600:hover {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .sm\\:hover\\:from-teal-700:hover {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .sm\\:hover\\:from-teal-800:hover {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .sm\\:hover\\:from-teal-900:hover {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .sm\\:hover\\:from-blue-100:hover {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .sm\\:hover\\:from-blue-200:hover {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .sm\\:hover\\:from-blue-300:hover {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .sm\\:hover\\:from-blue-400:hover {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .sm\\:hover\\:from-blue-500:hover {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .sm\\:hover\\:from-blue-600:hover {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .sm\\:hover\\:from-blue-700:hover {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .sm\\:hover\\:from-blue-800:hover {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .sm\\:hover\\:from-blue-900:hover {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-100:hover {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-200:hover {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-300:hover {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-400:hover {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-500:hover {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-600:hover {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-700:hover {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-800:hover {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .sm\\:hover\\:from-indigo-900:hover {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .sm\\:hover\\:from-purple-100:hover {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .sm\\:hover\\:from-purple-200:hover {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .sm\\:hover\\:from-purple-300:hover {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .sm\\:hover\\:from-purple-400:hover {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .sm\\:hover\\:from-purple-500:hover {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .sm\\:hover\\:from-purple-600:hover {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .sm\\:hover\\:from-purple-700:hover {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .sm\\:hover\\:from-purple-800:hover {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .sm\\:hover\\:from-purple-900:hover {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .sm\\:hover\\:from-pink-100:hover {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .sm\\:hover\\:from-pink-200:hover {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .sm\\:hover\\:from-pink-300:hover {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .sm\\:hover\\:from-pink-400:hover {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .sm\\:hover\\:from-pink-500:hover {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .sm\\:hover\\:from-pink-600:hover {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .sm\\:hover\\:from-pink-700:hover {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .sm\\:hover\\:from-pink-800:hover {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .sm\\:hover\\:from-pink-900:hover {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .sm\\:hover\\:via-transparent:hover {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:hover\\:via-current:hover {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:hover\\:via-black:hover {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:hover\\:via-white:hover {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:hover\\:via-gray-100:hover {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .sm\\:hover\\:via-gray-200:hover {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .sm\\:hover\\:via-gray-300:hover {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .sm\\:hover\\:via-gray-400:hover {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .sm\\:hover\\:via-gray-500:hover {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .sm\\:hover\\:via-gray-600:hover {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .sm\\:hover\\:via-gray-700:hover {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .sm\\:hover\\:via-gray-800:hover {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .sm\\:hover\\:via-gray-900:hover {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .sm\\:hover\\:via-red-100:hover {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .sm\\:hover\\:via-red-200:hover {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .sm\\:hover\\:via-red-300:hover {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .sm\\:hover\\:via-red-400:hover {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .sm\\:hover\\:via-red-500:hover {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .sm\\:hover\\:via-red-600:hover {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .sm\\:hover\\:via-red-700:hover {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .sm\\:hover\\:via-red-800:hover {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .sm\\:hover\\:via-red-900:hover {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .sm\\:hover\\:via-orange-100:hover {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .sm\\:hover\\:via-orange-200:hover {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .sm\\:hover\\:via-orange-300:hover {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .sm\\:hover\\:via-orange-400:hover {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .sm\\:hover\\:via-orange-500:hover {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .sm\\:hover\\:via-orange-600:hover {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .sm\\:hover\\:via-orange-700:hover {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .sm\\:hover\\:via-orange-800:hover {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .sm\\:hover\\:via-orange-900:hover {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-100:hover {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-200:hover {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-300:hover {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-400:hover {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-500:hover {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-600:hover {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-700:hover {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-800:hover {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .sm\\:hover\\:via-yellow-900:hover {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .sm\\:hover\\:via-green-100:hover {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .sm\\:hover\\:via-green-200:hover {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .sm\\:hover\\:via-green-300:hover {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .sm\\:hover\\:via-green-400:hover {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .sm\\:hover\\:via-green-500:hover {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .sm\\:hover\\:via-green-600:hover {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .sm\\:hover\\:via-green-700:hover {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .sm\\:hover\\:via-green-800:hover {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .sm\\:hover\\:via-green-900:hover {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .sm\\:hover\\:via-teal-100:hover {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .sm\\:hover\\:via-teal-200:hover {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .sm\\:hover\\:via-teal-300:hover {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .sm\\:hover\\:via-teal-400:hover {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .sm\\:hover\\:via-teal-500:hover {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .sm\\:hover\\:via-teal-600:hover {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .sm\\:hover\\:via-teal-700:hover {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .sm\\:hover\\:via-teal-800:hover {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .sm\\:hover\\:via-teal-900:hover {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .sm\\:hover\\:via-blue-100:hover {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .sm\\:hover\\:via-blue-200:hover {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .sm\\:hover\\:via-blue-300:hover {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .sm\\:hover\\:via-blue-400:hover {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .sm\\:hover\\:via-blue-500:hover {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .sm\\:hover\\:via-blue-600:hover {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .sm\\:hover\\:via-blue-700:hover {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .sm\\:hover\\:via-blue-800:hover {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .sm\\:hover\\:via-blue-900:hover {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-100:hover {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-200:hover {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-300:hover {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-400:hover {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-500:hover {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-600:hover {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-700:hover {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-800:hover {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .sm\\:hover\\:via-indigo-900:hover {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .sm\\:hover\\:via-purple-100:hover {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .sm\\:hover\\:via-purple-200:hover {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .sm\\:hover\\:via-purple-300:hover {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .sm\\:hover\\:via-purple-400:hover {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .sm\\:hover\\:via-purple-500:hover {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .sm\\:hover\\:via-purple-600:hover {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .sm\\:hover\\:via-purple-700:hover {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .sm\\:hover\\:via-purple-800:hover {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .sm\\:hover\\:via-purple-900:hover {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .sm\\:hover\\:via-pink-100:hover {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .sm\\:hover\\:via-pink-200:hover {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .sm\\:hover\\:via-pink-300:hover {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .sm\\:hover\\:via-pink-400:hover {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .sm\\:hover\\:via-pink-500:hover {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .sm\\:hover\\:via-pink-600:hover {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .sm\\:hover\\:via-pink-700:hover {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .sm\\:hover\\:via-pink-800:hover {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .sm\\:hover\\:via-pink-900:hover {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .sm\\:hover\\:to-transparent:hover {\n    --gradient-to-color: transparent;\n  }\n\n  .sm\\:hover\\:to-current:hover {\n    --gradient-to-color: currentColor;\n  }\n\n  .sm\\:hover\\:to-black:hover {\n    --gradient-to-color: #000;\n  }\n\n  .sm\\:hover\\:to-white:hover {\n    --gradient-to-color: #fff;\n  }\n\n  .sm\\:hover\\:to-gray-100:hover {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .sm\\:hover\\:to-gray-200:hover {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .sm\\:hover\\:to-gray-300:hover {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .sm\\:hover\\:to-gray-400:hover {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .sm\\:hover\\:to-gray-500:hover {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .sm\\:hover\\:to-gray-600:hover {\n    --gradient-to-color: #718096;\n  }\n\n  .sm\\:hover\\:to-gray-700:hover {\n    --gradient-to-color: #4a5568;\n  }\n\n  .sm\\:hover\\:to-gray-800:hover {\n    --gradient-to-color: #2d3748;\n  }\n\n  .sm\\:hover\\:to-gray-900:hover {\n    --gradient-to-color: #1a202c;\n  }\n\n  .sm\\:hover\\:to-red-100:hover {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .sm\\:hover\\:to-red-200:hover {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .sm\\:hover\\:to-red-300:hover {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .sm\\:hover\\:to-red-400:hover {\n    --gradient-to-color: #fc8181;\n  }\n\n  .sm\\:hover\\:to-red-500:hover {\n    --gradient-to-color: #f56565;\n  }\n\n  .sm\\:hover\\:to-red-600:hover {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .sm\\:hover\\:to-red-700:hover {\n    --gradient-to-color: #c53030;\n  }\n\n  .sm\\:hover\\:to-red-800:hover {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .sm\\:hover\\:to-red-900:hover {\n    --gradient-to-color: #742a2a;\n  }\n\n  .sm\\:hover\\:to-orange-100:hover {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .sm\\:hover\\:to-orange-200:hover {\n    --gradient-to-color: #feebc8;\n  }\n\n  .sm\\:hover\\:to-orange-300:hover {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .sm\\:hover\\:to-orange-400:hover {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .sm\\:hover\\:to-orange-500:hover {\n    --gradient-to-color: #ed8936;\n  }\n\n  .sm\\:hover\\:to-orange-600:hover {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .sm\\:hover\\:to-orange-700:hover {\n    --gradient-to-color: #c05621;\n  }\n\n  .sm\\:hover\\:to-orange-800:hover {\n    --gradient-to-color: #9c4221;\n  }\n\n  .sm\\:hover\\:to-orange-900:hover {\n    --gradient-to-color: #7b341e;\n  }\n\n  .sm\\:hover\\:to-yellow-100:hover {\n    --gradient-to-color: #fffff0;\n  }\n\n  .sm\\:hover\\:to-yellow-200:hover {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .sm\\:hover\\:to-yellow-300:hover {\n    --gradient-to-color: #faf089;\n  }\n\n  .sm\\:hover\\:to-yellow-400:hover {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .sm\\:hover\\:to-yellow-500:hover {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .sm\\:hover\\:to-yellow-600:hover {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .sm\\:hover\\:to-yellow-700:hover {\n    --gradient-to-color: #b7791f;\n  }\n\n  .sm\\:hover\\:to-yellow-800:hover {\n    --gradient-to-color: #975a16;\n  }\n\n  .sm\\:hover\\:to-yellow-900:hover {\n    --gradient-to-color: #744210;\n  }\n\n  .sm\\:hover\\:to-green-100:hover {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .sm\\:hover\\:to-green-200:hover {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .sm\\:hover\\:to-green-300:hover {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .sm\\:hover\\:to-green-400:hover {\n    --gradient-to-color: #68d391;\n  }\n\n  .sm\\:hover\\:to-green-500:hover {\n    --gradient-to-color: #48bb78;\n  }\n\n  .sm\\:hover\\:to-green-600:hover {\n    --gradient-to-color: #38a169;\n  }\n\n  .sm\\:hover\\:to-green-700:hover {\n    --gradient-to-color: #2f855a;\n  }\n\n  .sm\\:hover\\:to-green-800:hover {\n    --gradient-to-color: #276749;\n  }\n\n  .sm\\:hover\\:to-green-900:hover {\n    --gradient-to-color: #22543d;\n  }\n\n  .sm\\:hover\\:to-teal-100:hover {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .sm\\:hover\\:to-teal-200:hover {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .sm\\:hover\\:to-teal-300:hover {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .sm\\:hover\\:to-teal-400:hover {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .sm\\:hover\\:to-teal-500:hover {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .sm\\:hover\\:to-teal-600:hover {\n    --gradient-to-color: #319795;\n  }\n\n  .sm\\:hover\\:to-teal-700:hover {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .sm\\:hover\\:to-teal-800:hover {\n    --gradient-to-color: #285e61;\n  }\n\n  .sm\\:hover\\:to-teal-900:hover {\n    --gradient-to-color: #234e52;\n  }\n\n  .sm\\:hover\\:to-blue-100:hover {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .sm\\:hover\\:to-blue-200:hover {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .sm\\:hover\\:to-blue-300:hover {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .sm\\:hover\\:to-blue-400:hover {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .sm\\:hover\\:to-blue-500:hover {\n    --gradient-to-color: #4299e1;\n  }\n\n  .sm\\:hover\\:to-blue-600:hover {\n    --gradient-to-color: #3182ce;\n  }\n\n  .sm\\:hover\\:to-blue-700:hover {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .sm\\:hover\\:to-blue-800:hover {\n    --gradient-to-color: #2c5282;\n  }\n\n  .sm\\:hover\\:to-blue-900:hover {\n    --gradient-to-color: #2a4365;\n  }\n\n  .sm\\:hover\\:to-indigo-100:hover {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .sm\\:hover\\:to-indigo-200:hover {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .sm\\:hover\\:to-indigo-300:hover {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .sm\\:hover\\:to-indigo-400:hover {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .sm\\:hover\\:to-indigo-500:hover {\n    --gradient-to-color: #667eea;\n  }\n\n  .sm\\:hover\\:to-indigo-600:hover {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .sm\\:hover\\:to-indigo-700:hover {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .sm\\:hover\\:to-indigo-800:hover {\n    --gradient-to-color: #434190;\n  }\n\n  .sm\\:hover\\:to-indigo-900:hover {\n    --gradient-to-color: #3c366b;\n  }\n\n  .sm\\:hover\\:to-purple-100:hover {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .sm\\:hover\\:to-purple-200:hover {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .sm\\:hover\\:to-purple-300:hover {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .sm\\:hover\\:to-purple-400:hover {\n    --gradient-to-color: #b794f4;\n  }\n\n  .sm\\:hover\\:to-purple-500:hover {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .sm\\:hover\\:to-purple-600:hover {\n    --gradient-to-color: #805ad5;\n  }\n\n  .sm\\:hover\\:to-purple-700:hover {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .sm\\:hover\\:to-purple-800:hover {\n    --gradient-to-color: #553c9a;\n  }\n\n  .sm\\:hover\\:to-purple-900:hover {\n    --gradient-to-color: #44337a;\n  }\n\n  .sm\\:hover\\:to-pink-100:hover {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .sm\\:hover\\:to-pink-200:hover {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .sm\\:hover\\:to-pink-300:hover {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .sm\\:hover\\:to-pink-400:hover {\n    --gradient-to-color: #f687b3;\n  }\n\n  .sm\\:hover\\:to-pink-500:hover {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .sm\\:hover\\:to-pink-600:hover {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .sm\\:hover\\:to-pink-700:hover {\n    --gradient-to-color: #b83280;\n  }\n\n  .sm\\:hover\\:to-pink-800:hover {\n    --gradient-to-color: #97266d;\n  }\n\n  .sm\\:hover\\:to-pink-900:hover {\n    --gradient-to-color: #702459;\n  }\n\n  .sm\\:focus\\:from-transparent:focus {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:focus\\:from-current:focus {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:focus\\:from-black:focus {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:focus\\:from-white:focus {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:focus\\:from-gray-100:focus {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .sm\\:focus\\:from-gray-200:focus {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .sm\\:focus\\:from-gray-300:focus {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .sm\\:focus\\:from-gray-400:focus {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .sm\\:focus\\:from-gray-500:focus {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .sm\\:focus\\:from-gray-600:focus {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .sm\\:focus\\:from-gray-700:focus {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .sm\\:focus\\:from-gray-800:focus {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .sm\\:focus\\:from-gray-900:focus {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .sm\\:focus\\:from-red-100:focus {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .sm\\:focus\\:from-red-200:focus {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .sm\\:focus\\:from-red-300:focus {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .sm\\:focus\\:from-red-400:focus {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .sm\\:focus\\:from-red-500:focus {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .sm\\:focus\\:from-red-600:focus {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .sm\\:focus\\:from-red-700:focus {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .sm\\:focus\\:from-red-800:focus {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .sm\\:focus\\:from-red-900:focus {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .sm\\:focus\\:from-orange-100:focus {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .sm\\:focus\\:from-orange-200:focus {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .sm\\:focus\\:from-orange-300:focus {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .sm\\:focus\\:from-orange-400:focus {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .sm\\:focus\\:from-orange-500:focus {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .sm\\:focus\\:from-orange-600:focus {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .sm\\:focus\\:from-orange-700:focus {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .sm\\:focus\\:from-orange-800:focus {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .sm\\:focus\\:from-orange-900:focus {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-100:focus {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-200:focus {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-300:focus {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-400:focus {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-500:focus {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-600:focus {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-700:focus {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-800:focus {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .sm\\:focus\\:from-yellow-900:focus {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .sm\\:focus\\:from-green-100:focus {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .sm\\:focus\\:from-green-200:focus {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .sm\\:focus\\:from-green-300:focus {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .sm\\:focus\\:from-green-400:focus {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .sm\\:focus\\:from-green-500:focus {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .sm\\:focus\\:from-green-600:focus {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .sm\\:focus\\:from-green-700:focus {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .sm\\:focus\\:from-green-800:focus {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .sm\\:focus\\:from-green-900:focus {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .sm\\:focus\\:from-teal-100:focus {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .sm\\:focus\\:from-teal-200:focus {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .sm\\:focus\\:from-teal-300:focus {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .sm\\:focus\\:from-teal-400:focus {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .sm\\:focus\\:from-teal-500:focus {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .sm\\:focus\\:from-teal-600:focus {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .sm\\:focus\\:from-teal-700:focus {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .sm\\:focus\\:from-teal-800:focus {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .sm\\:focus\\:from-teal-900:focus {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .sm\\:focus\\:from-blue-100:focus {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .sm\\:focus\\:from-blue-200:focus {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .sm\\:focus\\:from-blue-300:focus {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .sm\\:focus\\:from-blue-400:focus {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .sm\\:focus\\:from-blue-500:focus {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .sm\\:focus\\:from-blue-600:focus {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .sm\\:focus\\:from-blue-700:focus {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .sm\\:focus\\:from-blue-800:focus {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .sm\\:focus\\:from-blue-900:focus {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-100:focus {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-200:focus {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-300:focus {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-400:focus {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-500:focus {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-600:focus {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-700:focus {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-800:focus {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .sm\\:focus\\:from-indigo-900:focus {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .sm\\:focus\\:from-purple-100:focus {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .sm\\:focus\\:from-purple-200:focus {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .sm\\:focus\\:from-purple-300:focus {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .sm\\:focus\\:from-purple-400:focus {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .sm\\:focus\\:from-purple-500:focus {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .sm\\:focus\\:from-purple-600:focus {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .sm\\:focus\\:from-purple-700:focus {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .sm\\:focus\\:from-purple-800:focus {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .sm\\:focus\\:from-purple-900:focus {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .sm\\:focus\\:from-pink-100:focus {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .sm\\:focus\\:from-pink-200:focus {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .sm\\:focus\\:from-pink-300:focus {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .sm\\:focus\\:from-pink-400:focus {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .sm\\:focus\\:from-pink-500:focus {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .sm\\:focus\\:from-pink-600:focus {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .sm\\:focus\\:from-pink-700:focus {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .sm\\:focus\\:from-pink-800:focus {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .sm\\:focus\\:from-pink-900:focus {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .sm\\:focus\\:via-transparent:focus {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:focus\\:via-current:focus {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:focus\\:via-black:focus {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .sm\\:focus\\:via-white:focus {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .sm\\:focus\\:via-gray-100:focus {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .sm\\:focus\\:via-gray-200:focus {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .sm\\:focus\\:via-gray-300:focus {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .sm\\:focus\\:via-gray-400:focus {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .sm\\:focus\\:via-gray-500:focus {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .sm\\:focus\\:via-gray-600:focus {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .sm\\:focus\\:via-gray-700:focus {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .sm\\:focus\\:via-gray-800:focus {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .sm\\:focus\\:via-gray-900:focus {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .sm\\:focus\\:via-red-100:focus {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .sm\\:focus\\:via-red-200:focus {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .sm\\:focus\\:via-red-300:focus {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .sm\\:focus\\:via-red-400:focus {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .sm\\:focus\\:via-red-500:focus {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .sm\\:focus\\:via-red-600:focus {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .sm\\:focus\\:via-red-700:focus {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .sm\\:focus\\:via-red-800:focus {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .sm\\:focus\\:via-red-900:focus {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .sm\\:focus\\:via-orange-100:focus {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .sm\\:focus\\:via-orange-200:focus {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .sm\\:focus\\:via-orange-300:focus {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .sm\\:focus\\:via-orange-400:focus {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .sm\\:focus\\:via-orange-500:focus {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .sm\\:focus\\:via-orange-600:focus {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .sm\\:focus\\:via-orange-700:focus {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .sm\\:focus\\:via-orange-800:focus {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .sm\\:focus\\:via-orange-900:focus {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-100:focus {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-200:focus {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-300:focus {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-400:focus {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-500:focus {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-600:focus {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-700:focus {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-800:focus {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .sm\\:focus\\:via-yellow-900:focus {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .sm\\:focus\\:via-green-100:focus {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .sm\\:focus\\:via-green-200:focus {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .sm\\:focus\\:via-green-300:focus {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .sm\\:focus\\:via-green-400:focus {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .sm\\:focus\\:via-green-500:focus {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .sm\\:focus\\:via-green-600:focus {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .sm\\:focus\\:via-green-700:focus {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .sm\\:focus\\:via-green-800:focus {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .sm\\:focus\\:via-green-900:focus {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .sm\\:focus\\:via-teal-100:focus {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .sm\\:focus\\:via-teal-200:focus {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .sm\\:focus\\:via-teal-300:focus {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .sm\\:focus\\:via-teal-400:focus {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .sm\\:focus\\:via-teal-500:focus {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .sm\\:focus\\:via-teal-600:focus {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .sm\\:focus\\:via-teal-700:focus {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .sm\\:focus\\:via-teal-800:focus {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .sm\\:focus\\:via-teal-900:focus {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .sm\\:focus\\:via-blue-100:focus {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .sm\\:focus\\:via-blue-200:focus {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .sm\\:focus\\:via-blue-300:focus {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .sm\\:focus\\:via-blue-400:focus {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .sm\\:focus\\:via-blue-500:focus {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .sm\\:focus\\:via-blue-600:focus {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .sm\\:focus\\:via-blue-700:focus {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .sm\\:focus\\:via-blue-800:focus {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .sm\\:focus\\:via-blue-900:focus {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-100:focus {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-200:focus {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-300:focus {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-400:focus {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-500:focus {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-600:focus {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-700:focus {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-800:focus {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .sm\\:focus\\:via-indigo-900:focus {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .sm\\:focus\\:via-purple-100:focus {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .sm\\:focus\\:via-purple-200:focus {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .sm\\:focus\\:via-purple-300:focus {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .sm\\:focus\\:via-purple-400:focus {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .sm\\:focus\\:via-purple-500:focus {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .sm\\:focus\\:via-purple-600:focus {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .sm\\:focus\\:via-purple-700:focus {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .sm\\:focus\\:via-purple-800:focus {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .sm\\:focus\\:via-purple-900:focus {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .sm\\:focus\\:via-pink-100:focus {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .sm\\:focus\\:via-pink-200:focus {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .sm\\:focus\\:via-pink-300:focus {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .sm\\:focus\\:via-pink-400:focus {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .sm\\:focus\\:via-pink-500:focus {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .sm\\:focus\\:via-pink-600:focus {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .sm\\:focus\\:via-pink-700:focus {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .sm\\:focus\\:via-pink-800:focus {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .sm\\:focus\\:via-pink-900:focus {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .sm\\:focus\\:to-transparent:focus {\n    --gradient-to-color: transparent;\n  }\n\n  .sm\\:focus\\:to-current:focus {\n    --gradient-to-color: currentColor;\n  }\n\n  .sm\\:focus\\:to-black:focus {\n    --gradient-to-color: #000;\n  }\n\n  .sm\\:focus\\:to-white:focus {\n    --gradient-to-color: #fff;\n  }\n\n  .sm\\:focus\\:to-gray-100:focus {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .sm\\:focus\\:to-gray-200:focus {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .sm\\:focus\\:to-gray-300:focus {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .sm\\:focus\\:to-gray-400:focus {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .sm\\:focus\\:to-gray-500:focus {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .sm\\:focus\\:to-gray-600:focus {\n    --gradient-to-color: #718096;\n  }\n\n  .sm\\:focus\\:to-gray-700:focus {\n    --gradient-to-color: #4a5568;\n  }\n\n  .sm\\:focus\\:to-gray-800:focus {\n    --gradient-to-color: #2d3748;\n  }\n\n  .sm\\:focus\\:to-gray-900:focus {\n    --gradient-to-color: #1a202c;\n  }\n\n  .sm\\:focus\\:to-red-100:focus {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .sm\\:focus\\:to-red-200:focus {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .sm\\:focus\\:to-red-300:focus {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .sm\\:focus\\:to-red-400:focus {\n    --gradient-to-color: #fc8181;\n  }\n\n  .sm\\:focus\\:to-red-500:focus {\n    --gradient-to-color: #f56565;\n  }\n\n  .sm\\:focus\\:to-red-600:focus {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .sm\\:focus\\:to-red-700:focus {\n    --gradient-to-color: #c53030;\n  }\n\n  .sm\\:focus\\:to-red-800:focus {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .sm\\:focus\\:to-red-900:focus {\n    --gradient-to-color: #742a2a;\n  }\n\n  .sm\\:focus\\:to-orange-100:focus {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .sm\\:focus\\:to-orange-200:focus {\n    --gradient-to-color: #feebc8;\n  }\n\n  .sm\\:focus\\:to-orange-300:focus {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .sm\\:focus\\:to-orange-400:focus {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .sm\\:focus\\:to-orange-500:focus {\n    --gradient-to-color: #ed8936;\n  }\n\n  .sm\\:focus\\:to-orange-600:focus {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .sm\\:focus\\:to-orange-700:focus {\n    --gradient-to-color: #c05621;\n  }\n\n  .sm\\:focus\\:to-orange-800:focus {\n    --gradient-to-color: #9c4221;\n  }\n\n  .sm\\:focus\\:to-orange-900:focus {\n    --gradient-to-color: #7b341e;\n  }\n\n  .sm\\:focus\\:to-yellow-100:focus {\n    --gradient-to-color: #fffff0;\n  }\n\n  .sm\\:focus\\:to-yellow-200:focus {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .sm\\:focus\\:to-yellow-300:focus {\n    --gradient-to-color: #faf089;\n  }\n\n  .sm\\:focus\\:to-yellow-400:focus {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .sm\\:focus\\:to-yellow-500:focus {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .sm\\:focus\\:to-yellow-600:focus {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .sm\\:focus\\:to-yellow-700:focus {\n    --gradient-to-color: #b7791f;\n  }\n\n  .sm\\:focus\\:to-yellow-800:focus {\n    --gradient-to-color: #975a16;\n  }\n\n  .sm\\:focus\\:to-yellow-900:focus {\n    --gradient-to-color: #744210;\n  }\n\n  .sm\\:focus\\:to-green-100:focus {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .sm\\:focus\\:to-green-200:focus {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .sm\\:focus\\:to-green-300:focus {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .sm\\:focus\\:to-green-400:focus {\n    --gradient-to-color: #68d391;\n  }\n\n  .sm\\:focus\\:to-green-500:focus {\n    --gradient-to-color: #48bb78;\n  }\n\n  .sm\\:focus\\:to-green-600:focus {\n    --gradient-to-color: #38a169;\n  }\n\n  .sm\\:focus\\:to-green-700:focus {\n    --gradient-to-color: #2f855a;\n  }\n\n  .sm\\:focus\\:to-green-800:focus {\n    --gradient-to-color: #276749;\n  }\n\n  .sm\\:focus\\:to-green-900:focus {\n    --gradient-to-color: #22543d;\n  }\n\n  .sm\\:focus\\:to-teal-100:focus {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .sm\\:focus\\:to-teal-200:focus {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .sm\\:focus\\:to-teal-300:focus {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .sm\\:focus\\:to-teal-400:focus {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .sm\\:focus\\:to-teal-500:focus {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .sm\\:focus\\:to-teal-600:focus {\n    --gradient-to-color: #319795;\n  }\n\n  .sm\\:focus\\:to-teal-700:focus {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .sm\\:focus\\:to-teal-800:focus {\n    --gradient-to-color: #285e61;\n  }\n\n  .sm\\:focus\\:to-teal-900:focus {\n    --gradient-to-color: #234e52;\n  }\n\n  .sm\\:focus\\:to-blue-100:focus {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .sm\\:focus\\:to-blue-200:focus {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .sm\\:focus\\:to-blue-300:focus {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .sm\\:focus\\:to-blue-400:focus {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .sm\\:focus\\:to-blue-500:focus {\n    --gradient-to-color: #4299e1;\n  }\n\n  .sm\\:focus\\:to-blue-600:focus {\n    --gradient-to-color: #3182ce;\n  }\n\n  .sm\\:focus\\:to-blue-700:focus {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .sm\\:focus\\:to-blue-800:focus {\n    --gradient-to-color: #2c5282;\n  }\n\n  .sm\\:focus\\:to-blue-900:focus {\n    --gradient-to-color: #2a4365;\n  }\n\n  .sm\\:focus\\:to-indigo-100:focus {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .sm\\:focus\\:to-indigo-200:focus {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .sm\\:focus\\:to-indigo-300:focus {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .sm\\:focus\\:to-indigo-400:focus {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .sm\\:focus\\:to-indigo-500:focus {\n    --gradient-to-color: #667eea;\n  }\n\n  .sm\\:focus\\:to-indigo-600:focus {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .sm\\:focus\\:to-indigo-700:focus {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .sm\\:focus\\:to-indigo-800:focus {\n    --gradient-to-color: #434190;\n  }\n\n  .sm\\:focus\\:to-indigo-900:focus {\n    --gradient-to-color: #3c366b;\n  }\n\n  .sm\\:focus\\:to-purple-100:focus {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .sm\\:focus\\:to-purple-200:focus {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .sm\\:focus\\:to-purple-300:focus {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .sm\\:focus\\:to-purple-400:focus {\n    --gradient-to-color: #b794f4;\n  }\n\n  .sm\\:focus\\:to-purple-500:focus {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .sm\\:focus\\:to-purple-600:focus {\n    --gradient-to-color: #805ad5;\n  }\n\n  .sm\\:focus\\:to-purple-700:focus {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .sm\\:focus\\:to-purple-800:focus {\n    --gradient-to-color: #553c9a;\n  }\n\n  .sm\\:focus\\:to-purple-900:focus {\n    --gradient-to-color: #44337a;\n  }\n\n  .sm\\:focus\\:to-pink-100:focus {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .sm\\:focus\\:to-pink-200:focus {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .sm\\:focus\\:to-pink-300:focus {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .sm\\:focus\\:to-pink-400:focus {\n    --gradient-to-color: #f687b3;\n  }\n\n  .sm\\:focus\\:to-pink-500:focus {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .sm\\:focus\\:to-pink-600:focus {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .sm\\:focus\\:to-pink-700:focus {\n    --gradient-to-color: #b83280;\n  }\n\n  .sm\\:focus\\:to-pink-800:focus {\n    --gradient-to-color: #97266d;\n  }\n\n  .sm\\:focus\\:to-pink-900:focus {\n    --gradient-to-color: #702459;\n  }\n\n  .sm\\:bg-opacity-0 {\n    --bg-opacity: 0;\n  }\n\n  .sm\\:bg-opacity-25 {\n    --bg-opacity: 0.25;\n  }\n\n  .sm\\:bg-opacity-50 {\n    --bg-opacity: 0.5;\n  }\n\n  .sm\\:bg-opacity-75 {\n    --bg-opacity: 0.75;\n  }\n\n  .sm\\:bg-opacity-100 {\n    --bg-opacity: 1;\n  }\n\n  .sm\\:hover\\:bg-opacity-0:hover {\n    --bg-opacity: 0;\n  }\n\n  .sm\\:hover\\:bg-opacity-25:hover {\n    --bg-opacity: 0.25;\n  }\n\n  .sm\\:hover\\:bg-opacity-50:hover {\n    --bg-opacity: 0.5;\n  }\n\n  .sm\\:hover\\:bg-opacity-75:hover {\n    --bg-opacity: 0.75;\n  }\n\n  .sm\\:hover\\:bg-opacity-100:hover {\n    --bg-opacity: 1;\n  }\n\n  .sm\\:focus\\:bg-opacity-0:focus {\n    --bg-opacity: 0;\n  }\n\n  .sm\\:focus\\:bg-opacity-25:focus {\n    --bg-opacity: 0.25;\n  }\n\n  .sm\\:focus\\:bg-opacity-50:focus {\n    --bg-opacity: 0.5;\n  }\n\n  .sm\\:focus\\:bg-opacity-75:focus {\n    --bg-opacity: 0.75;\n  }\n\n  .sm\\:focus\\:bg-opacity-100:focus {\n    --bg-opacity: 1;\n  }\n\n  .sm\\:bg-bottom {\n    background-position: bottom;\n  }\n\n  .sm\\:bg-center {\n    background-position: center;\n  }\n\n  .sm\\:bg-left {\n    background-position: left;\n  }\n\n  .sm\\:bg-left-bottom {\n    background-position: left bottom;\n  }\n\n  .sm\\:bg-left-top {\n    background-position: left top;\n  }\n\n  .sm\\:bg-right {\n    background-position: right;\n  }\n\n  .sm\\:bg-right-bottom {\n    background-position: right bottom;\n  }\n\n  .sm\\:bg-right-top {\n    background-position: right top;\n  }\n\n  .sm\\:bg-top {\n    background-position: top;\n  }\n\n  .sm\\:bg-repeat {\n    background-repeat: repeat;\n  }\n\n  .sm\\:bg-no-repeat {\n    background-repeat: no-repeat;\n  }\n\n  .sm\\:bg-repeat-x {\n    background-repeat: repeat-x;\n  }\n\n  .sm\\:bg-repeat-y {\n    background-repeat: repeat-y;\n  }\n\n  .sm\\:bg-repeat-round {\n    background-repeat: round;\n  }\n\n  .sm\\:bg-repeat-space {\n    background-repeat: space;\n  }\n\n  .sm\\:bg-auto {\n    background-size: auto;\n  }\n\n  .sm\\:bg-cover {\n    background-size: cover;\n  }\n\n  .sm\\:bg-contain {\n    background-size: contain;\n  }\n\n  .sm\\:border-collapse {\n    border-collapse: collapse;\n  }\n\n  .sm\\:border-separate {\n    border-collapse: separate;\n  }\n\n  .sm\\:border-transparent {\n    border-color: transparent;\n  }\n\n  .sm\\:border-current {\n    border-color: currentColor;\n  }\n\n  .sm\\:border-black {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .sm\\:border-white {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .sm\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .sm\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .sm\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .sm\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .sm\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .sm\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .sm\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .sm\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .sm\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .sm\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .sm\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .sm\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .sm\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .sm\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .sm\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .sm\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .sm\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .sm\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .sm\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .sm\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .sm\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .sm\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .sm\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .sm\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .sm\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .sm\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n  }\n\n  .sm\\:hover\\:border-current:hover {\n    border-color: currentColor;\n  }\n\n  .sm\\:hover\\:border-black:hover {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-white:hover {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-100:hover {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-200:hover {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-300:hover {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-400:hover {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-500:hover {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-600:hover {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-700:hover {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-800:hover {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-red-900:hover {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-100:hover {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-200:hover {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-300:hover {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-400:hover {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-500:hover {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-600:hover {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-700:hover {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-800:hover {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-orange-900:hover {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-100:hover {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-200:hover {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-300:hover {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-400:hover {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-500:hover {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-600:hover {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-700:hover {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-800:hover {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-yellow-900:hover {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-100:hover {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-200:hover {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-300:hover {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-400:hover {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-500:hover {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-600:hover {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-700:hover {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-800:hover {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-green-900:hover {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-100:hover {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-200:hover {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-300:hover {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-400:hover {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-500:hover {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-600:hover {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-700:hover {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-800:hover {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-teal-900:hover {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-100:hover {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-200:hover {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-300:hover {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-400:hover {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-500:hover {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-600:hover {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-700:hover {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-800:hover {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-blue-900:hover {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-100:hover {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-200:hover {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-300:hover {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-400:hover {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-500:hover {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-600:hover {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-700:hover {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-800:hover {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-indigo-900:hover {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-100:hover {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-200:hover {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-300:hover {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-400:hover {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-500:hover {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-600:hover {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-700:hover {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-800:hover {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-purple-900:hover {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-100:hover {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-200:hover {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-300:hover {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-400:hover {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-500:hover {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-600:hover {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-700:hover {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-800:hover {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .sm\\:hover\\:border-pink-900:hover {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-transparent:focus {\n    border-color: transparent;\n  }\n\n  .sm\\:focus\\:border-current:focus {\n    border-color: currentColor;\n  }\n\n  .sm\\:focus\\:border-black:focus {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-white:focus {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-100:focus {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-200:focus {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-300:focus {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-400:focus {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-500:focus {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-600:focus {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-700:focus {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-800:focus {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-red-900:focus {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-100:focus {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-200:focus {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-300:focus {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-400:focus {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-500:focus {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-600:focus {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-700:focus {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-800:focus {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-orange-900:focus {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-100:focus {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-200:focus {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-300:focus {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-400:focus {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-500:focus {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-600:focus {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-700:focus {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-800:focus {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-yellow-900:focus {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-100:focus {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-200:focus {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-300:focus {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-400:focus {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-500:focus {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-600:focus {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-700:focus {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-800:focus {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-green-900:focus {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-100:focus {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-200:focus {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-300:focus {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-400:focus {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-500:focus {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-600:focus {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-700:focus {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-800:focus {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-teal-900:focus {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-100:focus {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-200:focus {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-300:focus {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-400:focus {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-500:focus {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-600:focus {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-700:focus {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-800:focus {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-blue-900:focus {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-100:focus {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-200:focus {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-300:focus {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-400:focus {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-500:focus {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-600:focus {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-700:focus {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-800:focus {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-indigo-900:focus {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-100:focus {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-200:focus {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-300:focus {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-400:focus {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-500:focus {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-600:focus {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-700:focus {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-800:focus {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-purple-900:focus {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-100:focus {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-200:focus {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-300:focus {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-400:focus {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-500:focus {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-600:focus {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-700:focus {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-800:focus {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .sm\\:focus\\:border-pink-900:focus {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .sm\\:border-opacity-0 {\n    --border-opacity: 0;\n  }\n\n  .sm\\:border-opacity-25 {\n    --border-opacity: 0.25;\n  }\n\n  .sm\\:border-opacity-50 {\n    --border-opacity: 0.5;\n  }\n\n  .sm\\:border-opacity-75 {\n    --border-opacity: 0.75;\n  }\n\n  .sm\\:border-opacity-100 {\n    --border-opacity: 1;\n  }\n\n  .sm\\:hover\\:border-opacity-0:hover {\n    --border-opacity: 0;\n  }\n\n  .sm\\:hover\\:border-opacity-25:hover {\n    --border-opacity: 0.25;\n  }\n\n  .sm\\:hover\\:border-opacity-50:hover {\n    --border-opacity: 0.5;\n  }\n\n  .sm\\:hover\\:border-opacity-75:hover {\n    --border-opacity: 0.75;\n  }\n\n  .sm\\:hover\\:border-opacity-100:hover {\n    --border-opacity: 1;\n  }\n\n  .sm\\:focus\\:border-opacity-0:focus {\n    --border-opacity: 0;\n  }\n\n  .sm\\:focus\\:border-opacity-25:focus {\n    --border-opacity: 0.25;\n  }\n\n  .sm\\:focus\\:border-opacity-50:focus {\n    --border-opacity: 0.5;\n  }\n\n  .sm\\:focus\\:border-opacity-75:focus {\n    --border-opacity: 0.75;\n  }\n\n  .sm\\:focus\\:border-opacity-100:focus {\n    --border-opacity: 1;\n  }\n\n  .sm\\:rounded-none {\n    border-radius: 0;\n  }\n\n  .sm\\:rounded-sm {\n    border-radius: 0.125rem;\n  }\n\n  .sm\\:rounded {\n    border-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-md {\n    border-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-2xl {\n    border-radius: 1rem;\n  }\n\n  .sm\\:rounded-3xl {\n    border-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-full {\n    border-radius: 9999px;\n  }\n\n  .sm\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .sm\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .sm\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .sm\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .sm\\:rounded-t-sm {\n    border-top-left-radius: 0.125rem;\n    border-top-right-radius: 0.125rem;\n  }\n\n  .sm\\:rounded-r-sm {\n    border-top-right-radius: 0.125rem;\n    border-bottom-right-radius: 0.125rem;\n  }\n\n  .sm\\:rounded-b-sm {\n    border-bottom-right-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .sm\\:rounded-l-sm {\n    border-top-left-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .sm\\:rounded-t {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-r {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-b {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-l {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-b-md {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-b-lg {\n    border-bottom-right-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-t-xl {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-r-xl {\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-b-xl {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-l-xl {\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-t-2xl {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n\n  .sm\\:rounded-r-2xl {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n\n  .sm\\:rounded-b-2xl {\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .sm\\:rounded-l-2xl {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .sm\\:rounded-t-3xl {\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-r-3xl {\n    border-top-right-radius: 1.5rem;\n    border-bottom-right-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-b-3xl {\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-l-3xl {\n    border-top-left-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n  }\n\n  .sm\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n  }\n\n  .sm\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n\n  .sm\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n\n  .sm\\:rounded-tl-none {\n    border-top-left-radius: 0;\n  }\n\n  .sm\\:rounded-tr-none {\n    border-top-right-radius: 0;\n  }\n\n  .sm\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n  }\n\n  .sm\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n  }\n\n  .sm\\:rounded-tl-sm {\n    border-top-left-radius: 0.125rem;\n  }\n\n  .sm\\:rounded-tr-sm {\n    border-top-right-radius: 0.125rem;\n  }\n\n  .sm\\:rounded-br-sm {\n    border-bottom-right-radius: 0.125rem;\n  }\n\n  .sm\\:rounded-bl-sm {\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .sm\\:rounded-tl {\n    border-top-left-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-tr {\n    border-top-right-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-br {\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-bl {\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .sm\\:rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .sm\\:rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .sm\\:rounded-tl-xl {\n    border-top-left-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-tr-xl {\n    border-top-right-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-br-xl {\n    border-bottom-right-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-bl-xl {\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .sm\\:rounded-tl-2xl {\n    border-top-left-radius: 1rem;\n  }\n\n  .sm\\:rounded-tr-2xl {\n    border-top-right-radius: 1rem;\n  }\n\n  .sm\\:rounded-br-2xl {\n    border-bottom-right-radius: 1rem;\n  }\n\n  .sm\\:rounded-bl-2xl {\n    border-bottom-left-radius: 1rem;\n  }\n\n  .sm\\:rounded-tl-3xl {\n    border-top-left-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-tr-3xl {\n    border-top-right-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-br-3xl {\n    border-bottom-right-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-bl-3xl {\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .sm\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n  }\n\n  .sm\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n  }\n\n  .sm\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n  }\n\n  .sm\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n  }\n\n  .sm\\:border-solid {\n    border-style: solid;\n  }\n\n  .sm\\:border-dashed {\n    border-style: dashed;\n  }\n\n  .sm\\:border-dotted {\n    border-style: dotted;\n  }\n\n  .sm\\:border-double {\n    border-style: double;\n  }\n\n  .sm\\:border-none {\n    border-style: none;\n  }\n\n  .sm\\:border-0 {\n    border-width: 0;\n  }\n\n  .sm\\:border-2 {\n    border-width: 2px;\n  }\n\n  .sm\\:border-4 {\n    border-width: 4px;\n  }\n\n  .sm\\:border-8 {\n    border-width: 8px;\n  }\n\n  .sm\\:border {\n    border-width: 1px;\n  }\n\n  .sm\\:border-t-0 {\n    border-top-width: 0;\n  }\n\n  .sm\\:border-r-0 {\n    border-right-width: 0;\n  }\n\n  .sm\\:border-b-0 {\n    border-bottom-width: 0;\n  }\n\n  .sm\\:border-l-0 {\n    border-left-width: 0;\n  }\n\n  .sm\\:border-t-2 {\n    border-top-width: 2px;\n  }\n\n  .sm\\:border-r-2 {\n    border-right-width: 2px;\n  }\n\n  .sm\\:border-b-2 {\n    border-bottom-width: 2px;\n  }\n\n  .sm\\:border-l-2 {\n    border-left-width: 2px;\n  }\n\n  .sm\\:border-t-4 {\n    border-top-width: 4px;\n  }\n\n  .sm\\:border-r-4 {\n    border-right-width: 4px;\n  }\n\n  .sm\\:border-b-4 {\n    border-bottom-width: 4px;\n  }\n\n  .sm\\:border-l-4 {\n    border-left-width: 4px;\n  }\n\n  .sm\\:border-t-8 {\n    border-top-width: 8px;\n  }\n\n  .sm\\:border-r-8 {\n    border-right-width: 8px;\n  }\n\n  .sm\\:border-b-8 {\n    border-bottom-width: 8px;\n  }\n\n  .sm\\:border-l-8 {\n    border-left-width: 8px;\n  }\n\n  .sm\\:border-t {\n    border-top-width: 1px;\n  }\n\n  .sm\\:border-r {\n    border-right-width: 1px;\n  }\n\n  .sm\\:border-b {\n    border-bottom-width: 1px;\n  }\n\n  .sm\\:border-l {\n    border-left-width: 1px;\n  }\n\n  .sm\\:box-border {\n    box-sizing: border-box;\n  }\n\n  .sm\\:box-content {\n    box-sizing: content-box;\n  }\n\n  .sm\\:cursor-auto {\n    cursor: auto;\n  }\n\n  .sm\\:cursor-default {\n    cursor: default;\n  }\n\n  .sm\\:cursor-pointer {\n    cursor: pointer;\n  }\n\n  .sm\\:cursor-wait {\n    cursor: wait;\n  }\n\n  .sm\\:cursor-text {\n    cursor: text;\n  }\n\n  .sm\\:cursor-move {\n    cursor: move;\n  }\n\n  .sm\\:cursor-not-allowed {\n    cursor: not-allowed;\n  }\n\n  .sm\\:block {\n    display: block;\n  }\n\n  .sm\\:inline-block {\n    display: inline-block;\n  }\n\n  .sm\\:inline {\n    display: inline;\n  }\n\n  .sm\\:flex {\n    display: flex;\n  }\n\n  .sm\\:inline-flex {\n    display: inline-flex;\n  }\n\n  .sm\\:table {\n    display: table;\n  }\n\n  .sm\\:table-caption {\n    display: table-caption;\n  }\n\n  .sm\\:table-cell {\n    display: table-cell;\n  }\n\n  .sm\\:table-column {\n    display: table-column;\n  }\n\n  .sm\\:table-column-group {\n    display: table-column-group;\n  }\n\n  .sm\\:table-footer-group {\n    display: table-footer-group;\n  }\n\n  .sm\\:table-header-group {\n    display: table-header-group;\n  }\n\n  .sm\\:table-row-group {\n    display: table-row-group;\n  }\n\n  .sm\\:table-row {\n    display: table-row;\n  }\n\n  .sm\\:flow-root {\n    display: flow-root;\n  }\n\n  .sm\\:grid {\n    display: grid;\n  }\n\n  .sm\\:inline-grid {\n    display: inline-grid;\n  }\n\n  .sm\\:contents {\n    display: contents;\n  }\n\n  .sm\\:hidden {\n    display: none;\n  }\n\n  .sm\\:flex-row {\n    flex-direction: row;\n  }\n\n  .sm\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n\n  .sm\\:flex-col {\n    flex-direction: column;\n  }\n\n  .sm\\:flex-col-reverse {\n    flex-direction: column-reverse;\n  }\n\n  .sm\\:flex-wrap {\n    flex-wrap: wrap;\n  }\n\n  .sm\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n  }\n\n  .sm\\:flex-no-wrap {\n    flex-wrap: nowrap;\n  }\n\n  .sm\\:place-items-auto {\n    place-items: auto;\n  }\n\n  .sm\\:place-items-start {\n    place-items: start;\n  }\n\n  .sm\\:place-items-end {\n    place-items: end;\n  }\n\n  .sm\\:place-items-center {\n    place-items: center;\n  }\n\n  .sm\\:place-items-stretch {\n    place-items: stretch;\n  }\n\n  .sm\\:place-content-center {\n    place-content: center;\n  }\n\n  .sm\\:place-content-start {\n    place-content: start;\n  }\n\n  .sm\\:place-content-end {\n    place-content: end;\n  }\n\n  .sm\\:place-content-between {\n    place-content: space-between;\n  }\n\n  .sm\\:place-content-around {\n    place-content: space-around;\n  }\n\n  .sm\\:place-content-evenly {\n    place-content: space-evenly;\n  }\n\n  .sm\\:place-content-stretch {\n    place-content: stretch;\n  }\n\n  .sm\\:place-self-auto {\n    place-self: auto;\n  }\n\n  .sm\\:place-self-start {\n    place-self: start;\n  }\n\n  .sm\\:place-self-end {\n    place-self: end;\n  }\n\n  .sm\\:place-self-center {\n    place-self: center;\n  }\n\n  .sm\\:place-self-stretch {\n    place-self: stretch;\n  }\n\n  .sm\\:items-start {\n    align-items: flex-start;\n  }\n\n  .sm\\:items-end {\n    align-items: flex-end;\n  }\n\n  .sm\\:items-center {\n    align-items: center;\n  }\n\n  .sm\\:items-baseline {\n    align-items: baseline;\n  }\n\n  .sm\\:items-stretch {\n    align-items: stretch;\n  }\n\n  .sm\\:content-center {\n    align-content: center;\n  }\n\n  .sm\\:content-start {\n    align-content: flex-start;\n  }\n\n  .sm\\:content-end {\n    align-content: flex-end;\n  }\n\n  .sm\\:content-between {\n    align-content: space-between;\n  }\n\n  .sm\\:content-around {\n    align-content: space-around;\n  }\n\n  .sm\\:content-evenly {\n    align-content: space-evenly;\n  }\n\n  .sm\\:self-auto {\n    align-self: auto;\n  }\n\n  .sm\\:self-start {\n    align-self: flex-start;\n  }\n\n  .sm\\:self-end {\n    align-self: flex-end;\n  }\n\n  .sm\\:self-center {\n    align-self: center;\n  }\n\n  .sm\\:self-stretch {\n    align-self: stretch;\n  }\n\n  .sm\\:justify-items-auto {\n    justify-items: auto;\n  }\n\n  .sm\\:justify-items-start {\n    justify-items: start;\n  }\n\n  .sm\\:justify-items-end {\n    justify-items: end;\n  }\n\n  .sm\\:justify-items-center {\n    justify-items: center;\n  }\n\n  .sm\\:justify-items-stretch {\n    justify-items: stretch;\n  }\n\n  .sm\\:justify-start {\n    justify-content: flex-start;\n  }\n\n  .sm\\:justify-end {\n    justify-content: flex-end;\n  }\n\n  .sm\\:justify-center {\n    justify-content: center;\n  }\n\n  .sm\\:justify-between {\n    justify-content: space-between;\n  }\n\n  .sm\\:justify-around {\n    justify-content: space-around;\n  }\n\n  .sm\\:justify-evenly {\n    justify-content: space-evenly;\n  }\n\n  .sm\\:justify-self-auto {\n    justify-self: auto;\n  }\n\n  .sm\\:justify-self-start {\n    justify-self: start;\n  }\n\n  .sm\\:justify-self-end {\n    justify-self: end;\n  }\n\n  .sm\\:justify-self-center {\n    justify-self: center;\n  }\n\n  .sm\\:justify-self-stretch {\n    justify-self: stretch;\n  }\n\n  .sm\\:flex-1 {\n    flex: 1 1 0%;\n  }\n\n  .sm\\:flex-auto {\n    flex: 1 1 auto;\n  }\n\n  .sm\\:flex-initial {\n    flex: 0 1 auto;\n  }\n\n  .sm\\:flex-none {\n    flex: none;\n  }\n\n  .sm\\:flex-grow-0 {\n    flex-grow: 0;\n  }\n\n  .sm\\:flex-grow {\n    flex-grow: 1;\n  }\n\n  .sm\\:flex-shrink-0 {\n    flex-shrink: 0;\n  }\n\n  .sm\\:flex-shrink {\n    flex-shrink: 1;\n  }\n\n  .sm\\:order-1 {\n    order: 1;\n  }\n\n  .sm\\:order-2 {\n    order: 2;\n  }\n\n  .sm\\:order-3 {\n    order: 3;\n  }\n\n  .sm\\:order-4 {\n    order: 4;\n  }\n\n  .sm\\:order-5 {\n    order: 5;\n  }\n\n  .sm\\:order-6 {\n    order: 6;\n  }\n\n  .sm\\:order-7 {\n    order: 7;\n  }\n\n  .sm\\:order-8 {\n    order: 8;\n  }\n\n  .sm\\:order-9 {\n    order: 9;\n  }\n\n  .sm\\:order-10 {\n    order: 10;\n  }\n\n  .sm\\:order-11 {\n    order: 11;\n  }\n\n  .sm\\:order-12 {\n    order: 12;\n  }\n\n  .sm\\:order-first {\n    order: -9999;\n  }\n\n  .sm\\:order-last {\n    order: 9999;\n  }\n\n  .sm\\:order-none {\n    order: 0;\n  }\n\n  .sm\\:float-right {\n    float: right;\n  }\n\n  .sm\\:float-left {\n    float: left;\n  }\n\n  .sm\\:float-none {\n    float: none;\n  }\n\n  .sm\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  .sm\\:clear-left {\n    clear: left;\n  }\n\n  .sm\\:clear-right {\n    clear: right;\n  }\n\n  .sm\\:clear-both {\n    clear: both;\n  }\n\n  .sm\\:clear-none {\n    clear: none;\n  }\n\n  .sm\\:font-sans {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  }\n\n  .sm\\:font-serif {\n    font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n  }\n\n  .sm\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  }\n\n  .sm\\:font-hairline {\n    font-weight: 100;\n  }\n\n  .sm\\:font-thin {\n    font-weight: 200;\n  }\n\n  .sm\\:font-light {\n    font-weight: 300;\n  }\n\n  .sm\\:font-normal {\n    font-weight: 400;\n  }\n\n  .sm\\:font-medium {\n    font-weight: 500;\n  }\n\n  .sm\\:font-semibold {\n    font-weight: 600;\n  }\n\n  .sm\\:font-bold {\n    font-weight: 700;\n  }\n\n  .sm\\:font-extrabold {\n    font-weight: 800;\n  }\n\n  .sm\\:font-black {\n    font-weight: 900;\n  }\n\n  .sm\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n  }\n\n  .sm\\:hover\\:font-thin:hover {\n    font-weight: 200;\n  }\n\n  .sm\\:hover\\:font-light:hover {\n    font-weight: 300;\n  }\n\n  .sm\\:hover\\:font-normal:hover {\n    font-weight: 400;\n  }\n\n  .sm\\:hover\\:font-medium:hover {\n    font-weight: 500;\n  }\n\n  .sm\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n  }\n\n  .sm\\:hover\\:font-bold:hover {\n    font-weight: 700;\n  }\n\n  .sm\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n  }\n\n  .sm\\:hover\\:font-black:hover {\n    font-weight: 900;\n  }\n\n  .sm\\:focus\\:font-hairline:focus {\n    font-weight: 100;\n  }\n\n  .sm\\:focus\\:font-thin:focus {\n    font-weight: 200;\n  }\n\n  .sm\\:focus\\:font-light:focus {\n    font-weight: 300;\n  }\n\n  .sm\\:focus\\:font-normal:focus {\n    font-weight: 400;\n  }\n\n  .sm\\:focus\\:font-medium:focus {\n    font-weight: 500;\n  }\n\n  .sm\\:focus\\:font-semibold:focus {\n    font-weight: 600;\n  }\n\n  .sm\\:focus\\:font-bold:focus {\n    font-weight: 700;\n  }\n\n  .sm\\:focus\\:font-extrabold:focus {\n    font-weight: 800;\n  }\n\n  .sm\\:focus\\:font-black:focus {\n    font-weight: 900;\n  }\n\n  .sm\\:h-0 {\n    height: 0;\n  }\n\n  .sm\\:h-1 {\n    height: 0.25rem;\n  }\n\n  .sm\\:h-2 {\n    height: 0.5rem;\n  }\n\n  .sm\\:h-3 {\n    height: 0.75rem;\n  }\n\n  .sm\\:h-4 {\n    height: 1rem;\n  }\n\n  .sm\\:h-5 {\n    height: 1.25rem;\n  }\n\n  .sm\\:h-6 {\n    height: 1.5rem;\n  }\n\n  .sm\\:h-8 {\n    height: 2rem;\n  }\n\n  .sm\\:h-10 {\n    height: 2.5rem;\n  }\n\n  .sm\\:h-12 {\n    height: 3rem;\n  }\n\n  .sm\\:h-16 {\n    height: 4rem;\n  }\n\n  .sm\\:h-20 {\n    height: 5rem;\n  }\n\n  .sm\\:h-24 {\n    height: 6rem;\n  }\n\n  .sm\\:h-32 {\n    height: 8rem;\n  }\n\n  .sm\\:h-40 {\n    height: 10rem;\n  }\n\n  .sm\\:h-48 {\n    height: 12rem;\n  }\n\n  .sm\\:h-56 {\n    height: 14rem;\n  }\n\n  .sm\\:h-64 {\n    height: 16rem;\n  }\n\n  .sm\\:h-auto {\n    height: auto;\n  }\n\n  .sm\\:h-px {\n    height: 1px;\n  }\n\n  .sm\\:h-full {\n    height: 100%;\n  }\n\n  .sm\\:h-screen {\n    height: 100vh;\n  }\n\n  .sm\\:text-15 {\n    font-size: 0.9375rem;\n  }\n\n  .sm\\:text-xs {\n    font-size: 0.75rem;\n  }\n\n  .sm\\:text-sm {\n    font-size: 0.875rem;\n  }\n\n  .sm\\:text-base {\n    font-size: 1rem;\n  }\n\n  .sm\\:text-lg {\n    font-size: 1.125rem;\n  }\n\n  .sm\\:text-xl {\n    font-size: 1.25rem;\n  }\n\n  .sm\\:text-1\\.5xl {\n    font-size: 1.375rem;\n  }\n\n  .sm\\:text-2xl {\n    font-size: 1.5rem;\n  }\n\n  .sm\\:text-3xl {\n    font-size: 1.875rem;\n  }\n\n  .sm\\:text-4xl {\n    font-size: 2.25rem;\n  }\n\n  .sm\\:text-5xl {\n    font-size: 3rem;\n  }\n\n  .sm\\:text-6xl {\n    font-size: 4rem;\n  }\n\n  .sm\\:leading-3 {\n    line-height: .75rem;\n  }\n\n  .sm\\:leading-4 {\n    line-height: 1rem;\n  }\n\n  .sm\\:leading-5 {\n    line-height: 1.25rem;\n  }\n\n  .sm\\:leading-6 {\n    line-height: 1.5rem;\n  }\n\n  .sm\\:leading-7 {\n    line-height: 1.75rem;\n  }\n\n  .sm\\:leading-8 {\n    line-height: 2rem;\n  }\n\n  .sm\\:leading-9 {\n    line-height: 2.25rem;\n  }\n\n  .sm\\:leading-10 {\n    line-height: 2.5rem;\n  }\n\n  .sm\\:leading-none {\n    line-height: 1;\n  }\n\n  .sm\\:leading-tight {\n    line-height: 1.25;\n  }\n\n  .sm\\:leading-snug {\n    line-height: 1.375;\n  }\n\n  .sm\\:leading-normal {\n    line-height: 1.5;\n  }\n\n  .sm\\:leading-relaxed {\n    line-height: 1.625;\n  }\n\n  .sm\\:leading-loose {\n    line-height: 2;\n  }\n\n  .sm\\:list-inside {\n    list-style-position: inside;\n  }\n\n  .sm\\:list-outside {\n    list-style-position: outside;\n  }\n\n  .sm\\:list-none {\n    list-style-type: none;\n  }\n\n  .sm\\:list-disc {\n    list-style-type: disc;\n  }\n\n  .sm\\:list-decimal {\n    list-style-type: decimal;\n  }\n\n  .sm\\:m-0 {\n    margin: 0;\n  }\n\n  .sm\\:m-1 {\n    margin: 0.25rem;\n  }\n\n  .sm\\:m-2 {\n    margin: 0.5rem;\n  }\n\n  .sm\\:m-3 {\n    margin: 0.75rem;\n  }\n\n  .sm\\:m-4 {\n    margin: 1rem;\n  }\n\n  .sm\\:m-5 {\n    margin: 1.25rem;\n  }\n\n  .sm\\:m-6 {\n    margin: 1.5rem;\n  }\n\n  .sm\\:m-8 {\n    margin: 2rem;\n  }\n\n  .sm\\:m-10 {\n    margin: 2.5rem;\n  }\n\n  .sm\\:m-12 {\n    margin: 3rem;\n  }\n\n  .sm\\:m-16 {\n    margin: 4rem;\n  }\n\n  .sm\\:m-20 {\n    margin: 5rem;\n  }\n\n  .sm\\:m-24 {\n    margin: 6rem;\n  }\n\n  .sm\\:m-32 {\n    margin: 8rem;\n  }\n\n  .sm\\:m-40 {\n    margin: 10rem;\n  }\n\n  .sm\\:m-48 {\n    margin: 12rem;\n  }\n\n  .sm\\:m-56 {\n    margin: 14rem;\n  }\n\n  .sm\\:m-64 {\n    margin: 16rem;\n  }\n\n  .sm\\:m-auto {\n    margin: auto;\n  }\n\n  .sm\\:m-px {\n    margin: 1px;\n  }\n\n  .sm\\:-m-1 {\n    margin: -0.25rem;\n  }\n\n  .sm\\:-m-2 {\n    margin: -0.5rem;\n  }\n\n  .sm\\:-m-3 {\n    margin: -0.75rem;\n  }\n\n  .sm\\:-m-4 {\n    margin: -1rem;\n  }\n\n  .sm\\:-m-5 {\n    margin: -1.25rem;\n  }\n\n  .sm\\:-m-6 {\n    margin: -1.5rem;\n  }\n\n  .sm\\:-m-8 {\n    margin: -2rem;\n  }\n\n  .sm\\:-m-10 {\n    margin: -2.5rem;\n  }\n\n  .sm\\:-m-12 {\n    margin: -3rem;\n  }\n\n  .sm\\:-m-16 {\n    margin: -4rem;\n  }\n\n  .sm\\:-m-20 {\n    margin: -5rem;\n  }\n\n  .sm\\:-m-24 {\n    margin: -6rem;\n  }\n\n  .sm\\:-m-32 {\n    margin: -8rem;\n  }\n\n  .sm\\:-m-40 {\n    margin: -10rem;\n  }\n\n  .sm\\:-m-48 {\n    margin: -12rem;\n  }\n\n  .sm\\:-m-56 {\n    margin: -14rem;\n  }\n\n  .sm\\:-m-64 {\n    margin: -16rem;\n  }\n\n  .sm\\:-m-px {\n    margin: -1px;\n  }\n\n  .sm\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .sm\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .sm\\:my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n\n  .sm\\:mx-1 {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n\n  .sm\\:my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .sm\\:mx-2 {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n\n  .sm\\:my-3 {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .sm\\:mx-3 {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n\n  .sm\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .sm\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n\n  .sm\\:my-5 {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .sm\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n\n  .sm\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .sm\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n\n  .sm\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  .sm\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n\n  .sm\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n\n  .sm\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n\n  .sm\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n\n  .sm\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n\n  .sm\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n\n  .sm\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n\n  .sm\\:my-20 {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n\n  .sm\\:mx-20 {\n    margin-left: 5rem;\n    margin-right: 5rem;\n  }\n\n  .sm\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n\n  .sm\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n\n  .sm\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n\n  .sm\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n\n  .sm\\:my-40 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n  }\n\n  .sm\\:mx-40 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n  }\n\n  .sm\\:my-48 {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n\n  .sm\\:mx-48 {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n\n  .sm\\:my-56 {\n    margin-top: 14rem;\n    margin-bottom: 14rem;\n  }\n\n  .sm\\:mx-56 {\n    margin-left: 14rem;\n    margin-right: 14rem;\n  }\n\n  .sm\\:my-64 {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n\n  .sm\\:mx-64 {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n\n  .sm\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n\n  .sm\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .sm\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n\n  .sm\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n  }\n\n  .sm\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n  }\n\n  .sm\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n  }\n\n  .sm\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n  }\n\n  .sm\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n\n  .sm\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n  }\n\n  .sm\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n  }\n\n  .sm\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n  }\n\n  .sm\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n  }\n\n  .sm\\:-my-5 {\n    margin-top: -1.25rem;\n    margin-bottom: -1.25rem;\n  }\n\n  .sm\\:-mx-5 {\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n\n  .sm\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n  }\n\n  .sm\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n\n  .sm\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n  }\n\n  .sm\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n\n  .sm\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n  }\n\n  .sm\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n  }\n\n  .sm\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n  }\n\n  .sm\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n  }\n\n  .sm\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n  }\n\n  .sm\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n  }\n\n  .sm\\:-my-20 {\n    margin-top: -5rem;\n    margin-bottom: -5rem;\n  }\n\n  .sm\\:-mx-20 {\n    margin-left: -5rem;\n    margin-right: -5rem;\n  }\n\n  .sm\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n  }\n\n  .sm\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n  }\n\n  .sm\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n  }\n\n  .sm\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n  }\n\n  .sm\\:-my-40 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n  }\n\n  .sm\\:-mx-40 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n  }\n\n  .sm\\:-my-48 {\n    margin-top: -12rem;\n    margin-bottom: -12rem;\n  }\n\n  .sm\\:-mx-48 {\n    margin-left: -12rem;\n    margin-right: -12rem;\n  }\n\n  .sm\\:-my-56 {\n    margin-top: -14rem;\n    margin-bottom: -14rem;\n  }\n\n  .sm\\:-mx-56 {\n    margin-left: -14rem;\n    margin-right: -14rem;\n  }\n\n  .sm\\:-my-64 {\n    margin-top: -16rem;\n    margin-bottom: -16rem;\n  }\n\n  .sm\\:-mx-64 {\n    margin-left: -16rem;\n    margin-right: -16rem;\n  }\n\n  .sm\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n  }\n\n  .sm\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n  }\n\n  .sm\\:mt-0 {\n    margin-top: 0;\n  }\n\n  .sm\\:mr-0 {\n    margin-right: 0;\n  }\n\n  .sm\\:mb-0 {\n    margin-bottom: 0;\n  }\n\n  .sm\\:ml-0 {\n    margin-left: 0;\n  }\n\n  .sm\\:mt-1 {\n    margin-top: 0.25rem;\n  }\n\n  .sm\\:mr-1 {\n    margin-right: 0.25rem;\n  }\n\n  .sm\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n\n  .sm\\:ml-1 {\n    margin-left: 0.25rem;\n  }\n\n  .sm\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n\n  .sm\\:mr-2 {\n    margin-right: 0.5rem;\n  }\n\n  .sm\\:mb-2 {\n    margin-bottom: 0.5rem;\n  }\n\n  .sm\\:ml-2 {\n    margin-left: 0.5rem;\n  }\n\n  .sm\\:mt-3 {\n    margin-top: 0.75rem;\n  }\n\n  .sm\\:mr-3 {\n    margin-right: 0.75rem;\n  }\n\n  .sm\\:mb-3 {\n    margin-bottom: 0.75rem;\n  }\n\n  .sm\\:ml-3 {\n    margin-left: 0.75rem;\n  }\n\n  .sm\\:mt-4 {\n    margin-top: 1rem;\n  }\n\n  .sm\\:mr-4 {\n    margin-right: 1rem;\n  }\n\n  .sm\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n\n  .sm\\:ml-4 {\n    margin-left: 1rem;\n  }\n\n  .sm\\:mt-5 {\n    margin-top: 1.25rem;\n  }\n\n  .sm\\:mr-5 {\n    margin-right: 1.25rem;\n  }\n\n  .sm\\:mb-5 {\n    margin-bottom: 1.25rem;\n  }\n\n  .sm\\:ml-5 {\n    margin-left: 1.25rem;\n  }\n\n  .sm\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n\n  .sm\\:mr-6 {\n    margin-right: 1.5rem;\n  }\n\n  .sm\\:mb-6 {\n    margin-bottom: 1.5rem;\n  }\n\n  .sm\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n\n  .sm\\:mt-8 {\n    margin-top: 2rem;\n  }\n\n  .sm\\:mr-8 {\n    margin-right: 2rem;\n  }\n\n  .sm\\:mb-8 {\n    margin-bottom: 2rem;\n  }\n\n  .sm\\:ml-8 {\n    margin-left: 2rem;\n  }\n\n  .sm\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n\n  .sm\\:mr-10 {\n    margin-right: 2.5rem;\n  }\n\n  .sm\\:mb-10 {\n    margin-bottom: 2.5rem;\n  }\n\n  .sm\\:ml-10 {\n    margin-left: 2.5rem;\n  }\n\n  .sm\\:mt-12 {\n    margin-top: 3rem;\n  }\n\n  .sm\\:mr-12 {\n    margin-right: 3rem;\n  }\n\n  .sm\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n\n  .sm\\:ml-12 {\n    margin-left: 3rem;\n  }\n\n  .sm\\:mt-16 {\n    margin-top: 4rem;\n  }\n\n  .sm\\:mr-16 {\n    margin-right: 4rem;\n  }\n\n  .sm\\:mb-16 {\n    margin-bottom: 4rem;\n  }\n\n  .sm\\:ml-16 {\n    margin-left: 4rem;\n  }\n\n  .sm\\:mt-20 {\n    margin-top: 5rem;\n  }\n\n  .sm\\:mr-20 {\n    margin-right: 5rem;\n  }\n\n  .sm\\:mb-20 {\n    margin-bottom: 5rem;\n  }\n\n  .sm\\:ml-20 {\n    margin-left: 5rem;\n  }\n\n  .sm\\:mt-24 {\n    margin-top: 6rem;\n  }\n\n  .sm\\:mr-24 {\n    margin-right: 6rem;\n  }\n\n  .sm\\:mb-24 {\n    margin-bottom: 6rem;\n  }\n\n  .sm\\:ml-24 {\n    margin-left: 6rem;\n  }\n\n  .sm\\:mt-32 {\n    margin-top: 8rem;\n  }\n\n  .sm\\:mr-32 {\n    margin-right: 8rem;\n  }\n\n  .sm\\:mb-32 {\n    margin-bottom: 8rem;\n  }\n\n  .sm\\:ml-32 {\n    margin-left: 8rem;\n  }\n\n  .sm\\:mt-40 {\n    margin-top: 10rem;\n  }\n\n  .sm\\:mr-40 {\n    margin-right: 10rem;\n  }\n\n  .sm\\:mb-40 {\n    margin-bottom: 10rem;\n  }\n\n  .sm\\:ml-40 {\n    margin-left: 10rem;\n  }\n\n  .sm\\:mt-48 {\n    margin-top: 12rem;\n  }\n\n  .sm\\:mr-48 {\n    margin-right: 12rem;\n  }\n\n  .sm\\:mb-48 {\n    margin-bottom: 12rem;\n  }\n\n  .sm\\:ml-48 {\n    margin-left: 12rem;\n  }\n\n  .sm\\:mt-56 {\n    margin-top: 14rem;\n  }\n\n  .sm\\:mr-56 {\n    margin-right: 14rem;\n  }\n\n  .sm\\:mb-56 {\n    margin-bottom: 14rem;\n  }\n\n  .sm\\:ml-56 {\n    margin-left: 14rem;\n  }\n\n  .sm\\:mt-64 {\n    margin-top: 16rem;\n  }\n\n  .sm\\:mr-64 {\n    margin-right: 16rem;\n  }\n\n  .sm\\:mb-64 {\n    margin-bottom: 16rem;\n  }\n\n  .sm\\:ml-64 {\n    margin-left: 16rem;\n  }\n\n  .sm\\:mt-auto {\n    margin-top: auto;\n  }\n\n  .sm\\:mr-auto {\n    margin-right: auto;\n  }\n\n  .sm\\:mb-auto {\n    margin-bottom: auto;\n  }\n\n  .sm\\:ml-auto {\n    margin-left: auto;\n  }\n\n  .sm\\:mt-px {\n    margin-top: 1px;\n  }\n\n  .sm\\:mr-px {\n    margin-right: 1px;\n  }\n\n  .sm\\:mb-px {\n    margin-bottom: 1px;\n  }\n\n  .sm\\:ml-px {\n    margin-left: 1px;\n  }\n\n  .sm\\:-mt-1 {\n    margin-top: -0.25rem;\n  }\n\n  .sm\\:-mr-1 {\n    margin-right: -0.25rem;\n  }\n\n  .sm\\:-mb-1 {\n    margin-bottom: -0.25rem;\n  }\n\n  .sm\\:-ml-1 {\n    margin-left: -0.25rem;\n  }\n\n  .sm\\:-mt-2 {\n    margin-top: -0.5rem;\n  }\n\n  .sm\\:-mr-2 {\n    margin-right: -0.5rem;\n  }\n\n  .sm\\:-mb-2 {\n    margin-bottom: -0.5rem;\n  }\n\n  .sm\\:-ml-2 {\n    margin-left: -0.5rem;\n  }\n\n  .sm\\:-mt-3 {\n    margin-top: -0.75rem;\n  }\n\n  .sm\\:-mr-3 {\n    margin-right: -0.75rem;\n  }\n\n  .sm\\:-mb-3 {\n    margin-bottom: -0.75rem;\n  }\n\n  .sm\\:-ml-3 {\n    margin-left: -0.75rem;\n  }\n\n  .sm\\:-mt-4 {\n    margin-top: -1rem;\n  }\n\n  .sm\\:-mr-4 {\n    margin-right: -1rem;\n  }\n\n  .sm\\:-mb-4 {\n    margin-bottom: -1rem;\n  }\n\n  .sm\\:-ml-4 {\n    margin-left: -1rem;\n  }\n\n  .sm\\:-mt-5 {\n    margin-top: -1.25rem;\n  }\n\n  .sm\\:-mr-5 {\n    margin-right: -1.25rem;\n  }\n\n  .sm\\:-mb-5 {\n    margin-bottom: -1.25rem;\n  }\n\n  .sm\\:-ml-5 {\n    margin-left: -1.25rem;\n  }\n\n  .sm\\:-mt-6 {\n    margin-top: -1.5rem;\n  }\n\n  .sm\\:-mr-6 {\n    margin-right: -1.5rem;\n  }\n\n  .sm\\:-mb-6 {\n    margin-bottom: -1.5rem;\n  }\n\n  .sm\\:-ml-6 {\n    margin-left: -1.5rem;\n  }\n\n  .sm\\:-mt-8 {\n    margin-top: -2rem;\n  }\n\n  .sm\\:-mr-8 {\n    margin-right: -2rem;\n  }\n\n  .sm\\:-mb-8 {\n    margin-bottom: -2rem;\n  }\n\n  .sm\\:-ml-8 {\n    margin-left: -2rem;\n  }\n\n  .sm\\:-mt-10 {\n    margin-top: -2.5rem;\n  }\n\n  .sm\\:-mr-10 {\n    margin-right: -2.5rem;\n  }\n\n  .sm\\:-mb-10 {\n    margin-bottom: -2.5rem;\n  }\n\n  .sm\\:-ml-10 {\n    margin-left: -2.5rem;\n  }\n\n  .sm\\:-mt-12 {\n    margin-top: -3rem;\n  }\n\n  .sm\\:-mr-12 {\n    margin-right: -3rem;\n  }\n\n  .sm\\:-mb-12 {\n    margin-bottom: -3rem;\n  }\n\n  .sm\\:-ml-12 {\n    margin-left: -3rem;\n  }\n\n  .sm\\:-mt-16 {\n    margin-top: -4rem;\n  }\n\n  .sm\\:-mr-16 {\n    margin-right: -4rem;\n  }\n\n  .sm\\:-mb-16 {\n    margin-bottom: -4rem;\n  }\n\n  .sm\\:-ml-16 {\n    margin-left: -4rem;\n  }\n\n  .sm\\:-mt-20 {\n    margin-top: -5rem;\n  }\n\n  .sm\\:-mr-20 {\n    margin-right: -5rem;\n  }\n\n  .sm\\:-mb-20 {\n    margin-bottom: -5rem;\n  }\n\n  .sm\\:-ml-20 {\n    margin-left: -5rem;\n  }\n\n  .sm\\:-mt-24 {\n    margin-top: -6rem;\n  }\n\n  .sm\\:-mr-24 {\n    margin-right: -6rem;\n  }\n\n  .sm\\:-mb-24 {\n    margin-bottom: -6rem;\n  }\n\n  .sm\\:-ml-24 {\n    margin-left: -6rem;\n  }\n\n  .sm\\:-mt-32 {\n    margin-top: -8rem;\n  }\n\n  .sm\\:-mr-32 {\n    margin-right: -8rem;\n  }\n\n  .sm\\:-mb-32 {\n    margin-bottom: -8rem;\n  }\n\n  .sm\\:-ml-32 {\n    margin-left: -8rem;\n  }\n\n  .sm\\:-mt-40 {\n    margin-top: -10rem;\n  }\n\n  .sm\\:-mr-40 {\n    margin-right: -10rem;\n  }\n\n  .sm\\:-mb-40 {\n    margin-bottom: -10rem;\n  }\n\n  .sm\\:-ml-40 {\n    margin-left: -10rem;\n  }\n\n  .sm\\:-mt-48 {\n    margin-top: -12rem;\n  }\n\n  .sm\\:-mr-48 {\n    margin-right: -12rem;\n  }\n\n  .sm\\:-mb-48 {\n    margin-bottom: -12rem;\n  }\n\n  .sm\\:-ml-48 {\n    margin-left: -12rem;\n  }\n\n  .sm\\:-mt-56 {\n    margin-top: -14rem;\n  }\n\n  .sm\\:-mr-56 {\n    margin-right: -14rem;\n  }\n\n  .sm\\:-mb-56 {\n    margin-bottom: -14rem;\n  }\n\n  .sm\\:-ml-56 {\n    margin-left: -14rem;\n  }\n\n  .sm\\:-mt-64 {\n    margin-top: -16rem;\n  }\n\n  .sm\\:-mr-64 {\n    margin-right: -16rem;\n  }\n\n  .sm\\:-mb-64 {\n    margin-bottom: -16rem;\n  }\n\n  .sm\\:-ml-64 {\n    margin-left: -16rem;\n  }\n\n  .sm\\:-mt-px {\n    margin-top: -1px;\n  }\n\n  .sm\\:-mr-px {\n    margin-right: -1px;\n  }\n\n  .sm\\:-mb-px {\n    margin-bottom: -1px;\n  }\n\n  .sm\\:-ml-px {\n    margin-left: -1px;\n  }\n\n  .sm\\:max-h-full {\n    max-height: 100%;\n  }\n\n  .sm\\:max-h-screen {\n    max-height: 100vh;\n  }\n\n  .sm\\:max-w-none {\n    max-width: none;\n  }\n\n  .sm\\:max-w-xs {\n    max-width: 20rem;\n  }\n\n  .sm\\:max-w-sm {\n    max-width: 24rem;\n  }\n\n  .sm\\:max-w-md {\n    max-width: 28rem;\n  }\n\n  .sm\\:max-w-lg {\n    max-width: 32rem;\n  }\n\n  .sm\\:max-w-xl {\n    max-width: 36rem;\n  }\n\n  .sm\\:max-w-2xl {\n    max-width: 42rem;\n  }\n\n  .sm\\:max-w-3xl {\n    max-width: 48rem;\n  }\n\n  .sm\\:max-w-4xl {\n    max-width: 56rem;\n  }\n\n  .sm\\:max-w-5xl {\n    max-width: 64rem;\n  }\n\n  .sm\\:max-w-6xl {\n    max-width: 72rem;\n  }\n\n  .sm\\:max-w-full {\n    max-width: 100%;\n  }\n\n  .sm\\:max-w-screen-sm {\n    max-width: 640px;\n  }\n\n  .sm\\:max-w-screen-md {\n    max-width: 768px;\n  }\n\n  .sm\\:max-w-screen-lg {\n    max-width: 1024px;\n  }\n\n  .sm\\:max-w-screen-xl {\n    max-width: 1280px;\n  }\n\n  .sm\\:min-h-0 {\n    min-height: 0;\n  }\n\n  .sm\\:min-h-full {\n    min-height: 100%;\n  }\n\n  .sm\\:min-h-screen {\n    min-height: 100vh;\n  }\n\n  .sm\\:min-w-0 {\n    min-width: 0;\n  }\n\n  .sm\\:min-w-full {\n    min-width: 100%;\n  }\n\n  .sm\\:object-contain {\n    object-fit: contain;\n  }\n\n  .sm\\:object-cover {\n    object-fit: cover;\n  }\n\n  .sm\\:object-fill {\n    object-fit: fill;\n  }\n\n  .sm\\:object-none {\n    object-fit: none;\n  }\n\n  .sm\\:object-scale-down {\n    object-fit: scale-down;\n  }\n\n  .sm\\:object-bottom {\n    object-position: bottom;\n  }\n\n  .sm\\:object-center {\n    object-position: center;\n  }\n\n  .sm\\:object-left {\n    object-position: left;\n  }\n\n  .sm\\:object-left-bottom {\n    object-position: left bottom;\n  }\n\n  .sm\\:object-left-top {\n    object-position: left top;\n  }\n\n  .sm\\:object-right {\n    object-position: right;\n  }\n\n  .sm\\:object-right-bottom {\n    object-position: right bottom;\n  }\n\n  .sm\\:object-right-top {\n    object-position: right top;\n  }\n\n  .sm\\:object-top {\n    object-position: top;\n  }\n\n  .sm\\:opacity-0 {\n    opacity: 0;\n  }\n\n  .sm\\:opacity-25 {\n    opacity: 0.25;\n  }\n\n  .sm\\:opacity-50 {\n    opacity: 0.5;\n  }\n\n  .sm\\:opacity-75 {\n    opacity: 0.75;\n  }\n\n  .sm\\:opacity-100 {\n    opacity: 1;\n  }\n\n  .sm\\:hover\\:opacity-0:hover {\n    opacity: 0;\n  }\n\n  .sm\\:hover\\:opacity-25:hover {\n    opacity: 0.25;\n  }\n\n  .sm\\:hover\\:opacity-50:hover {\n    opacity: 0.5;\n  }\n\n  .sm\\:hover\\:opacity-75:hover {\n    opacity: 0.75;\n  }\n\n  .sm\\:hover\\:opacity-100:hover {\n    opacity: 1;\n  }\n\n  .sm\\:focus\\:opacity-0:focus {\n    opacity: 0;\n  }\n\n  .sm\\:focus\\:opacity-25:focus {\n    opacity: 0.25;\n  }\n\n  .sm\\:focus\\:opacity-50:focus {\n    opacity: 0.5;\n  }\n\n  .sm\\:focus\\:opacity-75:focus {\n    opacity: 0.75;\n  }\n\n  .sm\\:focus\\:opacity-100:focus {\n    opacity: 1;\n  }\n\n  .sm\\:outline-none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  .sm\\:outline-white {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n\n  .sm\\:outline-black {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n\n  .sm\\:focus\\:outline-none:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  .sm\\:focus\\:outline-white:focus {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n\n  .sm\\:focus\\:outline-black:focus {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n\n  .sm\\:overflow-auto {\n    overflow: auto;\n  }\n\n  .sm\\:overflow-hidden {\n    overflow: hidden;\n  }\n\n  .sm\\:overflow-visible {\n    overflow: visible;\n  }\n\n  .sm\\:overflow-scroll {\n    overflow: scroll;\n  }\n\n  .sm\\:overflow-x-auto {\n    overflow-x: auto;\n  }\n\n  .sm\\:overflow-y-auto {\n    overflow-y: auto;\n  }\n\n  .sm\\:overflow-x-hidden {\n    overflow-x: hidden;\n  }\n\n  .sm\\:overflow-y-hidden {\n    overflow-y: hidden;\n  }\n\n  .sm\\:overflow-x-visible {\n    overflow-x: visible;\n  }\n\n  .sm\\:overflow-y-visible {\n    overflow-y: visible;\n  }\n\n  .sm\\:overflow-x-scroll {\n    overflow-x: scroll;\n  }\n\n  .sm\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n\n  .sm\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .sm\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n  }\n\n  .sm\\:overscroll-auto {\n    overscroll-behavior: auto;\n  }\n\n  .sm\\:overscroll-contain {\n    overscroll-behavior: contain;\n  }\n\n  .sm\\:overscroll-none {\n    overscroll-behavior: none;\n  }\n\n  .sm\\:overscroll-y-auto {\n    overscroll-behavior-y: auto;\n  }\n\n  .sm\\:overscroll-y-contain {\n    overscroll-behavior-y: contain;\n  }\n\n  .sm\\:overscroll-y-none {\n    overscroll-behavior-y: none;\n  }\n\n  .sm\\:overscroll-x-auto {\n    overscroll-behavior-x: auto;\n  }\n\n  .sm\\:overscroll-x-contain {\n    overscroll-behavior-x: contain;\n  }\n\n  .sm\\:overscroll-x-none {\n    overscroll-behavior-x: none;\n  }\n\n  .sm\\:p-0 {\n    padding: 0;\n  }\n\n  .sm\\:p-1 {\n    padding: 0.25rem;\n  }\n\n  .sm\\:p-2 {\n    padding: 0.5rem;\n  }\n\n  .sm\\:p-3 {\n    padding: 0.75rem;\n  }\n\n  .sm\\:p-4 {\n    padding: 1rem;\n  }\n\n  .sm\\:p-5 {\n    padding: 1.25rem;\n  }\n\n  .sm\\:p-6 {\n    padding: 1.5rem;\n  }\n\n  .sm\\:p-8 {\n    padding: 2rem;\n  }\n\n  .sm\\:p-10 {\n    padding: 2.5rem;\n  }\n\n  .sm\\:p-12 {\n    padding: 3rem;\n  }\n\n  .sm\\:p-16 {\n    padding: 4rem;\n  }\n\n  .sm\\:p-20 {\n    padding: 5rem;\n  }\n\n  .sm\\:p-24 {\n    padding: 6rem;\n  }\n\n  .sm\\:p-32 {\n    padding: 8rem;\n  }\n\n  .sm\\:p-40 {\n    padding: 10rem;\n  }\n\n  .sm\\:p-48 {\n    padding: 12rem;\n  }\n\n  .sm\\:p-56 {\n    padding: 14rem;\n  }\n\n  .sm\\:p-64 {\n    padding: 16rem;\n  }\n\n  .sm\\:p-px {\n    padding: 1px;\n  }\n\n  .sm\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .sm\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .sm\\:py-1 {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .sm\\:px-1 {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n\n  .sm\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .sm\\:px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n\n  .sm\\:py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .sm\\:px-3 {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n\n  .sm\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .sm\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .sm\\:py-5 {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .sm\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n\n  .sm\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .sm\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .sm\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .sm\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .sm\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .sm\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  .sm\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n\n  .sm\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n\n  .sm\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n\n  .sm\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n\n  .sm\\:py-20 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n\n  .sm\\:px-20 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n\n  .sm\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n\n  .sm\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n\n  .sm\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n\n  .sm\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n\n  .sm\\:py-40 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n\n  .sm\\:px-40 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n\n  .sm\\:py-48 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n\n  .sm\\:px-48 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n\n  .sm\\:py-56 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n\n  .sm\\:px-56 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n\n  .sm\\:py-64 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n\n  .sm\\:px-64 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n\n  .sm\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n\n  .sm\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n\n  .sm\\:pt-0 {\n    padding-top: 0;\n  }\n\n  .sm\\:pr-0 {\n    padding-right: 0;\n  }\n\n  .sm\\:pb-0 {\n    padding-bottom: 0;\n  }\n\n  .sm\\:pl-0 {\n    padding-left: 0;\n  }\n\n  .sm\\:pt-1 {\n    padding-top: 0.25rem;\n  }\n\n  .sm\\:pr-1 {\n    padding-right: 0.25rem;\n  }\n\n  .sm\\:pb-1 {\n    padding-bottom: 0.25rem;\n  }\n\n  .sm\\:pl-1 {\n    padding-left: 0.25rem;\n  }\n\n  .sm\\:pt-2 {\n    padding-top: 0.5rem;\n  }\n\n  .sm\\:pr-2 {\n    padding-right: 0.5rem;\n  }\n\n  .sm\\:pb-2 {\n    padding-bottom: 0.5rem;\n  }\n\n  .sm\\:pl-2 {\n    padding-left: 0.5rem;\n  }\n\n  .sm\\:pt-3 {\n    padding-top: 0.75rem;\n  }\n\n  .sm\\:pr-3 {\n    padding-right: 0.75rem;\n  }\n\n  .sm\\:pb-3 {\n    padding-bottom: 0.75rem;\n  }\n\n  .sm\\:pl-3 {\n    padding-left: 0.75rem;\n  }\n\n  .sm\\:pt-4 {\n    padding-top: 1rem;\n  }\n\n  .sm\\:pr-4 {\n    padding-right: 1rem;\n  }\n\n  .sm\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n\n  .sm\\:pl-4 {\n    padding-left: 1rem;\n  }\n\n  .sm\\:pt-5 {\n    padding-top: 1.25rem;\n  }\n\n  .sm\\:pr-5 {\n    padding-right: 1.25rem;\n  }\n\n  .sm\\:pb-5 {\n    padding-bottom: 1.25rem;\n  }\n\n  .sm\\:pl-5 {\n    padding-left: 1.25rem;\n  }\n\n  .sm\\:pt-6 {\n    padding-top: 1.5rem;\n  }\n\n  .sm\\:pr-6 {\n    padding-right: 1.5rem;\n  }\n\n  .sm\\:pb-6 {\n    padding-bottom: 1.5rem;\n  }\n\n  .sm\\:pl-6 {\n    padding-left: 1.5rem;\n  }\n\n  .sm\\:pt-8 {\n    padding-top: 2rem;\n  }\n\n  .sm\\:pr-8 {\n    padding-right: 2rem;\n  }\n\n  .sm\\:pb-8 {\n    padding-bottom: 2rem;\n  }\n\n  .sm\\:pl-8 {\n    padding-left: 2rem;\n  }\n\n  .sm\\:pt-10 {\n    padding-top: 2.5rem;\n  }\n\n  .sm\\:pr-10 {\n    padding-right: 2.5rem;\n  }\n\n  .sm\\:pb-10 {\n    padding-bottom: 2.5rem;\n  }\n\n  .sm\\:pl-10 {\n    padding-left: 2.5rem;\n  }\n\n  .sm\\:pt-12 {\n    padding-top: 3rem;\n  }\n\n  .sm\\:pr-12 {\n    padding-right: 3rem;\n  }\n\n  .sm\\:pb-12 {\n    padding-bottom: 3rem;\n  }\n\n  .sm\\:pl-12 {\n    padding-left: 3rem;\n  }\n\n  .sm\\:pt-16 {\n    padding-top: 4rem;\n  }\n\n  .sm\\:pr-16 {\n    padding-right: 4rem;\n  }\n\n  .sm\\:pb-16 {\n    padding-bottom: 4rem;\n  }\n\n  .sm\\:pl-16 {\n    padding-left: 4rem;\n  }\n\n  .sm\\:pt-20 {\n    padding-top: 5rem;\n  }\n\n  .sm\\:pr-20 {\n    padding-right: 5rem;\n  }\n\n  .sm\\:pb-20 {\n    padding-bottom: 5rem;\n  }\n\n  .sm\\:pl-20 {\n    padding-left: 5rem;\n  }\n\n  .sm\\:pt-24 {\n    padding-top: 6rem;\n  }\n\n  .sm\\:pr-24 {\n    padding-right: 6rem;\n  }\n\n  .sm\\:pb-24 {\n    padding-bottom: 6rem;\n  }\n\n  .sm\\:pl-24 {\n    padding-left: 6rem;\n  }\n\n  .sm\\:pt-32 {\n    padding-top: 8rem;\n  }\n\n  .sm\\:pr-32 {\n    padding-right: 8rem;\n  }\n\n  .sm\\:pb-32 {\n    padding-bottom: 8rem;\n  }\n\n  .sm\\:pl-32 {\n    padding-left: 8rem;\n  }\n\n  .sm\\:pt-40 {\n    padding-top: 10rem;\n  }\n\n  .sm\\:pr-40 {\n    padding-right: 10rem;\n  }\n\n  .sm\\:pb-40 {\n    padding-bottom: 10rem;\n  }\n\n  .sm\\:pl-40 {\n    padding-left: 10rem;\n  }\n\n  .sm\\:pt-48 {\n    padding-top: 12rem;\n  }\n\n  .sm\\:pr-48 {\n    padding-right: 12rem;\n  }\n\n  .sm\\:pb-48 {\n    padding-bottom: 12rem;\n  }\n\n  .sm\\:pl-48 {\n    padding-left: 12rem;\n  }\n\n  .sm\\:pt-56 {\n    padding-top: 14rem;\n  }\n\n  .sm\\:pr-56 {\n    padding-right: 14rem;\n  }\n\n  .sm\\:pb-56 {\n    padding-bottom: 14rem;\n  }\n\n  .sm\\:pl-56 {\n    padding-left: 14rem;\n  }\n\n  .sm\\:pt-64 {\n    padding-top: 16rem;\n  }\n\n  .sm\\:pr-64 {\n    padding-right: 16rem;\n  }\n\n  .sm\\:pb-64 {\n    padding-bottom: 16rem;\n  }\n\n  .sm\\:pl-64 {\n    padding-left: 16rem;\n  }\n\n  .sm\\:pt-px {\n    padding-top: 1px;\n  }\n\n  .sm\\:pr-px {\n    padding-right: 1px;\n  }\n\n  .sm\\:pb-px {\n    padding-bottom: 1px;\n  }\n\n  .sm\\:pl-px {\n    padding-left: 1px;\n  }\n\n  .sm\\:placeholder-transparent::placeholder {\n    color: transparent;\n  }\n\n  .sm\\:placeholder-current::placeholder {\n    color: currentColor;\n  }\n\n  .sm\\:placeholder-black::placeholder {\n    --placeholder-opacity: 1;\n    color: #000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-white::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f7fafc;\n    color: rgba(247, 250, 252, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #edf2f7;\n    color: rgba(237, 242, 247, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #cbd5e0;\n    color: rgba(203, 213, 224, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160, 174, 192, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #718096;\n    color: rgba(113, 128, 150, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a5568;\n    color: rgba(74, 85, 104, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #2d3748;\n    color: rgba(45, 55, 72, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202c;\n    color: rgba(26, 32, 44, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f5;\n    color: rgba(255, 245, 245, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7d7;\n    color: rgba(254, 215, 215, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #feb2b2;\n    color: rgba(254, 178, 178, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #fc8181;\n    color: rgba(252, 129, 129, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #f56565;\n    color: rgba(245, 101, 101, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #e53e3e;\n    color: rgba(229, 62, 62, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c53030;\n    color: rgba(197, 48, 48, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b2c2c;\n    color: rgba(155, 44, 44, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-red-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #742a2a;\n    color: rgba(116, 42, 42, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffaf0;\n    color: rgba(255, 250, 240, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #feebc8;\n    color: rgba(254, 235, 200, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd38d;\n    color: rgba(251, 211, 141, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6ad55;\n    color: rgba(246, 173, 85, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed8936;\n    color: rgba(237, 137, 54, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #dd6b20;\n    color: rgba(221, 107, 32, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c05621;\n    color: rgba(192, 86, 33, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9c4221;\n    color: rgba(156, 66, 33, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-orange-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #7b341e;\n    color: rgba(123, 52, 30, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffff0;\n    color: rgba(255, 255, 240, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fefcbf;\n    color: rgba(254, 252, 191, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf089;\n    color: rgba(250, 240, 137, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6e05e;\n    color: rgba(246, 224, 94, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ecc94b;\n    color: rgba(236, 201, 75, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d69e2e;\n    color: rgba(214, 158, 46, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b7791f;\n    color: rgba(183, 121, 31, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #975a16;\n    color: rgba(151, 90, 22, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-yellow-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #744210;\n    color: rgba(116, 66, 16, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0fff4;\n    color: rgba(240, 255, 244, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c6f6d5;\n    color: rgba(198, 246, 213, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #9ae6b4;\n    color: rgba(154, 230, 180, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #68d391;\n    color: rgba(104, 211, 145, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #48bb78;\n    color: rgba(72, 187, 120, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #38a169;\n    color: rgba(56, 161, 105, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2f855a;\n    color: rgba(47, 133, 90, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #276749;\n    color: rgba(39, 103, 73, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-green-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #22543d;\n    color: rgba(34, 84, 61, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e6fffa;\n    color: rgba(230, 255, 250, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #b2f5ea;\n    color: rgba(178, 245, 234, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #81e6d9;\n    color: rgba(129, 230, 217, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #4fd1c5;\n    color: rgba(79, 209, 197, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #38b2ac;\n    color: rgba(56, 178, 172, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #319795;\n    color: rgba(49, 151, 149, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c7a7b;\n    color: rgba(44, 122, 123, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #285e61;\n    color: rgba(40, 94, 97, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-teal-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #234e52;\n    color: rgba(35, 78, 82, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf8ff;\n    color: rgba(235, 248, 255, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #bee3f8;\n    color: rgba(190, 227, 248, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #90cdf4;\n    color: rgba(144, 205, 244, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #63b3ed;\n    color: rgba(99, 179, 237, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #4299e1;\n    color: rgba(66, 153, 225, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #3182ce;\n    color: rgba(49, 130, 206, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2b6cb0;\n    color: rgba(43, 108, 176, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c5282;\n    color: rgba(44, 82, 130, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-blue-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #2a4365;\n    color: rgba(42, 67, 101, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf4ff;\n    color: rgba(235, 244, 255, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3dafe;\n    color: rgba(195, 218, 254, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #a3bffa;\n    color: rgba(163, 191, 250, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #7f9cf5;\n    color: rgba(127, 156, 245, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #667eea;\n    color: rgba(102, 126, 234, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #5a67d8;\n    color: rgba(90, 103, 216, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #4c51bf;\n    color: rgba(76, 81, 191, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #434190;\n    color: rgba(67, 65, 144, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-indigo-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #3c366b;\n    color: rgba(60, 54, 107, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf5ff;\n    color: rgba(250, 245, 255, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e9d8fd;\n    color: rgba(233, 216, 253, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #d6bcfa;\n    color: rgba(214, 188, 250, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #b794f4;\n    color: rgba(183, 148, 244, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f7aea;\n    color: rgba(159, 122, 234, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #805ad5;\n    color: rgba(128, 90, 213, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b46c1;\n    color: rgba(107, 70, 193, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #553c9a;\n    color: rgba(85, 60, 154, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-purple-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #44337a;\n    color: rgba(68, 51, 122, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f7;\n    color: rgba(255, 245, 247, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7e2;\n    color: rgba(254, 215, 226, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbb6ce;\n    color: rgba(251, 182, 206, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f687b3;\n    color: rgba(246, 135, 179, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed64a6;\n    color: rgba(237, 100, 166, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d53f8c;\n    color: rgba(213, 63, 140, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b83280;\n    color: rgba(184, 50, 128, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #97266d;\n    color: rgba(151, 38, 109, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-pink-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #702459;\n    color: rgba(112, 36, 89, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-transparent:focus::placeholder {\n    color: transparent;\n  }\n\n  .sm\\:focus\\:placeholder-current:focus::placeholder {\n    color: currentColor;\n  }\n\n  .sm\\:focus\\:placeholder-black:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-white:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f7fafc;\n    color: rgba(247, 250, 252, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edf2f7;\n    color: rgba(237, 242, 247, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cbd5e0;\n    color: rgba(203, 213, 224, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160, 174, 192, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #718096;\n    color: rgba(113, 128, 150, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a5568;\n    color: rgba(74, 85, 104, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2d3748;\n    color: rgba(45, 55, 72, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202c;\n    color: rgba(26, 32, 44, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f5;\n    color: rgba(255, 245, 245, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7d7;\n    color: rgba(254, 215, 215, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feb2b2;\n    color: rgba(254, 178, 178, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fc8181;\n    color: rgba(252, 129, 129, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f56565;\n    color: rgba(245, 101, 101, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e53e3e;\n    color: rgba(229, 62, 62, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c53030;\n    color: rgba(197, 48, 48, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b2c2c;\n    color: rgba(155, 44, 44, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-red-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #742a2a;\n    color: rgba(116, 42, 42, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffaf0;\n    color: rgba(255, 250, 240, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feebc8;\n    color: rgba(254, 235, 200, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd38d;\n    color: rgba(251, 211, 141, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6ad55;\n    color: rgba(246, 173, 85, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed8936;\n    color: rgba(237, 137, 54, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #dd6b20;\n    color: rgba(221, 107, 32, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c05621;\n    color: rgba(192, 86, 33, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9c4221;\n    color: rgba(156, 66, 33, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-orange-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7b341e;\n    color: rgba(123, 52, 30, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffff0;\n    color: rgba(255, 255, 240, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fefcbf;\n    color: rgba(254, 252, 191, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf089;\n    color: rgba(250, 240, 137, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6e05e;\n    color: rgba(246, 224, 94, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ecc94b;\n    color: rgba(236, 201, 75, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d69e2e;\n    color: rgba(214, 158, 46, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b7791f;\n    color: rgba(183, 121, 31, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #975a16;\n    color: rgba(151, 90, 22, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-yellow-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #744210;\n    color: rgba(116, 66, 16, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0fff4;\n    color: rgba(240, 255, 244, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c6f6d5;\n    color: rgba(198, 246, 213, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9ae6b4;\n    color: rgba(154, 230, 180, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #68d391;\n    color: rgba(104, 211, 145, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #48bb78;\n    color: rgba(72, 187, 120, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #38a169;\n    color: rgba(56, 161, 105, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2f855a;\n    color: rgba(47, 133, 90, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #276749;\n    color: rgba(39, 103, 73, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-green-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #22543d;\n    color: rgba(34, 84, 61, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e6fffa;\n    color: rgba(230, 255, 250, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b2f5ea;\n    color: rgba(178, 245, 234, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #81e6d9;\n    color: rgba(129, 230, 217, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4fd1c5;\n    color: rgba(79, 209, 197, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #38b2ac;\n    color: rgba(56, 178, 172, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #319795;\n    color: rgba(49, 151, 149, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c7a7b;\n    color: rgba(44, 122, 123, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #285e61;\n    color: rgba(40, 94, 97, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-teal-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #234e52;\n    color: rgba(35, 78, 82, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf8ff;\n    color: rgba(235, 248, 255, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bee3f8;\n    color: rgba(190, 227, 248, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #90cdf4;\n    color: rgba(144, 205, 244, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #63b3ed;\n    color: rgba(99, 179, 237, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4299e1;\n    color: rgba(66, 153, 225, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3182ce;\n    color: rgba(49, 130, 206, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2b6cb0;\n    color: rgba(43, 108, 176, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c5282;\n    color: rgba(44, 82, 130, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-blue-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2a4365;\n    color: rgba(42, 67, 101, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf4ff;\n    color: rgba(235, 244, 255, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3dafe;\n    color: rgba(195, 218, 254, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a3bffa;\n    color: rgba(163, 191, 250, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7f9cf5;\n    color: rgba(127, 156, 245, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #667eea;\n    color: rgba(102, 126, 234, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5a67d8;\n    color: rgba(90, 103, 216, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4c51bf;\n    color: rgba(76, 81, 191, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #434190;\n    color: rgba(67, 65, 144, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-indigo-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3c366b;\n    color: rgba(60, 54, 107, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf5ff;\n    color: rgba(250, 245, 255, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e9d8fd;\n    color: rgba(233, 216, 253, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d6bcfa;\n    color: rgba(214, 188, 250, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b794f4;\n    color: rgba(183, 148, 244, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f7aea;\n    color: rgba(159, 122, 234, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #805ad5;\n    color: rgba(128, 90, 213, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b46c1;\n    color: rgba(107, 70, 193, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #553c9a;\n    color: rgba(85, 60, 154, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-purple-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #44337a;\n    color: rgba(68, 51, 122, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f7;\n    color: rgba(255, 245, 247, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7e2;\n    color: rgba(254, 215, 226, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbb6ce;\n    color: rgba(251, 182, 206, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f687b3;\n    color: rgba(246, 135, 179, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed64a6;\n    color: rgba(237, 100, 166, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d53f8c;\n    color: rgba(213, 63, 140, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b83280;\n    color: rgba(184, 50, 128, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #97266d;\n    color: rgba(151, 38, 109, var(--placeholder-opacity));\n  }\n\n  .sm\\:focus\\:placeholder-pink-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #702459;\n    color: rgba(112, 36, 89, var(--placeholder-opacity));\n  }\n\n  .sm\\:placeholder-opacity-0::placeholder {\n    --placeholder-opacity: 0;\n  }\n\n  .sm\\:placeholder-opacity-25::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n\n  .sm\\:placeholder-opacity-50::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n\n  .sm\\:placeholder-opacity-75::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n\n  .sm\\:placeholder-opacity-100::placeholder {\n    --placeholder-opacity: 1;\n  }\n\n  .sm\\:focus\\:placeholder-opacity-0:focus::placeholder {\n    --placeholder-opacity: 0;\n  }\n\n  .sm\\:focus\\:placeholder-opacity-25:focus::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n\n  .sm\\:focus\\:placeholder-opacity-50:focus::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n\n  .sm\\:focus\\:placeholder-opacity-75:focus::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n\n  .sm\\:focus\\:placeholder-opacity-100:focus::placeholder {\n    --placeholder-opacity: 1;\n  }\n\n  .sm\\:pointer-events-none {\n    pointer-events: none;\n  }\n\n  .sm\\:pointer-events-auto {\n    pointer-events: auto;\n  }\n\n  .sm\\:static {\n    position: static;\n  }\n\n  .sm\\:fixed {\n    position: fixed;\n  }\n\n  .sm\\:absolute {\n    position: absolute;\n  }\n\n  .sm\\:relative {\n    position: relative;\n  }\n\n  .sm\\:sticky {\n    position: sticky;\n  }\n\n  .sm\\:inset-0 {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  .sm\\:inset-auto {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n  }\n\n  .sm\\:inset-y-0 {\n    top: 0;\n    bottom: 0;\n  }\n\n  .sm\\:inset-x-0 {\n    right: 0;\n    left: 0;\n  }\n\n  .sm\\:inset-y-auto {\n    top: auto;\n    bottom: auto;\n  }\n\n  .sm\\:inset-x-auto {\n    right: auto;\n    left: auto;\n  }\n\n  .sm\\:top-0 {\n    top: 0;\n  }\n\n  .sm\\:right-0 {\n    right: 0;\n  }\n\n  .sm\\:bottom-0 {\n    bottom: 0;\n  }\n\n  .sm\\:left-0 {\n    left: 0;\n  }\n\n  .sm\\:top-auto {\n    top: auto;\n  }\n\n  .sm\\:right-auto {\n    right: auto;\n  }\n\n  .sm\\:bottom-auto {\n    bottom: auto;\n  }\n\n  .sm\\:left-auto {\n    left: auto;\n  }\n\n  .sm\\:resize-none {\n    resize: none;\n  }\n\n  .sm\\:resize-y {\n    resize: vertical;\n  }\n\n  .sm\\:resize-x {\n    resize: horizontal;\n  }\n\n  .sm\\:resize {\n    resize: both;\n  }\n\n  .sm\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .sm\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .sm\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .sm\\:shadow-none {\n    box-shadow: none;\n  }\n\n  .sm\\:hover\\:shadow-xs:hover {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:hover\\:shadow-sm:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:hover\\:shadow:hover {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:hover\\:shadow-md:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:hover\\:shadow-lg:hover {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:hover\\:shadow-xl:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .sm\\:hover\\:shadow-2xl:hover {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .sm\\:hover\\:shadow-inner:hover {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:hover\\:shadow-outline:hover {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .sm\\:hover\\:shadow-none:hover {\n    box-shadow: none;\n  }\n\n  .sm\\:focus\\:shadow-xs:focus {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:focus\\:shadow-sm:focus {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:focus\\:shadow:focus {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:focus\\:shadow-md:focus {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:focus\\:shadow-lg:focus {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .sm\\:focus\\:shadow-xl:focus {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .sm\\:focus\\:shadow-2xl:focus {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .sm\\:focus\\:shadow-inner:focus {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .sm\\:focus\\:shadow-outline:focus {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .sm\\:focus\\:shadow-none:focus {\n    box-shadow: none;\n  }\n\n  .sm\\:fill-current {\n    fill: currentColor;\n  }\n\n  .sm\\:stroke-current {\n    stroke: currentColor;\n  }\n\n  .sm\\:stroke-0 {\n    stroke-width: 0;\n  }\n\n  .sm\\:stroke-1 {\n    stroke-width: 1;\n  }\n\n  .sm\\:stroke-2 {\n    stroke-width: 2;\n  }\n\n  .sm\\:table-auto {\n    table-layout: auto;\n  }\n\n  .sm\\:table-fixed {\n    table-layout: fixed;\n  }\n\n  .sm\\:text-left {\n    text-align: left;\n  }\n\n  .sm\\:text-center {\n    text-align: center;\n  }\n\n  .sm\\:text-right {\n    text-align: right;\n  }\n\n  .sm\\:text-justify {\n    text-align: justify;\n  }\n\n  .sm\\:text-blue {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .sm\\:text-primaryText {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .sm\\:text-red {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .sm\\:hover\\:text-blue:hover {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .sm\\:hover\\:text-primaryText:hover {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .sm\\:hover\\:text-red:hover {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .sm\\:focus\\:text-blue:focus {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .sm\\:focus\\:text-primaryText:focus {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .sm\\:focus\\:text-red:focus {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .sm\\:text-opacity-0 {\n    --text-opacity: 0;\n  }\n\n  .sm\\:text-opacity-25 {\n    --text-opacity: 0.25;\n  }\n\n  .sm\\:text-opacity-50 {\n    --text-opacity: 0.5;\n  }\n\n  .sm\\:text-opacity-75 {\n    --text-opacity: 0.75;\n  }\n\n  .sm\\:text-opacity-100 {\n    --text-opacity: 1;\n  }\n\n  .sm\\:hover\\:text-opacity-0:hover {\n    --text-opacity: 0;\n  }\n\n  .sm\\:hover\\:text-opacity-25:hover {\n    --text-opacity: 0.25;\n  }\n\n  .sm\\:hover\\:text-opacity-50:hover {\n    --text-opacity: 0.5;\n  }\n\n  .sm\\:hover\\:text-opacity-75:hover {\n    --text-opacity: 0.75;\n  }\n\n  .sm\\:hover\\:text-opacity-100:hover {\n    --text-opacity: 1;\n  }\n\n  .sm\\:focus\\:text-opacity-0:focus {\n    --text-opacity: 0;\n  }\n\n  .sm\\:focus\\:text-opacity-25:focus {\n    --text-opacity: 0.25;\n  }\n\n  .sm\\:focus\\:text-opacity-50:focus {\n    --text-opacity: 0.5;\n  }\n\n  .sm\\:focus\\:text-opacity-75:focus {\n    --text-opacity: 0.75;\n  }\n\n  .sm\\:focus\\:text-opacity-100:focus {\n    --text-opacity: 1;\n  }\n\n  .sm\\:italic {\n    font-style: italic;\n  }\n\n  .sm\\:not-italic {\n    font-style: normal;\n  }\n\n  .sm\\:uppercase {\n    text-transform: uppercase;\n  }\n\n  .sm\\:lowercase {\n    text-transform: lowercase;\n  }\n\n  .sm\\:capitalize {\n    text-transform: capitalize;\n  }\n\n  .sm\\:normal-case {\n    text-transform: none;\n  }\n\n  .sm\\:underline {\n    text-decoration: underline;\n  }\n\n  .sm\\:line-through {\n    text-decoration: line-through;\n  }\n\n  .sm\\:no-underline {\n    text-decoration: none;\n  }\n\n  .sm\\:hover\\:underline:hover {\n    text-decoration: underline;\n  }\n\n  .sm\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n  }\n\n  .sm\\:hover\\:no-underline:hover {\n    text-decoration: none;\n  }\n\n  .sm\\:focus\\:underline:focus {\n    text-decoration: underline;\n  }\n\n  .sm\\:focus\\:line-through:focus {\n    text-decoration: line-through;\n  }\n\n  .sm\\:focus\\:no-underline:focus {\n    text-decoration: none;\n  }\n\n  .sm\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  .sm\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n  }\n\n  .sm\\:ordinal, .sm\\:slashed-zero, .sm\\:lining-nums, .sm\\:oldstyle-nums, .sm\\:proportional-nums, .sm\\:tabular-nums, .sm\\:diagonal-fractions, .sm\\:stacked-fractions {\n    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);\n    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n  }\n\n  .sm\\:normal-nums {\n    font-variant-numeric: normal;\n  }\n\n  .sm\\:ordinal {\n    --font-variant-numeric-ordinal: ordinal;\n  }\n\n  .sm\\:slashed-zero {\n    --font-variant-numeric-slashed-zero: slashed-zero;\n  }\n\n  .sm\\:lining-nums {\n    --font-variant-numeric-figure: lining-nums;\n  }\n\n  .sm\\:oldstyle-nums {\n    --font-variant-numeric-figure: oldstyle-nums;\n  }\n\n  .sm\\:proportional-nums {\n    --font-variant-numeric-spacing: proportional-nums;\n  }\n\n  .sm\\:tabular-nums {\n    --font-variant-numeric-spacing: tabular-nums;\n  }\n\n  .sm\\:diagonal-fractions {\n    --font-variant-numeric-fraction: diagonal-fractions;\n  }\n\n  .sm\\:stacked-fractions {\n    --font-variant-numeric-fraction: stacked-fractions;\n  }\n\n  .sm\\:tracking-tighter {\n    letter-spacing: -0.05em;\n  }\n\n  .sm\\:tracking-tight {\n    letter-spacing: -0.025em;\n  }\n\n  .sm\\:tracking-normal {\n    letter-spacing: 0;\n  }\n\n  .sm\\:tracking-wide {\n    letter-spacing: 0.025em;\n  }\n\n  .sm\\:tracking-wider {\n    letter-spacing: 0.05em;\n  }\n\n  .sm\\:tracking-widest {\n    letter-spacing: 0.1em;\n  }\n\n  .sm\\:select-none {\n    -webkit-user-select: none;\n            user-select: none;\n  }\n\n  .sm\\:select-text {\n    -webkit-user-select: text;\n            user-select: text;\n  }\n\n  .sm\\:select-all {\n    -webkit-user-select: all;\n            user-select: all;\n  }\n\n  .sm\\:select-auto {\n    -webkit-user-select: auto;\n            user-select: auto;\n  }\n\n  .sm\\:align-baseline {\n    vertical-align: baseline;\n  }\n\n  .sm\\:align-top {\n    vertical-align: top;\n  }\n\n  .sm\\:align-middle {\n    vertical-align: middle;\n  }\n\n  .sm\\:align-bottom {\n    vertical-align: bottom;\n  }\n\n  .sm\\:align-text-top {\n    vertical-align: text-top;\n  }\n\n  .sm\\:align-text-bottom {\n    vertical-align: text-bottom;\n  }\n\n  .sm\\:visible {\n    visibility: visible;\n  }\n\n  .sm\\:invisible {\n    visibility: hidden;\n  }\n\n  .sm\\:whitespace-normal {\n    white-space: normal;\n  }\n\n  .sm\\:whitespace-no-wrap {\n    white-space: nowrap;\n  }\n\n  .sm\\:whitespace-pre {\n    white-space: pre;\n  }\n\n  .sm\\:whitespace-pre-line {\n    white-space: pre-line;\n  }\n\n  .sm\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n  }\n\n  .sm\\:break-normal {\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n\n  .sm\\:break-words {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  .sm\\:break-all {\n    word-break: break-all;\n  }\n\n  .sm\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .sm\\:w-0 {\n    width: 0;\n  }\n\n  .sm\\:w-1 {\n    width: 0.25rem;\n  }\n\n  .sm\\:w-2 {\n    width: 0.5rem;\n  }\n\n  .sm\\:w-3 {\n    width: 0.75rem;\n  }\n\n  .sm\\:w-4 {\n    width: 1rem;\n  }\n\n  .sm\\:w-5 {\n    width: 1.25rem;\n  }\n\n  .sm\\:w-6 {\n    width: 1.5rem;\n  }\n\n  .sm\\:w-8 {\n    width: 2rem;\n  }\n\n  .sm\\:w-10 {\n    width: 2.5rem;\n  }\n\n  .sm\\:w-12 {\n    width: 3rem;\n  }\n\n  .sm\\:w-16 {\n    width: 4rem;\n  }\n\n  .sm\\:w-20 {\n    width: 5rem;\n  }\n\n  .sm\\:w-24 {\n    width: 6rem;\n  }\n\n  .sm\\:w-32 {\n    width: 8rem;\n  }\n\n  .sm\\:w-40 {\n    width: 10rem;\n  }\n\n  .sm\\:w-48 {\n    width: 12rem;\n  }\n\n  .sm\\:w-56 {\n    width: 14rem;\n  }\n\n  .sm\\:w-64 {\n    width: 16rem;\n  }\n\n  .sm\\:w-auto {\n    width: auto;\n  }\n\n  .sm\\:w-px {\n    width: 1px;\n  }\n\n  .sm\\:w-1\\/2 {\n    width: 50%;\n  }\n\n  .sm\\:w-1\\/3 {\n    width: 33.333333%;\n  }\n\n  .sm\\:w-2\\/3 {\n    width: 66.666667%;\n  }\n\n  .sm\\:w-1\\/4 {\n    width: 25%;\n  }\n\n  .sm\\:w-2\\/4 {\n    width: 50%;\n  }\n\n  .sm\\:w-3\\/4 {\n    width: 75%;\n  }\n\n  .sm\\:w-1\\/5 {\n    width: 20%;\n  }\n\n  .sm\\:w-2\\/5 {\n    width: 40%;\n  }\n\n  .sm\\:w-3\\/5 {\n    width: 60%;\n  }\n\n  .sm\\:w-4\\/5 {\n    width: 80%;\n  }\n\n  .sm\\:w-1\\/6 {\n    width: 16.666667%;\n  }\n\n  .sm\\:w-2\\/6 {\n    width: 33.333333%;\n  }\n\n  .sm\\:w-3\\/6 {\n    width: 50%;\n  }\n\n  .sm\\:w-4\\/6 {\n    width: 66.666667%;\n  }\n\n  .sm\\:w-5\\/6 {\n    width: 83.333333%;\n  }\n\n  .sm\\:w-1\\/12 {\n    width: 8.333333%;\n  }\n\n  .sm\\:w-2\\/12 {\n    width: 16.666667%;\n  }\n\n  .sm\\:w-3\\/12 {\n    width: 25%;\n  }\n\n  .sm\\:w-4\\/12 {\n    width: 33.333333%;\n  }\n\n  .sm\\:w-5\\/12 {\n    width: 41.666667%;\n  }\n\n  .sm\\:w-6\\/12 {\n    width: 50%;\n  }\n\n  .sm\\:w-7\\/12 {\n    width: 58.333333%;\n  }\n\n  .sm\\:w-8\\/12 {\n    width: 66.666667%;\n  }\n\n  .sm\\:w-9\\/12 {\n    width: 75%;\n  }\n\n  .sm\\:w-10\\/12 {\n    width: 83.333333%;\n  }\n\n  .sm\\:w-11\\/12 {\n    width: 91.666667%;\n  }\n\n  .sm\\:w-full {\n    width: 100%;\n  }\n\n  .sm\\:w-screen {\n    width: 100vw;\n  }\n\n  .sm\\:z-0 {\n    z-index: 0;\n  }\n\n  .sm\\:z-10 {\n    z-index: 10;\n  }\n\n  .sm\\:z-20 {\n    z-index: 20;\n  }\n\n  .sm\\:z-30 {\n    z-index: 30;\n  }\n\n  .sm\\:z-40 {\n    z-index: 40;\n  }\n\n  .sm\\:z-50 {\n    z-index: 50;\n  }\n\n  .sm\\:z-auto {\n    z-index: auto;\n  }\n\n  .sm\\:gap-0 {\n    grid-gap: 0;\n    gap: 0;\n  }\n\n  .sm\\:gap-1 {\n    grid-gap: 0.25rem;\n    gap: 0.25rem;\n  }\n\n  .sm\\:gap-2 {\n    grid-gap: 0.5rem;\n    gap: 0.5rem;\n  }\n\n  .sm\\:gap-3 {\n    grid-gap: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .sm\\:gap-4 {\n    grid-gap: 1rem;\n    gap: 1rem;\n  }\n\n  .sm\\:gap-5 {\n    grid-gap: 1.25rem;\n    gap: 1.25rem;\n  }\n\n  .sm\\:gap-6 {\n    grid-gap: 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .sm\\:gap-8 {\n    grid-gap: 2rem;\n    gap: 2rem;\n  }\n\n  .sm\\:gap-10 {\n    grid-gap: 2.5rem;\n    gap: 2.5rem;\n  }\n\n  .sm\\:gap-12 {\n    grid-gap: 3rem;\n    gap: 3rem;\n  }\n\n  .sm\\:gap-16 {\n    grid-gap: 4rem;\n    gap: 4rem;\n  }\n\n  .sm\\:gap-20 {\n    grid-gap: 5rem;\n    gap: 5rem;\n  }\n\n  .sm\\:gap-24 {\n    grid-gap: 6rem;\n    gap: 6rem;\n  }\n\n  .sm\\:gap-32 {\n    grid-gap: 8rem;\n    gap: 8rem;\n  }\n\n  .sm\\:gap-40 {\n    grid-gap: 10rem;\n    gap: 10rem;\n  }\n\n  .sm\\:gap-48 {\n    grid-gap: 12rem;\n    gap: 12rem;\n  }\n\n  .sm\\:gap-56 {\n    grid-gap: 14rem;\n    gap: 14rem;\n  }\n\n  .sm\\:gap-64 {\n    grid-gap: 16rem;\n    gap: 16rem;\n  }\n\n  .sm\\:gap-px {\n    grid-gap: 1px;\n    gap: 1px;\n  }\n\n  .sm\\:col-gap-0 {\n    grid-column-gap: 0;\n    column-gap: 0;\n  }\n\n  .sm\\:col-gap-1 {\n    grid-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n\n  .sm\\:col-gap-2 {\n    grid-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n\n  .sm\\:col-gap-3 {\n    grid-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n\n  .sm\\:col-gap-4 {\n    grid-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n\n  .sm\\:col-gap-5 {\n    grid-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n\n  .sm\\:col-gap-6 {\n    grid-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n\n  .sm\\:col-gap-8 {\n    grid-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n\n  .sm\\:col-gap-10 {\n    grid-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n\n  .sm\\:col-gap-12 {\n    grid-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n\n  .sm\\:col-gap-16 {\n    grid-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n\n  .sm\\:col-gap-20 {\n    grid-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n\n  .sm\\:col-gap-24 {\n    grid-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n\n  .sm\\:col-gap-32 {\n    grid-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n\n  .sm\\:col-gap-40 {\n    grid-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n\n  .sm\\:col-gap-48 {\n    grid-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n\n  .sm\\:col-gap-56 {\n    grid-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n\n  .sm\\:col-gap-64 {\n    grid-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n\n  .sm\\:col-gap-px {\n    grid-column-gap: 1px;\n    column-gap: 1px;\n  }\n\n  .sm\\:gap-x-0 {\n    grid-column-gap: 0;\n    column-gap: 0;\n  }\n\n  .sm\\:gap-x-1 {\n    grid-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n\n  .sm\\:gap-x-2 {\n    grid-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n\n  .sm\\:gap-x-3 {\n    grid-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n\n  .sm\\:gap-x-4 {\n    grid-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n\n  .sm\\:gap-x-5 {\n    grid-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n\n  .sm\\:gap-x-6 {\n    grid-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n\n  .sm\\:gap-x-8 {\n    grid-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n\n  .sm\\:gap-x-10 {\n    grid-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n\n  .sm\\:gap-x-12 {\n    grid-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n\n  .sm\\:gap-x-16 {\n    grid-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n\n  .sm\\:gap-x-20 {\n    grid-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n\n  .sm\\:gap-x-24 {\n    grid-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n\n  .sm\\:gap-x-32 {\n    grid-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n\n  .sm\\:gap-x-40 {\n    grid-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n\n  .sm\\:gap-x-48 {\n    grid-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n\n  .sm\\:gap-x-56 {\n    grid-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n\n  .sm\\:gap-x-64 {\n    grid-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n\n  .sm\\:gap-x-px {\n    grid-column-gap: 1px;\n    column-gap: 1px;\n  }\n\n  .sm\\:row-gap-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n\n  .sm\\:row-gap-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n\n  .sm\\:row-gap-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n\n  .sm\\:row-gap-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n\n  .sm\\:row-gap-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n\n  .sm\\:row-gap-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n\n  .sm\\:row-gap-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n\n  .sm\\:row-gap-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n\n  .sm\\:row-gap-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n\n  .sm\\:row-gap-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n\n  .sm\\:row-gap-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n\n  .sm\\:row-gap-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n\n  .sm\\:row-gap-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n\n  .sm\\:row-gap-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n\n  .sm\\:row-gap-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n\n  .sm\\:row-gap-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n\n  .sm\\:row-gap-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n\n  .sm\\:row-gap-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n\n  .sm\\:row-gap-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n\n  .sm\\:gap-y-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n\n  .sm\\:gap-y-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n\n  .sm\\:gap-y-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n\n  .sm\\:gap-y-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n\n  .sm\\:gap-y-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n\n  .sm\\:gap-y-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n\n  .sm\\:gap-y-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n\n  .sm\\:gap-y-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n\n  .sm\\:gap-y-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n\n  .sm\\:gap-y-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n\n  .sm\\:gap-y-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n\n  .sm\\:gap-y-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n\n  .sm\\:gap-y-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n\n  .sm\\:gap-y-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n\n  .sm\\:gap-y-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n\n  .sm\\:gap-y-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n\n  .sm\\:gap-y-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n\n  .sm\\:gap-y-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n\n  .sm\\:gap-y-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n\n  .sm\\:grid-flow-row {\n    grid-auto-flow: row;\n  }\n\n  .sm\\:grid-flow-col {\n    grid-auto-flow: column;\n  }\n\n  .sm\\:grid-flow-row-dense {\n    grid-auto-flow: row dense;\n  }\n\n  .sm\\:grid-flow-col-dense {\n    grid-auto-flow: column dense;\n  }\n\n  .sm\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-cols-none {\n    grid-template-columns: none;\n  }\n\n  .sm\\:auto-cols-auto {\n    grid-auto-columns: auto;\n  }\n\n  .sm\\:auto-cols-min {\n    grid-auto-columns: min-content;\n  }\n\n  .sm\\:auto-cols-max {\n    grid-auto-columns: max-content;\n  }\n\n  .sm\\:auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n  }\n\n  .sm\\:col-auto {\n    grid-column: auto;\n  }\n\n  .sm\\:col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n\n  .sm\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n\n  .sm\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n\n  .sm\\:col-span-4 {\n    grid-column: span 4 / span 4;\n  }\n\n  .sm\\:col-span-5 {\n    grid-column: span 5 / span 5;\n  }\n\n  .sm\\:col-span-6 {\n    grid-column: span 6 / span 6;\n  }\n\n  .sm\\:col-span-7 {\n    grid-column: span 7 / span 7;\n  }\n\n  .sm\\:col-span-8 {\n    grid-column: span 8 / span 8;\n  }\n\n  .sm\\:col-span-9 {\n    grid-column: span 9 / span 9;\n  }\n\n  .sm\\:col-span-10 {\n    grid-column: span 10 / span 10;\n  }\n\n  .sm\\:col-span-11 {\n    grid-column: span 11 / span 11;\n  }\n\n  .sm\\:col-span-12 {\n    grid-column: span 12 / span 12;\n  }\n\n  .sm\\:col-span-full {\n    grid-column: 1 / -1;\n  }\n\n  .sm\\:col-start-1 {\n    grid-column-start: 1;\n  }\n\n  .sm\\:col-start-2 {\n    grid-column-start: 2;\n  }\n\n  .sm\\:col-start-3 {\n    grid-column-start: 3;\n  }\n\n  .sm\\:col-start-4 {\n    grid-column-start: 4;\n  }\n\n  .sm\\:col-start-5 {\n    grid-column-start: 5;\n  }\n\n  .sm\\:col-start-6 {\n    grid-column-start: 6;\n  }\n\n  .sm\\:col-start-7 {\n    grid-column-start: 7;\n  }\n\n  .sm\\:col-start-8 {\n    grid-column-start: 8;\n  }\n\n  .sm\\:col-start-9 {\n    grid-column-start: 9;\n  }\n\n  .sm\\:col-start-10 {\n    grid-column-start: 10;\n  }\n\n  .sm\\:col-start-11 {\n    grid-column-start: 11;\n  }\n\n  .sm\\:col-start-12 {\n    grid-column-start: 12;\n  }\n\n  .sm\\:col-start-13 {\n    grid-column-start: 13;\n  }\n\n  .sm\\:col-start-auto {\n    grid-column-start: auto;\n  }\n\n  .sm\\:col-end-1 {\n    grid-column-end: 1;\n  }\n\n  .sm\\:col-end-2 {\n    grid-column-end: 2;\n  }\n\n  .sm\\:col-end-3 {\n    grid-column-end: 3;\n  }\n\n  .sm\\:col-end-4 {\n    grid-column-end: 4;\n  }\n\n  .sm\\:col-end-5 {\n    grid-column-end: 5;\n  }\n\n  .sm\\:col-end-6 {\n    grid-column-end: 6;\n  }\n\n  .sm\\:col-end-7 {\n    grid-column-end: 7;\n  }\n\n  .sm\\:col-end-8 {\n    grid-column-end: 8;\n  }\n\n  .sm\\:col-end-9 {\n    grid-column-end: 9;\n  }\n\n  .sm\\:col-end-10 {\n    grid-column-end: 10;\n  }\n\n  .sm\\:col-end-11 {\n    grid-column-end: 11;\n  }\n\n  .sm\\:col-end-12 {\n    grid-column-end: 12;\n  }\n\n  .sm\\:col-end-13 {\n    grid-column-end: 13;\n  }\n\n  .sm\\:col-end-auto {\n    grid-column-end: auto;\n  }\n\n  .sm\\:grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n  }\n\n  .sm\\:grid-rows-none {\n    grid-template-rows: none;\n  }\n\n  .sm\\:auto-rows-auto {\n    grid-auto-rows: auto;\n  }\n\n  .sm\\:auto-rows-min {\n    grid-auto-rows: min-content;\n  }\n\n  .sm\\:auto-rows-max {\n    grid-auto-rows: max-content;\n  }\n\n  .sm\\:auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n  }\n\n  .sm\\:row-auto {\n    grid-row: auto;\n  }\n\n  .sm\\:row-span-1 {\n    grid-row: span 1 / span 1;\n  }\n\n  .sm\\:row-span-2 {\n    grid-row: span 2 / span 2;\n  }\n\n  .sm\\:row-span-3 {\n    grid-row: span 3 / span 3;\n  }\n\n  .sm\\:row-span-4 {\n    grid-row: span 4 / span 4;\n  }\n\n  .sm\\:row-span-5 {\n    grid-row: span 5 / span 5;\n  }\n\n  .sm\\:row-span-6 {\n    grid-row: span 6 / span 6;\n  }\n\n  .sm\\:row-span-full {\n    grid-row: 1 / -1;\n  }\n\n  .sm\\:row-start-1 {\n    grid-row-start: 1;\n  }\n\n  .sm\\:row-start-2 {\n    grid-row-start: 2;\n  }\n\n  .sm\\:row-start-3 {\n    grid-row-start: 3;\n  }\n\n  .sm\\:row-start-4 {\n    grid-row-start: 4;\n  }\n\n  .sm\\:row-start-5 {\n    grid-row-start: 5;\n  }\n\n  .sm\\:row-start-6 {\n    grid-row-start: 6;\n  }\n\n  .sm\\:row-start-7 {\n    grid-row-start: 7;\n  }\n\n  .sm\\:row-start-auto {\n    grid-row-start: auto;\n  }\n\n  .sm\\:row-end-1 {\n    grid-row-end: 1;\n  }\n\n  .sm\\:row-end-2 {\n    grid-row-end: 2;\n  }\n\n  .sm\\:row-end-3 {\n    grid-row-end: 3;\n  }\n\n  .sm\\:row-end-4 {\n    grid-row-end: 4;\n  }\n\n  .sm\\:row-end-5 {\n    grid-row-end: 5;\n  }\n\n  .sm\\:row-end-6 {\n    grid-row-end: 6;\n  }\n\n  .sm\\:row-end-7 {\n    grid-row-end: 7;\n  }\n\n  .sm\\:row-end-auto {\n    grid-row-end: auto;\n  }\n\n  .sm\\:transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n  }\n\n  .sm\\:transform-none {\n    transform: none;\n  }\n\n  .sm\\:origin-center {\n    transform-origin: center;\n  }\n\n  .sm\\:origin-top {\n    transform-origin: top;\n  }\n\n  .sm\\:origin-top-right {\n    transform-origin: top right;\n  }\n\n  .sm\\:origin-right {\n    transform-origin: right;\n  }\n\n  .sm\\:origin-bottom-right {\n    transform-origin: bottom right;\n  }\n\n  .sm\\:origin-bottom {\n    transform-origin: bottom;\n  }\n\n  .sm\\:origin-bottom-left {\n    transform-origin: bottom left;\n  }\n\n  .sm\\:origin-left {\n    transform-origin: left;\n  }\n\n  .sm\\:origin-top-left {\n    transform-origin: top left;\n  }\n\n  .sm\\:scale-0 {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .sm\\:scale-50 {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .sm\\:scale-75 {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .sm\\:scale-90 {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .sm\\:scale-95 {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .sm\\:scale-100 {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .sm\\:scale-105 {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .sm\\:scale-110 {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .sm\\:scale-125 {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .sm\\:scale-150 {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .sm\\:scale-x-0 {\n    --transform-scale-x: 0;\n  }\n\n  .sm\\:scale-x-50 {\n    --transform-scale-x: .5;\n  }\n\n  .sm\\:scale-x-75 {\n    --transform-scale-x: .75;\n  }\n\n  .sm\\:scale-x-90 {\n    --transform-scale-x: .9;\n  }\n\n  .sm\\:scale-x-95 {\n    --transform-scale-x: .95;\n  }\n\n  .sm\\:scale-x-100 {\n    --transform-scale-x: 1;\n  }\n\n  .sm\\:scale-x-105 {\n    --transform-scale-x: 1.05;\n  }\n\n  .sm\\:scale-x-110 {\n    --transform-scale-x: 1.1;\n  }\n\n  .sm\\:scale-x-125 {\n    --transform-scale-x: 1.25;\n  }\n\n  .sm\\:scale-x-150 {\n    --transform-scale-x: 1.5;\n  }\n\n  .sm\\:scale-y-0 {\n    --transform-scale-y: 0;\n  }\n\n  .sm\\:scale-y-50 {\n    --transform-scale-y: .5;\n  }\n\n  .sm\\:scale-y-75 {\n    --transform-scale-y: .75;\n  }\n\n  .sm\\:scale-y-90 {\n    --transform-scale-y: .9;\n  }\n\n  .sm\\:scale-y-95 {\n    --transform-scale-y: .95;\n  }\n\n  .sm\\:scale-y-100 {\n    --transform-scale-y: 1;\n  }\n\n  .sm\\:scale-y-105 {\n    --transform-scale-y: 1.05;\n  }\n\n  .sm\\:scale-y-110 {\n    --transform-scale-y: 1.1;\n  }\n\n  .sm\\:scale-y-125 {\n    --transform-scale-y: 1.25;\n  }\n\n  .sm\\:scale-y-150 {\n    --transform-scale-y: 1.5;\n  }\n\n  .sm\\:hover\\:scale-0:hover {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .sm\\:hover\\:scale-50:hover {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .sm\\:hover\\:scale-75:hover {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .sm\\:hover\\:scale-90:hover {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .sm\\:hover\\:scale-95:hover {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .sm\\:hover\\:scale-100:hover {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .sm\\:hover\\:scale-105:hover {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .sm\\:hover\\:scale-110:hover {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .sm\\:hover\\:scale-125:hover {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .sm\\:hover\\:scale-150:hover {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .sm\\:hover\\:scale-x-0:hover {\n    --transform-scale-x: 0;\n  }\n\n  .sm\\:hover\\:scale-x-50:hover {\n    --transform-scale-x: .5;\n  }\n\n  .sm\\:hover\\:scale-x-75:hover {\n    --transform-scale-x: .75;\n  }\n\n  .sm\\:hover\\:scale-x-90:hover {\n    --transform-scale-x: .9;\n  }\n\n  .sm\\:hover\\:scale-x-95:hover {\n    --transform-scale-x: .95;\n  }\n\n  .sm\\:hover\\:scale-x-100:hover {\n    --transform-scale-x: 1;\n  }\n\n  .sm\\:hover\\:scale-x-105:hover {\n    --transform-scale-x: 1.05;\n  }\n\n  .sm\\:hover\\:scale-x-110:hover {\n    --transform-scale-x: 1.1;\n  }\n\n  .sm\\:hover\\:scale-x-125:hover {\n    --transform-scale-x: 1.25;\n  }\n\n  .sm\\:hover\\:scale-x-150:hover {\n    --transform-scale-x: 1.5;\n  }\n\n  .sm\\:hover\\:scale-y-0:hover {\n    --transform-scale-y: 0;\n  }\n\n  .sm\\:hover\\:scale-y-50:hover {\n    --transform-scale-y: .5;\n  }\n\n  .sm\\:hover\\:scale-y-75:hover {\n    --transform-scale-y: .75;\n  }\n\n  .sm\\:hover\\:scale-y-90:hover {\n    --transform-scale-y: .9;\n  }\n\n  .sm\\:hover\\:scale-y-95:hover {\n    --transform-scale-y: .95;\n  }\n\n  .sm\\:hover\\:scale-y-100:hover {\n    --transform-scale-y: 1;\n  }\n\n  .sm\\:hover\\:scale-y-105:hover {\n    --transform-scale-y: 1.05;\n  }\n\n  .sm\\:hover\\:scale-y-110:hover {\n    --transform-scale-y: 1.1;\n  }\n\n  .sm\\:hover\\:scale-y-125:hover {\n    --transform-scale-y: 1.25;\n  }\n\n  .sm\\:hover\\:scale-y-150:hover {\n    --transform-scale-y: 1.5;\n  }\n\n  .sm\\:focus\\:scale-0:focus {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .sm\\:focus\\:scale-50:focus {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .sm\\:focus\\:scale-75:focus {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .sm\\:focus\\:scale-90:focus {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .sm\\:focus\\:scale-95:focus {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .sm\\:focus\\:scale-100:focus {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .sm\\:focus\\:scale-105:focus {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .sm\\:focus\\:scale-110:focus {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .sm\\:focus\\:scale-125:focus {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .sm\\:focus\\:scale-150:focus {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .sm\\:focus\\:scale-x-0:focus {\n    --transform-scale-x: 0;\n  }\n\n  .sm\\:focus\\:scale-x-50:focus {\n    --transform-scale-x: .5;\n  }\n\n  .sm\\:focus\\:scale-x-75:focus {\n    --transform-scale-x: .75;\n  }\n\n  .sm\\:focus\\:scale-x-90:focus {\n    --transform-scale-x: .9;\n  }\n\n  .sm\\:focus\\:scale-x-95:focus {\n    --transform-scale-x: .95;\n  }\n\n  .sm\\:focus\\:scale-x-100:focus {\n    --transform-scale-x: 1;\n  }\n\n  .sm\\:focus\\:scale-x-105:focus {\n    --transform-scale-x: 1.05;\n  }\n\n  .sm\\:focus\\:scale-x-110:focus {\n    --transform-scale-x: 1.1;\n  }\n\n  .sm\\:focus\\:scale-x-125:focus {\n    --transform-scale-x: 1.25;\n  }\n\n  .sm\\:focus\\:scale-x-150:focus {\n    --transform-scale-x: 1.5;\n  }\n\n  .sm\\:focus\\:scale-y-0:focus {\n    --transform-scale-y: 0;\n  }\n\n  .sm\\:focus\\:scale-y-50:focus {\n    --transform-scale-y: .5;\n  }\n\n  .sm\\:focus\\:scale-y-75:focus {\n    --transform-scale-y: .75;\n  }\n\n  .sm\\:focus\\:scale-y-90:focus {\n    --transform-scale-y: .9;\n  }\n\n  .sm\\:focus\\:scale-y-95:focus {\n    --transform-scale-y: .95;\n  }\n\n  .sm\\:focus\\:scale-y-100:focus {\n    --transform-scale-y: 1;\n  }\n\n  .sm\\:focus\\:scale-y-105:focus {\n    --transform-scale-y: 1.05;\n  }\n\n  .sm\\:focus\\:scale-y-110:focus {\n    --transform-scale-y: 1.1;\n  }\n\n  .sm\\:focus\\:scale-y-125:focus {\n    --transform-scale-y: 1.25;\n  }\n\n  .sm\\:focus\\:scale-y-150:focus {\n    --transform-scale-y: 1.5;\n  }\n\n  .sm\\:rotate-0 {\n    --transform-rotate: 0;\n  }\n\n  .sm\\:rotate-1 {\n    --transform-rotate: 1deg;\n  }\n\n  .sm\\:rotate-2 {\n    --transform-rotate: 2deg;\n  }\n\n  .sm\\:rotate-3 {\n    --transform-rotate: 3deg;\n  }\n\n  .sm\\:rotate-6 {\n    --transform-rotate: 6deg;\n  }\n\n  .sm\\:rotate-12 {\n    --transform-rotate: 12deg;\n  }\n\n  .sm\\:rotate-45 {\n    --transform-rotate: 45deg;\n  }\n\n  .sm\\:rotate-90 {\n    --transform-rotate: 90deg;\n  }\n\n  .sm\\:rotate-180 {\n    --transform-rotate: 180deg;\n  }\n\n  .sm\\:-rotate-180 {\n    --transform-rotate: -180deg;\n  }\n\n  .sm\\:-rotate-90 {\n    --transform-rotate: -90deg;\n  }\n\n  .sm\\:-rotate-45 {\n    --transform-rotate: -45deg;\n  }\n\n  .sm\\:-rotate-12 {\n    --transform-rotate: -12deg;\n  }\n\n  .sm\\:-rotate-6 {\n    --transform-rotate: -6deg;\n  }\n\n  .sm\\:-rotate-3 {\n    --transform-rotate: -3deg;\n  }\n\n  .sm\\:-rotate-2 {\n    --transform-rotate: -2deg;\n  }\n\n  .sm\\:-rotate-1 {\n    --transform-rotate: -1deg;\n  }\n\n  .sm\\:hover\\:rotate-0:hover {\n    --transform-rotate: 0;\n  }\n\n  .sm\\:hover\\:rotate-1:hover {\n    --transform-rotate: 1deg;\n  }\n\n  .sm\\:hover\\:rotate-2:hover {\n    --transform-rotate: 2deg;\n  }\n\n  .sm\\:hover\\:rotate-3:hover {\n    --transform-rotate: 3deg;\n  }\n\n  .sm\\:hover\\:rotate-6:hover {\n    --transform-rotate: 6deg;\n  }\n\n  .sm\\:hover\\:rotate-12:hover {\n    --transform-rotate: 12deg;\n  }\n\n  .sm\\:hover\\:rotate-45:hover {\n    --transform-rotate: 45deg;\n  }\n\n  .sm\\:hover\\:rotate-90:hover {\n    --transform-rotate: 90deg;\n  }\n\n  .sm\\:hover\\:rotate-180:hover {\n    --transform-rotate: 180deg;\n  }\n\n  .sm\\:hover\\:-rotate-180:hover {\n    --transform-rotate: -180deg;\n  }\n\n  .sm\\:hover\\:-rotate-90:hover {\n    --transform-rotate: -90deg;\n  }\n\n  .sm\\:hover\\:-rotate-45:hover {\n    --transform-rotate: -45deg;\n  }\n\n  .sm\\:hover\\:-rotate-12:hover {\n    --transform-rotate: -12deg;\n  }\n\n  .sm\\:hover\\:-rotate-6:hover {\n    --transform-rotate: -6deg;\n  }\n\n  .sm\\:hover\\:-rotate-3:hover {\n    --transform-rotate: -3deg;\n  }\n\n  .sm\\:hover\\:-rotate-2:hover {\n    --transform-rotate: -2deg;\n  }\n\n  .sm\\:hover\\:-rotate-1:hover {\n    --transform-rotate: -1deg;\n  }\n\n  .sm\\:focus\\:rotate-0:focus {\n    --transform-rotate: 0;\n  }\n\n  .sm\\:focus\\:rotate-1:focus {\n    --transform-rotate: 1deg;\n  }\n\n  .sm\\:focus\\:rotate-2:focus {\n    --transform-rotate: 2deg;\n  }\n\n  .sm\\:focus\\:rotate-3:focus {\n    --transform-rotate: 3deg;\n  }\n\n  .sm\\:focus\\:rotate-6:focus {\n    --transform-rotate: 6deg;\n  }\n\n  .sm\\:focus\\:rotate-12:focus {\n    --transform-rotate: 12deg;\n  }\n\n  .sm\\:focus\\:rotate-45:focus {\n    --transform-rotate: 45deg;\n  }\n\n  .sm\\:focus\\:rotate-90:focus {\n    --transform-rotate: 90deg;\n  }\n\n  .sm\\:focus\\:rotate-180:focus {\n    --transform-rotate: 180deg;\n  }\n\n  .sm\\:focus\\:-rotate-180:focus {\n    --transform-rotate: -180deg;\n  }\n\n  .sm\\:focus\\:-rotate-90:focus {\n    --transform-rotate: -90deg;\n  }\n\n  .sm\\:focus\\:-rotate-45:focus {\n    --transform-rotate: -45deg;\n  }\n\n  .sm\\:focus\\:-rotate-12:focus {\n    --transform-rotate: -12deg;\n  }\n\n  .sm\\:focus\\:-rotate-6:focus {\n    --transform-rotate: -6deg;\n  }\n\n  .sm\\:focus\\:-rotate-3:focus {\n    --transform-rotate: -3deg;\n  }\n\n  .sm\\:focus\\:-rotate-2:focus {\n    --transform-rotate: -2deg;\n  }\n\n  .sm\\:focus\\:-rotate-1:focus {\n    --transform-rotate: -1deg;\n  }\n\n  .sm\\:translate-x-0 {\n    --transform-translate-x: 0;\n  }\n\n  .sm\\:translate-x-1 {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .sm\\:translate-x-2 {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .sm\\:translate-x-3 {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .sm\\:translate-x-4 {\n    --transform-translate-x: 1rem;\n  }\n\n  .sm\\:translate-x-5 {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .sm\\:translate-x-6 {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .sm\\:translate-x-8 {\n    --transform-translate-x: 2rem;\n  }\n\n  .sm\\:translate-x-10 {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .sm\\:translate-x-12 {\n    --transform-translate-x: 3rem;\n  }\n\n  .sm\\:translate-x-16 {\n    --transform-translate-x: 4rem;\n  }\n\n  .sm\\:translate-x-20 {\n    --transform-translate-x: 5rem;\n  }\n\n  .sm\\:translate-x-24 {\n    --transform-translate-x: 6rem;\n  }\n\n  .sm\\:translate-x-32 {\n    --transform-translate-x: 8rem;\n  }\n\n  .sm\\:translate-x-40 {\n    --transform-translate-x: 10rem;\n  }\n\n  .sm\\:translate-x-48 {\n    --transform-translate-x: 12rem;\n  }\n\n  .sm\\:translate-x-56 {\n    --transform-translate-x: 14rem;\n  }\n\n  .sm\\:translate-x-64 {\n    --transform-translate-x: 16rem;\n  }\n\n  .sm\\:translate-x-px {\n    --transform-translate-x: 1px;\n  }\n\n  .sm\\:-translate-x-1 {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .sm\\:-translate-x-2 {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .sm\\:-translate-x-3 {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .sm\\:-translate-x-4 {\n    --transform-translate-x: -1rem;\n  }\n\n  .sm\\:-translate-x-5 {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .sm\\:-translate-x-6 {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .sm\\:-translate-x-8 {\n    --transform-translate-x: -2rem;\n  }\n\n  .sm\\:-translate-x-10 {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .sm\\:-translate-x-12 {\n    --transform-translate-x: -3rem;\n  }\n\n  .sm\\:-translate-x-16 {\n    --transform-translate-x: -4rem;\n  }\n\n  .sm\\:-translate-x-20 {\n    --transform-translate-x: -5rem;\n  }\n\n  .sm\\:-translate-x-24 {\n    --transform-translate-x: -6rem;\n  }\n\n  .sm\\:-translate-x-32 {\n    --transform-translate-x: -8rem;\n  }\n\n  .sm\\:-translate-x-40 {\n    --transform-translate-x: -10rem;\n  }\n\n  .sm\\:-translate-x-48 {\n    --transform-translate-x: -12rem;\n  }\n\n  .sm\\:-translate-x-56 {\n    --transform-translate-x: -14rem;\n  }\n\n  .sm\\:-translate-x-64 {\n    --transform-translate-x: -16rem;\n  }\n\n  .sm\\:-translate-x-px {\n    --transform-translate-x: -1px;\n  }\n\n  .sm\\:-translate-x-full {\n    --transform-translate-x: -100%;\n  }\n\n  .sm\\:-translate-x-1\\/2 {\n    --transform-translate-x: -50%;\n  }\n\n  .sm\\:translate-x-1\\/2 {\n    --transform-translate-x: 50%;\n  }\n\n  .sm\\:translate-x-full {\n    --transform-translate-x: 100%;\n  }\n\n  .sm\\:translate-y-0 {\n    --transform-translate-y: 0;\n  }\n\n  .sm\\:translate-y-1 {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .sm\\:translate-y-2 {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .sm\\:translate-y-3 {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .sm\\:translate-y-4 {\n    --transform-translate-y: 1rem;\n  }\n\n  .sm\\:translate-y-5 {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .sm\\:translate-y-6 {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .sm\\:translate-y-8 {\n    --transform-translate-y: 2rem;\n  }\n\n  .sm\\:translate-y-10 {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .sm\\:translate-y-12 {\n    --transform-translate-y: 3rem;\n  }\n\n  .sm\\:translate-y-16 {\n    --transform-translate-y: 4rem;\n  }\n\n  .sm\\:translate-y-20 {\n    --transform-translate-y: 5rem;\n  }\n\n  .sm\\:translate-y-24 {\n    --transform-translate-y: 6rem;\n  }\n\n  .sm\\:translate-y-32 {\n    --transform-translate-y: 8rem;\n  }\n\n  .sm\\:translate-y-40 {\n    --transform-translate-y: 10rem;\n  }\n\n  .sm\\:translate-y-48 {\n    --transform-translate-y: 12rem;\n  }\n\n  .sm\\:translate-y-56 {\n    --transform-translate-y: 14rem;\n  }\n\n  .sm\\:translate-y-64 {\n    --transform-translate-y: 16rem;\n  }\n\n  .sm\\:translate-y-px {\n    --transform-translate-y: 1px;\n  }\n\n  .sm\\:-translate-y-1 {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .sm\\:-translate-y-2 {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .sm\\:-translate-y-3 {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .sm\\:-translate-y-4 {\n    --transform-translate-y: -1rem;\n  }\n\n  .sm\\:-translate-y-5 {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .sm\\:-translate-y-6 {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .sm\\:-translate-y-8 {\n    --transform-translate-y: -2rem;\n  }\n\n  .sm\\:-translate-y-10 {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .sm\\:-translate-y-12 {\n    --transform-translate-y: -3rem;\n  }\n\n  .sm\\:-translate-y-16 {\n    --transform-translate-y: -4rem;\n  }\n\n  .sm\\:-translate-y-20 {\n    --transform-translate-y: -5rem;\n  }\n\n  .sm\\:-translate-y-24 {\n    --transform-translate-y: -6rem;\n  }\n\n  .sm\\:-translate-y-32 {\n    --transform-translate-y: -8rem;\n  }\n\n  .sm\\:-translate-y-40 {\n    --transform-translate-y: -10rem;\n  }\n\n  .sm\\:-translate-y-48 {\n    --transform-translate-y: -12rem;\n  }\n\n  .sm\\:-translate-y-56 {\n    --transform-translate-y: -14rem;\n  }\n\n  .sm\\:-translate-y-64 {\n    --transform-translate-y: -16rem;\n  }\n\n  .sm\\:-translate-y-px {\n    --transform-translate-y: -1px;\n  }\n\n  .sm\\:-translate-y-full {\n    --transform-translate-y: -100%;\n  }\n\n  .sm\\:-translate-y-1\\/2 {\n    --transform-translate-y: -50%;\n  }\n\n  .sm\\:translate-y-1\\/2 {\n    --transform-translate-y: 50%;\n  }\n\n  .sm\\:translate-y-full {\n    --transform-translate-y: 100%;\n  }\n\n  .sm\\:hover\\:translate-x-0:hover {\n    --transform-translate-x: 0;\n  }\n\n  .sm\\:hover\\:translate-x-1:hover {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .sm\\:hover\\:translate-x-2:hover {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .sm\\:hover\\:translate-x-3:hover {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .sm\\:hover\\:translate-x-4:hover {\n    --transform-translate-x: 1rem;\n  }\n\n  .sm\\:hover\\:translate-x-5:hover {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .sm\\:hover\\:translate-x-6:hover {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .sm\\:hover\\:translate-x-8:hover {\n    --transform-translate-x: 2rem;\n  }\n\n  .sm\\:hover\\:translate-x-10:hover {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .sm\\:hover\\:translate-x-12:hover {\n    --transform-translate-x: 3rem;\n  }\n\n  .sm\\:hover\\:translate-x-16:hover {\n    --transform-translate-x: 4rem;\n  }\n\n  .sm\\:hover\\:translate-x-20:hover {\n    --transform-translate-x: 5rem;\n  }\n\n  .sm\\:hover\\:translate-x-24:hover {\n    --transform-translate-x: 6rem;\n  }\n\n  .sm\\:hover\\:translate-x-32:hover {\n    --transform-translate-x: 8rem;\n  }\n\n  .sm\\:hover\\:translate-x-40:hover {\n    --transform-translate-x: 10rem;\n  }\n\n  .sm\\:hover\\:translate-x-48:hover {\n    --transform-translate-x: 12rem;\n  }\n\n  .sm\\:hover\\:translate-x-56:hover {\n    --transform-translate-x: 14rem;\n  }\n\n  .sm\\:hover\\:translate-x-64:hover {\n    --transform-translate-x: 16rem;\n  }\n\n  .sm\\:hover\\:translate-x-px:hover {\n    --transform-translate-x: 1px;\n  }\n\n  .sm\\:hover\\:-translate-x-1:hover {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .sm\\:hover\\:-translate-x-2:hover {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .sm\\:hover\\:-translate-x-3:hover {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .sm\\:hover\\:-translate-x-4:hover {\n    --transform-translate-x: -1rem;\n  }\n\n  .sm\\:hover\\:-translate-x-5:hover {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .sm\\:hover\\:-translate-x-6:hover {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .sm\\:hover\\:-translate-x-8:hover {\n    --transform-translate-x: -2rem;\n  }\n\n  .sm\\:hover\\:-translate-x-10:hover {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .sm\\:hover\\:-translate-x-12:hover {\n    --transform-translate-x: -3rem;\n  }\n\n  .sm\\:hover\\:-translate-x-16:hover {\n    --transform-translate-x: -4rem;\n  }\n\n  .sm\\:hover\\:-translate-x-20:hover {\n    --transform-translate-x: -5rem;\n  }\n\n  .sm\\:hover\\:-translate-x-24:hover {\n    --transform-translate-x: -6rem;\n  }\n\n  .sm\\:hover\\:-translate-x-32:hover {\n    --transform-translate-x: -8rem;\n  }\n\n  .sm\\:hover\\:-translate-x-40:hover {\n    --transform-translate-x: -10rem;\n  }\n\n  .sm\\:hover\\:-translate-x-48:hover {\n    --transform-translate-x: -12rem;\n  }\n\n  .sm\\:hover\\:-translate-x-56:hover {\n    --transform-translate-x: -14rem;\n  }\n\n  .sm\\:hover\\:-translate-x-64:hover {\n    --transform-translate-x: -16rem;\n  }\n\n  .sm\\:hover\\:-translate-x-px:hover {\n    --transform-translate-x: -1px;\n  }\n\n  .sm\\:hover\\:-translate-x-full:hover {\n    --transform-translate-x: -100%;\n  }\n\n  .sm\\:hover\\:-translate-x-1\\/2:hover {\n    --transform-translate-x: -50%;\n  }\n\n  .sm\\:hover\\:translate-x-1\\/2:hover {\n    --transform-translate-x: 50%;\n  }\n\n  .sm\\:hover\\:translate-x-full:hover {\n    --transform-translate-x: 100%;\n  }\n\n  .sm\\:hover\\:translate-y-0:hover {\n    --transform-translate-y: 0;\n  }\n\n  .sm\\:hover\\:translate-y-1:hover {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .sm\\:hover\\:translate-y-2:hover {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .sm\\:hover\\:translate-y-3:hover {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .sm\\:hover\\:translate-y-4:hover {\n    --transform-translate-y: 1rem;\n  }\n\n  .sm\\:hover\\:translate-y-5:hover {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .sm\\:hover\\:translate-y-6:hover {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .sm\\:hover\\:translate-y-8:hover {\n    --transform-translate-y: 2rem;\n  }\n\n  .sm\\:hover\\:translate-y-10:hover {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .sm\\:hover\\:translate-y-12:hover {\n    --transform-translate-y: 3rem;\n  }\n\n  .sm\\:hover\\:translate-y-16:hover {\n    --transform-translate-y: 4rem;\n  }\n\n  .sm\\:hover\\:translate-y-20:hover {\n    --transform-translate-y: 5rem;\n  }\n\n  .sm\\:hover\\:translate-y-24:hover {\n    --transform-translate-y: 6rem;\n  }\n\n  .sm\\:hover\\:translate-y-32:hover {\n    --transform-translate-y: 8rem;\n  }\n\n  .sm\\:hover\\:translate-y-40:hover {\n    --transform-translate-y: 10rem;\n  }\n\n  .sm\\:hover\\:translate-y-48:hover {\n    --transform-translate-y: 12rem;\n  }\n\n  .sm\\:hover\\:translate-y-56:hover {\n    --transform-translate-y: 14rem;\n  }\n\n  .sm\\:hover\\:translate-y-64:hover {\n    --transform-translate-y: 16rem;\n  }\n\n  .sm\\:hover\\:translate-y-px:hover {\n    --transform-translate-y: 1px;\n  }\n\n  .sm\\:hover\\:-translate-y-1:hover {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .sm\\:hover\\:-translate-y-2:hover {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .sm\\:hover\\:-translate-y-3:hover {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .sm\\:hover\\:-translate-y-4:hover {\n    --transform-translate-y: -1rem;\n  }\n\n  .sm\\:hover\\:-translate-y-5:hover {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .sm\\:hover\\:-translate-y-6:hover {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .sm\\:hover\\:-translate-y-8:hover {\n    --transform-translate-y: -2rem;\n  }\n\n  .sm\\:hover\\:-translate-y-10:hover {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .sm\\:hover\\:-translate-y-12:hover {\n    --transform-translate-y: -3rem;\n  }\n\n  .sm\\:hover\\:-translate-y-16:hover {\n    --transform-translate-y: -4rem;\n  }\n\n  .sm\\:hover\\:-translate-y-20:hover {\n    --transform-translate-y: -5rem;\n  }\n\n  .sm\\:hover\\:-translate-y-24:hover {\n    --transform-translate-y: -6rem;\n  }\n\n  .sm\\:hover\\:-translate-y-32:hover {\n    --transform-translate-y: -8rem;\n  }\n\n  .sm\\:hover\\:-translate-y-40:hover {\n    --transform-translate-y: -10rem;\n  }\n\n  .sm\\:hover\\:-translate-y-48:hover {\n    --transform-translate-y: -12rem;\n  }\n\n  .sm\\:hover\\:-translate-y-56:hover {\n    --transform-translate-y: -14rem;\n  }\n\n  .sm\\:hover\\:-translate-y-64:hover {\n    --transform-translate-y: -16rem;\n  }\n\n  .sm\\:hover\\:-translate-y-px:hover {\n    --transform-translate-y: -1px;\n  }\n\n  .sm\\:hover\\:-translate-y-full:hover {\n    --transform-translate-y: -100%;\n  }\n\n  .sm\\:hover\\:-translate-y-1\\/2:hover {\n    --transform-translate-y: -50%;\n  }\n\n  .sm\\:hover\\:translate-y-1\\/2:hover {\n    --transform-translate-y: 50%;\n  }\n\n  .sm\\:hover\\:translate-y-full:hover {\n    --transform-translate-y: 100%;\n  }\n\n  .sm\\:focus\\:translate-x-0:focus {\n    --transform-translate-x: 0;\n  }\n\n  .sm\\:focus\\:translate-x-1:focus {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .sm\\:focus\\:translate-x-2:focus {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .sm\\:focus\\:translate-x-3:focus {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .sm\\:focus\\:translate-x-4:focus {\n    --transform-translate-x: 1rem;\n  }\n\n  .sm\\:focus\\:translate-x-5:focus {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .sm\\:focus\\:translate-x-6:focus {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .sm\\:focus\\:translate-x-8:focus {\n    --transform-translate-x: 2rem;\n  }\n\n  .sm\\:focus\\:translate-x-10:focus {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .sm\\:focus\\:translate-x-12:focus {\n    --transform-translate-x: 3rem;\n  }\n\n  .sm\\:focus\\:translate-x-16:focus {\n    --transform-translate-x: 4rem;\n  }\n\n  .sm\\:focus\\:translate-x-20:focus {\n    --transform-translate-x: 5rem;\n  }\n\n  .sm\\:focus\\:translate-x-24:focus {\n    --transform-translate-x: 6rem;\n  }\n\n  .sm\\:focus\\:translate-x-32:focus {\n    --transform-translate-x: 8rem;\n  }\n\n  .sm\\:focus\\:translate-x-40:focus {\n    --transform-translate-x: 10rem;\n  }\n\n  .sm\\:focus\\:translate-x-48:focus {\n    --transform-translate-x: 12rem;\n  }\n\n  .sm\\:focus\\:translate-x-56:focus {\n    --transform-translate-x: 14rem;\n  }\n\n  .sm\\:focus\\:translate-x-64:focus {\n    --transform-translate-x: 16rem;\n  }\n\n  .sm\\:focus\\:translate-x-px:focus {\n    --transform-translate-x: 1px;\n  }\n\n  .sm\\:focus\\:-translate-x-1:focus {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .sm\\:focus\\:-translate-x-2:focus {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .sm\\:focus\\:-translate-x-3:focus {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .sm\\:focus\\:-translate-x-4:focus {\n    --transform-translate-x: -1rem;\n  }\n\n  .sm\\:focus\\:-translate-x-5:focus {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .sm\\:focus\\:-translate-x-6:focus {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .sm\\:focus\\:-translate-x-8:focus {\n    --transform-translate-x: -2rem;\n  }\n\n  .sm\\:focus\\:-translate-x-10:focus {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .sm\\:focus\\:-translate-x-12:focus {\n    --transform-translate-x: -3rem;\n  }\n\n  .sm\\:focus\\:-translate-x-16:focus {\n    --transform-translate-x: -4rem;\n  }\n\n  .sm\\:focus\\:-translate-x-20:focus {\n    --transform-translate-x: -5rem;\n  }\n\n  .sm\\:focus\\:-translate-x-24:focus {\n    --transform-translate-x: -6rem;\n  }\n\n  .sm\\:focus\\:-translate-x-32:focus {\n    --transform-translate-x: -8rem;\n  }\n\n  .sm\\:focus\\:-translate-x-40:focus {\n    --transform-translate-x: -10rem;\n  }\n\n  .sm\\:focus\\:-translate-x-48:focus {\n    --transform-translate-x: -12rem;\n  }\n\n  .sm\\:focus\\:-translate-x-56:focus {\n    --transform-translate-x: -14rem;\n  }\n\n  .sm\\:focus\\:-translate-x-64:focus {\n    --transform-translate-x: -16rem;\n  }\n\n  .sm\\:focus\\:-translate-x-px:focus {\n    --transform-translate-x: -1px;\n  }\n\n  .sm\\:focus\\:-translate-x-full:focus {\n    --transform-translate-x: -100%;\n  }\n\n  .sm\\:focus\\:-translate-x-1\\/2:focus {\n    --transform-translate-x: -50%;\n  }\n\n  .sm\\:focus\\:translate-x-1\\/2:focus {\n    --transform-translate-x: 50%;\n  }\n\n  .sm\\:focus\\:translate-x-full:focus {\n    --transform-translate-x: 100%;\n  }\n\n  .sm\\:focus\\:translate-y-0:focus {\n    --transform-translate-y: 0;\n  }\n\n  .sm\\:focus\\:translate-y-1:focus {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .sm\\:focus\\:translate-y-2:focus {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .sm\\:focus\\:translate-y-3:focus {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .sm\\:focus\\:translate-y-4:focus {\n    --transform-translate-y: 1rem;\n  }\n\n  .sm\\:focus\\:translate-y-5:focus {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .sm\\:focus\\:translate-y-6:focus {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .sm\\:focus\\:translate-y-8:focus {\n    --transform-translate-y: 2rem;\n  }\n\n  .sm\\:focus\\:translate-y-10:focus {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .sm\\:focus\\:translate-y-12:focus {\n    --transform-translate-y: 3rem;\n  }\n\n  .sm\\:focus\\:translate-y-16:focus {\n    --transform-translate-y: 4rem;\n  }\n\n  .sm\\:focus\\:translate-y-20:focus {\n    --transform-translate-y: 5rem;\n  }\n\n  .sm\\:focus\\:translate-y-24:focus {\n    --transform-translate-y: 6rem;\n  }\n\n  .sm\\:focus\\:translate-y-32:focus {\n    --transform-translate-y: 8rem;\n  }\n\n  .sm\\:focus\\:translate-y-40:focus {\n    --transform-translate-y: 10rem;\n  }\n\n  .sm\\:focus\\:translate-y-48:focus {\n    --transform-translate-y: 12rem;\n  }\n\n  .sm\\:focus\\:translate-y-56:focus {\n    --transform-translate-y: 14rem;\n  }\n\n  .sm\\:focus\\:translate-y-64:focus {\n    --transform-translate-y: 16rem;\n  }\n\n  .sm\\:focus\\:translate-y-px:focus {\n    --transform-translate-y: 1px;\n  }\n\n  .sm\\:focus\\:-translate-y-1:focus {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .sm\\:focus\\:-translate-y-2:focus {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .sm\\:focus\\:-translate-y-3:focus {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .sm\\:focus\\:-translate-y-4:focus {\n    --transform-translate-y: -1rem;\n  }\n\n  .sm\\:focus\\:-translate-y-5:focus {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .sm\\:focus\\:-translate-y-6:focus {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .sm\\:focus\\:-translate-y-8:focus {\n    --transform-translate-y: -2rem;\n  }\n\n  .sm\\:focus\\:-translate-y-10:focus {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .sm\\:focus\\:-translate-y-12:focus {\n    --transform-translate-y: -3rem;\n  }\n\n  .sm\\:focus\\:-translate-y-16:focus {\n    --transform-translate-y: -4rem;\n  }\n\n  .sm\\:focus\\:-translate-y-20:focus {\n    --transform-translate-y: -5rem;\n  }\n\n  .sm\\:focus\\:-translate-y-24:focus {\n    --transform-translate-y: -6rem;\n  }\n\n  .sm\\:focus\\:-translate-y-32:focus {\n    --transform-translate-y: -8rem;\n  }\n\n  .sm\\:focus\\:-translate-y-40:focus {\n    --transform-translate-y: -10rem;\n  }\n\n  .sm\\:focus\\:-translate-y-48:focus {\n    --transform-translate-y: -12rem;\n  }\n\n  .sm\\:focus\\:-translate-y-56:focus {\n    --transform-translate-y: -14rem;\n  }\n\n  .sm\\:focus\\:-translate-y-64:focus {\n    --transform-translate-y: -16rem;\n  }\n\n  .sm\\:focus\\:-translate-y-px:focus {\n    --transform-translate-y: -1px;\n  }\n\n  .sm\\:focus\\:-translate-y-full:focus {\n    --transform-translate-y: -100%;\n  }\n\n  .sm\\:focus\\:-translate-y-1\\/2:focus {\n    --transform-translate-y: -50%;\n  }\n\n  .sm\\:focus\\:translate-y-1\\/2:focus {\n    --transform-translate-y: 50%;\n  }\n\n  .sm\\:focus\\:translate-y-full:focus {\n    --transform-translate-y: 100%;\n  }\n\n  .sm\\:skew-x-0 {\n    --transform-skew-x: 0;\n  }\n\n  .sm\\:skew-x-1 {\n    --transform-skew-x: 1deg;\n  }\n\n  .sm\\:skew-x-2 {\n    --transform-skew-x: 2deg;\n  }\n\n  .sm\\:skew-x-3 {\n    --transform-skew-x: 3deg;\n  }\n\n  .sm\\:skew-x-6 {\n    --transform-skew-x: 6deg;\n  }\n\n  .sm\\:skew-x-12 {\n    --transform-skew-x: 12deg;\n  }\n\n  .sm\\:-skew-x-12 {\n    --transform-skew-x: -12deg;\n  }\n\n  .sm\\:-skew-x-6 {\n    --transform-skew-x: -6deg;\n  }\n\n  .sm\\:-skew-x-3 {\n    --transform-skew-x: -3deg;\n  }\n\n  .sm\\:-skew-x-2 {\n    --transform-skew-x: -2deg;\n  }\n\n  .sm\\:-skew-x-1 {\n    --transform-skew-x: -1deg;\n  }\n\n  .sm\\:skew-y-0 {\n    --transform-skew-y: 0;\n  }\n\n  .sm\\:skew-y-1 {\n    --transform-skew-y: 1deg;\n  }\n\n  .sm\\:skew-y-2 {\n    --transform-skew-y: 2deg;\n  }\n\n  .sm\\:skew-y-3 {\n    --transform-skew-y: 3deg;\n  }\n\n  .sm\\:skew-y-6 {\n    --transform-skew-y: 6deg;\n  }\n\n  .sm\\:skew-y-12 {\n    --transform-skew-y: 12deg;\n  }\n\n  .sm\\:-skew-y-12 {\n    --transform-skew-y: -12deg;\n  }\n\n  .sm\\:-skew-y-6 {\n    --transform-skew-y: -6deg;\n  }\n\n  .sm\\:-skew-y-3 {\n    --transform-skew-y: -3deg;\n  }\n\n  .sm\\:-skew-y-2 {\n    --transform-skew-y: -2deg;\n  }\n\n  .sm\\:-skew-y-1 {\n    --transform-skew-y: -1deg;\n  }\n\n  .sm\\:hover\\:skew-x-0:hover {\n    --transform-skew-x: 0;\n  }\n\n  .sm\\:hover\\:skew-x-1:hover {\n    --transform-skew-x: 1deg;\n  }\n\n  .sm\\:hover\\:skew-x-2:hover {\n    --transform-skew-x: 2deg;\n  }\n\n  .sm\\:hover\\:skew-x-3:hover {\n    --transform-skew-x: 3deg;\n  }\n\n  .sm\\:hover\\:skew-x-6:hover {\n    --transform-skew-x: 6deg;\n  }\n\n  .sm\\:hover\\:skew-x-12:hover {\n    --transform-skew-x: 12deg;\n  }\n\n  .sm\\:hover\\:-skew-x-12:hover {\n    --transform-skew-x: -12deg;\n  }\n\n  .sm\\:hover\\:-skew-x-6:hover {\n    --transform-skew-x: -6deg;\n  }\n\n  .sm\\:hover\\:-skew-x-3:hover {\n    --transform-skew-x: -3deg;\n  }\n\n  .sm\\:hover\\:-skew-x-2:hover {\n    --transform-skew-x: -2deg;\n  }\n\n  .sm\\:hover\\:-skew-x-1:hover {\n    --transform-skew-x: -1deg;\n  }\n\n  .sm\\:hover\\:skew-y-0:hover {\n    --transform-skew-y: 0;\n  }\n\n  .sm\\:hover\\:skew-y-1:hover {\n    --transform-skew-y: 1deg;\n  }\n\n  .sm\\:hover\\:skew-y-2:hover {\n    --transform-skew-y: 2deg;\n  }\n\n  .sm\\:hover\\:skew-y-3:hover {\n    --transform-skew-y: 3deg;\n  }\n\n  .sm\\:hover\\:skew-y-6:hover {\n    --transform-skew-y: 6deg;\n  }\n\n  .sm\\:hover\\:skew-y-12:hover {\n    --transform-skew-y: 12deg;\n  }\n\n  .sm\\:hover\\:-skew-y-12:hover {\n    --transform-skew-y: -12deg;\n  }\n\n  .sm\\:hover\\:-skew-y-6:hover {\n    --transform-skew-y: -6deg;\n  }\n\n  .sm\\:hover\\:-skew-y-3:hover {\n    --transform-skew-y: -3deg;\n  }\n\n  .sm\\:hover\\:-skew-y-2:hover {\n    --transform-skew-y: -2deg;\n  }\n\n  .sm\\:hover\\:-skew-y-1:hover {\n    --transform-skew-y: -1deg;\n  }\n\n  .sm\\:focus\\:skew-x-0:focus {\n    --transform-skew-x: 0;\n  }\n\n  .sm\\:focus\\:skew-x-1:focus {\n    --transform-skew-x: 1deg;\n  }\n\n  .sm\\:focus\\:skew-x-2:focus {\n    --transform-skew-x: 2deg;\n  }\n\n  .sm\\:focus\\:skew-x-3:focus {\n    --transform-skew-x: 3deg;\n  }\n\n  .sm\\:focus\\:skew-x-6:focus {\n    --transform-skew-x: 6deg;\n  }\n\n  .sm\\:focus\\:skew-x-12:focus {\n    --transform-skew-x: 12deg;\n  }\n\n  .sm\\:focus\\:-skew-x-12:focus {\n    --transform-skew-x: -12deg;\n  }\n\n  .sm\\:focus\\:-skew-x-6:focus {\n    --transform-skew-x: -6deg;\n  }\n\n  .sm\\:focus\\:-skew-x-3:focus {\n    --transform-skew-x: -3deg;\n  }\n\n  .sm\\:focus\\:-skew-x-2:focus {\n    --transform-skew-x: -2deg;\n  }\n\n  .sm\\:focus\\:-skew-x-1:focus {\n    --transform-skew-x: -1deg;\n  }\n\n  .sm\\:focus\\:skew-y-0:focus {\n    --transform-skew-y: 0;\n  }\n\n  .sm\\:focus\\:skew-y-1:focus {\n    --transform-skew-y: 1deg;\n  }\n\n  .sm\\:focus\\:skew-y-2:focus {\n    --transform-skew-y: 2deg;\n  }\n\n  .sm\\:focus\\:skew-y-3:focus {\n    --transform-skew-y: 3deg;\n  }\n\n  .sm\\:focus\\:skew-y-6:focus {\n    --transform-skew-y: 6deg;\n  }\n\n  .sm\\:focus\\:skew-y-12:focus {\n    --transform-skew-y: 12deg;\n  }\n\n  .sm\\:focus\\:-skew-y-12:focus {\n    --transform-skew-y: -12deg;\n  }\n\n  .sm\\:focus\\:-skew-y-6:focus {\n    --transform-skew-y: -6deg;\n  }\n\n  .sm\\:focus\\:-skew-y-3:focus {\n    --transform-skew-y: -3deg;\n  }\n\n  .sm\\:focus\\:-skew-y-2:focus {\n    --transform-skew-y: -2deg;\n  }\n\n  .sm\\:focus\\:-skew-y-1:focus {\n    --transform-skew-y: -1deg;\n  }\n\n  .sm\\:transition-none {\n    transition-property: none;\n  }\n\n  .sm\\:transition-all {\n    transition-property: all;\n  }\n\n  .sm\\:transition {\n    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n  }\n\n  .sm\\:transition-colors {\n    transition-property: background-color, border-color, color, fill, stroke;\n  }\n\n  .sm\\:transition-opacity {\n    transition-property: opacity;\n  }\n\n  .sm\\:transition-shadow {\n    transition-property: box-shadow;\n  }\n\n  .sm\\:transition-transform {\n    transition-property: transform;\n  }\n\n  .sm\\:ease-linear {\n    transition-timing-function: linear;\n  }\n\n  .sm\\:ease-in {\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  }\n\n  .sm\\:ease-out {\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n\n  .sm\\:ease-in-out {\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .sm\\:duration-75 {\n    transition-duration: 75ms;\n  }\n\n  .sm\\:duration-100 {\n    transition-duration: 100ms;\n  }\n\n  .sm\\:duration-150 {\n    transition-duration: 150ms;\n  }\n\n  .sm\\:duration-200 {\n    transition-duration: 200ms;\n  }\n\n  .sm\\:duration-300 {\n    transition-duration: 300ms;\n  }\n\n  .sm\\:duration-500 {\n    transition-duration: 500ms;\n  }\n\n  .sm\\:duration-700 {\n    transition-duration: 700ms;\n  }\n\n  .sm\\:duration-1000 {\n    transition-duration: 1000ms;\n  }\n\n  .sm\\:delay-75 {\n    transition-delay: 75ms;\n  }\n\n  .sm\\:delay-100 {\n    transition-delay: 100ms;\n  }\n\n  .sm\\:delay-150 {\n    transition-delay: 150ms;\n  }\n\n  .sm\\:delay-200 {\n    transition-delay: 200ms;\n  }\n\n  .sm\\:delay-300 {\n    transition-delay: 300ms;\n  }\n\n  .sm\\:delay-500 {\n    transition-delay: 500ms;\n  }\n\n  .sm\\:delay-700 {\n    transition-delay: 700ms;\n  }\n\n  .sm\\:delay-1000 {\n    transition-delay: 1000ms;\n  }\n\n  .sm\\:animate-none {\n    animation: none;\n  }\n\n  .sm\\:animate-spin {\n    animation: spin 1s linear infinite;\n  }\n\n  .sm\\:animate-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n\n  .sm\\:animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n\n  .sm\\:animate-bounce {\n    animation: bounce 1s infinite;\n  }\n}\n\n@media (min-width: 768px) {\n  .md\\:container {\n    width: 100%;\n  }\n\n  @media (min-width: 640px) {\n    .md\\:container {\n      max-width: 640px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .md\\:container {\n      max-width: 768px;\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .md\\:container {\n      max-width: 1024px;\n    }\n  }\n\n  @media (min-width: 1280px) {\n    .md\\:container {\n      max-width: 1280px;\n    }\n  }\n\n  .md\\:space-y-0 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0px * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-0 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0px * var(--space-x-reverse));\n    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-1 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.25rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-1 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.25rem * var(--space-x-reverse));\n    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-2 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.5rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-2 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-3 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.75rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-3 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.75rem * var(--space-x-reverse));\n    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-4 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-4 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1rem * var(--space-x-reverse));\n    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-5 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.25rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-5 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.25rem * var(--space-x-reverse));\n    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-6 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.5rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-6 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.5rem * var(--space-x-reverse));\n    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-8 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-8 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2rem * var(--space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-10 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.5rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-10 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.5rem * var(--space-x-reverse));\n    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-12 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-12 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3rem * var(--space-x-reverse));\n    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-16 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(4rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-16 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(4rem * var(--space-x-reverse));\n    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-20 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(5rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-20 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(5rem * var(--space-x-reverse));\n    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-24 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(6rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-24 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(6rem * var(--space-x-reverse));\n    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-32 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-32 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8rem * var(--space-x-reverse));\n    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-40 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(10rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-40 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(10rem * var(--space-x-reverse));\n    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-48 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(12rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-48 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(12rem * var(--space-x-reverse));\n    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-56 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(14rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-56 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(14rem * var(--space-x-reverse));\n    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-64 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16rem * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-64 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16rem * var(--space-x-reverse));\n    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-px > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1px * var(--space-y-reverse));\n  }\n\n  .md\\:space-x-px > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1px * var(--space-x-reverse));\n    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-1 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-1 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.25rem * var(--space-x-reverse));\n    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-2 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-2 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.5rem * var(--space-x-reverse));\n    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-3 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-3 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.75rem * var(--space-x-reverse));\n    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-4 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-4 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1rem * var(--space-x-reverse));\n    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-5 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-5 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.25rem * var(--space-x-reverse));\n    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-6 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-6 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.5rem * var(--space-x-reverse));\n    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-8 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-8 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2rem * var(--space-x-reverse));\n    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-10 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-10 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.5rem * var(--space-x-reverse));\n    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-12 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-12 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3rem * var(--space-x-reverse));\n    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-16 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-4rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-16 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-4rem * var(--space-x-reverse));\n    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-20 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-5rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-20 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-5rem * var(--space-x-reverse));\n    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-24 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-6rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-24 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-6rem * var(--space-x-reverse));\n    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-32 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-32 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8rem * var(--space-x-reverse));\n    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-40 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-10rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-40 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-10rem * var(--space-x-reverse));\n    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-48 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-12rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-48 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-12rem * var(--space-x-reverse));\n    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-56 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-14rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-56 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-14rem * var(--space-x-reverse));\n    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-64 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16rem * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-64 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16rem * var(--space-x-reverse));\n    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:-space-y-px > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1px * var(--space-y-reverse));\n  }\n\n  .md\\:-space-x-px > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1px * var(--space-x-reverse));\n    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .md\\:space-y-reverse > :not(template) ~ :not(template) {\n    --space-y-reverse: 1;\n  }\n\n  .md\\:space-x-reverse > :not(template) ~ :not(template) {\n    --space-x-reverse: 1;\n  }\n\n  .md\\:divide-y-0 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(0px * var(--divide-y-reverse));\n  }\n\n  .md\\:divide-x-0 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(0px * var(--divide-x-reverse));\n    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .md\\:divide-y-2 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(2px * var(--divide-y-reverse));\n  }\n\n  .md\\:divide-x-2 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .md\\:divide-y-4 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(4px * var(--divide-y-reverse));\n  }\n\n  .md\\:divide-x-4 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(4px * var(--divide-x-reverse));\n    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .md\\:divide-y-8 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(8px * var(--divide-y-reverse));\n  }\n\n  .md\\:divide-x-8 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(8px * var(--divide-x-reverse));\n    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .md\\:divide-y > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(1px * var(--divide-y-reverse));\n  }\n\n  .md\\:divide-x > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(1px * var(--divide-x-reverse));\n    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .md\\:divide-y-reverse > :not(template) ~ :not(template) {\n    --divide-y-reverse: 1;\n  }\n\n  .md\\:divide-x-reverse > :not(template) ~ :not(template) {\n    --divide-x-reverse: 1;\n  }\n\n  .md\\:divide-transparent > :not(template) ~ :not(template) {\n    border-color: transparent;\n  }\n\n  .md\\:divide-current > :not(template) ~ :not(template) {\n    border-color: currentColor;\n  }\n\n  .md\\:divide-black > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--divide-opacity));\n  }\n\n  .md\\:divide-white > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--divide-opacity));\n  }\n\n  .md\\:divide-gray-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--divide-opacity));\n  }\n\n  .md\\:divide-red-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--divide-opacity));\n  }\n\n  .md\\:divide-orange-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--divide-opacity));\n  }\n\n  .md\\:divide-yellow-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--divide-opacity));\n  }\n\n  .md\\:divide-green-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--divide-opacity));\n  }\n\n  .md\\:divide-teal-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--divide-opacity));\n  }\n\n  .md\\:divide-blue-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--divide-opacity));\n  }\n\n  .md\\:divide-indigo-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--divide-opacity));\n  }\n\n  .md\\:divide-purple-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--divide-opacity));\n  }\n\n  .md\\:divide-pink-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--divide-opacity));\n  }\n\n  .md\\:divide-solid > :not(template) ~ :not(template) {\n    border-style: solid;\n  }\n\n  .md\\:divide-dashed > :not(template) ~ :not(template) {\n    border-style: dashed;\n  }\n\n  .md\\:divide-dotted > :not(template) ~ :not(template) {\n    border-style: dotted;\n  }\n\n  .md\\:divide-double > :not(template) ~ :not(template) {\n    border-style: double;\n  }\n\n  .md\\:divide-none > :not(template) ~ :not(template) {\n    border-style: none;\n  }\n\n  .md\\:divide-opacity-0 > :not(template) ~ :not(template) {\n    --divide-opacity: 0;\n  }\n\n  .md\\:divide-opacity-25 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.25;\n  }\n\n  .md\\:divide-opacity-50 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.5;\n  }\n\n  .md\\:divide-opacity-75 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.75;\n  }\n\n  .md\\:divide-opacity-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n  }\n\n  .md\\:sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n\n  .md\\:not-sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n\n  .md\\:focus\\:sr-only:focus {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n\n  .md\\:focus\\:not-sr-only:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n\n  .md\\:appearance-none {\n    appearance: none;\n  }\n\n  .md\\:bg-fixed {\n    background-attachment: fixed;\n  }\n\n  .md\\:bg-local {\n    background-attachment: local;\n  }\n\n  .md\\:bg-scroll {\n    background-attachment: scroll;\n  }\n\n  .md\\:bg-clip-border {\n    background-clip: border-box;\n  }\n\n  .md\\:bg-clip-padding {\n    background-clip: padding-box;\n  }\n\n  .md\\:bg-clip-content {\n    background-clip: content-box;\n  }\n\n  .md\\:bg-clip-text {\n    -webkit-background-clip: text;\n            background-clip: text;\n  }\n\n  .md\\:bg-transparent {\n    background-color: transparent;\n  }\n\n  .md\\:bg-current {\n    background-color: currentColor;\n  }\n\n  .md\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .md\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .md\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .md\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .md\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .md\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .md\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .md\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .md\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .md\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .md\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .md\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n  }\n\n  .md\\:hover\\:bg-current:hover {\n    background-color: currentColor;\n  }\n\n  .md\\:hover\\:bg-black:hover {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-white:hover {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-100:hover {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-200:hover {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-300:hover {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-400:hover {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-500:hover {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-600:hover {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-700:hover {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-800:hover {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-red-900:hover {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-100:hover {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-200:hover {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-300:hover {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-400:hover {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-500:hover {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-600:hover {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-700:hover {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-800:hover {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-orange-900:hover {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-100:hover {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-200:hover {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-300:hover {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-400:hover {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-500:hover {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-600:hover {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-700:hover {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-800:hover {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-yellow-900:hover {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-100:hover {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-200:hover {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-300:hover {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-400:hover {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-500:hover {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-600:hover {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-700:hover {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-800:hover {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-green-900:hover {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-100:hover {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-200:hover {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-300:hover {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-400:hover {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-500:hover {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-600:hover {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-700:hover {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-800:hover {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-teal-900:hover {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-100:hover {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-200:hover {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-300:hover {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-400:hover {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-500:hover {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-600:hover {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-700:hover {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-800:hover {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-blue-900:hover {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-100:hover {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-200:hover {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-300:hover {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-400:hover {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-500:hover {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-600:hover {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-700:hover {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-800:hover {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-indigo-900:hover {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-100:hover {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-200:hover {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-300:hover {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-400:hover {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-500:hover {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-600:hover {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-700:hover {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-800:hover {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-purple-900:hover {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-100:hover {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-200:hover {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-300:hover {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-400:hover {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-500:hover {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-600:hover {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-700:hover {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-800:hover {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .md\\:hover\\:bg-pink-900:hover {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-transparent:focus {\n    background-color: transparent;\n  }\n\n  .md\\:focus\\:bg-current:focus {\n    background-color: currentColor;\n  }\n\n  .md\\:focus\\:bg-black:focus {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-white:focus {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-100:focus {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-200:focus {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-300:focus {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-400:focus {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-500:focus {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-600:focus {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-700:focus {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-800:focus {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-red-900:focus {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-100:focus {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-200:focus {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-300:focus {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-400:focus {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-500:focus {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-600:focus {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-700:focus {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-800:focus {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-orange-900:focus {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-100:focus {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-200:focus {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-300:focus {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-400:focus {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-500:focus {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-600:focus {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-700:focus {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-800:focus {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-yellow-900:focus {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-100:focus {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-200:focus {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-300:focus {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-400:focus {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-500:focus {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-600:focus {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-700:focus {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-800:focus {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-green-900:focus {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-100:focus {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-200:focus {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-300:focus {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-400:focus {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-500:focus {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-600:focus {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-700:focus {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-800:focus {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-teal-900:focus {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-100:focus {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-200:focus {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-300:focus {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-400:focus {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-500:focus {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-600:focus {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-700:focus {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-800:focus {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-blue-900:focus {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-100:focus {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-200:focus {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-300:focus {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-400:focus {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-500:focus {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-600:focus {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-700:focus {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-800:focus {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-indigo-900:focus {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-100:focus {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-200:focus {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-300:focus {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-400:focus {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-500:focus {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-600:focus {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-700:focus {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-800:focus {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-purple-900:focus {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-100:focus {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-200:focus {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-300:focus {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-400:focus {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-500:focus {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-600:focus {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-700:focus {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-800:focus {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .md\\:focus\\:bg-pink-900:focus {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .md\\:bg-none {\n    background-image: none;\n  }\n\n  .md\\:bg-gradient-to-t {\n    background-image: linear-gradient(to top, var(--gradient-color-stops));\n  }\n\n  .md\\:bg-gradient-to-tr {\n    background-image: linear-gradient(to top right, var(--gradient-color-stops));\n  }\n\n  .md\\:bg-gradient-to-r {\n    background-image: linear-gradient(to right, var(--gradient-color-stops));\n  }\n\n  .md\\:bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n  }\n\n  .md\\:bg-gradient-to-b {\n    background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n  }\n\n  .md\\:bg-gradient-to-bl {\n    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n  }\n\n  .md\\:bg-gradient-to-l {\n    background-image: linear-gradient(to left, var(--gradient-color-stops));\n  }\n\n  .md\\:bg-gradient-to-tl {\n    background-image: linear-gradient(to top left, var(--gradient-color-stops));\n  }\n\n  .md\\:from-transparent {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:from-current {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:from-black {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:from-white {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:from-gray-100 {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .md\\:from-gray-200 {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .md\\:from-gray-300 {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .md\\:from-gray-400 {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .md\\:from-gray-500 {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .md\\:from-gray-600 {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .md\\:from-gray-700 {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .md\\:from-gray-800 {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .md\\:from-gray-900 {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .md\\:from-red-100 {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .md\\:from-red-200 {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .md\\:from-red-300 {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .md\\:from-red-400 {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .md\\:from-red-500 {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .md\\:from-red-600 {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .md\\:from-red-700 {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .md\\:from-red-800 {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .md\\:from-red-900 {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .md\\:from-orange-100 {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .md\\:from-orange-200 {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .md\\:from-orange-300 {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .md\\:from-orange-400 {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .md\\:from-orange-500 {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .md\\:from-orange-600 {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .md\\:from-orange-700 {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .md\\:from-orange-800 {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .md\\:from-orange-900 {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .md\\:from-yellow-100 {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .md\\:from-yellow-200 {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .md\\:from-yellow-300 {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .md\\:from-yellow-400 {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .md\\:from-yellow-500 {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .md\\:from-yellow-600 {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .md\\:from-yellow-700 {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .md\\:from-yellow-800 {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .md\\:from-yellow-900 {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .md\\:from-green-100 {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .md\\:from-green-200 {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .md\\:from-green-300 {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .md\\:from-green-400 {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .md\\:from-green-500 {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .md\\:from-green-600 {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .md\\:from-green-700 {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .md\\:from-green-800 {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .md\\:from-green-900 {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .md\\:from-teal-100 {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .md\\:from-teal-200 {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .md\\:from-teal-300 {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .md\\:from-teal-400 {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .md\\:from-teal-500 {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .md\\:from-teal-600 {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .md\\:from-teal-700 {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .md\\:from-teal-800 {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .md\\:from-teal-900 {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .md\\:from-blue-100 {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .md\\:from-blue-200 {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .md\\:from-blue-300 {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .md\\:from-blue-400 {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .md\\:from-blue-500 {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .md\\:from-blue-600 {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .md\\:from-blue-700 {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .md\\:from-blue-800 {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .md\\:from-blue-900 {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .md\\:from-indigo-100 {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .md\\:from-indigo-200 {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .md\\:from-indigo-300 {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .md\\:from-indigo-400 {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .md\\:from-indigo-500 {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .md\\:from-indigo-600 {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .md\\:from-indigo-700 {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .md\\:from-indigo-800 {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .md\\:from-indigo-900 {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .md\\:from-purple-100 {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .md\\:from-purple-200 {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .md\\:from-purple-300 {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .md\\:from-purple-400 {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .md\\:from-purple-500 {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .md\\:from-purple-600 {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .md\\:from-purple-700 {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .md\\:from-purple-800 {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .md\\:from-purple-900 {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .md\\:from-pink-100 {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .md\\:from-pink-200 {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .md\\:from-pink-300 {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .md\\:from-pink-400 {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .md\\:from-pink-500 {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .md\\:from-pink-600 {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .md\\:from-pink-700 {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .md\\:from-pink-800 {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .md\\:from-pink-900 {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .md\\:via-transparent {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:via-current {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:via-black {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:via-white {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:via-gray-100 {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .md\\:via-gray-200 {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .md\\:via-gray-300 {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .md\\:via-gray-400 {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .md\\:via-gray-500 {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .md\\:via-gray-600 {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .md\\:via-gray-700 {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .md\\:via-gray-800 {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .md\\:via-gray-900 {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .md\\:via-red-100 {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .md\\:via-red-200 {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .md\\:via-red-300 {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .md\\:via-red-400 {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .md\\:via-red-500 {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .md\\:via-red-600 {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .md\\:via-red-700 {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .md\\:via-red-800 {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .md\\:via-red-900 {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .md\\:via-orange-100 {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .md\\:via-orange-200 {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .md\\:via-orange-300 {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .md\\:via-orange-400 {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .md\\:via-orange-500 {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .md\\:via-orange-600 {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .md\\:via-orange-700 {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .md\\:via-orange-800 {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .md\\:via-orange-900 {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .md\\:via-yellow-100 {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .md\\:via-yellow-200 {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .md\\:via-yellow-300 {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .md\\:via-yellow-400 {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .md\\:via-yellow-500 {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .md\\:via-yellow-600 {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .md\\:via-yellow-700 {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .md\\:via-yellow-800 {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .md\\:via-yellow-900 {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .md\\:via-green-100 {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .md\\:via-green-200 {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .md\\:via-green-300 {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .md\\:via-green-400 {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .md\\:via-green-500 {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .md\\:via-green-600 {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .md\\:via-green-700 {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .md\\:via-green-800 {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .md\\:via-green-900 {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .md\\:via-teal-100 {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .md\\:via-teal-200 {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .md\\:via-teal-300 {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .md\\:via-teal-400 {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .md\\:via-teal-500 {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .md\\:via-teal-600 {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .md\\:via-teal-700 {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .md\\:via-teal-800 {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .md\\:via-teal-900 {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .md\\:via-blue-100 {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .md\\:via-blue-200 {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .md\\:via-blue-300 {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .md\\:via-blue-400 {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .md\\:via-blue-500 {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .md\\:via-blue-600 {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .md\\:via-blue-700 {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .md\\:via-blue-800 {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .md\\:via-blue-900 {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .md\\:via-indigo-100 {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .md\\:via-indigo-200 {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .md\\:via-indigo-300 {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .md\\:via-indigo-400 {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .md\\:via-indigo-500 {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .md\\:via-indigo-600 {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .md\\:via-indigo-700 {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .md\\:via-indigo-800 {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .md\\:via-indigo-900 {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .md\\:via-purple-100 {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .md\\:via-purple-200 {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .md\\:via-purple-300 {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .md\\:via-purple-400 {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .md\\:via-purple-500 {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .md\\:via-purple-600 {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .md\\:via-purple-700 {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .md\\:via-purple-800 {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .md\\:via-purple-900 {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .md\\:via-pink-100 {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .md\\:via-pink-200 {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .md\\:via-pink-300 {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .md\\:via-pink-400 {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .md\\:via-pink-500 {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .md\\:via-pink-600 {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .md\\:via-pink-700 {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .md\\:via-pink-800 {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .md\\:via-pink-900 {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .md\\:to-transparent {\n    --gradient-to-color: transparent;\n  }\n\n  .md\\:to-current {\n    --gradient-to-color: currentColor;\n  }\n\n  .md\\:to-black {\n    --gradient-to-color: #000;\n  }\n\n  .md\\:to-white {\n    --gradient-to-color: #fff;\n  }\n\n  .md\\:to-gray-100 {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .md\\:to-gray-200 {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .md\\:to-gray-300 {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .md\\:to-gray-400 {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .md\\:to-gray-500 {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .md\\:to-gray-600 {\n    --gradient-to-color: #718096;\n  }\n\n  .md\\:to-gray-700 {\n    --gradient-to-color: #4a5568;\n  }\n\n  .md\\:to-gray-800 {\n    --gradient-to-color: #2d3748;\n  }\n\n  .md\\:to-gray-900 {\n    --gradient-to-color: #1a202c;\n  }\n\n  .md\\:to-red-100 {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .md\\:to-red-200 {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .md\\:to-red-300 {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .md\\:to-red-400 {\n    --gradient-to-color: #fc8181;\n  }\n\n  .md\\:to-red-500 {\n    --gradient-to-color: #f56565;\n  }\n\n  .md\\:to-red-600 {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .md\\:to-red-700 {\n    --gradient-to-color: #c53030;\n  }\n\n  .md\\:to-red-800 {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .md\\:to-red-900 {\n    --gradient-to-color: #742a2a;\n  }\n\n  .md\\:to-orange-100 {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .md\\:to-orange-200 {\n    --gradient-to-color: #feebc8;\n  }\n\n  .md\\:to-orange-300 {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .md\\:to-orange-400 {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .md\\:to-orange-500 {\n    --gradient-to-color: #ed8936;\n  }\n\n  .md\\:to-orange-600 {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .md\\:to-orange-700 {\n    --gradient-to-color: #c05621;\n  }\n\n  .md\\:to-orange-800 {\n    --gradient-to-color: #9c4221;\n  }\n\n  .md\\:to-orange-900 {\n    --gradient-to-color: #7b341e;\n  }\n\n  .md\\:to-yellow-100 {\n    --gradient-to-color: #fffff0;\n  }\n\n  .md\\:to-yellow-200 {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .md\\:to-yellow-300 {\n    --gradient-to-color: #faf089;\n  }\n\n  .md\\:to-yellow-400 {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .md\\:to-yellow-500 {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .md\\:to-yellow-600 {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .md\\:to-yellow-700 {\n    --gradient-to-color: #b7791f;\n  }\n\n  .md\\:to-yellow-800 {\n    --gradient-to-color: #975a16;\n  }\n\n  .md\\:to-yellow-900 {\n    --gradient-to-color: #744210;\n  }\n\n  .md\\:to-green-100 {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .md\\:to-green-200 {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .md\\:to-green-300 {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .md\\:to-green-400 {\n    --gradient-to-color: #68d391;\n  }\n\n  .md\\:to-green-500 {\n    --gradient-to-color: #48bb78;\n  }\n\n  .md\\:to-green-600 {\n    --gradient-to-color: #38a169;\n  }\n\n  .md\\:to-green-700 {\n    --gradient-to-color: #2f855a;\n  }\n\n  .md\\:to-green-800 {\n    --gradient-to-color: #276749;\n  }\n\n  .md\\:to-green-900 {\n    --gradient-to-color: #22543d;\n  }\n\n  .md\\:to-teal-100 {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .md\\:to-teal-200 {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .md\\:to-teal-300 {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .md\\:to-teal-400 {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .md\\:to-teal-500 {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .md\\:to-teal-600 {\n    --gradient-to-color: #319795;\n  }\n\n  .md\\:to-teal-700 {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .md\\:to-teal-800 {\n    --gradient-to-color: #285e61;\n  }\n\n  .md\\:to-teal-900 {\n    --gradient-to-color: #234e52;\n  }\n\n  .md\\:to-blue-100 {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .md\\:to-blue-200 {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .md\\:to-blue-300 {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .md\\:to-blue-400 {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .md\\:to-blue-500 {\n    --gradient-to-color: #4299e1;\n  }\n\n  .md\\:to-blue-600 {\n    --gradient-to-color: #3182ce;\n  }\n\n  .md\\:to-blue-700 {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .md\\:to-blue-800 {\n    --gradient-to-color: #2c5282;\n  }\n\n  .md\\:to-blue-900 {\n    --gradient-to-color: #2a4365;\n  }\n\n  .md\\:to-indigo-100 {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .md\\:to-indigo-200 {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .md\\:to-indigo-300 {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .md\\:to-indigo-400 {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .md\\:to-indigo-500 {\n    --gradient-to-color: #667eea;\n  }\n\n  .md\\:to-indigo-600 {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .md\\:to-indigo-700 {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .md\\:to-indigo-800 {\n    --gradient-to-color: #434190;\n  }\n\n  .md\\:to-indigo-900 {\n    --gradient-to-color: #3c366b;\n  }\n\n  .md\\:to-purple-100 {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .md\\:to-purple-200 {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .md\\:to-purple-300 {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .md\\:to-purple-400 {\n    --gradient-to-color: #b794f4;\n  }\n\n  .md\\:to-purple-500 {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .md\\:to-purple-600 {\n    --gradient-to-color: #805ad5;\n  }\n\n  .md\\:to-purple-700 {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .md\\:to-purple-800 {\n    --gradient-to-color: #553c9a;\n  }\n\n  .md\\:to-purple-900 {\n    --gradient-to-color: #44337a;\n  }\n\n  .md\\:to-pink-100 {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .md\\:to-pink-200 {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .md\\:to-pink-300 {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .md\\:to-pink-400 {\n    --gradient-to-color: #f687b3;\n  }\n\n  .md\\:to-pink-500 {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .md\\:to-pink-600 {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .md\\:to-pink-700 {\n    --gradient-to-color: #b83280;\n  }\n\n  .md\\:to-pink-800 {\n    --gradient-to-color: #97266d;\n  }\n\n  .md\\:to-pink-900 {\n    --gradient-to-color: #702459;\n  }\n\n  .md\\:hover\\:from-transparent:hover {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:hover\\:from-current:hover {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:hover\\:from-black:hover {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:hover\\:from-white:hover {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:hover\\:from-gray-100:hover {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .md\\:hover\\:from-gray-200:hover {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .md\\:hover\\:from-gray-300:hover {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .md\\:hover\\:from-gray-400:hover {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .md\\:hover\\:from-gray-500:hover {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .md\\:hover\\:from-gray-600:hover {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .md\\:hover\\:from-gray-700:hover {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .md\\:hover\\:from-gray-800:hover {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .md\\:hover\\:from-gray-900:hover {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .md\\:hover\\:from-red-100:hover {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .md\\:hover\\:from-red-200:hover {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .md\\:hover\\:from-red-300:hover {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .md\\:hover\\:from-red-400:hover {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .md\\:hover\\:from-red-500:hover {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .md\\:hover\\:from-red-600:hover {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .md\\:hover\\:from-red-700:hover {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .md\\:hover\\:from-red-800:hover {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .md\\:hover\\:from-red-900:hover {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .md\\:hover\\:from-orange-100:hover {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .md\\:hover\\:from-orange-200:hover {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .md\\:hover\\:from-orange-300:hover {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .md\\:hover\\:from-orange-400:hover {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .md\\:hover\\:from-orange-500:hover {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .md\\:hover\\:from-orange-600:hover {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .md\\:hover\\:from-orange-700:hover {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .md\\:hover\\:from-orange-800:hover {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .md\\:hover\\:from-orange-900:hover {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .md\\:hover\\:from-yellow-100:hover {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .md\\:hover\\:from-yellow-200:hover {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .md\\:hover\\:from-yellow-300:hover {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .md\\:hover\\:from-yellow-400:hover {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .md\\:hover\\:from-yellow-500:hover {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .md\\:hover\\:from-yellow-600:hover {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .md\\:hover\\:from-yellow-700:hover {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .md\\:hover\\:from-yellow-800:hover {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .md\\:hover\\:from-yellow-900:hover {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .md\\:hover\\:from-green-100:hover {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .md\\:hover\\:from-green-200:hover {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .md\\:hover\\:from-green-300:hover {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .md\\:hover\\:from-green-400:hover {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .md\\:hover\\:from-green-500:hover {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .md\\:hover\\:from-green-600:hover {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .md\\:hover\\:from-green-700:hover {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .md\\:hover\\:from-green-800:hover {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .md\\:hover\\:from-green-900:hover {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .md\\:hover\\:from-teal-100:hover {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .md\\:hover\\:from-teal-200:hover {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .md\\:hover\\:from-teal-300:hover {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .md\\:hover\\:from-teal-400:hover {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .md\\:hover\\:from-teal-500:hover {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .md\\:hover\\:from-teal-600:hover {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .md\\:hover\\:from-teal-700:hover {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .md\\:hover\\:from-teal-800:hover {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .md\\:hover\\:from-teal-900:hover {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .md\\:hover\\:from-blue-100:hover {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .md\\:hover\\:from-blue-200:hover {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .md\\:hover\\:from-blue-300:hover {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .md\\:hover\\:from-blue-400:hover {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .md\\:hover\\:from-blue-500:hover {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .md\\:hover\\:from-blue-600:hover {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .md\\:hover\\:from-blue-700:hover {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .md\\:hover\\:from-blue-800:hover {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .md\\:hover\\:from-blue-900:hover {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .md\\:hover\\:from-indigo-100:hover {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .md\\:hover\\:from-indigo-200:hover {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .md\\:hover\\:from-indigo-300:hover {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .md\\:hover\\:from-indigo-400:hover {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .md\\:hover\\:from-indigo-500:hover {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .md\\:hover\\:from-indigo-600:hover {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .md\\:hover\\:from-indigo-700:hover {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .md\\:hover\\:from-indigo-800:hover {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .md\\:hover\\:from-indigo-900:hover {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .md\\:hover\\:from-purple-100:hover {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .md\\:hover\\:from-purple-200:hover {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .md\\:hover\\:from-purple-300:hover {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .md\\:hover\\:from-purple-400:hover {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .md\\:hover\\:from-purple-500:hover {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .md\\:hover\\:from-purple-600:hover {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .md\\:hover\\:from-purple-700:hover {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .md\\:hover\\:from-purple-800:hover {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .md\\:hover\\:from-purple-900:hover {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .md\\:hover\\:from-pink-100:hover {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .md\\:hover\\:from-pink-200:hover {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .md\\:hover\\:from-pink-300:hover {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .md\\:hover\\:from-pink-400:hover {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .md\\:hover\\:from-pink-500:hover {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .md\\:hover\\:from-pink-600:hover {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .md\\:hover\\:from-pink-700:hover {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .md\\:hover\\:from-pink-800:hover {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .md\\:hover\\:from-pink-900:hover {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .md\\:hover\\:via-transparent:hover {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:hover\\:via-current:hover {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:hover\\:via-black:hover {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:hover\\:via-white:hover {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:hover\\:via-gray-100:hover {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .md\\:hover\\:via-gray-200:hover {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .md\\:hover\\:via-gray-300:hover {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .md\\:hover\\:via-gray-400:hover {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .md\\:hover\\:via-gray-500:hover {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .md\\:hover\\:via-gray-600:hover {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .md\\:hover\\:via-gray-700:hover {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .md\\:hover\\:via-gray-800:hover {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .md\\:hover\\:via-gray-900:hover {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .md\\:hover\\:via-red-100:hover {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .md\\:hover\\:via-red-200:hover {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .md\\:hover\\:via-red-300:hover {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .md\\:hover\\:via-red-400:hover {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .md\\:hover\\:via-red-500:hover {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .md\\:hover\\:via-red-600:hover {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .md\\:hover\\:via-red-700:hover {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .md\\:hover\\:via-red-800:hover {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .md\\:hover\\:via-red-900:hover {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .md\\:hover\\:via-orange-100:hover {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .md\\:hover\\:via-orange-200:hover {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .md\\:hover\\:via-orange-300:hover {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .md\\:hover\\:via-orange-400:hover {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .md\\:hover\\:via-orange-500:hover {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .md\\:hover\\:via-orange-600:hover {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .md\\:hover\\:via-orange-700:hover {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .md\\:hover\\:via-orange-800:hover {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .md\\:hover\\:via-orange-900:hover {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .md\\:hover\\:via-yellow-100:hover {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .md\\:hover\\:via-yellow-200:hover {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .md\\:hover\\:via-yellow-300:hover {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .md\\:hover\\:via-yellow-400:hover {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .md\\:hover\\:via-yellow-500:hover {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .md\\:hover\\:via-yellow-600:hover {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .md\\:hover\\:via-yellow-700:hover {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .md\\:hover\\:via-yellow-800:hover {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .md\\:hover\\:via-yellow-900:hover {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .md\\:hover\\:via-green-100:hover {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .md\\:hover\\:via-green-200:hover {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .md\\:hover\\:via-green-300:hover {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .md\\:hover\\:via-green-400:hover {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .md\\:hover\\:via-green-500:hover {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .md\\:hover\\:via-green-600:hover {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .md\\:hover\\:via-green-700:hover {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .md\\:hover\\:via-green-800:hover {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .md\\:hover\\:via-green-900:hover {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .md\\:hover\\:via-teal-100:hover {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .md\\:hover\\:via-teal-200:hover {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .md\\:hover\\:via-teal-300:hover {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .md\\:hover\\:via-teal-400:hover {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .md\\:hover\\:via-teal-500:hover {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .md\\:hover\\:via-teal-600:hover {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .md\\:hover\\:via-teal-700:hover {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .md\\:hover\\:via-teal-800:hover {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .md\\:hover\\:via-teal-900:hover {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .md\\:hover\\:via-blue-100:hover {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .md\\:hover\\:via-blue-200:hover {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .md\\:hover\\:via-blue-300:hover {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .md\\:hover\\:via-blue-400:hover {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .md\\:hover\\:via-blue-500:hover {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .md\\:hover\\:via-blue-600:hover {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .md\\:hover\\:via-blue-700:hover {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .md\\:hover\\:via-blue-800:hover {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .md\\:hover\\:via-blue-900:hover {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .md\\:hover\\:via-indigo-100:hover {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .md\\:hover\\:via-indigo-200:hover {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .md\\:hover\\:via-indigo-300:hover {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .md\\:hover\\:via-indigo-400:hover {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .md\\:hover\\:via-indigo-500:hover {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .md\\:hover\\:via-indigo-600:hover {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .md\\:hover\\:via-indigo-700:hover {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .md\\:hover\\:via-indigo-800:hover {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .md\\:hover\\:via-indigo-900:hover {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .md\\:hover\\:via-purple-100:hover {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .md\\:hover\\:via-purple-200:hover {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .md\\:hover\\:via-purple-300:hover {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .md\\:hover\\:via-purple-400:hover {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .md\\:hover\\:via-purple-500:hover {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .md\\:hover\\:via-purple-600:hover {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .md\\:hover\\:via-purple-700:hover {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .md\\:hover\\:via-purple-800:hover {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .md\\:hover\\:via-purple-900:hover {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .md\\:hover\\:via-pink-100:hover {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .md\\:hover\\:via-pink-200:hover {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .md\\:hover\\:via-pink-300:hover {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .md\\:hover\\:via-pink-400:hover {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .md\\:hover\\:via-pink-500:hover {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .md\\:hover\\:via-pink-600:hover {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .md\\:hover\\:via-pink-700:hover {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .md\\:hover\\:via-pink-800:hover {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .md\\:hover\\:via-pink-900:hover {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .md\\:hover\\:to-transparent:hover {\n    --gradient-to-color: transparent;\n  }\n\n  .md\\:hover\\:to-current:hover {\n    --gradient-to-color: currentColor;\n  }\n\n  .md\\:hover\\:to-black:hover {\n    --gradient-to-color: #000;\n  }\n\n  .md\\:hover\\:to-white:hover {\n    --gradient-to-color: #fff;\n  }\n\n  .md\\:hover\\:to-gray-100:hover {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .md\\:hover\\:to-gray-200:hover {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .md\\:hover\\:to-gray-300:hover {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .md\\:hover\\:to-gray-400:hover {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .md\\:hover\\:to-gray-500:hover {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .md\\:hover\\:to-gray-600:hover {\n    --gradient-to-color: #718096;\n  }\n\n  .md\\:hover\\:to-gray-700:hover {\n    --gradient-to-color: #4a5568;\n  }\n\n  .md\\:hover\\:to-gray-800:hover {\n    --gradient-to-color: #2d3748;\n  }\n\n  .md\\:hover\\:to-gray-900:hover {\n    --gradient-to-color: #1a202c;\n  }\n\n  .md\\:hover\\:to-red-100:hover {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .md\\:hover\\:to-red-200:hover {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .md\\:hover\\:to-red-300:hover {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .md\\:hover\\:to-red-400:hover {\n    --gradient-to-color: #fc8181;\n  }\n\n  .md\\:hover\\:to-red-500:hover {\n    --gradient-to-color: #f56565;\n  }\n\n  .md\\:hover\\:to-red-600:hover {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .md\\:hover\\:to-red-700:hover {\n    --gradient-to-color: #c53030;\n  }\n\n  .md\\:hover\\:to-red-800:hover {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .md\\:hover\\:to-red-900:hover {\n    --gradient-to-color: #742a2a;\n  }\n\n  .md\\:hover\\:to-orange-100:hover {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .md\\:hover\\:to-orange-200:hover {\n    --gradient-to-color: #feebc8;\n  }\n\n  .md\\:hover\\:to-orange-300:hover {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .md\\:hover\\:to-orange-400:hover {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .md\\:hover\\:to-orange-500:hover {\n    --gradient-to-color: #ed8936;\n  }\n\n  .md\\:hover\\:to-orange-600:hover {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .md\\:hover\\:to-orange-700:hover {\n    --gradient-to-color: #c05621;\n  }\n\n  .md\\:hover\\:to-orange-800:hover {\n    --gradient-to-color: #9c4221;\n  }\n\n  .md\\:hover\\:to-orange-900:hover {\n    --gradient-to-color: #7b341e;\n  }\n\n  .md\\:hover\\:to-yellow-100:hover {\n    --gradient-to-color: #fffff0;\n  }\n\n  .md\\:hover\\:to-yellow-200:hover {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .md\\:hover\\:to-yellow-300:hover {\n    --gradient-to-color: #faf089;\n  }\n\n  .md\\:hover\\:to-yellow-400:hover {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .md\\:hover\\:to-yellow-500:hover {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .md\\:hover\\:to-yellow-600:hover {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .md\\:hover\\:to-yellow-700:hover {\n    --gradient-to-color: #b7791f;\n  }\n\n  .md\\:hover\\:to-yellow-800:hover {\n    --gradient-to-color: #975a16;\n  }\n\n  .md\\:hover\\:to-yellow-900:hover {\n    --gradient-to-color: #744210;\n  }\n\n  .md\\:hover\\:to-green-100:hover {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .md\\:hover\\:to-green-200:hover {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .md\\:hover\\:to-green-300:hover {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .md\\:hover\\:to-green-400:hover {\n    --gradient-to-color: #68d391;\n  }\n\n  .md\\:hover\\:to-green-500:hover {\n    --gradient-to-color: #48bb78;\n  }\n\n  .md\\:hover\\:to-green-600:hover {\n    --gradient-to-color: #38a169;\n  }\n\n  .md\\:hover\\:to-green-700:hover {\n    --gradient-to-color: #2f855a;\n  }\n\n  .md\\:hover\\:to-green-800:hover {\n    --gradient-to-color: #276749;\n  }\n\n  .md\\:hover\\:to-green-900:hover {\n    --gradient-to-color: #22543d;\n  }\n\n  .md\\:hover\\:to-teal-100:hover {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .md\\:hover\\:to-teal-200:hover {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .md\\:hover\\:to-teal-300:hover {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .md\\:hover\\:to-teal-400:hover {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .md\\:hover\\:to-teal-500:hover {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .md\\:hover\\:to-teal-600:hover {\n    --gradient-to-color: #319795;\n  }\n\n  .md\\:hover\\:to-teal-700:hover {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .md\\:hover\\:to-teal-800:hover {\n    --gradient-to-color: #285e61;\n  }\n\n  .md\\:hover\\:to-teal-900:hover {\n    --gradient-to-color: #234e52;\n  }\n\n  .md\\:hover\\:to-blue-100:hover {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .md\\:hover\\:to-blue-200:hover {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .md\\:hover\\:to-blue-300:hover {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .md\\:hover\\:to-blue-400:hover {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .md\\:hover\\:to-blue-500:hover {\n    --gradient-to-color: #4299e1;\n  }\n\n  .md\\:hover\\:to-blue-600:hover {\n    --gradient-to-color: #3182ce;\n  }\n\n  .md\\:hover\\:to-blue-700:hover {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .md\\:hover\\:to-blue-800:hover {\n    --gradient-to-color: #2c5282;\n  }\n\n  .md\\:hover\\:to-blue-900:hover {\n    --gradient-to-color: #2a4365;\n  }\n\n  .md\\:hover\\:to-indigo-100:hover {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .md\\:hover\\:to-indigo-200:hover {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .md\\:hover\\:to-indigo-300:hover {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .md\\:hover\\:to-indigo-400:hover {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .md\\:hover\\:to-indigo-500:hover {\n    --gradient-to-color: #667eea;\n  }\n\n  .md\\:hover\\:to-indigo-600:hover {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .md\\:hover\\:to-indigo-700:hover {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .md\\:hover\\:to-indigo-800:hover {\n    --gradient-to-color: #434190;\n  }\n\n  .md\\:hover\\:to-indigo-900:hover {\n    --gradient-to-color: #3c366b;\n  }\n\n  .md\\:hover\\:to-purple-100:hover {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .md\\:hover\\:to-purple-200:hover {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .md\\:hover\\:to-purple-300:hover {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .md\\:hover\\:to-purple-400:hover {\n    --gradient-to-color: #b794f4;\n  }\n\n  .md\\:hover\\:to-purple-500:hover {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .md\\:hover\\:to-purple-600:hover {\n    --gradient-to-color: #805ad5;\n  }\n\n  .md\\:hover\\:to-purple-700:hover {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .md\\:hover\\:to-purple-800:hover {\n    --gradient-to-color: #553c9a;\n  }\n\n  .md\\:hover\\:to-purple-900:hover {\n    --gradient-to-color: #44337a;\n  }\n\n  .md\\:hover\\:to-pink-100:hover {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .md\\:hover\\:to-pink-200:hover {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .md\\:hover\\:to-pink-300:hover {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .md\\:hover\\:to-pink-400:hover {\n    --gradient-to-color: #f687b3;\n  }\n\n  .md\\:hover\\:to-pink-500:hover {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .md\\:hover\\:to-pink-600:hover {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .md\\:hover\\:to-pink-700:hover {\n    --gradient-to-color: #b83280;\n  }\n\n  .md\\:hover\\:to-pink-800:hover {\n    --gradient-to-color: #97266d;\n  }\n\n  .md\\:hover\\:to-pink-900:hover {\n    --gradient-to-color: #702459;\n  }\n\n  .md\\:focus\\:from-transparent:focus {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:focus\\:from-current:focus {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:focus\\:from-black:focus {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:focus\\:from-white:focus {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:focus\\:from-gray-100:focus {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .md\\:focus\\:from-gray-200:focus {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .md\\:focus\\:from-gray-300:focus {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .md\\:focus\\:from-gray-400:focus {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .md\\:focus\\:from-gray-500:focus {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .md\\:focus\\:from-gray-600:focus {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .md\\:focus\\:from-gray-700:focus {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .md\\:focus\\:from-gray-800:focus {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .md\\:focus\\:from-gray-900:focus {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .md\\:focus\\:from-red-100:focus {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .md\\:focus\\:from-red-200:focus {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .md\\:focus\\:from-red-300:focus {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .md\\:focus\\:from-red-400:focus {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .md\\:focus\\:from-red-500:focus {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .md\\:focus\\:from-red-600:focus {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .md\\:focus\\:from-red-700:focus {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .md\\:focus\\:from-red-800:focus {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .md\\:focus\\:from-red-900:focus {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .md\\:focus\\:from-orange-100:focus {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .md\\:focus\\:from-orange-200:focus {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .md\\:focus\\:from-orange-300:focus {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .md\\:focus\\:from-orange-400:focus {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .md\\:focus\\:from-orange-500:focus {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .md\\:focus\\:from-orange-600:focus {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .md\\:focus\\:from-orange-700:focus {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .md\\:focus\\:from-orange-800:focus {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .md\\:focus\\:from-orange-900:focus {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .md\\:focus\\:from-yellow-100:focus {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .md\\:focus\\:from-yellow-200:focus {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .md\\:focus\\:from-yellow-300:focus {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .md\\:focus\\:from-yellow-400:focus {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .md\\:focus\\:from-yellow-500:focus {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .md\\:focus\\:from-yellow-600:focus {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .md\\:focus\\:from-yellow-700:focus {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .md\\:focus\\:from-yellow-800:focus {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .md\\:focus\\:from-yellow-900:focus {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .md\\:focus\\:from-green-100:focus {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .md\\:focus\\:from-green-200:focus {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .md\\:focus\\:from-green-300:focus {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .md\\:focus\\:from-green-400:focus {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .md\\:focus\\:from-green-500:focus {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .md\\:focus\\:from-green-600:focus {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .md\\:focus\\:from-green-700:focus {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .md\\:focus\\:from-green-800:focus {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .md\\:focus\\:from-green-900:focus {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .md\\:focus\\:from-teal-100:focus {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .md\\:focus\\:from-teal-200:focus {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .md\\:focus\\:from-teal-300:focus {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .md\\:focus\\:from-teal-400:focus {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .md\\:focus\\:from-teal-500:focus {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .md\\:focus\\:from-teal-600:focus {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .md\\:focus\\:from-teal-700:focus {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .md\\:focus\\:from-teal-800:focus {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .md\\:focus\\:from-teal-900:focus {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .md\\:focus\\:from-blue-100:focus {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .md\\:focus\\:from-blue-200:focus {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .md\\:focus\\:from-blue-300:focus {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .md\\:focus\\:from-blue-400:focus {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .md\\:focus\\:from-blue-500:focus {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .md\\:focus\\:from-blue-600:focus {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .md\\:focus\\:from-blue-700:focus {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .md\\:focus\\:from-blue-800:focus {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .md\\:focus\\:from-blue-900:focus {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .md\\:focus\\:from-indigo-100:focus {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .md\\:focus\\:from-indigo-200:focus {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .md\\:focus\\:from-indigo-300:focus {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .md\\:focus\\:from-indigo-400:focus {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .md\\:focus\\:from-indigo-500:focus {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .md\\:focus\\:from-indigo-600:focus {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .md\\:focus\\:from-indigo-700:focus {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .md\\:focus\\:from-indigo-800:focus {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .md\\:focus\\:from-indigo-900:focus {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .md\\:focus\\:from-purple-100:focus {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .md\\:focus\\:from-purple-200:focus {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .md\\:focus\\:from-purple-300:focus {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .md\\:focus\\:from-purple-400:focus {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .md\\:focus\\:from-purple-500:focus {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .md\\:focus\\:from-purple-600:focus {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .md\\:focus\\:from-purple-700:focus {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .md\\:focus\\:from-purple-800:focus {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .md\\:focus\\:from-purple-900:focus {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .md\\:focus\\:from-pink-100:focus {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .md\\:focus\\:from-pink-200:focus {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .md\\:focus\\:from-pink-300:focus {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .md\\:focus\\:from-pink-400:focus {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .md\\:focus\\:from-pink-500:focus {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .md\\:focus\\:from-pink-600:focus {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .md\\:focus\\:from-pink-700:focus {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .md\\:focus\\:from-pink-800:focus {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .md\\:focus\\:from-pink-900:focus {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .md\\:focus\\:via-transparent:focus {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:focus\\:via-current:focus {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:focus\\:via-black:focus {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .md\\:focus\\:via-white:focus {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .md\\:focus\\:via-gray-100:focus {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .md\\:focus\\:via-gray-200:focus {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .md\\:focus\\:via-gray-300:focus {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .md\\:focus\\:via-gray-400:focus {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .md\\:focus\\:via-gray-500:focus {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .md\\:focus\\:via-gray-600:focus {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .md\\:focus\\:via-gray-700:focus {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .md\\:focus\\:via-gray-800:focus {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .md\\:focus\\:via-gray-900:focus {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .md\\:focus\\:via-red-100:focus {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .md\\:focus\\:via-red-200:focus {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .md\\:focus\\:via-red-300:focus {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .md\\:focus\\:via-red-400:focus {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .md\\:focus\\:via-red-500:focus {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .md\\:focus\\:via-red-600:focus {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .md\\:focus\\:via-red-700:focus {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .md\\:focus\\:via-red-800:focus {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .md\\:focus\\:via-red-900:focus {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .md\\:focus\\:via-orange-100:focus {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .md\\:focus\\:via-orange-200:focus {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .md\\:focus\\:via-orange-300:focus {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .md\\:focus\\:via-orange-400:focus {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .md\\:focus\\:via-orange-500:focus {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .md\\:focus\\:via-orange-600:focus {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .md\\:focus\\:via-orange-700:focus {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .md\\:focus\\:via-orange-800:focus {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .md\\:focus\\:via-orange-900:focus {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .md\\:focus\\:via-yellow-100:focus {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .md\\:focus\\:via-yellow-200:focus {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .md\\:focus\\:via-yellow-300:focus {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .md\\:focus\\:via-yellow-400:focus {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .md\\:focus\\:via-yellow-500:focus {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .md\\:focus\\:via-yellow-600:focus {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .md\\:focus\\:via-yellow-700:focus {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .md\\:focus\\:via-yellow-800:focus {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .md\\:focus\\:via-yellow-900:focus {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .md\\:focus\\:via-green-100:focus {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .md\\:focus\\:via-green-200:focus {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .md\\:focus\\:via-green-300:focus {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .md\\:focus\\:via-green-400:focus {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .md\\:focus\\:via-green-500:focus {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .md\\:focus\\:via-green-600:focus {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .md\\:focus\\:via-green-700:focus {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .md\\:focus\\:via-green-800:focus {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .md\\:focus\\:via-green-900:focus {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .md\\:focus\\:via-teal-100:focus {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .md\\:focus\\:via-teal-200:focus {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .md\\:focus\\:via-teal-300:focus {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .md\\:focus\\:via-teal-400:focus {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .md\\:focus\\:via-teal-500:focus {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .md\\:focus\\:via-teal-600:focus {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .md\\:focus\\:via-teal-700:focus {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .md\\:focus\\:via-teal-800:focus {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .md\\:focus\\:via-teal-900:focus {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .md\\:focus\\:via-blue-100:focus {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .md\\:focus\\:via-blue-200:focus {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .md\\:focus\\:via-blue-300:focus {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .md\\:focus\\:via-blue-400:focus {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .md\\:focus\\:via-blue-500:focus {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .md\\:focus\\:via-blue-600:focus {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .md\\:focus\\:via-blue-700:focus {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .md\\:focus\\:via-blue-800:focus {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .md\\:focus\\:via-blue-900:focus {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .md\\:focus\\:via-indigo-100:focus {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .md\\:focus\\:via-indigo-200:focus {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .md\\:focus\\:via-indigo-300:focus {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .md\\:focus\\:via-indigo-400:focus {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .md\\:focus\\:via-indigo-500:focus {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .md\\:focus\\:via-indigo-600:focus {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .md\\:focus\\:via-indigo-700:focus {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .md\\:focus\\:via-indigo-800:focus {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .md\\:focus\\:via-indigo-900:focus {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .md\\:focus\\:via-purple-100:focus {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .md\\:focus\\:via-purple-200:focus {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .md\\:focus\\:via-purple-300:focus {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .md\\:focus\\:via-purple-400:focus {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .md\\:focus\\:via-purple-500:focus {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .md\\:focus\\:via-purple-600:focus {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .md\\:focus\\:via-purple-700:focus {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .md\\:focus\\:via-purple-800:focus {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .md\\:focus\\:via-purple-900:focus {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .md\\:focus\\:via-pink-100:focus {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .md\\:focus\\:via-pink-200:focus {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .md\\:focus\\:via-pink-300:focus {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .md\\:focus\\:via-pink-400:focus {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .md\\:focus\\:via-pink-500:focus {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .md\\:focus\\:via-pink-600:focus {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .md\\:focus\\:via-pink-700:focus {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .md\\:focus\\:via-pink-800:focus {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .md\\:focus\\:via-pink-900:focus {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .md\\:focus\\:to-transparent:focus {\n    --gradient-to-color: transparent;\n  }\n\n  .md\\:focus\\:to-current:focus {\n    --gradient-to-color: currentColor;\n  }\n\n  .md\\:focus\\:to-black:focus {\n    --gradient-to-color: #000;\n  }\n\n  .md\\:focus\\:to-white:focus {\n    --gradient-to-color: #fff;\n  }\n\n  .md\\:focus\\:to-gray-100:focus {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .md\\:focus\\:to-gray-200:focus {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .md\\:focus\\:to-gray-300:focus {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .md\\:focus\\:to-gray-400:focus {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .md\\:focus\\:to-gray-500:focus {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .md\\:focus\\:to-gray-600:focus {\n    --gradient-to-color: #718096;\n  }\n\n  .md\\:focus\\:to-gray-700:focus {\n    --gradient-to-color: #4a5568;\n  }\n\n  .md\\:focus\\:to-gray-800:focus {\n    --gradient-to-color: #2d3748;\n  }\n\n  .md\\:focus\\:to-gray-900:focus {\n    --gradient-to-color: #1a202c;\n  }\n\n  .md\\:focus\\:to-red-100:focus {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .md\\:focus\\:to-red-200:focus {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .md\\:focus\\:to-red-300:focus {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .md\\:focus\\:to-red-400:focus {\n    --gradient-to-color: #fc8181;\n  }\n\n  .md\\:focus\\:to-red-500:focus {\n    --gradient-to-color: #f56565;\n  }\n\n  .md\\:focus\\:to-red-600:focus {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .md\\:focus\\:to-red-700:focus {\n    --gradient-to-color: #c53030;\n  }\n\n  .md\\:focus\\:to-red-800:focus {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .md\\:focus\\:to-red-900:focus {\n    --gradient-to-color: #742a2a;\n  }\n\n  .md\\:focus\\:to-orange-100:focus {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .md\\:focus\\:to-orange-200:focus {\n    --gradient-to-color: #feebc8;\n  }\n\n  .md\\:focus\\:to-orange-300:focus {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .md\\:focus\\:to-orange-400:focus {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .md\\:focus\\:to-orange-500:focus {\n    --gradient-to-color: #ed8936;\n  }\n\n  .md\\:focus\\:to-orange-600:focus {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .md\\:focus\\:to-orange-700:focus {\n    --gradient-to-color: #c05621;\n  }\n\n  .md\\:focus\\:to-orange-800:focus {\n    --gradient-to-color: #9c4221;\n  }\n\n  .md\\:focus\\:to-orange-900:focus {\n    --gradient-to-color: #7b341e;\n  }\n\n  .md\\:focus\\:to-yellow-100:focus {\n    --gradient-to-color: #fffff0;\n  }\n\n  .md\\:focus\\:to-yellow-200:focus {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .md\\:focus\\:to-yellow-300:focus {\n    --gradient-to-color: #faf089;\n  }\n\n  .md\\:focus\\:to-yellow-400:focus {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .md\\:focus\\:to-yellow-500:focus {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .md\\:focus\\:to-yellow-600:focus {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .md\\:focus\\:to-yellow-700:focus {\n    --gradient-to-color: #b7791f;\n  }\n\n  .md\\:focus\\:to-yellow-800:focus {\n    --gradient-to-color: #975a16;\n  }\n\n  .md\\:focus\\:to-yellow-900:focus {\n    --gradient-to-color: #744210;\n  }\n\n  .md\\:focus\\:to-green-100:focus {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .md\\:focus\\:to-green-200:focus {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .md\\:focus\\:to-green-300:focus {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .md\\:focus\\:to-green-400:focus {\n    --gradient-to-color: #68d391;\n  }\n\n  .md\\:focus\\:to-green-500:focus {\n    --gradient-to-color: #48bb78;\n  }\n\n  .md\\:focus\\:to-green-600:focus {\n    --gradient-to-color: #38a169;\n  }\n\n  .md\\:focus\\:to-green-700:focus {\n    --gradient-to-color: #2f855a;\n  }\n\n  .md\\:focus\\:to-green-800:focus {\n    --gradient-to-color: #276749;\n  }\n\n  .md\\:focus\\:to-green-900:focus {\n    --gradient-to-color: #22543d;\n  }\n\n  .md\\:focus\\:to-teal-100:focus {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .md\\:focus\\:to-teal-200:focus {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .md\\:focus\\:to-teal-300:focus {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .md\\:focus\\:to-teal-400:focus {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .md\\:focus\\:to-teal-500:focus {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .md\\:focus\\:to-teal-600:focus {\n    --gradient-to-color: #319795;\n  }\n\n  .md\\:focus\\:to-teal-700:focus {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .md\\:focus\\:to-teal-800:focus {\n    --gradient-to-color: #285e61;\n  }\n\n  .md\\:focus\\:to-teal-900:focus {\n    --gradient-to-color: #234e52;\n  }\n\n  .md\\:focus\\:to-blue-100:focus {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .md\\:focus\\:to-blue-200:focus {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .md\\:focus\\:to-blue-300:focus {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .md\\:focus\\:to-blue-400:focus {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .md\\:focus\\:to-blue-500:focus {\n    --gradient-to-color: #4299e1;\n  }\n\n  .md\\:focus\\:to-blue-600:focus {\n    --gradient-to-color: #3182ce;\n  }\n\n  .md\\:focus\\:to-blue-700:focus {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .md\\:focus\\:to-blue-800:focus {\n    --gradient-to-color: #2c5282;\n  }\n\n  .md\\:focus\\:to-blue-900:focus {\n    --gradient-to-color: #2a4365;\n  }\n\n  .md\\:focus\\:to-indigo-100:focus {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .md\\:focus\\:to-indigo-200:focus {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .md\\:focus\\:to-indigo-300:focus {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .md\\:focus\\:to-indigo-400:focus {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .md\\:focus\\:to-indigo-500:focus {\n    --gradient-to-color: #667eea;\n  }\n\n  .md\\:focus\\:to-indigo-600:focus {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .md\\:focus\\:to-indigo-700:focus {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .md\\:focus\\:to-indigo-800:focus {\n    --gradient-to-color: #434190;\n  }\n\n  .md\\:focus\\:to-indigo-900:focus {\n    --gradient-to-color: #3c366b;\n  }\n\n  .md\\:focus\\:to-purple-100:focus {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .md\\:focus\\:to-purple-200:focus {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .md\\:focus\\:to-purple-300:focus {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .md\\:focus\\:to-purple-400:focus {\n    --gradient-to-color: #b794f4;\n  }\n\n  .md\\:focus\\:to-purple-500:focus {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .md\\:focus\\:to-purple-600:focus {\n    --gradient-to-color: #805ad5;\n  }\n\n  .md\\:focus\\:to-purple-700:focus {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .md\\:focus\\:to-purple-800:focus {\n    --gradient-to-color: #553c9a;\n  }\n\n  .md\\:focus\\:to-purple-900:focus {\n    --gradient-to-color: #44337a;\n  }\n\n  .md\\:focus\\:to-pink-100:focus {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .md\\:focus\\:to-pink-200:focus {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .md\\:focus\\:to-pink-300:focus {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .md\\:focus\\:to-pink-400:focus {\n    --gradient-to-color: #f687b3;\n  }\n\n  .md\\:focus\\:to-pink-500:focus {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .md\\:focus\\:to-pink-600:focus {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .md\\:focus\\:to-pink-700:focus {\n    --gradient-to-color: #b83280;\n  }\n\n  .md\\:focus\\:to-pink-800:focus {\n    --gradient-to-color: #97266d;\n  }\n\n  .md\\:focus\\:to-pink-900:focus {\n    --gradient-to-color: #702459;\n  }\n\n  .md\\:bg-opacity-0 {\n    --bg-opacity: 0;\n  }\n\n  .md\\:bg-opacity-25 {\n    --bg-opacity: 0.25;\n  }\n\n  .md\\:bg-opacity-50 {\n    --bg-opacity: 0.5;\n  }\n\n  .md\\:bg-opacity-75 {\n    --bg-opacity: 0.75;\n  }\n\n  .md\\:bg-opacity-100 {\n    --bg-opacity: 1;\n  }\n\n  .md\\:hover\\:bg-opacity-0:hover {\n    --bg-opacity: 0;\n  }\n\n  .md\\:hover\\:bg-opacity-25:hover {\n    --bg-opacity: 0.25;\n  }\n\n  .md\\:hover\\:bg-opacity-50:hover {\n    --bg-opacity: 0.5;\n  }\n\n  .md\\:hover\\:bg-opacity-75:hover {\n    --bg-opacity: 0.75;\n  }\n\n  .md\\:hover\\:bg-opacity-100:hover {\n    --bg-opacity: 1;\n  }\n\n  .md\\:focus\\:bg-opacity-0:focus {\n    --bg-opacity: 0;\n  }\n\n  .md\\:focus\\:bg-opacity-25:focus {\n    --bg-opacity: 0.25;\n  }\n\n  .md\\:focus\\:bg-opacity-50:focus {\n    --bg-opacity: 0.5;\n  }\n\n  .md\\:focus\\:bg-opacity-75:focus {\n    --bg-opacity: 0.75;\n  }\n\n  .md\\:focus\\:bg-opacity-100:focus {\n    --bg-opacity: 1;\n  }\n\n  .md\\:bg-bottom {\n    background-position: bottom;\n  }\n\n  .md\\:bg-center {\n    background-position: center;\n  }\n\n  .md\\:bg-left {\n    background-position: left;\n  }\n\n  .md\\:bg-left-bottom {\n    background-position: left bottom;\n  }\n\n  .md\\:bg-left-top {\n    background-position: left top;\n  }\n\n  .md\\:bg-right {\n    background-position: right;\n  }\n\n  .md\\:bg-right-bottom {\n    background-position: right bottom;\n  }\n\n  .md\\:bg-right-top {\n    background-position: right top;\n  }\n\n  .md\\:bg-top {\n    background-position: top;\n  }\n\n  .md\\:bg-repeat {\n    background-repeat: repeat;\n  }\n\n  .md\\:bg-no-repeat {\n    background-repeat: no-repeat;\n  }\n\n  .md\\:bg-repeat-x {\n    background-repeat: repeat-x;\n  }\n\n  .md\\:bg-repeat-y {\n    background-repeat: repeat-y;\n  }\n\n  .md\\:bg-repeat-round {\n    background-repeat: round;\n  }\n\n  .md\\:bg-repeat-space {\n    background-repeat: space;\n  }\n\n  .md\\:bg-auto {\n    background-size: auto;\n  }\n\n  .md\\:bg-cover {\n    background-size: cover;\n  }\n\n  .md\\:bg-contain {\n    background-size: contain;\n  }\n\n  .md\\:border-collapse {\n    border-collapse: collapse;\n  }\n\n  .md\\:border-separate {\n    border-collapse: separate;\n  }\n\n  .md\\:border-transparent {\n    border-color: transparent;\n  }\n\n  .md\\:border-current {\n    border-color: currentColor;\n  }\n\n  .md\\:border-black {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .md\\:border-white {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .md\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .md\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .md\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .md\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .md\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .md\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .md\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .md\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .md\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .md\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .md\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .md\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .md\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .md\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .md\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .md\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .md\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .md\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .md\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .md\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .md\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .md\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .md\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .md\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .md\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .md\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .md\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .md\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .md\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .md\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .md\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .md\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .md\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .md\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .md\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .md\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .md\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .md\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .md\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .md\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .md\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .md\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .md\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .md\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .md\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .md\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .md\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .md\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .md\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .md\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .md\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .md\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .md\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .md\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .md\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .md\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .md\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .md\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .md\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .md\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .md\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .md\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .md\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .md\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .md\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .md\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .md\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .md\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .md\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .md\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .md\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .md\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .md\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .md\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n  }\n\n  .md\\:hover\\:border-current:hover {\n    border-color: currentColor;\n  }\n\n  .md\\:hover\\:border-black:hover {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-white:hover {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-100:hover {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-200:hover {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-300:hover {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-400:hover {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-500:hover {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-600:hover {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-700:hover {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-800:hover {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-red-900:hover {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-100:hover {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-200:hover {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-300:hover {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-400:hover {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-500:hover {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-600:hover {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-700:hover {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-800:hover {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-orange-900:hover {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-100:hover {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-200:hover {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-300:hover {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-400:hover {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-500:hover {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-600:hover {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-700:hover {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-800:hover {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-yellow-900:hover {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-100:hover {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-200:hover {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-300:hover {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-400:hover {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-500:hover {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-600:hover {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-700:hover {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-800:hover {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-green-900:hover {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-100:hover {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-200:hover {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-300:hover {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-400:hover {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-500:hover {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-600:hover {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-700:hover {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-800:hover {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-teal-900:hover {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-100:hover {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-200:hover {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-300:hover {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-400:hover {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-500:hover {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-600:hover {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-700:hover {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-800:hover {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-blue-900:hover {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-100:hover {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-200:hover {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-300:hover {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-400:hover {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-500:hover {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-600:hover {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-700:hover {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-800:hover {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-indigo-900:hover {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-100:hover {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-200:hover {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-300:hover {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-400:hover {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-500:hover {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-600:hover {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-700:hover {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-800:hover {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-purple-900:hover {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-100:hover {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-200:hover {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-300:hover {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-400:hover {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-500:hover {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-600:hover {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-700:hover {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-800:hover {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .md\\:hover\\:border-pink-900:hover {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-transparent:focus {\n    border-color: transparent;\n  }\n\n  .md\\:focus\\:border-current:focus {\n    border-color: currentColor;\n  }\n\n  .md\\:focus\\:border-black:focus {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-white:focus {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-100:focus {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-200:focus {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-300:focus {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-400:focus {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-500:focus {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-600:focus {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-700:focus {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-800:focus {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-red-900:focus {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-100:focus {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-200:focus {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-300:focus {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-400:focus {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-500:focus {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-600:focus {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-700:focus {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-800:focus {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-orange-900:focus {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-100:focus {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-200:focus {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-300:focus {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-400:focus {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-500:focus {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-600:focus {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-700:focus {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-800:focus {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-yellow-900:focus {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-100:focus {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-200:focus {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-300:focus {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-400:focus {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-500:focus {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-600:focus {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-700:focus {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-800:focus {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-green-900:focus {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-100:focus {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-200:focus {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-300:focus {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-400:focus {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-500:focus {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-600:focus {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-700:focus {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-800:focus {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-teal-900:focus {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-100:focus {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-200:focus {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-300:focus {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-400:focus {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-500:focus {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-600:focus {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-700:focus {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-800:focus {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-blue-900:focus {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-100:focus {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-200:focus {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-300:focus {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-400:focus {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-500:focus {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-600:focus {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-700:focus {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-800:focus {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-indigo-900:focus {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-100:focus {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-200:focus {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-300:focus {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-400:focus {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-500:focus {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-600:focus {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-700:focus {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-800:focus {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-purple-900:focus {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-100:focus {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-200:focus {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-300:focus {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-400:focus {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-500:focus {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-600:focus {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-700:focus {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-800:focus {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .md\\:focus\\:border-pink-900:focus {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .md\\:border-opacity-0 {\n    --border-opacity: 0;\n  }\n\n  .md\\:border-opacity-25 {\n    --border-opacity: 0.25;\n  }\n\n  .md\\:border-opacity-50 {\n    --border-opacity: 0.5;\n  }\n\n  .md\\:border-opacity-75 {\n    --border-opacity: 0.75;\n  }\n\n  .md\\:border-opacity-100 {\n    --border-opacity: 1;\n  }\n\n  .md\\:hover\\:border-opacity-0:hover {\n    --border-opacity: 0;\n  }\n\n  .md\\:hover\\:border-opacity-25:hover {\n    --border-opacity: 0.25;\n  }\n\n  .md\\:hover\\:border-opacity-50:hover {\n    --border-opacity: 0.5;\n  }\n\n  .md\\:hover\\:border-opacity-75:hover {\n    --border-opacity: 0.75;\n  }\n\n  .md\\:hover\\:border-opacity-100:hover {\n    --border-opacity: 1;\n  }\n\n  .md\\:focus\\:border-opacity-0:focus {\n    --border-opacity: 0;\n  }\n\n  .md\\:focus\\:border-opacity-25:focus {\n    --border-opacity: 0.25;\n  }\n\n  .md\\:focus\\:border-opacity-50:focus {\n    --border-opacity: 0.5;\n  }\n\n  .md\\:focus\\:border-opacity-75:focus {\n    --border-opacity: 0.75;\n  }\n\n  .md\\:focus\\:border-opacity-100:focus {\n    --border-opacity: 1;\n  }\n\n  .md\\:rounded-none {\n    border-radius: 0;\n  }\n\n  .md\\:rounded-sm {\n    border-radius: 0.125rem;\n  }\n\n  .md\\:rounded {\n    border-radius: 0.25rem;\n  }\n\n  .md\\:rounded-md {\n    border-radius: 0.375rem;\n  }\n\n  .md\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n\n  .md\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n\n  .md\\:rounded-2xl {\n    border-radius: 1rem;\n  }\n\n  .md\\:rounded-3xl {\n    border-radius: 1.5rem;\n  }\n\n  .md\\:rounded-full {\n    border-radius: 9999px;\n  }\n\n  .md\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .md\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .md\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .md\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .md\\:rounded-t-sm {\n    border-top-left-radius: 0.125rem;\n    border-top-right-radius: 0.125rem;\n  }\n\n  .md\\:rounded-r-sm {\n    border-top-right-radius: 0.125rem;\n    border-bottom-right-radius: 0.125rem;\n  }\n\n  .md\\:rounded-b-sm {\n    border-bottom-right-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .md\\:rounded-l-sm {\n    border-top-left-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .md\\:rounded-t {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n\n  .md\\:rounded-r {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .md\\:rounded-b {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .md\\:rounded-l {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .md\\:rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n  }\n\n  .md\\:rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n  }\n\n  .md\\:rounded-b-md {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .md\\:rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .md\\:rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n  }\n\n  .md\\:rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .md\\:rounded-b-lg {\n    border-bottom-right-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .md\\:rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .md\\:rounded-t-xl {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n\n  .md\\:rounded-r-xl {\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n  }\n\n  .md\\:rounded-b-xl {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .md\\:rounded-l-xl {\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .md\\:rounded-t-2xl {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n\n  .md\\:rounded-r-2xl {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n\n  .md\\:rounded-b-2xl {\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .md\\:rounded-l-2xl {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .md\\:rounded-t-3xl {\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n\n  .md\\:rounded-r-3xl {\n    border-top-right-radius: 1.5rem;\n    border-bottom-right-radius: 1.5rem;\n  }\n\n  .md\\:rounded-b-3xl {\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .md\\:rounded-l-3xl {\n    border-top-left-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .md\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n  }\n\n  .md\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n  }\n\n  .md\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n\n  .md\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n\n  .md\\:rounded-tl-none {\n    border-top-left-radius: 0;\n  }\n\n  .md\\:rounded-tr-none {\n    border-top-right-radius: 0;\n  }\n\n  .md\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n  }\n\n  .md\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n  }\n\n  .md\\:rounded-tl-sm {\n    border-top-left-radius: 0.125rem;\n  }\n\n  .md\\:rounded-tr-sm {\n    border-top-right-radius: 0.125rem;\n  }\n\n  .md\\:rounded-br-sm {\n    border-bottom-right-radius: 0.125rem;\n  }\n\n  .md\\:rounded-bl-sm {\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .md\\:rounded-tl {\n    border-top-left-radius: 0.25rem;\n  }\n\n  .md\\:rounded-tr {\n    border-top-right-radius: 0.25rem;\n  }\n\n  .md\\:rounded-br {\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .md\\:rounded-bl {\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .md\\:rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n  }\n\n  .md\\:rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n  }\n\n  .md\\:rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n  }\n\n  .md\\:rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .md\\:rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n  }\n\n  .md\\:rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n  }\n\n  .md\\:rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .md\\:rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .md\\:rounded-tl-xl {\n    border-top-left-radius: 0.75rem;\n  }\n\n  .md\\:rounded-tr-xl {\n    border-top-right-radius: 0.75rem;\n  }\n\n  .md\\:rounded-br-xl {\n    border-bottom-right-radius: 0.75rem;\n  }\n\n  .md\\:rounded-bl-xl {\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .md\\:rounded-tl-2xl {\n    border-top-left-radius: 1rem;\n  }\n\n  .md\\:rounded-tr-2xl {\n    border-top-right-radius: 1rem;\n  }\n\n  .md\\:rounded-br-2xl {\n    border-bottom-right-radius: 1rem;\n  }\n\n  .md\\:rounded-bl-2xl {\n    border-bottom-left-radius: 1rem;\n  }\n\n  .md\\:rounded-tl-3xl {\n    border-top-left-radius: 1.5rem;\n  }\n\n  .md\\:rounded-tr-3xl {\n    border-top-right-radius: 1.5rem;\n  }\n\n  .md\\:rounded-br-3xl {\n    border-bottom-right-radius: 1.5rem;\n  }\n\n  .md\\:rounded-bl-3xl {\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .md\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n  }\n\n  .md\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n  }\n\n  .md\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n  }\n\n  .md\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n  }\n\n  .md\\:border-solid {\n    border-style: solid;\n  }\n\n  .md\\:border-dashed {\n    border-style: dashed;\n  }\n\n  .md\\:border-dotted {\n    border-style: dotted;\n  }\n\n  .md\\:border-double {\n    border-style: double;\n  }\n\n  .md\\:border-none {\n    border-style: none;\n  }\n\n  .md\\:border-0 {\n    border-width: 0;\n  }\n\n  .md\\:border-2 {\n    border-width: 2px;\n  }\n\n  .md\\:border-4 {\n    border-width: 4px;\n  }\n\n  .md\\:border-8 {\n    border-width: 8px;\n  }\n\n  .md\\:border {\n    border-width: 1px;\n  }\n\n  .md\\:border-t-0 {\n    border-top-width: 0;\n  }\n\n  .md\\:border-r-0 {\n    border-right-width: 0;\n  }\n\n  .md\\:border-b-0 {\n    border-bottom-width: 0;\n  }\n\n  .md\\:border-l-0 {\n    border-left-width: 0;\n  }\n\n  .md\\:border-t-2 {\n    border-top-width: 2px;\n  }\n\n  .md\\:border-r-2 {\n    border-right-width: 2px;\n  }\n\n  .md\\:border-b-2 {\n    border-bottom-width: 2px;\n  }\n\n  .md\\:border-l-2 {\n    border-left-width: 2px;\n  }\n\n  .md\\:border-t-4 {\n    border-top-width: 4px;\n  }\n\n  .md\\:border-r-4 {\n    border-right-width: 4px;\n  }\n\n  .md\\:border-b-4 {\n    border-bottom-width: 4px;\n  }\n\n  .md\\:border-l-4 {\n    border-left-width: 4px;\n  }\n\n  .md\\:border-t-8 {\n    border-top-width: 8px;\n  }\n\n  .md\\:border-r-8 {\n    border-right-width: 8px;\n  }\n\n  .md\\:border-b-8 {\n    border-bottom-width: 8px;\n  }\n\n  .md\\:border-l-8 {\n    border-left-width: 8px;\n  }\n\n  .md\\:border-t {\n    border-top-width: 1px;\n  }\n\n  .md\\:border-r {\n    border-right-width: 1px;\n  }\n\n  .md\\:border-b {\n    border-bottom-width: 1px;\n  }\n\n  .md\\:border-l {\n    border-left-width: 1px;\n  }\n\n  .md\\:box-border {\n    box-sizing: border-box;\n  }\n\n  .md\\:box-content {\n    box-sizing: content-box;\n  }\n\n  .md\\:cursor-auto {\n    cursor: auto;\n  }\n\n  .md\\:cursor-default {\n    cursor: default;\n  }\n\n  .md\\:cursor-pointer {\n    cursor: pointer;\n  }\n\n  .md\\:cursor-wait {\n    cursor: wait;\n  }\n\n  .md\\:cursor-text {\n    cursor: text;\n  }\n\n  .md\\:cursor-move {\n    cursor: move;\n  }\n\n  .md\\:cursor-not-allowed {\n    cursor: not-allowed;\n  }\n\n  .md\\:block {\n    display: block;\n  }\n\n  .md\\:inline-block {\n    display: inline-block;\n  }\n\n  .md\\:inline {\n    display: inline;\n  }\n\n  .md\\:flex {\n    display: flex;\n  }\n\n  .md\\:inline-flex {\n    display: inline-flex;\n  }\n\n  .md\\:table {\n    display: table;\n  }\n\n  .md\\:table-caption {\n    display: table-caption;\n  }\n\n  .md\\:table-cell {\n    display: table-cell;\n  }\n\n  .md\\:table-column {\n    display: table-column;\n  }\n\n  .md\\:table-column-group {\n    display: table-column-group;\n  }\n\n  .md\\:table-footer-group {\n    display: table-footer-group;\n  }\n\n  .md\\:table-header-group {\n    display: table-header-group;\n  }\n\n  .md\\:table-row-group {\n    display: table-row-group;\n  }\n\n  .md\\:table-row {\n    display: table-row;\n  }\n\n  .md\\:flow-root {\n    display: flow-root;\n  }\n\n  .md\\:grid {\n    display: grid;\n  }\n\n  .md\\:inline-grid {\n    display: inline-grid;\n  }\n\n  .md\\:contents {\n    display: contents;\n  }\n\n  .md\\:hidden {\n    display: none;\n  }\n\n  .md\\:flex-row {\n    flex-direction: row;\n  }\n\n  .md\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n\n  .md\\:flex-col {\n    flex-direction: column;\n  }\n\n  .md\\:flex-col-reverse {\n    flex-direction: column-reverse;\n  }\n\n  .md\\:flex-wrap {\n    flex-wrap: wrap;\n  }\n\n  .md\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n  }\n\n  .md\\:flex-no-wrap {\n    flex-wrap: nowrap;\n  }\n\n  .md\\:place-items-auto {\n    place-items: auto;\n  }\n\n  .md\\:place-items-start {\n    place-items: start;\n  }\n\n  .md\\:place-items-end {\n    place-items: end;\n  }\n\n  .md\\:place-items-center {\n    place-items: center;\n  }\n\n  .md\\:place-items-stretch {\n    place-items: stretch;\n  }\n\n  .md\\:place-content-center {\n    place-content: center;\n  }\n\n  .md\\:place-content-start {\n    place-content: start;\n  }\n\n  .md\\:place-content-end {\n    place-content: end;\n  }\n\n  .md\\:place-content-between {\n    place-content: space-between;\n  }\n\n  .md\\:place-content-around {\n    place-content: space-around;\n  }\n\n  .md\\:place-content-evenly {\n    place-content: space-evenly;\n  }\n\n  .md\\:place-content-stretch {\n    place-content: stretch;\n  }\n\n  .md\\:place-self-auto {\n    place-self: auto;\n  }\n\n  .md\\:place-self-start {\n    place-self: start;\n  }\n\n  .md\\:place-self-end {\n    place-self: end;\n  }\n\n  .md\\:place-self-center {\n    place-self: center;\n  }\n\n  .md\\:place-self-stretch {\n    place-self: stretch;\n  }\n\n  .md\\:items-start {\n    align-items: flex-start;\n  }\n\n  .md\\:items-end {\n    align-items: flex-end;\n  }\n\n  .md\\:items-center {\n    align-items: center;\n  }\n\n  .md\\:items-baseline {\n    align-items: baseline;\n  }\n\n  .md\\:items-stretch {\n    align-items: stretch;\n  }\n\n  .md\\:content-center {\n    align-content: center;\n  }\n\n  .md\\:content-start {\n    align-content: flex-start;\n  }\n\n  .md\\:content-end {\n    align-content: flex-end;\n  }\n\n  .md\\:content-between {\n    align-content: space-between;\n  }\n\n  .md\\:content-around {\n    align-content: space-around;\n  }\n\n  .md\\:content-evenly {\n    align-content: space-evenly;\n  }\n\n  .md\\:self-auto {\n    align-self: auto;\n  }\n\n  .md\\:self-start {\n    align-self: flex-start;\n  }\n\n  .md\\:self-end {\n    align-self: flex-end;\n  }\n\n  .md\\:self-center {\n    align-self: center;\n  }\n\n  .md\\:self-stretch {\n    align-self: stretch;\n  }\n\n  .md\\:justify-items-auto {\n    justify-items: auto;\n  }\n\n  .md\\:justify-items-start {\n    justify-items: start;\n  }\n\n  .md\\:justify-items-end {\n    justify-items: end;\n  }\n\n  .md\\:justify-items-center {\n    justify-items: center;\n  }\n\n  .md\\:justify-items-stretch {\n    justify-items: stretch;\n  }\n\n  .md\\:justify-start {\n    justify-content: flex-start;\n  }\n\n  .md\\:justify-end {\n    justify-content: flex-end;\n  }\n\n  .md\\:justify-center {\n    justify-content: center;\n  }\n\n  .md\\:justify-between {\n    justify-content: space-between;\n  }\n\n  .md\\:justify-around {\n    justify-content: space-around;\n  }\n\n  .md\\:justify-evenly {\n    justify-content: space-evenly;\n  }\n\n  .md\\:justify-self-auto {\n    justify-self: auto;\n  }\n\n  .md\\:justify-self-start {\n    justify-self: start;\n  }\n\n  .md\\:justify-self-end {\n    justify-self: end;\n  }\n\n  .md\\:justify-self-center {\n    justify-self: center;\n  }\n\n  .md\\:justify-self-stretch {\n    justify-self: stretch;\n  }\n\n  .md\\:flex-1 {\n    flex: 1 1 0%;\n  }\n\n  .md\\:flex-auto {\n    flex: 1 1 auto;\n  }\n\n  .md\\:flex-initial {\n    flex: 0 1 auto;\n  }\n\n  .md\\:flex-none {\n    flex: none;\n  }\n\n  .md\\:flex-grow-0 {\n    flex-grow: 0;\n  }\n\n  .md\\:flex-grow {\n    flex-grow: 1;\n  }\n\n  .md\\:flex-shrink-0 {\n    flex-shrink: 0;\n  }\n\n  .md\\:flex-shrink {\n    flex-shrink: 1;\n  }\n\n  .md\\:order-1 {\n    order: 1;\n  }\n\n  .md\\:order-2 {\n    order: 2;\n  }\n\n  .md\\:order-3 {\n    order: 3;\n  }\n\n  .md\\:order-4 {\n    order: 4;\n  }\n\n  .md\\:order-5 {\n    order: 5;\n  }\n\n  .md\\:order-6 {\n    order: 6;\n  }\n\n  .md\\:order-7 {\n    order: 7;\n  }\n\n  .md\\:order-8 {\n    order: 8;\n  }\n\n  .md\\:order-9 {\n    order: 9;\n  }\n\n  .md\\:order-10 {\n    order: 10;\n  }\n\n  .md\\:order-11 {\n    order: 11;\n  }\n\n  .md\\:order-12 {\n    order: 12;\n  }\n\n  .md\\:order-first {\n    order: -9999;\n  }\n\n  .md\\:order-last {\n    order: 9999;\n  }\n\n  .md\\:order-none {\n    order: 0;\n  }\n\n  .md\\:float-right {\n    float: right;\n  }\n\n  .md\\:float-left {\n    float: left;\n  }\n\n  .md\\:float-none {\n    float: none;\n  }\n\n  .md\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  .md\\:clear-left {\n    clear: left;\n  }\n\n  .md\\:clear-right {\n    clear: right;\n  }\n\n  .md\\:clear-both {\n    clear: both;\n  }\n\n  .md\\:clear-none {\n    clear: none;\n  }\n\n  .md\\:font-sans {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  }\n\n  .md\\:font-serif {\n    font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n  }\n\n  .md\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  }\n\n  .md\\:font-hairline {\n    font-weight: 100;\n  }\n\n  .md\\:font-thin {\n    font-weight: 200;\n  }\n\n  .md\\:font-light {\n    font-weight: 300;\n  }\n\n  .md\\:font-normal {\n    font-weight: 400;\n  }\n\n  .md\\:font-medium {\n    font-weight: 500;\n  }\n\n  .md\\:font-semibold {\n    font-weight: 600;\n  }\n\n  .md\\:font-bold {\n    font-weight: 700;\n  }\n\n  .md\\:font-extrabold {\n    font-weight: 800;\n  }\n\n  .md\\:font-black {\n    font-weight: 900;\n  }\n\n  .md\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n  }\n\n  .md\\:hover\\:font-thin:hover {\n    font-weight: 200;\n  }\n\n  .md\\:hover\\:font-light:hover {\n    font-weight: 300;\n  }\n\n  .md\\:hover\\:font-normal:hover {\n    font-weight: 400;\n  }\n\n  .md\\:hover\\:font-medium:hover {\n    font-weight: 500;\n  }\n\n  .md\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n  }\n\n  .md\\:hover\\:font-bold:hover {\n    font-weight: 700;\n  }\n\n  .md\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n  }\n\n  .md\\:hover\\:font-black:hover {\n    font-weight: 900;\n  }\n\n  .md\\:focus\\:font-hairline:focus {\n    font-weight: 100;\n  }\n\n  .md\\:focus\\:font-thin:focus {\n    font-weight: 200;\n  }\n\n  .md\\:focus\\:font-light:focus {\n    font-weight: 300;\n  }\n\n  .md\\:focus\\:font-normal:focus {\n    font-weight: 400;\n  }\n\n  .md\\:focus\\:font-medium:focus {\n    font-weight: 500;\n  }\n\n  .md\\:focus\\:font-semibold:focus {\n    font-weight: 600;\n  }\n\n  .md\\:focus\\:font-bold:focus {\n    font-weight: 700;\n  }\n\n  .md\\:focus\\:font-extrabold:focus {\n    font-weight: 800;\n  }\n\n  .md\\:focus\\:font-black:focus {\n    font-weight: 900;\n  }\n\n  .md\\:h-0 {\n    height: 0;\n  }\n\n  .md\\:h-1 {\n    height: 0.25rem;\n  }\n\n  .md\\:h-2 {\n    height: 0.5rem;\n  }\n\n  .md\\:h-3 {\n    height: 0.75rem;\n  }\n\n  .md\\:h-4 {\n    height: 1rem;\n  }\n\n  .md\\:h-5 {\n    height: 1.25rem;\n  }\n\n  .md\\:h-6 {\n    height: 1.5rem;\n  }\n\n  .md\\:h-8 {\n    height: 2rem;\n  }\n\n  .md\\:h-10 {\n    height: 2.5rem;\n  }\n\n  .md\\:h-12 {\n    height: 3rem;\n  }\n\n  .md\\:h-16 {\n    height: 4rem;\n  }\n\n  .md\\:h-20 {\n    height: 5rem;\n  }\n\n  .md\\:h-24 {\n    height: 6rem;\n  }\n\n  .md\\:h-32 {\n    height: 8rem;\n  }\n\n  .md\\:h-40 {\n    height: 10rem;\n  }\n\n  .md\\:h-48 {\n    height: 12rem;\n  }\n\n  .md\\:h-56 {\n    height: 14rem;\n  }\n\n  .md\\:h-64 {\n    height: 16rem;\n  }\n\n  .md\\:h-auto {\n    height: auto;\n  }\n\n  .md\\:h-px {\n    height: 1px;\n  }\n\n  .md\\:h-full {\n    height: 100%;\n  }\n\n  .md\\:h-screen {\n    height: 100vh;\n  }\n\n  .md\\:text-15 {\n    font-size: 0.9375rem;\n  }\n\n  .md\\:text-xs {\n    font-size: 0.75rem;\n  }\n\n  .md\\:text-sm {\n    font-size: 0.875rem;\n  }\n\n  .md\\:text-base {\n    font-size: 1rem;\n  }\n\n  .md\\:text-lg {\n    font-size: 1.125rem;\n  }\n\n  .md\\:text-xl {\n    font-size: 1.25rem;\n  }\n\n  .md\\:text-1\\.5xl {\n    font-size: 1.375rem;\n  }\n\n  .md\\:text-2xl {\n    font-size: 1.5rem;\n  }\n\n  .md\\:text-3xl {\n    font-size: 1.875rem;\n  }\n\n  .md\\:text-4xl {\n    font-size: 2.25rem;\n  }\n\n  .md\\:text-5xl {\n    font-size: 3rem;\n  }\n\n  .md\\:text-6xl {\n    font-size: 4rem;\n  }\n\n  .md\\:leading-3 {\n    line-height: .75rem;\n  }\n\n  .md\\:leading-4 {\n    line-height: 1rem;\n  }\n\n  .md\\:leading-5 {\n    line-height: 1.25rem;\n  }\n\n  .md\\:leading-6 {\n    line-height: 1.5rem;\n  }\n\n  .md\\:leading-7 {\n    line-height: 1.75rem;\n  }\n\n  .md\\:leading-8 {\n    line-height: 2rem;\n  }\n\n  .md\\:leading-9 {\n    line-height: 2.25rem;\n  }\n\n  .md\\:leading-10 {\n    line-height: 2.5rem;\n  }\n\n  .md\\:leading-none {\n    line-height: 1;\n  }\n\n  .md\\:leading-tight {\n    line-height: 1.25;\n  }\n\n  .md\\:leading-snug {\n    line-height: 1.375;\n  }\n\n  .md\\:leading-normal {\n    line-height: 1.5;\n  }\n\n  .md\\:leading-relaxed {\n    line-height: 1.625;\n  }\n\n  .md\\:leading-loose {\n    line-height: 2;\n  }\n\n  .md\\:list-inside {\n    list-style-position: inside;\n  }\n\n  .md\\:list-outside {\n    list-style-position: outside;\n  }\n\n  .md\\:list-none {\n    list-style-type: none;\n  }\n\n  .md\\:list-disc {\n    list-style-type: disc;\n  }\n\n  .md\\:list-decimal {\n    list-style-type: decimal;\n  }\n\n  .md\\:m-0 {\n    margin: 0;\n  }\n\n  .md\\:m-1 {\n    margin: 0.25rem;\n  }\n\n  .md\\:m-2 {\n    margin: 0.5rem;\n  }\n\n  .md\\:m-3 {\n    margin: 0.75rem;\n  }\n\n  .md\\:m-4 {\n    margin: 1rem;\n  }\n\n  .md\\:m-5 {\n    margin: 1.25rem;\n  }\n\n  .md\\:m-6 {\n    margin: 1.5rem;\n  }\n\n  .md\\:m-8 {\n    margin: 2rem;\n  }\n\n  .md\\:m-10 {\n    margin: 2.5rem;\n  }\n\n  .md\\:m-12 {\n    margin: 3rem;\n  }\n\n  .md\\:m-16 {\n    margin: 4rem;\n  }\n\n  .md\\:m-20 {\n    margin: 5rem;\n  }\n\n  .md\\:m-24 {\n    margin: 6rem;\n  }\n\n  .md\\:m-32 {\n    margin: 8rem;\n  }\n\n  .md\\:m-40 {\n    margin: 10rem;\n  }\n\n  .md\\:m-48 {\n    margin: 12rem;\n  }\n\n  .md\\:m-56 {\n    margin: 14rem;\n  }\n\n  .md\\:m-64 {\n    margin: 16rem;\n  }\n\n  .md\\:m-auto {\n    margin: auto;\n  }\n\n  .md\\:m-px {\n    margin: 1px;\n  }\n\n  .md\\:-m-1 {\n    margin: -0.25rem;\n  }\n\n  .md\\:-m-2 {\n    margin: -0.5rem;\n  }\n\n  .md\\:-m-3 {\n    margin: -0.75rem;\n  }\n\n  .md\\:-m-4 {\n    margin: -1rem;\n  }\n\n  .md\\:-m-5 {\n    margin: -1.25rem;\n  }\n\n  .md\\:-m-6 {\n    margin: -1.5rem;\n  }\n\n  .md\\:-m-8 {\n    margin: -2rem;\n  }\n\n  .md\\:-m-10 {\n    margin: -2.5rem;\n  }\n\n  .md\\:-m-12 {\n    margin: -3rem;\n  }\n\n  .md\\:-m-16 {\n    margin: -4rem;\n  }\n\n  .md\\:-m-20 {\n    margin: -5rem;\n  }\n\n  .md\\:-m-24 {\n    margin: -6rem;\n  }\n\n  .md\\:-m-32 {\n    margin: -8rem;\n  }\n\n  .md\\:-m-40 {\n    margin: -10rem;\n  }\n\n  .md\\:-m-48 {\n    margin: -12rem;\n  }\n\n  .md\\:-m-56 {\n    margin: -14rem;\n  }\n\n  .md\\:-m-64 {\n    margin: -16rem;\n  }\n\n  .md\\:-m-px {\n    margin: -1px;\n  }\n\n  .md\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .md\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .md\\:my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n\n  .md\\:mx-1 {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n\n  .md\\:my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .md\\:mx-2 {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n\n  .md\\:my-3 {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .md\\:mx-3 {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n\n  .md\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .md\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n\n  .md\\:my-5 {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .md\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n\n  .md\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .md\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n\n  .md\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  .md\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n\n  .md\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n\n  .md\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n\n  .md\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n\n  .md\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n\n  .md\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n\n  .md\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n\n  .md\\:my-20 {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n\n  .md\\:mx-20 {\n    margin-left: 5rem;\n    margin-right: 5rem;\n  }\n\n  .md\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n\n  .md\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n\n  .md\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n\n  .md\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n\n  .md\\:my-40 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n  }\n\n  .md\\:mx-40 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n  }\n\n  .md\\:my-48 {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n\n  .md\\:mx-48 {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n\n  .md\\:my-56 {\n    margin-top: 14rem;\n    margin-bottom: 14rem;\n  }\n\n  .md\\:mx-56 {\n    margin-left: 14rem;\n    margin-right: 14rem;\n  }\n\n  .md\\:my-64 {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n\n  .md\\:mx-64 {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n\n  .md\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n\n  .md\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .md\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n\n  .md\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n  }\n\n  .md\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n  }\n\n  .md\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n  }\n\n  .md\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n  }\n\n  .md\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n\n  .md\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n  }\n\n  .md\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n  }\n\n  .md\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n  }\n\n  .md\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n  }\n\n  .md\\:-my-5 {\n    margin-top: -1.25rem;\n    margin-bottom: -1.25rem;\n  }\n\n  .md\\:-mx-5 {\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n\n  .md\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n  }\n\n  .md\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n\n  .md\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n  }\n\n  .md\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n\n  .md\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n  }\n\n  .md\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n  }\n\n  .md\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n  }\n\n  .md\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n  }\n\n  .md\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n  }\n\n  .md\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n  }\n\n  .md\\:-my-20 {\n    margin-top: -5rem;\n    margin-bottom: -5rem;\n  }\n\n  .md\\:-mx-20 {\n    margin-left: -5rem;\n    margin-right: -5rem;\n  }\n\n  .md\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n  }\n\n  .md\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n  }\n\n  .md\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n  }\n\n  .md\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n  }\n\n  .md\\:-my-40 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n  }\n\n  .md\\:-mx-40 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n  }\n\n  .md\\:-my-48 {\n    margin-top: -12rem;\n    margin-bottom: -12rem;\n  }\n\n  .md\\:-mx-48 {\n    margin-left: -12rem;\n    margin-right: -12rem;\n  }\n\n  .md\\:-my-56 {\n    margin-top: -14rem;\n    margin-bottom: -14rem;\n  }\n\n  .md\\:-mx-56 {\n    margin-left: -14rem;\n    margin-right: -14rem;\n  }\n\n  .md\\:-my-64 {\n    margin-top: -16rem;\n    margin-bottom: -16rem;\n  }\n\n  .md\\:-mx-64 {\n    margin-left: -16rem;\n    margin-right: -16rem;\n  }\n\n  .md\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n  }\n\n  .md\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n  }\n\n  .md\\:mt-0 {\n    margin-top: 0;\n  }\n\n  .md\\:mr-0 {\n    margin-right: 0;\n  }\n\n  .md\\:mb-0 {\n    margin-bottom: 0;\n  }\n\n  .md\\:ml-0 {\n    margin-left: 0;\n  }\n\n  .md\\:mt-1 {\n    margin-top: 0.25rem;\n  }\n\n  .md\\:mr-1 {\n    margin-right: 0.25rem;\n  }\n\n  .md\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n\n  .md\\:ml-1 {\n    margin-left: 0.25rem;\n  }\n\n  .md\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n\n  .md\\:mr-2 {\n    margin-right: 0.5rem;\n  }\n\n  .md\\:mb-2 {\n    margin-bottom: 0.5rem;\n  }\n\n  .md\\:ml-2 {\n    margin-left: 0.5rem;\n  }\n\n  .md\\:mt-3 {\n    margin-top: 0.75rem;\n  }\n\n  .md\\:mr-3 {\n    margin-right: 0.75rem;\n  }\n\n  .md\\:mb-3 {\n    margin-bottom: 0.75rem;\n  }\n\n  .md\\:ml-3 {\n    margin-left: 0.75rem;\n  }\n\n  .md\\:mt-4 {\n    margin-top: 1rem;\n  }\n\n  .md\\:mr-4 {\n    margin-right: 1rem;\n  }\n\n  .md\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n\n  .md\\:ml-4 {\n    margin-left: 1rem;\n  }\n\n  .md\\:mt-5 {\n    margin-top: 1.25rem;\n  }\n\n  .md\\:mr-5 {\n    margin-right: 1.25rem;\n  }\n\n  .md\\:mb-5 {\n    margin-bottom: 1.25rem;\n  }\n\n  .md\\:ml-5 {\n    margin-left: 1.25rem;\n  }\n\n  .md\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n\n  .md\\:mr-6 {\n    margin-right: 1.5rem;\n  }\n\n  .md\\:mb-6 {\n    margin-bottom: 1.5rem;\n  }\n\n  .md\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n\n  .md\\:mt-8 {\n    margin-top: 2rem;\n  }\n\n  .md\\:mr-8 {\n    margin-right: 2rem;\n  }\n\n  .md\\:mb-8 {\n    margin-bottom: 2rem;\n  }\n\n  .md\\:ml-8 {\n    margin-left: 2rem;\n  }\n\n  .md\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n\n  .md\\:mr-10 {\n    margin-right: 2.5rem;\n  }\n\n  .md\\:mb-10 {\n    margin-bottom: 2.5rem;\n  }\n\n  .md\\:ml-10 {\n    margin-left: 2.5rem;\n  }\n\n  .md\\:mt-12 {\n    margin-top: 3rem;\n  }\n\n  .md\\:mr-12 {\n    margin-right: 3rem;\n  }\n\n  .md\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n\n  .md\\:ml-12 {\n    margin-left: 3rem;\n  }\n\n  .md\\:mt-16 {\n    margin-top: 4rem;\n  }\n\n  .md\\:mr-16 {\n    margin-right: 4rem;\n  }\n\n  .md\\:mb-16 {\n    margin-bottom: 4rem;\n  }\n\n  .md\\:ml-16 {\n    margin-left: 4rem;\n  }\n\n  .md\\:mt-20 {\n    margin-top: 5rem;\n  }\n\n  .md\\:mr-20 {\n    margin-right: 5rem;\n  }\n\n  .md\\:mb-20 {\n    margin-bottom: 5rem;\n  }\n\n  .md\\:ml-20 {\n    margin-left: 5rem;\n  }\n\n  .md\\:mt-24 {\n    margin-top: 6rem;\n  }\n\n  .md\\:mr-24 {\n    margin-right: 6rem;\n  }\n\n  .md\\:mb-24 {\n    margin-bottom: 6rem;\n  }\n\n  .md\\:ml-24 {\n    margin-left: 6rem;\n  }\n\n  .md\\:mt-32 {\n    margin-top: 8rem;\n  }\n\n  .md\\:mr-32 {\n    margin-right: 8rem;\n  }\n\n  .md\\:mb-32 {\n    margin-bottom: 8rem;\n  }\n\n  .md\\:ml-32 {\n    margin-left: 8rem;\n  }\n\n  .md\\:mt-40 {\n    margin-top: 10rem;\n  }\n\n  .md\\:mr-40 {\n    margin-right: 10rem;\n  }\n\n  .md\\:mb-40 {\n    margin-bottom: 10rem;\n  }\n\n  .md\\:ml-40 {\n    margin-left: 10rem;\n  }\n\n  .md\\:mt-48 {\n    margin-top: 12rem;\n  }\n\n  .md\\:mr-48 {\n    margin-right: 12rem;\n  }\n\n  .md\\:mb-48 {\n    margin-bottom: 12rem;\n  }\n\n  .md\\:ml-48 {\n    margin-left: 12rem;\n  }\n\n  .md\\:mt-56 {\n    margin-top: 14rem;\n  }\n\n  .md\\:mr-56 {\n    margin-right: 14rem;\n  }\n\n  .md\\:mb-56 {\n    margin-bottom: 14rem;\n  }\n\n  .md\\:ml-56 {\n    margin-left: 14rem;\n  }\n\n  .md\\:mt-64 {\n    margin-top: 16rem;\n  }\n\n  .md\\:mr-64 {\n    margin-right: 16rem;\n  }\n\n  .md\\:mb-64 {\n    margin-bottom: 16rem;\n  }\n\n  .md\\:ml-64 {\n    margin-left: 16rem;\n  }\n\n  .md\\:mt-auto {\n    margin-top: auto;\n  }\n\n  .md\\:mr-auto {\n    margin-right: auto;\n  }\n\n  .md\\:mb-auto {\n    margin-bottom: auto;\n  }\n\n  .md\\:ml-auto {\n    margin-left: auto;\n  }\n\n  .md\\:mt-px {\n    margin-top: 1px;\n  }\n\n  .md\\:mr-px {\n    margin-right: 1px;\n  }\n\n  .md\\:mb-px {\n    margin-bottom: 1px;\n  }\n\n  .md\\:ml-px {\n    margin-left: 1px;\n  }\n\n  .md\\:-mt-1 {\n    margin-top: -0.25rem;\n  }\n\n  .md\\:-mr-1 {\n    margin-right: -0.25rem;\n  }\n\n  .md\\:-mb-1 {\n    margin-bottom: -0.25rem;\n  }\n\n  .md\\:-ml-1 {\n    margin-left: -0.25rem;\n  }\n\n  .md\\:-mt-2 {\n    margin-top: -0.5rem;\n  }\n\n  .md\\:-mr-2 {\n    margin-right: -0.5rem;\n  }\n\n  .md\\:-mb-2 {\n    margin-bottom: -0.5rem;\n  }\n\n  .md\\:-ml-2 {\n    margin-left: -0.5rem;\n  }\n\n  .md\\:-mt-3 {\n    margin-top: -0.75rem;\n  }\n\n  .md\\:-mr-3 {\n    margin-right: -0.75rem;\n  }\n\n  .md\\:-mb-3 {\n    margin-bottom: -0.75rem;\n  }\n\n  .md\\:-ml-3 {\n    margin-left: -0.75rem;\n  }\n\n  .md\\:-mt-4 {\n    margin-top: -1rem;\n  }\n\n  .md\\:-mr-4 {\n    margin-right: -1rem;\n  }\n\n  .md\\:-mb-4 {\n    margin-bottom: -1rem;\n  }\n\n  .md\\:-ml-4 {\n    margin-left: -1rem;\n  }\n\n  .md\\:-mt-5 {\n    margin-top: -1.25rem;\n  }\n\n  .md\\:-mr-5 {\n    margin-right: -1.25rem;\n  }\n\n  .md\\:-mb-5 {\n    margin-bottom: -1.25rem;\n  }\n\n  .md\\:-ml-5 {\n    margin-left: -1.25rem;\n  }\n\n  .md\\:-mt-6 {\n    margin-top: -1.5rem;\n  }\n\n  .md\\:-mr-6 {\n    margin-right: -1.5rem;\n  }\n\n  .md\\:-mb-6 {\n    margin-bottom: -1.5rem;\n  }\n\n  .md\\:-ml-6 {\n    margin-left: -1.5rem;\n  }\n\n  .md\\:-mt-8 {\n    margin-top: -2rem;\n  }\n\n  .md\\:-mr-8 {\n    margin-right: -2rem;\n  }\n\n  .md\\:-mb-8 {\n    margin-bottom: -2rem;\n  }\n\n  .md\\:-ml-8 {\n    margin-left: -2rem;\n  }\n\n  .md\\:-mt-10 {\n    margin-top: -2.5rem;\n  }\n\n  .md\\:-mr-10 {\n    margin-right: -2.5rem;\n  }\n\n  .md\\:-mb-10 {\n    margin-bottom: -2.5rem;\n  }\n\n  .md\\:-ml-10 {\n    margin-left: -2.5rem;\n  }\n\n  .md\\:-mt-12 {\n    margin-top: -3rem;\n  }\n\n  .md\\:-mr-12 {\n    margin-right: -3rem;\n  }\n\n  .md\\:-mb-12 {\n    margin-bottom: -3rem;\n  }\n\n  .md\\:-ml-12 {\n    margin-left: -3rem;\n  }\n\n  .md\\:-mt-16 {\n    margin-top: -4rem;\n  }\n\n  .md\\:-mr-16 {\n    margin-right: -4rem;\n  }\n\n  .md\\:-mb-16 {\n    margin-bottom: -4rem;\n  }\n\n  .md\\:-ml-16 {\n    margin-left: -4rem;\n  }\n\n  .md\\:-mt-20 {\n    margin-top: -5rem;\n  }\n\n  .md\\:-mr-20 {\n    margin-right: -5rem;\n  }\n\n  .md\\:-mb-20 {\n    margin-bottom: -5rem;\n  }\n\n  .md\\:-ml-20 {\n    margin-left: -5rem;\n  }\n\n  .md\\:-mt-24 {\n    margin-top: -6rem;\n  }\n\n  .md\\:-mr-24 {\n    margin-right: -6rem;\n  }\n\n  .md\\:-mb-24 {\n    margin-bottom: -6rem;\n  }\n\n  .md\\:-ml-24 {\n    margin-left: -6rem;\n  }\n\n  .md\\:-mt-32 {\n    margin-top: -8rem;\n  }\n\n  .md\\:-mr-32 {\n    margin-right: -8rem;\n  }\n\n  .md\\:-mb-32 {\n    margin-bottom: -8rem;\n  }\n\n  .md\\:-ml-32 {\n    margin-left: -8rem;\n  }\n\n  .md\\:-mt-40 {\n    margin-top: -10rem;\n  }\n\n  .md\\:-mr-40 {\n    margin-right: -10rem;\n  }\n\n  .md\\:-mb-40 {\n    margin-bottom: -10rem;\n  }\n\n  .md\\:-ml-40 {\n    margin-left: -10rem;\n  }\n\n  .md\\:-mt-48 {\n    margin-top: -12rem;\n  }\n\n  .md\\:-mr-48 {\n    margin-right: -12rem;\n  }\n\n  .md\\:-mb-48 {\n    margin-bottom: -12rem;\n  }\n\n  .md\\:-ml-48 {\n    margin-left: -12rem;\n  }\n\n  .md\\:-mt-56 {\n    margin-top: -14rem;\n  }\n\n  .md\\:-mr-56 {\n    margin-right: -14rem;\n  }\n\n  .md\\:-mb-56 {\n    margin-bottom: -14rem;\n  }\n\n  .md\\:-ml-56 {\n    margin-left: -14rem;\n  }\n\n  .md\\:-mt-64 {\n    margin-top: -16rem;\n  }\n\n  .md\\:-mr-64 {\n    margin-right: -16rem;\n  }\n\n  .md\\:-mb-64 {\n    margin-bottom: -16rem;\n  }\n\n  .md\\:-ml-64 {\n    margin-left: -16rem;\n  }\n\n  .md\\:-mt-px {\n    margin-top: -1px;\n  }\n\n  .md\\:-mr-px {\n    margin-right: -1px;\n  }\n\n  .md\\:-mb-px {\n    margin-bottom: -1px;\n  }\n\n  .md\\:-ml-px {\n    margin-left: -1px;\n  }\n\n  .md\\:max-h-full {\n    max-height: 100%;\n  }\n\n  .md\\:max-h-screen {\n    max-height: 100vh;\n  }\n\n  .md\\:max-w-none {\n    max-width: none;\n  }\n\n  .md\\:max-w-xs {\n    max-width: 20rem;\n  }\n\n  .md\\:max-w-sm {\n    max-width: 24rem;\n  }\n\n  .md\\:max-w-md {\n    max-width: 28rem;\n  }\n\n  .md\\:max-w-lg {\n    max-width: 32rem;\n  }\n\n  .md\\:max-w-xl {\n    max-width: 36rem;\n  }\n\n  .md\\:max-w-2xl {\n    max-width: 42rem;\n  }\n\n  .md\\:max-w-3xl {\n    max-width: 48rem;\n  }\n\n  .md\\:max-w-4xl {\n    max-width: 56rem;\n  }\n\n  .md\\:max-w-5xl {\n    max-width: 64rem;\n  }\n\n  .md\\:max-w-6xl {\n    max-width: 72rem;\n  }\n\n  .md\\:max-w-full {\n    max-width: 100%;\n  }\n\n  .md\\:max-w-screen-sm {\n    max-width: 640px;\n  }\n\n  .md\\:max-w-screen-md {\n    max-width: 768px;\n  }\n\n  .md\\:max-w-screen-lg {\n    max-width: 1024px;\n  }\n\n  .md\\:max-w-screen-xl {\n    max-width: 1280px;\n  }\n\n  .md\\:min-h-0 {\n    min-height: 0;\n  }\n\n  .md\\:min-h-full {\n    min-height: 100%;\n  }\n\n  .md\\:min-h-screen {\n    min-height: 100vh;\n  }\n\n  .md\\:min-w-0 {\n    min-width: 0;\n  }\n\n  .md\\:min-w-full {\n    min-width: 100%;\n  }\n\n  .md\\:object-contain {\n    object-fit: contain;\n  }\n\n  .md\\:object-cover {\n    object-fit: cover;\n  }\n\n  .md\\:object-fill {\n    object-fit: fill;\n  }\n\n  .md\\:object-none {\n    object-fit: none;\n  }\n\n  .md\\:object-scale-down {\n    object-fit: scale-down;\n  }\n\n  .md\\:object-bottom {\n    object-position: bottom;\n  }\n\n  .md\\:object-center {\n    object-position: center;\n  }\n\n  .md\\:object-left {\n    object-position: left;\n  }\n\n  .md\\:object-left-bottom {\n    object-position: left bottom;\n  }\n\n  .md\\:object-left-top {\n    object-position: left top;\n  }\n\n  .md\\:object-right {\n    object-position: right;\n  }\n\n  .md\\:object-right-bottom {\n    object-position: right bottom;\n  }\n\n  .md\\:object-right-top {\n    object-position: right top;\n  }\n\n  .md\\:object-top {\n    object-position: top;\n  }\n\n  .md\\:opacity-0 {\n    opacity: 0;\n  }\n\n  .md\\:opacity-25 {\n    opacity: 0.25;\n  }\n\n  .md\\:opacity-50 {\n    opacity: 0.5;\n  }\n\n  .md\\:opacity-75 {\n    opacity: 0.75;\n  }\n\n  .md\\:opacity-100 {\n    opacity: 1;\n  }\n\n  .md\\:hover\\:opacity-0:hover {\n    opacity: 0;\n  }\n\n  .md\\:hover\\:opacity-25:hover {\n    opacity: 0.25;\n  }\n\n  .md\\:hover\\:opacity-50:hover {\n    opacity: 0.5;\n  }\n\n  .md\\:hover\\:opacity-75:hover {\n    opacity: 0.75;\n  }\n\n  .md\\:hover\\:opacity-100:hover {\n    opacity: 1;\n  }\n\n  .md\\:focus\\:opacity-0:focus {\n    opacity: 0;\n  }\n\n  .md\\:focus\\:opacity-25:focus {\n    opacity: 0.25;\n  }\n\n  .md\\:focus\\:opacity-50:focus {\n    opacity: 0.5;\n  }\n\n  .md\\:focus\\:opacity-75:focus {\n    opacity: 0.75;\n  }\n\n  .md\\:focus\\:opacity-100:focus {\n    opacity: 1;\n  }\n\n  .md\\:outline-none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  .md\\:outline-white {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n\n  .md\\:outline-black {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n\n  .md\\:focus\\:outline-none:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  .md\\:focus\\:outline-white:focus {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n\n  .md\\:focus\\:outline-black:focus {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n\n  .md\\:overflow-auto {\n    overflow: auto;\n  }\n\n  .md\\:overflow-hidden {\n    overflow: hidden;\n  }\n\n  .md\\:overflow-visible {\n    overflow: visible;\n  }\n\n  .md\\:overflow-scroll {\n    overflow: scroll;\n  }\n\n  .md\\:overflow-x-auto {\n    overflow-x: auto;\n  }\n\n  .md\\:overflow-y-auto {\n    overflow-y: auto;\n  }\n\n  .md\\:overflow-x-hidden {\n    overflow-x: hidden;\n  }\n\n  .md\\:overflow-y-hidden {\n    overflow-y: hidden;\n  }\n\n  .md\\:overflow-x-visible {\n    overflow-x: visible;\n  }\n\n  .md\\:overflow-y-visible {\n    overflow-y: visible;\n  }\n\n  .md\\:overflow-x-scroll {\n    overflow-x: scroll;\n  }\n\n  .md\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n\n  .md\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .md\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n  }\n\n  .md\\:overscroll-auto {\n    overscroll-behavior: auto;\n  }\n\n  .md\\:overscroll-contain {\n    overscroll-behavior: contain;\n  }\n\n  .md\\:overscroll-none {\n    overscroll-behavior: none;\n  }\n\n  .md\\:overscroll-y-auto {\n    overscroll-behavior-y: auto;\n  }\n\n  .md\\:overscroll-y-contain {\n    overscroll-behavior-y: contain;\n  }\n\n  .md\\:overscroll-y-none {\n    overscroll-behavior-y: none;\n  }\n\n  .md\\:overscroll-x-auto {\n    overscroll-behavior-x: auto;\n  }\n\n  .md\\:overscroll-x-contain {\n    overscroll-behavior-x: contain;\n  }\n\n  .md\\:overscroll-x-none {\n    overscroll-behavior-x: none;\n  }\n\n  .md\\:p-0 {\n    padding: 0;\n  }\n\n  .md\\:p-1 {\n    padding: 0.25rem;\n  }\n\n  .md\\:p-2 {\n    padding: 0.5rem;\n  }\n\n  .md\\:p-3 {\n    padding: 0.75rem;\n  }\n\n  .md\\:p-4 {\n    padding: 1rem;\n  }\n\n  .md\\:p-5 {\n    padding: 1.25rem;\n  }\n\n  .md\\:p-6 {\n    padding: 1.5rem;\n  }\n\n  .md\\:p-8 {\n    padding: 2rem;\n  }\n\n  .md\\:p-10 {\n    padding: 2.5rem;\n  }\n\n  .md\\:p-12 {\n    padding: 3rem;\n  }\n\n  .md\\:p-16 {\n    padding: 4rem;\n  }\n\n  .md\\:p-20 {\n    padding: 5rem;\n  }\n\n  .md\\:p-24 {\n    padding: 6rem;\n  }\n\n  .md\\:p-32 {\n    padding: 8rem;\n  }\n\n  .md\\:p-40 {\n    padding: 10rem;\n  }\n\n  .md\\:p-48 {\n    padding: 12rem;\n  }\n\n  .md\\:p-56 {\n    padding: 14rem;\n  }\n\n  .md\\:p-64 {\n    padding: 16rem;\n  }\n\n  .md\\:p-px {\n    padding: 1px;\n  }\n\n  .md\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .md\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .md\\:py-1 {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .md\\:px-1 {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n\n  .md\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .md\\:px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n\n  .md\\:py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .md\\:px-3 {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n\n  .md\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .md\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .md\\:py-5 {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .md\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n\n  .md\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .md\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .md\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .md\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .md\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .md\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  .md\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n\n  .md\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n\n  .md\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n\n  .md\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n\n  .md\\:py-20 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n\n  .md\\:px-20 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n\n  .md\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n\n  .md\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n\n  .md\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n\n  .md\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n\n  .md\\:py-40 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n\n  .md\\:px-40 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n\n  .md\\:py-48 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n\n  .md\\:px-48 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n\n  .md\\:py-56 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n\n  .md\\:px-56 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n\n  .md\\:py-64 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n\n  .md\\:px-64 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n\n  .md\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n\n  .md\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n\n  .md\\:pt-0 {\n    padding-top: 0;\n  }\n\n  .md\\:pr-0 {\n    padding-right: 0;\n  }\n\n  .md\\:pb-0 {\n    padding-bottom: 0;\n  }\n\n  .md\\:pl-0 {\n    padding-left: 0;\n  }\n\n  .md\\:pt-1 {\n    padding-top: 0.25rem;\n  }\n\n  .md\\:pr-1 {\n    padding-right: 0.25rem;\n  }\n\n  .md\\:pb-1 {\n    padding-bottom: 0.25rem;\n  }\n\n  .md\\:pl-1 {\n    padding-left: 0.25rem;\n  }\n\n  .md\\:pt-2 {\n    padding-top: 0.5rem;\n  }\n\n  .md\\:pr-2 {\n    padding-right: 0.5rem;\n  }\n\n  .md\\:pb-2 {\n    padding-bottom: 0.5rem;\n  }\n\n  .md\\:pl-2 {\n    padding-left: 0.5rem;\n  }\n\n  .md\\:pt-3 {\n    padding-top: 0.75rem;\n  }\n\n  .md\\:pr-3 {\n    padding-right: 0.75rem;\n  }\n\n  .md\\:pb-3 {\n    padding-bottom: 0.75rem;\n  }\n\n  .md\\:pl-3 {\n    padding-left: 0.75rem;\n  }\n\n  .md\\:pt-4 {\n    padding-top: 1rem;\n  }\n\n  .md\\:pr-4 {\n    padding-right: 1rem;\n  }\n\n  .md\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n\n  .md\\:pl-4 {\n    padding-left: 1rem;\n  }\n\n  .md\\:pt-5 {\n    padding-top: 1.25rem;\n  }\n\n  .md\\:pr-5 {\n    padding-right: 1.25rem;\n  }\n\n  .md\\:pb-5 {\n    padding-bottom: 1.25rem;\n  }\n\n  .md\\:pl-5 {\n    padding-left: 1.25rem;\n  }\n\n  .md\\:pt-6 {\n    padding-top: 1.5rem;\n  }\n\n  .md\\:pr-6 {\n    padding-right: 1.5rem;\n  }\n\n  .md\\:pb-6 {\n    padding-bottom: 1.5rem;\n  }\n\n  .md\\:pl-6 {\n    padding-left: 1.5rem;\n  }\n\n  .md\\:pt-8 {\n    padding-top: 2rem;\n  }\n\n  .md\\:pr-8 {\n    padding-right: 2rem;\n  }\n\n  .md\\:pb-8 {\n    padding-bottom: 2rem;\n  }\n\n  .md\\:pl-8 {\n    padding-left: 2rem;\n  }\n\n  .md\\:pt-10 {\n    padding-top: 2.5rem;\n  }\n\n  .md\\:pr-10 {\n    padding-right: 2.5rem;\n  }\n\n  .md\\:pb-10 {\n    padding-bottom: 2.5rem;\n  }\n\n  .md\\:pl-10 {\n    padding-left: 2.5rem;\n  }\n\n  .md\\:pt-12 {\n    padding-top: 3rem;\n  }\n\n  .md\\:pr-12 {\n    padding-right: 3rem;\n  }\n\n  .md\\:pb-12 {\n    padding-bottom: 3rem;\n  }\n\n  .md\\:pl-12 {\n    padding-left: 3rem;\n  }\n\n  .md\\:pt-16 {\n    padding-top: 4rem;\n  }\n\n  .md\\:pr-16 {\n    padding-right: 4rem;\n  }\n\n  .md\\:pb-16 {\n    padding-bottom: 4rem;\n  }\n\n  .md\\:pl-16 {\n    padding-left: 4rem;\n  }\n\n  .md\\:pt-20 {\n    padding-top: 5rem;\n  }\n\n  .md\\:pr-20 {\n    padding-right: 5rem;\n  }\n\n  .md\\:pb-20 {\n    padding-bottom: 5rem;\n  }\n\n  .md\\:pl-20 {\n    padding-left: 5rem;\n  }\n\n  .md\\:pt-24 {\n    padding-top: 6rem;\n  }\n\n  .md\\:pr-24 {\n    padding-right: 6rem;\n  }\n\n  .md\\:pb-24 {\n    padding-bottom: 6rem;\n  }\n\n  .md\\:pl-24 {\n    padding-left: 6rem;\n  }\n\n  .md\\:pt-32 {\n    padding-top: 8rem;\n  }\n\n  .md\\:pr-32 {\n    padding-right: 8rem;\n  }\n\n  .md\\:pb-32 {\n    padding-bottom: 8rem;\n  }\n\n  .md\\:pl-32 {\n    padding-left: 8rem;\n  }\n\n  .md\\:pt-40 {\n    padding-top: 10rem;\n  }\n\n  .md\\:pr-40 {\n    padding-right: 10rem;\n  }\n\n  .md\\:pb-40 {\n    padding-bottom: 10rem;\n  }\n\n  .md\\:pl-40 {\n    padding-left: 10rem;\n  }\n\n  .md\\:pt-48 {\n    padding-top: 12rem;\n  }\n\n  .md\\:pr-48 {\n    padding-right: 12rem;\n  }\n\n  .md\\:pb-48 {\n    padding-bottom: 12rem;\n  }\n\n  .md\\:pl-48 {\n    padding-left: 12rem;\n  }\n\n  .md\\:pt-56 {\n    padding-top: 14rem;\n  }\n\n  .md\\:pr-56 {\n    padding-right: 14rem;\n  }\n\n  .md\\:pb-56 {\n    padding-bottom: 14rem;\n  }\n\n  .md\\:pl-56 {\n    padding-left: 14rem;\n  }\n\n  .md\\:pt-64 {\n    padding-top: 16rem;\n  }\n\n  .md\\:pr-64 {\n    padding-right: 16rem;\n  }\n\n  .md\\:pb-64 {\n    padding-bottom: 16rem;\n  }\n\n  .md\\:pl-64 {\n    padding-left: 16rem;\n  }\n\n  .md\\:pt-px {\n    padding-top: 1px;\n  }\n\n  .md\\:pr-px {\n    padding-right: 1px;\n  }\n\n  .md\\:pb-px {\n    padding-bottom: 1px;\n  }\n\n  .md\\:pl-px {\n    padding-left: 1px;\n  }\n\n  .md\\:placeholder-transparent::placeholder {\n    color: transparent;\n  }\n\n  .md\\:placeholder-current::placeholder {\n    color: currentColor;\n  }\n\n  .md\\:placeholder-black::placeholder {\n    --placeholder-opacity: 1;\n    color: #000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-white::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f7fafc;\n    color: rgba(247, 250, 252, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #edf2f7;\n    color: rgba(237, 242, 247, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #cbd5e0;\n    color: rgba(203, 213, 224, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160, 174, 192, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #718096;\n    color: rgba(113, 128, 150, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a5568;\n    color: rgba(74, 85, 104, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #2d3748;\n    color: rgba(45, 55, 72, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202c;\n    color: rgba(26, 32, 44, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f5;\n    color: rgba(255, 245, 245, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7d7;\n    color: rgba(254, 215, 215, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #feb2b2;\n    color: rgba(254, 178, 178, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #fc8181;\n    color: rgba(252, 129, 129, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #f56565;\n    color: rgba(245, 101, 101, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #e53e3e;\n    color: rgba(229, 62, 62, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c53030;\n    color: rgba(197, 48, 48, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b2c2c;\n    color: rgba(155, 44, 44, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-red-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #742a2a;\n    color: rgba(116, 42, 42, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffaf0;\n    color: rgba(255, 250, 240, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #feebc8;\n    color: rgba(254, 235, 200, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd38d;\n    color: rgba(251, 211, 141, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6ad55;\n    color: rgba(246, 173, 85, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed8936;\n    color: rgba(237, 137, 54, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #dd6b20;\n    color: rgba(221, 107, 32, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c05621;\n    color: rgba(192, 86, 33, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9c4221;\n    color: rgba(156, 66, 33, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-orange-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #7b341e;\n    color: rgba(123, 52, 30, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffff0;\n    color: rgba(255, 255, 240, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fefcbf;\n    color: rgba(254, 252, 191, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf089;\n    color: rgba(250, 240, 137, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6e05e;\n    color: rgba(246, 224, 94, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ecc94b;\n    color: rgba(236, 201, 75, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d69e2e;\n    color: rgba(214, 158, 46, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b7791f;\n    color: rgba(183, 121, 31, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #975a16;\n    color: rgba(151, 90, 22, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-yellow-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #744210;\n    color: rgba(116, 66, 16, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0fff4;\n    color: rgba(240, 255, 244, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c6f6d5;\n    color: rgba(198, 246, 213, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #9ae6b4;\n    color: rgba(154, 230, 180, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #68d391;\n    color: rgba(104, 211, 145, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #48bb78;\n    color: rgba(72, 187, 120, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #38a169;\n    color: rgba(56, 161, 105, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2f855a;\n    color: rgba(47, 133, 90, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #276749;\n    color: rgba(39, 103, 73, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-green-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #22543d;\n    color: rgba(34, 84, 61, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e6fffa;\n    color: rgba(230, 255, 250, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #b2f5ea;\n    color: rgba(178, 245, 234, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #81e6d9;\n    color: rgba(129, 230, 217, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #4fd1c5;\n    color: rgba(79, 209, 197, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #38b2ac;\n    color: rgba(56, 178, 172, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #319795;\n    color: rgba(49, 151, 149, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c7a7b;\n    color: rgba(44, 122, 123, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #285e61;\n    color: rgba(40, 94, 97, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-teal-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #234e52;\n    color: rgba(35, 78, 82, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf8ff;\n    color: rgba(235, 248, 255, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #bee3f8;\n    color: rgba(190, 227, 248, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #90cdf4;\n    color: rgba(144, 205, 244, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #63b3ed;\n    color: rgba(99, 179, 237, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #4299e1;\n    color: rgba(66, 153, 225, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #3182ce;\n    color: rgba(49, 130, 206, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2b6cb0;\n    color: rgba(43, 108, 176, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c5282;\n    color: rgba(44, 82, 130, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-blue-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #2a4365;\n    color: rgba(42, 67, 101, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf4ff;\n    color: rgba(235, 244, 255, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3dafe;\n    color: rgba(195, 218, 254, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #a3bffa;\n    color: rgba(163, 191, 250, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #7f9cf5;\n    color: rgba(127, 156, 245, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #667eea;\n    color: rgba(102, 126, 234, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #5a67d8;\n    color: rgba(90, 103, 216, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #4c51bf;\n    color: rgba(76, 81, 191, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #434190;\n    color: rgba(67, 65, 144, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-indigo-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #3c366b;\n    color: rgba(60, 54, 107, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf5ff;\n    color: rgba(250, 245, 255, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e9d8fd;\n    color: rgba(233, 216, 253, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #d6bcfa;\n    color: rgba(214, 188, 250, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #b794f4;\n    color: rgba(183, 148, 244, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f7aea;\n    color: rgba(159, 122, 234, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #805ad5;\n    color: rgba(128, 90, 213, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b46c1;\n    color: rgba(107, 70, 193, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #553c9a;\n    color: rgba(85, 60, 154, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-purple-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #44337a;\n    color: rgba(68, 51, 122, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f7;\n    color: rgba(255, 245, 247, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7e2;\n    color: rgba(254, 215, 226, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbb6ce;\n    color: rgba(251, 182, 206, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f687b3;\n    color: rgba(246, 135, 179, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed64a6;\n    color: rgba(237, 100, 166, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d53f8c;\n    color: rgba(213, 63, 140, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b83280;\n    color: rgba(184, 50, 128, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #97266d;\n    color: rgba(151, 38, 109, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-pink-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #702459;\n    color: rgba(112, 36, 89, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-transparent:focus::placeholder {\n    color: transparent;\n  }\n\n  .md\\:focus\\:placeholder-current:focus::placeholder {\n    color: currentColor;\n  }\n\n  .md\\:focus\\:placeholder-black:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-white:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f7fafc;\n    color: rgba(247, 250, 252, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edf2f7;\n    color: rgba(237, 242, 247, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cbd5e0;\n    color: rgba(203, 213, 224, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160, 174, 192, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #718096;\n    color: rgba(113, 128, 150, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a5568;\n    color: rgba(74, 85, 104, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2d3748;\n    color: rgba(45, 55, 72, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202c;\n    color: rgba(26, 32, 44, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f5;\n    color: rgba(255, 245, 245, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7d7;\n    color: rgba(254, 215, 215, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feb2b2;\n    color: rgba(254, 178, 178, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fc8181;\n    color: rgba(252, 129, 129, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f56565;\n    color: rgba(245, 101, 101, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e53e3e;\n    color: rgba(229, 62, 62, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c53030;\n    color: rgba(197, 48, 48, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b2c2c;\n    color: rgba(155, 44, 44, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-red-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #742a2a;\n    color: rgba(116, 42, 42, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffaf0;\n    color: rgba(255, 250, 240, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feebc8;\n    color: rgba(254, 235, 200, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd38d;\n    color: rgba(251, 211, 141, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6ad55;\n    color: rgba(246, 173, 85, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed8936;\n    color: rgba(237, 137, 54, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #dd6b20;\n    color: rgba(221, 107, 32, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c05621;\n    color: rgba(192, 86, 33, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9c4221;\n    color: rgba(156, 66, 33, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-orange-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7b341e;\n    color: rgba(123, 52, 30, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffff0;\n    color: rgba(255, 255, 240, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fefcbf;\n    color: rgba(254, 252, 191, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf089;\n    color: rgba(250, 240, 137, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6e05e;\n    color: rgba(246, 224, 94, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ecc94b;\n    color: rgba(236, 201, 75, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d69e2e;\n    color: rgba(214, 158, 46, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b7791f;\n    color: rgba(183, 121, 31, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #975a16;\n    color: rgba(151, 90, 22, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-yellow-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #744210;\n    color: rgba(116, 66, 16, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0fff4;\n    color: rgba(240, 255, 244, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c6f6d5;\n    color: rgba(198, 246, 213, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9ae6b4;\n    color: rgba(154, 230, 180, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #68d391;\n    color: rgba(104, 211, 145, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #48bb78;\n    color: rgba(72, 187, 120, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #38a169;\n    color: rgba(56, 161, 105, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2f855a;\n    color: rgba(47, 133, 90, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #276749;\n    color: rgba(39, 103, 73, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-green-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #22543d;\n    color: rgba(34, 84, 61, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e6fffa;\n    color: rgba(230, 255, 250, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b2f5ea;\n    color: rgba(178, 245, 234, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #81e6d9;\n    color: rgba(129, 230, 217, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4fd1c5;\n    color: rgba(79, 209, 197, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #38b2ac;\n    color: rgba(56, 178, 172, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #319795;\n    color: rgba(49, 151, 149, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c7a7b;\n    color: rgba(44, 122, 123, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #285e61;\n    color: rgba(40, 94, 97, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-teal-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #234e52;\n    color: rgba(35, 78, 82, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf8ff;\n    color: rgba(235, 248, 255, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bee3f8;\n    color: rgba(190, 227, 248, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #90cdf4;\n    color: rgba(144, 205, 244, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #63b3ed;\n    color: rgba(99, 179, 237, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4299e1;\n    color: rgba(66, 153, 225, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3182ce;\n    color: rgba(49, 130, 206, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2b6cb0;\n    color: rgba(43, 108, 176, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c5282;\n    color: rgba(44, 82, 130, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-blue-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2a4365;\n    color: rgba(42, 67, 101, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf4ff;\n    color: rgba(235, 244, 255, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3dafe;\n    color: rgba(195, 218, 254, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a3bffa;\n    color: rgba(163, 191, 250, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7f9cf5;\n    color: rgba(127, 156, 245, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #667eea;\n    color: rgba(102, 126, 234, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5a67d8;\n    color: rgba(90, 103, 216, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4c51bf;\n    color: rgba(76, 81, 191, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #434190;\n    color: rgba(67, 65, 144, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-indigo-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3c366b;\n    color: rgba(60, 54, 107, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf5ff;\n    color: rgba(250, 245, 255, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e9d8fd;\n    color: rgba(233, 216, 253, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d6bcfa;\n    color: rgba(214, 188, 250, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b794f4;\n    color: rgba(183, 148, 244, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f7aea;\n    color: rgba(159, 122, 234, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #805ad5;\n    color: rgba(128, 90, 213, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b46c1;\n    color: rgba(107, 70, 193, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #553c9a;\n    color: rgba(85, 60, 154, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-purple-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #44337a;\n    color: rgba(68, 51, 122, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f7;\n    color: rgba(255, 245, 247, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7e2;\n    color: rgba(254, 215, 226, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbb6ce;\n    color: rgba(251, 182, 206, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f687b3;\n    color: rgba(246, 135, 179, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed64a6;\n    color: rgba(237, 100, 166, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d53f8c;\n    color: rgba(213, 63, 140, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b83280;\n    color: rgba(184, 50, 128, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #97266d;\n    color: rgba(151, 38, 109, var(--placeholder-opacity));\n  }\n\n  .md\\:focus\\:placeholder-pink-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #702459;\n    color: rgba(112, 36, 89, var(--placeholder-opacity));\n  }\n\n  .md\\:placeholder-opacity-0::placeholder {\n    --placeholder-opacity: 0;\n  }\n\n  .md\\:placeholder-opacity-25::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n\n  .md\\:placeholder-opacity-50::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n\n  .md\\:placeholder-opacity-75::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n\n  .md\\:placeholder-opacity-100::placeholder {\n    --placeholder-opacity: 1;\n  }\n\n  .md\\:focus\\:placeholder-opacity-0:focus::placeholder {\n    --placeholder-opacity: 0;\n  }\n\n  .md\\:focus\\:placeholder-opacity-25:focus::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n\n  .md\\:focus\\:placeholder-opacity-50:focus::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n\n  .md\\:focus\\:placeholder-opacity-75:focus::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n\n  .md\\:focus\\:placeholder-opacity-100:focus::placeholder {\n    --placeholder-opacity: 1;\n  }\n\n  .md\\:pointer-events-none {\n    pointer-events: none;\n  }\n\n  .md\\:pointer-events-auto {\n    pointer-events: auto;\n  }\n\n  .md\\:static {\n    position: static;\n  }\n\n  .md\\:fixed {\n    position: fixed;\n  }\n\n  .md\\:absolute {\n    position: absolute;\n  }\n\n  .md\\:relative {\n    position: relative;\n  }\n\n  .md\\:sticky {\n    position: sticky;\n  }\n\n  .md\\:inset-0 {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  .md\\:inset-auto {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n  }\n\n  .md\\:inset-y-0 {\n    top: 0;\n    bottom: 0;\n  }\n\n  .md\\:inset-x-0 {\n    right: 0;\n    left: 0;\n  }\n\n  .md\\:inset-y-auto {\n    top: auto;\n    bottom: auto;\n  }\n\n  .md\\:inset-x-auto {\n    right: auto;\n    left: auto;\n  }\n\n  .md\\:top-0 {\n    top: 0;\n  }\n\n  .md\\:right-0 {\n    right: 0;\n  }\n\n  .md\\:bottom-0 {\n    bottom: 0;\n  }\n\n  .md\\:left-0 {\n    left: 0;\n  }\n\n  .md\\:top-auto {\n    top: auto;\n  }\n\n  .md\\:right-auto {\n    right: auto;\n  }\n\n  .md\\:bottom-auto {\n    bottom: auto;\n  }\n\n  .md\\:left-auto {\n    left: auto;\n  }\n\n  .md\\:resize-none {\n    resize: none;\n  }\n\n  .md\\:resize-y {\n    resize: vertical;\n  }\n\n  .md\\:resize-x {\n    resize: horizontal;\n  }\n\n  .md\\:resize {\n    resize: both;\n  }\n\n  .md\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .md\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .md\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .md\\:shadow-none {\n    box-shadow: none;\n  }\n\n  .md\\:hover\\:shadow-xs:hover {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:hover\\:shadow-sm:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:hover\\:shadow:hover {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:hover\\:shadow-md:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:hover\\:shadow-lg:hover {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:hover\\:shadow-xl:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .md\\:hover\\:shadow-2xl:hover {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .md\\:hover\\:shadow-inner:hover {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:hover\\:shadow-outline:hover {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .md\\:hover\\:shadow-none:hover {\n    box-shadow: none;\n  }\n\n  .md\\:focus\\:shadow-xs:focus {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:focus\\:shadow-sm:focus {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:focus\\:shadow:focus {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:focus\\:shadow-md:focus {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:focus\\:shadow-lg:focus {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .md\\:focus\\:shadow-xl:focus {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .md\\:focus\\:shadow-2xl:focus {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .md\\:focus\\:shadow-inner:focus {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .md\\:focus\\:shadow-outline:focus {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .md\\:focus\\:shadow-none:focus {\n    box-shadow: none;\n  }\n\n  .md\\:fill-current {\n    fill: currentColor;\n  }\n\n  .md\\:stroke-current {\n    stroke: currentColor;\n  }\n\n  .md\\:stroke-0 {\n    stroke-width: 0;\n  }\n\n  .md\\:stroke-1 {\n    stroke-width: 1;\n  }\n\n  .md\\:stroke-2 {\n    stroke-width: 2;\n  }\n\n  .md\\:table-auto {\n    table-layout: auto;\n  }\n\n  .md\\:table-fixed {\n    table-layout: fixed;\n  }\n\n  .md\\:text-left {\n    text-align: left;\n  }\n\n  .md\\:text-center {\n    text-align: center;\n  }\n\n  .md\\:text-right {\n    text-align: right;\n  }\n\n  .md\\:text-justify {\n    text-align: justify;\n  }\n\n  .md\\:text-blue {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .md\\:text-primaryText {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .md\\:text-red {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .md\\:hover\\:text-blue:hover {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .md\\:hover\\:text-primaryText:hover {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .md\\:hover\\:text-red:hover {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .md\\:focus\\:text-blue:focus {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .md\\:focus\\:text-primaryText:focus {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .md\\:focus\\:text-red:focus {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .md\\:text-opacity-0 {\n    --text-opacity: 0;\n  }\n\n  .md\\:text-opacity-25 {\n    --text-opacity: 0.25;\n  }\n\n  .md\\:text-opacity-50 {\n    --text-opacity: 0.5;\n  }\n\n  .md\\:text-opacity-75 {\n    --text-opacity: 0.75;\n  }\n\n  .md\\:text-opacity-100 {\n    --text-opacity: 1;\n  }\n\n  .md\\:hover\\:text-opacity-0:hover {\n    --text-opacity: 0;\n  }\n\n  .md\\:hover\\:text-opacity-25:hover {\n    --text-opacity: 0.25;\n  }\n\n  .md\\:hover\\:text-opacity-50:hover {\n    --text-opacity: 0.5;\n  }\n\n  .md\\:hover\\:text-opacity-75:hover {\n    --text-opacity: 0.75;\n  }\n\n  .md\\:hover\\:text-opacity-100:hover {\n    --text-opacity: 1;\n  }\n\n  .md\\:focus\\:text-opacity-0:focus {\n    --text-opacity: 0;\n  }\n\n  .md\\:focus\\:text-opacity-25:focus {\n    --text-opacity: 0.25;\n  }\n\n  .md\\:focus\\:text-opacity-50:focus {\n    --text-opacity: 0.5;\n  }\n\n  .md\\:focus\\:text-opacity-75:focus {\n    --text-opacity: 0.75;\n  }\n\n  .md\\:focus\\:text-opacity-100:focus {\n    --text-opacity: 1;\n  }\n\n  .md\\:italic {\n    font-style: italic;\n  }\n\n  .md\\:not-italic {\n    font-style: normal;\n  }\n\n  .md\\:uppercase {\n    text-transform: uppercase;\n  }\n\n  .md\\:lowercase {\n    text-transform: lowercase;\n  }\n\n  .md\\:capitalize {\n    text-transform: capitalize;\n  }\n\n  .md\\:normal-case {\n    text-transform: none;\n  }\n\n  .md\\:underline {\n    text-decoration: underline;\n  }\n\n  .md\\:line-through {\n    text-decoration: line-through;\n  }\n\n  .md\\:no-underline {\n    text-decoration: none;\n  }\n\n  .md\\:hover\\:underline:hover {\n    text-decoration: underline;\n  }\n\n  .md\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n  }\n\n  .md\\:hover\\:no-underline:hover {\n    text-decoration: none;\n  }\n\n  .md\\:focus\\:underline:focus {\n    text-decoration: underline;\n  }\n\n  .md\\:focus\\:line-through:focus {\n    text-decoration: line-through;\n  }\n\n  .md\\:focus\\:no-underline:focus {\n    text-decoration: none;\n  }\n\n  .md\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  .md\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n  }\n\n  .md\\:ordinal, .md\\:slashed-zero, .md\\:lining-nums, .md\\:oldstyle-nums, .md\\:proportional-nums, .md\\:tabular-nums, .md\\:diagonal-fractions, .md\\:stacked-fractions {\n    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);\n    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n  }\n\n  .md\\:normal-nums {\n    font-variant-numeric: normal;\n  }\n\n  .md\\:ordinal {\n    --font-variant-numeric-ordinal: ordinal;\n  }\n\n  .md\\:slashed-zero {\n    --font-variant-numeric-slashed-zero: slashed-zero;\n  }\n\n  .md\\:lining-nums {\n    --font-variant-numeric-figure: lining-nums;\n  }\n\n  .md\\:oldstyle-nums {\n    --font-variant-numeric-figure: oldstyle-nums;\n  }\n\n  .md\\:proportional-nums {\n    --font-variant-numeric-spacing: proportional-nums;\n  }\n\n  .md\\:tabular-nums {\n    --font-variant-numeric-spacing: tabular-nums;\n  }\n\n  .md\\:diagonal-fractions {\n    --font-variant-numeric-fraction: diagonal-fractions;\n  }\n\n  .md\\:stacked-fractions {\n    --font-variant-numeric-fraction: stacked-fractions;\n  }\n\n  .md\\:tracking-tighter {\n    letter-spacing: -0.05em;\n  }\n\n  .md\\:tracking-tight {\n    letter-spacing: -0.025em;\n  }\n\n  .md\\:tracking-normal {\n    letter-spacing: 0;\n  }\n\n  .md\\:tracking-wide {\n    letter-spacing: 0.025em;\n  }\n\n  .md\\:tracking-wider {\n    letter-spacing: 0.05em;\n  }\n\n  .md\\:tracking-widest {\n    letter-spacing: 0.1em;\n  }\n\n  .md\\:select-none {\n    -webkit-user-select: none;\n            user-select: none;\n  }\n\n  .md\\:select-text {\n    -webkit-user-select: text;\n            user-select: text;\n  }\n\n  .md\\:select-all {\n    -webkit-user-select: all;\n            user-select: all;\n  }\n\n  .md\\:select-auto {\n    -webkit-user-select: auto;\n            user-select: auto;\n  }\n\n  .md\\:align-baseline {\n    vertical-align: baseline;\n  }\n\n  .md\\:align-top {\n    vertical-align: top;\n  }\n\n  .md\\:align-middle {\n    vertical-align: middle;\n  }\n\n  .md\\:align-bottom {\n    vertical-align: bottom;\n  }\n\n  .md\\:align-text-top {\n    vertical-align: text-top;\n  }\n\n  .md\\:align-text-bottom {\n    vertical-align: text-bottom;\n  }\n\n  .md\\:visible {\n    visibility: visible;\n  }\n\n  .md\\:invisible {\n    visibility: hidden;\n  }\n\n  .md\\:whitespace-normal {\n    white-space: normal;\n  }\n\n  .md\\:whitespace-no-wrap {\n    white-space: nowrap;\n  }\n\n  .md\\:whitespace-pre {\n    white-space: pre;\n  }\n\n  .md\\:whitespace-pre-line {\n    white-space: pre-line;\n  }\n\n  .md\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n  }\n\n  .md\\:break-normal {\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n\n  .md\\:break-words {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  .md\\:break-all {\n    word-break: break-all;\n  }\n\n  .md\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .md\\:w-0 {\n    width: 0;\n  }\n\n  .md\\:w-1 {\n    width: 0.25rem;\n  }\n\n  .md\\:w-2 {\n    width: 0.5rem;\n  }\n\n  .md\\:w-3 {\n    width: 0.75rem;\n  }\n\n  .md\\:w-4 {\n    width: 1rem;\n  }\n\n  .md\\:w-5 {\n    width: 1.25rem;\n  }\n\n  .md\\:w-6 {\n    width: 1.5rem;\n  }\n\n  .md\\:w-8 {\n    width: 2rem;\n  }\n\n  .md\\:w-10 {\n    width: 2.5rem;\n  }\n\n  .md\\:w-12 {\n    width: 3rem;\n  }\n\n  .md\\:w-16 {\n    width: 4rem;\n  }\n\n  .md\\:w-20 {\n    width: 5rem;\n  }\n\n  .md\\:w-24 {\n    width: 6rem;\n  }\n\n  .md\\:w-32 {\n    width: 8rem;\n  }\n\n  .md\\:w-40 {\n    width: 10rem;\n  }\n\n  .md\\:w-48 {\n    width: 12rem;\n  }\n\n  .md\\:w-56 {\n    width: 14rem;\n  }\n\n  .md\\:w-64 {\n    width: 16rem;\n  }\n\n  .md\\:w-auto {\n    width: auto;\n  }\n\n  .md\\:w-px {\n    width: 1px;\n  }\n\n  .md\\:w-1\\/2 {\n    width: 50%;\n  }\n\n  .md\\:w-1\\/3 {\n    width: 33.333333%;\n  }\n\n  .md\\:w-2\\/3 {\n    width: 66.666667%;\n  }\n\n  .md\\:w-1\\/4 {\n    width: 25%;\n  }\n\n  .md\\:w-2\\/4 {\n    width: 50%;\n  }\n\n  .md\\:w-3\\/4 {\n    width: 75%;\n  }\n\n  .md\\:w-1\\/5 {\n    width: 20%;\n  }\n\n  .md\\:w-2\\/5 {\n    width: 40%;\n  }\n\n  .md\\:w-3\\/5 {\n    width: 60%;\n  }\n\n  .md\\:w-4\\/5 {\n    width: 80%;\n  }\n\n  .md\\:w-1\\/6 {\n    width: 16.666667%;\n  }\n\n  .md\\:w-2\\/6 {\n    width: 33.333333%;\n  }\n\n  .md\\:w-3\\/6 {\n    width: 50%;\n  }\n\n  .md\\:w-4\\/6 {\n    width: 66.666667%;\n  }\n\n  .md\\:w-5\\/6 {\n    width: 83.333333%;\n  }\n\n  .md\\:w-1\\/12 {\n    width: 8.333333%;\n  }\n\n  .md\\:w-2\\/12 {\n    width: 16.666667%;\n  }\n\n  .md\\:w-3\\/12 {\n    width: 25%;\n  }\n\n  .md\\:w-4\\/12 {\n    width: 33.333333%;\n  }\n\n  .md\\:w-5\\/12 {\n    width: 41.666667%;\n  }\n\n  .md\\:w-6\\/12 {\n    width: 50%;\n  }\n\n  .md\\:w-7\\/12 {\n    width: 58.333333%;\n  }\n\n  .md\\:w-8\\/12 {\n    width: 66.666667%;\n  }\n\n  .md\\:w-9\\/12 {\n    width: 75%;\n  }\n\n  .md\\:w-10\\/12 {\n    width: 83.333333%;\n  }\n\n  .md\\:w-11\\/12 {\n    width: 91.666667%;\n  }\n\n  .md\\:w-full {\n    width: 100%;\n  }\n\n  .md\\:w-screen {\n    width: 100vw;\n  }\n\n  .md\\:z-0 {\n    z-index: 0;\n  }\n\n  .md\\:z-10 {\n    z-index: 10;\n  }\n\n  .md\\:z-20 {\n    z-index: 20;\n  }\n\n  .md\\:z-30 {\n    z-index: 30;\n  }\n\n  .md\\:z-40 {\n    z-index: 40;\n  }\n\n  .md\\:z-50 {\n    z-index: 50;\n  }\n\n  .md\\:z-auto {\n    z-index: auto;\n  }\n\n  .md\\:gap-0 {\n    grid-gap: 0;\n    gap: 0;\n  }\n\n  .md\\:gap-1 {\n    grid-gap: 0.25rem;\n    gap: 0.25rem;\n  }\n\n  .md\\:gap-2 {\n    grid-gap: 0.5rem;\n    gap: 0.5rem;\n  }\n\n  .md\\:gap-3 {\n    grid-gap: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .md\\:gap-4 {\n    grid-gap: 1rem;\n    gap: 1rem;\n  }\n\n  .md\\:gap-5 {\n    grid-gap: 1.25rem;\n    gap: 1.25rem;\n  }\n\n  .md\\:gap-6 {\n    grid-gap: 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .md\\:gap-8 {\n    grid-gap: 2rem;\n    gap: 2rem;\n  }\n\n  .md\\:gap-10 {\n    grid-gap: 2.5rem;\n    gap: 2.5rem;\n  }\n\n  .md\\:gap-12 {\n    grid-gap: 3rem;\n    gap: 3rem;\n  }\n\n  .md\\:gap-16 {\n    grid-gap: 4rem;\n    gap: 4rem;\n  }\n\n  .md\\:gap-20 {\n    grid-gap: 5rem;\n    gap: 5rem;\n  }\n\n  .md\\:gap-24 {\n    grid-gap: 6rem;\n    gap: 6rem;\n  }\n\n  .md\\:gap-32 {\n    grid-gap: 8rem;\n    gap: 8rem;\n  }\n\n  .md\\:gap-40 {\n    grid-gap: 10rem;\n    gap: 10rem;\n  }\n\n  .md\\:gap-48 {\n    grid-gap: 12rem;\n    gap: 12rem;\n  }\n\n  .md\\:gap-56 {\n    grid-gap: 14rem;\n    gap: 14rem;\n  }\n\n  .md\\:gap-64 {\n    grid-gap: 16rem;\n    gap: 16rem;\n  }\n\n  .md\\:gap-px {\n    grid-gap: 1px;\n    gap: 1px;\n  }\n\n  .md\\:col-gap-0 {\n    grid-column-gap: 0;\n    column-gap: 0;\n  }\n\n  .md\\:col-gap-1 {\n    grid-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n\n  .md\\:col-gap-2 {\n    grid-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n\n  .md\\:col-gap-3 {\n    grid-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n\n  .md\\:col-gap-4 {\n    grid-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n\n  .md\\:col-gap-5 {\n    grid-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n\n  .md\\:col-gap-6 {\n    grid-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n\n  .md\\:col-gap-8 {\n    grid-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n\n  .md\\:col-gap-10 {\n    grid-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n\n  .md\\:col-gap-12 {\n    grid-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n\n  .md\\:col-gap-16 {\n    grid-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n\n  .md\\:col-gap-20 {\n    grid-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n\n  .md\\:col-gap-24 {\n    grid-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n\n  .md\\:col-gap-32 {\n    grid-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n\n  .md\\:col-gap-40 {\n    grid-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n\n  .md\\:col-gap-48 {\n    grid-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n\n  .md\\:col-gap-56 {\n    grid-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n\n  .md\\:col-gap-64 {\n    grid-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n\n  .md\\:col-gap-px {\n    grid-column-gap: 1px;\n    column-gap: 1px;\n  }\n\n  .md\\:gap-x-0 {\n    grid-column-gap: 0;\n    column-gap: 0;\n  }\n\n  .md\\:gap-x-1 {\n    grid-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n\n  .md\\:gap-x-2 {\n    grid-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n\n  .md\\:gap-x-3 {\n    grid-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n\n  .md\\:gap-x-4 {\n    grid-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n\n  .md\\:gap-x-5 {\n    grid-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n\n  .md\\:gap-x-6 {\n    grid-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n\n  .md\\:gap-x-8 {\n    grid-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n\n  .md\\:gap-x-10 {\n    grid-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n\n  .md\\:gap-x-12 {\n    grid-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n\n  .md\\:gap-x-16 {\n    grid-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n\n  .md\\:gap-x-20 {\n    grid-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n\n  .md\\:gap-x-24 {\n    grid-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n\n  .md\\:gap-x-32 {\n    grid-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n\n  .md\\:gap-x-40 {\n    grid-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n\n  .md\\:gap-x-48 {\n    grid-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n\n  .md\\:gap-x-56 {\n    grid-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n\n  .md\\:gap-x-64 {\n    grid-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n\n  .md\\:gap-x-px {\n    grid-column-gap: 1px;\n    column-gap: 1px;\n  }\n\n  .md\\:row-gap-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n\n  .md\\:row-gap-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n\n  .md\\:row-gap-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n\n  .md\\:row-gap-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n\n  .md\\:row-gap-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n\n  .md\\:row-gap-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n\n  .md\\:row-gap-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n\n  .md\\:row-gap-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n\n  .md\\:row-gap-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n\n  .md\\:row-gap-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n\n  .md\\:row-gap-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n\n  .md\\:row-gap-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n\n  .md\\:row-gap-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n\n  .md\\:row-gap-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n\n  .md\\:row-gap-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n\n  .md\\:row-gap-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n\n  .md\\:row-gap-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n\n  .md\\:row-gap-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n\n  .md\\:row-gap-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n\n  .md\\:gap-y-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n\n  .md\\:gap-y-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n\n  .md\\:gap-y-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n\n  .md\\:gap-y-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n\n  .md\\:gap-y-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n\n  .md\\:gap-y-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n\n  .md\\:gap-y-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n\n  .md\\:gap-y-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n\n  .md\\:gap-y-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n\n  .md\\:gap-y-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n\n  .md\\:gap-y-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n\n  .md\\:gap-y-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n\n  .md\\:gap-y-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n\n  .md\\:gap-y-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n\n  .md\\:gap-y-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n\n  .md\\:gap-y-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n\n  .md\\:gap-y-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n\n  .md\\:gap-y-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n\n  .md\\:gap-y-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n\n  .md\\:grid-flow-row {\n    grid-auto-flow: row;\n  }\n\n  .md\\:grid-flow-col {\n    grid-auto-flow: column;\n  }\n\n  .md\\:grid-flow-row-dense {\n    grid-auto-flow: row dense;\n  }\n\n  .md\\:grid-flow-col-dense {\n    grid-auto-flow: column dense;\n  }\n\n  .md\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n\n  .md\\:grid-cols-none {\n    grid-template-columns: none;\n  }\n\n  .md\\:auto-cols-auto {\n    grid-auto-columns: auto;\n  }\n\n  .md\\:auto-cols-min {\n    grid-auto-columns: min-content;\n  }\n\n  .md\\:auto-cols-max {\n    grid-auto-columns: max-content;\n  }\n\n  .md\\:auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n  }\n\n  .md\\:col-auto {\n    grid-column: auto;\n  }\n\n  .md\\:col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n\n  .md\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n\n  .md\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n\n  .md\\:col-span-4 {\n    grid-column: span 4 / span 4;\n  }\n\n  .md\\:col-span-5 {\n    grid-column: span 5 / span 5;\n  }\n\n  .md\\:col-span-6 {\n    grid-column: span 6 / span 6;\n  }\n\n  .md\\:col-span-7 {\n    grid-column: span 7 / span 7;\n  }\n\n  .md\\:col-span-8 {\n    grid-column: span 8 / span 8;\n  }\n\n  .md\\:col-span-9 {\n    grid-column: span 9 / span 9;\n  }\n\n  .md\\:col-span-10 {\n    grid-column: span 10 / span 10;\n  }\n\n  .md\\:col-span-11 {\n    grid-column: span 11 / span 11;\n  }\n\n  .md\\:col-span-12 {\n    grid-column: span 12 / span 12;\n  }\n\n  .md\\:col-span-full {\n    grid-column: 1 / -1;\n  }\n\n  .md\\:col-start-1 {\n    grid-column-start: 1;\n  }\n\n  .md\\:col-start-2 {\n    grid-column-start: 2;\n  }\n\n  .md\\:col-start-3 {\n    grid-column-start: 3;\n  }\n\n  .md\\:col-start-4 {\n    grid-column-start: 4;\n  }\n\n  .md\\:col-start-5 {\n    grid-column-start: 5;\n  }\n\n  .md\\:col-start-6 {\n    grid-column-start: 6;\n  }\n\n  .md\\:col-start-7 {\n    grid-column-start: 7;\n  }\n\n  .md\\:col-start-8 {\n    grid-column-start: 8;\n  }\n\n  .md\\:col-start-9 {\n    grid-column-start: 9;\n  }\n\n  .md\\:col-start-10 {\n    grid-column-start: 10;\n  }\n\n  .md\\:col-start-11 {\n    grid-column-start: 11;\n  }\n\n  .md\\:col-start-12 {\n    grid-column-start: 12;\n  }\n\n  .md\\:col-start-13 {\n    grid-column-start: 13;\n  }\n\n  .md\\:col-start-auto {\n    grid-column-start: auto;\n  }\n\n  .md\\:col-end-1 {\n    grid-column-end: 1;\n  }\n\n  .md\\:col-end-2 {\n    grid-column-end: 2;\n  }\n\n  .md\\:col-end-3 {\n    grid-column-end: 3;\n  }\n\n  .md\\:col-end-4 {\n    grid-column-end: 4;\n  }\n\n  .md\\:col-end-5 {\n    grid-column-end: 5;\n  }\n\n  .md\\:col-end-6 {\n    grid-column-end: 6;\n  }\n\n  .md\\:col-end-7 {\n    grid-column-end: 7;\n  }\n\n  .md\\:col-end-8 {\n    grid-column-end: 8;\n  }\n\n  .md\\:col-end-9 {\n    grid-column-end: 9;\n  }\n\n  .md\\:col-end-10 {\n    grid-column-end: 10;\n  }\n\n  .md\\:col-end-11 {\n    grid-column-end: 11;\n  }\n\n  .md\\:col-end-12 {\n    grid-column-end: 12;\n  }\n\n  .md\\:col-end-13 {\n    grid-column-end: 13;\n  }\n\n  .md\\:col-end-auto {\n    grid-column-end: auto;\n  }\n\n  .md\\:grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n  }\n\n  .md\\:grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n  }\n\n  .md\\:grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n  }\n\n  .md\\:grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n\n  .md\\:grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n  }\n\n  .md\\:grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n  }\n\n  .md\\:grid-rows-none {\n    grid-template-rows: none;\n  }\n\n  .md\\:auto-rows-auto {\n    grid-auto-rows: auto;\n  }\n\n  .md\\:auto-rows-min {\n    grid-auto-rows: min-content;\n  }\n\n  .md\\:auto-rows-max {\n    grid-auto-rows: max-content;\n  }\n\n  .md\\:auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n  }\n\n  .md\\:row-auto {\n    grid-row: auto;\n  }\n\n  .md\\:row-span-1 {\n    grid-row: span 1 / span 1;\n  }\n\n  .md\\:row-span-2 {\n    grid-row: span 2 / span 2;\n  }\n\n  .md\\:row-span-3 {\n    grid-row: span 3 / span 3;\n  }\n\n  .md\\:row-span-4 {\n    grid-row: span 4 / span 4;\n  }\n\n  .md\\:row-span-5 {\n    grid-row: span 5 / span 5;\n  }\n\n  .md\\:row-span-6 {\n    grid-row: span 6 / span 6;\n  }\n\n  .md\\:row-span-full {\n    grid-row: 1 / -1;\n  }\n\n  .md\\:row-start-1 {\n    grid-row-start: 1;\n  }\n\n  .md\\:row-start-2 {\n    grid-row-start: 2;\n  }\n\n  .md\\:row-start-3 {\n    grid-row-start: 3;\n  }\n\n  .md\\:row-start-4 {\n    grid-row-start: 4;\n  }\n\n  .md\\:row-start-5 {\n    grid-row-start: 5;\n  }\n\n  .md\\:row-start-6 {\n    grid-row-start: 6;\n  }\n\n  .md\\:row-start-7 {\n    grid-row-start: 7;\n  }\n\n  .md\\:row-start-auto {\n    grid-row-start: auto;\n  }\n\n  .md\\:row-end-1 {\n    grid-row-end: 1;\n  }\n\n  .md\\:row-end-2 {\n    grid-row-end: 2;\n  }\n\n  .md\\:row-end-3 {\n    grid-row-end: 3;\n  }\n\n  .md\\:row-end-4 {\n    grid-row-end: 4;\n  }\n\n  .md\\:row-end-5 {\n    grid-row-end: 5;\n  }\n\n  .md\\:row-end-6 {\n    grid-row-end: 6;\n  }\n\n  .md\\:row-end-7 {\n    grid-row-end: 7;\n  }\n\n  .md\\:row-end-auto {\n    grid-row-end: auto;\n  }\n\n  .md\\:transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n  }\n\n  .md\\:transform-none {\n    transform: none;\n  }\n\n  .md\\:origin-center {\n    transform-origin: center;\n  }\n\n  .md\\:origin-top {\n    transform-origin: top;\n  }\n\n  .md\\:origin-top-right {\n    transform-origin: top right;\n  }\n\n  .md\\:origin-right {\n    transform-origin: right;\n  }\n\n  .md\\:origin-bottom-right {\n    transform-origin: bottom right;\n  }\n\n  .md\\:origin-bottom {\n    transform-origin: bottom;\n  }\n\n  .md\\:origin-bottom-left {\n    transform-origin: bottom left;\n  }\n\n  .md\\:origin-left {\n    transform-origin: left;\n  }\n\n  .md\\:origin-top-left {\n    transform-origin: top left;\n  }\n\n  .md\\:scale-0 {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .md\\:scale-50 {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .md\\:scale-75 {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .md\\:scale-90 {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .md\\:scale-95 {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .md\\:scale-100 {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .md\\:scale-105 {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .md\\:scale-110 {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .md\\:scale-125 {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .md\\:scale-150 {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .md\\:scale-x-0 {\n    --transform-scale-x: 0;\n  }\n\n  .md\\:scale-x-50 {\n    --transform-scale-x: .5;\n  }\n\n  .md\\:scale-x-75 {\n    --transform-scale-x: .75;\n  }\n\n  .md\\:scale-x-90 {\n    --transform-scale-x: .9;\n  }\n\n  .md\\:scale-x-95 {\n    --transform-scale-x: .95;\n  }\n\n  .md\\:scale-x-100 {\n    --transform-scale-x: 1;\n  }\n\n  .md\\:scale-x-105 {\n    --transform-scale-x: 1.05;\n  }\n\n  .md\\:scale-x-110 {\n    --transform-scale-x: 1.1;\n  }\n\n  .md\\:scale-x-125 {\n    --transform-scale-x: 1.25;\n  }\n\n  .md\\:scale-x-150 {\n    --transform-scale-x: 1.5;\n  }\n\n  .md\\:scale-y-0 {\n    --transform-scale-y: 0;\n  }\n\n  .md\\:scale-y-50 {\n    --transform-scale-y: .5;\n  }\n\n  .md\\:scale-y-75 {\n    --transform-scale-y: .75;\n  }\n\n  .md\\:scale-y-90 {\n    --transform-scale-y: .9;\n  }\n\n  .md\\:scale-y-95 {\n    --transform-scale-y: .95;\n  }\n\n  .md\\:scale-y-100 {\n    --transform-scale-y: 1;\n  }\n\n  .md\\:scale-y-105 {\n    --transform-scale-y: 1.05;\n  }\n\n  .md\\:scale-y-110 {\n    --transform-scale-y: 1.1;\n  }\n\n  .md\\:scale-y-125 {\n    --transform-scale-y: 1.25;\n  }\n\n  .md\\:scale-y-150 {\n    --transform-scale-y: 1.5;\n  }\n\n  .md\\:hover\\:scale-0:hover {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .md\\:hover\\:scale-50:hover {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .md\\:hover\\:scale-75:hover {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .md\\:hover\\:scale-90:hover {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .md\\:hover\\:scale-95:hover {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .md\\:hover\\:scale-100:hover {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .md\\:hover\\:scale-105:hover {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .md\\:hover\\:scale-110:hover {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .md\\:hover\\:scale-125:hover {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .md\\:hover\\:scale-150:hover {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .md\\:hover\\:scale-x-0:hover {\n    --transform-scale-x: 0;\n  }\n\n  .md\\:hover\\:scale-x-50:hover {\n    --transform-scale-x: .5;\n  }\n\n  .md\\:hover\\:scale-x-75:hover {\n    --transform-scale-x: .75;\n  }\n\n  .md\\:hover\\:scale-x-90:hover {\n    --transform-scale-x: .9;\n  }\n\n  .md\\:hover\\:scale-x-95:hover {\n    --transform-scale-x: .95;\n  }\n\n  .md\\:hover\\:scale-x-100:hover {\n    --transform-scale-x: 1;\n  }\n\n  .md\\:hover\\:scale-x-105:hover {\n    --transform-scale-x: 1.05;\n  }\n\n  .md\\:hover\\:scale-x-110:hover {\n    --transform-scale-x: 1.1;\n  }\n\n  .md\\:hover\\:scale-x-125:hover {\n    --transform-scale-x: 1.25;\n  }\n\n  .md\\:hover\\:scale-x-150:hover {\n    --transform-scale-x: 1.5;\n  }\n\n  .md\\:hover\\:scale-y-0:hover {\n    --transform-scale-y: 0;\n  }\n\n  .md\\:hover\\:scale-y-50:hover {\n    --transform-scale-y: .5;\n  }\n\n  .md\\:hover\\:scale-y-75:hover {\n    --transform-scale-y: .75;\n  }\n\n  .md\\:hover\\:scale-y-90:hover {\n    --transform-scale-y: .9;\n  }\n\n  .md\\:hover\\:scale-y-95:hover {\n    --transform-scale-y: .95;\n  }\n\n  .md\\:hover\\:scale-y-100:hover {\n    --transform-scale-y: 1;\n  }\n\n  .md\\:hover\\:scale-y-105:hover {\n    --transform-scale-y: 1.05;\n  }\n\n  .md\\:hover\\:scale-y-110:hover {\n    --transform-scale-y: 1.1;\n  }\n\n  .md\\:hover\\:scale-y-125:hover {\n    --transform-scale-y: 1.25;\n  }\n\n  .md\\:hover\\:scale-y-150:hover {\n    --transform-scale-y: 1.5;\n  }\n\n  .md\\:focus\\:scale-0:focus {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .md\\:focus\\:scale-50:focus {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .md\\:focus\\:scale-75:focus {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .md\\:focus\\:scale-90:focus {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .md\\:focus\\:scale-95:focus {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .md\\:focus\\:scale-100:focus {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .md\\:focus\\:scale-105:focus {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .md\\:focus\\:scale-110:focus {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .md\\:focus\\:scale-125:focus {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .md\\:focus\\:scale-150:focus {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .md\\:focus\\:scale-x-0:focus {\n    --transform-scale-x: 0;\n  }\n\n  .md\\:focus\\:scale-x-50:focus {\n    --transform-scale-x: .5;\n  }\n\n  .md\\:focus\\:scale-x-75:focus {\n    --transform-scale-x: .75;\n  }\n\n  .md\\:focus\\:scale-x-90:focus {\n    --transform-scale-x: .9;\n  }\n\n  .md\\:focus\\:scale-x-95:focus {\n    --transform-scale-x: .95;\n  }\n\n  .md\\:focus\\:scale-x-100:focus {\n    --transform-scale-x: 1;\n  }\n\n  .md\\:focus\\:scale-x-105:focus {\n    --transform-scale-x: 1.05;\n  }\n\n  .md\\:focus\\:scale-x-110:focus {\n    --transform-scale-x: 1.1;\n  }\n\n  .md\\:focus\\:scale-x-125:focus {\n    --transform-scale-x: 1.25;\n  }\n\n  .md\\:focus\\:scale-x-150:focus {\n    --transform-scale-x: 1.5;\n  }\n\n  .md\\:focus\\:scale-y-0:focus {\n    --transform-scale-y: 0;\n  }\n\n  .md\\:focus\\:scale-y-50:focus {\n    --transform-scale-y: .5;\n  }\n\n  .md\\:focus\\:scale-y-75:focus {\n    --transform-scale-y: .75;\n  }\n\n  .md\\:focus\\:scale-y-90:focus {\n    --transform-scale-y: .9;\n  }\n\n  .md\\:focus\\:scale-y-95:focus {\n    --transform-scale-y: .95;\n  }\n\n  .md\\:focus\\:scale-y-100:focus {\n    --transform-scale-y: 1;\n  }\n\n  .md\\:focus\\:scale-y-105:focus {\n    --transform-scale-y: 1.05;\n  }\n\n  .md\\:focus\\:scale-y-110:focus {\n    --transform-scale-y: 1.1;\n  }\n\n  .md\\:focus\\:scale-y-125:focus {\n    --transform-scale-y: 1.25;\n  }\n\n  .md\\:focus\\:scale-y-150:focus {\n    --transform-scale-y: 1.5;\n  }\n\n  .md\\:rotate-0 {\n    --transform-rotate: 0;\n  }\n\n  .md\\:rotate-1 {\n    --transform-rotate: 1deg;\n  }\n\n  .md\\:rotate-2 {\n    --transform-rotate: 2deg;\n  }\n\n  .md\\:rotate-3 {\n    --transform-rotate: 3deg;\n  }\n\n  .md\\:rotate-6 {\n    --transform-rotate: 6deg;\n  }\n\n  .md\\:rotate-12 {\n    --transform-rotate: 12deg;\n  }\n\n  .md\\:rotate-45 {\n    --transform-rotate: 45deg;\n  }\n\n  .md\\:rotate-90 {\n    --transform-rotate: 90deg;\n  }\n\n  .md\\:rotate-180 {\n    --transform-rotate: 180deg;\n  }\n\n  .md\\:-rotate-180 {\n    --transform-rotate: -180deg;\n  }\n\n  .md\\:-rotate-90 {\n    --transform-rotate: -90deg;\n  }\n\n  .md\\:-rotate-45 {\n    --transform-rotate: -45deg;\n  }\n\n  .md\\:-rotate-12 {\n    --transform-rotate: -12deg;\n  }\n\n  .md\\:-rotate-6 {\n    --transform-rotate: -6deg;\n  }\n\n  .md\\:-rotate-3 {\n    --transform-rotate: -3deg;\n  }\n\n  .md\\:-rotate-2 {\n    --transform-rotate: -2deg;\n  }\n\n  .md\\:-rotate-1 {\n    --transform-rotate: -1deg;\n  }\n\n  .md\\:hover\\:rotate-0:hover {\n    --transform-rotate: 0;\n  }\n\n  .md\\:hover\\:rotate-1:hover {\n    --transform-rotate: 1deg;\n  }\n\n  .md\\:hover\\:rotate-2:hover {\n    --transform-rotate: 2deg;\n  }\n\n  .md\\:hover\\:rotate-3:hover {\n    --transform-rotate: 3deg;\n  }\n\n  .md\\:hover\\:rotate-6:hover {\n    --transform-rotate: 6deg;\n  }\n\n  .md\\:hover\\:rotate-12:hover {\n    --transform-rotate: 12deg;\n  }\n\n  .md\\:hover\\:rotate-45:hover {\n    --transform-rotate: 45deg;\n  }\n\n  .md\\:hover\\:rotate-90:hover {\n    --transform-rotate: 90deg;\n  }\n\n  .md\\:hover\\:rotate-180:hover {\n    --transform-rotate: 180deg;\n  }\n\n  .md\\:hover\\:-rotate-180:hover {\n    --transform-rotate: -180deg;\n  }\n\n  .md\\:hover\\:-rotate-90:hover {\n    --transform-rotate: -90deg;\n  }\n\n  .md\\:hover\\:-rotate-45:hover {\n    --transform-rotate: -45deg;\n  }\n\n  .md\\:hover\\:-rotate-12:hover {\n    --transform-rotate: -12deg;\n  }\n\n  .md\\:hover\\:-rotate-6:hover {\n    --transform-rotate: -6deg;\n  }\n\n  .md\\:hover\\:-rotate-3:hover {\n    --transform-rotate: -3deg;\n  }\n\n  .md\\:hover\\:-rotate-2:hover {\n    --transform-rotate: -2deg;\n  }\n\n  .md\\:hover\\:-rotate-1:hover {\n    --transform-rotate: -1deg;\n  }\n\n  .md\\:focus\\:rotate-0:focus {\n    --transform-rotate: 0;\n  }\n\n  .md\\:focus\\:rotate-1:focus {\n    --transform-rotate: 1deg;\n  }\n\n  .md\\:focus\\:rotate-2:focus {\n    --transform-rotate: 2deg;\n  }\n\n  .md\\:focus\\:rotate-3:focus {\n    --transform-rotate: 3deg;\n  }\n\n  .md\\:focus\\:rotate-6:focus {\n    --transform-rotate: 6deg;\n  }\n\n  .md\\:focus\\:rotate-12:focus {\n    --transform-rotate: 12deg;\n  }\n\n  .md\\:focus\\:rotate-45:focus {\n    --transform-rotate: 45deg;\n  }\n\n  .md\\:focus\\:rotate-90:focus {\n    --transform-rotate: 90deg;\n  }\n\n  .md\\:focus\\:rotate-180:focus {\n    --transform-rotate: 180deg;\n  }\n\n  .md\\:focus\\:-rotate-180:focus {\n    --transform-rotate: -180deg;\n  }\n\n  .md\\:focus\\:-rotate-90:focus {\n    --transform-rotate: -90deg;\n  }\n\n  .md\\:focus\\:-rotate-45:focus {\n    --transform-rotate: -45deg;\n  }\n\n  .md\\:focus\\:-rotate-12:focus {\n    --transform-rotate: -12deg;\n  }\n\n  .md\\:focus\\:-rotate-6:focus {\n    --transform-rotate: -6deg;\n  }\n\n  .md\\:focus\\:-rotate-3:focus {\n    --transform-rotate: -3deg;\n  }\n\n  .md\\:focus\\:-rotate-2:focus {\n    --transform-rotate: -2deg;\n  }\n\n  .md\\:focus\\:-rotate-1:focus {\n    --transform-rotate: -1deg;\n  }\n\n  .md\\:translate-x-0 {\n    --transform-translate-x: 0;\n  }\n\n  .md\\:translate-x-1 {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .md\\:translate-x-2 {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .md\\:translate-x-3 {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .md\\:translate-x-4 {\n    --transform-translate-x: 1rem;\n  }\n\n  .md\\:translate-x-5 {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .md\\:translate-x-6 {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .md\\:translate-x-8 {\n    --transform-translate-x: 2rem;\n  }\n\n  .md\\:translate-x-10 {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .md\\:translate-x-12 {\n    --transform-translate-x: 3rem;\n  }\n\n  .md\\:translate-x-16 {\n    --transform-translate-x: 4rem;\n  }\n\n  .md\\:translate-x-20 {\n    --transform-translate-x: 5rem;\n  }\n\n  .md\\:translate-x-24 {\n    --transform-translate-x: 6rem;\n  }\n\n  .md\\:translate-x-32 {\n    --transform-translate-x: 8rem;\n  }\n\n  .md\\:translate-x-40 {\n    --transform-translate-x: 10rem;\n  }\n\n  .md\\:translate-x-48 {\n    --transform-translate-x: 12rem;\n  }\n\n  .md\\:translate-x-56 {\n    --transform-translate-x: 14rem;\n  }\n\n  .md\\:translate-x-64 {\n    --transform-translate-x: 16rem;\n  }\n\n  .md\\:translate-x-px {\n    --transform-translate-x: 1px;\n  }\n\n  .md\\:-translate-x-1 {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .md\\:-translate-x-2 {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .md\\:-translate-x-3 {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .md\\:-translate-x-4 {\n    --transform-translate-x: -1rem;\n  }\n\n  .md\\:-translate-x-5 {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .md\\:-translate-x-6 {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .md\\:-translate-x-8 {\n    --transform-translate-x: -2rem;\n  }\n\n  .md\\:-translate-x-10 {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .md\\:-translate-x-12 {\n    --transform-translate-x: -3rem;\n  }\n\n  .md\\:-translate-x-16 {\n    --transform-translate-x: -4rem;\n  }\n\n  .md\\:-translate-x-20 {\n    --transform-translate-x: -5rem;\n  }\n\n  .md\\:-translate-x-24 {\n    --transform-translate-x: -6rem;\n  }\n\n  .md\\:-translate-x-32 {\n    --transform-translate-x: -8rem;\n  }\n\n  .md\\:-translate-x-40 {\n    --transform-translate-x: -10rem;\n  }\n\n  .md\\:-translate-x-48 {\n    --transform-translate-x: -12rem;\n  }\n\n  .md\\:-translate-x-56 {\n    --transform-translate-x: -14rem;\n  }\n\n  .md\\:-translate-x-64 {\n    --transform-translate-x: -16rem;\n  }\n\n  .md\\:-translate-x-px {\n    --transform-translate-x: -1px;\n  }\n\n  .md\\:-translate-x-full {\n    --transform-translate-x: -100%;\n  }\n\n  .md\\:-translate-x-1\\/2 {\n    --transform-translate-x: -50%;\n  }\n\n  .md\\:translate-x-1\\/2 {\n    --transform-translate-x: 50%;\n  }\n\n  .md\\:translate-x-full {\n    --transform-translate-x: 100%;\n  }\n\n  .md\\:translate-y-0 {\n    --transform-translate-y: 0;\n  }\n\n  .md\\:translate-y-1 {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .md\\:translate-y-2 {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .md\\:translate-y-3 {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .md\\:translate-y-4 {\n    --transform-translate-y: 1rem;\n  }\n\n  .md\\:translate-y-5 {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .md\\:translate-y-6 {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .md\\:translate-y-8 {\n    --transform-translate-y: 2rem;\n  }\n\n  .md\\:translate-y-10 {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .md\\:translate-y-12 {\n    --transform-translate-y: 3rem;\n  }\n\n  .md\\:translate-y-16 {\n    --transform-translate-y: 4rem;\n  }\n\n  .md\\:translate-y-20 {\n    --transform-translate-y: 5rem;\n  }\n\n  .md\\:translate-y-24 {\n    --transform-translate-y: 6rem;\n  }\n\n  .md\\:translate-y-32 {\n    --transform-translate-y: 8rem;\n  }\n\n  .md\\:translate-y-40 {\n    --transform-translate-y: 10rem;\n  }\n\n  .md\\:translate-y-48 {\n    --transform-translate-y: 12rem;\n  }\n\n  .md\\:translate-y-56 {\n    --transform-translate-y: 14rem;\n  }\n\n  .md\\:translate-y-64 {\n    --transform-translate-y: 16rem;\n  }\n\n  .md\\:translate-y-px {\n    --transform-translate-y: 1px;\n  }\n\n  .md\\:-translate-y-1 {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .md\\:-translate-y-2 {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .md\\:-translate-y-3 {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .md\\:-translate-y-4 {\n    --transform-translate-y: -1rem;\n  }\n\n  .md\\:-translate-y-5 {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .md\\:-translate-y-6 {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .md\\:-translate-y-8 {\n    --transform-translate-y: -2rem;\n  }\n\n  .md\\:-translate-y-10 {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .md\\:-translate-y-12 {\n    --transform-translate-y: -3rem;\n  }\n\n  .md\\:-translate-y-16 {\n    --transform-translate-y: -4rem;\n  }\n\n  .md\\:-translate-y-20 {\n    --transform-translate-y: -5rem;\n  }\n\n  .md\\:-translate-y-24 {\n    --transform-translate-y: -6rem;\n  }\n\n  .md\\:-translate-y-32 {\n    --transform-translate-y: -8rem;\n  }\n\n  .md\\:-translate-y-40 {\n    --transform-translate-y: -10rem;\n  }\n\n  .md\\:-translate-y-48 {\n    --transform-translate-y: -12rem;\n  }\n\n  .md\\:-translate-y-56 {\n    --transform-translate-y: -14rem;\n  }\n\n  .md\\:-translate-y-64 {\n    --transform-translate-y: -16rem;\n  }\n\n  .md\\:-translate-y-px {\n    --transform-translate-y: -1px;\n  }\n\n  .md\\:-translate-y-full {\n    --transform-translate-y: -100%;\n  }\n\n  .md\\:-translate-y-1\\/2 {\n    --transform-translate-y: -50%;\n  }\n\n  .md\\:translate-y-1\\/2 {\n    --transform-translate-y: 50%;\n  }\n\n  .md\\:translate-y-full {\n    --transform-translate-y: 100%;\n  }\n\n  .md\\:hover\\:translate-x-0:hover {\n    --transform-translate-x: 0;\n  }\n\n  .md\\:hover\\:translate-x-1:hover {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .md\\:hover\\:translate-x-2:hover {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .md\\:hover\\:translate-x-3:hover {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .md\\:hover\\:translate-x-4:hover {\n    --transform-translate-x: 1rem;\n  }\n\n  .md\\:hover\\:translate-x-5:hover {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .md\\:hover\\:translate-x-6:hover {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .md\\:hover\\:translate-x-8:hover {\n    --transform-translate-x: 2rem;\n  }\n\n  .md\\:hover\\:translate-x-10:hover {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .md\\:hover\\:translate-x-12:hover {\n    --transform-translate-x: 3rem;\n  }\n\n  .md\\:hover\\:translate-x-16:hover {\n    --transform-translate-x: 4rem;\n  }\n\n  .md\\:hover\\:translate-x-20:hover {\n    --transform-translate-x: 5rem;\n  }\n\n  .md\\:hover\\:translate-x-24:hover {\n    --transform-translate-x: 6rem;\n  }\n\n  .md\\:hover\\:translate-x-32:hover {\n    --transform-translate-x: 8rem;\n  }\n\n  .md\\:hover\\:translate-x-40:hover {\n    --transform-translate-x: 10rem;\n  }\n\n  .md\\:hover\\:translate-x-48:hover {\n    --transform-translate-x: 12rem;\n  }\n\n  .md\\:hover\\:translate-x-56:hover {\n    --transform-translate-x: 14rem;\n  }\n\n  .md\\:hover\\:translate-x-64:hover {\n    --transform-translate-x: 16rem;\n  }\n\n  .md\\:hover\\:translate-x-px:hover {\n    --transform-translate-x: 1px;\n  }\n\n  .md\\:hover\\:-translate-x-1:hover {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .md\\:hover\\:-translate-x-2:hover {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .md\\:hover\\:-translate-x-3:hover {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .md\\:hover\\:-translate-x-4:hover {\n    --transform-translate-x: -1rem;\n  }\n\n  .md\\:hover\\:-translate-x-5:hover {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .md\\:hover\\:-translate-x-6:hover {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .md\\:hover\\:-translate-x-8:hover {\n    --transform-translate-x: -2rem;\n  }\n\n  .md\\:hover\\:-translate-x-10:hover {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .md\\:hover\\:-translate-x-12:hover {\n    --transform-translate-x: -3rem;\n  }\n\n  .md\\:hover\\:-translate-x-16:hover {\n    --transform-translate-x: -4rem;\n  }\n\n  .md\\:hover\\:-translate-x-20:hover {\n    --transform-translate-x: -5rem;\n  }\n\n  .md\\:hover\\:-translate-x-24:hover {\n    --transform-translate-x: -6rem;\n  }\n\n  .md\\:hover\\:-translate-x-32:hover {\n    --transform-translate-x: -8rem;\n  }\n\n  .md\\:hover\\:-translate-x-40:hover {\n    --transform-translate-x: -10rem;\n  }\n\n  .md\\:hover\\:-translate-x-48:hover {\n    --transform-translate-x: -12rem;\n  }\n\n  .md\\:hover\\:-translate-x-56:hover {\n    --transform-translate-x: -14rem;\n  }\n\n  .md\\:hover\\:-translate-x-64:hover {\n    --transform-translate-x: -16rem;\n  }\n\n  .md\\:hover\\:-translate-x-px:hover {\n    --transform-translate-x: -1px;\n  }\n\n  .md\\:hover\\:-translate-x-full:hover {\n    --transform-translate-x: -100%;\n  }\n\n  .md\\:hover\\:-translate-x-1\\/2:hover {\n    --transform-translate-x: -50%;\n  }\n\n  .md\\:hover\\:translate-x-1\\/2:hover {\n    --transform-translate-x: 50%;\n  }\n\n  .md\\:hover\\:translate-x-full:hover {\n    --transform-translate-x: 100%;\n  }\n\n  .md\\:hover\\:translate-y-0:hover {\n    --transform-translate-y: 0;\n  }\n\n  .md\\:hover\\:translate-y-1:hover {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .md\\:hover\\:translate-y-2:hover {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .md\\:hover\\:translate-y-3:hover {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .md\\:hover\\:translate-y-4:hover {\n    --transform-translate-y: 1rem;\n  }\n\n  .md\\:hover\\:translate-y-5:hover {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .md\\:hover\\:translate-y-6:hover {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .md\\:hover\\:translate-y-8:hover {\n    --transform-translate-y: 2rem;\n  }\n\n  .md\\:hover\\:translate-y-10:hover {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .md\\:hover\\:translate-y-12:hover {\n    --transform-translate-y: 3rem;\n  }\n\n  .md\\:hover\\:translate-y-16:hover {\n    --transform-translate-y: 4rem;\n  }\n\n  .md\\:hover\\:translate-y-20:hover {\n    --transform-translate-y: 5rem;\n  }\n\n  .md\\:hover\\:translate-y-24:hover {\n    --transform-translate-y: 6rem;\n  }\n\n  .md\\:hover\\:translate-y-32:hover {\n    --transform-translate-y: 8rem;\n  }\n\n  .md\\:hover\\:translate-y-40:hover {\n    --transform-translate-y: 10rem;\n  }\n\n  .md\\:hover\\:translate-y-48:hover {\n    --transform-translate-y: 12rem;\n  }\n\n  .md\\:hover\\:translate-y-56:hover {\n    --transform-translate-y: 14rem;\n  }\n\n  .md\\:hover\\:translate-y-64:hover {\n    --transform-translate-y: 16rem;\n  }\n\n  .md\\:hover\\:translate-y-px:hover {\n    --transform-translate-y: 1px;\n  }\n\n  .md\\:hover\\:-translate-y-1:hover {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .md\\:hover\\:-translate-y-2:hover {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .md\\:hover\\:-translate-y-3:hover {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .md\\:hover\\:-translate-y-4:hover {\n    --transform-translate-y: -1rem;\n  }\n\n  .md\\:hover\\:-translate-y-5:hover {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .md\\:hover\\:-translate-y-6:hover {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .md\\:hover\\:-translate-y-8:hover {\n    --transform-translate-y: -2rem;\n  }\n\n  .md\\:hover\\:-translate-y-10:hover {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .md\\:hover\\:-translate-y-12:hover {\n    --transform-translate-y: -3rem;\n  }\n\n  .md\\:hover\\:-translate-y-16:hover {\n    --transform-translate-y: -4rem;\n  }\n\n  .md\\:hover\\:-translate-y-20:hover {\n    --transform-translate-y: -5rem;\n  }\n\n  .md\\:hover\\:-translate-y-24:hover {\n    --transform-translate-y: -6rem;\n  }\n\n  .md\\:hover\\:-translate-y-32:hover {\n    --transform-translate-y: -8rem;\n  }\n\n  .md\\:hover\\:-translate-y-40:hover {\n    --transform-translate-y: -10rem;\n  }\n\n  .md\\:hover\\:-translate-y-48:hover {\n    --transform-translate-y: -12rem;\n  }\n\n  .md\\:hover\\:-translate-y-56:hover {\n    --transform-translate-y: -14rem;\n  }\n\n  .md\\:hover\\:-translate-y-64:hover {\n    --transform-translate-y: -16rem;\n  }\n\n  .md\\:hover\\:-translate-y-px:hover {\n    --transform-translate-y: -1px;\n  }\n\n  .md\\:hover\\:-translate-y-full:hover {\n    --transform-translate-y: -100%;\n  }\n\n  .md\\:hover\\:-translate-y-1\\/2:hover {\n    --transform-translate-y: -50%;\n  }\n\n  .md\\:hover\\:translate-y-1\\/2:hover {\n    --transform-translate-y: 50%;\n  }\n\n  .md\\:hover\\:translate-y-full:hover {\n    --transform-translate-y: 100%;\n  }\n\n  .md\\:focus\\:translate-x-0:focus {\n    --transform-translate-x: 0;\n  }\n\n  .md\\:focus\\:translate-x-1:focus {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .md\\:focus\\:translate-x-2:focus {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .md\\:focus\\:translate-x-3:focus {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .md\\:focus\\:translate-x-4:focus {\n    --transform-translate-x: 1rem;\n  }\n\n  .md\\:focus\\:translate-x-5:focus {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .md\\:focus\\:translate-x-6:focus {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .md\\:focus\\:translate-x-8:focus {\n    --transform-translate-x: 2rem;\n  }\n\n  .md\\:focus\\:translate-x-10:focus {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .md\\:focus\\:translate-x-12:focus {\n    --transform-translate-x: 3rem;\n  }\n\n  .md\\:focus\\:translate-x-16:focus {\n    --transform-translate-x: 4rem;\n  }\n\n  .md\\:focus\\:translate-x-20:focus {\n    --transform-translate-x: 5rem;\n  }\n\n  .md\\:focus\\:translate-x-24:focus {\n    --transform-translate-x: 6rem;\n  }\n\n  .md\\:focus\\:translate-x-32:focus {\n    --transform-translate-x: 8rem;\n  }\n\n  .md\\:focus\\:translate-x-40:focus {\n    --transform-translate-x: 10rem;\n  }\n\n  .md\\:focus\\:translate-x-48:focus {\n    --transform-translate-x: 12rem;\n  }\n\n  .md\\:focus\\:translate-x-56:focus {\n    --transform-translate-x: 14rem;\n  }\n\n  .md\\:focus\\:translate-x-64:focus {\n    --transform-translate-x: 16rem;\n  }\n\n  .md\\:focus\\:translate-x-px:focus {\n    --transform-translate-x: 1px;\n  }\n\n  .md\\:focus\\:-translate-x-1:focus {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .md\\:focus\\:-translate-x-2:focus {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .md\\:focus\\:-translate-x-3:focus {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .md\\:focus\\:-translate-x-4:focus {\n    --transform-translate-x: -1rem;\n  }\n\n  .md\\:focus\\:-translate-x-5:focus {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .md\\:focus\\:-translate-x-6:focus {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .md\\:focus\\:-translate-x-8:focus {\n    --transform-translate-x: -2rem;\n  }\n\n  .md\\:focus\\:-translate-x-10:focus {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .md\\:focus\\:-translate-x-12:focus {\n    --transform-translate-x: -3rem;\n  }\n\n  .md\\:focus\\:-translate-x-16:focus {\n    --transform-translate-x: -4rem;\n  }\n\n  .md\\:focus\\:-translate-x-20:focus {\n    --transform-translate-x: -5rem;\n  }\n\n  .md\\:focus\\:-translate-x-24:focus {\n    --transform-translate-x: -6rem;\n  }\n\n  .md\\:focus\\:-translate-x-32:focus {\n    --transform-translate-x: -8rem;\n  }\n\n  .md\\:focus\\:-translate-x-40:focus {\n    --transform-translate-x: -10rem;\n  }\n\n  .md\\:focus\\:-translate-x-48:focus {\n    --transform-translate-x: -12rem;\n  }\n\n  .md\\:focus\\:-translate-x-56:focus {\n    --transform-translate-x: -14rem;\n  }\n\n  .md\\:focus\\:-translate-x-64:focus {\n    --transform-translate-x: -16rem;\n  }\n\n  .md\\:focus\\:-translate-x-px:focus {\n    --transform-translate-x: -1px;\n  }\n\n  .md\\:focus\\:-translate-x-full:focus {\n    --transform-translate-x: -100%;\n  }\n\n  .md\\:focus\\:-translate-x-1\\/2:focus {\n    --transform-translate-x: -50%;\n  }\n\n  .md\\:focus\\:translate-x-1\\/2:focus {\n    --transform-translate-x: 50%;\n  }\n\n  .md\\:focus\\:translate-x-full:focus {\n    --transform-translate-x: 100%;\n  }\n\n  .md\\:focus\\:translate-y-0:focus {\n    --transform-translate-y: 0;\n  }\n\n  .md\\:focus\\:translate-y-1:focus {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .md\\:focus\\:translate-y-2:focus {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .md\\:focus\\:translate-y-3:focus {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .md\\:focus\\:translate-y-4:focus {\n    --transform-translate-y: 1rem;\n  }\n\n  .md\\:focus\\:translate-y-5:focus {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .md\\:focus\\:translate-y-6:focus {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .md\\:focus\\:translate-y-8:focus {\n    --transform-translate-y: 2rem;\n  }\n\n  .md\\:focus\\:translate-y-10:focus {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .md\\:focus\\:translate-y-12:focus {\n    --transform-translate-y: 3rem;\n  }\n\n  .md\\:focus\\:translate-y-16:focus {\n    --transform-translate-y: 4rem;\n  }\n\n  .md\\:focus\\:translate-y-20:focus {\n    --transform-translate-y: 5rem;\n  }\n\n  .md\\:focus\\:translate-y-24:focus {\n    --transform-translate-y: 6rem;\n  }\n\n  .md\\:focus\\:translate-y-32:focus {\n    --transform-translate-y: 8rem;\n  }\n\n  .md\\:focus\\:translate-y-40:focus {\n    --transform-translate-y: 10rem;\n  }\n\n  .md\\:focus\\:translate-y-48:focus {\n    --transform-translate-y: 12rem;\n  }\n\n  .md\\:focus\\:translate-y-56:focus {\n    --transform-translate-y: 14rem;\n  }\n\n  .md\\:focus\\:translate-y-64:focus {\n    --transform-translate-y: 16rem;\n  }\n\n  .md\\:focus\\:translate-y-px:focus {\n    --transform-translate-y: 1px;\n  }\n\n  .md\\:focus\\:-translate-y-1:focus {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .md\\:focus\\:-translate-y-2:focus {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .md\\:focus\\:-translate-y-3:focus {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .md\\:focus\\:-translate-y-4:focus {\n    --transform-translate-y: -1rem;\n  }\n\n  .md\\:focus\\:-translate-y-5:focus {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .md\\:focus\\:-translate-y-6:focus {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .md\\:focus\\:-translate-y-8:focus {\n    --transform-translate-y: -2rem;\n  }\n\n  .md\\:focus\\:-translate-y-10:focus {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .md\\:focus\\:-translate-y-12:focus {\n    --transform-translate-y: -3rem;\n  }\n\n  .md\\:focus\\:-translate-y-16:focus {\n    --transform-translate-y: -4rem;\n  }\n\n  .md\\:focus\\:-translate-y-20:focus {\n    --transform-translate-y: -5rem;\n  }\n\n  .md\\:focus\\:-translate-y-24:focus {\n    --transform-translate-y: -6rem;\n  }\n\n  .md\\:focus\\:-translate-y-32:focus {\n    --transform-translate-y: -8rem;\n  }\n\n  .md\\:focus\\:-translate-y-40:focus {\n    --transform-translate-y: -10rem;\n  }\n\n  .md\\:focus\\:-translate-y-48:focus {\n    --transform-translate-y: -12rem;\n  }\n\n  .md\\:focus\\:-translate-y-56:focus {\n    --transform-translate-y: -14rem;\n  }\n\n  .md\\:focus\\:-translate-y-64:focus {\n    --transform-translate-y: -16rem;\n  }\n\n  .md\\:focus\\:-translate-y-px:focus {\n    --transform-translate-y: -1px;\n  }\n\n  .md\\:focus\\:-translate-y-full:focus {\n    --transform-translate-y: -100%;\n  }\n\n  .md\\:focus\\:-translate-y-1\\/2:focus {\n    --transform-translate-y: -50%;\n  }\n\n  .md\\:focus\\:translate-y-1\\/2:focus {\n    --transform-translate-y: 50%;\n  }\n\n  .md\\:focus\\:translate-y-full:focus {\n    --transform-translate-y: 100%;\n  }\n\n  .md\\:skew-x-0 {\n    --transform-skew-x: 0;\n  }\n\n  .md\\:skew-x-1 {\n    --transform-skew-x: 1deg;\n  }\n\n  .md\\:skew-x-2 {\n    --transform-skew-x: 2deg;\n  }\n\n  .md\\:skew-x-3 {\n    --transform-skew-x: 3deg;\n  }\n\n  .md\\:skew-x-6 {\n    --transform-skew-x: 6deg;\n  }\n\n  .md\\:skew-x-12 {\n    --transform-skew-x: 12deg;\n  }\n\n  .md\\:-skew-x-12 {\n    --transform-skew-x: -12deg;\n  }\n\n  .md\\:-skew-x-6 {\n    --transform-skew-x: -6deg;\n  }\n\n  .md\\:-skew-x-3 {\n    --transform-skew-x: -3deg;\n  }\n\n  .md\\:-skew-x-2 {\n    --transform-skew-x: -2deg;\n  }\n\n  .md\\:-skew-x-1 {\n    --transform-skew-x: -1deg;\n  }\n\n  .md\\:skew-y-0 {\n    --transform-skew-y: 0;\n  }\n\n  .md\\:skew-y-1 {\n    --transform-skew-y: 1deg;\n  }\n\n  .md\\:skew-y-2 {\n    --transform-skew-y: 2deg;\n  }\n\n  .md\\:skew-y-3 {\n    --transform-skew-y: 3deg;\n  }\n\n  .md\\:skew-y-6 {\n    --transform-skew-y: 6deg;\n  }\n\n  .md\\:skew-y-12 {\n    --transform-skew-y: 12deg;\n  }\n\n  .md\\:-skew-y-12 {\n    --transform-skew-y: -12deg;\n  }\n\n  .md\\:-skew-y-6 {\n    --transform-skew-y: -6deg;\n  }\n\n  .md\\:-skew-y-3 {\n    --transform-skew-y: -3deg;\n  }\n\n  .md\\:-skew-y-2 {\n    --transform-skew-y: -2deg;\n  }\n\n  .md\\:-skew-y-1 {\n    --transform-skew-y: -1deg;\n  }\n\n  .md\\:hover\\:skew-x-0:hover {\n    --transform-skew-x: 0;\n  }\n\n  .md\\:hover\\:skew-x-1:hover {\n    --transform-skew-x: 1deg;\n  }\n\n  .md\\:hover\\:skew-x-2:hover {\n    --transform-skew-x: 2deg;\n  }\n\n  .md\\:hover\\:skew-x-3:hover {\n    --transform-skew-x: 3deg;\n  }\n\n  .md\\:hover\\:skew-x-6:hover {\n    --transform-skew-x: 6deg;\n  }\n\n  .md\\:hover\\:skew-x-12:hover {\n    --transform-skew-x: 12deg;\n  }\n\n  .md\\:hover\\:-skew-x-12:hover {\n    --transform-skew-x: -12deg;\n  }\n\n  .md\\:hover\\:-skew-x-6:hover {\n    --transform-skew-x: -6deg;\n  }\n\n  .md\\:hover\\:-skew-x-3:hover {\n    --transform-skew-x: -3deg;\n  }\n\n  .md\\:hover\\:-skew-x-2:hover {\n    --transform-skew-x: -2deg;\n  }\n\n  .md\\:hover\\:-skew-x-1:hover {\n    --transform-skew-x: -1deg;\n  }\n\n  .md\\:hover\\:skew-y-0:hover {\n    --transform-skew-y: 0;\n  }\n\n  .md\\:hover\\:skew-y-1:hover {\n    --transform-skew-y: 1deg;\n  }\n\n  .md\\:hover\\:skew-y-2:hover {\n    --transform-skew-y: 2deg;\n  }\n\n  .md\\:hover\\:skew-y-3:hover {\n    --transform-skew-y: 3deg;\n  }\n\n  .md\\:hover\\:skew-y-6:hover {\n    --transform-skew-y: 6deg;\n  }\n\n  .md\\:hover\\:skew-y-12:hover {\n    --transform-skew-y: 12deg;\n  }\n\n  .md\\:hover\\:-skew-y-12:hover {\n    --transform-skew-y: -12deg;\n  }\n\n  .md\\:hover\\:-skew-y-6:hover {\n    --transform-skew-y: -6deg;\n  }\n\n  .md\\:hover\\:-skew-y-3:hover {\n    --transform-skew-y: -3deg;\n  }\n\n  .md\\:hover\\:-skew-y-2:hover {\n    --transform-skew-y: -2deg;\n  }\n\n  .md\\:hover\\:-skew-y-1:hover {\n    --transform-skew-y: -1deg;\n  }\n\n  .md\\:focus\\:skew-x-0:focus {\n    --transform-skew-x: 0;\n  }\n\n  .md\\:focus\\:skew-x-1:focus {\n    --transform-skew-x: 1deg;\n  }\n\n  .md\\:focus\\:skew-x-2:focus {\n    --transform-skew-x: 2deg;\n  }\n\n  .md\\:focus\\:skew-x-3:focus {\n    --transform-skew-x: 3deg;\n  }\n\n  .md\\:focus\\:skew-x-6:focus {\n    --transform-skew-x: 6deg;\n  }\n\n  .md\\:focus\\:skew-x-12:focus {\n    --transform-skew-x: 12deg;\n  }\n\n  .md\\:focus\\:-skew-x-12:focus {\n    --transform-skew-x: -12deg;\n  }\n\n  .md\\:focus\\:-skew-x-6:focus {\n    --transform-skew-x: -6deg;\n  }\n\n  .md\\:focus\\:-skew-x-3:focus {\n    --transform-skew-x: -3deg;\n  }\n\n  .md\\:focus\\:-skew-x-2:focus {\n    --transform-skew-x: -2deg;\n  }\n\n  .md\\:focus\\:-skew-x-1:focus {\n    --transform-skew-x: -1deg;\n  }\n\n  .md\\:focus\\:skew-y-0:focus {\n    --transform-skew-y: 0;\n  }\n\n  .md\\:focus\\:skew-y-1:focus {\n    --transform-skew-y: 1deg;\n  }\n\n  .md\\:focus\\:skew-y-2:focus {\n    --transform-skew-y: 2deg;\n  }\n\n  .md\\:focus\\:skew-y-3:focus {\n    --transform-skew-y: 3deg;\n  }\n\n  .md\\:focus\\:skew-y-6:focus {\n    --transform-skew-y: 6deg;\n  }\n\n  .md\\:focus\\:skew-y-12:focus {\n    --transform-skew-y: 12deg;\n  }\n\n  .md\\:focus\\:-skew-y-12:focus {\n    --transform-skew-y: -12deg;\n  }\n\n  .md\\:focus\\:-skew-y-6:focus {\n    --transform-skew-y: -6deg;\n  }\n\n  .md\\:focus\\:-skew-y-3:focus {\n    --transform-skew-y: -3deg;\n  }\n\n  .md\\:focus\\:-skew-y-2:focus {\n    --transform-skew-y: -2deg;\n  }\n\n  .md\\:focus\\:-skew-y-1:focus {\n    --transform-skew-y: -1deg;\n  }\n\n  .md\\:transition-none {\n    transition-property: none;\n  }\n\n  .md\\:transition-all {\n    transition-property: all;\n  }\n\n  .md\\:transition {\n    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n  }\n\n  .md\\:transition-colors {\n    transition-property: background-color, border-color, color, fill, stroke;\n  }\n\n  .md\\:transition-opacity {\n    transition-property: opacity;\n  }\n\n  .md\\:transition-shadow {\n    transition-property: box-shadow;\n  }\n\n  .md\\:transition-transform {\n    transition-property: transform;\n  }\n\n  .md\\:ease-linear {\n    transition-timing-function: linear;\n  }\n\n  .md\\:ease-in {\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  }\n\n  .md\\:ease-out {\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n\n  .md\\:ease-in-out {\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .md\\:duration-75 {\n    transition-duration: 75ms;\n  }\n\n  .md\\:duration-100 {\n    transition-duration: 100ms;\n  }\n\n  .md\\:duration-150 {\n    transition-duration: 150ms;\n  }\n\n  .md\\:duration-200 {\n    transition-duration: 200ms;\n  }\n\n  .md\\:duration-300 {\n    transition-duration: 300ms;\n  }\n\n  .md\\:duration-500 {\n    transition-duration: 500ms;\n  }\n\n  .md\\:duration-700 {\n    transition-duration: 700ms;\n  }\n\n  .md\\:duration-1000 {\n    transition-duration: 1000ms;\n  }\n\n  .md\\:delay-75 {\n    transition-delay: 75ms;\n  }\n\n  .md\\:delay-100 {\n    transition-delay: 100ms;\n  }\n\n  .md\\:delay-150 {\n    transition-delay: 150ms;\n  }\n\n  .md\\:delay-200 {\n    transition-delay: 200ms;\n  }\n\n  .md\\:delay-300 {\n    transition-delay: 300ms;\n  }\n\n  .md\\:delay-500 {\n    transition-delay: 500ms;\n  }\n\n  .md\\:delay-700 {\n    transition-delay: 700ms;\n  }\n\n  .md\\:delay-1000 {\n    transition-delay: 1000ms;\n  }\n\n  .md\\:animate-none {\n    animation: none;\n  }\n\n  .md\\:animate-spin {\n    animation: spin 1s linear infinite;\n  }\n\n  .md\\:animate-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n\n  .md\\:animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n\n  .md\\:animate-bounce {\n    animation: bounce 1s infinite;\n  }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:container {\n    width: 100%;\n  }\n\n  @media (min-width: 640px) {\n    .lg\\:container {\n      max-width: 640px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .lg\\:container {\n      max-width: 768px;\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .lg\\:container {\n      max-width: 1024px;\n    }\n  }\n\n  @media (min-width: 1280px) {\n    .lg\\:container {\n      max-width: 1280px;\n    }\n  }\n\n  .lg\\:space-y-0 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0px * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-0 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0px * var(--space-x-reverse));\n    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-1 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.25rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-1 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.25rem * var(--space-x-reverse));\n    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-2 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.5rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-2 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-3 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.75rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-3 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.75rem * var(--space-x-reverse));\n    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-4 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-4 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1rem * var(--space-x-reverse));\n    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-5 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.25rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-5 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.25rem * var(--space-x-reverse));\n    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-6 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.5rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-6 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.5rem * var(--space-x-reverse));\n    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-8 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-8 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2rem * var(--space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-10 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.5rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-10 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.5rem * var(--space-x-reverse));\n    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-12 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-12 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3rem * var(--space-x-reverse));\n    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-16 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(4rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-16 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(4rem * var(--space-x-reverse));\n    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-20 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(5rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-20 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(5rem * var(--space-x-reverse));\n    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-24 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(6rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-24 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(6rem * var(--space-x-reverse));\n    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-32 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-32 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8rem * var(--space-x-reverse));\n    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-40 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(10rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-40 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(10rem * var(--space-x-reverse));\n    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-48 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(12rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-48 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(12rem * var(--space-x-reverse));\n    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-56 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(14rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-56 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(14rem * var(--space-x-reverse));\n    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-64 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16rem * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-64 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16rem * var(--space-x-reverse));\n    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-px > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1px * var(--space-y-reverse));\n  }\n\n  .lg\\:space-x-px > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1px * var(--space-x-reverse));\n    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-1 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-1 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.25rem * var(--space-x-reverse));\n    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-2 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-2 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.5rem * var(--space-x-reverse));\n    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-3 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-3 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.75rem * var(--space-x-reverse));\n    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-4 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-4 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1rem * var(--space-x-reverse));\n    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-5 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-5 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.25rem * var(--space-x-reverse));\n    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-6 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-6 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.5rem * var(--space-x-reverse));\n    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-8 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-8 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2rem * var(--space-x-reverse));\n    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-10 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-10 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.5rem * var(--space-x-reverse));\n    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-12 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-12 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3rem * var(--space-x-reverse));\n    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-16 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-4rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-16 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-4rem * var(--space-x-reverse));\n    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-20 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-5rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-20 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-5rem * var(--space-x-reverse));\n    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-24 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-6rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-24 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-6rem * var(--space-x-reverse));\n    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-32 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-32 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8rem * var(--space-x-reverse));\n    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-40 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-10rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-40 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-10rem * var(--space-x-reverse));\n    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-48 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-12rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-48 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-12rem * var(--space-x-reverse));\n    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-56 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-14rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-56 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-14rem * var(--space-x-reverse));\n    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-64 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16rem * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-64 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16rem * var(--space-x-reverse));\n    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:-space-y-px > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1px * var(--space-y-reverse));\n  }\n\n  .lg\\:-space-x-px > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1px * var(--space-x-reverse));\n    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .lg\\:space-y-reverse > :not(template) ~ :not(template) {\n    --space-y-reverse: 1;\n  }\n\n  .lg\\:space-x-reverse > :not(template) ~ :not(template) {\n    --space-x-reverse: 1;\n  }\n\n  .lg\\:divide-y-0 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(0px * var(--divide-y-reverse));\n  }\n\n  .lg\\:divide-x-0 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(0px * var(--divide-x-reverse));\n    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .lg\\:divide-y-2 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(2px * var(--divide-y-reverse));\n  }\n\n  .lg\\:divide-x-2 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .lg\\:divide-y-4 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(4px * var(--divide-y-reverse));\n  }\n\n  .lg\\:divide-x-4 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(4px * var(--divide-x-reverse));\n    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .lg\\:divide-y-8 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(8px * var(--divide-y-reverse));\n  }\n\n  .lg\\:divide-x-8 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(8px * var(--divide-x-reverse));\n    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .lg\\:divide-y > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(1px * var(--divide-y-reverse));\n  }\n\n  .lg\\:divide-x > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(1px * var(--divide-x-reverse));\n    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .lg\\:divide-y-reverse > :not(template) ~ :not(template) {\n    --divide-y-reverse: 1;\n  }\n\n  .lg\\:divide-x-reverse > :not(template) ~ :not(template) {\n    --divide-x-reverse: 1;\n  }\n\n  .lg\\:divide-transparent > :not(template) ~ :not(template) {\n    border-color: transparent;\n  }\n\n  .lg\\:divide-current > :not(template) ~ :not(template) {\n    border-color: currentColor;\n  }\n\n  .lg\\:divide-black > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--divide-opacity));\n  }\n\n  .lg\\:divide-white > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--divide-opacity));\n  }\n\n  .lg\\:divide-gray-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--divide-opacity));\n  }\n\n  .lg\\:divide-red-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--divide-opacity));\n  }\n\n  .lg\\:divide-orange-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--divide-opacity));\n  }\n\n  .lg\\:divide-yellow-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--divide-opacity));\n  }\n\n  .lg\\:divide-green-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--divide-opacity));\n  }\n\n  .lg\\:divide-teal-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--divide-opacity));\n  }\n\n  .lg\\:divide-blue-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--divide-opacity));\n  }\n\n  .lg\\:divide-indigo-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--divide-opacity));\n  }\n\n  .lg\\:divide-purple-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--divide-opacity));\n  }\n\n  .lg\\:divide-pink-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--divide-opacity));\n  }\n\n  .lg\\:divide-solid > :not(template) ~ :not(template) {\n    border-style: solid;\n  }\n\n  .lg\\:divide-dashed > :not(template) ~ :not(template) {\n    border-style: dashed;\n  }\n\n  .lg\\:divide-dotted > :not(template) ~ :not(template) {\n    border-style: dotted;\n  }\n\n  .lg\\:divide-double > :not(template) ~ :not(template) {\n    border-style: double;\n  }\n\n  .lg\\:divide-none > :not(template) ~ :not(template) {\n    border-style: none;\n  }\n\n  .lg\\:divide-opacity-0 > :not(template) ~ :not(template) {\n    --divide-opacity: 0;\n  }\n\n  .lg\\:divide-opacity-25 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.25;\n  }\n\n  .lg\\:divide-opacity-50 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.5;\n  }\n\n  .lg\\:divide-opacity-75 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.75;\n  }\n\n  .lg\\:divide-opacity-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n  }\n\n  .lg\\:sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n\n  .lg\\:not-sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n\n  .lg\\:focus\\:sr-only:focus {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n\n  .lg\\:focus\\:not-sr-only:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n\n  .lg\\:appearance-none {\n    appearance: none;\n  }\n\n  .lg\\:bg-fixed {\n    background-attachment: fixed;\n  }\n\n  .lg\\:bg-local {\n    background-attachment: local;\n  }\n\n  .lg\\:bg-scroll {\n    background-attachment: scroll;\n  }\n\n  .lg\\:bg-clip-border {\n    background-clip: border-box;\n  }\n\n  .lg\\:bg-clip-padding {\n    background-clip: padding-box;\n  }\n\n  .lg\\:bg-clip-content {\n    background-clip: content-box;\n  }\n\n  .lg\\:bg-clip-text {\n    -webkit-background-clip: text;\n            background-clip: text;\n  }\n\n  .lg\\:bg-transparent {\n    background-color: transparent;\n  }\n\n  .lg\\:bg-current {\n    background-color: currentColor;\n  }\n\n  .lg\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .lg\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .lg\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .lg\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .lg\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .lg\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .lg\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .lg\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .lg\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .lg\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .lg\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .lg\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n  }\n\n  .lg\\:hover\\:bg-current:hover {\n    background-color: currentColor;\n  }\n\n  .lg\\:hover\\:bg-black:hover {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-white:hover {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-100:hover {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-200:hover {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-300:hover {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-400:hover {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-500:hover {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-600:hover {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-700:hover {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-800:hover {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-red-900:hover {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-100:hover {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-200:hover {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-300:hover {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-400:hover {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-500:hover {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-600:hover {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-700:hover {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-800:hover {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-orange-900:hover {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-100:hover {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-200:hover {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-300:hover {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-400:hover {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-500:hover {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-600:hover {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-700:hover {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-800:hover {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-yellow-900:hover {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-100:hover {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-200:hover {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-300:hover {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-400:hover {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-500:hover {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-600:hover {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-700:hover {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-800:hover {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-green-900:hover {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-100:hover {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-200:hover {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-300:hover {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-400:hover {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-500:hover {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-600:hover {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-700:hover {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-800:hover {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-teal-900:hover {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-100:hover {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-200:hover {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-300:hover {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-400:hover {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-500:hover {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-600:hover {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-700:hover {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-800:hover {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-blue-900:hover {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-100:hover {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-200:hover {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-300:hover {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-400:hover {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-500:hover {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-600:hover {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-700:hover {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-800:hover {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-indigo-900:hover {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-100:hover {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-200:hover {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-300:hover {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-400:hover {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-500:hover {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-600:hover {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-700:hover {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-800:hover {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-purple-900:hover {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-100:hover {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-200:hover {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-300:hover {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-400:hover {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-500:hover {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-600:hover {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-700:hover {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-800:hover {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .lg\\:hover\\:bg-pink-900:hover {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-transparent:focus {\n    background-color: transparent;\n  }\n\n  .lg\\:focus\\:bg-current:focus {\n    background-color: currentColor;\n  }\n\n  .lg\\:focus\\:bg-black:focus {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-white:focus {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-100:focus {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-200:focus {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-300:focus {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-400:focus {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-500:focus {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-600:focus {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-700:focus {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-800:focus {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-red-900:focus {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-100:focus {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-200:focus {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-300:focus {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-400:focus {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-500:focus {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-600:focus {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-700:focus {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-800:focus {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-orange-900:focus {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-100:focus {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-200:focus {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-300:focus {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-400:focus {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-500:focus {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-600:focus {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-700:focus {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-800:focus {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-yellow-900:focus {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-100:focus {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-200:focus {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-300:focus {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-400:focus {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-500:focus {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-600:focus {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-700:focus {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-800:focus {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-green-900:focus {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-100:focus {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-200:focus {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-300:focus {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-400:focus {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-500:focus {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-600:focus {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-700:focus {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-800:focus {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-teal-900:focus {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-100:focus {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-200:focus {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-300:focus {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-400:focus {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-500:focus {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-600:focus {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-700:focus {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-800:focus {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-blue-900:focus {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-100:focus {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-200:focus {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-300:focus {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-400:focus {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-500:focus {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-600:focus {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-700:focus {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-800:focus {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-indigo-900:focus {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-100:focus {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-200:focus {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-300:focus {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-400:focus {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-500:focus {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-600:focus {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-700:focus {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-800:focus {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-purple-900:focus {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-100:focus {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-200:focus {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-300:focus {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-400:focus {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-500:focus {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-600:focus {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-700:focus {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-800:focus {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .lg\\:focus\\:bg-pink-900:focus {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .lg\\:bg-none {\n    background-image: none;\n  }\n\n  .lg\\:bg-gradient-to-t {\n    background-image: linear-gradient(to top, var(--gradient-color-stops));\n  }\n\n  .lg\\:bg-gradient-to-tr {\n    background-image: linear-gradient(to top right, var(--gradient-color-stops));\n  }\n\n  .lg\\:bg-gradient-to-r {\n    background-image: linear-gradient(to right, var(--gradient-color-stops));\n  }\n\n  .lg\\:bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n  }\n\n  .lg\\:bg-gradient-to-b {\n    background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n  }\n\n  .lg\\:bg-gradient-to-bl {\n    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n  }\n\n  .lg\\:bg-gradient-to-l {\n    background-image: linear-gradient(to left, var(--gradient-color-stops));\n  }\n\n  .lg\\:bg-gradient-to-tl {\n    background-image: linear-gradient(to top left, var(--gradient-color-stops));\n  }\n\n  .lg\\:from-transparent {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:from-current {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:from-black {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:from-white {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:from-gray-100 {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .lg\\:from-gray-200 {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .lg\\:from-gray-300 {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .lg\\:from-gray-400 {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .lg\\:from-gray-500 {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .lg\\:from-gray-600 {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .lg\\:from-gray-700 {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .lg\\:from-gray-800 {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .lg\\:from-gray-900 {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .lg\\:from-red-100 {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .lg\\:from-red-200 {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .lg\\:from-red-300 {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .lg\\:from-red-400 {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .lg\\:from-red-500 {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .lg\\:from-red-600 {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .lg\\:from-red-700 {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .lg\\:from-red-800 {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .lg\\:from-red-900 {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .lg\\:from-orange-100 {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .lg\\:from-orange-200 {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .lg\\:from-orange-300 {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .lg\\:from-orange-400 {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .lg\\:from-orange-500 {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .lg\\:from-orange-600 {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .lg\\:from-orange-700 {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .lg\\:from-orange-800 {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .lg\\:from-orange-900 {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .lg\\:from-yellow-100 {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .lg\\:from-yellow-200 {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .lg\\:from-yellow-300 {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .lg\\:from-yellow-400 {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .lg\\:from-yellow-500 {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .lg\\:from-yellow-600 {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .lg\\:from-yellow-700 {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .lg\\:from-yellow-800 {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .lg\\:from-yellow-900 {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .lg\\:from-green-100 {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .lg\\:from-green-200 {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .lg\\:from-green-300 {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .lg\\:from-green-400 {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .lg\\:from-green-500 {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .lg\\:from-green-600 {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .lg\\:from-green-700 {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .lg\\:from-green-800 {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .lg\\:from-green-900 {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .lg\\:from-teal-100 {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .lg\\:from-teal-200 {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .lg\\:from-teal-300 {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .lg\\:from-teal-400 {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .lg\\:from-teal-500 {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .lg\\:from-teal-600 {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .lg\\:from-teal-700 {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .lg\\:from-teal-800 {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .lg\\:from-teal-900 {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .lg\\:from-blue-100 {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .lg\\:from-blue-200 {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .lg\\:from-blue-300 {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .lg\\:from-blue-400 {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .lg\\:from-blue-500 {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .lg\\:from-blue-600 {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .lg\\:from-blue-700 {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .lg\\:from-blue-800 {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .lg\\:from-blue-900 {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .lg\\:from-indigo-100 {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .lg\\:from-indigo-200 {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .lg\\:from-indigo-300 {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .lg\\:from-indigo-400 {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .lg\\:from-indigo-500 {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .lg\\:from-indigo-600 {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .lg\\:from-indigo-700 {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .lg\\:from-indigo-800 {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .lg\\:from-indigo-900 {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .lg\\:from-purple-100 {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .lg\\:from-purple-200 {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .lg\\:from-purple-300 {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .lg\\:from-purple-400 {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .lg\\:from-purple-500 {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .lg\\:from-purple-600 {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .lg\\:from-purple-700 {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .lg\\:from-purple-800 {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .lg\\:from-purple-900 {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .lg\\:from-pink-100 {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .lg\\:from-pink-200 {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .lg\\:from-pink-300 {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .lg\\:from-pink-400 {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .lg\\:from-pink-500 {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .lg\\:from-pink-600 {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .lg\\:from-pink-700 {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .lg\\:from-pink-800 {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .lg\\:from-pink-900 {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .lg\\:via-transparent {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:via-current {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:via-black {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:via-white {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:via-gray-100 {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .lg\\:via-gray-200 {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .lg\\:via-gray-300 {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .lg\\:via-gray-400 {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .lg\\:via-gray-500 {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .lg\\:via-gray-600 {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .lg\\:via-gray-700 {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .lg\\:via-gray-800 {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .lg\\:via-gray-900 {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .lg\\:via-red-100 {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .lg\\:via-red-200 {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .lg\\:via-red-300 {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .lg\\:via-red-400 {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .lg\\:via-red-500 {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .lg\\:via-red-600 {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .lg\\:via-red-700 {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .lg\\:via-red-800 {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .lg\\:via-red-900 {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .lg\\:via-orange-100 {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .lg\\:via-orange-200 {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .lg\\:via-orange-300 {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .lg\\:via-orange-400 {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .lg\\:via-orange-500 {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .lg\\:via-orange-600 {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .lg\\:via-orange-700 {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .lg\\:via-orange-800 {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .lg\\:via-orange-900 {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .lg\\:via-yellow-100 {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .lg\\:via-yellow-200 {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .lg\\:via-yellow-300 {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .lg\\:via-yellow-400 {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .lg\\:via-yellow-500 {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .lg\\:via-yellow-600 {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .lg\\:via-yellow-700 {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .lg\\:via-yellow-800 {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .lg\\:via-yellow-900 {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .lg\\:via-green-100 {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .lg\\:via-green-200 {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .lg\\:via-green-300 {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .lg\\:via-green-400 {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .lg\\:via-green-500 {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .lg\\:via-green-600 {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .lg\\:via-green-700 {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .lg\\:via-green-800 {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .lg\\:via-green-900 {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .lg\\:via-teal-100 {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .lg\\:via-teal-200 {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .lg\\:via-teal-300 {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .lg\\:via-teal-400 {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .lg\\:via-teal-500 {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .lg\\:via-teal-600 {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .lg\\:via-teal-700 {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .lg\\:via-teal-800 {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .lg\\:via-teal-900 {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .lg\\:via-blue-100 {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .lg\\:via-blue-200 {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .lg\\:via-blue-300 {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .lg\\:via-blue-400 {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .lg\\:via-blue-500 {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .lg\\:via-blue-600 {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .lg\\:via-blue-700 {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .lg\\:via-blue-800 {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .lg\\:via-blue-900 {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .lg\\:via-indigo-100 {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .lg\\:via-indigo-200 {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .lg\\:via-indigo-300 {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .lg\\:via-indigo-400 {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .lg\\:via-indigo-500 {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .lg\\:via-indigo-600 {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .lg\\:via-indigo-700 {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .lg\\:via-indigo-800 {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .lg\\:via-indigo-900 {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .lg\\:via-purple-100 {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .lg\\:via-purple-200 {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .lg\\:via-purple-300 {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .lg\\:via-purple-400 {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .lg\\:via-purple-500 {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .lg\\:via-purple-600 {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .lg\\:via-purple-700 {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .lg\\:via-purple-800 {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .lg\\:via-purple-900 {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .lg\\:via-pink-100 {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .lg\\:via-pink-200 {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .lg\\:via-pink-300 {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .lg\\:via-pink-400 {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .lg\\:via-pink-500 {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .lg\\:via-pink-600 {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .lg\\:via-pink-700 {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .lg\\:via-pink-800 {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .lg\\:via-pink-900 {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .lg\\:to-transparent {\n    --gradient-to-color: transparent;\n  }\n\n  .lg\\:to-current {\n    --gradient-to-color: currentColor;\n  }\n\n  .lg\\:to-black {\n    --gradient-to-color: #000;\n  }\n\n  .lg\\:to-white {\n    --gradient-to-color: #fff;\n  }\n\n  .lg\\:to-gray-100 {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .lg\\:to-gray-200 {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .lg\\:to-gray-300 {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .lg\\:to-gray-400 {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .lg\\:to-gray-500 {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .lg\\:to-gray-600 {\n    --gradient-to-color: #718096;\n  }\n\n  .lg\\:to-gray-700 {\n    --gradient-to-color: #4a5568;\n  }\n\n  .lg\\:to-gray-800 {\n    --gradient-to-color: #2d3748;\n  }\n\n  .lg\\:to-gray-900 {\n    --gradient-to-color: #1a202c;\n  }\n\n  .lg\\:to-red-100 {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .lg\\:to-red-200 {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .lg\\:to-red-300 {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .lg\\:to-red-400 {\n    --gradient-to-color: #fc8181;\n  }\n\n  .lg\\:to-red-500 {\n    --gradient-to-color: #f56565;\n  }\n\n  .lg\\:to-red-600 {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .lg\\:to-red-700 {\n    --gradient-to-color: #c53030;\n  }\n\n  .lg\\:to-red-800 {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .lg\\:to-red-900 {\n    --gradient-to-color: #742a2a;\n  }\n\n  .lg\\:to-orange-100 {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .lg\\:to-orange-200 {\n    --gradient-to-color: #feebc8;\n  }\n\n  .lg\\:to-orange-300 {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .lg\\:to-orange-400 {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .lg\\:to-orange-500 {\n    --gradient-to-color: #ed8936;\n  }\n\n  .lg\\:to-orange-600 {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .lg\\:to-orange-700 {\n    --gradient-to-color: #c05621;\n  }\n\n  .lg\\:to-orange-800 {\n    --gradient-to-color: #9c4221;\n  }\n\n  .lg\\:to-orange-900 {\n    --gradient-to-color: #7b341e;\n  }\n\n  .lg\\:to-yellow-100 {\n    --gradient-to-color: #fffff0;\n  }\n\n  .lg\\:to-yellow-200 {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .lg\\:to-yellow-300 {\n    --gradient-to-color: #faf089;\n  }\n\n  .lg\\:to-yellow-400 {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .lg\\:to-yellow-500 {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .lg\\:to-yellow-600 {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .lg\\:to-yellow-700 {\n    --gradient-to-color: #b7791f;\n  }\n\n  .lg\\:to-yellow-800 {\n    --gradient-to-color: #975a16;\n  }\n\n  .lg\\:to-yellow-900 {\n    --gradient-to-color: #744210;\n  }\n\n  .lg\\:to-green-100 {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .lg\\:to-green-200 {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .lg\\:to-green-300 {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .lg\\:to-green-400 {\n    --gradient-to-color: #68d391;\n  }\n\n  .lg\\:to-green-500 {\n    --gradient-to-color: #48bb78;\n  }\n\n  .lg\\:to-green-600 {\n    --gradient-to-color: #38a169;\n  }\n\n  .lg\\:to-green-700 {\n    --gradient-to-color: #2f855a;\n  }\n\n  .lg\\:to-green-800 {\n    --gradient-to-color: #276749;\n  }\n\n  .lg\\:to-green-900 {\n    --gradient-to-color: #22543d;\n  }\n\n  .lg\\:to-teal-100 {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .lg\\:to-teal-200 {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .lg\\:to-teal-300 {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .lg\\:to-teal-400 {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .lg\\:to-teal-500 {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .lg\\:to-teal-600 {\n    --gradient-to-color: #319795;\n  }\n\n  .lg\\:to-teal-700 {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .lg\\:to-teal-800 {\n    --gradient-to-color: #285e61;\n  }\n\n  .lg\\:to-teal-900 {\n    --gradient-to-color: #234e52;\n  }\n\n  .lg\\:to-blue-100 {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .lg\\:to-blue-200 {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .lg\\:to-blue-300 {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .lg\\:to-blue-400 {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .lg\\:to-blue-500 {\n    --gradient-to-color: #4299e1;\n  }\n\n  .lg\\:to-blue-600 {\n    --gradient-to-color: #3182ce;\n  }\n\n  .lg\\:to-blue-700 {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .lg\\:to-blue-800 {\n    --gradient-to-color: #2c5282;\n  }\n\n  .lg\\:to-blue-900 {\n    --gradient-to-color: #2a4365;\n  }\n\n  .lg\\:to-indigo-100 {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .lg\\:to-indigo-200 {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .lg\\:to-indigo-300 {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .lg\\:to-indigo-400 {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .lg\\:to-indigo-500 {\n    --gradient-to-color: #667eea;\n  }\n\n  .lg\\:to-indigo-600 {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .lg\\:to-indigo-700 {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .lg\\:to-indigo-800 {\n    --gradient-to-color: #434190;\n  }\n\n  .lg\\:to-indigo-900 {\n    --gradient-to-color: #3c366b;\n  }\n\n  .lg\\:to-purple-100 {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .lg\\:to-purple-200 {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .lg\\:to-purple-300 {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .lg\\:to-purple-400 {\n    --gradient-to-color: #b794f4;\n  }\n\n  .lg\\:to-purple-500 {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .lg\\:to-purple-600 {\n    --gradient-to-color: #805ad5;\n  }\n\n  .lg\\:to-purple-700 {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .lg\\:to-purple-800 {\n    --gradient-to-color: #553c9a;\n  }\n\n  .lg\\:to-purple-900 {\n    --gradient-to-color: #44337a;\n  }\n\n  .lg\\:to-pink-100 {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .lg\\:to-pink-200 {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .lg\\:to-pink-300 {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .lg\\:to-pink-400 {\n    --gradient-to-color: #f687b3;\n  }\n\n  .lg\\:to-pink-500 {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .lg\\:to-pink-600 {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .lg\\:to-pink-700 {\n    --gradient-to-color: #b83280;\n  }\n\n  .lg\\:to-pink-800 {\n    --gradient-to-color: #97266d;\n  }\n\n  .lg\\:to-pink-900 {\n    --gradient-to-color: #702459;\n  }\n\n  .lg\\:hover\\:from-transparent:hover {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:hover\\:from-current:hover {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:hover\\:from-black:hover {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:hover\\:from-white:hover {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:hover\\:from-gray-100:hover {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .lg\\:hover\\:from-gray-200:hover {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .lg\\:hover\\:from-gray-300:hover {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .lg\\:hover\\:from-gray-400:hover {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .lg\\:hover\\:from-gray-500:hover {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .lg\\:hover\\:from-gray-600:hover {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .lg\\:hover\\:from-gray-700:hover {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .lg\\:hover\\:from-gray-800:hover {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .lg\\:hover\\:from-gray-900:hover {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .lg\\:hover\\:from-red-100:hover {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .lg\\:hover\\:from-red-200:hover {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .lg\\:hover\\:from-red-300:hover {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .lg\\:hover\\:from-red-400:hover {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .lg\\:hover\\:from-red-500:hover {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .lg\\:hover\\:from-red-600:hover {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .lg\\:hover\\:from-red-700:hover {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .lg\\:hover\\:from-red-800:hover {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .lg\\:hover\\:from-red-900:hover {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .lg\\:hover\\:from-orange-100:hover {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .lg\\:hover\\:from-orange-200:hover {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .lg\\:hover\\:from-orange-300:hover {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .lg\\:hover\\:from-orange-400:hover {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .lg\\:hover\\:from-orange-500:hover {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .lg\\:hover\\:from-orange-600:hover {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .lg\\:hover\\:from-orange-700:hover {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .lg\\:hover\\:from-orange-800:hover {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .lg\\:hover\\:from-orange-900:hover {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-100:hover {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-200:hover {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-300:hover {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-400:hover {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-500:hover {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-600:hover {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-700:hover {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-800:hover {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .lg\\:hover\\:from-yellow-900:hover {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .lg\\:hover\\:from-green-100:hover {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .lg\\:hover\\:from-green-200:hover {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .lg\\:hover\\:from-green-300:hover {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .lg\\:hover\\:from-green-400:hover {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .lg\\:hover\\:from-green-500:hover {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .lg\\:hover\\:from-green-600:hover {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .lg\\:hover\\:from-green-700:hover {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .lg\\:hover\\:from-green-800:hover {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .lg\\:hover\\:from-green-900:hover {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .lg\\:hover\\:from-teal-100:hover {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .lg\\:hover\\:from-teal-200:hover {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .lg\\:hover\\:from-teal-300:hover {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .lg\\:hover\\:from-teal-400:hover {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .lg\\:hover\\:from-teal-500:hover {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .lg\\:hover\\:from-teal-600:hover {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .lg\\:hover\\:from-teal-700:hover {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .lg\\:hover\\:from-teal-800:hover {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .lg\\:hover\\:from-teal-900:hover {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .lg\\:hover\\:from-blue-100:hover {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .lg\\:hover\\:from-blue-200:hover {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .lg\\:hover\\:from-blue-300:hover {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .lg\\:hover\\:from-blue-400:hover {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .lg\\:hover\\:from-blue-500:hover {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .lg\\:hover\\:from-blue-600:hover {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .lg\\:hover\\:from-blue-700:hover {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .lg\\:hover\\:from-blue-800:hover {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .lg\\:hover\\:from-blue-900:hover {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-100:hover {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-200:hover {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-300:hover {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-400:hover {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-500:hover {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-600:hover {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-700:hover {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-800:hover {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .lg\\:hover\\:from-indigo-900:hover {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .lg\\:hover\\:from-purple-100:hover {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .lg\\:hover\\:from-purple-200:hover {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .lg\\:hover\\:from-purple-300:hover {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .lg\\:hover\\:from-purple-400:hover {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .lg\\:hover\\:from-purple-500:hover {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .lg\\:hover\\:from-purple-600:hover {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .lg\\:hover\\:from-purple-700:hover {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .lg\\:hover\\:from-purple-800:hover {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .lg\\:hover\\:from-purple-900:hover {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .lg\\:hover\\:from-pink-100:hover {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .lg\\:hover\\:from-pink-200:hover {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .lg\\:hover\\:from-pink-300:hover {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .lg\\:hover\\:from-pink-400:hover {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .lg\\:hover\\:from-pink-500:hover {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .lg\\:hover\\:from-pink-600:hover {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .lg\\:hover\\:from-pink-700:hover {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .lg\\:hover\\:from-pink-800:hover {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .lg\\:hover\\:from-pink-900:hover {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .lg\\:hover\\:via-transparent:hover {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:hover\\:via-current:hover {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:hover\\:via-black:hover {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:hover\\:via-white:hover {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:hover\\:via-gray-100:hover {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .lg\\:hover\\:via-gray-200:hover {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .lg\\:hover\\:via-gray-300:hover {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .lg\\:hover\\:via-gray-400:hover {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .lg\\:hover\\:via-gray-500:hover {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .lg\\:hover\\:via-gray-600:hover {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .lg\\:hover\\:via-gray-700:hover {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .lg\\:hover\\:via-gray-800:hover {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .lg\\:hover\\:via-gray-900:hover {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .lg\\:hover\\:via-red-100:hover {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .lg\\:hover\\:via-red-200:hover {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .lg\\:hover\\:via-red-300:hover {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .lg\\:hover\\:via-red-400:hover {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .lg\\:hover\\:via-red-500:hover {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .lg\\:hover\\:via-red-600:hover {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .lg\\:hover\\:via-red-700:hover {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .lg\\:hover\\:via-red-800:hover {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .lg\\:hover\\:via-red-900:hover {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .lg\\:hover\\:via-orange-100:hover {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .lg\\:hover\\:via-orange-200:hover {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .lg\\:hover\\:via-orange-300:hover {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .lg\\:hover\\:via-orange-400:hover {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .lg\\:hover\\:via-orange-500:hover {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .lg\\:hover\\:via-orange-600:hover {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .lg\\:hover\\:via-orange-700:hover {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .lg\\:hover\\:via-orange-800:hover {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .lg\\:hover\\:via-orange-900:hover {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-100:hover {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-200:hover {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-300:hover {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-400:hover {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-500:hover {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-600:hover {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-700:hover {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-800:hover {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .lg\\:hover\\:via-yellow-900:hover {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .lg\\:hover\\:via-green-100:hover {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .lg\\:hover\\:via-green-200:hover {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .lg\\:hover\\:via-green-300:hover {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .lg\\:hover\\:via-green-400:hover {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .lg\\:hover\\:via-green-500:hover {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .lg\\:hover\\:via-green-600:hover {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .lg\\:hover\\:via-green-700:hover {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .lg\\:hover\\:via-green-800:hover {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .lg\\:hover\\:via-green-900:hover {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .lg\\:hover\\:via-teal-100:hover {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .lg\\:hover\\:via-teal-200:hover {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .lg\\:hover\\:via-teal-300:hover {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .lg\\:hover\\:via-teal-400:hover {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .lg\\:hover\\:via-teal-500:hover {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .lg\\:hover\\:via-teal-600:hover {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .lg\\:hover\\:via-teal-700:hover {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .lg\\:hover\\:via-teal-800:hover {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .lg\\:hover\\:via-teal-900:hover {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .lg\\:hover\\:via-blue-100:hover {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .lg\\:hover\\:via-blue-200:hover {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .lg\\:hover\\:via-blue-300:hover {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .lg\\:hover\\:via-blue-400:hover {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .lg\\:hover\\:via-blue-500:hover {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .lg\\:hover\\:via-blue-600:hover {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .lg\\:hover\\:via-blue-700:hover {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .lg\\:hover\\:via-blue-800:hover {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .lg\\:hover\\:via-blue-900:hover {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-100:hover {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-200:hover {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-300:hover {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-400:hover {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-500:hover {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-600:hover {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-700:hover {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-800:hover {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .lg\\:hover\\:via-indigo-900:hover {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .lg\\:hover\\:via-purple-100:hover {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .lg\\:hover\\:via-purple-200:hover {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .lg\\:hover\\:via-purple-300:hover {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .lg\\:hover\\:via-purple-400:hover {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .lg\\:hover\\:via-purple-500:hover {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .lg\\:hover\\:via-purple-600:hover {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .lg\\:hover\\:via-purple-700:hover {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .lg\\:hover\\:via-purple-800:hover {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .lg\\:hover\\:via-purple-900:hover {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .lg\\:hover\\:via-pink-100:hover {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .lg\\:hover\\:via-pink-200:hover {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .lg\\:hover\\:via-pink-300:hover {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .lg\\:hover\\:via-pink-400:hover {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .lg\\:hover\\:via-pink-500:hover {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .lg\\:hover\\:via-pink-600:hover {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .lg\\:hover\\:via-pink-700:hover {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .lg\\:hover\\:via-pink-800:hover {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .lg\\:hover\\:via-pink-900:hover {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .lg\\:hover\\:to-transparent:hover {\n    --gradient-to-color: transparent;\n  }\n\n  .lg\\:hover\\:to-current:hover {\n    --gradient-to-color: currentColor;\n  }\n\n  .lg\\:hover\\:to-black:hover {\n    --gradient-to-color: #000;\n  }\n\n  .lg\\:hover\\:to-white:hover {\n    --gradient-to-color: #fff;\n  }\n\n  .lg\\:hover\\:to-gray-100:hover {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .lg\\:hover\\:to-gray-200:hover {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .lg\\:hover\\:to-gray-300:hover {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .lg\\:hover\\:to-gray-400:hover {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .lg\\:hover\\:to-gray-500:hover {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .lg\\:hover\\:to-gray-600:hover {\n    --gradient-to-color: #718096;\n  }\n\n  .lg\\:hover\\:to-gray-700:hover {\n    --gradient-to-color: #4a5568;\n  }\n\n  .lg\\:hover\\:to-gray-800:hover {\n    --gradient-to-color: #2d3748;\n  }\n\n  .lg\\:hover\\:to-gray-900:hover {\n    --gradient-to-color: #1a202c;\n  }\n\n  .lg\\:hover\\:to-red-100:hover {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .lg\\:hover\\:to-red-200:hover {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .lg\\:hover\\:to-red-300:hover {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .lg\\:hover\\:to-red-400:hover {\n    --gradient-to-color: #fc8181;\n  }\n\n  .lg\\:hover\\:to-red-500:hover {\n    --gradient-to-color: #f56565;\n  }\n\n  .lg\\:hover\\:to-red-600:hover {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .lg\\:hover\\:to-red-700:hover {\n    --gradient-to-color: #c53030;\n  }\n\n  .lg\\:hover\\:to-red-800:hover {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .lg\\:hover\\:to-red-900:hover {\n    --gradient-to-color: #742a2a;\n  }\n\n  .lg\\:hover\\:to-orange-100:hover {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .lg\\:hover\\:to-orange-200:hover {\n    --gradient-to-color: #feebc8;\n  }\n\n  .lg\\:hover\\:to-orange-300:hover {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .lg\\:hover\\:to-orange-400:hover {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .lg\\:hover\\:to-orange-500:hover {\n    --gradient-to-color: #ed8936;\n  }\n\n  .lg\\:hover\\:to-orange-600:hover {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .lg\\:hover\\:to-orange-700:hover {\n    --gradient-to-color: #c05621;\n  }\n\n  .lg\\:hover\\:to-orange-800:hover {\n    --gradient-to-color: #9c4221;\n  }\n\n  .lg\\:hover\\:to-orange-900:hover {\n    --gradient-to-color: #7b341e;\n  }\n\n  .lg\\:hover\\:to-yellow-100:hover {\n    --gradient-to-color: #fffff0;\n  }\n\n  .lg\\:hover\\:to-yellow-200:hover {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .lg\\:hover\\:to-yellow-300:hover {\n    --gradient-to-color: #faf089;\n  }\n\n  .lg\\:hover\\:to-yellow-400:hover {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .lg\\:hover\\:to-yellow-500:hover {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .lg\\:hover\\:to-yellow-600:hover {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .lg\\:hover\\:to-yellow-700:hover {\n    --gradient-to-color: #b7791f;\n  }\n\n  .lg\\:hover\\:to-yellow-800:hover {\n    --gradient-to-color: #975a16;\n  }\n\n  .lg\\:hover\\:to-yellow-900:hover {\n    --gradient-to-color: #744210;\n  }\n\n  .lg\\:hover\\:to-green-100:hover {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .lg\\:hover\\:to-green-200:hover {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .lg\\:hover\\:to-green-300:hover {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .lg\\:hover\\:to-green-400:hover {\n    --gradient-to-color: #68d391;\n  }\n\n  .lg\\:hover\\:to-green-500:hover {\n    --gradient-to-color: #48bb78;\n  }\n\n  .lg\\:hover\\:to-green-600:hover {\n    --gradient-to-color: #38a169;\n  }\n\n  .lg\\:hover\\:to-green-700:hover {\n    --gradient-to-color: #2f855a;\n  }\n\n  .lg\\:hover\\:to-green-800:hover {\n    --gradient-to-color: #276749;\n  }\n\n  .lg\\:hover\\:to-green-900:hover {\n    --gradient-to-color: #22543d;\n  }\n\n  .lg\\:hover\\:to-teal-100:hover {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .lg\\:hover\\:to-teal-200:hover {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .lg\\:hover\\:to-teal-300:hover {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .lg\\:hover\\:to-teal-400:hover {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .lg\\:hover\\:to-teal-500:hover {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .lg\\:hover\\:to-teal-600:hover {\n    --gradient-to-color: #319795;\n  }\n\n  .lg\\:hover\\:to-teal-700:hover {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .lg\\:hover\\:to-teal-800:hover {\n    --gradient-to-color: #285e61;\n  }\n\n  .lg\\:hover\\:to-teal-900:hover {\n    --gradient-to-color: #234e52;\n  }\n\n  .lg\\:hover\\:to-blue-100:hover {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .lg\\:hover\\:to-blue-200:hover {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .lg\\:hover\\:to-blue-300:hover {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .lg\\:hover\\:to-blue-400:hover {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .lg\\:hover\\:to-blue-500:hover {\n    --gradient-to-color: #4299e1;\n  }\n\n  .lg\\:hover\\:to-blue-600:hover {\n    --gradient-to-color: #3182ce;\n  }\n\n  .lg\\:hover\\:to-blue-700:hover {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .lg\\:hover\\:to-blue-800:hover {\n    --gradient-to-color: #2c5282;\n  }\n\n  .lg\\:hover\\:to-blue-900:hover {\n    --gradient-to-color: #2a4365;\n  }\n\n  .lg\\:hover\\:to-indigo-100:hover {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .lg\\:hover\\:to-indigo-200:hover {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .lg\\:hover\\:to-indigo-300:hover {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .lg\\:hover\\:to-indigo-400:hover {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .lg\\:hover\\:to-indigo-500:hover {\n    --gradient-to-color: #667eea;\n  }\n\n  .lg\\:hover\\:to-indigo-600:hover {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .lg\\:hover\\:to-indigo-700:hover {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .lg\\:hover\\:to-indigo-800:hover {\n    --gradient-to-color: #434190;\n  }\n\n  .lg\\:hover\\:to-indigo-900:hover {\n    --gradient-to-color: #3c366b;\n  }\n\n  .lg\\:hover\\:to-purple-100:hover {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .lg\\:hover\\:to-purple-200:hover {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .lg\\:hover\\:to-purple-300:hover {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .lg\\:hover\\:to-purple-400:hover {\n    --gradient-to-color: #b794f4;\n  }\n\n  .lg\\:hover\\:to-purple-500:hover {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .lg\\:hover\\:to-purple-600:hover {\n    --gradient-to-color: #805ad5;\n  }\n\n  .lg\\:hover\\:to-purple-700:hover {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .lg\\:hover\\:to-purple-800:hover {\n    --gradient-to-color: #553c9a;\n  }\n\n  .lg\\:hover\\:to-purple-900:hover {\n    --gradient-to-color: #44337a;\n  }\n\n  .lg\\:hover\\:to-pink-100:hover {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .lg\\:hover\\:to-pink-200:hover {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .lg\\:hover\\:to-pink-300:hover {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .lg\\:hover\\:to-pink-400:hover {\n    --gradient-to-color: #f687b3;\n  }\n\n  .lg\\:hover\\:to-pink-500:hover {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .lg\\:hover\\:to-pink-600:hover {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .lg\\:hover\\:to-pink-700:hover {\n    --gradient-to-color: #b83280;\n  }\n\n  .lg\\:hover\\:to-pink-800:hover {\n    --gradient-to-color: #97266d;\n  }\n\n  .lg\\:hover\\:to-pink-900:hover {\n    --gradient-to-color: #702459;\n  }\n\n  .lg\\:focus\\:from-transparent:focus {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:focus\\:from-current:focus {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:focus\\:from-black:focus {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:focus\\:from-white:focus {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:focus\\:from-gray-100:focus {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .lg\\:focus\\:from-gray-200:focus {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .lg\\:focus\\:from-gray-300:focus {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .lg\\:focus\\:from-gray-400:focus {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .lg\\:focus\\:from-gray-500:focus {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .lg\\:focus\\:from-gray-600:focus {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .lg\\:focus\\:from-gray-700:focus {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .lg\\:focus\\:from-gray-800:focus {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .lg\\:focus\\:from-gray-900:focus {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .lg\\:focus\\:from-red-100:focus {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .lg\\:focus\\:from-red-200:focus {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .lg\\:focus\\:from-red-300:focus {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .lg\\:focus\\:from-red-400:focus {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .lg\\:focus\\:from-red-500:focus {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .lg\\:focus\\:from-red-600:focus {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .lg\\:focus\\:from-red-700:focus {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .lg\\:focus\\:from-red-800:focus {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .lg\\:focus\\:from-red-900:focus {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .lg\\:focus\\:from-orange-100:focus {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .lg\\:focus\\:from-orange-200:focus {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .lg\\:focus\\:from-orange-300:focus {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .lg\\:focus\\:from-orange-400:focus {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .lg\\:focus\\:from-orange-500:focus {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .lg\\:focus\\:from-orange-600:focus {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .lg\\:focus\\:from-orange-700:focus {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .lg\\:focus\\:from-orange-800:focus {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .lg\\:focus\\:from-orange-900:focus {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-100:focus {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-200:focus {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-300:focus {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-400:focus {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-500:focus {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-600:focus {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-700:focus {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-800:focus {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .lg\\:focus\\:from-yellow-900:focus {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .lg\\:focus\\:from-green-100:focus {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .lg\\:focus\\:from-green-200:focus {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .lg\\:focus\\:from-green-300:focus {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .lg\\:focus\\:from-green-400:focus {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .lg\\:focus\\:from-green-500:focus {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .lg\\:focus\\:from-green-600:focus {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .lg\\:focus\\:from-green-700:focus {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .lg\\:focus\\:from-green-800:focus {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .lg\\:focus\\:from-green-900:focus {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .lg\\:focus\\:from-teal-100:focus {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .lg\\:focus\\:from-teal-200:focus {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .lg\\:focus\\:from-teal-300:focus {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .lg\\:focus\\:from-teal-400:focus {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .lg\\:focus\\:from-teal-500:focus {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .lg\\:focus\\:from-teal-600:focus {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .lg\\:focus\\:from-teal-700:focus {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .lg\\:focus\\:from-teal-800:focus {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .lg\\:focus\\:from-teal-900:focus {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .lg\\:focus\\:from-blue-100:focus {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .lg\\:focus\\:from-blue-200:focus {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .lg\\:focus\\:from-blue-300:focus {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .lg\\:focus\\:from-blue-400:focus {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .lg\\:focus\\:from-blue-500:focus {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .lg\\:focus\\:from-blue-600:focus {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .lg\\:focus\\:from-blue-700:focus {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .lg\\:focus\\:from-blue-800:focus {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .lg\\:focus\\:from-blue-900:focus {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-100:focus {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-200:focus {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-300:focus {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-400:focus {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-500:focus {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-600:focus {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-700:focus {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-800:focus {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .lg\\:focus\\:from-indigo-900:focus {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .lg\\:focus\\:from-purple-100:focus {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .lg\\:focus\\:from-purple-200:focus {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .lg\\:focus\\:from-purple-300:focus {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .lg\\:focus\\:from-purple-400:focus {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .lg\\:focus\\:from-purple-500:focus {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .lg\\:focus\\:from-purple-600:focus {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .lg\\:focus\\:from-purple-700:focus {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .lg\\:focus\\:from-purple-800:focus {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .lg\\:focus\\:from-purple-900:focus {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .lg\\:focus\\:from-pink-100:focus {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .lg\\:focus\\:from-pink-200:focus {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .lg\\:focus\\:from-pink-300:focus {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .lg\\:focus\\:from-pink-400:focus {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .lg\\:focus\\:from-pink-500:focus {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .lg\\:focus\\:from-pink-600:focus {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .lg\\:focus\\:from-pink-700:focus {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .lg\\:focus\\:from-pink-800:focus {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .lg\\:focus\\:from-pink-900:focus {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .lg\\:focus\\:via-transparent:focus {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:focus\\:via-current:focus {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:focus\\:via-black:focus {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .lg\\:focus\\:via-white:focus {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .lg\\:focus\\:via-gray-100:focus {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .lg\\:focus\\:via-gray-200:focus {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .lg\\:focus\\:via-gray-300:focus {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .lg\\:focus\\:via-gray-400:focus {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .lg\\:focus\\:via-gray-500:focus {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .lg\\:focus\\:via-gray-600:focus {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .lg\\:focus\\:via-gray-700:focus {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .lg\\:focus\\:via-gray-800:focus {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .lg\\:focus\\:via-gray-900:focus {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .lg\\:focus\\:via-red-100:focus {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .lg\\:focus\\:via-red-200:focus {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .lg\\:focus\\:via-red-300:focus {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .lg\\:focus\\:via-red-400:focus {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .lg\\:focus\\:via-red-500:focus {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .lg\\:focus\\:via-red-600:focus {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .lg\\:focus\\:via-red-700:focus {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .lg\\:focus\\:via-red-800:focus {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .lg\\:focus\\:via-red-900:focus {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .lg\\:focus\\:via-orange-100:focus {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .lg\\:focus\\:via-orange-200:focus {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .lg\\:focus\\:via-orange-300:focus {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .lg\\:focus\\:via-orange-400:focus {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .lg\\:focus\\:via-orange-500:focus {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .lg\\:focus\\:via-orange-600:focus {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .lg\\:focus\\:via-orange-700:focus {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .lg\\:focus\\:via-orange-800:focus {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .lg\\:focus\\:via-orange-900:focus {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-100:focus {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-200:focus {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-300:focus {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-400:focus {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-500:focus {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-600:focus {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-700:focus {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-800:focus {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .lg\\:focus\\:via-yellow-900:focus {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .lg\\:focus\\:via-green-100:focus {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .lg\\:focus\\:via-green-200:focus {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .lg\\:focus\\:via-green-300:focus {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .lg\\:focus\\:via-green-400:focus {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .lg\\:focus\\:via-green-500:focus {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .lg\\:focus\\:via-green-600:focus {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .lg\\:focus\\:via-green-700:focus {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .lg\\:focus\\:via-green-800:focus {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .lg\\:focus\\:via-green-900:focus {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .lg\\:focus\\:via-teal-100:focus {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .lg\\:focus\\:via-teal-200:focus {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .lg\\:focus\\:via-teal-300:focus {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .lg\\:focus\\:via-teal-400:focus {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .lg\\:focus\\:via-teal-500:focus {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .lg\\:focus\\:via-teal-600:focus {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .lg\\:focus\\:via-teal-700:focus {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .lg\\:focus\\:via-teal-800:focus {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .lg\\:focus\\:via-teal-900:focus {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .lg\\:focus\\:via-blue-100:focus {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .lg\\:focus\\:via-blue-200:focus {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .lg\\:focus\\:via-blue-300:focus {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .lg\\:focus\\:via-blue-400:focus {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .lg\\:focus\\:via-blue-500:focus {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .lg\\:focus\\:via-blue-600:focus {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .lg\\:focus\\:via-blue-700:focus {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .lg\\:focus\\:via-blue-800:focus {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .lg\\:focus\\:via-blue-900:focus {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-100:focus {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-200:focus {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-300:focus {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-400:focus {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-500:focus {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-600:focus {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-700:focus {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-800:focus {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .lg\\:focus\\:via-indigo-900:focus {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .lg\\:focus\\:via-purple-100:focus {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .lg\\:focus\\:via-purple-200:focus {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .lg\\:focus\\:via-purple-300:focus {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .lg\\:focus\\:via-purple-400:focus {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .lg\\:focus\\:via-purple-500:focus {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .lg\\:focus\\:via-purple-600:focus {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .lg\\:focus\\:via-purple-700:focus {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .lg\\:focus\\:via-purple-800:focus {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .lg\\:focus\\:via-purple-900:focus {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .lg\\:focus\\:via-pink-100:focus {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .lg\\:focus\\:via-pink-200:focus {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .lg\\:focus\\:via-pink-300:focus {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .lg\\:focus\\:via-pink-400:focus {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .lg\\:focus\\:via-pink-500:focus {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .lg\\:focus\\:via-pink-600:focus {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .lg\\:focus\\:via-pink-700:focus {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .lg\\:focus\\:via-pink-800:focus {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .lg\\:focus\\:via-pink-900:focus {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .lg\\:focus\\:to-transparent:focus {\n    --gradient-to-color: transparent;\n  }\n\n  .lg\\:focus\\:to-current:focus {\n    --gradient-to-color: currentColor;\n  }\n\n  .lg\\:focus\\:to-black:focus {\n    --gradient-to-color: #000;\n  }\n\n  .lg\\:focus\\:to-white:focus {\n    --gradient-to-color: #fff;\n  }\n\n  .lg\\:focus\\:to-gray-100:focus {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .lg\\:focus\\:to-gray-200:focus {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .lg\\:focus\\:to-gray-300:focus {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .lg\\:focus\\:to-gray-400:focus {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .lg\\:focus\\:to-gray-500:focus {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .lg\\:focus\\:to-gray-600:focus {\n    --gradient-to-color: #718096;\n  }\n\n  .lg\\:focus\\:to-gray-700:focus {\n    --gradient-to-color: #4a5568;\n  }\n\n  .lg\\:focus\\:to-gray-800:focus {\n    --gradient-to-color: #2d3748;\n  }\n\n  .lg\\:focus\\:to-gray-900:focus {\n    --gradient-to-color: #1a202c;\n  }\n\n  .lg\\:focus\\:to-red-100:focus {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .lg\\:focus\\:to-red-200:focus {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .lg\\:focus\\:to-red-300:focus {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .lg\\:focus\\:to-red-400:focus {\n    --gradient-to-color: #fc8181;\n  }\n\n  .lg\\:focus\\:to-red-500:focus {\n    --gradient-to-color: #f56565;\n  }\n\n  .lg\\:focus\\:to-red-600:focus {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .lg\\:focus\\:to-red-700:focus {\n    --gradient-to-color: #c53030;\n  }\n\n  .lg\\:focus\\:to-red-800:focus {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .lg\\:focus\\:to-red-900:focus {\n    --gradient-to-color: #742a2a;\n  }\n\n  .lg\\:focus\\:to-orange-100:focus {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .lg\\:focus\\:to-orange-200:focus {\n    --gradient-to-color: #feebc8;\n  }\n\n  .lg\\:focus\\:to-orange-300:focus {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .lg\\:focus\\:to-orange-400:focus {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .lg\\:focus\\:to-orange-500:focus {\n    --gradient-to-color: #ed8936;\n  }\n\n  .lg\\:focus\\:to-orange-600:focus {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .lg\\:focus\\:to-orange-700:focus {\n    --gradient-to-color: #c05621;\n  }\n\n  .lg\\:focus\\:to-orange-800:focus {\n    --gradient-to-color: #9c4221;\n  }\n\n  .lg\\:focus\\:to-orange-900:focus {\n    --gradient-to-color: #7b341e;\n  }\n\n  .lg\\:focus\\:to-yellow-100:focus {\n    --gradient-to-color: #fffff0;\n  }\n\n  .lg\\:focus\\:to-yellow-200:focus {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .lg\\:focus\\:to-yellow-300:focus {\n    --gradient-to-color: #faf089;\n  }\n\n  .lg\\:focus\\:to-yellow-400:focus {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .lg\\:focus\\:to-yellow-500:focus {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .lg\\:focus\\:to-yellow-600:focus {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .lg\\:focus\\:to-yellow-700:focus {\n    --gradient-to-color: #b7791f;\n  }\n\n  .lg\\:focus\\:to-yellow-800:focus {\n    --gradient-to-color: #975a16;\n  }\n\n  .lg\\:focus\\:to-yellow-900:focus {\n    --gradient-to-color: #744210;\n  }\n\n  .lg\\:focus\\:to-green-100:focus {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .lg\\:focus\\:to-green-200:focus {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .lg\\:focus\\:to-green-300:focus {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .lg\\:focus\\:to-green-400:focus {\n    --gradient-to-color: #68d391;\n  }\n\n  .lg\\:focus\\:to-green-500:focus {\n    --gradient-to-color: #48bb78;\n  }\n\n  .lg\\:focus\\:to-green-600:focus {\n    --gradient-to-color: #38a169;\n  }\n\n  .lg\\:focus\\:to-green-700:focus {\n    --gradient-to-color: #2f855a;\n  }\n\n  .lg\\:focus\\:to-green-800:focus {\n    --gradient-to-color: #276749;\n  }\n\n  .lg\\:focus\\:to-green-900:focus {\n    --gradient-to-color: #22543d;\n  }\n\n  .lg\\:focus\\:to-teal-100:focus {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .lg\\:focus\\:to-teal-200:focus {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .lg\\:focus\\:to-teal-300:focus {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .lg\\:focus\\:to-teal-400:focus {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .lg\\:focus\\:to-teal-500:focus {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .lg\\:focus\\:to-teal-600:focus {\n    --gradient-to-color: #319795;\n  }\n\n  .lg\\:focus\\:to-teal-700:focus {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .lg\\:focus\\:to-teal-800:focus {\n    --gradient-to-color: #285e61;\n  }\n\n  .lg\\:focus\\:to-teal-900:focus {\n    --gradient-to-color: #234e52;\n  }\n\n  .lg\\:focus\\:to-blue-100:focus {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .lg\\:focus\\:to-blue-200:focus {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .lg\\:focus\\:to-blue-300:focus {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .lg\\:focus\\:to-blue-400:focus {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .lg\\:focus\\:to-blue-500:focus {\n    --gradient-to-color: #4299e1;\n  }\n\n  .lg\\:focus\\:to-blue-600:focus {\n    --gradient-to-color: #3182ce;\n  }\n\n  .lg\\:focus\\:to-blue-700:focus {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .lg\\:focus\\:to-blue-800:focus {\n    --gradient-to-color: #2c5282;\n  }\n\n  .lg\\:focus\\:to-blue-900:focus {\n    --gradient-to-color: #2a4365;\n  }\n\n  .lg\\:focus\\:to-indigo-100:focus {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .lg\\:focus\\:to-indigo-200:focus {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .lg\\:focus\\:to-indigo-300:focus {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .lg\\:focus\\:to-indigo-400:focus {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .lg\\:focus\\:to-indigo-500:focus {\n    --gradient-to-color: #667eea;\n  }\n\n  .lg\\:focus\\:to-indigo-600:focus {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .lg\\:focus\\:to-indigo-700:focus {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .lg\\:focus\\:to-indigo-800:focus {\n    --gradient-to-color: #434190;\n  }\n\n  .lg\\:focus\\:to-indigo-900:focus {\n    --gradient-to-color: #3c366b;\n  }\n\n  .lg\\:focus\\:to-purple-100:focus {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .lg\\:focus\\:to-purple-200:focus {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .lg\\:focus\\:to-purple-300:focus {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .lg\\:focus\\:to-purple-400:focus {\n    --gradient-to-color: #b794f4;\n  }\n\n  .lg\\:focus\\:to-purple-500:focus {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .lg\\:focus\\:to-purple-600:focus {\n    --gradient-to-color: #805ad5;\n  }\n\n  .lg\\:focus\\:to-purple-700:focus {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .lg\\:focus\\:to-purple-800:focus {\n    --gradient-to-color: #553c9a;\n  }\n\n  .lg\\:focus\\:to-purple-900:focus {\n    --gradient-to-color: #44337a;\n  }\n\n  .lg\\:focus\\:to-pink-100:focus {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .lg\\:focus\\:to-pink-200:focus {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .lg\\:focus\\:to-pink-300:focus {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .lg\\:focus\\:to-pink-400:focus {\n    --gradient-to-color: #f687b3;\n  }\n\n  .lg\\:focus\\:to-pink-500:focus {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .lg\\:focus\\:to-pink-600:focus {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .lg\\:focus\\:to-pink-700:focus {\n    --gradient-to-color: #b83280;\n  }\n\n  .lg\\:focus\\:to-pink-800:focus {\n    --gradient-to-color: #97266d;\n  }\n\n  .lg\\:focus\\:to-pink-900:focus {\n    --gradient-to-color: #702459;\n  }\n\n  .lg\\:bg-opacity-0 {\n    --bg-opacity: 0;\n  }\n\n  .lg\\:bg-opacity-25 {\n    --bg-opacity: 0.25;\n  }\n\n  .lg\\:bg-opacity-50 {\n    --bg-opacity: 0.5;\n  }\n\n  .lg\\:bg-opacity-75 {\n    --bg-opacity: 0.75;\n  }\n\n  .lg\\:bg-opacity-100 {\n    --bg-opacity: 1;\n  }\n\n  .lg\\:hover\\:bg-opacity-0:hover {\n    --bg-opacity: 0;\n  }\n\n  .lg\\:hover\\:bg-opacity-25:hover {\n    --bg-opacity: 0.25;\n  }\n\n  .lg\\:hover\\:bg-opacity-50:hover {\n    --bg-opacity: 0.5;\n  }\n\n  .lg\\:hover\\:bg-opacity-75:hover {\n    --bg-opacity: 0.75;\n  }\n\n  .lg\\:hover\\:bg-opacity-100:hover {\n    --bg-opacity: 1;\n  }\n\n  .lg\\:focus\\:bg-opacity-0:focus {\n    --bg-opacity: 0;\n  }\n\n  .lg\\:focus\\:bg-opacity-25:focus {\n    --bg-opacity: 0.25;\n  }\n\n  .lg\\:focus\\:bg-opacity-50:focus {\n    --bg-opacity: 0.5;\n  }\n\n  .lg\\:focus\\:bg-opacity-75:focus {\n    --bg-opacity: 0.75;\n  }\n\n  .lg\\:focus\\:bg-opacity-100:focus {\n    --bg-opacity: 1;\n  }\n\n  .lg\\:bg-bottom {\n    background-position: bottom;\n  }\n\n  .lg\\:bg-center {\n    background-position: center;\n  }\n\n  .lg\\:bg-left {\n    background-position: left;\n  }\n\n  .lg\\:bg-left-bottom {\n    background-position: left bottom;\n  }\n\n  .lg\\:bg-left-top {\n    background-position: left top;\n  }\n\n  .lg\\:bg-right {\n    background-position: right;\n  }\n\n  .lg\\:bg-right-bottom {\n    background-position: right bottom;\n  }\n\n  .lg\\:bg-right-top {\n    background-position: right top;\n  }\n\n  .lg\\:bg-top {\n    background-position: top;\n  }\n\n  .lg\\:bg-repeat {\n    background-repeat: repeat;\n  }\n\n  .lg\\:bg-no-repeat {\n    background-repeat: no-repeat;\n  }\n\n  .lg\\:bg-repeat-x {\n    background-repeat: repeat-x;\n  }\n\n  .lg\\:bg-repeat-y {\n    background-repeat: repeat-y;\n  }\n\n  .lg\\:bg-repeat-round {\n    background-repeat: round;\n  }\n\n  .lg\\:bg-repeat-space {\n    background-repeat: space;\n  }\n\n  .lg\\:bg-auto {\n    background-size: auto;\n  }\n\n  .lg\\:bg-cover {\n    background-size: cover;\n  }\n\n  .lg\\:bg-contain {\n    background-size: contain;\n  }\n\n  .lg\\:border-collapse {\n    border-collapse: collapse;\n  }\n\n  .lg\\:border-separate {\n    border-collapse: separate;\n  }\n\n  .lg\\:border-transparent {\n    border-color: transparent;\n  }\n\n  .lg\\:border-current {\n    border-color: currentColor;\n  }\n\n  .lg\\:border-black {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .lg\\:border-white {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .lg\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .lg\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .lg\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .lg\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .lg\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .lg\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .lg\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .lg\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .lg\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .lg\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .lg\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .lg\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .lg\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .lg\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .lg\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .lg\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .lg\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .lg\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .lg\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .lg\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .lg\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .lg\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .lg\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .lg\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .lg\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .lg\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n  }\n\n  .lg\\:hover\\:border-current:hover {\n    border-color: currentColor;\n  }\n\n  .lg\\:hover\\:border-black:hover {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-white:hover {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-100:hover {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-200:hover {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-300:hover {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-400:hover {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-500:hover {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-600:hover {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-700:hover {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-800:hover {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-red-900:hover {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-100:hover {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-200:hover {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-300:hover {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-400:hover {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-500:hover {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-600:hover {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-700:hover {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-800:hover {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-orange-900:hover {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-100:hover {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-200:hover {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-300:hover {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-400:hover {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-500:hover {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-600:hover {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-700:hover {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-800:hover {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-yellow-900:hover {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-100:hover {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-200:hover {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-300:hover {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-400:hover {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-500:hover {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-600:hover {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-700:hover {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-800:hover {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-green-900:hover {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-100:hover {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-200:hover {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-300:hover {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-400:hover {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-500:hover {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-600:hover {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-700:hover {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-800:hover {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-teal-900:hover {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-100:hover {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-200:hover {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-300:hover {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-400:hover {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-500:hover {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-600:hover {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-700:hover {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-800:hover {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-blue-900:hover {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-100:hover {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-200:hover {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-300:hover {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-400:hover {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-500:hover {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-600:hover {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-700:hover {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-800:hover {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-indigo-900:hover {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-100:hover {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-200:hover {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-300:hover {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-400:hover {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-500:hover {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-600:hover {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-700:hover {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-800:hover {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-purple-900:hover {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-100:hover {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-200:hover {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-300:hover {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-400:hover {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-500:hover {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-600:hover {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-700:hover {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-800:hover {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .lg\\:hover\\:border-pink-900:hover {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-transparent:focus {\n    border-color: transparent;\n  }\n\n  .lg\\:focus\\:border-current:focus {\n    border-color: currentColor;\n  }\n\n  .lg\\:focus\\:border-black:focus {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-white:focus {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-100:focus {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-200:focus {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-300:focus {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-400:focus {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-500:focus {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-600:focus {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-700:focus {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-800:focus {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-red-900:focus {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-100:focus {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-200:focus {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-300:focus {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-400:focus {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-500:focus {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-600:focus {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-700:focus {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-800:focus {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-orange-900:focus {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-100:focus {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-200:focus {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-300:focus {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-400:focus {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-500:focus {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-600:focus {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-700:focus {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-800:focus {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-yellow-900:focus {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-100:focus {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-200:focus {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-300:focus {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-400:focus {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-500:focus {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-600:focus {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-700:focus {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-800:focus {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-green-900:focus {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-100:focus {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-200:focus {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-300:focus {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-400:focus {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-500:focus {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-600:focus {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-700:focus {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-800:focus {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-teal-900:focus {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-100:focus {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-200:focus {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-300:focus {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-400:focus {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-500:focus {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-600:focus {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-700:focus {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-800:focus {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-blue-900:focus {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-100:focus {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-200:focus {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-300:focus {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-400:focus {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-500:focus {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-600:focus {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-700:focus {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-800:focus {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-indigo-900:focus {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-100:focus {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-200:focus {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-300:focus {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-400:focus {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-500:focus {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-600:focus {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-700:focus {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-800:focus {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-purple-900:focus {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-100:focus {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-200:focus {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-300:focus {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-400:focus {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-500:focus {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-600:focus {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-700:focus {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-800:focus {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .lg\\:focus\\:border-pink-900:focus {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .lg\\:border-opacity-0 {\n    --border-opacity: 0;\n  }\n\n  .lg\\:border-opacity-25 {\n    --border-opacity: 0.25;\n  }\n\n  .lg\\:border-opacity-50 {\n    --border-opacity: 0.5;\n  }\n\n  .lg\\:border-opacity-75 {\n    --border-opacity: 0.75;\n  }\n\n  .lg\\:border-opacity-100 {\n    --border-opacity: 1;\n  }\n\n  .lg\\:hover\\:border-opacity-0:hover {\n    --border-opacity: 0;\n  }\n\n  .lg\\:hover\\:border-opacity-25:hover {\n    --border-opacity: 0.25;\n  }\n\n  .lg\\:hover\\:border-opacity-50:hover {\n    --border-opacity: 0.5;\n  }\n\n  .lg\\:hover\\:border-opacity-75:hover {\n    --border-opacity: 0.75;\n  }\n\n  .lg\\:hover\\:border-opacity-100:hover {\n    --border-opacity: 1;\n  }\n\n  .lg\\:focus\\:border-opacity-0:focus {\n    --border-opacity: 0;\n  }\n\n  .lg\\:focus\\:border-opacity-25:focus {\n    --border-opacity: 0.25;\n  }\n\n  .lg\\:focus\\:border-opacity-50:focus {\n    --border-opacity: 0.5;\n  }\n\n  .lg\\:focus\\:border-opacity-75:focus {\n    --border-opacity: 0.75;\n  }\n\n  .lg\\:focus\\:border-opacity-100:focus {\n    --border-opacity: 1;\n  }\n\n  .lg\\:rounded-none {\n    border-radius: 0;\n  }\n\n  .lg\\:rounded-sm {\n    border-radius: 0.125rem;\n  }\n\n  .lg\\:rounded {\n    border-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-md {\n    border-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-2xl {\n    border-radius: 1rem;\n  }\n\n  .lg\\:rounded-3xl {\n    border-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-full {\n    border-radius: 9999px;\n  }\n\n  .lg\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .lg\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .lg\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .lg\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .lg\\:rounded-t-sm {\n    border-top-left-radius: 0.125rem;\n    border-top-right-radius: 0.125rem;\n  }\n\n  .lg\\:rounded-r-sm {\n    border-top-right-radius: 0.125rem;\n    border-bottom-right-radius: 0.125rem;\n  }\n\n  .lg\\:rounded-b-sm {\n    border-bottom-right-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .lg\\:rounded-l-sm {\n    border-top-left-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .lg\\:rounded-t {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-r {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-b {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-l {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-b-md {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-b-lg {\n    border-bottom-right-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-t-xl {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-r-xl {\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-b-xl {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-l-xl {\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-t-2xl {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n\n  .lg\\:rounded-r-2xl {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n\n  .lg\\:rounded-b-2xl {\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .lg\\:rounded-l-2xl {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .lg\\:rounded-t-3xl {\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-r-3xl {\n    border-top-right-radius: 1.5rem;\n    border-bottom-right-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-b-3xl {\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-l-3xl {\n    border-top-left-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n  }\n\n  .lg\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n  }\n\n  .lg\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n\n  .lg\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n\n  .lg\\:rounded-tl-none {\n    border-top-left-radius: 0;\n  }\n\n  .lg\\:rounded-tr-none {\n    border-top-right-radius: 0;\n  }\n\n  .lg\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n  }\n\n  .lg\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n  }\n\n  .lg\\:rounded-tl-sm {\n    border-top-left-radius: 0.125rem;\n  }\n\n  .lg\\:rounded-tr-sm {\n    border-top-right-radius: 0.125rem;\n  }\n\n  .lg\\:rounded-br-sm {\n    border-bottom-right-radius: 0.125rem;\n  }\n\n  .lg\\:rounded-bl-sm {\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .lg\\:rounded-tl {\n    border-top-left-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-tr {\n    border-top-right-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-br {\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-bl {\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .lg\\:rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .lg\\:rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .lg\\:rounded-tl-xl {\n    border-top-left-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-tr-xl {\n    border-top-right-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-br-xl {\n    border-bottom-right-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-bl-xl {\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .lg\\:rounded-tl-2xl {\n    border-top-left-radius: 1rem;\n  }\n\n  .lg\\:rounded-tr-2xl {\n    border-top-right-radius: 1rem;\n  }\n\n  .lg\\:rounded-br-2xl {\n    border-bottom-right-radius: 1rem;\n  }\n\n  .lg\\:rounded-bl-2xl {\n    border-bottom-left-radius: 1rem;\n  }\n\n  .lg\\:rounded-tl-3xl {\n    border-top-left-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-tr-3xl {\n    border-top-right-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-br-3xl {\n    border-bottom-right-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-bl-3xl {\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .lg\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n  }\n\n  .lg\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n  }\n\n  .lg\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n  }\n\n  .lg\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n  }\n\n  .lg\\:border-solid {\n    border-style: solid;\n  }\n\n  .lg\\:border-dashed {\n    border-style: dashed;\n  }\n\n  .lg\\:border-dotted {\n    border-style: dotted;\n  }\n\n  .lg\\:border-double {\n    border-style: double;\n  }\n\n  .lg\\:border-none {\n    border-style: none;\n  }\n\n  .lg\\:border-0 {\n    border-width: 0;\n  }\n\n  .lg\\:border-2 {\n    border-width: 2px;\n  }\n\n  .lg\\:border-4 {\n    border-width: 4px;\n  }\n\n  .lg\\:border-8 {\n    border-width: 8px;\n  }\n\n  .lg\\:border {\n    border-width: 1px;\n  }\n\n  .lg\\:border-t-0 {\n    border-top-width: 0;\n  }\n\n  .lg\\:border-r-0 {\n    border-right-width: 0;\n  }\n\n  .lg\\:border-b-0 {\n    border-bottom-width: 0;\n  }\n\n  .lg\\:border-l-0 {\n    border-left-width: 0;\n  }\n\n  .lg\\:border-t-2 {\n    border-top-width: 2px;\n  }\n\n  .lg\\:border-r-2 {\n    border-right-width: 2px;\n  }\n\n  .lg\\:border-b-2 {\n    border-bottom-width: 2px;\n  }\n\n  .lg\\:border-l-2 {\n    border-left-width: 2px;\n  }\n\n  .lg\\:border-t-4 {\n    border-top-width: 4px;\n  }\n\n  .lg\\:border-r-4 {\n    border-right-width: 4px;\n  }\n\n  .lg\\:border-b-4 {\n    border-bottom-width: 4px;\n  }\n\n  .lg\\:border-l-4 {\n    border-left-width: 4px;\n  }\n\n  .lg\\:border-t-8 {\n    border-top-width: 8px;\n  }\n\n  .lg\\:border-r-8 {\n    border-right-width: 8px;\n  }\n\n  .lg\\:border-b-8 {\n    border-bottom-width: 8px;\n  }\n\n  .lg\\:border-l-8 {\n    border-left-width: 8px;\n  }\n\n  .lg\\:border-t {\n    border-top-width: 1px;\n  }\n\n  .lg\\:border-r {\n    border-right-width: 1px;\n  }\n\n  .lg\\:border-b {\n    border-bottom-width: 1px;\n  }\n\n  .lg\\:border-l {\n    border-left-width: 1px;\n  }\n\n  .lg\\:box-border {\n    box-sizing: border-box;\n  }\n\n  .lg\\:box-content {\n    box-sizing: content-box;\n  }\n\n  .lg\\:cursor-auto {\n    cursor: auto;\n  }\n\n  .lg\\:cursor-default {\n    cursor: default;\n  }\n\n  .lg\\:cursor-pointer {\n    cursor: pointer;\n  }\n\n  .lg\\:cursor-wait {\n    cursor: wait;\n  }\n\n  .lg\\:cursor-text {\n    cursor: text;\n  }\n\n  .lg\\:cursor-move {\n    cursor: move;\n  }\n\n  .lg\\:cursor-not-allowed {\n    cursor: not-allowed;\n  }\n\n  .lg\\:block {\n    display: block;\n  }\n\n  .lg\\:inline-block {\n    display: inline-block;\n  }\n\n  .lg\\:inline {\n    display: inline;\n  }\n\n  .lg\\:flex {\n    display: flex;\n  }\n\n  .lg\\:inline-flex {\n    display: inline-flex;\n  }\n\n  .lg\\:table {\n    display: table;\n  }\n\n  .lg\\:table-caption {\n    display: table-caption;\n  }\n\n  .lg\\:table-cell {\n    display: table-cell;\n  }\n\n  .lg\\:table-column {\n    display: table-column;\n  }\n\n  .lg\\:table-column-group {\n    display: table-column-group;\n  }\n\n  .lg\\:table-footer-group {\n    display: table-footer-group;\n  }\n\n  .lg\\:table-header-group {\n    display: table-header-group;\n  }\n\n  .lg\\:table-row-group {\n    display: table-row-group;\n  }\n\n  .lg\\:table-row {\n    display: table-row;\n  }\n\n  .lg\\:flow-root {\n    display: flow-root;\n  }\n\n  .lg\\:grid {\n    display: grid;\n  }\n\n  .lg\\:inline-grid {\n    display: inline-grid;\n  }\n\n  .lg\\:contents {\n    display: contents;\n  }\n\n  .lg\\:hidden {\n    display: none;\n  }\n\n  .lg\\:flex-row {\n    flex-direction: row;\n  }\n\n  .lg\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n\n  .lg\\:flex-col {\n    flex-direction: column;\n  }\n\n  .lg\\:flex-col-reverse {\n    flex-direction: column-reverse;\n  }\n\n  .lg\\:flex-wrap {\n    flex-wrap: wrap;\n  }\n\n  .lg\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n  }\n\n  .lg\\:flex-no-wrap {\n    flex-wrap: nowrap;\n  }\n\n  .lg\\:place-items-auto {\n    place-items: auto;\n  }\n\n  .lg\\:place-items-start {\n    place-items: start;\n  }\n\n  .lg\\:place-items-end {\n    place-items: end;\n  }\n\n  .lg\\:place-items-center {\n    place-items: center;\n  }\n\n  .lg\\:place-items-stretch {\n    place-items: stretch;\n  }\n\n  .lg\\:place-content-center {\n    place-content: center;\n  }\n\n  .lg\\:place-content-start {\n    place-content: start;\n  }\n\n  .lg\\:place-content-end {\n    place-content: end;\n  }\n\n  .lg\\:place-content-between {\n    place-content: space-between;\n  }\n\n  .lg\\:place-content-around {\n    place-content: space-around;\n  }\n\n  .lg\\:place-content-evenly {\n    place-content: space-evenly;\n  }\n\n  .lg\\:place-content-stretch {\n    place-content: stretch;\n  }\n\n  .lg\\:place-self-auto {\n    place-self: auto;\n  }\n\n  .lg\\:place-self-start {\n    place-self: start;\n  }\n\n  .lg\\:place-self-end {\n    place-self: end;\n  }\n\n  .lg\\:place-self-center {\n    place-self: center;\n  }\n\n  .lg\\:place-self-stretch {\n    place-self: stretch;\n  }\n\n  .lg\\:items-start {\n    align-items: flex-start;\n  }\n\n  .lg\\:items-end {\n    align-items: flex-end;\n  }\n\n  .lg\\:items-center {\n    align-items: center;\n  }\n\n  .lg\\:items-baseline {\n    align-items: baseline;\n  }\n\n  .lg\\:items-stretch {\n    align-items: stretch;\n  }\n\n  .lg\\:content-center {\n    align-content: center;\n  }\n\n  .lg\\:content-start {\n    align-content: flex-start;\n  }\n\n  .lg\\:content-end {\n    align-content: flex-end;\n  }\n\n  .lg\\:content-between {\n    align-content: space-between;\n  }\n\n  .lg\\:content-around {\n    align-content: space-around;\n  }\n\n  .lg\\:content-evenly {\n    align-content: space-evenly;\n  }\n\n  .lg\\:self-auto {\n    align-self: auto;\n  }\n\n  .lg\\:self-start {\n    align-self: flex-start;\n  }\n\n  .lg\\:self-end {\n    align-self: flex-end;\n  }\n\n  .lg\\:self-center {\n    align-self: center;\n  }\n\n  .lg\\:self-stretch {\n    align-self: stretch;\n  }\n\n  .lg\\:justify-items-auto {\n    justify-items: auto;\n  }\n\n  .lg\\:justify-items-start {\n    justify-items: start;\n  }\n\n  .lg\\:justify-items-end {\n    justify-items: end;\n  }\n\n  .lg\\:justify-items-center {\n    justify-items: center;\n  }\n\n  .lg\\:justify-items-stretch {\n    justify-items: stretch;\n  }\n\n  .lg\\:justify-start {\n    justify-content: flex-start;\n  }\n\n  .lg\\:justify-end {\n    justify-content: flex-end;\n  }\n\n  .lg\\:justify-center {\n    justify-content: center;\n  }\n\n  .lg\\:justify-between {\n    justify-content: space-between;\n  }\n\n  .lg\\:justify-around {\n    justify-content: space-around;\n  }\n\n  .lg\\:justify-evenly {\n    justify-content: space-evenly;\n  }\n\n  .lg\\:justify-self-auto {\n    justify-self: auto;\n  }\n\n  .lg\\:justify-self-start {\n    justify-self: start;\n  }\n\n  .lg\\:justify-self-end {\n    justify-self: end;\n  }\n\n  .lg\\:justify-self-center {\n    justify-self: center;\n  }\n\n  .lg\\:justify-self-stretch {\n    justify-self: stretch;\n  }\n\n  .lg\\:flex-1 {\n    flex: 1 1 0%;\n  }\n\n  .lg\\:flex-auto {\n    flex: 1 1 auto;\n  }\n\n  .lg\\:flex-initial {\n    flex: 0 1 auto;\n  }\n\n  .lg\\:flex-none {\n    flex: none;\n  }\n\n  .lg\\:flex-grow-0 {\n    flex-grow: 0;\n  }\n\n  .lg\\:flex-grow {\n    flex-grow: 1;\n  }\n\n  .lg\\:flex-shrink-0 {\n    flex-shrink: 0;\n  }\n\n  .lg\\:flex-shrink {\n    flex-shrink: 1;\n  }\n\n  .lg\\:order-1 {\n    order: 1;\n  }\n\n  .lg\\:order-2 {\n    order: 2;\n  }\n\n  .lg\\:order-3 {\n    order: 3;\n  }\n\n  .lg\\:order-4 {\n    order: 4;\n  }\n\n  .lg\\:order-5 {\n    order: 5;\n  }\n\n  .lg\\:order-6 {\n    order: 6;\n  }\n\n  .lg\\:order-7 {\n    order: 7;\n  }\n\n  .lg\\:order-8 {\n    order: 8;\n  }\n\n  .lg\\:order-9 {\n    order: 9;\n  }\n\n  .lg\\:order-10 {\n    order: 10;\n  }\n\n  .lg\\:order-11 {\n    order: 11;\n  }\n\n  .lg\\:order-12 {\n    order: 12;\n  }\n\n  .lg\\:order-first {\n    order: -9999;\n  }\n\n  .lg\\:order-last {\n    order: 9999;\n  }\n\n  .lg\\:order-none {\n    order: 0;\n  }\n\n  .lg\\:float-right {\n    float: right;\n  }\n\n  .lg\\:float-left {\n    float: left;\n  }\n\n  .lg\\:float-none {\n    float: none;\n  }\n\n  .lg\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  .lg\\:clear-left {\n    clear: left;\n  }\n\n  .lg\\:clear-right {\n    clear: right;\n  }\n\n  .lg\\:clear-both {\n    clear: both;\n  }\n\n  .lg\\:clear-none {\n    clear: none;\n  }\n\n  .lg\\:font-sans {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  }\n\n  .lg\\:font-serif {\n    font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n  }\n\n  .lg\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  }\n\n  .lg\\:font-hairline {\n    font-weight: 100;\n  }\n\n  .lg\\:font-thin {\n    font-weight: 200;\n  }\n\n  .lg\\:font-light {\n    font-weight: 300;\n  }\n\n  .lg\\:font-normal {\n    font-weight: 400;\n  }\n\n  .lg\\:font-medium {\n    font-weight: 500;\n  }\n\n  .lg\\:font-semibold {\n    font-weight: 600;\n  }\n\n  .lg\\:font-bold {\n    font-weight: 700;\n  }\n\n  .lg\\:font-extrabold {\n    font-weight: 800;\n  }\n\n  .lg\\:font-black {\n    font-weight: 900;\n  }\n\n  .lg\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n  }\n\n  .lg\\:hover\\:font-thin:hover {\n    font-weight: 200;\n  }\n\n  .lg\\:hover\\:font-light:hover {\n    font-weight: 300;\n  }\n\n  .lg\\:hover\\:font-normal:hover {\n    font-weight: 400;\n  }\n\n  .lg\\:hover\\:font-medium:hover {\n    font-weight: 500;\n  }\n\n  .lg\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n  }\n\n  .lg\\:hover\\:font-bold:hover {\n    font-weight: 700;\n  }\n\n  .lg\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n  }\n\n  .lg\\:hover\\:font-black:hover {\n    font-weight: 900;\n  }\n\n  .lg\\:focus\\:font-hairline:focus {\n    font-weight: 100;\n  }\n\n  .lg\\:focus\\:font-thin:focus {\n    font-weight: 200;\n  }\n\n  .lg\\:focus\\:font-light:focus {\n    font-weight: 300;\n  }\n\n  .lg\\:focus\\:font-normal:focus {\n    font-weight: 400;\n  }\n\n  .lg\\:focus\\:font-medium:focus {\n    font-weight: 500;\n  }\n\n  .lg\\:focus\\:font-semibold:focus {\n    font-weight: 600;\n  }\n\n  .lg\\:focus\\:font-bold:focus {\n    font-weight: 700;\n  }\n\n  .lg\\:focus\\:font-extrabold:focus {\n    font-weight: 800;\n  }\n\n  .lg\\:focus\\:font-black:focus {\n    font-weight: 900;\n  }\n\n  .lg\\:h-0 {\n    height: 0;\n  }\n\n  .lg\\:h-1 {\n    height: 0.25rem;\n  }\n\n  .lg\\:h-2 {\n    height: 0.5rem;\n  }\n\n  .lg\\:h-3 {\n    height: 0.75rem;\n  }\n\n  .lg\\:h-4 {\n    height: 1rem;\n  }\n\n  .lg\\:h-5 {\n    height: 1.25rem;\n  }\n\n  .lg\\:h-6 {\n    height: 1.5rem;\n  }\n\n  .lg\\:h-8 {\n    height: 2rem;\n  }\n\n  .lg\\:h-10 {\n    height: 2.5rem;\n  }\n\n  .lg\\:h-12 {\n    height: 3rem;\n  }\n\n  .lg\\:h-16 {\n    height: 4rem;\n  }\n\n  .lg\\:h-20 {\n    height: 5rem;\n  }\n\n  .lg\\:h-24 {\n    height: 6rem;\n  }\n\n  .lg\\:h-32 {\n    height: 8rem;\n  }\n\n  .lg\\:h-40 {\n    height: 10rem;\n  }\n\n  .lg\\:h-48 {\n    height: 12rem;\n  }\n\n  .lg\\:h-56 {\n    height: 14rem;\n  }\n\n  .lg\\:h-64 {\n    height: 16rem;\n  }\n\n  .lg\\:h-auto {\n    height: auto;\n  }\n\n  .lg\\:h-px {\n    height: 1px;\n  }\n\n  .lg\\:h-full {\n    height: 100%;\n  }\n\n  .lg\\:h-screen {\n    height: 100vh;\n  }\n\n  .lg\\:text-15 {\n    font-size: 0.9375rem;\n  }\n\n  .lg\\:text-xs {\n    font-size: 0.75rem;\n  }\n\n  .lg\\:text-sm {\n    font-size: 0.875rem;\n  }\n\n  .lg\\:text-base {\n    font-size: 1rem;\n  }\n\n  .lg\\:text-lg {\n    font-size: 1.125rem;\n  }\n\n  .lg\\:text-xl {\n    font-size: 1.25rem;\n  }\n\n  .lg\\:text-1\\.5xl {\n    font-size: 1.375rem;\n  }\n\n  .lg\\:text-2xl {\n    font-size: 1.5rem;\n  }\n\n  .lg\\:text-3xl {\n    font-size: 1.875rem;\n  }\n\n  .lg\\:text-4xl {\n    font-size: 2.25rem;\n  }\n\n  .lg\\:text-5xl {\n    font-size: 3rem;\n  }\n\n  .lg\\:text-6xl {\n    font-size: 4rem;\n  }\n\n  .lg\\:leading-3 {\n    line-height: .75rem;\n  }\n\n  .lg\\:leading-4 {\n    line-height: 1rem;\n  }\n\n  .lg\\:leading-5 {\n    line-height: 1.25rem;\n  }\n\n  .lg\\:leading-6 {\n    line-height: 1.5rem;\n  }\n\n  .lg\\:leading-7 {\n    line-height: 1.75rem;\n  }\n\n  .lg\\:leading-8 {\n    line-height: 2rem;\n  }\n\n  .lg\\:leading-9 {\n    line-height: 2.25rem;\n  }\n\n  .lg\\:leading-10 {\n    line-height: 2.5rem;\n  }\n\n  .lg\\:leading-none {\n    line-height: 1;\n  }\n\n  .lg\\:leading-tight {\n    line-height: 1.25;\n  }\n\n  .lg\\:leading-snug {\n    line-height: 1.375;\n  }\n\n  .lg\\:leading-normal {\n    line-height: 1.5;\n  }\n\n  .lg\\:leading-relaxed {\n    line-height: 1.625;\n  }\n\n  .lg\\:leading-loose {\n    line-height: 2;\n  }\n\n  .lg\\:list-inside {\n    list-style-position: inside;\n  }\n\n  .lg\\:list-outside {\n    list-style-position: outside;\n  }\n\n  .lg\\:list-none {\n    list-style-type: none;\n  }\n\n  .lg\\:list-disc {\n    list-style-type: disc;\n  }\n\n  .lg\\:list-decimal {\n    list-style-type: decimal;\n  }\n\n  .lg\\:m-0 {\n    margin: 0;\n  }\n\n  .lg\\:m-1 {\n    margin: 0.25rem;\n  }\n\n  .lg\\:m-2 {\n    margin: 0.5rem;\n  }\n\n  .lg\\:m-3 {\n    margin: 0.75rem;\n  }\n\n  .lg\\:m-4 {\n    margin: 1rem;\n  }\n\n  .lg\\:m-5 {\n    margin: 1.25rem;\n  }\n\n  .lg\\:m-6 {\n    margin: 1.5rem;\n  }\n\n  .lg\\:m-8 {\n    margin: 2rem;\n  }\n\n  .lg\\:m-10 {\n    margin: 2.5rem;\n  }\n\n  .lg\\:m-12 {\n    margin: 3rem;\n  }\n\n  .lg\\:m-16 {\n    margin: 4rem;\n  }\n\n  .lg\\:m-20 {\n    margin: 5rem;\n  }\n\n  .lg\\:m-24 {\n    margin: 6rem;\n  }\n\n  .lg\\:m-32 {\n    margin: 8rem;\n  }\n\n  .lg\\:m-40 {\n    margin: 10rem;\n  }\n\n  .lg\\:m-48 {\n    margin: 12rem;\n  }\n\n  .lg\\:m-56 {\n    margin: 14rem;\n  }\n\n  .lg\\:m-64 {\n    margin: 16rem;\n  }\n\n  .lg\\:m-auto {\n    margin: auto;\n  }\n\n  .lg\\:m-px {\n    margin: 1px;\n  }\n\n  .lg\\:-m-1 {\n    margin: -0.25rem;\n  }\n\n  .lg\\:-m-2 {\n    margin: -0.5rem;\n  }\n\n  .lg\\:-m-3 {\n    margin: -0.75rem;\n  }\n\n  .lg\\:-m-4 {\n    margin: -1rem;\n  }\n\n  .lg\\:-m-5 {\n    margin: -1.25rem;\n  }\n\n  .lg\\:-m-6 {\n    margin: -1.5rem;\n  }\n\n  .lg\\:-m-8 {\n    margin: -2rem;\n  }\n\n  .lg\\:-m-10 {\n    margin: -2.5rem;\n  }\n\n  .lg\\:-m-12 {\n    margin: -3rem;\n  }\n\n  .lg\\:-m-16 {\n    margin: -4rem;\n  }\n\n  .lg\\:-m-20 {\n    margin: -5rem;\n  }\n\n  .lg\\:-m-24 {\n    margin: -6rem;\n  }\n\n  .lg\\:-m-32 {\n    margin: -8rem;\n  }\n\n  .lg\\:-m-40 {\n    margin: -10rem;\n  }\n\n  .lg\\:-m-48 {\n    margin: -12rem;\n  }\n\n  .lg\\:-m-56 {\n    margin: -14rem;\n  }\n\n  .lg\\:-m-64 {\n    margin: -16rem;\n  }\n\n  .lg\\:-m-px {\n    margin: -1px;\n  }\n\n  .lg\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .lg\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .lg\\:my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n\n  .lg\\:mx-1 {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n\n  .lg\\:my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .lg\\:mx-2 {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n\n  .lg\\:my-3 {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .lg\\:mx-3 {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n\n  .lg\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .lg\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n\n  .lg\\:my-5 {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .lg\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n\n  .lg\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .lg\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n\n  .lg\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  .lg\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n\n  .lg\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n\n  .lg\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n\n  .lg\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n\n  .lg\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n\n  .lg\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n\n  .lg\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n\n  .lg\\:my-20 {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n\n  .lg\\:mx-20 {\n    margin-left: 5rem;\n    margin-right: 5rem;\n  }\n\n  .lg\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n\n  .lg\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n\n  .lg\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n\n  .lg\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n\n  .lg\\:my-40 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n  }\n\n  .lg\\:mx-40 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n  }\n\n  .lg\\:my-48 {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n\n  .lg\\:mx-48 {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n\n  .lg\\:my-56 {\n    margin-top: 14rem;\n    margin-bottom: 14rem;\n  }\n\n  .lg\\:mx-56 {\n    margin-left: 14rem;\n    margin-right: 14rem;\n  }\n\n  .lg\\:my-64 {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n\n  .lg\\:mx-64 {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n\n  .lg\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n\n  .lg\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .lg\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n\n  .lg\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n  }\n\n  .lg\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n  }\n\n  .lg\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n  }\n\n  .lg\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n  }\n\n  .lg\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n\n  .lg\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n  }\n\n  .lg\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n  }\n\n  .lg\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n  }\n\n  .lg\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n  }\n\n  .lg\\:-my-5 {\n    margin-top: -1.25rem;\n    margin-bottom: -1.25rem;\n  }\n\n  .lg\\:-mx-5 {\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n\n  .lg\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n  }\n\n  .lg\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n\n  .lg\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n  }\n\n  .lg\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n\n  .lg\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n  }\n\n  .lg\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n  }\n\n  .lg\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n  }\n\n  .lg\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n  }\n\n  .lg\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n  }\n\n  .lg\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n  }\n\n  .lg\\:-my-20 {\n    margin-top: -5rem;\n    margin-bottom: -5rem;\n  }\n\n  .lg\\:-mx-20 {\n    margin-left: -5rem;\n    margin-right: -5rem;\n  }\n\n  .lg\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n  }\n\n  .lg\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n  }\n\n  .lg\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n  }\n\n  .lg\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n  }\n\n  .lg\\:-my-40 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n  }\n\n  .lg\\:-mx-40 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n  }\n\n  .lg\\:-my-48 {\n    margin-top: -12rem;\n    margin-bottom: -12rem;\n  }\n\n  .lg\\:-mx-48 {\n    margin-left: -12rem;\n    margin-right: -12rem;\n  }\n\n  .lg\\:-my-56 {\n    margin-top: -14rem;\n    margin-bottom: -14rem;\n  }\n\n  .lg\\:-mx-56 {\n    margin-left: -14rem;\n    margin-right: -14rem;\n  }\n\n  .lg\\:-my-64 {\n    margin-top: -16rem;\n    margin-bottom: -16rem;\n  }\n\n  .lg\\:-mx-64 {\n    margin-left: -16rem;\n    margin-right: -16rem;\n  }\n\n  .lg\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n  }\n\n  .lg\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n  }\n\n  .lg\\:mt-0 {\n    margin-top: 0;\n  }\n\n  .lg\\:mr-0 {\n    margin-right: 0;\n  }\n\n  .lg\\:mb-0 {\n    margin-bottom: 0;\n  }\n\n  .lg\\:ml-0 {\n    margin-left: 0;\n  }\n\n  .lg\\:mt-1 {\n    margin-top: 0.25rem;\n  }\n\n  .lg\\:mr-1 {\n    margin-right: 0.25rem;\n  }\n\n  .lg\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n\n  .lg\\:ml-1 {\n    margin-left: 0.25rem;\n  }\n\n  .lg\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n\n  .lg\\:mr-2 {\n    margin-right: 0.5rem;\n  }\n\n  .lg\\:mb-2 {\n    margin-bottom: 0.5rem;\n  }\n\n  .lg\\:ml-2 {\n    margin-left: 0.5rem;\n  }\n\n  .lg\\:mt-3 {\n    margin-top: 0.75rem;\n  }\n\n  .lg\\:mr-3 {\n    margin-right: 0.75rem;\n  }\n\n  .lg\\:mb-3 {\n    margin-bottom: 0.75rem;\n  }\n\n  .lg\\:ml-3 {\n    margin-left: 0.75rem;\n  }\n\n  .lg\\:mt-4 {\n    margin-top: 1rem;\n  }\n\n  .lg\\:mr-4 {\n    margin-right: 1rem;\n  }\n\n  .lg\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n\n  .lg\\:ml-4 {\n    margin-left: 1rem;\n  }\n\n  .lg\\:mt-5 {\n    margin-top: 1.25rem;\n  }\n\n  .lg\\:mr-5 {\n    margin-right: 1.25rem;\n  }\n\n  .lg\\:mb-5 {\n    margin-bottom: 1.25rem;\n  }\n\n  .lg\\:ml-5 {\n    margin-left: 1.25rem;\n  }\n\n  .lg\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n\n  .lg\\:mr-6 {\n    margin-right: 1.5rem;\n  }\n\n  .lg\\:mb-6 {\n    margin-bottom: 1.5rem;\n  }\n\n  .lg\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n\n  .lg\\:mt-8 {\n    margin-top: 2rem;\n  }\n\n  .lg\\:mr-8 {\n    margin-right: 2rem;\n  }\n\n  .lg\\:mb-8 {\n    margin-bottom: 2rem;\n  }\n\n  .lg\\:ml-8 {\n    margin-left: 2rem;\n  }\n\n  .lg\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n\n  .lg\\:mr-10 {\n    margin-right: 2.5rem;\n  }\n\n  .lg\\:mb-10 {\n    margin-bottom: 2.5rem;\n  }\n\n  .lg\\:ml-10 {\n    margin-left: 2.5rem;\n  }\n\n  .lg\\:mt-12 {\n    margin-top: 3rem;\n  }\n\n  .lg\\:mr-12 {\n    margin-right: 3rem;\n  }\n\n  .lg\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n\n  .lg\\:ml-12 {\n    margin-left: 3rem;\n  }\n\n  .lg\\:mt-16 {\n    margin-top: 4rem;\n  }\n\n  .lg\\:mr-16 {\n    margin-right: 4rem;\n  }\n\n  .lg\\:mb-16 {\n    margin-bottom: 4rem;\n  }\n\n  .lg\\:ml-16 {\n    margin-left: 4rem;\n  }\n\n  .lg\\:mt-20 {\n    margin-top: 5rem;\n  }\n\n  .lg\\:mr-20 {\n    margin-right: 5rem;\n  }\n\n  .lg\\:mb-20 {\n    margin-bottom: 5rem;\n  }\n\n  .lg\\:ml-20 {\n    margin-left: 5rem;\n  }\n\n  .lg\\:mt-24 {\n    margin-top: 6rem;\n  }\n\n  .lg\\:mr-24 {\n    margin-right: 6rem;\n  }\n\n  .lg\\:mb-24 {\n    margin-bottom: 6rem;\n  }\n\n  .lg\\:ml-24 {\n    margin-left: 6rem;\n  }\n\n  .lg\\:mt-32 {\n    margin-top: 8rem;\n  }\n\n  .lg\\:mr-32 {\n    margin-right: 8rem;\n  }\n\n  .lg\\:mb-32 {\n    margin-bottom: 8rem;\n  }\n\n  .lg\\:ml-32 {\n    margin-left: 8rem;\n  }\n\n  .lg\\:mt-40 {\n    margin-top: 10rem;\n  }\n\n  .lg\\:mr-40 {\n    margin-right: 10rem;\n  }\n\n  .lg\\:mb-40 {\n    margin-bottom: 10rem;\n  }\n\n  .lg\\:ml-40 {\n    margin-left: 10rem;\n  }\n\n  .lg\\:mt-48 {\n    margin-top: 12rem;\n  }\n\n  .lg\\:mr-48 {\n    margin-right: 12rem;\n  }\n\n  .lg\\:mb-48 {\n    margin-bottom: 12rem;\n  }\n\n  .lg\\:ml-48 {\n    margin-left: 12rem;\n  }\n\n  .lg\\:mt-56 {\n    margin-top: 14rem;\n  }\n\n  .lg\\:mr-56 {\n    margin-right: 14rem;\n  }\n\n  .lg\\:mb-56 {\n    margin-bottom: 14rem;\n  }\n\n  .lg\\:ml-56 {\n    margin-left: 14rem;\n  }\n\n  .lg\\:mt-64 {\n    margin-top: 16rem;\n  }\n\n  .lg\\:mr-64 {\n    margin-right: 16rem;\n  }\n\n  .lg\\:mb-64 {\n    margin-bottom: 16rem;\n  }\n\n  .lg\\:ml-64 {\n    margin-left: 16rem;\n  }\n\n  .lg\\:mt-auto {\n    margin-top: auto;\n  }\n\n  .lg\\:mr-auto {\n    margin-right: auto;\n  }\n\n  .lg\\:mb-auto {\n    margin-bottom: auto;\n  }\n\n  .lg\\:ml-auto {\n    margin-left: auto;\n  }\n\n  .lg\\:mt-px {\n    margin-top: 1px;\n  }\n\n  .lg\\:mr-px {\n    margin-right: 1px;\n  }\n\n  .lg\\:mb-px {\n    margin-bottom: 1px;\n  }\n\n  .lg\\:ml-px {\n    margin-left: 1px;\n  }\n\n  .lg\\:-mt-1 {\n    margin-top: -0.25rem;\n  }\n\n  .lg\\:-mr-1 {\n    margin-right: -0.25rem;\n  }\n\n  .lg\\:-mb-1 {\n    margin-bottom: -0.25rem;\n  }\n\n  .lg\\:-ml-1 {\n    margin-left: -0.25rem;\n  }\n\n  .lg\\:-mt-2 {\n    margin-top: -0.5rem;\n  }\n\n  .lg\\:-mr-2 {\n    margin-right: -0.5rem;\n  }\n\n  .lg\\:-mb-2 {\n    margin-bottom: -0.5rem;\n  }\n\n  .lg\\:-ml-2 {\n    margin-left: -0.5rem;\n  }\n\n  .lg\\:-mt-3 {\n    margin-top: -0.75rem;\n  }\n\n  .lg\\:-mr-3 {\n    margin-right: -0.75rem;\n  }\n\n  .lg\\:-mb-3 {\n    margin-bottom: -0.75rem;\n  }\n\n  .lg\\:-ml-3 {\n    margin-left: -0.75rem;\n  }\n\n  .lg\\:-mt-4 {\n    margin-top: -1rem;\n  }\n\n  .lg\\:-mr-4 {\n    margin-right: -1rem;\n  }\n\n  .lg\\:-mb-4 {\n    margin-bottom: -1rem;\n  }\n\n  .lg\\:-ml-4 {\n    margin-left: -1rem;\n  }\n\n  .lg\\:-mt-5 {\n    margin-top: -1.25rem;\n  }\n\n  .lg\\:-mr-5 {\n    margin-right: -1.25rem;\n  }\n\n  .lg\\:-mb-5 {\n    margin-bottom: -1.25rem;\n  }\n\n  .lg\\:-ml-5 {\n    margin-left: -1.25rem;\n  }\n\n  .lg\\:-mt-6 {\n    margin-top: -1.5rem;\n  }\n\n  .lg\\:-mr-6 {\n    margin-right: -1.5rem;\n  }\n\n  .lg\\:-mb-6 {\n    margin-bottom: -1.5rem;\n  }\n\n  .lg\\:-ml-6 {\n    margin-left: -1.5rem;\n  }\n\n  .lg\\:-mt-8 {\n    margin-top: -2rem;\n  }\n\n  .lg\\:-mr-8 {\n    margin-right: -2rem;\n  }\n\n  .lg\\:-mb-8 {\n    margin-bottom: -2rem;\n  }\n\n  .lg\\:-ml-8 {\n    margin-left: -2rem;\n  }\n\n  .lg\\:-mt-10 {\n    margin-top: -2.5rem;\n  }\n\n  .lg\\:-mr-10 {\n    margin-right: -2.5rem;\n  }\n\n  .lg\\:-mb-10 {\n    margin-bottom: -2.5rem;\n  }\n\n  .lg\\:-ml-10 {\n    margin-left: -2.5rem;\n  }\n\n  .lg\\:-mt-12 {\n    margin-top: -3rem;\n  }\n\n  .lg\\:-mr-12 {\n    margin-right: -3rem;\n  }\n\n  .lg\\:-mb-12 {\n    margin-bottom: -3rem;\n  }\n\n  .lg\\:-ml-12 {\n    margin-left: -3rem;\n  }\n\n  .lg\\:-mt-16 {\n    margin-top: -4rem;\n  }\n\n  .lg\\:-mr-16 {\n    margin-right: -4rem;\n  }\n\n  .lg\\:-mb-16 {\n    margin-bottom: -4rem;\n  }\n\n  .lg\\:-ml-16 {\n    margin-left: -4rem;\n  }\n\n  .lg\\:-mt-20 {\n    margin-top: -5rem;\n  }\n\n  .lg\\:-mr-20 {\n    margin-right: -5rem;\n  }\n\n  .lg\\:-mb-20 {\n    margin-bottom: -5rem;\n  }\n\n  .lg\\:-ml-20 {\n    margin-left: -5rem;\n  }\n\n  .lg\\:-mt-24 {\n    margin-top: -6rem;\n  }\n\n  .lg\\:-mr-24 {\n    margin-right: -6rem;\n  }\n\n  .lg\\:-mb-24 {\n    margin-bottom: -6rem;\n  }\n\n  .lg\\:-ml-24 {\n    margin-left: -6rem;\n  }\n\n  .lg\\:-mt-32 {\n    margin-top: -8rem;\n  }\n\n  .lg\\:-mr-32 {\n    margin-right: -8rem;\n  }\n\n  .lg\\:-mb-32 {\n    margin-bottom: -8rem;\n  }\n\n  .lg\\:-ml-32 {\n    margin-left: -8rem;\n  }\n\n  .lg\\:-mt-40 {\n    margin-top: -10rem;\n  }\n\n  .lg\\:-mr-40 {\n    margin-right: -10rem;\n  }\n\n  .lg\\:-mb-40 {\n    margin-bottom: -10rem;\n  }\n\n  .lg\\:-ml-40 {\n    margin-left: -10rem;\n  }\n\n  .lg\\:-mt-48 {\n    margin-top: -12rem;\n  }\n\n  .lg\\:-mr-48 {\n    margin-right: -12rem;\n  }\n\n  .lg\\:-mb-48 {\n    margin-bottom: -12rem;\n  }\n\n  .lg\\:-ml-48 {\n    margin-left: -12rem;\n  }\n\n  .lg\\:-mt-56 {\n    margin-top: -14rem;\n  }\n\n  .lg\\:-mr-56 {\n    margin-right: -14rem;\n  }\n\n  .lg\\:-mb-56 {\n    margin-bottom: -14rem;\n  }\n\n  .lg\\:-ml-56 {\n    margin-left: -14rem;\n  }\n\n  .lg\\:-mt-64 {\n    margin-top: -16rem;\n  }\n\n  .lg\\:-mr-64 {\n    margin-right: -16rem;\n  }\n\n  .lg\\:-mb-64 {\n    margin-bottom: -16rem;\n  }\n\n  .lg\\:-ml-64 {\n    margin-left: -16rem;\n  }\n\n  .lg\\:-mt-px {\n    margin-top: -1px;\n  }\n\n  .lg\\:-mr-px {\n    margin-right: -1px;\n  }\n\n  .lg\\:-mb-px {\n    margin-bottom: -1px;\n  }\n\n  .lg\\:-ml-px {\n    margin-left: -1px;\n  }\n\n  .lg\\:max-h-full {\n    max-height: 100%;\n  }\n\n  .lg\\:max-h-screen {\n    max-height: 100vh;\n  }\n\n  .lg\\:max-w-none {\n    max-width: none;\n  }\n\n  .lg\\:max-w-xs {\n    max-width: 20rem;\n  }\n\n  .lg\\:max-w-sm {\n    max-width: 24rem;\n  }\n\n  .lg\\:max-w-md {\n    max-width: 28rem;\n  }\n\n  .lg\\:max-w-lg {\n    max-width: 32rem;\n  }\n\n  .lg\\:max-w-xl {\n    max-width: 36rem;\n  }\n\n  .lg\\:max-w-2xl {\n    max-width: 42rem;\n  }\n\n  .lg\\:max-w-3xl {\n    max-width: 48rem;\n  }\n\n  .lg\\:max-w-4xl {\n    max-width: 56rem;\n  }\n\n  .lg\\:max-w-5xl {\n    max-width: 64rem;\n  }\n\n  .lg\\:max-w-6xl {\n    max-width: 72rem;\n  }\n\n  .lg\\:max-w-full {\n    max-width: 100%;\n  }\n\n  .lg\\:max-w-screen-sm {\n    max-width: 640px;\n  }\n\n  .lg\\:max-w-screen-md {\n    max-width: 768px;\n  }\n\n  .lg\\:max-w-screen-lg {\n    max-width: 1024px;\n  }\n\n  .lg\\:max-w-screen-xl {\n    max-width: 1280px;\n  }\n\n  .lg\\:min-h-0 {\n    min-height: 0;\n  }\n\n  .lg\\:min-h-full {\n    min-height: 100%;\n  }\n\n  .lg\\:min-h-screen {\n    min-height: 100vh;\n  }\n\n  .lg\\:min-w-0 {\n    min-width: 0;\n  }\n\n  .lg\\:min-w-full {\n    min-width: 100%;\n  }\n\n  .lg\\:object-contain {\n    object-fit: contain;\n  }\n\n  .lg\\:object-cover {\n    object-fit: cover;\n  }\n\n  .lg\\:object-fill {\n    object-fit: fill;\n  }\n\n  .lg\\:object-none {\n    object-fit: none;\n  }\n\n  .lg\\:object-scale-down {\n    object-fit: scale-down;\n  }\n\n  .lg\\:object-bottom {\n    object-position: bottom;\n  }\n\n  .lg\\:object-center {\n    object-position: center;\n  }\n\n  .lg\\:object-left {\n    object-position: left;\n  }\n\n  .lg\\:object-left-bottom {\n    object-position: left bottom;\n  }\n\n  .lg\\:object-left-top {\n    object-position: left top;\n  }\n\n  .lg\\:object-right {\n    object-position: right;\n  }\n\n  .lg\\:object-right-bottom {\n    object-position: right bottom;\n  }\n\n  .lg\\:object-right-top {\n    object-position: right top;\n  }\n\n  .lg\\:object-top {\n    object-position: top;\n  }\n\n  .lg\\:opacity-0 {\n    opacity: 0;\n  }\n\n  .lg\\:opacity-25 {\n    opacity: 0.25;\n  }\n\n  .lg\\:opacity-50 {\n    opacity: 0.5;\n  }\n\n  .lg\\:opacity-75 {\n    opacity: 0.75;\n  }\n\n  .lg\\:opacity-100 {\n    opacity: 1;\n  }\n\n  .lg\\:hover\\:opacity-0:hover {\n    opacity: 0;\n  }\n\n  .lg\\:hover\\:opacity-25:hover {\n    opacity: 0.25;\n  }\n\n  .lg\\:hover\\:opacity-50:hover {\n    opacity: 0.5;\n  }\n\n  .lg\\:hover\\:opacity-75:hover {\n    opacity: 0.75;\n  }\n\n  .lg\\:hover\\:opacity-100:hover {\n    opacity: 1;\n  }\n\n  .lg\\:focus\\:opacity-0:focus {\n    opacity: 0;\n  }\n\n  .lg\\:focus\\:opacity-25:focus {\n    opacity: 0.25;\n  }\n\n  .lg\\:focus\\:opacity-50:focus {\n    opacity: 0.5;\n  }\n\n  .lg\\:focus\\:opacity-75:focus {\n    opacity: 0.75;\n  }\n\n  .lg\\:focus\\:opacity-100:focus {\n    opacity: 1;\n  }\n\n  .lg\\:outline-none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  .lg\\:outline-white {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n\n  .lg\\:outline-black {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n\n  .lg\\:focus\\:outline-none:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  .lg\\:focus\\:outline-white:focus {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n\n  .lg\\:focus\\:outline-black:focus {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n\n  .lg\\:overflow-auto {\n    overflow: auto;\n  }\n\n  .lg\\:overflow-hidden {\n    overflow: hidden;\n  }\n\n  .lg\\:overflow-visible {\n    overflow: visible;\n  }\n\n  .lg\\:overflow-scroll {\n    overflow: scroll;\n  }\n\n  .lg\\:overflow-x-auto {\n    overflow-x: auto;\n  }\n\n  .lg\\:overflow-y-auto {\n    overflow-y: auto;\n  }\n\n  .lg\\:overflow-x-hidden {\n    overflow-x: hidden;\n  }\n\n  .lg\\:overflow-y-hidden {\n    overflow-y: hidden;\n  }\n\n  .lg\\:overflow-x-visible {\n    overflow-x: visible;\n  }\n\n  .lg\\:overflow-y-visible {\n    overflow-y: visible;\n  }\n\n  .lg\\:overflow-x-scroll {\n    overflow-x: scroll;\n  }\n\n  .lg\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n\n  .lg\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .lg\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n  }\n\n  .lg\\:overscroll-auto {\n    overscroll-behavior: auto;\n  }\n\n  .lg\\:overscroll-contain {\n    overscroll-behavior: contain;\n  }\n\n  .lg\\:overscroll-none {\n    overscroll-behavior: none;\n  }\n\n  .lg\\:overscroll-y-auto {\n    overscroll-behavior-y: auto;\n  }\n\n  .lg\\:overscroll-y-contain {\n    overscroll-behavior-y: contain;\n  }\n\n  .lg\\:overscroll-y-none {\n    overscroll-behavior-y: none;\n  }\n\n  .lg\\:overscroll-x-auto {\n    overscroll-behavior-x: auto;\n  }\n\n  .lg\\:overscroll-x-contain {\n    overscroll-behavior-x: contain;\n  }\n\n  .lg\\:overscroll-x-none {\n    overscroll-behavior-x: none;\n  }\n\n  .lg\\:p-0 {\n    padding: 0;\n  }\n\n  .lg\\:p-1 {\n    padding: 0.25rem;\n  }\n\n  .lg\\:p-2 {\n    padding: 0.5rem;\n  }\n\n  .lg\\:p-3 {\n    padding: 0.75rem;\n  }\n\n  .lg\\:p-4 {\n    padding: 1rem;\n  }\n\n  .lg\\:p-5 {\n    padding: 1.25rem;\n  }\n\n  .lg\\:p-6 {\n    padding: 1.5rem;\n  }\n\n  .lg\\:p-8 {\n    padding: 2rem;\n  }\n\n  .lg\\:p-10 {\n    padding: 2.5rem;\n  }\n\n  .lg\\:p-12 {\n    padding: 3rem;\n  }\n\n  .lg\\:p-16 {\n    padding: 4rem;\n  }\n\n  .lg\\:p-20 {\n    padding: 5rem;\n  }\n\n  .lg\\:p-24 {\n    padding: 6rem;\n  }\n\n  .lg\\:p-32 {\n    padding: 8rem;\n  }\n\n  .lg\\:p-40 {\n    padding: 10rem;\n  }\n\n  .lg\\:p-48 {\n    padding: 12rem;\n  }\n\n  .lg\\:p-56 {\n    padding: 14rem;\n  }\n\n  .lg\\:p-64 {\n    padding: 16rem;\n  }\n\n  .lg\\:p-px {\n    padding: 1px;\n  }\n\n  .lg\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .lg\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .lg\\:py-1 {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .lg\\:px-1 {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n\n  .lg\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .lg\\:px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n\n  .lg\\:py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .lg\\:px-3 {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n\n  .lg\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .lg\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .lg\\:py-5 {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .lg\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n\n  .lg\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .lg\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .lg\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .lg\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .lg\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .lg\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  .lg\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n\n  .lg\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n\n  .lg\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n\n  .lg\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n\n  .lg\\:py-20 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n\n  .lg\\:px-20 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n\n  .lg\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n\n  .lg\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n\n  .lg\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n\n  .lg\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n\n  .lg\\:py-40 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n\n  .lg\\:px-40 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n\n  .lg\\:py-48 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n\n  .lg\\:px-48 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n\n  .lg\\:py-56 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n\n  .lg\\:px-56 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n\n  .lg\\:py-64 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n\n  .lg\\:px-64 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n\n  .lg\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n\n  .lg\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n\n  .lg\\:pt-0 {\n    padding-top: 0;\n  }\n\n  .lg\\:pr-0 {\n    padding-right: 0;\n  }\n\n  .lg\\:pb-0 {\n    padding-bottom: 0;\n  }\n\n  .lg\\:pl-0 {\n    padding-left: 0;\n  }\n\n  .lg\\:pt-1 {\n    padding-top: 0.25rem;\n  }\n\n  .lg\\:pr-1 {\n    padding-right: 0.25rem;\n  }\n\n  .lg\\:pb-1 {\n    padding-bottom: 0.25rem;\n  }\n\n  .lg\\:pl-1 {\n    padding-left: 0.25rem;\n  }\n\n  .lg\\:pt-2 {\n    padding-top: 0.5rem;\n  }\n\n  .lg\\:pr-2 {\n    padding-right: 0.5rem;\n  }\n\n  .lg\\:pb-2 {\n    padding-bottom: 0.5rem;\n  }\n\n  .lg\\:pl-2 {\n    padding-left: 0.5rem;\n  }\n\n  .lg\\:pt-3 {\n    padding-top: 0.75rem;\n  }\n\n  .lg\\:pr-3 {\n    padding-right: 0.75rem;\n  }\n\n  .lg\\:pb-3 {\n    padding-bottom: 0.75rem;\n  }\n\n  .lg\\:pl-3 {\n    padding-left: 0.75rem;\n  }\n\n  .lg\\:pt-4 {\n    padding-top: 1rem;\n  }\n\n  .lg\\:pr-4 {\n    padding-right: 1rem;\n  }\n\n  .lg\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n\n  .lg\\:pl-4 {\n    padding-left: 1rem;\n  }\n\n  .lg\\:pt-5 {\n    padding-top: 1.25rem;\n  }\n\n  .lg\\:pr-5 {\n    padding-right: 1.25rem;\n  }\n\n  .lg\\:pb-5 {\n    padding-bottom: 1.25rem;\n  }\n\n  .lg\\:pl-5 {\n    padding-left: 1.25rem;\n  }\n\n  .lg\\:pt-6 {\n    padding-top: 1.5rem;\n  }\n\n  .lg\\:pr-6 {\n    padding-right: 1.5rem;\n  }\n\n  .lg\\:pb-6 {\n    padding-bottom: 1.5rem;\n  }\n\n  .lg\\:pl-6 {\n    padding-left: 1.5rem;\n  }\n\n  .lg\\:pt-8 {\n    padding-top: 2rem;\n  }\n\n  .lg\\:pr-8 {\n    padding-right: 2rem;\n  }\n\n  .lg\\:pb-8 {\n    padding-bottom: 2rem;\n  }\n\n  .lg\\:pl-8 {\n    padding-left: 2rem;\n  }\n\n  .lg\\:pt-10 {\n    padding-top: 2.5rem;\n  }\n\n  .lg\\:pr-10 {\n    padding-right: 2.5rem;\n  }\n\n  .lg\\:pb-10 {\n    padding-bottom: 2.5rem;\n  }\n\n  .lg\\:pl-10 {\n    padding-left: 2.5rem;\n  }\n\n  .lg\\:pt-12 {\n    padding-top: 3rem;\n  }\n\n  .lg\\:pr-12 {\n    padding-right: 3rem;\n  }\n\n  .lg\\:pb-12 {\n    padding-bottom: 3rem;\n  }\n\n  .lg\\:pl-12 {\n    padding-left: 3rem;\n  }\n\n  .lg\\:pt-16 {\n    padding-top: 4rem;\n  }\n\n  .lg\\:pr-16 {\n    padding-right: 4rem;\n  }\n\n  .lg\\:pb-16 {\n    padding-bottom: 4rem;\n  }\n\n  .lg\\:pl-16 {\n    padding-left: 4rem;\n  }\n\n  .lg\\:pt-20 {\n    padding-top: 5rem;\n  }\n\n  .lg\\:pr-20 {\n    padding-right: 5rem;\n  }\n\n  .lg\\:pb-20 {\n    padding-bottom: 5rem;\n  }\n\n  .lg\\:pl-20 {\n    padding-left: 5rem;\n  }\n\n  .lg\\:pt-24 {\n    padding-top: 6rem;\n  }\n\n  .lg\\:pr-24 {\n    padding-right: 6rem;\n  }\n\n  .lg\\:pb-24 {\n    padding-bottom: 6rem;\n  }\n\n  .lg\\:pl-24 {\n    padding-left: 6rem;\n  }\n\n  .lg\\:pt-32 {\n    padding-top: 8rem;\n  }\n\n  .lg\\:pr-32 {\n    padding-right: 8rem;\n  }\n\n  .lg\\:pb-32 {\n    padding-bottom: 8rem;\n  }\n\n  .lg\\:pl-32 {\n    padding-left: 8rem;\n  }\n\n  .lg\\:pt-40 {\n    padding-top: 10rem;\n  }\n\n  .lg\\:pr-40 {\n    padding-right: 10rem;\n  }\n\n  .lg\\:pb-40 {\n    padding-bottom: 10rem;\n  }\n\n  .lg\\:pl-40 {\n    padding-left: 10rem;\n  }\n\n  .lg\\:pt-48 {\n    padding-top: 12rem;\n  }\n\n  .lg\\:pr-48 {\n    padding-right: 12rem;\n  }\n\n  .lg\\:pb-48 {\n    padding-bottom: 12rem;\n  }\n\n  .lg\\:pl-48 {\n    padding-left: 12rem;\n  }\n\n  .lg\\:pt-56 {\n    padding-top: 14rem;\n  }\n\n  .lg\\:pr-56 {\n    padding-right: 14rem;\n  }\n\n  .lg\\:pb-56 {\n    padding-bottom: 14rem;\n  }\n\n  .lg\\:pl-56 {\n    padding-left: 14rem;\n  }\n\n  .lg\\:pt-64 {\n    padding-top: 16rem;\n  }\n\n  .lg\\:pr-64 {\n    padding-right: 16rem;\n  }\n\n  .lg\\:pb-64 {\n    padding-bottom: 16rem;\n  }\n\n  .lg\\:pl-64 {\n    padding-left: 16rem;\n  }\n\n  .lg\\:pt-px {\n    padding-top: 1px;\n  }\n\n  .lg\\:pr-px {\n    padding-right: 1px;\n  }\n\n  .lg\\:pb-px {\n    padding-bottom: 1px;\n  }\n\n  .lg\\:pl-px {\n    padding-left: 1px;\n  }\n\n  .lg\\:placeholder-transparent::placeholder {\n    color: transparent;\n  }\n\n  .lg\\:placeholder-current::placeholder {\n    color: currentColor;\n  }\n\n  .lg\\:placeholder-black::placeholder {\n    --placeholder-opacity: 1;\n    color: #000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-white::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f7fafc;\n    color: rgba(247, 250, 252, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #edf2f7;\n    color: rgba(237, 242, 247, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #cbd5e0;\n    color: rgba(203, 213, 224, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160, 174, 192, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #718096;\n    color: rgba(113, 128, 150, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a5568;\n    color: rgba(74, 85, 104, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #2d3748;\n    color: rgba(45, 55, 72, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202c;\n    color: rgba(26, 32, 44, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f5;\n    color: rgba(255, 245, 245, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7d7;\n    color: rgba(254, 215, 215, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #feb2b2;\n    color: rgba(254, 178, 178, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #fc8181;\n    color: rgba(252, 129, 129, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #f56565;\n    color: rgba(245, 101, 101, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #e53e3e;\n    color: rgba(229, 62, 62, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c53030;\n    color: rgba(197, 48, 48, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b2c2c;\n    color: rgba(155, 44, 44, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-red-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #742a2a;\n    color: rgba(116, 42, 42, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffaf0;\n    color: rgba(255, 250, 240, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #feebc8;\n    color: rgba(254, 235, 200, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd38d;\n    color: rgba(251, 211, 141, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6ad55;\n    color: rgba(246, 173, 85, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed8936;\n    color: rgba(237, 137, 54, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #dd6b20;\n    color: rgba(221, 107, 32, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c05621;\n    color: rgba(192, 86, 33, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9c4221;\n    color: rgba(156, 66, 33, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-orange-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #7b341e;\n    color: rgba(123, 52, 30, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffff0;\n    color: rgba(255, 255, 240, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fefcbf;\n    color: rgba(254, 252, 191, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf089;\n    color: rgba(250, 240, 137, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6e05e;\n    color: rgba(246, 224, 94, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ecc94b;\n    color: rgba(236, 201, 75, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d69e2e;\n    color: rgba(214, 158, 46, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b7791f;\n    color: rgba(183, 121, 31, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #975a16;\n    color: rgba(151, 90, 22, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-yellow-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #744210;\n    color: rgba(116, 66, 16, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0fff4;\n    color: rgba(240, 255, 244, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c6f6d5;\n    color: rgba(198, 246, 213, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #9ae6b4;\n    color: rgba(154, 230, 180, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #68d391;\n    color: rgba(104, 211, 145, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #48bb78;\n    color: rgba(72, 187, 120, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #38a169;\n    color: rgba(56, 161, 105, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2f855a;\n    color: rgba(47, 133, 90, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #276749;\n    color: rgba(39, 103, 73, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-green-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #22543d;\n    color: rgba(34, 84, 61, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e6fffa;\n    color: rgba(230, 255, 250, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #b2f5ea;\n    color: rgba(178, 245, 234, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #81e6d9;\n    color: rgba(129, 230, 217, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #4fd1c5;\n    color: rgba(79, 209, 197, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #38b2ac;\n    color: rgba(56, 178, 172, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #319795;\n    color: rgba(49, 151, 149, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c7a7b;\n    color: rgba(44, 122, 123, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #285e61;\n    color: rgba(40, 94, 97, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-teal-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #234e52;\n    color: rgba(35, 78, 82, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf8ff;\n    color: rgba(235, 248, 255, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #bee3f8;\n    color: rgba(190, 227, 248, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #90cdf4;\n    color: rgba(144, 205, 244, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #63b3ed;\n    color: rgba(99, 179, 237, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #4299e1;\n    color: rgba(66, 153, 225, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #3182ce;\n    color: rgba(49, 130, 206, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2b6cb0;\n    color: rgba(43, 108, 176, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c5282;\n    color: rgba(44, 82, 130, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-blue-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #2a4365;\n    color: rgba(42, 67, 101, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf4ff;\n    color: rgba(235, 244, 255, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3dafe;\n    color: rgba(195, 218, 254, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #a3bffa;\n    color: rgba(163, 191, 250, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #7f9cf5;\n    color: rgba(127, 156, 245, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #667eea;\n    color: rgba(102, 126, 234, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #5a67d8;\n    color: rgba(90, 103, 216, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #4c51bf;\n    color: rgba(76, 81, 191, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #434190;\n    color: rgba(67, 65, 144, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-indigo-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #3c366b;\n    color: rgba(60, 54, 107, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf5ff;\n    color: rgba(250, 245, 255, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e9d8fd;\n    color: rgba(233, 216, 253, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #d6bcfa;\n    color: rgba(214, 188, 250, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #b794f4;\n    color: rgba(183, 148, 244, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f7aea;\n    color: rgba(159, 122, 234, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #805ad5;\n    color: rgba(128, 90, 213, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b46c1;\n    color: rgba(107, 70, 193, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #553c9a;\n    color: rgba(85, 60, 154, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-purple-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #44337a;\n    color: rgba(68, 51, 122, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f7;\n    color: rgba(255, 245, 247, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7e2;\n    color: rgba(254, 215, 226, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbb6ce;\n    color: rgba(251, 182, 206, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f687b3;\n    color: rgba(246, 135, 179, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed64a6;\n    color: rgba(237, 100, 166, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d53f8c;\n    color: rgba(213, 63, 140, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b83280;\n    color: rgba(184, 50, 128, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #97266d;\n    color: rgba(151, 38, 109, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-pink-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #702459;\n    color: rgba(112, 36, 89, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-transparent:focus::placeholder {\n    color: transparent;\n  }\n\n  .lg\\:focus\\:placeholder-current:focus::placeholder {\n    color: currentColor;\n  }\n\n  .lg\\:focus\\:placeholder-black:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-white:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f7fafc;\n    color: rgba(247, 250, 252, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edf2f7;\n    color: rgba(237, 242, 247, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cbd5e0;\n    color: rgba(203, 213, 224, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160, 174, 192, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #718096;\n    color: rgba(113, 128, 150, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a5568;\n    color: rgba(74, 85, 104, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2d3748;\n    color: rgba(45, 55, 72, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202c;\n    color: rgba(26, 32, 44, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f5;\n    color: rgba(255, 245, 245, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7d7;\n    color: rgba(254, 215, 215, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feb2b2;\n    color: rgba(254, 178, 178, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fc8181;\n    color: rgba(252, 129, 129, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f56565;\n    color: rgba(245, 101, 101, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e53e3e;\n    color: rgba(229, 62, 62, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c53030;\n    color: rgba(197, 48, 48, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b2c2c;\n    color: rgba(155, 44, 44, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-red-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #742a2a;\n    color: rgba(116, 42, 42, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffaf0;\n    color: rgba(255, 250, 240, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feebc8;\n    color: rgba(254, 235, 200, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd38d;\n    color: rgba(251, 211, 141, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6ad55;\n    color: rgba(246, 173, 85, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed8936;\n    color: rgba(237, 137, 54, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #dd6b20;\n    color: rgba(221, 107, 32, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c05621;\n    color: rgba(192, 86, 33, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9c4221;\n    color: rgba(156, 66, 33, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-orange-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7b341e;\n    color: rgba(123, 52, 30, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffff0;\n    color: rgba(255, 255, 240, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fefcbf;\n    color: rgba(254, 252, 191, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf089;\n    color: rgba(250, 240, 137, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6e05e;\n    color: rgba(246, 224, 94, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ecc94b;\n    color: rgba(236, 201, 75, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d69e2e;\n    color: rgba(214, 158, 46, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b7791f;\n    color: rgba(183, 121, 31, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #975a16;\n    color: rgba(151, 90, 22, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-yellow-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #744210;\n    color: rgba(116, 66, 16, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0fff4;\n    color: rgba(240, 255, 244, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c6f6d5;\n    color: rgba(198, 246, 213, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9ae6b4;\n    color: rgba(154, 230, 180, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #68d391;\n    color: rgba(104, 211, 145, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #48bb78;\n    color: rgba(72, 187, 120, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #38a169;\n    color: rgba(56, 161, 105, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2f855a;\n    color: rgba(47, 133, 90, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #276749;\n    color: rgba(39, 103, 73, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-green-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #22543d;\n    color: rgba(34, 84, 61, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e6fffa;\n    color: rgba(230, 255, 250, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b2f5ea;\n    color: rgba(178, 245, 234, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #81e6d9;\n    color: rgba(129, 230, 217, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4fd1c5;\n    color: rgba(79, 209, 197, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #38b2ac;\n    color: rgba(56, 178, 172, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #319795;\n    color: rgba(49, 151, 149, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c7a7b;\n    color: rgba(44, 122, 123, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #285e61;\n    color: rgba(40, 94, 97, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-teal-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #234e52;\n    color: rgba(35, 78, 82, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf8ff;\n    color: rgba(235, 248, 255, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bee3f8;\n    color: rgba(190, 227, 248, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #90cdf4;\n    color: rgba(144, 205, 244, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #63b3ed;\n    color: rgba(99, 179, 237, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4299e1;\n    color: rgba(66, 153, 225, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3182ce;\n    color: rgba(49, 130, 206, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2b6cb0;\n    color: rgba(43, 108, 176, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c5282;\n    color: rgba(44, 82, 130, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-blue-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2a4365;\n    color: rgba(42, 67, 101, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf4ff;\n    color: rgba(235, 244, 255, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3dafe;\n    color: rgba(195, 218, 254, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a3bffa;\n    color: rgba(163, 191, 250, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7f9cf5;\n    color: rgba(127, 156, 245, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #667eea;\n    color: rgba(102, 126, 234, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5a67d8;\n    color: rgba(90, 103, 216, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4c51bf;\n    color: rgba(76, 81, 191, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #434190;\n    color: rgba(67, 65, 144, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-indigo-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3c366b;\n    color: rgba(60, 54, 107, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf5ff;\n    color: rgba(250, 245, 255, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e9d8fd;\n    color: rgba(233, 216, 253, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d6bcfa;\n    color: rgba(214, 188, 250, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b794f4;\n    color: rgba(183, 148, 244, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f7aea;\n    color: rgba(159, 122, 234, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #805ad5;\n    color: rgba(128, 90, 213, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b46c1;\n    color: rgba(107, 70, 193, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #553c9a;\n    color: rgba(85, 60, 154, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-purple-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #44337a;\n    color: rgba(68, 51, 122, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f7;\n    color: rgba(255, 245, 247, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7e2;\n    color: rgba(254, 215, 226, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbb6ce;\n    color: rgba(251, 182, 206, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f687b3;\n    color: rgba(246, 135, 179, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed64a6;\n    color: rgba(237, 100, 166, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d53f8c;\n    color: rgba(213, 63, 140, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b83280;\n    color: rgba(184, 50, 128, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #97266d;\n    color: rgba(151, 38, 109, var(--placeholder-opacity));\n  }\n\n  .lg\\:focus\\:placeholder-pink-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #702459;\n    color: rgba(112, 36, 89, var(--placeholder-opacity));\n  }\n\n  .lg\\:placeholder-opacity-0::placeholder {\n    --placeholder-opacity: 0;\n  }\n\n  .lg\\:placeholder-opacity-25::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n\n  .lg\\:placeholder-opacity-50::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n\n  .lg\\:placeholder-opacity-75::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n\n  .lg\\:placeholder-opacity-100::placeholder {\n    --placeholder-opacity: 1;\n  }\n\n  .lg\\:focus\\:placeholder-opacity-0:focus::placeholder {\n    --placeholder-opacity: 0;\n  }\n\n  .lg\\:focus\\:placeholder-opacity-25:focus::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n\n  .lg\\:focus\\:placeholder-opacity-50:focus::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n\n  .lg\\:focus\\:placeholder-opacity-75:focus::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n\n  .lg\\:focus\\:placeholder-opacity-100:focus::placeholder {\n    --placeholder-opacity: 1;\n  }\n\n  .lg\\:pointer-events-none {\n    pointer-events: none;\n  }\n\n  .lg\\:pointer-events-auto {\n    pointer-events: auto;\n  }\n\n  .lg\\:static {\n    position: static;\n  }\n\n  .lg\\:fixed {\n    position: fixed;\n  }\n\n  .lg\\:absolute {\n    position: absolute;\n  }\n\n  .lg\\:relative {\n    position: relative;\n  }\n\n  .lg\\:sticky {\n    position: sticky;\n  }\n\n  .lg\\:inset-0 {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  .lg\\:inset-auto {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n  }\n\n  .lg\\:inset-y-0 {\n    top: 0;\n    bottom: 0;\n  }\n\n  .lg\\:inset-x-0 {\n    right: 0;\n    left: 0;\n  }\n\n  .lg\\:inset-y-auto {\n    top: auto;\n    bottom: auto;\n  }\n\n  .lg\\:inset-x-auto {\n    right: auto;\n    left: auto;\n  }\n\n  .lg\\:top-0 {\n    top: 0;\n  }\n\n  .lg\\:right-0 {\n    right: 0;\n  }\n\n  .lg\\:bottom-0 {\n    bottom: 0;\n  }\n\n  .lg\\:left-0 {\n    left: 0;\n  }\n\n  .lg\\:top-auto {\n    top: auto;\n  }\n\n  .lg\\:right-auto {\n    right: auto;\n  }\n\n  .lg\\:bottom-auto {\n    bottom: auto;\n  }\n\n  .lg\\:left-auto {\n    left: auto;\n  }\n\n  .lg\\:resize-none {\n    resize: none;\n  }\n\n  .lg\\:resize-y {\n    resize: vertical;\n  }\n\n  .lg\\:resize-x {\n    resize: horizontal;\n  }\n\n  .lg\\:resize {\n    resize: both;\n  }\n\n  .lg\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .lg\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .lg\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .lg\\:shadow-none {\n    box-shadow: none;\n  }\n\n  .lg\\:hover\\:shadow-xs:hover {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:hover\\:shadow-sm:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:hover\\:shadow:hover {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:hover\\:shadow-md:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:hover\\:shadow-lg:hover {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:hover\\:shadow-xl:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .lg\\:hover\\:shadow-2xl:hover {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .lg\\:hover\\:shadow-inner:hover {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:hover\\:shadow-outline:hover {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .lg\\:hover\\:shadow-none:hover {\n    box-shadow: none;\n  }\n\n  .lg\\:focus\\:shadow-xs:focus {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:focus\\:shadow-sm:focus {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:focus\\:shadow:focus {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:focus\\:shadow-md:focus {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:focus\\:shadow-lg:focus {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .lg\\:focus\\:shadow-xl:focus {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .lg\\:focus\\:shadow-2xl:focus {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .lg\\:focus\\:shadow-inner:focus {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .lg\\:focus\\:shadow-outline:focus {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .lg\\:focus\\:shadow-none:focus {\n    box-shadow: none;\n  }\n\n  .lg\\:fill-current {\n    fill: currentColor;\n  }\n\n  .lg\\:stroke-current {\n    stroke: currentColor;\n  }\n\n  .lg\\:stroke-0 {\n    stroke-width: 0;\n  }\n\n  .lg\\:stroke-1 {\n    stroke-width: 1;\n  }\n\n  .lg\\:stroke-2 {\n    stroke-width: 2;\n  }\n\n  .lg\\:table-auto {\n    table-layout: auto;\n  }\n\n  .lg\\:table-fixed {\n    table-layout: fixed;\n  }\n\n  .lg\\:text-left {\n    text-align: left;\n  }\n\n  .lg\\:text-center {\n    text-align: center;\n  }\n\n  .lg\\:text-right {\n    text-align: right;\n  }\n\n  .lg\\:text-justify {\n    text-align: justify;\n  }\n\n  .lg\\:text-blue {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .lg\\:text-primaryText {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .lg\\:text-red {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .lg\\:hover\\:text-blue:hover {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .lg\\:hover\\:text-primaryText:hover {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .lg\\:hover\\:text-red:hover {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .lg\\:focus\\:text-blue:focus {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .lg\\:focus\\:text-primaryText:focus {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .lg\\:focus\\:text-red:focus {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .lg\\:text-opacity-0 {\n    --text-opacity: 0;\n  }\n\n  .lg\\:text-opacity-25 {\n    --text-opacity: 0.25;\n  }\n\n  .lg\\:text-opacity-50 {\n    --text-opacity: 0.5;\n  }\n\n  .lg\\:text-opacity-75 {\n    --text-opacity: 0.75;\n  }\n\n  .lg\\:text-opacity-100 {\n    --text-opacity: 1;\n  }\n\n  .lg\\:hover\\:text-opacity-0:hover {\n    --text-opacity: 0;\n  }\n\n  .lg\\:hover\\:text-opacity-25:hover {\n    --text-opacity: 0.25;\n  }\n\n  .lg\\:hover\\:text-opacity-50:hover {\n    --text-opacity: 0.5;\n  }\n\n  .lg\\:hover\\:text-opacity-75:hover {\n    --text-opacity: 0.75;\n  }\n\n  .lg\\:hover\\:text-opacity-100:hover {\n    --text-opacity: 1;\n  }\n\n  .lg\\:focus\\:text-opacity-0:focus {\n    --text-opacity: 0;\n  }\n\n  .lg\\:focus\\:text-opacity-25:focus {\n    --text-opacity: 0.25;\n  }\n\n  .lg\\:focus\\:text-opacity-50:focus {\n    --text-opacity: 0.5;\n  }\n\n  .lg\\:focus\\:text-opacity-75:focus {\n    --text-opacity: 0.75;\n  }\n\n  .lg\\:focus\\:text-opacity-100:focus {\n    --text-opacity: 1;\n  }\n\n  .lg\\:italic {\n    font-style: italic;\n  }\n\n  .lg\\:not-italic {\n    font-style: normal;\n  }\n\n  .lg\\:uppercase {\n    text-transform: uppercase;\n  }\n\n  .lg\\:lowercase {\n    text-transform: lowercase;\n  }\n\n  .lg\\:capitalize {\n    text-transform: capitalize;\n  }\n\n  .lg\\:normal-case {\n    text-transform: none;\n  }\n\n  .lg\\:underline {\n    text-decoration: underline;\n  }\n\n  .lg\\:line-through {\n    text-decoration: line-through;\n  }\n\n  .lg\\:no-underline {\n    text-decoration: none;\n  }\n\n  .lg\\:hover\\:underline:hover {\n    text-decoration: underline;\n  }\n\n  .lg\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n  }\n\n  .lg\\:hover\\:no-underline:hover {\n    text-decoration: none;\n  }\n\n  .lg\\:focus\\:underline:focus {\n    text-decoration: underline;\n  }\n\n  .lg\\:focus\\:line-through:focus {\n    text-decoration: line-through;\n  }\n\n  .lg\\:focus\\:no-underline:focus {\n    text-decoration: none;\n  }\n\n  .lg\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  .lg\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n  }\n\n  .lg\\:ordinal, .lg\\:slashed-zero, .lg\\:lining-nums, .lg\\:oldstyle-nums, .lg\\:proportional-nums, .lg\\:tabular-nums, .lg\\:diagonal-fractions, .lg\\:stacked-fractions {\n    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);\n    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n  }\n\n  .lg\\:normal-nums {\n    font-variant-numeric: normal;\n  }\n\n  .lg\\:ordinal {\n    --font-variant-numeric-ordinal: ordinal;\n  }\n\n  .lg\\:slashed-zero {\n    --font-variant-numeric-slashed-zero: slashed-zero;\n  }\n\n  .lg\\:lining-nums {\n    --font-variant-numeric-figure: lining-nums;\n  }\n\n  .lg\\:oldstyle-nums {\n    --font-variant-numeric-figure: oldstyle-nums;\n  }\n\n  .lg\\:proportional-nums {\n    --font-variant-numeric-spacing: proportional-nums;\n  }\n\n  .lg\\:tabular-nums {\n    --font-variant-numeric-spacing: tabular-nums;\n  }\n\n  .lg\\:diagonal-fractions {\n    --font-variant-numeric-fraction: diagonal-fractions;\n  }\n\n  .lg\\:stacked-fractions {\n    --font-variant-numeric-fraction: stacked-fractions;\n  }\n\n  .lg\\:tracking-tighter {\n    letter-spacing: -0.05em;\n  }\n\n  .lg\\:tracking-tight {\n    letter-spacing: -0.025em;\n  }\n\n  .lg\\:tracking-normal {\n    letter-spacing: 0;\n  }\n\n  .lg\\:tracking-wide {\n    letter-spacing: 0.025em;\n  }\n\n  .lg\\:tracking-wider {\n    letter-spacing: 0.05em;\n  }\n\n  .lg\\:tracking-widest {\n    letter-spacing: 0.1em;\n  }\n\n  .lg\\:select-none {\n    -webkit-user-select: none;\n            user-select: none;\n  }\n\n  .lg\\:select-text {\n    -webkit-user-select: text;\n            user-select: text;\n  }\n\n  .lg\\:select-all {\n    -webkit-user-select: all;\n            user-select: all;\n  }\n\n  .lg\\:select-auto {\n    -webkit-user-select: auto;\n            user-select: auto;\n  }\n\n  .lg\\:align-baseline {\n    vertical-align: baseline;\n  }\n\n  .lg\\:align-top {\n    vertical-align: top;\n  }\n\n  .lg\\:align-middle {\n    vertical-align: middle;\n  }\n\n  .lg\\:align-bottom {\n    vertical-align: bottom;\n  }\n\n  .lg\\:align-text-top {\n    vertical-align: text-top;\n  }\n\n  .lg\\:align-text-bottom {\n    vertical-align: text-bottom;\n  }\n\n  .lg\\:visible {\n    visibility: visible;\n  }\n\n  .lg\\:invisible {\n    visibility: hidden;\n  }\n\n  .lg\\:whitespace-normal {\n    white-space: normal;\n  }\n\n  .lg\\:whitespace-no-wrap {\n    white-space: nowrap;\n  }\n\n  .lg\\:whitespace-pre {\n    white-space: pre;\n  }\n\n  .lg\\:whitespace-pre-line {\n    white-space: pre-line;\n  }\n\n  .lg\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n  }\n\n  .lg\\:break-normal {\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n\n  .lg\\:break-words {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  .lg\\:break-all {\n    word-break: break-all;\n  }\n\n  .lg\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .lg\\:w-0 {\n    width: 0;\n  }\n\n  .lg\\:w-1 {\n    width: 0.25rem;\n  }\n\n  .lg\\:w-2 {\n    width: 0.5rem;\n  }\n\n  .lg\\:w-3 {\n    width: 0.75rem;\n  }\n\n  .lg\\:w-4 {\n    width: 1rem;\n  }\n\n  .lg\\:w-5 {\n    width: 1.25rem;\n  }\n\n  .lg\\:w-6 {\n    width: 1.5rem;\n  }\n\n  .lg\\:w-8 {\n    width: 2rem;\n  }\n\n  .lg\\:w-10 {\n    width: 2.5rem;\n  }\n\n  .lg\\:w-12 {\n    width: 3rem;\n  }\n\n  .lg\\:w-16 {\n    width: 4rem;\n  }\n\n  .lg\\:w-20 {\n    width: 5rem;\n  }\n\n  .lg\\:w-24 {\n    width: 6rem;\n  }\n\n  .lg\\:w-32 {\n    width: 8rem;\n  }\n\n  .lg\\:w-40 {\n    width: 10rem;\n  }\n\n  .lg\\:w-48 {\n    width: 12rem;\n  }\n\n  .lg\\:w-56 {\n    width: 14rem;\n  }\n\n  .lg\\:w-64 {\n    width: 16rem;\n  }\n\n  .lg\\:w-auto {\n    width: auto;\n  }\n\n  .lg\\:w-px {\n    width: 1px;\n  }\n\n  .lg\\:w-1\\/2 {\n    width: 50%;\n  }\n\n  .lg\\:w-1\\/3 {\n    width: 33.333333%;\n  }\n\n  .lg\\:w-2\\/3 {\n    width: 66.666667%;\n  }\n\n  .lg\\:w-1\\/4 {\n    width: 25%;\n  }\n\n  .lg\\:w-2\\/4 {\n    width: 50%;\n  }\n\n  .lg\\:w-3\\/4 {\n    width: 75%;\n  }\n\n  .lg\\:w-1\\/5 {\n    width: 20%;\n  }\n\n  .lg\\:w-2\\/5 {\n    width: 40%;\n  }\n\n  .lg\\:w-3\\/5 {\n    width: 60%;\n  }\n\n  .lg\\:w-4\\/5 {\n    width: 80%;\n  }\n\n  .lg\\:w-1\\/6 {\n    width: 16.666667%;\n  }\n\n  .lg\\:w-2\\/6 {\n    width: 33.333333%;\n  }\n\n  .lg\\:w-3\\/6 {\n    width: 50%;\n  }\n\n  .lg\\:w-4\\/6 {\n    width: 66.666667%;\n  }\n\n  .lg\\:w-5\\/6 {\n    width: 83.333333%;\n  }\n\n  .lg\\:w-1\\/12 {\n    width: 8.333333%;\n  }\n\n  .lg\\:w-2\\/12 {\n    width: 16.666667%;\n  }\n\n  .lg\\:w-3\\/12 {\n    width: 25%;\n  }\n\n  .lg\\:w-4\\/12 {\n    width: 33.333333%;\n  }\n\n  .lg\\:w-5\\/12 {\n    width: 41.666667%;\n  }\n\n  .lg\\:w-6\\/12 {\n    width: 50%;\n  }\n\n  .lg\\:w-7\\/12 {\n    width: 58.333333%;\n  }\n\n  .lg\\:w-8\\/12 {\n    width: 66.666667%;\n  }\n\n  .lg\\:w-9\\/12 {\n    width: 75%;\n  }\n\n  .lg\\:w-10\\/12 {\n    width: 83.333333%;\n  }\n\n  .lg\\:w-11\\/12 {\n    width: 91.666667%;\n  }\n\n  .lg\\:w-full {\n    width: 100%;\n  }\n\n  .lg\\:w-screen {\n    width: 100vw;\n  }\n\n  .lg\\:z-0 {\n    z-index: 0;\n  }\n\n  .lg\\:z-10 {\n    z-index: 10;\n  }\n\n  .lg\\:z-20 {\n    z-index: 20;\n  }\n\n  .lg\\:z-30 {\n    z-index: 30;\n  }\n\n  .lg\\:z-40 {\n    z-index: 40;\n  }\n\n  .lg\\:z-50 {\n    z-index: 50;\n  }\n\n  .lg\\:z-auto {\n    z-index: auto;\n  }\n\n  .lg\\:gap-0 {\n    grid-gap: 0;\n    gap: 0;\n  }\n\n  .lg\\:gap-1 {\n    grid-gap: 0.25rem;\n    gap: 0.25rem;\n  }\n\n  .lg\\:gap-2 {\n    grid-gap: 0.5rem;\n    gap: 0.5rem;\n  }\n\n  .lg\\:gap-3 {\n    grid-gap: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .lg\\:gap-4 {\n    grid-gap: 1rem;\n    gap: 1rem;\n  }\n\n  .lg\\:gap-5 {\n    grid-gap: 1.25rem;\n    gap: 1.25rem;\n  }\n\n  .lg\\:gap-6 {\n    grid-gap: 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .lg\\:gap-8 {\n    grid-gap: 2rem;\n    gap: 2rem;\n  }\n\n  .lg\\:gap-10 {\n    grid-gap: 2.5rem;\n    gap: 2.5rem;\n  }\n\n  .lg\\:gap-12 {\n    grid-gap: 3rem;\n    gap: 3rem;\n  }\n\n  .lg\\:gap-16 {\n    grid-gap: 4rem;\n    gap: 4rem;\n  }\n\n  .lg\\:gap-20 {\n    grid-gap: 5rem;\n    gap: 5rem;\n  }\n\n  .lg\\:gap-24 {\n    grid-gap: 6rem;\n    gap: 6rem;\n  }\n\n  .lg\\:gap-32 {\n    grid-gap: 8rem;\n    gap: 8rem;\n  }\n\n  .lg\\:gap-40 {\n    grid-gap: 10rem;\n    gap: 10rem;\n  }\n\n  .lg\\:gap-48 {\n    grid-gap: 12rem;\n    gap: 12rem;\n  }\n\n  .lg\\:gap-56 {\n    grid-gap: 14rem;\n    gap: 14rem;\n  }\n\n  .lg\\:gap-64 {\n    grid-gap: 16rem;\n    gap: 16rem;\n  }\n\n  .lg\\:gap-px {\n    grid-gap: 1px;\n    gap: 1px;\n  }\n\n  .lg\\:col-gap-0 {\n    grid-column-gap: 0;\n    column-gap: 0;\n  }\n\n  .lg\\:col-gap-1 {\n    grid-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n\n  .lg\\:col-gap-2 {\n    grid-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n\n  .lg\\:col-gap-3 {\n    grid-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n\n  .lg\\:col-gap-4 {\n    grid-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n\n  .lg\\:col-gap-5 {\n    grid-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n\n  .lg\\:col-gap-6 {\n    grid-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n\n  .lg\\:col-gap-8 {\n    grid-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n\n  .lg\\:col-gap-10 {\n    grid-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n\n  .lg\\:col-gap-12 {\n    grid-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n\n  .lg\\:col-gap-16 {\n    grid-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n\n  .lg\\:col-gap-20 {\n    grid-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n\n  .lg\\:col-gap-24 {\n    grid-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n\n  .lg\\:col-gap-32 {\n    grid-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n\n  .lg\\:col-gap-40 {\n    grid-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n\n  .lg\\:col-gap-48 {\n    grid-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n\n  .lg\\:col-gap-56 {\n    grid-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n\n  .lg\\:col-gap-64 {\n    grid-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n\n  .lg\\:col-gap-px {\n    grid-column-gap: 1px;\n    column-gap: 1px;\n  }\n\n  .lg\\:gap-x-0 {\n    grid-column-gap: 0;\n    column-gap: 0;\n  }\n\n  .lg\\:gap-x-1 {\n    grid-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n\n  .lg\\:gap-x-2 {\n    grid-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n\n  .lg\\:gap-x-3 {\n    grid-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n\n  .lg\\:gap-x-4 {\n    grid-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n\n  .lg\\:gap-x-5 {\n    grid-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n\n  .lg\\:gap-x-6 {\n    grid-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n\n  .lg\\:gap-x-8 {\n    grid-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n\n  .lg\\:gap-x-10 {\n    grid-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n\n  .lg\\:gap-x-12 {\n    grid-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n\n  .lg\\:gap-x-16 {\n    grid-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n\n  .lg\\:gap-x-20 {\n    grid-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n\n  .lg\\:gap-x-24 {\n    grid-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n\n  .lg\\:gap-x-32 {\n    grid-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n\n  .lg\\:gap-x-40 {\n    grid-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n\n  .lg\\:gap-x-48 {\n    grid-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n\n  .lg\\:gap-x-56 {\n    grid-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n\n  .lg\\:gap-x-64 {\n    grid-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n\n  .lg\\:gap-x-px {\n    grid-column-gap: 1px;\n    column-gap: 1px;\n  }\n\n  .lg\\:row-gap-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n\n  .lg\\:row-gap-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n\n  .lg\\:row-gap-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n\n  .lg\\:row-gap-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n\n  .lg\\:row-gap-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n\n  .lg\\:row-gap-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n\n  .lg\\:row-gap-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n\n  .lg\\:row-gap-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n\n  .lg\\:row-gap-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n\n  .lg\\:row-gap-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n\n  .lg\\:row-gap-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n\n  .lg\\:row-gap-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n\n  .lg\\:row-gap-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n\n  .lg\\:row-gap-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n\n  .lg\\:row-gap-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n\n  .lg\\:row-gap-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n\n  .lg\\:row-gap-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n\n  .lg\\:row-gap-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n\n  .lg\\:row-gap-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n\n  .lg\\:gap-y-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n\n  .lg\\:gap-y-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n\n  .lg\\:gap-y-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n\n  .lg\\:gap-y-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n\n  .lg\\:gap-y-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n\n  .lg\\:gap-y-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n\n  .lg\\:gap-y-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n\n  .lg\\:gap-y-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n\n  .lg\\:gap-y-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n\n  .lg\\:gap-y-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n\n  .lg\\:gap-y-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n\n  .lg\\:gap-y-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n\n  .lg\\:gap-y-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n\n  .lg\\:gap-y-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n\n  .lg\\:gap-y-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n\n  .lg\\:gap-y-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n\n  .lg\\:gap-y-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n\n  .lg\\:gap-y-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n\n  .lg\\:gap-y-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n\n  .lg\\:grid-flow-row {\n    grid-auto-flow: row;\n  }\n\n  .lg\\:grid-flow-col {\n    grid-auto-flow: column;\n  }\n\n  .lg\\:grid-flow-row-dense {\n    grid-auto-flow: row dense;\n  }\n\n  .lg\\:grid-flow-col-dense {\n    grid-auto-flow: column dense;\n  }\n\n  .lg\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-cols-none {\n    grid-template-columns: none;\n  }\n\n  .lg\\:auto-cols-auto {\n    grid-auto-columns: auto;\n  }\n\n  .lg\\:auto-cols-min {\n    grid-auto-columns: min-content;\n  }\n\n  .lg\\:auto-cols-max {\n    grid-auto-columns: max-content;\n  }\n\n  .lg\\:auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n  }\n\n  .lg\\:col-auto {\n    grid-column: auto;\n  }\n\n  .lg\\:col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n\n  .lg\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n\n  .lg\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n\n  .lg\\:col-span-4 {\n    grid-column: span 4 / span 4;\n  }\n\n  .lg\\:col-span-5 {\n    grid-column: span 5 / span 5;\n  }\n\n  .lg\\:col-span-6 {\n    grid-column: span 6 / span 6;\n  }\n\n  .lg\\:col-span-7 {\n    grid-column: span 7 / span 7;\n  }\n\n  .lg\\:col-span-8 {\n    grid-column: span 8 / span 8;\n  }\n\n  .lg\\:col-span-9 {\n    grid-column: span 9 / span 9;\n  }\n\n  .lg\\:col-span-10 {\n    grid-column: span 10 / span 10;\n  }\n\n  .lg\\:col-span-11 {\n    grid-column: span 11 / span 11;\n  }\n\n  .lg\\:col-span-12 {\n    grid-column: span 12 / span 12;\n  }\n\n  .lg\\:col-span-full {\n    grid-column: 1 / -1;\n  }\n\n  .lg\\:col-start-1 {\n    grid-column-start: 1;\n  }\n\n  .lg\\:col-start-2 {\n    grid-column-start: 2;\n  }\n\n  .lg\\:col-start-3 {\n    grid-column-start: 3;\n  }\n\n  .lg\\:col-start-4 {\n    grid-column-start: 4;\n  }\n\n  .lg\\:col-start-5 {\n    grid-column-start: 5;\n  }\n\n  .lg\\:col-start-6 {\n    grid-column-start: 6;\n  }\n\n  .lg\\:col-start-7 {\n    grid-column-start: 7;\n  }\n\n  .lg\\:col-start-8 {\n    grid-column-start: 8;\n  }\n\n  .lg\\:col-start-9 {\n    grid-column-start: 9;\n  }\n\n  .lg\\:col-start-10 {\n    grid-column-start: 10;\n  }\n\n  .lg\\:col-start-11 {\n    grid-column-start: 11;\n  }\n\n  .lg\\:col-start-12 {\n    grid-column-start: 12;\n  }\n\n  .lg\\:col-start-13 {\n    grid-column-start: 13;\n  }\n\n  .lg\\:col-start-auto {\n    grid-column-start: auto;\n  }\n\n  .lg\\:col-end-1 {\n    grid-column-end: 1;\n  }\n\n  .lg\\:col-end-2 {\n    grid-column-end: 2;\n  }\n\n  .lg\\:col-end-3 {\n    grid-column-end: 3;\n  }\n\n  .lg\\:col-end-4 {\n    grid-column-end: 4;\n  }\n\n  .lg\\:col-end-5 {\n    grid-column-end: 5;\n  }\n\n  .lg\\:col-end-6 {\n    grid-column-end: 6;\n  }\n\n  .lg\\:col-end-7 {\n    grid-column-end: 7;\n  }\n\n  .lg\\:col-end-8 {\n    grid-column-end: 8;\n  }\n\n  .lg\\:col-end-9 {\n    grid-column-end: 9;\n  }\n\n  .lg\\:col-end-10 {\n    grid-column-end: 10;\n  }\n\n  .lg\\:col-end-11 {\n    grid-column-end: 11;\n  }\n\n  .lg\\:col-end-12 {\n    grid-column-end: 12;\n  }\n\n  .lg\\:col-end-13 {\n    grid-column-end: 13;\n  }\n\n  .lg\\:col-end-auto {\n    grid-column-end: auto;\n  }\n\n  .lg\\:grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n  }\n\n  .lg\\:grid-rows-none {\n    grid-template-rows: none;\n  }\n\n  .lg\\:auto-rows-auto {\n    grid-auto-rows: auto;\n  }\n\n  .lg\\:auto-rows-min {\n    grid-auto-rows: min-content;\n  }\n\n  .lg\\:auto-rows-max {\n    grid-auto-rows: max-content;\n  }\n\n  .lg\\:auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n  }\n\n  .lg\\:row-auto {\n    grid-row: auto;\n  }\n\n  .lg\\:row-span-1 {\n    grid-row: span 1 / span 1;\n  }\n\n  .lg\\:row-span-2 {\n    grid-row: span 2 / span 2;\n  }\n\n  .lg\\:row-span-3 {\n    grid-row: span 3 / span 3;\n  }\n\n  .lg\\:row-span-4 {\n    grid-row: span 4 / span 4;\n  }\n\n  .lg\\:row-span-5 {\n    grid-row: span 5 / span 5;\n  }\n\n  .lg\\:row-span-6 {\n    grid-row: span 6 / span 6;\n  }\n\n  .lg\\:row-span-full {\n    grid-row: 1 / -1;\n  }\n\n  .lg\\:row-start-1 {\n    grid-row-start: 1;\n  }\n\n  .lg\\:row-start-2 {\n    grid-row-start: 2;\n  }\n\n  .lg\\:row-start-3 {\n    grid-row-start: 3;\n  }\n\n  .lg\\:row-start-4 {\n    grid-row-start: 4;\n  }\n\n  .lg\\:row-start-5 {\n    grid-row-start: 5;\n  }\n\n  .lg\\:row-start-6 {\n    grid-row-start: 6;\n  }\n\n  .lg\\:row-start-7 {\n    grid-row-start: 7;\n  }\n\n  .lg\\:row-start-auto {\n    grid-row-start: auto;\n  }\n\n  .lg\\:row-end-1 {\n    grid-row-end: 1;\n  }\n\n  .lg\\:row-end-2 {\n    grid-row-end: 2;\n  }\n\n  .lg\\:row-end-3 {\n    grid-row-end: 3;\n  }\n\n  .lg\\:row-end-4 {\n    grid-row-end: 4;\n  }\n\n  .lg\\:row-end-5 {\n    grid-row-end: 5;\n  }\n\n  .lg\\:row-end-6 {\n    grid-row-end: 6;\n  }\n\n  .lg\\:row-end-7 {\n    grid-row-end: 7;\n  }\n\n  .lg\\:row-end-auto {\n    grid-row-end: auto;\n  }\n\n  .lg\\:transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n  }\n\n  .lg\\:transform-none {\n    transform: none;\n  }\n\n  .lg\\:origin-center {\n    transform-origin: center;\n  }\n\n  .lg\\:origin-top {\n    transform-origin: top;\n  }\n\n  .lg\\:origin-top-right {\n    transform-origin: top right;\n  }\n\n  .lg\\:origin-right {\n    transform-origin: right;\n  }\n\n  .lg\\:origin-bottom-right {\n    transform-origin: bottom right;\n  }\n\n  .lg\\:origin-bottom {\n    transform-origin: bottom;\n  }\n\n  .lg\\:origin-bottom-left {\n    transform-origin: bottom left;\n  }\n\n  .lg\\:origin-left {\n    transform-origin: left;\n  }\n\n  .lg\\:origin-top-left {\n    transform-origin: top left;\n  }\n\n  .lg\\:scale-0 {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .lg\\:scale-50 {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .lg\\:scale-75 {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .lg\\:scale-90 {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .lg\\:scale-95 {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .lg\\:scale-100 {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .lg\\:scale-105 {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .lg\\:scale-110 {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .lg\\:scale-125 {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .lg\\:scale-150 {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .lg\\:scale-x-0 {\n    --transform-scale-x: 0;\n  }\n\n  .lg\\:scale-x-50 {\n    --transform-scale-x: .5;\n  }\n\n  .lg\\:scale-x-75 {\n    --transform-scale-x: .75;\n  }\n\n  .lg\\:scale-x-90 {\n    --transform-scale-x: .9;\n  }\n\n  .lg\\:scale-x-95 {\n    --transform-scale-x: .95;\n  }\n\n  .lg\\:scale-x-100 {\n    --transform-scale-x: 1;\n  }\n\n  .lg\\:scale-x-105 {\n    --transform-scale-x: 1.05;\n  }\n\n  .lg\\:scale-x-110 {\n    --transform-scale-x: 1.1;\n  }\n\n  .lg\\:scale-x-125 {\n    --transform-scale-x: 1.25;\n  }\n\n  .lg\\:scale-x-150 {\n    --transform-scale-x: 1.5;\n  }\n\n  .lg\\:scale-y-0 {\n    --transform-scale-y: 0;\n  }\n\n  .lg\\:scale-y-50 {\n    --transform-scale-y: .5;\n  }\n\n  .lg\\:scale-y-75 {\n    --transform-scale-y: .75;\n  }\n\n  .lg\\:scale-y-90 {\n    --transform-scale-y: .9;\n  }\n\n  .lg\\:scale-y-95 {\n    --transform-scale-y: .95;\n  }\n\n  .lg\\:scale-y-100 {\n    --transform-scale-y: 1;\n  }\n\n  .lg\\:scale-y-105 {\n    --transform-scale-y: 1.05;\n  }\n\n  .lg\\:scale-y-110 {\n    --transform-scale-y: 1.1;\n  }\n\n  .lg\\:scale-y-125 {\n    --transform-scale-y: 1.25;\n  }\n\n  .lg\\:scale-y-150 {\n    --transform-scale-y: 1.5;\n  }\n\n  .lg\\:hover\\:scale-0:hover {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .lg\\:hover\\:scale-50:hover {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .lg\\:hover\\:scale-75:hover {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .lg\\:hover\\:scale-90:hover {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .lg\\:hover\\:scale-95:hover {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .lg\\:hover\\:scale-100:hover {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .lg\\:hover\\:scale-105:hover {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .lg\\:hover\\:scale-110:hover {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .lg\\:hover\\:scale-125:hover {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .lg\\:hover\\:scale-150:hover {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .lg\\:hover\\:scale-x-0:hover {\n    --transform-scale-x: 0;\n  }\n\n  .lg\\:hover\\:scale-x-50:hover {\n    --transform-scale-x: .5;\n  }\n\n  .lg\\:hover\\:scale-x-75:hover {\n    --transform-scale-x: .75;\n  }\n\n  .lg\\:hover\\:scale-x-90:hover {\n    --transform-scale-x: .9;\n  }\n\n  .lg\\:hover\\:scale-x-95:hover {\n    --transform-scale-x: .95;\n  }\n\n  .lg\\:hover\\:scale-x-100:hover {\n    --transform-scale-x: 1;\n  }\n\n  .lg\\:hover\\:scale-x-105:hover {\n    --transform-scale-x: 1.05;\n  }\n\n  .lg\\:hover\\:scale-x-110:hover {\n    --transform-scale-x: 1.1;\n  }\n\n  .lg\\:hover\\:scale-x-125:hover {\n    --transform-scale-x: 1.25;\n  }\n\n  .lg\\:hover\\:scale-x-150:hover {\n    --transform-scale-x: 1.5;\n  }\n\n  .lg\\:hover\\:scale-y-0:hover {\n    --transform-scale-y: 0;\n  }\n\n  .lg\\:hover\\:scale-y-50:hover {\n    --transform-scale-y: .5;\n  }\n\n  .lg\\:hover\\:scale-y-75:hover {\n    --transform-scale-y: .75;\n  }\n\n  .lg\\:hover\\:scale-y-90:hover {\n    --transform-scale-y: .9;\n  }\n\n  .lg\\:hover\\:scale-y-95:hover {\n    --transform-scale-y: .95;\n  }\n\n  .lg\\:hover\\:scale-y-100:hover {\n    --transform-scale-y: 1;\n  }\n\n  .lg\\:hover\\:scale-y-105:hover {\n    --transform-scale-y: 1.05;\n  }\n\n  .lg\\:hover\\:scale-y-110:hover {\n    --transform-scale-y: 1.1;\n  }\n\n  .lg\\:hover\\:scale-y-125:hover {\n    --transform-scale-y: 1.25;\n  }\n\n  .lg\\:hover\\:scale-y-150:hover {\n    --transform-scale-y: 1.5;\n  }\n\n  .lg\\:focus\\:scale-0:focus {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .lg\\:focus\\:scale-50:focus {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .lg\\:focus\\:scale-75:focus {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .lg\\:focus\\:scale-90:focus {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .lg\\:focus\\:scale-95:focus {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .lg\\:focus\\:scale-100:focus {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .lg\\:focus\\:scale-105:focus {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .lg\\:focus\\:scale-110:focus {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .lg\\:focus\\:scale-125:focus {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .lg\\:focus\\:scale-150:focus {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .lg\\:focus\\:scale-x-0:focus {\n    --transform-scale-x: 0;\n  }\n\n  .lg\\:focus\\:scale-x-50:focus {\n    --transform-scale-x: .5;\n  }\n\n  .lg\\:focus\\:scale-x-75:focus {\n    --transform-scale-x: .75;\n  }\n\n  .lg\\:focus\\:scale-x-90:focus {\n    --transform-scale-x: .9;\n  }\n\n  .lg\\:focus\\:scale-x-95:focus {\n    --transform-scale-x: .95;\n  }\n\n  .lg\\:focus\\:scale-x-100:focus {\n    --transform-scale-x: 1;\n  }\n\n  .lg\\:focus\\:scale-x-105:focus {\n    --transform-scale-x: 1.05;\n  }\n\n  .lg\\:focus\\:scale-x-110:focus {\n    --transform-scale-x: 1.1;\n  }\n\n  .lg\\:focus\\:scale-x-125:focus {\n    --transform-scale-x: 1.25;\n  }\n\n  .lg\\:focus\\:scale-x-150:focus {\n    --transform-scale-x: 1.5;\n  }\n\n  .lg\\:focus\\:scale-y-0:focus {\n    --transform-scale-y: 0;\n  }\n\n  .lg\\:focus\\:scale-y-50:focus {\n    --transform-scale-y: .5;\n  }\n\n  .lg\\:focus\\:scale-y-75:focus {\n    --transform-scale-y: .75;\n  }\n\n  .lg\\:focus\\:scale-y-90:focus {\n    --transform-scale-y: .9;\n  }\n\n  .lg\\:focus\\:scale-y-95:focus {\n    --transform-scale-y: .95;\n  }\n\n  .lg\\:focus\\:scale-y-100:focus {\n    --transform-scale-y: 1;\n  }\n\n  .lg\\:focus\\:scale-y-105:focus {\n    --transform-scale-y: 1.05;\n  }\n\n  .lg\\:focus\\:scale-y-110:focus {\n    --transform-scale-y: 1.1;\n  }\n\n  .lg\\:focus\\:scale-y-125:focus {\n    --transform-scale-y: 1.25;\n  }\n\n  .lg\\:focus\\:scale-y-150:focus {\n    --transform-scale-y: 1.5;\n  }\n\n  .lg\\:rotate-0 {\n    --transform-rotate: 0;\n  }\n\n  .lg\\:rotate-1 {\n    --transform-rotate: 1deg;\n  }\n\n  .lg\\:rotate-2 {\n    --transform-rotate: 2deg;\n  }\n\n  .lg\\:rotate-3 {\n    --transform-rotate: 3deg;\n  }\n\n  .lg\\:rotate-6 {\n    --transform-rotate: 6deg;\n  }\n\n  .lg\\:rotate-12 {\n    --transform-rotate: 12deg;\n  }\n\n  .lg\\:rotate-45 {\n    --transform-rotate: 45deg;\n  }\n\n  .lg\\:rotate-90 {\n    --transform-rotate: 90deg;\n  }\n\n  .lg\\:rotate-180 {\n    --transform-rotate: 180deg;\n  }\n\n  .lg\\:-rotate-180 {\n    --transform-rotate: -180deg;\n  }\n\n  .lg\\:-rotate-90 {\n    --transform-rotate: -90deg;\n  }\n\n  .lg\\:-rotate-45 {\n    --transform-rotate: -45deg;\n  }\n\n  .lg\\:-rotate-12 {\n    --transform-rotate: -12deg;\n  }\n\n  .lg\\:-rotate-6 {\n    --transform-rotate: -6deg;\n  }\n\n  .lg\\:-rotate-3 {\n    --transform-rotate: -3deg;\n  }\n\n  .lg\\:-rotate-2 {\n    --transform-rotate: -2deg;\n  }\n\n  .lg\\:-rotate-1 {\n    --transform-rotate: -1deg;\n  }\n\n  .lg\\:hover\\:rotate-0:hover {\n    --transform-rotate: 0;\n  }\n\n  .lg\\:hover\\:rotate-1:hover {\n    --transform-rotate: 1deg;\n  }\n\n  .lg\\:hover\\:rotate-2:hover {\n    --transform-rotate: 2deg;\n  }\n\n  .lg\\:hover\\:rotate-3:hover {\n    --transform-rotate: 3deg;\n  }\n\n  .lg\\:hover\\:rotate-6:hover {\n    --transform-rotate: 6deg;\n  }\n\n  .lg\\:hover\\:rotate-12:hover {\n    --transform-rotate: 12deg;\n  }\n\n  .lg\\:hover\\:rotate-45:hover {\n    --transform-rotate: 45deg;\n  }\n\n  .lg\\:hover\\:rotate-90:hover {\n    --transform-rotate: 90deg;\n  }\n\n  .lg\\:hover\\:rotate-180:hover {\n    --transform-rotate: 180deg;\n  }\n\n  .lg\\:hover\\:-rotate-180:hover {\n    --transform-rotate: -180deg;\n  }\n\n  .lg\\:hover\\:-rotate-90:hover {\n    --transform-rotate: -90deg;\n  }\n\n  .lg\\:hover\\:-rotate-45:hover {\n    --transform-rotate: -45deg;\n  }\n\n  .lg\\:hover\\:-rotate-12:hover {\n    --transform-rotate: -12deg;\n  }\n\n  .lg\\:hover\\:-rotate-6:hover {\n    --transform-rotate: -6deg;\n  }\n\n  .lg\\:hover\\:-rotate-3:hover {\n    --transform-rotate: -3deg;\n  }\n\n  .lg\\:hover\\:-rotate-2:hover {\n    --transform-rotate: -2deg;\n  }\n\n  .lg\\:hover\\:-rotate-1:hover {\n    --transform-rotate: -1deg;\n  }\n\n  .lg\\:focus\\:rotate-0:focus {\n    --transform-rotate: 0;\n  }\n\n  .lg\\:focus\\:rotate-1:focus {\n    --transform-rotate: 1deg;\n  }\n\n  .lg\\:focus\\:rotate-2:focus {\n    --transform-rotate: 2deg;\n  }\n\n  .lg\\:focus\\:rotate-3:focus {\n    --transform-rotate: 3deg;\n  }\n\n  .lg\\:focus\\:rotate-6:focus {\n    --transform-rotate: 6deg;\n  }\n\n  .lg\\:focus\\:rotate-12:focus {\n    --transform-rotate: 12deg;\n  }\n\n  .lg\\:focus\\:rotate-45:focus {\n    --transform-rotate: 45deg;\n  }\n\n  .lg\\:focus\\:rotate-90:focus {\n    --transform-rotate: 90deg;\n  }\n\n  .lg\\:focus\\:rotate-180:focus {\n    --transform-rotate: 180deg;\n  }\n\n  .lg\\:focus\\:-rotate-180:focus {\n    --transform-rotate: -180deg;\n  }\n\n  .lg\\:focus\\:-rotate-90:focus {\n    --transform-rotate: -90deg;\n  }\n\n  .lg\\:focus\\:-rotate-45:focus {\n    --transform-rotate: -45deg;\n  }\n\n  .lg\\:focus\\:-rotate-12:focus {\n    --transform-rotate: -12deg;\n  }\n\n  .lg\\:focus\\:-rotate-6:focus {\n    --transform-rotate: -6deg;\n  }\n\n  .lg\\:focus\\:-rotate-3:focus {\n    --transform-rotate: -3deg;\n  }\n\n  .lg\\:focus\\:-rotate-2:focus {\n    --transform-rotate: -2deg;\n  }\n\n  .lg\\:focus\\:-rotate-1:focus {\n    --transform-rotate: -1deg;\n  }\n\n  .lg\\:translate-x-0 {\n    --transform-translate-x: 0;\n  }\n\n  .lg\\:translate-x-1 {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .lg\\:translate-x-2 {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .lg\\:translate-x-3 {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .lg\\:translate-x-4 {\n    --transform-translate-x: 1rem;\n  }\n\n  .lg\\:translate-x-5 {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .lg\\:translate-x-6 {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .lg\\:translate-x-8 {\n    --transform-translate-x: 2rem;\n  }\n\n  .lg\\:translate-x-10 {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .lg\\:translate-x-12 {\n    --transform-translate-x: 3rem;\n  }\n\n  .lg\\:translate-x-16 {\n    --transform-translate-x: 4rem;\n  }\n\n  .lg\\:translate-x-20 {\n    --transform-translate-x: 5rem;\n  }\n\n  .lg\\:translate-x-24 {\n    --transform-translate-x: 6rem;\n  }\n\n  .lg\\:translate-x-32 {\n    --transform-translate-x: 8rem;\n  }\n\n  .lg\\:translate-x-40 {\n    --transform-translate-x: 10rem;\n  }\n\n  .lg\\:translate-x-48 {\n    --transform-translate-x: 12rem;\n  }\n\n  .lg\\:translate-x-56 {\n    --transform-translate-x: 14rem;\n  }\n\n  .lg\\:translate-x-64 {\n    --transform-translate-x: 16rem;\n  }\n\n  .lg\\:translate-x-px {\n    --transform-translate-x: 1px;\n  }\n\n  .lg\\:-translate-x-1 {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .lg\\:-translate-x-2 {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .lg\\:-translate-x-3 {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .lg\\:-translate-x-4 {\n    --transform-translate-x: -1rem;\n  }\n\n  .lg\\:-translate-x-5 {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .lg\\:-translate-x-6 {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .lg\\:-translate-x-8 {\n    --transform-translate-x: -2rem;\n  }\n\n  .lg\\:-translate-x-10 {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .lg\\:-translate-x-12 {\n    --transform-translate-x: -3rem;\n  }\n\n  .lg\\:-translate-x-16 {\n    --transform-translate-x: -4rem;\n  }\n\n  .lg\\:-translate-x-20 {\n    --transform-translate-x: -5rem;\n  }\n\n  .lg\\:-translate-x-24 {\n    --transform-translate-x: -6rem;\n  }\n\n  .lg\\:-translate-x-32 {\n    --transform-translate-x: -8rem;\n  }\n\n  .lg\\:-translate-x-40 {\n    --transform-translate-x: -10rem;\n  }\n\n  .lg\\:-translate-x-48 {\n    --transform-translate-x: -12rem;\n  }\n\n  .lg\\:-translate-x-56 {\n    --transform-translate-x: -14rem;\n  }\n\n  .lg\\:-translate-x-64 {\n    --transform-translate-x: -16rem;\n  }\n\n  .lg\\:-translate-x-px {\n    --transform-translate-x: -1px;\n  }\n\n  .lg\\:-translate-x-full {\n    --transform-translate-x: -100%;\n  }\n\n  .lg\\:-translate-x-1\\/2 {\n    --transform-translate-x: -50%;\n  }\n\n  .lg\\:translate-x-1\\/2 {\n    --transform-translate-x: 50%;\n  }\n\n  .lg\\:translate-x-full {\n    --transform-translate-x: 100%;\n  }\n\n  .lg\\:translate-y-0 {\n    --transform-translate-y: 0;\n  }\n\n  .lg\\:translate-y-1 {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .lg\\:translate-y-2 {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .lg\\:translate-y-3 {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .lg\\:translate-y-4 {\n    --transform-translate-y: 1rem;\n  }\n\n  .lg\\:translate-y-5 {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .lg\\:translate-y-6 {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .lg\\:translate-y-8 {\n    --transform-translate-y: 2rem;\n  }\n\n  .lg\\:translate-y-10 {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .lg\\:translate-y-12 {\n    --transform-translate-y: 3rem;\n  }\n\n  .lg\\:translate-y-16 {\n    --transform-translate-y: 4rem;\n  }\n\n  .lg\\:translate-y-20 {\n    --transform-translate-y: 5rem;\n  }\n\n  .lg\\:translate-y-24 {\n    --transform-translate-y: 6rem;\n  }\n\n  .lg\\:translate-y-32 {\n    --transform-translate-y: 8rem;\n  }\n\n  .lg\\:translate-y-40 {\n    --transform-translate-y: 10rem;\n  }\n\n  .lg\\:translate-y-48 {\n    --transform-translate-y: 12rem;\n  }\n\n  .lg\\:translate-y-56 {\n    --transform-translate-y: 14rem;\n  }\n\n  .lg\\:translate-y-64 {\n    --transform-translate-y: 16rem;\n  }\n\n  .lg\\:translate-y-px {\n    --transform-translate-y: 1px;\n  }\n\n  .lg\\:-translate-y-1 {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .lg\\:-translate-y-2 {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .lg\\:-translate-y-3 {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .lg\\:-translate-y-4 {\n    --transform-translate-y: -1rem;\n  }\n\n  .lg\\:-translate-y-5 {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .lg\\:-translate-y-6 {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .lg\\:-translate-y-8 {\n    --transform-translate-y: -2rem;\n  }\n\n  .lg\\:-translate-y-10 {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .lg\\:-translate-y-12 {\n    --transform-translate-y: -3rem;\n  }\n\n  .lg\\:-translate-y-16 {\n    --transform-translate-y: -4rem;\n  }\n\n  .lg\\:-translate-y-20 {\n    --transform-translate-y: -5rem;\n  }\n\n  .lg\\:-translate-y-24 {\n    --transform-translate-y: -6rem;\n  }\n\n  .lg\\:-translate-y-32 {\n    --transform-translate-y: -8rem;\n  }\n\n  .lg\\:-translate-y-40 {\n    --transform-translate-y: -10rem;\n  }\n\n  .lg\\:-translate-y-48 {\n    --transform-translate-y: -12rem;\n  }\n\n  .lg\\:-translate-y-56 {\n    --transform-translate-y: -14rem;\n  }\n\n  .lg\\:-translate-y-64 {\n    --transform-translate-y: -16rem;\n  }\n\n  .lg\\:-translate-y-px {\n    --transform-translate-y: -1px;\n  }\n\n  .lg\\:-translate-y-full {\n    --transform-translate-y: -100%;\n  }\n\n  .lg\\:-translate-y-1\\/2 {\n    --transform-translate-y: -50%;\n  }\n\n  .lg\\:translate-y-1\\/2 {\n    --transform-translate-y: 50%;\n  }\n\n  .lg\\:translate-y-full {\n    --transform-translate-y: 100%;\n  }\n\n  .lg\\:hover\\:translate-x-0:hover {\n    --transform-translate-x: 0;\n  }\n\n  .lg\\:hover\\:translate-x-1:hover {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .lg\\:hover\\:translate-x-2:hover {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .lg\\:hover\\:translate-x-3:hover {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .lg\\:hover\\:translate-x-4:hover {\n    --transform-translate-x: 1rem;\n  }\n\n  .lg\\:hover\\:translate-x-5:hover {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .lg\\:hover\\:translate-x-6:hover {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .lg\\:hover\\:translate-x-8:hover {\n    --transform-translate-x: 2rem;\n  }\n\n  .lg\\:hover\\:translate-x-10:hover {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .lg\\:hover\\:translate-x-12:hover {\n    --transform-translate-x: 3rem;\n  }\n\n  .lg\\:hover\\:translate-x-16:hover {\n    --transform-translate-x: 4rem;\n  }\n\n  .lg\\:hover\\:translate-x-20:hover {\n    --transform-translate-x: 5rem;\n  }\n\n  .lg\\:hover\\:translate-x-24:hover {\n    --transform-translate-x: 6rem;\n  }\n\n  .lg\\:hover\\:translate-x-32:hover {\n    --transform-translate-x: 8rem;\n  }\n\n  .lg\\:hover\\:translate-x-40:hover {\n    --transform-translate-x: 10rem;\n  }\n\n  .lg\\:hover\\:translate-x-48:hover {\n    --transform-translate-x: 12rem;\n  }\n\n  .lg\\:hover\\:translate-x-56:hover {\n    --transform-translate-x: 14rem;\n  }\n\n  .lg\\:hover\\:translate-x-64:hover {\n    --transform-translate-x: 16rem;\n  }\n\n  .lg\\:hover\\:translate-x-px:hover {\n    --transform-translate-x: 1px;\n  }\n\n  .lg\\:hover\\:-translate-x-1:hover {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .lg\\:hover\\:-translate-x-2:hover {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .lg\\:hover\\:-translate-x-3:hover {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .lg\\:hover\\:-translate-x-4:hover {\n    --transform-translate-x: -1rem;\n  }\n\n  .lg\\:hover\\:-translate-x-5:hover {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .lg\\:hover\\:-translate-x-6:hover {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .lg\\:hover\\:-translate-x-8:hover {\n    --transform-translate-x: -2rem;\n  }\n\n  .lg\\:hover\\:-translate-x-10:hover {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .lg\\:hover\\:-translate-x-12:hover {\n    --transform-translate-x: -3rem;\n  }\n\n  .lg\\:hover\\:-translate-x-16:hover {\n    --transform-translate-x: -4rem;\n  }\n\n  .lg\\:hover\\:-translate-x-20:hover {\n    --transform-translate-x: -5rem;\n  }\n\n  .lg\\:hover\\:-translate-x-24:hover {\n    --transform-translate-x: -6rem;\n  }\n\n  .lg\\:hover\\:-translate-x-32:hover {\n    --transform-translate-x: -8rem;\n  }\n\n  .lg\\:hover\\:-translate-x-40:hover {\n    --transform-translate-x: -10rem;\n  }\n\n  .lg\\:hover\\:-translate-x-48:hover {\n    --transform-translate-x: -12rem;\n  }\n\n  .lg\\:hover\\:-translate-x-56:hover {\n    --transform-translate-x: -14rem;\n  }\n\n  .lg\\:hover\\:-translate-x-64:hover {\n    --transform-translate-x: -16rem;\n  }\n\n  .lg\\:hover\\:-translate-x-px:hover {\n    --transform-translate-x: -1px;\n  }\n\n  .lg\\:hover\\:-translate-x-full:hover {\n    --transform-translate-x: -100%;\n  }\n\n  .lg\\:hover\\:-translate-x-1\\/2:hover {\n    --transform-translate-x: -50%;\n  }\n\n  .lg\\:hover\\:translate-x-1\\/2:hover {\n    --transform-translate-x: 50%;\n  }\n\n  .lg\\:hover\\:translate-x-full:hover {\n    --transform-translate-x: 100%;\n  }\n\n  .lg\\:hover\\:translate-y-0:hover {\n    --transform-translate-y: 0;\n  }\n\n  .lg\\:hover\\:translate-y-1:hover {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .lg\\:hover\\:translate-y-2:hover {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .lg\\:hover\\:translate-y-3:hover {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .lg\\:hover\\:translate-y-4:hover {\n    --transform-translate-y: 1rem;\n  }\n\n  .lg\\:hover\\:translate-y-5:hover {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .lg\\:hover\\:translate-y-6:hover {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .lg\\:hover\\:translate-y-8:hover {\n    --transform-translate-y: 2rem;\n  }\n\n  .lg\\:hover\\:translate-y-10:hover {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .lg\\:hover\\:translate-y-12:hover {\n    --transform-translate-y: 3rem;\n  }\n\n  .lg\\:hover\\:translate-y-16:hover {\n    --transform-translate-y: 4rem;\n  }\n\n  .lg\\:hover\\:translate-y-20:hover {\n    --transform-translate-y: 5rem;\n  }\n\n  .lg\\:hover\\:translate-y-24:hover {\n    --transform-translate-y: 6rem;\n  }\n\n  .lg\\:hover\\:translate-y-32:hover {\n    --transform-translate-y: 8rem;\n  }\n\n  .lg\\:hover\\:translate-y-40:hover {\n    --transform-translate-y: 10rem;\n  }\n\n  .lg\\:hover\\:translate-y-48:hover {\n    --transform-translate-y: 12rem;\n  }\n\n  .lg\\:hover\\:translate-y-56:hover {\n    --transform-translate-y: 14rem;\n  }\n\n  .lg\\:hover\\:translate-y-64:hover {\n    --transform-translate-y: 16rem;\n  }\n\n  .lg\\:hover\\:translate-y-px:hover {\n    --transform-translate-y: 1px;\n  }\n\n  .lg\\:hover\\:-translate-y-1:hover {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .lg\\:hover\\:-translate-y-2:hover {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .lg\\:hover\\:-translate-y-3:hover {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .lg\\:hover\\:-translate-y-4:hover {\n    --transform-translate-y: -1rem;\n  }\n\n  .lg\\:hover\\:-translate-y-5:hover {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .lg\\:hover\\:-translate-y-6:hover {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .lg\\:hover\\:-translate-y-8:hover {\n    --transform-translate-y: -2rem;\n  }\n\n  .lg\\:hover\\:-translate-y-10:hover {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .lg\\:hover\\:-translate-y-12:hover {\n    --transform-translate-y: -3rem;\n  }\n\n  .lg\\:hover\\:-translate-y-16:hover {\n    --transform-translate-y: -4rem;\n  }\n\n  .lg\\:hover\\:-translate-y-20:hover {\n    --transform-translate-y: -5rem;\n  }\n\n  .lg\\:hover\\:-translate-y-24:hover {\n    --transform-translate-y: -6rem;\n  }\n\n  .lg\\:hover\\:-translate-y-32:hover {\n    --transform-translate-y: -8rem;\n  }\n\n  .lg\\:hover\\:-translate-y-40:hover {\n    --transform-translate-y: -10rem;\n  }\n\n  .lg\\:hover\\:-translate-y-48:hover {\n    --transform-translate-y: -12rem;\n  }\n\n  .lg\\:hover\\:-translate-y-56:hover {\n    --transform-translate-y: -14rem;\n  }\n\n  .lg\\:hover\\:-translate-y-64:hover {\n    --transform-translate-y: -16rem;\n  }\n\n  .lg\\:hover\\:-translate-y-px:hover {\n    --transform-translate-y: -1px;\n  }\n\n  .lg\\:hover\\:-translate-y-full:hover {\n    --transform-translate-y: -100%;\n  }\n\n  .lg\\:hover\\:-translate-y-1\\/2:hover {\n    --transform-translate-y: -50%;\n  }\n\n  .lg\\:hover\\:translate-y-1\\/2:hover {\n    --transform-translate-y: 50%;\n  }\n\n  .lg\\:hover\\:translate-y-full:hover {\n    --transform-translate-y: 100%;\n  }\n\n  .lg\\:focus\\:translate-x-0:focus {\n    --transform-translate-x: 0;\n  }\n\n  .lg\\:focus\\:translate-x-1:focus {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .lg\\:focus\\:translate-x-2:focus {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .lg\\:focus\\:translate-x-3:focus {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .lg\\:focus\\:translate-x-4:focus {\n    --transform-translate-x: 1rem;\n  }\n\n  .lg\\:focus\\:translate-x-5:focus {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .lg\\:focus\\:translate-x-6:focus {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .lg\\:focus\\:translate-x-8:focus {\n    --transform-translate-x: 2rem;\n  }\n\n  .lg\\:focus\\:translate-x-10:focus {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .lg\\:focus\\:translate-x-12:focus {\n    --transform-translate-x: 3rem;\n  }\n\n  .lg\\:focus\\:translate-x-16:focus {\n    --transform-translate-x: 4rem;\n  }\n\n  .lg\\:focus\\:translate-x-20:focus {\n    --transform-translate-x: 5rem;\n  }\n\n  .lg\\:focus\\:translate-x-24:focus {\n    --transform-translate-x: 6rem;\n  }\n\n  .lg\\:focus\\:translate-x-32:focus {\n    --transform-translate-x: 8rem;\n  }\n\n  .lg\\:focus\\:translate-x-40:focus {\n    --transform-translate-x: 10rem;\n  }\n\n  .lg\\:focus\\:translate-x-48:focus {\n    --transform-translate-x: 12rem;\n  }\n\n  .lg\\:focus\\:translate-x-56:focus {\n    --transform-translate-x: 14rem;\n  }\n\n  .lg\\:focus\\:translate-x-64:focus {\n    --transform-translate-x: 16rem;\n  }\n\n  .lg\\:focus\\:translate-x-px:focus {\n    --transform-translate-x: 1px;\n  }\n\n  .lg\\:focus\\:-translate-x-1:focus {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .lg\\:focus\\:-translate-x-2:focus {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .lg\\:focus\\:-translate-x-3:focus {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .lg\\:focus\\:-translate-x-4:focus {\n    --transform-translate-x: -1rem;\n  }\n\n  .lg\\:focus\\:-translate-x-5:focus {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .lg\\:focus\\:-translate-x-6:focus {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .lg\\:focus\\:-translate-x-8:focus {\n    --transform-translate-x: -2rem;\n  }\n\n  .lg\\:focus\\:-translate-x-10:focus {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .lg\\:focus\\:-translate-x-12:focus {\n    --transform-translate-x: -3rem;\n  }\n\n  .lg\\:focus\\:-translate-x-16:focus {\n    --transform-translate-x: -4rem;\n  }\n\n  .lg\\:focus\\:-translate-x-20:focus {\n    --transform-translate-x: -5rem;\n  }\n\n  .lg\\:focus\\:-translate-x-24:focus {\n    --transform-translate-x: -6rem;\n  }\n\n  .lg\\:focus\\:-translate-x-32:focus {\n    --transform-translate-x: -8rem;\n  }\n\n  .lg\\:focus\\:-translate-x-40:focus {\n    --transform-translate-x: -10rem;\n  }\n\n  .lg\\:focus\\:-translate-x-48:focus {\n    --transform-translate-x: -12rem;\n  }\n\n  .lg\\:focus\\:-translate-x-56:focus {\n    --transform-translate-x: -14rem;\n  }\n\n  .lg\\:focus\\:-translate-x-64:focus {\n    --transform-translate-x: -16rem;\n  }\n\n  .lg\\:focus\\:-translate-x-px:focus {\n    --transform-translate-x: -1px;\n  }\n\n  .lg\\:focus\\:-translate-x-full:focus {\n    --transform-translate-x: -100%;\n  }\n\n  .lg\\:focus\\:-translate-x-1\\/2:focus {\n    --transform-translate-x: -50%;\n  }\n\n  .lg\\:focus\\:translate-x-1\\/2:focus {\n    --transform-translate-x: 50%;\n  }\n\n  .lg\\:focus\\:translate-x-full:focus {\n    --transform-translate-x: 100%;\n  }\n\n  .lg\\:focus\\:translate-y-0:focus {\n    --transform-translate-y: 0;\n  }\n\n  .lg\\:focus\\:translate-y-1:focus {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .lg\\:focus\\:translate-y-2:focus {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .lg\\:focus\\:translate-y-3:focus {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .lg\\:focus\\:translate-y-4:focus {\n    --transform-translate-y: 1rem;\n  }\n\n  .lg\\:focus\\:translate-y-5:focus {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .lg\\:focus\\:translate-y-6:focus {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .lg\\:focus\\:translate-y-8:focus {\n    --transform-translate-y: 2rem;\n  }\n\n  .lg\\:focus\\:translate-y-10:focus {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .lg\\:focus\\:translate-y-12:focus {\n    --transform-translate-y: 3rem;\n  }\n\n  .lg\\:focus\\:translate-y-16:focus {\n    --transform-translate-y: 4rem;\n  }\n\n  .lg\\:focus\\:translate-y-20:focus {\n    --transform-translate-y: 5rem;\n  }\n\n  .lg\\:focus\\:translate-y-24:focus {\n    --transform-translate-y: 6rem;\n  }\n\n  .lg\\:focus\\:translate-y-32:focus {\n    --transform-translate-y: 8rem;\n  }\n\n  .lg\\:focus\\:translate-y-40:focus {\n    --transform-translate-y: 10rem;\n  }\n\n  .lg\\:focus\\:translate-y-48:focus {\n    --transform-translate-y: 12rem;\n  }\n\n  .lg\\:focus\\:translate-y-56:focus {\n    --transform-translate-y: 14rem;\n  }\n\n  .lg\\:focus\\:translate-y-64:focus {\n    --transform-translate-y: 16rem;\n  }\n\n  .lg\\:focus\\:translate-y-px:focus {\n    --transform-translate-y: 1px;\n  }\n\n  .lg\\:focus\\:-translate-y-1:focus {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .lg\\:focus\\:-translate-y-2:focus {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .lg\\:focus\\:-translate-y-3:focus {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .lg\\:focus\\:-translate-y-4:focus {\n    --transform-translate-y: -1rem;\n  }\n\n  .lg\\:focus\\:-translate-y-5:focus {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .lg\\:focus\\:-translate-y-6:focus {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .lg\\:focus\\:-translate-y-8:focus {\n    --transform-translate-y: -2rem;\n  }\n\n  .lg\\:focus\\:-translate-y-10:focus {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .lg\\:focus\\:-translate-y-12:focus {\n    --transform-translate-y: -3rem;\n  }\n\n  .lg\\:focus\\:-translate-y-16:focus {\n    --transform-translate-y: -4rem;\n  }\n\n  .lg\\:focus\\:-translate-y-20:focus {\n    --transform-translate-y: -5rem;\n  }\n\n  .lg\\:focus\\:-translate-y-24:focus {\n    --transform-translate-y: -6rem;\n  }\n\n  .lg\\:focus\\:-translate-y-32:focus {\n    --transform-translate-y: -8rem;\n  }\n\n  .lg\\:focus\\:-translate-y-40:focus {\n    --transform-translate-y: -10rem;\n  }\n\n  .lg\\:focus\\:-translate-y-48:focus {\n    --transform-translate-y: -12rem;\n  }\n\n  .lg\\:focus\\:-translate-y-56:focus {\n    --transform-translate-y: -14rem;\n  }\n\n  .lg\\:focus\\:-translate-y-64:focus {\n    --transform-translate-y: -16rem;\n  }\n\n  .lg\\:focus\\:-translate-y-px:focus {\n    --transform-translate-y: -1px;\n  }\n\n  .lg\\:focus\\:-translate-y-full:focus {\n    --transform-translate-y: -100%;\n  }\n\n  .lg\\:focus\\:-translate-y-1\\/2:focus {\n    --transform-translate-y: -50%;\n  }\n\n  .lg\\:focus\\:translate-y-1\\/2:focus {\n    --transform-translate-y: 50%;\n  }\n\n  .lg\\:focus\\:translate-y-full:focus {\n    --transform-translate-y: 100%;\n  }\n\n  .lg\\:skew-x-0 {\n    --transform-skew-x: 0;\n  }\n\n  .lg\\:skew-x-1 {\n    --transform-skew-x: 1deg;\n  }\n\n  .lg\\:skew-x-2 {\n    --transform-skew-x: 2deg;\n  }\n\n  .lg\\:skew-x-3 {\n    --transform-skew-x: 3deg;\n  }\n\n  .lg\\:skew-x-6 {\n    --transform-skew-x: 6deg;\n  }\n\n  .lg\\:skew-x-12 {\n    --transform-skew-x: 12deg;\n  }\n\n  .lg\\:-skew-x-12 {\n    --transform-skew-x: -12deg;\n  }\n\n  .lg\\:-skew-x-6 {\n    --transform-skew-x: -6deg;\n  }\n\n  .lg\\:-skew-x-3 {\n    --transform-skew-x: -3deg;\n  }\n\n  .lg\\:-skew-x-2 {\n    --transform-skew-x: -2deg;\n  }\n\n  .lg\\:-skew-x-1 {\n    --transform-skew-x: -1deg;\n  }\n\n  .lg\\:skew-y-0 {\n    --transform-skew-y: 0;\n  }\n\n  .lg\\:skew-y-1 {\n    --transform-skew-y: 1deg;\n  }\n\n  .lg\\:skew-y-2 {\n    --transform-skew-y: 2deg;\n  }\n\n  .lg\\:skew-y-3 {\n    --transform-skew-y: 3deg;\n  }\n\n  .lg\\:skew-y-6 {\n    --transform-skew-y: 6deg;\n  }\n\n  .lg\\:skew-y-12 {\n    --transform-skew-y: 12deg;\n  }\n\n  .lg\\:-skew-y-12 {\n    --transform-skew-y: -12deg;\n  }\n\n  .lg\\:-skew-y-6 {\n    --transform-skew-y: -6deg;\n  }\n\n  .lg\\:-skew-y-3 {\n    --transform-skew-y: -3deg;\n  }\n\n  .lg\\:-skew-y-2 {\n    --transform-skew-y: -2deg;\n  }\n\n  .lg\\:-skew-y-1 {\n    --transform-skew-y: -1deg;\n  }\n\n  .lg\\:hover\\:skew-x-0:hover {\n    --transform-skew-x: 0;\n  }\n\n  .lg\\:hover\\:skew-x-1:hover {\n    --transform-skew-x: 1deg;\n  }\n\n  .lg\\:hover\\:skew-x-2:hover {\n    --transform-skew-x: 2deg;\n  }\n\n  .lg\\:hover\\:skew-x-3:hover {\n    --transform-skew-x: 3deg;\n  }\n\n  .lg\\:hover\\:skew-x-6:hover {\n    --transform-skew-x: 6deg;\n  }\n\n  .lg\\:hover\\:skew-x-12:hover {\n    --transform-skew-x: 12deg;\n  }\n\n  .lg\\:hover\\:-skew-x-12:hover {\n    --transform-skew-x: -12deg;\n  }\n\n  .lg\\:hover\\:-skew-x-6:hover {\n    --transform-skew-x: -6deg;\n  }\n\n  .lg\\:hover\\:-skew-x-3:hover {\n    --transform-skew-x: -3deg;\n  }\n\n  .lg\\:hover\\:-skew-x-2:hover {\n    --transform-skew-x: -2deg;\n  }\n\n  .lg\\:hover\\:-skew-x-1:hover {\n    --transform-skew-x: -1deg;\n  }\n\n  .lg\\:hover\\:skew-y-0:hover {\n    --transform-skew-y: 0;\n  }\n\n  .lg\\:hover\\:skew-y-1:hover {\n    --transform-skew-y: 1deg;\n  }\n\n  .lg\\:hover\\:skew-y-2:hover {\n    --transform-skew-y: 2deg;\n  }\n\n  .lg\\:hover\\:skew-y-3:hover {\n    --transform-skew-y: 3deg;\n  }\n\n  .lg\\:hover\\:skew-y-6:hover {\n    --transform-skew-y: 6deg;\n  }\n\n  .lg\\:hover\\:skew-y-12:hover {\n    --transform-skew-y: 12deg;\n  }\n\n  .lg\\:hover\\:-skew-y-12:hover {\n    --transform-skew-y: -12deg;\n  }\n\n  .lg\\:hover\\:-skew-y-6:hover {\n    --transform-skew-y: -6deg;\n  }\n\n  .lg\\:hover\\:-skew-y-3:hover {\n    --transform-skew-y: -3deg;\n  }\n\n  .lg\\:hover\\:-skew-y-2:hover {\n    --transform-skew-y: -2deg;\n  }\n\n  .lg\\:hover\\:-skew-y-1:hover {\n    --transform-skew-y: -1deg;\n  }\n\n  .lg\\:focus\\:skew-x-0:focus {\n    --transform-skew-x: 0;\n  }\n\n  .lg\\:focus\\:skew-x-1:focus {\n    --transform-skew-x: 1deg;\n  }\n\n  .lg\\:focus\\:skew-x-2:focus {\n    --transform-skew-x: 2deg;\n  }\n\n  .lg\\:focus\\:skew-x-3:focus {\n    --transform-skew-x: 3deg;\n  }\n\n  .lg\\:focus\\:skew-x-6:focus {\n    --transform-skew-x: 6deg;\n  }\n\n  .lg\\:focus\\:skew-x-12:focus {\n    --transform-skew-x: 12deg;\n  }\n\n  .lg\\:focus\\:-skew-x-12:focus {\n    --transform-skew-x: -12deg;\n  }\n\n  .lg\\:focus\\:-skew-x-6:focus {\n    --transform-skew-x: -6deg;\n  }\n\n  .lg\\:focus\\:-skew-x-3:focus {\n    --transform-skew-x: -3deg;\n  }\n\n  .lg\\:focus\\:-skew-x-2:focus {\n    --transform-skew-x: -2deg;\n  }\n\n  .lg\\:focus\\:-skew-x-1:focus {\n    --transform-skew-x: -1deg;\n  }\n\n  .lg\\:focus\\:skew-y-0:focus {\n    --transform-skew-y: 0;\n  }\n\n  .lg\\:focus\\:skew-y-1:focus {\n    --transform-skew-y: 1deg;\n  }\n\n  .lg\\:focus\\:skew-y-2:focus {\n    --transform-skew-y: 2deg;\n  }\n\n  .lg\\:focus\\:skew-y-3:focus {\n    --transform-skew-y: 3deg;\n  }\n\n  .lg\\:focus\\:skew-y-6:focus {\n    --transform-skew-y: 6deg;\n  }\n\n  .lg\\:focus\\:skew-y-12:focus {\n    --transform-skew-y: 12deg;\n  }\n\n  .lg\\:focus\\:-skew-y-12:focus {\n    --transform-skew-y: -12deg;\n  }\n\n  .lg\\:focus\\:-skew-y-6:focus {\n    --transform-skew-y: -6deg;\n  }\n\n  .lg\\:focus\\:-skew-y-3:focus {\n    --transform-skew-y: -3deg;\n  }\n\n  .lg\\:focus\\:-skew-y-2:focus {\n    --transform-skew-y: -2deg;\n  }\n\n  .lg\\:focus\\:-skew-y-1:focus {\n    --transform-skew-y: -1deg;\n  }\n\n  .lg\\:transition-none {\n    transition-property: none;\n  }\n\n  .lg\\:transition-all {\n    transition-property: all;\n  }\n\n  .lg\\:transition {\n    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n  }\n\n  .lg\\:transition-colors {\n    transition-property: background-color, border-color, color, fill, stroke;\n  }\n\n  .lg\\:transition-opacity {\n    transition-property: opacity;\n  }\n\n  .lg\\:transition-shadow {\n    transition-property: box-shadow;\n  }\n\n  .lg\\:transition-transform {\n    transition-property: transform;\n  }\n\n  .lg\\:ease-linear {\n    transition-timing-function: linear;\n  }\n\n  .lg\\:ease-in {\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  }\n\n  .lg\\:ease-out {\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n\n  .lg\\:ease-in-out {\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .lg\\:duration-75 {\n    transition-duration: 75ms;\n  }\n\n  .lg\\:duration-100 {\n    transition-duration: 100ms;\n  }\n\n  .lg\\:duration-150 {\n    transition-duration: 150ms;\n  }\n\n  .lg\\:duration-200 {\n    transition-duration: 200ms;\n  }\n\n  .lg\\:duration-300 {\n    transition-duration: 300ms;\n  }\n\n  .lg\\:duration-500 {\n    transition-duration: 500ms;\n  }\n\n  .lg\\:duration-700 {\n    transition-duration: 700ms;\n  }\n\n  .lg\\:duration-1000 {\n    transition-duration: 1000ms;\n  }\n\n  .lg\\:delay-75 {\n    transition-delay: 75ms;\n  }\n\n  .lg\\:delay-100 {\n    transition-delay: 100ms;\n  }\n\n  .lg\\:delay-150 {\n    transition-delay: 150ms;\n  }\n\n  .lg\\:delay-200 {\n    transition-delay: 200ms;\n  }\n\n  .lg\\:delay-300 {\n    transition-delay: 300ms;\n  }\n\n  .lg\\:delay-500 {\n    transition-delay: 500ms;\n  }\n\n  .lg\\:delay-700 {\n    transition-delay: 700ms;\n  }\n\n  .lg\\:delay-1000 {\n    transition-delay: 1000ms;\n  }\n\n  .lg\\:animate-none {\n    animation: none;\n  }\n\n  .lg\\:animate-spin {\n    animation: spin 1s linear infinite;\n  }\n\n  .lg\\:animate-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n\n  .lg\\:animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n\n  .lg\\:animate-bounce {\n    animation: bounce 1s infinite;\n  }\n}\n\n@media (min-width: 1280px) {\n  .xl\\:container {\n    width: 100%;\n  }\n\n  @media (min-width: 640px) {\n    .xl\\:container {\n      max-width: 640px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    .xl\\:container {\n      max-width: 768px;\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .xl\\:container {\n      max-width: 1024px;\n    }\n  }\n\n  @media (min-width: 1280px) {\n    .xl\\:container {\n      max-width: 1280px;\n    }\n  }\n\n  .xl\\:space-y-0 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0px * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-0 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0px * var(--space-x-reverse));\n    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-1 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.25rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-1 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.25rem * var(--space-x-reverse));\n    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-2 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.5rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-2 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.5rem * var(--space-x-reverse));\n    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-3 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(0.75rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-3 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(0.75rem * var(--space-x-reverse));\n    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-4 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-4 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1rem * var(--space-x-reverse));\n    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-5 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.25rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-5 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.25rem * var(--space-x-reverse));\n    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-6 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1.5rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-6 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1.5rem * var(--space-x-reverse));\n    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-8 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-8 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2rem * var(--space-x-reverse));\n    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-10 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(2.5rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-10 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(2.5rem * var(--space-x-reverse));\n    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-12 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(3rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-12 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(3rem * var(--space-x-reverse));\n    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-16 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(4rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-16 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(4rem * var(--space-x-reverse));\n    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-20 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(5rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-20 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(5rem * var(--space-x-reverse));\n    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-24 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(6rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-24 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(6rem * var(--space-x-reverse));\n    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-32 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(8rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-32 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(8rem * var(--space-x-reverse));\n    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-40 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(10rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-40 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(10rem * var(--space-x-reverse));\n    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-48 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(12rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-48 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(12rem * var(--space-x-reverse));\n    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-56 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(14rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-56 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(14rem * var(--space-x-reverse));\n    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-64 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(16rem * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-64 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(16rem * var(--space-x-reverse));\n    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-px > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(1px * var(--space-y-reverse));\n  }\n\n  .xl\\:space-x-px > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(1px * var(--space-x-reverse));\n    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-1 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.25rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-1 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.25rem * var(--space-x-reverse));\n    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-2 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.5rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-2 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.5rem * var(--space-x-reverse));\n    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-3 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-0.75rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-3 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-0.75rem * var(--space-x-reverse));\n    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-4 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-4 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1rem * var(--space-x-reverse));\n    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-5 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.25rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-5 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.25rem * var(--space-x-reverse));\n    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-6 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1.5rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-6 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1.5rem * var(--space-x-reverse));\n    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-8 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-8 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2rem * var(--space-x-reverse));\n    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-10 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-2.5rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-10 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-2.5rem * var(--space-x-reverse));\n    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-12 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-3rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-12 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-3rem * var(--space-x-reverse));\n    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-16 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-4rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-16 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-4rem * var(--space-x-reverse));\n    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-20 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-5rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-20 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-5rem * var(--space-x-reverse));\n    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-24 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-6rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-24 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-6rem * var(--space-x-reverse));\n    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-32 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-8rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-32 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-8rem * var(--space-x-reverse));\n    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-40 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-10rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-40 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-10rem * var(--space-x-reverse));\n    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-48 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-12rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-48 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-12rem * var(--space-x-reverse));\n    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-56 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-14rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-56 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-14rem * var(--space-x-reverse));\n    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-64 > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-16rem * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-64 > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-16rem * var(--space-x-reverse));\n    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:-space-y-px > :not(template) ~ :not(template) {\n    --space-y-reverse: 0;\n    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));\n    margin-bottom: calc(-1px * var(--space-y-reverse));\n  }\n\n  .xl\\:-space-x-px > :not(template) ~ :not(template) {\n    --space-x-reverse: 0;\n    margin-right: calc(-1px * var(--space-x-reverse));\n    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));\n  }\n\n  .xl\\:space-y-reverse > :not(template) ~ :not(template) {\n    --space-y-reverse: 1;\n  }\n\n  .xl\\:space-x-reverse > :not(template) ~ :not(template) {\n    --space-x-reverse: 1;\n  }\n\n  .xl\\:divide-y-0 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(0px * var(--divide-y-reverse));\n  }\n\n  .xl\\:divide-x-0 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(0px * var(--divide-x-reverse));\n    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .xl\\:divide-y-2 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(2px * var(--divide-y-reverse));\n  }\n\n  .xl\\:divide-x-2 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(2px * var(--divide-x-reverse));\n    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .xl\\:divide-y-4 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(4px * var(--divide-y-reverse));\n  }\n\n  .xl\\:divide-x-4 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(4px * var(--divide-x-reverse));\n    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .xl\\:divide-y-8 > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(8px * var(--divide-y-reverse));\n  }\n\n  .xl\\:divide-x-8 > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(8px * var(--divide-x-reverse));\n    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .xl\\:divide-y > :not(template) ~ :not(template) {\n    --divide-y-reverse: 0;\n    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));\n    border-bottom-width: calc(1px * var(--divide-y-reverse));\n  }\n\n  .xl\\:divide-x > :not(template) ~ :not(template) {\n    --divide-x-reverse: 0;\n    border-right-width: calc(1px * var(--divide-x-reverse));\n    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));\n  }\n\n  .xl\\:divide-y-reverse > :not(template) ~ :not(template) {\n    --divide-y-reverse: 1;\n  }\n\n  .xl\\:divide-x-reverse > :not(template) ~ :not(template) {\n    --divide-x-reverse: 1;\n  }\n\n  .xl\\:divide-transparent > :not(template) ~ :not(template) {\n    border-color: transparent;\n  }\n\n  .xl\\:divide-current > :not(template) ~ :not(template) {\n    border-color: currentColor;\n  }\n\n  .xl\\:divide-black > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--divide-opacity));\n  }\n\n  .xl\\:divide-white > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--divide-opacity));\n  }\n\n  .xl\\:divide-gray-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--divide-opacity));\n  }\n\n  .xl\\:divide-red-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--divide-opacity));\n  }\n\n  .xl\\:divide-orange-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--divide-opacity));\n  }\n\n  .xl\\:divide-yellow-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--divide-opacity));\n  }\n\n  .xl\\:divide-green-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--divide-opacity));\n  }\n\n  .xl\\:divide-teal-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--divide-opacity));\n  }\n\n  .xl\\:divide-blue-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--divide-opacity));\n  }\n\n  .xl\\:divide-indigo-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--divide-opacity));\n  }\n\n  .xl\\:divide-purple-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-200 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-300 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-400 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-500 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-600 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-700 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-800 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--divide-opacity));\n  }\n\n  .xl\\:divide-pink-900 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--divide-opacity));\n  }\n\n  .xl\\:divide-solid > :not(template) ~ :not(template) {\n    border-style: solid;\n  }\n\n  .xl\\:divide-dashed > :not(template) ~ :not(template) {\n    border-style: dashed;\n  }\n\n  .xl\\:divide-dotted > :not(template) ~ :not(template) {\n    border-style: dotted;\n  }\n\n  .xl\\:divide-double > :not(template) ~ :not(template) {\n    border-style: double;\n  }\n\n  .xl\\:divide-none > :not(template) ~ :not(template) {\n    border-style: none;\n  }\n\n  .xl\\:divide-opacity-0 > :not(template) ~ :not(template) {\n    --divide-opacity: 0;\n  }\n\n  .xl\\:divide-opacity-25 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.25;\n  }\n\n  .xl\\:divide-opacity-50 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.5;\n  }\n\n  .xl\\:divide-opacity-75 > :not(template) ~ :not(template) {\n    --divide-opacity: 0.75;\n  }\n\n  .xl\\:divide-opacity-100 > :not(template) ~ :not(template) {\n    --divide-opacity: 1;\n  }\n\n  .xl\\:sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n\n  .xl\\:not-sr-only {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n\n  .xl\\:focus\\:sr-only:focus {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n    border-width: 0;\n  }\n\n  .xl\\:focus\\:not-sr-only:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n\n  .xl\\:appearance-none {\n    appearance: none;\n  }\n\n  .xl\\:bg-fixed {\n    background-attachment: fixed;\n  }\n\n  .xl\\:bg-local {\n    background-attachment: local;\n  }\n\n  .xl\\:bg-scroll {\n    background-attachment: scroll;\n  }\n\n  .xl\\:bg-clip-border {\n    background-clip: border-box;\n  }\n\n  .xl\\:bg-clip-padding {\n    background-clip: padding-box;\n  }\n\n  .xl\\:bg-clip-content {\n    background-clip: content-box;\n  }\n\n  .xl\\:bg-clip-text {\n    -webkit-background-clip: text;\n            background-clip: text;\n  }\n\n  .xl\\:bg-transparent {\n    background-color: transparent;\n  }\n\n  .xl\\:bg-current {\n    background-color: currentColor;\n  }\n\n  .xl\\:bg-black {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .xl\\:bg-white {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-100 {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-200 {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-300 {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-400 {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-500 {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-600 {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-700 {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-800 {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .xl\\:bg-gray-900 {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-100 {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-200 {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-300 {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-400 {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-500 {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-600 {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-700 {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-800 {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .xl\\:bg-red-900 {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-100 {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-200 {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-300 {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-400 {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-500 {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-600 {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-700 {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-800 {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .xl\\:bg-orange-900 {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-100 {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-200 {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-300 {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-400 {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-500 {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-600 {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-700 {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-800 {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .xl\\:bg-yellow-900 {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-100 {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-200 {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-300 {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-400 {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-500 {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-600 {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-700 {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-800 {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .xl\\:bg-green-900 {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-100 {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-200 {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-300 {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-400 {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-500 {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-600 {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-700 {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-800 {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .xl\\:bg-teal-900 {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-100 {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-200 {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-300 {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-400 {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-500 {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-600 {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-700 {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-800 {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .xl\\:bg-blue-900 {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-100 {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-200 {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-300 {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-400 {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-500 {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-600 {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-700 {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-800 {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .xl\\:bg-indigo-900 {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-100 {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-200 {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-300 {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-400 {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-500 {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-600 {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-700 {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-800 {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .xl\\:bg-purple-900 {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-100 {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-200 {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-300 {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-400 {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-500 {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-600 {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-700 {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-800 {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .xl\\:bg-pink-900 {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n  }\n\n  .xl\\:hover\\:bg-current:hover {\n    background-color: currentColor;\n  }\n\n  .xl\\:hover\\:bg-black:hover {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-white:hover {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-100:hover {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-200:hover {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-300:hover {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-400:hover {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-500:hover {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-600:hover {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-700:hover {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-800:hover {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-gray-900:hover {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-100:hover {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-200:hover {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-300:hover {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-400:hover {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-500:hover {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-600:hover {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-700:hover {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-800:hover {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-red-900:hover {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-100:hover {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-200:hover {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-300:hover {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-400:hover {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-500:hover {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-600:hover {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-700:hover {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-800:hover {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-orange-900:hover {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-100:hover {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-200:hover {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-300:hover {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-400:hover {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-500:hover {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-600:hover {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-700:hover {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-800:hover {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-yellow-900:hover {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-100:hover {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-200:hover {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-300:hover {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-400:hover {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-500:hover {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-600:hover {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-700:hover {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-800:hover {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-green-900:hover {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-100:hover {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-200:hover {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-300:hover {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-400:hover {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-500:hover {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-600:hover {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-700:hover {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-800:hover {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-teal-900:hover {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-100:hover {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-200:hover {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-300:hover {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-400:hover {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-500:hover {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-600:hover {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-700:hover {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-800:hover {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-blue-900:hover {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-100:hover {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-200:hover {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-300:hover {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-400:hover {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-500:hover {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-600:hover {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-700:hover {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-800:hover {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-indigo-900:hover {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-100:hover {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-200:hover {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-300:hover {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-400:hover {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-500:hover {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-600:hover {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-700:hover {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-800:hover {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-purple-900:hover {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-100:hover {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-200:hover {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-300:hover {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-400:hover {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-500:hover {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-600:hover {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-700:hover {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-800:hover {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .xl\\:hover\\:bg-pink-900:hover {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-transparent:focus {\n    background-color: transparent;\n  }\n\n  .xl\\:focus\\:bg-current:focus {\n    background-color: currentColor;\n  }\n\n  .xl\\:focus\\:bg-black:focus {\n    --bg-opacity: 1;\n    background-color: #000;\n    background-color: rgba(0, 0, 0, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-white:focus {\n    --bg-opacity: 1;\n    background-color: #fff;\n    background-color: rgba(255, 255, 255, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-100:focus {\n    --bg-opacity: 1;\n    background-color: #f7fafc;\n    background-color: rgba(247, 250, 252, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-200:focus {\n    --bg-opacity: 1;\n    background-color: #edf2f7;\n    background-color: rgba(237, 242, 247, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-300:focus {\n    --bg-opacity: 1;\n    background-color: #e2e8f0;\n    background-color: rgba(226, 232, 240, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-400:focus {\n    --bg-opacity: 1;\n    background-color: #cbd5e0;\n    background-color: rgba(203, 213, 224, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-500:focus {\n    --bg-opacity: 1;\n    background-color: #a0aec0;\n    background-color: rgba(160, 174, 192, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-600:focus {\n    --bg-opacity: 1;\n    background-color: #718096;\n    background-color: rgba(113, 128, 150, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-700:focus {\n    --bg-opacity: 1;\n    background-color: #4a5568;\n    background-color: rgba(74, 85, 104, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-800:focus {\n    --bg-opacity: 1;\n    background-color: #2d3748;\n    background-color: rgba(45, 55, 72, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-gray-900:focus {\n    --bg-opacity: 1;\n    background-color: #1a202c;\n    background-color: rgba(26, 32, 44, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-100:focus {\n    --bg-opacity: 1;\n    background-color: #fff5f5;\n    background-color: rgba(255, 245, 245, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-200:focus {\n    --bg-opacity: 1;\n    background-color: #fed7d7;\n    background-color: rgba(254, 215, 215, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-300:focus {\n    --bg-opacity: 1;\n    background-color: #feb2b2;\n    background-color: rgba(254, 178, 178, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-400:focus {\n    --bg-opacity: 1;\n    background-color: #fc8181;\n    background-color: rgba(252, 129, 129, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-500:focus {\n    --bg-opacity: 1;\n    background-color: #f56565;\n    background-color: rgba(245, 101, 101, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-600:focus {\n    --bg-opacity: 1;\n    background-color: #e53e3e;\n    background-color: rgba(229, 62, 62, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-700:focus {\n    --bg-opacity: 1;\n    background-color: #c53030;\n    background-color: rgba(197, 48, 48, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-800:focus {\n    --bg-opacity: 1;\n    background-color: #9b2c2c;\n    background-color: rgba(155, 44, 44, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-red-900:focus {\n    --bg-opacity: 1;\n    background-color: #742a2a;\n    background-color: rgba(116, 42, 42, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-100:focus {\n    --bg-opacity: 1;\n    background-color: #fffaf0;\n    background-color: rgba(255, 250, 240, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-200:focus {\n    --bg-opacity: 1;\n    background-color: #feebc8;\n    background-color: rgba(254, 235, 200, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-300:focus {\n    --bg-opacity: 1;\n    background-color: #fbd38d;\n    background-color: rgba(251, 211, 141, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-400:focus {\n    --bg-opacity: 1;\n    background-color: #f6ad55;\n    background-color: rgba(246, 173, 85, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-500:focus {\n    --bg-opacity: 1;\n    background-color: #ed8936;\n    background-color: rgba(237, 137, 54, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-600:focus {\n    --bg-opacity: 1;\n    background-color: #dd6b20;\n    background-color: rgba(221, 107, 32, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-700:focus {\n    --bg-opacity: 1;\n    background-color: #c05621;\n    background-color: rgba(192, 86, 33, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-800:focus {\n    --bg-opacity: 1;\n    background-color: #9c4221;\n    background-color: rgba(156, 66, 33, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-orange-900:focus {\n    --bg-opacity: 1;\n    background-color: #7b341e;\n    background-color: rgba(123, 52, 30, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-100:focus {\n    --bg-opacity: 1;\n    background-color: #fffff0;\n    background-color: rgba(255, 255, 240, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-200:focus {\n    --bg-opacity: 1;\n    background-color: #fefcbf;\n    background-color: rgba(254, 252, 191, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-300:focus {\n    --bg-opacity: 1;\n    background-color: #faf089;\n    background-color: rgba(250, 240, 137, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-400:focus {\n    --bg-opacity: 1;\n    background-color: #f6e05e;\n    background-color: rgba(246, 224, 94, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-500:focus {\n    --bg-opacity: 1;\n    background-color: #ecc94b;\n    background-color: rgba(236, 201, 75, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-600:focus {\n    --bg-opacity: 1;\n    background-color: #d69e2e;\n    background-color: rgba(214, 158, 46, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-700:focus {\n    --bg-opacity: 1;\n    background-color: #b7791f;\n    background-color: rgba(183, 121, 31, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-800:focus {\n    --bg-opacity: 1;\n    background-color: #975a16;\n    background-color: rgba(151, 90, 22, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-yellow-900:focus {\n    --bg-opacity: 1;\n    background-color: #744210;\n    background-color: rgba(116, 66, 16, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-100:focus {\n    --bg-opacity: 1;\n    background-color: #f0fff4;\n    background-color: rgba(240, 255, 244, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-200:focus {\n    --bg-opacity: 1;\n    background-color: #c6f6d5;\n    background-color: rgba(198, 246, 213, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-300:focus {\n    --bg-opacity: 1;\n    background-color: #9ae6b4;\n    background-color: rgba(154, 230, 180, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-400:focus {\n    --bg-opacity: 1;\n    background-color: #68d391;\n    background-color: rgba(104, 211, 145, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-500:focus {\n    --bg-opacity: 1;\n    background-color: #48bb78;\n    background-color: rgba(72, 187, 120, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-600:focus {\n    --bg-opacity: 1;\n    background-color: #38a169;\n    background-color: rgba(56, 161, 105, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-700:focus {\n    --bg-opacity: 1;\n    background-color: #2f855a;\n    background-color: rgba(47, 133, 90, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-800:focus {\n    --bg-opacity: 1;\n    background-color: #276749;\n    background-color: rgba(39, 103, 73, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-green-900:focus {\n    --bg-opacity: 1;\n    background-color: #22543d;\n    background-color: rgba(34, 84, 61, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-100:focus {\n    --bg-opacity: 1;\n    background-color: #e6fffa;\n    background-color: rgba(230, 255, 250, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-200:focus {\n    --bg-opacity: 1;\n    background-color: #b2f5ea;\n    background-color: rgba(178, 245, 234, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-300:focus {\n    --bg-opacity: 1;\n    background-color: #81e6d9;\n    background-color: rgba(129, 230, 217, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-400:focus {\n    --bg-opacity: 1;\n    background-color: #4fd1c5;\n    background-color: rgba(79, 209, 197, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-500:focus {\n    --bg-opacity: 1;\n    background-color: #38b2ac;\n    background-color: rgba(56, 178, 172, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-600:focus {\n    --bg-opacity: 1;\n    background-color: #319795;\n    background-color: rgba(49, 151, 149, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-700:focus {\n    --bg-opacity: 1;\n    background-color: #2c7a7b;\n    background-color: rgba(44, 122, 123, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-800:focus {\n    --bg-opacity: 1;\n    background-color: #285e61;\n    background-color: rgba(40, 94, 97, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-teal-900:focus {\n    --bg-opacity: 1;\n    background-color: #234e52;\n    background-color: rgba(35, 78, 82, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-100:focus {\n    --bg-opacity: 1;\n    background-color: #ebf8ff;\n    background-color: rgba(235, 248, 255, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-200:focus {\n    --bg-opacity: 1;\n    background-color: #bee3f8;\n    background-color: rgba(190, 227, 248, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-300:focus {\n    --bg-opacity: 1;\n    background-color: #90cdf4;\n    background-color: rgba(144, 205, 244, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-400:focus {\n    --bg-opacity: 1;\n    background-color: #63b3ed;\n    background-color: rgba(99, 179, 237, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-500:focus {\n    --bg-opacity: 1;\n    background-color: #4299e1;\n    background-color: rgba(66, 153, 225, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-600:focus {\n    --bg-opacity: 1;\n    background-color: #3182ce;\n    background-color: rgba(49, 130, 206, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-700:focus {\n    --bg-opacity: 1;\n    background-color: #2b6cb0;\n    background-color: rgba(43, 108, 176, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-800:focus {\n    --bg-opacity: 1;\n    background-color: #2c5282;\n    background-color: rgba(44, 82, 130, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-blue-900:focus {\n    --bg-opacity: 1;\n    background-color: #2a4365;\n    background-color: rgba(42, 67, 101, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-100:focus {\n    --bg-opacity: 1;\n    background-color: #ebf4ff;\n    background-color: rgba(235, 244, 255, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-200:focus {\n    --bg-opacity: 1;\n    background-color: #c3dafe;\n    background-color: rgba(195, 218, 254, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-300:focus {\n    --bg-opacity: 1;\n    background-color: #a3bffa;\n    background-color: rgba(163, 191, 250, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-400:focus {\n    --bg-opacity: 1;\n    background-color: #7f9cf5;\n    background-color: rgba(127, 156, 245, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-500:focus {\n    --bg-opacity: 1;\n    background-color: #667eea;\n    background-color: rgba(102, 126, 234, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-600:focus {\n    --bg-opacity: 1;\n    background-color: #5a67d8;\n    background-color: rgba(90, 103, 216, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-700:focus {\n    --bg-opacity: 1;\n    background-color: #4c51bf;\n    background-color: rgba(76, 81, 191, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-800:focus {\n    --bg-opacity: 1;\n    background-color: #434190;\n    background-color: rgba(67, 65, 144, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-indigo-900:focus {\n    --bg-opacity: 1;\n    background-color: #3c366b;\n    background-color: rgba(60, 54, 107, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-100:focus {\n    --bg-opacity: 1;\n    background-color: #faf5ff;\n    background-color: rgba(250, 245, 255, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-200:focus {\n    --bg-opacity: 1;\n    background-color: #e9d8fd;\n    background-color: rgba(233, 216, 253, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-300:focus {\n    --bg-opacity: 1;\n    background-color: #d6bcfa;\n    background-color: rgba(214, 188, 250, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-400:focus {\n    --bg-opacity: 1;\n    background-color: #b794f4;\n    background-color: rgba(183, 148, 244, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-500:focus {\n    --bg-opacity: 1;\n    background-color: #9f7aea;\n    background-color: rgba(159, 122, 234, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-600:focus {\n    --bg-opacity: 1;\n    background-color: #805ad5;\n    background-color: rgba(128, 90, 213, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-700:focus {\n    --bg-opacity: 1;\n    background-color: #6b46c1;\n    background-color: rgba(107, 70, 193, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-800:focus {\n    --bg-opacity: 1;\n    background-color: #553c9a;\n    background-color: rgba(85, 60, 154, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-purple-900:focus {\n    --bg-opacity: 1;\n    background-color: #44337a;\n    background-color: rgba(68, 51, 122, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-100:focus {\n    --bg-opacity: 1;\n    background-color: #fff5f7;\n    background-color: rgba(255, 245, 247, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-200:focus {\n    --bg-opacity: 1;\n    background-color: #fed7e2;\n    background-color: rgba(254, 215, 226, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-300:focus {\n    --bg-opacity: 1;\n    background-color: #fbb6ce;\n    background-color: rgba(251, 182, 206, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-400:focus {\n    --bg-opacity: 1;\n    background-color: #f687b3;\n    background-color: rgba(246, 135, 179, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-500:focus {\n    --bg-opacity: 1;\n    background-color: #ed64a6;\n    background-color: rgba(237, 100, 166, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-600:focus {\n    --bg-opacity: 1;\n    background-color: #d53f8c;\n    background-color: rgba(213, 63, 140, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-700:focus {\n    --bg-opacity: 1;\n    background-color: #b83280;\n    background-color: rgba(184, 50, 128, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-800:focus {\n    --bg-opacity: 1;\n    background-color: #97266d;\n    background-color: rgba(151, 38, 109, var(--bg-opacity));\n  }\n\n  .xl\\:focus\\:bg-pink-900:focus {\n    --bg-opacity: 1;\n    background-color: #702459;\n    background-color: rgba(112, 36, 89, var(--bg-opacity));\n  }\n\n  .xl\\:bg-none {\n    background-image: none;\n  }\n\n  .xl\\:bg-gradient-to-t {\n    background-image: linear-gradient(to top, var(--gradient-color-stops));\n  }\n\n  .xl\\:bg-gradient-to-tr {\n    background-image: linear-gradient(to top right, var(--gradient-color-stops));\n  }\n\n  .xl\\:bg-gradient-to-r {\n    background-image: linear-gradient(to right, var(--gradient-color-stops));\n  }\n\n  .xl\\:bg-gradient-to-br {\n    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));\n  }\n\n  .xl\\:bg-gradient-to-b {\n    background-image: linear-gradient(to bottom, var(--gradient-color-stops));\n  }\n\n  .xl\\:bg-gradient-to-bl {\n    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));\n  }\n\n  .xl\\:bg-gradient-to-l {\n    background-image: linear-gradient(to left, var(--gradient-color-stops));\n  }\n\n  .xl\\:bg-gradient-to-tl {\n    background-image: linear-gradient(to top left, var(--gradient-color-stops));\n  }\n\n  .xl\\:from-transparent {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:from-current {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:from-black {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:from-white {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:from-gray-100 {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .xl\\:from-gray-200 {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .xl\\:from-gray-300 {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .xl\\:from-gray-400 {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .xl\\:from-gray-500 {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .xl\\:from-gray-600 {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .xl\\:from-gray-700 {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .xl\\:from-gray-800 {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .xl\\:from-gray-900 {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .xl\\:from-red-100 {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .xl\\:from-red-200 {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .xl\\:from-red-300 {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .xl\\:from-red-400 {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .xl\\:from-red-500 {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .xl\\:from-red-600 {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .xl\\:from-red-700 {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .xl\\:from-red-800 {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .xl\\:from-red-900 {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .xl\\:from-orange-100 {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .xl\\:from-orange-200 {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .xl\\:from-orange-300 {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .xl\\:from-orange-400 {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .xl\\:from-orange-500 {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .xl\\:from-orange-600 {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .xl\\:from-orange-700 {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .xl\\:from-orange-800 {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .xl\\:from-orange-900 {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .xl\\:from-yellow-100 {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .xl\\:from-yellow-200 {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .xl\\:from-yellow-300 {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .xl\\:from-yellow-400 {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .xl\\:from-yellow-500 {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .xl\\:from-yellow-600 {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .xl\\:from-yellow-700 {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .xl\\:from-yellow-800 {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .xl\\:from-yellow-900 {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .xl\\:from-green-100 {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .xl\\:from-green-200 {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .xl\\:from-green-300 {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .xl\\:from-green-400 {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .xl\\:from-green-500 {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .xl\\:from-green-600 {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .xl\\:from-green-700 {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .xl\\:from-green-800 {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .xl\\:from-green-900 {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .xl\\:from-teal-100 {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .xl\\:from-teal-200 {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .xl\\:from-teal-300 {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .xl\\:from-teal-400 {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .xl\\:from-teal-500 {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .xl\\:from-teal-600 {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .xl\\:from-teal-700 {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .xl\\:from-teal-800 {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .xl\\:from-teal-900 {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .xl\\:from-blue-100 {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .xl\\:from-blue-200 {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .xl\\:from-blue-300 {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .xl\\:from-blue-400 {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .xl\\:from-blue-500 {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .xl\\:from-blue-600 {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .xl\\:from-blue-700 {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .xl\\:from-blue-800 {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .xl\\:from-blue-900 {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .xl\\:from-indigo-100 {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .xl\\:from-indigo-200 {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .xl\\:from-indigo-300 {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .xl\\:from-indigo-400 {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .xl\\:from-indigo-500 {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .xl\\:from-indigo-600 {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .xl\\:from-indigo-700 {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .xl\\:from-indigo-800 {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .xl\\:from-indigo-900 {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .xl\\:from-purple-100 {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .xl\\:from-purple-200 {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .xl\\:from-purple-300 {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .xl\\:from-purple-400 {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .xl\\:from-purple-500 {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .xl\\:from-purple-600 {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .xl\\:from-purple-700 {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .xl\\:from-purple-800 {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .xl\\:from-purple-900 {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .xl\\:from-pink-100 {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .xl\\:from-pink-200 {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .xl\\:from-pink-300 {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .xl\\:from-pink-400 {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .xl\\:from-pink-500 {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .xl\\:from-pink-600 {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .xl\\:from-pink-700 {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .xl\\:from-pink-800 {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .xl\\:from-pink-900 {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .xl\\:via-transparent {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:via-current {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:via-black {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:via-white {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:via-gray-100 {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .xl\\:via-gray-200 {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .xl\\:via-gray-300 {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .xl\\:via-gray-400 {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .xl\\:via-gray-500 {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .xl\\:via-gray-600 {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .xl\\:via-gray-700 {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .xl\\:via-gray-800 {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .xl\\:via-gray-900 {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .xl\\:via-red-100 {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .xl\\:via-red-200 {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .xl\\:via-red-300 {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .xl\\:via-red-400 {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .xl\\:via-red-500 {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .xl\\:via-red-600 {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .xl\\:via-red-700 {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .xl\\:via-red-800 {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .xl\\:via-red-900 {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .xl\\:via-orange-100 {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .xl\\:via-orange-200 {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .xl\\:via-orange-300 {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .xl\\:via-orange-400 {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .xl\\:via-orange-500 {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .xl\\:via-orange-600 {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .xl\\:via-orange-700 {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .xl\\:via-orange-800 {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .xl\\:via-orange-900 {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .xl\\:via-yellow-100 {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .xl\\:via-yellow-200 {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .xl\\:via-yellow-300 {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .xl\\:via-yellow-400 {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .xl\\:via-yellow-500 {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .xl\\:via-yellow-600 {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .xl\\:via-yellow-700 {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .xl\\:via-yellow-800 {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .xl\\:via-yellow-900 {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .xl\\:via-green-100 {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .xl\\:via-green-200 {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .xl\\:via-green-300 {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .xl\\:via-green-400 {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .xl\\:via-green-500 {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .xl\\:via-green-600 {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .xl\\:via-green-700 {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .xl\\:via-green-800 {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .xl\\:via-green-900 {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .xl\\:via-teal-100 {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .xl\\:via-teal-200 {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .xl\\:via-teal-300 {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .xl\\:via-teal-400 {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .xl\\:via-teal-500 {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .xl\\:via-teal-600 {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .xl\\:via-teal-700 {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .xl\\:via-teal-800 {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .xl\\:via-teal-900 {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .xl\\:via-blue-100 {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .xl\\:via-blue-200 {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .xl\\:via-blue-300 {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .xl\\:via-blue-400 {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .xl\\:via-blue-500 {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .xl\\:via-blue-600 {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .xl\\:via-blue-700 {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .xl\\:via-blue-800 {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .xl\\:via-blue-900 {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .xl\\:via-indigo-100 {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .xl\\:via-indigo-200 {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .xl\\:via-indigo-300 {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .xl\\:via-indigo-400 {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .xl\\:via-indigo-500 {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .xl\\:via-indigo-600 {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .xl\\:via-indigo-700 {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .xl\\:via-indigo-800 {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .xl\\:via-indigo-900 {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .xl\\:via-purple-100 {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .xl\\:via-purple-200 {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .xl\\:via-purple-300 {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .xl\\:via-purple-400 {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .xl\\:via-purple-500 {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .xl\\:via-purple-600 {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .xl\\:via-purple-700 {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .xl\\:via-purple-800 {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .xl\\:via-purple-900 {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .xl\\:via-pink-100 {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .xl\\:via-pink-200 {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .xl\\:via-pink-300 {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .xl\\:via-pink-400 {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .xl\\:via-pink-500 {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .xl\\:via-pink-600 {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .xl\\:via-pink-700 {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .xl\\:via-pink-800 {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .xl\\:via-pink-900 {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .xl\\:to-transparent {\n    --gradient-to-color: transparent;\n  }\n\n  .xl\\:to-current {\n    --gradient-to-color: currentColor;\n  }\n\n  .xl\\:to-black {\n    --gradient-to-color: #000;\n  }\n\n  .xl\\:to-white {\n    --gradient-to-color: #fff;\n  }\n\n  .xl\\:to-gray-100 {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .xl\\:to-gray-200 {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .xl\\:to-gray-300 {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .xl\\:to-gray-400 {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .xl\\:to-gray-500 {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .xl\\:to-gray-600 {\n    --gradient-to-color: #718096;\n  }\n\n  .xl\\:to-gray-700 {\n    --gradient-to-color: #4a5568;\n  }\n\n  .xl\\:to-gray-800 {\n    --gradient-to-color: #2d3748;\n  }\n\n  .xl\\:to-gray-900 {\n    --gradient-to-color: #1a202c;\n  }\n\n  .xl\\:to-red-100 {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .xl\\:to-red-200 {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .xl\\:to-red-300 {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .xl\\:to-red-400 {\n    --gradient-to-color: #fc8181;\n  }\n\n  .xl\\:to-red-500 {\n    --gradient-to-color: #f56565;\n  }\n\n  .xl\\:to-red-600 {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .xl\\:to-red-700 {\n    --gradient-to-color: #c53030;\n  }\n\n  .xl\\:to-red-800 {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .xl\\:to-red-900 {\n    --gradient-to-color: #742a2a;\n  }\n\n  .xl\\:to-orange-100 {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .xl\\:to-orange-200 {\n    --gradient-to-color: #feebc8;\n  }\n\n  .xl\\:to-orange-300 {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .xl\\:to-orange-400 {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .xl\\:to-orange-500 {\n    --gradient-to-color: #ed8936;\n  }\n\n  .xl\\:to-orange-600 {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .xl\\:to-orange-700 {\n    --gradient-to-color: #c05621;\n  }\n\n  .xl\\:to-orange-800 {\n    --gradient-to-color: #9c4221;\n  }\n\n  .xl\\:to-orange-900 {\n    --gradient-to-color: #7b341e;\n  }\n\n  .xl\\:to-yellow-100 {\n    --gradient-to-color: #fffff0;\n  }\n\n  .xl\\:to-yellow-200 {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .xl\\:to-yellow-300 {\n    --gradient-to-color: #faf089;\n  }\n\n  .xl\\:to-yellow-400 {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .xl\\:to-yellow-500 {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .xl\\:to-yellow-600 {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .xl\\:to-yellow-700 {\n    --gradient-to-color: #b7791f;\n  }\n\n  .xl\\:to-yellow-800 {\n    --gradient-to-color: #975a16;\n  }\n\n  .xl\\:to-yellow-900 {\n    --gradient-to-color: #744210;\n  }\n\n  .xl\\:to-green-100 {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .xl\\:to-green-200 {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .xl\\:to-green-300 {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .xl\\:to-green-400 {\n    --gradient-to-color: #68d391;\n  }\n\n  .xl\\:to-green-500 {\n    --gradient-to-color: #48bb78;\n  }\n\n  .xl\\:to-green-600 {\n    --gradient-to-color: #38a169;\n  }\n\n  .xl\\:to-green-700 {\n    --gradient-to-color: #2f855a;\n  }\n\n  .xl\\:to-green-800 {\n    --gradient-to-color: #276749;\n  }\n\n  .xl\\:to-green-900 {\n    --gradient-to-color: #22543d;\n  }\n\n  .xl\\:to-teal-100 {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .xl\\:to-teal-200 {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .xl\\:to-teal-300 {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .xl\\:to-teal-400 {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .xl\\:to-teal-500 {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .xl\\:to-teal-600 {\n    --gradient-to-color: #319795;\n  }\n\n  .xl\\:to-teal-700 {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .xl\\:to-teal-800 {\n    --gradient-to-color: #285e61;\n  }\n\n  .xl\\:to-teal-900 {\n    --gradient-to-color: #234e52;\n  }\n\n  .xl\\:to-blue-100 {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .xl\\:to-blue-200 {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .xl\\:to-blue-300 {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .xl\\:to-blue-400 {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .xl\\:to-blue-500 {\n    --gradient-to-color: #4299e1;\n  }\n\n  .xl\\:to-blue-600 {\n    --gradient-to-color: #3182ce;\n  }\n\n  .xl\\:to-blue-700 {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .xl\\:to-blue-800 {\n    --gradient-to-color: #2c5282;\n  }\n\n  .xl\\:to-blue-900 {\n    --gradient-to-color: #2a4365;\n  }\n\n  .xl\\:to-indigo-100 {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .xl\\:to-indigo-200 {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .xl\\:to-indigo-300 {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .xl\\:to-indigo-400 {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .xl\\:to-indigo-500 {\n    --gradient-to-color: #667eea;\n  }\n\n  .xl\\:to-indigo-600 {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .xl\\:to-indigo-700 {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .xl\\:to-indigo-800 {\n    --gradient-to-color: #434190;\n  }\n\n  .xl\\:to-indigo-900 {\n    --gradient-to-color: #3c366b;\n  }\n\n  .xl\\:to-purple-100 {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .xl\\:to-purple-200 {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .xl\\:to-purple-300 {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .xl\\:to-purple-400 {\n    --gradient-to-color: #b794f4;\n  }\n\n  .xl\\:to-purple-500 {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .xl\\:to-purple-600 {\n    --gradient-to-color: #805ad5;\n  }\n\n  .xl\\:to-purple-700 {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .xl\\:to-purple-800 {\n    --gradient-to-color: #553c9a;\n  }\n\n  .xl\\:to-purple-900 {\n    --gradient-to-color: #44337a;\n  }\n\n  .xl\\:to-pink-100 {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .xl\\:to-pink-200 {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .xl\\:to-pink-300 {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .xl\\:to-pink-400 {\n    --gradient-to-color: #f687b3;\n  }\n\n  .xl\\:to-pink-500 {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .xl\\:to-pink-600 {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .xl\\:to-pink-700 {\n    --gradient-to-color: #b83280;\n  }\n\n  .xl\\:to-pink-800 {\n    --gradient-to-color: #97266d;\n  }\n\n  .xl\\:to-pink-900 {\n    --gradient-to-color: #702459;\n  }\n\n  .xl\\:hover\\:from-transparent:hover {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:hover\\:from-current:hover {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:hover\\:from-black:hover {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:hover\\:from-white:hover {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:hover\\:from-gray-100:hover {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .xl\\:hover\\:from-gray-200:hover {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .xl\\:hover\\:from-gray-300:hover {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .xl\\:hover\\:from-gray-400:hover {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .xl\\:hover\\:from-gray-500:hover {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .xl\\:hover\\:from-gray-600:hover {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .xl\\:hover\\:from-gray-700:hover {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .xl\\:hover\\:from-gray-800:hover {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .xl\\:hover\\:from-gray-900:hover {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .xl\\:hover\\:from-red-100:hover {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .xl\\:hover\\:from-red-200:hover {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .xl\\:hover\\:from-red-300:hover {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .xl\\:hover\\:from-red-400:hover {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .xl\\:hover\\:from-red-500:hover {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .xl\\:hover\\:from-red-600:hover {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .xl\\:hover\\:from-red-700:hover {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .xl\\:hover\\:from-red-800:hover {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .xl\\:hover\\:from-red-900:hover {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .xl\\:hover\\:from-orange-100:hover {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .xl\\:hover\\:from-orange-200:hover {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .xl\\:hover\\:from-orange-300:hover {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .xl\\:hover\\:from-orange-400:hover {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .xl\\:hover\\:from-orange-500:hover {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .xl\\:hover\\:from-orange-600:hover {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .xl\\:hover\\:from-orange-700:hover {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .xl\\:hover\\:from-orange-800:hover {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .xl\\:hover\\:from-orange-900:hover {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-100:hover {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-200:hover {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-300:hover {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-400:hover {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-500:hover {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-600:hover {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-700:hover {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-800:hover {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .xl\\:hover\\:from-yellow-900:hover {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .xl\\:hover\\:from-green-100:hover {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .xl\\:hover\\:from-green-200:hover {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .xl\\:hover\\:from-green-300:hover {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .xl\\:hover\\:from-green-400:hover {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .xl\\:hover\\:from-green-500:hover {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .xl\\:hover\\:from-green-600:hover {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .xl\\:hover\\:from-green-700:hover {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .xl\\:hover\\:from-green-800:hover {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .xl\\:hover\\:from-green-900:hover {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .xl\\:hover\\:from-teal-100:hover {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .xl\\:hover\\:from-teal-200:hover {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .xl\\:hover\\:from-teal-300:hover {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .xl\\:hover\\:from-teal-400:hover {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .xl\\:hover\\:from-teal-500:hover {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .xl\\:hover\\:from-teal-600:hover {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .xl\\:hover\\:from-teal-700:hover {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .xl\\:hover\\:from-teal-800:hover {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .xl\\:hover\\:from-teal-900:hover {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .xl\\:hover\\:from-blue-100:hover {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .xl\\:hover\\:from-blue-200:hover {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .xl\\:hover\\:from-blue-300:hover {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .xl\\:hover\\:from-blue-400:hover {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .xl\\:hover\\:from-blue-500:hover {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .xl\\:hover\\:from-blue-600:hover {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .xl\\:hover\\:from-blue-700:hover {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .xl\\:hover\\:from-blue-800:hover {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .xl\\:hover\\:from-blue-900:hover {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-100:hover {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-200:hover {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-300:hover {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-400:hover {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-500:hover {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-600:hover {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-700:hover {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-800:hover {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .xl\\:hover\\:from-indigo-900:hover {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .xl\\:hover\\:from-purple-100:hover {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .xl\\:hover\\:from-purple-200:hover {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .xl\\:hover\\:from-purple-300:hover {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .xl\\:hover\\:from-purple-400:hover {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .xl\\:hover\\:from-purple-500:hover {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .xl\\:hover\\:from-purple-600:hover {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .xl\\:hover\\:from-purple-700:hover {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .xl\\:hover\\:from-purple-800:hover {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .xl\\:hover\\:from-purple-900:hover {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .xl\\:hover\\:from-pink-100:hover {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .xl\\:hover\\:from-pink-200:hover {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .xl\\:hover\\:from-pink-300:hover {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .xl\\:hover\\:from-pink-400:hover {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .xl\\:hover\\:from-pink-500:hover {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .xl\\:hover\\:from-pink-600:hover {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .xl\\:hover\\:from-pink-700:hover {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .xl\\:hover\\:from-pink-800:hover {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .xl\\:hover\\:from-pink-900:hover {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .xl\\:hover\\:via-transparent:hover {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:hover\\:via-current:hover {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:hover\\:via-black:hover {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:hover\\:via-white:hover {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:hover\\:via-gray-100:hover {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .xl\\:hover\\:via-gray-200:hover {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .xl\\:hover\\:via-gray-300:hover {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .xl\\:hover\\:via-gray-400:hover {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .xl\\:hover\\:via-gray-500:hover {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .xl\\:hover\\:via-gray-600:hover {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .xl\\:hover\\:via-gray-700:hover {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .xl\\:hover\\:via-gray-800:hover {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .xl\\:hover\\:via-gray-900:hover {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .xl\\:hover\\:via-red-100:hover {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .xl\\:hover\\:via-red-200:hover {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .xl\\:hover\\:via-red-300:hover {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .xl\\:hover\\:via-red-400:hover {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .xl\\:hover\\:via-red-500:hover {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .xl\\:hover\\:via-red-600:hover {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .xl\\:hover\\:via-red-700:hover {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .xl\\:hover\\:via-red-800:hover {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .xl\\:hover\\:via-red-900:hover {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .xl\\:hover\\:via-orange-100:hover {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .xl\\:hover\\:via-orange-200:hover {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .xl\\:hover\\:via-orange-300:hover {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .xl\\:hover\\:via-orange-400:hover {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .xl\\:hover\\:via-orange-500:hover {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .xl\\:hover\\:via-orange-600:hover {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .xl\\:hover\\:via-orange-700:hover {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .xl\\:hover\\:via-orange-800:hover {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .xl\\:hover\\:via-orange-900:hover {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-100:hover {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-200:hover {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-300:hover {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-400:hover {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-500:hover {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-600:hover {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-700:hover {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-800:hover {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .xl\\:hover\\:via-yellow-900:hover {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .xl\\:hover\\:via-green-100:hover {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .xl\\:hover\\:via-green-200:hover {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .xl\\:hover\\:via-green-300:hover {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .xl\\:hover\\:via-green-400:hover {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .xl\\:hover\\:via-green-500:hover {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .xl\\:hover\\:via-green-600:hover {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .xl\\:hover\\:via-green-700:hover {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .xl\\:hover\\:via-green-800:hover {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .xl\\:hover\\:via-green-900:hover {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .xl\\:hover\\:via-teal-100:hover {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .xl\\:hover\\:via-teal-200:hover {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .xl\\:hover\\:via-teal-300:hover {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .xl\\:hover\\:via-teal-400:hover {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .xl\\:hover\\:via-teal-500:hover {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .xl\\:hover\\:via-teal-600:hover {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .xl\\:hover\\:via-teal-700:hover {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .xl\\:hover\\:via-teal-800:hover {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .xl\\:hover\\:via-teal-900:hover {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .xl\\:hover\\:via-blue-100:hover {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .xl\\:hover\\:via-blue-200:hover {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .xl\\:hover\\:via-blue-300:hover {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .xl\\:hover\\:via-blue-400:hover {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .xl\\:hover\\:via-blue-500:hover {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .xl\\:hover\\:via-blue-600:hover {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .xl\\:hover\\:via-blue-700:hover {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .xl\\:hover\\:via-blue-800:hover {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .xl\\:hover\\:via-blue-900:hover {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-100:hover {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-200:hover {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-300:hover {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-400:hover {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-500:hover {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-600:hover {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-700:hover {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-800:hover {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .xl\\:hover\\:via-indigo-900:hover {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .xl\\:hover\\:via-purple-100:hover {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .xl\\:hover\\:via-purple-200:hover {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .xl\\:hover\\:via-purple-300:hover {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .xl\\:hover\\:via-purple-400:hover {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .xl\\:hover\\:via-purple-500:hover {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .xl\\:hover\\:via-purple-600:hover {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .xl\\:hover\\:via-purple-700:hover {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .xl\\:hover\\:via-purple-800:hover {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .xl\\:hover\\:via-purple-900:hover {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .xl\\:hover\\:via-pink-100:hover {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .xl\\:hover\\:via-pink-200:hover {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .xl\\:hover\\:via-pink-300:hover {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .xl\\:hover\\:via-pink-400:hover {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .xl\\:hover\\:via-pink-500:hover {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .xl\\:hover\\:via-pink-600:hover {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .xl\\:hover\\:via-pink-700:hover {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .xl\\:hover\\:via-pink-800:hover {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .xl\\:hover\\:via-pink-900:hover {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .xl\\:hover\\:to-transparent:hover {\n    --gradient-to-color: transparent;\n  }\n\n  .xl\\:hover\\:to-current:hover {\n    --gradient-to-color: currentColor;\n  }\n\n  .xl\\:hover\\:to-black:hover {\n    --gradient-to-color: #000;\n  }\n\n  .xl\\:hover\\:to-white:hover {\n    --gradient-to-color: #fff;\n  }\n\n  .xl\\:hover\\:to-gray-100:hover {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .xl\\:hover\\:to-gray-200:hover {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .xl\\:hover\\:to-gray-300:hover {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .xl\\:hover\\:to-gray-400:hover {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .xl\\:hover\\:to-gray-500:hover {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .xl\\:hover\\:to-gray-600:hover {\n    --gradient-to-color: #718096;\n  }\n\n  .xl\\:hover\\:to-gray-700:hover {\n    --gradient-to-color: #4a5568;\n  }\n\n  .xl\\:hover\\:to-gray-800:hover {\n    --gradient-to-color: #2d3748;\n  }\n\n  .xl\\:hover\\:to-gray-900:hover {\n    --gradient-to-color: #1a202c;\n  }\n\n  .xl\\:hover\\:to-red-100:hover {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .xl\\:hover\\:to-red-200:hover {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .xl\\:hover\\:to-red-300:hover {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .xl\\:hover\\:to-red-400:hover {\n    --gradient-to-color: #fc8181;\n  }\n\n  .xl\\:hover\\:to-red-500:hover {\n    --gradient-to-color: #f56565;\n  }\n\n  .xl\\:hover\\:to-red-600:hover {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .xl\\:hover\\:to-red-700:hover {\n    --gradient-to-color: #c53030;\n  }\n\n  .xl\\:hover\\:to-red-800:hover {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .xl\\:hover\\:to-red-900:hover {\n    --gradient-to-color: #742a2a;\n  }\n\n  .xl\\:hover\\:to-orange-100:hover {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .xl\\:hover\\:to-orange-200:hover {\n    --gradient-to-color: #feebc8;\n  }\n\n  .xl\\:hover\\:to-orange-300:hover {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .xl\\:hover\\:to-orange-400:hover {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .xl\\:hover\\:to-orange-500:hover {\n    --gradient-to-color: #ed8936;\n  }\n\n  .xl\\:hover\\:to-orange-600:hover {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .xl\\:hover\\:to-orange-700:hover {\n    --gradient-to-color: #c05621;\n  }\n\n  .xl\\:hover\\:to-orange-800:hover {\n    --gradient-to-color: #9c4221;\n  }\n\n  .xl\\:hover\\:to-orange-900:hover {\n    --gradient-to-color: #7b341e;\n  }\n\n  .xl\\:hover\\:to-yellow-100:hover {\n    --gradient-to-color: #fffff0;\n  }\n\n  .xl\\:hover\\:to-yellow-200:hover {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .xl\\:hover\\:to-yellow-300:hover {\n    --gradient-to-color: #faf089;\n  }\n\n  .xl\\:hover\\:to-yellow-400:hover {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .xl\\:hover\\:to-yellow-500:hover {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .xl\\:hover\\:to-yellow-600:hover {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .xl\\:hover\\:to-yellow-700:hover {\n    --gradient-to-color: #b7791f;\n  }\n\n  .xl\\:hover\\:to-yellow-800:hover {\n    --gradient-to-color: #975a16;\n  }\n\n  .xl\\:hover\\:to-yellow-900:hover {\n    --gradient-to-color: #744210;\n  }\n\n  .xl\\:hover\\:to-green-100:hover {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .xl\\:hover\\:to-green-200:hover {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .xl\\:hover\\:to-green-300:hover {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .xl\\:hover\\:to-green-400:hover {\n    --gradient-to-color: #68d391;\n  }\n\n  .xl\\:hover\\:to-green-500:hover {\n    --gradient-to-color: #48bb78;\n  }\n\n  .xl\\:hover\\:to-green-600:hover {\n    --gradient-to-color: #38a169;\n  }\n\n  .xl\\:hover\\:to-green-700:hover {\n    --gradient-to-color: #2f855a;\n  }\n\n  .xl\\:hover\\:to-green-800:hover {\n    --gradient-to-color: #276749;\n  }\n\n  .xl\\:hover\\:to-green-900:hover {\n    --gradient-to-color: #22543d;\n  }\n\n  .xl\\:hover\\:to-teal-100:hover {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .xl\\:hover\\:to-teal-200:hover {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .xl\\:hover\\:to-teal-300:hover {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .xl\\:hover\\:to-teal-400:hover {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .xl\\:hover\\:to-teal-500:hover {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .xl\\:hover\\:to-teal-600:hover {\n    --gradient-to-color: #319795;\n  }\n\n  .xl\\:hover\\:to-teal-700:hover {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .xl\\:hover\\:to-teal-800:hover {\n    --gradient-to-color: #285e61;\n  }\n\n  .xl\\:hover\\:to-teal-900:hover {\n    --gradient-to-color: #234e52;\n  }\n\n  .xl\\:hover\\:to-blue-100:hover {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .xl\\:hover\\:to-blue-200:hover {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .xl\\:hover\\:to-blue-300:hover {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .xl\\:hover\\:to-blue-400:hover {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .xl\\:hover\\:to-blue-500:hover {\n    --gradient-to-color: #4299e1;\n  }\n\n  .xl\\:hover\\:to-blue-600:hover {\n    --gradient-to-color: #3182ce;\n  }\n\n  .xl\\:hover\\:to-blue-700:hover {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .xl\\:hover\\:to-blue-800:hover {\n    --gradient-to-color: #2c5282;\n  }\n\n  .xl\\:hover\\:to-blue-900:hover {\n    --gradient-to-color: #2a4365;\n  }\n\n  .xl\\:hover\\:to-indigo-100:hover {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .xl\\:hover\\:to-indigo-200:hover {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .xl\\:hover\\:to-indigo-300:hover {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .xl\\:hover\\:to-indigo-400:hover {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .xl\\:hover\\:to-indigo-500:hover {\n    --gradient-to-color: #667eea;\n  }\n\n  .xl\\:hover\\:to-indigo-600:hover {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .xl\\:hover\\:to-indigo-700:hover {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .xl\\:hover\\:to-indigo-800:hover {\n    --gradient-to-color: #434190;\n  }\n\n  .xl\\:hover\\:to-indigo-900:hover {\n    --gradient-to-color: #3c366b;\n  }\n\n  .xl\\:hover\\:to-purple-100:hover {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .xl\\:hover\\:to-purple-200:hover {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .xl\\:hover\\:to-purple-300:hover {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .xl\\:hover\\:to-purple-400:hover {\n    --gradient-to-color: #b794f4;\n  }\n\n  .xl\\:hover\\:to-purple-500:hover {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .xl\\:hover\\:to-purple-600:hover {\n    --gradient-to-color: #805ad5;\n  }\n\n  .xl\\:hover\\:to-purple-700:hover {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .xl\\:hover\\:to-purple-800:hover {\n    --gradient-to-color: #553c9a;\n  }\n\n  .xl\\:hover\\:to-purple-900:hover {\n    --gradient-to-color: #44337a;\n  }\n\n  .xl\\:hover\\:to-pink-100:hover {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .xl\\:hover\\:to-pink-200:hover {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .xl\\:hover\\:to-pink-300:hover {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .xl\\:hover\\:to-pink-400:hover {\n    --gradient-to-color: #f687b3;\n  }\n\n  .xl\\:hover\\:to-pink-500:hover {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .xl\\:hover\\:to-pink-600:hover {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .xl\\:hover\\:to-pink-700:hover {\n    --gradient-to-color: #b83280;\n  }\n\n  .xl\\:hover\\:to-pink-800:hover {\n    --gradient-to-color: #97266d;\n  }\n\n  .xl\\:hover\\:to-pink-900:hover {\n    --gradient-to-color: #702459;\n  }\n\n  .xl\\:focus\\:from-transparent:focus {\n    --gradient-from-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:focus\\:from-current:focus {\n    --gradient-from-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:focus\\:from-black:focus {\n    --gradient-from-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:focus\\:from-white:focus {\n    --gradient-from-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:focus\\:from-gray-100:focus {\n    --gradient-from-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .xl\\:focus\\:from-gray-200:focus {\n    --gradient-from-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .xl\\:focus\\:from-gray-300:focus {\n    --gradient-from-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .xl\\:focus\\:from-gray-400:focus {\n    --gradient-from-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .xl\\:focus\\:from-gray-500:focus {\n    --gradient-from-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .xl\\:focus\\:from-gray-600:focus {\n    --gradient-from-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .xl\\:focus\\:from-gray-700:focus {\n    --gradient-from-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .xl\\:focus\\:from-gray-800:focus {\n    --gradient-from-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .xl\\:focus\\:from-gray-900:focus {\n    --gradient-from-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .xl\\:focus\\:from-red-100:focus {\n    --gradient-from-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .xl\\:focus\\:from-red-200:focus {\n    --gradient-from-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .xl\\:focus\\:from-red-300:focus {\n    --gradient-from-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .xl\\:focus\\:from-red-400:focus {\n    --gradient-from-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .xl\\:focus\\:from-red-500:focus {\n    --gradient-from-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .xl\\:focus\\:from-red-600:focus {\n    --gradient-from-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .xl\\:focus\\:from-red-700:focus {\n    --gradient-from-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .xl\\:focus\\:from-red-800:focus {\n    --gradient-from-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .xl\\:focus\\:from-red-900:focus {\n    --gradient-from-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .xl\\:focus\\:from-orange-100:focus {\n    --gradient-from-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .xl\\:focus\\:from-orange-200:focus {\n    --gradient-from-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .xl\\:focus\\:from-orange-300:focus {\n    --gradient-from-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .xl\\:focus\\:from-orange-400:focus {\n    --gradient-from-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .xl\\:focus\\:from-orange-500:focus {\n    --gradient-from-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .xl\\:focus\\:from-orange-600:focus {\n    --gradient-from-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .xl\\:focus\\:from-orange-700:focus {\n    --gradient-from-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .xl\\:focus\\:from-orange-800:focus {\n    --gradient-from-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .xl\\:focus\\:from-orange-900:focus {\n    --gradient-from-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-100:focus {\n    --gradient-from-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-200:focus {\n    --gradient-from-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-300:focus {\n    --gradient-from-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-400:focus {\n    --gradient-from-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-500:focus {\n    --gradient-from-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-600:focus {\n    --gradient-from-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-700:focus {\n    --gradient-from-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-800:focus {\n    --gradient-from-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .xl\\:focus\\:from-yellow-900:focus {\n    --gradient-from-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .xl\\:focus\\:from-green-100:focus {\n    --gradient-from-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .xl\\:focus\\:from-green-200:focus {\n    --gradient-from-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .xl\\:focus\\:from-green-300:focus {\n    --gradient-from-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .xl\\:focus\\:from-green-400:focus {\n    --gradient-from-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .xl\\:focus\\:from-green-500:focus {\n    --gradient-from-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .xl\\:focus\\:from-green-600:focus {\n    --gradient-from-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .xl\\:focus\\:from-green-700:focus {\n    --gradient-from-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .xl\\:focus\\:from-green-800:focus {\n    --gradient-from-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .xl\\:focus\\:from-green-900:focus {\n    --gradient-from-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .xl\\:focus\\:from-teal-100:focus {\n    --gradient-from-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .xl\\:focus\\:from-teal-200:focus {\n    --gradient-from-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .xl\\:focus\\:from-teal-300:focus {\n    --gradient-from-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .xl\\:focus\\:from-teal-400:focus {\n    --gradient-from-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .xl\\:focus\\:from-teal-500:focus {\n    --gradient-from-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .xl\\:focus\\:from-teal-600:focus {\n    --gradient-from-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .xl\\:focus\\:from-teal-700:focus {\n    --gradient-from-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .xl\\:focus\\:from-teal-800:focus {\n    --gradient-from-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .xl\\:focus\\:from-teal-900:focus {\n    --gradient-from-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .xl\\:focus\\:from-blue-100:focus {\n    --gradient-from-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .xl\\:focus\\:from-blue-200:focus {\n    --gradient-from-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .xl\\:focus\\:from-blue-300:focus {\n    --gradient-from-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .xl\\:focus\\:from-blue-400:focus {\n    --gradient-from-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .xl\\:focus\\:from-blue-500:focus {\n    --gradient-from-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .xl\\:focus\\:from-blue-600:focus {\n    --gradient-from-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .xl\\:focus\\:from-blue-700:focus {\n    --gradient-from-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .xl\\:focus\\:from-blue-800:focus {\n    --gradient-from-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .xl\\:focus\\:from-blue-900:focus {\n    --gradient-from-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-100:focus {\n    --gradient-from-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-200:focus {\n    --gradient-from-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-300:focus {\n    --gradient-from-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-400:focus {\n    --gradient-from-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-500:focus {\n    --gradient-from-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-600:focus {\n    --gradient-from-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-700:focus {\n    --gradient-from-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-800:focus {\n    --gradient-from-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .xl\\:focus\\:from-indigo-900:focus {\n    --gradient-from-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .xl\\:focus\\:from-purple-100:focus {\n    --gradient-from-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .xl\\:focus\\:from-purple-200:focus {\n    --gradient-from-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .xl\\:focus\\:from-purple-300:focus {\n    --gradient-from-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .xl\\:focus\\:from-purple-400:focus {\n    --gradient-from-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .xl\\:focus\\:from-purple-500:focus {\n    --gradient-from-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .xl\\:focus\\:from-purple-600:focus {\n    --gradient-from-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .xl\\:focus\\:from-purple-700:focus {\n    --gradient-from-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .xl\\:focus\\:from-purple-800:focus {\n    --gradient-from-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .xl\\:focus\\:from-purple-900:focus {\n    --gradient-from-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .xl\\:focus\\:from-pink-100:focus {\n    --gradient-from-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .xl\\:focus\\:from-pink-200:focus {\n    --gradient-from-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .xl\\:focus\\:from-pink-300:focus {\n    --gradient-from-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .xl\\:focus\\:from-pink-400:focus {\n    --gradient-from-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .xl\\:focus\\:from-pink-500:focus {\n    --gradient-from-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .xl\\:focus\\:from-pink-600:focus {\n    --gradient-from-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .xl\\:focus\\:from-pink-700:focus {\n    --gradient-from-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .xl\\:focus\\:from-pink-800:focus {\n    --gradient-from-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .xl\\:focus\\:from-pink-900:focus {\n    --gradient-from-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .xl\\:focus\\:via-transparent:focus {\n    --gradient-via-color: transparent;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:focus\\:via-current:focus {\n    --gradient-via-color: currentColor;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:focus\\:via-black:focus {\n    --gradient-via-color: #000;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));\n  }\n\n  .xl\\:focus\\:via-white:focus {\n    --gradient-via-color: #fff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));\n  }\n\n  .xl\\:focus\\:via-gray-100:focus {\n    --gradient-via-color: #f7fafc;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 250, 252, 0));\n  }\n\n  .xl\\:focus\\:via-gray-200:focus {\n    --gradient-via-color: #edf2f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 242, 247, 0));\n  }\n\n  .xl\\:focus\\:via-gray-300:focus {\n    --gradient-via-color: #e2e8f0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(226, 232, 240, 0));\n  }\n\n  .xl\\:focus\\:via-gray-400:focus {\n    --gradient-via-color: #cbd5e0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(203, 213, 224, 0));\n  }\n\n  .xl\\:focus\\:via-gray-500:focus {\n    --gradient-via-color: #a0aec0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 174, 192, 0));\n  }\n\n  .xl\\:focus\\:via-gray-600:focus {\n    --gradient-via-color: #718096;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(113, 128, 150, 0));\n  }\n\n  .xl\\:focus\\:via-gray-700:focus {\n    --gradient-via-color: #4a5568;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(74, 85, 104, 0));\n  }\n\n  .xl\\:focus\\:via-gray-800:focus {\n    --gradient-via-color: #2d3748;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(45, 55, 72, 0));\n  }\n\n  .xl\\:focus\\:via-gray-900:focus {\n    --gradient-via-color: #1a202c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(26, 32, 44, 0));\n  }\n\n  .xl\\:focus\\:via-red-100:focus {\n    --gradient-via-color: #fff5f5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 245, 0));\n  }\n\n  .xl\\:focus\\:via-red-200:focus {\n    --gradient-via-color: #fed7d7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 215, 0));\n  }\n\n  .xl\\:focus\\:via-red-300:focus {\n    --gradient-via-color: #feb2b2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 178, 178, 0));\n  }\n\n  .xl\\:focus\\:via-red-400:focus {\n    --gradient-via-color: #fc8181;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(252, 129, 129, 0));\n  }\n\n  .xl\\:focus\\:via-red-500:focus {\n    --gradient-via-color: #f56565;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 101, 101, 0));\n  }\n\n  .xl\\:focus\\:via-red-600:focus {\n    --gradient-via-color: #e53e3e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(229, 62, 62, 0));\n  }\n\n  .xl\\:focus\\:via-red-700:focus {\n    --gradient-via-color: #c53030;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 48, 48, 0));\n  }\n\n  .xl\\:focus\\:via-red-800:focus {\n    --gradient-via-color: #9b2c2c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(155, 44, 44, 0));\n  }\n\n  .xl\\:focus\\:via-red-900:focus {\n    --gradient-via-color: #742a2a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 42, 42, 0));\n  }\n\n  .xl\\:focus\\:via-orange-100:focus {\n    --gradient-via-color: #fffaf0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 250, 240, 0));\n  }\n\n  .xl\\:focus\\:via-orange-200:focus {\n    --gradient-via-color: #feebc8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 235, 200, 0));\n  }\n\n  .xl\\:focus\\:via-orange-300:focus {\n    --gradient-via-color: #fbd38d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 211, 141, 0));\n  }\n\n  .xl\\:focus\\:via-orange-400:focus {\n    --gradient-via-color: #f6ad55;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 173, 85, 0));\n  }\n\n  .xl\\:focus\\:via-orange-500:focus {\n    --gradient-via-color: #ed8936;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 137, 54, 0));\n  }\n\n  .xl\\:focus\\:via-orange-600:focus {\n    --gradient-via-color: #dd6b20;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 107, 32, 0));\n  }\n\n  .xl\\:focus\\:via-orange-700:focus {\n    --gradient-via-color: #c05621;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(192, 86, 33, 0));\n  }\n\n  .xl\\:focus\\:via-orange-800:focus {\n    --gradient-via-color: #9c4221;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 66, 33, 0));\n  }\n\n  .xl\\:focus\\:via-orange-900:focus {\n    --gradient-via-color: #7b341e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(123, 52, 30, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-100:focus {\n    --gradient-via-color: #fffff0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 240, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-200:focus {\n    --gradient-via-color: #fefcbf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 252, 191, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-300:focus {\n    --gradient-via-color: #faf089;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 240, 137, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-400:focus {\n    --gradient-via-color: #f6e05e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 224, 94, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-500:focus {\n    --gradient-via-color: #ecc94b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(236, 201, 75, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-600:focus {\n    --gradient-via-color: #d69e2e;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 158, 46, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-700:focus {\n    --gradient-via-color: #b7791f;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 121, 31, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-800:focus {\n    --gradient-via-color: #975a16;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 90, 22, 0));\n  }\n\n  .xl\\:focus\\:via-yellow-900:focus {\n    --gradient-via-color: #744210;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 66, 16, 0));\n  }\n\n  .xl\\:focus\\:via-green-100:focus {\n    --gradient-via-color: #f0fff4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 255, 244, 0));\n  }\n\n  .xl\\:focus\\:via-green-200:focus {\n    --gradient-via-color: #c6f6d5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(198, 246, 213, 0));\n  }\n\n  .xl\\:focus\\:via-green-300:focus {\n    --gradient-via-color: #9ae6b4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(154, 230, 180, 0));\n  }\n\n  .xl\\:focus\\:via-green-400:focus {\n    --gradient-via-color: #68d391;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 211, 145, 0));\n  }\n\n  .xl\\:focus\\:via-green-500:focus {\n    --gradient-via-color: #48bb78;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(72, 187, 120, 0));\n  }\n\n  .xl\\:focus\\:via-green-600:focus {\n    --gradient-via-color: #38a169;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 161, 105, 0));\n  }\n\n  .xl\\:focus\\:via-green-700:focus {\n    --gradient-via-color: #2f855a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(47, 133, 90, 0));\n  }\n\n  .xl\\:focus\\:via-green-800:focus {\n    --gradient-via-color: #276749;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(39, 103, 73, 0));\n  }\n\n  .xl\\:focus\\:via-green-900:focus {\n    --gradient-via-color: #22543d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(34, 84, 61, 0));\n  }\n\n  .xl\\:focus\\:via-teal-100:focus {\n    --gradient-via-color: #e6fffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 255, 250, 0));\n  }\n\n  .xl\\:focus\\:via-teal-200:focus {\n    --gradient-via-color: #b2f5ea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(178, 245, 234, 0));\n  }\n\n  .xl\\:focus\\:via-teal-300:focus {\n    --gradient-via-color: #81e6d9;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(129, 230, 217, 0));\n  }\n\n  .xl\\:focus\\:via-teal-400:focus {\n    --gradient-via-color: #4fd1c5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 209, 197, 0));\n  }\n\n  .xl\\:focus\\:via-teal-500:focus {\n    --gradient-via-color: #38b2ac;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(56, 178, 172, 0));\n  }\n\n  .xl\\:focus\\:via-teal-600:focus {\n    --gradient-via-color: #319795;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 151, 149, 0));\n  }\n\n  .xl\\:focus\\:via-teal-700:focus {\n    --gradient-via-color: #2c7a7b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 122, 123, 0));\n  }\n\n  .xl\\:focus\\:via-teal-800:focus {\n    --gradient-via-color: #285e61;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(40, 94, 97, 0));\n  }\n\n  .xl\\:focus\\:via-teal-900:focus {\n    --gradient-via-color: #234e52;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(35, 78, 82, 0));\n  }\n\n  .xl\\:focus\\:via-blue-100:focus {\n    --gradient-via-color: #ebf8ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 248, 255, 0));\n  }\n\n  .xl\\:focus\\:via-blue-200:focus {\n    --gradient-via-color: #bee3f8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(190, 227, 248, 0));\n  }\n\n  .xl\\:focus\\:via-blue-300:focus {\n    --gradient-via-color: #90cdf4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(144, 205, 244, 0));\n  }\n\n  .xl\\:focus\\:via-blue-400:focus {\n    --gradient-via-color: #63b3ed;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(99, 179, 237, 0));\n  }\n\n  .xl\\:focus\\:via-blue-500:focus {\n    --gradient-via-color: #4299e1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(66, 153, 225, 0));\n  }\n\n  .xl\\:focus\\:via-blue-600:focus {\n    --gradient-via-color: #3182ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(49, 130, 206, 0));\n  }\n\n  .xl\\:focus\\:via-blue-700:focus {\n    --gradient-via-color: #2b6cb0;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(43, 108, 176, 0));\n  }\n\n  .xl\\:focus\\:via-blue-800:focus {\n    --gradient-via-color: #2c5282;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(44, 82, 130, 0));\n  }\n\n  .xl\\:focus\\:via-blue-900:focus {\n    --gradient-via-color: #2a4365;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 67, 101, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-100:focus {\n    --gradient-via-color: #ebf4ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 244, 255, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-200:focus {\n    --gradient-via-color: #c3dafe;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(195, 218, 254, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-300:focus {\n    --gradient-via-color: #a3bffa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(163, 191, 250, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-400:focus {\n    --gradient-via-color: #7f9cf5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(127, 156, 245, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-500:focus {\n    --gradient-via-color: #667eea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(102, 126, 234, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-600:focus {\n    --gradient-via-color: #5a67d8;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 103, 216, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-700:focus {\n    --gradient-via-color: #4c51bf;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(76, 81, 191, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-800:focus {\n    --gradient-via-color: #434190;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(67, 65, 144, 0));\n  }\n\n  .xl\\:focus\\:via-indigo-900:focus {\n    --gradient-via-color: #3c366b;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 54, 107, 0));\n  }\n\n  .xl\\:focus\\:via-purple-100:focus {\n    --gradient-via-color: #faf5ff;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(250, 245, 255, 0));\n  }\n\n  .xl\\:focus\\:via-purple-200:focus {\n    --gradient-via-color: #e9d8fd;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(233, 216, 253, 0));\n  }\n\n  .xl\\:focus\\:via-purple-300:focus {\n    --gradient-via-color: #d6bcfa;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(214, 188, 250, 0));\n  }\n\n  .xl\\:focus\\:via-purple-400:focus {\n    --gradient-via-color: #b794f4;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(183, 148, 244, 0));\n  }\n\n  .xl\\:focus\\:via-purple-500:focus {\n    --gradient-via-color: #9f7aea;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(159, 122, 234, 0));\n  }\n\n  .xl\\:focus\\:via-purple-600:focus {\n    --gradient-via-color: #805ad5;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(128, 90, 213, 0));\n  }\n\n  .xl\\:focus\\:via-purple-700:focus {\n    --gradient-via-color: #6b46c1;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(107, 70, 193, 0));\n  }\n\n  .xl\\:focus\\:via-purple-800:focus {\n    --gradient-via-color: #553c9a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(85, 60, 154, 0));\n  }\n\n  .xl\\:focus\\:via-purple-900:focus {\n    --gradient-via-color: #44337a;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(68, 51, 122, 0));\n  }\n\n  .xl\\:focus\\:via-pink-100:focus {\n    --gradient-via-color: #fff5f7;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 245, 247, 0));\n  }\n\n  .xl\\:focus\\:via-pink-200:focus {\n    --gradient-via-color: #fed7e2;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 215, 226, 0));\n  }\n\n  .xl\\:focus\\:via-pink-300:focus {\n    --gradient-via-color: #fbb6ce;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(251, 182, 206, 0));\n  }\n\n  .xl\\:focus\\:via-pink-400:focus {\n    --gradient-via-color: #f687b3;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 135, 179, 0));\n  }\n\n  .xl\\:focus\\:via-pink-500:focus {\n    --gradient-via-color: #ed64a6;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(237, 100, 166, 0));\n  }\n\n  .xl\\:focus\\:via-pink-600:focus {\n    --gradient-via-color: #d53f8c;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(213, 63, 140, 0));\n  }\n\n  .xl\\:focus\\:via-pink-700:focus {\n    --gradient-via-color: #b83280;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 50, 128, 0));\n  }\n\n  .xl\\:focus\\:via-pink-800:focus {\n    --gradient-via-color: #97266d;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 38, 109, 0));\n  }\n\n  .xl\\:focus\\:via-pink-900:focus {\n    --gradient-via-color: #702459;\n    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(112, 36, 89, 0));\n  }\n\n  .xl\\:focus\\:to-transparent:focus {\n    --gradient-to-color: transparent;\n  }\n\n  .xl\\:focus\\:to-current:focus {\n    --gradient-to-color: currentColor;\n  }\n\n  .xl\\:focus\\:to-black:focus {\n    --gradient-to-color: #000;\n  }\n\n  .xl\\:focus\\:to-white:focus {\n    --gradient-to-color: #fff;\n  }\n\n  .xl\\:focus\\:to-gray-100:focus {\n    --gradient-to-color: #f7fafc;\n  }\n\n  .xl\\:focus\\:to-gray-200:focus {\n    --gradient-to-color: #edf2f7;\n  }\n\n  .xl\\:focus\\:to-gray-300:focus {\n    --gradient-to-color: #e2e8f0;\n  }\n\n  .xl\\:focus\\:to-gray-400:focus {\n    --gradient-to-color: #cbd5e0;\n  }\n\n  .xl\\:focus\\:to-gray-500:focus {\n    --gradient-to-color: #a0aec0;\n  }\n\n  .xl\\:focus\\:to-gray-600:focus {\n    --gradient-to-color: #718096;\n  }\n\n  .xl\\:focus\\:to-gray-700:focus {\n    --gradient-to-color: #4a5568;\n  }\n\n  .xl\\:focus\\:to-gray-800:focus {\n    --gradient-to-color: #2d3748;\n  }\n\n  .xl\\:focus\\:to-gray-900:focus {\n    --gradient-to-color: #1a202c;\n  }\n\n  .xl\\:focus\\:to-red-100:focus {\n    --gradient-to-color: #fff5f5;\n  }\n\n  .xl\\:focus\\:to-red-200:focus {\n    --gradient-to-color: #fed7d7;\n  }\n\n  .xl\\:focus\\:to-red-300:focus {\n    --gradient-to-color: #feb2b2;\n  }\n\n  .xl\\:focus\\:to-red-400:focus {\n    --gradient-to-color: #fc8181;\n  }\n\n  .xl\\:focus\\:to-red-500:focus {\n    --gradient-to-color: #f56565;\n  }\n\n  .xl\\:focus\\:to-red-600:focus {\n    --gradient-to-color: #e53e3e;\n  }\n\n  .xl\\:focus\\:to-red-700:focus {\n    --gradient-to-color: #c53030;\n  }\n\n  .xl\\:focus\\:to-red-800:focus {\n    --gradient-to-color: #9b2c2c;\n  }\n\n  .xl\\:focus\\:to-red-900:focus {\n    --gradient-to-color: #742a2a;\n  }\n\n  .xl\\:focus\\:to-orange-100:focus {\n    --gradient-to-color: #fffaf0;\n  }\n\n  .xl\\:focus\\:to-orange-200:focus {\n    --gradient-to-color: #feebc8;\n  }\n\n  .xl\\:focus\\:to-orange-300:focus {\n    --gradient-to-color: #fbd38d;\n  }\n\n  .xl\\:focus\\:to-orange-400:focus {\n    --gradient-to-color: #f6ad55;\n  }\n\n  .xl\\:focus\\:to-orange-500:focus {\n    --gradient-to-color: #ed8936;\n  }\n\n  .xl\\:focus\\:to-orange-600:focus {\n    --gradient-to-color: #dd6b20;\n  }\n\n  .xl\\:focus\\:to-orange-700:focus {\n    --gradient-to-color: #c05621;\n  }\n\n  .xl\\:focus\\:to-orange-800:focus {\n    --gradient-to-color: #9c4221;\n  }\n\n  .xl\\:focus\\:to-orange-900:focus {\n    --gradient-to-color: #7b341e;\n  }\n\n  .xl\\:focus\\:to-yellow-100:focus {\n    --gradient-to-color: #fffff0;\n  }\n\n  .xl\\:focus\\:to-yellow-200:focus {\n    --gradient-to-color: #fefcbf;\n  }\n\n  .xl\\:focus\\:to-yellow-300:focus {\n    --gradient-to-color: #faf089;\n  }\n\n  .xl\\:focus\\:to-yellow-400:focus {\n    --gradient-to-color: #f6e05e;\n  }\n\n  .xl\\:focus\\:to-yellow-500:focus {\n    --gradient-to-color: #ecc94b;\n  }\n\n  .xl\\:focus\\:to-yellow-600:focus {\n    --gradient-to-color: #d69e2e;\n  }\n\n  .xl\\:focus\\:to-yellow-700:focus {\n    --gradient-to-color: #b7791f;\n  }\n\n  .xl\\:focus\\:to-yellow-800:focus {\n    --gradient-to-color: #975a16;\n  }\n\n  .xl\\:focus\\:to-yellow-900:focus {\n    --gradient-to-color: #744210;\n  }\n\n  .xl\\:focus\\:to-green-100:focus {\n    --gradient-to-color: #f0fff4;\n  }\n\n  .xl\\:focus\\:to-green-200:focus {\n    --gradient-to-color: #c6f6d5;\n  }\n\n  .xl\\:focus\\:to-green-300:focus {\n    --gradient-to-color: #9ae6b4;\n  }\n\n  .xl\\:focus\\:to-green-400:focus {\n    --gradient-to-color: #68d391;\n  }\n\n  .xl\\:focus\\:to-green-500:focus {\n    --gradient-to-color: #48bb78;\n  }\n\n  .xl\\:focus\\:to-green-600:focus {\n    --gradient-to-color: #38a169;\n  }\n\n  .xl\\:focus\\:to-green-700:focus {\n    --gradient-to-color: #2f855a;\n  }\n\n  .xl\\:focus\\:to-green-800:focus {\n    --gradient-to-color: #276749;\n  }\n\n  .xl\\:focus\\:to-green-900:focus {\n    --gradient-to-color: #22543d;\n  }\n\n  .xl\\:focus\\:to-teal-100:focus {\n    --gradient-to-color: #e6fffa;\n  }\n\n  .xl\\:focus\\:to-teal-200:focus {\n    --gradient-to-color: #b2f5ea;\n  }\n\n  .xl\\:focus\\:to-teal-300:focus {\n    --gradient-to-color: #81e6d9;\n  }\n\n  .xl\\:focus\\:to-teal-400:focus {\n    --gradient-to-color: #4fd1c5;\n  }\n\n  .xl\\:focus\\:to-teal-500:focus {\n    --gradient-to-color: #38b2ac;\n  }\n\n  .xl\\:focus\\:to-teal-600:focus {\n    --gradient-to-color: #319795;\n  }\n\n  .xl\\:focus\\:to-teal-700:focus {\n    --gradient-to-color: #2c7a7b;\n  }\n\n  .xl\\:focus\\:to-teal-800:focus {\n    --gradient-to-color: #285e61;\n  }\n\n  .xl\\:focus\\:to-teal-900:focus {\n    --gradient-to-color: #234e52;\n  }\n\n  .xl\\:focus\\:to-blue-100:focus {\n    --gradient-to-color: #ebf8ff;\n  }\n\n  .xl\\:focus\\:to-blue-200:focus {\n    --gradient-to-color: #bee3f8;\n  }\n\n  .xl\\:focus\\:to-blue-300:focus {\n    --gradient-to-color: #90cdf4;\n  }\n\n  .xl\\:focus\\:to-blue-400:focus {\n    --gradient-to-color: #63b3ed;\n  }\n\n  .xl\\:focus\\:to-blue-500:focus {\n    --gradient-to-color: #4299e1;\n  }\n\n  .xl\\:focus\\:to-blue-600:focus {\n    --gradient-to-color: #3182ce;\n  }\n\n  .xl\\:focus\\:to-blue-700:focus {\n    --gradient-to-color: #2b6cb0;\n  }\n\n  .xl\\:focus\\:to-blue-800:focus {\n    --gradient-to-color: #2c5282;\n  }\n\n  .xl\\:focus\\:to-blue-900:focus {\n    --gradient-to-color: #2a4365;\n  }\n\n  .xl\\:focus\\:to-indigo-100:focus {\n    --gradient-to-color: #ebf4ff;\n  }\n\n  .xl\\:focus\\:to-indigo-200:focus {\n    --gradient-to-color: #c3dafe;\n  }\n\n  .xl\\:focus\\:to-indigo-300:focus {\n    --gradient-to-color: #a3bffa;\n  }\n\n  .xl\\:focus\\:to-indigo-400:focus {\n    --gradient-to-color: #7f9cf5;\n  }\n\n  .xl\\:focus\\:to-indigo-500:focus {\n    --gradient-to-color: #667eea;\n  }\n\n  .xl\\:focus\\:to-indigo-600:focus {\n    --gradient-to-color: #5a67d8;\n  }\n\n  .xl\\:focus\\:to-indigo-700:focus {\n    --gradient-to-color: #4c51bf;\n  }\n\n  .xl\\:focus\\:to-indigo-800:focus {\n    --gradient-to-color: #434190;\n  }\n\n  .xl\\:focus\\:to-indigo-900:focus {\n    --gradient-to-color: #3c366b;\n  }\n\n  .xl\\:focus\\:to-purple-100:focus {\n    --gradient-to-color: #faf5ff;\n  }\n\n  .xl\\:focus\\:to-purple-200:focus {\n    --gradient-to-color: #e9d8fd;\n  }\n\n  .xl\\:focus\\:to-purple-300:focus {\n    --gradient-to-color: #d6bcfa;\n  }\n\n  .xl\\:focus\\:to-purple-400:focus {\n    --gradient-to-color: #b794f4;\n  }\n\n  .xl\\:focus\\:to-purple-500:focus {\n    --gradient-to-color: #9f7aea;\n  }\n\n  .xl\\:focus\\:to-purple-600:focus {\n    --gradient-to-color: #805ad5;\n  }\n\n  .xl\\:focus\\:to-purple-700:focus {\n    --gradient-to-color: #6b46c1;\n  }\n\n  .xl\\:focus\\:to-purple-800:focus {\n    --gradient-to-color: #553c9a;\n  }\n\n  .xl\\:focus\\:to-purple-900:focus {\n    --gradient-to-color: #44337a;\n  }\n\n  .xl\\:focus\\:to-pink-100:focus {\n    --gradient-to-color: #fff5f7;\n  }\n\n  .xl\\:focus\\:to-pink-200:focus {\n    --gradient-to-color: #fed7e2;\n  }\n\n  .xl\\:focus\\:to-pink-300:focus {\n    --gradient-to-color: #fbb6ce;\n  }\n\n  .xl\\:focus\\:to-pink-400:focus {\n    --gradient-to-color: #f687b3;\n  }\n\n  .xl\\:focus\\:to-pink-500:focus {\n    --gradient-to-color: #ed64a6;\n  }\n\n  .xl\\:focus\\:to-pink-600:focus {\n    --gradient-to-color: #d53f8c;\n  }\n\n  .xl\\:focus\\:to-pink-700:focus {\n    --gradient-to-color: #b83280;\n  }\n\n  .xl\\:focus\\:to-pink-800:focus {\n    --gradient-to-color: #97266d;\n  }\n\n  .xl\\:focus\\:to-pink-900:focus {\n    --gradient-to-color: #702459;\n  }\n\n  .xl\\:bg-opacity-0 {\n    --bg-opacity: 0;\n  }\n\n  .xl\\:bg-opacity-25 {\n    --bg-opacity: 0.25;\n  }\n\n  .xl\\:bg-opacity-50 {\n    --bg-opacity: 0.5;\n  }\n\n  .xl\\:bg-opacity-75 {\n    --bg-opacity: 0.75;\n  }\n\n  .xl\\:bg-opacity-100 {\n    --bg-opacity: 1;\n  }\n\n  .xl\\:hover\\:bg-opacity-0:hover {\n    --bg-opacity: 0;\n  }\n\n  .xl\\:hover\\:bg-opacity-25:hover {\n    --bg-opacity: 0.25;\n  }\n\n  .xl\\:hover\\:bg-opacity-50:hover {\n    --bg-opacity: 0.5;\n  }\n\n  .xl\\:hover\\:bg-opacity-75:hover {\n    --bg-opacity: 0.75;\n  }\n\n  .xl\\:hover\\:bg-opacity-100:hover {\n    --bg-opacity: 1;\n  }\n\n  .xl\\:focus\\:bg-opacity-0:focus {\n    --bg-opacity: 0;\n  }\n\n  .xl\\:focus\\:bg-opacity-25:focus {\n    --bg-opacity: 0.25;\n  }\n\n  .xl\\:focus\\:bg-opacity-50:focus {\n    --bg-opacity: 0.5;\n  }\n\n  .xl\\:focus\\:bg-opacity-75:focus {\n    --bg-opacity: 0.75;\n  }\n\n  .xl\\:focus\\:bg-opacity-100:focus {\n    --bg-opacity: 1;\n  }\n\n  .xl\\:bg-bottom {\n    background-position: bottom;\n  }\n\n  .xl\\:bg-center {\n    background-position: center;\n  }\n\n  .xl\\:bg-left {\n    background-position: left;\n  }\n\n  .xl\\:bg-left-bottom {\n    background-position: left bottom;\n  }\n\n  .xl\\:bg-left-top {\n    background-position: left top;\n  }\n\n  .xl\\:bg-right {\n    background-position: right;\n  }\n\n  .xl\\:bg-right-bottom {\n    background-position: right bottom;\n  }\n\n  .xl\\:bg-right-top {\n    background-position: right top;\n  }\n\n  .xl\\:bg-top {\n    background-position: top;\n  }\n\n  .xl\\:bg-repeat {\n    background-repeat: repeat;\n  }\n\n  .xl\\:bg-no-repeat {\n    background-repeat: no-repeat;\n  }\n\n  .xl\\:bg-repeat-x {\n    background-repeat: repeat-x;\n  }\n\n  .xl\\:bg-repeat-y {\n    background-repeat: repeat-y;\n  }\n\n  .xl\\:bg-repeat-round {\n    background-repeat: round;\n  }\n\n  .xl\\:bg-repeat-space {\n    background-repeat: space;\n  }\n\n  .xl\\:bg-auto {\n    background-size: auto;\n  }\n\n  .xl\\:bg-cover {\n    background-size: cover;\n  }\n\n  .xl\\:bg-contain {\n    background-size: contain;\n  }\n\n  .xl\\:border-collapse {\n    border-collapse: collapse;\n  }\n\n  .xl\\:border-separate {\n    border-collapse: separate;\n  }\n\n  .xl\\:border-transparent {\n    border-color: transparent;\n  }\n\n  .xl\\:border-current {\n    border-color: currentColor;\n  }\n\n  .xl\\:border-black {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .xl\\:border-white {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-100 {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-200 {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-300 {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-400 {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-500 {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-600 {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-700 {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-800 {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .xl\\:border-gray-900 {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .xl\\:border-red-100 {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .xl\\:border-red-200 {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .xl\\:border-red-300 {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .xl\\:border-red-400 {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .xl\\:border-red-500 {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .xl\\:border-red-600 {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .xl\\:border-red-700 {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .xl\\:border-red-800 {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .xl\\:border-red-900 {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-100 {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-200 {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-300 {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-400 {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-500 {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-600 {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-700 {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-800 {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .xl\\:border-orange-900 {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-100 {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-200 {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-300 {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-400 {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-500 {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-600 {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-700 {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-800 {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .xl\\:border-yellow-900 {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .xl\\:border-green-100 {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .xl\\:border-green-200 {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .xl\\:border-green-300 {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .xl\\:border-green-400 {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .xl\\:border-green-500 {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .xl\\:border-green-600 {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .xl\\:border-green-700 {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .xl\\:border-green-800 {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .xl\\:border-green-900 {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-100 {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-200 {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-300 {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-400 {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-500 {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-600 {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-700 {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-800 {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .xl\\:border-teal-900 {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-100 {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-200 {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-300 {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-400 {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-500 {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-600 {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-700 {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-800 {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .xl\\:border-blue-900 {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-100 {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-200 {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-300 {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-400 {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-500 {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-600 {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-700 {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-800 {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .xl\\:border-indigo-900 {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-100 {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-200 {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-300 {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-400 {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-500 {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-600 {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-700 {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-800 {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .xl\\:border-purple-900 {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-100 {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-200 {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-300 {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-400 {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-500 {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-600 {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-700 {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-800 {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .xl\\:border-pink-900 {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n  }\n\n  .xl\\:hover\\:border-current:hover {\n    border-color: currentColor;\n  }\n\n  .xl\\:hover\\:border-black:hover {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-white:hover {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-100:hover {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-200:hover {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-300:hover {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-400:hover {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-500:hover {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-600:hover {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-700:hover {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-800:hover {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-gray-900:hover {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-100:hover {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-200:hover {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-300:hover {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-400:hover {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-500:hover {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-600:hover {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-700:hover {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-800:hover {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-red-900:hover {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-100:hover {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-200:hover {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-300:hover {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-400:hover {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-500:hover {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-600:hover {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-700:hover {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-800:hover {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-orange-900:hover {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-100:hover {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-200:hover {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-300:hover {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-400:hover {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-500:hover {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-600:hover {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-700:hover {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-800:hover {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-yellow-900:hover {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-100:hover {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-200:hover {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-300:hover {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-400:hover {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-500:hover {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-600:hover {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-700:hover {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-800:hover {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-green-900:hover {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-100:hover {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-200:hover {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-300:hover {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-400:hover {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-500:hover {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-600:hover {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-700:hover {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-800:hover {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-teal-900:hover {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-100:hover {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-200:hover {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-300:hover {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-400:hover {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-500:hover {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-600:hover {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-700:hover {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-800:hover {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-blue-900:hover {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-100:hover {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-200:hover {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-300:hover {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-400:hover {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-500:hover {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-600:hover {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-700:hover {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-800:hover {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-indigo-900:hover {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-100:hover {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-200:hover {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-300:hover {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-400:hover {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-500:hover {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-600:hover {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-700:hover {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-800:hover {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-purple-900:hover {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-100:hover {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-200:hover {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-300:hover {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-400:hover {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-500:hover {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-600:hover {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-700:hover {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-800:hover {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .xl\\:hover\\:border-pink-900:hover {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-transparent:focus {\n    border-color: transparent;\n  }\n\n  .xl\\:focus\\:border-current:focus {\n    border-color: currentColor;\n  }\n\n  .xl\\:focus\\:border-black:focus {\n    --border-opacity: 1;\n    border-color: #000;\n    border-color: rgba(0, 0, 0, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-white:focus {\n    --border-opacity: 1;\n    border-color: #fff;\n    border-color: rgba(255, 255, 255, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-100:focus {\n    --border-opacity: 1;\n    border-color: #f7fafc;\n    border-color: rgba(247, 250, 252, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-200:focus {\n    --border-opacity: 1;\n    border-color: #edf2f7;\n    border-color: rgba(237, 242, 247, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-300:focus {\n    --border-opacity: 1;\n    border-color: #e2e8f0;\n    border-color: rgba(226, 232, 240, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-400:focus {\n    --border-opacity: 1;\n    border-color: #cbd5e0;\n    border-color: rgba(203, 213, 224, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-500:focus {\n    --border-opacity: 1;\n    border-color: #a0aec0;\n    border-color: rgba(160, 174, 192, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-600:focus {\n    --border-opacity: 1;\n    border-color: #718096;\n    border-color: rgba(113, 128, 150, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-700:focus {\n    --border-opacity: 1;\n    border-color: #4a5568;\n    border-color: rgba(74, 85, 104, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-800:focus {\n    --border-opacity: 1;\n    border-color: #2d3748;\n    border-color: rgba(45, 55, 72, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-gray-900:focus {\n    --border-opacity: 1;\n    border-color: #1a202c;\n    border-color: rgba(26, 32, 44, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-100:focus {\n    --border-opacity: 1;\n    border-color: #fff5f5;\n    border-color: rgba(255, 245, 245, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-200:focus {\n    --border-opacity: 1;\n    border-color: #fed7d7;\n    border-color: rgba(254, 215, 215, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-300:focus {\n    --border-opacity: 1;\n    border-color: #feb2b2;\n    border-color: rgba(254, 178, 178, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-400:focus {\n    --border-opacity: 1;\n    border-color: #fc8181;\n    border-color: rgba(252, 129, 129, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-500:focus {\n    --border-opacity: 1;\n    border-color: #f56565;\n    border-color: rgba(245, 101, 101, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-600:focus {\n    --border-opacity: 1;\n    border-color: #e53e3e;\n    border-color: rgba(229, 62, 62, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-700:focus {\n    --border-opacity: 1;\n    border-color: #c53030;\n    border-color: rgba(197, 48, 48, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-800:focus {\n    --border-opacity: 1;\n    border-color: #9b2c2c;\n    border-color: rgba(155, 44, 44, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-red-900:focus {\n    --border-opacity: 1;\n    border-color: #742a2a;\n    border-color: rgba(116, 42, 42, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-100:focus {\n    --border-opacity: 1;\n    border-color: #fffaf0;\n    border-color: rgba(255, 250, 240, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-200:focus {\n    --border-opacity: 1;\n    border-color: #feebc8;\n    border-color: rgba(254, 235, 200, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-300:focus {\n    --border-opacity: 1;\n    border-color: #fbd38d;\n    border-color: rgba(251, 211, 141, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-400:focus {\n    --border-opacity: 1;\n    border-color: #f6ad55;\n    border-color: rgba(246, 173, 85, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-500:focus {\n    --border-opacity: 1;\n    border-color: #ed8936;\n    border-color: rgba(237, 137, 54, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-600:focus {\n    --border-opacity: 1;\n    border-color: #dd6b20;\n    border-color: rgba(221, 107, 32, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-700:focus {\n    --border-opacity: 1;\n    border-color: #c05621;\n    border-color: rgba(192, 86, 33, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-800:focus {\n    --border-opacity: 1;\n    border-color: #9c4221;\n    border-color: rgba(156, 66, 33, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-orange-900:focus {\n    --border-opacity: 1;\n    border-color: #7b341e;\n    border-color: rgba(123, 52, 30, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-100:focus {\n    --border-opacity: 1;\n    border-color: #fffff0;\n    border-color: rgba(255, 255, 240, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-200:focus {\n    --border-opacity: 1;\n    border-color: #fefcbf;\n    border-color: rgba(254, 252, 191, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-300:focus {\n    --border-opacity: 1;\n    border-color: #faf089;\n    border-color: rgba(250, 240, 137, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-400:focus {\n    --border-opacity: 1;\n    border-color: #f6e05e;\n    border-color: rgba(246, 224, 94, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-500:focus {\n    --border-opacity: 1;\n    border-color: #ecc94b;\n    border-color: rgba(236, 201, 75, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-600:focus {\n    --border-opacity: 1;\n    border-color: #d69e2e;\n    border-color: rgba(214, 158, 46, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-700:focus {\n    --border-opacity: 1;\n    border-color: #b7791f;\n    border-color: rgba(183, 121, 31, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-800:focus {\n    --border-opacity: 1;\n    border-color: #975a16;\n    border-color: rgba(151, 90, 22, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-yellow-900:focus {\n    --border-opacity: 1;\n    border-color: #744210;\n    border-color: rgba(116, 66, 16, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-100:focus {\n    --border-opacity: 1;\n    border-color: #f0fff4;\n    border-color: rgba(240, 255, 244, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-200:focus {\n    --border-opacity: 1;\n    border-color: #c6f6d5;\n    border-color: rgba(198, 246, 213, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-300:focus {\n    --border-opacity: 1;\n    border-color: #9ae6b4;\n    border-color: rgba(154, 230, 180, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-400:focus {\n    --border-opacity: 1;\n    border-color: #68d391;\n    border-color: rgba(104, 211, 145, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-500:focus {\n    --border-opacity: 1;\n    border-color: #48bb78;\n    border-color: rgba(72, 187, 120, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-600:focus {\n    --border-opacity: 1;\n    border-color: #38a169;\n    border-color: rgba(56, 161, 105, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-700:focus {\n    --border-opacity: 1;\n    border-color: #2f855a;\n    border-color: rgba(47, 133, 90, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-800:focus {\n    --border-opacity: 1;\n    border-color: #276749;\n    border-color: rgba(39, 103, 73, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-green-900:focus {\n    --border-opacity: 1;\n    border-color: #22543d;\n    border-color: rgba(34, 84, 61, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-100:focus {\n    --border-opacity: 1;\n    border-color: #e6fffa;\n    border-color: rgba(230, 255, 250, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-200:focus {\n    --border-opacity: 1;\n    border-color: #b2f5ea;\n    border-color: rgba(178, 245, 234, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-300:focus {\n    --border-opacity: 1;\n    border-color: #81e6d9;\n    border-color: rgba(129, 230, 217, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-400:focus {\n    --border-opacity: 1;\n    border-color: #4fd1c5;\n    border-color: rgba(79, 209, 197, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-500:focus {\n    --border-opacity: 1;\n    border-color: #38b2ac;\n    border-color: rgba(56, 178, 172, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-600:focus {\n    --border-opacity: 1;\n    border-color: #319795;\n    border-color: rgba(49, 151, 149, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-700:focus {\n    --border-opacity: 1;\n    border-color: #2c7a7b;\n    border-color: rgba(44, 122, 123, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-800:focus {\n    --border-opacity: 1;\n    border-color: #285e61;\n    border-color: rgba(40, 94, 97, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-teal-900:focus {\n    --border-opacity: 1;\n    border-color: #234e52;\n    border-color: rgba(35, 78, 82, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-100:focus {\n    --border-opacity: 1;\n    border-color: #ebf8ff;\n    border-color: rgba(235, 248, 255, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-200:focus {\n    --border-opacity: 1;\n    border-color: #bee3f8;\n    border-color: rgba(190, 227, 248, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-300:focus {\n    --border-opacity: 1;\n    border-color: #90cdf4;\n    border-color: rgba(144, 205, 244, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-400:focus {\n    --border-opacity: 1;\n    border-color: #63b3ed;\n    border-color: rgba(99, 179, 237, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-500:focus {\n    --border-opacity: 1;\n    border-color: #4299e1;\n    border-color: rgba(66, 153, 225, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-600:focus {\n    --border-opacity: 1;\n    border-color: #3182ce;\n    border-color: rgba(49, 130, 206, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-700:focus {\n    --border-opacity: 1;\n    border-color: #2b6cb0;\n    border-color: rgba(43, 108, 176, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-800:focus {\n    --border-opacity: 1;\n    border-color: #2c5282;\n    border-color: rgba(44, 82, 130, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-blue-900:focus {\n    --border-opacity: 1;\n    border-color: #2a4365;\n    border-color: rgba(42, 67, 101, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-100:focus {\n    --border-opacity: 1;\n    border-color: #ebf4ff;\n    border-color: rgba(235, 244, 255, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-200:focus {\n    --border-opacity: 1;\n    border-color: #c3dafe;\n    border-color: rgba(195, 218, 254, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-300:focus {\n    --border-opacity: 1;\n    border-color: #a3bffa;\n    border-color: rgba(163, 191, 250, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-400:focus {\n    --border-opacity: 1;\n    border-color: #7f9cf5;\n    border-color: rgba(127, 156, 245, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-500:focus {\n    --border-opacity: 1;\n    border-color: #667eea;\n    border-color: rgba(102, 126, 234, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-600:focus {\n    --border-opacity: 1;\n    border-color: #5a67d8;\n    border-color: rgba(90, 103, 216, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-700:focus {\n    --border-opacity: 1;\n    border-color: #4c51bf;\n    border-color: rgba(76, 81, 191, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-800:focus {\n    --border-opacity: 1;\n    border-color: #434190;\n    border-color: rgba(67, 65, 144, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-indigo-900:focus {\n    --border-opacity: 1;\n    border-color: #3c366b;\n    border-color: rgba(60, 54, 107, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-100:focus {\n    --border-opacity: 1;\n    border-color: #faf5ff;\n    border-color: rgba(250, 245, 255, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-200:focus {\n    --border-opacity: 1;\n    border-color: #e9d8fd;\n    border-color: rgba(233, 216, 253, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-300:focus {\n    --border-opacity: 1;\n    border-color: #d6bcfa;\n    border-color: rgba(214, 188, 250, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-400:focus {\n    --border-opacity: 1;\n    border-color: #b794f4;\n    border-color: rgba(183, 148, 244, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-500:focus {\n    --border-opacity: 1;\n    border-color: #9f7aea;\n    border-color: rgba(159, 122, 234, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-600:focus {\n    --border-opacity: 1;\n    border-color: #805ad5;\n    border-color: rgba(128, 90, 213, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-700:focus {\n    --border-opacity: 1;\n    border-color: #6b46c1;\n    border-color: rgba(107, 70, 193, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-800:focus {\n    --border-opacity: 1;\n    border-color: #553c9a;\n    border-color: rgba(85, 60, 154, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-purple-900:focus {\n    --border-opacity: 1;\n    border-color: #44337a;\n    border-color: rgba(68, 51, 122, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-100:focus {\n    --border-opacity: 1;\n    border-color: #fff5f7;\n    border-color: rgba(255, 245, 247, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-200:focus {\n    --border-opacity: 1;\n    border-color: #fed7e2;\n    border-color: rgba(254, 215, 226, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-300:focus {\n    --border-opacity: 1;\n    border-color: #fbb6ce;\n    border-color: rgba(251, 182, 206, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-400:focus {\n    --border-opacity: 1;\n    border-color: #f687b3;\n    border-color: rgba(246, 135, 179, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-500:focus {\n    --border-opacity: 1;\n    border-color: #ed64a6;\n    border-color: rgba(237, 100, 166, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-600:focus {\n    --border-opacity: 1;\n    border-color: #d53f8c;\n    border-color: rgba(213, 63, 140, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-700:focus {\n    --border-opacity: 1;\n    border-color: #b83280;\n    border-color: rgba(184, 50, 128, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-800:focus {\n    --border-opacity: 1;\n    border-color: #97266d;\n    border-color: rgba(151, 38, 109, var(--border-opacity));\n  }\n\n  .xl\\:focus\\:border-pink-900:focus {\n    --border-opacity: 1;\n    border-color: #702459;\n    border-color: rgba(112, 36, 89, var(--border-opacity));\n  }\n\n  .xl\\:border-opacity-0 {\n    --border-opacity: 0;\n  }\n\n  .xl\\:border-opacity-25 {\n    --border-opacity: 0.25;\n  }\n\n  .xl\\:border-opacity-50 {\n    --border-opacity: 0.5;\n  }\n\n  .xl\\:border-opacity-75 {\n    --border-opacity: 0.75;\n  }\n\n  .xl\\:border-opacity-100 {\n    --border-opacity: 1;\n  }\n\n  .xl\\:hover\\:border-opacity-0:hover {\n    --border-opacity: 0;\n  }\n\n  .xl\\:hover\\:border-opacity-25:hover {\n    --border-opacity: 0.25;\n  }\n\n  .xl\\:hover\\:border-opacity-50:hover {\n    --border-opacity: 0.5;\n  }\n\n  .xl\\:hover\\:border-opacity-75:hover {\n    --border-opacity: 0.75;\n  }\n\n  .xl\\:hover\\:border-opacity-100:hover {\n    --border-opacity: 1;\n  }\n\n  .xl\\:focus\\:border-opacity-0:focus {\n    --border-opacity: 0;\n  }\n\n  .xl\\:focus\\:border-opacity-25:focus {\n    --border-opacity: 0.25;\n  }\n\n  .xl\\:focus\\:border-opacity-50:focus {\n    --border-opacity: 0.5;\n  }\n\n  .xl\\:focus\\:border-opacity-75:focus {\n    --border-opacity: 0.75;\n  }\n\n  .xl\\:focus\\:border-opacity-100:focus {\n    --border-opacity: 1;\n  }\n\n  .xl\\:rounded-none {\n    border-radius: 0;\n  }\n\n  .xl\\:rounded-sm {\n    border-radius: 0.125rem;\n  }\n\n  .xl\\:rounded {\n    border-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-md {\n    border-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-lg {\n    border-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-xl {\n    border-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-2xl {\n    border-radius: 1rem;\n  }\n\n  .xl\\:rounded-3xl {\n    border-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-full {\n    border-radius: 9999px;\n  }\n\n  .xl\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .xl\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n\n  .xl\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .xl\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n\n  .xl\\:rounded-t-sm {\n    border-top-left-radius: 0.125rem;\n    border-top-right-radius: 0.125rem;\n  }\n\n  .xl\\:rounded-r-sm {\n    border-top-right-radius: 0.125rem;\n    border-bottom-right-radius: 0.125rem;\n  }\n\n  .xl\\:rounded-b-sm {\n    border-bottom-right-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .xl\\:rounded-l-sm {\n    border-top-left-radius: 0.125rem;\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .xl\\:rounded-t {\n    border-top-left-radius: 0.25rem;\n    border-top-right-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-r {\n    border-top-right-radius: 0.25rem;\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-b {\n    border-bottom-right-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-l {\n    border-top-left-radius: 0.25rem;\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-t-md {\n    border-top-left-radius: 0.375rem;\n    border-top-right-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-r-md {\n    border-top-right-radius: 0.375rem;\n    border-bottom-right-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-b-md {\n    border-bottom-right-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-l-md {\n    border-top-left-radius: 0.375rem;\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-t-lg {\n    border-top-left-radius: 0.5rem;\n    border-top-right-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-r-lg {\n    border-top-right-radius: 0.5rem;\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-b-lg {\n    border-bottom-right-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-l-lg {\n    border-top-left-radius: 0.5rem;\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-t-xl {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-r-xl {\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-b-xl {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-l-xl {\n    border-top-left-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-t-2xl {\n    border-top-left-radius: 1rem;\n    border-top-right-radius: 1rem;\n  }\n\n  .xl\\:rounded-r-2xl {\n    border-top-right-radius: 1rem;\n    border-bottom-right-radius: 1rem;\n  }\n\n  .xl\\:rounded-b-2xl {\n    border-bottom-right-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .xl\\:rounded-l-2xl {\n    border-top-left-radius: 1rem;\n    border-bottom-left-radius: 1rem;\n  }\n\n  .xl\\:rounded-t-3xl {\n    border-top-left-radius: 1.5rem;\n    border-top-right-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-r-3xl {\n    border-top-right-radius: 1.5rem;\n    border-bottom-right-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-b-3xl {\n    border-bottom-right-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-l-3xl {\n    border-top-left-radius: 1.5rem;\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n  }\n\n  .xl\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n  }\n\n  .xl\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n\n  .xl\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n  }\n\n  .xl\\:rounded-tl-none {\n    border-top-left-radius: 0;\n  }\n\n  .xl\\:rounded-tr-none {\n    border-top-right-radius: 0;\n  }\n\n  .xl\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n  }\n\n  .xl\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n  }\n\n  .xl\\:rounded-tl-sm {\n    border-top-left-radius: 0.125rem;\n  }\n\n  .xl\\:rounded-tr-sm {\n    border-top-right-radius: 0.125rem;\n  }\n\n  .xl\\:rounded-br-sm {\n    border-bottom-right-radius: 0.125rem;\n  }\n\n  .xl\\:rounded-bl-sm {\n    border-bottom-left-radius: 0.125rem;\n  }\n\n  .xl\\:rounded-tl {\n    border-top-left-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-tr {\n    border-top-right-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-br {\n    border-bottom-right-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-bl {\n    border-bottom-left-radius: 0.25rem;\n  }\n\n  .xl\\:rounded-tl-md {\n    border-top-left-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-tr-md {\n    border-top-right-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-br-md {\n    border-bottom-right-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-bl-md {\n    border-bottom-left-radius: 0.375rem;\n  }\n\n  .xl\\:rounded-tl-lg {\n    border-top-left-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-tr-lg {\n    border-top-right-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-br-lg {\n    border-bottom-right-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-bl-lg {\n    border-bottom-left-radius: 0.5rem;\n  }\n\n  .xl\\:rounded-tl-xl {\n    border-top-left-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-tr-xl {\n    border-top-right-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-br-xl {\n    border-bottom-right-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-bl-xl {\n    border-bottom-left-radius: 0.75rem;\n  }\n\n  .xl\\:rounded-tl-2xl {\n    border-top-left-radius: 1rem;\n  }\n\n  .xl\\:rounded-tr-2xl {\n    border-top-right-radius: 1rem;\n  }\n\n  .xl\\:rounded-br-2xl {\n    border-bottom-right-radius: 1rem;\n  }\n\n  .xl\\:rounded-bl-2xl {\n    border-bottom-left-radius: 1rem;\n  }\n\n  .xl\\:rounded-tl-3xl {\n    border-top-left-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-tr-3xl {\n    border-top-right-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-br-3xl {\n    border-bottom-right-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-bl-3xl {\n    border-bottom-left-radius: 1.5rem;\n  }\n\n  .xl\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n  }\n\n  .xl\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n  }\n\n  .xl\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n  }\n\n  .xl\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n  }\n\n  .xl\\:border-solid {\n    border-style: solid;\n  }\n\n  .xl\\:border-dashed {\n    border-style: dashed;\n  }\n\n  .xl\\:border-dotted {\n    border-style: dotted;\n  }\n\n  .xl\\:border-double {\n    border-style: double;\n  }\n\n  .xl\\:border-none {\n    border-style: none;\n  }\n\n  .xl\\:border-0 {\n    border-width: 0;\n  }\n\n  .xl\\:border-2 {\n    border-width: 2px;\n  }\n\n  .xl\\:border-4 {\n    border-width: 4px;\n  }\n\n  .xl\\:border-8 {\n    border-width: 8px;\n  }\n\n  .xl\\:border {\n    border-width: 1px;\n  }\n\n  .xl\\:border-t-0 {\n    border-top-width: 0;\n  }\n\n  .xl\\:border-r-0 {\n    border-right-width: 0;\n  }\n\n  .xl\\:border-b-0 {\n    border-bottom-width: 0;\n  }\n\n  .xl\\:border-l-0 {\n    border-left-width: 0;\n  }\n\n  .xl\\:border-t-2 {\n    border-top-width: 2px;\n  }\n\n  .xl\\:border-r-2 {\n    border-right-width: 2px;\n  }\n\n  .xl\\:border-b-2 {\n    border-bottom-width: 2px;\n  }\n\n  .xl\\:border-l-2 {\n    border-left-width: 2px;\n  }\n\n  .xl\\:border-t-4 {\n    border-top-width: 4px;\n  }\n\n  .xl\\:border-r-4 {\n    border-right-width: 4px;\n  }\n\n  .xl\\:border-b-4 {\n    border-bottom-width: 4px;\n  }\n\n  .xl\\:border-l-4 {\n    border-left-width: 4px;\n  }\n\n  .xl\\:border-t-8 {\n    border-top-width: 8px;\n  }\n\n  .xl\\:border-r-8 {\n    border-right-width: 8px;\n  }\n\n  .xl\\:border-b-8 {\n    border-bottom-width: 8px;\n  }\n\n  .xl\\:border-l-8 {\n    border-left-width: 8px;\n  }\n\n  .xl\\:border-t {\n    border-top-width: 1px;\n  }\n\n  .xl\\:border-r {\n    border-right-width: 1px;\n  }\n\n  .xl\\:border-b {\n    border-bottom-width: 1px;\n  }\n\n  .xl\\:border-l {\n    border-left-width: 1px;\n  }\n\n  .xl\\:box-border {\n    box-sizing: border-box;\n  }\n\n  .xl\\:box-content {\n    box-sizing: content-box;\n  }\n\n  .xl\\:cursor-auto {\n    cursor: auto;\n  }\n\n  .xl\\:cursor-default {\n    cursor: default;\n  }\n\n  .xl\\:cursor-pointer {\n    cursor: pointer;\n  }\n\n  .xl\\:cursor-wait {\n    cursor: wait;\n  }\n\n  .xl\\:cursor-text {\n    cursor: text;\n  }\n\n  .xl\\:cursor-move {\n    cursor: move;\n  }\n\n  .xl\\:cursor-not-allowed {\n    cursor: not-allowed;\n  }\n\n  .xl\\:block {\n    display: block;\n  }\n\n  .xl\\:inline-block {\n    display: inline-block;\n  }\n\n  .xl\\:inline {\n    display: inline;\n  }\n\n  .xl\\:flex {\n    display: flex;\n  }\n\n  .xl\\:inline-flex {\n    display: inline-flex;\n  }\n\n  .xl\\:table {\n    display: table;\n  }\n\n  .xl\\:table-caption {\n    display: table-caption;\n  }\n\n  .xl\\:table-cell {\n    display: table-cell;\n  }\n\n  .xl\\:table-column {\n    display: table-column;\n  }\n\n  .xl\\:table-column-group {\n    display: table-column-group;\n  }\n\n  .xl\\:table-footer-group {\n    display: table-footer-group;\n  }\n\n  .xl\\:table-header-group {\n    display: table-header-group;\n  }\n\n  .xl\\:table-row-group {\n    display: table-row-group;\n  }\n\n  .xl\\:table-row {\n    display: table-row;\n  }\n\n  .xl\\:flow-root {\n    display: flow-root;\n  }\n\n  .xl\\:grid {\n    display: grid;\n  }\n\n  .xl\\:inline-grid {\n    display: inline-grid;\n  }\n\n  .xl\\:contents {\n    display: contents;\n  }\n\n  .xl\\:hidden {\n    display: none;\n  }\n\n  .xl\\:flex-row {\n    flex-direction: row;\n  }\n\n  .xl\\:flex-row-reverse {\n    flex-direction: row-reverse;\n  }\n\n  .xl\\:flex-col {\n    flex-direction: column;\n  }\n\n  .xl\\:flex-col-reverse {\n    flex-direction: column-reverse;\n  }\n\n  .xl\\:flex-wrap {\n    flex-wrap: wrap;\n  }\n\n  .xl\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n  }\n\n  .xl\\:flex-no-wrap {\n    flex-wrap: nowrap;\n  }\n\n  .xl\\:place-items-auto {\n    place-items: auto;\n  }\n\n  .xl\\:place-items-start {\n    place-items: start;\n  }\n\n  .xl\\:place-items-end {\n    place-items: end;\n  }\n\n  .xl\\:place-items-center {\n    place-items: center;\n  }\n\n  .xl\\:place-items-stretch {\n    place-items: stretch;\n  }\n\n  .xl\\:place-content-center {\n    place-content: center;\n  }\n\n  .xl\\:place-content-start {\n    place-content: start;\n  }\n\n  .xl\\:place-content-end {\n    place-content: end;\n  }\n\n  .xl\\:place-content-between {\n    place-content: space-between;\n  }\n\n  .xl\\:place-content-around {\n    place-content: space-around;\n  }\n\n  .xl\\:place-content-evenly {\n    place-content: space-evenly;\n  }\n\n  .xl\\:place-content-stretch {\n    place-content: stretch;\n  }\n\n  .xl\\:place-self-auto {\n    place-self: auto;\n  }\n\n  .xl\\:place-self-start {\n    place-self: start;\n  }\n\n  .xl\\:place-self-end {\n    place-self: end;\n  }\n\n  .xl\\:place-self-center {\n    place-self: center;\n  }\n\n  .xl\\:place-self-stretch {\n    place-self: stretch;\n  }\n\n  .xl\\:items-start {\n    align-items: flex-start;\n  }\n\n  .xl\\:items-end {\n    align-items: flex-end;\n  }\n\n  .xl\\:items-center {\n    align-items: center;\n  }\n\n  .xl\\:items-baseline {\n    align-items: baseline;\n  }\n\n  .xl\\:items-stretch {\n    align-items: stretch;\n  }\n\n  .xl\\:content-center {\n    align-content: center;\n  }\n\n  .xl\\:content-start {\n    align-content: flex-start;\n  }\n\n  .xl\\:content-end {\n    align-content: flex-end;\n  }\n\n  .xl\\:content-between {\n    align-content: space-between;\n  }\n\n  .xl\\:content-around {\n    align-content: space-around;\n  }\n\n  .xl\\:content-evenly {\n    align-content: space-evenly;\n  }\n\n  .xl\\:self-auto {\n    align-self: auto;\n  }\n\n  .xl\\:self-start {\n    align-self: flex-start;\n  }\n\n  .xl\\:self-end {\n    align-self: flex-end;\n  }\n\n  .xl\\:self-center {\n    align-self: center;\n  }\n\n  .xl\\:self-stretch {\n    align-self: stretch;\n  }\n\n  .xl\\:justify-items-auto {\n    justify-items: auto;\n  }\n\n  .xl\\:justify-items-start {\n    justify-items: start;\n  }\n\n  .xl\\:justify-items-end {\n    justify-items: end;\n  }\n\n  .xl\\:justify-items-center {\n    justify-items: center;\n  }\n\n  .xl\\:justify-items-stretch {\n    justify-items: stretch;\n  }\n\n  .xl\\:justify-start {\n    justify-content: flex-start;\n  }\n\n  .xl\\:justify-end {\n    justify-content: flex-end;\n  }\n\n  .xl\\:justify-center {\n    justify-content: center;\n  }\n\n  .xl\\:justify-between {\n    justify-content: space-between;\n  }\n\n  .xl\\:justify-around {\n    justify-content: space-around;\n  }\n\n  .xl\\:justify-evenly {\n    justify-content: space-evenly;\n  }\n\n  .xl\\:justify-self-auto {\n    justify-self: auto;\n  }\n\n  .xl\\:justify-self-start {\n    justify-self: start;\n  }\n\n  .xl\\:justify-self-end {\n    justify-self: end;\n  }\n\n  .xl\\:justify-self-center {\n    justify-self: center;\n  }\n\n  .xl\\:justify-self-stretch {\n    justify-self: stretch;\n  }\n\n  .xl\\:flex-1 {\n    flex: 1 1 0%;\n  }\n\n  .xl\\:flex-auto {\n    flex: 1 1 auto;\n  }\n\n  .xl\\:flex-initial {\n    flex: 0 1 auto;\n  }\n\n  .xl\\:flex-none {\n    flex: none;\n  }\n\n  .xl\\:flex-grow-0 {\n    flex-grow: 0;\n  }\n\n  .xl\\:flex-grow {\n    flex-grow: 1;\n  }\n\n  .xl\\:flex-shrink-0 {\n    flex-shrink: 0;\n  }\n\n  .xl\\:flex-shrink {\n    flex-shrink: 1;\n  }\n\n  .xl\\:order-1 {\n    order: 1;\n  }\n\n  .xl\\:order-2 {\n    order: 2;\n  }\n\n  .xl\\:order-3 {\n    order: 3;\n  }\n\n  .xl\\:order-4 {\n    order: 4;\n  }\n\n  .xl\\:order-5 {\n    order: 5;\n  }\n\n  .xl\\:order-6 {\n    order: 6;\n  }\n\n  .xl\\:order-7 {\n    order: 7;\n  }\n\n  .xl\\:order-8 {\n    order: 8;\n  }\n\n  .xl\\:order-9 {\n    order: 9;\n  }\n\n  .xl\\:order-10 {\n    order: 10;\n  }\n\n  .xl\\:order-11 {\n    order: 11;\n  }\n\n  .xl\\:order-12 {\n    order: 12;\n  }\n\n  .xl\\:order-first {\n    order: -9999;\n  }\n\n  .xl\\:order-last {\n    order: 9999;\n  }\n\n  .xl\\:order-none {\n    order: 0;\n  }\n\n  .xl\\:float-right {\n    float: right;\n  }\n\n  .xl\\:float-left {\n    float: left;\n  }\n\n  .xl\\:float-none {\n    float: none;\n  }\n\n  .xl\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  .xl\\:clear-left {\n    clear: left;\n  }\n\n  .xl\\:clear-right {\n    clear: right;\n  }\n\n  .xl\\:clear-both {\n    clear: both;\n  }\n\n  .xl\\:clear-none {\n    clear: none;\n  }\n\n  .xl\\:font-sans {\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  }\n\n  .xl\\:font-serif {\n    font-family: Georgia, Cambria, \"Times New Roman\", Times, serif;\n  }\n\n  .xl\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  }\n\n  .xl\\:font-hairline {\n    font-weight: 100;\n  }\n\n  .xl\\:font-thin {\n    font-weight: 200;\n  }\n\n  .xl\\:font-light {\n    font-weight: 300;\n  }\n\n  .xl\\:font-normal {\n    font-weight: 400;\n  }\n\n  .xl\\:font-medium {\n    font-weight: 500;\n  }\n\n  .xl\\:font-semibold {\n    font-weight: 600;\n  }\n\n  .xl\\:font-bold {\n    font-weight: 700;\n  }\n\n  .xl\\:font-extrabold {\n    font-weight: 800;\n  }\n\n  .xl\\:font-black {\n    font-weight: 900;\n  }\n\n  .xl\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n  }\n\n  .xl\\:hover\\:font-thin:hover {\n    font-weight: 200;\n  }\n\n  .xl\\:hover\\:font-light:hover {\n    font-weight: 300;\n  }\n\n  .xl\\:hover\\:font-normal:hover {\n    font-weight: 400;\n  }\n\n  .xl\\:hover\\:font-medium:hover {\n    font-weight: 500;\n  }\n\n  .xl\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n  }\n\n  .xl\\:hover\\:font-bold:hover {\n    font-weight: 700;\n  }\n\n  .xl\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n  }\n\n  .xl\\:hover\\:font-black:hover {\n    font-weight: 900;\n  }\n\n  .xl\\:focus\\:font-hairline:focus {\n    font-weight: 100;\n  }\n\n  .xl\\:focus\\:font-thin:focus {\n    font-weight: 200;\n  }\n\n  .xl\\:focus\\:font-light:focus {\n    font-weight: 300;\n  }\n\n  .xl\\:focus\\:font-normal:focus {\n    font-weight: 400;\n  }\n\n  .xl\\:focus\\:font-medium:focus {\n    font-weight: 500;\n  }\n\n  .xl\\:focus\\:font-semibold:focus {\n    font-weight: 600;\n  }\n\n  .xl\\:focus\\:font-bold:focus {\n    font-weight: 700;\n  }\n\n  .xl\\:focus\\:font-extrabold:focus {\n    font-weight: 800;\n  }\n\n  .xl\\:focus\\:font-black:focus {\n    font-weight: 900;\n  }\n\n  .xl\\:h-0 {\n    height: 0;\n  }\n\n  .xl\\:h-1 {\n    height: 0.25rem;\n  }\n\n  .xl\\:h-2 {\n    height: 0.5rem;\n  }\n\n  .xl\\:h-3 {\n    height: 0.75rem;\n  }\n\n  .xl\\:h-4 {\n    height: 1rem;\n  }\n\n  .xl\\:h-5 {\n    height: 1.25rem;\n  }\n\n  .xl\\:h-6 {\n    height: 1.5rem;\n  }\n\n  .xl\\:h-8 {\n    height: 2rem;\n  }\n\n  .xl\\:h-10 {\n    height: 2.5rem;\n  }\n\n  .xl\\:h-12 {\n    height: 3rem;\n  }\n\n  .xl\\:h-16 {\n    height: 4rem;\n  }\n\n  .xl\\:h-20 {\n    height: 5rem;\n  }\n\n  .xl\\:h-24 {\n    height: 6rem;\n  }\n\n  .xl\\:h-32 {\n    height: 8rem;\n  }\n\n  .xl\\:h-40 {\n    height: 10rem;\n  }\n\n  .xl\\:h-48 {\n    height: 12rem;\n  }\n\n  .xl\\:h-56 {\n    height: 14rem;\n  }\n\n  .xl\\:h-64 {\n    height: 16rem;\n  }\n\n  .xl\\:h-auto {\n    height: auto;\n  }\n\n  .xl\\:h-px {\n    height: 1px;\n  }\n\n  .xl\\:h-full {\n    height: 100%;\n  }\n\n  .xl\\:h-screen {\n    height: 100vh;\n  }\n\n  .xl\\:text-15 {\n    font-size: 0.9375rem;\n  }\n\n  .xl\\:text-xs {\n    font-size: 0.75rem;\n  }\n\n  .xl\\:text-sm {\n    font-size: 0.875rem;\n  }\n\n  .xl\\:text-base {\n    font-size: 1rem;\n  }\n\n  .xl\\:text-lg {\n    font-size: 1.125rem;\n  }\n\n  .xl\\:text-xl {\n    font-size: 1.25rem;\n  }\n\n  .xl\\:text-1\\.5xl {\n    font-size: 1.375rem;\n  }\n\n  .xl\\:text-2xl {\n    font-size: 1.5rem;\n  }\n\n  .xl\\:text-3xl {\n    font-size: 1.875rem;\n  }\n\n  .xl\\:text-4xl {\n    font-size: 2.25rem;\n  }\n\n  .xl\\:text-5xl {\n    font-size: 3rem;\n  }\n\n  .xl\\:text-6xl {\n    font-size: 4rem;\n  }\n\n  .xl\\:leading-3 {\n    line-height: .75rem;\n  }\n\n  .xl\\:leading-4 {\n    line-height: 1rem;\n  }\n\n  .xl\\:leading-5 {\n    line-height: 1.25rem;\n  }\n\n  .xl\\:leading-6 {\n    line-height: 1.5rem;\n  }\n\n  .xl\\:leading-7 {\n    line-height: 1.75rem;\n  }\n\n  .xl\\:leading-8 {\n    line-height: 2rem;\n  }\n\n  .xl\\:leading-9 {\n    line-height: 2.25rem;\n  }\n\n  .xl\\:leading-10 {\n    line-height: 2.5rem;\n  }\n\n  .xl\\:leading-none {\n    line-height: 1;\n  }\n\n  .xl\\:leading-tight {\n    line-height: 1.25;\n  }\n\n  .xl\\:leading-snug {\n    line-height: 1.375;\n  }\n\n  .xl\\:leading-normal {\n    line-height: 1.5;\n  }\n\n  .xl\\:leading-relaxed {\n    line-height: 1.625;\n  }\n\n  .xl\\:leading-loose {\n    line-height: 2;\n  }\n\n  .xl\\:list-inside {\n    list-style-position: inside;\n  }\n\n  .xl\\:list-outside {\n    list-style-position: outside;\n  }\n\n  .xl\\:list-none {\n    list-style-type: none;\n  }\n\n  .xl\\:list-disc {\n    list-style-type: disc;\n  }\n\n  .xl\\:list-decimal {\n    list-style-type: decimal;\n  }\n\n  .xl\\:m-0 {\n    margin: 0;\n  }\n\n  .xl\\:m-1 {\n    margin: 0.25rem;\n  }\n\n  .xl\\:m-2 {\n    margin: 0.5rem;\n  }\n\n  .xl\\:m-3 {\n    margin: 0.75rem;\n  }\n\n  .xl\\:m-4 {\n    margin: 1rem;\n  }\n\n  .xl\\:m-5 {\n    margin: 1.25rem;\n  }\n\n  .xl\\:m-6 {\n    margin: 1.5rem;\n  }\n\n  .xl\\:m-8 {\n    margin: 2rem;\n  }\n\n  .xl\\:m-10 {\n    margin: 2.5rem;\n  }\n\n  .xl\\:m-12 {\n    margin: 3rem;\n  }\n\n  .xl\\:m-16 {\n    margin: 4rem;\n  }\n\n  .xl\\:m-20 {\n    margin: 5rem;\n  }\n\n  .xl\\:m-24 {\n    margin: 6rem;\n  }\n\n  .xl\\:m-32 {\n    margin: 8rem;\n  }\n\n  .xl\\:m-40 {\n    margin: 10rem;\n  }\n\n  .xl\\:m-48 {\n    margin: 12rem;\n  }\n\n  .xl\\:m-56 {\n    margin: 14rem;\n  }\n\n  .xl\\:m-64 {\n    margin: 16rem;\n  }\n\n  .xl\\:m-auto {\n    margin: auto;\n  }\n\n  .xl\\:m-px {\n    margin: 1px;\n  }\n\n  .xl\\:-m-1 {\n    margin: -0.25rem;\n  }\n\n  .xl\\:-m-2 {\n    margin: -0.5rem;\n  }\n\n  .xl\\:-m-3 {\n    margin: -0.75rem;\n  }\n\n  .xl\\:-m-4 {\n    margin: -1rem;\n  }\n\n  .xl\\:-m-5 {\n    margin: -1.25rem;\n  }\n\n  .xl\\:-m-6 {\n    margin: -1.5rem;\n  }\n\n  .xl\\:-m-8 {\n    margin: -2rem;\n  }\n\n  .xl\\:-m-10 {\n    margin: -2.5rem;\n  }\n\n  .xl\\:-m-12 {\n    margin: -3rem;\n  }\n\n  .xl\\:-m-16 {\n    margin: -4rem;\n  }\n\n  .xl\\:-m-20 {\n    margin: -5rem;\n  }\n\n  .xl\\:-m-24 {\n    margin: -6rem;\n  }\n\n  .xl\\:-m-32 {\n    margin: -8rem;\n  }\n\n  .xl\\:-m-40 {\n    margin: -10rem;\n  }\n\n  .xl\\:-m-48 {\n    margin: -12rem;\n  }\n\n  .xl\\:-m-56 {\n    margin: -14rem;\n  }\n\n  .xl\\:-m-64 {\n    margin: -16rem;\n  }\n\n  .xl\\:-m-px {\n    margin: -1px;\n  }\n\n  .xl\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n\n  .xl\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  .xl\\:my-1 {\n    margin-top: 0.25rem;\n    margin-bottom: 0.25rem;\n  }\n\n  .xl\\:mx-1 {\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n  }\n\n  .xl\\:my-2 {\n    margin-top: 0.5rem;\n    margin-bottom: 0.5rem;\n  }\n\n  .xl\\:mx-2 {\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n  }\n\n  .xl\\:my-3 {\n    margin-top: 0.75rem;\n    margin-bottom: 0.75rem;\n  }\n\n  .xl\\:mx-3 {\n    margin-left: 0.75rem;\n    margin-right: 0.75rem;\n  }\n\n  .xl\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .xl\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n\n  .xl\\:my-5 {\n    margin-top: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n\n  .xl\\:mx-5 {\n    margin-left: 1.25rem;\n    margin-right: 1.25rem;\n  }\n\n  .xl\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n  }\n\n  .xl\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n\n  .xl\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n  }\n\n  .xl\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n  }\n\n  .xl\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n  }\n\n  .xl\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n  }\n\n  .xl\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n  }\n\n  .xl\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n  }\n\n  .xl\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n  }\n\n  .xl\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n  }\n\n  .xl\\:my-20 {\n    margin-top: 5rem;\n    margin-bottom: 5rem;\n  }\n\n  .xl\\:mx-20 {\n    margin-left: 5rem;\n    margin-right: 5rem;\n  }\n\n  .xl\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n  }\n\n  .xl\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n  }\n\n  .xl\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n  }\n\n  .xl\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n  }\n\n  .xl\\:my-40 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n  }\n\n  .xl\\:mx-40 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n  }\n\n  .xl\\:my-48 {\n    margin-top: 12rem;\n    margin-bottom: 12rem;\n  }\n\n  .xl\\:mx-48 {\n    margin-left: 12rem;\n    margin-right: 12rem;\n  }\n\n  .xl\\:my-56 {\n    margin-top: 14rem;\n    margin-bottom: 14rem;\n  }\n\n  .xl\\:mx-56 {\n    margin-left: 14rem;\n    margin-right: 14rem;\n  }\n\n  .xl\\:my-64 {\n    margin-top: 16rem;\n    margin-bottom: 16rem;\n  }\n\n  .xl\\:mx-64 {\n    margin-left: 16rem;\n    margin-right: 16rem;\n  }\n\n  .xl\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n\n  .xl\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .xl\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n  }\n\n  .xl\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n  }\n\n  .xl\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n  }\n\n  .xl\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n  }\n\n  .xl\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n  }\n\n  .xl\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n  }\n\n  .xl\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n  }\n\n  .xl\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n  }\n\n  .xl\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n  }\n\n  .xl\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n  }\n\n  .xl\\:-my-5 {\n    margin-top: -1.25rem;\n    margin-bottom: -1.25rem;\n  }\n\n  .xl\\:-mx-5 {\n    margin-left: -1.25rem;\n    margin-right: -1.25rem;\n  }\n\n  .xl\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n  }\n\n  .xl\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n  }\n\n  .xl\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n  }\n\n  .xl\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n  }\n\n  .xl\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n  }\n\n  .xl\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n  }\n\n  .xl\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n  }\n\n  .xl\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n  }\n\n  .xl\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n  }\n\n  .xl\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n  }\n\n  .xl\\:-my-20 {\n    margin-top: -5rem;\n    margin-bottom: -5rem;\n  }\n\n  .xl\\:-mx-20 {\n    margin-left: -5rem;\n    margin-right: -5rem;\n  }\n\n  .xl\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n  }\n\n  .xl\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n  }\n\n  .xl\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n  }\n\n  .xl\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n  }\n\n  .xl\\:-my-40 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n  }\n\n  .xl\\:-mx-40 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n  }\n\n  .xl\\:-my-48 {\n    margin-top: -12rem;\n    margin-bottom: -12rem;\n  }\n\n  .xl\\:-mx-48 {\n    margin-left: -12rem;\n    margin-right: -12rem;\n  }\n\n  .xl\\:-my-56 {\n    margin-top: -14rem;\n    margin-bottom: -14rem;\n  }\n\n  .xl\\:-mx-56 {\n    margin-left: -14rem;\n    margin-right: -14rem;\n  }\n\n  .xl\\:-my-64 {\n    margin-top: -16rem;\n    margin-bottom: -16rem;\n  }\n\n  .xl\\:-mx-64 {\n    margin-left: -16rem;\n    margin-right: -16rem;\n  }\n\n  .xl\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n  }\n\n  .xl\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n  }\n\n  .xl\\:mt-0 {\n    margin-top: 0;\n  }\n\n  .xl\\:mr-0 {\n    margin-right: 0;\n  }\n\n  .xl\\:mb-0 {\n    margin-bottom: 0;\n  }\n\n  .xl\\:ml-0 {\n    margin-left: 0;\n  }\n\n  .xl\\:mt-1 {\n    margin-top: 0.25rem;\n  }\n\n  .xl\\:mr-1 {\n    margin-right: 0.25rem;\n  }\n\n  .xl\\:mb-1 {\n    margin-bottom: 0.25rem;\n  }\n\n  .xl\\:ml-1 {\n    margin-left: 0.25rem;\n  }\n\n  .xl\\:mt-2 {\n    margin-top: 0.5rem;\n  }\n\n  .xl\\:mr-2 {\n    margin-right: 0.5rem;\n  }\n\n  .xl\\:mb-2 {\n    margin-bottom: 0.5rem;\n  }\n\n  .xl\\:ml-2 {\n    margin-left: 0.5rem;\n  }\n\n  .xl\\:mt-3 {\n    margin-top: 0.75rem;\n  }\n\n  .xl\\:mr-3 {\n    margin-right: 0.75rem;\n  }\n\n  .xl\\:mb-3 {\n    margin-bottom: 0.75rem;\n  }\n\n  .xl\\:ml-3 {\n    margin-left: 0.75rem;\n  }\n\n  .xl\\:mt-4 {\n    margin-top: 1rem;\n  }\n\n  .xl\\:mr-4 {\n    margin-right: 1rem;\n  }\n\n  .xl\\:mb-4 {\n    margin-bottom: 1rem;\n  }\n\n  .xl\\:ml-4 {\n    margin-left: 1rem;\n  }\n\n  .xl\\:mt-5 {\n    margin-top: 1.25rem;\n  }\n\n  .xl\\:mr-5 {\n    margin-right: 1.25rem;\n  }\n\n  .xl\\:mb-5 {\n    margin-bottom: 1.25rem;\n  }\n\n  .xl\\:ml-5 {\n    margin-left: 1.25rem;\n  }\n\n  .xl\\:mt-6 {\n    margin-top: 1.5rem;\n  }\n\n  .xl\\:mr-6 {\n    margin-right: 1.5rem;\n  }\n\n  .xl\\:mb-6 {\n    margin-bottom: 1.5rem;\n  }\n\n  .xl\\:ml-6 {\n    margin-left: 1.5rem;\n  }\n\n  .xl\\:mt-8 {\n    margin-top: 2rem;\n  }\n\n  .xl\\:mr-8 {\n    margin-right: 2rem;\n  }\n\n  .xl\\:mb-8 {\n    margin-bottom: 2rem;\n  }\n\n  .xl\\:ml-8 {\n    margin-left: 2rem;\n  }\n\n  .xl\\:mt-10 {\n    margin-top: 2.5rem;\n  }\n\n  .xl\\:mr-10 {\n    margin-right: 2.5rem;\n  }\n\n  .xl\\:mb-10 {\n    margin-bottom: 2.5rem;\n  }\n\n  .xl\\:ml-10 {\n    margin-left: 2.5rem;\n  }\n\n  .xl\\:mt-12 {\n    margin-top: 3rem;\n  }\n\n  .xl\\:mr-12 {\n    margin-right: 3rem;\n  }\n\n  .xl\\:mb-12 {\n    margin-bottom: 3rem;\n  }\n\n  .xl\\:ml-12 {\n    margin-left: 3rem;\n  }\n\n  .xl\\:mt-16 {\n    margin-top: 4rem;\n  }\n\n  .xl\\:mr-16 {\n    margin-right: 4rem;\n  }\n\n  .xl\\:mb-16 {\n    margin-bottom: 4rem;\n  }\n\n  .xl\\:ml-16 {\n    margin-left: 4rem;\n  }\n\n  .xl\\:mt-20 {\n    margin-top: 5rem;\n  }\n\n  .xl\\:mr-20 {\n    margin-right: 5rem;\n  }\n\n  .xl\\:mb-20 {\n    margin-bottom: 5rem;\n  }\n\n  .xl\\:ml-20 {\n    margin-left: 5rem;\n  }\n\n  .xl\\:mt-24 {\n    margin-top: 6rem;\n  }\n\n  .xl\\:mr-24 {\n    margin-right: 6rem;\n  }\n\n  .xl\\:mb-24 {\n    margin-bottom: 6rem;\n  }\n\n  .xl\\:ml-24 {\n    margin-left: 6rem;\n  }\n\n  .xl\\:mt-32 {\n    margin-top: 8rem;\n  }\n\n  .xl\\:mr-32 {\n    margin-right: 8rem;\n  }\n\n  .xl\\:mb-32 {\n    margin-bottom: 8rem;\n  }\n\n  .xl\\:ml-32 {\n    margin-left: 8rem;\n  }\n\n  .xl\\:mt-40 {\n    margin-top: 10rem;\n  }\n\n  .xl\\:mr-40 {\n    margin-right: 10rem;\n  }\n\n  .xl\\:mb-40 {\n    margin-bottom: 10rem;\n  }\n\n  .xl\\:ml-40 {\n    margin-left: 10rem;\n  }\n\n  .xl\\:mt-48 {\n    margin-top: 12rem;\n  }\n\n  .xl\\:mr-48 {\n    margin-right: 12rem;\n  }\n\n  .xl\\:mb-48 {\n    margin-bottom: 12rem;\n  }\n\n  .xl\\:ml-48 {\n    margin-left: 12rem;\n  }\n\n  .xl\\:mt-56 {\n    margin-top: 14rem;\n  }\n\n  .xl\\:mr-56 {\n    margin-right: 14rem;\n  }\n\n  .xl\\:mb-56 {\n    margin-bottom: 14rem;\n  }\n\n  .xl\\:ml-56 {\n    margin-left: 14rem;\n  }\n\n  .xl\\:mt-64 {\n    margin-top: 16rem;\n  }\n\n  .xl\\:mr-64 {\n    margin-right: 16rem;\n  }\n\n  .xl\\:mb-64 {\n    margin-bottom: 16rem;\n  }\n\n  .xl\\:ml-64 {\n    margin-left: 16rem;\n  }\n\n  .xl\\:mt-auto {\n    margin-top: auto;\n  }\n\n  .xl\\:mr-auto {\n    margin-right: auto;\n  }\n\n  .xl\\:mb-auto {\n    margin-bottom: auto;\n  }\n\n  .xl\\:ml-auto {\n    margin-left: auto;\n  }\n\n  .xl\\:mt-px {\n    margin-top: 1px;\n  }\n\n  .xl\\:mr-px {\n    margin-right: 1px;\n  }\n\n  .xl\\:mb-px {\n    margin-bottom: 1px;\n  }\n\n  .xl\\:ml-px {\n    margin-left: 1px;\n  }\n\n  .xl\\:-mt-1 {\n    margin-top: -0.25rem;\n  }\n\n  .xl\\:-mr-1 {\n    margin-right: -0.25rem;\n  }\n\n  .xl\\:-mb-1 {\n    margin-bottom: -0.25rem;\n  }\n\n  .xl\\:-ml-1 {\n    margin-left: -0.25rem;\n  }\n\n  .xl\\:-mt-2 {\n    margin-top: -0.5rem;\n  }\n\n  .xl\\:-mr-2 {\n    margin-right: -0.5rem;\n  }\n\n  .xl\\:-mb-2 {\n    margin-bottom: -0.5rem;\n  }\n\n  .xl\\:-ml-2 {\n    margin-left: -0.5rem;\n  }\n\n  .xl\\:-mt-3 {\n    margin-top: -0.75rem;\n  }\n\n  .xl\\:-mr-3 {\n    margin-right: -0.75rem;\n  }\n\n  .xl\\:-mb-3 {\n    margin-bottom: -0.75rem;\n  }\n\n  .xl\\:-ml-3 {\n    margin-left: -0.75rem;\n  }\n\n  .xl\\:-mt-4 {\n    margin-top: -1rem;\n  }\n\n  .xl\\:-mr-4 {\n    margin-right: -1rem;\n  }\n\n  .xl\\:-mb-4 {\n    margin-bottom: -1rem;\n  }\n\n  .xl\\:-ml-4 {\n    margin-left: -1rem;\n  }\n\n  .xl\\:-mt-5 {\n    margin-top: -1.25rem;\n  }\n\n  .xl\\:-mr-5 {\n    margin-right: -1.25rem;\n  }\n\n  .xl\\:-mb-5 {\n    margin-bottom: -1.25rem;\n  }\n\n  .xl\\:-ml-5 {\n    margin-left: -1.25rem;\n  }\n\n  .xl\\:-mt-6 {\n    margin-top: -1.5rem;\n  }\n\n  .xl\\:-mr-6 {\n    margin-right: -1.5rem;\n  }\n\n  .xl\\:-mb-6 {\n    margin-bottom: -1.5rem;\n  }\n\n  .xl\\:-ml-6 {\n    margin-left: -1.5rem;\n  }\n\n  .xl\\:-mt-8 {\n    margin-top: -2rem;\n  }\n\n  .xl\\:-mr-8 {\n    margin-right: -2rem;\n  }\n\n  .xl\\:-mb-8 {\n    margin-bottom: -2rem;\n  }\n\n  .xl\\:-ml-8 {\n    margin-left: -2rem;\n  }\n\n  .xl\\:-mt-10 {\n    margin-top: -2.5rem;\n  }\n\n  .xl\\:-mr-10 {\n    margin-right: -2.5rem;\n  }\n\n  .xl\\:-mb-10 {\n    margin-bottom: -2.5rem;\n  }\n\n  .xl\\:-ml-10 {\n    margin-left: -2.5rem;\n  }\n\n  .xl\\:-mt-12 {\n    margin-top: -3rem;\n  }\n\n  .xl\\:-mr-12 {\n    margin-right: -3rem;\n  }\n\n  .xl\\:-mb-12 {\n    margin-bottom: -3rem;\n  }\n\n  .xl\\:-ml-12 {\n    margin-left: -3rem;\n  }\n\n  .xl\\:-mt-16 {\n    margin-top: -4rem;\n  }\n\n  .xl\\:-mr-16 {\n    margin-right: -4rem;\n  }\n\n  .xl\\:-mb-16 {\n    margin-bottom: -4rem;\n  }\n\n  .xl\\:-ml-16 {\n    margin-left: -4rem;\n  }\n\n  .xl\\:-mt-20 {\n    margin-top: -5rem;\n  }\n\n  .xl\\:-mr-20 {\n    margin-right: -5rem;\n  }\n\n  .xl\\:-mb-20 {\n    margin-bottom: -5rem;\n  }\n\n  .xl\\:-ml-20 {\n    margin-left: -5rem;\n  }\n\n  .xl\\:-mt-24 {\n    margin-top: -6rem;\n  }\n\n  .xl\\:-mr-24 {\n    margin-right: -6rem;\n  }\n\n  .xl\\:-mb-24 {\n    margin-bottom: -6rem;\n  }\n\n  .xl\\:-ml-24 {\n    margin-left: -6rem;\n  }\n\n  .xl\\:-mt-32 {\n    margin-top: -8rem;\n  }\n\n  .xl\\:-mr-32 {\n    margin-right: -8rem;\n  }\n\n  .xl\\:-mb-32 {\n    margin-bottom: -8rem;\n  }\n\n  .xl\\:-ml-32 {\n    margin-left: -8rem;\n  }\n\n  .xl\\:-mt-40 {\n    margin-top: -10rem;\n  }\n\n  .xl\\:-mr-40 {\n    margin-right: -10rem;\n  }\n\n  .xl\\:-mb-40 {\n    margin-bottom: -10rem;\n  }\n\n  .xl\\:-ml-40 {\n    margin-left: -10rem;\n  }\n\n  .xl\\:-mt-48 {\n    margin-top: -12rem;\n  }\n\n  .xl\\:-mr-48 {\n    margin-right: -12rem;\n  }\n\n  .xl\\:-mb-48 {\n    margin-bottom: -12rem;\n  }\n\n  .xl\\:-ml-48 {\n    margin-left: -12rem;\n  }\n\n  .xl\\:-mt-56 {\n    margin-top: -14rem;\n  }\n\n  .xl\\:-mr-56 {\n    margin-right: -14rem;\n  }\n\n  .xl\\:-mb-56 {\n    margin-bottom: -14rem;\n  }\n\n  .xl\\:-ml-56 {\n    margin-left: -14rem;\n  }\n\n  .xl\\:-mt-64 {\n    margin-top: -16rem;\n  }\n\n  .xl\\:-mr-64 {\n    margin-right: -16rem;\n  }\n\n  .xl\\:-mb-64 {\n    margin-bottom: -16rem;\n  }\n\n  .xl\\:-ml-64 {\n    margin-left: -16rem;\n  }\n\n  .xl\\:-mt-px {\n    margin-top: -1px;\n  }\n\n  .xl\\:-mr-px {\n    margin-right: -1px;\n  }\n\n  .xl\\:-mb-px {\n    margin-bottom: -1px;\n  }\n\n  .xl\\:-ml-px {\n    margin-left: -1px;\n  }\n\n  .xl\\:max-h-full {\n    max-height: 100%;\n  }\n\n  .xl\\:max-h-screen {\n    max-height: 100vh;\n  }\n\n  .xl\\:max-w-none {\n    max-width: none;\n  }\n\n  .xl\\:max-w-xs {\n    max-width: 20rem;\n  }\n\n  .xl\\:max-w-sm {\n    max-width: 24rem;\n  }\n\n  .xl\\:max-w-md {\n    max-width: 28rem;\n  }\n\n  .xl\\:max-w-lg {\n    max-width: 32rem;\n  }\n\n  .xl\\:max-w-xl {\n    max-width: 36rem;\n  }\n\n  .xl\\:max-w-2xl {\n    max-width: 42rem;\n  }\n\n  .xl\\:max-w-3xl {\n    max-width: 48rem;\n  }\n\n  .xl\\:max-w-4xl {\n    max-width: 56rem;\n  }\n\n  .xl\\:max-w-5xl {\n    max-width: 64rem;\n  }\n\n  .xl\\:max-w-6xl {\n    max-width: 72rem;\n  }\n\n  .xl\\:max-w-full {\n    max-width: 100%;\n  }\n\n  .xl\\:max-w-screen-sm {\n    max-width: 640px;\n  }\n\n  .xl\\:max-w-screen-md {\n    max-width: 768px;\n  }\n\n  .xl\\:max-w-screen-lg {\n    max-width: 1024px;\n  }\n\n  .xl\\:max-w-screen-xl {\n    max-width: 1280px;\n  }\n\n  .xl\\:min-h-0 {\n    min-height: 0;\n  }\n\n  .xl\\:min-h-full {\n    min-height: 100%;\n  }\n\n  .xl\\:min-h-screen {\n    min-height: 100vh;\n  }\n\n  .xl\\:min-w-0 {\n    min-width: 0;\n  }\n\n  .xl\\:min-w-full {\n    min-width: 100%;\n  }\n\n  .xl\\:object-contain {\n    object-fit: contain;\n  }\n\n  .xl\\:object-cover {\n    object-fit: cover;\n  }\n\n  .xl\\:object-fill {\n    object-fit: fill;\n  }\n\n  .xl\\:object-none {\n    object-fit: none;\n  }\n\n  .xl\\:object-scale-down {\n    object-fit: scale-down;\n  }\n\n  .xl\\:object-bottom {\n    object-position: bottom;\n  }\n\n  .xl\\:object-center {\n    object-position: center;\n  }\n\n  .xl\\:object-left {\n    object-position: left;\n  }\n\n  .xl\\:object-left-bottom {\n    object-position: left bottom;\n  }\n\n  .xl\\:object-left-top {\n    object-position: left top;\n  }\n\n  .xl\\:object-right {\n    object-position: right;\n  }\n\n  .xl\\:object-right-bottom {\n    object-position: right bottom;\n  }\n\n  .xl\\:object-right-top {\n    object-position: right top;\n  }\n\n  .xl\\:object-top {\n    object-position: top;\n  }\n\n  .xl\\:opacity-0 {\n    opacity: 0;\n  }\n\n  .xl\\:opacity-25 {\n    opacity: 0.25;\n  }\n\n  .xl\\:opacity-50 {\n    opacity: 0.5;\n  }\n\n  .xl\\:opacity-75 {\n    opacity: 0.75;\n  }\n\n  .xl\\:opacity-100 {\n    opacity: 1;\n  }\n\n  .xl\\:hover\\:opacity-0:hover {\n    opacity: 0;\n  }\n\n  .xl\\:hover\\:opacity-25:hover {\n    opacity: 0.25;\n  }\n\n  .xl\\:hover\\:opacity-50:hover {\n    opacity: 0.5;\n  }\n\n  .xl\\:hover\\:opacity-75:hover {\n    opacity: 0.75;\n  }\n\n  .xl\\:hover\\:opacity-100:hover {\n    opacity: 1;\n  }\n\n  .xl\\:focus\\:opacity-0:focus {\n    opacity: 0;\n  }\n\n  .xl\\:focus\\:opacity-25:focus {\n    opacity: 0.25;\n  }\n\n  .xl\\:focus\\:opacity-50:focus {\n    opacity: 0.5;\n  }\n\n  .xl\\:focus\\:opacity-75:focus {\n    opacity: 0.75;\n  }\n\n  .xl\\:focus\\:opacity-100:focus {\n    opacity: 1;\n  }\n\n  .xl\\:outline-none {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  .xl\\:outline-white {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n\n  .xl\\:outline-black {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n\n  .xl\\:focus\\:outline-none:focus {\n    outline: 2px solid transparent;\n    outline-offset: 2px;\n  }\n\n  .xl\\:focus\\:outline-white:focus {\n    outline: 2px dotted white;\n    outline-offset: 2px;\n  }\n\n  .xl\\:focus\\:outline-black:focus {\n    outline: 2px dotted black;\n    outline-offset: 2px;\n  }\n\n  .xl\\:overflow-auto {\n    overflow: auto;\n  }\n\n  .xl\\:overflow-hidden {\n    overflow: hidden;\n  }\n\n  .xl\\:overflow-visible {\n    overflow: visible;\n  }\n\n  .xl\\:overflow-scroll {\n    overflow: scroll;\n  }\n\n  .xl\\:overflow-x-auto {\n    overflow-x: auto;\n  }\n\n  .xl\\:overflow-y-auto {\n    overflow-y: auto;\n  }\n\n  .xl\\:overflow-x-hidden {\n    overflow-x: hidden;\n  }\n\n  .xl\\:overflow-y-hidden {\n    overflow-y: hidden;\n  }\n\n  .xl\\:overflow-x-visible {\n    overflow-x: visible;\n  }\n\n  .xl\\:overflow-y-visible {\n    overflow-y: visible;\n  }\n\n  .xl\\:overflow-x-scroll {\n    overflow-x: scroll;\n  }\n\n  .xl\\:overflow-y-scroll {\n    overflow-y: scroll;\n  }\n\n  .xl\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .xl\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n  }\n\n  .xl\\:overscroll-auto {\n    overscroll-behavior: auto;\n  }\n\n  .xl\\:overscroll-contain {\n    overscroll-behavior: contain;\n  }\n\n  .xl\\:overscroll-none {\n    overscroll-behavior: none;\n  }\n\n  .xl\\:overscroll-y-auto {\n    overscroll-behavior-y: auto;\n  }\n\n  .xl\\:overscroll-y-contain {\n    overscroll-behavior-y: contain;\n  }\n\n  .xl\\:overscroll-y-none {\n    overscroll-behavior-y: none;\n  }\n\n  .xl\\:overscroll-x-auto {\n    overscroll-behavior-x: auto;\n  }\n\n  .xl\\:overscroll-x-contain {\n    overscroll-behavior-x: contain;\n  }\n\n  .xl\\:overscroll-x-none {\n    overscroll-behavior-x: none;\n  }\n\n  .xl\\:p-0 {\n    padding: 0;\n  }\n\n  .xl\\:p-1 {\n    padding: 0.25rem;\n  }\n\n  .xl\\:p-2 {\n    padding: 0.5rem;\n  }\n\n  .xl\\:p-3 {\n    padding: 0.75rem;\n  }\n\n  .xl\\:p-4 {\n    padding: 1rem;\n  }\n\n  .xl\\:p-5 {\n    padding: 1.25rem;\n  }\n\n  .xl\\:p-6 {\n    padding: 1.5rem;\n  }\n\n  .xl\\:p-8 {\n    padding: 2rem;\n  }\n\n  .xl\\:p-10 {\n    padding: 2.5rem;\n  }\n\n  .xl\\:p-12 {\n    padding: 3rem;\n  }\n\n  .xl\\:p-16 {\n    padding: 4rem;\n  }\n\n  .xl\\:p-20 {\n    padding: 5rem;\n  }\n\n  .xl\\:p-24 {\n    padding: 6rem;\n  }\n\n  .xl\\:p-32 {\n    padding: 8rem;\n  }\n\n  .xl\\:p-40 {\n    padding: 10rem;\n  }\n\n  .xl\\:p-48 {\n    padding: 12rem;\n  }\n\n  .xl\\:p-56 {\n    padding: 14rem;\n  }\n\n  .xl\\:p-64 {\n    padding: 16rem;\n  }\n\n  .xl\\:p-px {\n    padding: 1px;\n  }\n\n  .xl\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n  }\n\n  .xl\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .xl\\:py-1 {\n    padding-top: 0.25rem;\n    padding-bottom: 0.25rem;\n  }\n\n  .xl\\:px-1 {\n    padding-left: 0.25rem;\n    padding-right: 0.25rem;\n  }\n\n  .xl\\:py-2 {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n\n  .xl\\:px-2 {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n\n  .xl\\:py-3 {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n\n  .xl\\:px-3 {\n    padding-left: 0.75rem;\n    padding-right: 0.75rem;\n  }\n\n  .xl\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n  }\n\n  .xl\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n\n  .xl\\:py-5 {\n    padding-top: 1.25rem;\n    padding-bottom: 1.25rem;\n  }\n\n  .xl\\:px-5 {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n  }\n\n  .xl\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n\n  .xl\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n  }\n\n  .xl\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n\n  .xl\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n  }\n\n  .xl\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n  }\n\n  .xl\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n  }\n\n  .xl\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n  }\n\n  .xl\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n  }\n\n  .xl\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n  }\n\n  .xl\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n  }\n\n  .xl\\:py-20 {\n    padding-top: 5rem;\n    padding-bottom: 5rem;\n  }\n\n  .xl\\:px-20 {\n    padding-left: 5rem;\n    padding-right: 5rem;\n  }\n\n  .xl\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n  }\n\n  .xl\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n  }\n\n  .xl\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n  }\n\n  .xl\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n  }\n\n  .xl\\:py-40 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n  }\n\n  .xl\\:px-40 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n  }\n\n  .xl\\:py-48 {\n    padding-top: 12rem;\n    padding-bottom: 12rem;\n  }\n\n  .xl\\:px-48 {\n    padding-left: 12rem;\n    padding-right: 12rem;\n  }\n\n  .xl\\:py-56 {\n    padding-top: 14rem;\n    padding-bottom: 14rem;\n  }\n\n  .xl\\:px-56 {\n    padding-left: 14rem;\n    padding-right: 14rem;\n  }\n\n  .xl\\:py-64 {\n    padding-top: 16rem;\n    padding-bottom: 16rem;\n  }\n\n  .xl\\:px-64 {\n    padding-left: 16rem;\n    padding-right: 16rem;\n  }\n\n  .xl\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n  }\n\n  .xl\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n\n  .xl\\:pt-0 {\n    padding-top: 0;\n  }\n\n  .xl\\:pr-0 {\n    padding-right: 0;\n  }\n\n  .xl\\:pb-0 {\n    padding-bottom: 0;\n  }\n\n  .xl\\:pl-0 {\n    padding-left: 0;\n  }\n\n  .xl\\:pt-1 {\n    padding-top: 0.25rem;\n  }\n\n  .xl\\:pr-1 {\n    padding-right: 0.25rem;\n  }\n\n  .xl\\:pb-1 {\n    padding-bottom: 0.25rem;\n  }\n\n  .xl\\:pl-1 {\n    padding-left: 0.25rem;\n  }\n\n  .xl\\:pt-2 {\n    padding-top: 0.5rem;\n  }\n\n  .xl\\:pr-2 {\n    padding-right: 0.5rem;\n  }\n\n  .xl\\:pb-2 {\n    padding-bottom: 0.5rem;\n  }\n\n  .xl\\:pl-2 {\n    padding-left: 0.5rem;\n  }\n\n  .xl\\:pt-3 {\n    padding-top: 0.75rem;\n  }\n\n  .xl\\:pr-3 {\n    padding-right: 0.75rem;\n  }\n\n  .xl\\:pb-3 {\n    padding-bottom: 0.75rem;\n  }\n\n  .xl\\:pl-3 {\n    padding-left: 0.75rem;\n  }\n\n  .xl\\:pt-4 {\n    padding-top: 1rem;\n  }\n\n  .xl\\:pr-4 {\n    padding-right: 1rem;\n  }\n\n  .xl\\:pb-4 {\n    padding-bottom: 1rem;\n  }\n\n  .xl\\:pl-4 {\n    padding-left: 1rem;\n  }\n\n  .xl\\:pt-5 {\n    padding-top: 1.25rem;\n  }\n\n  .xl\\:pr-5 {\n    padding-right: 1.25rem;\n  }\n\n  .xl\\:pb-5 {\n    padding-bottom: 1.25rem;\n  }\n\n  .xl\\:pl-5 {\n    padding-left: 1.25rem;\n  }\n\n  .xl\\:pt-6 {\n    padding-top: 1.5rem;\n  }\n\n  .xl\\:pr-6 {\n    padding-right: 1.5rem;\n  }\n\n  .xl\\:pb-6 {\n    padding-bottom: 1.5rem;\n  }\n\n  .xl\\:pl-6 {\n    padding-left: 1.5rem;\n  }\n\n  .xl\\:pt-8 {\n    padding-top: 2rem;\n  }\n\n  .xl\\:pr-8 {\n    padding-right: 2rem;\n  }\n\n  .xl\\:pb-8 {\n    padding-bottom: 2rem;\n  }\n\n  .xl\\:pl-8 {\n    padding-left: 2rem;\n  }\n\n  .xl\\:pt-10 {\n    padding-top: 2.5rem;\n  }\n\n  .xl\\:pr-10 {\n    padding-right: 2.5rem;\n  }\n\n  .xl\\:pb-10 {\n    padding-bottom: 2.5rem;\n  }\n\n  .xl\\:pl-10 {\n    padding-left: 2.5rem;\n  }\n\n  .xl\\:pt-12 {\n    padding-top: 3rem;\n  }\n\n  .xl\\:pr-12 {\n    padding-right: 3rem;\n  }\n\n  .xl\\:pb-12 {\n    padding-bottom: 3rem;\n  }\n\n  .xl\\:pl-12 {\n    padding-left: 3rem;\n  }\n\n  .xl\\:pt-16 {\n    padding-top: 4rem;\n  }\n\n  .xl\\:pr-16 {\n    padding-right: 4rem;\n  }\n\n  .xl\\:pb-16 {\n    padding-bottom: 4rem;\n  }\n\n  .xl\\:pl-16 {\n    padding-left: 4rem;\n  }\n\n  .xl\\:pt-20 {\n    padding-top: 5rem;\n  }\n\n  .xl\\:pr-20 {\n    padding-right: 5rem;\n  }\n\n  .xl\\:pb-20 {\n    padding-bottom: 5rem;\n  }\n\n  .xl\\:pl-20 {\n    padding-left: 5rem;\n  }\n\n  .xl\\:pt-24 {\n    padding-top: 6rem;\n  }\n\n  .xl\\:pr-24 {\n    padding-right: 6rem;\n  }\n\n  .xl\\:pb-24 {\n    padding-bottom: 6rem;\n  }\n\n  .xl\\:pl-24 {\n    padding-left: 6rem;\n  }\n\n  .xl\\:pt-32 {\n    padding-top: 8rem;\n  }\n\n  .xl\\:pr-32 {\n    padding-right: 8rem;\n  }\n\n  .xl\\:pb-32 {\n    padding-bottom: 8rem;\n  }\n\n  .xl\\:pl-32 {\n    padding-left: 8rem;\n  }\n\n  .xl\\:pt-40 {\n    padding-top: 10rem;\n  }\n\n  .xl\\:pr-40 {\n    padding-right: 10rem;\n  }\n\n  .xl\\:pb-40 {\n    padding-bottom: 10rem;\n  }\n\n  .xl\\:pl-40 {\n    padding-left: 10rem;\n  }\n\n  .xl\\:pt-48 {\n    padding-top: 12rem;\n  }\n\n  .xl\\:pr-48 {\n    padding-right: 12rem;\n  }\n\n  .xl\\:pb-48 {\n    padding-bottom: 12rem;\n  }\n\n  .xl\\:pl-48 {\n    padding-left: 12rem;\n  }\n\n  .xl\\:pt-56 {\n    padding-top: 14rem;\n  }\n\n  .xl\\:pr-56 {\n    padding-right: 14rem;\n  }\n\n  .xl\\:pb-56 {\n    padding-bottom: 14rem;\n  }\n\n  .xl\\:pl-56 {\n    padding-left: 14rem;\n  }\n\n  .xl\\:pt-64 {\n    padding-top: 16rem;\n  }\n\n  .xl\\:pr-64 {\n    padding-right: 16rem;\n  }\n\n  .xl\\:pb-64 {\n    padding-bottom: 16rem;\n  }\n\n  .xl\\:pl-64 {\n    padding-left: 16rem;\n  }\n\n  .xl\\:pt-px {\n    padding-top: 1px;\n  }\n\n  .xl\\:pr-px {\n    padding-right: 1px;\n  }\n\n  .xl\\:pb-px {\n    padding-bottom: 1px;\n  }\n\n  .xl\\:pl-px {\n    padding-left: 1px;\n  }\n\n  .xl\\:placeholder-transparent::placeholder {\n    color: transparent;\n  }\n\n  .xl\\:placeholder-current::placeholder {\n    color: currentColor;\n  }\n\n  .xl\\:placeholder-black::placeholder {\n    --placeholder-opacity: 1;\n    color: #000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-white::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f7fafc;\n    color: rgba(247, 250, 252, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #edf2f7;\n    color: rgba(237, 242, 247, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #cbd5e0;\n    color: rgba(203, 213, 224, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160, 174, 192, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #718096;\n    color: rgba(113, 128, 150, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a5568;\n    color: rgba(74, 85, 104, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #2d3748;\n    color: rgba(45, 55, 72, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-gray-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202c;\n    color: rgba(26, 32, 44, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f5;\n    color: rgba(255, 245, 245, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7d7;\n    color: rgba(254, 215, 215, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #feb2b2;\n    color: rgba(254, 178, 178, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #fc8181;\n    color: rgba(252, 129, 129, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #f56565;\n    color: rgba(245, 101, 101, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #e53e3e;\n    color: rgba(229, 62, 62, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c53030;\n    color: rgba(197, 48, 48, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b2c2c;\n    color: rgba(155, 44, 44, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-red-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #742a2a;\n    color: rgba(116, 42, 42, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffaf0;\n    color: rgba(255, 250, 240, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #feebc8;\n    color: rgba(254, 235, 200, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd38d;\n    color: rgba(251, 211, 141, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6ad55;\n    color: rgba(246, 173, 85, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed8936;\n    color: rgba(237, 137, 54, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #dd6b20;\n    color: rgba(221, 107, 32, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #c05621;\n    color: rgba(192, 86, 33, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #9c4221;\n    color: rgba(156, 66, 33, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-orange-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #7b341e;\n    color: rgba(123, 52, 30, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffff0;\n    color: rgba(255, 255, 240, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fefcbf;\n    color: rgba(254, 252, 191, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf089;\n    color: rgba(250, 240, 137, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6e05e;\n    color: rgba(246, 224, 94, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ecc94b;\n    color: rgba(236, 201, 75, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d69e2e;\n    color: rgba(214, 158, 46, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b7791f;\n    color: rgba(183, 121, 31, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #975a16;\n    color: rgba(151, 90, 22, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-yellow-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #744210;\n    color: rgba(116, 66, 16, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0fff4;\n    color: rgba(240, 255, 244, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c6f6d5;\n    color: rgba(198, 246, 213, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #9ae6b4;\n    color: rgba(154, 230, 180, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #68d391;\n    color: rgba(104, 211, 145, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #48bb78;\n    color: rgba(72, 187, 120, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #38a169;\n    color: rgba(56, 161, 105, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2f855a;\n    color: rgba(47, 133, 90, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #276749;\n    color: rgba(39, 103, 73, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-green-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #22543d;\n    color: rgba(34, 84, 61, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #e6fffa;\n    color: rgba(230, 255, 250, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #b2f5ea;\n    color: rgba(178, 245, 234, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #81e6d9;\n    color: rgba(129, 230, 217, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #4fd1c5;\n    color: rgba(79, 209, 197, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #38b2ac;\n    color: rgba(56, 178, 172, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #319795;\n    color: rgba(49, 151, 149, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c7a7b;\n    color: rgba(44, 122, 123, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #285e61;\n    color: rgba(40, 94, 97, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-teal-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #234e52;\n    color: rgba(35, 78, 82, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf8ff;\n    color: rgba(235, 248, 255, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #bee3f8;\n    color: rgba(190, 227, 248, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #90cdf4;\n    color: rgba(144, 205, 244, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #63b3ed;\n    color: rgba(99, 179, 237, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #4299e1;\n    color: rgba(66, 153, 225, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #3182ce;\n    color: rgba(49, 130, 206, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #2b6cb0;\n    color: rgba(43, 108, 176, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c5282;\n    color: rgba(44, 82, 130, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-blue-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #2a4365;\n    color: rgba(42, 67, 101, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf4ff;\n    color: rgba(235, 244, 255, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3dafe;\n    color: rgba(195, 218, 254, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #a3bffa;\n    color: rgba(163, 191, 250, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #7f9cf5;\n    color: rgba(127, 156, 245, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #667eea;\n    color: rgba(102, 126, 234, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #5a67d8;\n    color: rgba(90, 103, 216, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #4c51bf;\n    color: rgba(76, 81, 191, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #434190;\n    color: rgba(67, 65, 144, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-indigo-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #3c366b;\n    color: rgba(60, 54, 107, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf5ff;\n    color: rgba(250, 245, 255, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #e9d8fd;\n    color: rgba(233, 216, 253, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #d6bcfa;\n    color: rgba(214, 188, 250, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #b794f4;\n    color: rgba(183, 148, 244, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f7aea;\n    color: rgba(159, 122, 234, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #805ad5;\n    color: rgba(128, 90, 213, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b46c1;\n    color: rgba(107, 70, 193, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #553c9a;\n    color: rgba(85, 60, 154, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-purple-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #44337a;\n    color: rgba(68, 51, 122, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-100::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f7;\n    color: rgba(255, 245, 247, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-200::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7e2;\n    color: rgba(254, 215, 226, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-300::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbb6ce;\n    color: rgba(251, 182, 206, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-400::placeholder {\n    --placeholder-opacity: 1;\n    color: #f687b3;\n    color: rgba(246, 135, 179, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-500::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed64a6;\n    color: rgba(237, 100, 166, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-600::placeholder {\n    --placeholder-opacity: 1;\n    color: #d53f8c;\n    color: rgba(213, 63, 140, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-700::placeholder {\n    --placeholder-opacity: 1;\n    color: #b83280;\n    color: rgba(184, 50, 128, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-800::placeholder {\n    --placeholder-opacity: 1;\n    color: #97266d;\n    color: rgba(151, 38, 109, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-pink-900::placeholder {\n    --placeholder-opacity: 1;\n    color: #702459;\n    color: rgba(112, 36, 89, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-transparent:focus::placeholder {\n    color: transparent;\n  }\n\n  .xl\\:focus\\:placeholder-current:focus::placeholder {\n    color: currentColor;\n  }\n\n  .xl\\:focus\\:placeholder-black:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #000;\n    color: rgba(0, 0, 0, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-white:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff;\n    color: rgba(255, 255, 255, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f7fafc;\n    color: rgba(247, 250, 252, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #edf2f7;\n    color: rgba(237, 242, 247, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e2e8f0;\n    color: rgba(226, 232, 240, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #cbd5e0;\n    color: rgba(203, 213, 224, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a0aec0;\n    color: rgba(160, 174, 192, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #718096;\n    color: rgba(113, 128, 150, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4a5568;\n    color: rgba(74, 85, 104, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2d3748;\n    color: rgba(45, 55, 72, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-gray-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #1a202c;\n    color: rgba(26, 32, 44, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f5;\n    color: rgba(255, 245, 245, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7d7;\n    color: rgba(254, 215, 215, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feb2b2;\n    color: rgba(254, 178, 178, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fc8181;\n    color: rgba(252, 129, 129, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f56565;\n    color: rgba(245, 101, 101, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e53e3e;\n    color: rgba(229, 62, 62, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c53030;\n    color: rgba(197, 48, 48, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9b2c2c;\n    color: rgba(155, 44, 44, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-red-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #742a2a;\n    color: rgba(116, 42, 42, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffaf0;\n    color: rgba(255, 250, 240, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #feebc8;\n    color: rgba(254, 235, 200, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbd38d;\n    color: rgba(251, 211, 141, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6ad55;\n    color: rgba(246, 173, 85, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed8936;\n    color: rgba(237, 137, 54, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #dd6b20;\n    color: rgba(221, 107, 32, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c05621;\n    color: rgba(192, 86, 33, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9c4221;\n    color: rgba(156, 66, 33, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-orange-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7b341e;\n    color: rgba(123, 52, 30, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fffff0;\n    color: rgba(255, 255, 240, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fefcbf;\n    color: rgba(254, 252, 191, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf089;\n    color: rgba(250, 240, 137, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f6e05e;\n    color: rgba(246, 224, 94, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ecc94b;\n    color: rgba(236, 201, 75, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d69e2e;\n    color: rgba(214, 158, 46, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b7791f;\n    color: rgba(183, 121, 31, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #975a16;\n    color: rgba(151, 90, 22, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-yellow-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #744210;\n    color: rgba(116, 66, 16, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f0fff4;\n    color: rgba(240, 255, 244, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c6f6d5;\n    color: rgba(198, 246, 213, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9ae6b4;\n    color: rgba(154, 230, 180, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #68d391;\n    color: rgba(104, 211, 145, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #48bb78;\n    color: rgba(72, 187, 120, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #38a169;\n    color: rgba(56, 161, 105, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2f855a;\n    color: rgba(47, 133, 90, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #276749;\n    color: rgba(39, 103, 73, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-green-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #22543d;\n    color: rgba(34, 84, 61, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e6fffa;\n    color: rgba(230, 255, 250, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b2f5ea;\n    color: rgba(178, 245, 234, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #81e6d9;\n    color: rgba(129, 230, 217, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4fd1c5;\n    color: rgba(79, 209, 197, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #38b2ac;\n    color: rgba(56, 178, 172, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #319795;\n    color: rgba(49, 151, 149, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c7a7b;\n    color: rgba(44, 122, 123, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #285e61;\n    color: rgba(40, 94, 97, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-teal-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #234e52;\n    color: rgba(35, 78, 82, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf8ff;\n    color: rgba(235, 248, 255, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #bee3f8;\n    color: rgba(190, 227, 248, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #90cdf4;\n    color: rgba(144, 205, 244, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #63b3ed;\n    color: rgba(99, 179, 237, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4299e1;\n    color: rgba(66, 153, 225, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3182ce;\n    color: rgba(49, 130, 206, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2b6cb0;\n    color: rgba(43, 108, 176, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2c5282;\n    color: rgba(44, 82, 130, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-blue-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #2a4365;\n    color: rgba(42, 67, 101, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ebf4ff;\n    color: rgba(235, 244, 255, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #c3dafe;\n    color: rgba(195, 218, 254, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #a3bffa;\n    color: rgba(163, 191, 250, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #7f9cf5;\n    color: rgba(127, 156, 245, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #667eea;\n    color: rgba(102, 126, 234, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #5a67d8;\n    color: rgba(90, 103, 216, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #4c51bf;\n    color: rgba(76, 81, 191, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #434190;\n    color: rgba(67, 65, 144, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-indigo-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #3c366b;\n    color: rgba(60, 54, 107, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #faf5ff;\n    color: rgba(250, 245, 255, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #e9d8fd;\n    color: rgba(233, 216, 253, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d6bcfa;\n    color: rgba(214, 188, 250, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b794f4;\n    color: rgba(183, 148, 244, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #9f7aea;\n    color: rgba(159, 122, 234, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #805ad5;\n    color: rgba(128, 90, 213, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #6b46c1;\n    color: rgba(107, 70, 193, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #553c9a;\n    color: rgba(85, 60, 154, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-purple-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #44337a;\n    color: rgba(68, 51, 122, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-100:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fff5f7;\n    color: rgba(255, 245, 247, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-200:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fed7e2;\n    color: rgba(254, 215, 226, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-300:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #fbb6ce;\n    color: rgba(251, 182, 206, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-400:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #f687b3;\n    color: rgba(246, 135, 179, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-500:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #ed64a6;\n    color: rgba(237, 100, 166, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-600:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #d53f8c;\n    color: rgba(213, 63, 140, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-700:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #b83280;\n    color: rgba(184, 50, 128, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-800:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #97266d;\n    color: rgba(151, 38, 109, var(--placeholder-opacity));\n  }\n\n  .xl\\:focus\\:placeholder-pink-900:focus::placeholder {\n    --placeholder-opacity: 1;\n    color: #702459;\n    color: rgba(112, 36, 89, var(--placeholder-opacity));\n  }\n\n  .xl\\:placeholder-opacity-0::placeholder {\n    --placeholder-opacity: 0;\n  }\n\n  .xl\\:placeholder-opacity-25::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n\n  .xl\\:placeholder-opacity-50::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n\n  .xl\\:placeholder-opacity-75::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n\n  .xl\\:placeholder-opacity-100::placeholder {\n    --placeholder-opacity: 1;\n  }\n\n  .xl\\:focus\\:placeholder-opacity-0:focus::placeholder {\n    --placeholder-opacity: 0;\n  }\n\n  .xl\\:focus\\:placeholder-opacity-25:focus::placeholder {\n    --placeholder-opacity: 0.25;\n  }\n\n  .xl\\:focus\\:placeholder-opacity-50:focus::placeholder {\n    --placeholder-opacity: 0.5;\n  }\n\n  .xl\\:focus\\:placeholder-opacity-75:focus::placeholder {\n    --placeholder-opacity: 0.75;\n  }\n\n  .xl\\:focus\\:placeholder-opacity-100:focus::placeholder {\n    --placeholder-opacity: 1;\n  }\n\n  .xl\\:pointer-events-none {\n    pointer-events: none;\n  }\n\n  .xl\\:pointer-events-auto {\n    pointer-events: auto;\n  }\n\n  .xl\\:static {\n    position: static;\n  }\n\n  .xl\\:fixed {\n    position: fixed;\n  }\n\n  .xl\\:absolute {\n    position: absolute;\n  }\n\n  .xl\\:relative {\n    position: relative;\n  }\n\n  .xl\\:sticky {\n    position: sticky;\n  }\n\n  .xl\\:inset-0 {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n  }\n\n  .xl\\:inset-auto {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n  }\n\n  .xl\\:inset-y-0 {\n    top: 0;\n    bottom: 0;\n  }\n\n  .xl\\:inset-x-0 {\n    right: 0;\n    left: 0;\n  }\n\n  .xl\\:inset-y-auto {\n    top: auto;\n    bottom: auto;\n  }\n\n  .xl\\:inset-x-auto {\n    right: auto;\n    left: auto;\n  }\n\n  .xl\\:top-0 {\n    top: 0;\n  }\n\n  .xl\\:right-0 {\n    right: 0;\n  }\n\n  .xl\\:bottom-0 {\n    bottom: 0;\n  }\n\n  .xl\\:left-0 {\n    left: 0;\n  }\n\n  .xl\\:top-auto {\n    top: auto;\n  }\n\n  .xl\\:right-auto {\n    right: auto;\n  }\n\n  .xl\\:bottom-auto {\n    bottom: auto;\n  }\n\n  .xl\\:left-auto {\n    left: auto;\n  }\n\n  .xl\\:resize-none {\n    resize: none;\n  }\n\n  .xl\\:resize-y {\n    resize: vertical;\n  }\n\n  .xl\\:resize-x {\n    resize: horizontal;\n  }\n\n  .xl\\:resize {\n    resize: both;\n  }\n\n  .xl\\:shadow-xs {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:shadow-sm {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:shadow {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:shadow-md {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:shadow-lg {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:shadow-xl {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .xl\\:shadow-2xl {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .xl\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:shadow-outline {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .xl\\:shadow-none {\n    box-shadow: none;\n  }\n\n  .xl\\:hover\\:shadow-xs:hover {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:hover\\:shadow-sm:hover {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:hover\\:shadow:hover {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:hover\\:shadow-md:hover {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:hover\\:shadow-lg:hover {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:hover\\:shadow-xl:hover {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .xl\\:hover\\:shadow-2xl:hover {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .xl\\:hover\\:shadow-inner:hover {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:hover\\:shadow-outline:hover {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .xl\\:hover\\:shadow-none:hover {\n    box-shadow: none;\n  }\n\n  .xl\\:focus\\:shadow-xs:focus {\n    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:focus\\:shadow-sm:focus {\n    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:focus\\:shadow:focus {\n    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:focus\\:shadow-md:focus {\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:focus\\:shadow-lg:focus {\n    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  }\n\n  .xl\\:focus\\:shadow-xl:focus {\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  }\n\n  .xl\\:focus\\:shadow-2xl:focus {\n    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  }\n\n  .xl\\:focus\\:shadow-inner:focus {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.06);\n  }\n\n  .xl\\:focus\\:shadow-outline:focus {\n    box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);\n  }\n\n  .xl\\:focus\\:shadow-none:focus {\n    box-shadow: none;\n  }\n\n  .xl\\:fill-current {\n    fill: currentColor;\n  }\n\n  .xl\\:stroke-current {\n    stroke: currentColor;\n  }\n\n  .xl\\:stroke-0 {\n    stroke-width: 0;\n  }\n\n  .xl\\:stroke-1 {\n    stroke-width: 1;\n  }\n\n  .xl\\:stroke-2 {\n    stroke-width: 2;\n  }\n\n  .xl\\:table-auto {\n    table-layout: auto;\n  }\n\n  .xl\\:table-fixed {\n    table-layout: fixed;\n  }\n\n  .xl\\:text-left {\n    text-align: left;\n  }\n\n  .xl\\:text-center {\n    text-align: center;\n  }\n\n  .xl\\:text-right {\n    text-align: right;\n  }\n\n  .xl\\:text-justify {\n    text-align: justify;\n  }\n\n  .xl\\:text-blue {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .xl\\:text-primaryText {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .xl\\:text-red {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .xl\\:hover\\:text-blue:hover {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .xl\\:hover\\:text-primaryText:hover {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .xl\\:hover\\:text-red:hover {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .xl\\:focus\\:text-blue:focus {\n    --text-opacity: 1;\n    color: #2C7FFF;\n    color: rgba(44, 127, 255, var(--text-opacity));\n  }\n\n  .xl\\:focus\\:text-primaryText:focus {\n    --text-opacity: 1;\n    color: #0E264B;\n    color: rgba(14, 38, 75, var(--text-opacity));\n  }\n\n  .xl\\:focus\\:text-red:focus {\n    --text-opacity: 1;\n    color: #FF2759;\n    color: rgba(255, 39, 89, var(--text-opacity));\n  }\n\n  .xl\\:text-opacity-0 {\n    --text-opacity: 0;\n  }\n\n  .xl\\:text-opacity-25 {\n    --text-opacity: 0.25;\n  }\n\n  .xl\\:text-opacity-50 {\n    --text-opacity: 0.5;\n  }\n\n  .xl\\:text-opacity-75 {\n    --text-opacity: 0.75;\n  }\n\n  .xl\\:text-opacity-100 {\n    --text-opacity: 1;\n  }\n\n  .xl\\:hover\\:text-opacity-0:hover {\n    --text-opacity: 0;\n  }\n\n  .xl\\:hover\\:text-opacity-25:hover {\n    --text-opacity: 0.25;\n  }\n\n  .xl\\:hover\\:text-opacity-50:hover {\n    --text-opacity: 0.5;\n  }\n\n  .xl\\:hover\\:text-opacity-75:hover {\n    --text-opacity: 0.75;\n  }\n\n  .xl\\:hover\\:text-opacity-100:hover {\n    --text-opacity: 1;\n  }\n\n  .xl\\:focus\\:text-opacity-0:focus {\n    --text-opacity: 0;\n  }\n\n  .xl\\:focus\\:text-opacity-25:focus {\n    --text-opacity: 0.25;\n  }\n\n  .xl\\:focus\\:text-opacity-50:focus {\n    --text-opacity: 0.5;\n  }\n\n  .xl\\:focus\\:text-opacity-75:focus {\n    --text-opacity: 0.75;\n  }\n\n  .xl\\:focus\\:text-opacity-100:focus {\n    --text-opacity: 1;\n  }\n\n  .xl\\:italic {\n    font-style: italic;\n  }\n\n  .xl\\:not-italic {\n    font-style: normal;\n  }\n\n  .xl\\:uppercase {\n    text-transform: uppercase;\n  }\n\n  .xl\\:lowercase {\n    text-transform: lowercase;\n  }\n\n  .xl\\:capitalize {\n    text-transform: capitalize;\n  }\n\n  .xl\\:normal-case {\n    text-transform: none;\n  }\n\n  .xl\\:underline {\n    text-decoration: underline;\n  }\n\n  .xl\\:line-through {\n    text-decoration: line-through;\n  }\n\n  .xl\\:no-underline {\n    text-decoration: none;\n  }\n\n  .xl\\:hover\\:underline:hover {\n    text-decoration: underline;\n  }\n\n  .xl\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n  }\n\n  .xl\\:hover\\:no-underline:hover {\n    text-decoration: none;\n  }\n\n  .xl\\:focus\\:underline:focus {\n    text-decoration: underline;\n  }\n\n  .xl\\:focus\\:line-through:focus {\n    text-decoration: line-through;\n  }\n\n  .xl\\:focus\\:no-underline:focus {\n    text-decoration: none;\n  }\n\n  .xl\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  .xl\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n  }\n\n  .xl\\:ordinal, .xl\\:slashed-zero, .xl\\:lining-nums, .xl\\:oldstyle-nums, .xl\\:proportional-nums, .xl\\:tabular-nums, .xl\\:diagonal-fractions, .xl\\:stacked-fractions {\n    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);\n    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);\n    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);\n  }\n\n  .xl\\:normal-nums {\n    font-variant-numeric: normal;\n  }\n\n  .xl\\:ordinal {\n    --font-variant-numeric-ordinal: ordinal;\n  }\n\n  .xl\\:slashed-zero {\n    --font-variant-numeric-slashed-zero: slashed-zero;\n  }\n\n  .xl\\:lining-nums {\n    --font-variant-numeric-figure: lining-nums;\n  }\n\n  .xl\\:oldstyle-nums {\n    --font-variant-numeric-figure: oldstyle-nums;\n  }\n\n  .xl\\:proportional-nums {\n    --font-variant-numeric-spacing: proportional-nums;\n  }\n\n  .xl\\:tabular-nums {\n    --font-variant-numeric-spacing: tabular-nums;\n  }\n\n  .xl\\:diagonal-fractions {\n    --font-variant-numeric-fraction: diagonal-fractions;\n  }\n\n  .xl\\:stacked-fractions {\n    --font-variant-numeric-fraction: stacked-fractions;\n  }\n\n  .xl\\:tracking-tighter {\n    letter-spacing: -0.05em;\n  }\n\n  .xl\\:tracking-tight {\n    letter-spacing: -0.025em;\n  }\n\n  .xl\\:tracking-normal {\n    letter-spacing: 0;\n  }\n\n  .xl\\:tracking-wide {\n    letter-spacing: 0.025em;\n  }\n\n  .xl\\:tracking-wider {\n    letter-spacing: 0.05em;\n  }\n\n  .xl\\:tracking-widest {\n    letter-spacing: 0.1em;\n  }\n\n  .xl\\:select-none {\n    -webkit-user-select: none;\n            user-select: none;\n  }\n\n  .xl\\:select-text {\n    -webkit-user-select: text;\n            user-select: text;\n  }\n\n  .xl\\:select-all {\n    -webkit-user-select: all;\n            user-select: all;\n  }\n\n  .xl\\:select-auto {\n    -webkit-user-select: auto;\n            user-select: auto;\n  }\n\n  .xl\\:align-baseline {\n    vertical-align: baseline;\n  }\n\n  .xl\\:align-top {\n    vertical-align: top;\n  }\n\n  .xl\\:align-middle {\n    vertical-align: middle;\n  }\n\n  .xl\\:align-bottom {\n    vertical-align: bottom;\n  }\n\n  .xl\\:align-text-top {\n    vertical-align: text-top;\n  }\n\n  .xl\\:align-text-bottom {\n    vertical-align: text-bottom;\n  }\n\n  .xl\\:visible {\n    visibility: visible;\n  }\n\n  .xl\\:invisible {\n    visibility: hidden;\n  }\n\n  .xl\\:whitespace-normal {\n    white-space: normal;\n  }\n\n  .xl\\:whitespace-no-wrap {\n    white-space: nowrap;\n  }\n\n  .xl\\:whitespace-pre {\n    white-space: pre;\n  }\n\n  .xl\\:whitespace-pre-line {\n    white-space: pre-line;\n  }\n\n  .xl\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n  }\n\n  .xl\\:break-normal {\n    word-wrap: normal;\n    overflow-wrap: normal;\n    word-break: normal;\n  }\n\n  .xl\\:break-words {\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n  }\n\n  .xl\\:break-all {\n    word-break: break-all;\n  }\n\n  .xl\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .xl\\:w-0 {\n    width: 0;\n  }\n\n  .xl\\:w-1 {\n    width: 0.25rem;\n  }\n\n  .xl\\:w-2 {\n    width: 0.5rem;\n  }\n\n  .xl\\:w-3 {\n    width: 0.75rem;\n  }\n\n  .xl\\:w-4 {\n    width: 1rem;\n  }\n\n  .xl\\:w-5 {\n    width: 1.25rem;\n  }\n\n  .xl\\:w-6 {\n    width: 1.5rem;\n  }\n\n  .xl\\:w-8 {\n    width: 2rem;\n  }\n\n  .xl\\:w-10 {\n    width: 2.5rem;\n  }\n\n  .xl\\:w-12 {\n    width: 3rem;\n  }\n\n  .xl\\:w-16 {\n    width: 4rem;\n  }\n\n  .xl\\:w-20 {\n    width: 5rem;\n  }\n\n  .xl\\:w-24 {\n    width: 6rem;\n  }\n\n  .xl\\:w-32 {\n    width: 8rem;\n  }\n\n  .xl\\:w-40 {\n    width: 10rem;\n  }\n\n  .xl\\:w-48 {\n    width: 12rem;\n  }\n\n  .xl\\:w-56 {\n    width: 14rem;\n  }\n\n  .xl\\:w-64 {\n    width: 16rem;\n  }\n\n  .xl\\:w-auto {\n    width: auto;\n  }\n\n  .xl\\:w-px {\n    width: 1px;\n  }\n\n  .xl\\:w-1\\/2 {\n    width: 50%;\n  }\n\n  .xl\\:w-1\\/3 {\n    width: 33.333333%;\n  }\n\n  .xl\\:w-2\\/3 {\n    width: 66.666667%;\n  }\n\n  .xl\\:w-1\\/4 {\n    width: 25%;\n  }\n\n  .xl\\:w-2\\/4 {\n    width: 50%;\n  }\n\n  .xl\\:w-3\\/4 {\n    width: 75%;\n  }\n\n  .xl\\:w-1\\/5 {\n    width: 20%;\n  }\n\n  .xl\\:w-2\\/5 {\n    width: 40%;\n  }\n\n  .xl\\:w-3\\/5 {\n    width: 60%;\n  }\n\n  .xl\\:w-4\\/5 {\n    width: 80%;\n  }\n\n  .xl\\:w-1\\/6 {\n    width: 16.666667%;\n  }\n\n  .xl\\:w-2\\/6 {\n    width: 33.333333%;\n  }\n\n  .xl\\:w-3\\/6 {\n    width: 50%;\n  }\n\n  .xl\\:w-4\\/6 {\n    width: 66.666667%;\n  }\n\n  .xl\\:w-5\\/6 {\n    width: 83.333333%;\n  }\n\n  .xl\\:w-1\\/12 {\n    width: 8.333333%;\n  }\n\n  .xl\\:w-2\\/12 {\n    width: 16.666667%;\n  }\n\n  .xl\\:w-3\\/12 {\n    width: 25%;\n  }\n\n  .xl\\:w-4\\/12 {\n    width: 33.333333%;\n  }\n\n  .xl\\:w-5\\/12 {\n    width: 41.666667%;\n  }\n\n  .xl\\:w-6\\/12 {\n    width: 50%;\n  }\n\n  .xl\\:w-7\\/12 {\n    width: 58.333333%;\n  }\n\n  .xl\\:w-8\\/12 {\n    width: 66.666667%;\n  }\n\n  .xl\\:w-9\\/12 {\n    width: 75%;\n  }\n\n  .xl\\:w-10\\/12 {\n    width: 83.333333%;\n  }\n\n  .xl\\:w-11\\/12 {\n    width: 91.666667%;\n  }\n\n  .xl\\:w-full {\n    width: 100%;\n  }\n\n  .xl\\:w-screen {\n    width: 100vw;\n  }\n\n  .xl\\:z-0 {\n    z-index: 0;\n  }\n\n  .xl\\:z-10 {\n    z-index: 10;\n  }\n\n  .xl\\:z-20 {\n    z-index: 20;\n  }\n\n  .xl\\:z-30 {\n    z-index: 30;\n  }\n\n  .xl\\:z-40 {\n    z-index: 40;\n  }\n\n  .xl\\:z-50 {\n    z-index: 50;\n  }\n\n  .xl\\:z-auto {\n    z-index: auto;\n  }\n\n  .xl\\:gap-0 {\n    grid-gap: 0;\n    gap: 0;\n  }\n\n  .xl\\:gap-1 {\n    grid-gap: 0.25rem;\n    gap: 0.25rem;\n  }\n\n  .xl\\:gap-2 {\n    grid-gap: 0.5rem;\n    gap: 0.5rem;\n  }\n\n  .xl\\:gap-3 {\n    grid-gap: 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .xl\\:gap-4 {\n    grid-gap: 1rem;\n    gap: 1rem;\n  }\n\n  .xl\\:gap-5 {\n    grid-gap: 1.25rem;\n    gap: 1.25rem;\n  }\n\n  .xl\\:gap-6 {\n    grid-gap: 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .xl\\:gap-8 {\n    grid-gap: 2rem;\n    gap: 2rem;\n  }\n\n  .xl\\:gap-10 {\n    grid-gap: 2.5rem;\n    gap: 2.5rem;\n  }\n\n  .xl\\:gap-12 {\n    grid-gap: 3rem;\n    gap: 3rem;\n  }\n\n  .xl\\:gap-16 {\n    grid-gap: 4rem;\n    gap: 4rem;\n  }\n\n  .xl\\:gap-20 {\n    grid-gap: 5rem;\n    gap: 5rem;\n  }\n\n  .xl\\:gap-24 {\n    grid-gap: 6rem;\n    gap: 6rem;\n  }\n\n  .xl\\:gap-32 {\n    grid-gap: 8rem;\n    gap: 8rem;\n  }\n\n  .xl\\:gap-40 {\n    grid-gap: 10rem;\n    gap: 10rem;\n  }\n\n  .xl\\:gap-48 {\n    grid-gap: 12rem;\n    gap: 12rem;\n  }\n\n  .xl\\:gap-56 {\n    grid-gap: 14rem;\n    gap: 14rem;\n  }\n\n  .xl\\:gap-64 {\n    grid-gap: 16rem;\n    gap: 16rem;\n  }\n\n  .xl\\:gap-px {\n    grid-gap: 1px;\n    gap: 1px;\n  }\n\n  .xl\\:col-gap-0 {\n    grid-column-gap: 0;\n    column-gap: 0;\n  }\n\n  .xl\\:col-gap-1 {\n    grid-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n\n  .xl\\:col-gap-2 {\n    grid-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n\n  .xl\\:col-gap-3 {\n    grid-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n\n  .xl\\:col-gap-4 {\n    grid-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n\n  .xl\\:col-gap-5 {\n    grid-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n\n  .xl\\:col-gap-6 {\n    grid-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n\n  .xl\\:col-gap-8 {\n    grid-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n\n  .xl\\:col-gap-10 {\n    grid-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n\n  .xl\\:col-gap-12 {\n    grid-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n\n  .xl\\:col-gap-16 {\n    grid-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n\n  .xl\\:col-gap-20 {\n    grid-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n\n  .xl\\:col-gap-24 {\n    grid-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n\n  .xl\\:col-gap-32 {\n    grid-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n\n  .xl\\:col-gap-40 {\n    grid-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n\n  .xl\\:col-gap-48 {\n    grid-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n\n  .xl\\:col-gap-56 {\n    grid-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n\n  .xl\\:col-gap-64 {\n    grid-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n\n  .xl\\:col-gap-px {\n    grid-column-gap: 1px;\n    column-gap: 1px;\n  }\n\n  .xl\\:gap-x-0 {\n    grid-column-gap: 0;\n    column-gap: 0;\n  }\n\n  .xl\\:gap-x-1 {\n    grid-column-gap: 0.25rem;\n    column-gap: 0.25rem;\n  }\n\n  .xl\\:gap-x-2 {\n    grid-column-gap: 0.5rem;\n    column-gap: 0.5rem;\n  }\n\n  .xl\\:gap-x-3 {\n    grid-column-gap: 0.75rem;\n    column-gap: 0.75rem;\n  }\n\n  .xl\\:gap-x-4 {\n    grid-column-gap: 1rem;\n    column-gap: 1rem;\n  }\n\n  .xl\\:gap-x-5 {\n    grid-column-gap: 1.25rem;\n    column-gap: 1.25rem;\n  }\n\n  .xl\\:gap-x-6 {\n    grid-column-gap: 1.5rem;\n    column-gap: 1.5rem;\n  }\n\n  .xl\\:gap-x-8 {\n    grid-column-gap: 2rem;\n    column-gap: 2rem;\n  }\n\n  .xl\\:gap-x-10 {\n    grid-column-gap: 2.5rem;\n    column-gap: 2.5rem;\n  }\n\n  .xl\\:gap-x-12 {\n    grid-column-gap: 3rem;\n    column-gap: 3rem;\n  }\n\n  .xl\\:gap-x-16 {\n    grid-column-gap: 4rem;\n    column-gap: 4rem;\n  }\n\n  .xl\\:gap-x-20 {\n    grid-column-gap: 5rem;\n    column-gap: 5rem;\n  }\n\n  .xl\\:gap-x-24 {\n    grid-column-gap: 6rem;\n    column-gap: 6rem;\n  }\n\n  .xl\\:gap-x-32 {\n    grid-column-gap: 8rem;\n    column-gap: 8rem;\n  }\n\n  .xl\\:gap-x-40 {\n    grid-column-gap: 10rem;\n    column-gap: 10rem;\n  }\n\n  .xl\\:gap-x-48 {\n    grid-column-gap: 12rem;\n    column-gap: 12rem;\n  }\n\n  .xl\\:gap-x-56 {\n    grid-column-gap: 14rem;\n    column-gap: 14rem;\n  }\n\n  .xl\\:gap-x-64 {\n    grid-column-gap: 16rem;\n    column-gap: 16rem;\n  }\n\n  .xl\\:gap-x-px {\n    grid-column-gap: 1px;\n    column-gap: 1px;\n  }\n\n  .xl\\:row-gap-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n\n  .xl\\:row-gap-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n\n  .xl\\:row-gap-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n\n  .xl\\:row-gap-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n\n  .xl\\:row-gap-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n\n  .xl\\:row-gap-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n\n  .xl\\:row-gap-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n\n  .xl\\:row-gap-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n\n  .xl\\:row-gap-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n\n  .xl\\:row-gap-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n\n  .xl\\:row-gap-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n\n  .xl\\:row-gap-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n\n  .xl\\:row-gap-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n\n  .xl\\:row-gap-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n\n  .xl\\:row-gap-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n\n  .xl\\:row-gap-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n\n  .xl\\:row-gap-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n\n  .xl\\:row-gap-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n\n  .xl\\:row-gap-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n\n  .xl\\:gap-y-0 {\n    grid-row-gap: 0;\n    row-gap: 0;\n  }\n\n  .xl\\:gap-y-1 {\n    grid-row-gap: 0.25rem;\n    row-gap: 0.25rem;\n  }\n\n  .xl\\:gap-y-2 {\n    grid-row-gap: 0.5rem;\n    row-gap: 0.5rem;\n  }\n\n  .xl\\:gap-y-3 {\n    grid-row-gap: 0.75rem;\n    row-gap: 0.75rem;\n  }\n\n  .xl\\:gap-y-4 {\n    grid-row-gap: 1rem;\n    row-gap: 1rem;\n  }\n\n  .xl\\:gap-y-5 {\n    grid-row-gap: 1.25rem;\n    row-gap: 1.25rem;\n  }\n\n  .xl\\:gap-y-6 {\n    grid-row-gap: 1.5rem;\n    row-gap: 1.5rem;\n  }\n\n  .xl\\:gap-y-8 {\n    grid-row-gap: 2rem;\n    row-gap: 2rem;\n  }\n\n  .xl\\:gap-y-10 {\n    grid-row-gap: 2.5rem;\n    row-gap: 2.5rem;\n  }\n\n  .xl\\:gap-y-12 {\n    grid-row-gap: 3rem;\n    row-gap: 3rem;\n  }\n\n  .xl\\:gap-y-16 {\n    grid-row-gap: 4rem;\n    row-gap: 4rem;\n  }\n\n  .xl\\:gap-y-20 {\n    grid-row-gap: 5rem;\n    row-gap: 5rem;\n  }\n\n  .xl\\:gap-y-24 {\n    grid-row-gap: 6rem;\n    row-gap: 6rem;\n  }\n\n  .xl\\:gap-y-32 {\n    grid-row-gap: 8rem;\n    row-gap: 8rem;\n  }\n\n  .xl\\:gap-y-40 {\n    grid-row-gap: 10rem;\n    row-gap: 10rem;\n  }\n\n  .xl\\:gap-y-48 {\n    grid-row-gap: 12rem;\n    row-gap: 12rem;\n  }\n\n  .xl\\:gap-y-56 {\n    grid-row-gap: 14rem;\n    row-gap: 14rem;\n  }\n\n  .xl\\:gap-y-64 {\n    grid-row-gap: 16rem;\n    row-gap: 16rem;\n  }\n\n  .xl\\:gap-y-px {\n    grid-row-gap: 1px;\n    row-gap: 1px;\n  }\n\n  .xl\\:grid-flow-row {\n    grid-auto-flow: row;\n  }\n\n  .xl\\:grid-flow-col {\n    grid-auto-flow: column;\n  }\n\n  .xl\\:grid-flow-row-dense {\n    grid-auto-flow: row dense;\n  }\n\n  .xl\\:grid-flow-col-dense {\n    grid-auto-flow: column dense;\n  }\n\n  .xl\\:grid-cols-1 {\n    grid-template-columns: repeat(1, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-2 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-3 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-4 {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-5 {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-6 {\n    grid-template-columns: repeat(6, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-7 {\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-8 {\n    grid-template-columns: repeat(8, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-9 {\n    grid-template-columns: repeat(9, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-10 {\n    grid-template-columns: repeat(10, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-11 {\n    grid-template-columns: repeat(11, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-12 {\n    grid-template-columns: repeat(12, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-cols-none {\n    grid-template-columns: none;\n  }\n\n  .xl\\:auto-cols-auto {\n    grid-auto-columns: auto;\n  }\n\n  .xl\\:auto-cols-min {\n    grid-auto-columns: min-content;\n  }\n\n  .xl\\:auto-cols-max {\n    grid-auto-columns: max-content;\n  }\n\n  .xl\\:auto-cols-fr {\n    grid-auto-columns: minmax(0, 1fr);\n  }\n\n  .xl\\:col-auto {\n    grid-column: auto;\n  }\n\n  .xl\\:col-span-1 {\n    grid-column: span 1 / span 1;\n  }\n\n  .xl\\:col-span-2 {\n    grid-column: span 2 / span 2;\n  }\n\n  .xl\\:col-span-3 {\n    grid-column: span 3 / span 3;\n  }\n\n  .xl\\:col-span-4 {\n    grid-column: span 4 / span 4;\n  }\n\n  .xl\\:col-span-5 {\n    grid-column: span 5 / span 5;\n  }\n\n  .xl\\:col-span-6 {\n    grid-column: span 6 / span 6;\n  }\n\n  .xl\\:col-span-7 {\n    grid-column: span 7 / span 7;\n  }\n\n  .xl\\:col-span-8 {\n    grid-column: span 8 / span 8;\n  }\n\n  .xl\\:col-span-9 {\n    grid-column: span 9 / span 9;\n  }\n\n  .xl\\:col-span-10 {\n    grid-column: span 10 / span 10;\n  }\n\n  .xl\\:col-span-11 {\n    grid-column: span 11 / span 11;\n  }\n\n  .xl\\:col-span-12 {\n    grid-column: span 12 / span 12;\n  }\n\n  .xl\\:col-span-full {\n    grid-column: 1 / -1;\n  }\n\n  .xl\\:col-start-1 {\n    grid-column-start: 1;\n  }\n\n  .xl\\:col-start-2 {\n    grid-column-start: 2;\n  }\n\n  .xl\\:col-start-3 {\n    grid-column-start: 3;\n  }\n\n  .xl\\:col-start-4 {\n    grid-column-start: 4;\n  }\n\n  .xl\\:col-start-5 {\n    grid-column-start: 5;\n  }\n\n  .xl\\:col-start-6 {\n    grid-column-start: 6;\n  }\n\n  .xl\\:col-start-7 {\n    grid-column-start: 7;\n  }\n\n  .xl\\:col-start-8 {\n    grid-column-start: 8;\n  }\n\n  .xl\\:col-start-9 {\n    grid-column-start: 9;\n  }\n\n  .xl\\:col-start-10 {\n    grid-column-start: 10;\n  }\n\n  .xl\\:col-start-11 {\n    grid-column-start: 11;\n  }\n\n  .xl\\:col-start-12 {\n    grid-column-start: 12;\n  }\n\n  .xl\\:col-start-13 {\n    grid-column-start: 13;\n  }\n\n  .xl\\:col-start-auto {\n    grid-column-start: auto;\n  }\n\n  .xl\\:col-end-1 {\n    grid-column-end: 1;\n  }\n\n  .xl\\:col-end-2 {\n    grid-column-end: 2;\n  }\n\n  .xl\\:col-end-3 {\n    grid-column-end: 3;\n  }\n\n  .xl\\:col-end-4 {\n    grid-column-end: 4;\n  }\n\n  .xl\\:col-end-5 {\n    grid-column-end: 5;\n  }\n\n  .xl\\:col-end-6 {\n    grid-column-end: 6;\n  }\n\n  .xl\\:col-end-7 {\n    grid-column-end: 7;\n  }\n\n  .xl\\:col-end-8 {\n    grid-column-end: 8;\n  }\n\n  .xl\\:col-end-9 {\n    grid-column-end: 9;\n  }\n\n  .xl\\:col-end-10 {\n    grid-column-end: 10;\n  }\n\n  .xl\\:col-end-11 {\n    grid-column-end: 11;\n  }\n\n  .xl\\:col-end-12 {\n    grid-column-end: 12;\n  }\n\n  .xl\\:col-end-13 {\n    grid-column-end: 13;\n  }\n\n  .xl\\:col-end-auto {\n    grid-column-end: auto;\n  }\n\n  .xl\\:grid-rows-1 {\n    grid-template-rows: repeat(1, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-rows-2 {\n    grid-template-rows: repeat(2, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-rows-3 {\n    grid-template-rows: repeat(3, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-rows-4 {\n    grid-template-rows: repeat(4, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-rows-5 {\n    grid-template-rows: repeat(5, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-rows-6 {\n    grid-template-rows: repeat(6, minmax(0, 1fr));\n  }\n\n  .xl\\:grid-rows-none {\n    grid-template-rows: none;\n  }\n\n  .xl\\:auto-rows-auto {\n    grid-auto-rows: auto;\n  }\n\n  .xl\\:auto-rows-min {\n    grid-auto-rows: min-content;\n  }\n\n  .xl\\:auto-rows-max {\n    grid-auto-rows: max-content;\n  }\n\n  .xl\\:auto-rows-fr {\n    grid-auto-rows: minmax(0, 1fr);\n  }\n\n  .xl\\:row-auto {\n    grid-row: auto;\n  }\n\n  .xl\\:row-span-1 {\n    grid-row: span 1 / span 1;\n  }\n\n  .xl\\:row-span-2 {\n    grid-row: span 2 / span 2;\n  }\n\n  .xl\\:row-span-3 {\n    grid-row: span 3 / span 3;\n  }\n\n  .xl\\:row-span-4 {\n    grid-row: span 4 / span 4;\n  }\n\n  .xl\\:row-span-5 {\n    grid-row: span 5 / span 5;\n  }\n\n  .xl\\:row-span-6 {\n    grid-row: span 6 / span 6;\n  }\n\n  .xl\\:row-span-full {\n    grid-row: 1 / -1;\n  }\n\n  .xl\\:row-start-1 {\n    grid-row-start: 1;\n  }\n\n  .xl\\:row-start-2 {\n    grid-row-start: 2;\n  }\n\n  .xl\\:row-start-3 {\n    grid-row-start: 3;\n  }\n\n  .xl\\:row-start-4 {\n    grid-row-start: 4;\n  }\n\n  .xl\\:row-start-5 {\n    grid-row-start: 5;\n  }\n\n  .xl\\:row-start-6 {\n    grid-row-start: 6;\n  }\n\n  .xl\\:row-start-7 {\n    grid-row-start: 7;\n  }\n\n  .xl\\:row-start-auto {\n    grid-row-start: auto;\n  }\n\n  .xl\\:row-end-1 {\n    grid-row-end: 1;\n  }\n\n  .xl\\:row-end-2 {\n    grid-row-end: 2;\n  }\n\n  .xl\\:row-end-3 {\n    grid-row-end: 3;\n  }\n\n  .xl\\:row-end-4 {\n    grid-row-end: 4;\n  }\n\n  .xl\\:row-end-5 {\n    grid-row-end: 5;\n  }\n\n  .xl\\:row-end-6 {\n    grid-row-end: 6;\n  }\n\n  .xl\\:row-end-7 {\n    grid-row-end: 7;\n  }\n\n  .xl\\:row-end-auto {\n    grid-row-end: auto;\n  }\n\n  .xl\\:transform {\n    --transform-translate-x: 0;\n    --transform-translate-y: 0;\n    --transform-rotate: 0;\n    --transform-skew-x: 0;\n    --transform-skew-y: 0;\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));\n  }\n\n  .xl\\:transform-none {\n    transform: none;\n  }\n\n  .xl\\:origin-center {\n    transform-origin: center;\n  }\n\n  .xl\\:origin-top {\n    transform-origin: top;\n  }\n\n  .xl\\:origin-top-right {\n    transform-origin: top right;\n  }\n\n  .xl\\:origin-right {\n    transform-origin: right;\n  }\n\n  .xl\\:origin-bottom-right {\n    transform-origin: bottom right;\n  }\n\n  .xl\\:origin-bottom {\n    transform-origin: bottom;\n  }\n\n  .xl\\:origin-bottom-left {\n    transform-origin: bottom left;\n  }\n\n  .xl\\:origin-left {\n    transform-origin: left;\n  }\n\n  .xl\\:origin-top-left {\n    transform-origin: top left;\n  }\n\n  .xl\\:scale-0 {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .xl\\:scale-50 {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .xl\\:scale-75 {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .xl\\:scale-90 {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .xl\\:scale-95 {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .xl\\:scale-100 {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .xl\\:scale-105 {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .xl\\:scale-110 {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .xl\\:scale-125 {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .xl\\:scale-150 {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .xl\\:scale-x-0 {\n    --transform-scale-x: 0;\n  }\n\n  .xl\\:scale-x-50 {\n    --transform-scale-x: .5;\n  }\n\n  .xl\\:scale-x-75 {\n    --transform-scale-x: .75;\n  }\n\n  .xl\\:scale-x-90 {\n    --transform-scale-x: .9;\n  }\n\n  .xl\\:scale-x-95 {\n    --transform-scale-x: .95;\n  }\n\n  .xl\\:scale-x-100 {\n    --transform-scale-x: 1;\n  }\n\n  .xl\\:scale-x-105 {\n    --transform-scale-x: 1.05;\n  }\n\n  .xl\\:scale-x-110 {\n    --transform-scale-x: 1.1;\n  }\n\n  .xl\\:scale-x-125 {\n    --transform-scale-x: 1.25;\n  }\n\n  .xl\\:scale-x-150 {\n    --transform-scale-x: 1.5;\n  }\n\n  .xl\\:scale-y-0 {\n    --transform-scale-y: 0;\n  }\n\n  .xl\\:scale-y-50 {\n    --transform-scale-y: .5;\n  }\n\n  .xl\\:scale-y-75 {\n    --transform-scale-y: .75;\n  }\n\n  .xl\\:scale-y-90 {\n    --transform-scale-y: .9;\n  }\n\n  .xl\\:scale-y-95 {\n    --transform-scale-y: .95;\n  }\n\n  .xl\\:scale-y-100 {\n    --transform-scale-y: 1;\n  }\n\n  .xl\\:scale-y-105 {\n    --transform-scale-y: 1.05;\n  }\n\n  .xl\\:scale-y-110 {\n    --transform-scale-y: 1.1;\n  }\n\n  .xl\\:scale-y-125 {\n    --transform-scale-y: 1.25;\n  }\n\n  .xl\\:scale-y-150 {\n    --transform-scale-y: 1.5;\n  }\n\n  .xl\\:hover\\:scale-0:hover {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .xl\\:hover\\:scale-50:hover {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .xl\\:hover\\:scale-75:hover {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .xl\\:hover\\:scale-90:hover {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .xl\\:hover\\:scale-95:hover {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .xl\\:hover\\:scale-100:hover {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .xl\\:hover\\:scale-105:hover {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .xl\\:hover\\:scale-110:hover {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .xl\\:hover\\:scale-125:hover {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .xl\\:hover\\:scale-150:hover {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .xl\\:hover\\:scale-x-0:hover {\n    --transform-scale-x: 0;\n  }\n\n  .xl\\:hover\\:scale-x-50:hover {\n    --transform-scale-x: .5;\n  }\n\n  .xl\\:hover\\:scale-x-75:hover {\n    --transform-scale-x: .75;\n  }\n\n  .xl\\:hover\\:scale-x-90:hover {\n    --transform-scale-x: .9;\n  }\n\n  .xl\\:hover\\:scale-x-95:hover {\n    --transform-scale-x: .95;\n  }\n\n  .xl\\:hover\\:scale-x-100:hover {\n    --transform-scale-x: 1;\n  }\n\n  .xl\\:hover\\:scale-x-105:hover {\n    --transform-scale-x: 1.05;\n  }\n\n  .xl\\:hover\\:scale-x-110:hover {\n    --transform-scale-x: 1.1;\n  }\n\n  .xl\\:hover\\:scale-x-125:hover {\n    --transform-scale-x: 1.25;\n  }\n\n  .xl\\:hover\\:scale-x-150:hover {\n    --transform-scale-x: 1.5;\n  }\n\n  .xl\\:hover\\:scale-y-0:hover {\n    --transform-scale-y: 0;\n  }\n\n  .xl\\:hover\\:scale-y-50:hover {\n    --transform-scale-y: .5;\n  }\n\n  .xl\\:hover\\:scale-y-75:hover {\n    --transform-scale-y: .75;\n  }\n\n  .xl\\:hover\\:scale-y-90:hover {\n    --transform-scale-y: .9;\n  }\n\n  .xl\\:hover\\:scale-y-95:hover {\n    --transform-scale-y: .95;\n  }\n\n  .xl\\:hover\\:scale-y-100:hover {\n    --transform-scale-y: 1;\n  }\n\n  .xl\\:hover\\:scale-y-105:hover {\n    --transform-scale-y: 1.05;\n  }\n\n  .xl\\:hover\\:scale-y-110:hover {\n    --transform-scale-y: 1.1;\n  }\n\n  .xl\\:hover\\:scale-y-125:hover {\n    --transform-scale-y: 1.25;\n  }\n\n  .xl\\:hover\\:scale-y-150:hover {\n    --transform-scale-y: 1.5;\n  }\n\n  .xl\\:focus\\:scale-0:focus {\n    --transform-scale-x: 0;\n    --transform-scale-y: 0;\n  }\n\n  .xl\\:focus\\:scale-50:focus {\n    --transform-scale-x: .5;\n    --transform-scale-y: .5;\n  }\n\n  .xl\\:focus\\:scale-75:focus {\n    --transform-scale-x: .75;\n    --transform-scale-y: .75;\n  }\n\n  .xl\\:focus\\:scale-90:focus {\n    --transform-scale-x: .9;\n    --transform-scale-y: .9;\n  }\n\n  .xl\\:focus\\:scale-95:focus {\n    --transform-scale-x: .95;\n    --transform-scale-y: .95;\n  }\n\n  .xl\\:focus\\:scale-100:focus {\n    --transform-scale-x: 1;\n    --transform-scale-y: 1;\n  }\n\n  .xl\\:focus\\:scale-105:focus {\n    --transform-scale-x: 1.05;\n    --transform-scale-y: 1.05;\n  }\n\n  .xl\\:focus\\:scale-110:focus {\n    --transform-scale-x: 1.1;\n    --transform-scale-y: 1.1;\n  }\n\n  .xl\\:focus\\:scale-125:focus {\n    --transform-scale-x: 1.25;\n    --transform-scale-y: 1.25;\n  }\n\n  .xl\\:focus\\:scale-150:focus {\n    --transform-scale-x: 1.5;\n    --transform-scale-y: 1.5;\n  }\n\n  .xl\\:focus\\:scale-x-0:focus {\n    --transform-scale-x: 0;\n  }\n\n  .xl\\:focus\\:scale-x-50:focus {\n    --transform-scale-x: .5;\n  }\n\n  .xl\\:focus\\:scale-x-75:focus {\n    --transform-scale-x: .75;\n  }\n\n  .xl\\:focus\\:scale-x-90:focus {\n    --transform-scale-x: .9;\n  }\n\n  .xl\\:focus\\:scale-x-95:focus {\n    --transform-scale-x: .95;\n  }\n\n  .xl\\:focus\\:scale-x-100:focus {\n    --transform-scale-x: 1;\n  }\n\n  .xl\\:focus\\:scale-x-105:focus {\n    --transform-scale-x: 1.05;\n  }\n\n  .xl\\:focus\\:scale-x-110:focus {\n    --transform-scale-x: 1.1;\n  }\n\n  .xl\\:focus\\:scale-x-125:focus {\n    --transform-scale-x: 1.25;\n  }\n\n  .xl\\:focus\\:scale-x-150:focus {\n    --transform-scale-x: 1.5;\n  }\n\n  .xl\\:focus\\:scale-y-0:focus {\n    --transform-scale-y: 0;\n  }\n\n  .xl\\:focus\\:scale-y-50:focus {\n    --transform-scale-y: .5;\n  }\n\n  .xl\\:focus\\:scale-y-75:focus {\n    --transform-scale-y: .75;\n  }\n\n  .xl\\:focus\\:scale-y-90:focus {\n    --transform-scale-y: .9;\n  }\n\n  .xl\\:focus\\:scale-y-95:focus {\n    --transform-scale-y: .95;\n  }\n\n  .xl\\:focus\\:scale-y-100:focus {\n    --transform-scale-y: 1;\n  }\n\n  .xl\\:focus\\:scale-y-105:focus {\n    --transform-scale-y: 1.05;\n  }\n\n  .xl\\:focus\\:scale-y-110:focus {\n    --transform-scale-y: 1.1;\n  }\n\n  .xl\\:focus\\:scale-y-125:focus {\n    --transform-scale-y: 1.25;\n  }\n\n  .xl\\:focus\\:scale-y-150:focus {\n    --transform-scale-y: 1.5;\n  }\n\n  .xl\\:rotate-0 {\n    --transform-rotate: 0;\n  }\n\n  .xl\\:rotate-1 {\n    --transform-rotate: 1deg;\n  }\n\n  .xl\\:rotate-2 {\n    --transform-rotate: 2deg;\n  }\n\n  .xl\\:rotate-3 {\n    --transform-rotate: 3deg;\n  }\n\n  .xl\\:rotate-6 {\n    --transform-rotate: 6deg;\n  }\n\n  .xl\\:rotate-12 {\n    --transform-rotate: 12deg;\n  }\n\n  .xl\\:rotate-45 {\n    --transform-rotate: 45deg;\n  }\n\n  .xl\\:rotate-90 {\n    --transform-rotate: 90deg;\n  }\n\n  .xl\\:rotate-180 {\n    --transform-rotate: 180deg;\n  }\n\n  .xl\\:-rotate-180 {\n    --transform-rotate: -180deg;\n  }\n\n  .xl\\:-rotate-90 {\n    --transform-rotate: -90deg;\n  }\n\n  .xl\\:-rotate-45 {\n    --transform-rotate: -45deg;\n  }\n\n  .xl\\:-rotate-12 {\n    --transform-rotate: -12deg;\n  }\n\n  .xl\\:-rotate-6 {\n    --transform-rotate: -6deg;\n  }\n\n  .xl\\:-rotate-3 {\n    --transform-rotate: -3deg;\n  }\n\n  .xl\\:-rotate-2 {\n    --transform-rotate: -2deg;\n  }\n\n  .xl\\:-rotate-1 {\n    --transform-rotate: -1deg;\n  }\n\n  .xl\\:hover\\:rotate-0:hover {\n    --transform-rotate: 0;\n  }\n\n  .xl\\:hover\\:rotate-1:hover {\n    --transform-rotate: 1deg;\n  }\n\n  .xl\\:hover\\:rotate-2:hover {\n    --transform-rotate: 2deg;\n  }\n\n  .xl\\:hover\\:rotate-3:hover {\n    --transform-rotate: 3deg;\n  }\n\n  .xl\\:hover\\:rotate-6:hover {\n    --transform-rotate: 6deg;\n  }\n\n  .xl\\:hover\\:rotate-12:hover {\n    --transform-rotate: 12deg;\n  }\n\n  .xl\\:hover\\:rotate-45:hover {\n    --transform-rotate: 45deg;\n  }\n\n  .xl\\:hover\\:rotate-90:hover {\n    --transform-rotate: 90deg;\n  }\n\n  .xl\\:hover\\:rotate-180:hover {\n    --transform-rotate: 180deg;\n  }\n\n  .xl\\:hover\\:-rotate-180:hover {\n    --transform-rotate: -180deg;\n  }\n\n  .xl\\:hover\\:-rotate-90:hover {\n    --transform-rotate: -90deg;\n  }\n\n  .xl\\:hover\\:-rotate-45:hover {\n    --transform-rotate: -45deg;\n  }\n\n  .xl\\:hover\\:-rotate-12:hover {\n    --transform-rotate: -12deg;\n  }\n\n  .xl\\:hover\\:-rotate-6:hover {\n    --transform-rotate: -6deg;\n  }\n\n  .xl\\:hover\\:-rotate-3:hover {\n    --transform-rotate: -3deg;\n  }\n\n  .xl\\:hover\\:-rotate-2:hover {\n    --transform-rotate: -2deg;\n  }\n\n  .xl\\:hover\\:-rotate-1:hover {\n    --transform-rotate: -1deg;\n  }\n\n  .xl\\:focus\\:rotate-0:focus {\n    --transform-rotate: 0;\n  }\n\n  .xl\\:focus\\:rotate-1:focus {\n    --transform-rotate: 1deg;\n  }\n\n  .xl\\:focus\\:rotate-2:focus {\n    --transform-rotate: 2deg;\n  }\n\n  .xl\\:focus\\:rotate-3:focus {\n    --transform-rotate: 3deg;\n  }\n\n  .xl\\:focus\\:rotate-6:focus {\n    --transform-rotate: 6deg;\n  }\n\n  .xl\\:focus\\:rotate-12:focus {\n    --transform-rotate: 12deg;\n  }\n\n  .xl\\:focus\\:rotate-45:focus {\n    --transform-rotate: 45deg;\n  }\n\n  .xl\\:focus\\:rotate-90:focus {\n    --transform-rotate: 90deg;\n  }\n\n  .xl\\:focus\\:rotate-180:focus {\n    --transform-rotate: 180deg;\n  }\n\n  .xl\\:focus\\:-rotate-180:focus {\n    --transform-rotate: -180deg;\n  }\n\n  .xl\\:focus\\:-rotate-90:focus {\n    --transform-rotate: -90deg;\n  }\n\n  .xl\\:focus\\:-rotate-45:focus {\n    --transform-rotate: -45deg;\n  }\n\n  .xl\\:focus\\:-rotate-12:focus {\n    --transform-rotate: -12deg;\n  }\n\n  .xl\\:focus\\:-rotate-6:focus {\n    --transform-rotate: -6deg;\n  }\n\n  .xl\\:focus\\:-rotate-3:focus {\n    --transform-rotate: -3deg;\n  }\n\n  .xl\\:focus\\:-rotate-2:focus {\n    --transform-rotate: -2deg;\n  }\n\n  .xl\\:focus\\:-rotate-1:focus {\n    --transform-rotate: -1deg;\n  }\n\n  .xl\\:translate-x-0 {\n    --transform-translate-x: 0;\n  }\n\n  .xl\\:translate-x-1 {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .xl\\:translate-x-2 {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .xl\\:translate-x-3 {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .xl\\:translate-x-4 {\n    --transform-translate-x: 1rem;\n  }\n\n  .xl\\:translate-x-5 {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .xl\\:translate-x-6 {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .xl\\:translate-x-8 {\n    --transform-translate-x: 2rem;\n  }\n\n  .xl\\:translate-x-10 {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .xl\\:translate-x-12 {\n    --transform-translate-x: 3rem;\n  }\n\n  .xl\\:translate-x-16 {\n    --transform-translate-x: 4rem;\n  }\n\n  .xl\\:translate-x-20 {\n    --transform-translate-x: 5rem;\n  }\n\n  .xl\\:translate-x-24 {\n    --transform-translate-x: 6rem;\n  }\n\n  .xl\\:translate-x-32 {\n    --transform-translate-x: 8rem;\n  }\n\n  .xl\\:translate-x-40 {\n    --transform-translate-x: 10rem;\n  }\n\n  .xl\\:translate-x-48 {\n    --transform-translate-x: 12rem;\n  }\n\n  .xl\\:translate-x-56 {\n    --transform-translate-x: 14rem;\n  }\n\n  .xl\\:translate-x-64 {\n    --transform-translate-x: 16rem;\n  }\n\n  .xl\\:translate-x-px {\n    --transform-translate-x: 1px;\n  }\n\n  .xl\\:-translate-x-1 {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .xl\\:-translate-x-2 {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .xl\\:-translate-x-3 {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .xl\\:-translate-x-4 {\n    --transform-translate-x: -1rem;\n  }\n\n  .xl\\:-translate-x-5 {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .xl\\:-translate-x-6 {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .xl\\:-translate-x-8 {\n    --transform-translate-x: -2rem;\n  }\n\n  .xl\\:-translate-x-10 {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .xl\\:-translate-x-12 {\n    --transform-translate-x: -3rem;\n  }\n\n  .xl\\:-translate-x-16 {\n    --transform-translate-x: -4rem;\n  }\n\n  .xl\\:-translate-x-20 {\n    --transform-translate-x: -5rem;\n  }\n\n  .xl\\:-translate-x-24 {\n    --transform-translate-x: -6rem;\n  }\n\n  .xl\\:-translate-x-32 {\n    --transform-translate-x: -8rem;\n  }\n\n  .xl\\:-translate-x-40 {\n    --transform-translate-x: -10rem;\n  }\n\n  .xl\\:-translate-x-48 {\n    --transform-translate-x: -12rem;\n  }\n\n  .xl\\:-translate-x-56 {\n    --transform-translate-x: -14rem;\n  }\n\n  .xl\\:-translate-x-64 {\n    --transform-translate-x: -16rem;\n  }\n\n  .xl\\:-translate-x-px {\n    --transform-translate-x: -1px;\n  }\n\n  .xl\\:-translate-x-full {\n    --transform-translate-x: -100%;\n  }\n\n  .xl\\:-translate-x-1\\/2 {\n    --transform-translate-x: -50%;\n  }\n\n  .xl\\:translate-x-1\\/2 {\n    --transform-translate-x: 50%;\n  }\n\n  .xl\\:translate-x-full {\n    --transform-translate-x: 100%;\n  }\n\n  .xl\\:translate-y-0 {\n    --transform-translate-y: 0;\n  }\n\n  .xl\\:translate-y-1 {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .xl\\:translate-y-2 {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .xl\\:translate-y-3 {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .xl\\:translate-y-4 {\n    --transform-translate-y: 1rem;\n  }\n\n  .xl\\:translate-y-5 {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .xl\\:translate-y-6 {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .xl\\:translate-y-8 {\n    --transform-translate-y: 2rem;\n  }\n\n  .xl\\:translate-y-10 {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .xl\\:translate-y-12 {\n    --transform-translate-y: 3rem;\n  }\n\n  .xl\\:translate-y-16 {\n    --transform-translate-y: 4rem;\n  }\n\n  .xl\\:translate-y-20 {\n    --transform-translate-y: 5rem;\n  }\n\n  .xl\\:translate-y-24 {\n    --transform-translate-y: 6rem;\n  }\n\n  .xl\\:translate-y-32 {\n    --transform-translate-y: 8rem;\n  }\n\n  .xl\\:translate-y-40 {\n    --transform-translate-y: 10rem;\n  }\n\n  .xl\\:translate-y-48 {\n    --transform-translate-y: 12rem;\n  }\n\n  .xl\\:translate-y-56 {\n    --transform-translate-y: 14rem;\n  }\n\n  .xl\\:translate-y-64 {\n    --transform-translate-y: 16rem;\n  }\n\n  .xl\\:translate-y-px {\n    --transform-translate-y: 1px;\n  }\n\n  .xl\\:-translate-y-1 {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .xl\\:-translate-y-2 {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .xl\\:-translate-y-3 {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .xl\\:-translate-y-4 {\n    --transform-translate-y: -1rem;\n  }\n\n  .xl\\:-translate-y-5 {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .xl\\:-translate-y-6 {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .xl\\:-translate-y-8 {\n    --transform-translate-y: -2rem;\n  }\n\n  .xl\\:-translate-y-10 {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .xl\\:-translate-y-12 {\n    --transform-translate-y: -3rem;\n  }\n\n  .xl\\:-translate-y-16 {\n    --transform-translate-y: -4rem;\n  }\n\n  .xl\\:-translate-y-20 {\n    --transform-translate-y: -5rem;\n  }\n\n  .xl\\:-translate-y-24 {\n    --transform-translate-y: -6rem;\n  }\n\n  .xl\\:-translate-y-32 {\n    --transform-translate-y: -8rem;\n  }\n\n  .xl\\:-translate-y-40 {\n    --transform-translate-y: -10rem;\n  }\n\n  .xl\\:-translate-y-48 {\n    --transform-translate-y: -12rem;\n  }\n\n  .xl\\:-translate-y-56 {\n    --transform-translate-y: -14rem;\n  }\n\n  .xl\\:-translate-y-64 {\n    --transform-translate-y: -16rem;\n  }\n\n  .xl\\:-translate-y-px {\n    --transform-translate-y: -1px;\n  }\n\n  .xl\\:-translate-y-full {\n    --transform-translate-y: -100%;\n  }\n\n  .xl\\:-translate-y-1\\/2 {\n    --transform-translate-y: -50%;\n  }\n\n  .xl\\:translate-y-1\\/2 {\n    --transform-translate-y: 50%;\n  }\n\n  .xl\\:translate-y-full {\n    --transform-translate-y: 100%;\n  }\n\n  .xl\\:hover\\:translate-x-0:hover {\n    --transform-translate-x: 0;\n  }\n\n  .xl\\:hover\\:translate-x-1:hover {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .xl\\:hover\\:translate-x-2:hover {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .xl\\:hover\\:translate-x-3:hover {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .xl\\:hover\\:translate-x-4:hover {\n    --transform-translate-x: 1rem;\n  }\n\n  .xl\\:hover\\:translate-x-5:hover {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .xl\\:hover\\:translate-x-6:hover {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .xl\\:hover\\:translate-x-8:hover {\n    --transform-translate-x: 2rem;\n  }\n\n  .xl\\:hover\\:translate-x-10:hover {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .xl\\:hover\\:translate-x-12:hover {\n    --transform-translate-x: 3rem;\n  }\n\n  .xl\\:hover\\:translate-x-16:hover {\n    --transform-translate-x: 4rem;\n  }\n\n  .xl\\:hover\\:translate-x-20:hover {\n    --transform-translate-x: 5rem;\n  }\n\n  .xl\\:hover\\:translate-x-24:hover {\n    --transform-translate-x: 6rem;\n  }\n\n  .xl\\:hover\\:translate-x-32:hover {\n    --transform-translate-x: 8rem;\n  }\n\n  .xl\\:hover\\:translate-x-40:hover {\n    --transform-translate-x: 10rem;\n  }\n\n  .xl\\:hover\\:translate-x-48:hover {\n    --transform-translate-x: 12rem;\n  }\n\n  .xl\\:hover\\:translate-x-56:hover {\n    --transform-translate-x: 14rem;\n  }\n\n  .xl\\:hover\\:translate-x-64:hover {\n    --transform-translate-x: 16rem;\n  }\n\n  .xl\\:hover\\:translate-x-px:hover {\n    --transform-translate-x: 1px;\n  }\n\n  .xl\\:hover\\:-translate-x-1:hover {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .xl\\:hover\\:-translate-x-2:hover {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .xl\\:hover\\:-translate-x-3:hover {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .xl\\:hover\\:-translate-x-4:hover {\n    --transform-translate-x: -1rem;\n  }\n\n  .xl\\:hover\\:-translate-x-5:hover {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .xl\\:hover\\:-translate-x-6:hover {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .xl\\:hover\\:-translate-x-8:hover {\n    --transform-translate-x: -2rem;\n  }\n\n  .xl\\:hover\\:-translate-x-10:hover {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .xl\\:hover\\:-translate-x-12:hover {\n    --transform-translate-x: -3rem;\n  }\n\n  .xl\\:hover\\:-translate-x-16:hover {\n    --transform-translate-x: -4rem;\n  }\n\n  .xl\\:hover\\:-translate-x-20:hover {\n    --transform-translate-x: -5rem;\n  }\n\n  .xl\\:hover\\:-translate-x-24:hover {\n    --transform-translate-x: -6rem;\n  }\n\n  .xl\\:hover\\:-translate-x-32:hover {\n    --transform-translate-x: -8rem;\n  }\n\n  .xl\\:hover\\:-translate-x-40:hover {\n    --transform-translate-x: -10rem;\n  }\n\n  .xl\\:hover\\:-translate-x-48:hover {\n    --transform-translate-x: -12rem;\n  }\n\n  .xl\\:hover\\:-translate-x-56:hover {\n    --transform-translate-x: -14rem;\n  }\n\n  .xl\\:hover\\:-translate-x-64:hover {\n    --transform-translate-x: -16rem;\n  }\n\n  .xl\\:hover\\:-translate-x-px:hover {\n    --transform-translate-x: -1px;\n  }\n\n  .xl\\:hover\\:-translate-x-full:hover {\n    --transform-translate-x: -100%;\n  }\n\n  .xl\\:hover\\:-translate-x-1\\/2:hover {\n    --transform-translate-x: -50%;\n  }\n\n  .xl\\:hover\\:translate-x-1\\/2:hover {\n    --transform-translate-x: 50%;\n  }\n\n  .xl\\:hover\\:translate-x-full:hover {\n    --transform-translate-x: 100%;\n  }\n\n  .xl\\:hover\\:translate-y-0:hover {\n    --transform-translate-y: 0;\n  }\n\n  .xl\\:hover\\:translate-y-1:hover {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .xl\\:hover\\:translate-y-2:hover {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .xl\\:hover\\:translate-y-3:hover {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .xl\\:hover\\:translate-y-4:hover {\n    --transform-translate-y: 1rem;\n  }\n\n  .xl\\:hover\\:translate-y-5:hover {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .xl\\:hover\\:translate-y-6:hover {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .xl\\:hover\\:translate-y-8:hover {\n    --transform-translate-y: 2rem;\n  }\n\n  .xl\\:hover\\:translate-y-10:hover {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .xl\\:hover\\:translate-y-12:hover {\n    --transform-translate-y: 3rem;\n  }\n\n  .xl\\:hover\\:translate-y-16:hover {\n    --transform-translate-y: 4rem;\n  }\n\n  .xl\\:hover\\:translate-y-20:hover {\n    --transform-translate-y: 5rem;\n  }\n\n  .xl\\:hover\\:translate-y-24:hover {\n    --transform-translate-y: 6rem;\n  }\n\n  .xl\\:hover\\:translate-y-32:hover {\n    --transform-translate-y: 8rem;\n  }\n\n  .xl\\:hover\\:translate-y-40:hover {\n    --transform-translate-y: 10rem;\n  }\n\n  .xl\\:hover\\:translate-y-48:hover {\n    --transform-translate-y: 12rem;\n  }\n\n  .xl\\:hover\\:translate-y-56:hover {\n    --transform-translate-y: 14rem;\n  }\n\n  .xl\\:hover\\:translate-y-64:hover {\n    --transform-translate-y: 16rem;\n  }\n\n  .xl\\:hover\\:translate-y-px:hover {\n    --transform-translate-y: 1px;\n  }\n\n  .xl\\:hover\\:-translate-y-1:hover {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .xl\\:hover\\:-translate-y-2:hover {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .xl\\:hover\\:-translate-y-3:hover {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .xl\\:hover\\:-translate-y-4:hover {\n    --transform-translate-y: -1rem;\n  }\n\n  .xl\\:hover\\:-translate-y-5:hover {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .xl\\:hover\\:-translate-y-6:hover {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .xl\\:hover\\:-translate-y-8:hover {\n    --transform-translate-y: -2rem;\n  }\n\n  .xl\\:hover\\:-translate-y-10:hover {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .xl\\:hover\\:-translate-y-12:hover {\n    --transform-translate-y: -3rem;\n  }\n\n  .xl\\:hover\\:-translate-y-16:hover {\n    --transform-translate-y: -4rem;\n  }\n\n  .xl\\:hover\\:-translate-y-20:hover {\n    --transform-translate-y: -5rem;\n  }\n\n  .xl\\:hover\\:-translate-y-24:hover {\n    --transform-translate-y: -6rem;\n  }\n\n  .xl\\:hover\\:-translate-y-32:hover {\n    --transform-translate-y: -8rem;\n  }\n\n  .xl\\:hover\\:-translate-y-40:hover {\n    --transform-translate-y: -10rem;\n  }\n\n  .xl\\:hover\\:-translate-y-48:hover {\n    --transform-translate-y: -12rem;\n  }\n\n  .xl\\:hover\\:-translate-y-56:hover {\n    --transform-translate-y: -14rem;\n  }\n\n  .xl\\:hover\\:-translate-y-64:hover {\n    --transform-translate-y: -16rem;\n  }\n\n  .xl\\:hover\\:-translate-y-px:hover {\n    --transform-translate-y: -1px;\n  }\n\n  .xl\\:hover\\:-translate-y-full:hover {\n    --transform-translate-y: -100%;\n  }\n\n  .xl\\:hover\\:-translate-y-1\\/2:hover {\n    --transform-translate-y: -50%;\n  }\n\n  .xl\\:hover\\:translate-y-1\\/2:hover {\n    --transform-translate-y: 50%;\n  }\n\n  .xl\\:hover\\:translate-y-full:hover {\n    --transform-translate-y: 100%;\n  }\n\n  .xl\\:focus\\:translate-x-0:focus {\n    --transform-translate-x: 0;\n  }\n\n  .xl\\:focus\\:translate-x-1:focus {\n    --transform-translate-x: 0.25rem;\n  }\n\n  .xl\\:focus\\:translate-x-2:focus {\n    --transform-translate-x: 0.5rem;\n  }\n\n  .xl\\:focus\\:translate-x-3:focus {\n    --transform-translate-x: 0.75rem;\n  }\n\n  .xl\\:focus\\:translate-x-4:focus {\n    --transform-translate-x: 1rem;\n  }\n\n  .xl\\:focus\\:translate-x-5:focus {\n    --transform-translate-x: 1.25rem;\n  }\n\n  .xl\\:focus\\:translate-x-6:focus {\n    --transform-translate-x: 1.5rem;\n  }\n\n  .xl\\:focus\\:translate-x-8:focus {\n    --transform-translate-x: 2rem;\n  }\n\n  .xl\\:focus\\:translate-x-10:focus {\n    --transform-translate-x: 2.5rem;\n  }\n\n  .xl\\:focus\\:translate-x-12:focus {\n    --transform-translate-x: 3rem;\n  }\n\n  .xl\\:focus\\:translate-x-16:focus {\n    --transform-translate-x: 4rem;\n  }\n\n  .xl\\:focus\\:translate-x-20:focus {\n    --transform-translate-x: 5rem;\n  }\n\n  .xl\\:focus\\:translate-x-24:focus {\n    --transform-translate-x: 6rem;\n  }\n\n  .xl\\:focus\\:translate-x-32:focus {\n    --transform-translate-x: 8rem;\n  }\n\n  .xl\\:focus\\:translate-x-40:focus {\n    --transform-translate-x: 10rem;\n  }\n\n  .xl\\:focus\\:translate-x-48:focus {\n    --transform-translate-x: 12rem;\n  }\n\n  .xl\\:focus\\:translate-x-56:focus {\n    --transform-translate-x: 14rem;\n  }\n\n  .xl\\:focus\\:translate-x-64:focus {\n    --transform-translate-x: 16rem;\n  }\n\n  .xl\\:focus\\:translate-x-px:focus {\n    --transform-translate-x: 1px;\n  }\n\n  .xl\\:focus\\:-translate-x-1:focus {\n    --transform-translate-x: -0.25rem;\n  }\n\n  .xl\\:focus\\:-translate-x-2:focus {\n    --transform-translate-x: -0.5rem;\n  }\n\n  .xl\\:focus\\:-translate-x-3:focus {\n    --transform-translate-x: -0.75rem;\n  }\n\n  .xl\\:focus\\:-translate-x-4:focus {\n    --transform-translate-x: -1rem;\n  }\n\n  .xl\\:focus\\:-translate-x-5:focus {\n    --transform-translate-x: -1.25rem;\n  }\n\n  .xl\\:focus\\:-translate-x-6:focus {\n    --transform-translate-x: -1.5rem;\n  }\n\n  .xl\\:focus\\:-translate-x-8:focus {\n    --transform-translate-x: -2rem;\n  }\n\n  .xl\\:focus\\:-translate-x-10:focus {\n    --transform-translate-x: -2.5rem;\n  }\n\n  .xl\\:focus\\:-translate-x-12:focus {\n    --transform-translate-x: -3rem;\n  }\n\n  .xl\\:focus\\:-translate-x-16:focus {\n    --transform-translate-x: -4rem;\n  }\n\n  .xl\\:focus\\:-translate-x-20:focus {\n    --transform-translate-x: -5rem;\n  }\n\n  .xl\\:focus\\:-translate-x-24:focus {\n    --transform-translate-x: -6rem;\n  }\n\n  .xl\\:focus\\:-translate-x-32:focus {\n    --transform-translate-x: -8rem;\n  }\n\n  .xl\\:focus\\:-translate-x-40:focus {\n    --transform-translate-x: -10rem;\n  }\n\n  .xl\\:focus\\:-translate-x-48:focus {\n    --transform-translate-x: -12rem;\n  }\n\n  .xl\\:focus\\:-translate-x-56:focus {\n    --transform-translate-x: -14rem;\n  }\n\n  .xl\\:focus\\:-translate-x-64:focus {\n    --transform-translate-x: -16rem;\n  }\n\n  .xl\\:focus\\:-translate-x-px:focus {\n    --transform-translate-x: -1px;\n  }\n\n  .xl\\:focus\\:-translate-x-full:focus {\n    --transform-translate-x: -100%;\n  }\n\n  .xl\\:focus\\:-translate-x-1\\/2:focus {\n    --transform-translate-x: -50%;\n  }\n\n  .xl\\:focus\\:translate-x-1\\/2:focus {\n    --transform-translate-x: 50%;\n  }\n\n  .xl\\:focus\\:translate-x-full:focus {\n    --transform-translate-x: 100%;\n  }\n\n  .xl\\:focus\\:translate-y-0:focus {\n    --transform-translate-y: 0;\n  }\n\n  .xl\\:focus\\:translate-y-1:focus {\n    --transform-translate-y: 0.25rem;\n  }\n\n  .xl\\:focus\\:translate-y-2:focus {\n    --transform-translate-y: 0.5rem;\n  }\n\n  .xl\\:focus\\:translate-y-3:focus {\n    --transform-translate-y: 0.75rem;\n  }\n\n  .xl\\:focus\\:translate-y-4:focus {\n    --transform-translate-y: 1rem;\n  }\n\n  .xl\\:focus\\:translate-y-5:focus {\n    --transform-translate-y: 1.25rem;\n  }\n\n  .xl\\:focus\\:translate-y-6:focus {\n    --transform-translate-y: 1.5rem;\n  }\n\n  .xl\\:focus\\:translate-y-8:focus {\n    --transform-translate-y: 2rem;\n  }\n\n  .xl\\:focus\\:translate-y-10:focus {\n    --transform-translate-y: 2.5rem;\n  }\n\n  .xl\\:focus\\:translate-y-12:focus {\n    --transform-translate-y: 3rem;\n  }\n\n  .xl\\:focus\\:translate-y-16:focus {\n    --transform-translate-y: 4rem;\n  }\n\n  .xl\\:focus\\:translate-y-20:focus {\n    --transform-translate-y: 5rem;\n  }\n\n  .xl\\:focus\\:translate-y-24:focus {\n    --transform-translate-y: 6rem;\n  }\n\n  .xl\\:focus\\:translate-y-32:focus {\n    --transform-translate-y: 8rem;\n  }\n\n  .xl\\:focus\\:translate-y-40:focus {\n    --transform-translate-y: 10rem;\n  }\n\n  .xl\\:focus\\:translate-y-48:focus {\n    --transform-translate-y: 12rem;\n  }\n\n  .xl\\:focus\\:translate-y-56:focus {\n    --transform-translate-y: 14rem;\n  }\n\n  .xl\\:focus\\:translate-y-64:focus {\n    --transform-translate-y: 16rem;\n  }\n\n  .xl\\:focus\\:translate-y-px:focus {\n    --transform-translate-y: 1px;\n  }\n\n  .xl\\:focus\\:-translate-y-1:focus {\n    --transform-translate-y: -0.25rem;\n  }\n\n  .xl\\:focus\\:-translate-y-2:focus {\n    --transform-translate-y: -0.5rem;\n  }\n\n  .xl\\:focus\\:-translate-y-3:focus {\n    --transform-translate-y: -0.75rem;\n  }\n\n  .xl\\:focus\\:-translate-y-4:focus {\n    --transform-translate-y: -1rem;\n  }\n\n  .xl\\:focus\\:-translate-y-5:focus {\n    --transform-translate-y: -1.25rem;\n  }\n\n  .xl\\:focus\\:-translate-y-6:focus {\n    --transform-translate-y: -1.5rem;\n  }\n\n  .xl\\:focus\\:-translate-y-8:focus {\n    --transform-translate-y: -2rem;\n  }\n\n  .xl\\:focus\\:-translate-y-10:focus {\n    --transform-translate-y: -2.5rem;\n  }\n\n  .xl\\:focus\\:-translate-y-12:focus {\n    --transform-translate-y: -3rem;\n  }\n\n  .xl\\:focus\\:-translate-y-16:focus {\n    --transform-translate-y: -4rem;\n  }\n\n  .xl\\:focus\\:-translate-y-20:focus {\n    --transform-translate-y: -5rem;\n  }\n\n  .xl\\:focus\\:-translate-y-24:focus {\n    --transform-translate-y: -6rem;\n  }\n\n  .xl\\:focus\\:-translate-y-32:focus {\n    --transform-translate-y: -8rem;\n  }\n\n  .xl\\:focus\\:-translate-y-40:focus {\n    --transform-translate-y: -10rem;\n  }\n\n  .xl\\:focus\\:-translate-y-48:focus {\n    --transform-translate-y: -12rem;\n  }\n\n  .xl\\:focus\\:-translate-y-56:focus {\n    --transform-translate-y: -14rem;\n  }\n\n  .xl\\:focus\\:-translate-y-64:focus {\n    --transform-translate-y: -16rem;\n  }\n\n  .xl\\:focus\\:-translate-y-px:focus {\n    --transform-translate-y: -1px;\n  }\n\n  .xl\\:focus\\:-translate-y-full:focus {\n    --transform-translate-y: -100%;\n  }\n\n  .xl\\:focus\\:-translate-y-1\\/2:focus {\n    --transform-translate-y: -50%;\n  }\n\n  .xl\\:focus\\:translate-y-1\\/2:focus {\n    --transform-translate-y: 50%;\n  }\n\n  .xl\\:focus\\:translate-y-full:focus {\n    --transform-translate-y: 100%;\n  }\n\n  .xl\\:skew-x-0 {\n    --transform-skew-x: 0;\n  }\n\n  .xl\\:skew-x-1 {\n    --transform-skew-x: 1deg;\n  }\n\n  .xl\\:skew-x-2 {\n    --transform-skew-x: 2deg;\n  }\n\n  .xl\\:skew-x-3 {\n    --transform-skew-x: 3deg;\n  }\n\n  .xl\\:skew-x-6 {\n    --transform-skew-x: 6deg;\n  }\n\n  .xl\\:skew-x-12 {\n    --transform-skew-x: 12deg;\n  }\n\n  .xl\\:-skew-x-12 {\n    --transform-skew-x: -12deg;\n  }\n\n  .xl\\:-skew-x-6 {\n    --transform-skew-x: -6deg;\n  }\n\n  .xl\\:-skew-x-3 {\n    --transform-skew-x: -3deg;\n  }\n\n  .xl\\:-skew-x-2 {\n    --transform-skew-x: -2deg;\n  }\n\n  .xl\\:-skew-x-1 {\n    --transform-skew-x: -1deg;\n  }\n\n  .xl\\:skew-y-0 {\n    --transform-skew-y: 0;\n  }\n\n  .xl\\:skew-y-1 {\n    --transform-skew-y: 1deg;\n  }\n\n  .xl\\:skew-y-2 {\n    --transform-skew-y: 2deg;\n  }\n\n  .xl\\:skew-y-3 {\n    --transform-skew-y: 3deg;\n  }\n\n  .xl\\:skew-y-6 {\n    --transform-skew-y: 6deg;\n  }\n\n  .xl\\:skew-y-12 {\n    --transform-skew-y: 12deg;\n  }\n\n  .xl\\:-skew-y-12 {\n    --transform-skew-y: -12deg;\n  }\n\n  .xl\\:-skew-y-6 {\n    --transform-skew-y: -6deg;\n  }\n\n  .xl\\:-skew-y-3 {\n    --transform-skew-y: -3deg;\n  }\n\n  .xl\\:-skew-y-2 {\n    --transform-skew-y: -2deg;\n  }\n\n  .xl\\:-skew-y-1 {\n    --transform-skew-y: -1deg;\n  }\n\n  .xl\\:hover\\:skew-x-0:hover {\n    --transform-skew-x: 0;\n  }\n\n  .xl\\:hover\\:skew-x-1:hover {\n    --transform-skew-x: 1deg;\n  }\n\n  .xl\\:hover\\:skew-x-2:hover {\n    --transform-skew-x: 2deg;\n  }\n\n  .xl\\:hover\\:skew-x-3:hover {\n    --transform-skew-x: 3deg;\n  }\n\n  .xl\\:hover\\:skew-x-6:hover {\n    --transform-skew-x: 6deg;\n  }\n\n  .xl\\:hover\\:skew-x-12:hover {\n    --transform-skew-x: 12deg;\n  }\n\n  .xl\\:hover\\:-skew-x-12:hover {\n    --transform-skew-x: -12deg;\n  }\n\n  .xl\\:hover\\:-skew-x-6:hover {\n    --transform-skew-x: -6deg;\n  }\n\n  .xl\\:hover\\:-skew-x-3:hover {\n    --transform-skew-x: -3deg;\n  }\n\n  .xl\\:hover\\:-skew-x-2:hover {\n    --transform-skew-x: -2deg;\n  }\n\n  .xl\\:hover\\:-skew-x-1:hover {\n    --transform-skew-x: -1deg;\n  }\n\n  .xl\\:hover\\:skew-y-0:hover {\n    --transform-skew-y: 0;\n  }\n\n  .xl\\:hover\\:skew-y-1:hover {\n    --transform-skew-y: 1deg;\n  }\n\n  .xl\\:hover\\:skew-y-2:hover {\n    --transform-skew-y: 2deg;\n  }\n\n  .xl\\:hover\\:skew-y-3:hover {\n    --transform-skew-y: 3deg;\n  }\n\n  .xl\\:hover\\:skew-y-6:hover {\n    --transform-skew-y: 6deg;\n  }\n\n  .xl\\:hover\\:skew-y-12:hover {\n    --transform-skew-y: 12deg;\n  }\n\n  .xl\\:hover\\:-skew-y-12:hover {\n    --transform-skew-y: -12deg;\n  }\n\n  .xl\\:hover\\:-skew-y-6:hover {\n    --transform-skew-y: -6deg;\n  }\n\n  .xl\\:hover\\:-skew-y-3:hover {\n    --transform-skew-y: -3deg;\n  }\n\n  .xl\\:hover\\:-skew-y-2:hover {\n    --transform-skew-y: -2deg;\n  }\n\n  .xl\\:hover\\:-skew-y-1:hover {\n    --transform-skew-y: -1deg;\n  }\n\n  .xl\\:focus\\:skew-x-0:focus {\n    --transform-skew-x: 0;\n  }\n\n  .xl\\:focus\\:skew-x-1:focus {\n    --transform-skew-x: 1deg;\n  }\n\n  .xl\\:focus\\:skew-x-2:focus {\n    --transform-skew-x: 2deg;\n  }\n\n  .xl\\:focus\\:skew-x-3:focus {\n    --transform-skew-x: 3deg;\n  }\n\n  .xl\\:focus\\:skew-x-6:focus {\n    --transform-skew-x: 6deg;\n  }\n\n  .xl\\:focus\\:skew-x-12:focus {\n    --transform-skew-x: 12deg;\n  }\n\n  .xl\\:focus\\:-skew-x-12:focus {\n    --transform-skew-x: -12deg;\n  }\n\n  .xl\\:focus\\:-skew-x-6:focus {\n    --transform-skew-x: -6deg;\n  }\n\n  .xl\\:focus\\:-skew-x-3:focus {\n    --transform-skew-x: -3deg;\n  }\n\n  .xl\\:focus\\:-skew-x-2:focus {\n    --transform-skew-x: -2deg;\n  }\n\n  .xl\\:focus\\:-skew-x-1:focus {\n    --transform-skew-x: -1deg;\n  }\n\n  .xl\\:focus\\:skew-y-0:focus {\n    --transform-skew-y: 0;\n  }\n\n  .xl\\:focus\\:skew-y-1:focus {\n    --transform-skew-y: 1deg;\n  }\n\n  .xl\\:focus\\:skew-y-2:focus {\n    --transform-skew-y: 2deg;\n  }\n\n  .xl\\:focus\\:skew-y-3:focus {\n    --transform-skew-y: 3deg;\n  }\n\n  .xl\\:focus\\:skew-y-6:focus {\n    --transform-skew-y: 6deg;\n  }\n\n  .xl\\:focus\\:skew-y-12:focus {\n    --transform-skew-y: 12deg;\n  }\n\n  .xl\\:focus\\:-skew-y-12:focus {\n    --transform-skew-y: -12deg;\n  }\n\n  .xl\\:focus\\:-skew-y-6:focus {\n    --transform-skew-y: -6deg;\n  }\n\n  .xl\\:focus\\:-skew-y-3:focus {\n    --transform-skew-y: -3deg;\n  }\n\n  .xl\\:focus\\:-skew-y-2:focus {\n    --transform-skew-y: -2deg;\n  }\n\n  .xl\\:focus\\:-skew-y-1:focus {\n    --transform-skew-y: -1deg;\n  }\n\n  .xl\\:transition-none {\n    transition-property: none;\n  }\n\n  .xl\\:transition-all {\n    transition-property: all;\n  }\n\n  .xl\\:transition {\n    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;\n  }\n\n  .xl\\:transition-colors {\n    transition-property: background-color, border-color, color, fill, stroke;\n  }\n\n  .xl\\:transition-opacity {\n    transition-property: opacity;\n  }\n\n  .xl\\:transition-shadow {\n    transition-property: box-shadow;\n  }\n\n  .xl\\:transition-transform {\n    transition-property: transform;\n  }\n\n  .xl\\:ease-linear {\n    transition-timing-function: linear;\n  }\n\n  .xl\\:ease-in {\n    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\n  }\n\n  .xl\\:ease-out {\n    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n\n  .xl\\:ease-in-out {\n    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  .xl\\:duration-75 {\n    transition-duration: 75ms;\n  }\n\n  .xl\\:duration-100 {\n    transition-duration: 100ms;\n  }\n\n  .xl\\:duration-150 {\n    transition-duration: 150ms;\n  }\n\n  .xl\\:duration-200 {\n    transition-duration: 200ms;\n  }\n\n  .xl\\:duration-300 {\n    transition-duration: 300ms;\n  }\n\n  .xl\\:duration-500 {\n    transition-duration: 500ms;\n  }\n\n  .xl\\:duration-700 {\n    transition-duration: 700ms;\n  }\n\n  .xl\\:duration-1000 {\n    transition-duration: 1000ms;\n  }\n\n  .xl\\:delay-75 {\n    transition-delay: 75ms;\n  }\n\n  .xl\\:delay-100 {\n    transition-delay: 100ms;\n  }\n\n  .xl\\:delay-150 {\n    transition-delay: 150ms;\n  }\n\n  .xl\\:delay-200 {\n    transition-delay: 200ms;\n  }\n\n  .xl\\:delay-300 {\n    transition-delay: 300ms;\n  }\n\n  .xl\\:delay-500 {\n    transition-delay: 500ms;\n  }\n\n  .xl\\:delay-700 {\n    transition-delay: 700ms;\n  }\n\n  .xl\\:delay-1000 {\n    transition-delay: 1000ms;\n  }\n\n  .xl\\:animate-none {\n    animation: none;\n  }\n\n  .xl\\:animate-spin {\n    animation: spin 1s linear infinite;\n  }\n\n  .xl\\:animate-ping {\n    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n  }\n\n  .xl\\:animate-pulse {\n    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  }\n\n  .xl\\:animate-bounce {\n    animation: bounce 1s infinite;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
